
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb34a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb34a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f3c4t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $af507fea4e0c9af9$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");
var $af507fea4e0c9af9$export$2e2bcd8739ae039 = {
    __name: 'index',
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            get RouterView () {
                return 0, $73mM4.RouterView;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("73mM4", function(module, exports) {

$parcel$export(module.exports, "createWebHashHistory", () => $a809ac530d32f081$export$542bc3a76486c94d);
$parcel$export(module.exports, "RouterView", () => $a809ac530d32f081$export$d941f00e9b9a537);
$parcel$export(module.exports, "createRouter", () => $a809ac530d32f081$export$baddd0131ee8c05b);
$parcel$export(module.exports, "useRouter", () => $a809ac530d32f081$export$9a302a45f65d0572);
$parcel$export(module.exports, "useRoute", () => $a809ac530d32f081$export$3f79f0b98112cf57);
/*!
  * vue-router v4.5.1
  * (c) 2025 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $j6G8F = parcelRequire("j6G8F");
const $a809ac530d32f081$var$isBrowser = typeof document !== 'undefined';
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === 'object' || 'displayName' in component || 'props' in component || '__vccOpts' in component;
}
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === 'Module' || // support CF with dynamic imports that do not
    // add the Module string tag
    obj.default && $a809ac530d32f081$var$isRouteComponent(obj.default);
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        '[Vue Router warn]: ' + msg
    ].concat(args));
}
/**
 * Encoding Rules (␣ = Space)
 * - Path: ␣ " < > # ? { }
 * - Query: ␣ " < > # & =
 * - Hash: ␣ " < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI('' + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, '|').replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, '[').replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, ']');
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, '{').replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, '}').replace($a809ac530d32f081$var$ENC_CARET_RE, '^');
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, '%2B').replace($a809ac530d32f081$var$ENC_SPACE_RE, '+').replace($a809ac530d32f081$var$HASH_RE, '%23').replace($a809ac530d32f081$var$AMPERSAND_RE, '%26').replace($a809ac530d32f081$var$ENC_BACKTICK_RE, '`').replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, '{').replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, '}').replace($a809ac530d32f081$var$ENC_CARET_RE, '^');
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, '%3D');
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, '%23').replace($a809ac530d32f081$var$IM_RE, '%3F');
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? '' : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, '%2F');
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent('' + text);
    } catch (err) {
        $a809ac530d32f081$var$warn(`Error decoding "${text}". Using original value`);
    }
    return '' + text;
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, '');
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = '/') {
    let path, query = {}, searchString = '', hash = '';
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf('#');
    let searchPos = location1.indexOf('?');
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && '?') + searchString + hash,
        path: path,
        query: query,
        hash: $a809ac530d32f081$var$decode(hash)
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : '';
    return location1.path + (query && '?') + query + (location1.hash || '');
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || '/';
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith('/')) return to;
    if (!from.startsWith('/')) {
        $a809ac530d32f081$var$warn(`Cannot resolve a relative location without an absolute path. Trying to resolve "${to}" from "${from}". It should look like "/${from}".`);
        return to;
    }
    if (!to) return from;
    const fromSegments = from.split('/');
    const toSegments = to.split('/');
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === '..' || lastToSegment === '.') toSegments.push('');
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === '.') continue;
        // go up in the from array
        if (segment === '..') // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join('/') + '/' + toSegments.slice(toPosition).join('/');
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: '/',
    // TODO: could we use a symbol in the future?
    name: undefined,
    params: {},
    query: {},
    hash: '',
    fullPath: '/',
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = '';
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector('base');
            base = baseEl && baseEl.getAttribute('href') || '/';
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, '');
        } else base = '/';
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== '/' && base[0] !== '#') base = '/' + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, '#') + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ('el' in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === 'string' && positionEl.startsWith('#');
        /**
         * `id`s can accept pretty much any characters, including CSS combinators
         * like `>` or `~`. It's still possible to retrieve elements using
         * `document.getElementById('~')` but it needs to be escaped when using
         * `document.querySelector('#\\~')` for it to be valid. The only
         * requirements for `id`s are them to be unique on the page and to not be
         * empty (`id=""`). Because of that, when passing an id selector, it should
         * be properly escaped for it to work with `querySelector`. We could check
         * for the id selector to be simple (no CSS combinators `+ >~`) but that
         * would make things inconsistent since they are valid characters for an
         * `id` but would need to be escaped when using `querySelector`, breaking
         * their usage and ending up in no selector returned. Selectors need to be
         * escaped:
         *
         * - `#1-thing` becomes `#\31 -thing`
         * - `#with~symbols` becomes `#with\\~symbols`
         *
         * - More information about  the topic can be found at
         *   https://mathiasbynens.be/notes/html5-id-class.
         * - Practical example: https://mathiasbynens.be/demo/html5-id
         */ if (typeof position.el === 'string') {
            if (!isIdSelector || !document.getElementById(position.el.slice(1))) try {
                const foundEl = document.querySelector(position.el);
                if (isIdSelector && foundEl) {
                    $a809ac530d32f081$var$warn(`The selector "${position.el}" should be passed as "el: document.querySelector('${position.el}')" because it starts with "#".`);
                    // return to avoid other warnings
                    return;
                }
            } catch (err) {
                $a809ac530d32f081$var$warn(`The selector "${position.el}" is invalid. If you are using an id selector, make sure to escape it. You can find more information about escaping characters in selectors at https://mathiasbynens.be/notes/css-escapes or use CSS.escape (https://developer.mozilla.org/en-US/docs/Web/API/CSS/escape).`);
                // return to avoid other warnings
                return;
            }
        }
        const el = typeof positionEl === 'string' ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) {
            $a809ac530d32f081$var$warn(`Couldn't find element using selector "${position.el}" returned by scrollBehavior.`);
            return;
        }
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ('scrollBehavior' in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + '//' + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf('#');
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== '/') pathFromHash = '/' + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, '');
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), '');
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener('popstate', popStateHandler);
        window.removeEventListener('beforeunload', beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener('popstate', popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener('beforeunload', beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf('#');
        const url = hashIndex > -1 ? (location1.host && document.querySelector('base') ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? 'replaceState' : 'pushState'](state, '', url);
            historyState.value = state;
        } catch (err) {
            $a809ac530d32f081$var$warn('Error with push/replace State', err);
            // Force the navigation, this also resets the call count
            location1[replace ? 'replace' : 'assign'](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        if (!history1.state) $a809ac530d32f081$var$warn(`history.state seems to have been manually replaced without preserving the necessary values. Make sure to preserve existing history state if you are manually calling history.replaceState:\n\n` + `history.replaceState(history.state, '', url)\n\n` + `You can find more information at https://router.vuejs.org/guide/migration/#Usage-of-history-state`);
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: '',
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, 'state', {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = '') {
    let listeners = [];
    let queue = [
        [
            $a809ac530d32f081$var$START,
            {}
        ]
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1, state = {}) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push([
            location1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // rewritten by Object.defineProperty
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to, state) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    $a809ac530d32f081$var$START,
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, 'state', {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : '';
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes('#')) base += '#';
    if (!base.endsWith('#/') && !base.endsWith('#')) $a809ac530d32f081$var$warn(`A hash base must end with a "#":\n"${base}" should be "${base.replace(/#.*$/, '#')}".`);
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === 'string' || route && typeof route === 'object';
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === 'string' || typeof name === 'symbol';
}
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol('navigation failure');
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? '\nwhile being at\n' + JSON.stringify(currentLocation) : ''}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
 * Creates a typed NavigationFailure object.
 * @internal
 * @param type - NavigationFailureType
 * @param params - { from, to }
 */ function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error($a809ac530d32f081$var$ErrorTypeMessages[type](params)), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    'params',
    'query',
    'hash'
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === 'string') return to;
    if (to.path != null) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = '[^/]+?';
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? '^' : '';
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += '/';
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += '/';
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, '\\$&');
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : '/' + subPattern;
                if (optional) subPattern += '?';
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === '.*') subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += '/?';
    if (options.end) pattern += '$';
    else if (options.strict && !pattern.endsWith('/')) pattern += '(?:/|$)';
    const re = new RegExp(pattern, options.sensitive ? '' : 'i');
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || '';
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split('/') : value;
        }
        return params;
    }
    function stringify(params) {
        let path = '';
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith('/')) path += '/';
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : '';
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join('/') : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith('/')) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || '/';
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ''
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === '/') return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith('/')) throw new Error(`Route paths should start with a "/": "${path}" should be "/${path}".`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = '';
    // custom regexp for a param
    let customRe = '';
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === '*' || char === '+')) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === '*' || char === '+',
                optional: char === '*' || char === '?'
            });
        } else crash('Invalid state to consume buffer');
        buffer = '';
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === '\\' && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === '/') {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ':') {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === '(') state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== '*' && char !== '?' && char !== '+') i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ')') {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == '\\') customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== '*' && char !== '?' && char !== '+') i--;
                customRe = '';
                break;
            default:
                crash('Unknown state');
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    {
        const existingKeys = new Set();
        for (const key of parser.keys){
            if (existingKeys.has(key.name)) $a809ac530d32f081$var$warn(`Found duplicated params with name "${key.name}" for path "${record.path}". Only the last one will be available on "$route.params".`);
            existingKeys.add(key.name);
        }
    }
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ('alias' in record) {
            const aliases = typeof record.alias === 'string' ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push(// we need to normalize again to ensure the `mods` property
            // being non enumerable
            $a809ac530d32f081$var$normalizeRouteRecord($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== '/') {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === '/' ? '' : '/';
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            if (normalizedRecord.path === '*') throw new Error('Catch all routes ("*") must now be defined using a param with a custom regexp.\nSee more at https://router.vuejs.org/guide/migration/#Removed-star-or-catch-all-routes.');
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (parent && path[0] === '/') $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(matcher, parent);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) {
                originalRecord.alias.push(matcher);
                $a809ac530d32f081$var$checkSameParams(originalRecord, matcher);
            } else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) {
                    $a809ac530d32f081$var$checkSameNameAsAncestor(record, parent);
                    removeRoute(record.name);
                }
            }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if ($a809ac530d32f081$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
        // TODO: add normalized records for more flexibility
        // if (parent && isAliasRecord(originalRecord)) {
        //   parent.children.push(originalRecord)
        // }
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $a809ac530d32f081$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ('name' in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            {
                const invalidParams = Object.keys(location1.params || {}).filter((paramName)=>!matcher.keys.find((k)=>k.name === paramName));
                if (invalidParams.length) $a809ac530d32f081$var$warn(`Discarded invalid param(s) "${invalidParams.join('", "')}" when navigating. See https://github.com/vuejs/router/blob/main/packages/router/CHANGELOG.md#414-2022-08-22 for more details.`);
            }
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            if (!path.startsWith('/')) $a809ac530d32f081$var$warn(`The Matcher cannot resolve relative paths but received "${path}". Unless you directly called \`matcher.resolve("${path}")\`, this is probably a bug in vue-router. Please open an issue at https://github.com/vuejs/router/issues/new/choose.`);
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        // must be declared afterwards
        // mods: {},
        components: 'components' in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    // mods contain modules and shouldn't be copied,
    // logged or anything. It's just used for internal
    // advanced use cases like data loaders
    Object.defineProperty(normalized, 'mods', {
        value: {}
    });
    return normalized;
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ('component' in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === 'object' ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent){
        if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? 'child' : 'descendant'} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
    }
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
/**
 * Performs a binary search to find the correct insertion index for a new matcher.
 *
 * Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
 * with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
 *
 * @param matcher - new matcher to be inserted
 * @param matchers - existing matchers
 */ function $a809ac530d32f081$var$findInsertionIndex(matcher, matchers) {
    // First phase: binary search based on score
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        const sortOrder = $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[mid]);
        if (sortOrder < 0) upper = mid;
        else lower = mid + 1;
    }
    // Second phase: check for an ancestor with the same score
    const insertionAncestor = $a809ac530d32f081$var$getInsertionAncestor(matcher);
    if (insertionAncestor) {
        upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
        if (upper < 0) // This should never happen
        $a809ac530d32f081$var$warn(`Finding ancestor route "${insertionAncestor.record.path}" failed for "${matcher.record.path}"`);
    }
    return upper;
}
function $a809ac530d32f081$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent){
        if ($a809ac530d32f081$var$isMatchable(ancestor) && $a809ac530d32f081$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
    }
    return;
}
/**
 * Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
 * a component, or name, or redirect, are just used to group other routes.
 * @param matcher
 * @param matcher.record record of the matcher
 * @returns
 */ function $a809ac530d32f081$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === '' || search === '?') return query;
    const hasLeadingIM = search[0] === '?';
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split('&');
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, ' ');
        // allow the = character
        const eqPos = searchParam.indexOf('=');
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = '';
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? '&' : '') + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? '&' : '') + key;
                if (value != null) search += '=' + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : '' + v) : value == null ? value : '' + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol('router view location matched');
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol('router view depth');
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol('router');
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol('route location');
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol('router view location');
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    if (!(0, $TusQn.getCurrentInstance)()) {
        $a809ac530d32f081$var$warn('getCurrentInstance() returned null. onBeforeRouteLeave() must be called at the top of a setup function');
        return;
    }
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) {
        $a809ac530d32f081$var$warn('No active route record was found when calling `onBeforeRouteLeave()`. Make sure you call this function inside a component child of <router-view>. Maybe you called it inside of App.vue?');
        return;
    }
    $a809ac530d32f081$var$registerGuard(activeRecord, 'leaveGuards', leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    if (!(0, $TusQn.getCurrentInstance)()) {
        $a809ac530d32f081$var$warn('getCurrentInstance() returned null. onBeforeRouteUpdate() must be called at the top of a setup function');
        return;
    }
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) {
        $a809ac530d32f081$var$warn('No active route record was found when calling `onBeforeRouteUpdate()`. Make sure you call this function inside a component child of <router-view>. Maybe you called it inside of App.vue?');
        return;
    }
    $a809ac530d32f081$var$registerGuard(activeRecord, 'updateGuards', updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === 'function') enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from)));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            if (guard.length > 2) {
                const message = `The "next" callback was never called inside of ${guard.name ? '"' + guard.name + '"' : ''}:\n${guard.toString()}\n. If you are returning a value instead of calling "next", make sure to remove the "next" parameter from your function.`;
                if (typeof guardReturn === 'object' && 'then' in guardReturn) guardCall = guardCall.then((resolvedValue)=>{
                    // @ts-expect-error: _called is added at canOnlyBeCalledOnce
                    if (!next._called) {
                        $a809ac530d32f081$var$warn(message);
                        return Promise.reject(new Error('Invalid navigation guard'));
                    }
                    return resolvedValue;
                });
                else if (guardReturn !== undefined) // @ts-expect-error: _called is added at canOnlyBeCalledOnce
                {
                    if (!next._called) {
                        $a809ac530d32f081$var$warn(message);
                        reject(new Error('Invalid navigation guard'));
                        return;
                    }
                }
            }
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched){
        if (!record.components && !record.children.length) $a809ac530d32f081$var$warn(`Record with path "${record.path}" is either missing a "component(s)"` + ` or "children" property.`);
        for(const name in record.components){
            let rawComponent = record.components[name];
            if (!rawComponent || typeof rawComponent !== 'object' && typeof rawComponent !== 'function') {
                $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is not` + ` a valid component. Received "${String(rawComponent)}".`);
                // throw to ensure we stop here but warn to ensure the message isn't
                // missed by the user
                throw new Error('Invalid route component');
            } else if ('then' in rawComponent) {
                // warn if user wrote import('/component.vue') instead of () =>
                // import('./component.vue')
                $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is a ` + `Promise instead of a function that returns a Promise. Did you ` + `write "import('./MyPage.vue')" instead of ` + `"() => import('./MyPage.vue')" ? This will break in ` + `production if not fixed.`);
                const promise = rawComponent;
                rawComponent = ()=>promise;
            } else if (rawComponent.__asyncLoader && // warn only once per component
            !rawComponent.__warnedDefineAsync) {
                rawComponent.__warnedDefineAsync = true;
                $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is defined ` + `using "defineAsyncComponent()". ` + `Write "() => import('./MyPage.vue')" instead of ` + `"defineAsyncComponent(() => import('./MyPage.vue'))".`);
            }
            // skip update and leave guards if the route component is not mounted
            if (guardType !== 'beforeRouteEnter' && !record.instances[name]) continue;
            if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
                // __vccOpts is added by vue-class-component and contain the regular options
                const options = rawComponent.__vccOpts || rawComponent;
                const guard = options[guardType];
                guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext));
            } else {
                // start requesting the chunk already
                let componentPromise = rawComponent();
                if (!('catch' in componentPromise)) {
                    $a809ac530d32f081$var$warn(`Component "${name}" in record with path "${record.path}" is a function that does not return a Promise. If you were passing a functional component, make sure to add a "displayName" to the component. This will break in production if not fixed.`);
                    componentPromise = Promise.resolve(componentPromise);
                }
                guards.push(()=>componentPromise.then((resolved)=>{
                        if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                        const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                        // keep the resolved module for plugins like data loaders
                        record.mods[name] = resolved;
                        // replace the function with the resolved component
                        // cannot be null or undefined because we went into the for loop
                        record.components[name] = resolvedComponent;
                        // __vccOpts is added by vue-class-component and contain the regular options
                        const options = resolvedComponent.__vccOpts || resolvedComponent;
                        const guard = options[guardType];
                        return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext)();
                    }));
            }
        }
    }
    return guards;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error('Cannot load a route that redirects.')) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === 'function' && !('displayName' in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // keep the resolved module for plugins like data loaders
                record.mods[name] = resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
/**
 * Returns the internal behavior of a {@link RouterLink} without the rendering part.
 *
 * @param props - a `to` location and an optional `replace` flag
 */ function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $01W3b.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        if (!hasPrevious || to !== previousTo) {
            if (!$a809ac530d32f081$var$isRouteLocation(to)) {
                if (hasPrevious) $a809ac530d32f081$var$warn(`Invalid value for prop "to" in useLink()\n- to:`, to, `\n- previous to:`, previousTo, `\n- props:`, props);
                else $a809ac530d32f081$var$warn(`Invalid value for prop "to" in useLink()\n- to:`, to, `\n- props:`, props);
            }
            previousTo = to;
            hasPrevious = true;
        }
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $01W3b.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) {
            const p = router[(0, $01W3b.unref)(props.replace) ? 'replace' : 'push']((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
            if (props.viewTransition && typeof document !== 'undefined' && 'startViewTransition' in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    // devtools only
    if ($a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = $a809ac530d32f081$var$isRouteLocation((0, $01W3b.unref)(props.to)) ? null : 'Invalid "to" value';
            }, {
                flush: 'post'
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $01W3b.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $a809ac530d32f081$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: 'RouterLink',
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: 'page'
        },
        viewTransition: Boolean
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $01W3b.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, 'router-link-active')]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, 'router-link-exact-active')]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $a809ac530d32f081$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $TusQn.h)('a', {
                'aria-current': link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute('target');
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === 'string') {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : '';
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: 'RouterView',
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: 'default'
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        $a809ac530d32f081$var$warnDeprecatedUsage();
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $01W3b.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $01W3b.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $01W3b.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $01W3b.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $01W3b.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: 'post'
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === 'function' ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if ($a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === 'KeepAlive' || parentName.includes('Transition')) && typeof parentSubTreeType === 'object' && parentSubTreeType.name === 'RouterView') {
        const comp = parentName === 'KeepAlive' ? 'keep-alive' : 'transition';
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                'instances',
                'children',
                'aliasOf'
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: 'org.vuejs.router' + (id ? '.' + id : ''),
        label: 'Vue Router',
        packageName: 'vue-router',
        homepage: 'https://router.vuejs.org',
        logo: 'https://router.vuejs.org/logo.png',
        componentStateTypes: [
            'Routing'
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== 'function') console.warn('[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: 'Routing',
                key: '$route',
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, 'Current Route')
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : '') + info.path,
                    textColor: 0,
                    tooltip: 'This component is rendered by &lt;router-view&gt;',
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = '';
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $a809ac530d32f081$var$RED_100;
                        textColor = $a809ac530d32f081$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = 'This is exactly active';
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = 'This link is active';
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $01W3b.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = 'router:navigations:' + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? ' ' + id : ''} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'Error during Navigation',
                    subtitle: to.fullPath,
                    logType: 'error',
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay('beforeEach'),
                from: $a809ac530d32f081$var$formatRouteLocation(from, 'Current Location during this navigation'),
                to: $a809ac530d32f081$var$formatRouteLocation(to, 'Target location')
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, '__navigationId', {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: 'Start of navigation',
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay('afterEach')
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : '',
                        tooltip: 'Navigation Failure',
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("\u274C");
            } else data.status = $a809ac530d32f081$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, 'Current Location during this navigation');
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, 'Target location');
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'End of navigation',
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? 'warning' : 'default',
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = 'router-inspector:' + id;
        api.addInspector({
            id: routerInspectorId,
            label: 'Routes' + (id ? ' ' + id : ''),
            icon: 'book',
            treeFilterPlaceholder: 'Search routes'
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? '*' : '?';
    else return key.repeatable ? '+' : '';
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: 'path',
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: 'name',
        value: record.name
    });
    fields.push({
        editable: false,
        key: 'regexp',
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: 'keys',
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(' '),
                tooltip: 'Param keys',
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: 'redirect',
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: 'aliases',
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: 'meta',
        value: route.record.meta
    });
    fields.push({
        key: 'score',
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(', ')).join(' | '),
                tooltip: 'Score used to sort routes',
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
const $a809ac530d32f081$var$RED_100 = 0xfee2e2;
const $a809ac530d32f081$var$RED_700 = 0xb91c1c;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: 'alias',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: 'matches',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: 'exact',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: 'active',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === 'string' ? `redirect: ${record.redirect}` : 'redirects',
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ''), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== '/' || filter === '/') {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith('/') && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    if (!routerHistory) throw new Error('Provide the "history" option when calling "createRouter()": https://router.vuejs.org/api/interfaces/RouterOptions.html#history');
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>'' + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            if (!parent) $a809ac530d32f081$var$warn(`Parent route "${String(parentOrRoute)}" not found when adding child route`, route);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
        else $a809ac530d32f081$var$warn(`Cannot remove non-existent route "${String(name)}"`);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const resolve: Router['resolve'] = (rawLocation: RouteLocationRaw, currentLocation) => {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === 'string') {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            if (href.startsWith('//')) $a809ac530d32f081$var$warn(`Location "${rawLocation}" resolved to "${href}". A resolved location cannot start with multiple slashes.`);
            else if (!matchedRoute.matched.length) $a809ac530d32f081$var$warn(`No match found for location with path "${rawLocation}"`);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        if (!$a809ac530d32f081$var$isRouteLocation(rawLocation)) {
            $a809ac530d32f081$var$warn(`router.resolve() was passed an invalid location. This will fail in production.\n- Location:`, rawLocation);
            return resolve({});
        }
        let matcherLocation;
        // path could be relative in object as well
        if (rawLocation.path != null) {
            if ('params' in rawLocation && !('name' in rawLocation) && // @ts-expect-error: the type is never
            Object.keys(rawLocation.params).length) $a809ac530d32f081$var$warn(`Path "${rawLocation.path}" was passed with params but they will be ignored. Use a named route alongside params instead.`);
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
            });
        } else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || '';
        if (hash && !hash.startsWith('#')) $a809ac530d32f081$var$warn(`A \`hash\` should always start with the character "#". Replace "${hash}" with "#${hash}".`);
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        if (href.startsWith('//')) $a809ac530d32f081$var$warn(`Location "${rawLocation}" resolved to "${href}". A resolved location cannot start with multiple slashes.`);
        else if (!matchedRoute.matched.length) $a809ac530d32f081$var$warn(`No match found for location with path "${rawLocation.path != null ? rawLocation.path : rawLocation}"`);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === 'string' ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === 'function' ? redirect(to) : redirect;
            if (typeof newTargetLocation === 'string') {
                newTargetLocation = newTargetLocation.includes('?') || newTargetLocation.includes('#') ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            if (newTargetLocation.path == null && !('name' in newTargetLocation)) {
                $a809ac530d32f081$var$warn(`Invalid redirect found:\n${JSON.stringify(newTargetLocation, null, 2)}\n when navigating to "${to.fullPath}". A redirect must contain a name or path. This will break in production.`);
                throw new Error('Invalid redirect');
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === 'object' ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    if (// we are redirecting to the same location we were already at
                    $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, resolve(failure.to), toLocation) && // and we have done it a couple of times
                    redirectedFrom && // @ts-expect-error: added only in dev
                    (redirectedFrom._count = redirectedFrom._count ? redirectedFrom._count + 1 : 1) > 30) {
                        $a809ac530d32f081$var$warn(`Detected a possibly infinite redirection in a navigation guard when going from "${from.fullPath}" to "${toLocation.fullPath}". Aborting to avoid a Stack Overflow.\n Are you always returning a new location within a navigation guard? That would lead to this error. Only return when redirecting or aborting, that should fix this. This might break in production if not fixed.`);
                        return Promise.reject(new Error('Infinite redirect in navigation guard'));
                    }
                    return pushWithRedirect(// keep options
                    $a809ac530d32f081$var$assign({
                        replace: // preserve an existing replacement but allow the redirect to override it
                        replace
                    }, locationAsObject(failure.to), {
                        state: typeof failure.to === 'object' ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                        force: force
                    }), // preserve the original redirectedFrom if any
                    redirectedFrom || toLocation);
                }
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === 'function' ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), 'beforeRouteLeave', to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, 'beforeRouteUpdate', to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, 'beforeRouteEnter', to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorListeners = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else {
            $a809ac530d32f081$var$warn('uncaught error during route navigation:');
            console.error(error);
        }
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component('RouterLink', $a809ac530d32f081$export$fce709ebdac448ed);
            app.component('RouterView', $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, '$route', {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{
                    $a809ac530d32f081$var$warn('Unexpected error when starting the router:', err);
                });
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57(_name) {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("eeJ70")).TransitionGroup);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
$a55c527d369bf9c1$var$initDev();
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{
    (0, $TusQn.warn)(`Runtime compilation is not supported in this build of Vue.` + ` Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`);
};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "assertNumber", () => $0a6cc4ba868319ae$export$dfbcecb440255e4a);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "hasInjectionContext", () => $0a6cc4ba868319ae$export$caf6761f24fc571a);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
/**
* @vue/runtime-core v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    if (val === void 0) return;
    else if (typeof val !== "number") $0a6cc4ba868319ae$var$warn$1(`${type} is not a valid number - got ${JSON.stringify(val)}.`);
    else if (isNaN(val)) $0a6cc4ba868319ae$var$warn$1(`${type} is NaN - the duration expression might be incorrect.`);
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    } else $0a6cc4ba868319ae$var$warn$1(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof fn}`);
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = (0, $0a6cc4ba868319ae$var$ErrorTypeStrings$1[type]);
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    {
        const info = $0a6cc4ba868319ae$var$ErrorTypeStrings$1[type];
        if (contextVNode) $0a6cc4ba868319ae$var$pushWarningContext(contextVNode);
        $0a6cc4ba868319ae$var$warn$1(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
        if (contextVNode) $0a6cc4ba868319ae$var$popWarningContext();
        if (throwInDev) throw err;
        else console.error(err);
    }
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    seen = seen || /* @__PURE__ */ new Map();
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            if ($0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, cb)) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        seen = seen || /* @__PURE__ */ new Map();
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if ($0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, cb)) continue;
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    seen = seen || /* @__PURE__ */ new Map();
    const check = (job)=>$0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, job);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (check(job)) continue;
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
(0, $8POXm.getGlobalThis)().__VUE_HMR_RUNTIME__ = {
    createRecord: $0a6cc4ba868319ae$var$tryWrap($0a6cc4ba868319ae$var$createRecord),
    rerender: $0a6cc4ba868319ae$var$tryWrap($0a6cc4ba868319ae$var$rerender),
    reload: $0a6cc4ba868319ae$var$tryWrap($0a6cc4ba868319ae$var$reload)
};
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            $0a6cc4ba868319ae$var$isHmrUpdating = true;
            instance.parent.update();
            $0a6cc4ba868319ae$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) {
        $0a6cc4ba868319ae$var$warn$1(`withDirectives can only be used inside render functions.`);
        return vnode;
    }
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$TeleportEndKey = Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) {
            $0a6cc4ba868319ae$var$warn$1(`Current renderer does not support string target for Teleports. (missing querySelector renderer option)`);
            return null;
        } else {
            const target = select(targetSelector);
            if (!target && !$0a6cc4ba868319ae$var$isTeleportDisabled(props)) $0a6cc4ba868319ae$var$warn$1(`Failed to locate Teleport target with selector "${targetSelector}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`);
            return target;
        }
    } else {
        if (!targetSelector && !$0a6cc4ba868319ae$var$isTeleportDisabled(props)) $0a6cc4ba868319ae$var$warn$1(`Invalid Teleport target: ${targetSelector}`);
        return targetSelector;
    }
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if ($0a6cc4ba868319ae$var$isHmrUpdating) {
            optimized = false;
            dynamicChildren = null;
        }
        if (n1 == null) {
            const placeholder = n2.el = createComment("teleport start");
            const mainAnchor = n2.anchor = createComment("teleport end");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $0a6cc4ba868319ae$var$updateCssVars(n2, false);
                    }
                } else if (!disabled) $0a6cc4ba868319ae$var$warn$1("Invalid Teleport target on mount:", target, `(${typeof target})`);
            };
            if (disabled) {
                mount(container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props)) {
                n2.el.__isMounted = false;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    mountToTarget();
                    delete n2.el.__isMounted;
                }, parentSuspense);
            } else mountToTarget();
        } else {
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) && n1.el.__isMounted === false) {
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    $0a6cc4ba868319ae$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, false);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    else $0a6cc4ba868319ae$var$warn$1("Invalid Teleport target on update:", target, `(${typeof target})`);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $0a6cc4ba868319ae$var$findNonCommentChild(children);
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (mode && mode !== "in-out" && mode !== "out-in" && mode !== "default") $0a6cc4ba868319ae$var$warn$1(`invalid <transition> mode: ${mode}`);
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            if (hasFound) {
                $0a6cc4ba868319ae$var$warn$1("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
                break;
            }
            child = c;
            hasFound = true;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    else $0a6cc4ba868319ae$var$warn$1(`useId() is called when there is no active component instance to be associated with.`);
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        if ((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable) $0a6cc4ba868319ae$var$warn$1(`useTemplateRef('${key}') already exists.`);
        else Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    } else $0a6cc4ba868319ae$var$warn$1(`useTemplateRef() is called when there is no active component instance to be associated with.`);
    const ret = (0, $01W3b.readonly)(r);
    $0a6cc4ba868319ae$var$knownTemplateRefs.add(ret);
    return ret;
}
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    if (!owner) {
        $0a6cc4ba868319ae$var$warn$1(`Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.`);
        return;
    }
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? ()=>false : (key)=>{
        if ((0, $8POXm.hasOwn)(rawSetupState, key) && !(0, $01W3b.isRef)(rawSetupState[key])) $0a6cc4ba868319ae$var$warn$1(`Template ref "${key}" used on a non-ref value. It will not work in the production build.`);
        if ($0a6cc4ba868319ae$var$knownTemplateRefs.has(rawSetupState[key])) return false;
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                } else $0a6cc4ba868319ae$var$warn$1("Invalid template ref type:", ref, `(${typeof ref})`);
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        } else $0a6cc4ba868319ae$var$warn$1("Invalid template ref type:", ref, `(${typeof ref})`);
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        (0, $8POXm.def)(node, "__vnode", vnode, true);
        (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (!hasWarned) {
                            $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                const isCustomElement = el.tagName.includes("-");
                for(const key in props){
                    if (// #11189 skip if this node has directives that have created hooks
                    // as it could have mutated the DOM in any possible way
                    !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                }
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (!hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (!comp) $0a6cc4ba868319ae$var$warn$1(`Async component loader resolved to undefined. If you are using retry(), make sure to return its return value.`);
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            if (comp && !(0, $8POXm.isObject)(comp) && !(0, $8POXm.isFunction)(comp)) throw new Error(`Invalid async component load result: ${comp}`);
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            const doHydrate = hydrateStrategy ? ()=>{
                const performHydrate = ()=>{
                    if (patched) {
                        $0a6cc4ba868319ae$var$warn$1(`Skipping lazy hydration for component '${$0a6cc4ba868319ae$var$getComponentName(resolvedComp)}': it was updated before lazy hydration performed.`);
                        return;
                    }
                    hydrate();
                };
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
                (instance.u || (instance.u = [])).push(()=>patched = true);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
            instance2.__keepAliveStorageContainer = storageContainer;
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                $0a6cc4ba868319ae$var$warn$1(`KeepAlive should contain exactly one component child.`);
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    } else {
        const apiName = (0, $8POXm.toHandlerKey)($0a6cc4ba868319ae$var$ErrorTypeStrings$1[type].replace(/ hook$/, ""));
        $0a6cc4ba868319ae$var$warn$1(`${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup().` + ` If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`);
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        if (warnMissing && !res) {
            const extra = type === $0a6cc4ba868319ae$var$COMPONENTS ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : ``;
            $0a6cc4ba868319ae$var$warn$1(`Failed to resolve ${type.slice(0, -1)}: ${name}${extra}`);
        }
        return res;
    } else $0a6cc4ba868319ae$var$warn$1(`resolve${(0, $8POXm.capitalize)(type.slice(0, -1))} can only be used in render() or setup().`);
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            isReadonlySource = (0, $01W3b.isReadonly)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $01W3b.toReadonly)((0, $01W3b.toReactive)(source[i])) : (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        if (!Number.isInteger(source)) $0a6cc4ba868319ae$var$warn$1(`The v-for range expect an integer value but got ${source}.`);
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot.length > 1) {
        $0a6cc4ba868319ae$var$warn$1(`SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.`);
        slot = ()=>[];
    }
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    if (!(0, $8POXm.isObject)(obj)) {
        $0a6cc4ba868319ae$var$warn$1(`v-on with no argument expects an object value.`);
        return ret;
    }
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, $01W3b.shallowReadonly)(i.props),
    $attrs: (i)=>(0, $01W3b.shallowReadonly)(i.attrs),
    $slots: (i)=>(0, $01W3b.shallowReadonly)(i.slots),
    $refs: (i)=>(0, $01W3b.shallowReadonly)(i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key === "__isVue") return true;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") {
                (0, $01W3b.track)(instance.attrs, "get", "");
                $0a6cc4ba868319ae$var$markAttrsAccessed();
            } else if (key === "$slots") (0, $01W3b.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
        else if ($0a6cc4ba868319ae$var$currentRenderingInstance && (!(0, $8POXm.isString)(key) || // #1091 avoid internal isRef/isVNode checks on component instance leading
        // to infinite warning loop
        key.indexOf("__v") !== 0)) {
            if (data !== (0, $8POXm.EMPTY_OBJ) && $0a6cc4ba868319ae$var$isReservedPrefix(key[0]) && (0, $8POXm.hasOwn)(data, key)) $0a6cc4ba868319ae$var$warn$1(`Property ${JSON.stringify(key)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`);
            else if (instance === $0a6cc4ba868319ae$var$currentRenderingInstance) $0a6cc4ba868319ae$var$warn$1(`Property ${JSON.stringify(key)} was accessed during render but is not defined on instance.`);
        }
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else if (setupState.__isScriptSetup && (0, $8POXm.hasOwn)(setupState, key)) {
            $0a6cc4ba868319ae$var$warn$1(`Cannot mutate <script setup> binding "${key}" from Options API.`);
            return false;
        } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
            data[key] = value;
            return true;
        } else if ((0, $8POXm.hasOwn)(instance.props, key)) {
            $0a6cc4ba868319ae$var$warn$1(`Attempting to mutate prop "${key}". Props are readonly.`);
            return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) {
            $0a6cc4ba868319ae$var$warn$1(`Attempting to mutate public property "${key}". Properties starting with $ are reserved and readonly.`);
            return false;
        } else if (key in instance.appContext.config.globalProperties) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            value: value
        });
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
$0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.ownKeys = (target)=>{
    $0a6cc4ba868319ae$var$warn$1(`Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.`);
    return Reflect.ownKeys(target);
};
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        if (!has && $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.has(_, key)) $0a6cc4ba868319ae$var$warn$1(`Property ${JSON.stringify(key)} should not start with _ which is a reserved prefix for Vue internals.`);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineProps`);
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineEmits`);
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineExpose`);
}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineOptions`);
}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`defineSlots`);
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {
    $0a6cc4ba868319ae$var$warnRuntimeUsage("defineModel");
}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    $0a6cc4ba868319ae$var$warnRuntimeUsage(`withDefaults`);
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (!i) $0a6cc4ba868319ae$var$warn$1(`useContext() called without active instance.`);
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        else $0a6cc4ba868319ae$var$warn$1(`props default key "${key}" has no corresponding declaration.`);
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (!ctx) $0a6cc4ba868319ae$var$warn$1(`withAsyncContext called without active current instance. This is likely a bug.`);
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = $0a6cc4ba868319ae$var$createDuplicateChecker();
    {
        const [propsOptions] = instance.propsOptions;
        if (propsOptions) for(const key in propsOptions)checkDuplicateProperties("Props" /* PROPS */ , key);
    }
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) {
            Object.defineProperty(ctx, key, {
                value: methodHandler.bind(publicThis),
                configurable: true,
                enumerable: true,
                writable: true
            });
            checkDuplicateProperties("Methods" /* METHODS */ , key);
        } else $0a6cc4ba868319ae$var$warn$1(`Method "${key}" has type "${typeof methodHandler}" in the component definition. Did you reference the function correctly?`);
    }
    if (dataOptions) {
        if (!(0, $8POXm.isFunction)(dataOptions)) $0a6cc4ba868319ae$var$warn$1(`The data option must be a function. Plain object usage is no longer supported.`);
        const data = dataOptions.call(publicThis, publicThis);
        if ((0, $8POXm.isPromise)(data)) $0a6cc4ba868319ae$var$warn$1(`data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.`);
        if (!(0, $8POXm.isObject)(data)) $0a6cc4ba868319ae$var$warn$1(`data() should return an object.`);
        else {
            instance.data = (0, $01W3b.reactive)(data);
            for(const key in data){
                checkDuplicateProperties("Data" /* DATA */ , key);
                if (!$0a6cc4ba868319ae$var$isReservedPrefix(key[0])) Object.defineProperty(ctx, key, {
                    configurable: true,
                    enumerable: true,
                    get: ()=>data[key],
                    set: (0, $8POXm.NOOP)
                });
            }
        }
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        if (get === (0, $8POXm.NOOP)) $0a6cc4ba868319ae$var$warn$1(`Computed property "${key}" has no getter.`);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : ()=>{
            $0a6cc4ba868319ae$var$warn$1(`Write operation failed: computed property "${key}" is readonly.`);
        };
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
        checkDuplicateProperties("Computed" /* COMPUTED */ , key);
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
        checkDuplicateProperties("Inject" /* INJECT */ , key);
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
        else $0a6cc4ba868319ae$var$warn$1(`Invalid watch handler specified by key "${raw}"`, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
            else $0a6cc4ba868319ae$var$warn$1(`Invalid watch handler specified by key "${raw.handler}"`, handler);
        }
    } else $0a6cc4ba868319ae$var$warn$1(`Invalid watch option: "${key}"`, raw);
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from)if (asMixin && key === "expose") $0a6cc4ba868319ae$var$warn$1(`"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.`);
    else {
        const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) {
            $0a6cc4ba868319ae$var$warn$1(`root props passed to app.mount() must be an object.`);
            rootProps = null;
        }
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){
                $0a6cc4ba868319ae$var$warn$1(`app.config cannot be replaced. Modify individual options instead.`);
            },
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) $0a6cc4ba868319ae$var$warn$1(`Plugin has already been applied to target app.`);
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                } else $0a6cc4ba868319ae$var$warn$1(`A plugin must either be a function or an object with an "install" function.`);
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                    else $0a6cc4ba868319ae$var$warn$1("Mixin has already been applied to target app" + (mixin.name ? `: ${mixin.name}` : ""));
                } else $0a6cc4ba868319ae$var$warn$1("Mixins are only available in builds supporting Options API");
                return app;
            },
            component (name, component) {
                $0a6cc4ba868319ae$var$validateComponentName(name, context.config);
                if (!component) return context.components[name];
                if (context.components[name]) $0a6cc4ba868319ae$var$warn$1(`Component "${name}" has already been registered in target app.`);
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                $0a6cc4ba868319ae$var$validateDirectiveName(name);
                if (!directive) return context.directives[name];
                if (context.directives[name]) $0a6cc4ba868319ae$var$warn$1(`Directive "${name}" has already been registered in target app.`);
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    if (rootContainer.__vue_app__) $0a6cc4ba868319ae$var$warn$1(`There is already an app instance mounted on the host container.
 If you want to mount another app on the same host container, you need to unmount the previous app by calling \`app.unmount()\` first.`);
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    context.reload = ()=>{
                        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                        cloned.el = null;
                        render(cloned, rootContainer, namespace);
                    };
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    app._instance = vnode.component;
                    $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                } else $0a6cc4ba868319ae$var$warn$1(`App has already been mounted.
If you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. \`const createMyApp = () => createApp(App)\``);
            },
            onUnmount (cleanupFn) {
                if (typeof cleanupFn !== "function") $0a6cc4ba868319ae$var$warn$1(`Expected function as first argument to app.onUnmount(), but got ${typeof cleanupFn}`);
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    app._instance = null;
                    $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    delete app._container.__vue_app__;
                } else $0a6cc4ba868319ae$var$warn$1(`Cannot unmount an app that is not mounted.`);
            },
            provide (key, value) {
                if (key in context.provides) {
                    if ((0, $8POXm.hasOwn)(context.provides, key)) $0a6cc4ba868319ae$var$warn$1(`App already provides property with key "${String(key)}". It will be overwritten with the new value.`);
                    else $0a6cc4ba868319ae$var$warn$1(`App already provides property with key "${String(key)}" inherited from its parent element. It will be overwritten with the new value.`);
                }
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) $0a6cc4ba868319ae$var$warn$1(`provide() can only be used inside setup().`);
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        let provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
        else $0a6cc4ba868319ae$var$warn$1(`injection "${String(key)}" not found.`);
    } else $0a6cc4ba868319ae$var$warn$1(`inject() can only be used inside setup() or functional components.`);
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    $0a6cc4ba868319ae$var$validateProps(rawProps || {}, props, instance);
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !$0a6cc4ba868319ae$var$isInHmrContext(instance) && (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
    $0a6cc4ba868319ae$var$validateProps(rawProps || {}, props, instance);
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        if (!(0, $8POXm.isString)(raw[i])) $0a6cc4ba868319ae$var$warn$1(`props must be strings when using array syntax.`, raw[i]);
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) {
        if (!(0, $8POXm.isObject)(raw)) $0a6cc4ba868319ae$var$warn$1(`invalid props options`, raw);
        for(const key in raw){
            const normalizedKey = (0, $8POXm.camelize)(key);
            if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
                const opt = raw[key];
                const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                    type: opt
                } : (0, $8POXm.extend)({}, opt);
                const propType = prop.type;
                let shouldCast = false;
                let shouldCastTrue = true;
                if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                    const type = propType[index];
                    const typeName = (0, $8POXm.isFunction)(type) && type.name;
                    if (typeName === "Boolean") {
                        shouldCast = true;
                        break;
                    } else if (typeName === "String") shouldCastTrue = false;
                }
                else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
                prop[0 /* shouldCast */ ] = shouldCast;
                prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
                if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    else $0a6cc4ba868319ae$var$warn$1(`Invalid prop name: "${key}" is a reserved property.`);
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, (0, $01W3b.shallowReadonly)(resolvedValues), !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        if ($0a6cc4ba868319ae$var$currentInstance && !(ctx === null && $0a6cc4ba868319ae$var$currentRenderingInstance) && !(ctx && ctx.root !== $0a6cc4ba868319ae$var$currentInstance.root)) $0a6cc4ba868319ae$var$warn$1(`Slot "${key}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`);
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            $0a6cc4ba868319ae$var$warn$1(`Non-function value encountered for slot "${key}". Prefer function slots for better performance.`);
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    if (!$0a6cc4ba868319ae$var$isKeepAlive(instance.vnode) && true) $0a6cc4ba868319ae$var$warn$1(`Non-function value encountered for default slot. Prefer function slots for better performance.`);
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0a6cc4ba868319ae$var$isInternalKey(key)) slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if ($0a6cc4ba868319ae$var$isHmrUpdating) {
                $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
                (0, $01W3b.trigger)(instance, "set", "$slots");
            } else if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") {
        needWarn.push(`__VUE_OPTIONS_API__`);
        (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    }
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") {
        needWarn.push(`__VUE_PROD_DEVTOOLS__`);
        (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    }
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") {
        needWarn.push(`__VUE_PROD_HYDRATION_MISMATCH_DETAILS__`);
        (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
    }
    if (needWarn.length) {
        const multi = needWarn.length > 1;
        console.warn(`Feature flag${multi ? `s` : ``} ${needWarn.join(", ")} ${multi ? `are` : `is`} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
    }
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = $0a6cc4ba868319ae$var$isHmrUpdating ? false : !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                else patchStaticNode(n1, n2, container, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else $0a6cc4ba868319ae$var$warn$1("Invalid VNode type:", type, `(${typeof type})`);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        (0, $8POXm.def)(el, "__vnode", vnode, true);
        (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (subTree.patchFlag > 0 && subTree.patchFlag & 2048) subTree = $0a6cc4ba868319ae$var$filterSingleRoot(subTree.children) || subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if ($0a6cc4ba868319ae$var$isHmrUpdating) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
            $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2);
        } else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (// #5523 dev root fragment may inherit directives
        $0a6cc4ba868319ae$var$isHmrUpdating || patchFlag & 2048) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if (instance.type.__hmrId) $0a6cc4ba868319ae$var$registerHMR(instance);
        $0a6cc4ba868319ae$var$pushWarningContext(initialVNode);
        $0a6cc4ba868319ae$var$startMeasure(instance, `mount`);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$startMeasure(instance, `init`);
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        $0a6cc4ba868319ae$var$endMeasure(instance, `init`);
        if ($0a6cc4ba868319ae$var$isHmrUpdating) initialVNode.el = null;
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
        $0a6cc4ba868319ae$var$popWarningContext();
        $0a6cc4ba868319ae$var$endMeasure(instance, `mount`);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                $0a6cc4ba868319ae$var$pushWarningContext(n2);
                updateComponentPreRender(instance, n2, optimized);
                $0a6cc4ba868319ae$var$popWarningContext();
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        $0a6cc4ba868319ae$var$startMeasure(instance, `render`);
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        $0a6cc4ba868319ae$var$endMeasure(instance, `render`);
                        $0a6cc4ba868319ae$var$startMeasure(instance, `hydrate`);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                        $0a6cc4ba868319ae$var$endMeasure(instance, `hydrate`);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    $0a6cc4ba868319ae$var$startMeasure(instance, `render`);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    $0a6cc4ba868319ae$var$endMeasure(instance, `render`);
                    $0a6cc4ba868319ae$var$startMeasure(instance, `patch`);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    $0a6cc4ba868319ae$var$endMeasure(instance, `patch`);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$pushWarningContext(next || instance.vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                $0a6cc4ba868319ae$var$startMeasure(instance, `render`);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                $0a6cc4ba868319ae$var$endMeasure(instance, `render`);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                $0a6cc4ba868319ae$var$startMeasure(instance, `patch`);
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                $0a6cc4ba868319ae$var$endMeasure(instance, `patch`);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
                $0a6cc4ba868319ae$var$popWarningContext();
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        effect.onTrack = instance.rtc ? (e)=>(0, $8POXm.invokeArrayFns)(instance.rtc, e) : void 0;
        effect.onTrigger = instance.rtg ? (e)=>(0, $8POXm.invokeArrayFns)(instance.rtg, e) : void 0;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) {
                    if (keyToNewIndexMap.has(nextChild.key)) $0a6cc4ba868319ae$var$warn$1(`Duplicate keys found during update:`, JSON.stringify(nextChild.key), `Make sure keys are unique.`);
                    keyToNewIndexMap.set(nextChild.key, i);
                }
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $01W3b.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (vnode.patchFlag > 0 && vnode.patchFlag & 2048 && transition && !transition.persisted) vnode.children.forEach((child)=>{
                if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) hostRemove(child.el);
                else remove(child);
            });
            else removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        if (instance.type.__hmrId) $0a6cc4ba868319ae$var$unregisterHMR(instance);
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a, parent: parent, slots: { __: slotCacheKeys } } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        if (parent && (0, $8POXm.isArray)(slotCacheKeys)) slotCacheKeys.forEach((v1)=>{
            parent.renderCache[v1] = void 0;
        });
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
        c2.el && (c2.el.__vnode = c2);
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        if (!ctx) $0a6cc4ba868319ae$var$warn$1(`Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.`);
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, (0, $8POXm.extend)({}, options, {
        flush: "post"
    }));
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, (0, $8POXm.extend)({}, options, {
        flush: "sync"
    }));
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    if (!(0, $8POXm.isFunction)(cb)) $0a6cc4ba868319ae$var$warn$1(`\`watch(fn, options?)\` signature has been moved to a separate API. Use \`watchEffect(fn, options?)\` instead. \`watch\` now only supports \`watch(source, cb, options?) signature.`);
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    if (!cb) {
        if (immediate !== void 0) $0a6cc4ba868319ae$var$warn$1(`watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.`);
        if (deep !== void 0) $0a6cc4ba868319ae$var$warn$1(`watch() "deep" option is only respected when using the watch(source, callback, options?) signature.`);
        if (once !== void 0) $0a6cc4ba868319ae$var$warn$1(`watch() "once" option is only respected when using the watch(source, callback, options?) signature.`);
    }
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    baseWatchOptions.onWarn = $0a6cc4ba868319ae$var$warn$1;
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (!i) {
        $0a6cc4ba868319ae$var$warn$1(`useModel() called without active instance.`);
        return (0, $01W3b.ref)();
    }
    const camelizedName = (0, $8POXm.camelize)(name);
    if (!i.propsOptions[0][camelizedName]) {
        $0a6cc4ba868319ae$var$warn$1(`useModel() called with prop "${name}" which is not declared.`);
        return (0, $01W3b.ref)();
    }
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, emittedValue) && (0, $8POXm.hasChanged)(value, prevSetValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    {
        const { emitsOptions: emitsOptions, propsOptions: [propsOptions] } = instance;
        if (emitsOptions) {
            if (!(event in emitsOptions) && true) {
                if (!propsOptions || !((0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event)) in propsOptions)) $0a6cc4ba868319ae$var$warn$1(`Component emitted event "${event}" but it is neither declared in the emits option nor as an "${(0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))}" prop.`);
            } else {
                const validator = emitsOptions[event];
                if ((0, $8POXm.isFunction)(validator)) {
                    const isValid = validator(...rawArgs);
                    if (!isValid) $0a6cc4ba868319ae$var$warn$1(`Invalid event arguments: event validation failed for event "${event}".`);
                }
            }
        }
    }
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    {
        const lowerCaseEvent = event.toLowerCase();
        if (lowerCaseEvent !== event && props[(0, $8POXm.toHandlerKey)(lowerCaseEvent)]) $0a6cc4ba868319ae$var$warn$1(`Event "${lowerCaseEvent}" is emitted in component ${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)} but the handler is registered for "${event}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${(0, $8POXm.hyphenate)(event)}" instead of "${event}".`);
    }
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    $0a6cc4ba868319ae$var$accessedAttrs = false;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = setupState.__isScriptSetup ? new Proxy(proxyToUse, {
                get (target, key, receiver) {
                    $0a6cc4ba868319ae$var$warn$1(`Property '${String(key)}' was accessed via 'this'. Avoid using 'this' in templates.`);
                    return Reflect.get(target, key, receiver);
                }
            }) : proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, (0, $01W3b.shallowReadonly)(props), setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            if (attrs === props) $0a6cc4ba868319ae$var$markAttrsAccessed();
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2((0, $01W3b.shallowReadonly)(props), {
                get attrs () {
                    $0a6cc4ba868319ae$var$markAttrsAccessed();
                    return (0, $01W3b.shallowReadonly)(attrs);
                },
                slots: slots,
                emit: emit
            }) : render2((0, $01W3b.shallowReadonly)(props), null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (result.patchFlag > 0 && result.patchFlag & 2048) [root, setRoot] = $0a6cc4ba868319ae$var$getChildRoot(result);
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            } else if (!$0a6cc4ba868319ae$var$accessedAttrs && root.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                const allAttrs = Object.keys(attrs);
                const eventAttrs = [];
                const extraAttrs = [];
                for(let i = 0, l = allAttrs.length; i < l; i++){
                    const key = allAttrs[i];
                    if ((0, $8POXm.isOn)(key)) {
                        if (!(0, $8POXm.isModelListener)(key)) eventAttrs.push(key[2].toLowerCase() + key.slice(3));
                    } else extraAttrs.push(key);
                }
                if (extraAttrs.length) $0a6cc4ba868319ae$var$warn$1(`Extraneous non-props attributes (${extraAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`);
                if (eventAttrs.length) $0a6cc4ba868319ae$var$warn$1(`Extraneous non-emits event listeners (${eventAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`);
            }
        }
    }
    if (vnode.dirs) {
        if (!$0a6cc4ba868319ae$var$isElementRoot(root)) $0a6cc4ba868319ae$var$warn$1(`Runtime directive used on component with non-element root node. The directives will not function as intended.`);
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        if (!$0a6cc4ba868319ae$var$isElementRoot(root)) $0a6cc4ba868319ae$var$warn$1(`Component inside <Transition> renders non-element root node that cannot be animated.`);
        $0a6cc4ba868319ae$export$7770a22486565649(root, vnode.transition);
    }
    if (setRoot) setRoot(root);
    else result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    else if (childRoot.patchFlag > 0 && childRoot.patchFlag & 2048) return $0a6cc4ba868319ae$var$getChildRoot(childRoot);
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else {
                    singleRoot = child;
                    if (recurse && singleRoot.patchFlag > 0 && singleRoot.patchFlag & 2048) return $0a6cc4ba868319ae$var$filterSingleRoot(singleRoot.children);
                }
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if ((prevChildren || nextChildren) && $0a6cc4ba868319ae$var$isHmrUpdating) return true;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    if (!$0a6cc4ba868319ae$var$hasWarned) {
        $0a6cc4ba868319ae$var$hasWarned = true;
        console[console.info ? "info" : "log"](`<Suspense> is an experimental feature and its API will likely change.`);
    }
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    $0a6cc4ba868319ae$export$dfbcecb440255e4a(timeout, `Suspense timeout`);
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            if (!resume && !suspense.pendingBranch) throw new Error(`suspense.resolve() is called without a pending branch.`);
            if (suspense.isUnmounted) throw new Error(`suspense.resolve() is called on an already unmounted suspense boundary.`);
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$pushWarningContext(vnode2);
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                $0a6cc4ba868319ae$var$popWarningContext();
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        if (!singleChild && s.filter((child)=>child !== $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT).length > 0) $0a6cc4ba868319ae$var$warn$1(`<Suspense> slots expect a single root node.`);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    if (n2.shapeFlag & 6 && n1.component) {
        const dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(n2.type);
        if (dirtyInstances && dirtyInstances.has(n1.component)) {
            n1.shapeFlag &= -257;
            n2.shapeFlag &= -513;
            return false;
        }
    }
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if (vnode.key !== vnode.key) $0a6cc4ba868319ae$var$warn$1(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$createVNodeWithArgsTransform;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) {
        if (!type) $0a6cc4ba868319ae$var$warn$1(`Invalid vnode type when creating vnode: ${type}.`);
        type = $0a6cc4ba868319ae$export$4d299b491347818a;
    }
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    if (shapeFlag & 4 && (0, $01W3b.isProxy)(type)) {
        type = (0, $01W3b.toRaw)(type);
        $0a6cc4ba868319ae$var$warn$1(`Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with \`markRaw\` or using \`shallowRef\` instead of \`ref\`.`, `
Component that was made reactive: `, type);
    }
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: patchFlag === -1 && (0, $8POXm.isArray)(children) ? children.map($0a6cc4ba868319ae$var$deepCloneVNode) : children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = $0a6cc4ba868319ae$var$createDevRenderContext(instance);
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    if (Component.name) $0a6cc4ba868319ae$var$validateComponentName(Component.name, instance.appContext.config);
    if (Component.components) {
        const names = Object.keys(Component.components);
        for(let i = 0; i < names.length; i++)$0a6cc4ba868319ae$var$validateComponentName(names[i], instance.appContext.config);
    }
    if (Component.directives) {
        const names = Object.keys(Component.directives);
        for(let i = 0; i < names.length; i++)$0a6cc4ba868319ae$var$validateDirectiveName(names[i]);
    }
    if (Component.compilerOptions && $0a6cc4ba868319ae$export$c93a9c496c5211fa()) $0a6cc4ba868319ae$var$warn$1(`"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.`);
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, $01W3b.shallowReadonly)(instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else {
                instance.asyncDep = setupResult;
                if (!instance.suspense) {
                    const name = (_a = Component.name) != null ? _a : "Anonymous";
                    $0a6cc4ba868319ae$var$warn$1(`Component <${name}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`);
                }
            }
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(setupResult)) $0a6cc4ba868319ae$var$warn$1(`setup() should not return VNodes directly - return a render function instead.`);
        instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
        $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance);
    } else if (setupResult !== void 0) $0a6cc4ba868319ae$var$warn$1(`setup() should return an object. Received: ${setupResult === null ? "null" : typeof setupResult}`);
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                $0a6cc4ba868319ae$var$startMeasure(instance, `compile`);
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
                $0a6cc4ba868319ae$var$endMeasure(instance, `compile`);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
    if (!Component.render && instance.render === (0, $8POXm.NOOP) && !isSSR) {
        if (!$0a6cc4ba868319ae$var$compile && Component.template) $0a6cc4ba868319ae$var$warn$1(`Component provided template option but runtime compilation is not supported in this build of Vue.` + ` Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`);
        else $0a6cc4ba868319ae$var$warn$1(`Component is missing template or render function: `, Component);
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        $0a6cc4ba868319ae$var$markAttrsAccessed();
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    },
    set () {
        $0a6cc4ba868319ae$var$warn$1(`setupContext.attrs is readonly.`);
        return false;
    },
    deleteProperty () {
        $0a6cc4ba868319ae$var$warn$1(`setupContext.attrs is readonly.`);
        return false;
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        if (instance.exposed) $0a6cc4ba868319ae$var$warn$1(`expose() should be called only once per setup().`);
        if (exposed != null) {
            let exposedType = typeof exposed;
            if (exposedType === "object") {
                if ((0, $8POXm.isArray)(exposed)) exposedType = "array";
                else if ((0, $01W3b.isRef)(exposed)) exposedType = "ref";
            }
            if (exposedType !== "object") $0a6cc4ba868319ae$var$warn$1(`expose() should be passed a plain object, received ${exposedType}.`);
        }
        instance.exposed = exposed || {};
    };
    {
        let attrsProxy;
        let slotsProxy;
        return Object.freeze({
            get attrs () {
                return attrsProxy || (attrsProxy = new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers));
            },
            get slots () {
                return slotsProxy || (slotsProxy = $0a6cc4ba868319ae$var$getSlotsProxy(instance));
            },
            get emit () {
                return (event, ...args)=>instance.emit(event, ...args);
            },
            expose: expose
        });
    }
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    {
        const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
        if (i && i.appContext.config.warnRecursiveComputed) c._warnRecursive = true;
    }
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    if (typeof window === "undefined") return;
    const vueStyle = {
        style: "color:#3ba776"
    };
    const numberStyle = {
        style: "color:#1677ff"
    };
    const stringStyle = {
        style: "color:#f5222d"
    };
    const keywordStyle = {
        style: "color:#eb2f96"
    };
    const formatter = {
        __vue_custom_formatter: true,
        header (obj) {
            if (!(0, $8POXm.isObject)(obj)) return null;
            if (obj.__isVue) return [
                "div",
                vueStyle,
                `VueInstance`
            ];
            else if ((0, $01W3b.isRef)(obj)) {
                (0, $01W3b.pauseTracking)();
                const value = obj.value;
                (0, $01W3b.resetTracking)();
                return [
                    "div",
                    {},
                    [
                        "span",
                        vueStyle,
                        genRefFlag(obj)
                    ],
                    "<",
                    formatValue(value),
                    `>`
                ];
            } else if ((0, $01W3b.isReactive)(obj)) return [
                "div",
                {},
                [
                    "span",
                    vueStyle,
                    (0, $01W3b.isShallow)(obj) ? "ShallowReactive" : "Reactive"
                ],
                "<",
                formatValue(obj),
                `>${(0, $01W3b.isReadonly)(obj) ? ` (readonly)` : ``}`
            ];
            else if ((0, $01W3b.isReadonly)(obj)) return [
                "div",
                {},
                [
                    "span",
                    vueStyle,
                    (0, $01W3b.isShallow)(obj) ? "ShallowReadonly" : "Readonly"
                ],
                "<",
                formatValue(obj),
                ">"
            ];
            return null;
        },
        hasBody (obj) {
            return obj && obj.__isVue;
        },
        body (obj) {
            if (obj && obj.__isVue) return [
                "div",
                {},
                ...formatInstance(obj.$)
            ];
        }
    };
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
    if (window.devtoolsFormatters) window.devtoolsFormatters.push(formatter);
    else window.devtoolsFormatters = [
        formatter
    ];
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.16";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = $0a6cc4ba868319ae$var$warn$1;
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "toReadonly", () => $005d1fb7704e278c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $005d1fb7704e278c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        } else $005d1fb7704e278c$var$warn(`cannot run an inactive effect scope.`);
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $005d1fb7704e278c$var$activeEffectScope;
            $005d1fb7704e278c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            $005d1fb7704e278c$var$activeEffectScope = this.prevScope;
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
    else if (!failSilently) $005d1fb7704e278c$var$warn(`onScopeDispose() is called when there is no active effect scope to be associated with.`);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope && $005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            if ($005d1fb7704e278c$var$activeSub !== this) $005d1fb7704e278c$var$warn("Active effect was not restored correctly - this is likely a Vue internal bug.");
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$005d1fb7704e278c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subsHead === link) dep.subsHead = nextSub;
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
    else if (!failSilently) $005d1fb7704e278c$var$warn(`onEffectCleanup() was called when there was no active effect to associate with.`);
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        this.subsHead = void 0;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        if ($005d1fb7704e278c$var$activeSub.onTrack) $005d1fb7704e278c$var$activeSub.onTrack((0, $8POXm.extend)({
            effect: $005d1fb7704e278c$var$activeSub
        }, debugInfo));
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let head = this.subsHead; head; head = head.nextSub)if (head.sub.onTrigger && !(head.sub.flags & 8)) head.sub.onTrigger((0, $8POXm.extend)({
                effect: head.sub
            }, debugInfo));
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        if (link.dep.subsHead === void 0) link.dep.subsHead = link;
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("Object iterate");
const $005d1fb7704e278c$export$49093fa1cddcb78d = Symbol("Map keys iterate");
const $005d1fb7704e278c$export$4f926f0baab682cd = Symbol("Array iterate");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track({
            target: target,
            type: type,
            key: key
        });
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger({
            target: target,
            type: type,
            key: key,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, $005d1fb7704e278c$export$45c769cf449a508c);
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map($005d1fb7704e278c$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", $005d1fb7704e278c$export$45c769cf449a508c);
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        $005d1fb7704e278c$var$warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
    deleteProperty(target, key) {
        $005d1fb7704e278c$var$warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            $005d1fb7704e278c$var$warn(`${(0, $8POXm.capitalize)(type)} operation ${key}failed: target is readonly.`, $005d1fb7704e278c$export$ab18938b9fc5f28e(this));
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            } else $005d1fb7704e278c$var$checkIdentityKeys(target, has, key);
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            } else $005d1fb7704e278c$var$checkIdentityKeys(target, has, key);
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = (0, $8POXm.isMap)(target) ? new Map(target) : new Set(target);
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) {
        $005d1fb7704e278c$var$warn(`value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track({
            target: this,
            type: "get",
            key: "value"
        });
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger({
                target: this,
                type: "set",
                key: "value",
                newValue: newValue,
                oldValue: oldValue
            });
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger({
        target: ref2,
        type: "set",
        key: "value",
        newValue: ref2._value
    });
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    if (!$005d1fb7704e278c$export$5f3ca29d057519b3(object)) $005d1fb7704e278c$var$warn(`toRefs() expects a reactive object but received a plain one.`);
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track({
            target: this,
            type: "get",
            key: "value"
        });
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
        else $005d1fb7704e278c$var$warn("Write operation failed: computed value is readonly");
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    if (debugOptions && !isSSR) {
        cRef.onTrack = debugOptions.onTrack;
        cRef.onTrigger = debugOptions.onTrigger;
    }
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    } else if (!failSilently) $005d1fb7704e278c$var$warn(`onWatcherCleanup() was called when there was no active watcher to associate with.`);
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
                else warnInvalidSource(s);
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else {
        getter = (0, $8POXm.NOOP);
        warnInvalidSource(source);
    }
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    effect.onTrack = options.onTrack;
    effect.onTrigger = options.onTrigger;
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
/**
* @vue/shared v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = Object.freeze({});
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = Object.freeze([]);
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "assertNumber", () => (parcelRequire("TusQn")).assertNumber);
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
/**
* @vue/runtime-dom v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {
    (0, $TusQn.warn)(`Error creating trusted types policy: ${e}`);
}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow();
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow();
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    (0, $TusQn.assertNumber)(res, "<transition> explicit duration");
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
$a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.name = "show";
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("CSS_VAR_TEXT");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) {
        (0, $TusQn.warn)(`useCssVars is called without current active component instance.`);
        return;
    }
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    instance.getCssVars = ()=>getter(instance.proxy);
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if ($a5d55dc64ccb07cf$var$semicolonRE.test(val)) (0, $TusQn.warn)(`Unexpected semicolon at the end of '${name}' style value: '${val}'`);
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {
        if (!needRemove) (0, $TusQn.warn)(`Failed setting prop "${key}" on <${tag.toLowerCase()}>: value ${value} is invalid.`, e);
    }
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = $a5d55dc64ccb07cf$var$sanitizeEventValue(nextValue, rawName);
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker($a5d55dc64ccb07cf$var$sanitizeEventValue(nextValue, rawName), instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) (0, $8POXm.extend)(Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else {
            if (this.shadowRoot) (0, $TusQn.warn)(`Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use \`defineSSRCustomElement\`.`);
            if (_def.shadowRoot !== false) {
                this.attachShadow({
                    mode: "open"
                });
                this._root = this.shadowRoot;
            } else this._root = this;
        }
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            else if (styles) (0, $TusQn.warn)("Custom element style injection is not supported when using shadowRoot: false");
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (!def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
        else (0, $TusQn.warn)(`Exposed property "${key}" already exists on custom element.`);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            instance.ceReload = (newStyles)=>{
                if (this._styles) {
                    this._styles.forEach((s)=>this._root.removeChild(s));
                    this._styles.length = 0;
                }
                this._applyStyles(newStyles);
                this._instance = null;
                this._update();
            };
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
            if (owner) {
                if (owner.__hmrId) {
                    if (!this._childStyles) this._childStyles = /* @__PURE__ */ new Map();
                    let entry = this._childStyles.get(owner.__hmrId);
                    if (!entry) this._childStyles.set(owner.__hmrId, entry = []);
                    entry.push(s);
                }
            } else (this._styles || (this._styles = [])).push(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        this._styleChildren.delete(comp);
        if (this._childStyles && comp.__hmrId) {
            const oldStyles = this._childStyles.get(comp.__hmrId);
            if (oldStyles) {
                oldStyles.forEach((s)=>this._root.removeChild(s));
                oldStyles.length = 0;
            }
        }
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (true) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d("useShadowRoot");
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) {
            (0, $TusQn.warn)(`useCssModule must be called inside setup()`);
            return 0, $8POXm.EMPTY_OBJ;
        }
        const modules = instance.type.__cssModules;
        if (!modules) {
            (0, $TusQn.warn)(`Current instance does not have CSS modules injected.`);
            return 0, $8POXm.EMPTY_OBJ;
        }
        const mod = modules[name];
        if (!mod) {
            (0, $TusQn.warn)(`Current instance does not have CSS module named "${name}".`);
            return 0, $8POXm.EMPTY_OBJ;
        }
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                else if (child.type !== (0, $TusQn.Text)) (0, $TusQn.warn)(`<TransitionGroup> children must be keyed.`);
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) {
        (0, $TusQn.warn)(`<select multiple v-model> expects an Array or Set value for its binding, but got ${Object.prototype.toString.call(value).slice(8, -1)}.`);
        return;
    }
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    $a5d55dc64ccb07cf$var$injectNativeTagCheck(app);
    $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    $a5d55dc64ccb07cf$var$injectNativeTagCheck(app);
    $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        if (!res) (0, $TusQn.warn)(`Failed to mount app: mount target selector "${container}" returned null.`);
        return res;
    }
    if (window.ShadowRoot && container instanceof window.ShadowRoot && container.mode === "closed") (0, $TusQn.warn)(`mounting on a ShadowRoot with \`{mode: "closed"}\` may lead to unpredictable bugs`);
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});


parcelRegister("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});





parcelRegister("cCAf4", function(module, exports) {

$parcel$export(module.exports, "render", () => $9305258e174af6a7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $9305258e174af6a7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["RouterView"], null, {
        default: (0, $TusQn.withCtx)(({ Component: Component })=>[
                ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(Component)))
            ]),
        _: 1 /* STABLE */ 
    });
}

});

parcelRegister("jWWsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e860c7c238d9cdee$export$2e2bcd8739ae039);
let $e860c7c238d9cdee$var$NOOP = ()=>{};
var $e860c7c238d9cdee$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("hc7Da", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c84979f233c4dac5$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $hmpaa = parcelRequire("hmpaa");

var $apRgG = parcelRequire("apRgG");

var $73mM4 = parcelRequire("73mM4");

var $8i0dy = parcelRequire("8i0dy");

var $1qJO6 = parcelRequire("1qJO6");

var $2aUHH = parcelRequire("2aUHH");

var $hX5RY = parcelRequire("hX5RY");

var $lQ1qL = parcelRequire("lQ1qL");

var $gnCBA = parcelRequire("gnCBA");

var $ijUEj = parcelRequire("ijUEj");

var $1wdf7 = parcelRequire("1wdf7");

var $jozPh = parcelRequire("jozPh");

var $hLe2u = parcelRequire("hLe2u");

var $1JZJg = parcelRequire("1JZJg");

var $9cg2T = parcelRequire("9cg2T");

var $2HsZk = parcelRequire("2HsZk");

var $8BKbF = parcelRequire("8BKbF");

var $jp4JI = parcelRequire("jp4JI");

var $azAp0 = parcelRequire("azAp0");

var $6UCRk = parcelRequire("6UCRk");

var $jmFna = parcelRequire("jmFna");

var $eP4z8 = parcelRequire("eP4z8");

var $2OUw4 = parcelRequire("2OUw4");

var $bMZB2 = parcelRequire("bMZB2");

var $670qV = parcelRequire("670qV");

var $tMxeq = parcelRequire("tMxeq");
var $c84979f233c4dac5$export$2e2bcd8739ae039 = {
    __name: 'report',
    setup (__props, { expose: __expose }) {
        __expose();
        const isSticky = (0, $01W3b.ref)(false);
        const navigationSection = (0, $01W3b.ref)(null);
        const endSection = (0, $01W3b.ref)(null);
        const tabRefs = (0, $01W3b.ref)([]);
        const zipCodeInput = (0, $01W3b.ref)(null);
        const router = (0, $73mM4.useRouter)();
        const currentUrl = (0, $apRgG.useRouteQuery)('zip-code');
        const healthCardBreakpoint = (0, $hmpaa.useMediaQuery)('(min-width: 768px)');
        const activeTab = (0, $01W3b.computed)(()=>(0, $8i0dy.tabs).value.find((tab)=>tab.active));
        const activeTabCards = (0, $01W3b.computed)(()=>(0, $jozPh.default).value.filter((fact)=>fact.tab === activeTab.value.id));
        const tabHasUnseenUpdatedCards = (tab)=>!(0, $hLe2u.default).seen((0, $ijUEj.default).value, tab.id) && (0, $jozPh.default).value.filter((fact)=>fact.tab === tab.id && fact.moreInfo.updatedAt?.alert).length;
        const { top: navPosition, height: navHeight } = (0, $hmpaa.useElementBounding)(navigationSection);
        const { top: endSectionPosition } = (0, $hmpaa.useElementBounding)(endSection);
        const handleTab = (selectedTab)=>{
            (0, $8i0dy.tabs).value.forEach((tab)=>tab.active = tab.id === selectedTab.id);
            tabRefs.value.find((btn)=>btn.id === selectedTab.id).scrollIntoView({
                behavior: 'smooth',
                block: "nearest",
                inline: "center"
            });
        };
        const activeStyles = (0, $01W3b.computed)(()=>{
            return {
                border: activeTab.value.styles.border,
                bgColor: activeTab.value.styles.bgColor
            };
        });
        const handleScroll = ()=>isSticky.value = navPosition.value <= 0 && endSectionPosition.value > navHeight.value;
        const handleSubmit = ()=>{
            router.push({
                query: {
                    'zip-code': zipCodeInput.value
                }
            });
            zipCodeInput.value = null;
        };
        const setShowMoreInfo = (selectedCard, cards)=>{
            cards.filter((card)=>card.id !== selectedCard.id).map((card)=>card.moreInfo.active = false);
            cards.filter((card)=>card.id === selectedCard.id).map((card)=>card.moreInfo.active = !card.moreInfo.active);
        };
        (0, $TusQn.onMounted)(()=>{
            tabRefs.value.forEach((tabRef, index)=>(0, $8i0dy.tabs).value[index].visible = (0, $hmpaa.useElementVisibility)(tabRef, {
                    rootMargin: '50px',
                    threshold: 0.99
                }));
            window.addEventListener('scroll', handleScroll);
        });
        (0, $01W3b.watch)(()=>(0, $1wdf7.default).exists, (exists)=>{
            if (!exists) return;
            (0, $TusQn.nextTick)(()=>tabRefs.value.forEach((tabRef, index)=>{
                    (0, $8i0dy.tabs).value[index].visible = (0, $hmpaa.useElementVisibility)(tabRef, {
                        rootMargin: '50px',
                        threshold: 0.99
                    });
                }));
        }, {
            immediate: true
        });
        (0, $01W3b.watch)(activeTab, (newTab, oldTab)=>(0, $hLe2u.default).saw((0, $ijUEj.default).value, oldTab?.id));
        (0, $TusQn.watchEffect)(()=>{
            if (healthCardBreakpoint.value) (0, $TusQn.nextTick)(()=>tabRefs.value.forEach((tabRef, index)=>{
                    (0, $8i0dy.tabs).value[index].visible = (0, $hmpaa.useElementVisibility)(tabRef, {
                        rootMargin: '50px',
                        threshold: 0.99
                    });
                }));
        });
        (0, $TusQn.watchEffect)(()=>{
            if (activeTabCards.value) activeTabCards.value.map((card)=>card.moreInfo.active = false);
            if ((0, $ijUEj.default).value) activeTabCards.value.map((card)=>card.moreInfo.active = false);
            (0, $ijUEj.default).value = currentUrl.value;
        });
        const navigateToForm = ()=>{
            router.push({
                path: '/form',
                query: {
                    'zip-code': (0, $ijUEj.default).value
                }
            });
        };
        const __returned__ = {
            isSticky: isSticky,
            navigationSection: navigationSection,
            endSection: endSection,
            tabRefs: tabRefs,
            zipCodeInput: zipCodeInput,
            router: router,
            currentUrl: currentUrl,
            healthCardBreakpoint: healthCardBreakpoint,
            activeTab: activeTab,
            activeTabCards: activeTabCards,
            tabHasUnseenUpdatedCards: tabHasUnseenUpdatedCards,
            navPosition: navPosition,
            navHeight: navHeight,
            endSectionPosition: endSectionPosition,
            handleTab: handleTab,
            activeStyles: activeStyles,
            handleScroll: handleScroll,
            handleSubmit: handleSubmit,
            setShowMoreInfo: setShowMoreInfo,
            navigateToForm: navigateToForm,
            ref: $01W3b.ref,
            onMounted: $TusQn.onMounted,
            computed: $01W3b.computed,
            watch: $01W3b.watch,
            watchEffect: $TusQn.watchEffect,
            nextTick: $TusQn.nextTick,
            get useElementVisibility () {
                return 0, $hmpaa.useElementVisibility;
            },
            get useElementBounding () {
                return 0, $hmpaa.useElementBounding;
            },
            get useMediaQuery () {
                return 0, $hmpaa.useMediaQuery;
            },
            get useRouteQuery () {
                return 0, $apRgG.useRouteQuery;
            },
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            get tabs () {
                return 0, $8i0dy.tabs;
            },
            get demographicStatsReference () {
                return 0, $1qJO6.demographicStatsReference;
            },
            get populationHealthReference () {
                return 0, $2aUHH.populationHealthReference;
            },
            get mockupUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($hX5RY));
            },
            get amsUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($lQ1qL));
            },
            get logoUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($gnCBA));
            },
            get zipCode () {
                return 0, $ijUEj.default;
            },
            get place () {
                return 0, $1wdf7.default;
            },
            get demographicStats () {
                return 0, $1qJO6.default;
            },
            get metricStats () {
                return 0, $2aUHH.default;
            },
            get healthDataFacts () {
                return 0, $jozPh.default;
            },
            get history () {
                return 0, $hLe2u.default;
            },
            DemographicDivider: $1JZJg.default,
            SectionDivider: $9cg2T.default,
            Header: $2HsZk.default,
            Footer: $8BKbF.default,
            Button: $jp4JI.default,
            Demographic: $azAp0.default,
            PopulationHealth: $6UCRk.default,
            HealthDataCards: $jmFna.default,
            CommunityImpactCards: $eP4z8.default,
            OutbreakAlert: $2OUw4.default,
            References: $bMZB2.default,
            get communityImpactFacts () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($670qV));
            },
            get references () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($tMxeq));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("hmpaa", function(module, exports) {

$parcel$export(module.exports, "useMediaQuery", () => $6ffe9515611cb489$export$32d5543ab307c01);
$parcel$export(module.exports, "useElementBounding", () => $6ffe9515611cb489$export$f623e6fca765c371);
$parcel$export(module.exports, "useElementSize", () => $6ffe9515611cb489$export$2b86bedf890eab8);
$parcel$export(module.exports, "useElementVisibility", () => $6ffe9515611cb489$export$6aadc312a449609d);
$parcel$export(module.exports, "useWindowSize", () => $6ffe9515611cb489$export$42c02f33970a2afa);

var $AHHxt = parcelRequire("AHHxt");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
function $6ffe9515611cb489$export$dcbb7025f4e5281b(evaluationCallback, initialState, optionsOrRef) {
    let options;
    if ((0, $01W3b.isRef)(optionsOrRef)) options = {
        evaluating: optionsOrRef
    };
    else options = optionsOrRef || {};
    const { lazy: lazy = false, evaluating: evaluating, shallow: shallow = true, onError: onError = (0, $AHHxt.noop) } = options;
    const started = (0, $01W3b.shallowRef)(!lazy);
    const current = shallow ? (0, $01W3b.shallowRef)(initialState) : (0, $01W3b.ref)(initialState);
    let counter = 0;
    (0, $TusQn.watchEffect)(async (onInvalidate)=>{
        if (!started.value) return;
        counter++;
        const counterAtBeginning = counter;
        let hasFinished = false;
        if (evaluating) Promise.resolve().then(()=>{
            evaluating.value = true;
        });
        try {
            const result = await evaluationCallback((cancelCallback)=>{
                onInvalidate(()=>{
                    if (evaluating) evaluating.value = false;
                    if (!hasFinished) cancelCallback();
                });
            });
            if (counterAtBeginning === counter) current.value = result;
        } catch (e) {
            onError(e);
        } finally{
            if (evaluating && counterAtBeginning === counter) evaluating.value = false;
            hasFinished = true;
        }
    });
    if (lazy) return (0, $01W3b.computed)(()=>{
        started.value = true;
        return current.value;
    });
    else return current;
}
function $6ffe9515611cb489$export$dc0885167ecf1257(key, options, defaultSource, treatDefaultAsFactory) {
    let source = (0, $TusQn.inject)(key);
    if (defaultSource) source = (0, $TusQn.inject)(key, defaultSource);
    if (treatDefaultAsFactory) source = (0, $TusQn.inject)(key, defaultSource, treatDefaultAsFactory);
    if (typeof options === "function") return (0, $01W3b.computed)((ctx)=>options(source, ctx));
    else return (0, $01W3b.computed)({
        get: (ctx)=>options.get(source, ctx),
        set: options.set
    });
}
function $6ffe9515611cb489$export$7ef9f841998c60db(options = {}) {
    const { inheritAttrs: inheritAttrs = true } = options;
    const render = (0, $01W3b.shallowRef)();
    const define = /*@__PURE__*/ (0, $TusQn.defineComponent)({
        setup (_, { slots: slots }) {
            return ()=>{
                render.value = slots.default;
            };
        }
    });
    const reuse = /*@__PURE__*/ (0, $TusQn.defineComponent)({
        inheritAttrs: inheritAttrs,
        props: options.props,
        setup (props, { attrs: attrs, slots: slots }) {
            return ()=>{
                var _a;
                if (!render.value && true) throw new Error("[VueUse] Failed to find the definition of reusable template");
                const vnode = (_a = render.value) == null ? void 0 : _a.call(render, {
                    ...options.props == null ? $6ffe9515611cb489$var$keysToCamelKebabCase(attrs) : props,
                    $slots: slots
                });
                return inheritAttrs && (vnode == null ? void 0 : vnode.length) === 1 ? vnode[0] : vnode;
            };
        }
    });
    return (0, $AHHxt.makeDestructurable)({
        define: define,
        reuse: reuse
    }, [
        define,
        reuse
    ]);
}
function $6ffe9515611cb489$var$keysToCamelKebabCase(obj) {
    const newObj = {};
    for(const key in obj)newObj[(0, $AHHxt.camelize)(key)] = obj[key];
    return newObj;
}
function $6ffe9515611cb489$export$cf238338337c58d1(options = {}) {
    let index = 0;
    const instances = (0, $01W3b.ref)([]);
    function create(...args) {
        const props = (0, $01W3b.shallowReactive)({
            key: index++,
            args: args,
            promise: void 0,
            resolve: ()=>{},
            reject: ()=>{},
            isResolving: false,
            options: options
        });
        instances.value.push(props);
        props.promise = new Promise((_resolve, _reject)=>{
            props.resolve = (v)=>{
                props.isResolving = true;
                return _resolve(v);
            };
            props.reject = _reject;
        }).finally(()=>{
            props.promise = void 0;
            const index2 = instances.value.indexOf(props);
            if (index2 !== -1) instances.value.splice(index2, 1);
        });
        return props.promise;
    }
    function start(...args) {
        if (options.singleton && instances.value.length > 0) return instances.value[0].promise;
        return create(...args);
    }
    const component = /*@__PURE__*/ (0, $TusQn.defineComponent)((_, { slots: slots })=>{
        const renderList = ()=>instances.value.map((props)=>{
                var _a;
                return (0, $TusQn.h)((0, $TusQn.Fragment), {
                    key: props.key
                }, (_a = slots.default) == null ? void 0 : _a.call(slots, props));
            });
        if (options.transition) return ()=>(0, $TusQn.h)((0, $eeJ70.TransitionGroup), options.transition, renderList);
        return renderList;
    });
    component.start = start;
    return component;
}
function $6ffe9515611cb489$export$4ebd6dd2d9c62e4b(fn) {
    return function(...args) {
        return fn.apply(this, args.map((i)=>(0, $01W3b.toValue)(i)));
    };
}
const $6ffe9515611cb489$export$16f8ba610718ae4a = (0, $AHHxt.isClient) ? window : void 0;
const $6ffe9515611cb489$export$37990bd438d16af3 = (0, $AHHxt.isClient) ? window.document : void 0;
const $6ffe9515611cb489$export$eade61489f57e3fc = (0, $AHHxt.isClient) ? window.navigator : void 0;
const $6ffe9515611cb489$export$66494ae16bad8985 = (0, $AHHxt.isClient) ? window.location : void 0;
function $6ffe9515611cb489$export$c61124d3cf5adbae(elRef) {
    var _a;
    const plain = (0, $01W3b.toValue)(elRef);
    return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
function $6ffe9515611cb489$export$7080b3e976bc91ab(...args) {
    const cleanups = [];
    const cleanup = ()=>{
        cleanups.forEach((fn)=>fn());
        cleanups.length = 0;
    };
    const register = (el, event, listener, options)=>{
        el.addEventListener(event, listener, options);
        return ()=>el.removeEventListener(event, listener, options);
    };
    const firstParamTargets = (0, $01W3b.computed)(()=>{
        const test = (0, $AHHxt.toArray)((0, $01W3b.toValue)(args[0])).filter((e)=>e != null);
        return test.every((e)=>typeof e !== "string") ? test : void 0;
    });
    const stopWatch = (0, $AHHxt.watchImmediate)(()=>{
        var _a, _b;
        return [
            (_b = (_a = firstParamTargets.value) == null ? void 0 : _a.map((e)=>$6ffe9515611cb489$export$c61124d3cf5adbae(e))) != null ? _b : [
                $6ffe9515611cb489$export$16f8ba610718ae4a
            ].filter((e)=>e != null),
            (0, $AHHxt.toArray)((0, $01W3b.toValue)(firstParamTargets.value ? args[1] : args[0])),
            (0, $AHHxt.toArray)((0, $01W3b.unref)(firstParamTargets.value ? args[2] : args[1])),
            // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
            (0, $01W3b.toValue)(firstParamTargets.value ? args[3] : args[2])
        ];
    }, ([raw_targets, raw_events, raw_listeners, raw_options])=>{
        cleanup();
        if (!(raw_targets == null ? void 0 : raw_targets.length) || !(raw_events == null ? void 0 : raw_events.length) || !(raw_listeners == null ? void 0 : raw_listeners.length)) return;
        const optionsClone = (0, $AHHxt.isObject)(raw_options) ? {
            ...raw_options
        } : raw_options;
        cleanups.push(...raw_targets.flatMap((el)=>raw_events.flatMap((event)=>raw_listeners.map((listener)=>register(el, event, listener, optionsClone)))));
    }, {
        flush: "post"
    });
    const stop = ()=>{
        stopWatch();
        cleanup();
    };
    (0, $AHHxt.tryOnScopeDispose)(cleanup);
    return stop;
}
let $6ffe9515611cb489$var$_iOSWorkaround = false;
function $6ffe9515611cb489$export$806d9a98fb0e6fd0(target, handler, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ignore: ignore = [], capture: capture = true, detectIframe: detectIframe = false, controls: controls = false } = options;
    if (!window1) return controls ? {
        stop: (0, $AHHxt.noop),
        cancel: (0, $AHHxt.noop),
        trigger: (0, $AHHxt.noop)
    } : (0, $AHHxt.noop);
    if ((0, $AHHxt.isIOS) && !$6ffe9515611cb489$var$_iOSWorkaround) {
        $6ffe9515611cb489$var$_iOSWorkaround = true;
        const listenerOptions = {
            passive: true
        };
        Array.from(window1.document.body.children).forEach((el)=>$6ffe9515611cb489$export$7080b3e976bc91ab(el, "click", (0, $AHHxt.noop), listenerOptions));
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1.document.documentElement, "click", (0, $AHHxt.noop), listenerOptions);
    }
    let shouldListen = true;
    const shouldIgnore = (event)=>{
        return (0, $01W3b.toValue)(ignore).some((target2)=>{
            if (typeof target2 === "string") return Array.from(window1.document.querySelectorAll(target2)).some((el)=>el === event.target || event.composedPath().includes(el));
            else {
                const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target2);
                return el && (event.target === el || event.composedPath().includes(el));
            }
        });
    };
    function hasMultipleRoots(target2) {
        const vm = (0, $01W3b.toValue)(target2);
        return vm && vm.$.subTree.shapeFlag === 16;
    }
    function checkMultipleRoots(target2, event) {
        const vm = (0, $01W3b.toValue)(target2);
        const children = vm.$.subTree && vm.$.subTree.children;
        if (children == null || !Array.isArray(children)) return false;
        return children.some((child)=>child.el === event.target || event.composedPath().includes(child.el));
    }
    const listener = (event)=>{
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (event.target == null) return;
        if (!(el instanceof Element) && hasMultipleRoots(target) && checkMultipleRoots(target, event)) return;
        if (!el || el === event.target || event.composedPath().includes(el)) return;
        if ("detail" in event && event.detail === 0) shouldListen = !shouldIgnore(event);
        if (!shouldListen) {
            shouldListen = true;
            return;
        }
        handler(event);
    };
    let isProcessingClick = false;
    const cleanup = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "click", (event)=>{
            if (!isProcessingClick) {
                isProcessingClick = true;
                setTimeout(()=>{
                    isProcessingClick = false;
                }, 0);
                listener(event);
            }
        }, {
            passive: true,
            capture: capture
        }),
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "pointerdown", (e)=>{
            const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
            shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
        }, {
            passive: true
        }),
        detectIframe && $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            setTimeout(()=>{
                var _a;
                const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
                if (((_a = window1.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window1.document.activeElement))) handler(event);
            }, 0);
        }, {
            passive: true
        })
    ].filter(Boolean);
    const stop = ()=>cleanup.forEach((fn)=>fn());
    if (controls) return {
        stop: stop,
        cancel: ()=>{
            shouldListen = false;
        },
        trigger: (event)=>{
            shouldListen = true;
            listener(event);
            shouldListen = false;
        }
    };
    return stop;
}
function $6ffe9515611cb489$export$bce3bfec9f56c837() {
    const isMounted = (0, $01W3b.shallowRef)(false);
    const instance = (0, $TusQn.getCurrentInstance)();
    if (instance) (0, $TusQn.onMounted)(()=>{
        isMounted.value = true;
    }, instance);
    return isMounted;
}
function $6ffe9515611cb489$export$85904d4478b9c8a4(callback) {
    const isMounted = $6ffe9515611cb489$export$bce3bfec9f56c837();
    return (0, $01W3b.computed)(()=>{
        isMounted.value;
        return Boolean(callback());
    });
}
function $6ffe9515611cb489$export$8ecdcf3bb089e9cd(target, callback, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ...mutationOptions } = options;
    let observer;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "MutationObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const targets = (0, $01W3b.computed)(()=>{
        const value = (0, $01W3b.toValue)(target);
        const items = (0, $AHHxt.toArray)(value).map($6ffe9515611cb489$export$c61124d3cf5adbae).filter((0, $AHHxt.notNullish));
        return new Set(items);
    });
    const stopWatch = (0, $01W3b.watch)(()=>targets.value, (targets2)=>{
        cleanup();
        if (isSupported.value && targets2.size) {
            observer = new MutationObserver(callback);
            targets2.forEach((el)=>observer.observe(el, mutationOptions));
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const takeRecords = ()=>{
        return observer == null ? void 0 : observer.takeRecords();
    };
    const stop = ()=>{
        stopWatch();
        cleanup();
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop,
        takeRecords: takeRecords
    };
}
function $6ffe9515611cb489$export$23b05fde944e9922(target, callback, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, document: document1 = window1 == null ? void 0 : window1.document, flush: flush = "sync" } = options;
    if (!window1 || !document1) return 0, $AHHxt.noop;
    let stopFn;
    const cleanupAndUpdate = (fn)=>{
        stopFn == null || stopFn();
        stopFn = fn;
    };
    const stopWatch = (0, $TusQn.watchEffect)(()=>{
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (el) {
            const { stop: stop } = $6ffe9515611cb489$export$8ecdcf3bb089e9cd(document1, (mutationsList)=>{
                const targetRemoved = mutationsList.map((mutation)=>[
                        ...mutation.removedNodes
                    ]).flat().some((node)=>node === el || node.contains(el));
                if (targetRemoved) callback(mutationsList);
            }, {
                window: window1,
                childList: true,
                subtree: true
            });
            cleanupAndUpdate(stop);
        }
    }, {
        flush: flush
    });
    const stopHandle = ()=>{
        stopWatch();
        cleanupAndUpdate();
    };
    (0, $AHHxt.tryOnScopeDispose)(stopHandle);
    return stopHandle;
}
function $6ffe9515611cb489$var$createKeyPredicate(keyFilter) {
    if (typeof keyFilter === "function") return keyFilter;
    else if (typeof keyFilter === "string") return (event)=>event.key === keyFilter;
    else if (Array.isArray(keyFilter)) return (event)=>keyFilter.includes(event.key);
    return ()=>true;
}
function $6ffe9515611cb489$export$70ca9878161d161b(...args) {
    let key;
    let handler;
    let options = {};
    if (args.length === 3) {
        key = args[0];
        handler = args[1];
        options = args[2];
    } else if (args.length === 2) {
        if (typeof args[1] === "object") {
            key = true;
            handler = args[0];
            options = args[1];
        } else {
            key = args[0];
            handler = args[1];
        }
    } else {
        key = true;
        handler = args[0];
    }
    const { target: target = $6ffe9515611cb489$export$16f8ba610718ae4a, eventName: eventName = "keydown", passive: passive = false, dedupe: dedupe = false } = options;
    const predicate = $6ffe9515611cb489$var$createKeyPredicate(key);
    const listener = (e)=>{
        if (e.repeat && (0, $01W3b.toValue)(dedupe)) return;
        if (predicate(e)) handler(e);
    };
    return $6ffe9515611cb489$export$7080b3e976bc91ab(target, eventName, listener, passive);
}
function $6ffe9515611cb489$export$de8e1b1372cdb41b(key, handler, options = {}) {
    return $6ffe9515611cb489$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keydown"
    });
}
function $6ffe9515611cb489$export$33ead148203888dd(key, handler, options = {}) {
    return $6ffe9515611cb489$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keypress"
    });
}
function $6ffe9515611cb489$export$f144bbb6e186b14b(key, handler, options = {}) {
    return $6ffe9515611cb489$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keyup"
    });
}
const $6ffe9515611cb489$var$DEFAULT_DELAY = 500;
const $6ffe9515611cb489$var$DEFAULT_THRESHOLD = 10;
function $6ffe9515611cb489$export$d0dd9c8bca391fcb(target, handler, options) {
    var _a, _b;
    const elementRef = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target));
    let timeout;
    let posStart;
    let startTimestamp;
    let hasLongPressed = false;
    function clear() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = void 0;
        }
        posStart = void 0;
        startTimestamp = void 0;
        hasLongPressed = false;
    }
    function onRelease(ev) {
        var _a2, _b2, _c;
        const [_startTimestamp, _posStart, _hasLongPressed] = [
            startTimestamp,
            posStart,
            hasLongPressed
        ];
        clear();
        if (!(options == null ? void 0 : options.onMouseUp) || !_posStart || !_startTimestamp) return;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        const dx = ev.x - _posStart.x;
        const dy = ev.y - _posStart.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        options.onMouseUp(ev.timeStamp - _startTimestamp, distance, _hasLongPressed);
    }
    function onDown(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        clear();
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        posStart = {
            x: ev.x,
            y: ev.y
        };
        startTimestamp = ev.timeStamp;
        timeout = setTimeout(()=>{
            hasLongPressed = true;
            handler(ev);
        }, (_d = options == null ? void 0 : options.delay) != null ? _d : $6ffe9515611cb489$var$DEFAULT_DELAY);
    }
    function onMove(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        if (!posStart || (options == null ? void 0 : options.distanceThreshold) === false) return;
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        const dx = ev.x - posStart.x;
        const dy = ev.y - posStart.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance >= ((_d = options == null ? void 0 : options.distanceThreshold) != null ? _d : $6ffe9515611cb489$var$DEFAULT_THRESHOLD)) clear();
    }
    const listenerOptions = {
        capture: (_a = options == null ? void 0 : options.modifiers) == null ? void 0 : _a.capture,
        once: (_b = options == null ? void 0 : options.modifiers) == null ? void 0 : _b.once
    };
    const cleanup = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(elementRef, "pointerdown", onDown, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(elementRef, "pointermove", onMove, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(elementRef, [
            "pointerup",
            "pointerleave"
        ], onRelease, listenerOptions)
    ];
    const stop = ()=>cleanup.forEach((fn)=>fn());
    return stop;
}
function $6ffe9515611cb489$var$isFocusedElementEditable() {
    const { activeElement: activeElement, body: body } = document;
    if (!activeElement) return false;
    if (activeElement === body) return false;
    switch(activeElement.tagName){
        case "INPUT":
        case "TEXTAREA":
            return true;
    }
    return activeElement.hasAttribute("contenteditable");
}
function $6ffe9515611cb489$var$isTypedCharValid({ keyCode: keyCode, metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey }) {
    if (metaKey || ctrlKey || altKey) return false;
    if (keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105) return true;
    if (keyCode >= 65 && keyCode <= 90) return true;
    return false;
}
function $6ffe9515611cb489$export$cd54fc233e2f4a5d(callback, options = {}) {
    const { document: document2 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const keydown = (event)=>{
        if (!$6ffe9515611cb489$var$isFocusedElementEditable() && $6ffe9515611cb489$var$isTypedCharValid(event)) callback(event);
    };
    if (document2) $6ffe9515611cb489$export$7080b3e976bc91ab(document2, "keydown", keydown, {
        passive: true
    });
}
function $6ffe9515611cb489$export$fc38e812d383221(key, initialValue = null) {
    const instance = (0, $TusQn.getCurrentInstance)();
    let _trigger = ()=>{};
    const element = (0, $01W3b.customRef)((track, trigger)=>{
        _trigger = trigger;
        return {
            get () {
                var _a, _b;
                track();
                return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs[key]) != null ? _b : initialValue;
            },
            set () {}
        };
    });
    (0, $AHHxt.tryOnMounted)(_trigger);
    (0, $TusQn.onUpdated)(_trigger);
    return element;
}
function $6ffe9515611cb489$export$4e1875a4b2b1434f(options = {}) {
    var _a;
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, deep: deep = true, triggerOnRemoval: triggerOnRemoval = false } = options;
    const document1 = (_a = options.document) != null ? _a : window1 == null ? void 0 : window1.document;
    const getDeepActiveElement = ()=>{
        var _a2;
        let element = document1 == null ? void 0 : document1.activeElement;
        if (deep) while(element == null ? void 0 : element.shadowRoot)element = (_a2 = element == null ? void 0 : element.shadowRoot) == null ? void 0 : _a2.activeElement;
        return element;
    };
    const activeElement = (0, $01W3b.shallowRef)();
    const trigger = ()=>{
        activeElement.value = getDeepActiveElement();
    };
    if (window1) {
        const listenerOptions = {
            capture: true,
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            if (event.relatedTarget !== null) return;
            trigger();
        }, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "focus", trigger, listenerOptions);
    }
    if (triggerOnRemoval) $6ffe9515611cb489$export$23b05fde944e9922(activeElement, trigger, {
        document: document1
    });
    trigger();
    return activeElement;
}
function $6ffe9515611cb489$export$13251e0fc79284e(fn, options = {}) {
    const { immediate: immediate = true, fpsLimit: fpsLimit, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, once: once = false } = options;
    const isActive = (0, $01W3b.shallowRef)(false);
    const intervalLimit = (0, $01W3b.computed)(()=>{
        return fpsLimit ? 1e3 / (0, $01W3b.toValue)(fpsLimit) : null;
    });
    let previousFrameTimestamp = 0;
    let rafId = null;
    function loop(timestamp) {
        if (!isActive.value || !window1) return;
        if (!previousFrameTimestamp) previousFrameTimestamp = timestamp;
        const delta = timestamp - previousFrameTimestamp;
        if (intervalLimit.value && delta < intervalLimit.value) {
            rafId = window1.requestAnimationFrame(loop);
            return;
        }
        previousFrameTimestamp = timestamp;
        fn({
            delta: delta,
            timestamp: timestamp
        });
        if (once) {
            isActive.value = false;
            rafId = null;
            return;
        }
        rafId = window1.requestAnimationFrame(loop);
    }
    function resume() {
        if (!isActive.value && window1) {
            isActive.value = true;
            previousFrameTimestamp = 0;
            rafId = window1.requestAnimationFrame(loop);
        }
    }
    function pause() {
        isActive.value = false;
        if (rafId != null && window1) {
            window1.cancelAnimationFrame(rafId);
            rafId = null;
        }
    }
    if (immediate) resume();
    (0, $AHHxt.tryOnScopeDispose)(pause);
    return {
        isActive: (0, $01W3b.readonly)(isActive),
        pause: pause,
        resume: resume
    };
}
function $6ffe9515611cb489$export$9f387b98a73b1511(target, keyframes, options) {
    let config;
    let animateOptions;
    if ((0, $AHHxt.isObject)(options)) {
        config = options;
        animateOptions = (0, $AHHxt.objectOmit)(options, [
            "window",
            "immediate",
            "commitStyles",
            "persist",
            "onReady",
            "onError"
        ]);
    } else {
        config = {
            duration: options
        };
        animateOptions = options;
    }
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, immediate: immediate = true, commitStyles: commitStyles, persist: persist, playbackRate: _playbackRate = 1, onReady: onReady, onError: onError = (e)=>{
        console.error(e);
    } } = config;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && HTMLElement && "animate" in HTMLElement.prototype);
    const animate = (0, $01W3b.shallowRef)(void 0);
    const store = (0, $01W3b.shallowReactive)({
        startTime: null,
        currentTime: null,
        timeline: null,
        playbackRate: _playbackRate,
        pending: false,
        playState: immediate ? "idle" : "paused",
        replaceState: "active"
    });
    const pending = (0, $01W3b.computed)(()=>store.pending);
    const playState = (0, $01W3b.computed)(()=>store.playState);
    const replaceState = (0, $01W3b.computed)(()=>store.replaceState);
    const startTime = (0, $01W3b.computed)({
        get () {
            return store.startTime;
        },
        set (value) {
            store.startTime = value;
            if (animate.value) animate.value.startTime = value;
        }
    });
    const currentTime = (0, $01W3b.computed)({
        get () {
            return store.currentTime;
        },
        set (value) {
            store.currentTime = value;
            if (animate.value) {
                animate.value.currentTime = value;
                syncResume();
            }
        }
    });
    const timeline = (0, $01W3b.computed)({
        get () {
            return store.timeline;
        },
        set (value) {
            store.timeline = value;
            if (animate.value) animate.value.timeline = value;
        }
    });
    const playbackRate = (0, $01W3b.computed)({
        get () {
            return store.playbackRate;
        },
        set (value) {
            store.playbackRate = value;
            if (animate.value) animate.value.playbackRate = value;
        }
    });
    const play = ()=>{
        if (animate.value) try {
            animate.value.play();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
        else update();
    };
    const pause = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.pause();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const reverse = ()=>{
        var _a;
        if (!animate.value) update();
        try {
            (_a = animate.value) == null || _a.reverse();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
    };
    const finish = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.finish();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const cancel = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.cancel();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    (0, $01W3b.watch)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target), (el)=>{
        if (el) update();
        else animate.value = void 0;
    });
    (0, $01W3b.watch)(()=>keyframes, (value)=>{
        if (animate.value) {
            update();
            const targetEl = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
            if (targetEl) animate.value.effect = new KeyframeEffect(targetEl, (0, $01W3b.toValue)(value), animateOptions);
        }
    }, {
        deep: true
    });
    (0, $AHHxt.tryOnMounted)(()=>update(true), false);
    (0, $AHHxt.tryOnScopeDispose)(cancel);
    function update(init) {
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (!isSupported.value || !el) return;
        if (!animate.value) animate.value = el.animate((0, $01W3b.toValue)(keyframes), animateOptions);
        if (persist) animate.value.persist();
        if (_playbackRate !== 1) animate.value.playbackRate = _playbackRate;
        if (init && !immediate) animate.value.pause();
        else syncResume();
        onReady == null || onReady(animate.value);
    }
    const listenerOptions = {
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(animate, [
        "cancel",
        "finish",
        "remove"
    ], syncPause, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(animate, "finish", ()=>{
        var _a;
        if (commitStyles) (_a = animate.value) == null || _a.commitStyles();
    }, listenerOptions);
    const { resume: resumeRef, pause: pauseRef } = $6ffe9515611cb489$export$13251e0fc79284e(()=>{
        if (!animate.value) return;
        store.pending = animate.value.pending;
        store.playState = animate.value.playState;
        store.replaceState = animate.value.replaceState;
        store.startTime = animate.value.startTime;
        store.currentTime = animate.value.currentTime;
        store.timeline = animate.value.timeline;
        store.playbackRate = animate.value.playbackRate;
    }, {
        immediate: false
    });
    function syncResume() {
        if (isSupported.value) resumeRef();
    }
    function syncPause() {
        if (isSupported.value && window1) window1.requestAnimationFrame(pauseRef);
    }
    return {
        isSupported: isSupported,
        animate: animate,
        play: // actions
        play,
        pause: pause,
        reverse: reverse,
        finish: finish,
        cancel: cancel,
        pending: // state
        pending,
        playState: playState,
        replaceState: replaceState,
        startTime: startTime,
        currentTime: currentTime,
        timeline: timeline,
        playbackRate: playbackRate
    };
}
function $6ffe9515611cb489$export$15048550d0df8459(tasks, options) {
    const { interrupt: interrupt = true, onError: onError = (0, $AHHxt.noop), onFinished: onFinished = (0, $AHHxt.noop), signal: signal } = options || {};
    const promiseState = {
        aborted: "aborted",
        fulfilled: "fulfilled",
        pending: "pending",
        rejected: "rejected"
    };
    const initialResult = Array.from(Array.from({
        length: tasks.length
    }), ()=>({
            state: promiseState.pending,
            data: null
        }));
    const result = (0, $01W3b.reactive)(initialResult);
    const activeIndex = (0, $01W3b.shallowRef)(-1);
    if (!tasks || tasks.length === 0) {
        onFinished();
        return {
            activeIndex: activeIndex,
            result: result
        };
    }
    function updateResult(state, res) {
        activeIndex.value++;
        result[activeIndex.value].data = res;
        result[activeIndex.value].state = state;
    }
    tasks.reduce((prev, curr)=>{
        return prev.then((prevRes)=>{
            var _a;
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, new Error("aborted"));
                return;
            }
            if (((_a = result[activeIndex.value]) == null ? void 0 : _a.state) === promiseState.rejected && interrupt) {
                onFinished();
                return;
            }
            const done = curr(prevRes).then((currentRes)=>{
                updateResult(promiseState.fulfilled, currentRes);
                if (activeIndex.value === tasks.length - 1) onFinished();
                return currentRes;
            });
            if (!signal) return done;
            return Promise.race([
                done,
                $6ffe9515611cb489$var$whenAborted(signal)
            ]);
        }).catch((e)=>{
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, e);
                return e;
            }
            updateResult(promiseState.rejected, e);
            onError();
            return e;
        });
    }, Promise.resolve());
    return {
        activeIndex: activeIndex,
        result: result
    };
}
function $6ffe9515611cb489$var$whenAborted(signal) {
    return new Promise((resolve, reject)=>{
        const error = new Error("aborted");
        if (signal.aborted) reject(error);
        else signal.addEventListener("abort", ()=>reject(error), {
            once: true
        });
    });
}
function $6ffe9515611cb489$export$d94717ae0e8aa8b(promise, initialState, options) {
    const { immediate: immediate = true, delay: delay = 0, onError: onError = (0, $AHHxt.noop), onSuccess: onSuccess = (0, $AHHxt.noop), resetOnExecute: resetOnExecute = true, shallow: shallow = true, throwError: throwError } = options != null ? options : {};
    const state = shallow ? (0, $01W3b.shallowRef)(initialState) : (0, $01W3b.ref)(initialState);
    const isReady = (0, $01W3b.shallowRef)(false);
    const isLoading = (0, $01W3b.shallowRef)(false);
    const error = (0, $01W3b.shallowRef)(void 0);
    async function execute(delay2 = 0, ...args) {
        if (resetOnExecute) state.value = initialState;
        error.value = void 0;
        isReady.value = false;
        isLoading.value = true;
        if (delay2 > 0) await (0, $AHHxt.promiseTimeout)(delay2);
        const _promise = typeof promise === "function" ? promise(...args) : promise;
        try {
            const data = await _promise;
            state.value = data;
            isReady.value = true;
            onSuccess(data);
        } catch (e) {
            error.value = e;
            onError(e);
            if (throwError) throw e;
        } finally{
            isLoading.value = false;
        }
        return state.value;
    }
    if (immediate) execute(delay);
    const shell = {
        state: state,
        isReady: isReady,
        isLoading: isLoading,
        error: error,
        execute: execute
    };
    function waitUntilIsLoaded() {
        return new Promise((resolve, reject)=>{
            (0, $AHHxt.until)(isLoading).toBe(false).then(()=>resolve(shell)).catch(reject);
        });
    }
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilIsLoaded().then(onFulfilled, onRejected);
        }
    };
}
const $6ffe9515611cb489$var$defaults = {
    array: (v)=>JSON.stringify(v),
    object: (v)=>JSON.stringify(v),
    set: (v)=>JSON.stringify(Array.from(v)),
    map: (v)=>JSON.stringify(Object.fromEntries(v)),
    null: ()=>""
};
function $6ffe9515611cb489$var$getDefaultSerialization(target) {
    if (!target) return $6ffe9515611cb489$var$defaults.null;
    if (target instanceof Map) return $6ffe9515611cb489$var$defaults.map;
    else if (target instanceof Set) return $6ffe9515611cb489$var$defaults.set;
    else if (Array.isArray(target)) return $6ffe9515611cb489$var$defaults.array;
    else return $6ffe9515611cb489$var$defaults.object;
}
function $6ffe9515611cb489$export$a1fce3538bfe26db(target, options) {
    const base64 = (0, $01W3b.shallowRef)("");
    const promise = (0, $01W3b.shallowRef)();
    function execute() {
        if (!(0, $AHHxt.isClient)) return;
        promise.value = new Promise((resolve, reject)=>{
            try {
                const _target = (0, $01W3b.toValue)(target);
                if (_target == null) resolve("");
                else if (typeof _target === "string") resolve($6ffe9515611cb489$var$blobToBase64(new Blob([
                    _target
                ], {
                    type: "text/plain"
                })));
                else if (_target instanceof Blob) resolve($6ffe9515611cb489$var$blobToBase64(_target));
                else if (_target instanceof ArrayBuffer) resolve(window.btoa(String.fromCharCode(...new Uint8Array(_target))));
                else if (_target instanceof HTMLCanvasElement) resolve(_target.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                else if (_target instanceof HTMLImageElement) {
                    const img = _target.cloneNode(false);
                    img.crossOrigin = "Anonymous";
                    $6ffe9515611cb489$var$imgLoaded(img).then(()=>{
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        resolve(canvas.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                    }).catch(reject);
                } else if (typeof _target === "object") {
                    const _serializeFn = (options == null ? void 0 : options.serializer) || $6ffe9515611cb489$var$getDefaultSerialization(_target);
                    const serialized = _serializeFn(_target);
                    return resolve($6ffe9515611cb489$var$blobToBase64(new Blob([
                        serialized
                    ], {
                        type: "application/json"
                    })));
                } else reject(new Error("target is unsupported types"));
            } catch (error) {
                reject(error);
            }
        });
        promise.value.then((res)=>{
            base64.value = (options == null ? void 0 : options.dataUrl) === false ? res.replace(/^data:.*?;base64,/, "") : res;
        });
        return promise.value;
    }
    if ((0, $01W3b.isRef)(target) || typeof target === "function") (0, $01W3b.watch)(target, execute, {
        immediate: true
    });
    else execute();
    return {
        base64: base64,
        promise: promise,
        execute: execute
    };
}
function $6ffe9515611cb489$var$imgLoaded(img) {
    return new Promise((resolve, reject)=>{
        if (!img.complete) {
            img.onload = ()=>{
                resolve();
            };
            img.onerror = reject;
        } else resolve();
    });
}
function $6ffe9515611cb489$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const fr = new FileReader();
        fr.onload = (e)=>{
            resolve(e.target.result);
        };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
    });
}
function $6ffe9515611cb489$export$2a2cdda660e4b159(options = {}) {
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const events = [
        "chargingchange",
        "chargingtimechange",
        "dischargingtimechange",
        "levelchange"
    ];
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "getBattery" in navigator1 && typeof navigator1.getBattery === "function");
    const charging = (0, $01W3b.shallowRef)(false);
    const chargingTime = (0, $01W3b.shallowRef)(0);
    const dischargingTime = (0, $01W3b.shallowRef)(0);
    const level = (0, $01W3b.shallowRef)(1);
    let battery;
    function updateBatteryInfo() {
        charging.value = this.charging;
        chargingTime.value = this.chargingTime || 0;
        dischargingTime.value = this.dischargingTime || 0;
        level.value = this.level;
    }
    if (isSupported.value) navigator1.getBattery().then((_battery)=>{
        battery = _battery;
        updateBatteryInfo.call(battery);
        $6ffe9515611cb489$export$7080b3e976bc91ab(battery, events, updateBatteryInfo, {
            passive: true
        });
    });
    return {
        isSupported: isSupported,
        charging: charging,
        chargingTime: chargingTime,
        dischargingTime: dischargingTime,
        level: level
    };
}
function $6ffe9515611cb489$export$4fa034be92e08f89(options) {
    let { acceptAllDevices: acceptAllDevices = false } = options || {};
    const { filters: filters, optionalServices: optionalServices, navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options || {};
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "bluetooth" in navigator1);
    const device = (0, $01W3b.shallowRef)();
    const error = (0, $01W3b.shallowRef)(null);
    (0, $01W3b.watch)(device, ()=>{
        connectToBluetoothGATTServer();
    });
    async function requestDevice() {
        if (!isSupported.value) return;
        error.value = null;
        if (filters && filters.length > 0) acceptAllDevices = false;
        try {
            device.value = await (navigator1 == null ? void 0 : navigator1.bluetooth.requestDevice({
                acceptAllDevices: acceptAllDevices,
                filters: filters,
                optionalServices: optionalServices
            }));
        } catch (err) {
            error.value = err;
        }
    }
    const server = (0, $01W3b.shallowRef)();
    const isConnected = (0, $01W3b.shallowRef)(false);
    function reset() {
        isConnected.value = false;
        device.value = void 0;
        server.value = void 0;
    }
    async function connectToBluetoothGATTServer() {
        error.value = null;
        if (device.value && device.value.gatt) {
            $6ffe9515611cb489$export$7080b3e976bc91ab(device, "gattserverdisconnected", reset, {
                passive: true
            });
            try {
                server.value = await device.value.gatt.connect();
                isConnected.value = server.value.connected;
            } catch (err) {
                error.value = err;
            }
        }
    }
    (0, $AHHxt.tryOnMounted)(()=>{
        var _a;
        if (device.value) (_a = device.value.gatt) == null || _a.connect();
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        var _a;
        if (device.value) (_a = device.value.gatt) == null || _a.disconnect();
    });
    return {
        isSupported: isSupported,
        isConnected: (0, $01W3b.readonly)(isConnected),
        device: // Device:
        device,
        requestDevice: requestDevice,
        server: // Server:
        server,
        error: // Errors:
        error
    };
}
const $6ffe9515611cb489$var$ssrWidthSymbol = Symbol("vueuse-ssr-width");
function $6ffe9515611cb489$export$cafdc23c22f6a4c3() {
    const ssrWidth = (0, $TusQn.hasInjectionContext)() ? (0, $AHHxt.injectLocal)($6ffe9515611cb489$var$ssrWidthSymbol, null) : null;
    return typeof ssrWidth === "number" ? ssrWidth : void 0;
}
function $6ffe9515611cb489$export$bd980f40a4d4aa5(width, app) {
    if (app !== void 0) app.provide($6ffe9515611cb489$var$ssrWidthSymbol, width);
    else (0, $AHHxt.provideLocal)($6ffe9515611cb489$var$ssrWidthSymbol, width);
}
function $6ffe9515611cb489$export$32d5543ab307c01(query, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ssrWidth: ssrWidth = $6ffe9515611cb489$export$cafdc23c22f6a4c3() } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "matchMedia" in window1 && typeof window1.matchMedia === "function");
    const ssrSupport = (0, $01W3b.shallowRef)(typeof ssrWidth === "number");
    const mediaQuery = (0, $01W3b.shallowRef)();
    const matches = (0, $01W3b.shallowRef)(false);
    const handler = (event)=>{
        matches.value = event.matches;
    };
    (0, $TusQn.watchEffect)(()=>{
        if (ssrSupport.value) {
            ssrSupport.value = !isSupported.value;
            const queryStrings = (0, $01W3b.toValue)(query).split(",");
            matches.value = queryStrings.some((queryString)=>{
                const not = queryString.includes("not all");
                const minWidth = queryString.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
                const maxWidth = queryString.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
                let res = Boolean(minWidth || maxWidth);
                if (minWidth && res) res = ssrWidth >= (0, $AHHxt.pxValue)(minWidth[1]);
                if (maxWidth && res) res = ssrWidth <= (0, $AHHxt.pxValue)(maxWidth[1]);
                return not ? !res : res;
            });
            return;
        }
        if (!isSupported.value) return;
        mediaQuery.value = window1.matchMedia((0, $01W3b.toValue)(query));
        matches.value = mediaQuery.value.matches;
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(mediaQuery, "change", handler, {
        passive: true
    });
    return (0, $01W3b.computed)(()=>matches.value);
}
const $6ffe9515611cb489$export$1e7f3da0afb51c4 = {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
};
const $6ffe9515611cb489$export$ab05426c509559f5 = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
const $6ffe9515611cb489$export$59a8910ce37234c0 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1264,
    xl: 1904
};
const $6ffe9515611cb489$export$f7fcbbae4606fa86 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
};
const $6ffe9515611cb489$export$e826524d50707be3 = $6ffe9515611cb489$export$59a8910ce37234c0;
const $6ffe9515611cb489$export$913d30ac358ba918 = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};
const $6ffe9515611cb489$export$6ed1cd5183566ff7 = {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
};
const $6ffe9515611cb489$export$b4376e330fd9cda3 = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop4K: 2560
};
const $6ffe9515611cb489$export$dba9946743c0ab98 = {
    "3xs": 360,
    "2xs": 480,
    "xs": 600,
    "sm": 768,
    "md": 1024,
    "lg": 1280,
    "xl": 1440,
    "2xl": 1600,
    "3xl": 1920,
    "4xl": 2560
};
const $6ffe9515611cb489$export$71df204985f11b6 = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
const $6ffe9515611cb489$export$8cbac7b6592328df = {
    xs: 0,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1920
};
function $6ffe9515611cb489$export$e818ed21e924bde4(breakpoints, options = {}) {
    function getValue(k, delta) {
        let v = (0, $01W3b.toValue)(breakpoints[(0, $01W3b.toValue)(k)]);
        if (delta != null) v = (0, $AHHxt.increaseWithUnit)(v, delta);
        if (typeof v === "number") v = `${v}px`;
        return v;
    }
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, strategy: strategy = "min-width", ssrWidth: ssrWidth = $6ffe9515611cb489$export$cafdc23c22f6a4c3() } = options;
    const ssrSupport = typeof ssrWidth === "number";
    const mounted = ssrSupport ? (0, $01W3b.shallowRef)(false) : {
        value: true
    };
    if (ssrSupport) (0, $AHHxt.tryOnMounted)(()=>mounted.value = !!window1);
    function match(query, size) {
        if (!mounted.value && ssrSupport) return query === "min" ? ssrWidth >= (0, $AHHxt.pxValue)(size) : ssrWidth <= (0, $AHHxt.pxValue)(size);
        if (!window1) return false;
        return window1.matchMedia(`(${query}-width: ${size})`).matches;
    }
    const greaterOrEqual = (k)=>{
        return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(min-width: ${getValue(k)})`, options);
    };
    const smallerOrEqual = (k)=>{
        return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(max-width: ${getValue(k)})`, options);
    };
    const shortcutMethods = Object.keys(breakpoints).reduce((shortcuts, k)=>{
        Object.defineProperty(shortcuts, k, {
            get: ()=>strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k),
            enumerable: true,
            configurable: true
        });
        return shortcuts;
    }, {});
    function current() {
        const points = Object.keys(breakpoints).map((k)=>[
                k,
                shortcutMethods[k],
                (0, $AHHxt.pxValue)(getValue(k))
            ]).sort((a, b)=>a[2] - b[2]);
        return (0, $01W3b.computed)(()=>points.filter(([, v])=>v.value).map(([k])=>k));
    }
    return Object.assign(shortcutMethods, {
        greaterOrEqual: greaterOrEqual,
        smallerOrEqual: smallerOrEqual,
        greater (k) {
            return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(min-width: ${getValue(k, 0.1)})`, options);
        },
        smaller (k) {
            return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(max-width: ${getValue(k, -0.1)})`, options);
        },
        between (a, b) {
            return $6ffe9515611cb489$export$32d5543ab307c01(()=>`(min-width: ${getValue(a)}) and (max-width: ${getValue(b, -0.1)})`, options);
        },
        isGreater (k) {
            return match("min", getValue(k, 0.1));
        },
        isGreaterOrEqual (k) {
            return match("min", getValue(k));
        },
        isSmaller (k) {
            return match("max", getValue(k, -0.1));
        },
        isSmallerOrEqual (k) {
            return match("max", getValue(k));
        },
        isInBetween (a, b) {
            return match("min", getValue(a)) && match("max", getValue(b, -0.1));
        },
        current: current,
        active () {
            const bps = current();
            return (0, $01W3b.computed)(()=>bps.value.length === 0 ? "" : bps.value.at(strategy === "min-width" ? -1 : 0));
        }
    });
}
function $6ffe9515611cb489$export$e38c76da774a8077(options) {
    const { name: name, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "BroadcastChannel" in window1);
    const isClosed = (0, $01W3b.shallowRef)(false);
    const channel = (0, $01W3b.ref)();
    const data = (0, $01W3b.ref)();
    const error = (0, $01W3b.shallowRef)(null);
    const post = (data2)=>{
        if (channel.value) channel.value.postMessage(data2);
    };
    const close = ()=>{
        if (channel.value) channel.value.close();
        isClosed.value = true;
    };
    if (isSupported.value) (0, $AHHxt.tryOnMounted)(()=>{
        error.value = null;
        channel.value = new BroadcastChannel(name);
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(channel, "message", (e)=>{
            data.value = e.data;
        }, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(channel, "messageerror", (e)=>{
            error.value = e;
        }, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(channel, "close", ()=>{
            isClosed.value = true;
        }, listenerOptions);
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        close();
    });
    return {
        isSupported: isSupported,
        channel: channel,
        data: data,
        post: post,
        close: close,
        error: error,
        isClosed: isClosed
    };
}
const $6ffe9515611cb489$var$WRITABLE_PROPERTIES = [
    "hash",
    "host",
    "hostname",
    "href",
    "pathname",
    "port",
    "protocol",
    "search"
];
function $6ffe9515611cb489$export$29c60f5332583(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const refs = Object.fromEntries($6ffe9515611cb489$var$WRITABLE_PROPERTIES.map((key)=>[
            key,
            (0, $01W3b.ref)()
        ]));
    for (const [key, ref] of (0, $AHHxt.objectEntries)(refs))(0, $01W3b.watch)(ref, (value)=>{
        if (!(window1 == null ? void 0 : window1.location) || window1.location[key] === value) return;
        window1.location[key] = value;
    });
    const buildState = (trigger)=>{
        var _a;
        const { state: state2, length: length } = (window1 == null ? void 0 : window1.history) || {};
        const { origin: origin } = (window1 == null ? void 0 : window1.location) || {};
        for (const key of $6ffe9515611cb489$var$WRITABLE_PROPERTIES)refs[key].value = (_a = window1 == null ? void 0 : window1.location) == null ? void 0 : _a[key];
        return (0, $01W3b.reactive)({
            trigger: trigger,
            state: state2,
            length: length,
            origin: origin,
            ...refs
        });
    };
    const state = (0, $01W3b.ref)(buildState("load"));
    if (window1) {
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "popstate", ()=>state.value = buildState("popstate"), listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "hashchange", ()=>state.value = buildState("hashchange"), listenerOptions);
    }
    return state;
}
function $6ffe9515611cb489$export$738959f2b29daa01(refValue, comparator = (a, b)=>a === b, options) {
    const { deepRefs: deepRefs = true, ...watchOptions } = options || {};
    const cachedValue = (0, $AHHxt.createRef)(refValue.value, deepRefs);
    (0, $01W3b.watch)(()=>refValue.value, (value)=>{
        if (!comparator(value, cachedValue.value)) cachedValue.value = value;
    }, watchOptions);
    return cachedValue;
}
function $6ffe9515611cb489$export$d7376454a3cf5ab4(permissionDesc, options = {}) {
    const { controls: controls = false, navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "permissions" in navigator1);
    const permissionStatus = (0, $01W3b.shallowRef)();
    const desc = typeof permissionDesc === "string" ? {
        name: permissionDesc
    } : permissionDesc;
    const state = (0, $01W3b.shallowRef)();
    const update = ()=>{
        var _a, _b;
        state.value = (_b = (_a = permissionStatus.value) == null ? void 0 : _a.state) != null ? _b : "prompt";
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(permissionStatus, "change", update, {
        passive: true
    });
    const query = (0, $AHHxt.createSingletonPromise)(async ()=>{
        if (!isSupported.value) return;
        if (!permissionStatus.value) try {
            permissionStatus.value = await navigator1.permissions.query(desc);
        } catch (e) {
            permissionStatus.value = void 0;
        } finally{
            update();
        }
        if (controls) return (0, $01W3b.toRaw)(permissionStatus.value);
    });
    query();
    if (controls) return {
        state: state,
        isSupported: isSupported,
        query: query
    };
    else return state;
}
function $6ffe9515611cb489$export$2314ca2a3e892862(options = {}) {
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500, legacy: legacy = false } = options;
    const isClipboardApiSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "clipboard" in navigator1);
    const permissionRead = $6ffe9515611cb489$export$d7376454a3cf5ab4("clipboard-read");
    const permissionWrite = $6ffe9515611cb489$export$d7376454a3cf5ab4("clipboard-write");
    const isSupported = (0, $01W3b.computed)(()=>isClipboardApiSupported.value || legacy);
    const text = (0, $01W3b.shallowRef)("");
    const copied = (0, $01W3b.shallowRef)(false);
    const timeout = (0, $AHHxt.useTimeoutFn)(()=>copied.value = false, copiedDuring, {
        immediate: false
    });
    async function updateText() {
        let useLegacy = !(isClipboardApiSupported.value && isAllowed(permissionRead.value));
        if (!useLegacy) try {
            text.value = await navigator1.clipboard.readText();
        } catch (e) {
            useLegacy = true;
        }
        if (useLegacy) text.value = legacyRead();
    }
    if (isSupported.value && read) $6ffe9515611cb489$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateText, {
        passive: true
    });
    async function copy(value = (0, $01W3b.toValue)(source)) {
        if (isSupported.value && value != null) {
            let useLegacy = !(isClipboardApiSupported.value && isAllowed(permissionWrite.value));
            if (!useLegacy) try {
                await navigator1.clipboard.writeText(value);
            } catch (e) {
                useLegacy = true;
            }
            if (useLegacy) legacyCopy(value);
            text.value = value;
            copied.value = true;
            timeout.start();
        }
    }
    function legacyCopy(value) {
        const ta = document.createElement("textarea");
        ta.value = value != null ? value : "";
        ta.style.position = "absolute";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }
    function legacyRead() {
        var _a, _b, _c;
        return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
    }
    function isAllowed(status) {
        return status === "granted" || status === "prompt";
    }
    return {
        isSupported: isSupported,
        text: text,
        copied: copied,
        copy: copy
    };
}
function $6ffe9515611cb489$export$ada6005637a1689d(options = {}) {
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500 } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "clipboard" in navigator1);
    const content = (0, $01W3b.ref)([]);
    const copied = (0, $01W3b.shallowRef)(false);
    const timeout = (0, $AHHxt.useTimeoutFn)(()=>copied.value = false, copiedDuring, {
        immediate: false
    });
    function updateContent() {
        if (isSupported.value) navigator1.clipboard.read().then((items)=>{
            content.value = items;
        });
    }
    if (isSupported.value && read) $6ffe9515611cb489$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateContent, {
        passive: true
    });
    async function copy(value = (0, $01W3b.toValue)(source)) {
        if (isSupported.value && value != null) {
            await navigator1.clipboard.write(value);
            content.value = value;
            copied.value = true;
            timeout.start();
        }
    }
    return {
        isSupported: isSupported,
        content: content,
        copied: copied,
        copy: copy
    };
}
function $6ffe9515611cb489$export$9e72043f8ff3a3df(source) {
    return JSON.parse(JSON.stringify(source));
}
function $6ffe9515611cb489$export$1d793528ac2b824a(source, options = {}) {
    const cloned = (0, $01W3b.ref)({});
    const isModified = (0, $01W3b.shallowRef)(false);
    let _lastSync = false;
    const { manual: manual, clone: clone = $6ffe9515611cb489$export$9e72043f8ff3a3df, deep: // watch options
    deep = true, immediate: immediate = true } = options;
    (0, $01W3b.watch)(cloned, ()=>{
        if (_lastSync) {
            _lastSync = false;
            return;
        }
        isModified.value = true;
    }, {
        deep: true,
        flush: "sync"
    });
    function sync() {
        _lastSync = true;
        isModified.value = false;
        cloned.value = clone((0, $01W3b.toValue)(source));
    }
    if (!manual && ((0, $01W3b.isRef)(source) || typeof source === "function")) (0, $01W3b.watch)(source, sync, {
        ...options,
        deep: deep,
        immediate: immediate
    });
    else sync();
    return {
        cloned: cloned,
        isModified: isModified,
        sync: sync
    };
}
const $6ffe9515611cb489$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
const $6ffe9515611cb489$var$globalKey = "__vueuse_ssr_handlers__";
const $6ffe9515611cb489$var$handlers = /* @__PURE__ */ $6ffe9515611cb489$var$getHandlers();
function $6ffe9515611cb489$var$getHandlers() {
    if (!($6ffe9515611cb489$var$globalKey in $6ffe9515611cb489$var$_global)) $6ffe9515611cb489$var$_global[$6ffe9515611cb489$var$globalKey] = $6ffe9515611cb489$var$_global[$6ffe9515611cb489$var$globalKey] || {};
    return $6ffe9515611cb489$var$_global[$6ffe9515611cb489$var$globalKey];
}
function $6ffe9515611cb489$export$b0cf1ae5a98eb83b(key, fallback) {
    return $6ffe9515611cb489$var$handlers[key] || fallback;
}
function $6ffe9515611cb489$export$4094cfc0512bc950(key, fn) {
    $6ffe9515611cb489$var$handlers[key] = fn;
}
function $6ffe9515611cb489$export$a9fe667866660cd5(options) {
    return $6ffe9515611cb489$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
}
function $6ffe9515611cb489$var$guessSerializerType(rawInit) {
    return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}
const $6ffe9515611cb489$export$8111877b006f9b0b = {
    boolean: {
        read: (v)=>v === "true",
        write: (v)=>String(v)
    },
    object: {
        read: (v)=>JSON.parse(v),
        write: (v)=>JSON.stringify(v)
    },
    number: {
        read: (v)=>Number.parseFloat(v),
        write: (v)=>String(v)
    },
    any: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    string: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    map: {
        read: (v)=>new Map(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v.entries()))
    },
    set: {
        read: (v)=>new Set(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v))
    },
    date: {
        read: (v)=>new Date(v),
        write: (v)=>v.toISOString()
    }
};
const $6ffe9515611cb489$export$5962b94d93010632 = "vueuse-storage";
function $6ffe9515611cb489$export$95809329f49ea9f9(key, defaults, storage, options = {}) {
    var _a;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    }, initOnMounted: initOnMounted } = options;
    const data = (shallow ? (0, $01W3b.shallowRef) : (0, $01W3b.ref))(typeof defaults === "function" ? defaults() : defaults);
    const keyComputed = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(key));
    if (!storage) try {
        storage = $6ffe9515611cb489$export$b0cf1ae5a98eb83b("getDefaultStorage", ()=>{
            var _a2;
            return (_a2 = $6ffe9515611cb489$export$16f8ba610718ae4a) == null ? void 0 : _a2.localStorage;
        })();
    } catch (e) {
        onError(e);
    }
    if (!storage) return data;
    const rawInit = (0, $01W3b.toValue)(defaults);
    const type = $6ffe9515611cb489$var$guessSerializerType(rawInit);
    const serializer = (_a = options.serializer) != null ? _a : $6ffe9515611cb489$export$8111877b006f9b0b[type];
    const { pause: pauseWatch, resume: resumeWatch } = (0, $AHHxt.pausableWatch)(data, ()=>write(data.value), {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    (0, $01W3b.watch)(keyComputed, ()=>update(), {
        flush: flush
    });
    if (window1 && listenToStorageChanges) (0, $AHHxt.tryOnMounted)(()=>{
        if (storage instanceof Storage) $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "storage", update, {
            passive: true
        });
        else $6ffe9515611cb489$export$7080b3e976bc91ab(window1, $6ffe9515611cb489$export$5962b94d93010632, updateFromCustomEvent);
        if (initOnMounted) update();
    });
    if (!initOnMounted) update();
    function dispatchWriteEvent(oldValue, newValue) {
        if (window1) {
            const payload = {
                key: keyComputed.value,
                oldValue: oldValue,
                newValue: newValue,
                storageArea: storage
            };
            window1.dispatchEvent(storage instanceof Storage ? new StorageEvent("storage", payload) : new CustomEvent($6ffe9515611cb489$export$5962b94d93010632, {
                detail: payload
            }));
        }
    }
    function write(v) {
        try {
            const oldValue = storage.getItem(keyComputed.value);
            if (v == null) {
                dispatchWriteEvent(oldValue, null);
                storage.removeItem(keyComputed.value);
            } else {
                const serialized = serializer.write(v);
                if (oldValue !== serialized) {
                    storage.setItem(keyComputed.value, serialized);
                    dispatchWriteEvent(oldValue, serialized);
                }
            }
        } catch (e) {
            onError(e);
        }
    }
    function read(event) {
        const rawValue = event ? event.newValue : storage.getItem(keyComputed.value);
        if (rawValue == null) {
            if (writeDefaults && rawInit != null) storage.setItem(keyComputed.value, serializer.write(rawInit));
            return rawInit;
        } else if (!event && mergeDefaults) {
            const value = serializer.read(rawValue);
            if (typeof mergeDefaults === "function") return mergeDefaults(value, rawInit);
            else if (type === "object" && !Array.isArray(value)) return {
                ...rawInit,
                ...value
            };
            return value;
        } else if (typeof rawValue !== "string") return rawValue;
        else return serializer.read(rawValue);
    }
    function update(event) {
        if (event && event.storageArea !== storage) return;
        if (event && event.key == null) {
            data.value = rawInit;
            return;
        }
        if (event && event.key !== keyComputed.value) return;
        pauseWatch();
        try {
            if ((event == null ? void 0 : event.newValue) !== serializer.write(data.value)) data.value = read(event);
        } catch (e) {
            onError(e);
        } finally{
            if (event) (0, $TusQn.nextTick)(resumeWatch);
            else resumeWatch();
        }
    }
    function updateFromCustomEvent(event) {
        update(event.detail);
    }
    return data;
}
const $6ffe9515611cb489$var$CSS_DISABLE_TRANS = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function $6ffe9515611cb489$export$20f3076712c8dfa(options = {}) {
    const { selector: selector = "html", attribute: attribute = "class", initialValue: initialValue = "auto", window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, storage: storage, storageKey: storageKey = "vueuse-color-scheme", listenToStorageChanges: listenToStorageChanges = true, storageRef: storageRef, emitAuto: emitAuto, disableTransition: disableTransition = true } = options;
    const modes = {
        auto: "",
        light: "light",
        dark: "dark",
        ...options.modes || {}
    };
    const preferredDark = $6ffe9515611cb489$export$a9fe667866660cd5({
        window: window1
    });
    const system = (0, $01W3b.computed)(()=>preferredDark.value ? "dark" : "light");
    const store = storageRef || (storageKey == null ? (0, $AHHxt.toRef)(initialValue) : $6ffe9515611cb489$export$95809329f49ea9f9(storageKey, initialValue, storage, {
        window: window1,
        listenToStorageChanges: listenToStorageChanges
    }));
    const state = (0, $01W3b.computed)(()=>store.value === "auto" ? system.value : store.value);
    const updateHTMLAttrs = $6ffe9515611cb489$export$b0cf1ae5a98eb83b("updateHTMLAttrs", (selector2, attribute2, value)=>{
        const el = typeof selector2 === "string" ? window1 == null ? void 0 : window1.document.querySelector(selector2) : $6ffe9515611cb489$export$c61124d3cf5adbae(selector2);
        if (!el) return;
        const classesToAdd = /* @__PURE__ */ new Set();
        const classesToRemove = /* @__PURE__ */ new Set();
        let attributeToChange = null;
        if (attribute2 === "class") {
            const current = value.split(/\s/g);
            Object.values(modes).flatMap((i)=>(i || "").split(/\s/g)).filter(Boolean).forEach((v)=>{
                if (current.includes(v)) classesToAdd.add(v);
                else classesToRemove.add(v);
            });
        } else attributeToChange = {
            key: attribute2,
            value: value
        };
        if (classesToAdd.size === 0 && classesToRemove.size === 0 && attributeToChange === null) return;
        let style;
        if (disableTransition) {
            style = window1.document.createElement("style");
            style.appendChild(document.createTextNode($6ffe9515611cb489$var$CSS_DISABLE_TRANS));
            window1.document.head.appendChild(style);
        }
        for (const c of classesToAdd)el.classList.add(c);
        for (const c of classesToRemove)el.classList.remove(c);
        if (attributeToChange) el.setAttribute(attributeToChange.key, attributeToChange.value);
        if (disableTransition) {
            window1.getComputedStyle(style).opacity;
            document.head.removeChild(style);
        }
    });
    function defaultOnChanged(mode) {
        var _a;
        updateHTMLAttrs(selector, attribute, (_a = modes[mode]) != null ? _a : mode);
    }
    function onChanged(mode) {
        if (options.onChanged) options.onChanged(mode, defaultOnChanged);
        else defaultOnChanged(mode);
    }
    (0, $01W3b.watch)(state, onChanged, {
        flush: "post",
        immediate: true
    });
    (0, $AHHxt.tryOnMounted)(()=>onChanged(state.value));
    const auto = (0, $01W3b.computed)({
        get () {
            return emitAuto ? store.value : state.value;
        },
        set (v) {
            store.value = v;
        }
    });
    return Object.assign(auto, {
        store: store,
        system: system,
        state: state
    });
}
function $6ffe9515611cb489$export$93c95fc6177ab5cd(revealed = (0, $01W3b.shallowRef)(false)) {
    const confirmHook = (0, $AHHxt.createEventHook)();
    const cancelHook = (0, $AHHxt.createEventHook)();
    const revealHook = (0, $AHHxt.createEventHook)();
    let _resolve = (0, $AHHxt.noop);
    const reveal = (data)=>{
        revealHook.trigger(data);
        revealed.value = true;
        return new Promise((resolve)=>{
            _resolve = resolve;
        });
    };
    const confirm = (data)=>{
        revealed.value = false;
        confirmHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: false
        });
    };
    const cancel = (data)=>{
        revealed.value = false;
        cancelHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: true
        });
    };
    return {
        isRevealed: (0, $01W3b.computed)(()=>revealed.value),
        reveal: reveal,
        confirm: confirm,
        cancel: cancel,
        onReveal: revealHook.on,
        onConfirm: confirmHook.on,
        onCancel: cancelHook.on
    };
}
function $6ffe9515611cb489$export$8103f7eb37e19f7b(initialCountdown, options) {
    var _a, _b;
    const remaining = (0, $01W3b.shallowRef)((0, $01W3b.toValue)(initialCountdown));
    const intervalController = (0, $AHHxt.useIntervalFn)(()=>{
        var _a2, _b2;
        const value = remaining.value - 1;
        remaining.value = value < 0 ? 0 : value;
        (_a2 = options == null ? void 0 : options.onTick) == null || _a2.call(options);
        if (remaining.value <= 0) {
            intervalController.pause();
            (_b2 = options == null ? void 0 : options.onComplete) == null || _b2.call(options);
        }
    }, (_a = options == null ? void 0 : options.interval) != null ? _a : 1e3, {
        immediate: (_b = options == null ? void 0 : options.immediate) != null ? _b : false
    });
    const reset = (countdown)=>{
        var _a2;
        remaining.value = (_a2 = (0, $01W3b.toValue)(countdown)) != null ? _a2 : (0, $01W3b.toValue)(initialCountdown);
    };
    const stop = ()=>{
        intervalController.pause();
        reset();
    };
    const resume = ()=>{
        if (!intervalController.isActive.value) {
            if (remaining.value > 0) intervalController.resume();
        }
    };
    const start = (countdown)=>{
        reset(countdown);
        intervalController.resume();
    };
    return {
        remaining: remaining,
        reset: reset,
        stop: stop,
        start: start,
        pause: intervalController.pause,
        resume: resume,
        isActive: intervalController.isActive
    };
}
function $6ffe9515611cb489$export$811e58a9be6ff112(prop, target, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, initialValue: initialValue, observe: observe = false } = options;
    const variable = (0, $01W3b.shallowRef)(initialValue);
    const elRef = (0, $01W3b.computed)(()=>{
        var _a;
        return $6ffe9515611cb489$export$c61124d3cf5adbae(target) || ((_a = window1 == null ? void 0 : window1.document) == null ? void 0 : _a.documentElement);
    });
    function updateCssVar() {
        var _a;
        const key = (0, $01W3b.toValue)(prop);
        const el = (0, $01W3b.toValue)(elRef);
        if (el && window1 && key) {
            const value = (_a = window1.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
            variable.value = value || variable.value || initialValue;
        }
    }
    if (observe) $6ffe9515611cb489$export$8ecdcf3bb089e9cd(elRef, updateCssVar, {
        attributeFilter: [
            "style",
            "class"
        ],
        window: window1
    });
    (0, $01W3b.watch)([
        elRef,
        ()=>(0, $01W3b.toValue)(prop)
    ], (_, old)=>{
        if (old[0] && old[1]) old[0].style.removeProperty(old[1]);
        updateCssVar();
    }, {
        immediate: true
    });
    (0, $01W3b.watch)([
        variable,
        elRef
    ], ([val, el])=>{
        const raw_prop = (0, $01W3b.toValue)(prop);
        if ((el == null ? void 0 : el.style) && raw_prop) {
            if (val == null) el.style.removeProperty(raw_prop);
            else el.style.setProperty(raw_prop, val);
        }
    }, {
        immediate: true
    });
    return variable;
}
function $6ffe9515611cb489$export$8d937a32bc2b31dd(rootComponent) {
    const vm = (0, $TusQn.getCurrentInstance)();
    const currentElement = (0, $AHHxt.computedWithControl)(()=>null, ()=>rootComponent ? $6ffe9515611cb489$export$c61124d3cf5adbae(rootComponent) : vm.proxy.$el);
    (0, $TusQn.onUpdated)(currentElement.trigger);
    (0, $TusQn.onMounted)(currentElement.trigger);
    return currentElement;
}
function $6ffe9515611cb489$export$a43ea948f6bdcecc(list, options) {
    const state = (0, $01W3b.shallowRef)(getInitialValue());
    const listRef = (0, $AHHxt.toRef)(list);
    const index = (0, $01W3b.computed)({
        get () {
            var _a;
            const targetList = listRef.value;
            let index2 = (options == null ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
            if (index2 < 0) index2 = (_a = options == null ? void 0 : options.fallbackIndex) != null ? _a : 0;
            return index2;
        },
        set (v) {
            set(v);
        }
    });
    function set(i) {
        const targetList = listRef.value;
        const length = targetList.length;
        const index2 = (i % length + length) % length;
        const value = targetList[index2];
        state.value = value;
        return value;
    }
    function shift(delta = 1) {
        return set(index.value + delta);
    }
    function next(n = 1) {
        return shift(n);
    }
    function prev(n = 1) {
        return shift(-n);
    }
    function getInitialValue() {
        var _a, _b;
        return (_b = (0, $01W3b.toValue)((_a = options == null ? void 0 : options.initialValue) != null ? _a : (0, $01W3b.toValue)(list)[0])) != null ? _b : void 0;
    }
    (0, $01W3b.watch)(listRef, ()=>set(index.value));
    return {
        state: state,
        index: index,
        next: next,
        prev: prev,
        go: set
    };
}
function $6ffe9515611cb489$export$b067746439a7c60(options = {}) {
    const { valueDark: valueDark = "dark", valueLight: valueLight = "" } = options;
    const mode = $6ffe9515611cb489$export$20f3076712c8dfa({
        ...options,
        onChanged: (mode2, defaultHandler)=>{
            var _a;
            if (options.onChanged) (_a = options.onChanged) == null || _a.call(options, mode2 === "dark", defaultHandler, mode2);
            else defaultHandler(mode2);
        },
        modes: {
            dark: valueDark,
            light: valueLight
        }
    });
    const system = (0, $01W3b.computed)(()=>mode.system.value);
    const isDark = (0, $01W3b.computed)({
        get () {
            return mode.value === "dark";
        },
        set (v) {
            const modeVal = v ? "dark" : "light";
            if (system.value === modeVal) mode.value = "auto";
            else mode.value = modeVal;
        }
    });
    return isDark;
}
function $6ffe9515611cb489$var$fnBypass(v) {
    return v;
}
function $6ffe9515611cb489$var$fnSetSource(source, value) {
    return source.value = value;
}
function $6ffe9515611cb489$var$defaultDump(clone) {
    return clone ? typeof clone === "function" ? clone : $6ffe9515611cb489$export$9e72043f8ff3a3df : $6ffe9515611cb489$var$fnBypass;
}
function $6ffe9515611cb489$var$defaultParse(clone) {
    return clone ? typeof clone === "function" ? clone : $6ffe9515611cb489$export$9e72043f8ff3a3df : $6ffe9515611cb489$var$fnBypass;
}
function $6ffe9515611cb489$export$614531ad6f0c8fd(source, options = {}) {
    const { clone: clone = false, dump: dump = $6ffe9515611cb489$var$defaultDump(clone), parse: parse = $6ffe9515611cb489$var$defaultParse(clone), setSource: setSource = $6ffe9515611cb489$var$fnSetSource } = options;
    function _createHistoryRecord() {
        return (0, $01W3b.markRaw)({
            snapshot: dump(source.value),
            timestamp: (0, $AHHxt.timestamp)()
        });
    }
    const last = (0, $01W3b.ref)(_createHistoryRecord());
    const undoStack = (0, $01W3b.ref)([]);
    const redoStack = (0, $01W3b.ref)([]);
    const _setSource = (record)=>{
        setSource(source, parse(record.snapshot));
        last.value = record;
    };
    const commit = ()=>{
        undoStack.value.unshift(last.value);
        last.value = _createHistoryRecord();
        if (options.capacity && undoStack.value.length > options.capacity) undoStack.value.splice(options.capacity, Number.POSITIVE_INFINITY);
        if (redoStack.value.length) redoStack.value.splice(0, redoStack.value.length);
    };
    const clear = ()=>{
        undoStack.value.splice(0, undoStack.value.length);
        redoStack.value.splice(0, redoStack.value.length);
    };
    const undo = ()=>{
        const state = undoStack.value.shift();
        if (state) {
            redoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const redo = ()=>{
        const state = redoStack.value.shift();
        if (state) {
            undoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const reset = ()=>{
        _setSource(last.value);
    };
    const history = (0, $01W3b.computed)(()=>[
            last.value,
            ...undoStack.value
        ]);
    const canUndo = (0, $01W3b.computed)(()=>undoStack.value.length > 0);
    const canRedo = (0, $01W3b.computed)(()=>redoStack.value.length > 0);
    return {
        source: source,
        undoStack: undoStack,
        redoStack: redoStack,
        last: last,
        history: history,
        canUndo: canUndo,
        canRedo: canRedo,
        clear: clear,
        commit: commit,
        reset: reset,
        undo: undo,
        redo: redo
    };
}
function $6ffe9515611cb489$export$de889b39e422efc4(source, options = {}) {
    const { deep: deep = false, flush: flush = "pre", eventFilter: eventFilter } = options;
    const { eventFilter: composedFilter, pause: pause, resume: resumeTracking, isActive: isTracking } = (0, $AHHxt.pausableFilter)(eventFilter);
    const { ignoreUpdates: ignoreUpdates, ignorePrevAsyncUpdates: ignorePrevAsyncUpdates, stop: stop } = (0, $AHHxt.watchIgnorable)(source, commit, {
        deep: deep,
        flush: flush,
        eventFilter: composedFilter
    });
    function setSource(source2, value) {
        ignorePrevAsyncUpdates();
        ignoreUpdates(()=>{
            source2.value = value;
        });
    }
    const manualHistory = $6ffe9515611cb489$export$614531ad6f0c8fd(source, {
        ...options,
        clone: options.clone || deep,
        setSource: setSource
    });
    const { clear: clear, commit: manualCommit } = manualHistory;
    function commit() {
        ignorePrevAsyncUpdates();
        manualCommit();
    }
    function resume(commitNow) {
        resumeTracking();
        if (commitNow) commit();
    }
    function batch(fn) {
        let canceled = false;
        const cancel = ()=>canceled = true;
        ignoreUpdates(()=>{
            fn(cancel);
        });
        if (!canceled) commit();
    }
    function dispose() {
        stop();
        clear();
    }
    return {
        ...manualHistory,
        isTracking: isTracking,
        pause: pause,
        resume: resume,
        commit: commit,
        batch: batch,
        dispose: dispose
    };
}
function $6ffe9515611cb489$export$3b9372c83f595b14(source, options = {}) {
    const filter = options.debounce ? (0, $AHHxt.debounceFilter)(options.debounce) : void 0;
    const history = $6ffe9515611cb489$export$de889b39e422efc4(source, {
        ...options,
        eventFilter: filter
    });
    return {
        ...history
    };
}
function $6ffe9515611cb489$export$45ef0ca3d803202d(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, requestPermissions: requestPermissions = false, eventFilter: eventFilter = (0, $AHHxt.bypassFilter) } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>typeof DeviceMotionEvent !== "undefined");
    const requirePermissions = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>isSupported.value && "requestPermission" in DeviceMotionEvent && typeof DeviceMotionEvent.requestPermission === "function");
    const permissionGranted = (0, $01W3b.shallowRef)(false);
    const acceleration = (0, $01W3b.ref)({
        x: null,
        y: null,
        z: null
    });
    const rotationRate = (0, $01W3b.ref)({
        alpha: null,
        beta: null,
        gamma: null
    });
    const interval = (0, $01W3b.shallowRef)(0);
    const accelerationIncludingGravity = (0, $01W3b.ref)({
        x: null,
        y: null,
        z: null
    });
    function init() {
        if (window1) {
            const onDeviceMotion = (0, $AHHxt.createFilterWrapper)(eventFilter, (event)=>{
                var _a, _b, _c, _d, _e, _f, _g, _h, _i;
                acceleration.value = {
                    x: ((_a = event.acceleration) == null ? void 0 : _a.x) || null,
                    y: ((_b = event.acceleration) == null ? void 0 : _b.y) || null,
                    z: ((_c = event.acceleration) == null ? void 0 : _c.z) || null
                };
                accelerationIncludingGravity.value = {
                    x: ((_d = event.accelerationIncludingGravity) == null ? void 0 : _d.x) || null,
                    y: ((_e = event.accelerationIncludingGravity) == null ? void 0 : _e.y) || null,
                    z: ((_f = event.accelerationIncludingGravity) == null ? void 0 : _f.z) || null
                };
                rotationRate.value = {
                    alpha: ((_g = event.rotationRate) == null ? void 0 : _g.alpha) || null,
                    beta: ((_h = event.rotationRate) == null ? void 0 : _h.beta) || null,
                    gamma: ((_i = event.rotationRate) == null ? void 0 : _i.gamma) || null
                };
                interval.value = event.interval;
            });
            $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "devicemotion", onDeviceMotion, {
                passive: true
            });
        }
    }
    const ensurePermissions = async ()=>{
        if (!requirePermissions.value) permissionGranted.value = true;
        if (permissionGranted.value) return;
        if (requirePermissions.value) {
            const requestPermission = DeviceMotionEvent.requestPermission;
            try {
                const response = await requestPermission();
                if (response === "granted") {
                    permissionGranted.value = true;
                    init();
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    if (isSupported.value) {
        if (requestPermissions && requirePermissions.value) ensurePermissions().then(()=>init());
        else init();
    }
    return {
        acceleration: acceleration,
        accelerationIncludingGravity: accelerationIncludingGravity,
        rotationRate: rotationRate,
        interval: interval,
        isSupported: isSupported,
        requirePermissions: requirePermissions,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted
    };
}
function $6ffe9515611cb489$export$9bafe4f626b63a33(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "DeviceOrientationEvent" in window1);
    const isAbsolute = (0, $01W3b.shallowRef)(false);
    const alpha = (0, $01W3b.shallowRef)(null);
    const beta = (0, $01W3b.shallowRef)(null);
    const gamma = (0, $01W3b.shallowRef)(null);
    if (window1 && isSupported.value) $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "deviceorientation", (event)=>{
        isAbsolute.value = event.absolute;
        alpha.value = event.alpha;
        beta.value = event.beta;
        gamma.value = event.gamma;
    }, {
        passive: true
    });
    return {
        isSupported: isSupported,
        isAbsolute: isAbsolute,
        alpha: alpha,
        beta: beta,
        gamma: gamma
    };
}
function $6ffe9515611cb489$export$9619f0fa9e7879c6(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const pixelRatio = (0, $01W3b.shallowRef)(1);
    const query = $6ffe9515611cb489$export$32d5543ab307c01(()=>`(resolution: ${pixelRatio.value}dppx)`, options);
    let stop = (0, $AHHxt.noop);
    if (window1) stop = (0, $AHHxt.watchImmediate)(query, ()=>pixelRatio.value = window1.devicePixelRatio);
    return {
        pixelRatio: (0, $01W3b.readonly)(pixelRatio),
        stop: stop
    };
}
function $6ffe9515611cb489$export$c860eb59c2f56cac(options = {}) {
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc, requestPermissions: requestPermissions = false, constraints: constraints = {
        audio: true,
        video: true
    }, onUpdated: onUpdated } = options;
    const devices = (0, $01W3b.ref)([]);
    const videoInputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "videoinput"));
    const audioInputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "audioinput"));
    const audioOutputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "audiooutput"));
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && navigator1.mediaDevices && navigator1.mediaDevices.enumerateDevices);
    const permissionGranted = (0, $01W3b.shallowRef)(false);
    let stream;
    async function update() {
        if (!isSupported.value) return;
        devices.value = await navigator1.mediaDevices.enumerateDevices();
        onUpdated == null || onUpdated(devices.value);
        if (stream) {
            stream.getTracks().forEach((t)=>t.stop());
            stream = null;
        }
    }
    async function ensurePermissions() {
        const deviceName = constraints.video ? "camera" : "microphone";
        if (!isSupported.value) return false;
        if (permissionGranted.value) return true;
        const { state: state, query: query } = $6ffe9515611cb489$export$d7376454a3cf5ab4(deviceName, {
            controls: true
        });
        await query();
        if (state.value !== "granted") {
            let granted = true;
            try {
                stream = await navigator1.mediaDevices.getUserMedia(constraints);
            } catch (e) {
                stream = null;
                granted = false;
            }
            update();
            permissionGranted.value = granted;
        } else permissionGranted.value = true;
        return permissionGranted.value;
    }
    if (isSupported.value) {
        if (requestPermissions) ensurePermissions();
        $6ffe9515611cb489$export$7080b3e976bc91ab(navigator1.mediaDevices, "devicechange", update, {
            passive: true
        });
        update();
    }
    return {
        devices: devices,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        videoInputs: videoInputs,
        audioInputs: audioInputs,
        audioOutputs: audioOutputs,
        isSupported: isSupported
    };
}
function $6ffe9515611cb489$export$f2d17e22a8e6ddfc(options = {}) {
    var _a;
    const enabled = (0, $01W3b.shallowRef)((_a = options.enabled) != null ? _a : false);
    const video = options.video;
    const audio = options.audio;
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>{
        var _a2;
        return (_a2 = navigator1 == null ? void 0 : navigator1.mediaDevices) == null ? void 0 : _a2.getDisplayMedia;
    });
    const constraint = {
        audio: audio,
        video: video
    };
    const stream = (0, $01W3b.shallowRef)();
    async function _start() {
        var _a2;
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator1.mediaDevices.getDisplayMedia(constraint);
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>$6ffe9515611cb489$export$7080b3e976bc91ab(t, "ended", stop, {
                passive: true
            }));
        return stream.value;
    }
    async function _stop() {
        var _a2;
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    (0, $01W3b.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        enabled: enabled
    };
}
function $6ffe9515611cb489$export$87a87a3d299ece7c(options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    if (!document1) return (0, $01W3b.shallowRef)("visible");
    const visibility = (0, $01W3b.shallowRef)(document1.visibilityState);
    $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
        visibility.value = document1.visibilityState;
    }, {
        passive: true
    });
    return visibility;
}
function $6ffe9515611cb489$export$df30c81f5aa01ff7(target, options = {}) {
    var _a;
    const { pointerTypes: pointerTypes, preventDefault: preventDefault, stopPropagation: stopPropagation, exact: exact, onMove: onMove, onEnd: onEnd, onStart: onStart, initialValue: initialValue, axis: axis = "both", draggingElement: draggingElement = $6ffe9515611cb489$export$16f8ba610718ae4a, containerElement: containerElement, handle: draggingHandle = target, buttons: buttons = [
        0
    ] } = options;
    const position = (0, $01W3b.ref)((_a = (0, $01W3b.toValue)(initialValue)) != null ? _a : {
        x: 0,
        y: 0
    });
    const pressedDelta = (0, $01W3b.ref)();
    const filterEvent = (e)=>{
        if (pointerTypes) return pointerTypes.includes(e.pointerType);
        return true;
    };
    const handleEvent = (e)=>{
        if ((0, $01W3b.toValue)(preventDefault)) e.preventDefault();
        if ((0, $01W3b.toValue)(stopPropagation)) e.stopPropagation();
    };
    const start = (e)=>{
        var _a2;
        if (!(0, $01W3b.toValue)(buttons).includes(e.button)) return;
        if ((0, $01W3b.toValue)(options.disabled) || !filterEvent(e)) return;
        if ((0, $01W3b.toValue)(exact) && e.target !== (0, $01W3b.toValue)(target)) return;
        const container = (0, $01W3b.toValue)(containerElement);
        const containerRect = (_a2 = container == null ? void 0 : container.getBoundingClientRect) == null ? void 0 : _a2.call(container);
        const targetRect = (0, $01W3b.toValue)(target).getBoundingClientRect();
        const pos = {
            x: e.clientX - (container ? targetRect.left - containerRect.left + container.scrollLeft : targetRect.left),
            y: e.clientY - (container ? targetRect.top - containerRect.top + container.scrollTop : targetRect.top)
        };
        if ((onStart == null ? void 0 : onStart(pos, e)) === false) return;
        pressedDelta.value = pos;
        handleEvent(e);
    };
    const move = (e)=>{
        if ((0, $01W3b.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        const container = (0, $01W3b.toValue)(containerElement);
        const targetRect = (0, $01W3b.toValue)(target).getBoundingClientRect();
        let { x: x, y: y } = position.value;
        if (axis === "x" || axis === "both") {
            x = e.clientX - pressedDelta.value.x;
            if (container) x = Math.min(Math.max(0, x), container.scrollWidth - targetRect.width);
        }
        if (axis === "y" || axis === "both") {
            y = e.clientY - pressedDelta.value.y;
            if (container) y = Math.min(Math.max(0, y), container.scrollHeight - targetRect.height);
        }
        position.value = {
            x: x,
            y: y
        };
        onMove == null || onMove(position.value, e);
        handleEvent(e);
    };
    const end = (e)=>{
        if ((0, $01W3b.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        pressedDelta.value = void 0;
        onEnd == null || onEnd(position.value, e);
        handleEvent(e);
    };
    if (0, $AHHxt.isClient) {
        const config = ()=>{
            var _a2;
            return {
                capture: (_a2 = options.capture) != null ? _a2 : true,
                passive: !(0, $01W3b.toValue)(preventDefault)
            };
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(draggingHandle, "pointerdown", start, config);
        $6ffe9515611cb489$export$7080b3e976bc91ab(draggingElement, "pointermove", move, config);
        $6ffe9515611cb489$export$7080b3e976bc91ab(draggingElement, "pointerup", end, config);
    }
    return {
        ...(0, $AHHxt.toRefs)(position),
        position: position,
        isDragging: (0, $01W3b.computed)(()=>!!pressedDelta.value),
        style: (0, $01W3b.computed)(()=>`left:${position.value.x}px;top:${position.value.y}px;`)
    };
}
function $6ffe9515611cb489$export$ff33ba24b8f2a683(target, options = {}) {
    var _a, _b;
    const isOverDropZone = (0, $01W3b.shallowRef)(false);
    const files = (0, $01W3b.shallowRef)(null);
    let counter = 0;
    let isValid = true;
    if (0, $AHHxt.isClient) {
        const _options = typeof options === "function" ? {
            onDrop: options
        } : options;
        const multiple = (_a = _options.multiple) != null ? _a : true;
        const preventDefaultForUnhandled = (_b = _options.preventDefaultForUnhandled) != null ? _b : false;
        const getFiles = (event)=>{
            var _a2, _b2;
            const list = Array.from((_b2 = (_a2 = event.dataTransfer) == null ? void 0 : _a2.files) != null ? _b2 : []);
            return list.length === 0 ? null : multiple ? list : [
                list[0]
            ];
        };
        const checkDataTypes = (types)=>{
            const dataTypes = (0, $01W3b.unref)(_options.dataTypes);
            if (typeof dataTypes === "function") return dataTypes(types);
            if (!(dataTypes == null ? void 0 : dataTypes.length)) return true;
            if (types.length === 0) return false;
            return types.every((type)=>dataTypes.some((allowedType)=>type.includes(allowedType)));
        };
        const checkValidity = (items)=>{
            const types = Array.from(items != null ? items : []).map((item)=>item.type);
            const dataTypesValid = checkDataTypes(types);
            const multipleFilesValid = multiple || items.length <= 1;
            return dataTypesValid && multipleFilesValid;
        };
        const isSafari = ()=>/^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window);
        const handleDragEvent = (event, eventType)=>{
            var _a2, _b2, _c, _d, _e, _f;
            const dataTransferItemList = (_a2 = event.dataTransfer) == null ? void 0 : _a2.items;
            isValid = (_b2 = dataTransferItemList && checkValidity(dataTransferItemList)) != null ? _b2 : false;
            if (preventDefaultForUnhandled) event.preventDefault();
            if (!isSafari() && !isValid) {
                if (event.dataTransfer) event.dataTransfer.dropEffect = "none";
                return;
            }
            event.preventDefault();
            if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
            const currentFiles = getFiles(event);
            switch(eventType){
                case "enter":
                    counter += 1;
                    isOverDropZone.value = true;
                    (_c = _options.onEnter) == null || _c.call(_options, null, event);
                    break;
                case "over":
                    (_d = _options.onOver) == null || _d.call(_options, null, event);
                    break;
                case "leave":
                    counter -= 1;
                    if (counter === 0) isOverDropZone.value = false;
                    (_e = _options.onLeave) == null || _e.call(_options, null, event);
                    break;
                case "drop":
                    counter = 0;
                    isOverDropZone.value = false;
                    if (isValid) {
                        files.value = currentFiles;
                        (_f = _options.onDrop) == null || _f.call(_options, currentFiles, event);
                    }
                    break;
            }
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragenter", (event)=>handleDragEvent(event, "enter"));
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragover", (event)=>handleDragEvent(event, "over"));
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragleave", (event)=>handleDragEvent(event, "leave"));
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "drop", (event)=>handleDragEvent(event, "drop"));
    }
    return {
        files: files,
        isOverDropZone: isOverDropZone
    };
}
function $6ffe9515611cb489$export$683480f191c0e3ea(target, callback, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ...observerOptions } = options;
    let observer;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "ResizeObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const targets = (0, $01W3b.computed)(()=>{
        const _targets = (0, $01W3b.toValue)(target);
        return Array.isArray(_targets) ? _targets.map((el)=>$6ffe9515611cb489$export$c61124d3cf5adbae(el)) : [
            $6ffe9515611cb489$export$c61124d3cf5adbae(_targets)
        ];
    });
    const stopWatch = (0, $01W3b.watch)(targets, (els)=>{
        cleanup();
        if (isSupported.value && window1) {
            observer = new ResizeObserver(callback);
            for (const _el of els)if (_el) observer.observe(_el, observerOptions);
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const stop = ()=>{
        cleanup();
        stopWatch();
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop
    };
}
function $6ffe9515611cb489$export$f623e6fca765c371(target, options = {}) {
    const { reset: reset = true, windowResize: windowResize = true, windowScroll: windowScroll = true, immediate: immediate = true, updateTiming: updateTiming = "sync" } = options;
    const height = (0, $01W3b.shallowRef)(0);
    const bottom = (0, $01W3b.shallowRef)(0);
    const left = (0, $01W3b.shallowRef)(0);
    const right = (0, $01W3b.shallowRef)(0);
    const top = (0, $01W3b.shallowRef)(0);
    const width = (0, $01W3b.shallowRef)(0);
    const x = (0, $01W3b.shallowRef)(0);
    const y = (0, $01W3b.shallowRef)(0);
    function recalculate() {
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (!el) {
            if (reset) {
                height.value = 0;
                bottom.value = 0;
                left.value = 0;
                right.value = 0;
                top.value = 0;
                width.value = 0;
                x.value = 0;
                y.value = 0;
            }
            return;
        }
        const rect = el.getBoundingClientRect();
        height.value = rect.height;
        bottom.value = rect.bottom;
        left.value = rect.left;
        right.value = rect.right;
        top.value = rect.top;
        width.value = rect.width;
        x.value = rect.x;
        y.value = rect.y;
    }
    function update() {
        if (updateTiming === "sync") recalculate();
        else if (updateTiming === "next-frame") requestAnimationFrame(()=>recalculate());
    }
    $6ffe9515611cb489$export$683480f191c0e3ea(target, update);
    (0, $01W3b.watch)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target), (ele)=>!ele && update());
    $6ffe9515611cb489$export$8ecdcf3bb089e9cd(target, update, {
        attributeFilter: [
            "style",
            "class"
        ]
    });
    if (windowScroll) $6ffe9515611cb489$export$7080b3e976bc91ab("scroll", update, {
        capture: true,
        passive: true
    });
    if (windowResize) $6ffe9515611cb489$export$7080b3e976bc91ab("resize", update, {
        passive: true
    });
    (0, $AHHxt.tryOnMounted)(()=>{
        if (immediate) update();
    });
    return {
        height: height,
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        width: width,
        x: x,
        y: y,
        update: update
    };
}
function $6ffe9515611cb489$export$f6b6f8dd6f68aad2(options) {
    const { x: x, y: y, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, multiple: multiple, interval: interval = "requestAnimationFrame", immediate: immediate = true } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>{
        if ((0, $01W3b.toValue)(multiple)) return document1 && "elementsFromPoint" in document1;
        return document1 && "elementFromPoint" in document1;
    });
    const element = (0, $01W3b.shallowRef)(null);
    const cb = ()=>{
        var _a, _b;
        element.value = (0, $01W3b.toValue)(multiple) ? (_a = document1 == null ? void 0 : document1.elementsFromPoint((0, $01W3b.toValue)(x), (0, $01W3b.toValue)(y))) != null ? _a : [] : (_b = document1 == null ? void 0 : document1.elementFromPoint((0, $01W3b.toValue)(x), (0, $01W3b.toValue)(y))) != null ? _b : null;
    };
    const controls = interval === "requestAnimationFrame" ? $6ffe9515611cb489$export$13251e0fc79284e(cb, {
        immediate: immediate
    }) : (0, $AHHxt.useIntervalFn)(cb, interval, {
        immediate: immediate
    });
    return {
        isSupported: isSupported,
        element: element,
        ...controls
    };
}
function $6ffe9515611cb489$export$6e95f3a294e6b04d(el, options = {}) {
    const { delayEnter: delayEnter = 0, delayLeave: delayLeave = 0, triggerOnRemoval: triggerOnRemoval = false, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isHovered = (0, $01W3b.shallowRef)(false);
    let timer;
    const toggle = (entering)=>{
        const delay = entering ? delayEnter : delayLeave;
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
        }
        if (delay) timer = setTimeout(()=>isHovered.value = entering, delay);
        else isHovered.value = entering;
    };
    if (!window1) return isHovered;
    $6ffe9515611cb489$export$7080b3e976bc91ab(el, "mouseenter", ()=>toggle(true), {
        passive: true
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(el, "mouseleave", ()=>toggle(false), {
        passive: true
    });
    if (triggerOnRemoval) $6ffe9515611cb489$export$23b05fde944e9922((0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(el)), ()=>toggle(false));
    return isHovered;
}
function $6ffe9515611cb489$export$2b86bedf890eab8(target, initialSize = {
    width: 0,
    height: 0
}, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, box: box = "content-box" } = options;
    const isSVG = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = $6ffe9515611cb489$export$c61124d3cf5adbae(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
    });
    const width = (0, $01W3b.shallowRef)(initialSize.width);
    const height = (0, $01W3b.shallowRef)(initialSize.height);
    const { stop: stop1 } = $6ffe9515611cb489$export$683480f191c0e3ea(target, ([entry])=>{
        const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
        if (window1 && isSVG.value) {
            const $elem = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
            if ($elem) {
                const rect = $elem.getBoundingClientRect();
                width.value = rect.width;
                height.value = rect.height;
            }
        } else if (boxSize) {
            const formatBoxSize = (0, $AHHxt.toArray)(boxSize);
            width.value = formatBoxSize.reduce((acc, { inlineSize: inlineSize })=>acc + inlineSize, 0);
            height.value = formatBoxSize.reduce((acc, { blockSize: blockSize })=>acc + blockSize, 0);
        } else {
            width.value = entry.contentRect.width;
            height.value = entry.contentRect.height;
        }
    }, options);
    (0, $AHHxt.tryOnMounted)(()=>{
        const ele = $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        if (ele) {
            width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
            height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
        }
    });
    const stop2 = (0, $01W3b.watch)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target), (ele)=>{
        width.value = ele ? initialSize.width : 0;
        height.value = ele ? initialSize.height : 0;
    });
    function stop() {
        stop1();
        stop2();
    }
    return {
        width: width,
        height: height,
        stop: stop
    };
}
function $6ffe9515611cb489$export$a7395f9832c00176(target, callback, options = {}) {
    const { root: root, rootMargin: rootMargin = "0px", threshold: threshold = 0, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, immediate: immediate = true } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "IntersectionObserver" in window1);
    const targets = (0, $01W3b.computed)(()=>{
        const _target = (0, $01W3b.toValue)(target);
        return (0, $AHHxt.toArray)(_target).map($6ffe9515611cb489$export$c61124d3cf5adbae).filter((0, $AHHxt.notNullish));
    });
    let cleanup = (0, $AHHxt.noop);
    const isActive = (0, $01W3b.shallowRef)(immediate);
    const stopWatch = isSupported.value ? (0, $01W3b.watch)(()=>[
            targets.value,
            $6ffe9515611cb489$export$c61124d3cf5adbae(root),
            isActive.value
        ], ([targets2, root2])=>{
        cleanup();
        if (!isActive.value) return;
        if (!targets2.length) return;
        const observer = new IntersectionObserver(callback, {
            root: $6ffe9515611cb489$export$c61124d3cf5adbae(root2),
            rootMargin: rootMargin,
            threshold: threshold
        });
        targets2.forEach((el)=>el && observer.observe(el));
        cleanup = ()=>{
            observer.disconnect();
            cleanup = (0, $AHHxt.noop);
        };
    }, {
        immediate: immediate,
        flush: "post"
    }) : (0, $AHHxt.noop);
    const stop = ()=>{
        cleanup();
        stopWatch();
        isActive.value = false;
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        isActive: isActive,
        pause () {
            cleanup();
            isActive.value = false;
        },
        resume () {
            isActive.value = true;
        },
        stop: stop
    };
}
function $6ffe9515611cb489$export$6aadc312a449609d(element, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, scrollTarget: scrollTarget, threshold: threshold = 0, rootMargin: rootMargin, once: once = false } = options;
    const elementIsVisible = (0, $01W3b.shallowRef)(false);
    const { stop: stop } = $6ffe9515611cb489$export$a7395f9832c00176(element, (intersectionObserverEntries)=>{
        let isIntersecting = elementIsVisible.value;
        let latestTime = 0;
        for (const entry of intersectionObserverEntries)if (entry.time >= latestTime) {
            latestTime = entry.time;
            isIntersecting = entry.isIntersecting;
        }
        elementIsVisible.value = isIntersecting;
        if (once) (0, $AHHxt.watchOnce)(elementIsVisible, ()=>{
            stop();
        });
    }, {
        root: scrollTarget,
        window: window1,
        threshold: threshold,
        rootMargin: (0, $01W3b.toValue)(rootMargin)
    });
    return elementIsVisible;
}
const $6ffe9515611cb489$var$events = /* @__PURE__ */ new Map();
function $6ffe9515611cb489$export$965c4f095bc7d646(key) {
    const scope = (0, $01W3b.getCurrentScope)();
    function on(listener) {
        var _a;
        const listeners = $6ffe9515611cb489$var$events.get(key) || /* @__PURE__ */ new Set();
        listeners.add(listener);
        $6ffe9515611cb489$var$events.set(key, listeners);
        const _off = ()=>off(listener);
        (_a = scope == null ? void 0 : scope.cleanups) == null || _a.push(_off);
        return _off;
    }
    function once(listener) {
        function _listener(...args) {
            off(_listener);
            listener(...args);
        }
        return on(_listener);
    }
    function off(listener) {
        const listeners = $6ffe9515611cb489$var$events.get(key);
        if (!listeners) return;
        listeners.delete(listener);
        if (!listeners.size) reset();
    }
    function reset() {
        $6ffe9515611cb489$var$events.delete(key);
    }
    function emit(event, payload) {
        var _a;
        (_a = $6ffe9515611cb489$var$events.get(key)) == null || _a.forEach((v)=>v(event, payload));
    }
    return {
        on: on,
        once: once,
        off: off,
        emit: emit,
        reset: reset
    };
}
function $6ffe9515611cb489$var$resolveNestedOptions$1(options) {
    if (options === true) return {};
    return options;
}
function $6ffe9515611cb489$export$1492e5081ec8f8b5(url, events = [], options = {}) {
    const event = (0, $01W3b.shallowRef)(null);
    const data = (0, $01W3b.shallowRef)(null);
    const status = (0, $01W3b.shallowRef)("CONNECTING");
    const eventSource = (0, $01W3b.ref)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const urlRef = (0, $AHHxt.toRef)(url);
    const lastEventId = (0, $01W3b.shallowRef)(null);
    let explicitlyClosed = false;
    let retried = 0;
    const { withCredentials: withCredentials = false, immediate: immediate = true, autoConnect: autoConnect = true, autoReconnect: autoReconnect } = options;
    const close = ()=>{
        if ((0, $AHHxt.isClient) && eventSource.value) {
            eventSource.value.close();
            eventSource.value = null;
            status.value = "CLOSED";
            explicitlyClosed = true;
        }
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const es = new EventSource(urlRef.value, {
            withCredentials: withCredentials
        });
        status.value = "CONNECTING";
        eventSource.value = es;
        es.onopen = ()=>{
            status.value = "OPEN";
            error.value = null;
        };
        es.onerror = (e)=>{
            status.value = "CLOSED";
            error.value = e;
            if (es.readyState === 2 && !explicitlyClosed && autoReconnect) {
                es.close();
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $6ffe9515611cb489$var$resolveNestedOptions$1(autoReconnect);
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);
                else if (typeof retries === "function" && retries()) setTimeout(_init, delay);
                else onFailed == null || onFailed();
            }
        };
        es.onmessage = (e)=>{
            event.value = null;
            data.value = e.data;
            lastEventId.value = e.lastEventId;
        };
        for (const event_name of events)$6ffe9515611cb489$export$7080b3e976bc91ab(es, event_name, (e)=>{
            event.value = event_name;
            data.value = e.data || null;
        }, {
            passive: true
        });
    };
    const open = ()=>{
        if (!(0, $AHHxt.isClient)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) open();
    if (autoConnect) (0, $01W3b.watch)(urlRef, open);
    (0, $AHHxt.tryOnScopeDispose)(close);
    return {
        eventSource: eventSource,
        event: event,
        data: data,
        status: status,
        error: error,
        open: open,
        close: close,
        lastEventId: lastEventId
    };
}
function $6ffe9515611cb489$export$b649d244384df275(options = {}) {
    const { initialValue: initialValue = "" } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>typeof window !== "undefined" && "EyeDropper" in window);
    const sRGBHex = (0, $01W3b.shallowRef)(initialValue);
    async function open(openOptions) {
        if (!isSupported.value) return;
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open(openOptions);
        sRGBHex.value = result.sRGBHex;
        return result;
    }
    return {
        isSupported: isSupported,
        sRGBHex: sRGBHex,
        open: open
    };
}
function $6ffe9515611cb489$export$1252d0179ae6292b(newIcon = null, options = {}) {
    const { baseUrl: baseUrl = "", rel: rel = "icon", document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const favicon = (0, $AHHxt.toRef)(newIcon);
    const applyIcon = (icon)=>{
        const elements = document1 == null ? void 0 : document1.head.querySelectorAll(`link[rel*="${rel}"]`);
        if (!elements || elements.length === 0) {
            const link = document1 == null ? void 0 : document1.createElement("link");
            if (link) {
                link.rel = rel;
                link.href = `${baseUrl}${icon}`;
                link.type = `image/${icon.split(".").pop()}`;
                document1 == null || document1.head.append(link);
            }
            return;
        }
        elements == null || elements.forEach((el)=>el.href = `${baseUrl}${icon}`);
    };
    (0, $01W3b.watch)(favicon, (i, o)=>{
        if (typeof i === "string" && i !== o) applyIcon(i);
    }, {
        immediate: true
    });
    return favicon;
}
const $6ffe9515611cb489$var$payloadMapping = {
    json: "application/json",
    text: "text/plain"
};
function $6ffe9515611cb489$var$isFetchOptions(obj) {
    return obj && (0, $AHHxt.containsProp)(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
const $6ffe9515611cb489$var$reAbsolute = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;
function $6ffe9515611cb489$var$isAbsoluteURL(url) {
    return $6ffe9515611cb489$var$reAbsolute.test(url);
}
function $6ffe9515611cb489$var$headersToObject(headers) {
    if (typeof Headers !== "undefined" && headers instanceof Headers) return Object.fromEntries(headers.entries());
    return headers;
}
function $6ffe9515611cb489$var$combineCallbacks(combination, ...callbacks) {
    if (combination === "overwrite") return async (ctx)=>{
        let callback;
        for(let i = callbacks.length - 1; i >= 0; i--)if (callbacks[i] != null) {
            callback = callbacks[i];
            break;
        }
        if (callback) return {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
    else return async (ctx)=>{
        for (const callback of callbacks)if (callback) ctx = {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
}
function $6ffe9515611cb489$export$3d173a42d8c9a48a(config = {}) {
    const _combination = config.combination || "chain";
    const _options = config.options || {};
    const _fetchOptions = config.fetchOptions || {};
    function useFactoryFetch(url, ...args) {
        const computedUrl = (0, $01W3b.computed)(()=>{
            const baseUrl = (0, $01W3b.toValue)(config.baseUrl);
            const targetUrl = (0, $01W3b.toValue)(url);
            return baseUrl && !$6ffe9515611cb489$var$isAbsoluteURL(targetUrl) ? $6ffe9515611cb489$var$joinPaths(baseUrl, targetUrl) : targetUrl;
        });
        let options = _options;
        let fetchOptions = _fetchOptions;
        if (args.length > 0) {
            if ($6ffe9515611cb489$var$isFetchOptions(args[0])) options = {
                ...options,
                ...args[0],
                beforeFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch),
                afterFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch),
                onFetchError: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError)
            };
            else fetchOptions = {
                ...fetchOptions,
                ...args[0],
                headers: {
                    ...$6ffe9515611cb489$var$headersToObject(fetchOptions.headers) || {},
                    ...$6ffe9515611cb489$var$headersToObject(args[0].headers) || {}
                }
            };
        }
        if (args.length > 1 && $6ffe9515611cb489$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1],
            beforeFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch),
            afterFetch: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch),
            onFetchError: $6ffe9515611cb489$var$combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError)
        };
        return $6ffe9515611cb489$export$d852f5f778460fa4(computedUrl, fetchOptions, options);
    }
    return useFactoryFetch;
}
function $6ffe9515611cb489$export$d852f5f778460fa4(url, ...args) {
    var _a;
    const supportsAbort = typeof AbortController === "function";
    let fetchOptions = {};
    let options = {
        immediate: true,
        refetch: false,
        timeout: 0,
        updateDataOnError: false
    };
    const config = {
        method: "GET",
        type: "text",
        payload: void 0
    };
    if (args.length > 0) {
        if ($6ffe9515611cb489$var$isFetchOptions(args[0])) options = {
            ...options,
            ...args[0]
        };
        else fetchOptions = args[0];
    }
    if (args.length > 1) {
        if ($6ffe9515611cb489$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1]
        };
    }
    const { fetch: fetch = (_a = $6ffe9515611cb489$export$16f8ba610718ae4a) == null ? void 0 : _a.fetch, initialData: initialData, timeout: timeout } = options;
    const responseEvent = (0, $AHHxt.createEventHook)();
    const errorEvent = (0, $AHHxt.createEventHook)();
    const finallyEvent = (0, $AHHxt.createEventHook)();
    const isFinished = (0, $01W3b.shallowRef)(false);
    const isFetching = (0, $01W3b.shallowRef)(false);
    const aborted = (0, $01W3b.shallowRef)(false);
    const statusCode = (0, $01W3b.shallowRef)(null);
    const response = (0, $01W3b.shallowRef)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const data = (0, $01W3b.shallowRef)(initialData || null);
    const canAbort = (0, $01W3b.computed)(()=>supportsAbort && isFetching.value);
    let controller;
    let timer;
    const abort = ()=>{
        if (supportsAbort) {
            controller == null || controller.abort();
            controller = new AbortController();
            controller.signal.onabort = ()=>aborted.value = true;
            fetchOptions = {
                ...fetchOptions,
                signal: controller.signal
            };
        }
    };
    const loading = (isLoading)=>{
        isFetching.value = isLoading;
        isFinished.value = !isLoading;
    };
    if (timeout) timer = (0, $AHHxt.useTimeoutFn)(abort, timeout, {
        immediate: false
    });
    let executeCounter = 0;
    const execute = async (throwOnFailed = false)=>{
        var _a2, _b;
        abort();
        loading(true);
        error.value = null;
        statusCode.value = null;
        aborted.value = false;
        executeCounter += 1;
        const currentExecuteCounter = executeCounter;
        const defaultFetchOptions = {
            method: config.method,
            headers: {}
        };
        const payload = (0, $01W3b.toValue)(config.payload);
        if (payload) {
            const headers = $6ffe9515611cb489$var$headersToObject(defaultFetchOptions.headers);
            const proto = Object.getPrototypeOf(payload);
            if (!config.payloadType && payload && (proto === Object.prototype || Array.isArray(proto)) && !(payload instanceof FormData)) config.payloadType = "json";
            if (config.payloadType) headers["Content-Type"] = (_a2 = $6ffe9515611cb489$var$payloadMapping[config.payloadType]) != null ? _a2 : config.payloadType;
            defaultFetchOptions.body = config.payloadType === "json" ? JSON.stringify(payload) : payload;
        }
        let isCanceled = false;
        const context = {
            url: (0, $01W3b.toValue)(url),
            options: {
                ...defaultFetchOptions,
                ...fetchOptions
            },
            cancel: ()=>{
                isCanceled = true;
            }
        };
        if (options.beforeFetch) Object.assign(context, await options.beforeFetch(context));
        if (isCanceled || !fetch) {
            loading(false);
            return Promise.resolve(null);
        }
        let responseData = null;
        if (timer) timer.start();
        return fetch(context.url, {
            ...defaultFetchOptions,
            ...context.options,
            headers: {
                ...$6ffe9515611cb489$var$headersToObject(defaultFetchOptions.headers),
                ...$6ffe9515611cb489$var$headersToObject((_b = context.options) == null ? void 0 : _b.headers)
            }
        }).then(async (fetchResponse)=>{
            response.value = fetchResponse;
            statusCode.value = fetchResponse.status;
            responseData = await fetchResponse.clone()[config.type]();
            if (!fetchResponse.ok) {
                data.value = initialData || null;
                throw new Error(fetchResponse.statusText);
            }
            if (options.afterFetch) ({ data: responseData } = await options.afterFetch({
                data: responseData,
                response: fetchResponse,
                context: context,
                execute: execute
            }));
            data.value = responseData;
            responseEvent.trigger(fetchResponse);
            return fetchResponse;
        }).catch(async (fetchError)=>{
            let errorData = fetchError.message || fetchError.name;
            if (options.onFetchError) ({ error: errorData, data: responseData } = await options.onFetchError({
                data: responseData,
                error: fetchError,
                response: response.value,
                context: context,
                execute: execute
            }));
            error.value = errorData;
            if (options.updateDataOnError) data.value = responseData;
            errorEvent.trigger(fetchError);
            if (throwOnFailed) throw fetchError;
            return null;
        }).finally(()=>{
            if (currentExecuteCounter === executeCounter) loading(false);
            if (timer) timer.stop();
            finallyEvent.trigger(null);
        });
    };
    const refetch = (0, $AHHxt.toRef)(options.refetch);
    (0, $01W3b.watch)([
        refetch,
        (0, $AHHxt.toRef)(url)
    ], ([refetch2])=>refetch2 && execute(), {
        deep: true
    });
    const shell = {
        isFinished: (0, $01W3b.readonly)(isFinished),
        isFetching: (0, $01W3b.readonly)(isFetching),
        statusCode: statusCode,
        response: response,
        error: error,
        data: data,
        canAbort: canAbort,
        aborted: aborted,
        abort: abort,
        execute: execute,
        onFetchResponse: responseEvent.on,
        onFetchError: errorEvent.on,
        onFetchFinally: finallyEvent.on,
        // method
        get: setMethod("GET"),
        put: setMethod("PUT"),
        post: setMethod("POST"),
        delete: setMethod("DELETE"),
        patch: setMethod("PATCH"),
        head: setMethod("HEAD"),
        options: setMethod("OPTIONS"),
        // type
        json: setType("json"),
        text: setType("text"),
        blob: setType("blob"),
        arrayBuffer: setType("arrayBuffer"),
        formData: setType("formData")
    };
    function setMethod(method) {
        return (payload, payloadType)=>{
            if (!isFetching.value) {
                config.method = method;
                config.payload = payload;
                config.payloadType = payloadType;
                if ((0, $01W3b.isRef)(config.payload)) (0, $01W3b.watch)([
                    refetch,
                    (0, $AHHxt.toRef)(config.payload)
                ], ([refetch2])=>refetch2 && execute(), {
                    deep: true
                });
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
            return void 0;
        };
    }
    function waitUntilFinished() {
        return new Promise((resolve, reject)=>{
            (0, $AHHxt.until)(isFinished).toBe(true).then(()=>resolve(shell)).catch(reject);
        });
    }
    function setType(type) {
        return ()=>{
            if (!isFetching.value) {
                config.type = type;
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
            return void 0;
        };
    }
    if (options.immediate) Promise.resolve().then(()=>execute());
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
        }
    };
}
function $6ffe9515611cb489$var$joinPaths(start, end) {
    if (!start.endsWith("/") && !end.startsWith("/")) return `${start}/${end}`;
    if (start.endsWith("/") && end.startsWith("/")) return `${start.slice(0, -1)}${end}`;
    return `${start}${end}`;
}
const $6ffe9515611cb489$var$DEFAULT_OPTIONS = {
    multiple: true,
    accept: "*",
    reset: false,
    directory: false
};
function $6ffe9515611cb489$var$prepareInitialFiles(files) {
    if (!files) return null;
    if (files instanceof FileList) return files;
    const dt = new DataTransfer();
    for (const file of files)dt.items.add(file);
    return dt.files;
}
function $6ffe9515611cb489$export$46ab9fa3f3719597(options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const files = (0, $01W3b.ref)($6ffe9515611cb489$var$prepareInitialFiles(options.initialFiles));
    const { on: onChange, trigger: changeTrigger } = (0, $AHHxt.createEventHook)();
    const { on: onCancel, trigger: cancelTrigger } = (0, $AHHxt.createEventHook)();
    let input;
    if (document1) {
        input = document1.createElement("input");
        input.type = "file";
        input.onchange = (event)=>{
            const result = event.target;
            files.value = result.files;
            changeTrigger(files.value);
        };
        input.oncancel = ()=>{
            cancelTrigger();
        };
    }
    const reset = ()=>{
        files.value = null;
        if (input && input.value) {
            input.value = "";
            changeTrigger(null);
        }
    };
    const open = (localOptions)=>{
        if (!input) return;
        const _options = {
            ...$6ffe9515611cb489$var$DEFAULT_OPTIONS,
            ...options,
            ...localOptions
        };
        input.multiple = _options.multiple;
        input.accept = _options.accept;
        input.webkitdirectory = _options.directory;
        if ((0, $AHHxt.hasOwn)(_options, "capture")) input.capture = _options.capture;
        if (_options.reset) reset();
        input.click();
    };
    return {
        files: (0, $01W3b.readonly)(files),
        open: open,
        reset: reset,
        onCancel: onCancel,
        onChange: onChange
    };
}
function $6ffe9515611cb489$export$2af170812ec5e71(options = {}) {
    const { window: _window = $6ffe9515611cb489$export$16f8ba610718ae4a, dataType: dataType = "Text" } = options;
    const window1 = _window;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "showSaveFilePicker" in window1 && "showOpenFilePicker" in window1);
    const fileHandle = (0, $01W3b.shallowRef)();
    const data = (0, $01W3b.shallowRef)();
    const file = (0, $01W3b.shallowRef)();
    const fileName = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.name) != null ? _b : "";
    });
    const fileMIME = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.type) != null ? _b : "";
    });
    const fileSize = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.size) != null ? _b : 0;
    });
    const fileLastModified = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.lastModified) != null ? _b : 0;
    });
    async function open(_options = {}) {
        if (!isSupported.value) return;
        const [handle] = await window1.showOpenFilePicker({
            ...(0, $01W3b.toValue)(options),
            ..._options
        });
        fileHandle.value = handle;
        await updateData();
    }
    async function create(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        data.value = void 0;
        await updateData();
    }
    async function save(_options = {}) {
        if (!isSupported.value) return;
        if (!fileHandle.value) return saveAs(_options);
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function saveAs(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function updateFile() {
        var _a;
        file.value = await ((_a = fileHandle.value) == null ? void 0 : _a.getFile());
    }
    async function updateData() {
        var _a, _b;
        await updateFile();
        const type = (0, $01W3b.toValue)(dataType);
        if (type === "Text") data.value = await ((_a = file.value) == null ? void 0 : _a.text());
        else if (type === "ArrayBuffer") data.value = await ((_b = file.value) == null ? void 0 : _b.arrayBuffer());
        else if (type === "Blob") data.value = file.value;
    }
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(dataType), updateData);
    return {
        isSupported: isSupported,
        data: data,
        file: file,
        fileName: fileName,
        fileMIME: fileMIME,
        fileSize: fileSize,
        fileLastModified: fileLastModified,
        open: open,
        create: create,
        save: save,
        saveAs: saveAs,
        updateData: updateData
    };
}
function $6ffe9515611cb489$export$f8168d8dd8fd66e6(target, options = {}) {
    const { initialValue: initialValue = false, focusVisible: focusVisible = false, preventScroll: preventScroll = false } = options;
    const innerFocused = (0, $01W3b.shallowRef)(false);
    const targetElement = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target));
    const listenerOptions = {
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(targetElement, "focus", (event)=>{
        var _a, _b;
        if (!focusVisible || ((_b = (_a = event.target).matches) == null ? void 0 : _b.call(_a, ":focus-visible"))) innerFocused.value = true;
    }, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(targetElement, "blur", ()=>innerFocused.value = false, listenerOptions);
    const focused = (0, $01W3b.computed)({
        get: ()=>innerFocused.value,
        set (value) {
            var _a, _b;
            if (!value && innerFocused.value) (_a = targetElement.value) == null || _a.blur();
            else if (value && !innerFocused.value) (_b = targetElement.value) == null || _b.focus({
                preventScroll: preventScroll
            });
        }
    });
    (0, $01W3b.watch)(targetElement, ()=>{
        focused.value = initialValue;
    }, {
        immediate: true,
        flush: "post"
    });
    return {
        focused: focused
    };
}
const $6ffe9515611cb489$var$EVENT_FOCUS_IN = "focusin";
const $6ffe9515611cb489$var$EVENT_FOCUS_OUT = "focusout";
const $6ffe9515611cb489$var$PSEUDO_CLASS_FOCUS_WITHIN = ":focus-within";
function $6ffe9515611cb489$export$420e68273165f4ec(target, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const targetElement = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(target));
    const _focused = (0, $01W3b.shallowRef)(false);
    const focused = (0, $01W3b.computed)(()=>_focused.value);
    const activeElement = $6ffe9515611cb489$export$4e1875a4b2b1434f(options);
    if (!window1 || !activeElement.value) return {
        focused: focused
    };
    const listenerOptions = {
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(targetElement, $6ffe9515611cb489$var$EVENT_FOCUS_IN, ()=>_focused.value = true, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(targetElement, $6ffe9515611cb489$var$EVENT_FOCUS_OUT, ()=>{
        var _a, _b, _c;
        return _focused.value = (_c = (_b = (_a = targetElement.value) == null ? void 0 : _a.matches) == null ? void 0 : _b.call(_a, $6ffe9515611cb489$var$PSEUDO_CLASS_FOCUS_WITHIN)) != null ? _c : false;
    }, listenerOptions);
    return {
        focused: focused
    };
}
function $6ffe9515611cb489$export$ab5229fe4b5ea5d0(options) {
    var _a;
    const fps = (0, $01W3b.shallowRef)(0);
    if (typeof performance === "undefined") return fps;
    const every = (_a = options == null ? void 0 : options.every) != null ? _a : 10;
    let last = performance.now();
    let ticks = 0;
    $6ffe9515611cb489$export$13251e0fc79284e(()=>{
        ticks += 1;
        if (ticks >= every) {
            const now = performance.now();
            const diff = now - last;
            fps.value = Math.round(1e3 / (diff / ticks));
            last = now;
            ticks = 0;
        }
    });
    return fps;
}
const $6ffe9515611cb489$var$eventHandlers = [
    "fullscreenchange",
    "webkitfullscreenchange",
    "webkitendfullscreen",
    "mozfullscreenchange",
    "MSFullscreenChange"
];
function $6ffe9515611cb489$export$873ff9d3a24fe223(target, options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, autoExit: autoExit = false } = options;
    const targetRef = (0, $01W3b.computed)(()=>{
        var _a;
        return (_a = $6ffe9515611cb489$export$c61124d3cf5adbae(target)) != null ? _a : document1 == null ? void 0 : document1.documentElement;
    });
    const isFullscreen = (0, $01W3b.shallowRef)(false);
    const requestMethod = (0, $01W3b.computed)(()=>{
        return [
            "requestFullscreen",
            "webkitRequestFullscreen",
            "webkitEnterFullscreen",
            "webkitEnterFullScreen",
            "webkitRequestFullScreen",
            "mozRequestFullScreen",
            "msRequestFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const exitMethod = (0, $01W3b.computed)(()=>{
        return [
            "exitFullscreen",
            "webkitExitFullscreen",
            "webkitExitFullScreen",
            "webkitCancelFullScreen",
            "mozCancelFullScreen",
            "msExitFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenEnabled = (0, $01W3b.computed)(()=>{
        return [
            "fullScreen",
            "webkitIsFullScreen",
            "webkitDisplayingFullscreen",
            "mozFullScreen",
            "msFullscreenElement"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenElementMethod = [
        "fullscreenElement",
        "webkitFullscreenElement",
        "mozFullScreenElement",
        "msFullscreenElement"
    ].find((m)=>document1 && m in document1);
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>targetRef.value && document1 && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0);
    const isCurrentElementFullScreen = ()=>{
        if (fullscreenElementMethod) return (document1 == null ? void 0 : document1[fullscreenElementMethod]) === targetRef.value;
        return false;
    };
    const isElementFullScreen = ()=>{
        if (fullscreenEnabled.value) {
            if (document1 && document1[fullscreenEnabled.value] != null) return document1[fullscreenEnabled.value];
            else {
                const target2 = targetRef.value;
                if ((target2 == null ? void 0 : target2[fullscreenEnabled.value]) != null) return Boolean(target2[fullscreenEnabled.value]);
            }
        }
        return false;
    };
    async function exit() {
        if (!isSupported.value || !isFullscreen.value) return;
        if (exitMethod.value) {
            if ((document1 == null ? void 0 : document1[exitMethod.value]) != null) await document1[exitMethod.value]();
            else {
                const target2 = targetRef.value;
                if ((target2 == null ? void 0 : target2[exitMethod.value]) != null) await target2[exitMethod.value]();
            }
        }
        isFullscreen.value = false;
    }
    async function enter() {
        if (!isSupported.value || isFullscreen.value) return;
        if (isElementFullScreen()) await exit();
        const target2 = targetRef.value;
        if (requestMethod.value && (target2 == null ? void 0 : target2[requestMethod.value]) != null) {
            await target2[requestMethod.value]();
            isFullscreen.value = true;
        }
    }
    async function toggle() {
        await (isFullscreen.value ? exit() : enter());
    }
    const handlerCallback = ()=>{
        const isElementFullScreenValue = isElementFullScreen();
        if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen()) isFullscreen.value = isElementFullScreenValue;
    };
    const listenerOptions = {
        capture: false,
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(document1, $6ffe9515611cb489$var$eventHandlers, handlerCallback, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(targetRef), $6ffe9515611cb489$var$eventHandlers, handlerCallback, listenerOptions);
    if (autoExit) (0, $AHHxt.tryOnScopeDispose)(exit);
    return {
        isSupported: isSupported,
        isFullscreen: isFullscreen,
        enter: enter,
        exit: exit,
        toggle: toggle
    };
}
function $6ffe9515611cb489$export$9688e62b453d9aed(gamepad) {
    return (0, $01W3b.computed)(()=>{
        if (gamepad.value) return {
            buttons: {
                a: gamepad.value.buttons[0],
                b: gamepad.value.buttons[1],
                x: gamepad.value.buttons[2],
                y: gamepad.value.buttons[3]
            },
            bumper: {
                left: gamepad.value.buttons[4],
                right: gamepad.value.buttons[5]
            },
            triggers: {
                left: gamepad.value.buttons[6],
                right: gamepad.value.buttons[7]
            },
            stick: {
                left: {
                    horizontal: gamepad.value.axes[0],
                    vertical: gamepad.value.axes[1],
                    button: gamepad.value.buttons[10]
                },
                right: {
                    horizontal: gamepad.value.axes[2],
                    vertical: gamepad.value.axes[3],
                    button: gamepad.value.buttons[11]
                }
            },
            dpad: {
                up: gamepad.value.buttons[12],
                down: gamepad.value.buttons[13],
                left: gamepad.value.buttons[14],
                right: gamepad.value.buttons[15]
            },
            back: gamepad.value.buttons[8],
            start: gamepad.value.buttons[9]
        };
        return null;
    });
}
function $6ffe9515611cb489$export$467a9d70edd1fd69(options = {}) {
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "getGamepads" in navigator1);
    const gamepads = (0, $01W3b.ref)([]);
    const onConnectedHook = (0, $AHHxt.createEventHook)();
    const onDisconnectedHook = (0, $AHHxt.createEventHook)();
    const stateFromGamepad = (gamepad)=>{
        const hapticActuators = [];
        const vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
        if (vibrationActuator) hapticActuators.push(vibrationActuator);
        if (gamepad.hapticActuators) hapticActuators.push(...gamepad.hapticActuators);
        return {
            id: gamepad.id,
            index: gamepad.index,
            connected: gamepad.connected,
            mapping: gamepad.mapping,
            timestamp: gamepad.timestamp,
            vibrationActuator: gamepad.vibrationActuator,
            hapticActuators: hapticActuators,
            axes: gamepad.axes.map((axes)=>axes),
            buttons: gamepad.buttons.map((button)=>({
                    pressed: button.pressed,
                    touched: button.touched,
                    value: button.value
                }))
        };
    };
    const updateGamepadState = ()=>{
        const _gamepads = (navigator1 == null ? void 0 : navigator1.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) gamepads.value[gamepad.index] = stateFromGamepad(gamepad);
    };
    const { isActive: isActive, pause: pause, resume: resume } = $6ffe9515611cb489$export$13251e0fc79284e(updateGamepadState);
    const onGamepadConnected = (gamepad)=>{
        if (!gamepads.value.some(({ index: index })=>index === gamepad.index)) {
            gamepads.value.push(stateFromGamepad(gamepad));
            onConnectedHook.trigger(gamepad.index);
        }
        resume();
    };
    const onGamepadDisconnected = (gamepad)=>{
        gamepads.value = gamepads.value.filter((x)=>x.index !== gamepad.index);
        onDisconnectedHook.trigger(gamepad.index);
    };
    const listenerOptions = {
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab("gamepadconnected", (e)=>onGamepadConnected(e.gamepad), listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab("gamepaddisconnected", (e)=>onGamepadDisconnected(e.gamepad), listenerOptions);
    (0, $AHHxt.tryOnMounted)(()=>{
        const _gamepads = (navigator1 == null ? void 0 : navigator1.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) onGamepadConnected(gamepad);
    });
    pause();
    return {
        isSupported: isSupported,
        onConnected: onConnectedHook.on,
        onDisconnected: onDisconnectedHook.on,
        gamepads: gamepads,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $6ffe9515611cb489$export$8c959c84e890409a(options = {}) {
    const { enableHighAccuracy: enableHighAccuracy = true, maximumAge: maximumAge = 3e4, timeout: timeout = 27e3, navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc, immediate: immediate = true } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "geolocation" in navigator1);
    const locatedAt = (0, $01W3b.shallowRef)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const coords = (0, $01W3b.ref)({
        accuracy: 0,
        latitude: Number.POSITIVE_INFINITY,
        longitude: Number.POSITIVE_INFINITY,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        speed: null
    });
    function updatePosition(position) {
        locatedAt.value = position.timestamp;
        coords.value = position.coords;
        error.value = null;
    }
    let watcher;
    function resume() {
        if (isSupported.value) watcher = navigator1.geolocation.watchPosition(updatePosition, (err)=>error.value = err, {
            enableHighAccuracy: enableHighAccuracy,
            maximumAge: maximumAge,
            timeout: timeout
        });
    }
    if (immediate) resume();
    function pause() {
        if (watcher && navigator1) navigator1.geolocation.clearWatch(watcher);
    }
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        pause();
    });
    return {
        isSupported: isSupported,
        coords: coords,
        locatedAt: locatedAt,
        error: error,
        resume: resume,
        pause: pause
    };
}
const $6ffe9515611cb489$var$defaultEvents$1 = [
    "mousemove",
    "mousedown",
    "resize",
    "keydown",
    "touchstart",
    "wheel"
];
const $6ffe9515611cb489$var$oneMinute = 6e4;
function $6ffe9515611cb489$export$4fed27c116de10cb(timeout = $6ffe9515611cb489$var$oneMinute, options = {}) {
    const { initialState: initialState = false, listenForVisibilityChange: listenForVisibilityChange = true, events: events = $6ffe9515611cb489$var$defaultEvents$1, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, eventFilter: eventFilter = (0, $AHHxt.throttleFilter)(50) } = options;
    const idle = (0, $01W3b.shallowRef)(initialState);
    const lastActive = (0, $01W3b.shallowRef)((0, $AHHxt.timestamp)());
    let timer;
    const reset = ()=>{
        idle.value = false;
        clearTimeout(timer);
        timer = setTimeout(()=>idle.value = true, timeout);
    };
    const onEvent = (0, $AHHxt.createFilterWrapper)(eventFilter, ()=>{
        lastActive.value = (0, $AHHxt.timestamp)();
        reset();
    });
    if (window1) {
        const document1 = window1.document;
        const listenerOptions = {
            passive: true
        };
        for (const event of events)$6ffe9515611cb489$export$7080b3e976bc91ab(window1, event, onEvent, listenerOptions);
        if (listenForVisibilityChange) $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
            if (!document1.hidden) onEvent();
        }, listenerOptions);
        reset();
    }
    return {
        idle: idle,
        lastActive: lastActive,
        reset: reset
    };
}
async function $6ffe9515611cb489$var$loadImage(options) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        const { src: src, srcset: srcset, sizes: sizes, class: clazz, loading: loading, crossorigin: crossorigin, referrerPolicy: referrerPolicy, width: width, height: height, decoding: decoding, fetchPriority: fetchPriority, ismap: ismap, usemap: usemap } = options;
        img.src = src;
        if (srcset != null) img.srcset = srcset;
        if (sizes != null) img.sizes = sizes;
        if (clazz != null) img.className = clazz;
        if (loading != null) img.loading = loading;
        if (crossorigin != null) img.crossOrigin = crossorigin;
        if (referrerPolicy != null) img.referrerPolicy = referrerPolicy;
        if (width != null) img.width = width;
        if (height != null) img.height = height;
        if (decoding != null) img.decoding = decoding;
        if (fetchPriority != null) img.fetchPriority = fetchPriority;
        if (ismap != null) img.isMap = ismap;
        if (usemap != null) img.useMap = usemap;
        img.onload = ()=>resolve(img);
        img.onerror = reject;
    });
}
function $6ffe9515611cb489$export$e4da99f09da8b739(options, asyncStateOptions = {}) {
    const state = $6ffe9515611cb489$export$d94717ae0e8aa8b(()=>$6ffe9515611cb489$var$loadImage((0, $01W3b.toValue)(options)), void 0, {
        resetOnExecute: true,
        ...asyncStateOptions
    });
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(options), ()=>state.execute(asyncStateOptions.delay), {
        deep: true
    });
    return state;
}
function $6ffe9515611cb489$var$resolveElement(el) {
    if (typeof Window !== "undefined" && el instanceof Window) return el.document.documentElement;
    if (typeof Document !== "undefined" && el instanceof Document) return el.documentElement;
    return el;
}
const $6ffe9515611cb489$var$ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function $6ffe9515611cb489$export$d928051c8cd740b(element, options = {}) {
    const { throttle: throttle = 0, idle: idle = 200, onStop: onStop = (0, $AHHxt.noop), onScroll: onScroll = (0, $AHHxt.noop), offset: offset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }, eventListenerOptions: eventListenerOptions = {
        capture: false,
        passive: true
    }, behavior: behavior = "auto", window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, onError: onError = (e)=>{
        console.error(e);
    } } = options;
    const internalX = (0, $01W3b.shallowRef)(0);
    const internalY = (0, $01W3b.shallowRef)(0);
    const x = (0, $01W3b.computed)({
        get () {
            return internalX.value;
        },
        set (x2) {
            scrollTo(x2, void 0);
        }
    });
    const y = (0, $01W3b.computed)({
        get () {
            return internalY.value;
        },
        set (y2) {
            scrollTo(void 0, y2);
        }
    });
    function scrollTo(_x, _y) {
        var _a, _b, _c, _d;
        if (!window1) return;
        const _element = (0, $01W3b.toValue)(element);
        if (!_element) return;
        (_c = _element instanceof Document ? window1.document.body : _element) == null || _c.scrollTo({
            top: (_a = (0, $01W3b.toValue)(_y)) != null ? _a : y.value,
            left: (_b = (0, $01W3b.toValue)(_x)) != null ? _b : x.value,
            behavior: (0, $01W3b.toValue)(behavior)
        });
        const scrollContainer = ((_d = _element == null ? void 0 : _element.document) == null ? void 0 : _d.documentElement) || (_element == null ? void 0 : _element.documentElement) || _element;
        if (x != null) internalX.value = scrollContainer.scrollLeft;
        if (y != null) internalY.value = scrollContainer.scrollTop;
    }
    const isScrolling = (0, $01W3b.shallowRef)(false);
    const arrivedState = (0, $01W3b.reactive)({
        left: true,
        right: false,
        top: true,
        bottom: false
    });
    const directions = (0, $01W3b.reactive)({
        left: false,
        right: false,
        top: false,
        bottom: false
    });
    const onScrollEnd = (e)=>{
        if (!isScrolling.value) return;
        isScrolling.value = false;
        directions.left = false;
        directions.right = false;
        directions.top = false;
        directions.bottom = false;
        onStop(e);
    };
    const onScrollEndDebounced = (0, $AHHxt.useDebounceFn)(onScrollEnd, throttle + idle);
    const setArrivedState = (target)=>{
        var _a;
        if (!window1) return;
        const el = ((_a = target == null ? void 0 : target.document) == null ? void 0 : _a.documentElement) || (target == null ? void 0 : target.documentElement) || $6ffe9515611cb489$export$c61124d3cf5adbae(target);
        const { display: display, flexDirection: flexDirection, direction: direction } = getComputedStyle(el);
        const directionMultipler = direction === "rtl" ? -1 : 1;
        const scrollLeft = el.scrollLeft;
        directions.left = scrollLeft < internalX.value;
        directions.right = scrollLeft > internalX.value;
        const left = Math.abs(scrollLeft * directionMultipler) <= (offset.left || 0);
        const right = Math.abs(scrollLeft * directionMultipler) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - $6ffe9515611cb489$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "row-reverse") {
            arrivedState.left = right;
            arrivedState.right = left;
        } else {
            arrivedState.left = left;
            arrivedState.right = right;
        }
        internalX.value = scrollLeft;
        let scrollTop = el.scrollTop;
        if (target === window1.document && !scrollTop) scrollTop = window1.document.body.scrollTop;
        directions.top = scrollTop < internalY.value;
        directions.bottom = scrollTop > internalY.value;
        const top = Math.abs(scrollTop) <= (offset.top || 0);
        const bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - $6ffe9515611cb489$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "column-reverse") {
            arrivedState.top = bottom;
            arrivedState.bottom = top;
        } else {
            arrivedState.top = top;
            arrivedState.bottom = bottom;
        }
        internalY.value = scrollTop;
    };
    const onScrollHandler = (e)=>{
        var _a;
        if (!window1) return;
        const eventTarget = (_a = e.target.documentElement) != null ? _a : e.target;
        setArrivedState(eventTarget);
        isScrolling.value = true;
        onScrollEndDebounced(e);
        onScroll(e);
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(element, "scroll", throttle ? (0, $AHHxt.useThrottleFn)(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
    (0, $AHHxt.tryOnMounted)(()=>{
        try {
            const _element = (0, $01W3b.toValue)(element);
            if (!_element) return;
            setArrivedState(_element);
        } catch (e) {
            onError(e);
        }
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(element, "scrollend", onScrollEnd, eventListenerOptions);
    return {
        x: x,
        y: y,
        isScrolling: isScrolling,
        arrivedState: arrivedState,
        directions: directions,
        measure () {
            const _element = (0, $01W3b.toValue)(element);
            if (window1 && _element) setArrivedState(_element);
        }
    };
}
function $6ffe9515611cb489$export$a973cef5093a8d22(element, onLoadMore, options = {}) {
    var _a;
    const { direction: direction = "bottom", interval: interval = 100, canLoadMore: canLoadMore = ()=>true } = options;
    const state = (0, $01W3b.reactive)($6ffe9515611cb489$export$d928051c8cd740b(element, {
        ...options,
        offset: {
            [direction]: (_a = options.distance) != null ? _a : 0,
            ...options.offset
        }
    }));
    const promise = (0, $01W3b.ref)();
    const isLoading = (0, $01W3b.computed)(()=>!!promise.value);
    const observedElement = (0, $01W3b.computed)(()=>{
        return $6ffe9515611cb489$var$resolveElement((0, $01W3b.toValue)(element));
    });
    const isElementVisible = $6ffe9515611cb489$export$6aadc312a449609d(observedElement);
    function checkAndLoad() {
        state.measure();
        if (!observedElement.value || !isElementVisible.value || !canLoadMore(observedElement.value)) return;
        const { scrollHeight: scrollHeight, clientHeight: clientHeight, scrollWidth: scrollWidth, clientWidth: clientWidth } = observedElement.value;
        const isNarrower = direction === "bottom" || direction === "top" ? scrollHeight <= clientHeight : scrollWidth <= clientWidth;
        if (state.arrivedState[direction] || isNarrower) {
            if (!promise.value) promise.value = Promise.all([
                onLoadMore(state),
                new Promise((resolve)=>setTimeout(resolve, interval))
            ]).finally(()=>{
                promise.value = null;
                (0, $TusQn.nextTick)(()=>checkAndLoad());
            });
        }
    }
    const stop = (0, $01W3b.watch)(()=>[
            state.arrivedState[direction],
            isElementVisible.value
        ], checkAndLoad, {
        immediate: true
    });
    (0, $AHHxt.tryOnUnmounted)(stop);
    return {
        isLoading: isLoading,
        reset () {
            (0, $TusQn.nextTick)(()=>checkAndLoad());
        }
    };
}
const $6ffe9515611cb489$var$defaultEvents = [
    "mousedown",
    "mouseup",
    "keydown",
    "keyup"
];
function $6ffe9515611cb489$export$2056835662f651c4(modifier, options = {}) {
    const { events: events = $6ffe9515611cb489$var$defaultEvents, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, initial: initial = null } = options;
    const state = (0, $01W3b.shallowRef)(initial);
    if (document1) events.forEach((listenerEvent)=>{
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, listenerEvent, (evt)=>{
            if (typeof evt.getModifierState === "function") state.value = evt.getModifierState(modifier);
        }, {
            passive: true
        });
    });
    return state;
}
function $6ffe9515611cb489$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    return $6ffe9515611cb489$export$95809329f49ea9f9(key, initialValue, window1 == null ? void 0 : window1.localStorage, options);
}
const $6ffe9515611cb489$export$73a678c1574e03a3 = {
    ctrl: "control",
    command: "meta",
    cmd: "meta",
    option: "alt",
    up: "arrowup",
    down: "arrowdown",
    left: "arrowleft",
    right: "arrowright"
};
function $6ffe9515611cb489$export$8805bf46e5b1d2e5(options = {}) {
    const { reactive: useReactive = false, target: target = $6ffe9515611cb489$export$16f8ba610718ae4a, aliasMap: aliasMap = $6ffe9515611cb489$export$73a678c1574e03a3, passive: passive = true, onEventFired: onEventFired = (0, $AHHxt.noop) } = options;
    const current = (0, $01W3b.reactive)(/* @__PURE__ */ new Set());
    const obj = {
        toJSON () {
            return {};
        },
        current: current
    };
    const refs = useReactive ? (0, $01W3b.reactive)(obj) : obj;
    const metaDeps = /* @__PURE__ */ new Set();
    const usedKeys = /* @__PURE__ */ new Set();
    function setRefs(key, value) {
        if (key in refs) {
            if (useReactive) refs[key] = value;
            else refs[key].value = value;
        }
    }
    function reset() {
        current.clear();
        for (const key of usedKeys)setRefs(key, false);
    }
    function updateRefs(e, value) {
        var _a, _b;
        const key = (_a = e.key) == null ? void 0 : _a.toLowerCase();
        const code = (_b = e.code) == null ? void 0 : _b.toLowerCase();
        const values = [
            code,
            key
        ].filter(Boolean);
        if (key) {
            if (value) current.add(key);
            else current.delete(key);
        }
        for (const key2 of values){
            usedKeys.add(key2);
            setRefs(key2, value);
        }
        if (key === "meta" && !value) {
            metaDeps.forEach((key2)=>{
                current.delete(key2);
                setRefs(key2, false);
            });
            metaDeps.clear();
        } else if (typeof e.getModifierState === "function" && e.getModifierState("Meta") && value) [
            ...current,
            ...values
        ].forEach((key2)=>metaDeps.add(key2));
    }
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "keydown", (e)=>{
        updateRefs(e, true);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "keyup", (e)=>{
        updateRefs(e, false);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab("blur", reset, {
        passive: passive
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab("focus", reset, {
        passive: passive
    });
    const proxy = new Proxy(refs, {
        get (target2, prop, rec) {
            if (typeof prop !== "string") return Reflect.get(target2, prop, rec);
            prop = prop.toLowerCase();
            if (prop in aliasMap) prop = aliasMap[prop];
            if (!(prop in refs)) {
                if (/[+_-]/.test(prop)) {
                    const keys = prop.split(/[+_-]/g).map((i)=>i.trim());
                    refs[prop] = (0, $01W3b.computed)(()=>keys.map((key)=>(0, $01W3b.toValue)(proxy[key])).every(Boolean));
                } else refs[prop] = (0, $01W3b.shallowRef)(false);
            }
            const r = Reflect.get(target2, prop, rec);
            return useReactive ? (0, $01W3b.toValue)(r) : r;
        }
    });
    return proxy;
}
function $6ffe9515611cb489$var$usingElRef(source, cb) {
    if ((0, $01W3b.toValue)(source)) cb((0, $01W3b.toValue)(source));
}
function $6ffe9515611cb489$var$timeRangeToArray(timeRanges) {
    let ranges = [];
    for(let i = 0; i < timeRanges.length; ++i)ranges = [
        ...ranges,
        [
            timeRanges.start(i),
            timeRanges.end(i)
        ]
    ];
    return ranges;
}
function $6ffe9515611cb489$var$tracksToArray(tracks) {
    return Array.from(tracks).map(({ label: label, kind: kind, language: language, mode: mode, activeCues: activeCues, cues: cues, inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType }, id)=>({
            id: id,
            label: label,
            kind: kind,
            language: language,
            mode: mode,
            activeCues: activeCues,
            cues: cues,
            inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType
        }));
}
const $6ffe9515611cb489$var$defaultOptions = {
    src: "",
    tracks: []
};
function $6ffe9515611cb489$export$4401816799be37c8(target, options = {}) {
    target = (0, $AHHxt.toRef)(target);
    options = {
        ...$6ffe9515611cb489$var$defaultOptions,
        ...options
    };
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const listenerOptions = {
        passive: true
    };
    const currentTime = (0, $01W3b.shallowRef)(0);
    const duration = (0, $01W3b.shallowRef)(0);
    const seeking = (0, $01W3b.shallowRef)(false);
    const volume = (0, $01W3b.shallowRef)(1);
    const waiting = (0, $01W3b.shallowRef)(false);
    const ended = (0, $01W3b.shallowRef)(false);
    const playing = (0, $01W3b.shallowRef)(false);
    const rate = (0, $01W3b.shallowRef)(1);
    const stalled = (0, $01W3b.shallowRef)(false);
    const buffered = (0, $01W3b.ref)([]);
    const tracks = (0, $01W3b.ref)([]);
    const selectedTrack = (0, $01W3b.shallowRef)(-1);
    const isPictureInPicture = (0, $01W3b.shallowRef)(false);
    const muted = (0, $01W3b.shallowRef)(false);
    const supportsPictureInPicture = document1 && "pictureInPictureEnabled" in document1;
    const sourceErrorEvent = (0, $AHHxt.createEventHook)();
    const playbackErrorEvent = (0, $AHHxt.createEventHook)();
    const disableTrack = (track)=>{
        $6ffe9515611cb489$var$usingElRef(target, (el)=>{
            if (track) {
                const id = typeof track === "number" ? track : track.id;
                el.textTracks[id].mode = "disabled";
            } else for(let i = 0; i < el.textTracks.length; ++i)el.textTracks[i].mode = "disabled";
            selectedTrack.value = -1;
        });
    };
    const enableTrack = (track, disableTracks = true)=>{
        $6ffe9515611cb489$var$usingElRef(target, (el)=>{
            const id = typeof track === "number" ? track : track.id;
            if (disableTracks) disableTrack();
            el.textTracks[id].mode = "showing";
            selectedTrack.value = id;
        });
    };
    const togglePictureInPicture = ()=>{
        return new Promise((resolve, reject)=>{
            $6ffe9515611cb489$var$usingElRef(target, async (el)=>{
                if (supportsPictureInPicture) {
                    if (!isPictureInPicture.value) el.requestPictureInPicture().then(resolve).catch(reject);
                    else document1.exitPictureInPicture().then(resolve).catch(reject);
                }
            });
        });
    };
    (0, $TusQn.watchEffect)(()=>{
        if (!document1) return;
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        const src = (0, $01W3b.toValue)(options.src);
        let sources = [];
        if (!src) return;
        if (typeof src === "string") sources = [
            {
                src: src
            }
        ];
        else if (Array.isArray(src)) sources = src;
        else if ((0, $AHHxt.isObject)(src)) sources = [
            src
        ];
        el.querySelectorAll("source").forEach((e)=>{
            e.remove();
        });
        sources.forEach(({ src: src2, type: type, media: media })=>{
            const source = document1.createElement("source");
            source.setAttribute("src", src2);
            source.setAttribute("type", type || "");
            source.setAttribute("media", media || "");
            $6ffe9515611cb489$export$7080b3e976bc91ab(source, "error", sourceErrorEvent.trigger, listenerOptions);
            el.appendChild(source);
        });
        el.load();
    });
    (0, $01W3b.watch)([
        target,
        volume
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.volume = volume.value;
    });
    (0, $01W3b.watch)([
        target,
        muted
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.muted = muted.value;
    });
    (0, $01W3b.watch)([
        target,
        rate
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.playbackRate = rate.value;
    });
    (0, $TusQn.watchEffect)(()=>{
        if (!document1) return;
        const textTracks = (0, $01W3b.toValue)(options.tracks);
        const el = (0, $01W3b.toValue)(target);
        if (!textTracks || !textTracks.length || !el) return;
        el.querySelectorAll("track").forEach((e)=>e.remove());
        textTracks.forEach(({ default: isDefault, kind: kind, label: label, src: src, srcLang: srcLang }, i)=>{
            const track = document1.createElement("track");
            track.default = isDefault || false;
            track.kind = kind;
            track.label = label;
            track.src = src;
            track.srclang = srcLang;
            if (track.default) selectedTrack.value = i;
            el.appendChild(track);
        });
    });
    const { ignoreUpdates: ignoreCurrentTimeUpdates } = (0, $AHHxt.watchIgnorable)(currentTime, (time)=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.currentTime = time;
    });
    const { ignoreUpdates: ignorePlayingUpdates } = (0, $AHHxt.watchIgnorable)(playing, (isPlaying)=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        if (isPlaying) el.play().catch((e)=>{
            playbackErrorEvent.trigger(e);
            throw e;
        });
        else el.pause();
    });
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "timeupdate", ()=>ignoreCurrentTimeUpdates(()=>currentTime.value = (0, $01W3b.toValue)(target).currentTime), listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "durationchange", ()=>duration.value = (0, $01W3b.toValue)(target).duration, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "progress", ()=>buffered.value = $6ffe9515611cb489$var$timeRangeToArray((0, $01W3b.toValue)(target).buffered), listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "seeking", ()=>seeking.value = true, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "seeked", ()=>seeking.value = false, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
        "waiting",
        "loadstart"
    ], ()=>{
        waiting.value = true;
        ignorePlayingUpdates(()=>playing.value = false);
    }, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "loadeddata", ()=>waiting.value = false, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "playing", ()=>{
        waiting.value = false;
        ended.value = false;
        ignorePlayingUpdates(()=>playing.value = true);
    }, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "ratechange", ()=>rate.value = (0, $01W3b.toValue)(target).playbackRate, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "stalled", ()=>stalled.value = true, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "ended", ()=>ended.value = true, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pause", ()=>ignorePlayingUpdates(()=>playing.value = false), listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "play", ()=>ignorePlayingUpdates(()=>playing.value = true), listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "enterpictureinpicture", ()=>isPictureInPicture.value = true, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "leavepictureinpicture", ()=>isPictureInPicture.value = false, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "volumechange", ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        volume.value = el.volume;
        muted.value = el.muted;
    }, listenerOptions);
    const listeners = [];
    const stop = (0, $01W3b.watch)([
        target
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        stop();
        listeners[0] = $6ffe9515611cb489$export$7080b3e976bc91ab(el.textTracks, "addtrack", ()=>tracks.value = $6ffe9515611cb489$var$tracksToArray(el.textTracks), listenerOptions);
        listeners[1] = $6ffe9515611cb489$export$7080b3e976bc91ab(el.textTracks, "removetrack", ()=>tracks.value = $6ffe9515611cb489$var$tracksToArray(el.textTracks), listenerOptions);
        listeners[2] = $6ffe9515611cb489$export$7080b3e976bc91ab(el.textTracks, "change", ()=>tracks.value = $6ffe9515611cb489$var$tracksToArray(el.textTracks), listenerOptions);
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>listeners.forEach((listener)=>listener()));
    return {
        currentTime: currentTime,
        duration: duration,
        waiting: waiting,
        seeking: seeking,
        ended: ended,
        stalled: stalled,
        buffered: buffered,
        playing: playing,
        rate: rate,
        volume: // Volume
        volume,
        muted: muted,
        tracks: // Tracks
        tracks,
        selectedTrack: selectedTrack,
        enableTrack: enableTrack,
        disableTrack: disableTrack,
        supportsPictureInPicture: // Picture in Picture
        supportsPictureInPicture,
        togglePictureInPicture: togglePictureInPicture,
        isPictureInPicture: isPictureInPicture,
        // Events
        onSourceError: sourceErrorEvent.on,
        onPlaybackError: playbackErrorEvent.on
    };
}
function $6ffe9515611cb489$export$7403ef0fca9c6367(resolver, options) {
    const initCache = ()=>{
        if (options == null ? void 0 : options.cache) return (0, $01W3b.shallowReactive)(options.cache);
        return (0, $01W3b.shallowReactive)(/* @__PURE__ */ new Map());
    };
    const cache = initCache();
    const generateKey = (...args)=>(options == null ? void 0 : options.getKey) ? options.getKey(...args) : JSON.stringify(args);
    const _loadData = (key, ...args)=>{
        cache.set(key, resolver(...args));
        return cache.get(key);
    };
    const loadData = (...args)=>_loadData(generateKey(...args), ...args);
    const deleteData = (...args)=>{
        cache.delete(generateKey(...args));
    };
    const clearData = ()=>{
        cache.clear();
    };
    const memoized = (...args)=>{
        const key = generateKey(...args);
        if (cache.has(key)) return cache.get(key);
        return _loadData(key, ...args);
    };
    memoized.load = loadData;
    memoized.delete = deleteData;
    memoized.clear = clearData;
    memoized.generateKey = generateKey;
    memoized.cache = cache;
    return memoized;
}
function $6ffe9515611cb489$export$b1c8a28243292cb9(options = {}) {
    const memory = (0, $01W3b.ref)();
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>typeof performance !== "undefined" && "memory" in performance);
    if (isSupported.value) {
        const { interval: interval = 1e3 } = options;
        (0, $AHHxt.useIntervalFn)(()=>{
            memory.value = performance.memory;
        }, interval, {
            immediate: options.immediate,
            immediateCallback: options.immediateCallback
        });
    }
    return {
        isSupported: isSupported,
        memory: memory
    };
}
const $6ffe9515611cb489$var$UseMouseBuiltinExtractors = {
    page: (event)=>[
            event.pageX,
            event.pageY
        ],
    client: (event)=>[
            event.clientX,
            event.clientY
        ],
    screen: (event)=>[
            event.screenX,
            event.screenY
        ],
    movement: (event)=>event instanceof MouseEvent ? [
            event.movementX,
            event.movementY
        ] : null
};
function $6ffe9515611cb489$export$70811b4970b0f258(options = {}) {
    const { type: type = "page", touch: touch = true, resetOnTouchEnds: resetOnTouchEnds = false, initialValue: initialValue = {
        x: 0,
        y: 0
    }, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, target: target = window1, scroll: scroll = true, eventFilter: eventFilter } = options;
    let _prevMouseEvent = null;
    let _prevScrollX = 0;
    let _prevScrollY = 0;
    const x = (0, $01W3b.shallowRef)(initialValue.x);
    const y = (0, $01W3b.shallowRef)(initialValue.y);
    const sourceType = (0, $01W3b.shallowRef)(null);
    const extractor = typeof type === "function" ? type : $6ffe9515611cb489$var$UseMouseBuiltinExtractors[type];
    const mouseHandler = (event)=>{
        const result = extractor(event);
        _prevMouseEvent = event;
        if (result) {
            [x.value, y.value] = result;
            sourceType.value = "mouse";
        }
        if (window1) {
            _prevScrollX = window1.scrollX;
            _prevScrollY = window1.scrollY;
        }
    };
    const touchHandler = (event)=>{
        if (event.touches.length > 0) {
            const result = extractor(event.touches[0]);
            if (result) {
                [x.value, y.value] = result;
                sourceType.value = "touch";
            }
        }
    };
    const scrollHandler = ()=>{
        if (!_prevMouseEvent || !window1) return;
        const pos = extractor(_prevMouseEvent);
        if (_prevMouseEvent instanceof MouseEvent && pos) {
            x.value = pos[0] + window1.scrollX - _prevScrollX;
            y.value = pos[1] + window1.scrollY - _prevScrollY;
        }
    };
    const reset = ()=>{
        x.value = initialValue.x;
        y.value = initialValue.y;
    };
    const mouseHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>mouseHandler(event), {}) : (event)=>mouseHandler(event);
    const touchHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>touchHandler(event), {}) : (event)=>touchHandler(event);
    const scrollHandlerWrapper = eventFilter ? ()=>eventFilter(()=>scrollHandler(), {}) : ()=>scrollHandler();
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
            "mousemove",
            "dragover"
        ], mouseHandlerWrapper, listenerOptions);
        if (touch && type !== "movement") {
            $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
                "touchstart",
                "touchmove"
            ], touchHandlerWrapper, listenerOptions);
            if (resetOnTouchEnds) $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchend", reset, listenerOptions);
        }
        if (scroll && type === "page") $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "scroll", scrollHandlerWrapper, listenerOptions);
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType
    };
}
function $6ffe9515611cb489$export$74acb291b8ceb4b8(target, options = {}) {
    const { handleOutside: handleOutside = true, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const type = options.type || "page";
    const { x: x, y: y, sourceType: sourceType } = $6ffe9515611cb489$export$70811b4970b0f258(options);
    const targetRef = (0, $01W3b.shallowRef)(target != null ? target : window1 == null ? void 0 : window1.document.body);
    const elementX = (0, $01W3b.shallowRef)(0);
    const elementY = (0, $01W3b.shallowRef)(0);
    const elementPositionX = (0, $01W3b.shallowRef)(0);
    const elementPositionY = (0, $01W3b.shallowRef)(0);
    const elementHeight = (0, $01W3b.shallowRef)(0);
    const elementWidth = (0, $01W3b.shallowRef)(0);
    const isOutside = (0, $01W3b.shallowRef)(true);
    let stop = ()=>{};
    if (window1) {
        stop = (0, $01W3b.watch)([
            targetRef,
            x,
            y
        ], ()=>{
            const el = $6ffe9515611cb489$export$c61124d3cf5adbae(targetRef);
            if (!el || !(el instanceof Element)) return;
            const { left: left, top: top, width: width, height: height } = el.getBoundingClientRect();
            elementPositionX.value = left + (type === "page" ? window1.pageXOffset : 0);
            elementPositionY.value = top + (type === "page" ? window1.pageYOffset : 0);
            elementHeight.value = height;
            elementWidth.value = width;
            const elX = x.value - elementPositionX.value;
            const elY = y.value - elementPositionY.value;
            isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
            if (handleOutside || !isOutside.value) {
                elementX.value = elX;
                elementY.value = elY;
            }
        }, {
            immediate: true
        });
        $6ffe9515611cb489$export$7080b3e976bc91ab(document, "mouseleave", ()=>isOutside.value = true, {
            passive: true
        });
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType,
        elementX: elementX,
        elementY: elementY,
        elementPositionX: elementPositionX,
        elementPositionY: elementPositionY,
        elementHeight: elementHeight,
        elementWidth: elementWidth,
        isOutside: isOutside,
        stop: stop
    };
}
function $6ffe9515611cb489$export$5d7a2a40c559277c(options = {}) {
    const { touch: touch = true, drag: drag = true, capture: capture = false, initialValue: initialValue = false, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const pressed = (0, $01W3b.shallowRef)(initialValue);
    const sourceType = (0, $01W3b.shallowRef)(null);
    if (!window1) return {
        pressed: pressed,
        sourceType: sourceType
    };
    const onPressed = (srcType)=>(event)=>{
            var _a;
            pressed.value = true;
            sourceType.value = srcType;
            (_a = options.onPressed) == null || _a.call(options, event);
        };
    const onReleased = (event)=>{
        var _a;
        pressed.value = false;
        sourceType.value = null;
        (_a = options.onReleased) == null || _a.call(options, event);
    };
    const target = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$c61124d3cf5adbae(options.target) || window1);
    const listenerOptions = {
        passive: true,
        capture: capture
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(target, "mousedown", onPressed("mouse"), listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "mouseleave", onReleased, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "mouseup", onReleased, listenerOptions);
    if (drag) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "dragstart", onPressed("mouse"), listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "drop", onReleased, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "dragend", onReleased, listenerOptions);
    }
    if (touch) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchstart", onPressed("touch"), listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "touchend", onReleased, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "touchcancel", onReleased, listenerOptions);
    }
    return {
        pressed: pressed,
        sourceType: sourceType
    };
}
function $6ffe9515611cb489$export$64fd3a716d6bb70f(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const navigator1 = window1 == null ? void 0 : window1.navigator;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "language" in navigator1);
    const language = (0, $01W3b.shallowRef)(navigator1 == null ? void 0 : navigator1.language);
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        if (navigator1) language.value = navigator1.language;
    }, {
        passive: true
    });
    return {
        isSupported: isSupported,
        language: language
    };
}
function $6ffe9515611cb489$export$553aaf59afc1a2d8(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const navigator1 = window1 == null ? void 0 : window1.navigator;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "connection" in navigator1);
    const isOnline = (0, $01W3b.shallowRef)(true);
    const saveData = (0, $01W3b.shallowRef)(false);
    const offlineAt = (0, $01W3b.shallowRef)(void 0);
    const onlineAt = (0, $01W3b.shallowRef)(void 0);
    const downlink = (0, $01W3b.shallowRef)(void 0);
    const downlinkMax = (0, $01W3b.shallowRef)(void 0);
    const rtt = (0, $01W3b.shallowRef)(void 0);
    const effectiveType = (0, $01W3b.shallowRef)(void 0);
    const type = (0, $01W3b.shallowRef)("unknown");
    const connection = isSupported.value && navigator1.connection;
    function updateNetworkInformation() {
        if (!navigator1) return;
        isOnline.value = navigator1.onLine;
        offlineAt.value = isOnline.value ? void 0 : Date.now();
        onlineAt.value = isOnline.value ? Date.now() : void 0;
        if (connection) {
            downlink.value = connection.downlink;
            downlinkMax.value = connection.downlinkMax;
            effectiveType.value = connection.effectiveType;
            rtt.value = connection.rtt;
            saveData.value = connection.saveData;
            type.value = connection.type;
        }
    }
    const listenerOptions = {
        passive: true
    };
    if (window1) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "offline", ()=>{
            isOnline.value = false;
            offlineAt.value = Date.now();
        }, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "online", ()=>{
            isOnline.value = true;
            onlineAt.value = Date.now();
        }, listenerOptions);
    }
    if (connection) $6ffe9515611cb489$export$7080b3e976bc91ab(connection, "change", updateNetworkInformation, listenerOptions);
    updateNetworkInformation();
    return {
        isSupported: isSupported,
        isOnline: (0, $01W3b.readonly)(isOnline),
        saveData: (0, $01W3b.readonly)(saveData),
        offlineAt: (0, $01W3b.readonly)(offlineAt),
        onlineAt: (0, $01W3b.readonly)(onlineAt),
        downlink: (0, $01W3b.readonly)(downlink),
        downlinkMax: (0, $01W3b.readonly)(downlinkMax),
        effectiveType: (0, $01W3b.readonly)(effectiveType),
        rtt: (0, $01W3b.readonly)(rtt),
        type: (0, $01W3b.readonly)(type)
    };
}
function $6ffe9515611cb489$export$3a404aece3dff2fa(options = {}) {
    const { controls: exposeControls = false, interval: interval = "requestAnimationFrame" } = options;
    const now = (0, $01W3b.ref)(/* @__PURE__ */ new Date());
    const update = ()=>now.value = /* @__PURE__ */ new Date();
    const controls = interval === "requestAnimationFrame" ? $6ffe9515611cb489$export$13251e0fc79284e(update, {
        immediate: true
    }) : (0, $AHHxt.useIntervalFn)(update, interval, {
        immediate: true
    });
    if (exposeControls) return {
        now: now,
        ...controls
    };
    else return now;
}
function $6ffe9515611cb489$export$533619a63360a89b(object) {
    const url = (0, $01W3b.shallowRef)();
    const release = ()=>{
        if (url.value) URL.revokeObjectURL(url.value);
        url.value = void 0;
    };
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(object), (newObject)=>{
        release();
        if (newObject) url.value = URL.createObjectURL(newObject);
    }, {
        immediate: true
    });
    (0, $AHHxt.tryOnScopeDispose)(release);
    return (0, $01W3b.readonly)(url);
}
function $6ffe9515611cb489$var$useClamp(value, min, max) {
    if (typeof value === "function" || (0, $01W3b.isReadonly)(value)) return (0, $01W3b.computed)(()=>(0, $AHHxt.clamp)((0, $01W3b.toValue)(value), (0, $01W3b.toValue)(min), (0, $01W3b.toValue)(max)));
    const _value = (0, $01W3b.ref)(value);
    return (0, $01W3b.computed)({
        get () {
            return _value.value = (0, $AHHxt.clamp)(_value.value, (0, $01W3b.toValue)(min), (0, $01W3b.toValue)(max));
        },
        set (value2) {
            _value.value = (0, $AHHxt.clamp)(value2, (0, $01W3b.toValue)(min), (0, $01W3b.toValue)(max));
        }
    });
}
function $6ffe9515611cb489$export$dca1841098f618ea(options) {
    const { total: total = Number.POSITIVE_INFINITY, pageSize: pageSize = 10, page: page = 1, onPageChange: onPageChange = (0, $AHHxt.noop), onPageSizeChange: onPageSizeChange = (0, $AHHxt.noop), onPageCountChange: onPageCountChange = (0, $AHHxt.noop) } = options;
    const currentPageSize = $6ffe9515611cb489$var$useClamp(pageSize, 1, Number.POSITIVE_INFINITY);
    const pageCount = (0, $01W3b.computed)(()=>Math.max(1, Math.ceil((0, $01W3b.toValue)(total) / (0, $01W3b.toValue)(currentPageSize))));
    const currentPage = $6ffe9515611cb489$var$useClamp(page, 1, pageCount);
    const isFirstPage = (0, $01W3b.computed)(()=>currentPage.value === 1);
    const isLastPage = (0, $01W3b.computed)(()=>currentPage.value === pageCount.value);
    if ((0, $01W3b.isRef)(page)) (0, $AHHxt.syncRef)(page, currentPage, {
        direction: (0, $01W3b.isReadonly)(page) ? "ltr" : "both"
    });
    if ((0, $01W3b.isRef)(pageSize)) (0, $AHHxt.syncRef)(pageSize, currentPageSize, {
        direction: (0, $01W3b.isReadonly)(pageSize) ? "ltr" : "both"
    });
    function prev() {
        currentPage.value--;
    }
    function next() {
        currentPage.value++;
    }
    const returnValue = {
        currentPage: currentPage,
        currentPageSize: currentPageSize,
        pageCount: pageCount,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        prev: prev,
        next: next
    };
    (0, $01W3b.watch)(currentPage, ()=>{
        onPageChange((0, $01W3b.reactive)(returnValue));
    });
    (0, $01W3b.watch)(currentPageSize, ()=>{
        onPageSizeChange((0, $01W3b.reactive)(returnValue));
    });
    (0, $01W3b.watch)(pageCount, ()=>{
        onPageCountChange((0, $01W3b.reactive)(returnValue));
    });
    return returnValue;
}
function $6ffe9515611cb489$export$6feb6ada280bcdab(options = {}) {
    const { isOnline: isOnline } = $6ffe9515611cb489$export$553aaf59afc1a2d8(options);
    return isOnline;
}
function $6ffe9515611cb489$export$6bd1f37e929013e5(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isLeft = (0, $01W3b.shallowRef)(false);
    const handler = (event)=>{
        if (!window1) return;
        event = event || window1.event;
        const from = event.relatedTarget || event.toElement;
        isLeft.value = !from;
    };
    if (window1) {
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "mouseout", handler, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1.document, "mouseleave", handler, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(window1.document, "mouseenter", handler, listenerOptions);
    }
    return isLeft;
}
function $6ffe9515611cb489$export$588695585364abce(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "screen" in window1 && "orientation" in window1.screen);
    const screenOrientation = isSupported.value ? window1.screen.orientation : {};
    const orientation = (0, $01W3b.ref)(screenOrientation.type);
    const angle = (0, $01W3b.shallowRef)(screenOrientation.angle || 0);
    if (isSupported.value) $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "orientationchange", ()=>{
        orientation.value = screenOrientation.type;
        angle.value = screenOrientation.angle;
    }, {
        passive: true
    });
    const lockOrientation = (type)=>{
        if (isSupported.value && typeof screenOrientation.lock === "function") return screenOrientation.lock(type);
        return Promise.reject(new Error("Not supported"));
    };
    const unlockOrientation = ()=>{
        if (isSupported.value && typeof screenOrientation.unlock === "function") screenOrientation.unlock();
    };
    return {
        isSupported: isSupported,
        orientation: orientation,
        angle: angle,
        lockOrientation: lockOrientation,
        unlockOrientation: unlockOrientation
    };
}
function $6ffe9515611cb489$export$78dabaa73e04c89f(target, options = {}) {
    const { deviceOrientationTiltAdjust: deviceOrientationTiltAdjust = (i)=>i, deviceOrientationRollAdjust: deviceOrientationRollAdjust = (i)=>i, mouseTiltAdjust: mouseTiltAdjust = (i)=>i, mouseRollAdjust: mouseRollAdjust = (i)=>i, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const orientation = (0, $01W3b.reactive)($6ffe9515611cb489$export$9bafe4f626b63a33({
        window: window1
    }));
    const screenOrientation = (0, $01W3b.reactive)($6ffe9515611cb489$export$588695585364abce({
        window: window1
    }));
    const { elementX: x, elementY: y, elementWidth: width, elementHeight: height } = $6ffe9515611cb489$export$74acb291b8ceb4b8(target, {
        handleOutside: false,
        window: window1
    });
    const source = (0, $01W3b.computed)(()=>{
        if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) return "deviceOrientation";
        return "mouse";
    });
    const roll = (0, $01W3b.computed)(()=>{
        if (source.value === "deviceOrientation") {
            let value;
            switch(screenOrientation.orientation){
                case "landscape-primary":
                    value = orientation.gamma / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.gamma / 90;
                    break;
                case "portrait-primary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-secondary":
                    value = orientation.beta / 90;
                    break;
                default:
                    value = -orientation.beta / 90;
            }
            return deviceOrientationRollAdjust(value);
        } else {
            const value = -(y.value - height.value / 2) / height.value;
            return mouseRollAdjust(value);
        }
    });
    const tilt = (0, $01W3b.computed)(()=>{
        if (source.value === "deviceOrientation") {
            let value;
            switch(screenOrientation.orientation){
                case "landscape-primary":
                    value = orientation.beta / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-primary":
                    value = orientation.gamma / 90;
                    break;
                case "portrait-secondary":
                    value = -orientation.gamma / 90;
                    break;
                default:
                    value = orientation.gamma / 90;
            }
            return deviceOrientationTiltAdjust(value);
        } else {
            const value = (x.value - width.value / 2) / width.value;
            return mouseTiltAdjust(value);
        }
    });
    return {
        roll: roll,
        tilt: tilt,
        source: source
    };
}
function $6ffe9515611cb489$export$868ba98d0a4efc6f(element = $6ffe9515611cb489$export$8d937a32bc2b31dd()) {
    const parentElement = (0, $01W3b.shallowRef)();
    const update = ()=>{
        const el = $6ffe9515611cb489$export$c61124d3cf5adbae(element);
        if (el) parentElement.value = el.parentElement;
    };
    (0, $AHHxt.tryOnMounted)(update);
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(element), update);
    return parentElement;
}
function $6ffe9515611cb489$export$d3d061a08d0fe848(options, callback) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, immediate: immediate = true, ...performanceOptions } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>window1 && "PerformanceObserver" in window1);
    let observer;
    const stop = ()=>{
        observer == null || observer.disconnect();
    };
    const start = ()=>{
        if (isSupported.value) {
            stop();
            observer = new PerformanceObserver(callback);
            observer.observe(performanceOptions);
        }
    };
    (0, $AHHxt.tryOnScopeDispose)(stop);
    if (immediate) start();
    return {
        isSupported: isSupported,
        start: start,
        stop: stop
    };
}
const $6ffe9515611cb489$var$defaultState = {
    x: 0,
    y: 0,
    pointerId: 0,
    pressure: 0,
    tiltX: 0,
    tiltY: 0,
    width: 0,
    height: 0,
    twist: 0,
    pointerType: null
};
const $6ffe9515611cb489$var$keys = /* @__PURE__ */ Object.keys($6ffe9515611cb489$var$defaultState);
function $6ffe9515611cb489$export$a6d851f32526772(options = {}) {
    const { target: target = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const isInside = (0, $01W3b.shallowRef)(false);
    const state = (0, $01W3b.ref)(options.initialValue || {});
    Object.assign(state.value, $6ffe9515611cb489$var$defaultState, state.value);
    const handler = (event)=>{
        isInside.value = true;
        if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType)) return;
        state.value = (0, $AHHxt.objectPick)(event, $6ffe9515611cb489$var$keys, false);
    };
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
            "pointerdown",
            "pointermove",
            "pointerup"
        ], handler, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointerleave", ()=>isInside.value = false, listenerOptions);
    }
    return {
        ...(0, $AHHxt.toRefs)(state),
        isInside: isInside
    };
}
function $6ffe9515611cb489$export$fc4b89f039a97947(target, options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>document1 && "pointerLockElement" in document1);
    const element = (0, $01W3b.shallowRef)();
    const triggerElement = (0, $01W3b.shallowRef)();
    let targetElement;
    if (isSupported.value) {
        const listenerOptions = {
            passive: true
        };
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "pointerlockchange", ()=>{
            var _a;
            const currentElement = (_a = document1.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                element.value = document1.pointerLockElement;
                if (!element.value) targetElement = triggerElement.value = null;
            }
        }, listenerOptions);
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "pointerlockerror", ()=>{
            var _a;
            const currentElement = (_a = document1.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                const action = document1.pointerLockElement ? "release" : "acquire";
                throw new Error(`Failed to ${action} pointer lock.`);
            }
        }, listenerOptions);
    }
    async function lock(e) {
        var _a;
        if (!isSupported.value) throw new Error("Pointer Lock API is not supported by your browser.");
        triggerElement.value = e instanceof Event ? e.currentTarget : null;
        targetElement = e instanceof Event ? (_a = $6ffe9515611cb489$export$c61124d3cf5adbae(target)) != null ? _a : triggerElement.value : $6ffe9515611cb489$export$c61124d3cf5adbae(e);
        if (!targetElement) throw new Error("Target element undefined.");
        targetElement.requestPointerLock();
        return await (0, $AHHxt.until)(element).toBe(targetElement);
    }
    async function unlock() {
        if (!element.value) return false;
        document1.exitPointerLock();
        await (0, $AHHxt.until)(element).toBeNull();
        return true;
    }
    return {
        isSupported: isSupported,
        element: element,
        triggerElement: triggerElement,
        lock: lock,
        unlock: unlock
    };
}
function $6ffe9515611cb489$export$abaee32ee49963c1(target, options = {}) {
    const targetRef = (0, $AHHxt.toRef)(target);
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, disableTextSelect: disableTextSelect = false } = options;
    const posStart = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const updatePosStart = (x, y)=>{
        posStart.x = x;
        posStart.y = y;
    };
    const posEnd = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const updatePosEnd = (x, y)=>{
        posEnd.x = x;
        posEnd.y = y;
    };
    const distanceX = (0, $01W3b.computed)(()=>posStart.x - posEnd.x);
    const distanceY = (0, $01W3b.computed)(()=>posStart.y - posEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $01W3b.computed)(()=>max(abs(distanceX.value), abs(distanceY.value)) >= threshold);
    const isSwiping = (0, $01W3b.shallowRef)(false);
    const isPointerDown = (0, $01W3b.shallowRef)(false);
    const direction = (0, $01W3b.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(distanceX.value) > abs(distanceY.value)) return distanceX.value > 0 ? "left" : "right";
        else return distanceY.value > 0 ? "up" : "down";
    });
    const eventIsAllowed = (e)=>{
        var _a, _b, _c;
        const isReleasingButton = e.buttons === 0;
        const isPrimaryButton = e.buttons === 1;
        return (_c = (_b = (_a = options.pointerTypes) == null ? void 0 : _a.includes(e.pointerType)) != null ? _b : isReleasingButton || isPrimaryButton) != null ? _c : true;
    };
    const listenerOptions = {
        passive: true
    };
    const stops = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointerdown", (e)=>{
            if (!eventIsAllowed(e)) return;
            isPointerDown.value = true;
            const eventTarget = e.target;
            eventTarget == null || eventTarget.setPointerCapture(e.pointerId);
            const { clientX: x, clientY: y } = e;
            updatePosStart(x, y);
            updatePosEnd(x, y);
            onSwipeStart == null || onSwipeStart(e);
        }, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointermove", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (!isPointerDown.value) return;
            const { clientX: x, clientY: y } = e;
            updatePosEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe == null || onSwipe(e);
        }, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "pointerup", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (isSwiping.value) onSwipeEnd == null || onSwipeEnd(e, direction.value);
            isPointerDown.value = false;
            isSwiping.value = false;
        }, listenerOptions)
    ];
    (0, $AHHxt.tryOnMounted)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null || _b.setProperty("touch-action", "none");
        if (disableTextSelect) {
            (_d = (_c = targetRef.value) == null ? void 0 : _c.style) == null || _d.setProperty("-webkit-user-select", "none");
            (_f = (_e = targetRef.value) == null ? void 0 : _e.style) == null || _f.setProperty("-ms-user-select", "none");
            (_h = (_g = targetRef.value) == null ? void 0 : _g.style) == null || _h.setProperty("user-select", "none");
        }
    });
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isSwiping: (0, $01W3b.readonly)(isSwiping),
        direction: (0, $01W3b.readonly)(direction),
        posStart: (0, $01W3b.readonly)(posStart),
        posEnd: (0, $01W3b.readonly)(posEnd),
        distanceX: distanceX,
        distanceY: distanceY,
        stop: stop
    };
}
function $6ffe9515611cb489$export$7c3b8f854ca5e941(options) {
    const isLight = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-color-scheme: light)", options);
    const isDark = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
    return (0, $01W3b.computed)(()=>{
        if (isDark.value) return "dark";
        if (isLight.value) return "light";
        return "no-preference";
    });
}
function $6ffe9515611cb489$export$14fe172294a7a184(options) {
    const isMore = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-contrast: more)", options);
    const isLess = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-contrast: less)", options);
    const isCustom = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-contrast: custom)", options);
    return (0, $01W3b.computed)(()=>{
        if (isMore.value) return "more";
        if (isLess.value) return "less";
        if (isCustom.value) return "custom";
        return "no-preference";
    });
}
function $6ffe9515611cb489$export$408b11bf0000ced3(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.ref)([
        "en"
    ]);
    const navigator1 = window1.navigator;
    const value = (0, $01W3b.ref)(navigator1.languages);
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        value.value = navigator1.languages;
    }, {
        passive: true
    });
    return value;
}
function $6ffe9515611cb489$export$66a8176c0ff6800c(options) {
    const isReduced = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-reduced-motion: reduce)", options);
    return (0, $01W3b.computed)(()=>{
        if (isReduced.value) return "reduce";
        return "no-preference";
    });
}
function $6ffe9515611cb489$export$d9ef768c38bc7027(options) {
    const isReduced = $6ffe9515611cb489$export$32d5543ab307c01("(prefers-reduced-transparency: reduce)", options);
    return (0, $01W3b.computed)(()=>{
        if (isReduced.value) return "reduce";
        return "no-preference";
    });
}
function $6ffe9515611cb489$export$5cae361ad82dce8b(value, initialValue) {
    const previous = (0, $01W3b.shallowRef)(initialValue);
    (0, $01W3b.watch)((0, $AHHxt.toRef)(value), (_, oldValue)=>{
        previous.value = oldValue;
    }, {
        flush: "sync"
    });
    return (0, $01W3b.readonly)(previous);
}
const $6ffe9515611cb489$var$topVarName = "--vueuse-safe-area-top";
const $6ffe9515611cb489$var$rightVarName = "--vueuse-safe-area-right";
const $6ffe9515611cb489$var$bottomVarName = "--vueuse-safe-area-bottom";
const $6ffe9515611cb489$var$leftVarName = "--vueuse-safe-area-left";
function $6ffe9515611cb489$export$40dfca171e090791() {
    const top = (0, $01W3b.shallowRef)("");
    const right = (0, $01W3b.shallowRef)("");
    const bottom = (0, $01W3b.shallowRef)("");
    const left = (0, $01W3b.shallowRef)("");
    if (0, $AHHxt.isClient) {
        const topCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$topVarName);
        const rightCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$rightVarName);
        const bottomCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$bottomVarName);
        const leftCssVar = $6ffe9515611cb489$export$811e58a9be6ff112($6ffe9515611cb489$var$leftVarName);
        topCssVar.value = "env(safe-area-inset-top, 0px)";
        rightCssVar.value = "env(safe-area-inset-right, 0px)";
        bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
        leftCssVar.value = "env(safe-area-inset-left, 0px)";
        update();
        $6ffe9515611cb489$export$7080b3e976bc91ab("resize", (0, $AHHxt.useDebounceFn)(update), {
            passive: true
        });
    }
    function update() {
        top.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$topVarName);
        right.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$rightVarName);
        bottom.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$bottomVarName);
        left.value = $6ffe9515611cb489$var$getValue($6ffe9515611cb489$var$leftVarName);
    }
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        update: update
    };
}
function $6ffe9515611cb489$var$getValue(position) {
    return getComputedStyle(document.documentElement).getPropertyValue(position);
}
function $6ffe9515611cb489$export$eac342b7cdc4d8de(src, onLoaded = (0, $AHHxt.noop), options = {}) {
    const { immediate: immediate = true, manual: manual = false, type: type = "text/javascript", async: async = true, crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, noModule: noModule, defer: defer, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, attrs: attrs = {} } = options;
    const scriptTag = (0, $01W3b.shallowRef)(null);
    let _promise = null;
    const loadScript = (waitForScriptLoad)=>new Promise((resolve, reject)=>{
            const resolveWithElement = (el2)=>{
                scriptTag.value = el2;
                resolve(el2);
                return el2;
            };
            if (!document1) {
                resolve(false);
                return;
            }
            let shouldAppend = false;
            let el = document1.querySelector(`script[src="${(0, $01W3b.toValue)(src)}"]`);
            if (!el) {
                el = document1.createElement("script");
                el.type = type;
                el.async = async;
                el.src = (0, $01W3b.toValue)(src);
                if (defer) el.defer = defer;
                if (crossOrigin) el.crossOrigin = crossOrigin;
                if (noModule) el.noModule = noModule;
                if (referrerPolicy) el.referrerPolicy = referrerPolicy;
                Object.entries(attrs).forEach(([name, value])=>el == null ? void 0 : el.setAttribute(name, value));
                shouldAppend = true;
            } else if (el.hasAttribute("data-loaded")) resolveWithElement(el);
            const listenerOptions = {
                passive: true
            };
            $6ffe9515611cb489$export$7080b3e976bc91ab(el, "error", (event)=>reject(event), listenerOptions);
            $6ffe9515611cb489$export$7080b3e976bc91ab(el, "abort", (event)=>reject(event), listenerOptions);
            $6ffe9515611cb489$export$7080b3e976bc91ab(el, "load", ()=>{
                el.setAttribute("data-loaded", "true");
                onLoaded(el);
                resolveWithElement(el);
            }, listenerOptions);
            if (shouldAppend) el = document1.head.appendChild(el);
            if (!waitForScriptLoad) resolveWithElement(el);
        });
    const load = (waitForScriptLoad = true)=>{
        if (!_promise) _promise = loadScript(waitForScriptLoad);
        return _promise;
    };
    const unload = ()=>{
        if (!document1) return;
        _promise = null;
        if (scriptTag.value) scriptTag.value = null;
        const el = document1.querySelector(`script[src="${(0, $01W3b.toValue)(src)}"]`);
        if (el) document1.head.removeChild(el);
    };
    if (immediate && !manual) (0, $AHHxt.tryOnMounted)(load);
    if (!manual) (0, $AHHxt.tryOnUnmounted)(unload);
    return {
        scriptTag: scriptTag,
        load: load,
        unload: unload
    };
}
function $6ffe9515611cb489$var$checkOverflowScroll(ele) {
    const style = window.getComputedStyle(ele);
    if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) return true;
    else {
        const parent = ele.parentNode;
        if (!parent || parent.tagName === "BODY") return false;
        return $6ffe9515611cb489$var$checkOverflowScroll(parent);
    }
}
function $6ffe9515611cb489$var$preventDefault(rawEvent) {
    const e = rawEvent || window.event;
    const _target = e.target;
    if ($6ffe9515611cb489$var$checkOverflowScroll(_target)) return false;
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
}
const $6ffe9515611cb489$var$elInitialOverflow = /* @__PURE__ */ new WeakMap();
function $6ffe9515611cb489$export$e47ba1b900da5d3b(element, initialState = false) {
    const isLocked = (0, $01W3b.shallowRef)(initialState);
    let stopTouchMoveListener = null;
    let initialOverflow = "";
    (0, $01W3b.watch)((0, $AHHxt.toRef)(element), (el)=>{
        const target = $6ffe9515611cb489$var$resolveElement((0, $01W3b.toValue)(el));
        if (target) {
            const ele = target;
            if (!$6ffe9515611cb489$var$elInitialOverflow.get(ele)) $6ffe9515611cb489$var$elInitialOverflow.set(ele, ele.style.overflow);
            if (ele.style.overflow !== "hidden") initialOverflow = ele.style.overflow;
            if (ele.style.overflow === "hidden") return isLocked.value = true;
            if (isLocked.value) return ele.style.overflow = "hidden";
        }
    }, {
        immediate: true
    });
    const lock = ()=>{
        const el = $6ffe9515611cb489$var$resolveElement((0, $01W3b.toValue)(element));
        if (!el || isLocked.value) return;
        if (0, $AHHxt.isIOS) stopTouchMoveListener = $6ffe9515611cb489$export$7080b3e976bc91ab(el, "touchmove", (e)=>{
            $6ffe9515611cb489$var$preventDefault(e);
        }, {
            passive: false
        });
        el.style.overflow = "hidden";
        isLocked.value = true;
    };
    const unlock = ()=>{
        const el = $6ffe9515611cb489$var$resolveElement((0, $01W3b.toValue)(element));
        if (!el || !isLocked.value) return;
        if (0, $AHHxt.isIOS) stopTouchMoveListener == null || stopTouchMoveListener();
        el.style.overflow = initialOverflow;
        $6ffe9515611cb489$var$elInitialOverflow.delete(el);
        isLocked.value = false;
    };
    (0, $AHHxt.tryOnScopeDispose)(unlock);
    return (0, $01W3b.computed)({
        get () {
            return isLocked.value;
        },
        set (v) {
            if (v) lock();
            else unlock();
        }
    });
}
function $6ffe9515611cb489$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    return $6ffe9515611cb489$export$95809329f49ea9f9(key, initialValue, window1 == null ? void 0 : window1.sessionStorage, options);
}
function $6ffe9515611cb489$export$96a35531d1008427(shareOptions = {}, options = {}) {
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const _navigator = navigator1;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>_navigator && "canShare" in _navigator);
    const share = async (overrideOptions = {})=>{
        if (isSupported.value) {
            const data = {
                ...(0, $01W3b.toValue)(shareOptions),
                ...(0, $01W3b.toValue)(overrideOptions)
            };
            let granted = true;
            if (data.files && _navigator.canShare) granted = _navigator.canShare({
                files: data.files
            });
            if (granted) return _navigator.share(data);
        }
    };
    return {
        isSupported: isSupported,
        share: share
    };
}
const $6ffe9515611cb489$var$defaultSortFn = (source, compareFn)=>source.sort(compareFn);
const $6ffe9515611cb489$var$defaultCompare = (a, b)=>a - b;
function $6ffe9515611cb489$export$a4fc6b60896f06a0(...args) {
    var _a, _b, _c, _d;
    const [source] = args;
    let compareFn = $6ffe9515611cb489$var$defaultCompare;
    let options = {};
    if (args.length === 2) {
        if (typeof args[1] === "object") {
            options = args[1];
            compareFn = (_a = options.compareFn) != null ? _a : $6ffe9515611cb489$var$defaultCompare;
        } else compareFn = (_b = args[1]) != null ? _b : $6ffe9515611cb489$var$defaultCompare;
    } else if (args.length > 2) {
        compareFn = (_c = args[1]) != null ? _c : $6ffe9515611cb489$var$defaultCompare;
        options = (_d = args[2]) != null ? _d : {};
    }
    const { dirty: dirty = false, sortFn: sortFn = $6ffe9515611cb489$var$defaultSortFn } = options;
    if (!dirty) return (0, $01W3b.computed)(()=>sortFn([
            ...(0, $01W3b.toValue)(source)
        ], compareFn));
    (0, $TusQn.watchEffect)(()=>{
        const result = sortFn((0, $01W3b.toValue)(source), compareFn);
        if ((0, $01W3b.isRef)(source)) source.value = result;
        else source.splice(0, source.length, ...result);
    });
    return source;
}
function $6ffe9515611cb489$export$b2a8ce41ccd863a1(options = {}) {
    const { interimResults: interimResults = true, continuous: continuous = true, maxAlternatives: maxAlternatives = 1, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const lang = (0, $AHHxt.toRef)(options.lang || "en-US");
    const isListening = (0, $01W3b.shallowRef)(false);
    const isFinal = (0, $01W3b.shallowRef)(false);
    const result = (0, $01W3b.shallowRef)("");
    const error = (0, $01W3b.shallowRef)(void 0);
    let recognition;
    const start = ()=>{
        isListening.value = true;
    };
    const stop = ()=>{
        isListening.value = false;
    };
    const toggle = (value = !isListening.value)=>{
        if (value) start();
        else stop();
    };
    const SpeechRecognition = window1 && (window1.SpeechRecognition || window1.webkitSpeechRecognition);
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>SpeechRecognition);
    if (isSupported.value) {
        recognition = new SpeechRecognition();
        recognition.continuous = continuous;
        recognition.interimResults = interimResults;
        recognition.lang = (0, $01W3b.toValue)(lang);
        recognition.maxAlternatives = maxAlternatives;
        recognition.onstart = ()=>{
            isListening.value = true;
            isFinal.value = false;
        };
        (0, $01W3b.watch)(lang, (lang2)=>{
            if (recognition && !isListening.value) recognition.lang = lang2;
        });
        recognition.onresult = (event)=>{
            const currentResult = event.results[event.resultIndex];
            const { transcript: transcript } = currentResult[0];
            isFinal.value = currentResult.isFinal;
            result.value = transcript;
            error.value = void 0;
        };
        recognition.onerror = (event)=>{
            error.value = event;
        };
        recognition.onend = ()=>{
            isListening.value = false;
            recognition.lang = (0, $01W3b.toValue)(lang);
        };
        (0, $01W3b.watch)(isListening, (newValue, oldValue)=>{
            if (newValue === oldValue) return;
            if (newValue) recognition.start();
            else recognition.stop();
        });
    }
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        stop();
    });
    return {
        isSupported: isSupported,
        isListening: isListening,
        isFinal: isFinal,
        recognition: recognition,
        result: result,
        error: error,
        toggle: toggle,
        start: start,
        stop: stop
    };
}
function $6ffe9515611cb489$export$44e311196d9d3623(text, options = {}) {
    const { pitch: pitch = 1, rate: rate = 1, volume: volume = 1, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const synth = window1 && window1.speechSynthesis;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>synth);
    const isPlaying = (0, $01W3b.shallowRef)(false);
    const status = (0, $01W3b.shallowRef)("init");
    const spokenText = (0, $AHHxt.toRef)(text || "");
    const lang = (0, $AHHxt.toRef)(options.lang || "en-US");
    const error = (0, $01W3b.shallowRef)(void 0);
    const toggle = (value = !isPlaying.value)=>{
        isPlaying.value = value;
    };
    const bindEventsForUtterance = (utterance2)=>{
        utterance2.lang = (0, $01W3b.toValue)(lang);
        utterance2.voice = (0, $01W3b.toValue)(options.voice) || null;
        utterance2.pitch = (0, $01W3b.toValue)(pitch);
        utterance2.rate = (0, $01W3b.toValue)(rate);
        utterance2.volume = volume;
        utterance2.onstart = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onpause = ()=>{
            isPlaying.value = false;
            status.value = "pause";
        };
        utterance2.onresume = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onend = ()=>{
            isPlaying.value = false;
            status.value = "end";
        };
        utterance2.onerror = (event)=>{
            error.value = event;
        };
    };
    const utterance = (0, $01W3b.computed)(()=>{
        isPlaying.value = false;
        status.value = "init";
        const newUtterance = new SpeechSynthesisUtterance(spokenText.value);
        bindEventsForUtterance(newUtterance);
        return newUtterance;
    });
    const speak = ()=>{
        synth.cancel();
        if (utterance) synth.speak(utterance.value);
    };
    const stop = ()=>{
        synth.cancel();
        isPlaying.value = false;
    };
    if (isSupported.value) {
        bindEventsForUtterance(utterance.value);
        (0, $01W3b.watch)(lang, (lang2)=>{
            if (utterance.value && !isPlaying.value) utterance.value.lang = lang2;
        });
        if (options.voice) (0, $01W3b.watch)(options.voice, ()=>{
            synth.cancel();
        });
        (0, $01W3b.watch)(isPlaying, ()=>{
            if (isPlaying.value) synth.resume();
            else synth.pause();
        });
    }
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        isPlaying.value = false;
    });
    return {
        isSupported: isSupported,
        isPlaying: isPlaying,
        status: status,
        utterance: utterance,
        error: error,
        stop: stop,
        toggle: toggle,
        speak: speak
    };
}
function $6ffe9515611cb489$export$9378619b14945e16(steps, initialStep) {
    const stepsRef = (0, $01W3b.ref)(steps);
    const stepNames = (0, $01W3b.computed)(()=>Array.isArray(stepsRef.value) ? stepsRef.value : Object.keys(stepsRef.value));
    const index = (0, $01W3b.ref)(stepNames.value.indexOf(initialStep != null ? initialStep : stepNames.value[0]));
    const current = (0, $01W3b.computed)(()=>at(index.value));
    const isFirst = (0, $01W3b.computed)(()=>index.value === 0);
    const isLast = (0, $01W3b.computed)(()=>index.value === stepNames.value.length - 1);
    const next = (0, $01W3b.computed)(()=>stepNames.value[index.value + 1]);
    const previous = (0, $01W3b.computed)(()=>stepNames.value[index.value - 1]);
    function at(index2) {
        if (Array.isArray(stepsRef.value)) return stepsRef.value[index2];
        return stepsRef.value[stepNames.value[index2]];
    }
    function get(step) {
        if (!stepNames.value.includes(step)) return;
        return at(stepNames.value.indexOf(step));
    }
    function goTo(step) {
        if (stepNames.value.includes(step)) index.value = stepNames.value.indexOf(step);
    }
    function goToNext() {
        if (isLast.value) return;
        index.value++;
    }
    function goToPrevious() {
        if (isFirst.value) return;
        index.value--;
    }
    function goBackTo(step) {
        if (isAfter(step)) goTo(step);
    }
    function isNext(step) {
        return stepNames.value.indexOf(step) === index.value + 1;
    }
    function isPrevious(step) {
        return stepNames.value.indexOf(step) === index.value - 1;
    }
    function isCurrent(step) {
        return stepNames.value.indexOf(step) === index.value;
    }
    function isBefore(step) {
        return index.value < stepNames.value.indexOf(step);
    }
    function isAfter(step) {
        return index.value > stepNames.value.indexOf(step);
    }
    return {
        steps: stepsRef,
        stepNames: stepNames,
        index: index,
        current: current,
        next: next,
        previous: previous,
        isFirst: isFirst,
        isLast: isLast,
        at: at,
        get: get,
        goTo: goTo,
        goToNext: goToNext,
        goToPrevious: goToPrevious,
        goBackTo: goBackTo,
        isNext: isNext,
        isPrevious: isPrevious,
        isCurrent: isCurrent,
        isBefore: isBefore,
        isAfter: isAfter
    };
}
function $6ffe9515611cb489$export$dd72d4318fe38e17(key, initialValue, storage, options = {}) {
    var _a;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    } } = options;
    const rawInit = (0, $01W3b.toValue)(initialValue);
    const type = $6ffe9515611cb489$var$guessSerializerType(rawInit);
    const data = (shallow ? (0, $01W3b.shallowRef) : (0, $01W3b.ref))((0, $01W3b.toValue)(initialValue));
    const serializer = (_a = options.serializer) != null ? _a : $6ffe9515611cb489$export$8111877b006f9b0b[type];
    if (!storage) try {
        storage = $6ffe9515611cb489$export$b0cf1ae5a98eb83b("getDefaultStorageAsync", ()=>{
            var _a2;
            return (_a2 = $6ffe9515611cb489$export$16f8ba610718ae4a) == null ? void 0 : _a2.localStorage;
        })();
    } catch (e) {
        onError(e);
    }
    async function read(event) {
        if (!storage || event && event.key !== key) return;
        try {
            const rawValue = event ? event.newValue : await storage.getItem(key);
            if (rawValue == null) {
                data.value = rawInit;
                if (writeDefaults && rawInit !== null) await storage.setItem(key, await serializer.write(rawInit));
            } else if (mergeDefaults) {
                const value = await serializer.read(rawValue);
                if (typeof mergeDefaults === "function") data.value = mergeDefaults(value, rawInit);
                else if (type === "object" && !Array.isArray(value)) data.value = {
                    ...rawInit,
                    ...value
                };
                else data.value = value;
            } else data.value = await serializer.read(rawValue);
        } catch (e) {
            onError(e);
        }
    }
    read();
    if (window1 && listenToStorageChanges) $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "storage", (e)=>Promise.resolve().then(()=>read(e)), {
        passive: true
    });
    if (storage) (0, $AHHxt.watchWithFilter)(data, async ()=>{
        try {
            if (data.value == null) await storage.removeItem(key);
            else await storage.setItem(key, await serializer.write(data.value));
        } catch (e) {
            onError(e);
        }
    }, {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    return data;
}
let $6ffe9515611cb489$var$_id = 0;
function $6ffe9515611cb489$export$c100116e6aa85030(css, options = {}) {
    const isLoaded = (0, $01W3b.shallowRef)(false);
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, immediate: immediate = true, manual: manual = false, id: id = `vueuse_styletag_${++$6ffe9515611cb489$var$_id}` } = options;
    const cssRef = (0, $01W3b.shallowRef)(css);
    let stop = ()=>{};
    const load = ()=>{
        if (!document1) return;
        const el = document1.getElementById(id) || document1.createElement("style");
        if (!el.isConnected) {
            el.id = id;
            if (options.media) el.media = options.media;
            document1.head.appendChild(el);
        }
        if (isLoaded.value) return;
        stop = (0, $01W3b.watch)(cssRef, (value)=>{
            el.textContent = value;
        }, {
            immediate: true
        });
        isLoaded.value = true;
    };
    const unload = ()=>{
        if (!document1 || !isLoaded.value) return;
        stop();
        document1.head.removeChild(document1.getElementById(id));
        isLoaded.value = false;
    };
    if (immediate && !manual) (0, $AHHxt.tryOnMounted)(load);
    if (!manual) (0, $AHHxt.tryOnScopeDispose)(unload);
    return {
        id: id,
        css: cssRef,
        unload: unload,
        load: load,
        isLoaded: (0, $01W3b.readonly)(isLoaded)
    };
}
function $6ffe9515611cb489$export$b57f07e22c950716(target, options = {}) {
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, passive: passive = true } = options;
    const coordsStart = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const coordsEnd = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const diffX = (0, $01W3b.computed)(()=>coordsStart.x - coordsEnd.x);
    const diffY = (0, $01W3b.computed)(()=>coordsStart.y - coordsEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $01W3b.computed)(()=>max(abs(diffX.value), abs(diffY.value)) >= threshold);
    const isSwiping = (0, $01W3b.shallowRef)(false);
    const direction = (0, $01W3b.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(diffX.value) > abs(diffY.value)) return diffX.value > 0 ? "left" : "right";
        else return diffY.value > 0 ? "up" : "down";
    });
    const getTouchEventCoords = (e)=>[
            e.touches[0].clientX,
            e.touches[0].clientY
        ];
    const updateCoordsStart = (x, y)=>{
        coordsStart.x = x;
        coordsStart.y = y;
    };
    const updateCoordsEnd = (x, y)=>{
        coordsEnd.x = x;
        coordsEnd.y = y;
    };
    const listenerOptions = {
        passive: passive,
        capture: !passive
    };
    const onTouchEnd = (e)=>{
        if (isSwiping.value) onSwipeEnd == null || onSwipeEnd(e, direction.value);
        isSwiping.value = false;
    };
    const stops = [
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchstart", (e)=>{
            if (e.touches.length !== 1) return;
            const [x, y] = getTouchEventCoords(e);
            updateCoordsStart(x, y);
            updateCoordsEnd(x, y);
            onSwipeStart == null || onSwipeStart(e);
        }, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, "touchmove", (e)=>{
            if (e.touches.length !== 1) return;
            const [x, y] = getTouchEventCoords(e);
            updateCoordsEnd(x, y);
            if (listenerOptions.capture && !listenerOptions.passive && Math.abs(diffX.value) > Math.abs(diffY.value)) e.preventDefault();
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe == null || onSwipe(e);
        }, listenerOptions),
        $6ffe9515611cb489$export$7080b3e976bc91ab(target, [
            "touchend",
            "touchcancel"
        ], onTouchEnd, listenerOptions)
    ];
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isSwiping: isSwiping,
        direction: direction,
        coordsStart: coordsStart,
        coordsEnd: coordsEnd,
        lengthX: diffX,
        lengthY: diffY,
        stop: stop,
        // TODO: Remove in the next major version
        isPassiveEventSupported: true
    };
}
function $6ffe9515611cb489$export$253c1ef7895b3fea() {
    const refs = (0, $01W3b.ref)([]);
    refs.value.set = (el)=>{
        if (el) refs.value.push(el);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        refs.value.length = 0;
    });
    return refs;
}
function $6ffe9515611cb489$export$cf24a79f32f45545(options = {}) {
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, selector: selector = "html", observe: observe = false, initialValue: initialValue = "ltr" } = options;
    function getValue() {
        var _a, _b;
        return (_b = (_a = document1 == null ? void 0 : document1.querySelector(selector)) == null ? void 0 : _a.getAttribute("dir")) != null ? _b : initialValue;
    }
    const dir = (0, $01W3b.ref)(getValue());
    (0, $AHHxt.tryOnMounted)(()=>dir.value = getValue());
    if (observe && document1) $6ffe9515611cb489$export$8ecdcf3bb089e9cd(document1.querySelector(selector), ()=>dir.value = getValue(), {
        attributes: true
    });
    return (0, $01W3b.computed)({
        get () {
            return dir.value;
        },
        set (v) {
            var _a, _b;
            dir.value = v;
            if (!document1) return;
            if (dir.value) (_a = document1.querySelector(selector)) == null || _a.setAttribute("dir", dir.value);
            else (_b = document1.querySelector(selector)) == null || _b.removeAttribute("dir");
        }
    });
}
function $6ffe9515611cb489$var$getRangesFromSelection(selection) {
    var _a;
    const rangeCount = (_a = selection.rangeCount) != null ? _a : 0;
    return Array.from({
        length: rangeCount
    }, (_, i)=>selection.getRangeAt(i));
}
function $6ffe9515611cb489$export$9c9cf404b65a1c0a(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const selection = (0, $01W3b.ref)(null);
    const text = (0, $01W3b.computed)(()=>{
        var _a, _b;
        return (_b = (_a = selection.value) == null ? void 0 : _a.toString()) != null ? _b : "";
    });
    const ranges = (0, $01W3b.computed)(()=>selection.value ? $6ffe9515611cb489$var$getRangesFromSelection(selection.value) : []);
    const rects = (0, $01W3b.computed)(()=>ranges.value.map((range)=>range.getBoundingClientRect()));
    function onSelectionChange() {
        selection.value = null;
        if (window1) selection.value = window1.getSelection();
    }
    if (window1) $6ffe9515611cb489$export$7080b3e976bc91ab(window1.document, "selectionchange", onSelectionChange, {
        passive: true
    });
    return {
        text: text,
        rects: rects,
        ranges: ranges,
        selection: selection
    };
}
function $6ffe9515611cb489$var$tryRequestAnimationFrame(window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, fn) {
    if (window1 && typeof window1.requestAnimationFrame === "function") window1.requestAnimationFrame(fn);
    else fn();
}
function $6ffe9515611cb489$export$2e9ef3b733cccd07(options = {}) {
    var _a, _b;
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const textarea = (0, $AHHxt.toRef)(options == null ? void 0 : options.element);
    const input = (0, $AHHxt.toRef)((_a = options == null ? void 0 : options.input) != null ? _a : "");
    const styleProp = (_b = options == null ? void 0 : options.styleProp) != null ? _b : "height";
    const textareaScrollHeight = (0, $01W3b.shallowRef)(1);
    const textareaOldWidth = (0, $01W3b.shallowRef)(0);
    function triggerResize() {
        var _a2;
        if (!textarea.value) return;
        let height = "";
        textarea.value.style[styleProp] = "1px";
        textareaScrollHeight.value = (_a2 = textarea.value) == null ? void 0 : _a2.scrollHeight;
        const _styleTarget = (0, $01W3b.toValue)(options == null ? void 0 : options.styleTarget);
        if (_styleTarget) _styleTarget.style[styleProp] = `${textareaScrollHeight.value}px`;
        else height = `${textareaScrollHeight.value}px`;
        textarea.value.style[styleProp] = height;
    }
    (0, $01W3b.watch)([
        input,
        textarea
    ], ()=>(0, $TusQn.nextTick)(triggerResize), {
        immediate: true
    });
    (0, $01W3b.watch)(textareaScrollHeight, ()=>{
        var _a2;
        return (_a2 = options == null ? void 0 : options.onResize) == null ? void 0 : _a2.call(options);
    });
    $6ffe9515611cb489$export$683480f191c0e3ea(textarea, ([{ contentRect: contentRect }])=>{
        if (textareaOldWidth.value === contentRect.width) return;
        $6ffe9515611cb489$var$tryRequestAnimationFrame(window1, ()=>{
            textareaOldWidth.value = contentRect.width;
            triggerResize();
        });
    });
    if (options == null ? void 0 : options.watch) (0, $01W3b.watch)(options.watch, triggerResize, {
        immediate: true,
        deep: true
    });
    return {
        textarea: textarea,
        input: input,
        triggerResize: triggerResize
    };
}
function $6ffe9515611cb489$export$55673c2843562e1(source, options = {}) {
    const { throttle: throttle = 200, trailing: trailing = true } = options;
    const filter = (0, $AHHxt.throttleFilter)(throttle, trailing);
    const history = $6ffe9515611cb489$export$de889b39e422efc4(source, {
        ...options,
        eventFilter: filter
    });
    return {
        ...history
    };
}
const $6ffe9515611cb489$var$DEFAULT_UNITS = [
    {
        max: 6e4,
        value: 1e3,
        name: "second"
    },
    {
        max: 276e4,
        value: 6e4,
        name: "minute"
    },
    {
        max: 72e6,
        value: 36e5,
        name: "hour"
    },
    {
        max: 5184e5,
        value: 864e5,
        name: "day"
    },
    {
        max: 24192e5,
        value: 6048e5,
        name: "week"
    },
    {
        max: 28512e6,
        value: 2592e6,
        name: "month"
    },
    {
        max: Number.POSITIVE_INFINITY,
        value: 31536e6,
        name: "year"
    }
];
const $6ffe9515611cb489$var$DEFAULT_MESSAGES = {
    justNow: "just now",
    past: (n)=>n.match(/\d/) ? `${n} ago` : n,
    future: (n)=>n.match(/\d/) ? `in ${n}` : n,
    month: (n, past)=>n === 1 ? past ? "last month" : "next month" : `${n} month${n > 1 ? "s" : ""}`,
    year: (n, past)=>n === 1 ? past ? "last year" : "next year" : `${n} year${n > 1 ? "s" : ""}`,
    day: (n, past)=>n === 1 ? past ? "yesterday" : "tomorrow" : `${n} day${n > 1 ? "s" : ""}`,
    week: (n, past)=>n === 1 ? past ? "last week" : "next week" : `${n} week${n > 1 ? "s" : ""}`,
    hour: (n)=>`${n} hour${n > 1 ? "s" : ""}`,
    minute: (n)=>`${n} minute${n > 1 ? "s" : ""}`,
    second: (n)=>`${n} second${n > 1 ? "s" : ""}`,
    invalid: ""
};
function $6ffe9515611cb489$var$DEFAULT_FORMATTER(date) {
    return date.toISOString().slice(0, 10);
}
function $6ffe9515611cb489$export$1deeb1050525eb40(time, options = {}) {
    const { controls: exposeControls = false, updateInterval: updateInterval = 3e4 } = options;
    const { now: now, ...controls } = $6ffe9515611cb489$export$3a404aece3dff2fa({
        interval: updateInterval,
        controls: true
    });
    const timeAgo = (0, $01W3b.computed)(()=>$6ffe9515611cb489$export$78ae3e68d8c394bc(new Date((0, $01W3b.toValue)(time)), options, (0, $01W3b.toValue)(now)));
    if (exposeControls) return {
        timeAgo: timeAgo,
        ...controls
    };
    else return timeAgo;
}
function $6ffe9515611cb489$export$78ae3e68d8c394bc(from, options = {}, now = Date.now()) {
    var _a;
    const { max: max, messages: messages = $6ffe9515611cb489$var$DEFAULT_MESSAGES, fullDateFormatter: fullDateFormatter = $6ffe9515611cb489$var$DEFAULT_FORMATTER, units: units = $6ffe9515611cb489$var$DEFAULT_UNITS, showSecond: showSecond = false, rounding: rounding = "round" } = options;
    const roundFn = typeof rounding === "number" ? (n)=>+n.toFixed(rounding) : Math[rounding];
    const diff = +now - +from;
    const absDiff = Math.abs(diff);
    function getValue(diff2, unit) {
        return roundFn(Math.abs(diff2) / unit.value);
    }
    function format(diff2, unit) {
        const val = getValue(diff2, unit);
        const past = diff2 > 0;
        const str = applyFormat(unit.name, val, past);
        return applyFormat(past ? "past" : "future", str, past);
    }
    function applyFormat(name, val, isPast) {
        const formatter = messages[name];
        if (typeof formatter === "function") return formatter(val, isPast);
        return formatter.replace("{0}", val.toString());
    }
    if (absDiff < 6e4 && !showSecond) return messages.justNow;
    if (typeof max === "number" && absDiff > max) return fullDateFormatter(new Date(from));
    if (typeof max === "string") {
        const unitMax = (_a = units.find((i)=>i.name === max)) == null ? void 0 : _a.max;
        if (unitMax && absDiff > unitMax) return fullDateFormatter(new Date(from));
    }
    for (const [idx, unit] of units.entries()){
        const val = getValue(diff, unit);
        if (val <= 0 && units[idx - 1]) return format(diff, units[idx - 1]);
        if (absDiff < unit.max) return format(diff, unit);
    }
    return messages.invalid;
}
function $6ffe9515611cb489$export$ce370d3d38ed4da0(fn, interval, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    const { start: start } = (0, $AHHxt.useTimeoutFn)(loop, interval, {
        immediate: immediate
    });
    const isActive = (0, $01W3b.shallowRef)(false);
    async function loop() {
        if (!isActive.value) return;
        await fn();
        start();
    }
    function resume() {
        if (!isActive.value) {
            isActive.value = true;
            if (immediateCallback) fn();
            start();
        }
    }
    function pause() {
        isActive.value = false;
    }
    if (immediate && (0, $AHHxt.isClient)) resume();
    (0, $AHHxt.tryOnScopeDispose)(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $6ffe9515611cb489$export$c4f6efe9f19a3a66(options = {}) {
    const { controls: exposeControls = false, offset: offset = 0, immediate: immediate = true, interval: interval = "requestAnimationFrame", callback: callback } = options;
    const ts = (0, $01W3b.shallowRef)((0, $AHHxt.timestamp)() + offset);
    const update = ()=>ts.value = (0, $AHHxt.timestamp)() + offset;
    const cb = callback ? ()=>{
        update();
        callback(ts.value);
    } : update;
    const controls = interval === "requestAnimationFrame" ? $6ffe9515611cb489$export$13251e0fc79284e(cb, {
        immediate: immediate
    }) : (0, $AHHxt.useIntervalFn)(cb, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        timestamp: ts,
        ...controls
    };
    else return ts;
}
function $6ffe9515611cb489$export$bc98e171e8c82a3d(newTitle = null, options = {}) {
    var _a, _b, _c;
    const { document: document1 = $6ffe9515611cb489$export$37990bd438d16af3, restoreOnUnmount: restoreOnUnmount = (t)=>t } = options;
    const originalTitle = (_a = document1 == null ? void 0 : document1.title) != null ? _a : "";
    const title = (0, $AHHxt.toRef)((_b = newTitle != null ? newTitle : document1 == null ? void 0 : document1.title) != null ? _b : null);
    const isReadonly = !!(newTitle && typeof newTitle === "function");
    function format(t) {
        if (!("titleTemplate" in options)) return t;
        const template = options.titleTemplate || "%s";
        return typeof template === "function" ? template(t) : (0, $01W3b.toValue)(template).replace(/%s/g, t);
    }
    (0, $01W3b.watch)(title, (newValue, oldValue)=>{
        if (newValue !== oldValue && document1) document1.title = format(newValue != null ? newValue : "");
    }, {
        immediate: true
    });
    if (options.observe && !options.titleTemplate && document1 && !isReadonly) $6ffe9515611cb489$export$8ecdcf3bb089e9cd((_c = document1.head) == null ? void 0 : _c.querySelector("title"), ()=>{
        if (document1 && document1.title !== title.value) title.value = format(document1.title);
    }, {
        childList: true
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        if (restoreOnUnmount) {
            const restoredTitle = restoreOnUnmount(originalTitle, title.value || "");
            if (restoredTitle != null && document1) document1.title = restoredTitle;
        }
    });
    return title;
}
const $6ffe9515611cb489$var$_TransitionPresets = {
    easeInSine: [
        0.12,
        0,
        0.39,
        0
    ],
    easeOutSine: [
        0.61,
        1,
        0.88,
        1
    ],
    easeInOutSine: [
        0.37,
        0,
        0.63,
        1
    ],
    easeInQuad: [
        0.11,
        0,
        0.5,
        0
    ],
    easeOutQuad: [
        0.5,
        1,
        0.89,
        1
    ],
    easeInOutQuad: [
        0.45,
        0,
        0.55,
        1
    ],
    easeInCubic: [
        0.32,
        0,
        0.67,
        0
    ],
    easeOutCubic: [
        0.33,
        1,
        0.68,
        1
    ],
    easeInOutCubic: [
        0.65,
        0,
        0.35,
        1
    ],
    easeInQuart: [
        0.5,
        0,
        0.75,
        0
    ],
    easeOutQuart: [
        0.25,
        1,
        0.5,
        1
    ],
    easeInOutQuart: [
        0.76,
        0,
        0.24,
        1
    ],
    easeInQuint: [
        0.64,
        0,
        0.78,
        0
    ],
    easeOutQuint: [
        0.22,
        1,
        0.36,
        1
    ],
    easeInOutQuint: [
        0.83,
        0,
        0.17,
        1
    ],
    easeInExpo: [
        0.7,
        0,
        0.84,
        0
    ],
    easeOutExpo: [
        0.16,
        1,
        0.3,
        1
    ],
    easeInOutExpo: [
        0.87,
        0,
        0.13,
        1
    ],
    easeInCirc: [
        0.55,
        0,
        1,
        0.45
    ],
    easeOutCirc: [
        0,
        0.55,
        0.45,
        1
    ],
    easeInOutCirc: [
        0.85,
        0,
        0.15,
        1
    ],
    easeInBack: [
        0.36,
        0,
        0.66,
        -0.56
    ],
    easeOutBack: [
        0.34,
        1.56,
        0.64,
        1
    ],
    easeInOutBack: [
        0.68,
        -0.6,
        0.32,
        1.6
    ]
};
const $6ffe9515611cb489$export$a1745a8bb687f918 = /* @__PURE__ */ Object.assign({}, {
    linear: (0, $AHHxt.identity)
}, $6ffe9515611cb489$var$_TransitionPresets);
function $6ffe9515611cb489$var$createEasingFunction([p0, p1, p2, p3]) {
    const a = (a1, a2)=>1 - 3 * a2 + 3 * a1;
    const b = (a1, a2)=>3 * a2 - 6 * a1;
    const c = (a1)=>3 * a1;
    const calcBezier = (t, a1, a2)=>((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
    const getSlope = (t, a1, a2)=>3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
    const getTforX = (x)=>{
        let aGuessT = x;
        for(let i = 0; i < 4; ++i){
            const currentSlope = getSlope(aGuessT, p0, p2);
            if (currentSlope === 0) return aGuessT;
            const currentX = calcBezier(aGuessT, p0, p2) - x;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    return (x)=>p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3);
}
function $6ffe9515611cb489$var$lerp(a, b, alpha) {
    return a + alpha * (b - a);
}
function $6ffe9515611cb489$var$toVec(t) {
    return (typeof t === "number" ? [
        t
    ] : t) || [];
}
function $6ffe9515611cb489$export$b82f7b6c1e4d2890(source, from, to, options = {}) {
    var _a, _b;
    const fromVal = (0, $01W3b.toValue)(from);
    const toVal = (0, $01W3b.toValue)(to);
    const v1 = $6ffe9515611cb489$var$toVec(fromVal);
    const v2 = $6ffe9515611cb489$var$toVec(toVal);
    const duration = (_a = (0, $01W3b.toValue)(options.duration)) != null ? _a : 1e3;
    const startedAt = Date.now();
    const endAt = Date.now() + duration;
    const trans = typeof options.transition === "function" ? options.transition : (_b = (0, $01W3b.toValue)(options.transition)) != null ? _b : (0, $AHHxt.identity);
    const ease = typeof trans === "function" ? trans : $6ffe9515611cb489$var$createEasingFunction(trans);
    return new Promise((resolve)=>{
        source.value = fromVal;
        const tick = ()=>{
            var _a2;
            if ((_a2 = options.abort) == null ? void 0 : _a2.call(options)) {
                resolve();
                return;
            }
            const now = Date.now();
            const alpha = ease((now - startedAt) / duration);
            const arr = $6ffe9515611cb489$var$toVec(source.value).map((n, i)=>$6ffe9515611cb489$var$lerp(v1[i], v2[i], alpha));
            if (Array.isArray(source.value)) source.value = arr.map((n, i)=>{
                var _a3, _b2;
                return $6ffe9515611cb489$var$lerp((_a3 = v1[i]) != null ? _a3 : 0, (_b2 = v2[i]) != null ? _b2 : 0, alpha);
            });
            else if (typeof source.value === "number") source.value = arr[0];
            if (now < endAt) requestAnimationFrame(tick);
            else {
                source.value = toVal;
                resolve();
            }
        };
        tick();
    });
}
function $6ffe9515611cb489$export$7b286972b8d8ccbf(source, options = {}) {
    let currentId = 0;
    const sourceVal = ()=>{
        const v = (0, $01W3b.toValue)(source);
        return typeof v === "number" ? v : v.map((0, $01W3b.toValue));
    };
    const outputRef = (0, $01W3b.ref)(sourceVal());
    (0, $01W3b.watch)(sourceVal, async (to)=>{
        var _a, _b;
        if ((0, $01W3b.toValue)(options.disabled)) return;
        const id = ++currentId;
        if (options.delay) await (0, $AHHxt.promiseTimeout)((0, $01W3b.toValue)(options.delay));
        if (id !== currentId) return;
        const toVal = Array.isArray(to) ? to.map((0, $01W3b.toValue)) : (0, $01W3b.toValue)(to);
        (_a = options.onStarted) == null || _a.call(options);
        await $6ffe9515611cb489$export$b82f7b6c1e4d2890(outputRef, outputRef.value, toVal, {
            ...options,
            abort: ()=>{
                var _a2;
                return id !== currentId || ((_a2 = options.abort) == null ? void 0 : _a2.call(options));
            }
        });
        (_b = options.onFinished) == null || _b.call(options);
    }, {
        deep: true
    });
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(options.disabled), (disabled)=>{
        if (disabled) {
            currentId++;
            outputRef.value = sourceVal();
        }
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        currentId++;
    });
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(options.disabled) ? sourceVal() : outputRef.value);
}
function $6ffe9515611cb489$export$a64580081d23e3b8(mode = "history", options = {}) {
    const { initialValue: initialValue = {}, removeNullishValues: removeNullishValues = true, removeFalsyValues: removeFalsyValues = false, write: enableWrite = true, writeMode: writeMode = "replace", window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.reactive)(initialValue);
    const state = (0, $01W3b.reactive)({});
    function getRawParams() {
        if (mode === "history") return window1.location.search || "";
        else if (mode === "hash") {
            const hash = window1.location.hash || "";
            const index = hash.indexOf("?");
            return index > 0 ? hash.slice(index) : "";
        } else return (window1.location.hash || "").replace(/^#/, "");
    }
    function constructQuery(params) {
        const stringified = params.toString();
        if (mode === "history") return `${stringified ? `?${stringified}` : ""}${window1.location.hash || ""}`;
        if (mode === "hash-params") return `${window1.location.search || ""}${stringified ? `#${stringified}` : ""}`;
        const hash = window1.location.hash || "#";
        const index = hash.indexOf("?");
        if (index > 0) return `${window1.location.search || ""}${hash.slice(0, index)}${stringified ? `?${stringified}` : ""}`;
        return `${window1.location.search || ""}${hash}${stringified ? `?${stringified}` : ""}`;
    }
    function read() {
        return new URLSearchParams(getRawParams());
    }
    function updateState(params) {
        const unusedKeys = new Set(Object.keys(state));
        for (const key of params.keys()){
            const paramsForKey = params.getAll(key);
            state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
            unusedKeys.delete(key);
        }
        Array.from(unusedKeys).forEach((key)=>delete state[key]);
    }
    const { pause: pause, resume: resume } = (0, $AHHxt.pausableWatch)(state, ()=>{
        const params = new URLSearchParams("");
        Object.keys(state).forEach((key)=>{
            const mapEntry = state[key];
            if (Array.isArray(mapEntry)) mapEntry.forEach((value)=>params.append(key, value));
            else if (removeNullishValues && mapEntry == null) params.delete(key);
            else if (removeFalsyValues && !mapEntry) params.delete(key);
            else params.set(key, mapEntry);
        });
        write(params, false);
    }, {
        deep: true
    });
    function write(params, shouldUpdate) {
        pause();
        if (shouldUpdate) updateState(params);
        if (writeMode === "replace") window1.history.replaceState(window1.history.state, window1.document.title, window1.location.pathname + constructQuery(params));
        else window1.history.pushState(window1.history.state, window1.document.title, window1.location.pathname + constructQuery(params));
        resume();
    }
    function onChanged() {
        if (!enableWrite) return;
        write(read(), true);
    }
    const listenerOptions = {
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "popstate", onChanged, listenerOptions);
    if (mode !== "history") $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "hashchange", onChanged, listenerOptions);
    const initial = read();
    if (initial.keys().next().value) updateState(initial);
    else Object.assign(state, initialValue);
    return state;
}
function $6ffe9515611cb489$export$a16ee9849ed85b4e(options = {}) {
    var _a, _b;
    const enabled = (0, $01W3b.shallowRef)((_a = options.enabled) != null ? _a : false);
    const autoSwitch = (0, $01W3b.shallowRef)((_b = options.autoSwitch) != null ? _b : true);
    const constraints = (0, $01W3b.ref)(options.constraints);
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>{
        var _a2;
        return (_a2 = navigator1 == null ? void 0 : navigator1.mediaDevices) == null ? void 0 : _a2.getUserMedia;
    });
    const stream = (0, $01W3b.shallowRef)();
    function getDeviceOptions(type) {
        switch(type){
            case "video":
                if (constraints.value) return constraints.value.video || false;
                break;
            case "audio":
                if (constraints.value) return constraints.value.audio || false;
                break;
        }
    }
    async function _start() {
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator1.mediaDevices.getUserMedia({
            video: getDeviceOptions("video"),
            audio: getDeviceOptions("audio")
        });
        return stream.value;
    }
    function _stop() {
        var _a2;
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    async function restart() {
        _stop();
        return await start();
    }
    (0, $01W3b.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    (0, $01W3b.watch)(constraints, ()=>{
        if (autoSwitch.value && stream.value) restart();
    }, {
        immediate: true
    });
    (0, $AHHxt.tryOnScopeDispose)(()=>{
        stop();
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        restart: restart,
        constraints: constraints,
        enabled: enabled,
        autoSwitch: autoSwitch
    };
}
function $6ffe9515611cb489$export$42662bab1b538e5(props, key, emit, options = {}) {
    var _a, _b, _c;
    const { clone: clone = false, passive: passive = false, eventName: eventName, deep: deep = false, defaultValue: defaultValue, shouldEmit: shouldEmit } = options;
    const vm = (0, $TusQn.getCurrentInstance)();
    const _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
    let event = eventName;
    if (!key) key = "modelValue";
    event = event || `update:${key.toString()}`;
    const cloneFn = (val)=>!clone ? val : typeof clone === "function" ? clone(val) : $6ffe9515611cb489$export$9e72043f8ff3a3df(val);
    const getValue = ()=>(0, $AHHxt.isDef)(props[key]) ? cloneFn(props[key]) : defaultValue;
    const triggerEmit = (value)=>{
        if (shouldEmit) {
            if (shouldEmit(value)) _emit(event, value);
        } else _emit(event, value);
    };
    if (passive) {
        const initialValue = getValue();
        const proxy = (0, $01W3b.ref)(initialValue);
        let isUpdating = false;
        (0, $01W3b.watch)(()=>props[key], (v)=>{
            if (!isUpdating) {
                isUpdating = true;
                proxy.value = cloneFn(v);
                (0, $TusQn.nextTick)(()=>isUpdating = false);
            }
        });
        (0, $01W3b.watch)(proxy, (v)=>{
            if (!isUpdating && (v !== props[key] || deep)) triggerEmit(v);
        }, {
            deep: deep
        });
        return proxy;
    } else return (0, $01W3b.computed)({
        get () {
            return getValue();
        },
        set (value) {
            triggerEmit(value);
        }
    });
}
function $6ffe9515611cb489$export$b020cc6dc10339b9(props, emit, options = {}) {
    const ret = {};
    for(const key in props)ret[key] = $6ffe9515611cb489$export$42662bab1b538e5(props, key, emit, options);
    return ret;
}
function $6ffe9515611cb489$export$165ce7a5158a386d(options) {
    const { pattern: pattern = [], interval: interval = 0, navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc } = options || {};
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>typeof navigator1 !== "undefined" && "vibrate" in navigator1);
    const patternRef = (0, $AHHxt.toRef)(pattern);
    let intervalControls;
    const vibrate = (pattern2 = patternRef.value)=>{
        if (isSupported.value) navigator1.vibrate(pattern2);
    };
    const stop = ()=>{
        if (isSupported.value) navigator1.vibrate(0);
        intervalControls == null || intervalControls.pause();
    };
    if (interval > 0) intervalControls = (0, $AHHxt.useIntervalFn)(vibrate, interval, {
        immediate: false,
        immediateCallback: false
    });
    return {
        isSupported: isSupported,
        pattern: pattern,
        intervalControls: intervalControls,
        vibrate: vibrate,
        stop: stop
    };
}
function $6ffe9515611cb489$export$e0cfc61c348fbd34(list, options) {
    const { containerStyle: containerStyle, wrapperProps: wrapperProps, scrollTo: scrollTo, calculateRange: calculateRange, currentList: currentList, containerRef: containerRef } = "itemHeight" in options ? $6ffe9515611cb489$var$useVerticalVirtualList(options, list) : $6ffe9515611cb489$var$useHorizontalVirtualList(options, list);
    return {
        list: currentList,
        scrollTo: scrollTo,
        containerProps: {
            ref: containerRef,
            onScroll: ()=>{
                calculateRange();
            },
            style: containerStyle
        },
        wrapperProps: wrapperProps
    };
}
function $6ffe9515611cb489$var$useVirtualListResources(list) {
    const containerRef = (0, $01W3b.shallowRef)(null);
    const size = $6ffe9515611cb489$export$2b86bedf890eab8(containerRef);
    const currentList = (0, $01W3b.ref)([]);
    const source = (0, $01W3b.shallowRef)(list);
    const state = (0, $01W3b.ref)({
        start: 0,
        end: 10
    });
    return {
        state: state,
        source: source,
        currentList: currentList,
        size: size,
        containerRef: containerRef
    };
}
function $6ffe9515611cb489$var$createGetViewCapacity(state, source, itemSize) {
    return (containerSize)=>{
        if (typeof itemSize === "number") return Math.ceil(containerSize / itemSize);
        const { start: start = 0 } = state.value;
        let sum = 0;
        let capacity = 0;
        for(let i = start; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            capacity = i;
            if (sum > containerSize) break;
        }
        return capacity - start;
    };
}
function $6ffe9515611cb489$var$createGetOffset(source, itemSize) {
    return (scrollDirection)=>{
        if (typeof itemSize === "number") return Math.floor(scrollDirection / itemSize) + 1;
        let sum = 0;
        let offset = 0;
        for(let i = 0; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            if (sum >= scrollDirection) {
                offset = i;
                break;
            }
        }
        return offset + 1;
    };
}
function $6ffe9515611cb489$var$createCalculateRange(type, overscan, getOffset, getViewCapacity, { containerRef: containerRef, state: state, currentList: currentList, source: source }) {
    return ()=>{
        const element = containerRef.value;
        if (element) {
            const offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
            const viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
            const from = offset - overscan;
            const to = offset + viewCapacity + overscan;
            state.value = {
                start: from < 0 ? 0 : from,
                end: to > source.value.length ? source.value.length : to
            };
            currentList.value = source.value.slice(state.value.start, state.value.end).map((ele, index)=>({
                    data: ele,
                    index: index + state.value.start
                }));
        }
    };
}
function $6ffe9515611cb489$var$createGetDistance(itemSize, source) {
    return (index)=>{
        if (typeof itemSize === "number") {
            const size2 = index * itemSize;
            return size2;
        }
        const size = source.value.slice(0, index).reduce((sum, _, i)=>sum + itemSize(i), 0);
        return size;
    };
}
function $6ffe9515611cb489$var$useWatchForSizes(size, list, containerRef, calculateRange) {
    (0, $01W3b.watch)([
        size.width,
        size.height,
        list,
        containerRef
    ], ()=>{
        calculateRange();
    });
}
function $6ffe9515611cb489$var$createComputedTotalSize(itemSize, source) {
    return (0, $01W3b.computed)(()=>{
        if (typeof itemSize === "number") return source.value.length * itemSize;
        return source.value.reduce((sum, _, index)=>sum + itemSize(index), 0);
    });
}
const $6ffe9515611cb489$var$scrollToDictionaryForElementScrollKey = {
    horizontal: "scrollLeft",
    vertical: "scrollTop"
};
function $6ffe9515611cb489$var$createScrollTo(type, calculateRange, getDistance, containerRef) {
    return (index)=>{
        if (containerRef.value) {
            containerRef.value[$6ffe9515611cb489$var$scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
            calculateRange();
        }
    };
}
function $6ffe9515611cb489$var$useHorizontalVirtualList(options, list) {
    const resources = $6ffe9515611cb489$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowX: "auto"
    };
    const { itemWidth: itemWidth, overscan: overscan = 5 } = options;
    const getViewCapacity = $6ffe9515611cb489$var$createGetViewCapacity(state, source, itemWidth);
    const getOffset = $6ffe9515611cb489$var$createGetOffset(source, itemWidth);
    const calculateRange = $6ffe9515611cb489$var$createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
    const getDistanceLeft = $6ffe9515611cb489$var$createGetDistance(itemWidth, source);
    const offsetLeft = (0, $01W3b.computed)(()=>getDistanceLeft(state.value.start));
    const totalWidth = $6ffe9515611cb489$var$createComputedTotalSize(itemWidth, source);
    $6ffe9515611cb489$var$useWatchForSizes(size, list, containerRef, calculateRange);
    const scrollTo = $6ffe9515611cb489$var$createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
    const wrapperProps = (0, $01W3b.computed)(()=>{
        return {
            style: {
                height: "100%",
                width: `${totalWidth.value - offsetLeft.value}px`,
                marginLeft: `${offsetLeft.value}px`,
                display: "flex"
            }
        };
    });
    return {
        scrollTo: scrollTo,
        calculateRange: calculateRange,
        wrapperProps: wrapperProps,
        containerStyle: containerStyle,
        currentList: currentList,
        containerRef: containerRef
    };
}
function $6ffe9515611cb489$var$useVerticalVirtualList(options, list) {
    const resources = $6ffe9515611cb489$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowY: "auto"
    };
    const { itemHeight: itemHeight, overscan: overscan = 5 } = options;
    const getViewCapacity = $6ffe9515611cb489$var$createGetViewCapacity(state, source, itemHeight);
    const getOffset = $6ffe9515611cb489$var$createGetOffset(source, itemHeight);
    const calculateRange = $6ffe9515611cb489$var$createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
    const getDistanceTop = $6ffe9515611cb489$var$createGetDistance(itemHeight, source);
    const offsetTop = (0, $01W3b.computed)(()=>getDistanceTop(state.value.start));
    const totalHeight = $6ffe9515611cb489$var$createComputedTotalSize(itemHeight, source);
    $6ffe9515611cb489$var$useWatchForSizes(size, list, containerRef, calculateRange);
    const scrollTo = $6ffe9515611cb489$var$createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
    const wrapperProps = (0, $01W3b.computed)(()=>{
        return {
            style: {
                width: "100%",
                height: `${totalHeight.value - offsetTop.value}px`,
                marginTop: `${offsetTop.value}px`
            }
        };
    });
    return {
        calculateRange: calculateRange,
        scrollTo: scrollTo,
        containerStyle: containerStyle,
        wrapperProps: wrapperProps,
        currentList: currentList,
        containerRef: containerRef
    };
}
function $6ffe9515611cb489$export$73321d658b51e565(options = {}) {
    const { navigator: navigator1 = $6ffe9515611cb489$export$eade61489f57e3fc, document: document1 = $6ffe9515611cb489$export$37990bd438d16af3 } = options;
    const requestedType = (0, $01W3b.shallowRef)(false);
    const sentinel = (0, $01W3b.shallowRef)(null);
    const documentVisibility = $6ffe9515611cb489$export$87a87a3d299ece7c({
        document: document1
    });
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>navigator1 && "wakeLock" in navigator1);
    const isActive = (0, $01W3b.computed)(()=>!!sentinel.value && documentVisibility.value === "visible");
    if (isSupported.value) {
        $6ffe9515611cb489$export$7080b3e976bc91ab(sentinel, "release", ()=>{
            var _a, _b;
            requestedType.value = (_b = (_a = sentinel.value) == null ? void 0 : _a.type) != null ? _b : false;
        }, {
            passive: true
        });
        (0, $AHHxt.whenever)(()=>documentVisibility.value === "visible" && (document1 == null ? void 0 : document1.visibilityState) === "visible" && requestedType.value, (type)=>{
            requestedType.value = false;
            forceRequest(type);
        });
    }
    async function forceRequest(type) {
        var _a;
        await ((_a = sentinel.value) == null ? void 0 : _a.release());
        sentinel.value = isSupported.value ? await navigator1.wakeLock.request(type) : null;
    }
    async function request(type) {
        if (documentVisibility.value === "visible") await forceRequest(type);
        else requestedType.value = type;
    }
    async function release() {
        requestedType.value = false;
        const s = sentinel.value;
        sentinel.value = null;
        await (s == null ? void 0 : s.release());
    }
    return {
        sentinel: sentinel,
        isSupported: isSupported,
        isActive: isActive,
        request: request,
        forceRequest: forceRequest,
        release: release
    };
}
function $6ffe9515611cb489$export$522fa265139e12a1(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, requestPermissions: _requestForPermissions = true } = options;
    const defaultWebNotificationOptions = options;
    const isSupported = $6ffe9515611cb489$export$85904d4478b9c8a4(()=>{
        if (!window1 || !("Notification" in window1)) return false;
        if (Notification.permission === "granted") return true;
        try {
            const notification2 = new Notification("");
            notification2.onshow = ()=>{
                notification2.close();
            };
        } catch (e) {
            if (e.name === "TypeError") return false;
        }
        return true;
    });
    const permissionGranted = (0, $01W3b.shallowRef)(isSupported.value && "permission" in Notification && Notification.permission === "granted");
    const notification = (0, $01W3b.ref)(null);
    const ensurePermissions = async ()=>{
        if (!isSupported.value) return;
        if (!permissionGranted.value && Notification.permission !== "denied") {
            const result = await Notification.requestPermission();
            if (result === "granted") permissionGranted.value = true;
        }
        return permissionGranted.value;
    };
    const { on: onClick, trigger: clickTrigger } = (0, $AHHxt.createEventHook)();
    const { on: onShow, trigger: showTrigger } = (0, $AHHxt.createEventHook)();
    const { on: onError, trigger: errorTrigger } = (0, $AHHxt.createEventHook)();
    const { on: onClose, trigger: closeTrigger } = (0, $AHHxt.createEventHook)();
    const show = async (overrides)=>{
        if (!isSupported.value || !permissionGranted.value) return;
        const options2 = Object.assign({}, defaultWebNotificationOptions, overrides);
        notification.value = new Notification(options2.title || "", options2);
        notification.value.onclick = clickTrigger;
        notification.value.onshow = showTrigger;
        notification.value.onerror = errorTrigger;
        notification.value.onclose = closeTrigger;
        return notification.value;
    };
    const close = ()=>{
        if (notification.value) notification.value.close();
        notification.value = null;
    };
    if (_requestForPermissions) (0, $AHHxt.tryOnMounted)(ensurePermissions);
    (0, $AHHxt.tryOnScopeDispose)(close);
    if (isSupported.value && window1) {
        const document1 = window1.document;
        $6ffe9515611cb489$export$7080b3e976bc91ab(document1, "visibilitychange", (e)=>{
            e.preventDefault();
            if (document1.visibilityState === "visible") close();
        });
    }
    return {
        isSupported: isSupported,
        notification: notification,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        show: show,
        close: close,
        onClick: onClick,
        onShow: onShow,
        onError: onError,
        onClose: onClose
    };
}
const $6ffe9515611cb489$var$DEFAULT_PING_MESSAGE = "ping";
function $6ffe9515611cb489$var$resolveNestedOptions(options) {
    if (options === true) return {};
    return options;
}
function $6ffe9515611cb489$export$ef4944d05bd3db0(url, options = {}) {
    const { onConnected: onConnected, onDisconnected: onDisconnected, onError: onError, onMessage: onMessage, immediate: immediate = true, autoConnect: autoConnect = true, autoClose: autoClose = true, protocols: protocols = [] } = options;
    const data = (0, $01W3b.ref)(null);
    const status = (0, $01W3b.shallowRef)("CLOSED");
    const wsRef = (0, $01W3b.ref)();
    const urlRef = (0, $AHHxt.toRef)(url);
    let heartbeatPause;
    let heartbeatResume;
    let explicitlyClosed = false;
    let retried = 0;
    let bufferedData = [];
    let retryTimeout;
    let pongTimeoutWait;
    const _sendBuffer = ()=>{
        if (bufferedData.length && wsRef.value && status.value === "OPEN") {
            for (const buffer of bufferedData)wsRef.value.send(buffer);
            bufferedData = [];
        }
    };
    const resetRetry = ()=>{
        if (retryTimeout != null) {
            clearTimeout(retryTimeout);
            retryTimeout = void 0;
        }
    };
    const resetHeartbeat = ()=>{
        clearTimeout(pongTimeoutWait);
        pongTimeoutWait = void 0;
    };
    const close = (code = 1e3, reason)=>{
        resetRetry();
        if (!(0, $AHHxt.isClient) && !(0, $AHHxt.isWorker) || !wsRef.value) return;
        explicitlyClosed = true;
        resetHeartbeat();
        heartbeatPause == null || heartbeatPause();
        wsRef.value.close(code, reason);
        wsRef.value = void 0;
    };
    const send = (data2, useBuffer = true)=>{
        if (!wsRef.value || status.value !== "OPEN") {
            if (useBuffer) bufferedData.push(data2);
            return false;
        }
        _sendBuffer();
        wsRef.value.send(data2);
        return true;
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const ws = new WebSocket(urlRef.value, protocols);
        wsRef.value = ws;
        status.value = "CONNECTING";
        ws.onopen = ()=>{
            status.value = "OPEN";
            retried = 0;
            onConnected == null || onConnected(ws);
            heartbeatResume == null || heartbeatResume();
            _sendBuffer();
        };
        ws.onclose = (ev)=>{
            status.value = "CLOSED";
            resetHeartbeat();
            heartbeatPause == null || heartbeatPause();
            onDisconnected == null || onDisconnected(ws, ev);
            if (!explicitlyClosed && options.autoReconnect && (wsRef.value == null || ws === wsRef.value)) {
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $6ffe9515611cb489$var$resolveNestedOptions(options.autoReconnect);
                const checkRetires = typeof retries === "function" ? retries : ()=>typeof retries === "number" && (retries < 0 || retried < retries);
                if (checkRetires(retried)) {
                    retried += 1;
                    retryTimeout = setTimeout(_init, delay);
                } else onFailed == null || onFailed();
            }
        };
        ws.onerror = (e)=>{
            onError == null || onError(ws, e);
        };
        ws.onmessage = (e)=>{
            if (options.heartbeat) {
                resetHeartbeat();
                const { message: message = $6ffe9515611cb489$var$DEFAULT_PING_MESSAGE, responseMessage: responseMessage = message } = $6ffe9515611cb489$var$resolveNestedOptions(options.heartbeat);
                if (e.data === (0, $01W3b.toValue)(responseMessage)) return;
            }
            data.value = e.data;
            onMessage == null || onMessage(ws, e);
        };
    };
    if (options.heartbeat) {
        const { message: message = $6ffe9515611cb489$var$DEFAULT_PING_MESSAGE, interval: interval = 1e3, pongTimeout: pongTimeout = 1e3 } = $6ffe9515611cb489$var$resolveNestedOptions(options.heartbeat);
        const { pause: pause, resume: resume } = (0, $AHHxt.useIntervalFn)(()=>{
            send((0, $01W3b.toValue)(message), false);
            if (pongTimeoutWait != null) return;
            pongTimeoutWait = setTimeout(()=>{
                close();
                explicitlyClosed = false;
            }, pongTimeout);
        }, interval, {
            immediate: false
        });
        heartbeatPause = pause;
        heartbeatResume = resume;
    }
    if (autoClose) {
        if (0, $AHHxt.isClient) $6ffe9515611cb489$export$7080b3e976bc91ab("beforeunload", ()=>close(), {
            passive: true
        });
        (0, $AHHxt.tryOnScopeDispose)(close);
    }
    const open = ()=>{
        if (!(0, $AHHxt.isClient) && !(0, $AHHxt.isWorker)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) open();
    if (autoConnect) (0, $01W3b.watch)(urlRef, open);
    return {
        data: data,
        status: status,
        close: close,
        send: send,
        open: open,
        ws: wsRef
    };
}
function $6ffe9515611cb489$export$44bc62d25eb3a976(arg0, workerOptions, options) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options != null ? options : {};
    const data = (0, $01W3b.ref)(null);
    const worker = (0, $01W3b.shallowRef)();
    const post = (...args)=>{
        if (!worker.value) return;
        worker.value.postMessage(...args);
    };
    const terminate = function terminate2() {
        if (!worker.value) return;
        worker.value.terminate();
    };
    if (window1) {
        if (typeof arg0 === "string") worker.value = new Worker(arg0, workerOptions);
        else if (typeof arg0 === "function") worker.value = arg0();
        else worker.value = arg0;
        worker.value.onmessage = (e)=>{
            data.value = e.data;
        };
        (0, $AHHxt.tryOnScopeDispose)(()=>{
            if (worker.value) worker.value.terminate();
        });
    }
    return {
        data: data,
        post: post,
        terminate: terminate,
        worker: worker
    };
}
function $6ffe9515611cb489$var$depsParser(deps, localDeps) {
    if (deps.length === 0 && localDeps.length === 0) return "";
    const depsString = deps.map((dep)=>`'${dep}'`).toString();
    const depsFunctionString = localDeps.filter((dep)=>typeof dep === "function").map((fn)=>{
        const str = fn.toString();
        if (str.trim().startsWith("function")) return str;
        else {
            const name = fn.name;
            return `const ${name} = ${str}`;
        }
    }).join(";");
    const importString = `importScripts(${depsString});`;
    return `${depsString.trim() === "" ? "" : importString} ${depsFunctionString}`;
}
function $6ffe9515611cb489$var$jobRunner(userFunc) {
    return (e)=>{
        const userFuncArgs = e.data[0];
        return Promise.resolve(userFunc.apply(void 0, userFuncArgs)).then((result)=>{
            postMessage([
                "SUCCESS",
                result
            ]);
        }).catch((error)=>{
            postMessage([
                "ERROR",
                error
            ]);
        });
    };
}
function $6ffe9515611cb489$var$createWorkerBlobUrl(fn, deps, localDeps) {
    const blobCode = `${$6ffe9515611cb489$var$depsParser(deps, localDeps)}; onmessage=(${$6ffe9515611cb489$var$jobRunner})(${fn})`;
    const blob = new Blob([
        blobCode
    ], {
        type: "text/javascript"
    });
    const url = URL.createObjectURL(blob);
    return url;
}
function $6ffe9515611cb489$export$33b1fcfcd57b961(fn, options = {}) {
    const { dependencies: dependencies = [], localDependencies: localDependencies = [], timeout: timeout, window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    const worker = (0, $01W3b.ref)();
    const workerStatus = (0, $01W3b.shallowRef)("PENDING");
    const promise = (0, $01W3b.ref)({});
    const timeoutId = (0, $01W3b.shallowRef)();
    const workerTerminate = (status = "PENDING")=>{
        if (worker.value && worker.value._url && window1) {
            worker.value.terminate();
            URL.revokeObjectURL(worker.value._url);
            promise.value = {};
            worker.value = void 0;
            window1.clearTimeout(timeoutId.value);
            workerStatus.value = status;
        }
    };
    workerTerminate();
    (0, $AHHxt.tryOnScopeDispose)(workerTerminate);
    const generateWorker = ()=>{
        const blobUrl = $6ffe9515611cb489$var$createWorkerBlobUrl(fn, dependencies, localDependencies);
        const newWorker = new Worker(blobUrl);
        newWorker._url = blobUrl;
        newWorker.onmessage = (e)=>{
            const { resolve: resolve = ()=>{}, reject: reject = ()=>{} } = promise.value;
            const [status, result] = e.data;
            switch(status){
                case "SUCCESS":
                    resolve(result);
                    workerTerminate(status);
                    break;
                default:
                    reject(result);
                    workerTerminate("ERROR");
                    break;
            }
        };
        newWorker.onerror = (e)=>{
            const { reject: reject = ()=>{} } = promise.value;
            e.preventDefault();
            reject(e);
            workerTerminate("ERROR");
        };
        if (timeout) timeoutId.value = setTimeout(()=>workerTerminate("TIMEOUT_EXPIRED"), timeout);
        return newWorker;
    };
    const callWorker = (...fnArgs)=>new Promise((resolve, reject)=>{
            var _a;
            promise.value = {
                resolve: resolve,
                reject: reject
            };
            (_a = worker.value) == null || _a.postMessage([
                [
                    ...fnArgs
                ]
            ]);
            workerStatus.value = "RUNNING";
        });
    const workerFn = (...fnArgs)=>{
        if (workerStatus.value === "RUNNING") {
            console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
            return Promise.reject();
        }
        worker.value = generateWorker();
        return callWorker(...fnArgs);
    };
    return {
        workerFn: workerFn,
        workerStatus: workerStatus,
        workerTerminate: workerTerminate
    };
}
function $6ffe9515611cb489$export$e838b63e89f8751e(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.shallowRef)(false);
    const focused = (0, $01W3b.shallowRef)(window1.document.hasFocus());
    const listenerOptions = {
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "blur", ()=>{
        focused.value = false;
    }, listenerOptions);
    $6ffe9515611cb489$export$7080b3e976bc91ab(window1, "focus", ()=>{
        focused.value = true;
    }, listenerOptions);
    return focused;
}
function $6ffe9515611cb489$export$c510e5ca8a22f2a1(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, ...rest } = options;
    return $6ffe9515611cb489$export$d928051c8cd740b(window1, rest);
}
function $6ffe9515611cb489$export$42c02f33970a2afa(options = {}) {
    const { window: window1 = $6ffe9515611cb489$export$16f8ba610718ae4a, initialWidth: initialWidth = Number.POSITIVE_INFINITY, initialHeight: initialHeight = Number.POSITIVE_INFINITY, listenOrientation: listenOrientation = true, includeScrollbar: includeScrollbar = true, type: type = "inner" } = options;
    const width = (0, $01W3b.shallowRef)(initialWidth);
    const height = (0, $01W3b.shallowRef)(initialHeight);
    const update = ()=>{
        if (window1) {
            if (type === "outer") {
                width.value = window1.outerWidth;
                height.value = window1.outerHeight;
            } else if (type === "visual" && window1.visualViewport) {
                const { width: visualViewportWidth, height: visualViewportHeight, scale: scale } = window1.visualViewport;
                width.value = Math.round(visualViewportWidth * scale);
                height.value = Math.round(visualViewportHeight * scale);
            } else if (includeScrollbar) {
                width.value = window1.innerWidth;
                height.value = window1.innerHeight;
            } else {
                width.value = window1.document.documentElement.clientWidth;
                height.value = window1.document.documentElement.clientHeight;
            }
        }
    };
    update();
    (0, $AHHxt.tryOnMounted)(update);
    const listenerOptions = {
        passive: true
    };
    $6ffe9515611cb489$export$7080b3e976bc91ab("resize", update, listenerOptions);
    if (window1 && type === "visual" && window1.visualViewport) $6ffe9515611cb489$export$7080b3e976bc91ab(window1.visualViewport, "resize", update, listenerOptions);
    if (listenOrientation) {
        const matches = $6ffe9515611cb489$export$32d5543ab307c01("(orientation: portrait)");
        (0, $01W3b.watch)(matches, ()=>update());
    }
    return {
        width: width,
        height: height
    };
}

});
parcelRegister("AHHxt", function(module, exports) {

$parcel$export(module.exports, "computedWithControl", () => $bc6380c684a2e15a$export$220dfb31330e2956);
$parcel$export(module.exports, "tryOnScopeDispose", () => $bc6380c684a2e15a$export$c3d49ae4e58d3d9d);
$parcel$export(module.exports, "createEventHook", () => $bc6380c684a2e15a$export$c8b3b0996d763ee);
$parcel$export(module.exports, "injectLocal", () => $bc6380c684a2e15a$export$89897216f9bf9933);
$parcel$export(module.exports, "provideLocal", () => $bc6380c684a2e15a$export$a797c3886d31ed0);
$parcel$export(module.exports, "createRef", () => $bc6380c684a2e15a$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "makeDestructurable", () => $bc6380c684a2e15a$export$d50fdd10db75504e);
$parcel$export(module.exports, "isClient", () => $bc6380c684a2e15a$export$7383f122bf48ec30);
$parcel$export(module.exports, "isWorker", () => $bc6380c684a2e15a$export$3c901a5f01941a06);
$parcel$export(module.exports, "isDef", () => $bc6380c684a2e15a$export$7b816c9b8ecf71b4);
$parcel$export(module.exports, "notNullish", () => $bc6380c684a2e15a$export$aedb69ff3e31596c);
$parcel$export(module.exports, "isObject", () => $bc6380c684a2e15a$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "timestamp", () => $bc6380c684a2e15a$export$fc00ee57782020aa);
$parcel$export(module.exports, "clamp", () => $bc6380c684a2e15a$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "noop", () => $bc6380c684a2e15a$export$8793edee2d425525);
$parcel$export(module.exports, "hasOwn", () => $bc6380c684a2e15a$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isIOS", () => $bc6380c684a2e15a$export$fedb369cb70207f1);
$parcel$export(module.exports, "createFilterWrapper", () => $bc6380c684a2e15a$export$a1f1cf91007f23bf);
$parcel$export(module.exports, "bypassFilter", () => $bc6380c684a2e15a$export$8cc0e33a27868391);
$parcel$export(module.exports, "debounceFilter", () => $bc6380c684a2e15a$export$fca2c450ae03b38e);
$parcel$export(module.exports, "throttleFilter", () => $bc6380c684a2e15a$export$cd62e9dbf204fd92);
$parcel$export(module.exports, "pausableFilter", () => $bc6380c684a2e15a$export$8d46ce8e0ead9c2b);
$parcel$export(module.exports, "toRef", () => $bc6380c684a2e15a$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "camelize", () => $bc6380c684a2e15a$export$161d051f5dd25de7);
$parcel$export(module.exports, "promiseTimeout", () => $bc6380c684a2e15a$export$69e8b3daf72c74b7);
$parcel$export(module.exports, "identity", () => $bc6380c684a2e15a$export$f0954fd7d5368655);
$parcel$export(module.exports, "createSingletonPromise", () => $bc6380c684a2e15a$export$7a0c7c93e8e22bce);
$parcel$export(module.exports, "containsProp", () => $bc6380c684a2e15a$export$d138bf93e1dfa23f);
$parcel$export(module.exports, "increaseWithUnit", () => $bc6380c684a2e15a$export$f5c97f6a04b90212);
$parcel$export(module.exports, "pxValue", () => $bc6380c684a2e15a$export$e3ee541f3ff8ee70);
$parcel$export(module.exports, "objectPick", () => $bc6380c684a2e15a$export$5f2d71bd504be1ec);
$parcel$export(module.exports, "objectOmit", () => $bc6380c684a2e15a$export$3320623908f24e40);
$parcel$export(module.exports, "objectEntries", () => $bc6380c684a2e15a$export$6a29ade99f81ec8a);
$parcel$export(module.exports, "toArray", () => $bc6380c684a2e15a$export$45b10814cc054894);
$parcel$export(module.exports, "useDebounceFn", () => $bc6380c684a2e15a$export$ddf8f1aa96b8ea88);
$parcel$export(module.exports, "useThrottleFn", () => $bc6380c684a2e15a$export$8ed85856108010bc);
$parcel$export(module.exports, "watchWithFilter", () => $bc6380c684a2e15a$export$3955c00bb6715986);
$parcel$export(module.exports, "pausableWatch", () => $bc6380c684a2e15a$export$37fdf671f882195e);
$parcel$export(module.exports, "syncRef", () => $bc6380c684a2e15a$export$d43743c1df800be0);
$parcel$export(module.exports, "toRefs", () => $bc6380c684a2e15a$export$2e9533675e5e70e0);
$parcel$export(module.exports, "tryOnMounted", () => $bc6380c684a2e15a$export$cf1be5b643f0827);
$parcel$export(module.exports, "tryOnUnmounted", () => $bc6380c684a2e15a$export$9fa6e59ca833c930);
$parcel$export(module.exports, "until", () => $bc6380c684a2e15a$export$a40009bd2c363351);
$parcel$export(module.exports, "useIntervalFn", () => $bc6380c684a2e15a$export$35ee30a05e4f2223);
$parcel$export(module.exports, "useTimeoutFn", () => $bc6380c684a2e15a$export$14705c14c13d528a);
$parcel$export(module.exports, "watchImmediate", () => $bc6380c684a2e15a$export$d9aec7ec4e8a1634);
$parcel$export(module.exports, "watchOnce", () => $bc6380c684a2e15a$export$95d4a8ca30b80ae0);
$parcel$export(module.exports, "whenever", () => $bc6380c684a2e15a$export$909eba9696cc3445);
$parcel$export(module.exports, "watchIgnorable", () => $bc6380c684a2e15a$export$63ac06655f58d92a);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
function $bc6380c684a2e15a$export$c92323792c35f5f1(fn, options) {
    var _a;
    const result = (0, $01W3b.shallowRef)();
    (0, $TusQn.watchEffect)(()=>{
        result.value = fn();
    }, {
        ...options,
        flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
    });
    return (0, $01W3b.readonly)(result);
}
function $bc6380c684a2e15a$export$220dfb31330e2956(source, fn) {
    let v = void 0;
    let track;
    let trigger;
    const dirty = (0, $01W3b.shallowRef)(true);
    const update = ()=>{
        dirty.value = true;
        trigger();
    };
    (0, $01W3b.watch)(source, update, {
        flush: "sync"
    });
    const get = typeof fn === "function" ? fn : fn.get;
    const set = typeof fn === "function" ? void 0 : fn.set;
    const result = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                if (dirty.value) {
                    v = get(v);
                    dirty.value = false;
                }
                track();
                return v;
            },
            set (v2) {
                set == null || set(v2);
            }
        };
    });
    if (Object.isExtensible(result)) result.trigger = update;
    return result;
}
function $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(fn) {
    if ((0, $01W3b.getCurrentScope)()) {
        (0, $01W3b.onScopeDispose)(fn);
        return true;
    }
    return false;
}
function $bc6380c684a2e15a$export$c8b3b0996d763ee() {
    const fns = /* @__PURE__ */ new Set();
    const off = (fn)=>{
        fns.delete(fn);
    };
    const clear = ()=>{
        fns.clear();
    };
    const on = (fn)=>{
        fns.add(fn);
        const offFn = ()=>off(fn);
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    const trigger = (...args)=>{
        return Promise.all(Array.from(fns).map((fn)=>fn(...args)));
    };
    return {
        on: on,
        off: off,
        trigger: trigger,
        clear: clear
    };
}
function $bc6380c684a2e15a$export$aa9aac23b3959ee1(stateFactory) {
    let initialized = false;
    let state;
    const scope = (0, $01W3b.effectScope)(true);
    return (...args)=>{
        if (!initialized) {
            state = scope.run(()=>stateFactory(...args));
            initialized = true;
        }
        return state;
    };
}
const $bc6380c684a2e15a$var$localProvidedStateMap = /* @__PURE__ */ new WeakMap();
const $bc6380c684a2e15a$export$89897216f9bf9933 = (...args)=>{
    var _a;
    const key = args[0];
    const instance = (_a = (0, $TusQn.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null && !(0, $TusQn.hasInjectionContext)()) throw new Error("injectLocal must be called in setup");
    if (instance && $bc6380c684a2e15a$var$localProvidedStateMap.has(instance) && key in $bc6380c684a2e15a$var$localProvidedStateMap.get(instance)) return $bc6380c684a2e15a$var$localProvidedStateMap.get(instance)[key];
    return (0, $TusQn.inject)(...args);
};
const $bc6380c684a2e15a$export$a797c3886d31ed0 = (key, value)=>{
    var _a;
    const instance = (_a = (0, $TusQn.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("provideLocal must be called in setup");
    if (!$bc6380c684a2e15a$var$localProvidedStateMap.has(instance)) $bc6380c684a2e15a$var$localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
    const localProvidedState = $bc6380c684a2e15a$var$localProvidedStateMap.get(instance);
    localProvidedState[key] = value;
    (0, $TusQn.provide)(key, value);
};
function $bc6380c684a2e15a$export$91b9c7550061230e(composable, options) {
    const key = (options == null ? void 0 : options.injectionKey) || Symbol(composable.name || "InjectionState");
    const defaultValue = options == null ? void 0 : options.defaultValue;
    const useProvidingState = (...args)=>{
        const state = composable(...args);
        $bc6380c684a2e15a$export$a797c3886d31ed0(key, state);
        return state;
    };
    const useInjectedState = ()=>$bc6380c684a2e15a$export$89897216f9bf9933(key, defaultValue);
    return [
        useProvidingState,
        useInjectedState
    ];
}
function $bc6380c684a2e15a$export$7d1e3a5e95ceca43(value, deep) {
    if (deep === true) return (0, $01W3b.ref)(value);
    else return (0, $01W3b.shallowRef)(value);
}
function $bc6380c684a2e15a$export$9e8d4b001a1bb310(composable) {
    let subscribers = 0;
    let state;
    let scope;
    const dispose = ()=>{
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return (...args)=>{
        subscribers += 1;
        if (!scope) {
            scope = (0, $01W3b.effectScope)(true);
            state = scope.run(()=>composable(...args));
        }
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
function $bc6380c684a2e15a$export$ecda8b07a1b5deab(ref, extend, { enumerable: enumerable = false, unwrap: unwrap = true } = {}) {
    for (const [key, value] of Object.entries(extend)){
        if (key === "value") continue;
        if ((0, $01W3b.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
            get () {
                return value.value;
            },
            set (v) {
                value.value = v;
            },
            enumerable: enumerable
        });
        else Object.defineProperty(ref, key, {
            value: value,
            enumerable: enumerable
        });
    }
    return ref;
}
function $bc6380c684a2e15a$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $01W3b.unref)(obj);
    return (0, $01W3b.unref)(obj)[key];
}
function $bc6380c684a2e15a$export$4e62c701997796c1(v) {
    return (0, $01W3b.unref)(v) != null;
}
function $bc6380c684a2e15a$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        const clone = {
            ...obj
        };
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value () {
                let index = 0;
                return {
                    next: ()=>({
                            value: arr[index++],
                            done: index > arr.length
                        })
                };
            }
        });
        return clone;
    } else return Object.assign([
        ...arr
    ], obj);
}
function $bc6380c684a2e15a$export$4ba03523724ba2d7(fn, options) {
    const unrefFn = (options == null ? void 0 : options.computedGetter) === false ? (0, $01W3b.unref) : (0, $01W3b.toValue);
    return function(...args) {
        return (0, $01W3b.computed)(()=>fn.apply(this, args.map((i)=>unrefFn(i))));
    };
}
function $bc6380c684a2e15a$export$1ff2e29423610e60(obj, optionsOrKeys = {}) {
    let keys = [];
    let options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        options = optionsOrKeys;
        const { includeOwnProperties: includeOwnProperties = true } = optionsOrKeys;
        keys.push(...Object.keys(obj));
        if (includeOwnProperties) keys.push(...Object.getOwnPropertyNames(obj));
    }
    return Object.fromEntries(keys.map((key)=>{
        const value = obj[key];
        return [
            key,
            typeof value === "function" ? $bc6380c684a2e15a$export$4ba03523724ba2d7(value.bind(obj), options) : value
        ];
    }));
}
function $bc6380c684a2e15a$export$45c769cf449a508c(objectRef) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.reactive)(objectRef);
    const proxy = new Proxy({}, {
        get (_, p, receiver) {
            return (0, $01W3b.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set (_, p, value) {
            if ((0, $01W3b.isRef)(objectRef.value[p]) && !(0, $01W3b.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return (0, $01W3b.reactive)(proxy);
}
function $bc6380c684a2e15a$export$35298289c11958e1(fn) {
    return $bc6380c684a2e15a$export$45c769cf449a508c((0, $01W3b.computed)(fn));
}
function $bc6380c684a2e15a$export$797deb43a681bdd1(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $bc6380c684a2e15a$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>!predicate((0, $01W3b.toValue)(v), k))) : Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter((e)=>!flatKeys.includes(e[0]))));
}
const $bc6380c684a2e15a$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof document !== "undefined";
const $bc6380c684a2e15a$export$3c901a5f01941a06 = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const $bc6380c684a2e15a$export$7b816c9b8ecf71b4 = (val)=>typeof val !== "undefined";
const $bc6380c684a2e15a$export$aedb69ff3e31596c = (val)=>val != null;
const $bc6380c684a2e15a$export$a7a9523472993e97 = (condition, ...infos)=>{
    if (!condition) console.warn(...infos);
};
const $bc6380c684a2e15a$var$toString = Object.prototype.toString;
const $bc6380c684a2e15a$export$a6cdc56e425d0d0a = (val)=>$bc6380c684a2e15a$var$toString.call(val) === "[object Object]";
const $bc6380c684a2e15a$export$461939dd4422153 = ()=>Date.now();
const $bc6380c684a2e15a$export$fc00ee57782020aa = ()=>+Date.now();
const $bc6380c684a2e15a$export$7d15b64cf5a3a4c4 = (n, min, max)=>Math.min(max, Math.max(min, n));
const $bc6380c684a2e15a$export$8793edee2d425525 = ()=>{};
const $bc6380c684a2e15a$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $bc6380c684a2e15a$export$b5a638e9b3fff9f3 = (val, key)=>Object.prototype.hasOwnProperty.call(val, key);
const $bc6380c684a2e15a$export$fedb369cb70207f1 = /* @__PURE__ */ $bc6380c684a2e15a$var$getIsIOS();
function $bc6380c684a2e15a$var$getIsIOS() {
    var _a, _b;
    return $bc6380c684a2e15a$export$7383f122bf48ec30 && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $bc6380c684a2e15a$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper(...args) {
        return new Promise((resolve, reject)=>{
            Promise.resolve(filter(()=>fn.apply(this, args), {
                fn: fn,
                thisArg: this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
const $bc6380c684a2e15a$export$8cc0e33a27868391 = (invoke)=>{
    return invoke();
};
function $bc6380c684a2e15a$export$fca2c450ae03b38e(ms, options = {}) {
    let timer;
    let maxTimer;
    let lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
    const _clearTimeout = (timer2)=>{
        clearTimeout(timer2);
        lastRejector();
        lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
    };
    let lastInvoker;
    const filter = (invoke)=>{
        const duration = (0, $01W3b.toValue)(ms);
        const maxDuration = (0, $01W3b.toValue)(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise((resolve, reject)=>{
            lastRejector = options.rejectOnCancel ? reject : resolve;
            lastInvoker = invoke;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(()=>{
                if (timer) _clearTimeout(timer);
                maxTimer = null;
                resolve(lastInvoker());
            }, maxDuration);
            timer = setTimeout(()=>{
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $bc6380c684a2e15a$export$cd62e9dbf204fd92(...args) {
    let lastExec = 0;
    let timer;
    let isLeading = true;
    let lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
    let lastValue;
    let ms;
    let trailing;
    let leading;
    let rejectOnCancel;
    if (!(0, $01W3b.isRef)(args[0]) && typeof args[0] === "object") ({ delay: ms, trailing: trailing = true, leading: leading = true, rejectOnCancel: rejectOnCancel = false } = args[0]);
    else [ms, trailing = true, leading = true, rejectOnCancel = false] = args;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $bc6380c684a2e15a$export$8793edee2d425525;
        }
    };
    const filter = (_invoke)=>{
        const duration = (0, $01W3b.toValue)(ms);
        const elapsed = Date.now() - lastExec;
        const invoke = ()=>{
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        } else if (trailing) lastValue = new Promise((resolve, reject)=>{
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(()=>{
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(()=>isLeading = true, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function $bc6380c684a2e15a$export$8d46ce8e0ead9c2b(extendFilter = $bc6380c684a2e15a$export$8cc0e33a27868391, options = {}) {
    const { initialState: initialState = "active" } = options;
    const isActive = $bc6380c684a2e15a$export$1f60508e4f47b4b7(initialState === "active");
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    const eventFilter = (...args)=>{
        if (isActive.value) extendFilter(...args);
    };
    return {
        isActive: (0, $01W3b.readonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
function $bc6380c684a2e15a$var$cacheStringFunction(fn) {
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
const $bc6380c684a2e15a$var$hyphenateRE = /\B([A-Z])/g;
const $bc6380c684a2e15a$export$6e6a0a3676c4b8bb = $bc6380c684a2e15a$var$cacheStringFunction((str)=>str.replace($bc6380c684a2e15a$var$hyphenateRE, "-$1").toLowerCase());
const $bc6380c684a2e15a$var$camelizeRE = /-(\w)/g;
const $bc6380c684a2e15a$export$161d051f5dd25de7 = $bc6380c684a2e15a$var$cacheStringFunction((str)=>{
    return str.replace($bc6380c684a2e15a$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
function $bc6380c684a2e15a$export$69e8b3daf72c74b7(ms, throwOnTimeout = false, reason = "Timeout") {
    return new Promise((resolve, reject)=>{
        if (throwOnTimeout) setTimeout(()=>reject(reason), ms);
        else setTimeout(resolve, ms);
    });
}
function $bc6380c684a2e15a$export$f0954fd7d5368655(arg) {
    return arg;
}
function $bc6380c684a2e15a$export$7a0c7c93e8e22bce(fn) {
    let _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = async ()=>{
        const _prev = _promise;
        _promise = void 0;
        if (_prev) await _prev;
    };
    return wrapper;
}
function $bc6380c684a2e15a$export$468cda29b159ee5d(fn) {
    return fn();
}
function $bc6380c684a2e15a$export$d138bf93e1dfa23f(obj, ...props) {
    return props.some((k)=>k in obj);
}
function $bc6380c684a2e15a$export$f5c97f6a04b90212(target, delta) {
    var _a;
    if (typeof target === "number") return target + delta;
    const value = ((_a = target.match(/^-?\d+\.?\d*/)) == null ? void 0 : _a[0]) || "";
    const unit = target.slice(value.length);
    const result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
function $bc6380c684a2e15a$export$e3ee541f3ff8ee70(px) {
    return px.endsWith("rem") ? Number.parseFloat(px) * 16 : Number.parseFloat(px);
}
function $bc6380c684a2e15a$export$5f2d71bd504be1ec(obj, keys, omitUndefined = false) {
    return keys.reduce((n, k)=>{
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
function $bc6380c684a2e15a$export$3320623908f24e40(obj, keys, omitUndefined = false) {
    return Object.fromEntries(Object.entries(obj).filter(([key, value])=>{
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function $bc6380c684a2e15a$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $bc6380c684a2e15a$export$5c967efe8efb656c(target) {
    return target || (0, $TusQn.getCurrentInstance)();
}
function $bc6380c684a2e15a$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $bc6380c684a2e15a$export$1f60508e4f47b4b7(...args) {
    if (args.length !== 1) return (0, $01W3b.toRef)(...args);
    const r = args[0];
    return typeof r === "function" ? (0, $01W3b.readonly)((0, $01W3b.customRef)(()=>({
            get: r,
            set: $bc6380c684a2e15a$export$8793edee2d425525
        }))) : (0, $01W3b.ref)(r);
}
const $bc6380c684a2e15a$export$fb2b8a41d9966b32 = $bc6380c684a2e15a$export$1f60508e4f47b4b7;
function $bc6380c684a2e15a$export$afd74972d99a820f(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $bc6380c684a2e15a$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>predicate((0, $01W3b.toValue)(v), k))) : Object.fromEntries(flatKeys.map((k)=>[
                k,
                $bc6380c684a2e15a$export$1f60508e4f47b4b7(obj, k)
            ])));
}
function $bc6380c684a2e15a$export$c1f1e286df6cc58f(defaultValue, afterMs = 1e4) {
    return (0, $01W3b.customRef)((track, trigger)=>{
        let value = (0, $01W3b.toValue)(defaultValue);
        let timer;
        const resetAfter = ()=>setTimeout(()=>{
                value = (0, $01W3b.toValue)(defaultValue);
                trigger();
            }, (0, $01W3b.toValue)(afterMs));
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(()=>{
            clearTimeout(timer);
        });
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function $bc6380c684a2e15a$export$ddf8f1aa96b8ea88(fn, ms = 200, options = {}) {
    return $bc6380c684a2e15a$export$a1f1cf91007f23bf($bc6380c684a2e15a$export$fca2c450ae03b38e(ms, options), fn);
}
function $bc6380c684a2e15a$export$179967fbe3ecb41a(value, ms = 200, options = {}) {
    const debounced = (0, $01W3b.ref)(value.value);
    const updater = $bc6380c684a2e15a$export$ddf8f1aa96b8ea88(()=>{
        debounced.value = value.value;
    }, ms, options);
    (0, $01W3b.watch)(value, ()=>updater());
    return debounced;
}
function $bc6380c684a2e15a$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $01W3b.computed)({
        get () {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set (value) {
            source.value = value;
        }
    });
}
function $bc6380c684a2e15a$export$8ed85856108010bc(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
    return $bc6380c684a2e15a$export$a1f1cf91007f23bf($bc6380c684a2e15a$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
function $bc6380c684a2e15a$export$4d1d638ad6b48495(value, delay = 200, trailing = true, leading = true) {
    if (delay <= 0) return value;
    const throttled = (0, $01W3b.ref)(value.value);
    const updater = $bc6380c684a2e15a$export$8ed85856108010bc(()=>{
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $01W3b.watch)(value, ()=>updater());
    return throttled;
}
function $bc6380c684a2e15a$export$4b7f2010e13474b2(initial, options = {}) {
    let source = initial;
    let track;
    let trigger;
    const ref = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                return get();
            },
            set (v) {
                set(v);
            }
        };
    });
    function get(tracking = true) {
        if (tracking) track();
        return source;
    }
    function set(value, triggering = true) {
        var _a, _b;
        if (value === source) return;
        const old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
        source = value;
        (_b = options.onChanged) == null || _b.call(options, value, old);
        if (triggering) trigger();
    }
    const untrackedGet = ()=>get(false);
    const silentSet = (v)=>set(v, false);
    const peek = ()=>get(false);
    const lay = (v)=>set(v, false);
    return $bc6380c684a2e15a$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
const $bc6380c684a2e15a$export$6b6db3af7a80e2d2 = $bc6380c684a2e15a$export$4b7f2010e13474b2;
function $bc6380c684a2e15a$export$adaa4cf7ef1b65be(...args) {
    if (args.length === 2) {
        const [ref, value] = args;
        ref.value = value;
    }
    if (args.length === 3) {
        const [target, key, value] = args;
        target[key] = value;
    }
}
function $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, options = {}) {
    const { eventFilter: eventFilter = $bc6380c684a2e15a$export$8cc0e33a27868391, ...watchOptions } = options;
    return (0, $01W3b.watch)(source, $bc6380c684a2e15a$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
function $bc6380c684a2e15a$export$37fdf671f882195e(source, cb, options = {}) {
    const { eventFilter: filter, initialState: initialState = "active", ...watchOptions } = options;
    const { eventFilter: eventFilter, pause: pause, resume: resume, isActive: isActive } = $bc6380c684a2e15a$export$8d46ce8e0ead9c2b(filter, {
        initialState: initialState
    });
    const stop = $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: eventFilter
    });
    return {
        stop: stop,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $bc6380c684a2e15a$export$d43743c1df800be0(left, right, ...[options]) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true, direction: direction = "both", transform: transform = {} } = options || {};
    const watchers = [];
    const transformLTR = "ltr" in transform && transform.ltr || ((v)=>v);
    const transformRTL = "rtl" in transform && transform.rtl || ((v)=>v);
    if (direction === "both" || direction === "ltr") watchers.push($bc6380c684a2e15a$export$37fdf671f882195e(left, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        right.value = transformLTR(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    if (direction === "both" || direction === "rtl") watchers.push($bc6380c684a2e15a$export$37fdf671f882195e(right, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        left.value = transformRTL(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    const stop = ()=>{
        watchers.forEach((w)=>w.stop());
    };
    return stop;
}
function $bc6380c684a2e15a$export$16a582ae8a437df6(source, targets, options = {}) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true } = options;
    const targetsArray = $bc6380c684a2e15a$export$45b10814cc054894(targets);
    return (0, $01W3b.watch)(source, (newValue)=>targetsArray.forEach((target)=>target.value = newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
function $bc6380c684a2e15a$export$2e9533675e5e70e0(objectRef, options = {}) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.toRefs)(objectRef);
    const result = Array.isArray(objectRef.value) ? Array.from({
        length: objectRef.value.length
    }) : {};
    for(const key in objectRef.value)result[key] = (0, $01W3b.customRef)(()=>({
            get () {
                return objectRef.value[key];
            },
            set (v) {
                var _a;
                const replaceRef = (_a = (0, $01W3b.toValue)(options.replaceRef)) != null ? _a : true;
                if (replaceRef) {
                    if (Array.isArray(objectRef.value)) {
                        const copy = [
                            ...objectRef.value
                        ];
                        copy[key] = v;
                        objectRef.value = copy;
                    } else {
                        const newObject = {
                            ...objectRef.value,
                            [key]: v
                        };
                        Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                        objectRef.value = newObject;
                    }
                } else objectRef.value[key] = v;
            }
        }));
    return result;
}
const $bc6380c684a2e15a$export$30bdcc2218aa9458 = (0, $01W3b.toValue);
const $bc6380c684a2e15a$export$13fbab860e8afb41 = (0, $01W3b.toValue);
function $bc6380c684a2e15a$export$25180f6b7105226e(fn, sync = true, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onBeforeMount)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
function $bc6380c684a2e15a$export$7b037ce8d7969c15(fn, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onBeforeUnmount)(fn, target);
}
function $bc6380c684a2e15a$export$cf1be5b643f0827(fn, sync = true, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c();
    if (instance) (0, $TusQn.onMounted)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
function $bc6380c684a2e15a$export$9fa6e59ca833c930(fn, target) {
    const instance = $bc6380c684a2e15a$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onUnmounted)(fn, target);
}
function $bc6380c684a2e15a$var$createUntil(r, isNot = false) {
    function toMatch(condition, { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = {}) {
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $01W3b.watch)(r, (v)=>{
                if (condition(v) !== isNot) {
                    if (stop) stop();
                    else (0, $TusQn.nextTick)(()=>stop == null ? void 0 : stop());
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($bc6380c684a2e15a$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>(0, $01W3b.toValue)(r)).finally(()=>stop == null ? void 0 : stop()));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $01W3b.isRef)(value)) return toMatch((v)=>v === value, options);
        const { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = options != null ? options : {};
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $01W3b.watch)([
                r,
                value
            ], ([v1, v2])=>{
                if (isNot !== (v1 === v2)) {
                    if (stop) stop();
                    else (0, $TusQn.nextTick)(()=>stop == null ? void 0 : stop());
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($bc6380c684a2e15a$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>(0, $01W3b.toValue)(r)).finally(()=>{
            stop == null || stop();
            return (0, $01W3b.toValue)(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch((v)=>Boolean(v), options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch((v)=>{
            const array = Array.from(v);
            return array.includes(value) || array.includes((0, $01W3b.toValue)(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n = 1, options) {
        let count = -1;
        return toMatch(()=>{
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray((0, $01W3b.toValue)(r))) {
        const instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $bc6380c684a2e15a$var$createUntil(r, !isNot);
            }
        };
        return instance;
    } else {
        const instance = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $bc6380c684a2e15a$var$createUntil(r, !isNot);
            }
        };
        return instance;
    }
}
function $bc6380c684a2e15a$export$a40009bd2c363351(r) {
    return $bc6380c684a2e15a$var$createUntil(r);
}
function $bc6380c684a2e15a$var$defaultComparator(value, othVal) {
    return value === othVal;
}
function $bc6380c684a2e15a$export$34602ebc410e389c(...args) {
    var _a, _b;
    const list = args[0];
    const values = args[1];
    let compareFn = (_a = args[2]) != null ? _a : $bc6380c684a2e15a$var$defaultComparator;
    const { symmetric: symmetric = false } = (_b = args[3]) != null ? _b : {};
    if (typeof compareFn === "string") {
        const key = compareFn;
        compareFn = (value, othVal)=>value[key] === othVal[key];
    }
    const diff1 = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).filter((x)=>(0, $01W3b.toValue)(values).findIndex((y)=>compareFn(x, y)) === -1));
    if (symmetric) {
        const diff2 = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(values).filter((x)=>(0, $01W3b.toValue)(list).findIndex((y)=>compareFn(x, y)) === -1));
        return (0, $01W3b.computed)(()=>symmetric ? [
                ...(0, $01W3b.toValue)(diff1),
                ...(0, $01W3b.toValue)(diff2)
            ] : (0, $01W3b.toValue)(diff1));
    } else return diff1;
}
function $bc6380c684a2e15a$export$1e5a400faddb345f(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).every((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
function $bc6380c684a2e15a$export$d62e4083f0a2d244(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).filter(fn));
}
function $bc6380c684a2e15a$export$ace4ef07c63f605e(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)((0, $01W3b.toValue)(list).find((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array))));
}
function $bc6380c684a2e15a$export$3ec066cdb63e2970(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).findIndex((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
function $bc6380c684a2e15a$var$findLast(arr, cb) {
    let index = arr.length;
    while(index-- > 0){
        if (cb(arr[index], index, arr)) return arr[index];
    }
    return void 0;
}
function $bc6380c684a2e15a$export$b59cd47693a134f7(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(!Array.prototype.findLast ? $bc6380c684a2e15a$var$findLast((0, $01W3b.toValue)(list), (element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)) : (0, $01W3b.toValue)(list).findLast((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array))));
}
function $bc6380c684a2e15a$var$isArrayIncludesOptions(obj) {
    return $bc6380c684a2e15a$export$a6cdc56e425d0d0a(obj) && $bc6380c684a2e15a$export$d138bf93e1dfa23f(obj, "formIndex", "comparator");
}
function $bc6380c684a2e15a$export$34f006a38543d952(...args) {
    var _a;
    const list = args[0];
    const value = args[1];
    let comparator = args[2];
    let formIndex = 0;
    if ($bc6380c684a2e15a$var$isArrayIncludesOptions(comparator)) {
        formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        const key = comparator;
        comparator = (element, value2)=>element[key] === (0, $01W3b.toValue)(value2);
    }
    comparator = comparator != null ? comparator : (element, value2)=>element === (0, $01W3b.toValue)(value2);
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).slice(formIndex).some((element, index, array)=>comparator((0, $01W3b.toValue)(element), (0, $01W3b.toValue)(value), index, (0, $01W3b.toValue)(array))));
}
function $bc6380c684a2e15a$export$4a02928bbff39848(list, separator) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).join((0, $01W3b.toValue)(separator)));
}
function $bc6380c684a2e15a$export$8cc4758f083c4ffe(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).map(fn));
}
function $bc6380c684a2e15a$export$2a4c0ee40e3400de(list, reducer, ...args) {
    const reduceCallback = (sum, value, index)=>reducer((0, $01W3b.toValue)(sum), (0, $01W3b.toValue)(value), index);
    return (0, $01W3b.computed)(()=>{
        const resolved = (0, $01W3b.toValue)(list);
        return args.length ? resolved.reduce(reduceCallback, typeof args[0] === "function" ? (0, $01W3b.toValue)(args[0]()) : (0, $01W3b.toValue)(args[0])) : resolved.reduce(reduceCallback);
    });
}
function $bc6380c684a2e15a$export$53834b0e1a20e7a3(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).some((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
function $bc6380c684a2e15a$var$uniq(array) {
    return Array.from(new Set(array));
}
function $bc6380c684a2e15a$var$uniqueElementsBy(array, fn) {
    return array.reduce((acc, v)=>{
        if (!acc.some((x)=>fn(v, x, array))) acc.push(v);
        return acc;
    }, []);
}
function $bc6380c684a2e15a$export$1b97ec936c2f7d03(list, compareFn) {
    return (0, $01W3b.computed)(()=>{
        const resolvedList = (0, $01W3b.toValue)(list).map((element)=>(0, $01W3b.toValue)(element));
        return compareFn ? $bc6380c684a2e15a$var$uniqueElementsBy(resolvedList, compareFn) : $bc6380c684a2e15a$var$uniq(resolvedList);
    });
}
function $bc6380c684a2e15a$export$70c4067197c60e2d(initialValue = 0, options = {}) {
    let _initialValue = (0, $01W3b.unref)(initialValue);
    const count = (0, $01W3b.shallowRef)(initialValue);
    const { max: max = Number.POSITIVE_INFINITY, min: min = Number.NEGATIVE_INFINITY } = options;
    const inc = (delta = 1)=>count.value = Math.max(Math.min(max, count.value + delta), min);
    const dec = (delta = 1)=>count.value = Math.min(Math.max(min, count.value - delta), max);
    const get = ()=>count.value;
    const set = (val)=>count.value = Math.max(min, Math.min(max, val));
    const reset = (val = _initialValue)=>{
        _initialValue = val;
        return set(val);
    };
    return {
        count: count,
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
const $bc6380c684a2e15a$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[T\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/i;
const $bc6380c684a2e15a$var$REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)\]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|z{1,4}|SSS/g;
function $bc6380c684a2e15a$var$defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    let m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce((acc, curr)=>acc += `${curr}.`, "");
    return isLowercase ? m.toLowerCase() : m;
}
function $bc6380c684a2e15a$var$formatOrdinal(num) {
    const suffixes = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function $bc6380c684a2e15a$export$3ae94a2503e890a1(date, formatStr, options = {}) {
    var _a;
    const years = date.getFullYear();
    const month = date.getMonth();
    const days = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const day = date.getDay();
    const meridiem = (_a = options.customMeridiem) != null ? _a : $bc6380c684a2e15a$var$defaultMeridiem;
    const stripTimeZone = (dateString)=>{
        var _a2;
        return (_a2 = dateString.split(" ")[1]) != null ? _a2 : "";
    };
    const matches = {
        Yo: ()=>$bc6380c684a2e15a$var$formatOrdinal(years),
        YY: ()=>String(years).slice(-2),
        YYYY: ()=>years,
        M: ()=>month + 1,
        Mo: ()=>$bc6380c684a2e15a$var$formatOrdinal(month + 1),
        MM: ()=>`${month + 1}`.padStart(2, "0"),
        MMM: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                month: "short"
            }),
        MMMM: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                month: "long"
            }),
        D: ()=>String(days),
        Do: ()=>$bc6380c684a2e15a$var$formatOrdinal(days),
        DD: ()=>`${days}`.padStart(2, "0"),
        H: ()=>String(hours),
        Ho: ()=>$bc6380c684a2e15a$var$formatOrdinal(hours),
        HH: ()=>`${hours}`.padStart(2, "0"),
        h: ()=>`${hours % 12 || 12}`.padStart(1, "0"),
        ho: ()=>$bc6380c684a2e15a$var$formatOrdinal(hours % 12 || 12),
        hh: ()=>`${hours % 12 || 12}`.padStart(2, "0"),
        m: ()=>String(minutes),
        mo: ()=>$bc6380c684a2e15a$var$formatOrdinal(minutes),
        mm: ()=>`${minutes}`.padStart(2, "0"),
        s: ()=>String(seconds),
        so: ()=>$bc6380c684a2e15a$var$formatOrdinal(seconds),
        ss: ()=>`${seconds}`.padStart(2, "0"),
        SSS: ()=>`${milliseconds}`.padStart(3, "0"),
        d: ()=>day,
        dd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "narrow"
            }),
        ddd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "short"
            }),
        dddd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "long"
            }),
        A: ()=>meridiem(hours, minutes),
        AA: ()=>meridiem(hours, minutes, false, true),
        a: ()=>meridiem(hours, minutes, true),
        aa: ()=>meridiem(hours, minutes, true, true),
        z: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zzz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zzzz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "longOffset"
            }))
    };
    return formatStr.replace($bc6380c684a2e15a$var$REGEX_FORMAT, (match, $1)=>{
        var _a2, _b;
        return (_b = $1 != null ? $1 : (_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) != null ? _b : match;
    });
}
function $bc6380c684a2e15a$export$fcc71269590ba0a8(date) {
    if (date === null) return new Date(Number.NaN);
    if (date === void 0) return /* @__PURE__ */ new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        const d = date.match($bc6380c684a2e15a$var$REGEX_PARSE);
        if (d) {
            const m = d[2] - 1 || 0;
            const ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
function $bc6380c684a2e15a$export$6d181172004bc6fc(date, formatStr = "HH:mm:ss", options = {}) {
    return (0, $01W3b.computed)(()=>$bc6380c684a2e15a$export$3ae94a2503e890a1($bc6380c684a2e15a$export$fcc71269590ba0a8((0, $01W3b.toValue)(date)), (0, $01W3b.toValue)(formatStr), options));
}
function $bc6380c684a2e15a$export$35ee30a05e4f2223(cb, interval = 1e3, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    let timer = null;
    const isActive = (0, $01W3b.shallowRef)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        const intervalValue = (0, $01W3b.toValue)(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        if (isActive.value) timer = setInterval(cb, intervalValue);
    }
    if (immediate && $bc6380c684a2e15a$export$7383f122bf48ec30) resume();
    if ((0, $01W3b.isRef)(interval) || typeof interval === "function") {
        const stopWatch = (0, $01W3b.watch)(interval, ()=>{
            if (isActive.value && $bc6380c684a2e15a$export$7383f122bf48ec30) resume();
        });
        $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(stopWatch);
    }
    $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $bc6380c684a2e15a$export$f4b266cd2aae9cb1(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, immediate: immediate = true, callback: callback } = options;
    const counter = (0, $01W3b.shallowRef)(0);
    const update = ()=>counter.value += 1;
    const reset = ()=>{
        counter.value = 0;
    };
    const controls = $bc6380c684a2e15a$export$35ee30a05e4f2223(callback ? ()=>{
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        counter: counter,
        reset: reset,
        ...controls
    };
    else return counter;
}
function $bc6380c684a2e15a$export$de385d6f89d6db3c(source, options = {}) {
    var _a;
    const ms = (0, $01W3b.shallowRef)((_a = options.initialValue) != null ? _a : null);
    (0, $01W3b.watch)(source, ()=>ms.value = $bc6380c684a2e15a$export$fc00ee57782020aa(), options);
    return ms;
}
function $bc6380c684a2e15a$export$14705c14c13d528a(cb, interval, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    const isPending = (0, $01W3b.shallowRef)(false);
    let timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start(...args) {
        if (immediateCallback) cb();
        clear();
        isPending.value = true;
        timer = setTimeout(()=>{
            isPending.value = false;
            timer = null;
            cb(...args);
        }, (0, $01W3b.toValue)(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($bc6380c684a2e15a$export$7383f122bf48ec30) start();
    }
    $bc6380c684a2e15a$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $01W3b.readonly)(isPending),
        start: start,
        stop: stop
    };
}
function $bc6380c684a2e15a$export$d8e6abf214c9ec0f(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, callback: callback } = options;
    const controls = $bc6380c684a2e15a$export$14705c14c13d528a(callback != null ? callback : $bc6380c684a2e15a$export$8793edee2d425525, interval, options);
    const ready = (0, $01W3b.computed)(()=>!controls.isPending.value);
    if (exposeControls) return {
        ready: ready,
        ...controls
    };
    else return ready;
}
function $bc6380c684a2e15a$export$1ee6bb1f922f50b3(value, options = {}) {
    const { method: method = "parseFloat", radix: radix, nanToZero: nanToZero } = options;
    return (0, $01W3b.computed)(()=>{
        let resolved = (0, $01W3b.toValue)(value);
        if (typeof method === "function") resolved = method(resolved);
        else if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
function $bc6380c684a2e15a$export$8906942fea47e698(value) {
    return (0, $01W3b.computed)(()=>`${(0, $01W3b.toValue)(value)}`);
}
function $bc6380c684a2e15a$export$cbe85ee05b554577(initialValue = false, options = {}) {
    const { truthyValue: truthyValue = true, falsyValue: falsyValue = false } = options;
    const valueIsRef = (0, $01W3b.isRef)(initialValue);
    const _value = (0, $01W3b.shallowRef)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            const truthy = (0, $01W3b.toValue)(truthyValue);
            _value.value = _value.value === truthy ? (0, $01W3b.toValue)(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
function $bc6380c684a2e15a$export$8ebd2befe4deaa6b(source, cb, options) {
    let oldList = (options == null ? void 0 : options.immediate) ? [] : [
        ...typeof source === "function" ? source() : Array.isArray(source) ? source : (0, $01W3b.toValue)(source)
    ];
    return (0, $01W3b.watch)(source, (newList, _, onCleanup)=>{
        const oldListRemains = Array.from({
            length: oldList.length
        });
        const added = [];
        for (const obj of newList){
            let found = false;
            for(let i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                oldListRemains[i] = true;
                found = true;
                break;
            }
            if (!found) added.push(obj);
        }
        const removed = oldList.filter((_2, i)=>!oldListRemains[i]);
        cb(newList, oldList, added, removed, onCleanup);
        oldList = [
            ...newList
        ];
    }, options);
}
function $bc6380c684a2e15a$export$a121c3bc1a97f0b4(source, cb, options) {
    const { count: count, ...watchOptions } = options;
    const current = (0, $01W3b.shallowRef)(0);
    const stop = $bc6380c684a2e15a$export$3955c00bb6715986(source, (...args)=>{
        current.value += 1;
        if (current.value >= (0, $01W3b.toValue)(count)) (0, $TusQn.nextTick)(()=>stop());
        cb(...args);
    }, watchOptions);
    return {
        count: current,
        stop: stop
    };
}
function $bc6380c684a2e15a$export$578b5d9cbe132cee(source, cb, options = {}) {
    const { debounce: debounce = 0, maxWait: maxWait, ...watchOptions } = options;
    return $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $bc6380c684a2e15a$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    });
}
function $bc6380c684a2e15a$export$79f242cf85fb93a(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        deep: true
    });
}
function $bc6380c684a2e15a$export$63ac06655f58d92a(source, cb, options = {}) {
    const { eventFilter: eventFilter = $bc6380c684a2e15a$export$8cc0e33a27868391, ...watchOptions } = options;
    const filteredCb = $bc6380c684a2e15a$export$a1f1cf91007f23bf(eventFilter, cb);
    let ignoreUpdates;
    let ignorePrevAsyncUpdates;
    let stop;
    if (watchOptions.flush === "sync") {
        const ignore = (0, $01W3b.shallowRef)(false);
        ignorePrevAsyncUpdates = ()=>{};
        ignoreUpdates = (updater)=>{
            ignore.value = true;
            updater();
            ignore.value = false;
        };
        stop = (0, $01W3b.watch)(source, (...args)=>{
            if (!ignore.value) filteredCb(...args);
        }, watchOptions);
    } else {
        const disposables = [];
        const ignoreCounter = (0, $01W3b.shallowRef)(0);
        const syncCounter = (0, $01W3b.shallowRef)(0);
        ignorePrevAsyncUpdates = ()=>{
            ignoreCounter.value = syncCounter.value;
        };
        disposables.push((0, $01W3b.watch)(source, ()=>{
            syncCounter.value++;
        }, {
            ...watchOptions,
            flush: "sync"
        }));
        ignoreUpdates = (updater)=>{
            const syncCounterPrev = syncCounter.value;
            updater();
            ignoreCounter.value += syncCounter.value - syncCounterPrev;
        };
        disposables.push((0, $01W3b.watch)(source, (...args)=>{
            const ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
            ignoreCounter.value = 0;
            syncCounter.value = 0;
            if (ignore) return;
            filteredCb(...args);
        }, watchOptions));
        stop = ()=>{
            disposables.forEach((fn)=>fn());
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
function $bc6380c684a2e15a$export$d9aec7ec4e8a1634(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        immediate: true
    });
}
function $bc6380c684a2e15a$export$95d4a8ca30b80ae0(source, cb, options) {
    const stop = (0, $01W3b.watch)(source, (...args)=>{
        (0, $TusQn.nextTick)(()=>stop());
        return cb(...args);
    }, options);
    return stop;
}
function $bc6380c684a2e15a$export$2768dce732d5eb3(source, cb, options = {}) {
    const { throttle: throttle = 0, trailing: trailing = true, leading: leading = true, ...watchOptions } = options;
    return $bc6380c684a2e15a$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $bc6380c684a2e15a$export$cd62e9dbf204fd92(throttle, trailing, leading)
    });
}
function $bc6380c684a2e15a$export$b75c094d1092c205(source, cb, options = {}) {
    let cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        const fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    const _cb = (value, oldValue)=>{
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    const res = $bc6380c684a2e15a$export$63ac06655f58d92a(source, _cb, options);
    const { ignoreUpdates: ignoreUpdates } = res;
    const trigger = ()=>{
        let res2;
        ignoreUpdates(()=>{
            res2 = _cb($bc6380c684a2e15a$var$getWatchSources(source), $bc6380c684a2e15a$var$getOldValue(source));
        });
        return res2;
    };
    return {
        ...res,
        trigger: trigger
    };
}
function $bc6380c684a2e15a$var$getWatchSources(sources) {
    if ((0, $01W3b.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map((item)=>(0, $01W3b.toValue)(item));
    return (0, $01W3b.toValue)(sources);
}
function $bc6380c684a2e15a$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(()=>void 0) : void 0;
}
function $bc6380c684a2e15a$export$909eba9696cc3445(source, cb, options) {
    const stop = (0, $01W3b.watch)(source, (v, ov, onInvalidate)=>{
        if (v) {
            if (options == null ? void 0 : options.once) (0, $TusQn.nextTick)(()=>stop());
            cb(v, ov, onInvalidate);
        }
    }, {
        ...options,
        once: false
    });
    return stop;
}

});


parcelRegister("apRgG", function(module, exports) {

$parcel$export(module.exports, "useRouteQuery", () => $b70067cd5c3f61c4$export$b3d7760d9ef6752e);

var $awjGF = parcelRequire("awjGF");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");
let $b70067cd5c3f61c4$var$_hash;
function $b70067cd5c3f61c4$export$31893124eb4bb712(defaultValue, { mode: mode = "replace", route: route = (0, $73mM4.useRoute)(), router: router = (0, $73mM4.useRouter)() } = {}) {
    $b70067cd5c3f61c4$var$_hash = route.hash;
    (0, $awjGF.tryOnScopeDispose)(()=>{
        $b70067cd5c3f61c4$var$_hash = void 0;
    });
    let _trigger;
    const proxy = (0, $01W3b.customRef)((track, trigger)=>{
        _trigger = trigger;
        return {
            get () {
                track();
                return $b70067cd5c3f61c4$var$_hash || (0, $01W3b.toValue)(defaultValue);
            },
            set (v) {
                if (v === $b70067cd5c3f61c4$var$_hash) return;
                $b70067cd5c3f61c4$var$_hash = v === null ? void 0 : v;
                trigger();
                (0, $TusQn.nextTick)(()=>{
                    const { params: params, query: query } = route;
                    router[(0, $01W3b.toValue)(mode)]({
                        params: params,
                        query: query,
                        hash: $b70067cd5c3f61c4$var$_hash
                    });
                });
            }
        };
    });
    (0, $01W3b.watch)(()=>route.hash, ()=>{
        if (route.hash === $b70067cd5c3f61c4$var$_hash) return;
        $b70067cd5c3f61c4$var$_hash = route.hash;
        _trigger();
    }, {
        flush: "sync"
    });
    return proxy;
}
const $b70067cd5c3f61c4$var$_queue$1 = /* @__PURE__ */ new WeakMap();
function $b70067cd5c3f61c4$export$1f9b870ad76091(name, defaultValue, options = {}) {
    const { mode: mode = "replace", route: route = (0, $73mM4.useRoute)(), router: router = (0, $73mM4.useRouter)(), transform: transform } = options;
    let transformGet = (value)=>value;
    let transformSet = (value)=>value;
    if (typeof transform === "function") transformGet = transform;
    else if (transform) {
        if (transform.get) transformGet = transform.get;
        if (transform.set) transformSet = transform.set;
    }
    if (!$b70067cd5c3f61c4$var$_queue$1.has(router)) $b70067cd5c3f61c4$var$_queue$1.set(router, /* @__PURE__ */ new Map());
    const _paramsQueue = $b70067cd5c3f61c4$var$_queue$1.get(router);
    let param = route.params[name];
    (0, $awjGF.tryOnScopeDispose)(()=>{
        param = void 0;
    });
    let _trigger;
    const proxy = (0, $01W3b.customRef)((track, trigger)=>{
        _trigger = trigger;
        return {
            get () {
                track();
                return transformGet(param !== void 0 && param !== "" ? param : (0, $01W3b.toValue)(defaultValue));
            },
            set (v) {
                v = transformSet(v);
                if (param === v) return;
                param = v === (0, $01W3b.toValue)(defaultValue) || v === null ? void 0 : v;
                _paramsQueue.set(name, v === (0, $01W3b.toValue)(defaultValue) || v === null ? void 0 : v);
                trigger();
                (0, $TusQn.nextTick)(()=>{
                    if (_paramsQueue.size === 0) return;
                    const newParams = Object.fromEntries(_paramsQueue.entries());
                    _paramsQueue.clear();
                    const { params: params, query: query, hash: hash } = route;
                    router[(0, $01W3b.toValue)(mode)]({
                        params: {
                            ...params,
                            ...newParams
                        },
                        query: query,
                        hash: hash
                    });
                });
            }
        };
    });
    (0, $01W3b.watch)(()=>route.params[name], (v)=>{
        if (param === transformGet(v)) return;
        param = v;
        _trigger();
    }, {
        flush: "sync"
    });
    return proxy;
}
const $b70067cd5c3f61c4$var$_queue = /* @__PURE__ */ new WeakMap();
function $b70067cd5c3f61c4$export$b3d7760d9ef6752e(name, defaultValue, options = {}) {
    const { mode: mode = "replace", route: route = (0, $73mM4.useRoute)(), router: router = (0, $73mM4.useRouter)(), transform: transform } = options;
    let transformGet = (value)=>value;
    let transformSet = (value)=>value;
    if (typeof transform === "function") transformGet = transform;
    else if (transform) {
        if (transform.get) transformGet = transform.get;
        if (transform.set) transformSet = transform.set;
    }
    if (!$b70067cd5c3f61c4$var$_queue.has(router)) $b70067cd5c3f61c4$var$_queue.set(router, /* @__PURE__ */ new Map());
    const _queriesQueue = $b70067cd5c3f61c4$var$_queue.get(router);
    let query = route.query[name];
    (0, $awjGF.tryOnScopeDispose)(()=>{
        query = void 0;
    });
    let _trigger;
    const proxy = (0, $01W3b.customRef)((track, trigger)=>{
        _trigger = trigger;
        return {
            get () {
                track();
                return transformGet(query !== void 0 ? query : (0, $01W3b.toValue)(defaultValue));
            },
            set (v) {
                v = transformSet(v);
                if (query === v) return;
                query = v === (0, $01W3b.toValue)(defaultValue) ? void 0 : v;
                _queriesQueue.set(name, v === (0, $01W3b.toValue)(defaultValue) ? void 0 : v);
                trigger();
                (0, $TusQn.nextTick)(()=>{
                    if (_queriesQueue.size === 0) return;
                    const newQueries = Object.fromEntries(_queriesQueue.entries());
                    _queriesQueue.clear();
                    const { params: params, query: query2, hash: hash } = route;
                    router[(0, $01W3b.toValue)(mode)]({
                        params: params,
                        query: {
                            ...query2,
                            ...newQueries
                        },
                        hash: hash
                    });
                });
            }
        };
    });
    (0, $01W3b.watch)(()=>route.query[name], (v)=>{
        if (query === transformGet(v)) return;
        query = v;
        _trigger();
    }, {
        flush: "sync"
    });
    return proxy;
}

});
parcelRegister("awjGF", function(module, exports) {

$parcel$export(module.exports, "tryOnScopeDispose", () => $2c539f0759d9aba1$export$c3d49ae4e58d3d9d);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
function $2c539f0759d9aba1$export$c92323792c35f5f1(fn, options) {
    var _a;
    const result = (0, $01W3b.shallowRef)();
    (0, $TusQn.watchEffect)(()=>{
        result.value = fn();
    }, {
        ...options,
        flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
    });
    return (0, $01W3b.readonly)(result);
}
function $2c539f0759d9aba1$export$220dfb31330e2956(source, fn) {
    let v = void 0;
    let track;
    let trigger;
    const dirty = (0, $01W3b.shallowRef)(true);
    const update = ()=>{
        dirty.value = true;
        trigger();
    };
    (0, $01W3b.watch)(source, update, {
        flush: "sync"
    });
    const get = typeof fn === "function" ? fn : fn.get;
    const set = typeof fn === "function" ? void 0 : fn.set;
    const result = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                if (dirty.value) {
                    v = get(v);
                    dirty.value = false;
                }
                track();
                return v;
            },
            set (v2) {
                set == null || set(v2);
            }
        };
    });
    if (Object.isExtensible(result)) result.trigger = update;
    return result;
}
function $2c539f0759d9aba1$export$c3d49ae4e58d3d9d(fn) {
    if ((0, $01W3b.getCurrentScope)()) {
        (0, $01W3b.onScopeDispose)(fn);
        return true;
    }
    return false;
}
function $2c539f0759d9aba1$export$c8b3b0996d763ee() {
    const fns = /* @__PURE__ */ new Set();
    const off = (fn)=>{
        fns.delete(fn);
    };
    const clear = ()=>{
        fns.clear();
    };
    const on = (fn)=>{
        fns.add(fn);
        const offFn = ()=>off(fn);
        $2c539f0759d9aba1$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    const trigger = (...args)=>{
        return Promise.all(Array.from(fns).map((fn)=>fn(...args)));
    };
    return {
        on: on,
        off: off,
        trigger: trigger,
        clear: clear
    };
}
function $2c539f0759d9aba1$export$aa9aac23b3959ee1(stateFactory) {
    let initialized = false;
    let state;
    const scope = (0, $01W3b.effectScope)(true);
    return (...args)=>{
        if (!initialized) {
            state = scope.run(()=>stateFactory(...args));
            initialized = true;
        }
        return state;
    };
}
const $2c539f0759d9aba1$var$localProvidedStateMap = /* @__PURE__ */ new WeakMap();
const $2c539f0759d9aba1$export$89897216f9bf9933 = (...args)=>{
    var _a;
    const key = args[0];
    const instance = (_a = (0, $TusQn.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null && !(0, $TusQn.hasInjectionContext)()) throw new Error("injectLocal must be called in setup");
    if (instance && $2c539f0759d9aba1$var$localProvidedStateMap.has(instance) && key in $2c539f0759d9aba1$var$localProvidedStateMap.get(instance)) return $2c539f0759d9aba1$var$localProvidedStateMap.get(instance)[key];
    return (0, $TusQn.inject)(...args);
};
function $2c539f0759d9aba1$export$a797c3886d31ed0(key, value) {
    var _a;
    const instance = (_a = (0, $TusQn.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("provideLocal must be called in setup");
    if (!$2c539f0759d9aba1$var$localProvidedStateMap.has(instance)) $2c539f0759d9aba1$var$localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
    const localProvidedState = $2c539f0759d9aba1$var$localProvidedStateMap.get(instance);
    localProvidedState[key] = value;
    return (0, $TusQn.provide)(key, value);
}
function $2c539f0759d9aba1$export$91b9c7550061230e(composable, options) {
    const key = (options == null ? void 0 : options.injectionKey) || Symbol(composable.name || "InjectionState");
    const defaultValue = options == null ? void 0 : options.defaultValue;
    const useProvidingState = (...args)=>{
        const state = composable(...args);
        $2c539f0759d9aba1$export$a797c3886d31ed0(key, state);
        return state;
    };
    const useInjectedState = ()=>$2c539f0759d9aba1$export$89897216f9bf9933(key, defaultValue);
    return [
        useProvidingState,
        useInjectedState
    ];
}
function $2c539f0759d9aba1$export$7d1e3a5e95ceca43(value, deep) {
    if (deep === true) return (0, $01W3b.ref)(value);
    else return (0, $01W3b.shallowRef)(value);
}
function $2c539f0759d9aba1$export$9e8d4b001a1bb310(composable) {
    let subscribers = 0;
    let state;
    let scope;
    const dispose = ()=>{
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return (...args)=>{
        subscribers += 1;
        if (!scope) {
            scope = (0, $01W3b.effectScope)(true);
            state = scope.run(()=>composable(...args));
        }
        $2c539f0759d9aba1$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
function $2c539f0759d9aba1$export$ecda8b07a1b5deab(ref, extend, { enumerable: enumerable = false, unwrap: unwrap = true } = {}) {
    for (const [key, value] of Object.entries(extend)){
        if (key === "value") continue;
        if ((0, $01W3b.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
            get () {
                return value.value;
            },
            set (v) {
                value.value = v;
            },
            enumerable: enumerable
        });
        else Object.defineProperty(ref, key, {
            value: value,
            enumerable: enumerable
        });
    }
    return ref;
}
function $2c539f0759d9aba1$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $01W3b.unref)(obj);
    return (0, $01W3b.unref)(obj)[key];
}
function $2c539f0759d9aba1$export$4e62c701997796c1(v) {
    return (0, $01W3b.unref)(v) != null;
}
function $2c539f0759d9aba1$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        const clone = {
            ...obj
        };
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value () {
                let index = 0;
                return {
                    next: ()=>({
                            value: arr[index++],
                            done: index > arr.length
                        })
                };
            }
        });
        return clone;
    } else return Object.assign([
        ...arr
    ], obj);
}
function $2c539f0759d9aba1$export$4ba03523724ba2d7(fn, options) {
    const unrefFn = (options == null ? void 0 : options.computedGetter) === false ? (0, $01W3b.unref) : (0, $01W3b.toValue);
    return function(...args) {
        return (0, $01W3b.computed)(()=>fn.apply(this, args.map((i)=>unrefFn(i))));
    };
}
function $2c539f0759d9aba1$export$1ff2e29423610e60(obj, optionsOrKeys = {}) {
    let keys = [];
    let options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        options = optionsOrKeys;
        const { includeOwnProperties: includeOwnProperties = true } = optionsOrKeys;
        keys.push(...Object.keys(obj));
        if (includeOwnProperties) keys.push(...Object.getOwnPropertyNames(obj));
    }
    return Object.fromEntries(keys.map((key)=>{
        const value = obj[key];
        return [
            key,
            typeof value === "function" ? $2c539f0759d9aba1$export$4ba03523724ba2d7(value.bind(obj), options) : value
        ];
    }));
}
function $2c539f0759d9aba1$export$45c769cf449a508c(objectRef) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.reactive)(objectRef);
    const proxy = new Proxy({}, {
        get (_, p, receiver) {
            return (0, $01W3b.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set (_, p, value) {
            if ((0, $01W3b.isRef)(objectRef.value[p]) && !(0, $01W3b.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return (0, $01W3b.reactive)(proxy);
}
function $2c539f0759d9aba1$export$35298289c11958e1(fn) {
    return $2c539f0759d9aba1$export$45c769cf449a508c((0, $01W3b.computed)(fn));
}
function $2c539f0759d9aba1$export$797deb43a681bdd1(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $2c539f0759d9aba1$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>!predicate((0, $01W3b.toValue)(v), k))) : Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter((e)=>!flatKeys.includes(e[0]))));
}
const $2c539f0759d9aba1$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof document !== "undefined";
const $2c539f0759d9aba1$export$3c901a5f01941a06 = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const $2c539f0759d9aba1$export$7b816c9b8ecf71b4 = (val)=>typeof val !== "undefined";
const $2c539f0759d9aba1$export$aedb69ff3e31596c = (val)=>val != null;
const $2c539f0759d9aba1$export$a7a9523472993e97 = (condition, ...infos)=>{
    if (!condition) console.warn(...infos);
};
const $2c539f0759d9aba1$var$toString = Object.prototype.toString;
const $2c539f0759d9aba1$export$a6cdc56e425d0d0a = (val)=>$2c539f0759d9aba1$var$toString.call(val) === "[object Object]";
const $2c539f0759d9aba1$export$461939dd4422153 = ()=>Date.now();
const $2c539f0759d9aba1$export$fc00ee57782020aa = ()=>+Date.now();
const $2c539f0759d9aba1$export$7d15b64cf5a3a4c4 = (n, min, max)=>Math.min(max, Math.max(min, n));
const $2c539f0759d9aba1$export$8793edee2d425525 = ()=>{};
const $2c539f0759d9aba1$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $2c539f0759d9aba1$export$b5a638e9b3fff9f3 = (val, key)=>Object.prototype.hasOwnProperty.call(val, key);
const $2c539f0759d9aba1$export$fedb369cb70207f1 = /* @__PURE__ */ $2c539f0759d9aba1$var$getIsIOS();
function $2c539f0759d9aba1$var$getIsIOS() {
    var _a, _b;
    return $2c539f0759d9aba1$export$7383f122bf48ec30 && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $2c539f0759d9aba1$export$1f60508e4f47b4b7(...args) {
    if (args.length !== 1) return (0, $01W3b.toRef)(...args);
    const r = args[0];
    return typeof r === "function" ? (0, $01W3b.readonly)((0, $01W3b.customRef)(()=>({
            get: r,
            set: $2c539f0759d9aba1$export$8793edee2d425525
        }))) : (0, $01W3b.ref)(r);
}
const $2c539f0759d9aba1$export$fb2b8a41d9966b32 = $2c539f0759d9aba1$export$1f60508e4f47b4b7;
function $2c539f0759d9aba1$export$afd74972d99a820f(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $2c539f0759d9aba1$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>predicate((0, $01W3b.toValue)(v), k))) : Object.fromEntries(flatKeys.map((k)=>[
                k,
                $2c539f0759d9aba1$export$1f60508e4f47b4b7(obj, k)
            ])));
}
function $2c539f0759d9aba1$export$c1f1e286df6cc58f(defaultValue, afterMs = 1e4) {
    return (0, $01W3b.customRef)((track, trigger)=>{
        let value = (0, $01W3b.toValue)(defaultValue);
        let timer;
        const resetAfter = ()=>setTimeout(()=>{
                value = (0, $01W3b.toValue)(defaultValue);
                trigger();
            }, (0, $01W3b.toValue)(afterMs));
        $2c539f0759d9aba1$export$c3d49ae4e58d3d9d(()=>{
            clearTimeout(timer);
        });
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function $2c539f0759d9aba1$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper(...args) {
        return new Promise((resolve, reject)=>{
            Promise.resolve(filter(()=>fn.apply(this, args), {
                fn: fn,
                thisArg: this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
const $2c539f0759d9aba1$export$8cc0e33a27868391 = (invoke)=>{
    return invoke();
};
function $2c539f0759d9aba1$export$fca2c450ae03b38e(ms, options = {}) {
    let timer;
    let maxTimer;
    let lastRejector = $2c539f0759d9aba1$export$8793edee2d425525;
    const _clearTimeout = (timer2)=>{
        clearTimeout(timer2);
        lastRejector();
        lastRejector = $2c539f0759d9aba1$export$8793edee2d425525;
    };
    let lastInvoker;
    const filter = (invoke)=>{
        const duration = (0, $01W3b.toValue)(ms);
        const maxDuration = (0, $01W3b.toValue)(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise((resolve, reject)=>{
            lastRejector = options.rejectOnCancel ? reject : resolve;
            lastInvoker = invoke;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(()=>{
                if (timer) _clearTimeout(timer);
                maxTimer = null;
                resolve(lastInvoker());
            }, maxDuration);
            timer = setTimeout(()=>{
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $2c539f0759d9aba1$export$cd62e9dbf204fd92(...args) {
    let lastExec = 0;
    let timer;
    let isLeading = true;
    let lastRejector = $2c539f0759d9aba1$export$8793edee2d425525;
    let lastValue;
    let ms;
    let trailing;
    let leading;
    let rejectOnCancel;
    if (!(0, $01W3b.isRef)(args[0]) && typeof args[0] === "object") ({ delay: ms, trailing: trailing = true, leading: leading = true, rejectOnCancel: rejectOnCancel = false } = args[0]);
    else [ms, trailing = true, leading = true, rejectOnCancel = false] = args;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $2c539f0759d9aba1$export$8793edee2d425525;
        }
    };
    const filter = (_invoke)=>{
        const duration = (0, $01W3b.toValue)(ms);
        const elapsed = Date.now() - lastExec;
        const invoke = ()=>{
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        } else if (trailing) lastValue = new Promise((resolve, reject)=>{
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(()=>{
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(()=>isLeading = true, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function $2c539f0759d9aba1$export$8d46ce8e0ead9c2b(extendFilter = $2c539f0759d9aba1$export$8cc0e33a27868391, options = {}) {
    const { initialState: initialState = "active" } = options;
    const isActive = $2c539f0759d9aba1$export$1f60508e4f47b4b7(initialState === "active");
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    const eventFilter = (...args)=>{
        if (isActive.value) extendFilter(...args);
    };
    return {
        isActive: (0, $01W3b.readonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
function $2c539f0759d9aba1$export$69e8b3daf72c74b7(ms, throwOnTimeout = false, reason = "Timeout") {
    return new Promise((resolve, reject)=>{
        if (throwOnTimeout) setTimeout(()=>reject(reason), ms);
        else setTimeout(resolve, ms);
    });
}
function $2c539f0759d9aba1$export$f0954fd7d5368655(arg) {
    return arg;
}
function $2c539f0759d9aba1$export$7a0c7c93e8e22bce(fn) {
    let _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = async ()=>{
        const _prev = _promise;
        _promise = void 0;
        if (_prev) await _prev;
    };
    return wrapper;
}
function $2c539f0759d9aba1$export$468cda29b159ee5d(fn) {
    return fn();
}
function $2c539f0759d9aba1$export$d138bf93e1dfa23f(obj, ...props) {
    return props.some((k)=>k in obj);
}
function $2c539f0759d9aba1$export$f5c97f6a04b90212(target, delta) {
    var _a;
    if (typeof target === "number") return target + delta;
    const value = ((_a = target.match(/^-?\d+\.?\d*/)) == null ? void 0 : _a[0]) || "";
    const unit = target.slice(value.length);
    const result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
function $2c539f0759d9aba1$export$e3ee541f3ff8ee70(px) {
    return px.endsWith("rem") ? Number.parseFloat(px) * 16 : Number.parseFloat(px);
}
function $2c539f0759d9aba1$export$5f2d71bd504be1ec(obj, keys, omitUndefined = false) {
    return keys.reduce((n, k)=>{
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
function $2c539f0759d9aba1$export$3320623908f24e40(obj, keys, omitUndefined = false) {
    return Object.fromEntries(Object.entries(obj).filter(([key, value])=>{
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function $2c539f0759d9aba1$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $2c539f0759d9aba1$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $2c539f0759d9aba1$var$cacheStringFunction(fn) {
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
const $2c539f0759d9aba1$var$hyphenateRE = /\B([A-Z])/g;
const $2c539f0759d9aba1$export$6e6a0a3676c4b8bb = $2c539f0759d9aba1$var$cacheStringFunction((str)=>str.replace($2c539f0759d9aba1$var$hyphenateRE, "-$1").toLowerCase());
const $2c539f0759d9aba1$var$camelizeRE = /-(\w)/g;
const $2c539f0759d9aba1$export$161d051f5dd25de7 = $2c539f0759d9aba1$var$cacheStringFunction((str)=>{
    return str.replace($2c539f0759d9aba1$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
function $2c539f0759d9aba1$export$5c967efe8efb656c(target) {
    return target || (0, $TusQn.getCurrentInstance)();
}
function $2c539f0759d9aba1$export$ddf8f1aa96b8ea88(fn, ms = 200, options = {}) {
    return $2c539f0759d9aba1$export$a1f1cf91007f23bf($2c539f0759d9aba1$export$fca2c450ae03b38e(ms, options), fn);
}
function $2c539f0759d9aba1$export$179967fbe3ecb41a(value, ms = 200, options = {}) {
    const debounced = (0, $01W3b.ref)((0, $01W3b.toValue)(value));
    const updater = $2c539f0759d9aba1$export$ddf8f1aa96b8ea88(()=>{
        debounced.value = value.value;
    }, ms, options);
    (0, $01W3b.watch)(value, ()=>updater());
    return (0, $01W3b.shallowReadonly)(debounced);
}
function $2c539f0759d9aba1$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $01W3b.computed)({
        get () {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set (value) {
            source.value = value;
        }
    });
}
function $2c539f0759d9aba1$export$8ed85856108010bc(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
    return $2c539f0759d9aba1$export$a1f1cf91007f23bf($2c539f0759d9aba1$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
function $2c539f0759d9aba1$export$4d1d638ad6b48495(value, delay = 200, trailing = true, leading = true) {
    if (delay <= 0) return value;
    const throttled = (0, $01W3b.ref)((0, $01W3b.toValue)(value));
    const updater = $2c539f0759d9aba1$export$8ed85856108010bc(()=>{
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $01W3b.watch)(value, ()=>updater());
    return throttled;
}
function $2c539f0759d9aba1$export$4b7f2010e13474b2(initial, options = {}) {
    let source = initial;
    let track;
    let trigger;
    const ref = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                return get();
            },
            set (v) {
                set(v);
            }
        };
    });
    function get(tracking = true) {
        if (tracking) track();
        return source;
    }
    function set(value, triggering = true) {
        var _a, _b;
        if (value === source) return;
        const old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
        source = value;
        (_b = options.onChanged) == null || _b.call(options, value, old);
        if (triggering) trigger();
    }
    const untrackedGet = ()=>get(false);
    const silentSet = (v)=>set(v, false);
    const peek = ()=>get(false);
    const lay = (v)=>set(v, false);
    return $2c539f0759d9aba1$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
const $2c539f0759d9aba1$export$6b6db3af7a80e2d2 = $2c539f0759d9aba1$export$4b7f2010e13474b2;
function $2c539f0759d9aba1$export$adaa4cf7ef1b65be(...args) {
    if (args.length === 2) {
        const [ref, value] = args;
        ref.value = value;
    }
    if (args.length === 3) {
        const [target, key, value] = args;
        target[key] = value;
    }
}
function $2c539f0759d9aba1$export$3955c00bb6715986(source, cb, options = {}) {
    const { eventFilter: eventFilter = $2c539f0759d9aba1$export$8cc0e33a27868391, ...watchOptions } = options;
    return (0, $01W3b.watch)(source, $2c539f0759d9aba1$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
function $2c539f0759d9aba1$export$37fdf671f882195e(source, cb, options = {}) {
    const { eventFilter: filter, initialState: initialState = "active", ...watchOptions } = options;
    const { eventFilter: eventFilter, pause: pause, resume: resume, isActive: isActive } = $2c539f0759d9aba1$export$8d46ce8e0ead9c2b(filter, {
        initialState: initialState
    });
    const stop = $2c539f0759d9aba1$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: eventFilter
    });
    return {
        stop: stop,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $2c539f0759d9aba1$export$d43743c1df800be0(left, right, ...[options]) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true, direction: direction = "both", transform: transform = {} } = options || {};
    const watchers = [];
    const transformLTR = "ltr" in transform && transform.ltr || ((v)=>v);
    const transformRTL = "rtl" in transform && transform.rtl || ((v)=>v);
    if (direction === "both" || direction === "ltr") watchers.push($2c539f0759d9aba1$export$37fdf671f882195e(left, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        right.value = transformLTR(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    if (direction === "both" || direction === "rtl") watchers.push($2c539f0759d9aba1$export$37fdf671f882195e(right, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        left.value = transformRTL(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    const stop = ()=>{
        watchers.forEach((w)=>w.stop());
    };
    return stop;
}
function $2c539f0759d9aba1$export$16a582ae8a437df6(source, targets, options = {}) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true } = options;
    const targetsArray = $2c539f0759d9aba1$export$45b10814cc054894(targets);
    return (0, $01W3b.watch)(source, (newValue)=>targetsArray.forEach((target)=>target.value = newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
function $2c539f0759d9aba1$export$2e9533675e5e70e0(objectRef, options = {}) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.toRefs)(objectRef);
    const result = Array.isArray(objectRef.value) ? Array.from({
        length: objectRef.value.length
    }) : {};
    for(const key in objectRef.value)result[key] = (0, $01W3b.customRef)(()=>({
            get () {
                return objectRef.value[key];
            },
            set (v) {
                var _a;
                const replaceRef = (_a = (0, $01W3b.toValue)(options.replaceRef)) != null ? _a : true;
                if (replaceRef) {
                    if (Array.isArray(objectRef.value)) {
                        const copy = [
                            ...objectRef.value
                        ];
                        copy[key] = v;
                        objectRef.value = copy;
                    } else {
                        const newObject = {
                            ...objectRef.value,
                            [key]: v
                        };
                        Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                        objectRef.value = newObject;
                    }
                } else objectRef.value[key] = v;
            }
        }));
    return result;
}
const $2c539f0759d9aba1$export$30bdcc2218aa9458 = (0, $01W3b.toValue);
const $2c539f0759d9aba1$export$13fbab860e8afb41 = (0, $01W3b.toValue);
function $2c539f0759d9aba1$export$25180f6b7105226e(fn, sync = true, target) {
    const instance = $2c539f0759d9aba1$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onBeforeMount)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
function $2c539f0759d9aba1$export$7b037ce8d7969c15(fn, target) {
    const instance = $2c539f0759d9aba1$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onBeforeUnmount)(fn, target);
}
function $2c539f0759d9aba1$export$cf1be5b643f0827(fn, sync = true, target) {
    const instance = $2c539f0759d9aba1$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onMounted)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
function $2c539f0759d9aba1$export$9fa6e59ca833c930(fn, target) {
    const instance = $2c539f0759d9aba1$export$5c967efe8efb656c(target);
    if (instance) (0, $TusQn.onUnmounted)(fn, target);
}
function $2c539f0759d9aba1$var$createUntil(r, isNot = false) {
    function toMatch(condition, { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = {}) {
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $01W3b.watch)(r, (v)=>{
                if (condition(v) !== isNot) {
                    if (stop) stop();
                    else (0, $TusQn.nextTick)(()=>stop == null ? void 0 : stop());
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($2c539f0759d9aba1$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>(0, $01W3b.toValue)(r)).finally(()=>stop == null ? void 0 : stop()));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $01W3b.isRef)(value)) return toMatch((v)=>v === value, options);
        const { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = options != null ? options : {};
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $01W3b.watch)([
                r,
                value
            ], ([v1, v2])=>{
                if (isNot !== (v1 === v2)) {
                    if (stop) stop();
                    else (0, $TusQn.nextTick)(()=>stop == null ? void 0 : stop());
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($2c539f0759d9aba1$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>(0, $01W3b.toValue)(r)).finally(()=>{
            stop == null || stop();
            return (0, $01W3b.toValue)(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch((v)=>Boolean(v), options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch((v)=>{
            const array = Array.from(v);
            return array.includes(value) || array.includes((0, $01W3b.toValue)(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n = 1, options) {
        let count = -1;
        return toMatch(()=>{
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray((0, $01W3b.toValue)(r))) {
        const instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $2c539f0759d9aba1$var$createUntil(r, !isNot);
            }
        };
        return instance;
    } else {
        const instance = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $2c539f0759d9aba1$var$createUntil(r, !isNot);
            }
        };
        return instance;
    }
}
function $2c539f0759d9aba1$export$a40009bd2c363351(r) {
    return $2c539f0759d9aba1$var$createUntil(r);
}
function $2c539f0759d9aba1$var$defaultComparator(value, othVal) {
    return value === othVal;
}
function $2c539f0759d9aba1$export$34602ebc410e389c(...args) {
    var _a, _b;
    const list = args[0];
    const values = args[1];
    let compareFn = (_a = args[2]) != null ? _a : $2c539f0759d9aba1$var$defaultComparator;
    const { symmetric: symmetric = false } = (_b = args[3]) != null ? _b : {};
    if (typeof compareFn === "string") {
        const key = compareFn;
        compareFn = (value, othVal)=>value[key] === othVal[key];
    }
    const diff1 = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).filter((x)=>(0, $01W3b.toValue)(values).findIndex((y)=>compareFn(x, y)) === -1));
    if (symmetric) {
        const diff2 = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(values).filter((x)=>(0, $01W3b.toValue)(list).findIndex((y)=>compareFn(x, y)) === -1));
        return (0, $01W3b.computed)(()=>symmetric ? [
                ...(0, $01W3b.toValue)(diff1),
                ...(0, $01W3b.toValue)(diff2)
            ] : (0, $01W3b.toValue)(diff1));
    } else return diff1;
}
function $2c539f0759d9aba1$export$1e5a400faddb345f(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).every((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
function $2c539f0759d9aba1$export$d62e4083f0a2d244(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).filter(fn));
}
function $2c539f0759d9aba1$export$ace4ef07c63f605e(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)((0, $01W3b.toValue)(list).find((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array))));
}
function $2c539f0759d9aba1$export$3ec066cdb63e2970(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).findIndex((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
function $2c539f0759d9aba1$var$findLast(arr, cb) {
    let index = arr.length;
    while(index-- > 0){
        if (cb(arr[index], index, arr)) return arr[index];
    }
    return void 0;
}
function $2c539f0759d9aba1$export$b59cd47693a134f7(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(!Array.prototype.findLast ? $2c539f0759d9aba1$var$findLast((0, $01W3b.toValue)(list), (element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)) : (0, $01W3b.toValue)(list).findLast((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array))));
}
function $2c539f0759d9aba1$var$isArrayIncludesOptions(obj) {
    return $2c539f0759d9aba1$export$a6cdc56e425d0d0a(obj) && $2c539f0759d9aba1$export$d138bf93e1dfa23f(obj, "formIndex", "comparator");
}
function $2c539f0759d9aba1$export$34f006a38543d952(...args) {
    var _a;
    const list = args[0];
    const value = args[1];
    let comparator = args[2];
    let formIndex = 0;
    if ($2c539f0759d9aba1$var$isArrayIncludesOptions(comparator)) {
        formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        const key = comparator;
        comparator = (element, value2)=>element[key] === (0, $01W3b.toValue)(value2);
    }
    comparator = comparator != null ? comparator : (element, value2)=>element === (0, $01W3b.toValue)(value2);
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).slice(formIndex).some((element, index, array)=>comparator((0, $01W3b.toValue)(element), (0, $01W3b.toValue)(value), index, (0, $01W3b.toValue)(array))));
}
function $2c539f0759d9aba1$export$4a02928bbff39848(list, separator) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).join((0, $01W3b.toValue)(separator)));
}
function $2c539f0759d9aba1$export$8cc4758f083c4ffe(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).map(fn));
}
function $2c539f0759d9aba1$export$2a4c0ee40e3400de(list, reducer, ...args) {
    const reduceCallback = (sum, value, index)=>reducer((0, $01W3b.toValue)(sum), (0, $01W3b.toValue)(value), index);
    return (0, $01W3b.computed)(()=>{
        const resolved = (0, $01W3b.toValue)(list);
        return args.length ? resolved.reduce(reduceCallback, typeof args[0] === "function" ? (0, $01W3b.toValue)(args[0]()) : (0, $01W3b.toValue)(args[0])) : resolved.reduce(reduceCallback);
    });
}
function $2c539f0759d9aba1$export$53834b0e1a20e7a3(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).some((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
function $2c539f0759d9aba1$var$uniq(array) {
    return Array.from(new Set(array));
}
function $2c539f0759d9aba1$var$uniqueElementsBy(array, fn) {
    return array.reduce((acc, v)=>{
        if (!acc.some((x)=>fn(v, x, array))) acc.push(v);
        return acc;
    }, []);
}
function $2c539f0759d9aba1$export$1b97ec936c2f7d03(list, compareFn) {
    return (0, $01W3b.computed)(()=>{
        const resolvedList = (0, $01W3b.toValue)(list).map((element)=>(0, $01W3b.toValue)(element));
        return compareFn ? $2c539f0759d9aba1$var$uniqueElementsBy(resolvedList, compareFn) : $2c539f0759d9aba1$var$uniq(resolvedList);
    });
}
function $2c539f0759d9aba1$export$70c4067197c60e2d(initialValue = 0, options = {}) {
    let _initialValue = (0, $01W3b.unref)(initialValue);
    const count = (0, $01W3b.shallowRef)(initialValue);
    const { max: max = Number.POSITIVE_INFINITY, min: min = Number.NEGATIVE_INFINITY } = options;
    const inc = (delta = 1)=>count.value = Math.max(Math.min(max, count.value + delta), min);
    const dec = (delta = 1)=>count.value = Math.min(Math.max(min, count.value - delta), max);
    const get = ()=>count.value;
    const set = (val)=>count.value = Math.max(min, Math.min(max, val));
    const reset = (val = _initialValue)=>{
        _initialValue = val;
        return set(val);
    };
    return {
        count: (0, $01W3b.shallowReadonly)(count),
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
const $2c539f0759d9aba1$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[T\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/i;
const $2c539f0759d9aba1$var$REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)\]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|z{1,4}|SSS/g;
function $2c539f0759d9aba1$var$defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    let m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce((acc, curr)=>acc += `${curr}.`, "");
    return isLowercase ? m.toLowerCase() : m;
}
function $2c539f0759d9aba1$var$formatOrdinal(num) {
    const suffixes = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function $2c539f0759d9aba1$export$3ae94a2503e890a1(date, formatStr, options = {}) {
    var _a;
    const years = date.getFullYear();
    const month = date.getMonth();
    const days = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const day = date.getDay();
    const meridiem = (_a = options.customMeridiem) != null ? _a : $2c539f0759d9aba1$var$defaultMeridiem;
    const stripTimeZone = (dateString)=>{
        var _a2;
        return (_a2 = dateString.split(" ")[1]) != null ? _a2 : "";
    };
    const matches = {
        Yo: ()=>$2c539f0759d9aba1$var$formatOrdinal(years),
        YY: ()=>String(years).slice(-2),
        YYYY: ()=>years,
        M: ()=>month + 1,
        Mo: ()=>$2c539f0759d9aba1$var$formatOrdinal(month + 1),
        MM: ()=>`${month + 1}`.padStart(2, "0"),
        MMM: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                month: "short"
            }),
        MMMM: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                month: "long"
            }),
        D: ()=>String(days),
        Do: ()=>$2c539f0759d9aba1$var$formatOrdinal(days),
        DD: ()=>`${days}`.padStart(2, "0"),
        H: ()=>String(hours),
        Ho: ()=>$2c539f0759d9aba1$var$formatOrdinal(hours),
        HH: ()=>`${hours}`.padStart(2, "0"),
        h: ()=>`${hours % 12 || 12}`.padStart(1, "0"),
        ho: ()=>$2c539f0759d9aba1$var$formatOrdinal(hours % 12 || 12),
        hh: ()=>`${hours % 12 || 12}`.padStart(2, "0"),
        m: ()=>String(minutes),
        mo: ()=>$2c539f0759d9aba1$var$formatOrdinal(minutes),
        mm: ()=>`${minutes}`.padStart(2, "0"),
        s: ()=>String(seconds),
        so: ()=>$2c539f0759d9aba1$var$formatOrdinal(seconds),
        ss: ()=>`${seconds}`.padStart(2, "0"),
        SSS: ()=>`${milliseconds}`.padStart(3, "0"),
        d: ()=>day,
        dd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "narrow"
            }),
        ddd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "short"
            }),
        dddd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "long"
            }),
        A: ()=>meridiem(hours, minutes),
        AA: ()=>meridiem(hours, minutes, false, true),
        a: ()=>meridiem(hours, minutes, true),
        aa: ()=>meridiem(hours, minutes, true, true),
        z: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zzz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zzzz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "longOffset"
            }))
    };
    return formatStr.replace($2c539f0759d9aba1$var$REGEX_FORMAT, (match, $1)=>{
        var _a2, _b;
        return (_b = $1 != null ? $1 : (_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) != null ? _b : match;
    });
}
function $2c539f0759d9aba1$export$fcc71269590ba0a8(date) {
    if (date === null) return new Date(Number.NaN);
    if (date === void 0) return /* @__PURE__ */ new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        const d = date.match($2c539f0759d9aba1$var$REGEX_PARSE);
        if (d) {
            const m = d[2] - 1 || 0;
            const ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
function $2c539f0759d9aba1$export$6d181172004bc6fc(date, formatStr = "HH:mm:ss", options = {}) {
    return (0, $01W3b.computed)(()=>$2c539f0759d9aba1$export$3ae94a2503e890a1($2c539f0759d9aba1$export$fcc71269590ba0a8((0, $01W3b.toValue)(date)), (0, $01W3b.toValue)(formatStr), options));
}
function $2c539f0759d9aba1$export$35ee30a05e4f2223(cb, interval = 1e3, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    let timer = null;
    const isActive = (0, $01W3b.shallowRef)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        const intervalValue = (0, $01W3b.toValue)(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        if (isActive.value) timer = setInterval(cb, intervalValue);
    }
    if (immediate && $2c539f0759d9aba1$export$7383f122bf48ec30) resume();
    if ((0, $01W3b.isRef)(interval) || typeof interval === "function") {
        const stopWatch = (0, $01W3b.watch)(interval, ()=>{
            if (isActive.value && $2c539f0759d9aba1$export$7383f122bf48ec30) resume();
        });
        $2c539f0759d9aba1$export$c3d49ae4e58d3d9d(stopWatch);
    }
    $2c539f0759d9aba1$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: (0, $01W3b.shallowReadonly)(isActive),
        pause: pause,
        resume: resume
    };
}
function $2c539f0759d9aba1$export$f4b266cd2aae9cb1(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, immediate: immediate = true, callback: callback } = options;
    const counter = (0, $01W3b.shallowRef)(0);
    const update = ()=>counter.value += 1;
    const reset = ()=>{
        counter.value = 0;
    };
    const controls = $2c539f0759d9aba1$export$35ee30a05e4f2223(callback ? ()=>{
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        counter: (0, $01W3b.shallowReadonly)(counter),
        reset: reset,
        ...controls
    };
    else return (0, $01W3b.shallowReadonly)(counter);
}
function $2c539f0759d9aba1$export$de385d6f89d6db3c(source, options = {}) {
    var _a;
    const ms = (0, $01W3b.shallowRef)((_a = options.initialValue) != null ? _a : null);
    (0, $01W3b.watch)(source, ()=>ms.value = $2c539f0759d9aba1$export$fc00ee57782020aa(), options);
    return (0, $01W3b.shallowReadonly)(ms);
}
function $2c539f0759d9aba1$export$14705c14c13d528a(cb, interval, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    const isPending = (0, $01W3b.shallowRef)(false);
    let timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start(...args) {
        if (immediateCallback) cb();
        clear();
        isPending.value = true;
        timer = setTimeout(()=>{
            isPending.value = false;
            timer = null;
            cb(...args);
        }, (0, $01W3b.toValue)(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($2c539f0759d9aba1$export$7383f122bf48ec30) start();
    }
    $2c539f0759d9aba1$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $01W3b.shallowReadonly)(isPending),
        start: start,
        stop: stop
    };
}
function $2c539f0759d9aba1$export$d8e6abf214c9ec0f(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, callback: callback } = options;
    const controls = $2c539f0759d9aba1$export$14705c14c13d528a(callback != null ? callback : $2c539f0759d9aba1$export$8793edee2d425525, interval, options);
    const ready = (0, $01W3b.computed)(()=>!controls.isPending.value);
    if (exposeControls) return {
        ready: ready,
        ...controls
    };
    else return ready;
}
function $2c539f0759d9aba1$export$1ee6bb1f922f50b3(value, options = {}) {
    const { method: method = "parseFloat", radix: radix, nanToZero: nanToZero } = options;
    return (0, $01W3b.computed)(()=>{
        let resolved = (0, $01W3b.toValue)(value);
        if (typeof method === "function") resolved = method(resolved);
        else if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
function $2c539f0759d9aba1$export$8906942fea47e698(value) {
    return (0, $01W3b.computed)(()=>`${(0, $01W3b.toValue)(value)}`);
}
function $2c539f0759d9aba1$export$cbe85ee05b554577(initialValue = false, options = {}) {
    const { truthyValue: truthyValue = true, falsyValue: falsyValue = false } = options;
    const valueIsRef = (0, $01W3b.isRef)(initialValue);
    const _value = (0, $01W3b.shallowRef)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            const truthy = (0, $01W3b.toValue)(truthyValue);
            _value.value = _value.value === truthy ? (0, $01W3b.toValue)(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
function $2c539f0759d9aba1$export$8ebd2befe4deaa6b(source, cb, options) {
    let oldList = (options == null ? void 0 : options.immediate) ? [] : [
        ...typeof source === "function" ? source() : Array.isArray(source) ? source : (0, $01W3b.toValue)(source)
    ];
    return (0, $01W3b.watch)(source, (newList, _, onCleanup)=>{
        const oldListRemains = Array.from({
            length: oldList.length
        });
        const added = [];
        for (const obj of newList){
            let found = false;
            for(let i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                oldListRemains[i] = true;
                found = true;
                break;
            }
            if (!found) added.push(obj);
        }
        const removed = oldList.filter((_2, i)=>!oldListRemains[i]);
        cb(newList, oldList, added, removed, onCleanup);
        oldList = [
            ...newList
        ];
    }, options);
}
function $2c539f0759d9aba1$export$a121c3bc1a97f0b4(source, cb, options) {
    const { count: count, ...watchOptions } = options;
    const current = (0, $01W3b.shallowRef)(0);
    const stop = $2c539f0759d9aba1$export$3955c00bb6715986(source, (...args)=>{
        current.value += 1;
        if (current.value >= (0, $01W3b.toValue)(count)) (0, $TusQn.nextTick)(()=>stop());
        cb(...args);
    }, watchOptions);
    return {
        count: current,
        stop: stop
    };
}
function $2c539f0759d9aba1$export$578b5d9cbe132cee(source, cb, options = {}) {
    const { debounce: debounce = 0, maxWait: maxWait, ...watchOptions } = options;
    return $2c539f0759d9aba1$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $2c539f0759d9aba1$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    });
}
function $2c539f0759d9aba1$export$79f242cf85fb93a(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        deep: true
    });
}
function $2c539f0759d9aba1$export$63ac06655f58d92a(source, cb, options = {}) {
    const { eventFilter: eventFilter = $2c539f0759d9aba1$export$8cc0e33a27868391, ...watchOptions } = options;
    const filteredCb = $2c539f0759d9aba1$export$a1f1cf91007f23bf(eventFilter, cb);
    let ignoreUpdates;
    let ignorePrevAsyncUpdates;
    let stop;
    if (watchOptions.flush === "sync") {
        const ignore = (0, $01W3b.shallowRef)(false);
        ignorePrevAsyncUpdates = ()=>{};
        ignoreUpdates = (updater)=>{
            ignore.value = true;
            updater();
            ignore.value = false;
        };
        stop = (0, $01W3b.watch)(source, (...args)=>{
            if (!ignore.value) filteredCb(...args);
        }, watchOptions);
    } else {
        const disposables = [];
        const ignoreCounter = (0, $01W3b.shallowRef)(0);
        const syncCounter = (0, $01W3b.shallowRef)(0);
        ignorePrevAsyncUpdates = ()=>{
            ignoreCounter.value = syncCounter.value;
        };
        disposables.push((0, $01W3b.watch)(source, ()=>{
            syncCounter.value++;
        }, {
            ...watchOptions,
            flush: "sync"
        }));
        ignoreUpdates = (updater)=>{
            const syncCounterPrev = syncCounter.value;
            updater();
            ignoreCounter.value += syncCounter.value - syncCounterPrev;
        };
        disposables.push((0, $01W3b.watch)(source, (...args)=>{
            const ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
            ignoreCounter.value = 0;
            syncCounter.value = 0;
            if (ignore) return;
            filteredCb(...args);
        }, watchOptions));
        stop = ()=>{
            disposables.forEach((fn)=>fn());
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
function $2c539f0759d9aba1$export$d9aec7ec4e8a1634(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        immediate: true
    });
}
function $2c539f0759d9aba1$export$95d4a8ca30b80ae0(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        once: true
    });
}
function $2c539f0759d9aba1$export$2768dce732d5eb3(source, cb, options = {}) {
    const { throttle: throttle = 0, trailing: trailing = true, leading: leading = true, ...watchOptions } = options;
    return $2c539f0759d9aba1$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $2c539f0759d9aba1$export$cd62e9dbf204fd92(throttle, trailing, leading)
    });
}
function $2c539f0759d9aba1$export$b75c094d1092c205(source, cb, options = {}) {
    let cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        const fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    const _cb = (value, oldValue)=>{
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    const res = $2c539f0759d9aba1$export$63ac06655f58d92a(source, _cb, options);
    const { ignoreUpdates: ignoreUpdates } = res;
    const trigger = ()=>{
        let res2;
        ignoreUpdates(()=>{
            res2 = _cb($2c539f0759d9aba1$var$getWatchSources(source), $2c539f0759d9aba1$var$getOldValue(source));
        });
        return res2;
    };
    return {
        ...res,
        trigger: trigger
    };
}
function $2c539f0759d9aba1$var$getWatchSources(sources) {
    if ((0, $01W3b.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map((item)=>(0, $01W3b.toValue)(item));
    return (0, $01W3b.toValue)(sources);
}
function $2c539f0759d9aba1$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(()=>void 0) : void 0;
}
function $2c539f0759d9aba1$export$909eba9696cc3445(source, cb, options) {
    const stop = (0, $01W3b.watch)(source, (v, ov, onInvalidate)=>{
        if (v) {
            if (options == null ? void 0 : options.once) (0, $TusQn.nextTick)(()=>stop());
            cb(v, ov, onInvalidate);
        }
    }, {
        ...options,
        once: false
    });
    return stop;
}

});


parcelRegister("8i0dy", function(module, exports) {

$parcel$export(module.exports, "tabs", () => $60902c64feb32eb4$export$39f5674517ec0000);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
const $60902c64feb32eb4$export$39f5674517ec0000 = (0, $01W3b.ref)([
    {
        id: 'respiratory',
        label: 'Respiratory',
        active: true,
        visible: true,
        styles: {
            bgColor: 'bg-respiratory',
            border: 'border-respiratory',
            borderHover: 'hover:border-respiratory'
        }
    },
    {
        id: 'gastrointestinal',
        label: 'Gastrointestinal',
        active: false,
        visible: true,
        styles: {
            bgColor: 'bg-gastrointestinal',
            border: 'border-gastrointestinal',
            borderHover: 'hover:border-gastrointestinal'
        }
    },
    {
        id: 'meningitis',
        label: 'Meningitis/Encephalitis',
        active: false,
        visible: true,
        styles: {
            bgColor: 'bg-meningitis',
            border: 'border-meningitis',
            borderHover: 'hover:border-meningitis'
        }
    },
    {
        id: 'tropical-fever',
        label: 'Tropical Fever',
        active: false,
        visible: true,
        styles: {
            bgColor: 'bg-tropical-fever',
            border: 'border-tropical-fever',
            borderHover: 'hover:border-tropical-fever'
        }
    },
    {
        id: 'bloodstream-infections',
        label: 'Bloodstream Infections',
        active: false,
        visible: true,
        styles: {
            bgColor: 'bg-bloodstream-infections',
            border: 'border-bloodstream-infections',
            borderHover: 'hover:border-bloodstream-infections'
        }
    }
]);

});

parcelRegister("1qJO6", function(module, exports) {

$parcel$export(module.exports, "demographicStatsReference", () => $10abc07733e28687$export$3f8e90b494a27030);
$parcel$export(module.exports, "default", () => $10abc07733e28687$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $7SlR4 = parcelRequire("7SlR4");

var $714ap = parcelRequire("714ap");
const $10abc07733e28687$export$3f8e90b494a27030 = '1, 2';
var $10abc07733e28687$export$2e2bcd8739ae039 = (0, $01W3b.ref)([
    {
        id: 1,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['population'],
        statistic: 'population',
        value: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.pep?.pop?.toLocaleString('en') || 'N/A')
    },
    {
        id: 2,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['median-age'],
        statistic: 'median age',
        value: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.pep?.medage ? `${(0, $714ap.default).value?.pep?.medage} years` : 'N/A')
    },
    {
        id: 5,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['over-65'],
        statistic: 'persons over 65 years old',
        value: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.pep?.age_65_plus && (0, $714ap.default).value?.pep?.pop ? `${((0, $714ap.default).value?.pep?.age_65_plus / (0, $714ap.default).value?.pep?.pop * 100).toFixed(1)}%` : 'N/A')
    },
    {
        id: 4,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['income'],
        statistic: 'median household income',
        value: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.acs?.est_houses_median_income_dollars ? `$${(0, $714ap.default).value?.acs?.est_houses_median_income_dollars.toLocaleString('en')}` : 'N/A')
    },
    {
        id: 6,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['housing'],
        statistic: 'housing',
        value: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.acs?.est_houses_total ? `${(0, $714ap.default).value?.acs?.est_houses_total.toLocaleString('en')} households` : 'N/A')
    }
]);

});
parcelRegister("7SlR4", function(module, exports) {

var $64vwr = parcelRequire("64vwr");

var $eeLYc = parcelRequire("eeLYc");

var $hxO9s = parcelRequire("hxO9s");

var $6CfMr = parcelRequire("6CfMr");

var $2jVBe = parcelRequire("2jVBe");

var $9dOXb = parcelRequire("9dOXb");

var $95cit = parcelRequire("95cit");

var $6Yxv7 = parcelRequire("6Yxv7");

var $dyAsD = parcelRequire("dyAsD");

var $dlVFl = parcelRequire("dlVFl");

var $6m0TQ = parcelRequire("6m0TQ");

var $deTE8 = parcelRequire("deTE8");

var $9bFB0 = parcelRequire("9bFB0");
module.exports = {
    "alert": $64vwr,
    "cancer": $eeLYc,
    "diabetes": $hxO9s,
    "heart-disease": $6CfMr,
    "high-blood-pressure": $2jVBe,
    "high-cholesterol": $9dOXb,
    "housing": $95cit,
    "income": $6Yxv7,
    "median-age": $dyAsD,
    "obesity": $dlVFl,
    "over-65": $6m0TQ,
    "population": $deTE8,
    "white-alert": $9bFB0
};

});
parcelRegister("64vwr", function(module, exports) {
module.exports = import.meta.resolve("9zw0L");

});

parcelRegister("eeLYc", function(module, exports) {
module.exports = import.meta.resolve("etP4b");

});

parcelRegister("hxO9s", function(module, exports) {
module.exports = import.meta.resolve("79Qt9");

});

parcelRegister("6CfMr", function(module, exports) {
module.exports = import.meta.resolve("fIUiO");

});

parcelRegister("2jVBe", function(module, exports) {
module.exports = import.meta.resolve("8Deq2");

});

parcelRegister("9dOXb", function(module, exports) {
module.exports = import.meta.resolve("d7aC6");

});

parcelRegister("95cit", function(module, exports) {
module.exports = import.meta.resolve("hwQFZ");

});

parcelRegister("6Yxv7", function(module, exports) {
module.exports = import.meta.resolve("6au5h");

});

parcelRegister("dyAsD", function(module, exports) {
module.exports = import.meta.resolve("4WV9E");

});

parcelRegister("dlVFl", function(module, exports) {
module.exports = import.meta.resolve("hoK72");

});

parcelRegister("6m0TQ", function(module, exports) {
module.exports = import.meta.resolve("l1r3G");

});

parcelRegister("deTE8", function(module, exports) {
module.exports = import.meta.resolve("8TyUP");

});

parcelRegister("9bFB0", function(module, exports) {
module.exports = import.meta.resolve("aBaQ7");

});


parcelRegister("714ap", function(module, exports) {

$parcel$export(module.exports, "default", () => $51bbdbe0134f0897$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $3sg19 = parcelRequire("3sg19");

var $ijUEj = parcelRequire("ijUEj");
const $51bbdbe0134f0897$var$payload = (0, $01W3b.ref)({
    ready: false
});
(0, $01W3b.watch)((0, $ijUEj.default), async ()=>{
    $51bbdbe0134f0897$var$payload.value = await (0, $3sg19.fetchData)((0, $ijUEj.default).value);
});
var $51bbdbe0134f0897$export$2e2bcd8739ae039 = $51bbdbe0134f0897$var$payload;

});
parcelRegister("3sg19", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $2840695db888eba6$export$8134c072fddab6a5);
$parcel$export(module.exports, "fetchNationalAverage", () => $2840695db888eba6$export$4cbc81aab576428e);
async function $2840695db888eba6$export$8134c072fddab6a5(zipCode) {
    try {
        const response = await fetch(`https://bmx-apps.alextom.com/population-health-data/v2/stats-by-zip/${zipCode}.json`);
        if (!response.ok) return {
            exists: false,
            ready: true
        };
        const data = await response.json();
        return {
            ...data,
            exists: true,
            ready: true
        };
    } catch (error) {
        console.error("Could not fetch the data:", error);
    }
}
async function $2840695db888eba6$export$4cbc81aab576428e() {
    try {
        const response = await fetch('https://bmx-apps.alextom.com/population-health-data/v2/national-average.json');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Could not fetch the data:", error);
    }
}

});

parcelRegister("ijUEj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d565f1b3088f8d05$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $d565f1b3088f8d05$export$2e2bcd8739ae039 = (0, $01W3b.ref)(null);

});



parcelRegister("2aUHH", function(module, exports) {

$parcel$export(module.exports, "populationHealthReference", () => $19588026c5a34088$export$496259c04a9f5630);
$parcel$export(module.exports, "default", () => $19588026c5a34088$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $7SlR4 = parcelRequire("7SlR4");

var $714ap = parcelRequire("714ap");

var $k7fDd = parcelRequire("k7fDd");
const $19588026c5a34088$export$496259c04a9f5630 = 3;
var $19588026c5a34088$export$2e2bcd8739ae039 = (0, $01W3b.ref)([
    {
        id: 1,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['heart-disease'],
        statistic: 'heart disease',
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.chd_crude_prev),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.places?.chd_crude_prev.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.chd_crude_prev > (0, $k7fDd.default).value?.places?.chd_crude_prev)
    },
    {
        id: 2,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['cancer'],
        statistic: 'cancer',
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.cancer_crude_prev),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.places?.cancer_crude_prev.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.cancer_crude_prev > (0, $k7fDd.default).value?.places?.cancer_crude_prev)
    },
    {
        id: 3,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['diabetes'],
        statistic: 'diabetes',
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.diabetes_crude_prev),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.places?.diabetes_crude_prev.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.diabetes_crude_prev > (0, $k7fDd.default).value?.places?.diabetes_crude_prev)
    },
    {
        id: 4,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['obesity'],
        statistic: 'obesity',
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.obesity_crude_prev),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.places?.obesity_crude_prev.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.obesity_crude_prev > (0, $k7fDd.default).value?.places?.obesity_crude_prev)
    },
    {
        id: 5,
        statistic: 'high cholesterol',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['high-cholesterol'],
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.highchol_crude_prev),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.places?.highchol_crude_prev.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.highchol_crude_prev > (0, $k7fDd.default).value?.places?.highchol_crude_prev)
    },
    {
        id: 6,
        statistic: 'high blood pressure',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7SlR4)))['high-blood-pressure'],
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.bphigh_crude_prev),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.places?.bphigh_crude_prev.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.places?.bphigh_crude_prev > (0, $k7fDd.default).value?.places?.bphigh_crude_prev)
    }
]);

});
parcelRegister("k7fDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c77e4b213dee54$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $3sg19 = parcelRequire("3sg19");
const $03c77e4b213dee54$var$nationalAverage = (0, $01W3b.ref)();
async function $03c77e4b213dee54$var$initNationalValue() {
    $03c77e4b213dee54$var$nationalAverage.value = await (0, $3sg19.fetchNationalAverage)();
}
$03c77e4b213dee54$var$initNationalValue();
var $03c77e4b213dee54$export$2e2bcd8739ae039 = $03c77e4b213dee54$var$nationalAverage;

});


parcelRegister("hX5RY", function(module, exports) {
module.exports = import.meta.resolve("5J4qZ");

});

parcelRegister("lQ1qL", function(module, exports) {
module.exports = import.meta.resolve("9Ei08");

});

parcelRegister("gnCBA", function(module, exports) {
module.exports = import.meta.resolve("hdN2r");

});

parcelRegister("1wdf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $11b30d60eae2541a$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $714ap = parcelRequire("714ap");
var $11b30d60eae2541a$export$2e2bcd8739ae039 = (0, $01W3b.reactive)({
    county: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.county_name),
    state: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.state_name),
    stateAbbr: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.state_abbr),
    ready: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.ready),
    exists: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.exists)
});

});

parcelRegister("jozPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ec0c8557944fcb$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $714ap = parcelRequire("714ap");

var $1wdf7 = parcelRequire("1wdf7");

var $k7fDd = parcelRequire("k7fDd");
const $e1ec0c8557944fcb$var$state = (0, $01W3b.computed)(()=>(0, $1wdf7.default)?.state || ' the state');
const $e1ec0c8557944fcb$var$generateNHSNWindow = ()=>{
    if ((0, $714ap.default).value?.nhsn) return ` ${(0, $714ap.default).value.nhsn.week_end}`;
    return '';
};
const $e1ec0c8557944fcb$var$lookupBEAMPathogen = (pathogenType, db)=>{
    const pattern = new RegExp(pathogenType, 'i');
    return db.value?.beam?.find((pathogen)=>pathogen.pathogen.match(pattern));
};
const $e1ec0c8557944fcb$var$generateBEAMWindow = (pathogenType, db)=>{
    const pathogen = $e1ec0c8557944fcb$var$lookupBEAMPathogen(pathogenType, db);
    if (pathogen) {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        return ` for ${months[pathogen.month - 1]} ${pathogen.year}`;
    } else return '';
};
const $e1ec0c8557944fcb$var$lookupNNDSSPathogen = (pathogenType, db)=>{
    const pattern = new RegExp(pathogenType, 'i');
    return db.value?.nndss?.find((pathogen)=>pathogen.pathogen.match(pattern));
};
const $e1ec0c8557944fcb$var$generateNNDSSWindow = (pathogenType, db)=>{
    const pathogen = $e1ec0c8557944fcb$var$lookupNNDSSPathogen(pathogenType, db);
    if (pathogen) {
        const day = 1 + (pathogen.week - 1) * 7;
        const date = new Date(pathogen.year, 0, day);
        return ` for week ${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, 0)}-${date.getDate()}`;
    } else return '';
};
const $e1ec0c8557944fcb$var$parseUpdatedAt = (updatedAt)=>{
    if (updatedAt) {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        const date = new Date(`${updatedAt} UTC`);
        const now = new Date();
        const threshold = 604800000;
        return {
            date: date,
            message: `Data Updated on ${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`,
            alert: now - date < threshold
        };
    }
    return null;
};
var $e1ec0c8557944fcb$export$2e2bcd8739ae039 = (0, $01W3b.ref)([
    {
        id: 1,
        reference: 4,
        tab: 'respiratory',
        title: 'RSV',
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.nhsn?.total_patients_rsv),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.nhsn?.total_patients_rsv.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.nhsn?.total_patients_rsv > (0, $k7fDd.default).value?.nhsn?.total_patients_rsv),
        description: 'total state patients hospitalized.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt((0, $714ap.default).value?.nhsn?.updated_at)),
            description: (0, $01W3b.computed)(()=>`Total number of ${$e1ec0c8557944fcb$var$state.value} patients hospitalized with confirmed RSV captured for the Wednesday of the reporting week ${$e1ec0c8557944fcb$var$generateNHSNWindow()}.`),
            source: 'Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).',
            url: 'https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data',
            active: false
        }
    },
    {
        id: 2,
        reference: 4,
        tab: 'respiratory',
        title: 'COVID-19',
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.nhsn?.total_patients_covid),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.nhsn?.total_patients_covid.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.nhsn?.total_patients_covid > (0, $k7fDd.default).value?.nhsn?.total_patients_covid),
        description: 'total state patients hospitalized.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt((0, $714ap.default).value?.nhsn?.updated_at)),
            description: (0, $01W3b.computed)(()=>`Total number of ${$e1ec0c8557944fcb$var$state.value} hospitals that reported data for number of confirmed COVID-19 patients for Wednesday of the reporting week ${$e1ec0c8557944fcb$var$generateNHSNWindow()}.`),
            source: 'Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).',
            url: 'https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data',
            active: false
        }
    },
    {
        id: 3,
        reference: 4,
        tab: 'respiratory',
        title: 'influenza',
        localValue: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.nhsn?.total_patients_influenza),
        nationalValue: (0, $01W3b.computed)(()=>(0, $k7fDd.default).value?.nhsn?.total_patients_influenza.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>(0, $714ap.default).value?.nhsn?.total_patients_influenza > (0, $k7fDd.default).value?.nhsn?.total_patients_influenza),
        description: 'total state patients hospitalized.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt((0, $714ap.default).value?.nhsn?.updated_at)),
            description: (0, $01W3b.computed)(()=>`Total number of ${$e1ec0c8557944fcb$var$state.value} hospitals that reported data for number of confirmed influenza patients for Wednesday of the reporting week ${$e1ec0c8557944fcb$var$generateNHSNWindow()}.`),
            source: 'Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).',
            url: 'https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data',
            active: false
        }
    },
    {
        id: 4,
        reference: 5,
        tab: 'gastrointestinal',
        title: '<i>salmonella</i>',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('salmonella', (0, $714ap.default))?.number_of_isolates),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('salmonella', (0, $k7fDd.default))?.number_of_isolates.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('salmonella', (0, $714ap.default))?.number_of_isolates > $e1ec0c8557944fcb$var$lookupBEAMPathogen('salmonella', (0, $k7fDd.default))?.number_of_isolates),
        description: 'isolates reported in state residents.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupBEAMPathogen('salmonella', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the number of <i>Salmonella</i> isolates reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateBEAMWindow('salmonella', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',
            url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',
            active: false
        }
    },
    {
        id: 5,
        reference: 5,
        tab: 'gastrointestinal',
        title: 'stec',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('stec', (0, $714ap.default))?.number_of_isolates),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('stec', (0, $k7fDd.default))?.number_of_isolates.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('stec', (0, $714ap.default))?.number_of_isolates > $e1ec0c8557944fcb$var$lookupBEAMPathogen('stec', (0, $k7fDd.default))?.number_of_isolates),
        description: 'isolates reported in state residents.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupBEAMPathogen('stec', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the number of Shiga toxin-producing <i>Escherichia coli</i> (STEC) isolates reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateBEAMWindow('stec', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',
            url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',
            active: false
        }
    },
    {
        id: 6,
        reference: 5,
        tab: 'gastrointestinal',
        title: '<i>shigella</i>',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('shigella', (0, $714ap.default))?.number_of_isolates),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('shigella', (0, $k7fDd.default))?.number_of_isolates.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('shigella', (0, $714ap.default))?.number_of_isolates > $e1ec0c8557944fcb$var$lookupBEAMPathogen('shigella', (0, $k7fDd.default))?.number_of_isolates),
        description: 'isolates reported in state residents.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupBEAMPathogen('shigella', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the number of <i>Shigella</i> isolates reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateBEAMWindow('shigella', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',
            url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',
            active: false
        }
    },
    {
        id: 7,
        reference: 5,
        tab: 'gastrointestinal',
        title: '<i>campylobacter</i>',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('campylobacter', (0, $714ap.default))?.number_of_isolates),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('campylobacter', (0, $k7fDd.default))?.number_of_isolates.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('campylobacter', (0, $714ap.default))?.number_of_isolates > $e1ec0c8557944fcb$var$lookupBEAMPathogen('campylobacter', (0, $k7fDd.default))?.number_of_isolates),
        description: 'isolates reported in state residents.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupBEAMPathogen('campylobacter', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the number of <i>Campylobacter</i> isolates reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateBEAMWindow('campylobacter', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',
            url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',
            active: false
        }
    },
    {
        id: 8,
        reference: 5,
        tab: 'gastrointestinal',
        title: '<i>vibrio</i>',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('vibrio', (0, $714ap.default))?.number_of_isolates),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('vibrio', (0, $k7fDd.default))?.number_of_isolates.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupBEAMPathogen('vibrio', (0, $714ap.default))?.number_of_isolates > $e1ec0c8557944fcb$var$lookupBEAMPathogen('vibrio', (0, $k7fDd.default))?.number_of_isolates),
        description: 'isolates reported in state residents.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupBEAMPathogen('vibrio', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the number of <i>Vibrio</i> isolates reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateBEAMWindow('vibrio', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',
            url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',
            active: false
        }
    },
    {
        id: 9,
        reference: 6,
        tab: 'meningitis',
        title: 'meningococcal diseases',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('meningococcal', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('meningococcal', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('meningococcal', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('meningococcal', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('meningococcal', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of Meningococcal diseases cases reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('meningococcal', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    },
    {
        id: 10,
        reference: 6,
        tab: 'meningitis',
        title: '<i>haemophilus influenzae</i>',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('haemophilus influenzae', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('haemophilus influenzae', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('haemophilus influenzae', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('haemophilus influenzae', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('haemophilus influenzae', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of <i>Haemophilus influenzae</i> (inclusive of all invasive <i>Haemophilus</i> cases) reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('haemophilus influenzae', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    },
    {
        id: 16,
        reference: 6,
        tab: 'meningitis',
        title: 'listeriosis',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('listeriosis', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('listeriosis', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('listeriosis', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('listeriosis', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('listeriosis', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of Listeriosis reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('listeriosis', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    },
    {
        id: 11,
        reference: 6,
        tab: 'tropical-fever',
        title: 'dengue',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('dengue', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('dengue', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('dengue', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('dengue', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('dengue', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of Dengue reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('dengue', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    },
    {
        id: 12,
        reference: 6,
        tab: 'tropical-fever',
        title: 'malaria',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('malaria', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('malaria', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('malaria', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('malaria', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('malaria', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of Malaria reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('malaria', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    },
    {
        id: 13,
        reference: 6,
        tab: 'bloodstream-infections',
        title: 'stec',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('stec', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('stec', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('stec', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('stec', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('stec', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of Shiga toxin-producing <i>Escherichia coli</i> (STEC) reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('stec', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    },
    {
        id: 14,
        reference: 6,
        tab: 'bloodstream-infections',
        title: 'stss',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('stss', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('stss', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('stss', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('stss', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('stss', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of Streptococcal Toxic Shock Syndrome (STSS) reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('stss', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    },
    {
        id: 15,
        reference: 6,
        tab: 'bloodstream-infections',
        title: '<i>candida auris</i>',
        localValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('candida auris', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year),
        nationalValue: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('candida auris', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year.toFixed(1)),
        alert: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$lookupNNDSSPathogen('candida auris', (0, $714ap.default))?.cumulative_ytd_current_mmwr_year > $e1ec0c8557944fcb$var$lookupNNDSSPathogen('candida auris', (0, $k7fDd.default))?.cumulative_ytd_current_mmwr_year),
        description: 'cumulative YTD MMWR state-level cases.',
        symbol: false,
        moreInfo: {
            updatedAt: (0, $01W3b.computed)(()=>$e1ec0c8557944fcb$var$parseUpdatedAt($e1ec0c8557944fcb$var$lookupNNDSSPathogen('candida auris', (0, $714ap.default))?.updated_at)),
            description: (0, $01W3b.computed)(()=>`This data point represents the cumulative year-to-date current MMWR year state-level cases of <i>Candida auris</i> (clinical) reported within ${$e1ec0c8557944fcb$var$state.value}${$e1ec0c8557944fcb$var$generateNNDSSWindow('candida auris', (0, $714ap.default))}.`),
            source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',
            url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',
            active: false
        }
    }
]);

});

parcelRegister("hLe2u", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee1b755c3189cbb$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
const $cee1b755c3189cbb$var$key = 'history';
const $cee1b755c3189cbb$var$store = (0, $01W3b.ref)(JSON.parse(sessionStorage.getItem($cee1b755c3189cbb$var$key)) || {});
const $cee1b755c3189cbb$var$actions = {
    saw: (zipCode, tabId)=>{
        $cee1b755c3189cbb$var$store.value[`${zipCode}-${tabId}`] = true;
    },
    seen: (zipCode, tabId)=>$cee1b755c3189cbb$var$store.value[`${zipCode}-${tabId}`],
    toJSON: ()=>$cee1b755c3189cbb$var$store.value
};
(0, $01W3b.watch)($cee1b755c3189cbb$var$store, ()=>sessionStorage.setItem($cee1b755c3189cbb$var$key, JSON.stringify($cee1b755c3189cbb$var$store.value)), {
    deep: true,
    immediate: true
});
var $cee1b755c3189cbb$export$2e2bcd8739ae039 = (0, $01W3b.reactive)({
    store: $cee1b755c3189cbb$var$store,
    ...$cee1b755c3189cbb$var$actions
});

});

parcelRegister("1JZJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1449e07f6c772f3e$export$2e2bcd8739ae039);
let $1449e07f6c772f3e$var$script;


let $1449e07f6c772f3e$var$initialize = ()=>{
    $1449e07f6c772f3e$var$script = {};
    $1449e07f6c772f3e$var$script.render = (parcelRequire("8WayK")).render;
    (parcelRequire("9mdQx")).default($1449e07f6c772f3e$var$script);
    $1449e07f6c772f3e$var$script.__scopeId = 'data-v-300e16';
    $1449e07f6c772f3e$var$script.__file = "demographic-divider.vue";
};
$1449e07f6c772f3e$var$initialize();
var $1449e07f6c772f3e$export$2e2bcd8739ae039 = $1449e07f6c772f3e$var$script;

});
parcelRegister("8WayK", function(module, exports) {

$parcel$export(module.exports, "render", () => $681bee673f4016b3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $681bee673f4016b3$var$_hoisted_1 = {
    class: "w-full stroke-blue-fresh",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1250",
    height: "2",
    viewBox: "0 0 1250 2",
    fill: "none"
};
function $681bee673f4016b3$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $681bee673f4016b3$var$_hoisted_1, _cache[0] || (_cache[0] = [
        (0, $TusQn.createElementVNode)("path", {
            d: "M0 1H2000"
        }, null, -1 /* HOISTED */ )
    ]));
}

});

parcelRegister("9mdQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d00e8bb3fb9ccee$export$2e2bcd8739ae039);
let $6d00e8bb3fb9ccee$var$NOOP = ()=>{};
var $6d00e8bb3fb9ccee$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9cg2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b21ae64dbc057c3$export$2e2bcd8739ae039);
let $6b21ae64dbc057c3$var$script;


let $6b21ae64dbc057c3$var$initialize = ()=>{
    $6b21ae64dbc057c3$var$script = {};
    $6b21ae64dbc057c3$var$script.render = (parcelRequire("g2Kt4")).render;
    (parcelRequire("la7ve")).default($6b21ae64dbc057c3$var$script);
    $6b21ae64dbc057c3$var$script.__scopeId = 'data-v-751cfe';
    $6b21ae64dbc057c3$var$script.__file = "section-divider.vue";
};
$6b21ae64dbc057c3$var$initialize();
var $6b21ae64dbc057c3$export$2e2bcd8739ae039 = $6b21ae64dbc057c3$var$script;

});
parcelRegister("g2Kt4", function(module, exports) {

$parcel$export(module.exports, "render", () => $bae0e0d18cc81e39$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $bae0e0d18cc81e39$var$_hoisted_1 = {
    class: "w-full",
    xmlns: "http://www.w3.org/2000/svg",
    width: "2000",
    height: "4",
    viewBox: "0 0 2000 4",
    fill: "none"
};
function $bae0e0d18cc81e39$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $bae0e0d18cc81e39$var$_hoisted_1, _cache[0] || (_cache[0] = [
        (0, $TusQn.createStaticVNode)("<path class=\"stroke-12 sm:stroke-8 md:stroke-6 lg:stroke-4\" d=\"M0 2H2000\" stroke=\"url(#paint0_linear_8680_602)\"></path><path class=\"stroke-12 sm:stroke-8 md:stroke-6 lg:stroke-4\" d=\"M0 2H2000\" stroke=\"#0A7FEB\"></path><defs><linearGradient id=\"paint0_linear_8680_602\" x1=\"1.23747e-05\" y1=\"2.5\" x2=\"0.173333\" y2=\"-11.5554\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#45C5E3\"></stop><stop offset=\"1\" stop-color=\"#BFD630\"></stop></linearGradient></defs>", 3)
    ]));
}

});

parcelRegister("la7ve", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6805a0a0156f075$export$2e2bcd8739ae039);
let $f6805a0a0156f075$var$NOOP = ()=>{};
var $f6805a0a0156f075$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("2HsZk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f76155e0fea8f77$export$2e2bcd8739ae039);
let $1f76155e0fea8f77$var$script;



let $1f76155e0fea8f77$var$initialize = ()=>{
    $1f76155e0fea8f77$var$script = (parcelRequire("hGXKz"));
    if ($1f76155e0fea8f77$var$script.__esModule) $1f76155e0fea8f77$var$script = $1f76155e0fea8f77$var$script.default;
    $1f76155e0fea8f77$var$script.render = (parcelRequire("445kE")).render;
    (parcelRequire("7Rqtt")).default($1f76155e0fea8f77$var$script);
    $1f76155e0fea8f77$var$script.__scopeId = 'data-v-db8d7b';
    $1f76155e0fea8f77$var$script.__file = "header.vue";
};
$1f76155e0fea8f77$var$initialize();
var $1f76155e0fea8f77$export$2e2bcd8739ae039 = $1f76155e0fea8f77$var$script;

});
parcelRegister("hGXKz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ce14b5115fc4b3dd$export$2e2bcd8739ae039);

var $gnCBA = parcelRequire("gnCBA");
var $ce14b5115fc4b3dd$export$2e2bcd8739ae039 = {
    __name: 'header',
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            get logoUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($gnCBA));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("445kE", function(module, exports) {

$parcel$export(module.exports, "render", () => $2f5babfe958715f6$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $2f5babfe958715f6$var$_hoisted_1 = {
    class: "px-6 sm:px-8",
    ref: "header"
};
const $2f5babfe958715f6$var$_hoisted_2 = {
    href: "https://www.biomerieux.com/",
    class: "z-20 mt-4 sm:mt-0"
};
const $2f5babfe958715f6$var$_hoisted_3 = [
    "src"
];
function $2f5babfe958715f6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("header", $2f5babfe958715f6$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", {
            class: (0, $8POXm.normalizeClass)([
                "sm:relative max-w-screen-xl mx-auto flex sm:justify-center py-4 sm:py-5 min-h-[76px]",
                [
                    _ctx.$slots.default ? 'justify-between' : 'justify-center'
                ]
            ])
        }, [
            (0, $TusQn.createElementVNode)("a", $2f5babfe958715f6$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("img", {
                    class: "w-[66px] h-[66px] -mb-[58px] transition-[height,width] duration-300 sm:w-[124px] sm:h-[124px] sm:-mb-[62px]",
                    src: $setup.logoUrl,
                    alt: "bioM\xe9rieux logo"
                }, null, 8 /* PROPS */ , $2f5babfe958715f6$var$_hoisted_3)
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ], 2 /* CLASS */ )
    ], 512 /* NEED_PATCH */ );
}

});

parcelRegister("7Rqtt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b9204e1adfb7980$export$2e2bcd8739ae039);
let $5b9204e1adfb7980$var$NOOP = ()=>{};
var $5b9204e1adfb7980$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("8BKbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $64459b3a8ca9b67a$export$2e2bcd8739ae039);
let $64459b3a8ca9b67a$var$script;


let $64459b3a8ca9b67a$var$initialize = ()=>{
    $64459b3a8ca9b67a$var$script = {};
    $64459b3a8ca9b67a$var$script.render = (parcelRequire("8CUAP")).render;
    (parcelRequire("5VwaG")).default($64459b3a8ca9b67a$var$script);
    $64459b3a8ca9b67a$var$script.__scopeId = 'data-v-78736e';
    $64459b3a8ca9b67a$var$script.__file = "footer.vue";
};
$64459b3a8ca9b67a$var$initialize();
var $64459b3a8ca9b67a$export$2e2bcd8739ae039 = $64459b3a8ca9b67a$var$script;

});
parcelRegister("8CUAP", function(module, exports) {

$parcel$export(module.exports, "render", () => $647dc5887c9ad9e9$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $647dc5887c9ad9e9$var$_hoisted_1 = {
    class: "max-w-6xl mx-auto"
};
const $647dc5887c9ad9e9$var$_hoisted_2 = {
    class: "max-w-5xl mx-auto text-xs text-white text-center"
};
function $647dc5887c9ad9e9$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("footer", null, [
        (0, $TusQn.createElementVNode)("div", {
            class: (0, $8POXm.normalizeClass)({
                'mt-8 sm:mt-16': _ctx.$slots.logo
            })
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "logo")
        ], 2 /* CLASS */ ),
        (0, $TusQn.createElementVNode)("div", {
            class: (0, $8POXm.normalizeClass)([
                "bg-blue-primary px-6 py-16 sm:px-8 lg:px-24",
                [
                    _ctx.$slots.logo && _ctx.$slots.note ? 'sm:py-28' : ''
                ]
            ])
        }, [
            (0, $TusQn.createElementVNode)("div", $647dc5887c9ad9e9$var$_hoisted_1, [
                (0, $TusQn.createElementVNode)("h2", {
                    class: (0, $8POXm.normalizeClass)([
                        "font-bold text-white text-center",
                        [
                            _ctx.$slots.logo && _ctx.$slots.note ? 'mb-12' : 'mb-4'
                        ]
                    ])
                }, "PIONEERING DIAGNOSTICS", 2 /* CLASS */ ),
                (0, $TusQn.createElementVNode)("div", $647dc5887c9ad9e9$var$_hoisted_2, [
                    (0, $TusQn.renderSlot)(_ctx.$slots, "note"),
                    _cache[0] || (_cache[0] = (0, $TusQn.createStaticVNode)('<p> \xa9<span data-use-full-year></span> bioM\xe9rieux, Inc. <span class="font-extrabold">\xb7 </span><a class="underline" href="https://www.biomerieux.com/us/en/service-and-support/patents.html">Patents</a><span class="font-extrabold"> \xb7</span> 515 Colorow Drive, Salt Lake City, UT 84108 <span class="font-extrabold">\xb7</span> Tel: <a href="tel:+18006347656">(800) 634-7656</a><span class="font-extrabold"> \xb7 </span><a class="underline" href="https://www.biomerieux.com/us/en/privacy/protection-of-personal-information-and-commitment-to-privacy.html">Privacy Policy</a><span class="font-extrabold"> \xb7</span> BMX.1.168991 <span class="font-extrabold">\xb7</span> Rev01.A. </p>', 1))
                ])
            ])
        ], 2 /* CLASS */ )
    ]);
}

});

parcelRegister("5VwaG", function(module, exports) {

$parcel$export(module.exports, "default", () => $450b3b3132416cf6$export$2e2bcd8739ae039);
let $450b3b3132416cf6$var$NOOP = ()=>{};
var $450b3b3132416cf6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jp4JI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20406a9541aaeea$export$2e2bcd8739ae039);
let $e20406a9541aaeea$var$script;



let $e20406a9541aaeea$var$initialize = ()=>{
    $e20406a9541aaeea$var$script = (parcelRequire("af2Hm"));
    if ($e20406a9541aaeea$var$script.__esModule) $e20406a9541aaeea$var$script = $e20406a9541aaeea$var$script.default;
    $e20406a9541aaeea$var$script.render = (parcelRequire("haCQx")).render;
    (parcelRequire("hpJr5")).default($e20406a9541aaeea$var$script);
    $e20406a9541aaeea$var$script.__scopeId = 'data-v-6fc8db';
    $e20406a9541aaeea$var$script.__file = "button.vue";
};
$e20406a9541aaeea$var$initialize();
var $e20406a9541aaeea$export$2e2bcd8739ae039 = $e20406a9541aaeea$var$script;

});
parcelRegister("af2Hm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $774d65ea4f7d8109$export$2e2bcd8739ae039);
var $774d65ea4f7d8109$export$2e2bcd8739ae039 = {
    __name: 'button',
    props: [
        'size'
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("haCQx", function(module, exports) {

$parcel$export(module.exports, "render", () => $c80180ea0f085cfa$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
function $c80180ea0f085cfa$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: (0, $8POXm.normalizeClass)([
            "rounded-full cursor-pointer text-center font-bold capitalize",
            [
                $props.size === 'sm' ? 'px-6 py-2 text-sm' : 'sm:px-10 py-3 text-base'
            ]
        ])
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 2 /* CLASS */ );
}

});

parcelRegister("hpJr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad8041147f1c6a6$export$2e2bcd8739ae039);
let $cad8041147f1c6a6$var$NOOP = ()=>{};
var $cad8041147f1c6a6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("azAp0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b2969010d35c9a6$export$2e2bcd8739ae039);
let $7b2969010d35c9a6$var$script;



let $7b2969010d35c9a6$var$initialize = ()=>{
    $7b2969010d35c9a6$var$script = (parcelRequire("d3ZA0"));
    if ($7b2969010d35c9a6$var$script.__esModule) $7b2969010d35c9a6$var$script = $7b2969010d35c9a6$var$script.default;
    $7b2969010d35c9a6$var$script.render = (parcelRequire("5QTOQ")).render;
    (parcelRequire("j0IDV")).default($7b2969010d35c9a6$var$script);
    $7b2969010d35c9a6$var$script.__scopeId = 'data-v-ac2982';
    $7b2969010d35c9a6$var$script.__file = "demographic.vue";
};
$7b2969010d35c9a6$var$initialize();
var $7b2969010d35c9a6$export$2e2bcd8739ae039 = $7b2969010d35c9a6$var$script;

});
parcelRegister("d3ZA0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $982b52a2ae7f2932$export$2e2bcd8739ae039);
var $982b52a2ae7f2932$export$2e2bcd8739ae039 = {
    __name: 'demographic',
    props: [
        'stat'
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const { icon: icon, statistic: statistic } = __props.stat;
        const __returned__ = {
            icon: icon,
            statistic: statistic
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("5QTOQ", function(module, exports) {

$parcel$export(module.exports, "render", () => $442d1b9a92fc04b1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $442d1b9a92fc04b1$var$_hoisted_1 = {
    class: "flex gap-2 py-5 @container"
};
const $442d1b9a92fc04b1$var$_hoisted_2 = [
    "src",
    "alt"
];
const $442d1b9a92fc04b1$var$_hoisted_3 = {
    class: "capitalize"
};
const $442d1b9a92fc04b1$var$_hoisted_4 = {
    class: "font-bold"
};
function $442d1b9a92fc04b1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $442d1b9a92fc04b1$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("img", {
            src: $setup.icon,
            alt: $setup.statistic + ' icon',
            class: "w-6 h-6 hidden @xs:block"
        }, null, 8 /* PROPS */ , $442d1b9a92fc04b1$var$_hoisted_2),
        (0, $TusQn.createElementVNode)("p", $442d1b9a92fc04b1$var$_hoisted_3, (0, $8POXm.toDisplayString)($setup.statistic) + ":", 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("span", $442d1b9a92fc04b1$var$_hoisted_4, (0, $8POXm.toDisplayString)($props.stat.value), 1 /* TEXT */ )
    ]);
}

});

parcelRegister("j0IDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd70a5958ecfe0fa$export$2e2bcd8739ae039);
let $dd70a5958ecfe0fa$var$NOOP = ()=>{};
var $dd70a5958ecfe0fa$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("6UCRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $50861da43c641bac$export$2e2bcd8739ae039);
let $50861da43c641bac$var$script;



let $50861da43c641bac$var$initialize = ()=>{
    $50861da43c641bac$var$script = (parcelRequire("61NOu"));
    if ($50861da43c641bac$var$script.__esModule) $50861da43c641bac$var$script = $50861da43c641bac$var$script.default;
    $50861da43c641bac$var$script.render = (parcelRequire("37Sn8")).render;
    (parcelRequire("hzlku")).default($50861da43c641bac$var$script);
    $50861da43c641bac$var$script.__scopeId = 'data-v-bcd497';
    $50861da43c641bac$var$script.__file = "population-health.vue";
};
$50861da43c641bac$var$initialize();
var $50861da43c641bac$export$2e2bcd8739ae039 = $50861da43c641bac$var$script;

});
parcelRegister("61NOu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $463979f4b59622fe$export$2e2bcd8739ae039);

var $8IRL5 = parcelRequire("8IRL5");
var $463979f4b59622fe$export$2e2bcd8739ae039 = {
    __name: 'population-health',
    props: [
        'metric'
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const { icon: icon, statistic: statistic } = __props.metric;
        const __returned__ = {
            icon: icon,
            statistic: statistic,
            get alertUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($8IRL5));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("8IRL5", function(module, exports) {
module.exports = import.meta.resolve("7um3v");

});


parcelRegister("37Sn8", function(module, exports) {

$parcel$export(module.exports, "render", () => $246c33b33aa71a49$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $246c33b33aa71a49$var$_hoisted_1 = {
    class: "@container border-[1.5px] border-blue-fresh bg-black/15 px-5 flex justify-between items-center rounded-md"
};
const $246c33b33aa71a49$var$_hoisted_2 = {
    class: "flex gap-2 @xs:gap-4 items-center py-5"
};
const $246c33b33aa71a49$var$_hoisted_3 = [
    "src",
    "alt"
];
const $246c33b33aa71a49$var$_hoisted_4 = [
    "src"
];
const $246c33b33aa71a49$var$_hoisted_5 = {
    class: "max-w-24 font-bold capitalize"
};
const $246c33b33aa71a49$var$_hoisted_6 = {
    class: "flex flex-col gap-1 py-3 sm:py-0"
};
const $246c33b33aa71a49$var$_hoisted_7 = {
    key: 0,
    class: "flex gap-1 items-center justify-end"
};
const $246c33b33aa71a49$var$_hoisted_8 = {
    class: "font-bold text-2xl sm:text-3xl lg:text-4xl"
};
const $246c33b33aa71a49$var$_hoisted_9 = {
    key: 1,
    class: "flex items-center justify-end"
};
const $246c33b33aa71a49$var$_hoisted_10 = {
    class: "text-white/50 text-xs sm:text-sm italic text-end"
};
function $246c33b33aa71a49$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $246c33b33aa71a49$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $246c33b33aa71a49$var$_hoisted_2, [
            !$props.metric.alert ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                key: 0,
                src: $setup.icon,
                alt: $setup.statistic + 'icon',
                class: "h-11 w-11 hidden @2xs:block"
            }, null, 8 /* PROPS */ , $246c33b33aa71a49$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("img", {
                key: 1,
                src: $setup.alertUrl,
                class: "h-11 w-11 hidden @2xs:block"
            }, null, 8 /* PROPS */ , $246c33b33aa71a49$var$_hoisted_4)),
            (0, $TusQn.createElementVNode)("p", $246c33b33aa71a49$var$_hoisted_5, (0, $8POXm.toDisplayString)($setup.statistic), 1 /* TEXT */ )
        ]),
        (0, $TusQn.createElementVNode)("div", $246c33b33aa71a49$var$_hoisted_6, [
            $props.metric.localValue ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $246c33b33aa71a49$var$_hoisted_7, [
                (0, $TusQn.createElementVNode)("span", $246c33b33aa71a49$var$_hoisted_8, (0, $8POXm.toDisplayString)($props.metric.localValue) + "% ", 1 /* TEXT */ ),
                _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("p", {
                    class: "text-xs max-w-13 @2xs:text-sm @2xs:max-w-16 leading-4 text-end"
                }, "of county residents", -1 /* HOISTED */ ))
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $246c33b33aa71a49$var$_hoisted_9, _cache[1] || (_cache[1] = [
                (0, $TusQn.createElementVNode)("span", {
                    class: "font-bold text-2xl sm:text-3xl lg:text-4xl"
                }, "N/A", -1 /* HOISTED */ )
            ]))),
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("p", $246c33b33aa71a49$var$_hoisted_10, (0, $8POXm.toDisplayString)($props.metric.nationalValue) + "% national average ", 1 /* TEXT */ )
            ])
        ])
    ]);
}

});

parcelRegister("hzlku", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca64027ed5c4327$export$2e2bcd8739ae039);
let $cca64027ed5c4327$var$NOOP = ()=>{};
var $cca64027ed5c4327$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jmFna", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1902a26625f5b9c$export$2e2bcd8739ae039);
let $e1902a26625f5b9c$var$script;



let $e1902a26625f5b9c$var$initialize = ()=>{
    $e1902a26625f5b9c$var$script = (parcelRequire("eHoP9"));
    if ($e1902a26625f5b9c$var$script.__esModule) $e1902a26625f5b9c$var$script = $e1902a26625f5b9c$var$script.default;
    $e1902a26625f5b9c$var$script.render = (parcelRequire("e3PVY")).render;
    (parcelRequire("wDLLo")).default($e1902a26625f5b9c$var$script);
    $e1902a26625f5b9c$var$script.__scopeId = 'data-v-52b7de';
    $e1902a26625f5b9c$var$script.__file = "health-data-cards.vue";
};
$e1902a26625f5b9c$var$initialize();
var $e1902a26625f5b9c$export$2e2bcd8739ae039 = $e1902a26625f5b9c$var$script;

});
parcelRegister("eHoP9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ab385665a6405949$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $cQQ5k = parcelRequire("cQQ5k");

var $vCgWZ = parcelRequire("vCgWZ");
var $ab385665a6405949$export$2e2bcd8739ae039 = {
    __name: 'health-data-cards',
    props: [
        'card',
        'bgColor'
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const titleRef = (0, $01W3b.ref)(null);
        const dataFound = (0, $01W3b.computed)(()=>__props.card?.localValue || __props.card?.localValue === 0);
        const __returned__ = {
            titleRef: titleRef,
            dataFound: dataFound,
            computed: $01W3b.computed,
            ref: $01W3b.ref,
            get moreInfoUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($cQQ5k));
            },
            get closeUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($vCgWZ));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("cQQ5k", function(module, exports) {
module.exports = import.meta.resolve("hhIjE");

});

parcelRegister("vCgWZ", function(module, exports) {
module.exports = import.meta.resolve("2raBe");

});


parcelRegister("e3PVY", function(module, exports) {

$parcel$export(module.exports, "render", () => $a3c9a18109f6a8de$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a3c9a18109f6a8de$var$_hoisted_1 = {
    class: "min-h-50 hover:cursor-pointer group"
};
const $a3c9a18109f6a8de$var$_hoisted_2 = {
    key: 0,
    class: "bg-white flex flex-col rounded-md shadow-md h-full relative @container"
};
const $a3c9a18109f6a8de$var$_hoisted_3 = {
    ref: "titleRef",
    class: "font-bold text-center uppercase py-1.5 px-4 min-h-10 flex items-center text-sm md:text-base"
};
const $a3c9a18109f6a8de$var$_hoisted_4 = [
    "innerHTML"
];
const $a3c9a18109f6a8de$var$_hoisted_5 = {
    class: "ml-1"
};
const $a3c9a18109f6a8de$var$_hoisted_6 = {
    class: "absolute end-0 mr-2 @xs:mr-4"
};
const $a3c9a18109f6a8de$var$_hoisted_7 = [
    "src"
];
const $a3c9a18109f6a8de$var$_hoisted_8 = {
    key: 0,
    class: "flex gap-2.5 items-center text-[#373737]"
};
const $a3c9a18109f6a8de$var$_hoisted_9 = {
    key: 0
};
const $a3c9a18109f6a8de$var$_hoisted_10 = {
    class: "text-md @2xs:text-lg max-w-35 @2xs:max-w-40 leading-5"
};
const $a3c9a18109f6a8de$var$_hoisted_11 = {
    key: 1,
    class: "flex items-center text-[#373737]"
};
const $a3c9a18109f6a8de$var$_hoisted_12 = {
    key: 2,
    class: "text-neutral-500 italic text-center"
};
const $a3c9a18109f6a8de$var$_hoisted_13 = {
    key: 0
};
const $a3c9a18109f6a8de$var$_hoisted_14 = {
    key: 1
};
const $a3c9a18109f6a8de$var$_hoisted_15 = {
    key: 3,
    class: "text-neutral-500 italic text-center"
};
const $a3c9a18109f6a8de$var$_hoisted_16 = {
    key: 1,
    class: "bg-white px-4 pb-4 rounded-md shadow-md space-y-3 h-full flex flex-col"
};
const $a3c9a18109f6a8de$var$_hoisted_17 = {
    class: "flex justify-between items-center h-10 py-2 border-b border-[#E4E4E4]"
};
const $a3c9a18109f6a8de$var$_hoisted_18 = {
    class: "rounded-full group-hover:bg-neutral-200 p-1 flex items-center justify-center"
};
const $a3c9a18109f6a8de$var$_hoisted_19 = [
    "src"
];
const $a3c9a18109f6a8de$var$_hoisted_20 = {
    class: "grow flex flex-col gap-4"
};
const $a3c9a18109f6a8de$var$_hoisted_21 = [
    "innerHTML"
];
const $a3c9a18109f6a8de$var$_hoisted_22 = {
    key: 0
};
const $a3c9a18109f6a8de$var$_hoisted_23 = [
    "href"
];
function $a3c9a18109f6a8de$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a3c9a18109f6a8de$var$_hoisted_1, [
        !$props.card?.moreInfo.active ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a3c9a18109f6a8de$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", {
                class: (0, $8POXm.normalizeClass)([
                    $props.card?.alert ? 'bg-red' : `${$props.bgColor}`,
                    $props.card?.alert || $props.card?.tab === 'bloodstream-infections' ? 'text-white' : 'text-neutral-900',
                    'rounded-t-md flex items-center justify-center px-4'
                ])
            }, [
                (0, $TusQn.createElementVNode)("h2", $a3c9a18109f6a8de$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", null, [
                        (0, $TusQn.createElementVNode)("span", {
                            innerHTML: $props.card?.title
                        }, null, 8 /* PROPS */ , $a3c9a18109f6a8de$var$_hoisted_4),
                        (0, $TusQn.createElementVNode)("sup", $a3c9a18109f6a8de$var$_hoisted_5, (0, $8POXm.toDisplayString)($props.card?.reference), 1 /* TEXT */ )
                    ])
                ], 512 /* NEED_PATCH */ ),
                (0, $TusQn.createElementVNode)("div", $a3c9a18109f6a8de$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("img", {
                        class: "size-5 group-hover:brightness-85",
                        src: $setup.moreInfoUrl
                    }, null, 8 /* PROPS */ , $a3c9a18109f6a8de$var$_hoisted_7)
                ])
            ], 2 /* CLASS */ ),
            (0, $TusQn.createElementVNode)("div", {
                class: (0, $8POXm.normalizeClass)([
                    $props.card?.alert ? 'border-red' : 'border-white',
                    'flex flex-col items-center justify-center gap-4 border-2 p-4 rounded-b-md border-t-0 h-full'
                ])
            }, [
                $setup.dataFound ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a3c9a18109f6a8de$var$_hoisted_8, [
                    (0, $TusQn.createElementVNode)("p", {
                        class: (0, $8POXm.normalizeClass)([
                            "font-bold text-5xl @2xs:text-6xl flex",
                            {
                                'text-red': $props.card?.alert
                            }
                        ])
                    }, [
                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($props.card?.localValue), 1 /* TEXT */ ),
                        $props.card?.symbol ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a3c9a18109f6a8de$var$_hoisted_9, "%")) : (0, $TusQn.createCommentVNode)("v-if", true)
                    ], 2 /* CLASS */ ),
                    (0, $TusQn.createElementVNode)("p", $a3c9a18109f6a8de$var$_hoisted_10, (0, $8POXm.toDisplayString)($props.card?.description), 1 /* TEXT */ )
                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a3c9a18109f6a8de$var$_hoisted_11, _cache[1] || (_cache[1] = [
                    (0, $TusQn.createElementVNode)("p", {
                        class: "font-bold text-4xl @2xs:text-6xl flex"
                    }, "N/A", -1 /* HOISTED */ )
                ]))),
                $setup.dataFound ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $a3c9a18109f6a8de$var$_hoisted_12, [
                    $props.card?.alert ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a3c9a18109f6a8de$var$_hoisted_13, "Above\xa0")) : (0, $TusQn.createCommentVNode)("v-if", true),
                    (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($props.card?.nationalValue), 1 /* TEXT */ ),
                    $props.card?.symbol ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $a3c9a18109f6a8de$var$_hoisted_14, "%")) : (0, $TusQn.createCommentVNode)("v-if", true),
                    _cache[2] || (_cache[2] = (0, $TusQn.createTextVNode)(" National Average "))
                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $a3c9a18109f6a8de$var$_hoisted_15, " Data Not Available "))
            ], 2 /* CLASS */ )
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        $props.card?.moreInfo?.active ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a3c9a18109f6a8de$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $a3c9a18109f6a8de$var$_hoisted_17, [
                _cache[3] || (_cache[3] = (0, $TusQn.createElementVNode)("h2", {
                    class: "text-[#373737] font-bold text-sm"
                }, "What does this data mean?", -1 /* HOISTED */ )),
                (0, $TusQn.createElementVNode)("span", $a3c9a18109f6a8de$var$_hoisted_18, [
                    (0, $TusQn.createElementVNode)("img", {
                        class: "size-3",
                        src: $setup.closeUrl
                    }, null, 8 /* PROPS */ , $a3c9a18109f6a8de$var$_hoisted_19)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a3c9a18109f6a8de$var$_hoisted_20, [
                (0, $TusQn.createElementVNode)("div", null, [
                    (0, $TusQn.createElementVNode)("p", {
                        class: "text-[#373737] text-sm leading-4",
                        innerHTML: $props.card?.moreInfo?.description
                    }, null, 8 /* PROPS */ , $a3c9a18109f6a8de$var$_hoisted_21)
                ]),
                $props.card?.moreInfo?.url ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a3c9a18109f6a8de$var$_hoisted_22, [
                    _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("p", {
                        class: "italic text-neutral-500 text-xs font-bold"
                    }, "Source:", -1 /* HOISTED */ )),
                    (0, $TusQn.createElementVNode)("a", {
                        href: $props.card?.moreInfo?.url,
                        onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(()=>{}, [
                            "stop"
                        ])),
                        target: "_blank",
                        class: "italic text-neutral-500 text-xs hover:underline"
                    }, [
                        (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)($props.card?.moreInfo?.source), 1 /* TEXT */ )
                    ], 8 /* PROPS */ , $a3c9a18109f6a8de$var$_hoisted_23)
                ])) : (0, $TusQn.createCommentVNode)("v-if", true)
            ])
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        $props.card?.moreInfo.updatedAt ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 2,
            class: (0, $8POXm.normalizeClass)([
                'mt-4 text-sm text-center',
                $props.card?.moreInfo.updatedAt.alert ? 'text-[#69a03b] font-semibold' : 'text-black/35'
            ])
        }, (0, $8POXm.toDisplayString)($props.card?.moreInfo.updatedAt.message), 3 /* TEXT, CLASS */ )) : (0, $TusQn.createCommentVNode)("v-if", true)
    ]);
}

});

parcelRegister("wDLLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0621d6a4be77f655$export$2e2bcd8739ae039);
let $0621d6a4be77f655$var$NOOP = ()=>{};
var $0621d6a4be77f655$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eP4z8", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca95ec55a7d3703$export$2e2bcd8739ae039);
let $aca95ec55a7d3703$var$script;



let $aca95ec55a7d3703$var$initialize = ()=>{
    $aca95ec55a7d3703$var$script = (parcelRequire("lfhB1"));
    if ($aca95ec55a7d3703$var$script.__esModule) $aca95ec55a7d3703$var$script = $aca95ec55a7d3703$var$script.default;
    $aca95ec55a7d3703$var$script.render = (parcelRequire("2bZIh")).render;
    (parcelRequire("5lhUh")).default($aca95ec55a7d3703$var$script);
    $aca95ec55a7d3703$var$script.__scopeId = 'data-v-0b5584';
    $aca95ec55a7d3703$var$script.__file = "community-impact-cards.vue";
};
$aca95ec55a7d3703$var$initialize();
var $aca95ec55a7d3703$export$2e2bcd8739ae039 = $aca95ec55a7d3703$var$script;

});
parcelRegister("lfhB1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f778a5eace94f210$export$2e2bcd8739ae039);
var $f778a5eace94f210$export$2e2bcd8739ae039 = {
    __name: 'community-impact-cards',
    props: [
        'heading',
        'text',
        "reference"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("2bZIh", function(module, exports) {

$parcel$export(module.exports, "render", () => $198c7ad0e7784279$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $198c7ad0e7784279$var$_hoisted_1 = {
    class: "border-t-8 border-t-[#373737] text-[#373737] min-h-45 shadow-md bg-white p-6 text-center flex flex-col gap-2"
};
const $198c7ad0e7784279$var$_hoisted_2 = {
    class: "font-bold text-lg"
};
const $198c7ad0e7784279$var$_hoisted_3 = [
    "innerHTML"
];
const $198c7ad0e7784279$var$_hoisted_4 = {
    key: 0
};
const $198c7ad0e7784279$var$_hoisted_5 = {
    class: "text-xs"
};
function $198c7ad0e7784279$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $198c7ad0e7784279$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h3", $198c7ad0e7784279$var$_hoisted_2, (0, $8POXm.toDisplayString)($props.heading), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("p", null, [
            (0, $TusQn.createElementVNode)("span", {
                innerHTML: $props.text
            }, null, 8 /* PROPS */ , $198c7ad0e7784279$var$_hoisted_3),
            $props.reference ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $198c7ad0e7784279$var$_hoisted_4, [
                (0, $TusQn.createElementVNode)("sup", $198c7ad0e7784279$var$_hoisted_5, (0, $8POXm.toDisplayString)(Array.isArray($props.reference) ? $props.reference.join(',') : $props.reference), 1 /* TEXT */ )
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ])
    ]);
}

});

parcelRegister("5lhUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3ccdd72e5f2515$export$2e2bcd8739ae039);
let $3e3ccdd72e5f2515$var$NOOP = ()=>{};
var $3e3ccdd72e5f2515$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("2OUw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $20dc1742fcec3da7$export$2e2bcd8739ae039);
let $20dc1742fcec3da7$var$script;



let $20dc1742fcec3da7$var$initialize = ()=>{
    $20dc1742fcec3da7$var$script = (parcelRequire("6XQWy"));
    if ($20dc1742fcec3da7$var$script.__esModule) $20dc1742fcec3da7$var$script = $20dc1742fcec3da7$var$script.default;
    $20dc1742fcec3da7$var$script.render = (parcelRequire("27YMY")).render;
    (parcelRequire("3kv6w")).default($20dc1742fcec3da7$var$script);
    $20dc1742fcec3da7$var$script.__scopeId = 'data-v-57a718';
    $20dc1742fcec3da7$var$script.__file = "outbreak-alert.vue";
};
$20dc1742fcec3da7$var$initialize();
var $20dc1742fcec3da7$export$2e2bcd8739ae039 = $20dc1742fcec3da7$var$script;

});
parcelRegister("6XQWy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $51215233ecbe1603$export$2e2bcd8739ae039);

var $jp4JI = parcelRequire("jp4JI");
var $51215233ecbe1603$export$2e2bcd8739ae039 = {
    __name: 'outbreak-alert',
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            Button: $jp4JI.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("27YMY", function(module, exports) {

$parcel$export(module.exports, "render", () => $18cb63a0c358a0e8$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $9bFB0 = parcelRequire("9bFB0");
const $18cb63a0c358a0e8$var$_hoisted_1 = {
    class: "bg-red rounded-md border-2 border-white"
};
const $18cb63a0c358a0e8$var$_hoisted_2 = {
    class: "flex flex-col md:flex-row md:justify-between md:items-center px-6 py-4 gap-6"
};
function $18cb63a0c358a0e8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $18cb63a0c358a0e8$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $18cb63a0c358a0e8$var$_hoisted_2, [
            _cache[1] || (_cache[1] = (0, $TusQn.createStaticVNode)("<div class=\"flex items-center gap-4\"><div class=\"hidden md:block min-w-9 min-h-9\"><img src=\"" + (0, (/*@__PURE__*/$parcel$interopDefault($9bFB0))) + "\"></div><div class=\"flex flex-col gap-2 sm:gap-0\"><p class=\"font-bold text-lg leading-5\">Outbreak Alert: Mycoplasma Pneumonia</p><p class=\"text-sm xl:text-base\">The CDC has flagged a significant spike in cases of Mycoplasma pneumoniae since late spring, which continue to remain high.</p></div></div>", 1)),
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createVNode)($setup["Button"], {
                    size: "sm",
                    class: "bg-white text-blue-primary hover:bg-neutral-200 block whitespace-nowrap"
                }, {
                    default: (0, $TusQn.withCtx)(()=>_cache[0] || (_cache[0] = [
                            (0, $TusQn.createElementVNode)("a", {
                                "data-use-tracking": "",
                                href: ""
                            }, "take action", -1 /* HOISTED */ )
                        ])),
                    _: 1 /* STABLE */ ,
                    __: [
                        0
                    ]
                })
            ])
        ])
    ]);
}

});

parcelRegister("3kv6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $26cb5dfbe2005122$export$2e2bcd8739ae039);
let $26cb5dfbe2005122$var$NOOP = ()=>{};
var $26cb5dfbe2005122$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bMZB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8953f528a68bc3eb$export$2e2bcd8739ae039);
let $8953f528a68bc3eb$var$script;



let $8953f528a68bc3eb$var$initialize = ()=>{
    $8953f528a68bc3eb$var$script = (parcelRequire("eXBhy"));
    if ($8953f528a68bc3eb$var$script.__esModule) $8953f528a68bc3eb$var$script = $8953f528a68bc3eb$var$script.default;
    $8953f528a68bc3eb$var$script.render = (parcelRequire("kMszK")).render;
    (parcelRequire("3kMIf")).default($8953f528a68bc3eb$var$script);
    $8953f528a68bc3eb$var$script.__scopeId = 'data-v-6e5b97';
    $8953f528a68bc3eb$var$script.__file = "references.vue";
};
$8953f528a68bc3eb$var$initialize();
var $8953f528a68bc3eb$export$2e2bcd8739ae039 = $8953f528a68bc3eb$var$script;

});
parcelRegister("eXBhy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ae437ed96ba20867$export$2e2bcd8739ae039);
var $ae437ed96ba20867$export$2e2bcd8739ae039 = {
    __name: 'references',
    props: [
        'references'
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("kMszK", function(module, exports) {

$parcel$export(module.exports, "render", () => $f20e74dca6c647bc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $f20e74dca6c647bc$var$_hoisted_1 = {
    class: "text-[#666] space-y-6"
};
const $f20e74dca6c647bc$var$_hoisted_2 = {
    key: 0,
    class: "space-y-4"
};
const $f20e74dca6c647bc$var$_hoisted_3 = {
    class: "flex gap-2"
};
const $f20e74dca6c647bc$var$_hoisted_4 = {
    class: "min-w-6 text-end"
};
const $f20e74dca6c647bc$var$_hoisted_5 = {
    class: ""
};
const $f20e74dca6c647bc$var$_hoisted_6 = [
    "href"
];
function $f20e74dca6c647bc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("div", $f20e74dca6c647bc$var$_hoisted_1, [
            _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("p", null, " The data presented in this tool is for informational and educational purposes only. It reflects pathogen trends observed across the United States, and may not indicate potential outbreaks or emerging regional trends. Always refer to relevant guidelines to determine appropriate testing. ", -1 /* HOISTED */ )),
            _cache[2] || (_cache[2] = (0, $TusQn.createElementVNode)("p", null, " The data presented in this tool is updated on an annual basis (subject to change). Each individual pathogen notes the specific date that the data was pulled and how often the source publishes said data. Please consult the original source for the most current data. National averages are not part of the original source data. ", -1 /* HOISTED */ )),
            $props.references.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f20e74dca6c647bc$var$_hoisted_2, [
                _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("h2", null, "References", -1 /* HOISTED */ )),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.references, (reference)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", null, [
                        (0, $TusQn.createElementVNode)("li", $f20e74dca6c647bc$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("span", $f20e74dca6c647bc$var$_hoisted_4, (0, $8POXm.toDisplayString)(reference.id) + ".", 1 /* TEXT */ ),
                            (0, $TusQn.createElementVNode)("div", $f20e74dca6c647bc$var$_hoisted_5, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(reference.text), 1 /* TEXT */ ),
                                reference.url ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                    key: 0,
                                    class: "block break-all hover:underline",
                                    href: reference.url,
                                    target: "_blank"
                                }, (0, $8POXm.toDisplayString)(reference.url), 9 /* TEXT, PROPS */ , $f20e74dca6c647bc$var$_hoisted_6)) : (0, $TusQn.createCommentVNode)("v-if", true)
                            ])
                        ])
                    ]);
                }), 256 /* UNKEYED_FRAGMENT */ ))
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ])
    ]);
}

});

parcelRegister("3kMIf", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d906aa9fe24280$export$2e2bcd8739ae039);
let $26d906aa9fe24280$var$NOOP = ()=>{};
var $26d906aa9fe24280$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("670qV", function(module, exports) {
module.exports = JSON.parse("[{\"id\":1,\"heading\":\"Patient Satisfaction\",\"text\":\"Syndromic testing can enhance patient outcomes by guiding more precise and timely therapies, lowering hospital admissions, and reducing the misuse of antimicrobials.\",\"reference\":[10,11]},{\"id\":2,\"heading\":\"Faster Triage\",\"text\":\"PCR testing has been shown to <strong>significantly enhance patient triage efficiency</strong>.\",\"reference\":8},{\"id\":3,\"heading\":\"Improved Workflow\",\"text\":\"Streamlined and faster sample-to-answer workflows with Minimal hands-on time and sample preparation.\",\"reference\":[9,12,13]},{\"id\":4,\"heading\":\"Reduce Cost\",\"text\":\"Syndromic testing leads to more accurate diagnoses, improved patient outcomes, and potentially reduced long-term costs.\",\"reference\":9}]");

});

parcelRegister("tMxeq", function(module, exports) {
module.exports = JSON.parse("[{\"id\":1,\"text\":\"Census Bureau, Population and Housing Unit Estimates.\",\"url\":\"https://www.census.gov/programs-surveys/popest.html\"},{\"id\":2,\"text\":\"Census Bureau, American Community Survey (ACS).\",\"url\":\"https://www.census.gov/programs-surveys/acs.html\"},{\"id\":3,\"text\":\"Centers for Disease Control and Prevention, PLACES: County Data (GIS Friendly Format).\",\"url\":\"https://data.cdc.gov/500-Cities-Places/PLACES-County-Data-GIS-Friendly-Format-2024-releas/i46a-9kgh/about_data\"},{\"id\":4,\"text\":\"Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).\",\"url\":\"https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data\"},{\"id\":5,\"text\":\"Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.\",\"url\":\"https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data\"},{\"id\":6,\"text\":\"Centers for Disease Control and Prevention, NNDSS Weekly Data.\",\"url\":\"https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data\"},{\"id\":7,\"text\":\"Turner L. Point-of-Care Testing in the Urgent Care Setting. Sekisuidiagnostics.com. Published May 15, 2019.\",\"url\":\"https://blog.sekisuidiagnostics.com/dxdialogue/point-of-care-testing/2019/05/15/point-of-care-testing-in-the-urgent-care-setting\"},{\"id\":8,\"text\":\"Fistera D, Kikull K, Risse J, Herrmann A, Brachmann M, Kill C. Point-of-care PCR testing of SARS-CoV-2 in the emergency department: Influence on workflow and efficiency. PLOS ONE. 2023;18(8):e0288906\",\"url\":\"https://doi.org/10.1371/journal.pone.0288906\"},{\"id\":9,\"text\":\"Clark TW, Lindsley K, Wigmosta TB, et al. Rapid multiplex PCR for respiratory viruses reduces time to result and improves clinical care: Results of a systematic review and meta-analysis. Journal of Infection. 2023;86(5):462-475.\",\"url\":\"https://doi.org/10.1016/j.jinf.2023.03.005\"},{\"id\":10,\"text\":\"Rappo U, Schuetz AN, Jenkins SG et al. Impact of early detection of respiratory viruses by multiplex PCR assay on clinical outcomes in adult patients. J Clin Microbiol. 2016; 54: 2096-103.\",\"url\":\"https://doi.org/doi/10.1128/jcm.00549-16\"},{\"id\":11,\"text\":\"Peri AM, Ling W, Furuya-Kanamori L, Harris PNA, Paterson DL, et al. Performance of BioFire Blood Culture Identification 2 Panel (BCID2) for the detection of bloodstream pathogens and their associated resistance markers: a systematic review and meta-analysis of diagnostic test accuracy studies. BMC Infect Dis. 2022;22(1):794. doi:10.1186/s12879-022-07772-x\",\"url\":\"https://bmcinfectdis.biomedcentral.com/articles/10.1186/s12879-022-07772-x\"},{\"id\":12,\"text\":\"Axelrad, J, et al. Impact of gastrointestinal panel implementation on health care utilization and outcomes. J Clin Mirobiol. 2019;57(3):e01775-18. doi: 10.1128/JCM.01775-18\",\"url\":\"https://doi.org/10.1128/jcm.01775-18\"},{\"id\":13,\"text\":\"Bard J, McElvania E. Panels and syndromic testing in clinical microbiology. Clin Lab Med. 2020;40(4):393-420. doi: 10.1016/j.cll.2020.08.001\",\"url\":\"https://doi.org/10.1016/j.cll.2020.08.001\"}]");

});


parcelRegister("4v856", function(module, exports) {

$parcel$export(module.exports, "render", () => $347053712799b2f8$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $347053712799b2f8$var$_hoisted_1 = {
    class: "flex items-center"
};
const $347053712799b2f8$var$_hoisted_2 = {
    key: 0,
    class: "text-white"
};
const $347053712799b2f8$var$_hoisted_3 = {
    class: "bg-linear-to-t from-blue-primary to-blue-prussian px-6 sm:px-8 pb-6"
};
const $347053712799b2f8$var$_hoisted_4 = {
    class: "max-w-screen-xl mx-auto py-8"
};
const $347053712799b2f8$var$_hoisted_5 = {
    class: "sm:pt-0 pt-4 flex flex-col items-start gap-4 sm:flex-row sm:justify-between sm:items-center"
};
const $347053712799b2f8$var$_hoisted_6 = {
    key: 0
};
const $347053712799b2f8$var$_hoisted_7 = {
    class: "bg-linear-to-r from-[#45C5E3] to-[#BFD630] inline-block text-transparent bg-clip-text font-bold text-2xl sm:text-3xl capitalize"
};
const $347053712799b2f8$var$_hoisted_8 = {
    key: 1
};
const $347053712799b2f8$var$_hoisted_9 = {
    class: "font-bold text-2xl sm:text-3xl"
};
const $347053712799b2f8$var$_hoisted_10 = {
    class: "relative"
};
const $347053712799b2f8$var$_hoisted_11 = {
    key: 0,
    class: "max-w-screen-xl mx-auto"
};
const $347053712799b2f8$var$_hoisted_12 = {
    key: 1,
    class: "max-w-screen-xl mx-auto py-8"
};
const $347053712799b2f8$var$_hoisted_13 = {
    class: "grid xl:grid-cols-3 gap-8"
};
const $347053712799b2f8$var$_hoisted_14 = {
    class: "flex flex-col"
};
const $347053712799b2f8$var$_hoisted_15 = {
    class: "font-bold text-xl mb-4"
};
const $347053712799b2f8$var$_hoisted_16 = {
    class: "text-xs -ml-0.5"
};
const $347053712799b2f8$var$_hoisted_17 = {
    class: "xl:col-span-2"
};
const $347053712799b2f8$var$_hoisted_18 = {
    class: "font-bold text-xl mb-4"
};
const $347053712799b2f8$var$_hoisted_19 = {
    class: "text-xs -ml-0.5"
};
const $347053712799b2f8$var$_hoisted_20 = {
    class: "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6"
};
const $347053712799b2f8$var$_hoisted_21 = {
    class: "max-w-screen-xl mx-auto"
};
const $347053712799b2f8$var$_hoisted_22 = {
    class: "flex justify-between pt-4 items-end gap-8"
};
const $347053712799b2f8$var$_hoisted_23 = {
    class: "flex overflow-x-auto whitespace-nowrap relative -bottom-[5px]"
};
const $347053712799b2f8$var$_hoisted_24 = [
    "id",
    "disabled",
    "onClick"
];
const $347053712799b2f8$var$_hoisted_25 = {
    class: "flex gap-x-2"
};
const $347053712799b2f8$var$_hoisted_26 = {
    key: 0,
    class: "flex items-center px-2 text-xs text-white bg-[#69a03b] rounded-md"
};
const $347053712799b2f8$var$_hoisted_27 = {
    key: 1,
    class: "overflow-hidden bg-grey-background px-6 sm:px-8 pb-12 md:pb-16 xl:pb-20"
};
const $347053712799b2f8$var$_hoisted_28 = {
    class: "max-w-screen-xl mx-auto"
};
const $347053712799b2f8$var$_hoisted_29 = {
    key: 0,
    class: "grid lg:grid-cols-3 sm:grid-cols-2 gap-8 md:gap-x-12 md: gap-y-18"
};
const $347053712799b2f8$var$_hoisted_30 = {
    key: 1,
    class: "flex flex-col gap-16"
};
const $347053712799b2f8$var$_hoisted_31 = {
    class: "grid gap-x-8 gap-y-16 sm:grid-cols-2"
};
const $347053712799b2f8$var$_hoisted_32 = {
    class: "grid gap-x-8 gap-y-16 sm:grid-cols-2"
};
const $347053712799b2f8$var$_hoisted_33 = {
    class: "grid gap-x-8 gap-y-16 sm:grid-cols-2"
};
const $347053712799b2f8$var$_hoisted_34 = {
    class: "grid gap-x-8 gap-y-16 sm:grid-cols-2"
};
const $347053712799b2f8$var$_hoisted_35 = {
    class: "grid gap-x-8 gap-y-16 sm:grid-cols-2"
};
const $347053712799b2f8$var$_hoisted_36 = {
    ref: "endSection"
};
const $347053712799b2f8$var$_hoisted_37 = {
    class: "grid lg:grid-cols-4 sm:grid-cols-2 gap-8 xl:gap-16"
};
const $347053712799b2f8$var$_hoisted_38 = {
    key: 2,
    class: "bg-blue-primary px-6 sm:px-8 py-8 lg:py-4"
};
const $347053712799b2f8$var$_hoisted_39 = {
    class: "max-w-screen-xl mx-auto flex flex-col lg:h-26 lg:flex-row gap-6 items-center justify-between"
};
const $347053712799b2f8$var$_hoisted_40 = {
    class: "hidden lg:block"
};
const $347053712799b2f8$var$_hoisted_41 = [
    "src"
];
const $347053712799b2f8$var$_hoisted_42 = {
    class: "bg-white px-6 sm:px-8 sm:py-32 py-16"
};
const $347053712799b2f8$var$_hoisted_43 = {
    class: "max-w-screen-lg mx-auto"
};
const $347053712799b2f8$var$_hoisted_44 = {
    class: "grid md:grid-cols-2 gap-8 md:gap-0"
};
const $347053712799b2f8$var$_hoisted_45 = {
    class: "flex items-center justify-center"
};
const $347053712799b2f8$var$_hoisted_46 = [
    "src"
];
const $347053712799b2f8$var$_hoisted_47 = {
    class: "bg-grey-background px-6 sm:px-8 py-12 md:py-16"
};
const $347053712799b2f8$var$_hoisted_48 = {
    class: "max-w-screen-xl mx-auto"
};
const $347053712799b2f8$var$_hoisted_49 = {
    key: 1,
    class: "w-screen h-screen bg-linear-to-t from-blue-primary to-blue-prussian"
};
const $347053712799b2f8$var$_hoisted_50 = [
    "src"
];
function $347053712799b2f8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"], null, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_1, [
                        $setup.place.exists ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["Button"], {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.navigateToForm()),
                            class: "sm:absolute sm:right-0 px-5 sm:px-10 text-sm sm:text-base text-white bg-blue-primary hover:bg-blue-prussian-hover z-20"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>_cache[4] || (_cache[4] = [
                                    (0, $TusQn.createTextVNode)(" download my report ")
                                ])),
                            _: 1 /* STABLE */ ,
                            __: [
                                4
                            ]
                        })) : (0, $TusQn.createCommentVNode)("v-if", true)
                    ])
                ]),
            _: 1 /* STABLE */ 
        }),
        $setup.place.ready ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $347053712799b2f8$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("section", $347053712799b2f8$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_5, [
                        $setup.place.exists ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_6, [
                            _cache[5] || (_cache[5] = (0, $TusQn.createElementVNode)("p", {
                                class: "font-bold uppercase"
                            }, "your area", -1 /* HOISTED */ )),
                            (0, $TusQn.createElementVNode)("h1", $347053712799b2f8$var$_hoisted_7, [
                                (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)($setup.place.county) + ", " + (0, $8POXm.toDisplayString)($setup.place.stateAbbr) + " (" + (0, $8POXm.toDisplayString)($setup.zipCode) + ")", 1 /* TEXT */ )
                            ]),
                            _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("p", {
                                class: "max-w-lg mt-4 italic text-xs"
                            }, " Note: State or regional data may be used when county data is unavailable. National averages are calculated for each data point given the county, state, or regional data available. National averages are not part of the original source data. ", -1 /* HOISTED */ ))
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_8, [
                            _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("p", {
                                class: "bg-linear-to-r from-[#45C5E3] to-[#BFD630] inline-block text-transparent bg-clip-text font-bold uppercase"
                            }, "please try again", -1 /* HOISTED */ )),
                            (0, $TusQn.createElementVNode)("h1", $347053712799b2f8$var$_hoisted_9, " Your ZIP code \"" + (0, $8POXm.toDisplayString)($setup.zipCode) + "\" was not found. ", 1 /* TEXT */ )
                        ])),
                        (0, $TusQn.createElementVNode)("form", {
                            onSubmit: (0, $eeJ70.withModifiers)($setup.handleSubmit, [
                                "prevent"
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_10, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    id: "zipCode",
                                    name: "zip-code",
                                    type: "text",
                                    pattern: "^\\d{5}$",
                                    maxlength: "5",
                                    placeholder: "",
                                    required: "",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.zipCodeInput = $event),
                                    class: "bg-white peer w-52 md:w-64 h-12 px-3 pt-5 text-neutral-700 rounded-md border-0 outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-bitter-lemon focus-visible:ring-offset-blue-prussian"
                                }, null, 512 /* NEED_PATCH */ ), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        $setup.zipCodeInput
                                    ]
                                ]),
                                _cache[8] || (_cache[8] = (0, $TusQn.createElementVNode)("label", {
                                    for: "zipCode",
                                    class: "flex items-center absolute top-0 left-0 text-base h-12 mx-3 italic text-neutral-400 pointer-events-none origin-top-left transform -translate-y-1 scale-75 transition-transform peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-1 peer-focus:scale-75"
                                }, " Enter another ZIP code ", -1 /* HOISTED */ ))
                            ])
                        ], 32 /* NEED_HYDRATION */ )
                    ])
                ]),
                $setup.place.exists ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_11, [
                    (0, $TusQn.createVNode)($setup["SectionDivider"])
                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                $setup.place.exists ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_12, [
                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_13, [
                        (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_14, [
                            (0, $TusQn.createElementVNode)("h2", $347053712799b2f8$var$_hoisted_15, [
                                _cache[9] || (_cache[9] = (0, $TusQn.createTextVNode)(" Demographics ")),
                                (0, $TusQn.createElementVNode)("sup", $347053712799b2f8$var$_hoisted_16, (0, $8POXm.toDisplayString)($setup.demographicStatsReference), 1 /* TEXT */ )
                            ]),
                            (0, $TusQn.createVNode)($setup["DemographicDivider"], {
                                class: "stroke-4"
                            }),
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.demographicStats, (stat, index)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                    key: stat.id
                                }, [
                                    (0, $TusQn.createVNode)($setup["Demographic"], {
                                        stat: stat
                                    }, null, 8 /* PROPS */ , [
                                        "stat"
                                    ]),
                                    index < $setup.demographicStats.length - 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["DemographicDivider"], {
                                        key: 0,
                                        class: "stroke-3 opacity-50"
                                    })) : (0, $TusQn.createCommentVNode)("v-if", true)
                                ]);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ]),
                        (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_17, [
                            (0, $TusQn.createElementVNode)("h2", $347053712799b2f8$var$_hoisted_18, [
                                _cache[10] || (_cache[10] = (0, $TusQn.createTextVNode)(" Population Health Metrics ")),
                                (0, $TusQn.createElementVNode)("sup", $347053712799b2f8$var$_hoisted_19, (0, $8POXm.toDisplayString)($setup.populationHealthReference), 1 /* TEXT */ )
                            ]),
                            (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_20, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.metricStats, (metric)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["PopulationHealth"], {
                                        key: metric.id,
                                        metric: metric
                                    }, null, 8 /* PROPS */ , [
                                        "metric"
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ])
                        ])
                    ])
                ])) : (0, $TusQn.createCommentVNode)("v-if", true)
            ]),
            $setup.place.exists && $setup.healthCardBreakpoint ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("section", {
                key: 0,
                class: (0, $8POXm.normalizeClass)([
                    "bg-blue-primary px-6 sm:px-8 z-20",
                    {
                        'sticky top-0': $setup.isSticky
                    }
                ]),
                ref: "navigationSection"
            }, [
                (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_21, [
                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_22, [
                        (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_23, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.tabs, (tab)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                    key: tab.id,
                                    id: tab.id,
                                    ref_for: true,
                                    ref: "tabRefs",
                                    disabled: tab.active,
                                    onClick: ($event)=>$setup.handleTab(tab),
                                    class: (0, $8POXm.normalizeClass)([
                                        "text-sm px-2 py-2 lg:px-4 lg:text-base rounded-t-md border-b-5",
                                        [
                                            tab.visible ? 'text-neutral-300' : 'text-neutral-500',
                                            tab.active ? `bg-grey-background border-b-grey-background text-[#373737]! font-bold` : `hover:text-white cursor-pointer ${$setup.activeStyles.border} ${tab.styles.borderHover}`
                                        ]
                                    ])
                                }, [
                                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_25, [
                                        $setup.tabHasUnseenUpdatedCards(tab) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_26, "New")) : (0, $TusQn.createCommentVNode)("v-if", true),
                                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(tab.label), 1 /* TEXT */ )
                                    ])
                                ], 10 /* CLASS, PROPS */ , $347053712799b2f8$var$_hoisted_24);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ]),
                        (0, $TusQn.createVNode)($setup["Button"], {
                            size: "sm",
                            onClick: _cache[2] || (_cache[2] = ($event)=>$setup.navigateToForm()),
                            class: "hidden md:inline-block mb-4 text-blue-primary bg-green-bitter-lemon hover:bg-green-rio whitespace-nowrap"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>_cache[11] || (_cache[11] = [
                                    (0, $TusQn.createTextVNode)(" download full report ")
                                ])),
                            _: 1 /* STABLE */ ,
                            __: [
                                11
                            ]
                        })
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    class: (0, $8POXm.normalizeClass)([
                        "sm:-mx-8 -mx-6 border-b-5",
                        `${$setup.activeStyles.border}`
                    ])
                }, null, 2 /* CLASS */ )
            ], 2 /* CLASS */ )) : (0, $TusQn.createCommentVNode)("v-if", true),
            $setup.place.exists ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("section", $347053712799b2f8$var$_hoisted_27, [
                (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_28, [
                    _cache[18] || (_cache[18] = (0, $TusQn.createElementVNode)("div", {
                        class: "my-6 md:my-8 xl:my-10"
                    }, [
                        (0, $TusQn.createCommentVNode)(" For future alert bar. ")
                    ], -1 /* HOISTED */ )),
                    $setup.healthCardBreakpoint ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_29, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.activeTabCards, (card)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["HealthDataCards"], {
                                onClick: ($event)=>$setup.setShowMoreInfo(card, $setup.activeTabCards),
                                key: card.id,
                                card: card,
                                bgColor: `${$setup.activeStyles.bgColor}`
                            }, null, 8 /* PROPS */ , [
                                "onClick",
                                "card",
                                "bgColor"
                            ]);
                        }), 128 /* KEYED_FRAGMENT */ ))
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_30, [
                        (0, $TusQn.createElementVNode)("div", null, [
                            _cache[12] || (_cache[12] = (0, $TusQn.createElementVNode)("h2", {
                                class: "text-neutral-900 font-bold text-2xl mb-4 capitalize"
                            }, "respiratory", -1 /* HOISTED */ )),
                            (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_31, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.healthDataFacts.filter((fact)=>fact.tab === 'respiratory'), (card)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["HealthDataCards"], {
                                        onClick: ($event)=>$setup.setShowMoreInfo(card, $setup.healthDataFacts),
                                        key: card.id,
                                        card: card,
                                        bgColor: `${$setup.tabs.filter((tab)=>tab.id === 'respiratory').map((tab)=>tab.styles.bgColor)}`
                                    }, null, 8 /* PROPS */ , [
                                        "onClick",
                                        "card",
                                        "bgColor"
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", null, [
                            _cache[13] || (_cache[13] = (0, $TusQn.createElementVNode)("h2", {
                                class: "text-neutral-900 font-bold text-2xl mb-4 capitalize"
                            }, "gastrointestinal", -1 /* HOISTED */ )),
                            (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_32, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.healthDataFacts.filter((fact)=>fact.tab === 'gastrointestinal'), (card)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["HealthDataCards"], {
                                        onClick: ($event)=>$setup.setShowMoreInfo(card, $setup.healthDataFacts),
                                        key: card.id,
                                        card: card,
                                        bgColor: `${$setup.tabs.filter((tab)=>tab.id === 'gastrointestinal').map((tab)=>tab.styles.bgColor)}`
                                    }, null, 8 /* PROPS */ , [
                                        "onClick",
                                        "card",
                                        "bgColor"
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", null, [
                            _cache[14] || (_cache[14] = (0, $TusQn.createElementVNode)("h2", {
                                class: "text-neutral-900 font-bold text-2xl mb-4 capitalize"
                            }, "meningitis", -1 /* HOISTED */ )),
                            (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_33, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.healthDataFacts.filter((fact)=>fact.tab === 'meningitis'), (card)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["HealthDataCards"], {
                                        onClick: ($event)=>$setup.setShowMoreInfo(card, $setup.healthDataFacts),
                                        key: card.id,
                                        card: card,
                                        bgColor: `${$setup.tabs.filter((tab)=>tab.id === 'meningitis').map((tab)=>tab.styles.bgColor)}`
                                    }, null, 8 /* PROPS */ , [
                                        "onClick",
                                        "card",
                                        "bgColor"
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", null, [
                            _cache[15] || (_cache[15] = (0, $TusQn.createElementVNode)("h2", {
                                class: "text-neutral-900 font-bold text-2xl mb-4 capitalize"
                            }, "tropical fever", -1 /* HOISTED */ )),
                            (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_34, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.healthDataFacts.filter((fact)=>fact.tab === 'tropical-fever'), (card)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["HealthDataCards"], {
                                        onClick: ($event)=>$setup.setShowMoreInfo(card, $setup.healthDataFacts),
                                        key: card.id,
                                        card: card,
                                        bgColor: `${$setup.tabs.filter((tab)=>tab.id === 'tropical-fever').map((tab)=>tab.styles.bgColor)}`
                                    }, null, 8 /* PROPS */ , [
                                        "onClick",
                                        "card",
                                        "bgColor"
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", null, [
                            _cache[16] || (_cache[16] = (0, $TusQn.createElementVNode)("h2", {
                                class: "text-neutral-900 font-bold text-2xl mb-4 capitalize"
                            }, "bloodstream infections", -1 /* HOISTED */ )),
                            (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_35, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.healthDataFacts.filter((fact)=>fact.tab === 'bloodstream-infections'), (card)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["HealthDataCards"], {
                                        onClick: ($event)=>$setup.setShowMoreInfo(card, $setup.healthDataFacts),
                                        key: card.id,
                                        card: card,
                                        bgColor: `${$setup.tabs.filter((tab)=>tab.id === 'bloodstream-infections').map((tab)=>tab.styles.bgColor)}`
                                    }, null, 8 /* PROPS */ , [
                                        "onClick",
                                        "card",
                                        "bgColor"
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ])
                        ])
                    ])),
                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_36, [
                        _cache[17] || (_cache[17] = (0, $TusQn.createElementVNode)("h2", {
                            class: "font-bold text-xl text-blue-primary mt-18 mb-6"
                        }, "Community Impact of Syndromic Testing", -1 /* HOISTED */ )),
                        (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_37, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.communityImpactFacts, (fact)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["CommunityImpactCards"], {
                                    key: fact.id,
                                    heading: fact.heading,
                                    text: fact.text,
                                    reference: fact.reference
                                }, null, 8 /* PROPS */ , [
                                    "heading",
                                    "text",
                                    "reference"
                                ]);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ])
                    ], 512 /* NEED_PATCH */ )
                ])
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            $setup.place.exists ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("section", $347053712799b2f8$var$_hoisted_38, [
                (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_39, [
                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_40, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: $setup.mockupUrl,
                            alt: "bioM\xe9rieux Population Health Data Mockup",
                            class: "w-64"
                        }, null, 8 /* PROPS */ , $347053712799b2f8$var$_hoisted_41)
                    ]),
                    _cache[20] || (_cache[20] = (0, $TusQn.createElementVNode)("div", {
                        class: "text-center lg:text-left"
                    }, [
                        (0, $TusQn.createElementVNode)("h2", {
                            class: "font-bold text-2xl lg:text-3xl"
                        }, "Download my full custom report.")
                    ], -1 /* HOISTED */ )),
                    (0, $TusQn.createVNode)($setup["Button"], {
                        onClick: _cache[3] || (_cache[3] = ($event)=>$setup.navigateToForm()),
                        class: "text-blue-primary bg-green-bitter-lemon hover:bg-green-rio px-10"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>_cache[19] || (_cache[19] = [
                                (0, $TusQn.createTextVNode)(" download "),
                                (0, $TusQn.createElementVNode)("span", {
                                    class: "inline-block lg:hidden xl:inline-block"
                                }, "full report", -1 /* HOISTED */ )
                            ])),
                        _: 1 /* STABLE */ ,
                        __: [
                            19
                        ]
                    })
                ])
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            (0, $TusQn.createElementVNode)("section", $347053712799b2f8$var$_hoisted_42, [
                (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_43, [
                    (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_44, [
                        _cache[21] || (_cache[21] = (0, $TusQn.createElementVNode)("div", {
                            class: "flex flex-col gap-2"
                        }, [
                            (0, $TusQn.createElementVNode)("p", {
                                class: "font-bold text-blue-primary text-2xl"
                            }, "The fight against antimicrobial resistance starts here."),
                            (0, $TusQn.createElementVNode)("p", {
                                class: "text-neutral-700 text-lg"
                            }, " Our diagnostic solutions serve as frontline defenders against the growing threat of drug resistance by swiftly and accurately identifying potential pathogens to help inform effective treatment options. ")
                        ], -1 /* HOISTED */ )),
                        (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_45, [
                            (0, $TusQn.createElementVNode)("img", {
                                src: $setup.amsUrl,
                                alt: "AMS Logo",
                                class: "w-90"
                            }, null, 8 /* PROPS */ , $347053712799b2f8$var$_hoisted_46)
                        ])
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("section", $347053712799b2f8$var$_hoisted_47, [
                (0, $TusQn.createElementVNode)("div", $347053712799b2f8$var$_hoisted_48, [
                    $setup.place.exists ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["References"], {
                        key: 0,
                        references: $setup.references
                    }, null, 8 /* PROPS */ , [
                        "references"
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["References"], {
                        key: 1,
                        references: []
                    }))
                ])
            ])
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $347053712799b2f8$var$_hoisted_49)),
        (0, $TusQn.createVNode)($setup["Footer"], null, {
            logo: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("img", {
                        class: "w-[66px] h-[66px] -mb-[22px] mx-auto sm:w-[124px] sm:h-[124px] sm:-mb-[40px] transition-[width,height] duration-300",
                        src: $setup.logoUrl,
                        alt: "bioM\xe9rieux logo"
                    }, null, 8 /* PROPS */ , $347053712799b2f8$var$_hoisted_50)
                ]),
            note: (0, $TusQn.withCtx)(()=>_cache[22] || (_cache[22] = [
                    (0, $TusQn.createElementVNode)("p", {
                        class: "mb-5 font-bold"
                    }, "Product availability varies by country. Consult your bioM\xe9rieux representative.", -1 /* HOISTED */ )
                ])),
            _: 1 /* STABLE */ 
        })
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("1hsKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eedae0a475f38b6$export$2e2bcd8739ae039);
let $0eedae0a475f38b6$var$NOOP = ()=>{};
var $0eedae0a475f38b6$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gmjQI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $be8e1915f17f158a$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $hmpaa = parcelRequire("hmpaa");

var $73mM4 = parcelRequire("73mM4");

var $jD3LJ = parcelRequire("jD3LJ");

var $2HsZk = parcelRequire("2HsZk");

var $8BKbF = parcelRequire("8BKbF");

var $aJyQ6 = parcelRequire("aJyQ6");
var $be8e1915f17f158a$export$2e2bcd8739ae039 = {
    __name: 'entry',
    setup (__props, { expose: __expose }) {
        __expose();
        const header = (0, $01W3b.ref)(null);
        const { height: headerHeight } = (0, $hmpaa.useElementSize)(header);
        const zipCodeInput = (0, $01W3b.ref)(null);
        const router = (0, $73mM4.useRouter)();
        const handleSubmit = ()=>router.push({
                name: 'report',
                query: {
                    'zip-code': zipCodeInput.value
                }
            });
        const __returned__ = {
            header: header,
            headerHeight: headerHeight,
            zipCodeInput: zipCodeInput,
            router: router,
            handleSubmit: handleSubmit,
            ref: $01W3b.ref,
            get useElementSize () {
                return 0, $hmpaa.useElementSize;
            },
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            Clouds: $jD3LJ.default,
            Header: $2HsZk.default,
            Footer: $8BKbF.default,
            get skylineUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($aJyQ6));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("jD3LJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a49543b9728683$export$2e2bcd8739ae039);
let $e4a49543b9728683$var$script;



let $e4a49543b9728683$var$initialize = ()=>{
    $e4a49543b9728683$var$script = (parcelRequire("4J8d5"));
    if ($e4a49543b9728683$var$script.__esModule) $e4a49543b9728683$var$script = $e4a49543b9728683$var$script.default;
    $e4a49543b9728683$var$script.render = (parcelRequire("foZm2")).render;
    (parcelRequire("eucBl")).default($e4a49543b9728683$var$script);
    $e4a49543b9728683$var$script.__scopeId = 'data-v-48c2bc';
    $e4a49543b9728683$var$script.__file = "clouds.vue";
};
$e4a49543b9728683$var$initialize();
var $e4a49543b9728683$export$2e2bcd8739ae039 = $e4a49543b9728683$var$script;

});
parcelRegister("4J8d5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3711bbbff822f5eb$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $hmpaa = parcelRequire("hmpaa");

var $5VUhp = parcelRequire("5VUhp");
var $3711bbbff822f5eb$export$2e2bcd8739ae039 = {
    __name: 'clouds',
    setup (__props, { expose: __expose }) {
        __expose();
        const { width: windowWidth } = (0, $hmpaa.useWindowSize)();
        const clouds = (0, $01W3b.ref)([]);
        const shuffleArray = (array)=>{
            const shuffledArray = [
                ...array
            ];
            for(let i = shuffledArray.length - 1; i > 0; i--){
                const j = Math.floor(Math.random() * (i + 1));
                [shuffledArray[i], shuffledArray[j]] = [
                    shuffledArray[j],
                    shuffledArray[i]
                ];
            }
            return shuffledArray;
        };
        const generateClouds = (screenWidth)=>{
            const numberOfClouds = 2;
            const newClouds = [];
            for(let i = 0; i < numberOfClouds; i++){
                const randomTop = Math.floor(Math.random() * 11) + (25 * i + 10);
                const randomDuration = Math.floor(Math.random() * 30) + 60;
                const randomSize = Math.floor(Math.random() * 10) + 10;
                const randomNumber = Math.round(Math.random());
                newClouds.push({
                    topPosition: `${randomTop}%`,
                    duration: `${screenWidth > 640 ? randomDuration : randomDuration - 30}s`,
                    size: `${screenWidth < 640 ? randomSize * 2.5 : screenWidth < 1024 ? randomSize * 1.5 : randomSize}%`,
                    randomNumber: randomNumber
                });
            }
            clouds.value = shuffleArray(newClouds);
        };
        (0, $TusQn.onMounted)(()=>generateClouds(windowWidth.value));
        (0, $01W3b.watch)(windowWidth, (newWindowWidth)=>generateClouds(newWindowWidth));
        const __returned__ = {
            windowWidth: windowWidth,
            clouds: clouds,
            shuffleArray: shuffleArray,
            generateClouds: generateClouds,
            ref: $01W3b.ref,
            onMounted: $TusQn.onMounted,
            watch: $01W3b.watch,
            get useWindowSize () {
                return 0, $hmpaa.useWindowSize;
            },
            get cloudUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($5VUhp));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("5VUhp", function(module, exports) {
module.exports = import.meta.resolve("2tvSq");

});


parcelRegister("foZm2", function(module, exports) {

$parcel$export(module.exports, "render", () => $b368b09dbe04d89f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $b368b09dbe04d89f$var$_hoisted_1 = [
    "src"
];
const $b368b09dbe04d89f$var$_hoisted_2 = [
    "src"
];
const $b368b09dbe04d89f$var$_hoisted_3 = [
    "src"
];
const $b368b09dbe04d89f$var$_hoisted_4 = [
    "src"
];
const $b368b09dbe04d89f$var$_hoisted_5 = [
    "src"
];
function $b368b09dbe04d89f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createCommentVNode)(" top-left "),
        (0, $TusQn.createElementVNode)("img", {
            src: $setup.cloudUrl,
            class: "absolute opacity-15 w-[50%] sm:w-[40%] lg:w-[30%] xl:w-[25%] top-[8%] left-[8%]"
        }, null, 8 /* PROPS */ , $b368b09dbe04d89f$var$_hoisted_1),
        (0, $TusQn.createCommentVNode)(" bottom-left "),
        (0, $TusQn.createElementVNode)("img", {
            src: $setup.cloudUrl,
            class: "absolute opacity-15 w-[35%] sm:w-[30%] lg:w-[20%] xl:w-[15%] top-[30%] sm:top-[40%] left-[13%]"
        }, null, 8 /* PROPS */ , $b368b09dbe04d89f$var$_hoisted_2),
        (0, $TusQn.createCommentVNode)(" top-right "),
        (0, $TusQn.createElementVNode)("img", {
            src: $setup.cloudUrl,
            class: "absolute opacity-15 w-[35%] sm:w-[30%] lg:w-[20%] xl:w-[15%] top-[3%] sm:top-[12%] right-[12%]"
        }, null, 8 /* PROPS */ , $b368b09dbe04d89f$var$_hoisted_3),
        (0, $TusQn.createCommentVNode)(" bottom-right "),
        (0, $TusQn.createElementVNode)("img", {
            src: $setup.cloudUrl,
            class: "absolute opacity-15 w-[30%] sm:w-[25%] lg:w-[15%] xl:w-[12%] top-[25%] sm:top-[38%] right-[5%]"
        }, null, 8 /* PROPS */ , $b368b09dbe04d89f$var$_hoisted_4),
        (0, $TusQn.createCommentVNode)(" middle "),
        (0, $TusQn.createElementVNode)("img", {
            src: $setup.cloudUrl,
            class: "hidden lg:block absolute opacity-15 w-[20%] xl:w-[15%] top-[28%] left-[55%]"
        }, null, 8 /* PROPS */ , $b368b09dbe04d89f$var$_hoisted_5),
        (0, $TusQn.createCommentVNode)(" <img\n    \n      v-for=\"( cloud, index ) in clouds\"\n\n      :key=\"index\"\n\n      src=\"../../images/cloud.svg\"\n\n      alt=\"cloud\"\n\n      class=\"absolute opacity-10\"\n\n      :class=\"[ cloud.randomNumber ? 'animate-moveCloudRightLeft': 'animate-moveCloudLeftRight' ]\"\n\n      style=\"transform: translateX(-100%)\"\n\n      :style=\"{\n\n        top: cloud.topPosition,\n\n        animationDuration: cloud.duration,\n\n        width: cloud.size,\n\n        // animationDelay: `${ index * 2 }s`\n\n      }\"\n\n    /> ")
    ]);
}

});

parcelRegister("eucBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8bda45faaab0017$export$2e2bcd8739ae039);
let $a8bda45faaab0017$var$NOOP = ()=>{};
var $a8bda45faaab0017$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("aJyQ6", function(module, exports) {
module.exports = import.meta.resolve("gnwS1");

});


parcelRegister("dW5xm", function(module, exports) {

$parcel$export(module.exports, "render", () => $a254fcb5090e95c1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a254fcb5090e95c1$var$_hoisted_1 = {
    class: "absolute inset-x-0 bottom-0 flex justify-center overflow-hidden"
};
const $a254fcb5090e95c1$var$_hoisted_2 = [
    "src"
];
const $a254fcb5090e95c1$var$_hoisted_3 = {
    class: "max-w-screen-xl mx-auto z-50"
};
const $a254fcb5090e95c1$var$_hoisted_4 = {
    class: "text-white flex flex-col items-center text-center gap-6 lg:gap-10 py-24 lg:py-36 px-6 sm:px-8"
};
const $a254fcb5090e95c1$var$_hoisted_5 = {
    class: "flex"
};
const $a254fcb5090e95c1$var$_hoisted_6 = {
    class: "relative"
};
function $a254fcb5090e95c1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"], {
            ref: "header"
        }, null, 512 /* NEED_PATCH */ ),
        (0, $TusQn.createElementVNode)("main", {
            class: "relative overflow-hidden min-h-screen bg-linear-to-r from-[#45C5E3] to-[#BFD630]",
            style: (0, $8POXm.normalizeStyle)({
                minHeight: `calc(100vh - ${$setup.headerHeight}px)`
            })
        }, [
            (0, $TusQn.createElementVNode)("div", $a254fcb5090e95c1$var$_hoisted_1, [
                (0, $TusQn.createElementVNode)("img", {
                    src: $setup.skylineUrl,
                    class: "w-full min-w-6xl mix-blend-multiply object-cover"
                }, null, 8 /* PROPS */ , $a254fcb5090e95c1$var$_hoisted_2)
            ]),
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createVNode)($setup["Clouds"])
            ]),
            (0, $TusQn.createElementVNode)("div", $a254fcb5090e95c1$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $a254fcb5090e95c1$var$_hoisted_4, [
                    _cache[3] || (_cache[3] = (0, $TusQn.createElementVNode)("h1", {
                        class: "text-4xl md:text-5xl lg:text-6xl font-bold z-50"
                    }, " See Local Health Trends in Seconds ", -1 /* HOISTED */ )),
                    _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("p", {
                        class: "text-xl lg:text-2xl z-50"
                    }, " Enter your ZIP code below to get your custom health report. ", -1 /* HOISTED */ )),
                    (0, $TusQn.createElementVNode)("form", {
                        onSubmit: (0, $eeJ70.withModifiers)($setup.handleSubmit, [
                            "prevent"
                        ])
                    }, [
                        (0, $TusQn.createElementVNode)("div", $a254fcb5090e95c1$var$_hoisted_5, [
                            (0, $TusQn.createElementVNode)("div", $a254fcb5090e95c1$var$_hoisted_6, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.zipCodeInput = $event),
                                    name: "zipCode",
                                    type: "text",
                                    pattern: "^\\d{5}$",
                                    maxlength: "5",
                                    placeholder: "",
                                    required: "",
                                    class: "bg-white pl-5 w-full peer h-12 pt-4 text-sm sm:mr-16 text-neutral-700 border border-gray-300 rounded-l-full focus:outline-none focus:ring-2 focus:border-blue-500 focus:ring-blue-500 z-50"
                                }, null, 512 /* NEED_PATCH */ ), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        $setup.zipCodeInput
                                    ]
                                ]),
                                _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("label", {
                                    for: "zipCode",
                                    class: "pl-3 text-sm sm:text-base flex items-center absolute top-0 left-0 h-12 mx-3 text-neutral-400 pointer-events-none origin-top-left transform -translate-y-1 scale-75 transition-transform peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-1 peer-focus:scale-75 whitespace-nowrap"
                                }, " Enter your ZIP code ", -1 /* HOISTED */ ))
                            ]),
                            _cache[2] || (_cache[2] = (0, $TusQn.createElementVNode)("button", {
                                type: "submit",
                                class: "bg-[#0A7FEB] text-sm sm:text-lg font-bold px-2 sm:px-6 h-12 rounded-r-full flex items-center justify-center z-50 hover:cursor-pointer"
                            }, " View Report ", -1 /* HOISTED */ ))
                        ])
                    ], 32 /* NEED_HYDRATION */ )
                ])
            ])
        ], 4 /* STYLE */ ),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("6K7T2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8d2813d8ea2e2e$export$2e2bcd8739ae039);
let $4e8d2813d8ea2e2e$var$NOOP = ()=>{};
var $4e8d2813d8ea2e2e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("grgHc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bf7c1e6699790974$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $apRgG = parcelRequire("apRgG");

var $ijUEj = parcelRequire("ijUEj");

var $2HsZk = parcelRequire("2HsZk");

var $8BKbF = parcelRequire("8BKbF");

var $hX5RY = parcelRequire("hX5RY");
var $bf7c1e6699790974$export$2e2bcd8739ae039 = {
    __name: 'form',
    setup (__props, { expose: __expose }) {
        __expose();
        const router = (0, $73mM4.useRouter)();
        const currentUrl = (0, $apRgG.useRouteQuery)('zip-code');
        const form = (0, $01W3b.ref)(null);
        (0, $TusQn.watchEffect)(()=>{
            (0, $ijUEj.default).value = currentUrl.value;
            form.value?.setValues({
                PM_Custom1: (0, $ijUEj.default).value
            });
        });
        (0, $01W3b.watch)(form, (form)=>{
            if (!form) return;
            const formElm = form.getFormElem()[0];
            // Remove the form placeholder on ready.
            const wrapper = formElm.closest('[ data-form-wrapper ]');
            if (wrapper) wrapper.querySelector('[ data-form-placeholder ]')?.remove();
            // Position form rows containing a disclaimer to the bottom, above the submit button row.
            const buttonRow = formElm.querySelector('.mktoButtonRow:has( button[ type = "submit" ] )');
            const disclaimerRows = formElm.querySelectorAll('.mktoFormRow:has( [ data-disclaimer ] )');
            Array.from(disclaimerRows).forEach((row)=>formElm.insertBefore(row, buttonRow));
            // Set the "referrer" form field.
            form.setValues({
                referrer: document.referrer
            });
            // Change submit button label.
            const submitButton = formElm.querySelector('.mktoButton');
            submitButton.innerText = 'Download Report';
            // Navigate to download on success.
            form.onSuccess(()=>{
                router.push({
                    path: '/download',
                    query: {
                        'zip-code': (0, $ijUEj.default).value
                    }
                });
                return false;
            });
        });
        (0, $TusQn.onMounted)(()=>{
            if (typeof MktoForms2 == 'object') {
                MktoForms2.loadForm('https://info.biomerieux.com', '315-VKA-657', 3753);
                MktoForms2.whenReady((reference)=>form.value = reference);
            }
        });
        const __returned__ = {
            router: router,
            currentUrl: currentUrl,
            form: form,
            ref: $01W3b.ref,
            onMounted: $TusQn.onMounted,
            watch: $01W3b.watch,
            watchEffect: $TusQn.watchEffect,
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            get useRouteQuery () {
                return 0, $apRgG.useRouteQuery;
            },
            get zipCode () {
                return 0, $ijUEj.default;
            },
            Header: $2HsZk.default,
            Footer: $8BKbF.default,
            get mockupUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($hX5RY));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("kB4kJ", function(module, exports) {

$parcel$export(module.exports, "render", () => $efea9fdc8a329e43$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $efea9fdc8a329e43$var$_hoisted_1 = {
    class: "mb-0.25"
};
const $efea9fdc8a329e43$var$_hoisted_2 = {
    class: "pt-20 bg-blue-primary bg-no-repeat bg-[length:700px_auto] bg-[top_left_-345px] bg-[url(./images/circle-pattern-white.svg)] md:bg-[length:1000px_auto] md:bg-[left_-500px_center] sm:px-8 sm:pt-28 sm:pb-8 md:py-28 lg:px-24"
};
const $efea9fdc8a329e43$var$_hoisted_3 = {
    class: "max-w-6xl mx-auto"
};
const $efea9fdc8a329e43$var$_hoisted_4 = {
    class: "flex flex-col gap-14 md:flex-row"
};
const $efea9fdc8a329e43$var$_hoisted_5 = {
    class: "px-6 text-white sm:px-0 md:w-1/2 lg:w-3/5"
};
const $efea9fdc8a329e43$var$_hoisted_6 = {
    class: "max-w-xl"
};
const $efea9fdc8a329e43$var$_hoisted_7 = {
    class: "flex justify-center"
};
const $efea9fdc8a329e43$var$_hoisted_8 = [
    "src"
];
function $efea9fdc8a329e43$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", $efea9fdc8a329e43$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $efea9fdc8a329e43$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $efea9fdc8a329e43$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $efea9fdc8a329e43$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("div", $efea9fdc8a329e43$var$_hoisted_5, [
                            (0, $TusQn.createElementVNode)("div", $efea9fdc8a329e43$var$_hoisted_6, [
                                _cache[0] || (_cache[0] = (0, $TusQn.createElementVNode)("span", {
                                    class: "inline-block mb-8 px-4 py-[2px] font-bold text-green-bitter-lemon border-2 border-green-bitter-lemon"
                                }, " Custom Report ", -1 /* HOISTED */ )),
                                _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("h1", {
                                    class: "mb-5 text-2xl font-bold sm:mb-8 sm:text-[2.5rem] sm:leading-[1.25]"
                                }, " Community insights, ready when you are. ", -1 /* HOISTED */ )),
                                _cache[2] || (_cache[2] = (0, $TusQn.createElementVNode)("p", {
                                    class: "mb-8 text-base sm:text-xl"
                                }, " Download your custom report to keep critical health trends at your fingertips. ", -1 /* HOISTED */ )),
                                (0, $TusQn.createElementVNode)("div", $efea9fdc8a329e43$var$_hoisted_7, [
                                    (0, $TusQn.createElementVNode)("img", {
                                        src: $setup.mockupUrl,
                                        alt: "bioM\xe9rieux Population Health Data Mockup",
                                        class: "w-sm"
                                    }, null, 8 /* PROPS */ , $efea9fdc8a329e43$var$_hoisted_8)
                                ])
                            ])
                        ]),
                        _cache[3] || (_cache[3] = (0, $TusQn.createStaticVNode)("<div id=\"form-container\" class=\"md:w-1/2 lg:w-2/5\"><div class=\"sm:rounded-xl overflow-hidden shadow-lg\"><div class=\"py-8 bg-blue-prussian text-center sm:px-10 md:text-left\"><h2 class=\"text-xl font-bold text-white sm:text-2xl xl:text-3xl\"> Download the Report </h2><p class=\"text-lg font-normal text-green-rio sm:text-xl xl:text-2xl\"> It&#39;s completely free. </p></div><div class=\"px-8 py-8 bg-white sm:px-10 sm:py-10 lg:px-10\"><div data-form-wrapper class=\"grid\"><div data-form-placeholder class=\"row-start-1 col-start-1 flex items-center justify-center\"><svg viewBox=\"0 0 24 24\" class=\"w-16 animate-spin\" fill=\"none\" aria-hidden=\"true\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg></div><div class=\"relative row-start-1 col-start-1\"><form id=\"mktoForm_3753\"></form></div></div></div></div></div>", 1))
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("8etOz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe6c21584c47a7f$export$2e2bcd8739ae039);
let $5fe6c21584c47a7f$var$NOOP = ()=>{};
var $5fe6c21584c47a7f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lfBBY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f7882c8d82e82c00$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $apRgG = parcelRequire("apRgG");

var $ijUEj = parcelRequire("ijUEj");

var $2HsZk = parcelRequire("2HsZk");

var $8BKbF = parcelRequire("8BKbF");

var $jp4JI = parcelRequire("jp4JI");

var $asNuu = parcelRequire("asNuu");

var $l5psp = parcelRequire("l5psp");

var $hX5RY = parcelRequire("hX5RY");
var $f7882c8d82e82c00$export$2e2bcd8739ae039 = {
    __name: 'download',
    setup (__props, { expose: __expose }) {
        __expose();
        const router = (0, $73mM4.useRouter)();
        const currentUrl = (0, $apRgG.useRouteQuery)('zip-code');
        (0, $TusQn.watchEffect)(()=>{
            (0, $ijUEj.default).value = currentUrl.value;
        });
        const downloadDisabled = (0, $01W3b.ref)(false);
        const downloadCompleted = (0, $01W3b.ref)(false);
        async function onClickDownload() {
            downloadDisabled.value = true;
            await (0, $l5psp.exportPDF)();
            downloadCompleted.value = true;
        }
        const __returned__ = {
            router: router,
            currentUrl: currentUrl,
            downloadDisabled: downloadDisabled,
            downloadCompleted: downloadCompleted,
            onClickDownload: onClickDownload,
            ref: $01W3b.ref,
            watchEffect: $TusQn.watchEffect,
            get useRouter () {
                return 0, $73mM4.useRouter;
            },
            get useRouteQuery () {
                return 0, $apRgG.useRouteQuery;
            },
            get zipCode () {
                return 0, $ijUEj.default;
            },
            Header: $2HsZk.default,
            Footer: $8BKbF.default,
            Button: $jp4JI.default,
            DownloadBlock: $asNuu.default,
            get exportPDF () {
                return 0, $l5psp.exportPDF;
            },
            get mockupUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($hX5RY));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("asNuu", function(module, exports) {

$parcel$export(module.exports, "default", () => $79e2e8ba1429c59c$export$2e2bcd8739ae039);
let $79e2e8ba1429c59c$var$script;



let $79e2e8ba1429c59c$var$initialize = ()=>{
    $79e2e8ba1429c59c$var$script = (parcelRequire("3u3L5"));
    if ($79e2e8ba1429c59c$var$script.__esModule) $79e2e8ba1429c59c$var$script = $79e2e8ba1429c59c$var$script.default;
    $79e2e8ba1429c59c$var$script.render = (parcelRequire("f4Wnl")).render;
    (parcelRequire("i3bJb")).default($79e2e8ba1429c59c$var$script);
    $79e2e8ba1429c59c$var$script.__scopeId = 'data-v-3f06f6';
    $79e2e8ba1429c59c$var$script.__file = "download-block.vue";
};
$79e2e8ba1429c59c$var$initialize();
var $79e2e8ba1429c59c$export$2e2bcd8739ae039 = $79e2e8ba1429c59c$var$script;

});
parcelRegister("3u3L5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $289716cb6d5217ec$export$2e2bcd8739ae039);

var $hmpaa = parcelRequire("hmpaa");

var $jp4JI = parcelRequire("jp4JI");
var $289716cb6d5217ec$export$2e2bcd8739ae039 = {
    __name: 'download-block',
    props: [
        'eyebrow',
        'heading',
        'paragraph',
        'buttonText',
        'buttonLink'
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const buttonBreakpoint = (0, $hmpaa.useMediaQuery)('(min-width: 640px)');
        const __returned__ = {
            buttonBreakpoint: buttonBreakpoint,
            get useMediaQuery () {
                return 0, $hmpaa.useMediaQuery;
            },
            Button: $jp4JI.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("f4Wnl", function(module, exports) {

$parcel$export(module.exports, "render", () => $afa482e679402146$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $afa482e679402146$var$_hoisted_1 = {
    class: "bg-blue-primary px-4 py-8 sm:p-8 flex flex-col justify-center items-center max-w-96"
};
const $afa482e679402146$var$_hoisted_2 = {
    class: "text-green-bitter-lemon text-sm sm:text-base font-bold uppercase mb-4"
};
const $afa482e679402146$var$_hoisted_3 = {
    class: "text-white font-bold text-center text-xl sm:text-2xl mb-3"
};
const $afa482e679402146$var$_hoisted_4 = {
    class: "text-white text-center sm:text-lg mb-8"
};
function $afa482e679402146$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $afa482e679402146$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("p", $afa482e679402146$var$_hoisted_2, (0, $8POXm.toDisplayString)($props.eyebrow), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("h2", $afa482e679402146$var$_hoisted_3, (0, $8POXm.toDisplayString)($props.heading), 1 /* TEXT */ ),
        (0, $TusQn.createElementVNode)("p", $afa482e679402146$var$_hoisted_4, (0, $8POXm.toDisplayString)($props.paragraph), 1 /* TEXT */ ),
        (0, $TusQn.createVNode)($setup["Button"], {
            size: $setup.buttonBreakpoint ? '' : 'sm',
            class: "text-blue-primary bg-green-bitter-lemon hover:bg-green-rio whitespace-nowrap capitalize"
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "button")
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "size"
        ])
    ]);
}

});

parcelRegister("i3bJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $036427a809961d0b$export$2e2bcd8739ae039);
let $036427a809961d0b$var$NOOP = ()=>{};
var $036427a809961d0b$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("l5psp", function(module, exports) {

$parcel$export(module.exports, "exportPDF", () => $f59dcfe1799ab959$export$60ffe60482f5955d);
parcelRequire("01v82");
var $cGbw3 = parcelRequire("cGbw3");

var $4UBW9 = parcelRequire("4UBW9");

var $4GpFN = parcelRequire("4GpFN");

var $lyNTZ = parcelRequire("lyNTZ");

var $4frTP = parcelRequire("4frTP");

var $dL6bL = parcelRequire("dL6bL");

var $d1QFr = parcelRequire("d1QFr");

var $kYWTk = parcelRequire("kYWTk");

var $05c6E = parcelRequire("05c6E");

var $5jVXc = parcelRequire("5jVXc");

var $ijUEj = parcelRequire("ijUEj");

var $1wdf7 = parcelRequire("1wdf7");
parcelRequire("k7fDd");

var $1qJO6 = parcelRequire("1qJO6");

var $2aUHH = parcelRequire("2aUHH");

var $jozPh = parcelRequire("jozPh");
function $f59dcfe1799ab959$var$drawCover(doc, page, regularFont) {
    (0, $4GpFN.drawText)({
        doc: doc,
        page: page,
        font: regularFont,
        size: 18,
        x: 88,
        y: 390,
        align: 'left',
        color: 0x26447c,
        text: `${(0, $4GpFN.capitalizeEveryWord)((0, $1wdf7.default).county)}, ${(0, $1wdf7.default).stateAbbr.toUpperCase()} (${(0, $ijUEj.default).value})`
    });
    (0, $4GpFN.drawText)({
        doc: doc,
        page: page,
        font: regularFont,
        size: 18,
        x: 138,
        y: 411.6,
        align: 'left',
        color: 0x26447c,
        text: (0, $4GpFN.getDate)()
    });
}
function $f59dcfe1799ab959$var$drawHeader(doc, page, regularFont) {
    (0, $4GpFN.drawText)({
        doc: doc,
        page: page,
        font: regularFont,
        size: 12.5,
        x: page.getWidth() / 2,
        y: 57,
        align: 'center',
        color: 0xffffff,
        text: `${(0, $4GpFN.capitalizeEveryWord)((0, $1wdf7.default).county)}, ${(0, $1wdf7.default).stateAbbr.toUpperCase()} (${(0, $ijUEj.default).value}) |  Generated: ${(0, $4GpFN.getDate)()}`
    });
}
function $f59dcfe1799ab959$var$drawDems(doc, page, boldFont) {
    const positions = [
        {
            x: 378,
            y: 167.6
        },
        {
            x: 383,
            y: 213.5
        },
        {
            x: 440,
            y: 259.15
        },
        {
            x: 465,
            y: 305.7
        },
        {
            x: 365,
            y: 352
        }
    ];
    (0, $1qJO6.default).value.forEach((stat, index)=>(0, $4GpFN.drawText)({
            ...positions[index],
            doc: doc,
            page: page,
            font: boldFont,
            size: 12.5,
            align: 'left',
            color: 0x26447c,
            text: stat.value
        }));
}
function $f59dcfe1799ab959$var$drawCardBox(options) {
    const { doc: doc, page: page, x: x, y: y, width: width, height: height, barHeight: barHeight, paddingTop: paddingTop, boxColor: boxColor, noData: noData, headingFont: headingFont, heading: heading, headingColor: headingColor, localFont: localFont, local: local, localColor: localColor, descriptionFont: descriptionFont, description: description, descriptionColor: descriptionColor, nationalFont: nationalFont, national: national, nationalColor: nationalColor } = {
        width: 168,
        height: 138,
        barHeight: 28,
        paddingTop: 0,
        ...options
    };
    (0, $4GpFN.drawRectangle)({
        page: page,
        x: x,
        y: y,
        width: width,
        height: height,
        color: boxColor
    });
    (0, $4GpFN.drawRectangle)({
        page: page,
        x: x + 1,
        y: y + barHeight,
        width: width - 2,
        height: height - barHeight - 1,
        color: 0xffffff
    });
    (0, $4GpFN.drawText)({
        doc: doc,
        page: page,
        x: x + width / 2,
        y: y + barHeight / 2 - 3,
        font: headingFont,
        size: 10,
        align: 'center',
        color: headingColor,
        text: heading
    });
    if (noData) {
        let { y: lastY, height: lastHeight } = (0, $4GpFN.drawText)({
            doc: doc,
            page: page,
            x: x + width / 2,
            y: y + height / 2 + paddingTop + 8,
            font: localFont,
            size: 34,
            align: 'center',
            color: localColor,
            text: 'N/A'
        });
        (0, $4GpFN.drawText)({
            doc: doc,
            page: page,
            x: x + width / 2,
            y: lastY + lastHeight,
            font: nationalFont,
            size: 9,
            align: 'center',
            color: nationalColor,
            text: 'Data Not Available'
        });
    } else {
        (0, $4GpFN.drawText)({
            doc: doc,
            page: page,
            x: x + width / 2,
            y: y + height / 2 + paddingTop - 11,
            font: localFont,
            size: 34,
            align: 'center',
            color: localColor,
            text: local
        });
        let { y: lastY, height: lastHeight } = (0, $4GpFN.drawText)({
            doc: doc,
            page: page,
            x: x + width / 2 + 5,
            y: y + height / 2 + paddingTop + 15,
            maxWidth: 100,
            align: 'top center',
            font: descriptionFont,
            size: 10,
            color: descriptionColor,
            text: description
        });
        (0, $4GpFN.drawText)({
            doc: doc,
            page: page,
            x: x + width / 2,
            y: lastY + lastHeight + 10,
            font: nationalFont,
            size: 9,
            align: 'center',
            color: nationalColor,
            text: national
        });
    }
}
function $f59dcfe1799ab959$var$drawPopMetrics(doc, page, boldFont, condensedBoldFont, condensedItalicFont, mediumFont) {
    const positions = [
        {
            x: 36,
            y: 441
        },
        {
            x: 222,
            y: 441
        },
        {
            x: 408,
            y: 441
        },
        {
            x: 36,
            y: 597
        },
        {
            x: 222,
            y: 597
        },
        {
            x: 408,
            y: 597
        }
    ];
    (0, $2aUHH.default).value.forEach((stat, index)=>$f59dcfe1799ab959$var$drawCardBox({
            doc: doc,
            page: page,
            ...positions[index],
            boxColor: stat.alert ? 0xe22828 : 0x00427f,
            noData: !stat.localValue || isNaN(stat.localValue),
            headingFont: boldFont,
            heading: (0, $4GpFN.capitalizeEveryWord)(stat.statistic),
            headingColor: 0xffffff,
            localFont: condensedBoldFont,
            local: stat.localValue ? `${stat.localValue}%` : 'N/A',
            localColor: stat.alert ? 0xe22828 : 0x373737,
            descriptionFont: mediumFont,
            description: 'of county residents',
            descriptionColor: 0x373737,
            nationalFont: condensedItalicFont,
            national: `${stat.alert ? 'Above ' : ''}${stat.nationalValue}% National Average`,
            nationalColor: 0xaaaaaa
        }));
}
function $f59dcfe1799ab959$var$drawRPMetrics(doc, page, boldFont, condensedBoldFont, condensedItalicFont, mediumFont) {
    const positions = [
        {
            x: 36,
            y: 147
        },
        {
            x: 222,
            y: 147
        },
        {
            x: 408,
            y: 147
        }
    ];
    (0, $jozPh.default).value.filter((stat)=>stat.tab === 'respiratory').forEach((stat, index)=>$f59dcfe1799ab959$var$drawCardBox({
            doc: doc,
            page: page,
            ...positions[index],
            height: 153,
            paddingTop: -5,
            boxColor: stat.alert ? 0xe22828 : 0x4dc3e0,
            noData: !stat.localValue || isNaN(stat.localValue),
            headingFont: boldFont,
            heading: `${stat.title.toUpperCase()}${(0, $4GpFN.superscript)(stat.reference)}`,
            headingColor: stat.alert ? 0xffffff : 0x373737,
            localFont: condensedBoldFont,
            local: `${stat.localValue}${stat.suffix ?? ''}`,
            localColor: stat.alert ? 0xe22828 : 0x373737,
            descriptionFont: mediumFont,
            description: stat.description,
            descriptionColor: 0x373737,
            nationalFont: condensedItalicFont,
            national: `${stat.alert ? 'Above ' : ''}${stat.nationalValue}${stat.suffix ?? ''} National Average`,
            nationalColor: 0xaaaaaa
        }));
}
function $f59dcfe1799ab959$var$drawGIMetrics(doc, page, boldItalicFont, boldFont, condensedBoldFont, condensedItalicFont, mediumFont) {
    const positions = [
        {
            x: 36,
            y: 376
        },
        {
            x: 222,
            y: 376
        },
        {
            x: 408,
            y: 376
        },
        {
            x: 36,
            y: 546
        },
        {
            x: 222,
            y: 546
        }
    ];
    (0, $jozPh.default).value.filter((stat)=>stat.tab === 'gastrointestinal').forEach((stat, index)=>$f59dcfe1799ab959$var$drawCardBox({
            doc: doc,
            page: page,
            ...positions[index],
            height: 153,
            paddingTop: -5,
            boxColor: stat.alert ? 0xe22828 : 0xc0d630,
            noData: !stat.localValue || isNaN(stat.localValue),
            headingFont: stat.title.match(/<i>/) ? boldItalicFont : boldFont,
            headingColor: stat.alert ? 0xffffff : 0x373737,
            heading: `${stat.title.replace(/<\/?i>/g, '').toUpperCase()}${(0, $4GpFN.superscript)(stat.reference)}`,
            localFont: condensedBoldFont,
            local: stat.localValue,
            localColor: stat.alert ? 0xe22828 : 0x373737,
            descriptionFont: mediumFont,
            description: stat.description,
            descriptionColor: 0x373737,
            nationalFont: condensedItalicFont,
            national: `${stat.alert ? 'Above ' : ''}${stat.nationalValue} National Average`,
            nationalColor: 0xaaaaaa
        }));
}
function $f59dcfe1799ab959$var$drawMEMetrics(doc, page, boldItalicFont, boldFont, condensedBoldFont, condensedItalicFont, mediumFont) {
    const positions = [
        {
            x: 36,
            y: 147
        },
        {
            x: 222,
            y: 147
        },
        {
            x: 408,
            y: 147
        }
    ];
    (0, $jozPh.default).value.filter((stat)=>stat.tab === 'meningitis').forEach((stat, index)=>$f59dcfe1799ab959$var$drawCardBox({
            doc: doc,
            page: page,
            ...positions[index],
            height: 153,
            paddingTop: -5,
            boxColor: stat.alert ? 0xe22828 : 0xf4b334,
            noData: !stat.localValue || isNaN(stat.localValue),
            headingFont: stat.title.match(/<i>/) ? boldItalicFont : boldFont,
            headingColor: stat.alert ? 0xffffff : 0x373737,
            heading: `${stat.title.replace(/<\/?i>/g, '').toUpperCase()}${(0, $4GpFN.superscript)(stat.reference)}`,
            localFont: condensedBoldFont,
            local: stat.localValue,
            localColor: stat.alert ? 0xe22828 : 0x373737,
            descriptionFont: mediumFont,
            description: stat.description,
            descriptionColor: 0x373737,
            nationalFont: condensedItalicFont,
            national: `${stat.alert ? 'Above ' : ''}${stat.nationalValue} National Average`,
            nationalColor: 0xaaaaaa
        }));
}
function $f59dcfe1799ab959$var$drawTFMetrics(doc, page, boldFont, condensedBoldFont, condensedItalicFont, mediumFont) {
    const positions = [
        {
            x: 36,
            y: 376
        },
        {
            x: 222,
            y: 376
        }
    ];
    (0, $jozPh.default).value.filter((stat)=>stat.tab === 'tropical-fever').forEach((stat, index)=>$f59dcfe1799ab959$var$drawCardBox({
            doc: doc,
            page: page,
            ...positions[index],
            height: 153,
            paddingTop: -5,
            boxColor: stat.alert ? 0xe22828 : 0xe65f1c,
            noData: !stat.localValue || isNaN(stat.localValue),
            headingFont: boldFont,
            headingColor: stat.alert ? 0xffffff : 0x373737,
            heading: `${stat.title.toUpperCase()}${(0, $4GpFN.superscript)(stat.reference)}`,
            localFont: condensedBoldFont,
            local: stat.localValue,
            localColor: stat.alert ? 0xe22828 : 0x373737,
            descriptionFont: mediumFont,
            description: stat.description,
            descriptionColor: 0x373737,
            nationalFont: condensedItalicFont,
            national: `${stat.alert ? 'Above ' : ''}${stat.nationalValue} National Average`,
            nationalColor: 0xaaaaaa
        }));
}
function $f59dcfe1799ab959$var$drawBSIMetrics(doc, page, boldItalicFont, boldFont, condensedBoldFont, condensedItalicFont, mediumFont) {
    const positions = [
        {
            x: 36,
            y: 605
        },
        {
            x: 222,
            y: 605
        },
        {
            x: 408,
            y: 605
        }
    ];
    (0, $jozPh.default).value.filter((stat)=>stat.tab === 'bloodstream-infections').forEach((stat, index)=>$f59dcfe1799ab959$var$drawCardBox({
            doc: doc,
            page: page,
            ...positions[index],
            height: 153,
            paddingTop: -5,
            boxColor: stat.alert ? 0xe22828 : 0x0,
            noData: !stat.localValue || isNaN(stat.localValue),
            headingFont: stat.title.match(/<i>/) ? boldItalicFont : boldFont,
            headingColor: 0xffffff,
            heading: `${stat.title.replace(/<\/?i>/g, '').toUpperCase()}${(0, $4GpFN.superscript)(stat.reference)}`,
            localFont: condensedBoldFont,
            local: stat.localValue,
            localColor: stat.alert ? 0xe22828 : 0x373737,
            descriptionFont: mediumFont,
            description: stat.description,
            descriptionColor: 0x373737,
            nationalFont: condensedItalicFont,
            national: `${stat.alert ? 'Above ' : ''}${stat.nationalValue} National Average`,
            nationalColor: 0xaaaaaa
        }));
}
async function $f59dcfe1799ab959$export$60ffe60482f5955d() {
    const boldItalicFontBytes = await (0, $4GpFN.fetchUint8Array)((0, (/*@__PURE__*/$parcel$interopDefault($lyNTZ))));
    const boldFontBytes = await (0, $4GpFN.fetchUint8Array)((0, (/*@__PURE__*/$parcel$interopDefault($4frTP))));
    const condensedBoldFontBytes = await (0, $4GpFN.fetchUint8Array)((0, (/*@__PURE__*/$parcel$interopDefault($dL6bL))));
    const condensedItalicFontBytes = await (0, $4GpFN.fetchUint8Array)((0, (/*@__PURE__*/$parcel$interopDefault($d1QFr))));
    const mediumFontBytes = await (0, $4GpFN.fetchUint8Array)((0, (/*@__PURE__*/$parcel$interopDefault($kYWTk))));
    const regularFontBytes = await (0, $4GpFN.fetchUint8Array)((0, (/*@__PURE__*/$parcel$interopDefault($05c6E))));
    const templateBytes = await (0, $4GpFN.fetchUint8Array)((0, (/*@__PURE__*/$parcel$interopDefault($5jVXc))));
    const doc = await (0, $cGbw3.default).load(templateBytes);
    doc.registerFontkit((0, $4UBW9.default));
    const boldItalicFont = await doc.embedFont(boldItalicFontBytes);
    const boldFont = await doc.embedFont(boldFontBytes);
    const condensedBoldFont = await doc.embedFont(condensedBoldFontBytes);
    const condensedItalicFont = await doc.embedFont(condensedItalicFontBytes);
    const mediumFont = await doc.embedFont(mediumFontBytes);
    const regularFont = await doc.embedFont(regularFontBytes);
    const pages = doc.getPages();
    $f59dcfe1799ab959$var$drawCover(doc, pages[0], regularFont);
    for(let i = 1; i < 4; i++)$f59dcfe1799ab959$var$drawHeader(doc, pages[i], regularFont);
    $f59dcfe1799ab959$var$drawDems(doc, pages[1], boldFont);
    $f59dcfe1799ab959$var$drawPopMetrics(doc, pages[1], boldFont, condensedBoldFont, condensedItalicFont, mediumFont);
    $f59dcfe1799ab959$var$drawRPMetrics(doc, pages[2], boldFont, condensedBoldFont, condensedItalicFont, mediumFont);
    $f59dcfe1799ab959$var$drawGIMetrics(doc, pages[2], boldItalicFont, boldFont, condensedBoldFont, condensedItalicFont, mediumFont);
    $f59dcfe1799ab959$var$drawMEMetrics(doc, pages[3], boldItalicFont, boldFont, condensedBoldFont, condensedItalicFont, mediumFont);
    $f59dcfe1799ab959$var$drawTFMetrics(doc, pages[3], boldFont, condensedBoldFont, condensedItalicFont, mediumFont);
    $f59dcfe1799ab959$var$drawBSIMetrics(doc, pages[3], boldItalicFont, boldFont, condensedBoldFont, condensedItalicFont, mediumFont);
    (0, $4GpFN.savePDF)(`Population Health Data for ${(0, $ijUEj.default).value}`, doc);
}

});
parcelRegister("01v82", function(module, exports) {
$parcel$export(module.exports, "PDFDocument", () => (parcelRequire("cGbw3")).default);
$parcel$export(module.exports, "rgb", () => (parcelRequire("gidDr")).rgb);
$parcel$export(module.exports, "PDFArray", () => (parcelRequire("8auL6")).default);
$parcel$export(module.exports, "PDFName", () => (parcelRequire("dPHSK")).default);
$parcel$export(module.exports, "PDFString", () => (parcelRequire("8dCYu")).default);
parcelRequire("43ivt");
parcelRequire("iT7lj");

var $4J7XC = parcelRequire("4J7XC");
parcelRequire("fvYKZ");
$parcel$exportWildcard(module.exports, $4J7XC);

});
parcelRegister("43ivt", function(module, exports) {
$parcel$export(module.exports, "rgb", () => (parcelRequire("gidDr")).rgb);

$parcel$export(module.exports, "PDFDocument", () => (parcelRequire("cGbw3")).default);
parcelRequire("1tnyK");
parcelRequire("5yZPW");
parcelRequire("gidDr");
parcelRequire("aYJvX");
parcelRequire("6vWdG");
parcelRequire("dW4Sr");
parcelRequire("7mLHs");
parcelRequire("hPFvC");
parcelRequire("55HYh");
parcelRequire("gjdfV");
parcelRequire("j1dka");
parcelRequire("dJaLP");
parcelRequire("i4gUC");

var $cGbw3 = parcelRequire("cGbw3");

var $lzaL9 = parcelRequire("lzaL9");

var $7F2yc = parcelRequire("7F2yc");

var $eq4Zh = parcelRequire("eq4Zh");

var $kUs6q = parcelRequire("kUs6q");

var $ceWew = parcelRequire("ceWew");

});
parcelRegister("1tnyK", function(module, exports) {
parcelRequire("ikSoM");

var $fphXB = parcelRequire("fphXB");

var $67hmm = parcelRequire("67hmm");

var $c2qg8 = parcelRequire("c2qg8");

var $dgAbg = parcelRequire("dgAbg");

var $2sybW = parcelRequire("2sybW");

var $5Apvp = parcelRequire("5Apvp");

var $1DKij = parcelRequire("1DKij");

var $hzhWN = parcelRequire("hzhWN");

var $lqhKQ = parcelRequire("lqhKQ");

});
parcelRegister("ikSoM", function(module, exports) {

$parcel$export(module.exports, "normalizeAppearance", () => $d5944ab433082972$export$8a3aea031520d39b);
$parcel$export(module.exports, "defaultCheckBoxAppearanceProvider", () => $d5944ab433082972$export$e11eab3ac6c06eb0);
$parcel$export(module.exports, "defaultRadioGroupAppearanceProvider", () => $d5944ab433082972$export$6440094330a99ef8);
$parcel$export(module.exports, "defaultButtonAppearanceProvider", () => $d5944ab433082972$export$68f9b19f48ffeeec);
$parcel$export(module.exports, "defaultTextFieldAppearanceProvider", () => $d5944ab433082972$export$42ba95e6b8df3d7);
$parcel$export(module.exports, "defaultDropdownAppearanceProvider", () => $d5944ab433082972$export$90f1ca03d512ec5);
$parcel$export(module.exports, "defaultOptionListAppearanceProvider", () => $d5944ab433082972$export$f9fab495286778d2);

var $cOQTW = parcelRequire("cOQTW");

var $7mLHs = parcelRequire("7mLHs");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");

var $d1UXb = parcelRequire("d1UXb");

var $5rdXu = parcelRequire("5rdXu");

var $hPFvC = parcelRequire("hPFvC");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $d5944ab433082972$export$8a3aea031520d39b = function(appearance) {
    if ('normal' in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $d5944ab433082972$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $d5944ab433082972$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (_b = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $d5944ab433082972$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $d5944ab433082972$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === 'g' && c1) return (0, $gidDr.grayscale)(Number(c1));
    if (colorSpace === 'rg' && c1 && c2 && c3) return (0, $gidDr.rgb)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === 'k' && c1 && c2 && c3 && c4) return (0, $gidDr.cmyk)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $d5944ab433082972$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $gidDr.setFillingColor)(color).toString(),
        (0, $hPFvC.setFontAndSize)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()
    ].join('\n');
    field.setDefaultAppearance(da);
};
var $d5944ab433082972$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (_b = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (_b = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(button.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $d1UXb.layoutSinglelineText)(normalText, {
        alignment: (0, $5rdXu.TextAlignment).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $d1UXb.layoutSinglelineText)(downText, {
        alignment: (0, $5rdXu.TextAlignment).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $d5944ab433082972$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $d1UXb.layoutMultilineText)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $d1UXb.layoutCombedText)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $d1UXb.layoutSinglelineText)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawTextField)(options));
};
var $d5944ab433082972$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $d1UXb.layoutSinglelineText)(text, {
        alignment: (0, $5rdXu.TextAlignment).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawTextField)(options));
};
var $d5944ab433082972$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = '';
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += '\n';
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $d1UXb.layoutMultilineText)(text, {
        alignment: (0, $5rdXu.TextAlignment).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $gidDr.rgb)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawOptionList)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};

});
parcelRegister("cOQTW", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $955330a26152f448$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $955330a26152f448$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $955330a26152f448$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $955330a26152f448$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $955330a26152f448$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArrays", () => $955330a26152f448$export$6388937ca91ccae8);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $955330a26152f448$var$extendStatics = function(d, b) {
    $955330a26152f448$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $955330a26152f448$var$extendStatics(d, b);
};
function $955330a26152f448$export$a8ba968b8961cb8a(d, b) {
    $955330a26152f448$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $955330a26152f448$export$18ce0697a983be9b = function() {
    $955330a26152f448$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $955330a26152f448$export$18ce0697a983be9b.apply(this, arguments);
};
function $955330a26152f448$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $955330a26152f448$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $955330a26152f448$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $955330a26152f448$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $955330a26152f448$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $955330a26152f448$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $955330a26152f448$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $955330a26152f448$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $955330a26152f448$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $955330a26152f448$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $955330a26152f448$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($955330a26152f448$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $955330a26152f448$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $955330a26152f448$export$10c90e4f7922046c(v) {
    return this instanceof $955330a26152f448$export$10c90e4f7922046c ? (this.v = v, this) : new $955330a26152f448$export$10c90e4f7922046c(v);
}
function $955330a26152f448$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $955330a26152f448$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $955330a26152f448$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $955330a26152f448$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $955330a26152f448$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $955330a26152f448$export$19a8beecd37a4c45 === "function" ? $955330a26152f448$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $955330a26152f448$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $955330a26152f448$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $955330a26152f448$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $955330a26152f448$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $955330a26152f448$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("7mLHs", function(module, exports) {

$parcel$export(module.exports, "drawLinesOfText", () => $55cf96b3448598de$export$f7b8b44d3d84bc26);
$parcel$export(module.exports, "drawImage", () => $55cf96b3448598de$export$21a059be5bfd5fb);
$parcel$export(module.exports, "drawPage", () => $55cf96b3448598de$export$f8ea28c31069cbc9);
$parcel$export(module.exports, "drawLine", () => $55cf96b3448598de$export$819db45aec5fcbe5);
$parcel$export(module.exports, "drawRectangle", () => $55cf96b3448598de$export$cac848e0621718d8);
$parcel$export(module.exports, "drawEllipse", () => $55cf96b3448598de$export$43c9e2bb0dc74582);
$parcel$export(module.exports, "drawSvgPath", () => $55cf96b3448598de$export$47c8a640c39d0756);
$parcel$export(module.exports, "rotateInPlace", () => $55cf96b3448598de$export$5dd9a0a87f38a2a6);
$parcel$export(module.exports, "drawCheckBox", () => $55cf96b3448598de$export$1c2f7a8d0ec539ab);
$parcel$export(module.exports, "drawRadioButton", () => $55cf96b3448598de$export$d01bb537f184a293);
$parcel$export(module.exports, "drawButton", () => $55cf96b3448598de$export$31046eb8c5070d92);
$parcel$export(module.exports, "drawTextField", () => $55cf96b3448598de$export$7d8517ad99905084);
$parcel$export(module.exports, "drawOptionList", () => $55cf96b3448598de$export$5a3093287b85b7c0);

var $cOQTW = parcelRequire("cOQTW");

var $gidDr = parcelRequire("gidDr");

var $hPFvC = parcelRequire("hPFvC");

var $55HYh = parcelRequire("55HYh");

var $ibsNb = parcelRequire("ibsNb");

var $dW4Sr = parcelRequire("dW4Sr");
var $55cf96b3448598de$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.beginText)(),
        (0, $gidDr.setFillingColor)(options.color),
        (0, $hPFvC.setFontAndSize)(options.font, options.size),
        (0, $hPFvC.rotateAndSkewTextRadiansAndTranslate)((0, $55HYh.toRadians)(options.rotate), (0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew), options.x, options.y),
        (0, $hPFvC.showText)(line),
        (0, $hPFvC.endText)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.beginText)(),
        (0, $gidDr.setFillingColor)(options.color),
        (0, $hPFvC.setFontAndSize)(options.font, options.size),
        (0, $hPFvC.setLineHeight)(options.lineHeight),
        (0, $hPFvC.rotateAndSkewTextRadiansAndTranslate)((0, $55HYh.toRadians)(options.rotate), (0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $hPFvC.showText)(lines[idx]), (0, $hPFvC.nextLine)());
    operators.push((0, $hPFvC.endText)(), (0, $hPFvC.popGraphicsState)());
    return operators;
};
var $55cf96b3448598de$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(options.rotate)),
        (0, $hPFvC.scale)(options.width, options.height),
        (0, $hPFvC.skewRadians)((0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew)),
        (0, $hPFvC.drawObject)(name),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(options.rotate)),
        (0, $hPFvC.scale)(options.xScale, options.yScale),
        (0, $hPFvC.skewRadians)((0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew)),
        (0, $hPFvC.drawObject)(name),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        options.color && (0, $gidDr.setStrokingColor)(options.color),
        (0, $hPFvC.setLineWidth)(options.thickness),
        (0, $hPFvC.setDashPattern)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $hPFvC.moveTo)(options.start.x, options.start.y),
        options.lineCap && (0, $hPFvC.setLineCap)(options.lineCap),
        (0, $hPFvC.moveTo)(options.start.x, options.start.y),
        (0, $hPFvC.lineTo)(options.end.x, options.end.y),
        (0, $hPFvC.stroke)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        options.color && (0, $gidDr.setFillingColor)(options.color),
        options.borderColor && (0, $gidDr.setStrokingColor)(options.borderColor),
        (0, $hPFvC.setLineWidth)(options.borderWidth),
        options.borderLineCap && (0, $hPFvC.setLineCap)(options.borderLineCap),
        (0, $hPFvC.setDashPattern)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(options.rotate)),
        (0, $hPFvC.skewRadians)((0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew)),
        (0, $hPFvC.moveTo)(0, 0),
        (0, $hPFvC.lineTo)(0, options.height),
        (0, $hPFvC.lineTo)(options.width, options.height),
        (0, $hPFvC.lineTo)(options.width, 0),
        (0, $hPFvC.closePath)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $hPFvC.fillAndStroke)() : options.color ? (0, $hPFvC.fill)() : options.borderColor ? (0, $hPFvC.stroke)() : (0, $hPFvC.closePath)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $55cf96b3448598de$export$f219d5f4b18063ad = function(config) {
    var x = (0, $dW4Sr.asNumber)(config.x);
    var y = (0, $dW4Sr.asNumber)(config.y);
    var xScale = (0, $dW4Sr.asNumber)(config.xScale);
    var yScale = (0, $dW4Sr.asNumber)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $hPFvC.pushGraphicsState)(),
        (0, $hPFvC.moveTo)(x, ym),
        (0, $hPFvC.appendBezierCurve)(x, ym - oy, xm - ox, y, xm, y),
        (0, $hPFvC.appendBezierCurve)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $hPFvC.appendBezierCurve)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $hPFvC.appendBezierCurve)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $hPFvC.popGraphicsState)()
    ];
};
var $55cf96b3448598de$var$drawEllipseCurves = function(config) {
    var centerX = (0, $dW4Sr.asNumber)(config.x);
    var centerY = (0, $dW4Sr.asNumber)(config.y);
    var xScale = (0, $dW4Sr.asNumber)(config.xScale);
    var yScale = (0, $dW4Sr.asNumber)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $hPFvC.translate)(centerX, centerY),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(config.rotate)),
        (0, $hPFvC.moveTo)(x, ym),
        (0, $hPFvC.appendBezierCurve)(x, ym - oy, xm - ox, y, xm, y),
        (0, $hPFvC.appendBezierCurve)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $hPFvC.appendBezierCurve)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $hPFvC.appendBezierCurve)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $55cf96b3448598de$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        options.color && (0, $gidDr.setFillingColor)(options.color),
        options.borderColor && (0, $gidDr.setStrokingColor)(options.borderColor),
        (0, $hPFvC.setLineWidth)(options.borderWidth),
        options.borderLineCap && (0, $hPFvC.setLineCap)(options.borderLineCap),
        (0, $hPFvC.setDashPattern)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $55cf96b3448598de$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $55cf96b3448598de$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $hPFvC.fillAndStroke)() : options.color ? (0, $hPFvC.fill)() : options.borderColor ? (0, $hPFvC.stroke)() : (0, $hPFvC.closePath)(),
        (0, $hPFvC.popGraphicsState)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $55HYh.degrees)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $hPFvC.scale)(options.scale, -options.scale) : (0, $hPFvC.scale)(1, -1),
        options.color && (0, $gidDr.setFillingColor)(options.color),
        options.borderColor && (0, $gidDr.setStrokingColor)(options.borderColor),
        options.borderWidth && (0, $hPFvC.setLineWidth)(options.borderWidth),
        options.borderLineCap && (0, $hPFvC.setLineCap)(options.borderLineCap),
        (0, $hPFvC.setDashPattern)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $ibsNb.svgPathToOperators)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $hPFvC.fillAndStroke)() : options.color ? (0, $hPFvC.fill)() : options.borderColor ? (0, $hPFvC.stroke)() : (0, $hPFvC.closePath)(),
        (0, $hPFvC.popGraphicsState)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$695703ffa02b3ffb = function(options) {
    var size = (0, $dW4Sr.asNumber)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $hPFvC.pushGraphicsState)(),
        options.color && (0, $gidDr.setStrokingColor)(options.color),
        (0, $hPFvC.setLineWidth)(options.thickness),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.moveTo)(p1x * size, p1y * size),
        (0, $hPFvC.lineTo)(p2x * size, p2y * size),
        (0, $hPFvC.lineTo)(p3x * size, p3y * size),
        (0, $hPFvC.stroke)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $hPFvC.translate)(0, 0),
        (0, $hPFvC.rotateDegrees)(0)
    ] : options.rotation === 90 ? [
        (0, $hPFvC.translate)(options.width, 0),
        (0, $hPFvC.rotateDegrees)(90)
    ] : options.rotation === 180 ? [
        (0, $hPFvC.translate)(options.width, options.height),
        (0, $hPFvC.rotateDegrees)(180)
    ] : options.rotation === 270 ? [
        (0, $hPFvC.translate)(0, options.height),
        (0, $hPFvC.rotateDegrees)(270)
    ] : [];
}; // Invalid rotation - noop
var $55cf96b3448598de$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $55cf96b3448598de$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $55cf96b3448598de$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], outline, checkMark, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$d01bb537f184a293 = function(options) {
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], outline, dot, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$31046eb8c5070d92 = function(options) {
    var x = (0, $dW4Sr.asNumber)(options.x);
    var y = (0, $dW4Sr.asNumber)(options.y);
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], background, lines, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $hPFvC.beginText)(),
        (0, $gidDr.setFillingColor)(options.color),
        (0, $hPFvC.setFontAndSize)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $hPFvC.rotateAndSkewTextRadiansAndTranslate)((0, $55HYh.toRadians)(options.rotate), (0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew), x, y), (0, $hPFvC.showText)(encoded));
    }
    operators.push((0, $hPFvC.endText)());
    return operators;
};
var $55cf96b3448598de$export$7d8517ad99905084 = function(options) {
    var x = (0, $dW4Sr.asNumber)(options.x);
    var y = (0, $dW4Sr.asNumber)(options.y);
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var borderWidth = (0, $dW4Sr.asNumber)(options.borderWidth);
    var padding = (0, $dW4Sr.asNumber)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $hPFvC.moveTo)(clipX, clipY),
        (0, $hPFvC.lineTo)(clipX, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY),
        (0, $hPFvC.closePath)(),
        (0, $hPFvC.clip)(),
        (0, $hPFvC.endPath)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.beginMarkedContent)('Tx'),
        (0, $hPFvC.pushGraphicsState)()
    ], lines, [
        (0, $hPFvC.popGraphicsState)(),
        (0, $hPFvC.endMarkedContent)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], background, clippingArea, markedContent, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $dW4Sr.asNumber)(options.x);
    var y = (0, $dW4Sr.asNumber)(options.y);
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var lineHeight = (0, $dW4Sr.asNumber)(options.lineHeight);
    var borderWidth = (0, $dW4Sr.asNumber)(options.borderWidth);
    var padding = (0, $dW4Sr.asNumber)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $hPFvC.moveTo)(clipX, clipY),
        (0, $hPFvC.lineTo)(clipX, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY),
        (0, $hPFvC.closePath)(),
        (0, $hPFvC.clip)(),
        (0, $hPFvC.endPath)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $55cf96b3448598de$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $55HYh.degrees)(0),
            xSkew: (0, $55HYh.degrees)(0),
            ySkew: (0, $55HYh.degrees)(0)
        }));
    }
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.beginMarkedContent)('Tx'),
        (0, $hPFvC.pushGraphicsState)()
    ], lines, [
        (0, $hPFvC.popGraphicsState)(),
        (0, $hPFvC.endMarkedContent)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};

});
parcelRegister("gidDr", function(module, exports) {

$parcel$export(module.exports, "grayscale", () => $030fa0a2c4d1456e$export$6f416a6db2dfcd5c);
$parcel$export(module.exports, "rgb", () => $030fa0a2c4d1456e$export$8972dc0e6ad9238f);
$parcel$export(module.exports, "cmyk", () => $030fa0a2c4d1456e$export$358b1a66a3c77756);
$parcel$export(module.exports, "setFillingColor", () => $030fa0a2c4d1456e$export$6126e5d7ba707741);
$parcel$export(module.exports, "setStrokingColor", () => $030fa0a2c4d1456e$export$ae31e5cacc8bb23d);
$parcel$export(module.exports, "componentsToColor", () => $030fa0a2c4d1456e$export$8750a268217b0987);
$parcel$export(module.exports, "colorToComponents", () => $030fa0a2c4d1456e$export$ffee2793812e3e56);

var $hPFvC = parcelRequire("hPFvC");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $030fa0a2c4d1456e$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 || ($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 = {}));
var $030fa0a2c4d1456e$export$6f416a6db2dfcd5c = function(gray) {
    (0, $j0tvB.assertRange)(gray, 'gray', 0.0, 1.0);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $030fa0a2c4d1456e$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $j0tvB.assertRange)(red, 'red', 0, 1);
    (0, $j0tvB.assertRange)(green, 'green', 0, 1);
    (0, $j0tvB.assertRange)(blue, 'blue', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $030fa0a2c4d1456e$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $j0tvB.assertRange)(cyan, 'cyan', 0, 1);
    (0, $j0tvB.assertRange)(magenta, 'magenta', 0, 1);
    (0, $j0tvB.assertRange)(yellow, 'yellow', 0, 1);
    (0, $j0tvB.assertRange)(key, 'key', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $030fa0a2c4d1456e$var$Grayscale = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale, $030fa0a2c4d1456e$var$RGB = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB, $030fa0a2c4d1456e$var$CMYK = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK;
var $030fa0a2c4d1456e$export$6126e5d7ba707741 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $hPFvC.setFillingGrayscaleColor)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $hPFvC.setFillingRgbColor)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $hPFvC.setFillingCmykColor)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $hPFvC.setStrokingGrayscaleColor)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $hPFvC.setStrokingRgbColor)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $hPFvC.setStrokingCmykColor)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $030fa0a2c4d1456e$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $030fa0a2c4d1456e$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $030fa0a2c4d1456e$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $030fa0a2c4d1456e$export$ffee2793812e3e56 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? [
        color.gray
    ] : color.type === $030fa0a2c4d1456e$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $030fa0a2c4d1456e$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};

});
parcelRegister("hPFvC", function(module, exports) {

$parcel$export(module.exports, "clip", () => $cfb765e9daff3c3a$export$e0b576e7a74416cd);
$parcel$export(module.exports, "translate", () => $cfb765e9daff3c3a$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "scale", () => $cfb765e9daff3c3a$export$dcdf75081b88279d);
$parcel$export(module.exports, "rotateRadians", () => $cfb765e9daff3c3a$export$a2ba89726971a90f);
$parcel$export(module.exports, "rotateDegrees", () => $cfb765e9daff3c3a$export$91df22fbff99d059);
$parcel$export(module.exports, "skewRadians", () => $cfb765e9daff3c3a$export$985cb1d69d6a3add);
$parcel$export(module.exports, "setDashPattern", () => $cfb765e9daff3c3a$export$e0e900d241274e06);
$parcel$export(module.exports, "LineCapStyle", () => $cfb765e9daff3c3a$export$7a77bc708e50709e);
$parcel$export(module.exports, "setLineCap", () => $cfb765e9daff3c3a$export$6c65ed24e870eec);
$parcel$export(module.exports, "setGraphicsState", () => $cfb765e9daff3c3a$export$568567f665d3f3bb);
$parcel$export(module.exports, "pushGraphicsState", () => $cfb765e9daff3c3a$export$cb182c48e35739ac);
$parcel$export(module.exports, "popGraphicsState", () => $cfb765e9daff3c3a$export$10581a6f45bf75eb);
$parcel$export(module.exports, "setLineWidth", () => $cfb765e9daff3c3a$export$558e0f90d8262345);
$parcel$export(module.exports, "appendBezierCurve", () => $cfb765e9daff3c3a$export$45bd49bb15a3c5cb);
$parcel$export(module.exports, "appendQuadraticCurve", () => $cfb765e9daff3c3a$export$6f4913b22432f892);
$parcel$export(module.exports, "closePath", () => $cfb765e9daff3c3a$export$21f87e210c424cd0);
$parcel$export(module.exports, "moveTo", () => $cfb765e9daff3c3a$export$75f1ccd6dc32e80a);
$parcel$export(module.exports, "lineTo", () => $cfb765e9daff3c3a$export$73abee0cf983cb99);
$parcel$export(module.exports, "stroke", () => $cfb765e9daff3c3a$export$d9b706f8d0a70aef);
$parcel$export(module.exports, "fill", () => $cfb765e9daff3c3a$export$9563e054e6f787fb);
$parcel$export(module.exports, "fillAndStroke", () => $cfb765e9daff3c3a$export$76d37801baac10fb);
$parcel$export(module.exports, "endPath", () => $cfb765e9daff3c3a$export$d366e9c0a9bd860f);
$parcel$export(module.exports, "nextLine", () => $cfb765e9daff3c3a$export$829ffc2dbe358942);
$parcel$export(module.exports, "showText", () => $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4);
$parcel$export(module.exports, "beginText", () => $cfb765e9daff3c3a$export$337b8dbf65fbb95e);
$parcel$export(module.exports, "endText", () => $cfb765e9daff3c3a$export$e3caa83a99d72806);
$parcel$export(module.exports, "setFontAndSize", () => $cfb765e9daff3c3a$export$df01d619ff6ce7f7);
$parcel$export(module.exports, "setLineHeight", () => $cfb765e9daff3c3a$export$79399e66b6bb212c);
$parcel$export(module.exports, "rotateAndSkewTextRadiansAndTranslate", () => $cfb765e9daff3c3a$export$f567083ac6aa5aa3);
$parcel$export(module.exports, "drawObject", () => $cfb765e9daff3c3a$export$382c18f8bccd9e2b);
$parcel$export(module.exports, "setFillingGrayscaleColor", () => $cfb765e9daff3c3a$export$f30201749d00f572);
$parcel$export(module.exports, "setStrokingGrayscaleColor", () => $cfb765e9daff3c3a$export$6502921112196b8f);
$parcel$export(module.exports, "setFillingRgbColor", () => $cfb765e9daff3c3a$export$f59cae633978eea7);
$parcel$export(module.exports, "setStrokingRgbColor", () => $cfb765e9daff3c3a$export$e743468c48a4fd5a);
$parcel$export(module.exports, "setFillingCmykColor", () => $cfb765e9daff3c3a$export$e836aceb3db98cc0);
$parcel$export(module.exports, "setStrokingCmykColor", () => $cfb765e9daff3c3a$export$4004b818fda831c1);
$parcel$export(module.exports, "beginMarkedContent", () => $cfb765e9daff3c3a$export$a028b403e40f1ab2);
$parcel$export(module.exports, "endMarkedContent", () => $cfb765e9daff3c3a$export$935e2334f5a50589);

var $dW4Sr = parcelRequire("dW4Sr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $5uV6d = parcelRequire("5uV6d");
var $3oHKx = parcelRequire("3oHKx");
var $cfb765e9daff3c3a$export$e0b576e7a74416cd = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ClipNonZero);
};
var $cfb765e9daff3c3a$export$dd6fb25f201b5a7a = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $cfb765e9daff3c3a$var$cos = Math.cos, $cfb765e9daff3c3a$var$sin = Math.sin, $cfb765e9daff3c3a$var$tan = Math.tan;
var $cfb765e9daff3c3a$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ConcatTransformationMatrix, [
        (0, $dW4Sr.asPDFNumber)(a),
        (0, $dW4Sr.asPDFNumber)(b),
        (0, $dW4Sr.asPDFNumber)(c),
        (0, $dW4Sr.asPDFNumber)(d),
        (0, $dW4Sr.asPDFNumber)(e),
        (0, $dW4Sr.asPDFNumber)(f)
    ]);
};
var $cfb765e9daff3c3a$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $cfb765e9daff3c3a$export$dcdf75081b88279d = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $cfb765e9daff3c3a$export$a2ba89726971a90f = function(angle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497($cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(angle)), $cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(angle)), -$cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(angle)), $cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(angle)), 0, 0);
};
var $cfb765e9daff3c3a$export$91df22fbff99d059 = function(angle) {
    return $cfb765e9daff3c3a$export$a2ba89726971a90f((0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(angle)));
};
var $cfb765e9daff3c3a$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(xSkewAngle)), $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(ySkewAngle)), 1, 0, 0);
};
var $cfb765e9daff3c3a$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$985cb1d69d6a3add((0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(xSkewAngle)), (0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(ySkewAngle)));
};
var $cfb765e9daff3c3a$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineDashPattern, [
        "[" + dashArray.map((0, $dW4Sr.asPDFNumber)).join(' ') + "]",
        (0, $dW4Sr.asPDFNumber)(dashPhase)
    ]);
};
var $cfb765e9daff3c3a$export$d10d019aadfd45c7 = function() {
    return $cfb765e9daff3c3a$export$e0e900d241274e06([], 0);
};
var $cfb765e9daff3c3a$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($cfb765e9daff3c3a$export$7a77bc708e50709e || ($cfb765e9daff3c3a$export$7a77bc708e50709e = {}));
var $cfb765e9daff3c3a$export$6c65ed24e870eec = function(style) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineCapStyle, [
        (0, $dW4Sr.asPDFNumber)(style)
    ]);
};
var $cfb765e9daff3c3a$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($cfb765e9daff3c3a$export$cba5d0f1cde60b86 || ($cfb765e9daff3c3a$export$cba5d0f1cde60b86 = {}));
var $cfb765e9daff3c3a$export$97dfb3b4509cd5bc = function(style) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineJoinStyle, [
        (0, $dW4Sr.asPDFNumber)(style)
    ]);
};
var $cfb765e9daff3c3a$export$568567f665d3f3bb = function(state) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetGraphicsStateParams, [
        (0, $dW4Sr.asPDFName)(state)
    ]);
};
var $cfb765e9daff3c3a$export$cb182c48e35739ac = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).PushGraphicsState);
};
var $cfb765e9daff3c3a$export$10581a6f45bf75eb = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).PopGraphicsState);
};
var $cfb765e9daff3c3a$export$558e0f90d8262345 = function(width) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineWidth, [
        (0, $dW4Sr.asPDFNumber)(width)
    ]);
};
var $cfb765e9daff3c3a$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).AppendBezierCurve, [
        (0, $dW4Sr.asPDFNumber)(x1),
        (0, $dW4Sr.asPDFNumber)(y1),
        (0, $dW4Sr.asPDFNumber)(x2),
        (0, $dW4Sr.asPDFNumber)(y2),
        (0, $dW4Sr.asPDFNumber)(x3),
        (0, $dW4Sr.asPDFNumber)(y3)
    ]);
};
var $cfb765e9daff3c3a$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).CurveToReplicateInitialPoint, [
        (0, $dW4Sr.asPDFNumber)(x1),
        (0, $dW4Sr.asPDFNumber)(y1),
        (0, $dW4Sr.asPDFNumber)(x2),
        (0, $dW4Sr.asPDFNumber)(y2)
    ]);
};
var $cfb765e9daff3c3a$export$21f87e210c424cd0 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ClosePath);
};
var $cfb765e9daff3c3a$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).MoveTo, [
        (0, $dW4Sr.asPDFNumber)(xPos),
        (0, $dW4Sr.asPDFNumber)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).LineTo, [
        (0, $dW4Sr.asPDFNumber)(xPos),
        (0, $dW4Sr.asPDFNumber)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).AppendRectangle, [
        (0, $dW4Sr.asPDFNumber)(xPos),
        (0, $dW4Sr.asPDFNumber)(yPos),
        (0, $dW4Sr.asPDFNumber)(width),
        (0, $dW4Sr.asPDFNumber)(height)
    ]);
};
var $cfb765e9daff3c3a$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $cfb765e9daff3c3a$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $cfb765e9daff3c3a$export$d9b706f8d0a70aef = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokePath);
};
var $cfb765e9daff3c3a$export$9563e054e6f787fb = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).FillNonZero);
};
var $cfb765e9daff3c3a$export$76d37801baac10fb = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).FillNonZeroAndStroke);
};
var $cfb765e9daff3c3a$export$d366e9c0a9bd860f = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).EndPath);
};
var $cfb765e9daff3c3a$export$829ffc2dbe358942 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NextLine);
};
var $cfb765e9daff3c3a$export$b84c1833e225e397 = function(x, y) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).MoveText, [
        (0, $dW4Sr.asPDFNumber)(x),
        (0, $dW4Sr.asPDFNumber)(y)
    ]);
};
var $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ShowText, [
        text
    ]);
};
var $cfb765e9daff3c3a$export$337b8dbf65fbb95e = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).BeginText);
};
var $cfb765e9daff3c3a$export$e3caa83a99d72806 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).EndText);
};
var $cfb765e9daff3c3a$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetFontAndSize, [
        (0, $dW4Sr.asPDFName)(name),
        (0, $dW4Sr.asPDFNumber)(size)
    ]);
};
var $cfb765e9daff3c3a$export$710392ce2617f080 = function(spacing) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetCharacterSpacing, [
        (0, $dW4Sr.asPDFNumber)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$a2801242b2f8967d = function(spacing) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetWordSpacing, [
        (0, $dW4Sr.asPDFNumber)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$20dbb065c447b4da = function(squeeze) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextHorizontalScaling, [
        (0, $dW4Sr.asPDFNumber)(squeeze)
    ]);
};
var $cfb765e9daff3c3a$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextLineHeight, [
        (0, $dW4Sr.asPDFNumber)(lineHeight)
    ]);
};
var $cfb765e9daff3c3a$export$ad1653459b07f70c = function(rise) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextRise, [
        (0, $dW4Sr.asPDFNumber)(rise)
    ]);
};
var $cfb765e9daff3c3a$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($cfb765e9daff3c3a$export$ca45e4ab114d4814 || ($cfb765e9daff3c3a$export$ca45e4ab114d4814 = {}));
var $cfb765e9daff3c3a$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextRenderingMode, [
        (0, $dW4Sr.asPDFNumber)(mode)
    ]);
};
var $cfb765e9daff3c3a$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextMatrix, [
        (0, $dW4Sr.asPDFNumber)(a),
        (0, $dW4Sr.asPDFNumber)(b),
        (0, $dW4Sr.asPDFNumber)(c),
        (0, $dW4Sr.asPDFNumber)(d),
        (0, $dW4Sr.asPDFNumber)(e),
        (0, $dW4Sr.asPDFNumber)(f)
    ]);
};
var $cfb765e9daff3c3a$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$d3656d656af31043($cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(rotationAngle)), $cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(xSkewAngle)), -$cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(ySkewAngle)), $cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(rotationAngle)), x, y);
};
var $cfb765e9daff3c3a$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$f567083ac6aa5aa3((0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(rotationAngle)), (0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(xSkewAngle)), (0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(ySkewAngle)), x, y);
};
var $cfb765e9daff3c3a$export$382c18f8bccd9e2b = function(name) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).DrawObject, [
        (0, $dW4Sr.asPDFName)(name)
    ]);
};
var $cfb765e9daff3c3a$export$f30201749d00f572 = function(gray) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NonStrokingColorGray, [
        (0, $dW4Sr.asPDFNumber)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$6502921112196b8f = function(gray) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokingColorGray, [
        (0, $dW4Sr.asPDFNumber)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NonStrokingColorRgb, [
        (0, $dW4Sr.asPDFNumber)(red),
        (0, $dW4Sr.asPDFNumber)(green),
        (0, $dW4Sr.asPDFNumber)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokingColorRgb, [
        (0, $dW4Sr.asPDFNumber)(red),
        (0, $dW4Sr.asPDFNumber)(green),
        (0, $dW4Sr.asPDFNumber)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NonStrokingColorCmyk, [
        (0, $dW4Sr.asPDFNumber)(cyan),
        (0, $dW4Sr.asPDFNumber)(magenta),
        (0, $dW4Sr.asPDFNumber)(yellow),
        (0, $dW4Sr.asPDFNumber)(key)
    ]);
};
var $cfb765e9daff3c3a$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokingColorCmyk, [
        (0, $dW4Sr.asPDFNumber)(cyan),
        (0, $dW4Sr.asPDFNumber)(magenta),
        (0, $dW4Sr.asPDFNumber)(yellow),
        (0, $dW4Sr.asPDFNumber)(key)
    ]);
};
var $cfb765e9daff3c3a$export$a028b403e40f1ab2 = function(tag) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).BeginMarkedContent, [
        (0, $dW4Sr.asPDFName)(tag)
    ]);
};
var $cfb765e9daff3c3a$export$935e2334f5a50589 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).EndMarkedContent);
};

});
parcelRegister("dW4Sr", function(module, exports) {

$parcel$export(module.exports, "asPDFName", () => $a25479a44f824b27$export$69d5e1b305482e08);
$parcel$export(module.exports, "asPDFNumber", () => $a25479a44f824b27$export$fb5b5e76a3a5c568);
$parcel$export(module.exports, "asNumber", () => $a25479a44f824b27$export$37576b9ba69b50db);
parcelRequire("iT7lj");
var $dPHSK = parcelRequire("dPHSK");
var $j04jt = parcelRequire("j04jt");
var $a25479a44f824b27$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $dPHSK.default) ? name : (0, $dPHSK.default).of(name);
};
var $a25479a44f824b27$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $j04jt.default) ? num : (0, $j04jt.default).of(num);
};
var $a25479a44f824b27$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $j04jt.default) ? num.asNumber() : num;
};

});
parcelRegister("iT7lj", function(module, exports) {
$parcel$export(module.exports, "MethodNotImplementedError", () => (parcelRequire("nAWRe")).MethodNotImplementedError);
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", () => (parcelRequire("nAWRe")).PageEmbeddingMismatchedContextError);
$parcel$export(module.exports, "UnexpectedObjectTypeError", () => (parcelRequire("nAWRe")).UnexpectedObjectTypeError);
$parcel$export(module.exports, "AnnotationFlags", () => (parcelRequire("ckfWn")).AnnotationFlags);
$parcel$export(module.exports, "PDFWidgetAnnotation", () => (parcelRequire("7ds0z")).default);
$parcel$export(module.exports, "AcroButtonFlags", () => (parcelRequire("d5IrD")).AcroButtonFlags);
$parcel$export(module.exports, "AcroChoiceFlags", () => (parcelRequire("d5IrD")).AcroChoiceFlags);
$parcel$export(module.exports, "AcroFieldFlags", () => (parcelRequire("d5IrD")).AcroFieldFlags);
$parcel$export(module.exports, "AcroTextFlags", () => (parcelRequire("d5IrD")).AcroTextFlags);
$parcel$export(module.exports, "createPDFAcroFields", () => (parcelRequire("gkGMc")).createPDFAcroFields);
$parcel$export(module.exports, "PDFAcroCheckBox", () => (parcelRequire("lmORt")).default);
$parcel$export(module.exports, "PDFAcroComboBox", () => (parcelRequire("4vDg3")).default);
$parcel$export(module.exports, "PDFAcroForm", () => (parcelRequire("flrAV")).default);
$parcel$export(module.exports, "PDFAcroListBox", () => (parcelRequire("gEqSi")).default);
$parcel$export(module.exports, "PDFAcroNonTerminal", () => (parcelRequire("dP7Ar")).default);
$parcel$export(module.exports, "PDFAcroPushButton", () => (parcelRequire("1757u")).default);
$parcel$export(module.exports, "PDFAcroRadioButton", () => (parcelRequire("hpItd")).default);
$parcel$export(module.exports, "PDFAcroSignature", () => (parcelRequire("7hDvO")).default);
$parcel$export(module.exports, "PDFAcroTerminal", () => (parcelRequire("64Z70")).default);
$parcel$export(module.exports, "PDFAcroText", () => (parcelRequire("clInn")).default);

$parcel$export(module.exports, "PDFContext", () => (parcelRequire("kl4jO")).default);
$parcel$export(module.exports, "PDFObjectCopier", () => (parcelRequire("k5Uzj")).default);
$parcel$export(module.exports, "PDFWriter", () => (parcelRequire("5HlMk")).default);
$parcel$export(module.exports, "PDFStreamWriter", () => (parcelRequire("7YdvF")).default);
$parcel$export(module.exports, "StandardFontEmbedder", () => (parcelRequire("jwvE5")).default);
$parcel$export(module.exports, "CustomFontEmbedder", () => (parcelRequire("gCJZ9")).default);
$parcel$export(module.exports, "CustomFontSubsetEmbedder", () => (parcelRequire("6uXKX")).default);
$parcel$export(module.exports, "JpegEmbedder", () => (parcelRequire("fmxHr")).default);
$parcel$export(module.exports, "PngEmbedder", () => (parcelRequire("atfwl")).default);
$parcel$export(module.exports, "PDFPageEmbedder", () => (parcelRequire("h9IbG")).default);
$parcel$export(module.exports, "PDFNumber", () => (parcelRequire("j04jt")).default);
$parcel$export(module.exports, "PDFString", () => (parcelRequire("8dCYu")).default);
$parcel$export(module.exports, "PDFHexString", () => (parcelRequire("jWFiV")).default);
$parcel$export(module.exports, "PDFName", () => (parcelRequire("dPHSK")).default);
$parcel$export(module.exports, "PDFArray", () => (parcelRequire("8auL6")).default);
$parcel$export(module.exports, "PDFDict", () => (parcelRequire("brir8")).default);
$parcel$export(module.exports, "PDFRef", () => (parcelRequire("kHzkO")).default);
$parcel$export(module.exports, "PDFStream", () => (parcelRequire("4CgUJ")).default);
$parcel$export(module.exports, "PDFCatalog", () => (parcelRequire("b3l66")).default);
$parcel$export(module.exports, "PDFContentStream", () => (parcelRequire("9EODP")).default);
$parcel$export(module.exports, "PDFPageTree", () => (parcelRequire("4oH3u")).default);
$parcel$export(module.exports, "PDFPageLeaf", () => (parcelRequire("eAof5")).default);
$parcel$export(module.exports, "PDFOperator", () => (parcelRequire("5uV6d")).default);
$parcel$export(module.exports, "PDFOperatorNames", () => (parcelRequire("3oHKx")).default);
$parcel$export(module.exports, "PDFParser", () => (parcelRequire("14nUL")).default);
parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $kl4jO = parcelRequire("kl4jO");

var $k5Uzj = parcelRequire("k5Uzj");

var $5HlMk = parcelRequire("5HlMk");

var $7YdvF = parcelRequire("7YdvF");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $fXb4L = parcelRequire("fXb4L");

var $Vy0LI = parcelRequire("Vy0LI");

var $jwvE5 = parcelRequire("jwvE5");

var $gCJZ9 = parcelRequire("gCJZ9");

var $6uXKX = parcelRequire("6uXKX");

var $k8kub = parcelRequire("k8kub");

var $fmxHr = parcelRequire("fmxHr");

var $atfwl = parcelRequire("atfwl");

var $h9IbG = parcelRequire("h9IbG");

var $cpTWE = parcelRequire("cpTWE");

var $11c5J = parcelRequire("11c5J");

var $8gQNC = parcelRequire("8gQNC");

var $j04jt = parcelRequire("j04jt");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $kHzkO = parcelRequire("kHzkO");

var $eTWtL = parcelRequire("eTWtL");

var $4CgUJ = parcelRequire("4CgUJ");

var $kx2r4 = parcelRequire("kx2r4");

var $b3l66 = parcelRequire("b3l66");

var $9EODP = parcelRequire("9EODP");

var $eMjAF = parcelRequire("eMjAF");

var $8nK9n = parcelRequire("8nK9n");

var $4oH3u = parcelRequire("4oH3u");

var $eAof5 = parcelRequire("eAof5");

var $3T8kK = parcelRequire("3T8kK");

var $5uV6d = parcelRequire("5uV6d");

var $3oHKx = parcelRequire("3oHKx");

var $3QRZR = parcelRequire("3QRZR");

var $7yUXZ = parcelRequire("7yUXZ");

var $14nUL = parcelRequire("14nUL");

var $b1gaC = parcelRequire("b1gaC");

var $dLMRX = parcelRequire("dLMRX");
parcelRequire("6anj6");
parcelRequire("hO9YF");

});
parcelRegister("nAWRe", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", () => $046ecf435f71da9c$export$b549a6777be1bc17);
$parcel$export(module.exports, "PrivateConstructorError", () => $046ecf435f71da9c$export$20e18464cd4b43a);
$parcel$export(module.exports, "UnexpectedObjectTypeError", () => $046ecf435f71da9c$export$ab03f98a62c22159);
$parcel$export(module.exports, "UnsupportedEncodingError", () => $046ecf435f71da9c$export$5de8fe8a6031fb92);
$parcel$export(module.exports, "ReparseError", () => $046ecf435f71da9c$export$df523155c7c35e23);
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", () => $046ecf435f71da9c$export$48e9be38307e3c37);
$parcel$export(module.exports, "UnrecognizedStreamTypeError", () => $046ecf435f71da9c$export$f8343077e7fd3a86);
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", () => $046ecf435f71da9c$export$22c55e00f6509a2c);
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", () => $046ecf435f71da9c$export$a76bae7761f3d760);
$parcel$export(module.exports, "InvalidPDFDateStringError", () => $046ecf435f71da9c$export$8638e3ad1edceac8);
$parcel$export(module.exports, "InvalidTargetIndexError", () => $046ecf435f71da9c$export$845c01ec1ddb8877);
$parcel$export(module.exports, "CorruptPageTreeError", () => $046ecf435f71da9c$export$1012d63cae1523f8);
$parcel$export(module.exports, "IndexOutOfBoundsError", () => $046ecf435f71da9c$export$19a77d83c7473130);
$parcel$export(module.exports, "InvalidAcroFieldValueError", () => $046ecf435f71da9c$export$d39c49ea9be644ec);
$parcel$export(module.exports, "MultiSelectValueError", () => $046ecf435f71da9c$export$6606fe23b6c4542c);
$parcel$export(module.exports, "MissingDAEntryError", () => $046ecf435f71da9c$export$dfa101de065b3cc2);
$parcel$export(module.exports, "MissingTfOperatorError", () => $046ecf435f71da9c$export$b5ee390f1267b133);
$parcel$export(module.exports, "NumberParsingError", () => $046ecf435f71da9c$export$81adf4c464255546);
$parcel$export(module.exports, "NextByteAssertionError", () => $046ecf435f71da9c$export$fda6cb3cf0fe0c76);
$parcel$export(module.exports, "PDFObjectParsingError", () => $046ecf435f71da9c$export$b8907968b8d7f502);
$parcel$export(module.exports, "PDFInvalidObjectParsingError", () => $046ecf435f71da9c$export$72474f06fb3a1c6b);
$parcel$export(module.exports, "PDFStreamParsingError", () => $046ecf435f71da9c$export$b1a91b84397f50d6);
$parcel$export(module.exports, "UnbalancedParenthesisError", () => $046ecf435f71da9c$export$92803ff0e03167f9);
$parcel$export(module.exports, "StalledParserError", () => $046ecf435f71da9c$export$b934c61834236c8);
$parcel$export(module.exports, "MissingPDFHeaderError", () => $046ecf435f71da9c$export$cf6bd1b11dd05d74);
$parcel$export(module.exports, "MissingKeywordError", () => $046ecf435f71da9c$export$bc024c15c94be864);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $046ecf435f71da9c$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $046ecf435f71da9c$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $046ecf435f71da9c$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $046ecf435f71da9c$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $046ecf435f71da9c$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $046ecf435f71da9c$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $046ecf435f71da9c$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $046ecf435f71da9c$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $046ecf435f71da9c$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $046ecf435f71da9c$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $046ecf435f71da9c$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $046ecf435f71da9c$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $046ecf435f71da9c$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $046ecf435f71da9c$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $046ecf435f71da9c$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $046ecf435f71da9c$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $046ecf435f71da9c$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $046ecf435f71da9c$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $046ecf435f71da9c$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $046ecf435f71da9c$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $046ecf435f71da9c$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $4ISq8.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($046ecf435f71da9c$export$fd202455a19cb700);

});
parcelRegister("fvYKZ", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", () => (parcelRequire("4ISq8")).arrayAsString);
$parcel$export(module.exports, "byAscendingId", () => (parcelRequire("4ISq8")).byAscendingId);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => (parcelRequire("4ISq8")).canBeConvertedToUint8Array);
$parcel$export(module.exports, "last", () => (parcelRequire("4ISq8")).last);
$parcel$export(module.exports, "mergeIntoTypedArray", () => (parcelRequire("4ISq8")).mergeIntoTypedArray);
$parcel$export(module.exports, "mergeUint8Arrays", () => (parcelRequire("4ISq8")).mergeUint8Arrays);
$parcel$export(module.exports, "pluckIndices", () => (parcelRequire("4ISq8")).pluckIndices);
$parcel$export(module.exports, "range", () => (parcelRequire("4ISq8")).range);
$parcel$export(module.exports, "reverseArray", () => (parcelRequire("4ISq8")).reverseArray);
$parcel$export(module.exports, "sortedUniq", () => (parcelRequire("4ISq8")).sortedUniq);
$parcel$export(module.exports, "sum", () => (parcelRequire("4ISq8")).sum);
$parcel$export(module.exports, "toUint8Array", () => (parcelRequire("4ISq8")).toUint8Array);
$parcel$export(module.exports, "typedArrayFor", () => (parcelRequire("4ISq8")).typedArrayFor);
$parcel$export(module.exports, "waitForTick", () => (parcelRequire("ggjMi")).waitForTick);
$parcel$export(module.exports, "breakTextIntoLines", () => (parcelRequire("7Kmy8")).breakTextIntoLines);
$parcel$export(module.exports, "charAtIndex", () => (parcelRequire("7Kmy8")).charAtIndex);
$parcel$export(module.exports, "charFromCode", () => (parcelRequire("7Kmy8")).charFromCode);
$parcel$export(module.exports, "charFromHexCode", () => (parcelRequire("7Kmy8")).charFromHexCode);
$parcel$export(module.exports, "charSplit", () => (parcelRequire("7Kmy8")).charSplit);
$parcel$export(module.exports, "cleanText", () => (parcelRequire("7Kmy8")).cleanText);
$parcel$export(module.exports, "copyStringIntoBuffer", () => (parcelRequire("7Kmy8")).copyStringIntoBuffer);
$parcel$export(module.exports, "findLastMatch", () => (parcelRequire("7Kmy8")).findLastMatch);
$parcel$export(module.exports, "lineSplit", () => (parcelRequire("7Kmy8")).lineSplit);
$parcel$export(module.exports, "mergeLines", () => (parcelRequire("7Kmy8")).mergeLines);
$parcel$export(module.exports, "padStart", () => (parcelRequire("7Kmy8")).padStart);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("7Kmy8")).parseDate);
$parcel$export(module.exports, "toCharCode", () => (parcelRequire("7Kmy8")).toCharCode);
$parcel$export(module.exports, "toCodePoint", () => (parcelRequire("7Kmy8")).toCodePoint);
$parcel$export(module.exports, "toHexString", () => (parcelRequire("7Kmy8")).toHexString);
$parcel$export(module.exports, "toHexStringOfMinLength", () => (parcelRequire("7Kmy8")).toHexStringOfMinLength);
$parcel$export(module.exports, "hasUtf16BOM", () => (parcelRequire("ejAvl")).hasUtf16BOM);
$parcel$export(module.exports, "utf16Decode", () => (parcelRequire("ejAvl")).utf16Decode);
$parcel$export(module.exports, "utf16Encode", () => (parcelRequire("ejAvl")).utf16Encode);
$parcel$export(module.exports, "bytesFor", () => (parcelRequire("hiEdU")).bytesFor);
$parcel$export(module.exports, "numberToString", () => (parcelRequire("hiEdU")).numberToString);
$parcel$export(module.exports, "sizeInBytes", () => (parcelRequire("hiEdU")).sizeInBytes);
$parcel$export(module.exports, "error", () => (parcelRequire("hP0hy")).error);
$parcel$export(module.exports, "encodeToBase64", () => (parcelRequire("fZ8o5")).encodeToBase64);
$parcel$export(module.exports, "isStandardFont", () => (parcelRequire("cbIAG")).isStandardFont);
$parcel$export(module.exports, "rectanglesAreEqual", () => (parcelRequire("cbIAG")).rectanglesAreEqual);
$parcel$export(module.exports, "assertEachIs", () => (parcelRequire("j0tvB")).assertEachIs);
$parcel$export(module.exports, "assertInteger", () => (parcelRequire("j0tvB")).assertInteger);
$parcel$export(module.exports, "assertIs", () => (parcelRequire("j0tvB")).assertIs);
$parcel$export(module.exports, "assertIsOneOf", () => (parcelRequire("j0tvB")).assertIsOneOf);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => (parcelRequire("j0tvB")).assertIsOneOfOrUndefined);
$parcel$export(module.exports, "assertIsSubset", () => (parcelRequire("j0tvB")).assertIsSubset);
$parcel$export(module.exports, "assertMultiple", () => (parcelRequire("j0tvB")).assertMultiple);
$parcel$export(module.exports, "assertOrUndefined", () => (parcelRequire("j0tvB")).assertOrUndefined);
$parcel$export(module.exports, "assertPositive", () => (parcelRequire("j0tvB")).assertPositive);
$parcel$export(module.exports, "assertRange", () => (parcelRequire("j0tvB")).assertRange);
$parcel$export(module.exports, "assertRangeOrUndefined", () => (parcelRequire("j0tvB")).assertRangeOrUndefined);
$parcel$export(module.exports, "pdfDocEncodingDecode", () => (parcelRequire("iSBb0")).pdfDocEncodingDecode);

$parcel$export(module.exports, "Cache", () => (parcelRequire("clYSv")).default);
parcelRequire("4ISq8");
parcelRequire("ggjMi");
parcelRequire("7Kmy8");
parcelRequire("ejAvl");
parcelRequire("hiEdU");
parcelRequire("hP0hy");
parcelRequire("fZ8o5");
parcelRequire("cbIAG");
parcelRequire("j0tvB");
parcelRequire("iSBb0");

var $clYSv = parcelRequire("clYSv");

});
parcelRegister("4ISq8", function(module, exports) {

$parcel$export(module.exports, "last", () => $37057c446bb711eb$export$4c7897fafd92b108);
$parcel$export(module.exports, "typedArrayFor", () => $37057c446bb711eb$export$98b44e66722b6f4d);
$parcel$export(module.exports, "mergeIntoTypedArray", () => $37057c446bb711eb$export$8907b5381cbcd9a7);
$parcel$export(module.exports, "mergeUint8Arrays", () => $37057c446bb711eb$export$99cee7ee2de7e6e4);
$parcel$export(module.exports, "arrayAsString", () => $37057c446bb711eb$export$5f8f9664fe5c5f14);
$parcel$export(module.exports, "byAscendingId", () => $37057c446bb711eb$export$55b6b1f56c6e1ba5);
$parcel$export(module.exports, "sortedUniq", () => $37057c446bb711eb$export$720e3b5aefb27114);
$parcel$export(module.exports, "reverseArray", () => $37057c446bb711eb$export$c9b97e771c4a8302);
$parcel$export(module.exports, "sum", () => $37057c446bb711eb$export$8a63f25cc62965f1);
$parcel$export(module.exports, "range", () => $37057c446bb711eb$export$d02631cccf789723);
$parcel$export(module.exports, "pluckIndices", () => $37057c446bb711eb$export$279d041ff3481d88);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => $37057c446bb711eb$export$20e9c5ed92218c4b);
$parcel$export(module.exports, "toUint8Array", () => $37057c446bb711eb$export$73470fd2221e6aef);

var $fZ8o5 = parcelRequire("fZ8o5");

var $7Kmy8 = parcelRequire("7Kmy8");
var $37057c446bb711eb$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $37057c446bb711eb$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $37057c446bb711eb$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $37057c446bb711eb$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $37057c446bb711eb$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $37057c446bb711eb$export$5f8f9664fe5c5f14 = function(array) {
    var str = '';
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $7Kmy8.charFromCode)(array[idx]);
    return str;
};
var $37057c446bb711eb$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $37057c446bb711eb$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $37057c446bb711eb$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $37057c446bb711eb$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $37057c446bb711eb$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $37057c446bb711eb$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $37057c446bb711eb$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var $37057c446bb711eb$export$73470fd2221e6aef = function(input) {
    if (typeof input === 'string') return (0, $fZ8o5.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
};

});
parcelRegister("fZ8o5", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", () => $ba330f1ee33d4a3b$export$373f4c3083978ffd);
$parcel$export(module.exports, "decodeFromBase64DataUri", () => $ba330f1ee33d4a3b$export$f6810f5086699d73);
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $ba330f1ee33d4a3b$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $ba330f1ee33d4a3b$var$lookup = new Uint8Array(256);
for(var $ba330f1ee33d4a3b$var$i = 0; $ba330f1ee33d4a3b$var$i < $ba330f1ee33d4a3b$var$chars.length; $ba330f1ee33d4a3b$var$i++)$ba330f1ee33d4a3b$var$lookup[$ba330f1ee33d4a3b$var$chars.charCodeAt($ba330f1ee33d4a3b$var$i)] = $ba330f1ee33d4a3b$var$i;
var $ba330f1ee33d4a3b$export$373f4c3083978ffd = function(bytes) {
    var base64 = '';
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i] >> 2];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $ba330f1ee33d4a3b$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $ba330f1ee33d4a3b$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("7Kmy8", function(module, exports) {

$parcel$export(module.exports, "toCharCode", () => $5a3e522cca792aad$export$d90166409dd04e85);
$parcel$export(module.exports, "toCodePoint", () => $5a3e522cca792aad$export$93bf578f015d73f0);
$parcel$export(module.exports, "toHexStringOfMinLength", () => $5a3e522cca792aad$export$6ac97d2d1bf41f39);
$parcel$export(module.exports, "padStart", () => $5a3e522cca792aad$export$36cf564d487b5178);
$parcel$export(module.exports, "toHexString", () => $5a3e522cca792aad$export$f4915efbb94d4d01);
$parcel$export(module.exports, "charFromCode", () => $5a3e522cca792aad$export$207031940e6950ad);
$parcel$export(module.exports, "charFromHexCode", () => $5a3e522cca792aad$export$ceedd1b69dcde7a5);
$parcel$export(module.exports, "copyStringIntoBuffer", () => $5a3e522cca792aad$export$c41a03555c37a984);
$parcel$export(module.exports, "cleanText", () => $5a3e522cca792aad$export$6b5e57d20078142b);
$parcel$export(module.exports, "lineSplit", () => $5a3e522cca792aad$export$4f60280859794d8c);
$parcel$export(module.exports, "mergeLines", () => $5a3e522cca792aad$export$b5bf5e120f07cbe);
$parcel$export(module.exports, "charAtIndex", () => $5a3e522cca792aad$export$1a93fc5af577aa5c);
$parcel$export(module.exports, "charSplit", () => $5a3e522cca792aad$export$78f5a8ab9b5e7f1e);
$parcel$export(module.exports, "breakTextIntoLines", () => $5a3e522cca792aad$export$38936f7739928807);
$parcel$export(module.exports, "parseDate", () => $5a3e522cca792aad$export$6b862160d295c8e);
$parcel$export(module.exports, "findLastMatch", () => $5a3e522cca792aad$export$dc1d7d42f51764e3);
var $5a3e522cca792aad$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $5a3e522cca792aad$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $5a3e522cca792aad$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $5a3e522cca792aad$export$36cf564d487b5178(num.toString(16), minLength, '0').toUpperCase();
};
var $5a3e522cca792aad$export$f4915efbb94d4d01 = function(num) {
    return $5a3e522cca792aad$export$6ac97d2d1bf41f39(num, 2);
};
var $5a3e522cca792aad$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $5a3e522cca792aad$export$ceedd1b69dcde7a5 = function(hex) {
    return $5a3e522cca792aad$export$207031940e6950ad(parseInt(hex, 16));
};
var $5a3e522cca792aad$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $5a3e522cca792aad$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $5a3e522cca792aad$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $5a3e522cca792aad$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $5a3e522cca792aad$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var $5a3e522cca792aad$export$60bd2eb6e5a75df0 = [
    '\\n',
    '\\f',
    '\\r',
    '\\u000B'
];
var $5a3e522cca792aad$export$634cc0013ed0f624 = [
    '\n',
    '\f',
    '\r',
    '\u000B'
];
var $5a3e522cca792aad$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $5a3e522cca792aad$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $5a3e522cca792aad$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var $5a3e522cca792aad$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $5a3e522cca792aad$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $5a3e522cca792aad$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $5a3e522cca792aad$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $5a3e522cca792aad$export$60bd2eb6e5a75df0.join('|');
    var escapedRules = [
        '$'
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === '' ? '.' : $5a3e522cca792aad$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join('|');
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var $5a3e522cca792aad$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $5a3e522cca792aad$var$buildWordBreakRegex(wordBreaks);
    var words = $5a3e522cca792aad$export$6b5e57d20078142b(text).match(regex);
    var currLine = '';
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== '') lines.push(currLine);
        currLine = '';
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $5a3e522cca792aad$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $5a3e522cca792aad$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($5a3e522cca792aad$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? '01' : _a, _b = match[3], day = _b === void 0 ? '01' : _b, _c = match[4], hours = _c === void 0 ? '00' : _c, _d = match[5], mins = _d === void 0 ? '00' : _d, _e = match[6], secs = _e === void 0 ? '00' : _e, _f = match[7], offsetSign = _f === void 0 ? 'Z' : _f, _g = match[8], offsetHours = _g === void 0 ? '00' : _g, _h = match[9], offsetMins = _h === void 0 ? '00' : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $5a3e522cca792aad$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("ggjMi", function(module, exports) {

$parcel$export(module.exports, "waitForTick", () => $bd6d7b74aa8160e5$export$3b7198a3beef1a5f);
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $bd6d7b74aa8160e5$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("ejAvl", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", () => $a6bf2813aae3d0a0$export$73704d2337848c8e);
$parcel$export(module.exports, "highSurrogate", () => $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb);
$parcel$export(module.exports, "lowSurrogate", () => $a6bf2813aae3d0a0$export$382051c72943492d);
$parcel$export(module.exports, "isWithinBMP", () => $a6bf2813aae3d0a0$export$919ae47c3852aa15);
$parcel$export(module.exports, "hasSurrogates", () => $a6bf2813aae3d0a0$export$d5ab89e7561b44ab);
$parcel$export(module.exports, "utf16Decode", () => $a6bf2813aae3d0a0$export$b89f54f9db637f79);
$parcel$export(module.exports, "hasUtf16BOM", () => $a6bf2813aae3d0a0$export$41e7c15c75b1b24d);

var $7Kmy8 = parcelRequire("7Kmy8");
var $a6bf2813aae3d0a0$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $a6bf2813aae3d0a0$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($a6bf2813aae3d0a0$export$8d3bd4086f36eaeb(codePoint), $a6bf2813aae3d0a0$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $a6bf2813aae3d0a0$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $a6bf2813aae3d0a0$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $a6bf2813aae3d0a0$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $a6bf2813aae3d0a0$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($a6bf2813aae3d0a0$var$ByteOrder || ($a6bf2813aae3d0a0$var$ByteOrder = {}));
var $a6bf2813aae3d0a0$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $a6bf2813aae3d0a0$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($a6bf2813aae3d0a0$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $a6bf2813aae3d0a0$var$readBOM(input) : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($a6bf2813aae3d0a0$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            else {
                var second = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($a6bf2813aae3d0a0$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            }
        } else if ($a6bf2813aae3d0a0$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $a6bf2813aae3d0a0$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $a6bf2813aae3d0a0$var$readBOM = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.BigEndian : $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
};
var $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $a6bf2813aae3d0a0$export$41e7c15c75b1b24d = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) || $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("hiEdU", function(module, exports) {

$parcel$export(module.exports, "numberToString", () => $c983519a4c18aa89$export$f67be9d9b0e25d7b);
$parcel$export(module.exports, "sizeInBytes", () => $c983519a4c18aa89$export$cc6acfd7a782614d);
$parcel$export(module.exports, "bytesFor", () => $c983519a4c18aa89$export$3c7962b7d5fa4e42);
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $c983519a4c18aa89$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split('e-')[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
            if (negative) numStr = '-' + numStr;
        }
    } else {
        var e = parseInt(num.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join('0');
        }
    }
    return numStr;
};
var $c983519a4c18aa89$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $c983519a4c18aa89$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($c983519a4c18aa89$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("hP0hy", function(module, exports) {

$parcel$export(module.exports, "error", () => $cf976b189519155d$export$a3bc9b8ed74fc);
var $cf976b189519155d$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("cbIAG", function(module, exports) {

$parcel$export(module.exports, "values", () => $8df919e62912d805$export$68c286be0e7e55b7);
$parcel$export(module.exports, "isStandardFont", () => $8df919e62912d805$export$f2950432a4491977);
$parcel$export(module.exports, "rectanglesAreEqual", () => $8df919e62912d805$export$93263d7e9f52c023);
parcelRequire("eNCdi");
var $kkdJe = parcelRequire("kkdJe");
var $8df919e62912d805$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8df919e62912d805$export$59252e21bbb61725 = $8df919e62912d805$export$68c286be0e7e55b7((0, $kkdJe.FontNames));
var $8df919e62912d805$export$f2950432a4491977 = function(input) {
    return $8df919e62912d805$export$59252e21bbb61725.includes(input);
};
var $8df919e62912d805$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("eNCdi", function(module, exports) {
$parcel$export(module.exports, "Font", () => (parcelRequire("kkdJe")).Font);
$parcel$export(module.exports, "FontNames", () => (parcelRequire("kkdJe")).FontNames);
$parcel$export(module.exports, "Encodings", () => (parcelRequire("90iSP")).Encodings);
parcelRequire("kkdJe");
parcelRequire("90iSP");

});
parcelRegister("kkdJe", function(module, exports) {

$parcel$export(module.exports, "FontNames", () => $ecc0531572753d26$export$a1e7b970f5a14844);
$parcel$export(module.exports, "Font", () => $ecc0531572753d26$export$89abf52a030e56ee);

var $5JpfH = parcelRequire("5JpfH");

var $3uXKw = parcelRequire("3uXKw");

var $7ybLn = parcelRequire("7ybLn");

var $fCZVO = parcelRequire("fCZVO");

var $cOHfc = parcelRequire("cOHfc");

var $eVbDh = parcelRequire("eVbDh");

var $g9ZKL = parcelRequire("g9ZKL");

var $hgkij = parcelRequire("hgkij");

var $4W9K8 = parcelRequire("4W9K8");

var $gbK7N = parcelRequire("gbK7N");

var $lan6Z = parcelRequire("lan6Z");

var $1zetG = parcelRequire("1zetG");

var $53nEH = parcelRequire("53nEH");

var $fhfja = parcelRequire("fhfja");

var $enbPQ = parcelRequire("enbPQ");
// prettier-ignore
var $ecc0531572753d26$var$compressedJsonForFontName = {
    'Courier': (0, (/*@__PURE__*/$parcel$interopDefault($cOHfc))),
    'Courier-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($3uXKw))),
    'Courier-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($fCZVO))),
    'Courier-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($7ybLn))),
    'Helvetica': (0, (/*@__PURE__*/$parcel$interopDefault($4W9K8))),
    'Helvetica-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($eVbDh))),
    'Helvetica-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($hgkij))),
    'Helvetica-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($g9ZKL))),
    'Times-Roman': (0, (/*@__PURE__*/$parcel$interopDefault($53nEH))),
    'Times-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($gbK7N))),
    'Times-Italic': (0, (/*@__PURE__*/$parcel$interopDefault($1zetG))),
    'Times-BoldItalic': (0, (/*@__PURE__*/$parcel$interopDefault($lan6Z))),
    'Symbol': (0, (/*@__PURE__*/$parcel$interopDefault($fhfja))),
    'ZapfDingbats': (0, (/*@__PURE__*/$parcel$interopDefault($enbPQ)))
};
var $ecc0531572753d26$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($ecc0531572753d26$export$a1e7b970f5a14844 || ($ecc0531572753d26$export$a1e7b970f5a14844 = {}));
var $ecc0531572753d26$var$fontCache = {};
var $ecc0531572753d26$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $ecc0531572753d26$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $5JpfH.decompressJson)($ecc0531572753d26$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $ecc0531572753d26$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("5JpfH", function(module, exports) {

$parcel$export(module.exports, "decompressJson", () => $42c4be4670940c1e$export$134b8d792d6efd14);
$parcel$export(module.exports, "padStart", () => $42c4be4670940c1e$export$36cf564d487b5178);
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $ckCqy = parcelRequire("ckCqy");
var $42c4be4670940c1e$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $42c4be4670940c1e$var$lookup = new Uint8Array(256);
for(var $42c4be4670940c1e$var$i = 0; $42c4be4670940c1e$var$i < $42c4be4670940c1e$var$chars.length; $42c4be4670940c1e$var$i++)$42c4be4670940c1e$var$lookup[$42c4be4670940c1e$var$chars.charCodeAt($42c4be4670940c1e$var$i)] = $42c4be4670940c1e$var$i;
var $42c4be4670940c1e$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i)];
        encoded2 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $42c4be4670940c1e$var$arrayToString = function(array) {
    var str = '';
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $42c4be4670940c1e$export$134b8d792d6efd14 = function(compressedJson) {
    return $42c4be4670940c1e$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($42c4be4670940c1e$export$83edfd8fcc66ec17(compressedJson)));
};
var $42c4be4670940c1e$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("ckCqy", function(module, exports) {
// Top level file is just a mixin of submodules & constants
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $8fa5292818130bae$require$assign = $9CLQF.assign;

var $2wbN5 = parcelRequire("2wbN5");

var $3OYOJ = parcelRequire("3OYOJ");

var $hf4Xu = parcelRequire("hf4Xu");
var $8fa5292818130bae$var$pako = {};
$8fa5292818130bae$require$assign($8fa5292818130bae$var$pako, $2wbN5, $3OYOJ, $hf4Xu);
module.exports = $8fa5292818130bae$var$pako;

});
parcelRegister("9CLQF", function(module, exports) {
'use strict';
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnUntyped);
    }
};
module.exports.setTyped($701cc75d47025217$var$TYPED_OK);

});

parcelRegister("2wbN5", function(module, exports) {

$parcel$export(module.exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export(module.exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export(module.exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
'use strict';

var $lGf86 = parcelRequire("lGf86");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");
var $1d57b756249bc6d3$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d57b756249bc6d3$var$Z_NO_FLUSH = 0;
var $1d57b756249bc6d3$var$Z_FINISH = 4;
var $1d57b756249bc6d3$var$Z_OK = 0;
var $1d57b756249bc6d3$var$Z_STREAM_END = 1;
var $1d57b756249bc6d3$var$Z_SYNC_FLUSH = 2;
var $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION = -1;
var $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY = 0;
var $1d57b756249bc6d3$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    if (!(this instanceof $1d57b756249bc6d3$var$Deflate)) return new $1d57b756249bc6d3$var$Deflate(options);
    this.options = $9CLQF.assign({
        level: $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $lGf86.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
    if (opt.header) $lGf86.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $iC2HB.string2buf(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $lGf86.deflateSetDictionary(this.strm, dict);
        if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d57b756249bc6d3$var$Z_FINISH : $1d57b756249bc6d3$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $iC2HB.string2buf(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $lGf86.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $1d57b756249bc6d3$var$Z_STREAM_END && status !== $1d57b756249bc6d3$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d57b756249bc6d3$var$Z_FINISH || _mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($iC2HB.buf2binstring($9CLQF.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d57b756249bc6d3$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d57b756249bc6d3$var$Z_FINISH) {
        status = $lGf86.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d57b756249bc6d3$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH) {
        this.onEnd($1d57b756249bc6d3$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    var deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $7gAmB[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;

});
parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateSetHeader", () => $fc8941aa2060205a$export$1cd50f7b2515ba19, (v) => $fc8941aa2060205a$export$1cd50f7b2515ba19 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $hx6dX = parcelRequire("hx6dX");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $7gAmB[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $9CLQF.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $hx6dX._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $9CLQF.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $9CLQF.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $hx6dX._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $9CLQF.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $9CLQF.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $hx6dX._tr_init(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $9CLQF.Buf8(s.w_size * 2);
    s.head = new $9CLQF.Buf16(s.hash_size);
    s.prev = new $9CLQF.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $9CLQF.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $hx6dX._tr_align(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $hx6dX._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $9CLQF.Buf8(s.w_size);
        $9CLQF.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $9CLQF.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("iC2HB", function(module, exports) {

$parcel$export(module.exports, "string2buf", () => $d8cddf31faab2448$export$7a4c1b2f775b5a9f, (v) => $d8cddf31faab2448$export$7a4c1b2f775b5a9f = v);
$parcel$export(module.exports, "buf2binstring", () => $d8cddf31faab2448$export$a751fe64af8a9a51, (v) => $d8cddf31faab2448$export$a751fe64af8a9a51 = v);
$parcel$export(module.exports, "binstring2buf", () => $d8cddf31faab2448$export$1d1a7119601ff18c, (v) => $d8cddf31faab2448$export$1d1a7119601ff18c = v);
$parcel$export(module.exports, "buf2string", () => $d8cddf31faab2448$export$49a50563f377746, (v) => $d8cddf31faab2448$export$49a50563f377746 = v);
$parcel$export(module.exports, "utf8border", () => $d8cddf31faab2448$export$53dee3f58a714214, (v) => $d8cddf31faab2448$export$53dee3f58a714214 = v);
// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $d8cddf31faab2448$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $d8cddf31faab2448$export$1d1a7119601ff18c;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $d8cddf31faab2448$var$STR_APPLY_OK = true;
var $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $d8cddf31faab2448$var$_utf8len = new $9CLQF.Buf8(256);
for(var $d8cddf31faab2448$var$q = 0; $d8cddf31faab2448$var$q < 256; $d8cddf31faab2448$var$q++)$d8cddf31faab2448$var$_utf8len[$d8cddf31faab2448$var$q] = $d8cddf31faab2448$var$q >= 252 ? 6 : $d8cddf31faab2448$var$q >= 248 ? 5 : $d8cddf31faab2448$var$q >= 240 ? 4 : $d8cddf31faab2448$var$q >= 224 ? 3 : $d8cddf31faab2448$var$q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $9CLQF.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $d8cddf31faab2448$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK || !buf.subarray && $d8cddf31faab2448$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $9CLQF.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$d8cddf31faab2448$export$a751fe64af8a9a51 = function(buf) {
    return $d8cddf31faab2448$var$buf2binstring(buf, buf.length);
};
$d8cddf31faab2448$export$1d1a7119601ff18c = function(str) {
    var buf = new $9CLQF.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$d8cddf31faab2448$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("9WDto", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});


parcelRegister("3OYOJ", function(module, exports) {

$parcel$export(module.exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export(module.exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export(module.exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
'use strict';

var $fzvBq = parcelRequire("fzvBq");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $hf4Xu = parcelRequire("hf4Xu");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");

var $9t6AE = parcelRequire("9t6AE");
var $2c8537a6b47169be$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    if (!(this instanceof $2c8537a6b47169be$var$Inflate)) return new $2c8537a6b47169be$var$Inflate(options);
    this.options = $9CLQF.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $fzvBq.inflateInit2(this.strm, opt.windowBits);
    if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
    this.header = new $9t6AE();
    $fzvBq.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $iC2HB.string2buf(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $fzvBq.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $hf4Xu.Z_FINISH : $hf4Xu.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $iC2HB.binstring2buf(data);
    else if ($2c8537a6b47169be$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fzvBq.inflate(strm, $hf4Xu.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $hf4Xu.Z_NEED_DICT && dictionary) status = $fzvBq.inflateSetDictionary(this.strm, dictionary);
        if (status === $hf4Xu.Z_BUF_ERROR && allowBufError === true) {
            status = $hf4Xu.Z_OK;
            allowBufError = false;
        }
        if (status !== $hf4Xu.Z_STREAM_END && status !== $hf4Xu.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $hf4Xu.Z_STREAM_END || strm.avail_in === 0 && (_mode === $hf4Xu.Z_FINISH || _mode === $hf4Xu.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $iC2HB.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $iC2HB.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $9CLQF.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $hf4Xu.Z_STREAM_END);
    if (status === $hf4Xu.Z_STREAM_END) _mode = $hf4Xu.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $hf4Xu.Z_FINISH) {
        status = $fzvBq.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $hf4Xu.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $hf4Xu.Z_SYNC_FLUSH) {
        this.onEnd($hf4Xu.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $hf4Xu.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    var inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $7gAmB[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;

});
parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateGetHeader", () => $b562a383a327bea1$export$6d4647cb9e1c75fc, (v) => $b562a383a327bea1$export$6d4647cb9e1c75fc = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $9CLQF.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $9CLQF.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $9CLQF.Buf32(512);
        $b562a383a327bea1$var$distfix = new $9CLQF.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $9CLQF.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $9CLQF.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $9CLQF.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $9CLQF.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $9CLQF.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $9CLQF.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $9CLQF.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("hf4Xu", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("9t6AE", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $6e4bef2851e6b301$var$GZheader;

});




parcelRegister("3uXKw", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("7ybLn", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fCZVO", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("cOHfc", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("eVbDh", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("g9ZKL", function(module, exports) {
module.exports = JSON.parse("\"eJyNnVtzG0eyrf8KA0/7RMhzRIq6+U2+zMX2mJYsEuJMzANEtihsgYQMEITaO/Z/P41CV+bKlaug86JQf6uArsrKXNVX8H8m3y9vb7u7+8m3k4t/btazm+7o+PT0xcnRsxdPXzybPJr8dXl3/+vsthsa/L1bPHT386vZN98tF9dn7xfzPzbdrslmseAmR7smR9Bmdjtf9NxqEKbd/Objbve7Dwzb/7ifLeZXr+5uFkPLb45PBrL+6/xLd/3b/P7q4+Tb+9WmezT5/uNsNbu671a/d7vP/vjlvru77q7fLG9nd2Onv/tu+WXy7b+/OX5++uibk5MXj46Pj08fvXx28p9Hk/Oh8Woxv+t+W67n9/Pl3W5Xjx+D8Pbj/OrTXbdeT759OvCLbrUuzSaPH5/85fHjx8NOfl0OQ9gN5/vl5361G8XRf139n6Pjly+ePtr9+7z8+3L378vH5d/nR6+ul++7o9/79X13uz76x93VcvV5uZrdd9d/OTp6tVgcvdl9z/roTbfuVg8D9YDO10ezo/vV7Lq7na0+HS0/HP0yv1ve95+7b4ZGi6NXfzua3V3/3+XqaD58wXrzfj2/ns9W8279l6GzPw67up7f3fx+9bErc1B68vv98JHZ6rqqQ8PvZ5//Pk7J8+MXjybv6tbTJ8NcvFpf7QK9GsUfOtv+5uTx80eT3++v/z6dfHu8E4f/X+z+f/p4P1//7O5X86shoP/+n8n03eTbk+dDo1+Hrqw/z4Y4/u+jPX7y5Mked1+uFrNb46fDPBb+x2Y5xOv9wpSnT5/tlbvN7fvdRN3cZe16uVjMVsZfDBNT+OdudbXL/yo8PznZC7PbQVoP8THJOlx6UGY89/rzbNXdLboPLYk+VrsxW+++cf3JO/5iHO7nxWadu3A1lO0s7+Jj//ljd5ebD0OZL8VI1ovZ+mMO1p/dapnp8q7L8H4rWt5/XHWi7YflZiXo/EG0Xc+/CNg9dGJuuxBTT4f5nUirq+VieZfxurudR8lmYLGzgUS7PzazRcY3q24oZx/ms+PjmjTdulhNVV4+fzrOvci+Vxl9l9H3Gf3ge372fI9+zJ35q3+wpsLf8nf9PSfMP3KYf8of/Dnv8RcvvRryf+YP/pr7dZYH9Ftu9Tp/15v8wd9zv97mD57nD174rJ2OEz3Nrd5ldJn3+K+cfO+HxexTdx9sw0L+ftBinfLnoqdYKs7WV/P51Xx1tbnNs7bZ2fZ6WH+6vMfib6Ez9rFZHs/73Ooqt7rOrURxfsgfvMnoY+7yPKP/znv8lFt5CduScJv3eJfRMqPPouqz1QsLXOdI3Ofv2uQPPuRK2OZWwkl7R7vjnmL6uau7/IqJcPLicc3KVaP9oWy8ny+um0v99XIrzD2szh6x+3Kc5slxXCvuw+7AEH3Wx6zWjg+L5Wou+LprfMvVZjUs41cewJMnWDbreTl0TdGtRy26rG4280G5Xd7rI4edXL74K3IMvSXOh7lg4vhpOJSThwPXs5ubTqTtnuOhGB1w7OauW3Wi9odjodnNavYZTO1pzazhdKITPujhfT9bH4jwYXWljxVsAqI+nBSMnx8Oseef1/O1kIax3n9cbsKxYlr2Q3L7zK1mD6IeZlebe3XoUrz8w6L7krVGZd3OrlbqcOf9qlM7vl7ez65Cxbk0H2YSA2DKCuvQO9tdDyFVx6ibu5vZanO7mG3EbpY3w2HmJ/F1MxwHzMttyFkXXvlhz5PnI1uurj8Mx3nhwNCPUOIi6wcgkfsezmAPz57aHm4Hp9sscBe2sszEYnu9K/r1Wixgi7hjX3kityOSpRjUUJ/DKfGQ9+Ic4h9pSt0JYgb68h/zxpcmOan+dXH2/Ogo96AuF9fzhzkktH8k9swPmEVxeLcbHzo/9KG+EYN1OfeiMoGh5q/0/YVScdyeiBnVg38m9s5ngj7gZwFpJ37OMHgEnIScVCdWA33+5HkVx6seYlfkOr52xjzwUeq4/Ko64OXRytFoqn6kL4djp1Ktb4vGCuFMVgkZooe5Zk/0w9e499OX9dRz+Wd3dyMy903chZ/FqUF6chwskkOZ+4oXEjuabYz1isfq5z85chbVtx+XKzGqM9q7h4GqwE70qOBP6yJGYbNqoh14xPTiVi5wrDflKGcl+htT0KPY4tFWzQRvN4v7+edFL/rVKP+3cYCWSMPx1v18trief/iQ56pvW8OvcT+esCJZvDYOptmBVactXTXGe9eywVbG/BoD5Ish1T9efhuOGPAanJ0CrZafujs8ETJzXHU383U89PUSjZMNy3Gui3qosd4MVR3ORzzYdAxphdmIzLKV6v9qfOBfVOGnL+uxa7nSFa+DWZx/vP+Y4fdNA1wo37Kx3DdMpmuuji3hVevw4UBWxgD7+XKrNHjf5gqtGWktPa1ldN3ac65j2/fBwxJeMetxQbe4FwZ+H0zaPXG7POCIqWv2dbcbMZLGGr6Ux5leC3zwY1ef4hHOiyen4ONDAq+GRF7n7/ud8/W0Tv6isZD8fHD9/SVOnJ9K2H0dZYrJFtwyYpict2r8l9hti8MQtY+zBSwNtch3pyaxwn0u1BJgvhwPmzzVvjKBjVLoWgO6iWaKAxqnVc2qPhv5XR4gWgbLnltCXA820amMbSz531MnbOEitzk1O7+eXymj/SF+ERyYHTrc/ZUOa627jXl7czivD+7rVeM7XzVNOp4O2AzE73EjPnBA+WNruad9+yVieXZnB2TxSMC+7WAp0ASZXx7c02J5s5vvu6UI97Jtppu8jtUMGr6qUck3Bye3g5XcY95I3zu5jtvFnbt80Oye31ruftzs7kb+59Hk525199tsvtrdQ/735NXubvXk0Tenj//zaNzau0dA+35GNJo6wr8NW099a+8qAeHAUDgL33OWu4BLb+A2VYHu6z+g4DxBGUMW2P7qUED7wkH0Omy9HbZe+laNGaIwehfOQyzO6+gBhdEDh9EDraMHRKMHxUYPbKzrwIqdILkYtl7Y1nTYemZbl8PW8bFv1iEhg74D3gybT3yrfhBQiAVw+D6gNRaAKBagWCyAWSyAjbFw8hAyYRu0Pm7lEfW552MjLE1DVBzGqUidc6VWBcrVENWscVm4VT3L380lbFzVsYm5mE2iijauy9pkrm0TqMCNU5VX/jojqHdDVPTOVeVX9TxHlD3AuDICE7MbmESWYFz7gslsDiawQ5gQbaJi8IqKwDAqQtcwxtZhgvCPqoGJGKK6M67sxMR2ZbKxGNfuYjJbjAnsMyZEs6n4ISfkNrfqBWoEQrjQaAboQoaovo2TCzlnF6oKuJAhciHj0oWqepa/m13IuHIhE7MLmUQuZFy7kMnsQiaQCxknF6r8dUbgQobIhZwrF6rqeY4ou5Bx5UImZhcyiVzIuHYhk9mFTGAXMiG6UMXgQhWBC1WELmSMXcgE4UJVAxcyRMVnXLmQie3KZBcyrl3IZHYhE9iFTIguVPFDTshtbtUL1AiEcCEMDVpR5FTpUSRTIpGdKchgT5GTR0VRGlVoctbYH1tWFJVvxRbZvKJODhZFbWOxDXtZVMnQokiuFsTXDQ7+FjmZHInK6UKT88a8sOdFURlfbJHdL+pkgVHUPhjbsBlGlR0xqtEWgwbeGDgYZODoklFgq4yq8MvQAEwzcjKMKCr7jC2+4itspFHUbhrbsKVGlX01qtFcg/bQqItto33f4ofiJ1zXCXouUjIqlMhvg8RuCyJ4LVJyWpSkz0KDM7kf9liUlMOinv0VVXJXlLS3Ygt2VtTIV1EiVwXptaTgqEjJT4Ok3BQanMvYs5OipHwU9eyiqJKHoqQdFFuwf6LG7ola9E5QwDmBgm8CRddEzJ6JmnBMkMEvkVK1o6S8EvWDXsA+iZJ2SWzBHokaOyRq0R9BeZAZvpVte03bkRKuOI4eLdEQmYpxMkPn7IRVARs0RB5oXBpgVc/yd7P1GVe+Z2I2PZPI8YxruzOZvc4EMjrj5HKVv84I/M0QmZtz5WxVPc8RZU8zrgzNxOxmJpGVGdc+ZjKbmAnsYCZE+6oYvKsiMK6K0LWMsWWZIPyqamBWhqj+jCubMrFdmWxQxrU7mczWZAL7kgnRlCp+yAm5za16gRqBEC5U+4o25Iwq3AUyIhDYiUwCK3JGXuSCNCOTz8T3sx25oPzI1WxIrpEjuaAtyXX2JFfIlFwgVzLhtWDgS87ImEBQzmTyuYgve5MLypxcze7kGtmTC9qfXGeDcoUdypVoUcbBo4yBSRlDl3LINuWK8CkTwaicUYG6oKzK1QP1y2blgnYr19muXGG/ciUalvEHkatb0a5XrBUT4Vq1Y+hazsgIXCDXAoFdyyRwLWfkWi5I1zL5THw/u5YLyrVcza7lGrmWC9q1XGfXcoVcywVyLRNeCwau5YxcCwTlWiafi/iya7mgXMvV7FqukWu5oF3LdXYtV9i1XImuZRxcyxi4ljF0LYfsWq4I1zIRXMsZVagLyrVcPVC/7FouaNdynV3LFXYtV6JrGX8QuboV7XrFWjERrrUaf9HDd1cJmUDF5FeG2a1GAbyqEnKqiqVPjeJZ+l72qIqVQ1Ut+1NVyJ0q1t5UVXamysmXKiZXGvHrRMCRKiE/MqzcaBTPUwzZiSpWPlS17EJVIQ+qWDtQVdl/Kmf3qTx6z0jBeUYCvjMSdJ2K2HMqF44zSuA3lVBlVay8pmrNmmOfqVi7TFXZYypnh6k8+stIH1LWbVObPhM9euEqY66jrRiiwjVOxuKcnaUqYC2GyFuMS3Op6ln+brYX48pfTMwGYxI5jHFtMSazx5hAJmOcXKby1xmBzxgio3GunKaq5zmi7DXGldmYmN3GJLIb49pvTGbDMYEdx4RoORWD51QEplMRuo4xth0ThO9UDYzHENWecWU9JrYrk83HuHYfk9l+TGD/MSEaUMUPOSG3uVUvUCMQ2YW+G+iruBU/W1B1DEAipIXrPcRAFkRBKoziU1gITSG1fB3tquvYtyydHIXuAscEc1q7C4imHBQbCDAbCLBxIHvywxj3U9+KbvoDxh2Q8NYfKO5Ao6P+EOIOzLoLbOwukGibP4wl71vTsLUr9Oe+VUcHCLrsdP97bHVyd2T8yTVDo/9i+AxRDI1TII2raJqYQ2oSxdU4B9cEjrAJMcyGKdaVX2Q0zQhCb4jibzxPQpVoJipO01FeCIzTURFPR+U8HZXL6aiimI4q8XRUnqajCmk6qkDTUTFPx8gvMppmhNNREU9H5WI6RomnY8Q0HX8dZ+KFb9VdAarxBxRCDxw6BLQGHJDFGpiFGdgYYSA1uI524zzxrToCQHUEgMIIgMMIgNYRALIRALMRABtHAKSOwFGdrePHhmymRvbTOFUnvhUH+hNOFSAx0J9oqoDGgf4UpgoYDfQnmCogcaA/wUCd2DgdbeJWHuamMaaNHNMmj4kPyUARo92I0W7CaH+e7E95nvhWPC4qSBwEFZ4OggqNB0EFyQPJotDhUWH1fAZQPBbaoXLc8tS27FjIUT2BQRQOj5zj4RFQe000YDtqcuTHRs782MjYcjcC37JIO4qRdo6RdmqRdsSRdsUj7cwi7cgibWgT4r7J+aHOO36eqFOOnyfpbONnkdWgiPzg04ufJ3xmsSO9LVBlKy7RBaWFNryLH+qCBAoBqSoa1CQHhhpQjEjV4aJGHDmSqchIpXqLKiQ/CVSFpFJBsipqk5rkMuUGuWKpBRUvqVzHJHNJRxmqmwQqdFJVzVOTXP7UgJyAVG0K1Ij9gWSyClLJNaK6aSUSewmpXy8k4TDU4GAhNXyHGh0upORGJEdjiiJ4FAlkV6Qm5/plgtfwyla8fLdH4srdTtgd3o+XnXabUztG3W2VC1knvmklDgzr0nH8Bc1BOo2S4H6N55dJurzzy0Rd2fklv6PqiIJw8B1VUzEc+Abni4gwMPkNThZEiKrWilPQW2KfA8Fha7/1+EvMK4ggCRRHVlU0YxuMaVQgslHA+JLCUSZZxDq2aEVctDrcpG+FkuegXcBjg9FecQ4MUfSdq7hXFSNeGcS6IoyyMY6vCSKyVWvFNOgtsc+B4AgaT7EbjtPKCeZT34q3HAqKd4MKEjcgCk/3HgqNtx0KolsKhdHdhMLCjYRC6nrp6K2Z+RnOOaIw3S5chO+Zhq13Ycuv0JxN0sWZs4m6LrOj9dzXd2nnviOqFgPTYIjmwjhNiHE1KybmqTGJ5sc4T5IJPFMmxOkyTHOG6w6FgWevse6QepG/e5rRu4xgWtNCxDxPcJVolivmqQ4vU8F8R06THkWa+Siq6Y8tcg5EnRIhipwNUeWUiGrMi6hRcqT3OlX0OE0Ovdepmlw09jdt8HcNDvmjX2+UYs6koFM6BY1zCl5EgYxCSvmEEmUTSiqXUM+ZhCrlEUqcRahxDqEWMwgVyh96hy3HiXOn/Q5bbnAh9zOV9J2kkDHq1S4h5WwBlXIFFM6U+qYApIkhyhHjlCDGVXaYmFPDJMoL45wUJnBGmBDTwTDlAr7sQ2HgLGi87EPqRf7uaUbvMoJpT+/GMM8TXiWa7Yp5quO5Oc44KzTxLNP8s6zSgNvkbOAWlBQsc26wzinCeswUVilhSH7bjCmnT5JVFlGji+Z+p03lXVOBDGOFEo3lnG/UgtKOVM4+e7of8s4ZZZwLlGsuqCxzNeeXa5RZLnBOucLZ5ErMI+eUQeFFHo4IZ03rRR6WL8T3TwV7JxjkRX7fJQk5F0yjLDDO819PN2H6DdHsG6fJN67m3sQ89SbRzBvniTeB592EOO2GadbxGgSFgee8cQ2C1Iv83dOM3mUE050uSjDPk10lmuuKearrU2Mw1YZoqo3TVBtXU21inmqTaKqN81SbwFNtQpxqwzTV+OAnhYGnuvHgJ6kX+bunGb3LCKY6PSfJPE91lWiqK6ap/m2c5fHJhN9whpHV2UVGT9a5EB6tc+zP1jmDR+gcwjN0Du0hOkd1BoH5czJlK14xKyg+0ViQuKtSeLquVmi8f1IQ3Q8pjG6CFBbufBQS7yr+BvM2Xk3codigy4Oy+4iI9KA6OahwmxBwHmsnxtqJsS5Ditn9PkDika/C062cQuODXgXJh8OLQk9/FRYfCS8oPtv1G1bHGP3XE3zEtGzFR0wLEo+YFp4eMS00PmJakHzEtCj0iGlh9IhpYeER09eeRj6MOrQ9eTPZ382HrfhsTkHi2ZzC07M5hcZncwqSz+YUhZ7NKaxOEaD42NGb0Z9hq2Y+ouDKLpzHrTze88Z4z+V4z/N4eSJBEeM9p2eR3sBEOvFl5M0EHzJ8M64Url3GpfkNrQ8jrVcxYfYNUUiMq7iYmINjEkXIuA6TyRwrEyhBjFOW4HVoRpQvjevQpJ4L1IiVzCET27HibDJ+OFYpr0zg5DIhZli+1G4Icg2vq1Mrzjp1XX2U6oPEkHqGKJzGVThNzOE0icJpXIfTZA6nCZR6xin1Kn8rEKWec5V6VT0XqBErmXomtmPFqWf8cKxS6pnAqWdCTD18tJ0yBFIPH22nVpx66tH2KqXn2E6kwKE98BybbiLCrJ9j02oj5I3n2LTMqaqfY5Pq26bAyXvoeQfZ5rwpHIy5TurY5GsxTwke1f+fmOdkj3JK+ShT4qcHQWSWYhGk50DkJ1JBNJ8C2TcYpruc/b30rfoNgOoZE6AwKcBhD0Br+AFZOIFZDIGNgQNS89eRv6D6FksYkDjVeEvFCjSearwVZQkKnWq8xQIEFE81dmh3jvfCt+K7GgXFdzUKEu9qFJ7e1Sg0vqtREL2rURi9q1FYeFejkPiuxg5dLRc08nru6m12n3jmW3WUgKqxIMJRAodRIoVTV8B18IBs8MBs8M4+9p8/duWc68TYMoxqmWdr2ZiapZyaZZ4aPp0FRUyanc4CyjNkp7OOVnErD2QVvdyFdXc7z1O+CaW4yfaxaXjFRnrFJnsFP5IKinCRjXCRTXKRbZjwPm7lJO1z5uG7iC8JURDSu4jMVYTUu4gsUazyu4gscGz4XUTG5LV4/H5KiFxXH7+zmP03Hb8z106cj99ZIE9Ox+/EwcUMUa0YJ582rhzBxGwLJpE3GGcbMIEN3ITo4obJKPy1z4UKHZl6xV2uBbZ34+TxzoXRm9iuOWX5ppHvG2fzN4FXgCqkZaAKyxwMXhCMH8oBsTSY1MiBxiJhcitFeLkw3kgFXjgqXwnUGLpeR6oqFpMqwYpiqOGocm0xse2cvMoY10uNyS1jTYuOCdpYtznbeoEa5aRWo3Cgj2tSFDiOUeX1Kaoy1rGJiHhswHGPagpvlFOQo0yhjiKvZOlywKkUeFU7cDlANxErnL4coNXGate4HKBlXvn05QCpou1HgYs+qrwiRlV6YmwinDE2YH+MarLBKKf1Msq0akaRDTOo7GgkxnU0vkjXquW0pkaVV1ZS1foam3zNS+RaG1vwihvVtO5GOa2+Qc5rcHzJrhXOtB5H9esZqNbm2OBgBrbW6djocJqmNTuqBxMxrd9BXTWFg2FrrOihjVrXQwNc3aNwcG3SK31s8rXVJ636UW2s/bHR4SUqHwdE+dAStW3VQN8UDlpDPko4n+ATPed4PAAoPsdznlZ+4Ol64jmu8YDomZ3zsJoDC0/qnOO67aja6BMj9EMo9XoyjrXx6o1zGvWhV29czONvvHrjnCPRevXGhRiTxqs3xik66ZWVkTdeWSFOwTr0ygqJKmxfeWWFdArgwVdWSOVQHnhlhTQKqnx7Q0WQwyvf3giUQtt+eyNIKqwH394IKoX0wNsbQeNwNt/eCAqFUrzakGPFYcyvNjiiADZebXCuQtd+tcElClrr1QYXOFz61QbHFCh+JYBCwSFqvhKQFArY4VcCkqzC99VXAlILCuZXXglIOof24CsBSaVAN56F13HlsItn4YFRqFvPwoOgwnvgWXjQKKTNZ+FB4TA2noUHTqFLj45zVDhc9hPbEC5nFC4XKFwuqHC5msPlGoXLBQ6XKxwuV2K4nFO4TKBwGedwjb8cDMGqhEJVMQWqYhWmquUgVYVCVDEHqHIOT+UxOJVSaEZMgRkpheViDMkL34qnKxcYCkDibO+CQgA0ntddhKEDo2sIFzBkIPEkbYf8Z5nLVpy5guJZlgtncSumQkFivgtPc11onOeC5O8FF4Vmv7B6fgooTu8O7ab1mW/FU5aCaggAiesWhadTmkLj9YeC6KJDYXSlobBxxoDUETiKp7MXk/SI9g7FQXd5cuxKDSI9X52cr3AhBnCexk5MVkdlumN2ccWzc3dB5aVvxVPygsR5eOHp5LvQeMZdkDzNLgqdWxdWcwxQvJR7MclPbe9YvhCxo5sws5ucjZtG6m1k6m1y6vFlBFBEUm5EUm5CUk5H14Ot2Ospuh4gMZApuR7QOJBpcD1g1N0puB6QWEPTCT5wN0XvAiQe85qSdwGND3RNhXeBQo9uTdG7AMUH46ajd536VrwZMEXvAiRuCkzJu4DGy//T4F3A6Fdrp+BdQOK1/Cl41zEQvAo9Ha1r/yNlU7QuQPZ2CaD8C21Tsi6k+HaJ4/gTbdNgXcD87RJjZl0+1GVIuGUukmWjIpayIpa5Iti6QBG1YtYFKBcGXaidknP5vO2c69TGb84FKCaec0w8p5Z4jvhmkyueks48JZ3VlDTSh3rqc933qb4vR8Mbf6npEh0Pmb2RBiy+iAMCvokD2F7FAeZv3AD0V24A1nduANkbac521vfct+KLfJfJ+oCnd/su0foA0cSBYoMBVvMSUO22o5ktsJdofYDizeLLZH3A07HBJVofIDoCuAzWByxcR79E63NUS+gpkFv8ZebL0fte+FY8n7hE70OUzycuyfuQgvcBjqcZl8H7gNFpxuVodDAEczpk6tXMS/I6xPRq5qVwO5T4rc1L9Dtk9Ibm5ST/GPYlWZ7P1yY22oiBbloD3eiBbsRA2fdQUgN150MYX0+9tOv0YAbpJkQS2NP0bYikCndLNyKSkHwu34pICjleuhnBAnhfeseMuXJB9Y4ZS+SHrXfMWGZnTO+YMSePrByM0hC5pXGyTOPKN03M5mkSOahxtlET2EtNiIZqmFzVbzKFUuV7T1wDYHOGyGmNk906F55rYjZel7L7mkYWbJx92AQ24yosxaCTLZsgLctU4VumsXmZ0HAw05ONmcKmbQI7d7qTyILw8CptRPPk5iYcjI/yddNa8Wk5vOnN+GSvN4UMn275VSdU9/yUxs7fvOunGgj/V/f9lJZWAXnnT4m0Fqh7f0KDFQEpLQooqXUB9bw0oEqrA0p6gcAWvEagRssESrRSgASLBVJaL1CiJQMltWqgnhcOVGntQImXD9R4BUEtLiKo0DoSbgYHxxC3iUWBgWkjpTUFJVpWgiRWFtTz4hLUvL6gTEsMSrzKoMYLDWhLHZK03KAmHRUbCFNFmX0VtYa1YpPkrijyAoQar0HqUQGhiZUI1I3+UFqPUPtaANWqhPKBALbWJmxyKIB5hUIxLlJDOU38V0LKlv+uj6F4/8mF3d8k3P+Vh93WNmz5dZ6yFa/zFJSu81TXwx4Zom4Zl32rKnSwom1Gfe4B99d47vTYMey0Ieq0cdnpqkKnK9pm1OcecKeN506HZ5Wg55FT96MoxxCawEAC3zZ43+gfjyuKeXCQ7jA0pDQwlOSwoAEMCuhW0l72iYeDUh5MfcwHRmKIhmFcjqGqMICKthn1uQfcb+O50/bYB/TaGXXbBdlvk6HjxraC9aIf3HcXcuftIQzovDPqvAuy8+HP048dDX+enlkv+sGdl3+eftTGByWg65VQxyuW3Ya/ej12EP7qdSR92jd3V/zV61Gpv0AHvTVE3TUu+4t/JHfsHv6RXEJ97gH3Wf2R3L30fqAL23PZ8uMEQ6qXRfCDm4o24avp7+G9T8cawGXf6O/hvRcHFKDQjdD34fABWPi1ivdjpH2rj1t5DDmOVwP1QOy2PgXtk/oBkasx+LAV93WVgw9CvMV7NXbce9DHmbyijo+0Hgt8zAiGYEj2pqoLgWhExg9/EY0Nj22okzxKdWwzSvbia0YwVEOyh1VdCERDNX74i2io+L4kdZKHqt6XrNJwWrdYzGiwBnG4DnU/TV9IyIN25WtfxwM3pVddToN3JQ9/f3I0WX+eXe0+cjrScsKd/2zNSZYbWvzC4fRscm07LVtX+79dC8hN/Dr493UdqG/ZCB3h0PZ03APu2BDtvfKH/OltRr1A1CPjqVu7ihuDtN85Xko9MfIQPrANW1/CVh+3YkdSfe8pXacfO8IXdk8ifsif32b0JaNeIOqm9KK9RD8+MPaVX08/ifghf36b0ZeMeoGor9JMRkm8JlI7rN4SORHaQ+Prtg3+pcH7FufhtM6qRj1fiBtHJK7BnCTlQX7RVtIvkvaa0igaJ1NV9WtzPAhQeBQgPejv2mr8ReO+gXkoqOWx0Gsh4zj4rZCTiB/y57cZfcmoF4j6q84HR4lfDxg7m94OOCH+IL5iK9gXwXrFqMvyNHDU+Bn9sc/pEf0T4g/iK7aCfRGsV4z6LM/+9tqHCV4kr6SLW/GooKB6LRxR/gHjwtORw57in5R1HH/XuCD69eLC6NeLd2xpRzllKx4yFSROigpPJxqFxpOiguRJUVHopKiweOhVUHw69MMkXIKuiA6dnkQh0Jv9XB37xjhsIONMIYE4APYwIPRpAjrGBkgNAKA6R478pF1cXmheWqjtYKRG4nANxzE7zgM3LY3elRQCk2IcDFMwjFNE8mXgm8Zl4JuDl4EjhDDpH4HQYgzZgZ+A0C1S+No/AKEbxFA2fv5BqxTWqN60wsQhJlUFuv5JzRPfijbDf0hzTz+N7rR33E/oToCifTpPlv0J3QkQ3wNyxR3UmV1VcmR3yvYo/0qGFmgsh34lQzfJI2z8SoZW9bhbv5KhZYpG41cy9uoirM6LsAYv8uq7kOvuIp8HLfJJz6Jx0rNon/TEKwL49fkHIbRAu2r/IMTYoP79l21GvUD09ervz+6l2wle6SxbsdoKEot64akKC42LekFyUS8KLeqF0ZXOwsKVztsJ/tndWxwxIOjdnt5N6k1l24pHXXdpsMDTIdbdJNwwNiT/RsTdJN4eNkZHWXcTvBlcye7g9dS23B7FPRR99+QuPuEVEQWh9XxXFHM4xNNdkevAqGe7osAhyk92BQzByreS71K1M8+xw9+7OyZEsdO/d8dijl36vTvmOnb59+5Y4Njx790RhtjhJRcKBMdOXXKpUvpNoWMpcBwP/KaQbiJiqn9TSKuN+DZ+U0jLKdbyN4WkiHFPS4gMZZqD5hIyNqj3zmAODFH0jau4m5gjbhLF2riOsskcXxM4sibEmOL9xtOI+hwIjmD75uJygnfWlmEd3m35H25ahl0t816WegfoXYRgV3gR90ls1ecP8p7bDrdMVzgVh46kK5xPRPu+8T3cr688NwKHrtg1ebkSKXRLPvsRKHXp4LMfS7xqRwi6glftnsRWff4g96D9FAcdi2MvSIHOkAJ9IqVvfhv3kOXc0XC9kBl0LlwvfELtevFZ7sqBx0bqWQf2IR9MG4Ie4PE1fZD3r46vRwktiRDsviLYfTauZcO4lm3j+jzB84PP+FlA6aygXjBr3WGMekuM9xjpq0x94eqi+3Bfv3T//29On5laP3gdP2S43jMUmt/wjTjGMWrqpm9sEa89Bi3ERYxhFcNiuHZIafVqsNRCZ0WL3dw+E7juUGnxF0tJqzettRq6o1rkya+SF8oQpN2zHrgVJ6yg2ktE1jmA4/X3Z0aug27p4+jG6qFs2aUsR3T9ygR76d2/bBm38kDUlfPCU1EXGk+yC5In2UWhk+zCYvYWFK+c75BdOfew/REarMO419FcVphFiGx+EDZieV9v5ZSN0Mr5Q70wudobHmyEC7KraHcjtNvtPjRDNFHGKe2cc+7RvfwayYqvc0tORXum2uNiiJLSuIymPSFF6Vn5UqDG+GW2mphT1iTKW+M6eU3mDDaB0tg45TI/O8HT8Eduus6B4/w2TknunDPdlUMT5LltRCU+nDRQJveZxDoQ5wKjYs9zeEQMUTIYp2JwzsXAf6niWcTXuSUXQ+VQDIaoGIzLWKc/HkE7WArUGL8sBvW3I1iiYmj97QiWuRjS345gTsWQ/nYETcMfuek6B46LwTgVg3MuBlcOTZDnuxFVDHAFizK5zyQWg7h8VZVwUQVLIgqcGFHl8iA1FUnUqVSCeN36VCqbfL/uqRK4hA7er1NtUjmlG1xaOBhBXWDNG1y6ARfbwRtculEqPH2DS6tchEFNpRjUP1ofW7emIRVnVLlESU2FSvrX0wDqMnJZunwpVFZf3+JUzK3roHs9Xi+qYUKUH0j0gATYuAcILzXSKfC4Vf525/iinyF/1oc43SIP6oWdQlUyTWT3JyjHM3NDlhzE8UJAlOrZ+3ha/iKLo7LP32EOJ+5oZSsWeEHVbACJQi88VXehsaQLohItjO4nFhbuJxYS6/MBrPeFkZ1/PfGteNPxITkV8HQz8gE9CRAZESj+i2vOquUAquNwRD9dtoWhnRpxa95mP942THgrnXeb7Xbb9NitMNZtdtNtttAtDm0/kN0VZL/vULbirY2C4nN1e5RvdBSe7nHsaXquruB416MguqNRGN3M6MdaeeJbMa96rBVAItV6qhWgMdX6UCvA/Cf8nI21AiTmWJ9qpQ/z0Od56PM89I156OU89Hoe+jwPvZiHvjEPpQie2pYVgaNYBM6xCJxaETjiInDFi8CZFYEjKwJDVN91QcSsMkSpZZzyy7hKMhNzpplE6Wacc84ETjwTYvYZphTkyywUCkgHQ5SRxiktnYvcNDEnqEs5S02jVDXO+WoCJ224dvM0IkrfxrUbEnMi52s3xHVKi2s3JFBy52s3kXOaw006yHSklOwoUb6jpFIe9Zz1qFLio8S5jxqnP2qxAlChIsjvgohYQbohpWpAiQoiSKImUM9lEdRcGShTcaDE9YEalwhoUCVIqVBQUrWCei4XVKliUNJFgy24blCj0kGJqke8BjQmxZ8TeI75T8gBIOGJ5T95xgHzedafNL9Aw1PIf+JsAorPG/8JPs4kdppdPOHcfeHhSUkDYQdnTENK/j3yerLZZRLHZTiOy3Eel2lpXK6kcZkUx2WYxmWcxoUvSXWaxvEFKY4xSnmcQU9jjWoab5DjmINE4w4ajP0///v/AGoZ428=\"");

});

parcelRegister("hgkij", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("4W9K8", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("gbK7N", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("lan6Z", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("1zetG", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("53nEH", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fhfja", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("enbPQ", function(module, exports) {
module.exports = JSON.parse("\"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==\"");

});


parcelRegister("90iSP", function(module, exports) {

$parcel$export(module.exports, "Encodings", () => $68e2c2ff57f5b549$export$c85030bb86979d84);
/* tslint:disable max-classes-per-file */ 
var $5JpfH = parcelRequire("5JpfH");

var $9zuq9 = parcelRequire("9zuq9");
var $68e2c2ff57f5b549$var$decompressedEncodings = (0, $5JpfH.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($9zuq9))));
var $68e2c2ff57f5b549$var$allUnicodeMappings = JSON.parse($68e2c2ff57f5b549$var$decompressedEncodings);
var $68e2c2ff57f5b549$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $5JpfH.padStart)(codePoint.toString(16), 4, '0');
                var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $68e2c2ff57f5b549$export$c85030bb86979d84 = {
    Symbol: new $68e2c2ff57f5b549$var$Encoding('Symbol', $68e2c2ff57f5b549$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $68e2c2ff57f5b549$var$Encoding('ZapfDingbats', $68e2c2ff57f5b549$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $68e2c2ff57f5b549$var$Encoding('WinAnsi', $68e2c2ff57f5b549$var$allUnicodeMappings.win1252)
};

});
parcelRegister("9zuq9", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});




parcelRegister("j0tvB", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", () => $dd64e83d12710def$export$8883a3014ee46cd1);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => $dd64e83d12710def$export$846079600c50354e);
$parcel$export(module.exports, "assertIsSubset", () => $dd64e83d12710def$export$dce66947695c582f);
$parcel$export(module.exports, "assertIs", () => $dd64e83d12710def$export$6fee1f82edcf4a03);
$parcel$export(module.exports, "assertOrUndefined", () => $dd64e83d12710def$export$92143017cb173fb0);
$parcel$export(module.exports, "assertEachIs", () => $dd64e83d12710def$export$47fbce961905bcd0);
$parcel$export(module.exports, "assertRange", () => $dd64e83d12710def$export$6698b6d148bc9b0c);
$parcel$export(module.exports, "assertRangeOrUndefined", () => $dd64e83d12710def$export$bce4080186be486);
$parcel$export(module.exports, "assertMultiple", () => $dd64e83d12710def$export$c9f5acf8e31d1a2e);
$parcel$export(module.exports, "assertInteger", () => $dd64e83d12710def$export$a59e49f1e2708383);
$parcel$export(module.exports, "assertPositive", () => $dd64e83d12710def$export$2cad8b74f3cf13dd);
/* tslint:disable:ban-types */ 
var $cbIAG = parcelRequire("cbIAG");
var $dd64e83d12710def$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $dd64e83d12710def$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $dd64e83d12710def$var$formatValue = function(value) {
    var type = typeof value;
    if (type === 'string') return $dd64e83d12710def$export$1909b7b8a28995a9(value);
    else if (type === 'undefined') return $dd64e83d12710def$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $dd64e83d12710def$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $dd64e83d12710def$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $dd64e83d12710def$var$formatValue(value);
};
var $dd64e83d12710def$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($dd64e83d12710def$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $dd64e83d12710def$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    $dd64e83d12710def$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $dd64e83d12710def$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $dd64e83d12710def$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return 'null';
    if (val === undefined) return 'undefined';
    if (typeof val === 'string') return 'string';
    if (isNaN(val)) return 'NaN';
    if (typeof val === 'number') return 'number';
    if (typeof val === 'boolean') return 'boolean';
    if (typeof val === 'symbol') return 'symbol';
    if (typeof val === 'bigint') return 'bigint';
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $dd64e83d12710def$export$26b9f946b448f23e = function(value, type) {
    if (type === 'null') return value === null;
    if (type === 'undefined') return value === undefined;
    if (type === 'string') return typeof value === 'string';
    if (type === 'number') return typeof value === 'number' && !isNaN(value);
    if (type === 'boolean') return typeof value === 'boolean';
    if (type === 'symbol') return typeof value === 'symbol';
    if (type === 'bigint') return typeof value === 'bigint';
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $dd64e83d12710def$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === 'null') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('null');
        if (type === 'undefined') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('undefined');
        if (type === 'string') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('string');
        else if (type === 'number') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('number');
        else if (type === 'boolean') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('boolean');
        else if (type === 'symbol') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('symbol');
        else if (type === 'bigint') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('bigint');
        else if (type === Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Array');
        else if (type === Uint8Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Uint8Array');
        else if (type === ArrayBuffer) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('ArrayBuffer');
        else allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $dd64e83d12710def$export$c7ce26e85cccb3a8($dd64e83d12710def$export$e2b5c5db9e2009fd(value));
};
var $dd64e83d12710def$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($dd64e83d12710def$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($dd64e83d12710def$export$6e3e1e6304e79984(value, valueName, types));
};
var $dd64e83d12710def$export$92143017cb173fb0 = function(value, valueName, types) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, types.concat('undefined'));
};
var $dd64e83d12710def$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $dd64e83d12710def$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(min, 'min', [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(max, 'max', [
        'number'
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $dd64e83d12710def$export$bce4080186be486 = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number',
        'undefined'
    ]);
    if (typeof value === 'number') $dd64e83d12710def$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $dd64e83d12710def$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $dd64e83d12710def$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $dd64e83d12710def$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("iSBb0", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", () => $dbea1b9ee80fa12b$export$ea426b9c784ba215);

var $7Kmy8 = parcelRequire("7Kmy8");
// Mapping from PDFDocEncoding to Unicode code point
var $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $dbea1b9ee80fa12b$var$idx = 0; $dbea1b9ee80fa12b$var$idx < 256; $dbea1b9ee80fa12b$var$idx++)$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[$dbea1b9ee80fa12b$var$idx] = $dbea1b9ee80fa12b$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x16] = (0, $7Kmy8.toCharCode)('\u0017'); // SYNCRONOUS IDLE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x18] = (0, $7Kmy8.toCharCode)('\u02D8'); // BREVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x19] = (0, $7Kmy8.toCharCode)('\u02C7'); // CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1a] = (0, $7Kmy8.toCharCode)('\u02C6'); // MODIFIER LETTER CIRCUMFLEX ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1b] = (0, $7Kmy8.toCharCode)('\u02D9'); // DOT ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1c] = (0, $7Kmy8.toCharCode)('\u02DD'); // DOUBLE ACUTE ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1d] = (0, $7Kmy8.toCharCode)('\u02DB'); // OGONEK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1e] = (0, $7Kmy8.toCharCode)('\u02DA'); // RING ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1f] = (0, $7Kmy8.toCharCode)('\u02DC'); // SMALL TILDE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x7f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x80] = (0, $7Kmy8.toCharCode)('\u2022'); // BULLET
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x81] = (0, $7Kmy8.toCharCode)('\u2020'); // DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x82] = (0, $7Kmy8.toCharCode)('\u2021'); // DOUBLE DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x83] = (0, $7Kmy8.toCharCode)('\u2026'); // HORIZONTAL ELLIPSIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x84] = (0, $7Kmy8.toCharCode)('\u2014'); // EM DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x85] = (0, $7Kmy8.toCharCode)('\u2013'); // EN DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x86] = (0, $7Kmy8.toCharCode)('\u0192'); // LATIN SMALL LETTER SCRIPT F
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x87] = (0, $7Kmy8.toCharCode)('\u2044'); // FRACTION SLASH (solidus)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x88] = (0, $7Kmy8.toCharCode)('\u2039'); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x89] = (0, $7Kmy8.toCharCode)('\u203A'); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8a] = (0, $7Kmy8.toCharCode)('\u2212'); // MINUS SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8b] = (0, $7Kmy8.toCharCode)('\u2030'); // PER MILLE SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8c] = (0, $7Kmy8.toCharCode)('\u201E'); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8d] = (0, $7Kmy8.toCharCode)('\u201C'); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8e] = (0, $7Kmy8.toCharCode)('\u201D'); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8f] = (0, $7Kmy8.toCharCode)('\u2018'); // LEFT SINGLE QUOTATION MARK (quoteleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x90] = (0, $7Kmy8.toCharCode)('\u2019'); // RIGHT SINGLE QUOTATION MARK (quoteright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x91] = (0, $7Kmy8.toCharCode)('\u201A'); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x92] = (0, $7Kmy8.toCharCode)('\u2122'); // TRADE MARK SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x93] = (0, $7Kmy8.toCharCode)('\uFB01'); // LATIN SMALL LIGATURE FI
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x94] = (0, $7Kmy8.toCharCode)('\uFB02'); // LATIN SMALL LIGATURE FL
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x95] = (0, $7Kmy8.toCharCode)('\u0141'); // LATIN CAPITAL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x96] = (0, $7Kmy8.toCharCode)('\u0152'); // LATIN CAPITAL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x97] = (0, $7Kmy8.toCharCode)('\u0160'); // LATIN CAPITAL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x98] = (0, $7Kmy8.toCharCode)('\u0178'); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x99] = (0, $7Kmy8.toCharCode)('\u017D'); // LATIN CAPITAL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9a] = (0, $7Kmy8.toCharCode)('\u0131'); // LATIN SMALL LETTER DOTLESS I
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9b] = (0, $7Kmy8.toCharCode)('\u0142'); // LATIN SMALL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9c] = (0, $7Kmy8.toCharCode)('\u0153'); // LATIN SMALL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9d] = (0, $7Kmy8.toCharCode)('\u0161'); // LATIN SMALL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9e] = (0, $7Kmy8.toCharCode)('\u017E'); // LATIN SMALL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xa0] = (0, $7Kmy8.toCharCode)('\u20AC'); // EURO SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xad] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
var $dbea1b9ee80fa12b$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("clYSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe6ab59ebda0f6a$export$2e2bcd8739ae039);
var $8fe6ab59ebda0f6a$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $8fe6ab59ebda0f6a$export$2e2bcd8739ae039 = $8fe6ab59ebda0f6a$var$Cache;

});



parcelRegister("8zvel", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d9d14d65819945$export$2e2bcd8739ae039);
var $63d9d14d65819945$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($63d9d14d65819945$var$CharCodes || ($63d9d14d65819945$var$CharCodes = {}));
var $63d9d14d65819945$export$2e2bcd8739ae039 = $63d9d14d65819945$var$CharCodes;

});

parcelRegister("kl4jO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece91e5f61c516eb$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $eHlB9 = parcelRequire("eHlB9");

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $kx2r4 = parcelRequire("kx2r4");

var $kHzkO = parcelRequire("kHzkO");

var $5uV6d = parcelRequire("5uV6d");

var $3oHKx = parcelRequire("3oHKx");

var $9EODP = parcelRequire("9EODP");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");

var $5QhVg = parcelRequire("5QhVg");
var $ece91e5f61c516eb$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $ece91e5f61c516eb$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $eHlB9.default).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $5QhVg.SimpleRNG).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $kHzkO.default).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $eTKUN.default));
        var result = ref instanceof (0, $kHzkO.default) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $eTKUN.default)) {
                if (result === (0, $eTKUN.default)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $kHzkO.default) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $eTKUN.default)) {
                if (result === (0, $eTKUN.default)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($ece91e5f61c516eb$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $11c5J.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $eTKUN.default;
        else if (typeof literal === 'string') return (0, $dPHSK.default).of(literal);
        else if (typeof literal === 'number') return (0, $j04jt.default).of(literal);
        else if (typeof literal === 'boolean') return literal ? (0, $8gQNC.default).True : (0, $8gQNC.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $8auL6.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $brir8.default).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $dPHSK.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $kx2r4.default).of(this.obj(dict), (0, $4ISq8.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate((0, $4ISq8.typedArrayFor)(contents)), (0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, dict), {
            Filter: 'FlateDecode'
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $9EODP.default).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $cOQTW.__assign)((0, $cOQTW.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: 'XObject',
            Subtype: 'Form'
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $5uV6d.default).of((0, $3oHKx.default).PushGraphicsState);
        var stream = (0, $9EODP.default).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $5uV6d.default).of((0, $3oHKx.default).PopGraphicsState);
        var stream = (0, $9EODP.default).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $ece91e5f61c516eb$export$2e2bcd8739ae039 = $ece91e5f61c516eb$var$PDFContext;

});
parcelRegister("eHlB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab35d5c6c69177c9$export$2e2bcd8739ae039);

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ab35d5c6c69177c9$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $7Kmy8.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).P;
        buffer[offset++] = (0, $8zvel.default).D;
        buffer[offset++] = (0, $8zvel.default).F;
        buffer[offset++] = (0, $8zvel.default).Dash;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Period;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $ab35d5c6c69177c9$export$2e2bcd8739ae039 = $ab35d5c6c69177c9$var$PDFHeader;

});

parcelRegister("8auL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f271df805933107$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $nAWRe = parcelRequire("nAWRe");
var $5f271df805933107$var$PDFArray = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $nAWRe.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $j04jt.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $j04jt.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $j04jt.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $j04jt.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = '[ ';
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += ' ';
        }
        arrayString += ']';
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LeftSquareBracket;
        buffer[offset++] = (0, $8zvel.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        buffer[offset++] = (0, $8zvel.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $j04jt.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $j04jt.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $11c5J.default));
var $5f271df805933107$export$2e2bcd8739ae039 = $5f271df805933107$var$PDFArray;

});
parcelRegister("j04jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515ce6ac431bbb$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $hiEdU = parcelRequire("hiEdU");

var $11c5J = parcelRequire("11c5J");
var $dd515ce6ac431bbb$var$PDFNumber = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $hiEdU.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $11c5J.default));
var $dd515ce6ac431bbb$export$2e2bcd8739ae039 = $dd515ce6ac431bbb$var$PDFNumber;

});
parcelRegister("11c5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdf4392b99cfcf1$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");
var $0bdf4392b99cfcf1$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'toString');
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'sizeInBytes');
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'copyBytesInto');
    };
    return PDFObject;
}();
var $0bdf4392b99cfcf1$export$2e2bcd8739ae039 = $0bdf4392b99cfcf1$var$PDFObject;

});



parcelRegister("8gQNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6058c6342b5f9099$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $6058c6342b5f9099$var$ENFORCER = {};
var $6058c6342b5f9099$var$PDFBool = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $6058c6342b5f9099$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFBool');
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $8zvel.default).t;
            buffer[offset++] = (0, $8zvel.default).r;
            buffer[offset++] = (0, $8zvel.default).u;
            buffer[offset++] = (0, $8zvel.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $8zvel.default).f;
            buffer[offset++] = (0, $8zvel.default).a;
            buffer[offset++] = (0, $8zvel.default).l;
            buffer[offset++] = (0, $8zvel.default).s;
            buffer[offset++] = (0, $8zvel.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($6058c6342b5f9099$var$ENFORCER, true);
    PDFBool.False = new PDFBool($6058c6342b5f9099$var$ENFORCER, false);
    return PDFBool;
}((0, $11c5J.default));
var $6058c6342b5f9099$export$2e2bcd8739ae039 = $6058c6342b5f9099$var$PDFBool;

});

parcelRegister("brir8", function(module, exports) {

$parcel$export(module.exports, "default", () => $85408478fbb7cbde$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $85408478fbb7cbde$var$PDFDict = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $eTKUN.default);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $eTKUN.default));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $eTKUN.default));
        var value = (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = '';
        var existingKeys = this.keys();
        var key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = '<<\n';
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + ' ' + value.toString() + '\n';
        }
        dictString += '>>';
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $11c5J.default));
var $85408478fbb7cbde$export$2e2bcd8739ae039 = $85408478fbb7cbde$var$PDFDict;

});
parcelRegister("dPHSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12213d87b46303c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $6InlX = parcelRequire("6InlX");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $a12213d87b46303c$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $7Kmy8.charFromHexCode)(hex);
    });
};
var $a12213d87b46303c$var$isRegularChar = function(charCode) {
    return charCode >= (0, $8zvel.default).ExclamationPoint && charCode <= (0, $8zvel.default).Tilde && !(0, $6InlX.IsIrregular)[charCode];
};
var $a12213d87b46303c$var$ENFORCER = {};
var $a12213d87b46303c$var$pool = new Map();
var $a12213d87b46303c$var$PDFName = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $a12213d87b46303c$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFName');
        _this = _super.call(this) || this;
        var encodedName = '/';
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $7Kmy8.toCharCode)(character);
            encodedName += $a12213d87b46303c$var$isRegularChar(code) ? character : "#" + (0, $7Kmy8.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Nine || byte >= (0, $8zvel.default).a && byte <= (0, $8zvel.default).f || byte >= (0, $8zvel.default).A && byte <= (0, $8zvel.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
                    pushByte(parseInt(hex, 16));
                    hex = '';
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $a12213d87b46303c$var$decodeName(name);
        var instance = $a12213d87b46303c$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($a12213d87b46303c$var$ENFORCER, decodedValue);
            $a12213d87b46303c$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of('Length');
    PDFName.FlateDecode = PDFName.of('FlateDecode');
    PDFName.Resources = PDFName.of('Resources');
    PDFName.Font = PDFName.of('Font');
    PDFName.XObject = PDFName.of('XObject');
    PDFName.ExtGState = PDFName.of('ExtGState');
    PDFName.Contents = PDFName.of('Contents');
    PDFName.Type = PDFName.of('Type');
    PDFName.Parent = PDFName.of('Parent');
    PDFName.MediaBox = PDFName.of('MediaBox');
    PDFName.Page = PDFName.of('Page');
    PDFName.Annots = PDFName.of('Annots');
    PDFName.TrimBox = PDFName.of('TrimBox');
    PDFName.ArtBox = PDFName.of('ArtBox');
    PDFName.BleedBox = PDFName.of('BleedBox');
    PDFName.CropBox = PDFName.of('CropBox');
    PDFName.Rotate = PDFName.of('Rotate');
    PDFName.Title = PDFName.of('Title');
    PDFName.Author = PDFName.of('Author');
    PDFName.Subject = PDFName.of('Subject');
    PDFName.Creator = PDFName.of('Creator');
    PDFName.Keywords = PDFName.of('Keywords');
    PDFName.Producer = PDFName.of('Producer');
    PDFName.CreationDate = PDFName.of('CreationDate');
    PDFName.ModDate = PDFName.of('ModDate');
    return PDFName;
}((0, $11c5J.default));
var $a12213d87b46303c$export$2e2bcd8739ae039 = $a12213d87b46303c$var$PDFName;

});
parcelRegister("6InlX", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", () => $4e38f796f0a0073a$export$5a447e10c710a69b);

var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $14u6w = parcelRequire("14u6w");
var $4e38f796f0a0073a$export$5a447e10c710a69b = new Uint8Array(256);
for(var $4e38f796f0a0073a$var$idx = 0, $4e38f796f0a0073a$var$len = 256; $4e38f796f0a0073a$var$idx < $4e38f796f0a0073a$var$len; $4e38f796f0a0073a$var$idx++)$4e38f796f0a0073a$export$5a447e10c710a69b[$4e38f796f0a0073a$var$idx] = (0, $14u6w.IsWhitespace)[$4e38f796f0a0073a$var$idx] || (0, $eOx0D.IsDelimiter)[$4e38f796f0a0073a$var$idx] ? 1 : 0;
$4e38f796f0a0073a$export$5a447e10c710a69b[(0, $8zvel.default).Hash] = 1;

});
parcelRegister("eOx0D", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", () => $ac8f572666c7d7dc$export$30620680eaa3becd);

var $8zvel = parcelRequire("8zvel");
var $ac8f572666c7d7dc$export$30620680eaa3becd = new Uint8Array(256);
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LessThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).GreaterThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).ForwardSlash] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).Percent] = 1;

});

parcelRegister("14u6w", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", () => $0c7d843fbd7cd19d$export$38c4de915d0e2c37);

var $8zvel = parcelRequire("8zvel");
var $0c7d843fbd7cd19d$export$38c4de915d0e2c37 = new Uint8Array(256);
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Null] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Tab] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Newline] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).FormFeed] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).CarriageReturn] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Space] = 1;

});



parcelRegister("eTKUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad8a981877dc5d20$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $ad8a981877dc5d20$var$PDFNull = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return 'null';
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).u;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).l;
        return 4;
    };
    return PDFNull;
}((0, $11c5J.default));
var $ad8a981877dc5d20$export$2e2bcd8739ae039 = new $ad8a981877dc5d20$var$PDFNull();

});


parcelRegister("kx2r4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef28c75b0f11042e$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ef28c75b0f11042e$var$PDFRawStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $4ISq8.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $4CgUJ.default));
var $ef28c75b0f11042e$export$2e2bcd8739ae039 = $ef28c75b0f11042e$var$PDFRawStream;

});
parcelRegister("4CgUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $35c7d4c8e4f2bcc7$var$PDFStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsString');
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContents');
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsSize');
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $dPHSK.default).Length, (0, $j04jt.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += '\nstream\n';
        streamString += this.getContentsString();
        streamString += '\nendstream';
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).d;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $11c5J.default));
var $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039 = $35c7d4c8e4f2bcc7$var$PDFStream;

});


parcelRegister("kHzkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1233b848bc26abe$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $f1233b848bc26abe$var$ENFORCER = {};
var $f1233b848bc26abe$var$pool = new Map();
var $f1233b848bc26abe$var$PDFRef = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $f1233b848bc26abe$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFRef');
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $f1233b848bc26abe$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($f1233b848bc26abe$var$ENFORCER, objectNumber, generationNumber);
            $f1233b848bc26abe$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $11c5J.default));
var $f1233b848bc26abe$export$2e2bcd8739ae039 = $f1233b848bc26abe$var$PDFRef;

});

parcelRegister("5uV6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $400c0bd11400a1c4$export$2e2bcd8739ae039);

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $400c0bd11400a1c4$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $11c5J.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = '';
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + ' ';
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $11c5J.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $11c5J.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $7Kmy8.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $400c0bd11400a1c4$export$2e2bcd8739ae039 = $400c0bd11400a1c4$var$PDFOperator;

});

parcelRegister("3oHKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $27958cc2c5d88a31$export$2e2bcd8739ae039);
var $27958cc2c5d88a31$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($27958cc2c5d88a31$var$PDFOperatorNames || ($27958cc2c5d88a31$var$PDFOperatorNames = {}));
var $27958cc2c5d88a31$export$2e2bcd8739ae039 = $27958cc2c5d88a31$var$PDFOperatorNames;

});

parcelRegister("9EODP", function(module, exports) {

$parcel$export(module.exports, "default", () => $707f21d02e4e1bf4$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $3T8kK = parcelRequire("3T8kK");

var $8zvel = parcelRequire("8zvel");
var $707f21d02e4e1bf4$var$PDFContentStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = '';
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $3T8kK.default));
var $707f21d02e4e1bf4$export$2e2bcd8739ae039 = $707f21d02e4e1bf4$var$PDFContentStream;

});
parcelRegister("3T8kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d4cf9103ab67d11$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $2d4cf9103ab67d11$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $dPHSK.default).of('Filter'), (0, $dPHSK.default).of('FlateDecode'));
        _this.contentsCache = (0, $clYSv.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getUnencodedContents');
    };
    return PDFFlateStream;
}((0, $4CgUJ.default));
var $2d4cf9103ab67d11$export$2e2bcd8739ae039 = $2d4cf9103ab67d11$var$PDFFlateStream;

});


parcelRegister("5QhVg", function(module, exports) {

$parcel$export(module.exports, "SimpleRNG", () => $440fb620dea1b860$export$205b650d120b95b5);
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $440fb620dea1b860$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();

});


parcelRegister("k5Uzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea102798c96bfd06$export$2e2bcd8739ae039);

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $kHzkO = parcelRequire("kHzkO");

var $4CgUJ = parcelRequire("4CgUJ");

var $eAof5 = parcelRequire("eAof5");
/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $ea102798c96bfd06$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $eAof5.default) ? _this.copyPDFPage(object) : object instanceof (0, $brir8.default) ? _this.copyPDFDict(object) : object instanceof (0, $8auL6.default) ? _this.copyPDFArray(object) : object instanceof (0, $4CgUJ.default) ? _this.copyPDFStream(object) : object instanceof (0, $kHzkO.default) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $eAof5.default).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $dPHSK.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $dPHSK.default).of('Parent'));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $ea102798c96bfd06$export$2e2bcd8739ae039 = $ea102798c96bfd06$var$PDFObjectCopier;

});
parcelRegister("eAof5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e73b7ced5abfa4$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $4CgUJ = parcelRequire("4CgUJ");
var $a9e73b7ced5abfa4$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $dPHSK.default).Parent, (0, $brir8.default));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $dPHSK.default).of('Contents'));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $dPHSK.default).Annots, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).BleedBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).TrimBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).ArtBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $brir8.default));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $dPHSK.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $dPHSK.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $8auL6.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $dPHSK.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $4CgUJ.default)) this.set((0, $dPHSK.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $brir8.default)) || context.obj({});
        this.set((0, $dPHSK.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $dPHSK.default).Font, (0, $brir8.default)) || context.obj({});
        Resources.set((0, $dPHSK.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $dPHSK.default).XObject, (0, $brir8.default)) || context.obj({});
        Resources.set((0, $dPHSK.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $dPHSK.default).ExtGState, (0, $brir8.default)) || context.obj({});
        Resources.set((0, $dPHSK.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $dPHSK.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $dPHSK.default).Font, (0, $brir8.default)),
            XObject: Resources.lookup((0, $dPHSK.default).XObject, (0, $brir8.default)),
            ExtGState: Resources.lookup((0, $dPHSK.default).ExtGState, (0, $brir8.default))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        'Resources',
        'MediaBox',
        'CropBox',
        'Rotate'
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).Type, (0, $dPHSK.default).Page);
        dict.set((0, $dPHSK.default).Parent, parent);
        dict.set((0, $dPHSK.default).Resources, context.obj({}));
        dict.set((0, $dPHSK.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $brir8.default));
var $a9e73b7ced5abfa4$export$2e2bcd8739ae039 = $a9e73b7ced5abfa4$var$PDFPageLeaf;

});


parcelRegister("5HlMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4261dca68d44d2dc$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $Vy0LI = parcelRequire("Vy0LI");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $fXb4L = parcelRequire("fXb4L");

var $8nK9n = parcelRequire("8nK9n");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ggjMi = parcelRequire("ggjMi");
var $4261dca68d44d2dc$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).e;
                        buffer[offset++] = (0, $8zvel.default).n;
                        buffer[offset++] = (0, $8zvel.default).d;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        n = object instanceof (0, $8nK9n.default) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $eHlB9.default).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $Vy0LI.default).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $fXb4L.default).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $4S3gv.default).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $4261dca68d44d2dc$export$2e2bcd8739ae039 = $4261dca68d44d2dc$var$PDFWriter;

});
parcelRegister("Vy0LI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0acfb4f0f4898246$export$2e2bcd8739ae039);

var $kHzkO = parcelRequire("kHzkO");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $0acfb4f0f4898246$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
                section += ' ';
                section += (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
                section += ' ';
                section += entry.deleted ? 'f' : 'n';
                section += ' \n';
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var entryGen = (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = entry.deleted ? (0, $8zvel.default).f : (0, $8zvel.default).n;
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $kHzkO.default).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $0acfb4f0f4898246$export$2e2bcd8739ae039 = $0acfb4f0f4898246$var$PDFCrossRefSection;

});

parcelRegister("4S3gv", function(module, exports) {

$parcel$export(module.exports, "default", () => $38bebcf76e0d2d54$export$2e2bcd8739ae039);

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $38bebcf76e0d2d54$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).E;
        buffer[offset++] = (0, $8zvel.default).O;
        buffer[offset++] = (0, $8zvel.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $38bebcf76e0d2d54$export$2e2bcd8739ae039 = $38bebcf76e0d2d54$var$PDFTrailer;

});

parcelRegister("fXb4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9d4f51bf55d54ab$export$2e2bcd8739ae039);

var $8zvel = parcelRequire("8zvel");
var $b9d4f51bf55d54ab$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).i;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $b9d4f51bf55d54ab$export$2e2bcd8739ae039 = $b9d4f51bf55d54ab$var$PDFTrailerDict;

});

parcelRegister("8nK9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a4452f4878bba9$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $3T8kK = parcelRequire("3T8kK");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $4ISq8 = parcelRequire("4ISq8");
var $61a4452f4878bba9$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('ObjStm'));
        _this.dict.set((0, $dPHSK.default).of('N'), (0, $j04jt.default).of(_this.objects.length));
        _this.dict.set((0, $dPHSK.default).of('First'), (0, $j04jt.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $7Kmy8.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $4ISq8.last)(this.offsets)[1] + (0, $4ISq8.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = '';
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $3T8kK.default));
var $61a4452f4878bba9$export$2e2bcd8739ae039 = $61a4452f4878bba9$var$PDFObjectStream;

});


parcelRegister("7YdvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd89dbe12e59987$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $eTWtL = parcelRequire("eTWtL");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $kHzkO = parcelRequire("kHzkO");

var $4CgUJ = parcelRequire("4CgUJ");

var $eMjAF = parcelRequire("eMjAF");

var $8nK9n = parcelRequire("8nK9n");

var $5HlMk = parcelRequire("5HlMk");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ggjMi = parcelRequire("ggjMi");
var $5cd89dbe12e59987$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $eHlB9.default).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $eMjAF.default).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $4CgUJ.default) || object instanceof (0, $eTWtL.default) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $4ISq8.last)(compressedObjects);
                        objectStreamRef = (0, $4ISq8.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $kHzkO.default).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $8nK9n.default).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $kHzkO.default).of(objectNumber++);
                        xrefStream.dict.set((0, $dPHSK.default).of('Size'), (0, $j04jt.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $4S3gv.default).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $5HlMk.default));
var $5cd89dbe12e59987$export$2e2bcd8739ae039 = $5cd89dbe12e59987$var$PDFStreamWriter;

});
parcelRegister("eTWtL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9390730b9495a5$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");
var $ad9390730b9495a5$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $11c5J.default));
var $ad9390730b9495a5$export$2e2bcd8739ae039 = $ad9390730b9495a5$var$PDFInvalidObject;

});

parcelRegister("eMjAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac24be9f2612b58f$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $kHzkO = parcelRequire("kHzkO");

var $3T8kK = parcelRequire("3T8kK");
parcelRequire("fvYKZ");
var $hiEdU = parcelRequire("hiEdU");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $ac24be9f2612b58f$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($ac24be9f2612b58f$export$e41c32906b33062a || ($ac24be9f2612b58f$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $ac24be9f2612b58f$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $hiEdU.sizeInBytes)(first);
                var secondSize = (0, $hiEdU.sizeInBytes)(second);
                var thirdSize = (0, $hiEdU.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $clYSv.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $clYSv.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $clYSv.default).populatedBy(_this.computeIndex);
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('XRef'));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = '';
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $4ISq8.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $dPHSK.default).of('W'), context.obj(byteWidths));
        this.dict.set((0, $dPHSK.default).of('Index'), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $kHzkO.default).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $3T8kK.default));
var $ac24be9f2612b58f$export$2e2bcd8739ae039 = $ac24be9f2612b58f$var$PDFCrossRefStream;

});


parcelRegister("jwvE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3698d9fec5e57b0$export$2e2bcd8739ae039);
parcelRequire("eNCdi");
var $90iSP = parcelRequire("90iSP");
var $kkdJe = parcelRequire("kkdJe");

var $jWFiV = parcelRequire("jWFiV");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $e3698d9fec5e57b0$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $kkdJe.FontNames).ZapfDingbats ? (0, $90iSP.Encodings).ZapfDingbats : fontName === (0, $kkdJe.FontNames).Symbol ? (0, $90iSP.Encodings).Symbol : (0, $90iSP.Encodings).WinAnsi;
        this.font = (0, $kkdJe.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexString)(glyphs[idx].code);
        return (0, $jWFiV.default).of(hexCodes.join(''));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: 'Font',
            Subtype: 'Type1',
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $90iSP.Encodings).WinAnsi ? 'WinAnsiEncoding' : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $7Kmy8.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $e3698d9fec5e57b0$export$2e2bcd8739ae039 = $e3698d9fec5e57b0$var$StandardFontEmbedder;

});
parcelRegister("jWFiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8537943f4279a06$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $e8537943f4279a06$var$PDFHexString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LessThan;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $ejAvl.utf16Encode)(value);
        var hex = '';
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $7Kmy8.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $11c5J.default));
var $e8537943f4279a06$export$2e2bcd8739ae039 = $e8537943f4279a06$var$PDFHexString;

});


parcelRegister("gCJZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a3ddaa0f08fc18$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $ckCcM = parcelRequire("ckCcM");

var $9XzjW = parcelRequire("9XzjW");

var $jWFiV = parcelRequire("jWFiV");

var $8dCYu = parcelRequire("8dCYu");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $clYSv = parcelRequire("clYSv");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $c1a3ddaa0f08fc18$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $4ISq8.sortedUniq)(glyphs.sort((0, $4ISq8.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || 'Font';
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = '';
        this.glyphCache = (0, $clYSv.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $jWFiV.default).of(hexCodes.join(''));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: this.baseFontName,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: 'Font',
                            Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
                            CIDToGIDMap: 'Identity',
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $8dCYu.default).of('Adobe'),
                                Ordering: (0, $8dCYu.default).of('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $cOQTW.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: 'FontDescriptor',
                            FontName: this.baseFontName,
                            Flags: (0, $9XzjW.deriveFontFlags)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $ckCcM.createCmap)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $c1a3ddaa0f08fc18$export$2e2bcd8739ae039 = $c1a3ddaa0f08fc18$var$CustomFontEmbedder;

});
parcelRegister("ckCcM", function(module, exports) {

$parcel$export(module.exports, "createCmap", () => $8fa4fd029ce650b8$export$ecb273704ecc155f);
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $ejAvl = parcelRequire("ejAvl");
var $8fa4fd029ce650b8$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $8fa4fd029ce650b8$var$cmapHexFormat($8fa4fd029ce650b8$var$cmapHexString(glyphId(glyph)));
        var unicode = $8fa4fd029ce650b8$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($8fa4fd029ce650b8$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $8fa4fd029ce650b8$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $8fa4fd029ce650b8$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $8fa4fd029ce650b8$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join('') + ">";
};
var $8fa4fd029ce650b8$var$cmapHexString = function(value) {
    return (0, $7Kmy8.toHexStringOfMinLength)(value, 4);
};
var $8fa4fd029ce650b8$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $ejAvl.isWithinBMP)(codePoint)) return $8fa4fd029ce650b8$var$cmapHexString(codePoint);
    if ((0, $ejAvl.hasSurrogates)(codePoint)) {
        var hs = (0, $ejAvl.highSurrogate)(codePoint);
        var ls = (0, $ejAvl.lowSurrogate)(codePoint);
        return "" + $8fa4fd029ce650b8$var$cmapHexString(hs) + $8fa4fd029ce650b8$var$cmapHexString(ls);
    }
    var hex = (0, $7Kmy8.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};

});

parcelRegister("9XzjW", function(module, exports) {

$parcel$export(module.exports, "deriveFontFlags", () => $740505aae0fb9700$export$aa92af1a056b24e8);
// prettier-ignore
var $740505aae0fb9700$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $740505aae0fb9700$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
    var flags = $740505aae0fb9700$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};

});

parcelRegister("8dCYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fbdc5307b6362f1$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $5fbdc5307b6362f1$var$PDFString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $8zvel.default).Newline) pushByte();
                else if (byte === (0, $8zvel.default).CarriageReturn) pushByte();
                else if (byte === (0, $8zvel.default).n) pushByte((0, $8zvel.default).Newline);
                else if (byte === (0, $8zvel.default).r) pushByte((0, $8zvel.default).CarriageReturn);
                else if (byte === (0, $8zvel.default).t) pushByte((0, $8zvel.default).Tab);
                else if (byte === (0, $8zvel.default).b) pushByte((0, $8zvel.default).Backspace);
                else if (byte === (0, $8zvel.default).f) pushByte((0, $8zvel.default).FormFeed);
                else if (byte === (0, $8zvel.default).LeftParen) pushByte((0, $8zvel.default).LeftParen);
                else if (byte === (0, $8zvel.default).RightParen) pushByte((0, $8zvel.default).RightParen);
                else if (byte === (0, $8zvel.default).Backspace) pushByte((0, $8zvel.default).BackSlash);
                else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
                        pushByte(parseInt(octal, 8));
                        octal = '';
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LeftParen;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $7Kmy8.padStart)(String(date.getUTCFullYear()), 4, '0');
        var month = (0, $7Kmy8.padStart)(String(date.getUTCMonth() + 1), 2, '0');
        var day = (0, $7Kmy8.padStart)(String(date.getUTCDate()), 2, '0');
        var hours = (0, $7Kmy8.padStart)(String(date.getUTCHours()), 2, '0');
        var mins = (0, $7Kmy8.padStart)(String(date.getUTCMinutes()), 2, '0');
        var secs = (0, $7Kmy8.padStart)(String(date.getUTCSeconds()), 2, '0');
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $11c5J.default));
var $5fbdc5307b6362f1$export$2e2bcd8739ae039 = $5fbdc5307b6362f1$var$PDFString;

});


parcelRegister("6uXKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb3e5ce3694dd68$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $gCJZ9 = parcelRequire("gCJZ9");

var $jWFiV = parcelRequire("jWFiV");
parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $clYSv.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $jWFiV.default).of(hexCodes.join(''));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on('data', function(bytes) {
                return parts.push(bytes);
            }).on('end', function() {
                return resolve((0, $4ISq8.mergeUint8Arrays)(parts));
            }).on('error', function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $gCJZ9.default));
var $4bb3e5ce3694dd68$export$2e2bcd8739ae039 = $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder;

});

parcelRegister("k8kub", function(module, exports) {

$parcel$export(module.exports, "AFRelationship", () => $03c8546b8537a071$export$c12eac46fbec1b74);
$parcel$export(module.exports, "default", () => $03c8546b8537a071$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");
var $03c8546b8537a071$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($03c8546b8537a071$export$c12eac46fbec1b74 || ($03c8546b8537a071$export$c12eac46fbec1b74 = {}));
var $03c8546b8537a071$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: 'EmbeddedFile',
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $8dCYu.default).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $8dCYu.default).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: 'Filespec',
                    F: (0, $8dCYu.default).of(this.fileName),
                    UF: (0, $jWFiV.default).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $jWFiV.default).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $03c8546b8537a071$export$2e2bcd8739ae039 = $03c8546b8537a071$var$FileEmbedder;

});

parcelRegister("fmxHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2f30d23c2f107ea$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
// prettier-ignore
var $b2f30d23c2f107ea$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $b2f30d23c2f107ea$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($b2f30d23c2f107ea$var$ColorSpace || ($b2f30d23c2f107ea$var$ColorSpace = {}));
var $b2f30d23c2f107ea$var$ChannelToColorSpace = {
    1: $b2f30d23c2f107ea$var$ColorSpace.DeviceGray,
    3: $b2f30d23c2f107ea$var$ColorSpace.DeviceRGB,
    4: $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $b2f30d23c2f107ea$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $cOQTW.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($b2f30d23c2f107ea$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$b2f30d23c2f107ea$var$MARKERS.includes(marker)) throw new Error('Invalid JPEG');
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $b2f30d23c2f107ea$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error('Unknown JPEG channel.');
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode',
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $b2f30d23c2f107ea$export$2e2bcd8739ae039 = $b2f30d23c2f107ea$var$JpegEmbedder;

});

parcelRegister("atfwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f8a6e417146498$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $kdfvO = parcelRequire("kdfvO");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $79f8a6e417146498$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = 'DeviceRGB';
    }
    PngEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $cOQTW.__generator)(this, function(_a) {
                png = (0, $kdfvO.PNG).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: 'XObject',
            Subtype: 'Image',
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: 'DeviceGray',
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $79f8a6e417146498$export$2e2bcd8739ae039 = $79f8a6e417146498$var$PngEmbedder;

});
parcelRegister("kdfvO", function(module, exports) {

$parcel$export(module.exports, "PNG", () => $eb710dec6a4e1482$export$1f536085c24cc947);

var $9wmwO = parcelRequire("9wmwO");
var $eb710dec6a4e1482$var$getImageType = function(ctype) {
    if (ctype === 0) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $eb710dec6a4e1482$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $eb710dec6a4e1482$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $eb710dec6a4e1482$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $eb710dec6a4e1482$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $eb710dec6a4e1482$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($eb710dec6a4e1482$export$3ff975e8f63e458c || ($eb710dec6a4e1482$export$3ff975e8f63e458c = {}));
var $eb710dec6a4e1482$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $9wmwO.default).decode(pngData);
        var frames = (0, $9wmwO.default).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $eb710dec6a4e1482$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $eb710dec6a4e1482$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();

});
parcelRegister("9wmwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee893d66c44e557$export$2e2bcd8739ae039);

var $ckCqy = parcelRequire("ckCqy");
var $6ee893d66c44e557$var$UPNG = {};
$6ee893d66c44e557$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $6ee893d66c44e557$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $6ee893d66c44e557$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$6ee893d66c44e557$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $6ee893d66c44e557$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $6ee893d66c44e557$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$6ee893d66c44e557$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $6ee893d66c44e557$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $6ee893d66c44e557$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $6ee893d66c44e557$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$6ee893d66c44e557$var$UPNG.decode._inflate = function(data, buff) {
    var out = $6ee893d66c44e557$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$6ee893d66c44e557$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$6ee893d66c44e557$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $6ee893d66c44e557$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$6ee893d66c44e557$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$6ee893d66c44e557$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$6ee893d66c44e557$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$6ee893d66c44e557$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $6ee893d66c44e557$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$6ee893d66c44e557$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $6ee893d66c44e557$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $6ee893d66c44e557$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$6ee893d66c44e557$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$6ee893d66c44e557$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $6ee893d66c44e557$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, -1);
    return $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$6ee893d66c44e557$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$6ee893d66c44e557$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $6ee893d66c44e557$var$UPNG.crc.crc, wUi = $6ee893d66c44e557$var$UPNG._bin.writeUint, wUs = $6ee893d66c44e557$var$UPNG._bin.writeUshort, wAs = $6ee893d66c44e557$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$6ee893d66c44e557$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $6ee893d66c44e557$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$6ee893d66c44e557$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $6ee893d66c44e557$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $6ee893d66c44e557$var$UPNG.encode.concatRGBA(nbufs), qres = $6ee893d66c44e557$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$6ee893d66c44e557$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$6ee893d66c44e557$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$6ee893d66c44e557$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$6ee893d66c44e557$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$6ee893d66c44e557$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$6ee893d66c44e557$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$6ee893d66c44e557$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $6ee893d66c44e557$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $6ee893d66c44e557$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$6ee893d66c44e557$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $6ee893d66c44e557$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $6ee893d66c44e557$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$6ee893d66c44e557$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $6ee893d66c44e557$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $6ee893d66c44e557$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $6ee893d66c44e557$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $6ee893d66c44e557$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$6ee893d66c44e557$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $6ee893d66c44e557$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$6ee893d66c44e557$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$6ee893d66c44e557$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$6ee893d66c44e557$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $6ee893d66c44e557$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$6ee893d66c44e557$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$6ee893d66c44e557$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$6ee893d66c44e557$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $6ee893d66c44e557$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$6ee893d66c44e557$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$6ee893d66c44e557$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $6ee893d66c44e557$export$2e2bcd8739ae039 = $6ee893d66c44e557$var$UPNG;

});



parcelRegister("h9IbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d58da35b52112a$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $j04jt = parcelRequire("j04jt");

var $kx2r4 = parcelRequire("kx2r4");

var $4CgUJ = parcelRequire("4CgUJ");

var $dLMRX = parcelRequire("dLMRX");

var $9EODP = parcelRequire("9EODP");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $c7d58da35b52112a$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $j04jt.default)).asNumber() - mediaBox.lookup(0, (0, $j04jt.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $j04jt.default)).asNumber() - mediaBox.lookup(1, (0, $j04jt.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $c7d58da35b52112a$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $c7d58da35b52112a$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $c7d58da35b52112a$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $c7d58da35b52112a$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $cOQTW.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $nAWRe.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: 'XObject',
                    Subtype: 'Form',
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $8zvel.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $4CgUJ.default));
            var content = void 0;
            if (stream instanceof (0, $kx2r4.default)) content = (0, $dLMRX.decodePDFRawStream)(stream).decode();
            else if (stream instanceof (0, $9EODP.default)) content = stream.getUnencodedContents();
            else throw new (0, $nAWRe.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $4ISq8.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $c7d58da35b52112a$export$2e2bcd8739ae039 = $c7d58da35b52112a$var$PDFPageEmbedder;

});
parcelRegister("dLMRX", function(module, exports) {

$parcel$export(module.exports, "decodePDFRawStream", () => $a0659294f562ac04$export$b8317e68ca978594);

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $2wSV8 = parcelRequire("2wSV8");

var $jZikx = parcelRequire("jZikx");

var $1ptqQ = parcelRequire("1ptqQ");

var $hoQ98 = parcelRequire("hoQ98");

var $oQP7X = parcelRequire("oQP7X");

var $940jP = parcelRequire("940jP");
var $a0659294f562ac04$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $dPHSK.default).of('FlateDecode')) return new (0, $1ptqQ.default)(stream);
    if (encoding === (0, $dPHSK.default).of('LZWDecode')) {
        var earlyChange = 1;
        if (params instanceof (0, $brir8.default)) {
            var EarlyChange = params.lookup((0, $dPHSK.default).of('EarlyChange'));
            if (EarlyChange instanceof (0, $j04jt.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $hoQ98.default)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $dPHSK.default).of('ASCII85Decode')) return new (0, $2wSV8.default)(stream);
    if (encoding === (0, $dPHSK.default).of('ASCIIHexDecode')) return new (0, $jZikx.default)(stream);
    if (encoding === (0, $dPHSK.default).of('RunLengthDecode')) return new (0, $oQP7X.default)(stream);
    throw new (0, $nAWRe.UnsupportedEncodingError)(encoding.asString());
};
var $a0659294f562ac04$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $940jP.default)(contents);
    var Filter = dict.lookup((0, $dPHSK.default).of('Filter'));
    var DecodeParms = dict.lookup((0, $dPHSK.default).of('DecodeParms'));
    if (Filter instanceof (0, $dPHSK.default)) stream = $a0659294f562ac04$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $8auL6.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $a0659294f562ac04$var$decodeStream(stream, Filter.lookup(idx, (0, $dPHSK.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $brir8.default)));
    else if (!!Filter) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $dPHSK.default),
        (0, $8auL6.default)
    ], Filter);
    return stream;
};

});
parcelRegister("2wSV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d792bffef4b9a0f$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $1d792bffef4b9a0f$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $1d792bffef4b9a0f$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $9BULP.default));
var $1d792bffef4b9a0f$export$2e2bcd8739ae039 = $1d792bffef4b9a0f$var$Ascii85Stream;

});
parcelRegister("9BULP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ff39b2bedd52666$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $940jP = parcelRequire("940jP");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $6ff39b2bedd52666$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $6ff39b2bedd52666$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $6ff39b2bedd52666$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $940jP.default)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'readBlock');
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $6ff39b2bedd52666$export$2e2bcd8739ae039 = $6ff39b2bedd52666$var$DecodeStream;

});
parcelRegister("940jP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6994bc106090076a$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $6994bc106090076a$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $6994bc106090076a$export$2e2bcd8739ae039 = $6994bc106090076a$var$Stream;

});



parcelRegister("jZikx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d1eed445279b14$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $e8d1eed445279b14$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $9BULP.default));
var $e8d1eed445279b14$export$2e2bcd8739ae039 = $e8d1eed445279b14$var$AsciiHexStream;

});

parcelRegister("1ptqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $106ef4d7516ef3d6$export$2e2bcd8739ae039);
/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
// prettier-ignore
var $106ef4d7516ef3d6$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $106ef4d7516ef3d6$var$FlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error('Bad uncompressed block length in flate stream');
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $106ef4d7516ef3d6$var$fixedLitCodeTab;
            distCodeTable = $106ef4d7516ef3d6$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($106ef4d7516ef3d6$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$106ef4d7516ef3d6$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error('Unknown block type in flate stream');
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $106ef4d7516ef3d6$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $106ef4d7516ef3d6$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error('Bad encoding in flate stream');
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === 'number') console.log('FLATE:', code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error('Bad encoding in flate stream');
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $9BULP.default));
var $106ef4d7516ef3d6$export$2e2bcd8739ae039 = $106ef4d7516ef3d6$var$FlateStream;

});

parcelRegister("hoQ98", function(module, exports) {

$parcel$export(module.exports, "default", () => $caad20b69225c7a9$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $caad20b69225c7a9$var$LZWStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $9BULP.default));
var $caad20b69225c7a9$export$2e2bcd8739ae039 = $caad20b69225c7a9$var$LZWStream;

});

parcelRegister("oQP7X", function(module, exports) {

$parcel$export(module.exports, "default", () => $04ab37ade25dd344$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $04ab37ade25dd344$var$RunLengthStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $9BULP.default));
var $04ab37ade25dd344$export$2e2bcd8739ae039 = $04ab37ade25dd344$var$RunLengthStream;

});



parcelRegister("cpTWE", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", () => NonFullScreenPageMode);
$parcel$export(module.exports, "ReadingDirection", () => ReadingDirection);
$parcel$export(module.exports, "PrintScaling", () => PrintScaling);
$parcel$export(module.exports, "Duplex", () => Duplex);
$parcel$export(module.exports, "default", () => $90a3375623cd9a5a$export$2e2bcd8739ae039);

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $8gQNC.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $dPHSK.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool('HideToolbar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool('HideMenubar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool('HideWindowUI');
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool('FitWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool('CenterWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool('DisplayDocTitle');
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName('NonFullScreenPageMode');
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName('Direction');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName('PrintScaling');
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName('Duplex');
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool('PickTrayByPDFSize');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $dPHSK.default).of('PrintPageRange'));
        if (PrintPageRange instanceof (0, $8auL6.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $dPHSK.default).of('NumCopies'));
        if (NumCopies instanceof (0, $j04jt.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $j04jt.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $j04jt.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $dPHSK.default).of('HideToolbar'), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $dPHSK.default).of('HideMenubar'), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $dPHSK.default).of('HideWindowUI'), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $dPHSK.default).of('FitWindow'), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $dPHSK.default).of('CenterWindow'), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $dPHSK.default).of('DisplayDocTitle'), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $j0tvB.assertIsOneOf)(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
        var mode = (0, $dPHSK.default).of(nonFullScreenPageMode);
        this.dict.set((0, $dPHSK.default).of('NonFullScreenPageMode'), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $j0tvB.assertIsOneOf)(readingDirection, 'readingDirection', ReadingDirection);
        var direction = (0, $dPHSK.default).of(readingDirection);
        this.dict.set((0, $dPHSK.default).of('Direction'), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $j0tvB.assertIsOneOf)(printScaling, 'printScaling', PrintScaling);
        var scaling = (0, $dPHSK.default).of(printScaling);
        this.dict.set((0, $dPHSK.default).of('PrintScaling'), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $j0tvB.assertIsOneOf)(duplex, 'duplex', Duplex);
        var dup = (0, $dPHSK.default).of(duplex);
        this.dict.set((0, $dPHSK.default).of('Duplex'), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $dPHSK.default).of('PickTrayByPDFSize'), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $j0tvB.assertEachIs)(flatRange, 'printPageRange', [
            'number'
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $dPHSK.default).of('PrintPageRange'), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $j0tvB.assertRange)(numCopies, 'numCopies', 1, Number.MAX_VALUE);
        (0, $j0tvB.assertInteger)(numCopies, 'numCopies');
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $dPHSK.default).of('NumCopies'), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $90a3375623cd9a5a$export$2e2bcd8739ae039 = ViewerPreferences;

});

parcelRegister("b3l66", function(module, exports) {

$parcel$export(module.exports, "default", () => $80c05707f2c8c1f7$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");
parcelRequire("hO9YF");
var $flrAV = parcelRequire("flrAV");

var $cpTWE = parcelRequire("cpTWE");
var $80c05707f2c8c1f7$var$PDFCatalog = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $dPHSK.default).of('Pages'), (0, $brir8.default));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('AcroForm'), (0, $brir8.default));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $flrAV.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $flrAV.default).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $dPHSK.default).of('AcroForm'), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('ViewerPreferences'), (0, $brir8.default));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $cpTWE.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $cpTWE.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $dPHSK.default).of('ViewerPreferences'), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $dPHSK.default).of('Pages'));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Catalog'));
        dict.set((0, $dPHSK.default).of('Pages'), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $brir8.default));
var $80c05707f2c8c1f7$export$2e2bcd8739ae039 = $80c05707f2c8c1f7$var$PDFCatalog;

});
parcelRegister("hO9YF", function(module, exports) {
$parcel$export(module.exports, "AcroButtonFlags", () => (parcelRequire("d5IrD")).AcroButtonFlags);
$parcel$export(module.exports, "AcroChoiceFlags", () => (parcelRequire("d5IrD")).AcroChoiceFlags);
$parcel$export(module.exports, "AcroFieldFlags", () => (parcelRequire("d5IrD")).AcroFieldFlags);
$parcel$export(module.exports, "AcroTextFlags", () => (parcelRequire("d5IrD")).AcroTextFlags);
$parcel$export(module.exports, "createPDFAcroFields", () => (parcelRequire("gkGMc")).createPDFAcroFields);

$parcel$export(module.exports, "PDFAcroCheckBox", () => (parcelRequire("lmORt")).default);
$parcel$export(module.exports, "PDFAcroComboBox", () => (parcelRequire("4vDg3")).default);
$parcel$export(module.exports, "PDFAcroForm", () => (parcelRequire("flrAV")).default);
$parcel$export(module.exports, "PDFAcroListBox", () => (parcelRequire("gEqSi")).default);
$parcel$export(module.exports, "PDFAcroNonTerminal", () => (parcelRequire("dP7Ar")).default);
$parcel$export(module.exports, "PDFAcroPushButton", () => (parcelRequire("1757u")).default);
$parcel$export(module.exports, "PDFAcroRadioButton", () => (parcelRequire("hpItd")).default);
$parcel$export(module.exports, "PDFAcroSignature", () => (parcelRequire("7hDvO")).default);
$parcel$export(module.exports, "PDFAcroTerminal", () => (parcelRequire("64Z70")).default);
$parcel$export(module.exports, "PDFAcroText", () => (parcelRequire("clInn")).default);

var $bYlnh = parcelRequire("bYlnh");

var $lmORt = parcelRequire("lmORt");

var $1pFNX = parcelRequire("1pFNX");

var $4vDg3 = parcelRequire("4vDg3");

var $50MTm = parcelRequire("50MTm");

var $flrAV = parcelRequire("flrAV");

var $gEqSi = parcelRequire("gEqSi");

var $dP7Ar = parcelRequire("dP7Ar");

var $1757u = parcelRequire("1757u");

var $hpItd = parcelRequire("hpItd");

var $7hDvO = parcelRequire("7hDvO");

var $64Z70 = parcelRequire("64Z70");

var $clInn = parcelRequire("clInn");
parcelRequire("d5IrD");
parcelRequire("gkGMc");

});
parcelRegister("bYlnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b75e0d2aabd8761$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $64Z70 = parcelRequire("64Z70");

var $nAWRe = parcelRequire("nAWRe");
var $8b75e0d2aabd8761$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $8dCYu.default), (0, $jWFiV.default), (0, $8auL6.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $8dCYu.default) || opt instanceof (0, $jWFiV.default)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $8dCYu.default) || value instanceof (0, $jWFiV.default)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $8dCYu.default) || opt instanceof (0, $jWFiV.default)) {
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $jWFiV.default).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $dPHSK.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $64Z70.default));
var $8b75e0d2aabd8761$export$2e2bcd8739ae039 = $8b75e0d2aabd8761$var$PDFAcroButton;

});
parcelRegister("64Z70", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d285649821c095$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $50MTm = parcelRequire("50MTm");

var $7ds0z = parcelRequire("7ds0z");

var $nAWRe = parcelRequire("nAWRe");
var $46d285649821c095$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('FT'));
        return this.dict.context.lookup(nameOrRef, (0, $dPHSK.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $7ds0z.default).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $brir8.default));
            widgets[idx] = (0, $7ds0z.default).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $50MTm.default));
var $46d285649821c095$export$2e2bcd8739ae039 = $46d285649821c095$var$PDFAcroTerminal;

});
parcelRegister("50MTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a62e0bdc23bf2e5$export$2e2bcd8739ae039);

var $brir8 = parcelRequire("brir8");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");

var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $nAWRe = parcelRequire("nAWRe");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $3a62e0bdc23bf2e5$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $3a62e0bdc23bf2e5$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('T'), (0, $8dCYu.default), (0, $jWFiV.default));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('Ff'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('V'));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $8dCYu.default) || da instanceof (0, $jWFiV.default)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $dPHSK.default).of('Kids'), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $dPHSK.default).of('Parent'));
        if (parentRef instanceof (0, $kHzkO.default)) {
            var parent_1 = this.dict.lookup((0, $dPHSK.default).of('Parent'), (0, $brir8.default));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $dPHSK.default).of('Parent'));
        else this.dict.set((0, $dPHSK.default).of('Parent'), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $dPHSK.default).of('T'));
        else this.dict.set((0, $dPHSK.default).of('T'), (0, $jWFiV.default).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $8dCYu.default).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $jWFiV.default)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $nAWRe.MissingDAEntryError)(name);
        var daMatch = (0, $7Kmy8.findLastMatch)(da, $3a62e0bdc23bf2e5$var$tfRegex);
        if (!daMatch.match) throw new (0, $nAWRe.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('Ff'), (0, $j04jt.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $3a62e0bdc23bf2e5$export$2e2bcd8739ae039 = $3a62e0bdc23bf2e5$var$PDFAcroField;

});

parcelRegister("7ds0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $540f7922618e60a2$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $kHzkO = parcelRequire("kHzkO");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $2tiKE = parcelRequire("2tiKE");

var $frgJX = parcelRequire("frgJX");

var $6293R = parcelRequire("6293R");
var $540f7922618e60a2$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $dPHSK.default).of('MK'));
        if (MK instanceof (0, $brir8.default)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $dPHSK.default).of('BS'));
        if (BS instanceof (0, $brir8.default)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $8dCYu.default) || da instanceof (0, $jWFiV.default)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $dPHSK.default).of('P'));
        if (P instanceof (0, $kHzkO.default)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $dPHSK.default).of('P'), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $8dCYu.default).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $jWFiV.default)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $6293R.default).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $6293R.default).fromDict(MK);
        var ac = (0, $6293R.default).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('MK'), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $2tiKE.default).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $2tiKE.default).fromDict(BS);
        var bs = (0, $2tiKE.default).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('BS'), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $brir8.default)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $dPHSK.default).of('Off')) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: 'Annot',
            Subtype: 'Widget',
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $frgJX.default));
var $540f7922618e60a2$export$2e2bcd8739ae039 = $540f7922618e60a2$var$PDFWidgetAnnotation;

});
parcelRegister("2tiKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cccd5df89c90385$export$2e2bcd8739ae039);

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
// TODO: Also handle the `/S` and `/D` entries
var $1cccd5df89c90385$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $dPHSK.default).of('W'));
        if (W instanceof (0, $j04jt.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $dPHSK.default).of('W'), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $1cccd5df89c90385$export$2e2bcd8739ae039 = $1cccd5df89c90385$var$BorderStyle;

});

parcelRegister("frgJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d65ce7bc0fb74b$export$2e2bcd8739ae039);

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $4CgUJ = parcelRequire("4CgUJ");

var $8auL6 = parcelRequire("8auL6");

var $kHzkO = parcelRequire("kHzkO");

var $j04jt = parcelRequire("j04jt");
var $b3d65ce7bc0fb74b$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $dPHSK.default).of('Rect'), (0, $8auL6.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('AP'), (0, $brir8.default));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $dPHSK.default).of('F'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $dPHSK.default).of('Rect'), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $dPHSK.default).of('AS'));
        if (AS instanceof (0, $dPHSK.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $dPHSK.default).of('AS'), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $dPHSK.default).of('AP'), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $dPHSK.default).of('AP'), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $dPHSK.default).of('N'));
        if (N instanceof (0, $kHzkO.default) || N instanceof (0, $brir8.default)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('N'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('R'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('D'), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('R'));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('D'));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $dPHSK.default).of('N'), (0, $brir8.default), (0, $4CgUJ.default));
        var R = AP.lookupMaybe((0, $dPHSK.default).of('R'), (0, $brir8.default), (0, $4CgUJ.default));
        var D = AP.lookupMaybe((0, $dPHSK.default).of('D'), (0, $brir8.default), (0, $4CgUJ.default));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('F'), (0, $j04jt.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $b3d65ce7bc0fb74b$export$2e2bcd8739ae039 = $b3d65ce7bc0fb74b$var$PDFAnnotation;

});

parcelRegister("6293R", function(module, exports) {

$parcel$export(module.exports, "default", () => $4649f56151c7fd29$export$2e2bcd8739ae039);

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");

var $jWFiV = parcelRequire("jWFiV");

var $8dCYu = parcelRequire("8dCYu");
var $4649f56151c7fd29$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $dPHSK.default).of('R'));
        if (R instanceof (0, $j04jt.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $dPHSK.default).of('BC'));
        if (BC instanceof (0, $8auL6.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $dPHSK.default).of('BG'));
        if (BG instanceof (0, $8auL6.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $dPHSK.default).of('CA'));
        if (CA instanceof (0, $jWFiV.default) || CA instanceof (0, $8dCYu.default)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $dPHSK.default).of('RC'));
        if (RC instanceof (0, $jWFiV.default) || RC instanceof (0, $8dCYu.default)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $dPHSK.default).of('AC'));
        if (AC instanceof (0, $jWFiV.default) || AC instanceof (0, $8dCYu.default)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $dPHSK.default).of('R'), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BC'), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BG'), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $jWFiV.default).fromText(captions.normal);
        this.dict.set((0, $dPHSK.default).of('CA'), CA);
        if (captions.rollover) {
            var RC = (0, $jWFiV.default).fromText(captions.rollover);
            this.dict.set((0, $dPHSK.default).of('RC'), RC);
        } else this.dict.delete((0, $dPHSK.default).of('RC'));
        if (captions.down) {
            var AC = (0, $jWFiV.default).fromText(captions.down);
            this.dict.set((0, $dPHSK.default).of('AC'), AC);
        } else this.dict.delete((0, $dPHSK.default).of('AC'));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $4649f56151c7fd29$export$2e2bcd8739ae039 = $4649f56151c7fd29$var$AppearanceCharacteristics;

});




parcelRegister("lmORt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e31b0e21e15332$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $bYlnh = parcelRequire("bYlnh");

var $nAWRe = parcelRequire("nAWRe");
var $f8e31b0e21e15332$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        if (value !== onValue && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $bYlnh.default));
var $f8e31b0e21e15332$export$2e2bcd8739ae039 = $f8e31b0e21e15332$var$PDFAcroCheckBox;

});

parcelRegister("1pFNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $10788dcfb83fdb6c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $64Z70 = parcelRequire("64Z70");

var $jWFiV = parcelRequire("jWFiV");

var $8dCYu = parcelRequire("8dCYu");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $d5IrD = parcelRequire("d5IrD");

var $nAWRe = parcelRequire("nAWRe");
var $10788dcfb83fdb6c$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $d5IrD.AcroChoiceFlags).Combo) && !this.hasFlag((0, $d5IrD.AcroChoiceFlags).Edit) && !this.valuesAreValid(values)) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $dPHSK.default).of('V'));
        if (values.length === 1) this.dict.set((0, $dPHSK.default).of('V'), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $d5IrD.AcroChoiceFlags).MultiSelect)) throw new (0, $nAWRe.MultiSelectValueError)();
            this.dict.set((0, $dPHSK.default).of('V'), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $dPHSK.default).of('I'), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $dPHSK.default).of('I'));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $8dCYu.default) || v instanceof (0, $jWFiV.default)) return [
            v
        ];
        if (v instanceof (0, $8auL6.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $8dCYu.default) || value instanceof (0, $jWFiV.default)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $8dCYu.default), (0, $jWFiV.default), (0, $8auL6.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $8dCYu.default) || Opt instanceof (0, $jWFiV.default)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $8auL6.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $8dCYu.default) || item instanceof (0, $jWFiV.default)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $8auL6.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $8dCYu.default), (0, $jWFiV.default));
                        var second = item.lookupMaybe(1, (0, $8dCYu.default), (0, $jWFiV.default));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $64Z70.default));
var $10788dcfb83fdb6c$export$2e2bcd8739ae039 = $10788dcfb83fdb6c$var$PDFAcroChoice;

});
parcelRegister("d5IrD", function(module, exports) {

$parcel$export(module.exports, "AcroFieldFlags", () => $987e37c460e8464e$export$3600c95532547643);
$parcel$export(module.exports, "AcroButtonFlags", () => $987e37c460e8464e$export$59f660e89ffb4f8a);
$parcel$export(module.exports, "AcroTextFlags", () => $987e37c460e8464e$export$389fc7b97397dc8b);
$parcel$export(module.exports, "AcroChoiceFlags", () => $987e37c460e8464e$export$eb88827058402599);
var $987e37c460e8464e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $987e37c460e8464e$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $987e37c460e8464e$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $987e37c460e8464e$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $987e37c460e8464e$var$flag(2)] = "NoExport";
})($987e37c460e8464e$export$3600c95532547643 || ($987e37c460e8464e$export$3600c95532547643 = {}));
var $987e37c460e8464e$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $987e37c460e8464e$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $987e37c460e8464e$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $987e37c460e8464e$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $987e37c460e8464e$var$flag(25)] = "RadiosInUnison";
})($987e37c460e8464e$export$59f660e89ffb4f8a || ($987e37c460e8464e$export$59f660e89ffb4f8a = {}));
var $987e37c460e8464e$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $987e37c460e8464e$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $987e37c460e8464e$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $987e37c460e8464e$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $987e37c460e8464e$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $987e37c460e8464e$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $987e37c460e8464e$var$flag(25)] = "RichText";
})($987e37c460e8464e$export$389fc7b97397dc8b || ($987e37c460e8464e$export$389fc7b97397dc8b = {}));
var $987e37c460e8464e$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $987e37c460e8464e$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $987e37c460e8464e$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $987e37c460e8464e$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $987e37c460e8464e$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $987e37c460e8464e$var$flag(26)] = "CommitOnSelChange";
})($987e37c460e8464e$export$eb88827058402599 || ($987e37c460e8464e$export$eb88827058402599 = {}));

});


parcelRegister("4vDg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3488827c1474fcce$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $1pFNX = parcelRequire("1pFNX");

var $d5IrD = parcelRequire("d5IrD");
var $3488827c1474fcce$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Ff: (0, $d5IrD.AcroChoiceFlags).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $1pFNX.default));
var $3488827c1474fcce$export$2e2bcd8739ae039 = $3488827c1474fcce$var$PDFAcroComboBox;

});

parcelRegister("flrAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2be38e1e2597241$export$2e2bcd8739ae039);

var $brir8 = parcelRequire("brir8");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $dP7Ar = parcelRequire("dP7Ar");

var $gkGMc = parcelRequire("gkGMc");
var $b2be38e1e2597241$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $dPHSK.default).of('Fields'));
        if (fields instanceof (0, $8auL6.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $brir8.default));
            fields[idx] = [
                (0, $gkGMc.createPDFAcroField)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $dP7Ar.default)) pushFields((0, $gkGMc.createPDFAcroFields)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Fields'), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $b2be38e1e2597241$export$2e2bcd8739ae039 = $b2be38e1e2597241$var$PDFAcroForm;

});
parcelRegister("dP7Ar", function(module, exports) {

$parcel$export(module.exports, "default", () => $a105ec5aeb848914$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $50MTm = parcelRequire("50MTm");
var $a105ec5aeb848914$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $50MTm.default));
var $a105ec5aeb848914$export$2e2bcd8739ae039 = $a105ec5aeb848914$var$PDFAcroNonTerminal;

});

parcelRegister("gkGMc", function(module, exports) {

$parcel$export(module.exports, "createPDFAcroFields", () => $be3fb214968b38d5$export$34b4fb8893136c4c);
$parcel$export(module.exports, "createPDFAcroField", () => $be3fb214968b38d5$export$fe770f59a8fbe6d);

var $j04jt = parcelRequire("j04jt");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $8auL6 = parcelRequire("8auL6");

var $kHzkO = parcelRequire("kHzkO");

var $64Z70 = parcelRequire("64Z70");

var $dP7Ar = parcelRequire("dP7Ar");

var $7hDvO = parcelRequire("7hDvO");

var $clInn = parcelRequire("clInn");

var $1757u = parcelRequire("1757u");

var $hpItd = parcelRequire("hpItd");

var $lmORt = parcelRequire("lmORt");

var $4vDg3 = parcelRequire("4vDg3");

var $gEqSi = parcelRequire("gEqSi");

var $d5IrD = parcelRequire("d5IrD");
var $be3fb214968b38d5$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $kHzkO.default) && dict instanceof (0, $brir8.default)) kids.push([
            $be3fb214968b38d5$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $be3fb214968b38d5$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $be3fb214968b38d5$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $dP7Ar.default).fromDict(dict, ref);
    return $be3fb214968b38d5$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $be3fb214968b38d5$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $dPHSK.default).of('Kids'));
    if (kids instanceof (0, $8auL6.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $brir8.default) && kid.has((0, $dPHSK.default).of('T'));
        if (kidIsField) return true;
    }
    return false;
};
var $be3fb214968b38d5$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('FT'));
    var type = dict.context.lookup(ftNameOrRef, (0, $dPHSK.default));
    if (type === (0, $dPHSK.default).of('Btn')) return $be3fb214968b38d5$var$createPDFAcroButton(dict, ref);
    if (type === (0, $dPHSK.default).of('Ch')) return $be3fb214968b38d5$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $dPHSK.default).of('Tx')) return (0, $clInn.default).fromDict(dict, ref);
    if (type === (0, $dPHSK.default).of('Sig')) return (0, $7hDvO.default).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $64Z70.default).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $d5IrD.AcroButtonFlags).PushButton)) return (0, $1757u.default).fromDict(dict, ref);
    else if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $d5IrD.AcroButtonFlags).Radio)) return (0, $hpItd.default).fromDict(dict, ref);
    else return (0, $lmORt.default).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $d5IrD.AcroChoiceFlags).Combo)) return (0, $4vDg3.default).fromDict(dict, ref);
    else return (0, $gEqSi.default).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $be3fb214968b38d5$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $be3fb214968b38d5$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $be3fb214968b38d5$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $dPHSK.default).of('Parent'), (0, $brir8.default));
    if (Parent) $be3fb214968b38d5$var$ascend(Parent, visitor);
};

});
parcelRegister("7hDvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $54d8c5346cdc5323$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $64Z70 = parcelRequire("64Z70");
var $54d8c5346cdc5323$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $64Z70.default));
var $54d8c5346cdc5323$export$2e2bcd8739ae039 = $54d8c5346cdc5323$var$PDFAcroSignature;

});

parcelRegister("clInn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fd9de5d2343325e$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $64Z70 = parcelRequire("64Z70");
var $8fd9de5d2343325e$var$PDFAcroText = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $dPHSK.default).of('MaxLen'));
        if (maxLen instanceof (0, $j04jt.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $dPHSK.default).of('Q'));
        if (q instanceof (0, $j04jt.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $dPHSK.default).of('MaxLen'), (0, $j04jt.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $dPHSK.default).of('MaxLen'));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $dPHSK.default).of('Q'), (0, $j04jt.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $dPHSK.default).of('V'), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $dPHSK.default).of('V'));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $8dCYu.default) || v instanceof (0, $jWFiV.default)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: 'Tx',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $64Z70.default));
var $8fd9de5d2343325e$export$2e2bcd8739ae039 = $8fd9de5d2343325e$var$PDFAcroText;

});

parcelRegister("1757u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfa6a9523f95402$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $bYlnh = parcelRequire("bYlnh");

var $d5IrD = parcelRequire("d5IrD");
var $0cfa6a9523f95402$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $d5IrD.AcroButtonFlags).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $bYlnh.default));
var $0cfa6a9523f95402$export$2e2bcd8739ae039 = $0cfa6a9523f95402$var$PDFAcroPushButton;

});

parcelRegister("hpItd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad74455a26124b0$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $bYlnh = parcelRequire("bYlnh");

var $d5IrD = parcelRequire("d5IrD");

var $nAWRe = parcelRequire("nAWRe");
var $cad74455a26124b0$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $d5IrD.AcroButtonFlags).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $bYlnh.default));
var $cad74455a26124b0$export$2e2bcd8739ae039 = $cad74455a26124b0$var$PDFAcroRadioButton;

});

parcelRegister("gEqSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f53a89685317ba$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $1pFNX = parcelRequire("1pFNX");
var $c1f53a89685317ba$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $1pFNX.default));
var $c1f53a89685317ba$export$2e2bcd8739ae039 = $c1f53a89685317ba$var$PDFAcroListBox;

});





parcelRegister("4oH3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $333acd2e5fba0d32$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $eAof5 = parcelRequire("eAof5");

var $nAWRe = parcelRequire("nAWRe");
var $333acd2e5fba0d32$var$PDFPageTree = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $dPHSK.default).of('Parent'));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $dPHSK.default).of('Count'), (0, $j04jt.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $eAof5.default)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'insertLeafNode');
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $eAof5.default)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'removeLeafNode');
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $eAof5.default)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Pages'));
        dict.set((0, $dPHSK.default).of('Kids'), context.obj([]));
        dict.set((0, $dPHSK.default).of('Count'), context.obj(0));
        if (parent) dict.set((0, $dPHSK.default).of('Parent'), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $brir8.default));
var $333acd2e5fba0d32$export$2e2bcd8739ae039 = $333acd2e5fba0d32$var$PDFPageTree;

});

parcelRegister("3QRZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce01d1490df00cf$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $brir8 = parcelRequire("brir8");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $j04jt = parcelRequire("j04jt");

var $kx2r4 = parcelRequire("kx2r4");

var $kHzkO = parcelRequire("kHzkO");

var $8dCYu = parcelRequire("8dCYu");

var $hzVNG = parcelRequire("hzVNG");

var $cDaup = parcelRequire("cDaup");

var $b3l66 = parcelRequire("b3l66");

var $eAof5 = parcelRequire("eAof5");

var $4oH3u = parcelRequire("4oH3u");

var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $kThye = parcelRequire("kThye");

var $7qiVc = parcelRequire("7qiVc");

var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
// TODO: Throw error if eof is reached before finishing object parse...
var $2ce01d1490df00cf$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $kThye.Keywords).true)) return (0, $8gQNC.default).True;
        if (this.matchKeyword((0, $kThye.Keywords).false)) return (0, $8gQNC.default).False;
        if (this.matchKeyword((0, $kThye.Keywords).null)) return 0, $eTKUN.default;
        var byte = this.bytes.peek();
        if (byte === (0, $8zvel.default).LessThan && this.bytes.peekAhead(1) === (0, $8zvel.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $8zvel.default).LessThan) return this.parseHexString();
        if (byte === (0, $8zvel.default).LeftParen) return this.parseString();
        if (byte === (0, $8zvel.default).ForwardSlash) return this.parseName();
        if (byte === (0, $8zvel.default).LeftSquareBracket) return this.parseArray();
        if ((0, $7qiVc.IsNumeric)[byte]) return this.parseNumberOrRef();
        throw new (0, $nAWRe.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $7qiVc.IsDigit)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $8zvel.default).R) {
                this.bytes.assertNext((0, $8zvel.default).R);
                return (0, $kHzkO.default).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $j04jt.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = '';
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan)value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        return (0, $jWFiV.default).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $7Kmy8.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $8zvel.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $8zvel.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $8zvel.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $8dCYu.default).of(value.substring(1, value.length - 1));
        }
        throw new (0, $nAWRe.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $8zvel.default).ForwardSlash);
        var name = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $14u6w.IsWhitespace)[byte] || (0, $eOx0D.IsDelimiter)[byte]) break;
            name += (0, $7Kmy8.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $dPHSK.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $8zvel.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $8auL6.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $8zvel.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $8zvel.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $8zvel.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        var Type = dict.get((0, $dPHSK.default).of('Type'));
        if (Type === (0, $dPHSK.default).of('Catalog')) return (0, $b3l66.default).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Pages')) return (0, $4oH3u.default).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Page')) return (0, $eAof5.default).fromMapWithContext(dict, this.context);
        else return (0, $brir8.default).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).streamEOF1) && !this.matchKeyword((0, $kThye.Keywords).streamEOF2) && !this.matchKeyword((0, $kThye.Keywords).streamEOF3) && !this.matchKeyword((0, $kThye.Keywords).streamEOF4) && !this.matchKeyword((0, $kThye.Keywords).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $dPHSK.default).of('Length'));
        if (Length instanceof (0, $j04jt.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $kThye.Keywords).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $kx2r4.default).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $kThye.Keywords).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $kThye.Keywords).EOF1endstream) || this.matchKeyword((0, $kThye.Keywords).EOF2endstream) || this.matchKeyword((0, $kThye.Keywords).EOF3endstream) || this.matchKeyword((0, $kThye.Keywords).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $nAWRe.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $cDaup.default).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $hzVNG.default));
var $2ce01d1490df00cf$export$2e2bcd8739ae039 = $2ce01d1490df00cf$var$PDFObjectParser;

});
parcelRegister("hzVNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc28a798e23d674$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $7qiVc = parcelRequire("7qiVc");

var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ccc28a798e23d674$var$Newline = (0, $8zvel.default).Newline, $ccc28a798e23d674$var$CarriageReturn = (0, $8zvel.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $ccc28a798e23d674$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7qiVc.IsDigit)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = '';
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7qiVc.IsNumeric)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
            if (byte === (0, $8zvel.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7qiVc.IsDigit)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $14u6w.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $8zvel.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $ccc28a798e23d674$export$2e2bcd8739ae039 = $ccc28a798e23d674$var$BaseParser;

});
parcelRegister("7qiVc", function(module, exports) {

$parcel$export(module.exports, "IsDigit", () => $5679a387c9e20301$export$9492c31549e88980);
$parcel$export(module.exports, "IsNumeric", () => $5679a387c9e20301$export$4d926b029fa61cfe);

var $8zvel = parcelRequire("8zvel");
var $5679a387c9e20301$export$9492c31549e88980 = new Uint8Array(256);
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Zero] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).One] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Two] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Three] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Four] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Five] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Six] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Seven] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Eight] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Nine] = 1;
var $5679a387c9e20301$export$d438b84505bee68c = new Uint8Array(256);
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Period] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Plus] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Minus] = 1;
var $5679a387c9e20301$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $5679a387c9e20301$var$idx = 0, $5679a387c9e20301$var$len = 256; $5679a387c9e20301$var$idx < $5679a387c9e20301$var$len; $5679a387c9e20301$var$idx++)$5679a387c9e20301$export$4d926b029fa61cfe[$5679a387c9e20301$var$idx] = $5679a387c9e20301$export$9492c31549e88980[$5679a387c9e20301$var$idx] || $5679a387c9e20301$export$d438b84505bee68c[$5679a387c9e20301$var$idx] ? 1 : 0;

});


parcelRegister("cDaup", function(module, exports) {

$parcel$export(module.exports, "default", () => $93214384d2c510d6$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $dLMRX = parcelRequire("dLMRX");

var $8zvel = parcelRequire("8zvel");
// TODO: See how line/col tracking affects performance
var $93214384d2c510d6$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $8zvel.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $nAWRe.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $dLMRX.decodePDFRawStream)(rawStream).decode());
    };
    return ByteStream;
}();
var $93214384d2c510d6$export$2e2bcd8739ae039 = $93214384d2c510d6$var$ByteStream;

});

parcelRegister("kThye", function(module, exports) {

$parcel$export(module.exports, "Keywords", () => $f3568ef95260ec55$export$93ad50ccfacdd77);

var $cOQTW = parcelRequire("cOQTW");

var $8zvel = parcelRequire("8zvel");
var $f3568ef95260ec55$var$Space = (0, $8zvel.default).Space, $f3568ef95260ec55$var$CarriageReturn = (0, $8zvel.default).CarriageReturn, $f3568ef95260ec55$var$Newline = (0, $8zvel.default).Newline;
var $f3568ef95260ec55$var$stream = [
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$var$endstream = [
    (0, $8zvel.default).e,
    (0, $8zvel.default).n,
    (0, $8zvel.default).d,
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$export$93ad50ccfacdd77 = {
    header: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).P,
        (0, $8zvel.default).D,
        (0, $8zvel.default).F,
        (0, $8zvel.default).Dash
    ],
    eof: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).E,
        (0, $8zvel.default).O,
        (0, $8zvel.default).F
    ],
    obj: [
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    endobj: [
        (0, $8zvel.default).e,
        (0, $8zvel.default).n,
        (0, $8zvel.default).d,
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    xref: [
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    trailer: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).a,
        (0, $8zvel.default).i,
        (0, $8zvel.default).l,
        (0, $8zvel.default).e,
        (0, $8zvel.default).r
    ],
    startxref: [
        (0, $8zvel.default).s,
        (0, $8zvel.default).t,
        (0, $8zvel.default).a,
        (0, $8zvel.default).r,
        (0, $8zvel.default).t,
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    true: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).u,
        (0, $8zvel.default).e
    ],
    false: [
        (0, $8zvel.default).f,
        (0, $8zvel.default).a,
        (0, $8zvel.default).l,
        (0, $8zvel.default).s,
        (0, $8zvel.default).e
    ],
    null: [
        (0, $8zvel.default).n,
        (0, $8zvel.default).u,
        (0, $8zvel.default).l,
        (0, $8zvel.default).l
    ],
    stream: $f3568ef95260ec55$var$stream,
    streamEOF1: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Space,
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF2: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF3: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn
    ]),
    streamEOF4: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Newline
    ]),
    endstream: $f3568ef95260ec55$var$endstream,
    EOF1endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream),
    EOF2endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn
    ], $f3568ef95260ec55$var$endstream),
    EOF3endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream)
};

});


parcelRegister("7yUXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $016bbd830ce30da5$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $kHzkO = parcelRequire("kHzkO");

var $cDaup = parcelRequire("cDaup");

var $3QRZR = parcelRequire("3QRZR");
parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $016bbd830ce30da5$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $cDaup.default).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $dPHSK.default).of('First'), (0, $j04jt.default)).asNumber();
        _this.objectCount = dict.lookup((0, $dPHSK.default).of('N'), (0, $j04jt.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFObjectStreamParser', 'parseIntoContext');
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $kHzkO.default).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $3QRZR.default));
var $016bbd830ce30da5$export$2e2bcd8739ae039 = $016bbd830ce30da5$var$PDFObjectStreamParser;

});

parcelRegister("14nUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c78b71d995ee90b$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $Vy0LI = parcelRequire("Vy0LI");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $nAWRe = parcelRequire("nAWRe");

var $brir8 = parcelRequire("brir8");

var $eTWtL = parcelRequire("eTWtL");

var $dPHSK = parcelRequire("dPHSK");

var $kx2r4 = parcelRequire("kx2r4");

var $kHzkO = parcelRequire("kHzkO");

var $cDaup = parcelRequire("cDaup");

var $3QRZR = parcelRequire("3QRZR");

var $7yUXZ = parcelRequire("7yUXZ");

var $b1gaC = parcelRequire("b1gaC");

var $kl4jO = parcelRequire("kl4jO");

var $8zvel = parcelRequire("8zvel");

var $kThye = parcelRequire("kThye");

var $7qiVc = parcelRequire("7qiVc");
parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $0c78b71d995ee90b$var$PDFParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $cDaup.default).of(pdfBytes), (0, $kl4jO.default).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFParser', 'parseDocument');
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $nAWRe.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $kHzkO.default).of(0))) {
                            console.warn('Removing parsed object: 0 0 R');
                            this.context.delete((0, $kHzkO.default).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $brir8.default) && obj.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('Catalog');
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $kThye.Keywords).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $8zvel.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $eHlB9.default).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $nAWRe.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).obj)) throw new (0, $nAWRe.MissingKeywordError)(this.bytes.position(), (0, $kThye.Keywords).obj);
        return (0, $kHzkO.default).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $kThye.Keywords).endobj);
                        if (!(object instanceof (0, $kx2r4.default) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('ObjStm'))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $7yUXZ.default).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $kx2r4.default) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('XRef')) (0, $b1gaC.default).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $kThye.Keywords).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $nAWRe.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $kThye.Keywords).endobj.length;
        var object = (0, $eTWtL.default).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $7qiVc.IsDigit)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $Vy0LI.default).createEmpty();
        while(!this.bytes.done() && (0, $7qiVc.IsDigit)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $8zvel.default).n || byte === (0, $8zvel.default).f) {
                var ref = (0, $kHzkO.default).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $8zvel.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $dPHSK.default).of('Root')) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $dPHSK.default).of('Encrypt')) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $dPHSK.default).of('Info')) || context.trailerInfo.Info,
            ID: dict.get((0, $dPHSK.default).of('ID')) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $kThye.Keywords).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $kThye.Keywords).eof);
        this.skipWhitespaceAndComments();
        return (0, $4S3gv.default).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $8zvel.default).Space && byte <= (0, $8zvel.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $kThye.Keywords).xref) || this.matchKeyword((0, $kThye.Keywords).trailer) || this.matchKeyword((0, $kThye.Keywords).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $3QRZR.default));
var $0c78b71d995ee90b$export$2e2bcd8739ae039 = $0c78b71d995ee90b$var$PDFParser;

});
parcelRegister("b1gaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $805c54c8bff8c138$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $kHzkO = parcelRequire("kHzkO");

var $cDaup = parcelRequire("cDaup");
var $805c54c8bff8c138$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $cDaup.default).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $dPHSK.default).of('Size'), (0, $j04jt.default));
        var Index = this.dict.lookup((0, $dPHSK.default).of('Index'));
        if (Index instanceof (0, $8auL6.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $j04jt.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $j04jt.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $dPHSK.default).of('W'), (0, $8auL6.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $j04jt.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFXRefStreamParser', 'parseIntoContext');
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $dPHSK.default).of('Root')),
            Encrypt: this.dict.get((0, $dPHSK.default).of('Encrypt')),
            Info: this.dict.get((0, $dPHSK.default).of('Info')),
            ID: this.dict.get((0, $dPHSK.default).of('ID'))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $kHzkO.default).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $805c54c8bff8c138$export$2e2bcd8739ae039 = $805c54c8bff8c138$var$PDFXRefStreamParser;

});


parcelRegister("6anj6", function(module, exports) {
$parcel$export(module.exports, "AnnotationFlags", () => (parcelRequire("ckfWn")).AnnotationFlags);

$parcel$export(module.exports, "PDFWidgetAnnotation", () => (parcelRequire("7ds0z")).default);

var $frgJX = parcelRequire("frgJX");

var $7ds0z = parcelRequire("7ds0z");

var $6293R = parcelRequire("6293R");
parcelRequire("ckfWn");

});
parcelRegister("ckfWn", function(module, exports) {

$parcel$export(module.exports, "AnnotationFlags", () => $8f93b7bf8ef0f00e$export$1fa7b68b35026177);
var $8f93b7bf8ef0f00e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $8f93b7bf8ef0f00e$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $8f93b7bf8ef0f00e$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $8f93b7bf8ef0f00e$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $8f93b7bf8ef0f00e$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $8f93b7bf8ef0f00e$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $8f93b7bf8ef0f00e$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $8f93b7bf8ef0f00e$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $8f93b7bf8ef0f00e$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $8f93b7bf8ef0f00e$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $8f93b7bf8ef0f00e$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $8f93b7bf8ef0f00e$var$flag(9)] = "LockedContents";
})($8f93b7bf8ef0f00e$export$1fa7b68b35026177 || ($8f93b7bf8ef0f00e$export$1fa7b68b35026177 = {}));

});




parcelRegister("55HYh", function(module, exports) {

$parcel$export(module.exports, "degrees", () => $3b4f8728c2695c8d$export$41fc368e1a942b97);
$parcel$export(module.exports, "degreesToRadians", () => $3b4f8728c2695c8d$export$c9fcf1a7df975d78);
$parcel$export(module.exports, "toRadians", () => $3b4f8728c2695c8d$export$cba01ba138429a1d);
$parcel$export(module.exports, "toDegrees", () => $3b4f8728c2695c8d$export$56cb859c01fa134d);
$parcel$export(module.exports, "reduceRotation", () => $3b4f8728c2695c8d$export$ee0ed07fe78ec05);
$parcel$export(module.exports, "adjustDimsForRotation", () => $3b4f8728c2695c8d$export$312e44550db33c6a);
$parcel$export(module.exports, "rotateRectangle", () => $3b4f8728c2695c8d$export$afddc3b8600307a4);
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $3b4f8728c2695c8d$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($3b4f8728c2695c8d$export$c3cc0f63dbb3500f || ($3b4f8728c2695c8d$export$c3cc0f63dbb3500f = {}));
var $3b4f8728c2695c8d$export$8449e153fbd325fc = function(radianAngle) {
    (0, $j0tvB.assertIs)(radianAngle, 'radianAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $3b4f8728c2695c8d$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $j0tvB.assertIs)(degreeAngle, 'degreeAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $3b4f8728c2695c8d$var$Radians = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians, $3b4f8728c2695c8d$var$Degrees = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees;
var $3b4f8728c2695c8d$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $3b4f8728c2695c8d$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $3b4f8728c2695c8d$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? rotation.angle : rotation.type === $3b4f8728c2695c8d$var$Degrees ? $3b4f8728c2695c8d$export$c9fcf1a7df975d78(rotation.angle) : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? $3b4f8728c2695c8d$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $3b4f8728c2695c8d$var$Degrees ? rotation.angle : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $3b4f8728c2695c8d$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $3b4f8728c2695c8d$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};

});



parcelRegister("ibsNb", function(module, exports) {

$parcel$export(module.exports, "svgPathToOperators", () => $d3cf96a299d38647$export$8de5166f0a5bde2a);
// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $hPFvC = parcelRequire("hPFvC");
var $d3cf96a299d38647$var$cx = 0;
var $d3cf96a299d38647$var$cy = 0;
var $d3cf96a299d38647$var$px = 0;
var $d3cf96a299d38647$var$py = 0;
var $d3cf96a299d38647$var$sx = 0;
var $d3cf96a299d38647$var$sy = 0;
var $d3cf96a299d38647$var$parameters = new Map([
    [
        'A',
        7
    ],
    [
        'a',
        7
    ],
    [
        'C',
        6
    ],
    [
        'c',
        6
    ],
    [
        'H',
        1
    ],
    [
        'h',
        1
    ],
    [
        'L',
        2
    ],
    [
        'l',
        2
    ],
    [
        'M',
        2
    ],
    [
        'm',
        2
    ],
    [
        'Q',
        4
    ],
    [
        'q',
        4
    ],
    [
        'S',
        4
    ],
    [
        's',
        4
    ],
    [
        'T',
        2
    ],
    [
        't',
        2
    ],
    [
        'V',
        1
    ],
    [
        'v',
        1
    ],
    [
        'Z',
        0
    ],
    [
        'z',
        0
    ]
]);
var $d3cf96a299d38647$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = '';
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($d3cf96a299d38647$var$parameters.has(c)) {
            params = $d3cf96a299d38647$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = '';
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            ' ',
            ','
        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === 'M') cmd = 'L';
                if (cmd === 'm') cmd = 'l';
            } else args[args.length] = +curArg;
            foundDecimal = c === '.';
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                '-',
                '.'
            ].includes(c) ? c : '';
        } else {
            curArg += c;
            if (c === '.') foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === 'M') cmd = 'L';
            if (cmd === 'm') cmd = 'l';
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $d3cf96a299d38647$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $d3cf96a299d38647$var$runners[c.cmd] === 'function') {
            var cmd = $d3cf96a299d38647$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $d3cf96a299d38647$var$runners = {
    M: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $hPFvC.moveTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    m: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $hPFvC.moveTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    C: function(a) {
        $d3cf96a299d38647$var$cx = a[4];
        $d3cf96a299d38647$var$cy = a[5];
        $d3cf96a299d38647$var$px = a[2];
        $d3cf96a299d38647$var$py = a[3];
        return (0, $hPFvC.appendBezierCurve)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $hPFvC.appendBezierCurve)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy, a[4] + $d3cf96a299d38647$var$cx, a[5] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[2];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[3];
        $d3cf96a299d38647$var$cx += a[4];
        $d3cf96a299d38647$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $hPFvC.appendBezierCurve)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), a[0], a[1], a[2], a[3]);
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $hPFvC.appendBezierCurve)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1], $d3cf96a299d38647$var$cx + a[2], $d3cf96a299d38647$var$cy + a[3]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return (0, $hPFvC.appendQuadraticCurve)(a[0], a[1], $d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    q: function(a) {
        var cmd = (0, $hPFvC.appendQuadraticCurve)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $hPFvC.appendQuadraticCurve)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, a[0], a[1]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $hPFvC.appendQuadraticCurve)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1]);
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $d3cf96a299d38647$var$cx;
        a[6] += $d3cf96a299d38647$var$cy;
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    l: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    H: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    h: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    V: function(a) {
        $d3cf96a299d38647$var$cy = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    v: function(a) {
        $d3cf96a299d38647$var$cy += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    Z: function() {
        var cmd = (0, $hPFvC.closePath)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $hPFvC.closePath)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    }
};
var $d3cf96a299d38647$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $d3cf96a299d38647$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $d3cf96a299d38647$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $hPFvC.appendBezierCurve).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $d3cf96a299d38647$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $d3cf96a299d38647$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $d3cf96a299d38647$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $d3cf96a299d38647$var$px * $d3cf96a299d38647$var$px / (rx * rx) + $d3cf96a299d38647$var$py * $d3cf96a299d38647$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $d3cf96a299d38647$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $d3cf96a299d38647$export$8de5166f0a5bde2a = function(path) {
    return $d3cf96a299d38647$var$apply($d3cf96a299d38647$var$parse(path));
};

});


parcelRegister("d1UXb", function(module, exports) {

$parcel$export(module.exports, "layoutMultilineText", () => $97c78c294af7eaa8$export$f6ba9f13f815cc95);
$parcel$export(module.exports, "layoutCombedText", () => $97c78c294af7eaa8$export$deba41d88dd75dfc);
$parcel$export(module.exports, "layoutSinglelineText", () => $97c78c294af7eaa8$export$c0030606588cf6f2);

var $aYJvX = parcelRequire("aYJvX");

var $5rdXu = parcelRequire("5rdXu");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $97c78c294af7eaa8$var$MIN_FONT_SIZE = 4;
var $97c78c294af7eaa8$var$MAX_FONT_SIZE = 500;
var $97c78c294af7eaa8$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(' ');
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + ' ';
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    var chars = (0, $7Kmy8.charSplit)(line);
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $97c78c294af7eaa8$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $97c78c294af7eaa8$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $97c78c294af7eaa8$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $97c78c294af7eaa8$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $5rdXu.TextAlignment).Left ? bounds.x : alignment === (0, $5rdXu.TextAlignment).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $5rdXu.TextAlignment).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (line.length > cellCount) throw new (0, $aYJvX.CombedTextLayoutError)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $7Kmy8.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $5rdXu.TextAlignment).Left ? bounds.x : alignment === (0, $5rdXu.TextAlignment).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $5rdXu.TextAlignment).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};

});
parcelRegister("aYJvX", function(module, exports) {

$parcel$export(module.exports, "EncryptedPDFError", () => $7fe2d034822cb526$export$20fcceeca2b098d2);
$parcel$export(module.exports, "FontkitNotRegisteredError", () => $7fe2d034822cb526$export$529a7c74d0636a48);
$parcel$export(module.exports, "ForeignPageError", () => $7fe2d034822cb526$export$9564a4d28d94eae2);
$parcel$export(module.exports, "RemovePageFromEmptyDocumentError", () => $7fe2d034822cb526$export$cdca06c5927ddc2d);
$parcel$export(module.exports, "NoSuchFieldError", () => $7fe2d034822cb526$export$5bc08baa4a027cbd);
$parcel$export(module.exports, "UnexpectedFieldTypeError", () => $7fe2d034822cb526$export$8909da6c566ff652);
$parcel$export(module.exports, "FieldAlreadyExistsError", () => $7fe2d034822cb526$export$c428cfe4dc6c68df);
$parcel$export(module.exports, "InvalidFieldNamePartError", () => $7fe2d034822cb526$export$83c39fdacfe38500);
$parcel$export(module.exports, "RichTextFieldReadError", () => $7fe2d034822cb526$export$f2fed572e1ed57ab);
$parcel$export(module.exports, "CombedTextLayoutError", () => $7fe2d034822cb526$export$5283dffc620a5c9f);
$parcel$export(module.exports, "ExceededMaxLengthError", () => $7fe2d034822cb526$export$1577e99040d42609);
$parcel$export(module.exports, "InvalidMaxLengthError", () => $7fe2d034822cb526$export$6da6c372180e79b0);
// tslint:disable: max-classes-per-file

var $cOQTW = parcelRequire("cOQTW");
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $7fe2d034822cb526$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = "PDFDocument has no form field with the name \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $7fe2d034822cb526$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $7fe2d034822cb526$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $7fe2d034822cb526$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = "A field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $7fe2d034822cb526$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = "Field name contains invalid component: \"" + namePart + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $7fe2d034822cb526$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $7fe2d034822cb526$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $7fe2d034822cb526$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $7fe2d034822cb526$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $7fe2d034822cb526$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);

});

parcelRegister("5rdXu", function(module, exports) {

$parcel$export(module.exports, "TextAlignment", () => $010595e4078a43c6$export$84b2d1b68830363f);
var $010595e4078a43c6$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($010595e4078a43c6$export$84b2d1b68830363f || ($010595e4078a43c6$export$84b2d1b68830363f = {}));

});



parcelRegister("fphXB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3771f5aa96680ee$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $gYSUQ = parcelRequire("gYSUQ");

var $ikSoM = parcelRequire("ikSoM");

var $dgAbg = parcelRequire("dgAbg");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $1757u = parcelRequire("1757u");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $b3771f5aa96680ee$var$PDFButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroPushButton, 'acroButton', [
            [
                (0, $1757u.default),
                'PDFAcroPushButton'
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $gYSUQ.ImageAlignment).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $gidDr.rgb)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $gidDr.rgb)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $55HYh.degrees)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultButtonAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $dgAbg.default));
var $b3771f5aa96680ee$export$2e2bcd8739ae039 = $b3771f5aa96680ee$var$PDFButton;

});
parcelRegister("eq4Zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7f75cccfbb7eb6c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $gidDr = parcelRequire("gidDr");

var $7mLHs = parcelRequire("7mLHs");

var $hPFvC = parcelRequire("hPFvC");

var $cGbw3 = parcelRequire("cGbw3");

var $kUs6q = parcelRequire("kUs6q");

var $lzaL9 = parcelRequire("lzaL9");

var $7F2yc = parcelRequire("7F2yc");

var $j1dka = parcelRequire("j1dka");

var $55HYh = parcelRequire("55HYh");

var $i4gUC = parcelRequire("i4gUC");
parcelRequire("iT7lj");
var $8auL6 = parcelRequire("8auL6");
var $9EODP = parcelRequire("9EODP");
var $brir8 = parcelRequire("brir8");
var $dPHSK = parcelRequire("dPHSK");
var $5uV6d = parcelRequire("5uV6d");
var $eAof5 = parcelRequire("eAof5");
var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $7Kmy8 = parcelRequire("7Kmy8");
var $cbIAG = parcelRequire("cbIAG");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $a7f75cccfbb7eb6c$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $gidDr.rgb)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $j0tvB.assertIs)(leafNode, 'leafNode', [
            [
                (0, $eAof5.default),
                'PDFPageLeaf'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $55HYh.toDegrees)(angle);
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        this.node.set((0, $dPHSK.default).of('Rotate'), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $55HYh.degrees)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $cbIAG.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $cbIAG.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $cbIAG.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $cbIAG.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $hPFvC.pushGraphicsState)(), (0, $hPFvC.translate)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $hPFvC.popGraphicsState)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $hPFvC.pushGraphicsState)(), (0, $hPFvC.scale)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $hPFvC.popGraphicsState)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $brir8.default)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertIs)(fontSize, 'fontSize', [
            'number'
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $j0tvB.assertIs)(fontColor, 'fontColor', [
            [
                Object,
                'Color'
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $j0tvB.assertIs)(lineHeight, 'lineHeight', [
            'number'
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $j0tvB.assertIs)(yDecrease, 'yDecrease', [
            'number'
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $j0tvB.assertIs)(yIncrease, 'yIncrease', [
            'number'
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $j0tvB.assertIs)(xDecrease, 'xDecrease', [
            'number'
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $j0tvB.assertIs)(xIncrease, 'xIncrease', [
            'number'
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $j0tvB.assertEachIs)(operator, 'operator', [
            [
                (0, $5uV6d.default),
                'PDFOperator'
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.font, 'options.font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.size, 'options.size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.lineHeight, 'options.lineHeight', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.maxWidth, 'options.maxWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.wordBreaks, 'options.wordBreaks', [
            Array
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text)) : (0, $7Kmy8.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawLinesOfText)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $55HYh.degrees)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $55HYh.degrees)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $j0tvB.assertIs)(image, 'image', [
            [
                (0, $7F2yc.default),
                'PDFImage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var xObjectKey = this.node.newXObject('Image', image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawImage)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $55HYh.degrees)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $55HYh.degrees)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $j0tvB.assertIs)(embeddedPage, 'embeddedPage', [
            [
                (0, $kUs6q.default),
                'PDFEmbeddedPage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawPage)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $55HYh.degrees)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $55HYh.degrees)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(path, 'path', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.scale, 'options.scale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawSvgPath)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $j0tvB.assertIs)(options.start, 'options.start', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.end, 'options.end', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.start.x, 'options.start.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.start.y, 'options.start.y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.x, 'options.end.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.y, 'options.end.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.thickness, 'options.thickness', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashArray, 'options.dashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashPhase, 'options.dashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.lineCap, 'options.lineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!('color' in options)) options.color = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawLine)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawRectangle)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $55HYh.degrees)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $55HYh.degrees)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawRectangle((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawEllipse)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawEllipse((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $i4gUC.StandardFonts).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $9EODP.default).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: 'ExtGState',
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState('GS', graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            'RD',
            'CL',
            'Vertices',
            'QuadPoints',
            'L',
            'Rect'
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $dPHSK.default).of(selectors[idx]));
            if (list instanceof (0, $8auL6.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $dPHSK.default).of('InkList'));
        if (inkLists instanceof (0, $8auL6.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $8auL6.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        var dummyRef = (0, $kHzkO.default).of(-1);
        var pageLeaf = (0, $eAof5.default).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $a7f75cccfbb7eb6c$export$2e2bcd8739ae039 = $a7f75cccfbb7eb6c$var$PDFPage;

});
parcelRegister("cGbw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b2571d4e1dfe94$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $aYJvX = parcelRequire("aYJvX");

var $kUs6q = parcelRequire("kUs6q");

var $lzaL9 = parcelRequire("lzaL9");

var $7F2yc = parcelRequire("7F2yc");

var $eq4Zh = parcelRequire("eq4Zh");

var $2sybW = parcelRequire("2sybW");

var $gjdfV = parcelRequire("gjdfV");
parcelRequire("iT7lj");
var $gCJZ9 = parcelRequire("gCJZ9");
var $6uXKX = parcelRequire("6uXKX");
var $fmxHr = parcelRequire("fmxHr");
var $nAWRe = parcelRequire("nAWRe");
var $b3l66 = parcelRequire("b3l66");
var $kl4jO = parcelRequire("kl4jO");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
var $k5Uzj = parcelRequire("k5Uzj");
var $h9IbG = parcelRequire("h9IbG");
var $eAof5 = parcelRequire("eAof5");
var $4oH3u = parcelRequire("4oH3u");
var $14nUL = parcelRequire("14nUL");
var $7YdvF = parcelRequire("7YdvF");
var $8dCYu = parcelRequire("8dCYu");
var $5HlMk = parcelRequire("5HlMk");
var $atfwl = parcelRequire("atfwl");
var $jwvE5 = parcelRequire("jwvE5");

var $dJaLP = parcelRequire("dJaLP");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $fZ8o5 = parcelRequire("fZ8o5");
var $cbIAG = parcelRequire("cbIAG");

var $k8kub = parcelRequire("k8kub");

var $C6azw = parcelRequire("C6azw");

var $ceWew = parcelRequire("ceWew");

var $8gnuI = parcelRequire("8gnuI");
/**
 * Represents a PDF document.
 */ var $93b2571d4e1dfe94$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            ' '
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $eAof5.default)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $eq4Zh.default).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $2sybW.default).of(acroForm, _this);
        };
        (0, $j0tvB.assertIs)(context, 'context', [
            [
                (0, $kl4jO.default),
                'PDFContext'
            ]
        ]);
        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
            'boolean'
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $clYSv.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $clYSv.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $aYJvX.EncryptedPDFError)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $cOQTW.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $dJaLP.ParseSpeeds).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(parseSpeed, 'parseSpeed', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(throwOnInvalidObject, 'throwOnInvalidObject', [
                            'boolean'
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $14nUL.default).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $kl4jO.default).create();
                pageTree = (0, $4oH3u.default).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $b3l66.default).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $dPHSK.default).Title);
        if (!title) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $dPHSK.default).Author);
        if (!author) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $dPHSK.default).Subject);
        if (!subject) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $dPHSK.default).Keywords);
        if (!keywords) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $dPHSK.default).Creator);
        if (!creator) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $dPHSK.default).Producer);
        if (!producer) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $dPHSK.default).CreationDate);
        if (!creationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $dPHSK.default).ModDate);
        if (!modificationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $j0tvB.assertIs)(title, 'title', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Title');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $j0tvB.assertIs)(author, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Author');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $j0tvB.assertIs)(subject, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Subject');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $j0tvB.assertIs)(keywords, 'keywords', [
            Array
        ]);
        var key = (0, $dPHSK.default).of('Keywords');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(keywords.join(' ')));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $j0tvB.assertIs)(creator, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Creator');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $j0tvB.assertIs)(producer, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Producer');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $j0tvB.assertIs)(language, 'language', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Lang');
        this.catalog.set(key, (0, $8dCYu.default).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $j0tvB.assertIs)(creationDate, 'creationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('CreationDate');
        this.getInfoDict().set(key, (0, $8dCYu.default).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $j0tvB.assertIs)(modificationDate, 'modificationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('ModDate');
        this.getInfoDict().set(key, (0, $8dCYu.default).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $j0tvB.assertRange)(index, 'index', 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $4ISq8.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $aYJvX.RemovePageFromEmptyDocumentError)();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount);
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $gjdfV.PageSizes).A4;
            page = (0, $eq4Zh.default).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $aYJvX.ForeignPageError)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(srcDoc, 'srcDoc', [
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $k5Uzj.default).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $eq4Zh.default).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(script, 'script', [
            'string'
        ]);
        var embedder = (0, $8gnuI.default).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $ceWew.default).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $cOQTW.__generator)(this, function(_a) {
                (0, $j0tvB.assertIs)(attachment, 'attachment', [
                    'string',
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $j0tvB.assertIs)(name, 'name', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.mimeType, 'mimeType', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.description, 'description', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.creationDate, 'options.creationDate', [
                    Date
                ]);
                (0, $j0tvB.assertOrUndefined)(options.modificationDate, 'options.modificationDate', [
                    Date
                ]);
                (0, $j0tvB.assertIsOneOfOrUndefined)(options.afRelationship, 'options.afRelationship', (0, $k8kub.AFRelationship));
                bytes = (0, $4ISq8.toUint8Array)(attachment);
                embedder = (0, $k8kub.default).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $C6azw.default).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $j0tvB.assertIs)(font, 'font', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(subset, 'subset', [
                            'boolean'
                        ]);
                        if (!(0, $cbIAG.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $jwvE5.default).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $4ISq8.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $4ISq8.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $6uXKX.default).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $gCJZ9.default).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $lzaL9.default).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $j0tvB.assertIs)(font, 'font', [
            'string'
        ]);
        if (!(0, $cbIAG.isStandardFont)(font)) throw new TypeError('`font` must be one of type `StandardFonts`');
        var embedder = (0, $jwvE5.default).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $lzaL9.default).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(jpg, 'jpg', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $fmxHr.default).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $7F2yc.default).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(png, 'png', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $atfwl.default).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $7F2yc.default).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $4ISq8.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(page, 'page', [
                            [
                                (0, $eq4Zh.default),
                                'PDFPage'
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $nAWRe.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $k5Uzj.default).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $h9IbG.default).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $kUs6q.default).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $cOQTW.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $j0tvB.assertIs)(useObjectStreams, 'useObjectStreams', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(addDefaultPage, 'addDefaultPage', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(objectsPerTick, 'objectsPerTick', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(updateFieldAppearances, 'updateFieldAppearances', [
                            'boolean'
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $7YdvF.default) : (0, $5HlMk.default);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $cOQTW.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $j0tvB.assertIs)(dataUri, 'dataUri', [
                            'boolean'
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $fZ8o5.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $dPHSK.default).of('Creator'))) this.setCreator(pdfLib);
        if (!info.get((0, $dPHSK.default).of('CreationDate'))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $brir8.default)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $aYJvX.FontkitNotRegisteredError)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $93b2571d4e1dfe94$export$2e2bcd8739ae039 = $93b2571d4e1dfe94$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $jWFiV.default)) && !(pdfObject instanceof (0, $8dCYu.default))) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $jWFiV.default),
        (0, $8dCYu.default)
    ], pdfObject);
}

});
parcelRegister("kUs6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f38ed62eeee08801$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");
parcelRequire("iT7lj");
var $h9IbG = parcelRequire("h9IbG");
var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $f38ed62eeee08801$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $h9IbG.default),
                'PDFPageEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $f38ed62eeee08801$export$2e2bcd8739ae039 = $f38ed62eeee08801$var$PDFEmbeddedPage;

});

parcelRegister("lzaL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb353673e42bee9b$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");
parcelRequire("iT7lj");
var $gCJZ9 = parcelRequire("gCJZ9");
var $kHzkO = parcelRequire("kHzkO");
var $jwvE5 = parcelRequire("jwvE5");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $fb353673e42bee9b$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $gCJZ9.default),
                'CustomFontEmbedder'
            ],
            [
                (0, $jwvE5.default),
                'StandardFontEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', [
            'boolean'
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $jwvE5.default)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $fb353673e42bee9b$export$2e2bcd8739ae039 = $fb353673e42bee9b$var$PDFFont;

});

parcelRegister("7F2yc", function(module, exports) {

$parcel$export(module.exports, "default", () => $593e57425d0dad5a$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");
parcelRequire("iT7lj");
var $fmxHr = parcelRequire("fmxHr");
var $kHzkO = parcelRequire("kHzkO");
var $atfwl = parcelRequire("atfwl");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $593e57425d0dad5a$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $fmxHr.default),
                'JpegEmbedder'
            ],
            [
                (0, $atfwl.default),
                'PngEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $593e57425d0dad5a$export$2e2bcd8739ae039 = $593e57425d0dad5a$var$PDFImage;

});

parcelRegister("2sybW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ca8b80442f19ab5$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");

var $fphXB = parcelRequire("fphXB");

var $67hmm = parcelRequire("67hmm");

var $c2qg8 = parcelRequire("c2qg8");

var $5Apvp = parcelRequire("5Apvp");

var $1DKij = parcelRequire("1DKij");

var $hzhWN = parcelRequire("hzhWN");

var $lqhKQ = parcelRequire("lqhKQ");

var $aYJvX = parcelRequire("aYJvX");

var $lzaL9 = parcelRequire("lzaL9");

var $i4gUC = parcelRequire("i4gUC");

var $7mLHs = parcelRequire("7mLHs");

var $hPFvC = parcelRequire("hPFvC");
parcelRequire("iT7lj");
var $gkGMc = parcelRequire("gkGMc");
var $lmORt = parcelRequire("lmORt");
var $4vDg3 = parcelRequire("4vDg3");
var $flrAV = parcelRequire("flrAV");
var $gEqSi = parcelRequire("gEqSi");
var $dP7Ar = parcelRequire("dP7Ar");
var $1757u = parcelRequire("1757u");
var $hpItd = parcelRequire("hpItd");
var $7hDvO = parcelRequire("7hDvO");
var $clInn = parcelRequire("clInn");
var $brir8 = parcelRequire("brir8");
var $dPHSK = parcelRequire("dPHSK");
var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $1ca8b80442f19ab5$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $i4gUC.StandardFonts).Helvetica);
        };
        (0, $j0tvB.assertIs)(acroForm, 'acroForm', [
            [
                (0, $flrAV.default),
                'PDFAcroForm'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $clYSv.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $1ca8b80442f19ab5$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $aYJvX.NoSuchFieldError)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $fphXB.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $fphXB.default), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $67hmm.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $67hmm.default), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $c2qg8.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $c2qg8.default), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $5Apvp.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $5Apvp.default), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $1DKij.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $1DKij.default), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $hzhWN.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $hzhWN.default), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $lqhKQ.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $lqhKQ.default), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $1757u.default).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $fphXB.default).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $lmORt.default).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $67hmm.default).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $4vDg3.default).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $c2qg8.default).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $gEqSi.default).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $5Apvp.default).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $hpItd.default).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $1DKij.default).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $clInn.default).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $lqhKQ.default).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $cOQTW.__spreadArrays)([
                    (0, $hPFvC.pushGraphicsState)(),
                    (0, $hPFvC.translate)(rectangle.x, rectangle.y)
                ], (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $hPFvC.drawObject)(xObjectKey),
                    (0, $hPFvC.popGraphicsState)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $kHzkO.default)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $j0tvB.assertOrUndefined)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error('Could not find PDFRef for PDFObject');
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $brir8.default) && (field instanceof (0, $67hmm.default) || field instanceof (0, $1DKij.default))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $dPHSK.default).of('Off'));
            if (ref instanceof (0, $kHzkO.default)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $kHzkO.default))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $aYJvX.InvalidFieldNamePartError)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $dP7Ar.default).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $flrAV.default) ? this.acroForm.getFields() : (0, $gkGMc.createPDFAcroFields)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $dP7Ar.default)) return [
                    field,
                    ref
                ];
                throw new (0, $aYJvX.FieldAlreadyExistsError)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $1ca8b80442f19ab5$export$2e2bcd8739ae039 = $1ca8b80442f19ab5$var$PDFForm;
var $1ca8b80442f19ab5$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $1757u.default)) return (0, $fphXB.default).of(field, ref, doc);
    if (field instanceof (0, $lmORt.default)) return (0, $67hmm.default).of(field, ref, doc);
    if (field instanceof (0, $4vDg3.default)) return (0, $c2qg8.default).of(field, ref, doc);
    if (field instanceof (0, $gEqSi.default)) return (0, $5Apvp.default).of(field, ref, doc);
    if (field instanceof (0, $clInn.default)) return (0, $lqhKQ.default).of(field, ref, doc);
    if (field instanceof (0, $hpItd.default)) return (0, $1DKij.default).of(field, ref, doc);
    if (field instanceof (0, $7hDvO.default)) return (0, $hzhWN.default).of(field, ref, doc);
    return undefined;
};
var $1ca8b80442f19ab5$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error('PDF field names must not be empty strings');
    var parts = fullyQualifiedName.split('.');
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === '') throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $1ca8b80442f19ab5$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $gkGMc.createPDFAcroFields)('Kids' in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $aYJvX.FieldAlreadyExistsError)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};

});
parcelRegister("67hmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4740dcccc2940521$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");

var $dgAbg = parcelRequire("dgAbg");
parcelRequire("iT7lj");
var $lmORt = parcelRequire("lmORt");
var $brir8 = parcelRequire("brir8");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $4740dcccc2940521$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroCheckBox, 'acroCheckBox', [
            [
                (0, $lmORt.default),
                'PDFAcroCheckBox'
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, (0, $dPHSK.default).of('Yes'));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $brir8.default))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultCheckBoxAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $dgAbg.default));
var $4740dcccc2940521$export$2e2bcd8739ae039 = $4740dcccc2940521$var$PDFCheckBox;

});
parcelRegister("dgAbg", function(module, exports) {

$parcel$export(module.exports, "assertFieldAppearanceOptions", () => $9a88d5b8c9019f73$export$55643210f1835a35);
$parcel$export(module.exports, "default", () => $9a88d5b8c9019f73$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $ckfWn = parcelRequire("ckfWn");
var $nAWRe = parcelRequire("nAWRe");
var $64Z70 = parcelRequire("64Z70");
var $dPHSK = parcelRequire("dPHSK");
var $kHzkO = parcelRequire("kHzkO");
var $7ds0z = parcelRequire("7ds0z");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
parcelRequire("6vWdG");
var $gYSUQ = parcelRequire("gYSUQ");

var $7mLHs = parcelRequire("7mLHs");
var $9a88d5b8c9019f73$export$55643210f1835a35 = function(options) {
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, 'options.x', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, 'options.y', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, 'options.width', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, 'options.height', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [
        [
            Object,
            'Rotation'
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $9a88d5b8c9019f73$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $j0tvB.assertIs)(acroField, 'acroField', [
            [
                (0, $64Z70.default),
                'PDFAcroTerminal'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroFieldFlags).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroFieldFlags).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroFieldFlags).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'needsAppearancesUpdate');
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'defaultUpdateAppearances');
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $55HYh.toDegrees)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        // Create a widget for this field
        var widget = (0, $7ds0z.default).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $55HYh.rotateRectangle)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $gidDr.colorToComponents)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $gidDr.colorToComponents)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $ckfWn.AnnotationFlags).Print, true);
        widget.setFlagTo((0, $ckfWn.AnnotationFlags).Hidden, hidden);
        widget.setFlagTo((0, $ckfWn.AnnotationFlags).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
            var newDa = da + '\n' + (0, $gidDr.setFillingColor)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $55HYh.degrees)(0),
            xSkew: (0, $55HYh.degrees)(0),
            ySkew: (0, $55HYh.degrees)(0)
        };
        if (alignment === (0, $gYSUQ.ImageAlignment).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $gYSUQ.ImageAlignment).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix('Image', 10);
        var appearance = (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawImage)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $dPHSK.default).of('Off'), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $9a88d5b8c9019f73$export$2e2bcd8739ae039 = $9a88d5b8c9019f73$var$PDFField;

});
parcelRegister("6vWdG", function(module, exports) {
$parcel$export(module.exports, "ImageAlignment", () => (parcelRequire("gYSUQ")).ImageAlignment);
parcelRequire("gYSUQ");

});
parcelRegister("gYSUQ", function(module, exports) {

$parcel$export(module.exports, "ImageAlignment", () => $c5ccd91931a24d5b$export$8efa99ca8f041e7e);
var $c5ccd91931a24d5b$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($c5ccd91931a24d5b$export$8efa99ca8f041e7e || ($c5ccd91931a24d5b$export$8efa99ca8f041e7e = {}));

});




parcelRegister("c2qg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c3a0a776d3c65cf$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $4vDg3 = parcelRequire("4vDg3");
var $jWFiV = parcelRequire("jWFiV");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $8c3a0a776d3c65cf$var$PDFDropdown = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroComboBox, 'acroComboBox', [
            [
                (0, $4vDg3.default),
                'PDFAcroComboBox'
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $jWFiV.default).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $jWFiV.default).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $jWFiV.default).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultDropdownAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $dgAbg.default));
var $8c3a0a776d3c65cf$export$2e2bcd8739ae039 = $8c3a0a776d3c65cf$var$PDFDropdown;

});

parcelRegister("5Apvp", function(module, exports) {

$parcel$export(module.exports, "default", () => $41141972e5bafa05$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $gEqSi = parcelRequire("gEqSi");
var $jWFiV = parcelRequire("jWFiV");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $41141972e5bafa05$var$PDFOptionList = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroListBox, 'acroListBox', [
            [
                (0, $gEqSi.default),
                'PDFAcroListBox'
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $jWFiV.default).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $jWFiV.default).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsSubset)(optionsArr, 'option', validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $jWFiV.default).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultOptionListAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $dgAbg.default));
var $41141972e5bafa05$export$2e2bcd8739ae039 = $41141972e5bafa05$var$PDFOptionList;

});

parcelRegister("1DKij", function(module, exports) {

$parcel$export(module.exports, "default", () => $131d580cd94f5347$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $hpItd = parcelRequire("hpItd");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $131d580cd94f5347$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroRadioButton, 'acroRadioButton', [
            [
                (0, $hpItd.default),
                'PDFAcroRadioButton'
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $dPHSK.default).of('Off')) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsOneOf)(option, 'option', validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroButtonFlags).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroButtonFlags).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $gidDr.rgb)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $gidDr.rgb)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $gidDr.rgb)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $55HYh.degrees)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $jWFiV.default).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $brir8.default))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultRadioGroupAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $dgAbg.default));
var $131d580cd94f5347$export$2e2bcd8739ae039 = $131d580cd94f5347$var$PDFRadioGroup;

});

parcelRegister("hzhWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca3a084a6440272$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dgAbg = parcelRequire("dgAbg");
parcelRequire("iT7lj");
var $7hDvO = parcelRequire("7hDvO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $cca3a084a6440272$var$PDFSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroSignature, 'acroSignature', [
            [
                (0, $7hDvO.default),
                'PDFAcroSignature'
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $dgAbg.default));
var $cca3a084a6440272$export$2e2bcd8739ae039 = $cca3a084a6440272$var$PDFSignature;

});

parcelRegister("lqhKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f989cc5b81a68a40$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");

var $aYJvX = parcelRequire("aYJvX");

var $gYSUQ = parcelRequire("gYSUQ");

var $5rdXu = parcelRequire("5rdXu");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $clInn = parcelRequire("clInn");
var $jWFiV = parcelRequire("jWFiV");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $f989cc5b81a68a40$var$PDFTextField = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroText, 'acroText', [
            [
                (0, $clInn.default),
                'PDFAcroText'
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $aYJvX.RichTextFieldReadError)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $aYJvX.ExceededMaxLengthError)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $jWFiV.default).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $5rdXu.TextAlignment).Left : quadding === 1 ? (0, $5rdXu.TextAlignment).Center : quadding === 2 ? (0, $5rdXu.TextAlignment).Right : (0, $5rdXu.TextAlignment).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $j0tvB.assertIsOneOf)(alignment, 'alignment', (0, $5rdXu.TextAlignment));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $j0tvB.assertRangeOrUndefined)(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $aYJvX.InvalidMaxLengthError)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $5rdXu.TextAlignment).Center ? (0, $gYSUQ.ImageAlignment).Center : fieldAlignment === (0, $5rdXu.TextAlignment).Right ? (0, $gYSUQ.ImageAlignment).Right : (0, $gYSUQ.ImageAlignment).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultTextFieldAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $dgAbg.default));
var $f989cc5b81a68a40$export$2e2bcd8739ae039 = $f989cc5b81a68a40$var$PDFTextField;

});

parcelRegister("i4gUC", function(module, exports) {

$parcel$export(module.exports, "StandardFonts", () => $d275b823cf3c6e5b$export$7dcb046109e65a3d);
var $d275b823cf3c6e5b$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($d275b823cf3c6e5b$export$7dcb046109e65a3d || ($d275b823cf3c6e5b$export$7dcb046109e65a3d = {}));

});


parcelRegister("gjdfV", function(module, exports) {

$parcel$export(module.exports, "PageSizes", () => $bdf8b405f72f9bf0$export$b4a05ae367f5515c);
var $bdf8b405f72f9bf0$export$b4a05ae367f5515c = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};

});

parcelRegister("dJaLP", function(module, exports) {

$parcel$export(module.exports, "ParseSpeeds", () => $9fe7d517881d9f8b$export$ba19d141a3749548);
var $9fe7d517881d9f8b$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($9fe7d517881d9f8b$export$ba19d141a3749548 || ($9fe7d517881d9f8b$export$ba19d141a3749548 = {}));

});

parcelRegister("C6azw", function(module, exports) {

$parcel$export(module.exports, "default", () => $072855dc9321c2b4$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("iT7lj");
var $8auL6 = parcelRequire("8auL6");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $072855dc9321c2b4$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $dPHSK.default).of('Names'))) this.doc.catalog.set((0, $dPHSK.default).of('Names'), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $dPHSK.default).of('Names'), (0, $brir8.default));
                        if (!Names.has((0, $dPHSK.default).of('EmbeddedFiles'))) Names.set((0, $dPHSK.default).of('EmbeddedFiles'), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $dPHSK.default).of('EmbeddedFiles'), (0, $brir8.default));
                        if (!EmbeddedFiles.has((0, $dPHSK.default).of('Names'))) EmbeddedFiles.set((0, $dPHSK.default).of('Names'), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        EFNames.push((0, $jWFiV.default).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $dPHSK.default).of('AF'))) this.doc.catalog.set((0, $dPHSK.default).of('AF'), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $dPHSK.default).of('AF'), (0, $8auL6.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $072855dc9321c2b4$export$2e2bcd8739ae039 = $072855dc9321c2b4$var$PDFEmbeddedFile;

});

parcelRegister("ceWew", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e93f6bd1fec6f6e$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("iT7lj");
var $8auL6 = parcelRequire("8auL6");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $8e93f6bd1fec6f6e$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $dPHSK.default).of('Names'))) catalog.set((0, $dPHSK.default).of('Names'), context.obj({}));
                        Names = catalog.lookup((0, $dPHSK.default).of('Names'), (0, $brir8.default));
                        if (!Names.has((0, $dPHSK.default).of('JavaScript'))) Names.set((0, $dPHSK.default).of('JavaScript'), context.obj({}));
                        Javascript = Names.lookup((0, $dPHSK.default).of('JavaScript'), (0, $brir8.default));
                        if (!Javascript.has((0, $dPHSK.default).of('Names'))) Javascript.set((0, $dPHSK.default).of('Names'), context.obj([]));
                        JSNames = Javascript.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        JSNames.push((0, $jWFiV.default).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $8e93f6bd1fec6f6e$export$2e2bcd8739ae039 = $8e93f6bd1fec6f6e$var$PDFJavaScript;

});

parcelRegister("8gnuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $60420ad6933b406d$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $jWFiV = parcelRequire("jWFiV");
var $60420ad6933b406d$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: 'Action',
                    S: 'JavaScript',
                    JS: (0, $jWFiV.default).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $60420ad6933b406d$export$2e2bcd8739ae039 = $60420ad6933b406d$var$JavaScriptEmbedder;

});


parcelRegister("j1dka", function(module, exports) {

$parcel$export(module.exports, "BlendMode", () => $dd8872426cc55b05$export$c9b8fe72ac71821);
var $dd8872426cc55b05$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($dd8872426cc55b05$export$c9b8fe72ac71821 || ($dd8872426cc55b05$export$c9b8fe72ac71821 = {}));

});




parcelRegister("5yZPW", function(module, exports) {
parcelRequire("5rdXu");
parcelRequire("d1UXb");

});


parcelRegister("4J7XC", function(module, exports) {

});


parcelRegister("4UBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3939d1de148b5202$export$2e2bcd8739ae039);

var $ckCqy = parcelRequire("ckCqy");
var $3939d1de148b5202$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $3939d1de148b5202$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
function $3939d1de148b5202$var$getCjsExportFromNamespace(n) {
    return n && n['default'] || n;
}
var $3939d1de148b5202$var$byteLength_1 = $3939d1de148b5202$var$byteLength;
var $3939d1de148b5202$var$toByteArray_1 = $3939d1de148b5202$var$toByteArray;
var $3939d1de148b5202$var$fromByteArray_1 = $3939d1de148b5202$var$fromByteArray;
var $3939d1de148b5202$var$lookup = [];
var $3939d1de148b5202$var$revLookup = [];
var $3939d1de148b5202$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3939d1de148b5202$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3939d1de148b5202$var$i = 0, $3939d1de148b5202$var$len = $3939d1de148b5202$var$code.length; $3939d1de148b5202$var$i < $3939d1de148b5202$var$len; ++$3939d1de148b5202$var$i){
    $3939d1de148b5202$var$lookup[$3939d1de148b5202$var$i] = $3939d1de148b5202$var$code[$3939d1de148b5202$var$i];
    $3939d1de148b5202$var$revLookup[$3939d1de148b5202$var$code.charCodeAt($3939d1de148b5202$var$i)] = $3939d1de148b5202$var$i;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3939d1de148b5202$var$revLookup['-'.charCodeAt(0)] = 62;
$3939d1de148b5202$var$revLookup['_'.charCodeAt(0)] = 63;
function $3939d1de148b5202$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
     // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
} // base64 is 4/3 + up to two characters of the original data
function $3939d1de148b5202$var$byteLength(b64) {
    var lens = $3939d1de148b5202$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3939d1de148b5202$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3939d1de148b5202$var$toByteArray(b64) {
    var tmp;
    var lens = $3939d1de148b5202$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3939d1de148b5202$var$Arr($3939d1de148b5202$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3939d1de148b5202$var$revLookup[b64.charCodeAt(i)] << 18 | $3939d1de148b5202$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3939d1de148b5202$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3939d1de148b5202$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3939d1de148b5202$var$revLookup[b64.charCodeAt(i)] << 2 | $3939d1de148b5202$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3939d1de148b5202$var$revLookup[b64.charCodeAt(i)] << 10 | $3939d1de148b5202$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3939d1de148b5202$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3939d1de148b5202$var$tripletToBase64(num) {
    return $3939d1de148b5202$var$lookup[num >> 18 & 0x3F] + $3939d1de148b5202$var$lookup[num >> 12 & 0x3F] + $3939d1de148b5202$var$lookup[num >> 6 & 0x3F] + $3939d1de148b5202$var$lookup[num & 0x3F];
}
function $3939d1de148b5202$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3939d1de148b5202$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3939d1de148b5202$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3939d1de148b5202$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
     // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3939d1de148b5202$var$lookup[tmp >> 2] + $3939d1de148b5202$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3939d1de148b5202$var$lookup[tmp >> 10] + $3939d1de148b5202$var$lookup[tmp >> 4 & 0x3F] + $3939d1de148b5202$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $3939d1de148b5202$var$base64Js = {
    byteLength: $3939d1de148b5202$var$byteLength_1,
    toByteArray: $3939d1de148b5202$var$toByteArray_1,
    fromByteArray: $3939d1de148b5202$var$fromByteArray_1
};
var $3939d1de148b5202$var$read = function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
var $3939d1de148b5202$var$write = function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
var $3939d1de148b5202$var$ieee754 = {
    read: $3939d1de148b5202$var$read,
    write: $3939d1de148b5202$var$write
};
var $3939d1de148b5202$var$buffer = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol["for"] === 'function' ? Symbol["for"]('nodejs.util.inspect.custom') : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Print warning and recommend using `buffer` v4.x which has an Object
   *               implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * We report that the browser does not support typed arrays if the are not subclassable
   * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
   * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
   * for __proto__ and has a buggy typed array implementation.
   */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            var arr = new Uint8Array(1);
            var proto = {
                foo: function foo() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, 'parent', {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, 'offset', {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
         // Return an augmented `Uint8Array` instance
        var buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === 'number') {
            if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === 'string') return fromString(value, encodingOrOffset);
        if (ArrayBuffer.isView(value)) return fromArrayLike(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
        var valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        var b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    }; // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer, Uint8Array);
    function assertSize(size) {
        if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
        if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        var length = byteLength(string, encoding) | 0;
        var buf = createBuffer(length);
        var actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        var length = array.length < 0 ? 0 : checked(array.length) | 0;
        var buf = createBuffer(length);
        for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        var buf;
        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
        else buf = new Uint8Array(array, byteOffset, length);
         // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            var len = checked(obj.length) | 0;
            var buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) // eslint-disable-line eqeqeq
        length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        var i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        var buffer = Buffer.allocUnsafe(length);
        var pos = 0;
        for(i = 0; i < list.length; ++i){
            var buf = list[i];
            if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
            if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
        if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        var len = string.length;
        var mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0; // Use a for loop to avoid recursion
        var loweredCase = false;
        for(;;)switch(encoding){
            case 'ascii':
            case 'latin1':
            case 'binary':
                return len;
            case 'utf8':
            case 'utf-8':
                return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return len * 2;
            case 'hex':
                return len >>> 1;
            case 'base64':
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
         // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return '';
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return '';
         // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return '';
        if (!encoding) encoding = 'utf8';
        while(true)switch(encoding){
            case 'hex':
                return hexSlice(this, start, end);
            case 'utf8':
            case 'utf-8':
                return utf8Slice(this, start, end);
            case 'ascii':
                return asciiSlice(this, start, end);
            case 'latin1':
            case 'binary':
                return latin1Slice(this, start, end);
            case 'base64':
                return base64Slice(this, start, end);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = (encoding + '').toLowerCase();
                loweredCase = true;
        }
    } // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        var i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        var len = this.length;
        if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
        for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        var len = this.length;
        if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
        for(var i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        var len = this.length;
        if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
        for(var i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        var length = this.length;
        if (length === 0) return '';
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        var str = '';
        var max = exports.INSPECT_MAX_BYTES;
        str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
        if (this.length > max) str += ' ... ';
        return '<Buffer ' + str + '>';
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        var x = thisEnd - thisStart;
        var y = end - start;
        var len = Math.min(x, y);
        var thisCopy = this.slice(thisStart, thisEnd);
        var targetCopy = target.slice(start, end);
        for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1; // Normalize byteOffset
        if (typeof byteOffset === 'string') {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
         // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        } // Normalize val
        if (typeof val === 'string') val = Buffer.from(val, encoding);
         // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === 'number') {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof Uint8Array.prototype.indexOf === 'function') {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError('val must be string, number or Buffer');
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        var indexSize = 1;
        var arrLength = arr.length;
        var valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        var i;
        if (dir) {
            var foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                var found = true;
                for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        var remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        var strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        for(var i = 0; i < length; ++i){
            var parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function latin1Write(buf, string, offset, length) {
        return asciiWrite(buf, string, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = 'utf8';
            length = this.length;
            offset = 0; // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === 'string') {
            encoding = offset;
            length = this.length;
            offset = 0; // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = 'utf8';
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
        var remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
        if (!encoding) encoding = 'utf8';
        var loweredCase = false;
        for(;;)switch(encoding){
            case 'hex':
                return hexWrite(this, string, offset, length);
            case 'utf8':
            case 'utf-8':
                return utf8Write(this, string, offset, length);
            case 'ascii':
                return asciiWrite(this, string, offset, length);
            case 'latin1':
            case 'binary':
                return latin1Write(this, string, offset, length);
            case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: 'Buffer',
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return $3939d1de148b5202$var$base64Js.fromByteArray(buf);
        else return $3939d1de148b5202$var$base64Js.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        var res = [];
        var i = start;
        while(i < end){
            var firstByte = buf[i];
            var codePoint = null;
            var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        var len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
         // Decode in chunks to avoid "call stack size exceeded".
        var res = '';
        var i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        var len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        var out = '';
        for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        var bytes = buf.slice(start, end);
        var res = '';
        for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        var len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        var newBuf = this.subarray(start, end); // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }
    Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset + --byteLength];
        var mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var i = byteLength;
        var mul = 1;
        var val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return $3939d1de148b5202$var$ieee754.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return $3939d1de148b5202$var$ieee754.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return $3939d1de148b5202$var$ieee754.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return $3939d1de148b5202$var$ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }
    Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var mul = 1;
        var i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var i = byteLength - 1;
        var mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = 0;
        var mul = 1;
        var sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = byteLength - 1;
        var mul = 1;
        var sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
        if (offset < 0) throw new RangeError('Index out of range');
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        $3939d1de148b5202$var$ieee754.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        $3939d1de148b5202$var$ieee754.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions
        if (targetStart < 0) throw new RangeError('targetStart out of bounds');
        if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
        if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        var len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else if (this === target && start < targetStart && targetStart < end) // descending copy from end
        for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    }; // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === 'string') {
            if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
            if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === 'number') val = val & 255;
        else if (typeof val === 'boolean') val = Number(val);
         // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        var i;
        if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
        else {
            var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            var len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    }; // HELPER FUNCTIONS
    // ================
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split('=')[0]; // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''
        if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + '=';
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        var codePoint;
        var length = string.length;
        var leadSurrogate = null;
        var bytes = [];
        for(var i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i); // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } // valid lead
                    leadSurrogate = codePoint;
                    continue;
                } // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                } // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null; // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error('Invalid code point');
        }
        return bytes;
    }
    function asciiToBytes(str) {
        var byteArray = [];
        for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        var c, hi, lo;
        var byteArray = [];
        for(var i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return $3939d1de148b5202$var$base64Js.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        for(var i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    } // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj; // eslint-disable-line no-self-compare
    } // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    var hexSliceLookupTable = function() {
        var alphabet = '0123456789abcdef';
        var table = new Array(256);
        for(var i = 0; i < 16; ++i){
            var i16 = i * 16;
            for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
});
var $3939d1de148b5202$var$buffer_1 = $3939d1de148b5202$var$buffer.Buffer;
var $3939d1de148b5202$var$buffer_2 = $3939d1de148b5202$var$buffer.SlowBuffer;
var $3939d1de148b5202$var$buffer_3 = $3939d1de148b5202$var$buffer.INSPECT_MAX_BYTES;
var $3939d1de148b5202$var$buffer_4 = $3939d1de148b5202$var$buffer.kMaxLength;
var $3939d1de148b5202$var$domain; // This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function $3939d1de148b5202$var$EventHandlers() {}
$3939d1de148b5202$var$EventHandlers.prototype = Object.create(null);
function $3939d1de148b5202$var$EventEmitter() {
    $3939d1de148b5202$var$EventEmitter.init.call(this);
}
// require('events') === require('events').EventEmitter
$3939d1de148b5202$var$EventEmitter.EventEmitter = $3939d1de148b5202$var$EventEmitter;
$3939d1de148b5202$var$EventEmitter.usingDomains = false;
$3939d1de148b5202$var$EventEmitter.prototype.domain = undefined;
$3939d1de148b5202$var$EventEmitter.prototype._events = undefined;
$3939d1de148b5202$var$EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$3939d1de148b5202$var$EventEmitter.defaultMaxListeners = 10;
$3939d1de148b5202$var$EventEmitter.init = function() {
    this.domain = null;
    if ($3939d1de148b5202$var$EventEmitter.usingDomains) // if there is an active domain, then attach to it.
    $3939d1de148b5202$var$domain.active;
    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
        this._events = new $3939d1de148b5202$var$EventHandlers();
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
}; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$3939d1de148b5202$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
};
function $3939d1de148b5202$var$$getMaxListeners(that) {
    if (that._maxListeners === undefined) return $3939d1de148b5202$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$3939d1de148b5202$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $3939d1de148b5202$var$$getMaxListeners(this);
}; // These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function $3939d1de148b5202$var$emitNone(handler, isFn, self1) {
    if (isFn) handler.call(self1);
    else {
        var len = handler.length;
        var listeners = $3939d1de148b5202$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1);
    }
}
function $3939d1de148b5202$var$emitOne(handler, isFn, self1, arg1) {
    if (isFn) handler.call(self1, arg1);
    else {
        var len = handler.length;
        var listeners = $3939d1de148b5202$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
    }
}
function $3939d1de148b5202$var$emitTwo(handler, isFn, self1, arg1, arg2) {
    if (isFn) handler.call(self1, arg1, arg2);
    else {
        var len = handler.length;
        var listeners = $3939d1de148b5202$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
    }
}
function $3939d1de148b5202$var$emitThree(handler, isFn, self1, arg1, arg2, arg3) {
    if (isFn) handler.call(self1, arg1, arg2, arg3);
    else {
        var len = handler.length;
        var listeners = $3939d1de148b5202$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
    }
}
function $3939d1de148b5202$var$emitMany(handler, isFn, self1, args) {
    if (isFn) handler.apply(self1, args);
    else {
        var len = handler.length;
        var listeners = $3939d1de148b5202$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
    }
}
$3939d1de148b5202$var$EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = type === 'error';
    events = this._events;
    if (events) doError = doError && events.error == null;
    else if (!doError) return false;
    domain = this.domain; // If there is no 'error' event listener then throw.
    if (doError) {
        er = arguments[1];
        if (domain) {
            if (!er) er = new Error('Uncaught, unspecified "error" event');
            er.domainEmitter = this;
            er.domain = domain;
            er.domainThrown = false;
            domain.emit('error', er);
        } else if (er instanceof Error) throw er; // Unhandled 'error' event
        else {
            // At least give some kind of context to the user
            var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
            err.context = er;
            throw err;
        }
        return false;
    }
    handler = events[type];
    if (!handler) return false;
    var isFn = typeof handler === 'function';
    len = arguments.length;
    switch(len){
        // fast cases
        case 1:
            $3939d1de148b5202$var$emitNone(handler, isFn, this);
            break;
        case 2:
            $3939d1de148b5202$var$emitOne(handler, isFn, this, arguments[1]);
            break;
        case 3:
            $3939d1de148b5202$var$emitTwo(handler, isFn, this, arguments[1], arguments[2]);
            break;
        case 4:
            $3939d1de148b5202$var$emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
            break;
        // slower
        default:
            args = new Array(len - 1);
            for(i = 1; i < len; i++)args[i - 1] = arguments[i];
            $3939d1de148b5202$var$emitMany(handler, isFn, this, args);
    }
    return true;
};
function $3939d1de148b5202$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = target._events;
    if (!events) {
        events = target._events = new $3939d1de148b5202$var$EventHandlers();
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (!existing) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else // If we've already got an array, just append.
        if (prepend) existing.unshift(listener);
        else existing.push(listener);
         // Check for listener leak
        if (!existing.warned) {
            m = $3939d1de148b5202$var$$getMaxListeners(target);
            if (m && m > 0 && existing.length > m) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $3939d1de148b5202$var$emitWarning(w);
            }
        }
    }
    return target;
}
function $3939d1de148b5202$var$emitWarning(e) {
    typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
$3939d1de148b5202$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $3939d1de148b5202$var$_addListener(this, type, listener, false);
};
$3939d1de148b5202$var$EventEmitter.prototype.on = $3939d1de148b5202$var$EventEmitter.prototype.addListener;
$3939d1de148b5202$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $3939d1de148b5202$var$_addListener(this, type, listener, true);
};
function $3939d1de148b5202$var$_onceWrap(target, type, listener) {
    var fired = false;
    function g() {
        target.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(target, arguments);
        }
    }
    g.listener = listener;
    return g;
}
$3939d1de148b5202$var$EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.on(type, $3939d1de148b5202$var$_onceWrap(this, type, listener));
    return this;
};
$3939d1de148b5202$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.prependListener(type, $3939d1de148b5202$var$_onceWrap(this, type, listener));
    return this;
}; // emits a 'removeListener' event iff the listener was removed
$3939d1de148b5202$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events) return this;
    list = events[type];
    if (!list) return this;
    if (list === listener || list.listener && list.listener === listener) {
        if (--this._eventsCount === 0) this._events = new $3939d1de148b5202$var$EventHandlers();
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list[0] = undefined;
            if (--this._eventsCount === 0) {
                this._events = new $3939d1de148b5202$var$EventHandlers();
                return this;
            } else delete events[type];
        } else $3939d1de148b5202$var$spliceOne(list, position);
        if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$3939d1de148b5202$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events;
    events = this._events;
    if (!events) return this; // not listening for removeListener, no need to emit
    if (!events.removeListener) {
        if (arguments.length === 0) {
            this._events = new $3939d1de148b5202$var$EventHandlers();
            this._eventsCount = 0;
        } else if (events[type]) {
            if (--this._eventsCount === 0) this._events = new $3939d1de148b5202$var$EventHandlers();
            else delete events[type];
        }
        return this;
    } // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        for(var i = 0, key; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new $3939d1de148b5202$var$EventHandlers();
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    do this.removeListener(type, listeners[listeners.length - 1]);
    while (listeners[0]);
    return this;
};
$3939d1de148b5202$var$EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events) ret = [];
    else {
        evlistener = events[type];
        if (!evlistener) ret = [];
        else if (typeof evlistener === 'function') ret = [
            evlistener.listener || evlistener
        ];
        else ret = $3939d1de148b5202$var$unwrapListeners(evlistener);
    }
    return ret;
};
$3939d1de148b5202$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $3939d1de148b5202$var$listenerCount.call(emitter, type);
};
$3939d1de148b5202$var$EventEmitter.prototype.listenerCount = $3939d1de148b5202$var$listenerCount;
function $3939d1de148b5202$var$listenerCount(type) {
    var events = this._events;
    if (events) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
}
$3939d1de148b5202$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
}; // About 1.5x faster than the two-arg version of Array#splice().
function $3939d1de148b5202$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
function $3939d1de148b5202$var$arrayClone(arr, i) {
    var copy = new Array(i);
    while(i--)copy[i] = arr[i];
    return copy;
}
function $3939d1de148b5202$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
var $3939d1de148b5202$var$global$1 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js
function $3939d1de148b5202$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3939d1de148b5202$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
var $3939d1de148b5202$var$cachedSetTimeout = $3939d1de148b5202$var$defaultSetTimout;
var $3939d1de148b5202$var$cachedClearTimeout = $3939d1de148b5202$var$defaultClearTimeout;
if (typeof $3939d1de148b5202$var$global$1.setTimeout === 'function') $3939d1de148b5202$var$cachedSetTimeout = setTimeout;
if (typeof $3939d1de148b5202$var$global$1.clearTimeout === 'function') $3939d1de148b5202$var$cachedClearTimeout = clearTimeout;
function $3939d1de148b5202$var$runTimeout(fun) {
    if ($3939d1de148b5202$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
     // if setTimeout wasn't available but was latter defined
    if (($3939d1de148b5202$var$cachedSetTimeout === $3939d1de148b5202$var$defaultSetTimout || !$3939d1de148b5202$var$cachedSetTimeout) && setTimeout) {
        $3939d1de148b5202$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3939d1de148b5202$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3939d1de148b5202$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3939d1de148b5202$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3939d1de148b5202$var$runClearTimeout(marker) {
    if ($3939d1de148b5202$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
     // if clearTimeout wasn't available but was latter defined
    if (($3939d1de148b5202$var$cachedClearTimeout === $3939d1de148b5202$var$defaultClearTimeout || !$3939d1de148b5202$var$cachedClearTimeout) && clearTimeout) {
        $3939d1de148b5202$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3939d1de148b5202$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3939d1de148b5202$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3939d1de148b5202$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3939d1de148b5202$var$queue = [];
var $3939d1de148b5202$var$draining = false;
var $3939d1de148b5202$var$currentQueue;
var $3939d1de148b5202$var$queueIndex = -1;
function $3939d1de148b5202$var$cleanUpNextTick() {
    if (!$3939d1de148b5202$var$draining || !$3939d1de148b5202$var$currentQueue) return;
    $3939d1de148b5202$var$draining = false;
    if ($3939d1de148b5202$var$currentQueue.length) $3939d1de148b5202$var$queue = $3939d1de148b5202$var$currentQueue.concat($3939d1de148b5202$var$queue);
    else $3939d1de148b5202$var$queueIndex = -1;
    if ($3939d1de148b5202$var$queue.length) $3939d1de148b5202$var$drainQueue();
}
function $3939d1de148b5202$var$drainQueue() {
    if ($3939d1de148b5202$var$draining) return;
    var timeout = $3939d1de148b5202$var$runTimeout($3939d1de148b5202$var$cleanUpNextTick);
    $3939d1de148b5202$var$draining = true;
    var len = $3939d1de148b5202$var$queue.length;
    while(len){
        $3939d1de148b5202$var$currentQueue = $3939d1de148b5202$var$queue;
        $3939d1de148b5202$var$queue = [];
        while(++$3939d1de148b5202$var$queueIndex < len)if ($3939d1de148b5202$var$currentQueue) $3939d1de148b5202$var$currentQueue[$3939d1de148b5202$var$queueIndex].run();
        $3939d1de148b5202$var$queueIndex = -1;
        len = $3939d1de148b5202$var$queue.length;
    }
    $3939d1de148b5202$var$currentQueue = null;
    $3939d1de148b5202$var$draining = false;
    $3939d1de148b5202$var$runClearTimeout(timeout);
}
function $3939d1de148b5202$var$nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3939d1de148b5202$var$queue.push(new $3939d1de148b5202$var$Item(fun, args));
    if ($3939d1de148b5202$var$queue.length === 1 && !$3939d1de148b5202$var$draining) $3939d1de148b5202$var$runTimeout($3939d1de148b5202$var$drainQueue);
} // v8 likes predictible objects
function $3939d1de148b5202$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3939d1de148b5202$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var $3939d1de148b5202$var$title = 'browser';
var $3939d1de148b5202$var$platform = 'browser';
var $3939d1de148b5202$var$browser = true;
var $3939d1de148b5202$var$env = {};
var $3939d1de148b5202$var$argv = [];
var $3939d1de148b5202$var$version = ''; // empty string to avoid regexp issues
var $3939d1de148b5202$var$versions = {};
var $3939d1de148b5202$var$release = {};
var $3939d1de148b5202$var$config = {};
function $3939d1de148b5202$var$noop() {}
var $3939d1de148b5202$var$on = $3939d1de148b5202$var$noop;
var $3939d1de148b5202$var$addListener = $3939d1de148b5202$var$noop;
var $3939d1de148b5202$var$once = $3939d1de148b5202$var$noop;
var $3939d1de148b5202$var$off = $3939d1de148b5202$var$noop;
var $3939d1de148b5202$var$removeListener = $3939d1de148b5202$var$noop;
var $3939d1de148b5202$var$removeAllListeners = $3939d1de148b5202$var$noop;
var $3939d1de148b5202$var$emit = $3939d1de148b5202$var$noop;
function $3939d1de148b5202$var$binding(name) {
    throw new Error('process.binding is not supported');
}
function $3939d1de148b5202$var$cwd() {
    return '/';
}
function $3939d1de148b5202$var$chdir(dir) {
    throw new Error('process.chdir is not supported');
}
function $3939d1de148b5202$var$umask() {
    return 0;
} // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var $3939d1de148b5202$var$performance = $3939d1de148b5202$var$global$1.performance || {};
var $3939d1de148b5202$var$performanceNow = $3939d1de148b5202$var$performance.now || $3939d1de148b5202$var$performance.mozNow || $3939d1de148b5202$var$performance.msNow || $3939d1de148b5202$var$performance.oNow || $3939d1de148b5202$var$performance.webkitNow || function() {
    return new Date().getTime();
}; // generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function $3939d1de148b5202$var$hrtime(previousTimestamp) {
    var clocktime = $3939d1de148b5202$var$performanceNow.call($3939d1de148b5202$var$performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var $3939d1de148b5202$var$startTime = new Date();
function $3939d1de148b5202$var$uptime() {
    var currentTime = new Date();
    var dif = currentTime - $3939d1de148b5202$var$startTime;
    return dif / 1000;
}
var $3939d1de148b5202$var$process = {
    nextTick: $3939d1de148b5202$var$nextTick,
    title: $3939d1de148b5202$var$title,
    browser: $3939d1de148b5202$var$browser,
    env: $3939d1de148b5202$var$env,
    argv: $3939d1de148b5202$var$argv,
    version: $3939d1de148b5202$var$version,
    versions: $3939d1de148b5202$var$versions,
    on: $3939d1de148b5202$var$on,
    addListener: $3939d1de148b5202$var$addListener,
    once: $3939d1de148b5202$var$once,
    off: $3939d1de148b5202$var$off,
    removeListener: $3939d1de148b5202$var$removeListener,
    removeAllListeners: $3939d1de148b5202$var$removeAllListeners,
    emit: $3939d1de148b5202$var$emit,
    binding: $3939d1de148b5202$var$binding,
    cwd: $3939d1de148b5202$var$cwd,
    chdir: $3939d1de148b5202$var$chdir,
    umask: $3939d1de148b5202$var$umask,
    hrtime: $3939d1de148b5202$var$hrtime,
    platform: $3939d1de148b5202$var$platform,
    release: $3939d1de148b5202$var$release,
    config: $3939d1de148b5202$var$config,
    uptime: $3939d1de148b5202$var$uptime
};
var $3939d1de148b5202$var$inherits;
if (typeof Object.create === 'function') $3939d1de148b5202$var$inherits = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else $3939d1de148b5202$var$inherits = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var $3939d1de148b5202$var$inherits$1 = $3939d1de148b5202$var$inherits;
var $3939d1de148b5202$var$formatRegExp = /%[sdj%]/g;
function $3939d1de148b5202$var$format(f) {
    if (!$3939d1de148b5202$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($3939d1de148b5202$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($3939d1de148b5202$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($3939d1de148b5202$var$isNull(x) || !$3939d1de148b5202$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $3939d1de148b5202$var$inspect(x);
    return str;
}
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
function $3939d1de148b5202$var$deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if ($3939d1de148b5202$var$isUndefined($3939d1de148b5202$var$global$1.process)) return function() {
        return $3939d1de148b5202$var$deprecate(fn, msg).apply(this, arguments);
    };
    if ($3939d1de148b5202$var$process.noDeprecation === true) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($3939d1de148b5202$var$process.throwDeprecation) throw new Error(msg);
            else if ($3939d1de148b5202$var$process.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
var $3939d1de148b5202$var$debugs = {};
var $3939d1de148b5202$var$debugEnviron;
function $3939d1de148b5202$var$debuglog(set) {
    if ($3939d1de148b5202$var$isUndefined($3939d1de148b5202$var$debugEnviron)) $3939d1de148b5202$var$debugEnviron = $3939d1de148b5202$var$process.env.NODE_DEBUG || '';
    set = set.toUpperCase();
    if (!$3939d1de148b5202$var$debugs[set]) {
        if (new RegExp('\\b' + set + '\\b', 'i').test($3939d1de148b5202$var$debugEnviron)) {
            var pid = 0;
            $3939d1de148b5202$var$debugs[set] = function() {
                var msg = $3939d1de148b5202$var$format.apply(null, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $3939d1de148b5202$var$debugs[set] = function() {};
    }
    return $3939d1de148b5202$var$debugs[set];
}
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $3939d1de148b5202$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $3939d1de148b5202$var$stylizeNoColor
    }; // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($3939d1de148b5202$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $3939d1de148b5202$var$_extend(ctx, opts);
     // set default options
    if ($3939d1de148b5202$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($3939d1de148b5202$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($3939d1de148b5202$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($3939d1de148b5202$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $3939d1de148b5202$var$stylizeWithColor;
    return $3939d1de148b5202$var$formatValue(ctx, obj, ctx.depth);
} // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$3939d1de148b5202$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
}; // Don't use 'blue' not visible on cmd.exe
$3939d1de148b5202$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $3939d1de148b5202$var$stylizeWithColor(str, styleType) {
    var style = $3939d1de148b5202$var$inspect.styles[styleType];
    if (style) return "\x1B[" + $3939d1de148b5202$var$inspect.colors[style][0] + 'm' + str + "\x1B[" + $3939d1de148b5202$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $3939d1de148b5202$var$stylizeNoColor(str, styleType) {
    return str;
}
function $3939d1de148b5202$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $3939d1de148b5202$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $3939d1de148b5202$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $3939d1de148b5202$var$inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$3939d1de148b5202$var$isString(ret)) ret = $3939d1de148b5202$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    } // Primitive types cannot have properties
    var primitive = $3939d1de148b5202$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
     // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $3939d1de148b5202$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
     // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($3939d1de148b5202$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $3939d1de148b5202$var$formatError(value);
     // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($3939d1de148b5202$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($3939d1de148b5202$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($3939d1de148b5202$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($3939d1de148b5202$var$isError(value)) return $3939d1de148b5202$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ]; // Make Array say that they are Array
    if ($3939d1de148b5202$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    } // Make functions say that they are functions
    if ($3939d1de148b5202$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    } // Make RegExps say that they are RegExps
    if ($3939d1de148b5202$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
     // Make dates with properties first say the date
    if ($3939d1de148b5202$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
     // Make error with message first say the error
    if ($3939d1de148b5202$var$isError(value)) base = ' ' + $3939d1de148b5202$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($3939d1de148b5202$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $3939d1de148b5202$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $3939d1de148b5202$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $3939d1de148b5202$var$reduceToSingleString(output, base, braces);
}
function $3939d1de148b5202$var$formatPrimitive(ctx, value) {
    if ($3939d1de148b5202$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($3939d1de148b5202$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($3939d1de148b5202$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($3939d1de148b5202$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.
    if ($3939d1de148b5202$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $3939d1de148b5202$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $3939d1de148b5202$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($3939d1de148b5202$var$hasOwnProperty(value, String(i))) output.push($3939d1de148b5202$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($3939d1de148b5202$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $3939d1de148b5202$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$3939d1de148b5202$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($3939d1de148b5202$var$isNull(recurseTimes)) str = $3939d1de148b5202$var$formatValue(ctx, desc.value, null);
            else str = $3939d1de148b5202$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').substr(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($3939d1de148b5202$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $3939d1de148b5202$var$reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
        cur.indexOf('\n');
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
} // NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function $3939d1de148b5202$var$isArray(ar) {
    return Array.isArray(ar);
}
function $3939d1de148b5202$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
function $3939d1de148b5202$var$isNull(arg) {
    return arg === null;
}
function $3939d1de148b5202$var$isNullOrUndefined(arg) {
    return arg == null;
}
function $3939d1de148b5202$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $3939d1de148b5202$var$isString(arg) {
    return typeof arg === 'string';
}
function $3939d1de148b5202$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
function $3939d1de148b5202$var$isUndefined(arg) {
    return arg === void 0;
}
function $3939d1de148b5202$var$isRegExp(re) {
    return $3939d1de148b5202$var$isObject(re) && $3939d1de148b5202$var$objectToString(re) === '[object RegExp]';
}
function $3939d1de148b5202$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $3939d1de148b5202$var$isDate(d) {
    return $3939d1de148b5202$var$isObject(d) && $3939d1de148b5202$var$objectToString(d) === '[object Date]';
}
function $3939d1de148b5202$var$isError(e) {
    return $3939d1de148b5202$var$isObject(e) && ($3939d1de148b5202$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
function $3939d1de148b5202$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $3939d1de148b5202$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
function $3939d1de148b5202$var$isBuffer(maybeBuf) {
    return $3939d1de148b5202$var$buffer_1.isBuffer(maybeBuf);
}
function $3939d1de148b5202$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $3939d1de148b5202$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $3939d1de148b5202$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
]; // 26 Feb 16:19:34
function $3939d1de148b5202$var$timestamp() {
    var d = new Date();
    var time = [
        $3939d1de148b5202$var$pad(d.getHours()),
        $3939d1de148b5202$var$pad(d.getMinutes()),
        $3939d1de148b5202$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $3939d1de148b5202$var$months[d.getMonth()],
        time
    ].join(' ');
} // log is just a thin wrapper to console.log that prepends a timestamp
function $3939d1de148b5202$var$log() {
    console.log('%s - %s', $3939d1de148b5202$var$timestamp(), $3939d1de148b5202$var$format.apply(null, arguments));
}
function $3939d1de148b5202$var$_extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$3939d1de148b5202$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}
function $3939d1de148b5202$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $3939d1de148b5202$var$require$$3 = {
    inherits: $3939d1de148b5202$var$inherits$1,
    _extend: $3939d1de148b5202$var$_extend,
    log: $3939d1de148b5202$var$log,
    isBuffer: $3939d1de148b5202$var$isBuffer,
    isPrimitive: $3939d1de148b5202$var$isPrimitive,
    isFunction: $3939d1de148b5202$var$isFunction,
    isError: $3939d1de148b5202$var$isError,
    isDate: $3939d1de148b5202$var$isDate,
    isObject: $3939d1de148b5202$var$isObject,
    isRegExp: $3939d1de148b5202$var$isRegExp,
    isUndefined: $3939d1de148b5202$var$isUndefined,
    isSymbol: $3939d1de148b5202$var$isSymbol,
    isString: $3939d1de148b5202$var$isString,
    isNumber: $3939d1de148b5202$var$isNumber,
    isNullOrUndefined: $3939d1de148b5202$var$isNullOrUndefined,
    isNull: $3939d1de148b5202$var$isNull,
    isBoolean: $3939d1de148b5202$var$isBoolean,
    isArray: $3939d1de148b5202$var$isArray,
    inspect: $3939d1de148b5202$var$inspect,
    deprecate: $3939d1de148b5202$var$deprecate,
    format: $3939d1de148b5202$var$format,
    debuglog: $3939d1de148b5202$var$debuglog
};
function $3939d1de148b5202$var$BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
}
$3939d1de148b5202$var$BufferList.prototype.push = function(v) {
    var entry = {
        data: v,
        next: null
    };
    if (this.length > 0) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
    ++this.length;
};
$3939d1de148b5202$var$BufferList.prototype.unshift = function(v) {
    var entry = {
        data: v,
        next: this.head
    };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
};
$3939d1de148b5202$var$BufferList.prototype.shift = function() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;
    else this.head = this.head.next;
    --this.length;
    return ret;
};
$3939d1de148b5202$var$BufferList.prototype.clear = function() {
    this.head = this.tail = null;
    this.length = 0;
};
$3939d1de148b5202$var$BufferList.prototype.join = function(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while(p = p.next)ret += s + p.data;
    return ret;
};
$3939d1de148b5202$var$BufferList.prototype.concat = function(n) {
    if (this.length === 0) return $3939d1de148b5202$var$buffer_1.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = $3939d1de148b5202$var$buffer_1.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while(p){
        p.data.copy(ret, i);
        i += p.data.length;
        p = p.next;
    }
    return ret;
};
var $3939d1de148b5202$var$string_decoder = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    var Buffer = $3939d1de148b5202$var$buffer.Buffer;
    var isBufferEncoding = Buffer.isEncoding || function(encoding) {
        switch(encoding && encoding.toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
            case 'raw':
                return true;
            default:
                return false;
        }
    };
    function assertEncoding(encoding) {
        if (encoding && !isBufferEncoding(encoding)) throw new Error('Unknown encoding: ' + encoding);
    } // StringDecoder provides an interface for efficiently splitting a series of
    // buffers into a series of JS strings without breaking apart multi-byte
    // characters. CESU-8 is handled as part of the UTF-8 encoding.
    //
    // @TODO Handling all encodings inside a single object makes it very difficult
    // to reason about this code, so it should be split up in the future.
    // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
    // points as used by CESU-8.
    var StringDecoder = exports.StringDecoder = function(encoding) {
        this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
        assertEncoding(encoding);
        switch(this.encoding){
            case 'utf8':
                // CESU-8 represents each of Surrogate Pair by 3-bytes
                this.surrogateSize = 3;
                break;
            case 'ucs2':
            case 'utf16le':
                // UTF-16 represents each of Surrogate Pair by 2-bytes
                this.surrogateSize = 2;
                this.detectIncompleteChar = utf16DetectIncompleteChar;
                break;
            case 'base64':
                // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
                this.surrogateSize = 3;
                this.detectIncompleteChar = base64DetectIncompleteChar;
                break;
            default:
                this.write = passThroughWrite;
                return;
        } // Enough space to store all bytes of a single character. UTF-8 needs 4
        // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
        this.charBuffer = new Buffer(6); // Number of bytes received for the current incomplete multi-byte character.
        this.charReceived = 0; // Number of bytes expected for the current incomplete multi-byte character.
        this.charLength = 0;
    }; // write decodes the given buffer and returns it as JS string that is
    // guaranteed to not contain any partial multi-byte characters. Any partial
    // character found at the end of the buffer is buffered up, and will be
    // returned when calling write again with the remaining bytes.
    //
    // Note: Converting a Buffer containing an orphan surrogate to a String
    // currently works, but converting a String to a Buffer (via `new Buffer`, or
    // Buffer#write) will replace incomplete surrogates with the unicode
    // replacement character. See https://codereview.chromium.org/121173009/ .
    StringDecoder.prototype.write = function(buffer) {
        var charStr = ''; // if our last write ended with an incomplete multibyte character
        while(this.charLength){
            // determine how many remaining bytes this buffer has to offer for this char
            var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length; // add the new bytes to the char buffer
            buffer.copy(this.charBuffer, this.charReceived, 0, available);
            this.charReceived += available;
            if (this.charReceived < this.charLength) // still not enough chars in this buffer? wait for more ...
            return '';
             // remove bytes belonging to the current character from the buffer
            buffer = buffer.slice(available, buffer.length); // get the character that was split
            charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding); // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
            var charCode = charStr.charCodeAt(charStr.length - 1);
            if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                this.charLength += this.surrogateSize;
                charStr = '';
                continue;
            }
            this.charReceived = this.charLength = 0; // if there are no more bytes in this buffer, just emit our char
            if (buffer.length === 0) return charStr;
            break;
        } // determine and set charLength / charReceived
        this.detectIncompleteChar(buffer);
        var end = buffer.length;
        if (this.charLength) {
            // buffer the incomplete character bytes we got
            buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
            end -= this.charReceived;
        }
        charStr += buffer.toString(this.encoding, 0, end);
        var end = charStr.length - 1;
        var charCode = charStr.charCodeAt(end); // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
        if (charCode >= 0xD800 && charCode <= 0xDBFF) {
            var size = this.surrogateSize;
            this.charLength += size;
            this.charReceived += size;
            this.charBuffer.copy(this.charBuffer, size, 0, size);
            buffer.copy(this.charBuffer, 0, 0, size);
            return charStr.substring(0, end);
        } // or just emit the charStr
        return charStr;
    }; // detectIncompleteChar determines if there is an incomplete UTF-8 character at
    // the end of the given buffer. If so, it sets this.charLength to the byte
    // length that character, and sets this.charReceived to the number of bytes
    // that are available for this character.
    StringDecoder.prototype.detectIncompleteChar = function(buffer) {
        // determine how many bytes we have to check at the end of this buffer
        var i = buffer.length >= 3 ? 3 : buffer.length; // Figure out if one of the last i bytes of our buffer announces an
        // incomplete char.
        for(; i > 0; i--){
            var c = buffer[buffer.length - i]; // See http://en.wikipedia.org/wiki/UTF-8#Description
            // 110XXXXX
            if (i == 1 && c >> 5 == 0x06) {
                this.charLength = 2;
                break;
            } // 1110XXXX
            if (i <= 2 && c >> 4 == 0x0E) {
                this.charLength = 3;
                break;
            } // 11110XXX
            if (i <= 3 && c >> 3 == 0x1E) {
                this.charLength = 4;
                break;
            }
        }
        this.charReceived = i;
    };
    StringDecoder.prototype.end = function(buffer) {
        var res = '';
        if (buffer && buffer.length) res = this.write(buffer);
        if (this.charReceived) {
            var cr = this.charReceived;
            var buf = this.charBuffer;
            var enc = this.encoding;
            res += buf.slice(0, cr).toString(enc);
        }
        return res;
    };
    function passThroughWrite(buffer) {
        return buffer.toString(this.encoding);
    }
    function utf16DetectIncompleteChar(buffer) {
        this.charReceived = buffer.length % 2;
        this.charLength = this.charReceived ? 2 : 0;
    }
    function base64DetectIncompleteChar(buffer) {
        this.charReceived = buffer.length % 3;
        this.charLength = this.charReceived ? 3 : 0;
    }
});
var $3939d1de148b5202$var$string_decoder_1 = $3939d1de148b5202$var$string_decoder.StringDecoder;
$3939d1de148b5202$var$Readable.ReadableState = $3939d1de148b5202$var$ReadableState;
var $3939d1de148b5202$var$debug = $3939d1de148b5202$var$debuglog('stream');
$3939d1de148b5202$var$inherits$1($3939d1de148b5202$var$Readable, $3939d1de148b5202$var$EventEmitter);
function $3939d1de148b5202$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    else {
        // This is a hack to make sure that our error handler is attached before any
        // userland ones.  NEVER DO THIS. This is here only because this code needs
        // to continue to work with older versions of Node.js that do not include
        // the prependListener() method. The goal is to eventually remove this hack.
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
}
function $3939d1de148b5202$var$listenerCount$1(emitter, type) {
    return emitter.listeners(type).length;
}
function $3939d1de148b5202$var$ReadableState(options, stream) {
    options = options || {}; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (stream instanceof $3939d1de148b5202$var$Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm; // cast to ints.
    this.highWaterMark = ~~this.highWaterMark; // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $3939d1de148b5202$var$BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.
    this.ranOut = false; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        this.decoder = new $3939d1de148b5202$var$string_decoder_1(options.encoding);
        this.encoding = options.encoding;
    }
}
function $3939d1de148b5202$var$Readable(options) {
    if (!(this instanceof $3939d1de148b5202$var$Readable)) return new $3939d1de148b5202$var$Readable(options);
    this._readableState = new $3939d1de148b5202$var$ReadableState(options, this); // legacy
    this.readable = true;
    if (options && typeof options.read === 'function') this._read = options.read;
    $3939d1de148b5202$var$EventEmitter.call(this);
} // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3939d1de148b5202$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    if (!state.objectMode && typeof chunk === 'string') {
        encoding = encoding || state.defaultEncoding;
        if (encoding !== state.encoding) {
            chunk = $3939d1de148b5202$var$buffer_1.from(chunk, encoding);
            encoding = '';
        }
    }
    return $3939d1de148b5202$var$readableAddChunk(this, state, chunk, encoding, false);
}; // Unshift should *always* be something directly out of read()
$3939d1de148b5202$var$Readable.prototype.unshift = function(chunk) {
    var state = this._readableState;
    return $3939d1de148b5202$var$readableAddChunk(this, state, chunk, '', true);
};
$3939d1de148b5202$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
function $3939d1de148b5202$var$readableAddChunk(stream, state, chunk, encoding, addToFront) {
    var er = $3939d1de148b5202$var$chunkInvalid(state, chunk);
    if (er) stream.emit('error', er);
    else if (chunk === null) {
        state.reading = false;
        $3939d1de148b5202$var$onEofChunk(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
        if (state.ended && !addToFront) {
            var e = new Error('stream.push() after EOF');
            stream.emit('error', e);
        } else if (state.endEmitted && addToFront) {
            var _e = new Error('stream.unshift() after end event');
            stream.emit('error', _e);
        } else {
            var skipAdd;
            if (state.decoder && !addToFront && !encoding) {
                chunk = state.decoder.write(chunk);
                skipAdd = !state.objectMode && chunk.length === 0;
            }
            if (!addToFront) state.reading = false; // Don't add to the buffer if we've decoded to an empty string chunk and
            // we're not in object mode
            if (!skipAdd) {
                // if we want the data now, just emit it.
                if (state.flowing && state.length === 0 && !state.sync) {
                    stream.emit('data', chunk);
                    stream.read(0);
                } else {
                    // update the buffer info.
                    state.length += state.objectMode ? 1 : chunk.length;
                    if (addToFront) state.buffer.unshift(chunk);
                    else state.buffer.push(chunk);
                    if (state.needReadable) $3939d1de148b5202$var$emitReadable(stream);
                }
            }
            $3939d1de148b5202$var$maybeReadMore(stream, state);
        }
    } else if (!addToFront) state.reading = false;
    return $3939d1de148b5202$var$needMoreData(state);
} // if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $3939d1de148b5202$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
} // backwards compatibility.
$3939d1de148b5202$var$Readable.prototype.setEncoding = function(enc) {
    this._readableState.decoder = new $3939d1de148b5202$var$string_decoder_1(enc);
    this._readableState.encoding = enc;
    return this;
}; // Don't raise the hwm > 8MB
var $3939d1de148b5202$var$MAX_HWM = 0x800000;
function $3939d1de148b5202$var$computeNewHighWaterMark(n) {
    if (n >= $3939d1de148b5202$var$MAX_HWM) n = $3939d1de148b5202$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3939d1de148b5202$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3939d1de148b5202$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$3939d1de148b5202$var$Readable.prototype.read = function(n) {
    $3939d1de148b5202$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $3939d1de148b5202$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3939d1de148b5202$var$endReadable(this);
        else $3939d1de148b5202$var$emitReadable(this);
        return null;
    }
    n = $3939d1de148b5202$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3939d1de148b5202$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $3939d1de148b5202$var$debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3939d1de148b5202$var$debug('length less than watermark', doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $3939d1de148b5202$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $3939d1de148b5202$var$debug('do read');
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3939d1de148b5202$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $3939d1de148b5202$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3939d1de148b5202$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $3939d1de148b5202$var$chunkInvalid(state, chunk) {
    var er = null;
    if (!$3939d1de148b5202$var$buffer_1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
function $3939d1de148b5202$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true; // emit 'readable' now to make sure it gets picked up.
    $3939d1de148b5202$var$emitReadable(stream);
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3939d1de148b5202$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3939d1de148b5202$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $3939d1de148b5202$var$nextTick($3939d1de148b5202$var$emitReadable_, stream);
        else $3939d1de148b5202$var$emitReadable_(stream);
    }
}
function $3939d1de148b5202$var$emitReadable_(stream) {
    $3939d1de148b5202$var$debug('emit readable');
    stream.emit('readable');
    $3939d1de148b5202$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3939d1de148b5202$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $3939d1de148b5202$var$nextTick($3939d1de148b5202$var$maybeReadMore_, stream, state);
    }
}
function $3939d1de148b5202$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $3939d1de148b5202$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3939d1de148b5202$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('not implemented'));
};
$3939d1de148b5202$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $3939d1de148b5202$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = !pipeOpts || pipeOpts.end !== false;
    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) $3939d1de148b5202$var$nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable) {
        $3939d1de148b5202$var$debug('onunpipe');
        if (readable === src) cleanup();
    }
    function onend() {
        $3939d1de148b5202$var$debug('onend');
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $3939d1de148b5202$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $3939d1de148b5202$var$debug('cleanup'); // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', cleanup);
        src.removeListener('data', ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    } // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $3939d1de148b5202$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $3939d1de148b5202$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $3939d1de148b5202$var$debug('false write response, pause', src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3939d1de148b5202$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($3939d1de148b5202$var$listenerCount$1(dest, 'error') === 0) dest.emit('error', er);
    } // Make sure our error handler is attached before userland ones.
    $3939d1de148b5202$var$prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3939d1de148b5202$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3939d1de148b5202$var$debug('unpipe');
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit('pipe', src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $3939d1de148b5202$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3939d1de148b5202$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $3939d1de148b5202$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && src.listeners('data').length) {
            state.flowing = true;
            $3939d1de148b5202$var$flow(src);
        }
    };
}
$3939d1de148b5202$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var _i = 0; _i < len; _i++)dests[_i].emit('unpipe', this);
        return this;
    } // try to find the right one.
    var i = $3939d1de148b5202$var$indexOf(state.pipes, dest);
    if (i === -1) return this;
    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$3939d1de148b5202$var$Readable.prototype.on = function(ev, fn) {
    var res = $3939d1de148b5202$var$EventEmitter.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $3939d1de148b5202$var$nextTick($3939d1de148b5202$var$nReadingNextTick, this);
            else if (state.length) $3939d1de148b5202$var$emitReadable(this);
        }
    }
    return res;
};
$3939d1de148b5202$var$Readable.prototype.addListener = $3939d1de148b5202$var$Readable.prototype.on;
function $3939d1de148b5202$var$nReadingNextTick(self1) {
    $3939d1de148b5202$var$debug('readable nexttick read 0');
    self1.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3939d1de148b5202$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $3939d1de148b5202$var$debug('resume');
        state.flowing = true;
        $3939d1de148b5202$var$resume(this, state);
    }
    return this;
};
function $3939d1de148b5202$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $3939d1de148b5202$var$nextTick($3939d1de148b5202$var$resume_, stream, state);
    }
}
function $3939d1de148b5202$var$resume_(stream, state) {
    if (!state.reading) {
        $3939d1de148b5202$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $3939d1de148b5202$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3939d1de148b5202$var$Readable.prototype.pause = function() {
    $3939d1de148b5202$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $3939d1de148b5202$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $3939d1de148b5202$var$flow(stream) {
    var state = stream._readableState;
    $3939d1de148b5202$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3939d1de148b5202$var$Readable.prototype.wrap = function(stream) {
    var state = this._readableState;
    var paused = false;
    var self1 = this;
    stream.on('end', function() {
        $3939d1de148b5202$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) self1.push(chunk);
        }
        self1.push(null);
    });
    stream.on('data', function(chunk) {
        $3939d1de148b5202$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = self1.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    var events = [
        'error',
        'close',
        'destroy',
        'pause',
        'resume'
    ];
    $3939d1de148b5202$var$forEach(events, function(ev) {
        stream.on(ev, self1.emit.bind(self1, ev));
    }); // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    self1._read = function(n) {
        $3939d1de148b5202$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return self1;
}; // exposed for testing purposes only.
$3939d1de148b5202$var$Readable._fromList = $3939d1de148b5202$var$fromList; // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3939d1de148b5202$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $3939d1de148b5202$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
} // Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3939d1de148b5202$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $3939d1de148b5202$var$copyFromBufferString(n, list) : $3939d1de148b5202$var$copyFromBuffer(n, list);
    return ret;
} // Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3939d1de148b5202$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
} // Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3939d1de148b5202$var$copyFromBuffer(n, list) {
    var ret = $3939d1de148b5202$var$buffer_1.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $3939d1de148b5202$var$endReadable(stream) {
    var state = stream._readableState; // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $3939d1de148b5202$var$nextTick($3939d1de148b5202$var$endReadableNT, state, stream);
    }
}
function $3939d1de148b5202$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $3939d1de148b5202$var$forEach(xs, f) {
    for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
}
function $3939d1de148b5202$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
// A bit simpler than readable streams.
$3939d1de148b5202$var$Writable.WritableState = $3939d1de148b5202$var$WritableState;
$3939d1de148b5202$var$inherits$1($3939d1de148b5202$var$Writable, $3939d1de148b5202$var$EventEmitter);
function $3939d1de148b5202$var$nop() {}
function $3939d1de148b5202$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
function $3939d1de148b5202$var$WritableState(options, stream) {
    Object.defineProperty(this, 'buffer', {
        get: $3939d1de148b5202$var$deprecate(function() {
            return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
    });
    options = options || {}; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (stream instanceof $3939d1de148b5202$var$Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm; // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $3939d1de148b5202$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $3939d1de148b5202$var$CorkedRequest(this);
}
$3939d1de148b5202$var$WritableState.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
function $3939d1de148b5202$var$Writable(options) {
    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof $3939d1de148b5202$var$Writable) && !(this instanceof $3939d1de148b5202$var$Duplex)) return new $3939d1de148b5202$var$Writable(options);
    this._writableState = new $3939d1de148b5202$var$WritableState(options, this); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
    }
    $3939d1de148b5202$var$EventEmitter.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$3939d1de148b5202$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $3939d1de148b5202$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end'); // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $3939d1de148b5202$var$nextTick(cb, er);
} // If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function $3939d1de148b5202$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false; // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (!$3939d1de148b5202$var$buffer_1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $3939d1de148b5202$var$nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$3939d1de148b5202$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if ($3939d1de148b5202$var$buffer_1.isBuffer(chunk)) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $3939d1de148b5202$var$nop;
    if (state.ended) $3939d1de148b5202$var$writeAfterEnd(this, cb);
    else if ($3939d1de148b5202$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $3939d1de148b5202$var$writeOrBuffer(this, state, chunk, encoding, cb);
    }
    return ret;
};
$3939d1de148b5202$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$3939d1de148b5202$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) $3939d1de148b5202$var$clearBuffer(this, state);
    }
};
$3939d1de148b5202$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $3939d1de148b5202$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $3939d1de148b5202$var$buffer_1.from(chunk, encoding);
    return chunk;
} // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $3939d1de148b5202$var$writeOrBuffer(stream, state, chunk, encoding, cb) {
    chunk = $3939d1de148b5202$var$decodeChunk(state, chunk, encoding);
    if ($3939d1de148b5202$var$buffer_1.isBuffer(chunk)) encoding = 'buffer';
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = new $3939d1de148b5202$var$WriteReq(chunk, encoding, cb);
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $3939d1de148b5202$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $3939d1de148b5202$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $3939d1de148b5202$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) $3939d1de148b5202$var$nextTick(cb, er);
    else cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
}
function $3939d1de148b5202$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $3939d1de148b5202$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $3939d1de148b5202$var$onwriteStateUpdate(state);
    if (er) $3939d1de148b5202$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $3939d1de148b5202$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $3939d1de148b5202$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $3939d1de148b5202$var$nextTick($3939d1de148b5202$var$afterWrite, stream, state, finished, cb);
        else $3939d1de148b5202$var$afterWrite(stream, state, finished, cb);
    }
}
function $3939d1de148b5202$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $3939d1de148b5202$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $3939d1de148b5202$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $3939d1de148b5202$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
} // if there's something in the buffer waiting, then process it
function $3939d1de148b5202$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        while(entry){
            buffer[count] = entry;
            entry = entry.next;
            count += 1;
        }
        $3939d1de148b5202$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $3939d1de148b5202$var$CorkedRequest(state);
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $3939d1de148b5202$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$3939d1de148b5202$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('not implemented'));
};
$3939d1de148b5202$var$Writable.prototype._writev = null;
$3939d1de148b5202$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) $3939d1de148b5202$var$endWritable(this, state, cb);
};
function $3939d1de148b5202$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $3939d1de148b5202$var$prefinish(stream, state) {
    if (!state.prefinished) {
        state.prefinished = true;
        stream.emit('prefinish');
    }
}
function $3939d1de148b5202$var$finishMaybe(stream, state) {
    var need = $3939d1de148b5202$var$needFinish(state);
    if (need) {
        if (state.pendingcb === 0) {
            $3939d1de148b5202$var$prefinish(stream, state);
            state.finished = true;
            stream.emit('finish');
        } else $3939d1de148b5202$var$prefinish(stream, state);
    }
    return need;
}
function $3939d1de148b5202$var$endWritable(stream, state, cb) {
    state.ending = true;
    $3939d1de148b5202$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $3939d1de148b5202$var$nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $3939d1de148b5202$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function(err) {
        var entry = _this.entry;
        _this.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        if (state.corkedRequestsFree) state.corkedRequestsFree.next = _this;
        else state.corkedRequestsFree = _this;
    };
}
$3939d1de148b5202$var$inherits$1($3939d1de148b5202$var$Duplex, $3939d1de148b5202$var$Readable);
var $3939d1de148b5202$var$keys = Object.keys($3939d1de148b5202$var$Writable.prototype);
for(var $3939d1de148b5202$var$v = 0; $3939d1de148b5202$var$v < $3939d1de148b5202$var$keys.length; $3939d1de148b5202$var$v++){
    var $3939d1de148b5202$var$method = $3939d1de148b5202$var$keys[$3939d1de148b5202$var$v];
    if (!$3939d1de148b5202$var$Duplex.prototype[$3939d1de148b5202$var$method]) $3939d1de148b5202$var$Duplex.prototype[$3939d1de148b5202$var$method] = $3939d1de148b5202$var$Writable.prototype[$3939d1de148b5202$var$method];
}
function $3939d1de148b5202$var$Duplex(options) {
    if (!(this instanceof $3939d1de148b5202$var$Duplex)) return new $3939d1de148b5202$var$Duplex(options);
    $3939d1de148b5202$var$Readable.call(this, options);
    $3939d1de148b5202$var$Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $3939d1de148b5202$var$onend);
} // the no-half-open enforcer
function $3939d1de148b5202$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $3939d1de148b5202$var$nextTick($3939d1de148b5202$var$onEndNT, this);
}
function $3939d1de148b5202$var$onEndNT(self1) {
    self1.end();
}
// a transform stream is a readable/writable stream where you do
$3939d1de148b5202$var$inherits$1($3939d1de148b5202$var$Transform, $3939d1de148b5202$var$Duplex);
function $3939d1de148b5202$var$TransformState(stream) {
    this.afterTransform = function(er, data) {
        return $3939d1de148b5202$var$afterTransform(stream, er, data);
    };
    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
}
function $3939d1de148b5202$var$afterTransform(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data !== null && data !== undefined) stream.push(data);
    cb(er);
    var rs = stream._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) stream._read(rs.highWaterMark);
}
function $3939d1de148b5202$var$Transform(options) {
    if (!(this instanceof $3939d1de148b5202$var$Transform)) return new $3939d1de148b5202$var$Transform(options);
    $3939d1de148b5202$var$Duplex.call(this, options);
    this._transformState = new $3939d1de148b5202$var$TransformState(this); // when the writable side finishes, then flush out anything remaining.
    var stream = this; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    this.once('prefinish', function() {
        if (typeof this._flush === 'function') this._flush(function(er) {
            $3939d1de148b5202$var$done(stream, er);
        });
        else $3939d1de148b5202$var$done(stream);
    });
}
$3939d1de148b5202$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $3939d1de148b5202$var$Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$3939d1de148b5202$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('Not implemented');
};
$3939d1de148b5202$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$3939d1de148b5202$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
function $3939d1de148b5202$var$done(stream, er) {
    if (er) return stream.emit('error', er); // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    var ws = stream._writableState;
    var ts = stream._transformState;
    if (ws.length) throw new Error('Calling transform done when ws.length != 0');
    if (ts.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}
$3939d1de148b5202$var$inherits$1($3939d1de148b5202$var$PassThrough, $3939d1de148b5202$var$Transform);
function $3939d1de148b5202$var$PassThrough(options) {
    if (!(this instanceof $3939d1de148b5202$var$PassThrough)) return new $3939d1de148b5202$var$PassThrough(options);
    $3939d1de148b5202$var$Transform.call(this, options);
}
$3939d1de148b5202$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};
$3939d1de148b5202$var$inherits$1($3939d1de148b5202$var$Stream, $3939d1de148b5202$var$EventEmitter);
$3939d1de148b5202$var$Stream.Readable = $3939d1de148b5202$var$Readable;
$3939d1de148b5202$var$Stream.Writable = $3939d1de148b5202$var$Writable;
$3939d1de148b5202$var$Stream.Duplex = $3939d1de148b5202$var$Duplex;
$3939d1de148b5202$var$Stream.Transform = $3939d1de148b5202$var$Transform;
$3939d1de148b5202$var$Stream.PassThrough = $3939d1de148b5202$var$PassThrough; // Backwards-compat with node 0.4.x
$3939d1de148b5202$var$Stream.Stream = $3939d1de148b5202$var$Stream;
// part of this class) is overridden in the Readable class.
function $3939d1de148b5202$var$Stream() {
    $3939d1de148b5202$var$EventEmitter.call(this);
}
$3939d1de148b5202$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain); // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    } // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($3939d1de148b5202$var$EventEmitter.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror); // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source); // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
var $3939d1de148b5202$var$Buffer = $3939d1de148b5202$var$buffer.Buffer;
var $3939d1de148b5202$var$safer = {};
var $3939d1de148b5202$var$key;
for($3939d1de148b5202$var$key in $3939d1de148b5202$var$buffer){
    if (!$3939d1de148b5202$var$buffer.hasOwnProperty($3939d1de148b5202$var$key)) continue;
    if ($3939d1de148b5202$var$key === 'SlowBuffer' || $3939d1de148b5202$var$key === 'Buffer') continue;
    $3939d1de148b5202$var$safer[$3939d1de148b5202$var$key] = $3939d1de148b5202$var$buffer[$3939d1de148b5202$var$key];
}
var $3939d1de148b5202$var$Safer = $3939d1de148b5202$var$safer.Buffer = {};
for($3939d1de148b5202$var$key in $3939d1de148b5202$var$Buffer){
    if (!$3939d1de148b5202$var$Buffer.hasOwnProperty($3939d1de148b5202$var$key)) continue;
    if ($3939d1de148b5202$var$key === 'allocUnsafe' || $3939d1de148b5202$var$key === 'allocUnsafeSlow') continue;
    $3939d1de148b5202$var$Safer[$3939d1de148b5202$var$key] = $3939d1de148b5202$var$Buffer[$3939d1de148b5202$var$key];
}
$3939d1de148b5202$var$safer.Buffer.prototype = $3939d1de148b5202$var$Buffer.prototype;
if (!$3939d1de148b5202$var$Safer.from || $3939d1de148b5202$var$Safer.from === Uint8Array.from) $3939d1de148b5202$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
    return $3939d1de148b5202$var$Buffer(value, encodingOrOffset, length);
};
if (!$3939d1de148b5202$var$Safer.alloc) $3939d1de148b5202$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $3939d1de148b5202$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === 'string') buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$3939d1de148b5202$var$safer.kStringMaxLength) try {
    $3939d1de148b5202$var$safer.kStringMaxLength = $3939d1de148b5202$var$process.binding('buffer').kStringMaxLength;
} catch (e) {
// is unsupported, so let's not set it
}
if (!$3939d1de148b5202$var$safer.constants) {
    $3939d1de148b5202$var$safer.constants = {
        MAX_LENGTH: $3939d1de148b5202$var$safer.kMaxLength
    };
    if ($3939d1de148b5202$var$safer.kStringMaxLength) $3939d1de148b5202$var$safer.constants.MAX_STRING_LENGTH = $3939d1de148b5202$var$safer.kStringMaxLength;
}
var $3939d1de148b5202$var$safer_1 = $3939d1de148b5202$var$safer;
var $3939d1de148b5202$var$BOMChar = "\uFEFF";
var $3939d1de148b5202$var$PrependBOM = $3939d1de148b5202$var$PrependBOMWrapper;
function $3939d1de148b5202$var$PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}
$3939d1de148b5202$var$PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = $3939d1de148b5202$var$BOMChar + str;
        this.addBOM = false;
    }
    return this.encoder.write(str);
};
$3939d1de148b5202$var$PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
}; //------------------------------------------------------------------------------
var $3939d1de148b5202$var$StripBOM = $3939d1de148b5202$var$StripBOMWrapper;
function $3939d1de148b5202$var$StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}
$3939d1de148b5202$var$StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res) return res;
    if (res[0] === $3939d1de148b5202$var$BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === 'function') this.options.stripBOM();
    }
    this.pass = true;
    return res;
};
$3939d1de148b5202$var$StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
};
var $3939d1de148b5202$var$bomHandling = {
    PrependBOM: $3939d1de148b5202$var$PrependBOM,
    StripBOM: $3939d1de148b5202$var$StripBOM
};
var $3939d1de148b5202$var$Buffer$1 = $3939d1de148b5202$var$safer_1.Buffer; // Export Node.js internal encodings.
var $3939d1de148b5202$var$internal = {
    // Encodings
    utf8: {
        type: "_internal",
        bomAware: true
    },
    cesu8: {
        type: "_internal",
        bomAware: true
    },
    unicode11utf8: "utf8",
    ucs2: {
        type: "_internal",
        bomAware: true
    },
    utf16le: "ucs2",
    binary: {
        type: "_internal"
    },
    base64: {
        type: "_internal"
    },
    hex: {
        type: "_internal"
    },
    // Codec.
    _internal: $3939d1de148b5202$var$InternalCodec
}; //------------------------------------------------------------------------------
function $3939d1de148b5202$var$InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;
    if (this.enc === "base64") this.encoder = $3939d1de148b5202$var$InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = $3939d1de148b5202$var$InternalEncoderCesu8; // Add decoder for versions of Node not supporting CESU-8
        if ($3939d1de148b5202$var$Buffer$1.from('eda0bdedb2a9', 'hex').toString() !== "\uD83D\uDCA9") {
            this.decoder = $3939d1de148b5202$var$InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}
$3939d1de148b5202$var$InternalCodec.prototype.encoder = $3939d1de148b5202$var$InternalEncoder;
$3939d1de148b5202$var$InternalCodec.prototype.decoder = $3939d1de148b5202$var$InternalDecoder; //------------------------------------------------------------------------------
// We use node.js internal decoder. Its signature is the same as ours.
var $3939d1de148b5202$var$StringDecoder = $3939d1de148b5202$var$string_decoder.StringDecoder;
if (!$3939d1de148b5202$var$StringDecoder.prototype.end) $3939d1de148b5202$var$StringDecoder.prototype.end = function() {};
function $3939d1de148b5202$var$InternalDecoder(options, codec) {
    $3939d1de148b5202$var$StringDecoder.call(this, codec.enc);
}
$3939d1de148b5202$var$InternalDecoder.prototype = $3939d1de148b5202$var$StringDecoder.prototype; //------------------------------------------------------------------------------
// Encoder is mostly trivial
function $3939d1de148b5202$var$InternalEncoder(options, codec) {
    this.enc = codec.enc;
}
$3939d1de148b5202$var$InternalEncoder.prototype.write = function(str) {
    return $3939d1de148b5202$var$Buffer$1.from(str, this.enc);
};
$3939d1de148b5202$var$InternalEncoder.prototype.end = function() {}; //------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.
function $3939d1de148b5202$var$InternalEncoderBase64(options, codec) {
    this.prevStr = '';
}
$3939d1de148b5202$var$InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - str.length % 4;
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);
    return $3939d1de148b5202$var$Buffer$1.from(str, "base64");
};
$3939d1de148b5202$var$InternalEncoderBase64.prototype.end = function() {
    return $3939d1de148b5202$var$Buffer$1.from(this.prevStr, "base64");
}; //------------------------------------------------------------------------------
// CESU-8 encoder is also special.
function $3939d1de148b5202$var$InternalEncoderCesu8(options, codec) {}
$3939d1de148b5202$var$InternalEncoderCesu8.prototype.write = function(str) {
    var buf = $3939d1de148b5202$var$Buffer$1.alloc(str.length * 3), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var charCode = str.charCodeAt(i); // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80) buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        } else {
            // charCode will always be < 0x10000 in javascript.
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
};
$3939d1de148b5202$var$InternalEncoderCesu8.prototype.end = function() {}; //------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+
function $3939d1de148b5202$var$InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}
$3939d1de148b5202$var$InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = '';
    for(var i = 0; i < buf.length; i++){
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) {
            // Leading byte
            if (contBytes > 0) {
                // Previous code is invalid
                res += this.defaultCharUnicode;
                contBytes = 0;
            }
            if (curByte < 0x80) // Single-byte code
            res += String.fromCharCode(curByte);
            else if (curByte < 0xE0) {
                // Two-byte code
                acc = curByte & 0x1F;
                contBytes = 1;
                accBytes = 1;
            } else if (curByte < 0xF0) {
                // Three-byte code
                acc = curByte & 0x0F;
                contBytes = 2;
                accBytes = 1;
            } else // Four or more are not supported for CESU-8.
            res += this.defaultCharUnicode;
        } else // Continuation byte
        if (contBytes > 0) {
            // We're waiting for it.
            acc = acc << 6 | curByte & 0x3f;
            contBytes--;
            accBytes++;
            if (contBytes === 0) {
                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                else res += String.fromCharCode(acc);
            }
        } else // Unexpected continuation byte
        res += this.defaultCharUnicode;
    }
    this.acc = acc;
    this.contBytes = contBytes;
    this.accBytes = accBytes;
    return res;
};
$3939d1de148b5202$var$InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0) res += this.defaultCharUnicode;
    return res;
};
var $3939d1de148b5202$var$Buffer$2 = $3939d1de148b5202$var$safer_1.Buffer; // Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
// == UTF16-BE codec. ==========================================================
var $3939d1de148b5202$var$utf16be = $3939d1de148b5202$var$Utf16BECodec;
function $3939d1de148b5202$var$Utf16BECodec() {}
$3939d1de148b5202$var$Utf16BECodec.prototype.encoder = $3939d1de148b5202$var$Utf16BEEncoder;
$3939d1de148b5202$var$Utf16BECodec.prototype.decoder = $3939d1de148b5202$var$Utf16BEDecoder;
$3939d1de148b5202$var$Utf16BECodec.prototype.bomAware = true; // -- Encoding
function $3939d1de148b5202$var$Utf16BEEncoder() {}
$3939d1de148b5202$var$Utf16BEEncoder.prototype.write = function(str) {
    var buf = $3939d1de148b5202$var$Buffer$2.from(str, 'ucs2');
    for(var i = 0; i < buf.length; i += 2){
        var tmp = buf[i];
        buf[i] = buf[i + 1];
        buf[i + 1] = tmp;
    }
    return buf;
};
$3939d1de148b5202$var$Utf16BEEncoder.prototype.end = function() {}; // -- Decoding
function $3939d1de148b5202$var$Utf16BEDecoder() {
    this.overflowByte = -1;
}
$3939d1de148b5202$var$Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0) return '';
    var buf2 = $3939d1de148b5202$var$Buffer$2.alloc(buf.length + 1), i = 0, j = 0;
    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1;
        j = 2;
    }
    for(; i < buf.length - 1; i += 2, j += 2){
        buf2[j] = buf[i + 1];
        buf2[j + 1] = buf[i];
    }
    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
    return buf2.slice(0, j).toString('ucs2');
};
$3939d1de148b5202$var$Utf16BEDecoder.prototype.end = function() {}; // == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
var $3939d1de148b5202$var$utf16_1 = $3939d1de148b5202$var$Utf16Codec;
function $3939d1de148b5202$var$Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$3939d1de148b5202$var$Utf16Codec.prototype.encoder = $3939d1de148b5202$var$Utf16Encoder;
$3939d1de148b5202$var$Utf16Codec.prototype.decoder = $3939d1de148b5202$var$Utf16Decoder; // -- Encoding (pass-through)
function $3939d1de148b5202$var$Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder('utf-16le', options);
}
$3939d1de148b5202$var$Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
$3939d1de148b5202$var$Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
}; // -- Decoding
function $3939d1de148b5202$var$Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBytes = [];
    this.initialBytesLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
$3939d1de148b5202$var$Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBytes.push(buf);
        this.initialBytesLen += buf.length;
        if (this.initialBytesLen < 16) return ''; // We have enough bytes -> detect endianness.
        var buf = $3939d1de148b5202$var$Buffer$2.concat(this.initialBytes), encoding = $3939d1de148b5202$var$detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        this.initialBytes.length = this.initialBytesLen = 0;
    }
    return this.decoder.write(buf);
};
$3939d1de148b5202$var$Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var buf = $3939d1de148b5202$var$Buffer$2.concat(this.initialBytes), encoding = $3939d1de148b5202$var$detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var res = this.decoder.write(buf), trail = this.decoder.end();
        return trail ? res + trail : res;
    }
    return this.decoder.end();
};
function $3939d1de148b5202$var$detectEncoding(buf, defaultEncoding) {
    var enc = defaultEncoding || 'utf-16le';
    if (buf.length >= 2) {
        // Check BOM.
        if (buf[0] == 0xFE && buf[1] == 0xFF) enc = 'utf-16be';
        else if (buf[0] == 0xFF && buf[1] == 0xFE) enc = 'utf-16le';
        else {
            // No BOM found. Try to deduce encoding from initial content.
            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
            // So, we count ASCII as if it was LE or BE, and decide from that.
            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
            _len = Math.min(buf.length - buf.length % 2, 64); // Len is always even.
            for(var i = 0; i < _len; i += 2){
                if (buf[i] === 0 && buf[i + 1] !== 0) asciiCharsBE++;
                if (buf[i] !== 0 && buf[i + 1] === 0) asciiCharsLE++;
            }
            if (asciiCharsBE > asciiCharsLE) enc = 'utf-16be';
            else if (asciiCharsBE < asciiCharsLE) enc = 'utf-16le';
        }
    }
    return enc;
}
var $3939d1de148b5202$var$utf16 = {
    utf16be: $3939d1de148b5202$var$utf16be,
    utf16: $3939d1de148b5202$var$utf16_1
};
var $3939d1de148b5202$var$Buffer$3 = $3939d1de148b5202$var$safer_1.Buffer; // UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
var $3939d1de148b5202$var$utf7_1 = $3939d1de148b5202$var$Utf7Codec;
var $3939d1de148b5202$var$unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
function $3939d1de148b5202$var$Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$3939d1de148b5202$var$Utf7Codec.prototype.encoder = $3939d1de148b5202$var$Utf7Encoder;
$3939d1de148b5202$var$Utf7Codec.prototype.decoder = $3939d1de148b5202$var$Utf7Decoder;
$3939d1de148b5202$var$Utf7Codec.prototype.bomAware = true; // -- Encoding
var $3939d1de148b5202$var$nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
function $3939d1de148b5202$var$Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}
$3939d1de148b5202$var$Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return $3939d1de148b5202$var$Buffer$3.from(str.replace($3939d1de148b5202$var$nonDirectChars, (function(chunk) {
        return "+" + (chunk === '+' ? '' : this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) + "-";
    }).bind(this)));
};
$3939d1de148b5202$var$Utf7Encoder.prototype.end = function() {}; // -- Decoding
function $3939d1de148b5202$var$Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $3939d1de148b5202$var$base64Regex = /[A-Za-z0-9\/+]/;
var $3939d1de148b5202$var$base64Chars = [];
for(var $3939d1de148b5202$var$i$1 = 0; $3939d1de148b5202$var$i$1 < 256; $3939d1de148b5202$var$i$1++)$3939d1de148b5202$var$base64Chars[$3939d1de148b5202$var$i$1] = $3939d1de148b5202$var$base64Regex.test(String.fromCharCode($3939d1de148b5202$var$i$1));
var $3939d1de148b5202$var$plusChar = '+'.charCodeAt(0), $3939d1de148b5202$var$minusChar = '-'.charCodeAt(0), $3939d1de148b5202$var$andChar = '&'.charCodeAt(0);
$3939d1de148b5202$var$Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum; // The decoder is more involved as we must handle chunks in stream.
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // We're in direct mode.
        // Write direct chars until '+'
        {
            if (buf[i] == $3939d1de148b5202$var$plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else // We decode base64.
        if (!$3939d1de148b5202$var$base64Chars[buf[i]]) {
            // Base64 ended.
            if (i == lastI && buf[i] == $3939d1de148b5202$var$minusChar) // "+-" -> "+"
            res += "+";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString();
                res += this.iconv.decode($3939d1de148b5202$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $3939d1de148b5202$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString();
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($3939d1de148b5202$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$3939d1de148b5202$var$Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($3939d1de148b5202$var$Buffer$3.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
}; // UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.
var $3939d1de148b5202$var$utf7imap = $3939d1de148b5202$var$Utf7IMAPCodec;
function $3939d1de148b5202$var$Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
}
$3939d1de148b5202$var$Utf7IMAPCodec.prototype.encoder = $3939d1de148b5202$var$Utf7IMAPEncoder;
$3939d1de148b5202$var$Utf7IMAPCodec.prototype.decoder = $3939d1de148b5202$var$Utf7IMAPDecoder;
$3939d1de148b5202$var$Utf7IMAPCodec.prototype.bomAware = true; // -- Encoding
function $3939d1de148b5202$var$Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = $3939d1de148b5202$var$Buffer$3.alloc(6);
    this.base64AccumIdx = 0;
}
$3939d1de148b5202$var$Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = $3939d1de148b5202$var$Buffer$3.alloc(str.length * 5 + 10), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) {
            // Direct character or '&'.
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                    base64AccumIdx = 0;
                }
                buf[bufIdx++] = $3939d1de148b5202$var$minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }
            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character
                if (uChar === $3939d1de148b5202$var$andChar) buf[bufIdx++] = $3939d1de148b5202$var$minusChar;
            }
        } else {
            // Non-direct character
            if (!inBase64) {
                buf[bufIdx++] = $3939d1de148b5202$var$andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }
    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;
    return buf.slice(0, bufIdx);
};
$3939d1de148b5202$var$Utf7IMAPEncoder.prototype.end = function() {
    var buf = $3939d1de148b5202$var$Buffer$3.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
            this.base64AccumIdx = 0;
        }
        buf[bufIdx++] = $3939d1de148b5202$var$minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }
    return buf.slice(0, bufIdx);
}; // -- Decoding
function $3939d1de148b5202$var$Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $3939d1de148b5202$var$base64IMAPChars = $3939d1de148b5202$var$base64Chars.slice();
$3939d1de148b5202$var$base64IMAPChars[','.charCodeAt(0)] = true;
$3939d1de148b5202$var$Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum; // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // We're in direct mode.
        // Write direct chars until '&'
        {
            if (buf[i] == $3939d1de148b5202$var$andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else // We decode base64.
        if (!$3939d1de148b5202$var$base64IMAPChars[buf[i]]) {
            // Base64 ended.
            if (i == lastI && buf[i] == $3939d1de148b5202$var$minusChar) // "&-" -> "&"
            res += "&";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
                res += this.iconv.decode($3939d1de148b5202$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $3939d1de148b5202$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($3939d1de148b5202$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$3939d1de148b5202$var$Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($3939d1de148b5202$var$Buffer$3.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};
var $3939d1de148b5202$var$utf7 = {
    utf7: $3939d1de148b5202$var$utf7_1,
    unicode11utf7: $3939d1de148b5202$var$unicode11utf7,
    utf7imap: $3939d1de148b5202$var$utf7imap
};
var $3939d1de148b5202$var$Buffer$4 = $3939d1de148b5202$var$safer_1.Buffer; // Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 
var $3939d1de148b5202$var$_sbcs = $3939d1de148b5202$var$SBCSCodec;
function $3939d1de148b5202$var$SBCSCodec(codecOptions, iconv) {
    if (!codecOptions) throw new Error("SBCS codec is called without the data."); // Prepare char buffer for decoding.
    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }
    this.decodeBuf = $3939d1de148b5202$var$Buffer$4.from(codecOptions.chars, 'ucs2'); // Encoding buffer.
    var encodeBuf = $3939d1de148b5202$var$Buffer$4.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
    this.encodeBuf = encodeBuf;
}
$3939d1de148b5202$var$SBCSCodec.prototype.encoder = $3939d1de148b5202$var$SBCSEncoder;
$3939d1de148b5202$var$SBCSCodec.prototype.decoder = $3939d1de148b5202$var$SBCSDecoder;
function $3939d1de148b5202$var$SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}
$3939d1de148b5202$var$SBCSEncoder.prototype.write = function(str) {
    var buf = $3939d1de148b5202$var$Buffer$4.alloc(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
    return buf;
};
$3939d1de148b5202$var$SBCSEncoder.prototype.end = function() {};
function $3939d1de148b5202$var$SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}
$3939d1de148b5202$var$SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = $3939d1de148b5202$var$Buffer$4.alloc(buf.length * 2);
    var idx1 = 0, idx2 = 0;
    for(var i = 0; i < buf.length; i++){
        idx1 = buf[i] * 2;
        idx2 = i * 2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
    }
    return newBuf.toString('ucs2');
};
$3939d1de148b5202$var$SBCSDecoder.prototype.end = function() {};
var $3939d1de148b5202$var$sbcsCodec = {
    _sbcs: $3939d1de148b5202$var$_sbcs
};
var $3939d1de148b5202$var$sbcsData = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
    },
    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
    },
    "mik": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",
    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",
    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek": "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",
    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",
    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",
    "cp819": "iso88591",
    "ibm819": "iso88591",
    "cyrillic": "iso88595",
    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",
    "greek": "iso88597",
    "greek8": "iso88597",
    "ecma118": "iso88597",
    "elot928": "iso88597",
    "hebrew": "iso88598",
    "hebrew8": "iso88598",
    "turkish": "iso88599",
    "turkish8": "iso88599",
    "thai": "iso885911",
    "thai8": "iso885911",
    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",
    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",
    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",
    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",
    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",
    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",
    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",
    "strk10482002": "rk1048",
    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",
    "gb198880": "iso646cn",
    "cn": "iso646cn",
    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",
    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",
    "mac": "macintosh",
    "csmacintosh": "macintosh"
};
var $3939d1de148b5202$var$sbcsDataGenerated = {
    "437": "cp437",
    "737": "cp737",
    "775": "cp775",
    "850": "cp850",
    "852": "cp852",
    "855": "cp855",
    "856": "cp856",
    "857": "cp857",
    "858": "cp858",
    "860": "cp860",
    "861": "cp861",
    "862": "cp862",
    "863": "cp863",
    "864": "cp864",
    "865": "cp865",
    "866": "cp866",
    "869": "cp869",
    "874": "windows874",
    "922": "cp922",
    "1046": "cp1046",
    "1124": "cp1124",
    "1125": "cp1125",
    "1129": "cp1129",
    "1133": "cp1133",
    "1161": "cp1161",
    "1162": "cp1162",
    "1163": "cp1163",
    "1250": "windows1250",
    "1251": "windows1251",
    "1252": "windows1252",
    "1253": "windows1253",
    "1254": "windows1254",
    "1255": "windows1255",
    "1256": "windows1256",
    "1257": "windows1257",
    "1258": "windows1258",
    "28591": "iso88591",
    "28592": "iso88592",
    "28593": "iso88593",
    "28594": "iso88594",
    "28595": "iso88595",
    "28596": "iso88596",
    "28597": "iso88597",
    "28598": "iso88598",
    "28599": "iso88599",
    "28600": "iso885910",
    "28601": "iso885911",
    "28603": "iso885913",
    "28604": "iso885914",
    "28605": "iso885915",
    "28606": "iso885916",
    "windows874": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "win874": "windows874",
    "cp874": "windows874",
    "windows1250": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "win1250": "windows1250",
    "cp1250": "windows1250",
    "windows1251": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "win1251": "windows1251",
    "cp1251": "windows1251",
    "windows1252": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "win1252": "windows1252",
    "cp1252": "windows1252",
    "windows1253": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "win1253": "windows1253",
    "cp1253": "windows1253",
    "windows1254": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "win1254": "windows1254",
    "cp1254": "windows1254",
    "windows1255": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "win1255": "windows1255",
    "cp1255": "windows1255",
    "windows1256": {
        "type": "_sbcs",
        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
    },
    "win1256": "windows1256",
    "cp1256": "windows1256",
    "windows1257": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
    },
    "win1257": "windows1257",
    "cp1257": "windows1257",
    "windows1258": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "win1258": "windows1258",
    "cp1258": "windows1258",
    "iso88591": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28591": "iso88591",
    "iso88592": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "cp28592": "iso88592",
    "iso88593": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
    },
    "cp28593": "iso88593",
    "iso88594": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
    },
    "cp28594": "iso88594",
    "iso88595": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "cp28595": "iso88595",
    "iso88596": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28596": "iso88596",
    "iso88597": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "cp28597": "iso88597",
    "iso88598": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "cp28598": "iso88598",
    "iso88599": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "cp28599": "iso88599",
    "iso885910": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
    },
    "cp28600": "iso885910",
    "iso885911": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28601": "iso885911",
    "iso885913": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
    },
    "cp28603": "iso885913",
    "iso885914": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
    },
    "cp28604": "iso885914",
    "iso885915": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28605": "iso885915",
    "iso885916": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
    },
    "cp28606": "iso885916",
    "cp437": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm437": "cp437",
    "csibm437": "cp437",
    "cp737": {
        "type": "_sbcs",
        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm737": "cp737",
    "csibm737": "cp737",
    "cp775": {
        "type": "_sbcs",
        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm775": "cp775",
    "csibm775": "cp775",
    "cp850": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm850": "cp850",
    "csibm850": "cp850",
    "cp852": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
    },
    "ibm852": "cp852",
    "csibm852": "cp852",
    "cp855": {
        "type": "_sbcs",
        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
    },
    "ibm855": "cp855",
    "csibm855": "cp855",
    "cp856": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm856": "cp856",
    "csibm856": "cp856",
    "cp857": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm857": "cp857",
    "csibm857": "cp857",
    "cp858": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm858": "cp858",
    "csibm858": "cp858",
    "cp860": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm860": "cp860",
    "csibm860": "cp860",
    "cp861": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm861": "cp861",
    "csibm861": "cp861",
    "cp862": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm862": "cp862",
    "csibm862": "cp862",
    "cp863": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm863": "cp863",
    "csibm863": "cp863",
    "cp864": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7F\xB0\xB7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xB1\xBD\xBC\u2248\xAB\xBB\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xA0\xAD\uFE82\xA3\xA4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xA2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xA6\xAC\xF7\xD7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
    },
    "ibm864": "cp864",
    "csibm864": "cp864",
    "cp865": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm865": "cp865",
    "csibm865": "cp865",
    "cp866": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm866": "cp866",
    "csibm866": "cp866",
    "cp869": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
    },
    "ibm869": "cp869",
    "csibm869": "cp869",
    "cp922": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
    },
    "ibm922": "cp922",
    "csibm922": "cp922",
    "cp1046": {
        "type": "_sbcs",
        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
    },
    "ibm1046": "cp1046",
    "csibm1046": "cp1046",
    "cp1124": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "ibm1124": "cp1124",
    "csibm1124": "cp1124",
    "cp1125": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm1125": "cp1125",
    "csibm1125": "cp1125",
    "cp1129": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1129": "cp1129",
    "csibm1129": "cp1129",
    "cp1133": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
    },
    "ibm1133": "cp1133",
    "csibm1133": "cp1133",
    "cp1161": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
    },
    "ibm1161": "cp1161",
    "csibm1161": "cp1161",
    "cp1162": {
        "type": "_sbcs",
        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "ibm1162": "cp1162",
    "csibm1162": "cp1162",
    "cp1163": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1163": "cp1163",
    "csibm1163": "cp1163",
    "maccroatian": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
    },
    "maccyrillic": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "macgreek": {
        "type": "_sbcs",
        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
    },
    "maciceland": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macroman": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macromania": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macthai": {
        "type": "_sbcs",
        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "macturkish": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macukraine": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "koi8r": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8u": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8ru": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8t": {
        "type": "_sbcs",
        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "armscii8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
    },
    "rk1048": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "tcvn": {
        "type": "_sbcs",
        "chars": "\0\xDA\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b\t\n\x0B\f\r\x0E\x0F\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xDD\u1EF4\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7F\xC0\u1EA2\xC3\xC1\u1EA0\u1EB6\u1EAC\xC8\u1EBA\u1EBC\xC9\u1EB8\u1EC6\xCC\u1EC8\u0128\xCD\u1ECA\xD2\u1ECE\xD5\xD3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xD9\u1EE6\u0168\xA0\u0102\xC2\xCA\xD4\u01A0\u01AF\u0110\u0103\xE2\xEA\xF4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xE0\u1EA3\xE3\xE1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xE8\u1EC2\u1EBB\u1EBD\xE9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xEC\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xED\u1ECB\xF2\u1ED4\u1ECF\xF5\xF3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xF9\u1ED6\u1EE7\u0169\xFA\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xFD\u1EF5\u1ED0"
    },
    "georgianacademy": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "georgianps": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "pt154": {
        "type": "_sbcs",
        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "viscii": {
        "type": "_sbcs",
        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1A\x1B\x1C\x1D\u1EF4\x1F !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7F\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xD5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xC0\xC1\xC2\xC3\u1EA2\u0102\u1EB3\u1EB5\xC8\xC9\xCA\u1EBA\xCC\xCD\u0128\u1EF3\u0110\u1EE9\xD2\xD3\xD4\u1EA1\u1EF7\u1EEB\u1EED\xD9\xDA\u1EF9\u1EF5\xDD\u1EE1\u01B0\xE0\xE1\xE2\xE3\u1EA3\u0103\u1EEF\u1EAB\xE8\xE9\xEA\u1EBB\xEC\xED\u0129\u1EC9\u0111\u1EF1\xF2\xF3\xF4\xF5\u1ECF\u1ECD\u1EE5\xF9\xFA\u0169\u1EE7\xFD\u1EE3\u1EEE"
    },
    "iso646cn": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#\xA5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "iso646jp": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xA5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "hproman8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
    },
    "macintosh": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "ascii": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "tis620": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    }
};
var $3939d1de148b5202$var$Buffer$5 = $3939d1de148b5202$var$safer_1.Buffer; // Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.
var $3939d1de148b5202$var$_dbcs = $3939d1de148b5202$var$DBCSCodec;
var $3939d1de148b5202$var$UNASSIGNED = -1, $3939d1de148b5202$var$GB18030_CODE = -2, $3939d1de148b5202$var$SEQ_START = -10, $3939d1de148b5202$var$NODE_START = -1000, $3939d1de148b5202$var$UNASSIGNED_NODE = new Array(0x100), $3939d1de148b5202$var$DEF_CHAR = -1;
for(var $3939d1de148b5202$var$i$2 = 0; $3939d1de148b5202$var$i$2 < 0x100; $3939d1de148b5202$var$i$2++)$3939d1de148b5202$var$UNASSIGNED_NODE[$3939d1de148b5202$var$i$2] = $3939d1de148b5202$var$UNASSIGNED;
 // Class DBCSCodec reads and initializes mapping tables.
function $3939d1de148b5202$var$DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data."); // Load tables.
    var mappingTable = codecOptions.table(); // Decode tables: MBCS -> Unicode.
    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = $3939d1de148b5202$var$UNASSIGNED_NODE.slice(0); // Create root node.
    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = []; // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
    this.defaultCharUnicode = iconv.defaultCharUnicode; // Encode tables: Unicode -> DBCS.
    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = []; // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = []; // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
        var val = codecOptions.encodeSkipVals[i];
        if (typeof val === 'number') skipEncodeChars[val] = true;
        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
    } // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars); // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }
    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === $3939d1de148b5202$var$UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
    if (this.defCharSB === $3939d1de148b5202$var$UNASSIGNED) this.defCharSB = "?".charCodeAt(0); // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === 'function') {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
        // Add GB18030 decode tables.
        var thirdByteNodeIdx = this.decodeTables.length;
        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = $3939d1de148b5202$var$UNASSIGNED_NODE.slice(0);
        var fourthByteNodeIdx = this.decodeTables.length;
        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = $3939d1de148b5202$var$UNASSIGNED_NODE.slice(0);
        for(var i = 0x81; i <= 0xFE; i++){
            var secondByteNodeIdx = $3939d1de148b5202$var$NODE_START - this.decodeTables[0][i];
            var secondByteNode = this.decodeTables[secondByteNodeIdx];
            for(var j = 0x30; j <= 0x39; j++)secondByteNode[j] = $3939d1de148b5202$var$NODE_START - thirdByteNodeIdx;
        }
        for(var i = 0x81; i <= 0xFE; i++)thirdByteNode[i] = $3939d1de148b5202$var$NODE_START - fourthByteNodeIdx;
        for(var i = 0x30; i <= 0x39; i++)fourthByteNode[i] = $3939d1de148b5202$var$GB18030_CODE;
    }
}
$3939d1de148b5202$var$DBCSCodec.prototype.encoder = $3939d1de148b5202$var$DBCSEncoder;
$3939d1de148b5202$var$DBCSCodec.prototype.decoder = $3939d1de148b5202$var$DBCSDecoder; // Decoder helpers
$3939d1de148b5202$var$DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for(; addr > 0; addr >>= 8)bytes.push(addr & 0xFF);
    if (bytes.length == 0) bytes.push(0);
    var node = this.decodeTables[0];
    for(var i = bytes.length - 1; i > 0; i--){
        // Traverse nodes deeper into the trie.
        var val = node[bytes[i]];
        if (val == $3939d1de148b5202$var$UNASSIGNED) {
            // Create new node.
            node[bytes[i]] = $3939d1de148b5202$var$NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = $3939d1de148b5202$var$UNASSIGNED_NODE.slice(0));
        } else if (val <= $3939d1de148b5202$var$NODE_START) // Existing node.
        node = this.decodeTables[$3939d1de148b5202$var$NODE_START - val];
        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
};
$3939d1de148b5202$var$DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16); // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF; // Write all other elements of the chunk to the table.
    for(var k = 1; k < chunk.length; k++){
        var part = chunk[k];
        if (typeof part === "string") // String, write as-is.
        for(var l = 0; l < part.length;){
            var code = part.charCodeAt(l++);
            if (0xD800 <= code && code < 0xDC00) {
                // Decode surrogate
                var codeTrail = part.charCodeAt(l++);
                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
            } else if (0x0FF0 < code && code <= 0x0FFF) {
                // Character sequence (our own encoding used)
                var len = 0xFFF - code + 2;
                var seq = [];
                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++));
                 // Simple variation: don't support surrogates or subsequences in seq.
                writeTable[curAddr++] = $3939d1de148b5202$var$SEQ_START - this.decodeTableSeq.length;
                this.decodeTableSeq.push(seq);
            } else writeTable[curAddr++] = code; // Basic char
        }
        else if (typeof part === "number") {
            // Integer, meaning increasing sequence starting with prev character.
            var charCode = writeTable[curAddr - 1] + 1;
            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
}; // Encoder helpers
$3939d1de148b5202$var$DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined) this.encodeTable[high] = $3939d1de148b5202$var$UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
};
$3939d1de148b5202$var$DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= $3939d1de148b5202$var$SEQ_START) this.encodeTableSeq[$3939d1de148b5202$var$SEQ_START - bucket[low]][$3939d1de148b5202$var$DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == $3939d1de148b5202$var$UNASSIGNED) bucket[low] = dbcsCode;
};
$3939d1de148b5202$var$DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    var node;
    if (bucket[low] <= $3939d1de148b5202$var$SEQ_START) // There's already a sequence with  - use it.
    node = this.encodeTableSeq[$3939d1de148b5202$var$SEQ_START - bucket[low]];
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== $3939d1de148b5202$var$UNASSIGNED) node[$3939d1de148b5202$var$DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = $3939d1de148b5202$var$SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    } // Traverse the character tree, allocating new nodes as needed.
    for(var j = 1; j < seq.length - 1; j++){
        var oldVal = node[uCode];
        if (typeof oldVal === 'object') node = oldVal;
        else {
            node = node[uCode] = {};
            if (oldVal !== undefined) node[$3939d1de148b5202$var$DEF_CHAR] = oldVal;
        }
    } // Set the leaf to given dbcsCode.
    uCode = seq[seq.length - 1];
    node[uCode] = dbcsCode;
};
$3939d1de148b5202$var$DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    for(var i = 0; i < 0x100; i++){
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode]) continue;
        if (uCode >= 0) this._setEncodeChar(uCode, mbCode);
        else if (uCode <= $3939d1de148b5202$var$NODE_START) this._fillEncodeTable($3939d1de148b5202$var$NODE_START - uCode, mbCode << 8, skipEncodeChars);
        else if (uCode <= $3939d1de148b5202$var$SEQ_START) this._setEncodeSequence(this.decodeTableSeq[$3939d1de148b5202$var$SEQ_START - uCode], mbCode);
    }
}; // == Encoder ==================================================================
function $3939d1de148b5202$var$DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined; // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}
$3939d1de148b5202$var$DBCSEncoder.prototype.write = function(str) {
    var newBuf = $3939d1de148b5202$var$Buffer$5.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
    while(true){
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        } else {
            var uCode = nextChar;
            nextChar = -1;
        } // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) {
            // Char is one of surrogates.
            if (uCode < 0xDC00) {
                // We've got lead surrogate.
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode; // Double lead surrogate found.
                    uCode = $3939d1de148b5202$var$UNASSIGNED;
                }
            } else // We've got trail surrogate.
            if (leadSurrogate !== -1) {
                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                leadSurrogate = -1;
            } else // Incomplete surrogate pair - only trail surrogate found.
            uCode = $3939d1de148b5202$var$UNASSIGNED;
        } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode;
            uCode = $3939d1de148b5202$var$UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        } // 2. Convert uCode character.
        var dbcsCode = $3939d1de148b5202$var$UNASSIGNED;
        if (seqObj !== undefined && uCode != $3939d1de148b5202$var$UNASSIGNED) {
            // We are in the middle of the sequence
            var resCode = seqObj[uCode];
            if (typeof resCode === 'object') {
                // Sequence continues.
                seqObj = resCode;
                continue;
            } else if (typeof resCode == 'number') // Sequence finished. Write it.
            dbcsCode = resCode;
            else if (resCode == undefined) {
                // Current character is not part of the sequence.
                // Try default character for this sequence
                resCode = seqObj[$3939d1de148b5202$var$DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.
                }
            }
            seqObj = undefined;
        } else if (uCode >= 0) {
            // Regular character
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
            if (dbcsCode <= $3939d1de148b5202$var$SEQ_START) {
                // Sequence start
                seqObj = this.encodeTableSeq[$3939d1de148b5202$var$SEQ_START - dbcsCode];
                continue;
            }
            if (dbcsCode == $3939d1de148b5202$var$UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = $3939d1de148b5202$var$findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                    dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                    dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                    dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        } // 3. Write dbcsCode character.
        if (dbcsCode === $3939d1de148b5202$var$UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8; // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        } else {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = dbcsCode >> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }
    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
};
$3939d1de148b5202$var$DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
    var newBuf = $3939d1de148b5202$var$Buffer$5.alloc(10), j = 0;
    if (this.seqObj) {
        // We're in the sequence.
        var dbcsCode = this.seqObj[$3939d1de148b5202$var$DEF_CHAR];
        if (dbcsCode !== undefined) {
            // Write beginning of the sequence.
            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
            else {
                newBuf[j++] = dbcsCode >> 8; // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        }
        this.seqObj = undefined;
    }
    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    return newBuf.slice(0, j);
}; // Export for testing
$3939d1de148b5202$var$DBCSEncoder.prototype.findIdx = $3939d1de148b5202$var$findIdx; // == Decoder ==================================================================
function $3939d1de148b5202$var$DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBuf = $3939d1de148b5202$var$Buffer$5.alloc(0); // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}
$3939d1de148b5202$var$DBCSDecoder.prototype.write = function(buf) {
    var newBuf = $3939d1de148b5202$var$Buffer$5.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length, seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
    uCode;
    if (prevBufOffset > 0) prevBuf = $3939d1de148b5202$var$Buffer$5.concat([
        prevBuf,
        buf.slice(0, 10)
    ]);
    for(var i = 0, j = 0; i < buf.length; i++){
        var curByte = i >= 0 ? buf[i] : prevBuf[i + prevBufOffset]; // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];
        if (uCode >= 0) ;
        else if (uCode === $3939d1de148b5202$var$UNASSIGNED) {
            // Unknown char.
            // TODO: Callback with seq.
            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
            uCode = this.defaultCharUnicode.charCodeAt(0);
        } else if (uCode === $3939d1de148b5202$var$GB18030_CODE) {
            var curSeq = seqStart >= 0 ? buf.slice(seqStart, i + 1) : prevBuf.slice(seqStart + prevBufOffset, i + 1 + prevBufOffset);
            var ptr = (curSeq[0] - 0x81) * 12600 + (curSeq[1] - 0x30) * 1260 + (curSeq[2] - 0x81) * 10 + (curSeq[3] - 0x30);
            var idx = $3939d1de148b5202$var$findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        } else if (uCode <= $3939d1de148b5202$var$NODE_START) {
            // Go to next trie node.
            nodeIdx = $3939d1de148b5202$var$NODE_START - uCode;
            continue;
        } else if (uCode <= $3939d1de148b5202$var$SEQ_START) {
            // Output a sequence of chars.
            var seq = this.decodeTableSeq[$3939d1de148b5202$var$SEQ_START - uCode];
            for(var k = 0; k < seq.length - 1; k++){
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length - 1];
        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte); // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode > 0xFFFF) {
            uCode -= 0x10000;
            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;
            uCode = 0xDC00 + uCode % 0x400;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8; // Reset trie node.
        nodeIdx = 0;
        seqStart = i + 1;
    }
    this.nodeIdx = nodeIdx;
    this.prevBuf = seqStart >= 0 ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
    return newBuf.slice(0, j).toString('ucs2');
};
$3939d1de148b5202$var$DBCSDecoder.prototype.end = function() {
    var ret = ''; // Try to parse all remaining chars.
    while(this.prevBuf.length > 0){
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var buf = this.prevBuf.slice(1); // Parse remaining as usual.
        this.prevBuf = $3939d1de148b5202$var$Buffer$5.alloc(0);
        this.nodeIdx = 0;
        if (buf.length > 0) ret += this.write(buf);
    }
    this.nodeIdx = 0;
    return ret;
}; // Binary search for GB18030. Returns largest i such that table[i] <= val.
function $3939d1de148b5202$var$findIdx(table, val) {
    if (table[0] > val) return -1;
    var l = 0, r = table.length;
    while(l < r - 1){
        // always table[l] <= val < table[r]
        var mid = l + Math.floor((r - l + 1) / 2);
        if (table[mid] <= val) l = mid;
        else r = mid;
    }
    return l;
}
var $3939d1de148b5202$var$dbcsCodec = {
    _dbcs: $3939d1de148b5202$var$_dbcs
};
var $3939d1de148b5202$var$shiftjis = [
    [
        "0",
        "\u0000",
        128
    ],
    [
        "a1",
        "\uFF61",
        62
    ],
    [
        "8140",
        "\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",
        9,
        "\uFF0B\uFF0D\xb1\xd7"
    ],
    [
        "8180",
        "\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"
    ],
    [
        "81b8",
        "\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"
    ],
    [
        "81c8",
        "\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"
    ],
    [
        "81da",
        "\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"
    ],
    [
        "81f0",
        "\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"
    ],
    [
        "81fc",
        "\u25EF"
    ],
    [
        "824f",
        "\uFF10",
        9
    ],
    [
        "8260",
        "\uFF21",
        25
    ],
    [
        "8281",
        "\uFF41",
        25
    ],
    [
        "829f",
        "\u3041",
        82
    ],
    [
        "8340",
        "\u30A1",
        62
    ],
    [
        "8380",
        "\u30E0",
        22
    ],
    [
        "839f",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "83bf",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "8440",
        "\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "8470",
        "\u0430",
        5,
        "\u0451\u0436",
        7
    ],
    [
        "8480",
        "\u043E",
        17
    ],
    [
        "849f",
        "\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"
    ],
    [
        "8740",
        "\u2460",
        19,
        "\u2160",
        9
    ],
    [
        "875f",
        "\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"
    ],
    [
        "877e",
        "\u337B"
    ],
    [
        "8780",
        "\u301D\u301F\u2116\u33CD\u2121\u32A4",
        4,
        "\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"
    ],
    [
        "889f",
        "\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"
    ],
    [
        "8940",
        "\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"
    ],
    [
        "8980",
        "\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"
    ],
    [
        "8a40",
        "\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"
    ],
    [
        "8a80",
        "\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"
    ],
    [
        "8b40",
        "\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"
    ],
    [
        "8b80",
        "\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"
    ],
    [
        "8c40",
        "\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"
    ],
    [
        "8c80",
        "\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"
    ],
    [
        "8d40",
        "\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"
    ],
    [
        "8d80",
        "\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"
    ],
    [
        "8e40",
        "\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"
    ],
    [
        "8e80",
        "\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"
    ],
    [
        "8f40",
        "\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"
    ],
    [
        "8f80",
        "\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"
    ],
    [
        "9040",
        "\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"
    ],
    [
        "9080",
        "\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"
    ],
    [
        "9140",
        "\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"
    ],
    [
        "9180",
        "\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"
    ],
    [
        "9240",
        "\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"
    ],
    [
        "9280",
        "\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"
    ],
    [
        "9340",
        "\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"
    ],
    [
        "9380",
        "\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"
    ],
    [
        "9440",
        "\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"
    ],
    [
        "9480",
        "\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"
    ],
    [
        "9540",
        "\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"
    ],
    [
        "9580",
        "\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"
    ],
    [
        "9640",
        "\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"
    ],
    [
        "9680",
        "\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"
    ],
    [
        "9740",
        "\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"
    ],
    [
        "9780",
        "\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"
    ],
    [
        "9840",
        "\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"
    ],
    [
        "989f",
        "\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"
    ],
    [
        "9940",
        "\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"
    ],
    [
        "9980",
        "\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"
    ],
    [
        "9a40",
        "\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"
    ],
    [
        "9a80",
        "\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"
    ],
    [
        "9b40",
        "\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"
    ],
    [
        "9b80",
        "\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"
    ],
    [
        "9c40",
        "\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"
    ],
    [
        "9c80",
        "\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"
    ],
    [
        "9d40",
        "\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"
    ],
    [
        "9d80",
        "\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"
    ],
    [
        "9e40",
        "\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"
    ],
    [
        "9e80",
        "\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"
    ],
    [
        "9f40",
        "\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"
    ],
    [
        "9f80",
        "\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"
    ],
    [
        "e040",
        "\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"
    ],
    [
        "e080",
        "\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"
    ],
    [
        "e140",
        "\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"
    ],
    [
        "e180",
        "\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"
    ],
    [
        "e240",
        "\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"
    ],
    [
        "e280",
        "\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"
    ],
    [
        "e340",
        "\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"
    ],
    [
        "e380",
        "\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"
    ],
    [
        "e440",
        "\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"
    ],
    [
        "e480",
        "\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"
    ],
    [
        "e540",
        "\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"
    ],
    [
        "e580",
        "\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"
    ],
    [
        "e640",
        "\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"
    ],
    [
        "e680",
        "\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"
    ],
    [
        "e740",
        "\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"
    ],
    [
        "e780",
        "\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"
    ],
    [
        "e840",
        "\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"
    ],
    [
        "e880",
        "\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"
    ],
    [
        "e940",
        "\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"
    ],
    [
        "e980",
        "\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"
    ],
    [
        "ea40",
        "\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"
    ],
    [
        "ea80",
        "\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"
    ],
    [
        "ed40",
        "\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"
    ],
    [
        "ed80",
        "\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"
    ],
    [
        "ee40",
        "\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"
    ],
    [
        "ee80",
        "\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"
    ],
    [
        "eeef",
        "\u2170",
        9,
        "\uFFE2\uFFE4\uFF07\uFF02"
    ],
    [
        "f040",
        "\uE000",
        62
    ],
    [
        "f080",
        "\uE03F",
        124
    ],
    [
        "f140",
        "\uE0BC",
        62
    ],
    [
        "f180",
        "\uE0FB",
        124
    ],
    [
        "f240",
        "\uE178",
        62
    ],
    [
        "f280",
        "\uE1B7",
        124
    ],
    [
        "f340",
        "\uE234",
        62
    ],
    [
        "f380",
        "\uE273",
        124
    ],
    [
        "f440",
        "\uE2F0",
        62
    ],
    [
        "f480",
        "\uE32F",
        124
    ],
    [
        "f540",
        "\uE3AC",
        62
    ],
    [
        "f580",
        "\uE3EB",
        124
    ],
    [
        "f640",
        "\uE468",
        62
    ],
    [
        "f680",
        "\uE4A7",
        124
    ],
    [
        "f740",
        "\uE524",
        62
    ],
    [
        "f780",
        "\uE563",
        124
    ],
    [
        "f840",
        "\uE5E0",
        62
    ],
    [
        "f880",
        "\uE61F",
        124
    ],
    [
        "f940",
        "\uE69C"
    ],
    [
        "fa40",
        "\u2170",
        9,
        "\u2160",
        9,
        "\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"
    ],
    [
        "fa80",
        "\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"
    ],
    [
        "fb40",
        "\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"
    ],
    [
        "fb80",
        "\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"
    ],
    [
        "fc40",
        "\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"
    ]
];
var $3939d1de148b5202$var$shiftjis$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $3939d1de148b5202$var$shiftjis
});
var $3939d1de148b5202$var$eucjp = [
    [
        "0",
        "\u0000",
        127
    ],
    [
        "8ea1",
        "\uFF61",
        62
    ],
    [
        "a1a1",
        "\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",
        9,
        "\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"
    ],
    [
        "a2a1",
        "\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"
    ],
    [
        "a2ba",
        "\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"
    ],
    [
        "a2ca",
        "\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"
    ],
    [
        "a2dc",
        "\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"
    ],
    [
        "a2f2",
        "\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"
    ],
    [
        "a2fe",
        "\u25EF"
    ],
    [
        "a3b0",
        "\uFF10",
        9
    ],
    [
        "a3c1",
        "\uFF21",
        25
    ],
    [
        "a3e1",
        "\uFF41",
        25
    ],
    [
        "a4a1",
        "\u3041",
        82
    ],
    [
        "a5a1",
        "\u30A1",
        85
    ],
    [
        "a6a1",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "a6c1",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "a7a1",
        "\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "a7d1",
        "\u0430",
        5,
        "\u0451\u0436",
        25
    ],
    [
        "a8a1",
        "\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"
    ],
    [
        "ada1",
        "\u2460",
        19,
        "\u2160",
        9
    ],
    [
        "adc0",
        "\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"
    ],
    [
        "addf",
        "\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",
        4,
        "\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"
    ],
    [
        "b0a1",
        "\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"
    ],
    [
        "b1a1",
        "\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"
    ],
    [
        "b2a1",
        "\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"
    ],
    [
        "b3a1",
        "\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"
    ],
    [
        "b4a1",
        "\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"
    ],
    [
        "b5a1",
        "\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"
    ],
    [
        "b6a1",
        "\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"
    ],
    [
        "b7a1",
        "\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"
    ],
    [
        "b8a1",
        "\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"
    ],
    [
        "b9a1",
        "\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"
    ],
    [
        "baa1",
        "\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"
    ],
    [
        "bba1",
        "\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"
    ],
    [
        "bca1",
        "\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"
    ],
    [
        "bda1",
        "\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"
    ],
    [
        "bea1",
        "\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"
    ],
    [
        "bfa1",
        "\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"
    ],
    [
        "c0a1",
        "\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"
    ],
    [
        "c1a1",
        "\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"
    ],
    [
        "c2a1",
        "\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"
    ],
    [
        "c3a1",
        "\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"
    ],
    [
        "c4a1",
        "\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"
    ],
    [
        "c5a1",
        "\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"
    ],
    [
        "c6a1",
        "\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"
    ],
    [
        "c7a1",
        "\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"
    ],
    [
        "c8a1",
        "\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"
    ],
    [
        "c9a1",
        "\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"
    ],
    [
        "caa1",
        "\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"
    ],
    [
        "cba1",
        "\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"
    ],
    [
        "cca1",
        "\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"
    ],
    [
        "cda1",
        "\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"
    ],
    [
        "cea1",
        "\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"
    ],
    [
        "cfa1",
        "\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"
    ],
    [
        "d0a1",
        "\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"
    ],
    [
        "d1a1",
        "\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"
    ],
    [
        "d2a1",
        "\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"
    ],
    [
        "d3a1",
        "\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"
    ],
    [
        "d4a1",
        "\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"
    ],
    [
        "d5a1",
        "\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"
    ],
    [
        "d6a1",
        "\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"
    ],
    [
        "d7a1",
        "\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"
    ],
    [
        "d8a1",
        "\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"
    ],
    [
        "d9a1",
        "\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"
    ],
    [
        "daa1",
        "\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"
    ],
    [
        "dba1",
        "\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"
    ],
    [
        "dca1",
        "\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"
    ],
    [
        "dda1",
        "\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"
    ],
    [
        "dea1",
        "\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"
    ],
    [
        "dfa1",
        "\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"
    ],
    [
        "e0a1",
        "\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"
    ],
    [
        "e1a1",
        "\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"
    ],
    [
        "e2a1",
        "\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"
    ],
    [
        "e3a1",
        "\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"
    ],
    [
        "e4a1",
        "\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"
    ],
    [
        "e5a1",
        "\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"
    ],
    [
        "e6a1",
        "\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"
    ],
    [
        "e7a1",
        "\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"
    ],
    [
        "e8a1",
        "\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"
    ],
    [
        "e9a1",
        "\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"
    ],
    [
        "eaa1",
        "\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"
    ],
    [
        "eba1",
        "\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"
    ],
    [
        "eca1",
        "\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"
    ],
    [
        "eda1",
        "\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"
    ],
    [
        "eea1",
        "\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"
    ],
    [
        "efa1",
        "\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"
    ],
    [
        "f0a1",
        "\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"
    ],
    [
        "f1a1",
        "\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"
    ],
    [
        "f2a1",
        "\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"
    ],
    [
        "f3a1",
        "\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"
    ],
    [
        "f4a1",
        "\u582F\u69C7\u9059\u7464\u51DC\u7199"
    ],
    [
        "f9a1",
        "\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"
    ],
    [
        "faa1",
        "\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"
    ],
    [
        "fba1",
        "\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"
    ],
    [
        "fca1",
        "\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"
    ],
    [
        "fcf1",
        "\u2170",
        9,
        "\uFFE2\uFFE4\uFF07\uFF02"
    ],
    [
        "8fa2af",
        "\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"
    ],
    [
        "8fa2c2",
        "\xa1\xa6\xbf"
    ],
    [
        "8fa2eb",
        "\xba\xaa\xa9\xae\u2122\xa4\u2116"
    ],
    [
        "8fa6e1",
        "\u0386\u0388\u0389\u038A\u03AA"
    ],
    [
        "8fa6e7",
        "\u038C"
    ],
    [
        "8fa6e9",
        "\u038E\u03AB"
    ],
    [
        "8fa6ec",
        "\u038F"
    ],
    [
        "8fa6f1",
        "\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"
    ],
    [
        "8fa7c2",
        "\u0402",
        10,
        "\u040E\u040F"
    ],
    [
        "8fa7f2",
        "\u0452",
        10,
        "\u045E\u045F"
    ],
    [
        "8fa9a1",
        "\xc6\u0110"
    ],
    [
        "8fa9a4",
        "\u0126"
    ],
    [
        "8fa9a6",
        "\u0132"
    ],
    [
        "8fa9a8",
        "\u0141\u013F"
    ],
    [
        "8fa9ab",
        "\u014A\xd8\u0152"
    ],
    [
        "8fa9af",
        "\u0166\xde"
    ],
    [
        "8fa9c1",
        "\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"
    ],
    [
        "8faaa1",
        "\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"
    ],
    [
        "8faaba",
        "\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"
    ],
    [
        "8faba1",
        "\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"
    ],
    [
        "8fabbd",
        "\u0121\u0125\xed\xec\xef\xee\u01D0"
    ],
    [
        "8fabc5",
        "\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"
    ],
    [
        "8fb0a1",
        "\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"
    ],
    [
        "8fb1a1",
        "\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"
    ],
    [
        "8fb2a1",
        "\u5092\u5093\u5094\u5096\u509B\u509C\u509E",
        4,
        "\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"
    ],
    [
        "8fb3a1",
        "\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"
    ],
    [
        "8fb4a1",
        "\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"
    ],
    [
        "8fb5a1",
        "\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"
    ],
    [
        "8fb6a1",
        "\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",
        5,
        "\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",
        4,
        "\u56F1\u56EB\u56ED"
    ],
    [
        "8fb7a1",
        "\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",
        4,
        "\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"
    ],
    [
        "8fb8a1",
        "\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"
    ],
    [
        "8fb9a1",
        "\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"
    ],
    [
        "8fbaa1",
        "\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",
        4,
        "\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"
    ],
    [
        "8fbba1",
        "\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"
    ],
    [
        "8fbca1",
        "\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",
        4,
        "\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"
    ],
    [
        "8fbda1",
        "\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",
        4,
        "\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"
    ],
    [
        "8fbea1",
        "\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",
        4,
        "\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"
    ],
    [
        "8fbfa1",
        "\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"
    ],
    [
        "8fc0a1",
        "\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"
    ],
    [
        "8fc1a1",
        "\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"
    ],
    [
        "8fc2a1",
        "\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"
    ],
    [
        "8fc3a1",
        "\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",
        4,
        "\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"
    ],
    [
        "8fc4a1",
        "\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"
    ],
    [
        "8fc5a1",
        "\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"
    ],
    [
        "8fc6a1",
        "\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"
    ],
    [
        "8fc7a1",
        "\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"
    ],
    [
        "8fc8a1",
        "\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"
    ],
    [
        "8fc9a1",
        "\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",
        4,
        "\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",
        4,
        "\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"
    ],
    [
        "8fcaa1",
        "\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"
    ],
    [
        "8fcba1",
        "\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"
    ],
    [
        "8fcca1",
        "\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",
        9,
        "\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"
    ],
    [
        "8fcda1",
        "\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",
        5,
        "\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"
    ],
    [
        "8fcea1",
        "\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",
        6,
        "\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"
    ],
    [
        "8fcfa1",
        "\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"
    ],
    [
        "8fd0a1",
        "\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"
    ],
    [
        "8fd1a1",
        "\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"
    ],
    [
        "8fd2a1",
        "\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",
        5
    ],
    [
        "8fd3a1",
        "\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"
    ],
    [
        "8fd4a1",
        "\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",
        4,
        "\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"
    ],
    [
        "8fd5a1",
        "\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"
    ],
    [
        "8fd6a1",
        "\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"
    ],
    [
        "8fd7a1",
        "\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"
    ],
    [
        "8fd8a1",
        "\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"
    ],
    [
        "8fd9a1",
        "\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",
        4,
        "\u8556\u8559\u855C",
        6,
        "\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"
    ],
    [
        "8fdaa1",
        "\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",
        4,
        "\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"
    ],
    [
        "8fdba1",
        "\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",
        6,
        "\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"
    ],
    [
        "8fdca1",
        "\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",
        4,
        "\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"
    ],
    [
        "8fdda1",
        "\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",
        4,
        "\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"
    ],
    [
        "8fdea1",
        "\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",
        4,
        "\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"
    ],
    [
        "8fdfa1",
        "\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"
    ],
    [
        "8fe0a1",
        "\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"
    ],
    [
        "8fe1a1",
        "\u8F43\u8F47\u8F4F\u8F51",
        4,
        "\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"
    ],
    [
        "8fe2a1",
        "\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"
    ],
    [
        "8fe3a1",
        "\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",
        5,
        "\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",
        4,
        "\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"
    ],
    [
        "8fe4a1",
        "\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",
        4,
        "\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"
    ],
    [
        "8fe5a1",
        "\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",
        4,
        "\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"
    ],
    [
        "8fe6a1",
        "\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"
    ],
    [
        "8fe7a1",
        "\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"
    ],
    [
        "8fe8a1",
        "\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",
        4,
        "\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"
    ],
    [
        "8fe9a1",
        "\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",
        4
    ],
    [
        "8feaa1",
        "\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",
        4,
        "\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"
    ],
    [
        "8feba1",
        "\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",
        4,
        "\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"
    ],
    [
        "8feca1",
        "\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"
    ],
    [
        "8feda1",
        "\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",
        4,
        "\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",
        4,
        "\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"
    ]
];
var $3939d1de148b5202$var$eucjp$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $3939d1de148b5202$var$eucjp
});
var $3939d1de148b5202$var$cp936 = [
    [
        "0",
        "\u0000",
        127,
        "\u20AC"
    ],
    [
        "8140",
        "\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",
        5,
        "\u4E72\u4E74",
        9,
        "\u4E7F",
        6,
        "\u4E87\u4E8A"
    ],
    [
        "8180",
        "\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",
        6,
        "\u4F0B\u4F0C\u4F12",
        4,
        "\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",
        4,
        "\u4F44\u4F45\u4F47",
        5,
        "\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"
    ],
    [
        "8240",
        "\u4FA4\u4FAB\u4FAD\u4FB0",
        4,
        "\u4FB6",
        8,
        "\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",
        4,
        "\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",
        11
    ],
    [
        "8280",
        "\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",
        10,
        "\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",
        4,
        "\u5056\u5057\u5058\u5059\u505B\u505D",
        7,
        "\u5066",
        5,
        "\u506D",
        8,
        "\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",
        20,
        "\u50A4\u50A6\u50AA\u50AB\u50AD",
        4,
        "\u50B3",
        6,
        "\u50BC"
    ],
    [
        "8340",
        "\u50BD",
        17,
        "\u50D0",
        5,
        "\u50D7\u50D8\u50D9\u50DB",
        10,
        "\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",
        4,
        "\u50FC",
        9,
        "\u5108"
    ],
    [
        "8380",
        "\u5109\u510A\u510C",
        5,
        "\u5113",
        13,
        "\u5122",
        28,
        "\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",
        4,
        "\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",
        4,
        "\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",
        5
    ],
    [
        "8440",
        "\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",
        5,
        "\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",
        5,
        "\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"
    ],
    [
        "8480",
        "\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",
        9,
        "\u527E\u5280\u5283",
        4,
        "\u5289",
        6,
        "\u5291\u5292\u5294",
        6,
        "\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",
        9,
        "\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",
        5,
        "\u52E0\u52E1\u52E2\u52E3\u52E5",
        10,
        "\u52F1",
        7,
        "\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"
    ],
    [
        "8540",
        "\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",
        9,
        "\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"
    ],
    [
        "8580",
        "\u5390",
        4,
        "\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",
        6,
        "\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",
        4,
        "\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",
        4,
        "\u5463\u5465\u5467\u5469",
        7,
        "\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"
    ],
    [
        "8640",
        "\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",
        4,
        "\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",
        5,
        "\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",
        4,
        "\u5512\u5513\u5515",
        5,
        "\u551C\u551D\u551E\u551F\u5521\u5525\u5526"
    ],
    [
        "8680",
        "\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",
        4,
        "\u5551\u5552\u5553\u5554\u5557",
        4,
        "\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",
        5,
        "\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",
        6,
        "\u55A8",
        8,
        "\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",
        4,
        "\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",
        4,
        "\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",
        4,
        "\u55FF\u5602\u5603\u5604\u5605"
    ],
    [
        "8740",
        "\u5606\u5607\u560A\u560B\u560D\u5610",
        7,
        "\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",
        11,
        "\u564F",
        4,
        "\u5655\u5656\u565A\u565B\u565D",
        4
    ],
    [
        "8780",
        "\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",
        7,
        "\u5687",
        6,
        "\u5690\u5691\u5692\u5694",
        14,
        "\u56A4",
        10,
        "\u56B0",
        6,
        "\u56B8\u56B9\u56BA\u56BB\u56BD",
        12,
        "\u56CB",
        8,
        "\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",
        5,
        "\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",
        6
    ],
    [
        "8840",
        "\u5712",
        9,
        "\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",
        4,
        "\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",
        4,
        "\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"
    ],
    [
        "8880",
        "\u5781\u5787\u5788\u5789\u578A\u578D",
        4,
        "\u5794",
        6,
        "\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",
        8,
        "\u57C4",
        6,
        "\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",
        7,
        "\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",
        4,
        "\u582B",
        4,
        "\u5831\u5832\u5833\u5834\u5836",
        7
    ],
    [
        "8940",
        "\u583E",
        5,
        "\u5845",
        6,
        "\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",
        4,
        "\u585F",
        5,
        "\u5866",
        4,
        "\u586D",
        16,
        "\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"
    ],
    [
        "8980",
        "\u588D",
        4,
        "\u5894",
        4,
        "\u589B\u589C\u589D\u58A0",
        7,
        "\u58AA",
        17,
        "\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",
        10,
        "\u58D2\u58D3\u58D4\u58D6",
        13,
        "\u58E5",
        5,
        "\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",
        7,
        "\u5903\u5905\u5906\u5908",
        4,
        "\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"
    ],
    [
        "8a40",
        "\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",
        4,
        "\u5961\u5963\u5964\u5966",
        12,
        "\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"
    ],
    [
        "8a80",
        "\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",
        5,
        "\u59BA\u59BC\u59BD\u59BF",
        6,
        "\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",
        4,
        "\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",
        11,
        "\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",
        6,
        "\u5A33\u5A35\u5A37",
        4,
        "\u5A3D\u5A3E\u5A3F\u5A41",
        4,
        "\u5A47\u5A48\u5A4B",
        9,
        "\u5A56\u5A57\u5A58\u5A59\u5A5B",
        5
    ],
    [
        "8b40",
        "\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",
        8,
        "\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",
        17,
        "\u5A93",
        6,
        "\u5A9C",
        13,
        "\u5AAB\u5AAC"
    ],
    [
        "8b80",
        "\u5AAD",
        4,
        "\u5AB4\u5AB6\u5AB7\u5AB9",
        4,
        "\u5ABF\u5AC0\u5AC3",
        5,
        "\u5ACA\u5ACB\u5ACD",
        4,
        "\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",
        4,
        "\u5AF2",
        22,
        "\u5B0A",
        11,
        "\u5B18",
        25,
        "\u5B33\u5B35\u5B36\u5B38",
        7,
        "\u5B41",
        6
    ],
    [
        "8c40",
        "\u5B48",
        7,
        "\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"
    ],
    [
        "8c80",
        "\u5BD1\u5BD4",
        8,
        "\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",
        4,
        "\u5BEF\u5BF1",
        6,
        "\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",
        6,
        "\u5C70\u5C72",
        6,
        "\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",
        4,
        "\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",
        4,
        "\u5CA4",
        4
    ],
    [
        "8d40",
        "\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",
        5,
        "\u5CCC",
        5,
        "\u5CD3",
        5,
        "\u5CDA",
        6,
        "\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",
        9,
        "\u5CFC",
        4
    ],
    [
        "8d80",
        "\u5D01\u5D04\u5D05\u5D08",
        5,
        "\u5D0F",
        4,
        "\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",
        4,
        "\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",
        4,
        "\u5D35",
        7,
        "\u5D3F",
        7,
        "\u5D48\u5D49\u5D4D",
        10,
        "\u5D59\u5D5A\u5D5C\u5D5E",
        10,
        "\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",
        12,
        "\u5D83",
        21,
        "\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"
    ],
    [
        "8e40",
        "\u5DA1",
        21,
        "\u5DB8",
        12,
        "\u5DC6",
        6,
        "\u5DCE",
        12,
        "\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"
    ],
    [
        "8e80",
        "\u5DF0\u5DF5\u5DF6\u5DF8",
        4,
        "\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",
        7,
        "\u5E28",
        4,
        "\u5E2F\u5E30\u5E32",
        4,
        "\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",
        5,
        "\u5E4D",
        6,
        "\u5E56",
        4,
        "\u5E5C\u5E5D\u5E5F\u5E60\u5E63",
        14,
        "\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",
        4,
        "\u5EAE",
        4,
        "\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",
        6
    ],
    [
        "8f40",
        "\u5EC6\u5EC7\u5EC8\u5ECB",
        5,
        "\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",
        11,
        "\u5EE9\u5EEB",
        8,
        "\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"
    ],
    [
        "8f80",
        "\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",
        6,
        "\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",
        14,
        "\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",
        5,
        "\u5FA9\u5FAB\u5FAC\u5FAF",
        5,
        "\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",
        4,
        "\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"
    ],
    [
        "9040",
        "\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",
        4,
        "\u6036",
        4,
        "\u603D\u603E\u6040\u6044",
        6,
        "\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"
    ],
    [
        "9080",
        "\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",
        7,
        "\u60C7\u60C8\u60C9\u60CC",
        4,
        "\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",
        4,
        "\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",
        4,
        "\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",
        4,
        "\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",
        18,
        "\u6140",
        6
    ],
    [
        "9140",
        "\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",
        6,
        "\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",
        6,
        "\u6171\u6172\u6173\u6174\u6176\u6178",
        18,
        "\u618C\u618D\u618F",
        4,
        "\u6195"
    ],
    [
        "9180",
        "\u6196",
        6,
        "\u619E",
        8,
        "\u61AA\u61AB\u61AD",
        9,
        "\u61B8",
        5,
        "\u61BF\u61C0\u61C1\u61C3",
        4,
        "\u61C9\u61CC",
        4,
        "\u61D3\u61D5",
        16,
        "\u61E7",
        13,
        "\u61F6",
        8,
        "\u6200",
        5,
        "\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",
        4,
        "\u6242\u6244\u6245\u6246\u624A"
    ],
    [
        "9240",
        "\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",
        6,
        "\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",
        5,
        "\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"
    ],
    [
        "9280",
        "\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",
        5,
        "\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",
        7,
        "\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",
        6,
        "\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"
    ],
    [
        "9340",
        "\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",
        6,
        "\u63DF\u63E2\u63E4",
        4,
        "\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",
        4,
        "\u640D\u640E\u6411\u6412\u6415",
        5,
        "\u641D\u641F\u6422\u6423\u6424"
    ],
    [
        "9380",
        "\u6425\u6427\u6428\u6429\u642B\u642E",
        5,
        "\u6435",
        4,
        "\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",
        6,
        "\u6453\u6455\u6456\u6457\u6459",
        4,
        "\u645F",
        7,
        "\u6468\u646A\u646B\u646C\u646E",
        9,
        "\u647B",
        6,
        "\u6483\u6486\u6488",
        8,
        "\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",
        4,
        "\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",
        6,
        "\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"
    ],
    [
        "9440",
        "\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",
        24,
        "\u6501",
        7,
        "\u650A",
        7,
        "\u6513",
        4,
        "\u6519",
        8
    ],
    [
        "9480",
        "\u6522\u6523\u6524\u6526",
        4,
        "\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",
        4,
        "\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",
        14,
        "\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",
        7,
        "\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",
        7,
        "\u65E1\u65E3\u65E4\u65EA\u65EB"
    ],
    [
        "9540",
        "\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",
        4,
        "\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",
        4,
        "\u663D\u663F\u6640\u6642\u6644",
        6,
        "\u664D\u664E\u6650\u6651\u6658"
    ],
    [
        "9580",
        "\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",
        4,
        "\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",
        4,
        "\u669E",
        8,
        "\u66A9",
        4,
        "\u66AF",
        4,
        "\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",
        25,
        "\u66DA\u66DE",
        7,
        "\u66E7\u66E8\u66EA",
        5,
        "\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"
    ],
    [
        "9640",
        "\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",
        5,
        "\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",
        4,
        "\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"
    ],
    [
        "9680",
        "\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",
        7,
        "\u67C2\u67C5",
        9,
        "\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",
        7,
        "\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",
        4,
        "\u681E\u681F\u6820\u6822",
        6,
        "\u682B",
        6,
        "\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",
        5
    ],
    [
        "9740",
        "\u685C\u685D\u685E\u685F\u686A\u686C",
        7,
        "\u6875\u6878",
        8,
        "\u6882\u6884\u6887",
        7,
        "\u6890\u6891\u6892\u6894\u6895\u6896\u6898",
        9,
        "\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"
    ],
    [
        "9780",
        "\u68B9",
        6,
        "\u68C1\u68C3",
        5,
        "\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",
        4,
        "\u68E1\u68E2\u68E4",
        9,
        "\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",
        4,
        "\u690C\u690F\u6911\u6913",
        11,
        "\u6921\u6922\u6923\u6925",
        7,
        "\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",
        16,
        "\u6955\u6956\u6958\u6959\u695B\u695C\u695F"
    ],
    [
        "9840",
        "\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",
        4,
        "\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",
        5,
        "\u6996\u6997\u6999\u699A\u699D",
        9,
        "\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"
    ],
    [
        "9880",
        "\u69BE\u69BF\u69C0\u69C2",
        7,
        "\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",
        5,
        "\u69DC\u69DD\u69DE\u69E1",
        11,
        "\u69EE\u69EF\u69F0\u69F1\u69F3",
        9,
        "\u69FE\u6A00",
        9,
        "\u6A0B",
        11,
        "\u6A19",
        5,
        "\u6A20\u6A22",
        5,
        "\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",
        6,
        "\u6A3F",
        4,
        "\u6A45\u6A46\u6A48",
        7,
        "\u6A51",
        6,
        "\u6A5A"
    ],
    [
        "9940",
        "\u6A5C",
        4,
        "\u6A62\u6A63\u6A64\u6A66",
        10,
        "\u6A72",
        6,
        "\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",
        8,
        "\u6A8F\u6A92",
        4,
        "\u6A98",
        7,
        "\u6AA1",
        5
    ],
    [
        "9980",
        "\u6AA7\u6AA8\u6AAA\u6AAD",
        114,
        "\u6B25\u6B26\u6B28",
        6
    ],
    [
        "9a40",
        "\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",
        11,
        "\u6B5A",
        7,
        "\u6B68\u6B69\u6B6B",
        13,
        "\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"
    ],
    [
        "9a80",
        "\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",
        4,
        "\u6BA2",
        7,
        "\u6BAB",
        7,
        "\u6BB6\u6BB8",
        6,
        "\u6BC0\u6BC3\u6BC4\u6BC6",
        4,
        "\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",
        4,
        "\u6BE2",
        7,
        "\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",
        6,
        "\u6C08",
        4,
        "\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",
        4,
        "\u6C51\u6C52\u6C53\u6C56\u6C58"
    ],
    [
        "9b40",
        "\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",
        4,
        "\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"
    ],
    [
        "9b80",
        "\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",
        5,
        "\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",
        4,
        "\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",
        4,
        "\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",
        5,
        "\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"
    ],
    [
        "9c40",
        "\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",
        7,
        "\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"
    ],
    [
        "9c80",
        "\u6E36\u6E37\u6E39\u6E3B",
        7,
        "\u6E45",
        7,
        "\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",
        10,
        "\u6E6C\u6E6D\u6E6F",
        14,
        "\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",
        4,
        "\u6E91",
        6,
        "\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",
        5
    ],
    [
        "9d40",
        "\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",
        7,
        "\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",
        4,
        "\u6F10\u6F11\u6F12\u6F16",
        9,
        "\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",
        6,
        "\u6F3F\u6F40\u6F41\u6F42"
    ],
    [
        "9d80",
        "\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",
        9,
        "\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",
        5,
        "\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",
        6,
        "\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",
        12,
        "\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",
        4,
        "\u6FA8",
        10,
        "\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",
        5,
        "\u6FC1\u6FC3",
        5,
        "\u6FCA",
        6,
        "\u6FD3",
        10,
        "\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"
    ],
    [
        "9e40",
        "\u6FE6",
        7,
        "\u6FF0",
        32,
        "\u7012",
        7,
        "\u701C",
        6,
        "\u7024",
        6
    ],
    [
        "9e80",
        "\u702B",
        9,
        "\u7036\u7037\u7038\u703A",
        17,
        "\u704D\u704E\u7050",
        13,
        "\u705F",
        11,
        "\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",
        12,
        "\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",
        12,
        "\u70DA"
    ],
    [
        "9f40",
        "\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",
        6,
        "\u70F8\u70FA\u70FB\u70FC\u70FE",
        10,
        "\u710B",
        4,
        "\u7111\u7112\u7114\u7117\u711B",
        10,
        "\u7127",
        7,
        "\u7132\u7133\u7134"
    ],
    [
        "9f80",
        "\u7135\u7137",
        13,
        "\u7146\u7147\u7148\u7149\u714B\u714D\u714F",
        12,
        "\u715D\u715F",
        4,
        "\u7165\u7169",
        4,
        "\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",
        5,
        "\u7185",
        4,
        "\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",
        4,
        "\u71A1",
        6,
        "\u71A9\u71AA\u71AB\u71AD",
        5,
        "\u71B4\u71B6\u71B7\u71B8\u71BA",
        8,
        "\u71C4",
        9,
        "\u71CF",
        4
    ],
    [
        "a040",
        "\u71D6",
        9,
        "\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",
        5,
        "\u71EF",
        9,
        "\u71FA",
        11,
        "\u7207",
        19
    ],
    [
        "a080",
        "\u721B\u721C\u721E",
        9,
        "\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",
        6,
        "\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",
        4,
        "\u728C\u728E\u7290\u7291\u7293",
        11,
        "\u72A0",
        11,
        "\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",
        6,
        "\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"
    ],
    [
        "a1a1",
        "\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",
        7,
        "\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"
    ],
    [
        "a2a1",
        "\u2170",
        9
    ],
    [
        "a2b1",
        "\u2488",
        19,
        "\u2474",
        19,
        "\u2460",
        9
    ],
    [
        "a2e5",
        "\u3220",
        9
    ],
    [
        "a2f1",
        "\u2160",
        11
    ],
    [
        "a3a1",
        "\uFF01\uFF02\uFF03\uFFE5\uFF05",
        88,
        "\uFFE3"
    ],
    [
        "a4a1",
        "\u3041",
        82
    ],
    [
        "a5a1",
        "\u30A1",
        85
    ],
    [
        "a6a1",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "a6c1",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "a6e0",
        "\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"
    ],
    [
        "a6ee",
        "\uFE3B\uFE3C\uFE37\uFE38\uFE31"
    ],
    [
        "a6f4",
        "\uFE33\uFE34"
    ],
    [
        "a7a1",
        "\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "a7d1",
        "\u0430",
        5,
        "\u0451\u0436",
        25
    ],
    [
        "a840",
        "\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",
        35,
        "\u2581",
        6
    ],
    [
        "a880",
        "\u2588",
        7,
        "\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"
    ],
    [
        "a8a1",
        "\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"
    ],
    [
        "a8bd",
        "\u0144\u0148"
    ],
    [
        "a8c0",
        "\u0261"
    ],
    [
        "a8c5",
        "\u3105",
        36
    ],
    [
        "a940",
        "\u3021",
        8,
        "\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"
    ],
    [
        "a959",
        "\u2121\u3231"
    ],
    [
        "a95c",
        "\u2010"
    ],
    [
        "a960",
        "\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",
        9,
        "\uFE54\uFE55\uFE56\uFE57\uFE59",
        8
    ],
    [
        "a980",
        "\uFE62",
        4,
        "\uFE68\uFE69\uFE6A\uFE6B"
    ],
    [
        "a996",
        "\u3007"
    ],
    [
        "a9a4",
        "\u2500",
        75
    ],
    [
        "aa40",
        "\u72DC\u72DD\u72DF\u72E2",
        5,
        "\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",
        5,
        "\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",
        8
    ],
    [
        "aa80",
        "\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",
        7,
        "\u7361",
        10,
        "\u736E\u7370\u7371"
    ],
    [
        "ab40",
        "\u7372",
        11,
        "\u737F",
        4,
        "\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",
        5,
        "\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",
        4
    ],
    [
        "ab80",
        "\u73CB\u73CC\u73CE\u73D2",
        6,
        "\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",
        4
    ],
    [
        "ac40",
        "\u73F8",
        10,
        "\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",
        8,
        "\u741C",
        5,
        "\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",
        4,
        "\u743D\u743E\u743F\u7440\u7442",
        11
    ],
    [
        "ac80",
        "\u744E",
        6,
        "\u7456\u7458\u745D\u7460",
        12,
        "\u746E\u746F\u7471",
        4,
        "\u7478\u7479\u747A"
    ],
    [
        "ad40",
        "\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",
        10,
        "\u749D\u749F",
        7,
        "\u74AA",
        15,
        "\u74BB",
        12
    ],
    [
        "ad80",
        "\u74C8",
        9,
        "\u74D3",
        8,
        "\u74DD\u74DF\u74E1\u74E5\u74E7",
        6,
        "\u74F0\u74F1\u74F2"
    ],
    [
        "ae40",
        "\u74F3\u74F5\u74F8",
        6,
        "\u7500\u7501\u7502\u7503\u7505",
        7,
        "\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",
        4,
        "\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"
    ],
    [
        "ae80",
        "\u755D",
        7,
        "\u7567\u7568\u7569\u756B",
        6,
        "\u7573\u7575\u7576\u7577\u757A",
        4,
        "\u7580\u7581\u7582\u7584\u7585\u7587"
    ],
    [
        "af40",
        "\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",
        4,
        "\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"
    ],
    [
        "af80",
        "\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"
    ],
    [
        "b040",
        "\u7645",
        6,
        "\u764E",
        5,
        "\u7655\u7657",
        4,
        "\u765D\u765F\u7660\u7661\u7662\u7664",
        6,
        "\u766C\u766D\u766E\u7670",
        7,
        "\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"
    ],
    [
        "b080",
        "\u769C",
        7,
        "\u76A5",
        8,
        "\u76AF\u76B0\u76B3\u76B5",
        9,
        "\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"
    ],
    [
        "b140",
        "\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",
        4,
        "\u76E6",
        7,
        "\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",
        10,
        "\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"
    ],
    [
        "b180",
        "\u772C\u772E\u7730",
        4,
        "\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",
        7,
        "\u7752",
        7,
        "\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"
    ],
    [
        "b240",
        "\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",
        11,
        "\u777A\u777B\u777C\u7781\u7782\u7783\u7786",
        5,
        "\u778F\u7790\u7793",
        11,
        "\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",
        4
    ],
    [
        "b280",
        "\u77BC\u77BE\u77C0",
        12,
        "\u77CE",
        8,
        "\u77D8\u77D9\u77DA\u77DD",
        4,
        "\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"
    ],
    [
        "b340",
        "\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",
        5,
        "\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"
    ],
    [
        "b380",
        "\u785B\u785C\u785E",
        11,
        "\u786F",
        7,
        "\u7878\u7879\u787A\u787B\u787D",
        6,
        "\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"
    ],
    [
        "b440",
        "\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",
        7,
        "\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",
        9
    ],
    [
        "b480",
        "\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",
        4,
        "\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",
        5,
        "\u7902\u7903\u7904\u7906",
        6,
        "\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"
    ],
    [
        "b540",
        "\u790D",
        5,
        "\u7914",
        9,
        "\u791F",
        4,
        "\u7925",
        14,
        "\u7935",
        4,
        "\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",
        8,
        "\u7954\u7955\u7958\u7959\u7961\u7963"
    ],
    [
        "b580",
        "\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",
        6,
        "\u7979\u797B",
        4,
        "\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"
    ],
    [
        "b640",
        "\u7993",
        6,
        "\u799B",
        11,
        "\u79A8",
        10,
        "\u79B4",
        4,
        "\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",
        5,
        "\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"
    ],
    [
        "b680",
        "\u79EC\u79EE\u79F1",
        6,
        "\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",
        4,
        "\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"
    ],
    [
        "b740",
        "\u7A1D\u7A1F\u7A21\u7A22\u7A24",
        14,
        "\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",
        5,
        "\u7A47",
        9,
        "\u7A52",
        4,
        "\u7A58",
        16
    ],
    [
        "b780",
        "\u7A69",
        6,
        "\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"
    ],
    [
        "b840",
        "\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",
        4,
        "\u7AB4",
        10,
        "\u7AC0",
        10,
        "\u7ACC",
        9,
        "\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",
        5,
        "\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"
    ],
    [
        "b880",
        "\u7AF4",
        4,
        "\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"
    ],
    [
        "b940",
        "\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",
        5,
        "\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",
        10,
        "\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",
        6,
        "\u7B8E\u7B8F"
    ],
    [
        "b980",
        "\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",
        7,
        "\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"
    ],
    [
        "ba40",
        "\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",
        4,
        "\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",
        4,
        "\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",
        7,
        "\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",
        5,
        "\u7C17\u7C18\u7C19"
    ],
    [
        "ba80",
        "\u7C1A",
        4,
        "\u7C20",
        5,
        "\u7C28\u7C29\u7C2B",
        12,
        "\u7C39",
        5,
        "\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"
    ],
    [
        "bb40",
        "\u7C43",
        9,
        "\u7C4E",
        36,
        "\u7C75",
        5,
        "\u7C7E",
        9
    ],
    [
        "bb80",
        "\u7C88\u7C8A",
        6,
        "\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",
        4,
        "\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"
    ],
    [
        "bc40",
        "\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",
        6,
        "\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",
        6,
        "\u7CE9",
        5,
        "\u7CF0",
        7,
        "\u7CF9\u7CFA\u7CFC",
        13,
        "\u7D0B",
        5
    ],
    [
        "bc80",
        "\u7D11",
        14,
        "\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",
        6,
        "\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"
    ],
    [
        "bd40",
        "\u7D37",
        54,
        "\u7D6F",
        7
    ],
    [
        "bd80",
        "\u7D78",
        32,
        "\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"
    ],
    [
        "be40",
        "\u7D99",
        12,
        "\u7DA7",
        6,
        "\u7DAF",
        42
    ],
    [
        "be80",
        "\u7DDA",
        32,
        "\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"
    ],
    [
        "bf40",
        "\u7DFB",
        62
    ],
    [
        "bf80",
        "\u7E3A\u7E3C",
        4,
        "\u7E42",
        4,
        "\u7E48",
        21,
        "\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"
    ],
    [
        "c040",
        "\u7E5E",
        35,
        "\u7E83",
        23,
        "\u7E9C\u7E9D\u7E9E"
    ],
    [
        "c080",
        "\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",
        6,
        "\u7F43\u7F46",
        9,
        "\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"
    ],
    [
        "c140",
        "\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",
        4,
        "\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",
        7,
        "\u7F8B\u7F8D\u7F8F",
        4,
        "\u7F95",
        4,
        "\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",
        6,
        "\u7FB1"
    ],
    [
        "c180",
        "\u7FB3",
        4,
        "\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",
        4,
        "\u7FD6\u7FD7\u7FD9",
        5,
        "\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"
    ],
    [
        "c240",
        "\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",
        6,
        "\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",
        5,
        "\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"
    ],
    [
        "c280",
        "\u8059\u805B",
        13,
        "\u806B",
        5,
        "\u8072",
        11,
        "\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"
    ],
    [
        "c340",
        "\u807E\u8081\u8082\u8085\u8088\u808A\u808D",
        5,
        "\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",
        4,
        "\u80CF",
        6,
        "\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"
    ],
    [
        "c380",
        "\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",
        12,
        "\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",
        4,
        "\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"
    ],
    [
        "c440",
        "\u8140",
        5,
        "\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",
        4,
        "\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",
        4,
        "\u8189\u818B\u818C\u818D\u818E\u8190\u8192",
        5,
        "\u8199\u819A\u819E",
        4,
        "\u81A4\u81A5"
    ],
    [
        "c480",
        "\u81A7\u81A9\u81AB",
        7,
        "\u81B4",
        5,
        "\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",
        6,
        "\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"
    ],
    [
        "c540",
        "\u81D4",
        14,
        "\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",
        4,
        "\u81F5",
        5,
        "\u81FD\u81FF\u8203\u8207",
        4,
        "\u820E\u820F\u8211\u8213\u8215",
        5,
        "\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"
    ],
    [
        "c580",
        "\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",
        7,
        "\u8259\u825B\u825C\u825D\u825E\u8260",
        7,
        "\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"
    ],
    [
        "c640",
        "\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"
    ],
    [
        "c680",
        "\u82FA\u82FC",
        4,
        "\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",
        9,
        "\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"
    ],
    [
        "c740",
        "\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",
        4,
        "\u8353\u8355",
        4,
        "\u835D\u8362\u8370",
        6,
        "\u8379\u837A\u837E",
        6,
        "\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",
        6,
        "\u83AC\u83AD\u83AE"
    ],
    [
        "c780",
        "\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"
    ],
    [
        "c840",
        "\u83EE\u83EF\u83F3",
        4,
        "\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",
        5,
        "\u8419\u841A\u841B\u841E",
        5,
        "\u8429",
        7,
        "\u8432",
        5,
        "\u8439\u843A\u843B\u843E",
        7,
        "\u8447\u8448\u8449"
    ],
    [
        "c880",
        "\u844A",
        6,
        "\u8452",
        4,
        "\u8458\u845D\u845E\u845F\u8460\u8462\u8464",
        4,
        "\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"
    ],
    [
        "c940",
        "\u847D",
        4,
        "\u8483\u8484\u8485\u8486\u848A\u848D\u848F",
        7,
        "\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",
        12,
        "\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"
    ],
    [
        "c980",
        "\u84D8",
        4,
        "\u84DE\u84E1\u84E2\u84E4\u84E7",
        4,
        "\u84ED\u84EE\u84EF\u84F1",
        10,
        "\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"
    ],
    [
        "ca40",
        "\u8503",
        8,
        "\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",
        8,
        "\u852D",
        9,
        "\u853E",
        4,
        "\u8544\u8545\u8546\u8547\u854B",
        10
    ],
    [
        "ca80",
        "\u8557\u8558\u855A\u855B\u855C\u855D\u855F",
        4,
        "\u8565\u8566\u8567\u8569",
        8,
        "\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"
    ],
    [
        "cb40",
        "\u8582\u8583\u8586\u8588",
        6,
        "\u8590",
        10,
        "\u859D",
        6,
        "\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",
        5,
        "\u85B8\u85BA",
        6,
        "\u85C2",
        6,
        "\u85CA",
        4,
        "\u85D1\u85D2"
    ],
    [
        "cb80",
        "\u85D4\u85D6",
        5,
        "\u85DD",
        6,
        "\u85E5\u85E6\u85E7\u85E8\u85EA",
        14,
        "\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"
    ],
    [
        "cc40",
        "\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",
        4,
        "\u8606",
        10,
        "\u8612\u8613\u8614\u8615\u8617",
        15,
        "\u8628\u862A",
        13,
        "\u8639\u863A\u863B\u863D\u863E\u863F\u8640"
    ],
    [
        "cc80",
        "\u8641",
        11,
        "\u8652\u8653\u8655",
        4,
        "\u865B\u865C\u865D\u865F\u8660\u8661\u8663",
        7,
        "\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"
    ],
    [
        "cd40",
        "\u866D\u866F\u8670\u8672",
        6,
        "\u8683",
        6,
        "\u868E",
        4,
        "\u8694\u8696",
        5,
        "\u869E",
        4,
        "\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",
        4,
        "\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"
    ],
    [
        "cd80",
        "\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"
    ],
    [
        "ce40",
        "\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",
        6,
        "\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",
        5,
        "\u8761\u8762\u8766",
        7,
        "\u876F\u8771\u8772\u8773\u8775"
    ],
    [
        "ce80",
        "\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",
        4,
        "\u8794\u8795\u8796\u8798",
        6,
        "\u87A0",
        4,
        "\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"
    ],
    [
        "cf40",
        "\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",
        4,
        "\u87C7\u87C8\u87C9\u87CC",
        4,
        "\u87D4",
        6,
        "\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",
        9
    ],
    [
        "cf80",
        "\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",
        5,
        "\u880B",
        7,
        "\u8814\u8817\u8818\u8819\u881A\u881C",
        4,
        "\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"
    ],
    [
        "d040",
        "\u8824",
        13,
        "\u8833",
        5,
        "\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",
        5,
        "\u884E",
        5,
        "\u8855\u8856\u8858\u885A",
        6,
        "\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"
    ],
    [
        "d080",
        "\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",
        4,
        "\u889D",
        4,
        "\u88A3\u88A5",
        5,
        "\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"
    ],
    [
        "d140",
        "\u88AC\u88AE\u88AF\u88B0\u88B2",
        4,
        "\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",
        4,
        "\u88E0\u88E1\u88E6\u88E7\u88E9",
        6,
        "\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",
        5
    ],
    [
        "d180",
        "\u8909\u890B",
        4,
        "\u8911\u8914",
        4,
        "\u891C",
        4,
        "\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"
    ],
    [
        "d240",
        "\u8938",
        8,
        "\u8942\u8943\u8945",
        24,
        "\u8960",
        5,
        "\u8967",
        19,
        "\u897C"
    ],
    [
        "d280",
        "\u897D\u897E\u8980\u8982\u8984\u8985\u8987",
        26,
        "\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"
    ],
    [
        "d340",
        "\u89A2",
        30,
        "\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",
        6
    ],
    [
        "d380",
        "\u89FB",
        4,
        "\u8A01",
        5,
        "\u8A08",
        21,
        "\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"
    ],
    [
        "d440",
        "\u8A1E",
        31,
        "\u8A3F",
        8,
        "\u8A49",
        21
    ],
    [
        "d480",
        "\u8A5F",
        25,
        "\u8A7A",
        6,
        "\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"
    ],
    [
        "d540",
        "\u8A81",
        7,
        "\u8A8B",
        7,
        "\u8A94",
        46
    ],
    [
        "d580",
        "\u8AC3",
        32,
        "\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"
    ],
    [
        "d640",
        "\u8AE4",
        34,
        "\u8B08",
        27
    ],
    [
        "d680",
        "\u8B24\u8B25\u8B27",
        30,
        "\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"
    ],
    [
        "d740",
        "\u8B46",
        31,
        "\u8B67",
        4,
        "\u8B6D",
        25
    ],
    [
        "d780",
        "\u8B87",
        24,
        "\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"
    ],
    [
        "d840",
        "\u8C38",
        8,
        "\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",
        7,
        "\u8C56\u8C57\u8C58\u8C59\u8C5B",
        5,
        "\u8C63",
        6,
        "\u8C6C",
        6,
        "\u8C74\u8C75\u8C76\u8C77\u8C7B",
        6,
        "\u8C83\u8C84\u8C86\u8C87"
    ],
    [
        "d880",
        "\u8C88\u8C8B\u8C8D",
        6,
        "\u8C95\u8C96\u8C97\u8C99",
        20,
        "\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"
    ],
    [
        "d940",
        "\u8CAE",
        62
    ],
    [
        "d980",
        "\u8CED",
        32,
        "\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"
    ],
    [
        "da40",
        "\u8D0E",
        14,
        "\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",
        8,
        "\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",
        4,
        "\u8D92\u8D93\u8D95",
        9,
        "\u8DA0\u8DA1"
    ],
    [
        "da80",
        "\u8DA2\u8DA4",
        12,
        "\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"
    ],
    [
        "db40",
        "\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",
        6,
        "\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",
        7,
        "\u8E20\u8E21\u8E24",
        4,
        "\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"
    ],
    [
        "db80",
        "\u8E3F\u8E43\u8E45\u8E46\u8E4C",
        4,
        "\u8E53",
        5,
        "\u8E5A",
        11,
        "\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"
    ],
    [
        "dc40",
        "\u8E73\u8E75\u8E77",
        4,
        "\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",
        6,
        "\u8E91\u8E92\u8E93\u8E95",
        6,
        "\u8E9D\u8E9F",
        11,
        "\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",
        6,
        "\u8EBB",
        7
    ],
    [
        "dc80",
        "\u8EC3",
        10,
        "\u8ECF",
        21,
        "\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"
    ],
    [
        "dd40",
        "\u8EE5",
        62
    ],
    [
        "dd80",
        "\u8F24",
        32,
        "\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"
    ],
    [
        "de40",
        "\u8F45",
        32,
        "\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"
    ],
    [
        "de80",
        "\u8FC9",
        4,
        "\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"
    ],
    [
        "df40",
        "\u9019\u901C\u9023\u9024\u9025\u9027",
        5,
        "\u9030",
        4,
        "\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",
        4,
        "\u904E\u9054\u9055\u9056\u9059\u905A\u905C",
        5,
        "\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",
        4,
        "\u9076",
        6,
        "\u907E\u9081"
    ],
    [
        "df80",
        "\u9084\u9085\u9086\u9087\u9089\u908A\u908C",
        4,
        "\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"
    ],
    [
        "e040",
        "\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",
        19,
        "\u911A\u911B\u911C"
    ],
    [
        "e080",
        "\u911D\u911F\u9120\u9121\u9124",
        10,
        "\u9130\u9132",
        6,
        "\u913A",
        8,
        "\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"
    ],
    [
        "e140",
        "\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",
        4,
        "\u9186\u9188\u918A\u918E\u918F\u9193",
        6,
        "\u919C",
        5,
        "\u91A4",
        5,
        "\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"
    ],
    [
        "e180",
        "\u91BC",
        10,
        "\u91C8\u91CB\u91D0\u91D2",
        9,
        "\u91DD",
        8,
        "\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"
    ],
    [
        "e240",
        "\u91E6",
        62
    ],
    [
        "e280",
        "\u9225",
        32,
        "\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",
        5,
        "\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"
    ],
    [
        "e340",
        "\u9246",
        45,
        "\u9275",
        16
    ],
    [
        "e380",
        "\u9286",
        7,
        "\u928F",
        24,
        "\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"
    ],
    [
        "e440",
        "\u92A8",
        5,
        "\u92AF",
        24,
        "\u92C9",
        31
    ],
    [
        "e480",
        "\u92E9",
        32,
        "\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"
    ],
    [
        "e540",
        "\u930A",
        51,
        "\u933F",
        10
    ],
    [
        "e580",
        "\u934A",
        31,
        "\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"
    ],
    [
        "e640",
        "\u936C",
        34,
        "\u9390",
        27
    ],
    [
        "e680",
        "\u93AC",
        29,
        "\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"
    ],
    [
        "e740",
        "\u93CE",
        7,
        "\u93D7",
        54
    ],
    [
        "e780",
        "\u940E",
        32,
        "\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",
        6,
        "\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",
        4,
        "\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"
    ],
    [
        "e840",
        "\u942F",
        14,
        "\u943F",
        43,
        "\u946C\u946D\u946E\u946F"
    ],
    [
        "e880",
        "\u9470",
        20,
        "\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"
    ],
    [
        "e940",
        "\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",
        7,
        "\u9580",
        42
    ],
    [
        "e980",
        "\u95AB",
        32,
        "\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"
    ],
    [
        "ea40",
        "\u95CC",
        27,
        "\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",
        6,
        "\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"
    ],
    [
        "ea80",
        "\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",
        4,
        "\u9673\u9678",
        12,
        "\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"
    ],
    [
        "eb40",
        "\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",
        9,
        "\u96A8",
        7,
        "\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",
        9,
        "\u96E1",
        6,
        "\u96EB"
    ],
    [
        "eb80",
        "\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",
        4,
        "\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"
    ],
    [
        "ec40",
        "\u9721",
        8,
        "\u972B\u972C\u972E\u972F\u9731\u9733",
        4,
        "\u973A\u973B\u973C\u973D\u973F",
        18,
        "\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",
        7
    ],
    [
        "ec80",
        "\u9772\u9775\u9777",
        4,
        "\u977D",
        7,
        "\u9786",
        4,
        "\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",
        4,
        "\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"
    ],
    [
        "ed40",
        "\u979E\u979F\u97A1\u97A2\u97A4",
        6,
        "\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",
        46
    ],
    [
        "ed80",
        "\u97E4\u97E5\u97E8\u97EE",
        4,
        "\u97F4\u97F7",
        23,
        "\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"
    ],
    [
        "ee40",
        "\u980F",
        62
    ],
    [
        "ee80",
        "\u984E",
        32,
        "\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",
        4,
        "\u94BC\u94BD\u94BF\u94C4\u94C8",
        6,
        "\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"
    ],
    [
        "ef40",
        "\u986F",
        5,
        "\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",
        37,
        "\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",
        4
    ],
    [
        "ef80",
        "\u98E5\u98E6\u98E9",
        30,
        "\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",
        4,
        "\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",
        8,
        "\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"
    ],
    [
        "f040",
        "\u9908",
        4,
        "\u990E\u990F\u9911",
        28,
        "\u992F",
        26
    ],
    [
        "f080",
        "\u994A",
        9,
        "\u9956",
        12,
        "\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",
        4,
        "\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",
        6,
        "\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"
    ],
    [
        "f140",
        "\u998C\u998E\u999A",
        10,
        "\u99A6\u99A7\u99A9",
        47
    ],
    [
        "f180",
        "\u99D9",
        32,
        "\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"
    ],
    [
        "f240",
        "\u99FA",
        62
    ],
    [
        "f280",
        "\u9A39",
        32,
        "\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"
    ],
    [
        "f340",
        "\u9A5A",
        17,
        "\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",
        6,
        "\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",
        4,
        "\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"
    ],
    [
        "f380",
        "\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",
        8,
        "\u9AFA\u9AFC",
        6,
        "\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"
    ],
    [
        "f440",
        "\u9B07\u9B09",
        5,
        "\u9B10\u9B11\u9B12\u9B14",
        10,
        "\u9B20\u9B21\u9B22\u9B24",
        10,
        "\u9B30\u9B31\u9B33",
        7,
        "\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",
        5
    ],
    [
        "f480",
        "\u9B5B",
        32,
        "\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"
    ],
    [
        "f540",
        "\u9B7C",
        62
    ],
    [
        "f580",
        "\u9BBB",
        32,
        "\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"
    ],
    [
        "f640",
        "\u9BDC",
        62
    ],
    [
        "f680",
        "\u9C1B",
        32,
        "\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",
        5,
        "\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",
        5,
        "\u9CA5",
        4,
        "\u9CAB\u9CAD\u9CAE\u9CB0",
        7,
        "\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"
    ],
    [
        "f740",
        "\u9C3C",
        62
    ],
    [
        "f780",
        "\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",
        4,
        "\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",
        4,
        "\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"
    ],
    [
        "f840",
        "\u9CE3",
        62
    ],
    [
        "f880",
        "\u9D22",
        32
    ],
    [
        "f940",
        "\u9D43",
        62
    ],
    [
        "f980",
        "\u9D82",
        32
    ],
    [
        "fa40",
        "\u9DA3",
        62
    ],
    [
        "fa80",
        "\u9DE2",
        32
    ],
    [
        "fb40",
        "\u9E03",
        27,
        "\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",
        9,
        "\u9E80"
    ],
    [
        "fb80",
        "\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",
        5,
        "\u9E94",
        8,
        "\u9E9E\u9EA0",
        5,
        "\u9EA7\u9EA8\u9EA9\u9EAA"
    ],
    [
        "fc40",
        "\u9EAB",
        8,
        "\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",
        4,
        "\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",
        8,
        "\u9EFA\u9EFD\u9EFF",
        6
    ],
    [
        "fc80",
        "\u9F06",
        4,
        "\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",
        5,
        "\u9F21\u9F23",
        8,
        "\u9F2D\u9F2E\u9F30\u9F31"
    ],
    [
        "fd40",
        "\u9F32",
        4,
        "\u9F38\u9F3A\u9F3C\u9F3F",
        4,
        "\u9F45",
        10,
        "\u9F52",
        38
    ],
    [
        "fd80",
        "\u9F79",
        5,
        "\u9F81\u9F82\u9F8D",
        11,
        "\u9F9C\u9F9D\u9F9E\u9FA1",
        4,
        "\uF92C\uF979\uF995\uF9E7\uF9F1"
    ],
    [
        "fe40",
        "\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"
    ]
];
var $3939d1de148b5202$var$cp936$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $3939d1de148b5202$var$cp936
});
var $3939d1de148b5202$var$gbkAdded = [
    [
        "a140",
        "\uE4C6",
        62
    ],
    [
        "a180",
        "\uE505",
        32
    ],
    [
        "a240",
        "\uE526",
        62
    ],
    [
        "a280",
        "\uE565",
        32
    ],
    [
        "a2ab",
        "\uE766",
        5
    ],
    [
        "a2e3",
        "\u20AC\uE76D"
    ],
    [
        "a2ef",
        "\uE76E\uE76F"
    ],
    [
        "a2fd",
        "\uE770\uE771"
    ],
    [
        "a340",
        "\uE586",
        62
    ],
    [
        "a380",
        "\uE5C5",
        31,
        "\u3000"
    ],
    [
        "a440",
        "\uE5E6",
        62
    ],
    [
        "a480",
        "\uE625",
        32
    ],
    [
        "a4f4",
        "\uE772",
        10
    ],
    [
        "a540",
        "\uE646",
        62
    ],
    [
        "a580",
        "\uE685",
        32
    ],
    [
        "a5f7",
        "\uE77D",
        7
    ],
    [
        "a640",
        "\uE6A6",
        62
    ],
    [
        "a680",
        "\uE6E5",
        32
    ],
    [
        "a6b9",
        "\uE785",
        7
    ],
    [
        "a6d9",
        "\uE78D",
        6
    ],
    [
        "a6ec",
        "\uE794\uE795"
    ],
    [
        "a6f3",
        "\uE796"
    ],
    [
        "a6f6",
        "\uE797",
        8
    ],
    [
        "a740",
        "\uE706",
        62
    ],
    [
        "a780",
        "\uE745",
        32
    ],
    [
        "a7c2",
        "\uE7A0",
        14
    ],
    [
        "a7f2",
        "\uE7AF",
        12
    ],
    [
        "a896",
        "\uE7BC",
        10
    ],
    [
        "a8bc",
        "\uE7C7"
    ],
    [
        "a8bf",
        "\u01F9"
    ],
    [
        "a8c1",
        "\uE7C9\uE7CA\uE7CB\uE7CC"
    ],
    [
        "a8ea",
        "\uE7CD",
        20
    ],
    [
        "a958",
        "\uE7E2"
    ],
    [
        "a95b",
        "\uE7E3"
    ],
    [
        "a95d",
        "\uE7E4\uE7E5\uE7E6"
    ],
    [
        "a989",
        "\u303E\u2FF0",
        11
    ],
    [
        "a997",
        "\uE7F4",
        12
    ],
    [
        "a9f0",
        "\uE801",
        14
    ],
    [
        "aaa1",
        "\uE000",
        93
    ],
    [
        "aba1",
        "\uE05E",
        93
    ],
    [
        "aca1",
        "\uE0BC",
        93
    ],
    [
        "ada1",
        "\uE11A",
        93
    ],
    [
        "aea1",
        "\uE178",
        93
    ],
    [
        "afa1",
        "\uE1D6",
        93
    ],
    [
        "d7fa",
        "\uE810",
        4
    ],
    [
        "f8a1",
        "\uE234",
        93
    ],
    [
        "f9a1",
        "\uE292",
        93
    ],
    [
        "faa1",
        "\uE2F0",
        93
    ],
    [
        "fba1",
        "\uE34E",
        93
    ],
    [
        "fca1",
        "\uE3AC",
        93
    ],
    [
        "fda1",
        "\uE40A",
        93
    ],
    [
        "fe50",
        "\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"
    ],
    [
        "fe80",
        "\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",
        6,
        "\u4DAE\uE864\uE468",
        93
    ]
];
var $3939d1de148b5202$var$gbkAdded$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $3939d1de148b5202$var$gbkAdded
});
var $3939d1de148b5202$var$uChars = [
    128,
    165,
    169,
    178,
    184,
    216,
    226,
    235,
    238,
    244,
    248,
    251,
    253,
    258,
    276,
    284,
    300,
    325,
    329,
    334,
    364,
    463,
    465,
    467,
    469,
    471,
    473,
    475,
    477,
    506,
    594,
    610,
    712,
    716,
    730,
    930,
    938,
    962,
    970,
    1026,
    1104,
    1106,
    8209,
    8215,
    8218,
    8222,
    8231,
    8241,
    8244,
    8246,
    8252,
    8365,
    8452,
    8454,
    8458,
    8471,
    8482,
    8556,
    8570,
    8596,
    8602,
    8713,
    8720,
    8722,
    8726,
    8731,
    8737,
    8740,
    8742,
    8748,
    8751,
    8760,
    8766,
    8777,
    8781,
    8787,
    8802,
    8808,
    8816,
    8854,
    8858,
    8870,
    8896,
    8979,
    9322,
    9372,
    9548,
    9588,
    9616,
    9622,
    9634,
    9652,
    9662,
    9672,
    9676,
    9680,
    9702,
    9735,
    9738,
    9793,
    9795,
    11906,
    11909,
    11913,
    11917,
    11928,
    11944,
    11947,
    11951,
    11956,
    11960,
    11964,
    11979,
    12284,
    12292,
    12312,
    12319,
    12330,
    12351,
    12436,
    12447,
    12535,
    12543,
    12586,
    12842,
    12850,
    12964,
    13200,
    13215,
    13218,
    13253,
    13263,
    13267,
    13270,
    13384,
    13428,
    13727,
    13839,
    13851,
    14617,
    14703,
    14801,
    14816,
    14964,
    15183,
    15471,
    15585,
    16471,
    16736,
    17208,
    17325,
    17330,
    17374,
    17623,
    17997,
    18018,
    18212,
    18218,
    18301,
    18318,
    18760,
    18811,
    18814,
    18820,
    18823,
    18844,
    18848,
    18872,
    19576,
    19620,
    19738,
    19887,
    40870,
    59244,
    59336,
    59367,
    59413,
    59417,
    59423,
    59431,
    59437,
    59443,
    59452,
    59460,
    59478,
    59493,
    63789,
    63866,
    63894,
    63976,
    63986,
    64016,
    64018,
    64021,
    64025,
    64034,
    64037,
    64042,
    65074,
    65093,
    65107,
    65112,
    65127,
    65132,
    65375,
    65510,
    65536
];
var $3939d1de148b5202$var$gbChars = [
    0,
    36,
    38,
    45,
    50,
    81,
    89,
    95,
    96,
    100,
    103,
    104,
    105,
    109,
    126,
    133,
    148,
    172,
    175,
    179,
    208,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    341,
    428,
    443,
    544,
    545,
    558,
    741,
    742,
    749,
    750,
    805,
    819,
    820,
    7922,
    7924,
    7925,
    7927,
    7934,
    7943,
    7944,
    7945,
    7950,
    8062,
    8148,
    8149,
    8152,
    8164,
    8174,
    8236,
    8240,
    8262,
    8264,
    8374,
    8380,
    8381,
    8384,
    8388,
    8390,
    8392,
    8393,
    8394,
    8396,
    8401,
    8406,
    8416,
    8419,
    8424,
    8437,
    8439,
    8445,
    8482,
    8485,
    8496,
    8521,
    8603,
    8936,
    8946,
    9046,
    9050,
    9063,
    9066,
    9076,
    9092,
    9100,
    9108,
    9111,
    9113,
    9131,
    9162,
    9164,
    9218,
    9219,
    11329,
    11331,
    11334,
    11336,
    11346,
    11361,
    11363,
    11366,
    11370,
    11372,
    11375,
    11389,
    11682,
    11686,
    11687,
    11692,
    11694,
    11714,
    11716,
    11723,
    11725,
    11730,
    11736,
    11982,
    11989,
    12102,
    12336,
    12348,
    12350,
    12384,
    12393,
    12395,
    12397,
    12510,
    12553,
    12851,
    12962,
    12973,
    13738,
    13823,
    13919,
    13933,
    14080,
    14298,
    14585,
    14698,
    15583,
    15847,
    16318,
    16434,
    16438,
    16481,
    16729,
    17102,
    17122,
    17315,
    17320,
    17402,
    17418,
    17859,
    17909,
    17911,
    17915,
    17916,
    17936,
    17939,
    17961,
    18664,
    18703,
    18814,
    18962,
    19043,
    33469,
    33470,
    33471,
    33484,
    33485,
    33490,
    33497,
    33501,
    33505,
    33513,
    33520,
    33536,
    33550,
    37845,
    37921,
    37948,
    38029,
    38038,
    38064,
    38065,
    38066,
    38069,
    38075,
    38076,
    38078,
    39108,
    39109,
    39113,
    39114,
    39115,
    39116,
    39265,
    39394,
    189000
];
var $3939d1de148b5202$var$gb18030Ranges = {
    uChars: $3939d1de148b5202$var$uChars,
    gbChars: $3939d1de148b5202$var$gbChars
};
var $3939d1de148b5202$var$gb18030Ranges$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    uChars: $3939d1de148b5202$var$uChars,
    gbChars: $3939d1de148b5202$var$gbChars,
    'default': $3939d1de148b5202$var$gb18030Ranges
});
var $3939d1de148b5202$var$cp949 = [
    [
        "0",
        "\u0000",
        127
    ],
    [
        "8141",
        "\uAC02\uAC03\uAC05\uAC06\uAC0B",
        4,
        "\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",
        6,
        "\uAC2E\uAC32\uAC33\uAC34"
    ],
    [
        "8161",
        "\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",
        9,
        "\uAC4C\uAC4E",
        5,
        "\uAC55"
    ],
    [
        "8181",
        "\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",
        18,
        "\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",
        4,
        "\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",
        6,
        "\uAC9E\uACA2",
        5,
        "\uACAB\uACAD\uACAE\uACB1",
        6,
        "\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",
        7,
        "\uACD6\uACD8",
        7,
        "\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",
        4,
        "\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",
        4,
        "\uAD0E\uAD10\uAD12\uAD13"
    ],
    [
        "8241",
        "\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",
        7,
        "\uAD2A\uAD2B\uAD2E",
        5
    ],
    [
        "8261",
        "\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",
        6,
        "\uAD46\uAD48\uAD4A",
        5,
        "\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"
    ],
    [
        "8281",
        "\uAD59",
        7,
        "\uAD62\uAD64",
        7,
        "\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",
        4,
        "\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",
        10,
        "\uAD9E",
        5,
        "\uADA5",
        17,
        "\uADB8",
        7,
        "\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",
        6,
        "\uADD2\uADD4",
        7,
        "\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",
        18
    ],
    [
        "8341",
        "\uADFA\uADFB\uADFD\uADFE\uAE02",
        5,
        "\uAE0A\uAE0C\uAE0E",
        5,
        "\uAE15",
        7
    ],
    [
        "8361",
        "\uAE1D",
        18,
        "\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"
    ],
    [
        "8381",
        "\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",
        4,
        "\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",
        6,
        "\uAE7A\uAE7E",
        5,
        "\uAE86",
        5,
        "\uAE8D",
        46,
        "\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",
        6,
        "\uAECE\uAED2",
        5,
        "\uAEDA\uAEDB\uAEDD",
        8
    ],
    [
        "8441",
        "\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",
        5,
        "\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",
        8
    ],
    [
        "8461",
        "\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",
        18
    ],
    [
        "8481",
        "\uAF24",
        7,
        "\uAF2E\uAF2F\uAF31\uAF33\uAF35",
        6,
        "\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",
        5,
        "\uAF51",
        10,
        "\uAF5E",
        5,
        "\uAF66",
        18,
        "\uAF7A",
        5,
        "\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",
        6,
        "\uAF92\uAF93\uAF94\uAF96",
        5,
        "\uAF9D",
        26,
        "\uAFBA\uAFBB\uAFBD\uAFBE"
    ],
    [
        "8541",
        "\uAFBF\uAFC1",
        5,
        "\uAFCA\uAFCC\uAFCF",
        4,
        "\uAFD5",
        6,
        "\uAFDD",
        4
    ],
    [
        "8561",
        "\uAFE2",
        5,
        "\uAFEA",
        5,
        "\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",
        6,
        "\uB002\uB003"
    ],
    [
        "8581",
        "\uB005",
        6,
        "\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",
        6,
        "\uB01E",
        9,
        "\uB029",
        26,
        "\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",
        29,
        "\uB07E\uB07F\uB081\uB082\uB083\uB085",
        6,
        "\uB08E\uB090\uB092",
        5,
        "\uB09B\uB09D\uB09E\uB0A3\uB0A4"
    ],
    [
        "8641",
        "\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",
        6,
        "\uB0C6\uB0CA",
        5,
        "\uB0D2"
    ],
    [
        "8661",
        "\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",
        6,
        "\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",
        10
    ],
    [
        "8681",
        "\uB0F1",
        22,
        "\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",
        4,
        "\uB126\uB127\uB129\uB12A\uB12B\uB12D",
        6,
        "\uB136\uB13A",
        5,
        "\uB142\uB143\uB145\uB146\uB147\uB149",
        6,
        "\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",
        22,
        "\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",
        4,
        "\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"
    ],
    [
        "8741",
        "\uB19E",
        9,
        "\uB1A9",
        15
    ],
    [
        "8761",
        "\uB1B9",
        18,
        "\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"
    ],
    [
        "8781",
        "\uB1D6",
        5,
        "\uB1DE\uB1E0",
        7,
        "\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",
        7,
        "\uB1FA\uB1FC\uB1FE",
        5,
        "\uB206\uB207\uB209\uB20A\uB20D",
        6,
        "\uB216\uB218\uB21A",
        5,
        "\uB221",
        18,
        "\uB235",
        6,
        "\uB23D",
        26,
        "\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",
        6,
        "\uB26A",
        4
    ],
    [
        "8841",
        "\uB26F",
        4,
        "\uB276",
        5,
        "\uB27D",
        6,
        "\uB286\uB287\uB288\uB28A",
        4
    ],
    [
        "8861",
        "\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",
        4,
        "\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"
    ],
    [
        "8881",
        "\uB2B8",
        15,
        "\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",
        4,
        "\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",
        6,
        "\uB312\uB316",
        5,
        "\uB31D",
        54,
        "\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"
    ],
    [
        "8941",
        "\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",
        6,
        "\uB382\uB386",
        5,
        "\uB38D"
    ],
    [
        "8961",
        "\uB38E\uB38F\uB391\uB392\uB393\uB395",
        10,
        "\uB3A2",
        5,
        "\uB3A9\uB3AA\uB3AB\uB3AD"
    ],
    [
        "8981",
        "\uB3AE",
        21,
        "\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",
        18,
        "\uB3FD",
        18,
        "\uB411",
        6,
        "\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",
        6,
        "\uB42A\uB42C",
        7,
        "\uB435",
        15
    ],
    [
        "8a41",
        "\uB445",
        10,
        "\uB452\uB453\uB455\uB456\uB457\uB459",
        6,
        "\uB462\uB464\uB466"
    ],
    [
        "8a61",
        "\uB467",
        4,
        "\uB46D",
        18,
        "\uB481\uB482"
    ],
    [
        "8a81",
        "\uB483",
        4,
        "\uB489",
        19,
        "\uB49E",
        5,
        "\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",
        7,
        "\uB4B6\uB4B8\uB4BA",
        5,
        "\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",
        6,
        "\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",
        5,
        "\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",
        4,
        "\uB4EE\uB4F0\uB4F2",
        5,
        "\uB4F9",
        26,
        "\uB516\uB517\uB519\uB51A\uB51D"
    ],
    [
        "8b41",
        "\uB51E",
        5,
        "\uB526\uB52B",
        4,
        "\uB532\uB533\uB535\uB536\uB537\uB539",
        6,
        "\uB542\uB546"
    ],
    [
        "8b61",
        "\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",
        6,
        "\uB55E\uB562",
        8
    ],
    [
        "8b81",
        "\uB56B",
        52,
        "\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",
        4,
        "\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",
        6,
        "\uB5CE\uB5D2",
        5,
        "\uB5D9",
        18,
        "\uB5ED",
        18
    ],
    [
        "8c41",
        "\uB600",
        15,
        "\uB612\uB613\uB615\uB616\uB617\uB619",
        4
    ],
    [
        "8c61",
        "\uB61E",
        6,
        "\uB626",
        5,
        "\uB62D",
        6,
        "\uB635",
        5
    ],
    [
        "8c81",
        "\uB63B",
        12,
        "\uB649",
        26,
        "\uB665\uB666\uB667\uB669",
        50,
        "\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",
        5,
        "\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",
        16
    ],
    [
        "8d41",
        "\uB6C3",
        16,
        "\uB6D5",
        8
    ],
    [
        "8d61",
        "\uB6DE",
        17,
        "\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"
    ],
    [
        "8d81",
        "\uB6FB",
        4,
        "\uB702\uB703\uB704\uB706",
        33,
        "\uB72A\uB72B\uB72D\uB72E\uB731",
        6,
        "\uB73A\uB73C",
        7,
        "\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",
        6,
        "\uB756",
        9,
        "\uB761\uB762\uB763\uB765\uB766\uB767\uB769",
        6,
        "\uB772\uB774\uB776",
        5,
        "\uB77E\uB77F\uB781\uB782\uB783\uB785",
        6,
        "\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"
    ],
    [
        "8e41",
        "\uB79F\uB7A1",
        6,
        "\uB7AA\uB7AE",
        5,
        "\uB7B6\uB7B7\uB7B9",
        8
    ],
    [
        "8e61",
        "\uB7C2",
        4,
        "\uB7C8\uB7CA",
        19
    ],
    [
        "8e81",
        "\uB7DE",
        13,
        "\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",
        6,
        "\uB7FE\uB802",
        4,
        "\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",
        6,
        "\uB81A\uB81C\uB81E",
        5,
        "\uB826\uB827\uB829\uB82A\uB82B\uB82D",
        6,
        "\uB836\uB83A",
        5,
        "\uB841\uB842\uB843\uB845",
        11,
        "\uB852\uB854",
        7,
        "\uB85E\uB85F\uB861\uB862\uB863\uB865",
        6,
        "\uB86E\uB870\uB872",
        5,
        "\uB879\uB87A\uB87B\uB87D",
        7
    ],
    [
        "8f41",
        "\uB885",
        7,
        "\uB88E",
        17
    ],
    [
        "8f61",
        "\uB8A0",
        7,
        "\uB8A9",
        6,
        "\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",
        4
    ],
    [
        "8f81",
        "\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",
        5,
        "\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",
        7,
        "\uB8DE\uB8E0\uB8E2",
        5,
        "\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",
        6,
        "\uB8FA\uB8FC\uB8FE",
        5,
        "\uB905",
        18,
        "\uB919",
        6,
        "\uB921",
        26,
        "\uB93E\uB93F\uB941\uB942\uB943\uB945",
        6,
        "\uB94D\uB94E\uB950\uB952",
        5
    ],
    [
        "9041",
        "\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",
        6,
        "\uB96A\uB96C\uB96E",
        5,
        "\uB976\uB977\uB979\uB97A\uB97B\uB97D"
    ],
    [
        "9061",
        "\uB97E",
        5,
        "\uB986\uB988\uB98B\uB98C\uB98F",
        15
    ],
    [
        "9081",
        "\uB99F",
        12,
        "\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",
        6,
        "\uB9BE\uB9C0\uB9C2",
        5,
        "\uB9CA\uB9CB\uB9CD\uB9D3",
        4,
        "\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",
        6,
        "\uB9F6\uB9FB",
        4,
        "\uBA02",
        5,
        "\uBA09",
        11,
        "\uBA16",
        33,
        "\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"
    ],
    [
        "9141",
        "\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",
        6,
        "\uBA66\uBA6A",
        5
    ],
    [
        "9161",
        "\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",
        9,
        "\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",
        5
    ],
    [
        "9181",
        "\uBA93",
        20,
        "\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",
        4,
        "\uBABA\uBABC\uBABE",
        5,
        "\uBAC5\uBAC6\uBAC7\uBAC9",
        14,
        "\uBADA",
        33,
        "\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",
        7,
        "\uBB0E\uBB10\uBB12",
        5,
        "\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",
        6
    ],
    [
        "9241",
        "\uBB28\uBB2A\uBB2C",
        7,
        "\uBB37\uBB39\uBB3A\uBB3F",
        4,
        "\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"
    ],
    [
        "9261",
        "\uBB53\uBB55\uBB56\uBB57\uBB59",
        7,
        "\uBB62\uBB64",
        7,
        "\uBB6D",
        4
    ],
    [
        "9281",
        "\uBB72",
        21,
        "\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",
        18,
        "\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",
        6,
        "\uBBB5\uBBB6\uBBB8",
        7,
        "\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",
        6,
        "\uBBD1\uBBD2\uBBD4",
        35,
        "\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"
    ],
    [
        "9341",
        "\uBC03",
        4,
        "\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"
    ],
    [
        "9361",
        "\uBC36\uBC37\uBC39",
        6,
        "\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",
        8
    ],
    [
        "9381",
        "\uBC5A\uBC5B\uBC5C\uBC5E",
        37,
        "\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",
        4,
        "\uBC96\uBC98\uBC9B",
        4,
        "\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",
        6,
        "\uBCB2\uBCB6",
        5,
        "\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",
        7,
        "\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",
        22,
        "\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"
    ],
    [
        "9441",
        "\uBCFE",
        5,
        "\uBD06\uBD08\uBD0A",
        5,
        "\uBD11\uBD12\uBD13\uBD15",
        8
    ],
    [
        "9461",
        "\uBD1E",
        5,
        "\uBD25",
        6,
        "\uBD2D",
        12
    ],
    [
        "9481",
        "\uBD3A",
        5,
        "\uBD41",
        6,
        "\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",
        6,
        "\uBD5A",
        9,
        "\uBD65\uBD66\uBD67\uBD69",
        22,
        "\uBD82\uBD83\uBD85\uBD86\uBD8B",
        4,
        "\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",
        6,
        "\uBDA5",
        10,
        "\uBDB1",
        6,
        "\uBDB9",
        24
    ],
    [
        "9541",
        "\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",
        11,
        "\uBDEA",
        5,
        "\uBDF1"
    ],
    [
        "9561",
        "\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",
        6,
        "\uBE01\uBE02\uBE04\uBE06",
        5,
        "\uBE0E\uBE0F\uBE11\uBE12\uBE13"
    ],
    [
        "9581",
        "\uBE15",
        6,
        "\uBE1E\uBE20",
        35,
        "\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",
        4,
        "\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",
        4,
        "\uBE72\uBE76",
        4,
        "\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",
        6,
        "\uBE8E\uBE92",
        5,
        "\uBE9A",
        13,
        "\uBEA9",
        14
    ],
    [
        "9641",
        "\uBEB8",
        23,
        "\uBED2\uBED3"
    ],
    [
        "9661",
        "\uBED5\uBED6\uBED9",
        6,
        "\uBEE1\uBEE2\uBEE6",
        5,
        "\uBEED",
        8
    ],
    [
        "9681",
        "\uBEF6",
        10,
        "\uBF02",
        5,
        "\uBF0A",
        13,
        "\uBF1A\uBF1E",
        33,
        "\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",
        6,
        "\uBF52\uBF53\uBF54\uBF56",
        44
    ],
    [
        "9741",
        "\uBF83",
        16,
        "\uBF95",
        8
    ],
    [
        "9761",
        "\uBF9E",
        17,
        "\uBFB1",
        7
    ],
    [
        "9781",
        "\uBFB9",
        11,
        "\uBFC6",
        5,
        "\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",
        6,
        "\uBFDD\uBFDE\uBFE0\uBFE2",
        89,
        "\uC03D\uC03E\uC03F"
    ],
    [
        "9841",
        "\uC040",
        16,
        "\uC052",
        5,
        "\uC059\uC05A\uC05B"
    ],
    [
        "9861",
        "\uC05D\uC05E\uC05F\uC061",
        6,
        "\uC06A",
        15
    ],
    [
        "9881",
        "\uC07A",
        21,
        "\uC092\uC093\uC095\uC096\uC097\uC099",
        6,
        "\uC0A2\uC0A4\uC0A6",
        5,
        "\uC0AE\uC0B1\uC0B2\uC0B7",
        4,
        "\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",
        6,
        "\uC0DA\uC0DE",
        5,
        "\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",
        6,
        "\uC0F6\uC0F8\uC0FA",
        5,
        "\uC101\uC102\uC103\uC105\uC106\uC107\uC109",
        6,
        "\uC111\uC112\uC113\uC114\uC116",
        5,
        "\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"
    ],
    [
        "9941",
        "\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",
        6,
        "\uC14A\uC14E",
        5,
        "\uC156\uC157"
    ],
    [
        "9961",
        "\uC159\uC15A\uC15B\uC15D",
        6,
        "\uC166\uC16A",
        5,
        "\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"
    ],
    [
        "9981",
        "\uC17C",
        8,
        "\uC186",
        5,
        "\uC18F\uC191\uC192\uC193\uC195\uC197",
        4,
        "\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",
        11,
        "\uC1BE",
        5,
        "\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",
        6,
        "\uC1D5\uC1D6\uC1D9",
        6,
        "\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",
        6,
        "\uC1F2\uC1F4",
        7,
        "\uC1FE\uC1FF\uC201\uC202\uC203\uC205",
        6,
        "\uC20E\uC210\uC212",
        5,
        "\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"
    ],
    [
        "9a41",
        "\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",
        16
    ],
    [
        "9a61",
        "\uC246\uC247\uC249",
        6,
        "\uC252\uC253\uC255\uC256\uC257\uC259",
        6,
        "\uC261\uC262\uC263\uC264\uC266"
    ],
    [
        "9a81",
        "\uC267",
        4,
        "\uC26E\uC26F\uC271\uC272\uC273\uC275",
        6,
        "\uC27E\uC280\uC282",
        5,
        "\uC28A",
        5,
        "\uC291",
        6,
        "\uC299\uC29A\uC29C\uC29E",
        5,
        "\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",
        5,
        "\uC2B6\uC2B8\uC2BA",
        33,
        "\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",
        5,
        "\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",
        6,
        "\uC30A\uC30B\uC30E\uC30F"
    ],
    [
        "9b41",
        "\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",
        6,
        "\uC326\uC327\uC32A",
        8
    ],
    [
        "9b61",
        "\uC333",
        17,
        "\uC346",
        7
    ],
    [
        "9b81",
        "\uC34E",
        25,
        "\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",
        4,
        "\uC37A\uC37B\uC37E",
        5,
        "\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",
        50,
        "\uC3C1",
        22,
        "\uC3DA"
    ],
    [
        "9c41",
        "\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",
        4,
        "\uC3EA\uC3EB\uC3EC\uC3EE",
        5,
        "\uC3F6\uC3F7\uC3F9",
        5
    ],
    [
        "9c61",
        "\uC3FF",
        8,
        "\uC409",
        6,
        "\uC411",
        9
    ],
    [
        "9c81",
        "\uC41B",
        8,
        "\uC425",
        6,
        "\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",
        6,
        "\uC43E",
        9,
        "\uC449",
        26,
        "\uC466\uC467\uC469\uC46A\uC46B\uC46D",
        6,
        "\uC476\uC477\uC478\uC47A",
        5,
        "\uC481",
        18,
        "\uC495",
        6,
        "\uC49D",
        12
    ],
    [
        "9d41",
        "\uC4AA",
        13,
        "\uC4B9\uC4BA\uC4BB\uC4BD",
        8
    ],
    [
        "9d61",
        "\uC4C6",
        25
    ],
    [
        "9d81",
        "\uC4E0",
        8,
        "\uC4EA",
        5,
        "\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",
        9,
        "\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",
        6,
        "\uC51D",
        10,
        "\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",
        6,
        "\uC53A\uC53C\uC53E",
        5,
        "\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",
        6,
        "\uC572\uC576",
        5,
        "\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"
    ],
    [
        "9e41",
        "\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",
        7,
        "\uC5AA",
        9,
        "\uC5B6"
    ],
    [
        "9e61",
        "\uC5B7\uC5BA\uC5BF",
        4,
        "\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",
        6,
        "\uC5E2\uC5E4\uC5E6\uC5E7"
    ],
    [
        "9e81",
        "\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",
        6,
        "\uC61A\uC61D",
        6,
        "\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",
        6,
        "\uC652\uC656",
        5,
        "\uC65E\uC65F\uC661",
        10,
        "\uC66D\uC66E\uC670\uC672",
        5,
        "\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",
        6,
        "\uC68A\uC68C\uC68E",
        5,
        "\uC696\uC697\uC699\uC69A\uC69B\uC69D",
        6,
        "\uC6A6"
    ],
    [
        "9f41",
        "\uC6A8\uC6AA",
        5,
        "\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",
        4,
        "\uC6C2\uC6C4\uC6C6",
        5,
        "\uC6CE"
    ],
    [
        "9f61",
        "\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",
        6,
        "\uC6DE\uC6DF\uC6E2",
        5,
        "\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"
    ],
    [
        "9f81",
        "\uC6F3",
        4,
        "\uC6FA\uC6FB\uC6FC\uC6FE",
        5,
        "\uC706\uC707\uC709\uC70A\uC70B\uC70D",
        6,
        "\uC716\uC718\uC71A",
        5,
        "\uC722\uC723\uC725\uC726\uC727\uC729",
        6,
        "\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",
        4,
        "\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",
        6,
        "\uC769\uC76A\uC76C",
        7,
        "\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",
        4,
        "\uC7A2\uC7A7",
        4,
        "\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"
    ],
    [
        "a041",
        "\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",
        5,
        "\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",
        6,
        "\uC7D9\uC7DA\uC7DB\uC7DC"
    ],
    [
        "a061",
        "\uC7DE",
        5,
        "\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",
        13
    ],
    [
        "a081",
        "\uC7FB",
        4,
        "\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",
        4,
        "\uC812\uC814\uC817",
        4,
        "\uC81E\uC81F\uC821\uC822\uC823\uC825",
        6,
        "\uC82E\uC830\uC832",
        5,
        "\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",
        6,
        "\uC84A\uC84B\uC84E",
        5,
        "\uC855",
        26,
        "\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",
        4,
        "\uC882\uC884\uC888\uC889\uC88A\uC88E",
        5,
        "\uC895",
        7,
        "\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"
    ],
    [
        "a141",
        "\uC8A5\uC8A6\uC8A7\uC8A9",
        18,
        "\uC8BE\uC8BF\uC8C0\uC8C1"
    ],
    [
        "a161",
        "\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",
        6,
        "\uC8D6\uC8D8\uC8DA",
        5,
        "\uC8E2\uC8E3\uC8E5"
    ],
    [
        "a181",
        "\uC8E6",
        14,
        "\uC8F6",
        5,
        "\uC8FE\uC8FF\uC901\uC902\uC903\uC907",
        4,
        "\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",
        9,
        "\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"
    ],
    [
        "a241",
        "\uC910\uC912",
        5,
        "\uC919",
        18
    ],
    [
        "a261",
        "\uC92D",
        6,
        "\uC935",
        18
    ],
    [
        "a281",
        "\uC948",
        7,
        "\uC952\uC953\uC955\uC956\uC957\uC959",
        6,
        "\uC962\uC964",
        7,
        "\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"
    ],
    [
        "a341",
        "\uC971\uC972\uC973\uC975",
        6,
        "\uC97D",
        10,
        "\uC98A\uC98B\uC98D\uC98E\uC98F"
    ],
    [
        "a361",
        "\uC991",
        6,
        "\uC99A\uC99C\uC99E",
        16
    ],
    [
        "a381",
        "\uC9AF",
        16,
        "\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",
        4,
        "\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",
        58,
        "\uFFE6\uFF3D",
        32,
        "\uFFE3"
    ],
    [
        "a441",
        "\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",
        5,
        "\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"
    ],
    [
        "a461",
        "\uCA05\uCA06\uCA07\uCA0A\uCA0E",
        5,
        "\uCA15\uCA16\uCA17\uCA19",
        12
    ],
    [
        "a481",
        "\uCA26\uCA27\uCA28\uCA2A",
        28,
        "\u3131",
        93
    ],
    [
        "a541",
        "\uCA47",
        4,
        "\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",
        6,
        "\uCA5E\uCA62",
        5,
        "\uCA69\uCA6A"
    ],
    [
        "a561",
        "\uCA6B",
        17,
        "\uCA7E",
        5,
        "\uCA85\uCA86"
    ],
    [
        "a581",
        "\uCA87",
        16,
        "\uCA99",
        14,
        "\u2170",
        9
    ],
    [
        "a5b0",
        "\u2160",
        9
    ],
    [
        "a5c1",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "a5e1",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "a641",
        "\uCAA8",
        19,
        "\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"
    ],
    [
        "a661",
        "\uCAC6",
        5,
        "\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",
        5,
        "\uCAE1",
        6
    ],
    [
        "a681",
        "\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",
        6,
        "\uCAF5",
        18,
        "\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",
        7
    ],
    [
        "a741",
        "\uCB0B",
        4,
        "\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",
        6,
        "\uCB22",
        7
    ],
    [
        "a761",
        "\uCB2A",
        22,
        "\uCB42\uCB43\uCB44"
    ],
    [
        "a781",
        "\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",
        6,
        "\uCB5A\uCB5B\uCB5C\uCB5E",
        5,
        "\uCB65",
        7,
        "\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",
        9,
        "\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",
        9,
        "\u3380",
        4,
        "\u33BA",
        5,
        "\u3390",
        4,
        "\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"
    ],
    [
        "a841",
        "\uCB6D",
        10,
        "\uCB7A",
        14
    ],
    [
        "a861",
        "\uCB89",
        18,
        "\uCB9D",
        6
    ],
    [
        "a881",
        "\uCBA4",
        19,
        "\uCBB9",
        11,
        "\xc6\xd0\xaa\u0126"
    ],
    [
        "a8a6",
        "\u0132"
    ],
    [
        "a8a8",
        "\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"
    ],
    [
        "a8b1",
        "\u3260",
        27,
        "\u24D0",
        25,
        "\u2460",
        14,
        "\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"
    ],
    [
        "a941",
        "\uCBC5",
        14,
        "\uCBD5",
        10
    ],
    [
        "a961",
        "\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",
        18
    ],
    [
        "a981",
        "\uCBFD",
        14,
        "\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",
        6,
        "\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",
        27,
        "\u249C",
        25,
        "\u2474",
        14,
        "\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"
    ],
    [
        "aa41",
        "\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",
        6,
        "\uCC3A\uCC3F",
        4,
        "\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"
    ],
    [
        "aa61",
        "\uCC4F",
        4,
        "\uCC56\uCC5A",
        5,
        "\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",
        6,
        "\uCC71\uCC72"
    ],
    [
        "aa81",
        "\uCC73\uCC74\uCC76",
        29,
        "\u3041",
        82
    ],
    [
        "ab41",
        "\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",
        6,
        "\uCCAA\uCCAE",
        5,
        "\uCCB6\uCCB7\uCCB9"
    ],
    [
        "ab61",
        "\uCCBA\uCCBB\uCCBD",
        6,
        "\uCCC6\uCCC8\uCCCA",
        5,
        "\uCCD1\uCCD2\uCCD3\uCCD5",
        5
    ],
    [
        "ab81",
        "\uCCDB",
        8,
        "\uCCE5",
        6,
        "\uCCED\uCCEE\uCCEF\uCCF1",
        12,
        "\u30A1",
        85
    ],
    [
        "ac41",
        "\uCCFE\uCCFF\uCD00\uCD02",
        5,
        "\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",
        6,
        "\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"
    ],
    [
        "ac61",
        "\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",
        11,
        "\uCD3A",
        4
    ],
    [
        "ac81",
        "\uCD3F",
        28,
        "\uCD5D\uCD5E\uCD5F\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "acd1",
        "\u0430",
        5,
        "\u0451\u0436",
        25
    ],
    [
        "ad41",
        "\uCD61\uCD62\uCD63\uCD65",
        6,
        "\uCD6E\uCD70\uCD72",
        5,
        "\uCD79",
        7
    ],
    [
        "ad61",
        "\uCD81",
        6,
        "\uCD89",
        10,
        "\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"
    ],
    [
        "ad81",
        "\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",
        5,
        "\uCDB1",
        18,
        "\uCDC5"
    ],
    [
        "ae41",
        "\uCDC6",
        5,
        "\uCDCD\uCDCE\uCDCF\uCDD1",
        16
    ],
    [
        "ae61",
        "\uCDE2",
        5,
        "\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",
        6,
        "\uCDFA\uCDFC\uCDFE",
        4
    ],
    [
        "ae81",
        "\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",
        6,
        "\uCE15\uCE16\uCE17\uCE18\uCE1A",
        5,
        "\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"
    ],
    [
        "af41",
        "\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",
        19
    ],
    [
        "af61",
        "\uCE4A",
        13,
        "\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",
        5,
        "\uCE6A\uCE6C"
    ],
    [
        "af81",
        "\uCE6E",
        5,
        "\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",
        6,
        "\uCE86\uCE88\uCE8A",
        5,
        "\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"
    ],
    [
        "b041",
        "\uCE9A",
        5,
        "\uCEA2\uCEA6",
        5,
        "\uCEAE",
        12
    ],
    [
        "b061",
        "\uCEBB",
        5,
        "\uCEC2",
        19
    ],
    [
        "b081",
        "\uCED6",
        13,
        "\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",
        6,
        "\uCEF6\uCEFA",
        5,
        "\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",
        7,
        "\uAC19",
        4,
        "\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"
    ],
    [
        "b141",
        "\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",
        6,
        "\uCF12\uCF14\uCF16",
        5,
        "\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"
    ],
    [
        "b161",
        "\uCF25",
        6,
        "\uCF2E\uCF32",
        5,
        "\uCF39",
        11
    ],
    [
        "b181",
        "\uCF45",
        14,
        "\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",
        6,
        "\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"
    ],
    [
        "b241",
        "\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",
        6,
        "\uCF81\uCF82\uCF83\uCF84\uCF86",
        5,
        "\uCF8D"
    ],
    [
        "b261",
        "\uCF8E",
        18,
        "\uCFA2",
        5,
        "\uCFA9"
    ],
    [
        "b281",
        "\uCFAA",
        5,
        "\uCFB1",
        18,
        "\uCFC5",
        6,
        "\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"
    ],
    [
        "b341",
        "\uCFCC",
        19,
        "\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"
    ],
    [
        "b361",
        "\uCFEA",
        5,
        "\uCFF2\uCFF4\uCFF6",
        5,
        "\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",
        5
    ],
    [
        "b381",
        "\uD00B",
        5,
        "\uD012",
        5,
        "\uD019",
        19,
        "\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",
        4,
        "\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"
    ],
    [
        "b441",
        "\uD02E",
        5,
        "\uD036\uD037\uD039\uD03A\uD03B\uD03D",
        6,
        "\uD046\uD048\uD04A",
        5
    ],
    [
        "b461",
        "\uD051\uD052\uD053\uD055\uD056\uD057\uD059",
        6,
        "\uD061",
        10,
        "\uD06E\uD06F"
    ],
    [
        "b481",
        "\uD071\uD072\uD073\uD075",
        6,
        "\uD07E\uD07F\uD080\uD082",
        18,
        "\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",
        4,
        "\uB2F3\uB2F4\uB2F5\uB2F7",
        4,
        "\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"
    ],
    [
        "b541",
        "\uD095",
        14,
        "\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",
        5
    ],
    [
        "b561",
        "\uD0B3\uD0B6\uD0B8\uD0BA",
        5,
        "\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",
        5,
        "\uD0D2\uD0D6",
        4
    ],
    [
        "b581",
        "\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",
        6,
        "\uD0EE\uD0F2",
        5,
        "\uD0F9",
        11,
        "\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"
    ],
    [
        "b641",
        "\uD105",
        7,
        "\uD10E",
        17
    ],
    [
        "b661",
        "\uD120",
        15,
        "\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"
    ],
    [
        "b681",
        "\uD13F\uD142\uD146",
        5,
        "\uD14E\uD14F\uD151\uD152\uD153\uD155",
        6,
        "\uD15E\uD160\uD162",
        5,
        "\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"
    ],
    [
        "b741",
        "\uD16E",
        13,
        "\uD17D",
        6,
        "\uD185\uD186\uD187\uD189\uD18A"
    ],
    [
        "b761",
        "\uD18B",
        20,
        "\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"
    ],
    [
        "b781",
        "\uD1A9",
        6,
        "\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",
        14,
        "\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"
    ],
    [
        "b841",
        "\uD1D0",
        7,
        "\uD1D9",
        17
    ],
    [
        "b861",
        "\uD1EB",
        8,
        "\uD1F5\uD1F6\uD1F7\uD1F9",
        13
    ],
    [
        "b881",
        "\uD208\uD20A",
        5,
        "\uD211",
        24,
        "\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",
        4,
        "\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"
    ],
    [
        "b941",
        "\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",
        6,
        "\uD23E\uD240\uD242",
        5,
        "\uD249\uD24A\uD24B\uD24C"
    ],
    [
        "b961",
        "\uD24D",
        14,
        "\uD25D",
        6,
        "\uD265\uD266\uD267\uD268"
    ],
    [
        "b981",
        "\uD269",
        22,
        "\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",
        4,
        "\uBC1B",
        4,
        "\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"
    ],
    [
        "ba41",
        "\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",
        5,
        "\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",
        6,
        "\uD2AD"
    ],
    [
        "ba61",
        "\uD2AE\uD2AF\uD2B0\uD2B2",
        5,
        "\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",
        4,
        "\uD2CA\uD2CC",
        5
    ],
    [
        "ba81",
        "\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",
        6,
        "\uD2E6",
        9,
        "\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"
    ],
    [
        "bb41",
        "\uD2FB",
        4,
        "\uD302\uD304\uD306",
        5,
        "\uD30F\uD311\uD312\uD313\uD315\uD317",
        4,
        "\uD31E\uD322\uD323"
    ],
    [
        "bb61",
        "\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",
        6,
        "\uD33A\uD33E",
        5,
        "\uD346\uD347\uD348\uD349"
    ],
    [
        "bb81",
        "\uD34A",
        31,
        "\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"
    ],
    [
        "bc41",
        "\uD36A",
        17,
        "\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"
    ],
    [
        "bc61",
        "\uD388\uD389\uD38A\uD38B\uD38E\uD392",
        5,
        "\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",
        6,
        "\uD3AA\uD3AC\uD3AE"
    ],
    [
        "bc81",
        "\uD3AF",
        4,
        "\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",
        6,
        "\uD3C6\uD3C7\uD3CA",
        5,
        "\uD3D1",
        5,
        "\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",
        4,
        "\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"
    ],
    [
        "bd41",
        "\uD3D7\uD3D9",
        7,
        "\uD3E2\uD3E4",
        7,
        "\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"
    ],
    [
        "bd61",
        "\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",
        5,
        "\uD409",
        13
    ],
    [
        "bd81",
        "\uD417",
        5,
        "\uD41E",
        25,
        "\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"
    ],
    [
        "be41",
        "\uD438",
        7,
        "\uD441\uD442\uD443\uD445",
        14
    ],
    [
        "be61",
        "\uD454",
        7,
        "\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",
        7,
        "\uD46E\uD470\uD471\uD472"
    ],
    [
        "be81",
        "\uD473",
        4,
        "\uD47A\uD47B\uD47D\uD47E\uD481\uD483",
        4,
        "\uD48A\uD48C\uD48E",
        5,
        "\uD495",
        8,
        "\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",
        6,
        "\uC5CC\uC5CE"
    ],
    [
        "bf41",
        "\uD49E",
        10,
        "\uD4AA",
        14
    ],
    [
        "bf61",
        "\uD4B9",
        18,
        "\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"
    ],
    [
        "bf81",
        "\uD4D6",
        5,
        "\uD4DD\uD4DE\uD4E0",
        7,
        "\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",
        6,
        "\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",
        5,
        "\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"
    ],
    [
        "c041",
        "\uD4FE",
        5,
        "\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",
        6,
        "\uD516\uD518",
        5
    ],
    [
        "c061",
        "\uD51E",
        25
    ],
    [
        "c081",
        "\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",
        6,
        "\uD54E\uD550\uD552",
        5,
        "\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",
        7,
        "\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"
    ],
    [
        "c141",
        "\uD564\uD566\uD567\uD56A\uD56C\uD56E",
        5,
        "\uD576\uD577\uD579\uD57A\uD57B\uD57D",
        6,
        "\uD586\uD58A\uD58B"
    ],
    [
        "c161",
        "\uD58C\uD58D\uD58E\uD58F\uD591",
        19,
        "\uD5A6\uD5A7"
    ],
    [
        "c181",
        "\uD5A8",
        31,
        "\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"
    ],
    [
        "c241",
        "\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",
        4,
        "\uD5DA\uD5DC\uD5DE",
        5,
        "\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"
    ],
    [
        "c261",
        "\uD5EF",
        4,
        "\uD5F6\uD5F8\uD5FA",
        5,
        "\uD602\uD603\uD605\uD606\uD607\uD609",
        6,
        "\uD612"
    ],
    [
        "c281",
        "\uD616",
        5,
        "\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",
        7,
        "\uD62E",
        9,
        "\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"
    ],
    [
        "c341",
        "\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",
        4
    ],
    [
        "c361",
        "\uD662",
        4,
        "\uD668\uD66A",
        5,
        "\uD672\uD673\uD675",
        11
    ],
    [
        "c381",
        "\uD681\uD682\uD684\uD686",
        5,
        "\uD68E\uD68F\uD691\uD692\uD693\uD695",
        7,
        "\uD69E\uD6A0\uD6A2",
        5,
        "\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"
    ],
    [
        "c441",
        "\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",
        7,
        "\uD6BA\uD6BC",
        7,
        "\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"
    ],
    [
        "c461",
        "\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",
        5,
        "\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",
        4
    ],
    [
        "c481",
        "\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",
        5,
        "\uD6FE\uD6FF\uD701\uD702\uD703\uD705",
        11,
        "\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"
    ],
    [
        "c541",
        "\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",
        6,
        "\uD72A\uD72C\uD72E",
        5,
        "\uD736\uD737\uD739"
    ],
    [
        "c561",
        "\uD73A\uD73B\uD73D",
        6,
        "\uD745\uD746\uD748\uD74A",
        5,
        "\uD752\uD753\uD755\uD75A",
        4
    ],
    [
        "c581",
        "\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",
        6,
        "\uD77E\uD77F\uD780\uD782",
        5,
        "\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"
    ],
    [
        "c641",
        "\uD78D\uD78E\uD78F\uD791",
        6,
        "\uD79A\uD79C\uD79E",
        5
    ],
    [
        "c6a1",
        "\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"
    ],
    [
        "c7a1",
        "\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"
    ],
    [
        "c8a1",
        "\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"
    ],
    [
        "caa1",
        "\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"
    ],
    [
        "cba1",
        "\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"
    ],
    [
        "cca1",
        "\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"
    ],
    [
        "cda1",
        "\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"
    ],
    [
        "cea1",
        "\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"
    ],
    [
        "cfa1",
        "\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"
    ],
    [
        "d0a1",
        "\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"
    ],
    [
        "d1a1",
        "\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",
        5,
        "\u90A3\uF914",
        4,
        "\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"
    ],
    [
        "d2a1",
        "\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",
        4,
        "\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",
        5,
        "\u99D1\uF939",
        10,
        "\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",
        7,
        "\u5AE9\u8A25\u677B\u7D10\uF952",
        5,
        "\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"
    ],
    [
        "d3a1",
        "\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"
    ],
    [
        "d4a1",
        "\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"
    ],
    [
        "d5a1",
        "\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"
    ],
    [
        "d6a1",
        "\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"
    ],
    [
        "d7a1",
        "\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"
    ],
    [
        "d8a1",
        "\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"
    ],
    [
        "d9a1",
        "\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"
    ],
    [
        "daa1",
        "\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"
    ],
    [
        "dba1",
        "\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"
    ],
    [
        "dca1",
        "\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"
    ],
    [
        "dda1",
        "\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"
    ],
    [
        "dea1",
        "\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"
    ],
    [
        "dfa1",
        "\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"
    ],
    [
        "e0a1",
        "\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"
    ],
    [
        "e1a1",
        "\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"
    ],
    [
        "e2a1",
        "\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"
    ],
    [
        "e3a1",
        "\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"
    ],
    [
        "e4a1",
        "\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"
    ],
    [
        "e5a1",
        "\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"
    ],
    [
        "e6a1",
        "\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"
    ],
    [
        "e7a1",
        "\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"
    ],
    [
        "e8a1",
        "\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"
    ],
    [
        "e9a1",
        "\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"
    ],
    [
        "eaa1",
        "\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"
    ],
    [
        "eba1",
        "\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"
    ],
    [
        "eca1",
        "\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"
    ],
    [
        "eda1",
        "\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"
    ],
    [
        "eea1",
        "\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"
    ],
    [
        "efa1",
        "\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"
    ],
    [
        "f0a1",
        "\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"
    ],
    [
        "f1a1",
        "\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"
    ],
    [
        "f2a1",
        "\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"
    ],
    [
        "f3a1",
        "\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"
    ],
    [
        "f4a1",
        "\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"
    ],
    [
        "f5a1",
        "\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"
    ],
    [
        "f6a1",
        "\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"
    ],
    [
        "f7a1",
        "\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"
    ],
    [
        "f8a1",
        "\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"
    ],
    [
        "f9a1",
        "\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"
    ],
    [
        "faa1",
        "\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"
    ],
    [
        "fba1",
        "\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"
    ],
    [
        "fca1",
        "\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"
    ],
    [
        "fda1",
        "\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"
    ]
];
var $3939d1de148b5202$var$cp949$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $3939d1de148b5202$var$cp949
});
var $3939d1de148b5202$var$cp950 = [
    [
        "0",
        "\u0000",
        127
    ],
    [
        "a140",
        "\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"
    ],
    [
        "a1a1",
        "\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",
        4,
        "\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"
    ],
    [
        "a240",
        "\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",
        7,
        "\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"
    ],
    [
        "a2a1",
        "\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",
        9,
        "\u2160",
        9,
        "\u3021",
        8,
        "\u5341\u5344\u5345\uFF21",
        25,
        "\uFF41",
        21
    ],
    [
        "a340",
        "\uFF57\uFF58\uFF59\uFF5A\u0391",
        16,
        "\u03A3",
        6,
        "\u03B1",
        16,
        "\u03C3",
        6,
        "\u3105",
        10
    ],
    [
        "a3a1",
        "\u3110",
        25,
        "\u02D9\u02C9\u02CA\u02C7\u02CB"
    ],
    [
        "a3e1",
        "\u20AC"
    ],
    [
        "a440",
        "\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"
    ],
    [
        "a4a1",
        "\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"
    ],
    [
        "a540",
        "\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"
    ],
    [
        "a5a1",
        "\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"
    ],
    [
        "a640",
        "\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"
    ],
    [
        "a6a1",
        "\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"
    ],
    [
        "a740",
        "\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"
    ],
    [
        "a7a1",
        "\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"
    ],
    [
        "a840",
        "\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"
    ],
    [
        "a8a1",
        "\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"
    ],
    [
        "a940",
        "\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"
    ],
    [
        "a9a1",
        "\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"
    ],
    [
        "aa40",
        "\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"
    ],
    [
        "aaa1",
        "\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"
    ],
    [
        "ab40",
        "\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"
    ],
    [
        "aba1",
        "\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"
    ],
    [
        "ac40",
        "\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"
    ],
    [
        "aca1",
        "\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"
    ],
    [
        "ad40",
        "\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"
    ],
    [
        "ada1",
        "\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"
    ],
    [
        "ae40",
        "\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"
    ],
    [
        "aea1",
        "\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"
    ],
    [
        "af40",
        "\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"
    ],
    [
        "afa1",
        "\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"
    ],
    [
        "b040",
        "\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"
    ],
    [
        "b0a1",
        "\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"
    ],
    [
        "b140",
        "\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"
    ],
    [
        "b1a1",
        "\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"
    ],
    [
        "b240",
        "\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"
    ],
    [
        "b2a1",
        "\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"
    ],
    [
        "b340",
        "\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"
    ],
    [
        "b3a1",
        "\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"
    ],
    [
        "b440",
        "\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"
    ],
    [
        "b4a1",
        "\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"
    ],
    [
        "b540",
        "\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"
    ],
    [
        "b5a1",
        "\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"
    ],
    [
        "b640",
        "\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"
    ],
    [
        "b6a1",
        "\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"
    ],
    [
        "b740",
        "\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"
    ],
    [
        "b7a1",
        "\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"
    ],
    [
        "b840",
        "\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"
    ],
    [
        "b8a1",
        "\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"
    ],
    [
        "b940",
        "\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"
    ],
    [
        "b9a1",
        "\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"
    ],
    [
        "ba40",
        "\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"
    ],
    [
        "baa1",
        "\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"
    ],
    [
        "bb40",
        "\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"
    ],
    [
        "bba1",
        "\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"
    ],
    [
        "bc40",
        "\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"
    ],
    [
        "bca1",
        "\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"
    ],
    [
        "bd40",
        "\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"
    ],
    [
        "bda1",
        "\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"
    ],
    [
        "be40",
        "\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"
    ],
    [
        "bea1",
        "\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"
    ],
    [
        "bf40",
        "\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"
    ],
    [
        "bfa1",
        "\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"
    ],
    [
        "c040",
        "\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"
    ],
    [
        "c0a1",
        "\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"
    ],
    [
        "c140",
        "\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"
    ],
    [
        "c1a1",
        "\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"
    ],
    [
        "c240",
        "\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"
    ],
    [
        "c2a1",
        "\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"
    ],
    [
        "c340",
        "\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"
    ],
    [
        "c3a1",
        "\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"
    ],
    [
        "c440",
        "\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"
    ],
    [
        "c4a1",
        "\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"
    ],
    [
        "c540",
        "\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"
    ],
    [
        "c5a1",
        "\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"
    ],
    [
        "c640",
        "\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"
    ],
    [
        "c940",
        "\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"
    ],
    [
        "c9a1",
        "\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"
    ],
    [
        "ca40",
        "\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"
    ],
    [
        "caa1",
        "\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"
    ],
    [
        "cb40",
        "\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"
    ],
    [
        "cba1",
        "\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"
    ],
    [
        "cc40",
        "\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"
    ],
    [
        "cca1",
        "\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"
    ],
    [
        "cd40",
        "\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"
    ],
    [
        "cda1",
        "\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"
    ],
    [
        "ce40",
        "\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"
    ],
    [
        "cea1",
        "\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"
    ],
    [
        "cf40",
        "\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"
    ],
    [
        "cfa1",
        "\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"
    ],
    [
        "d040",
        "\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"
    ],
    [
        "d0a1",
        "\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"
    ],
    [
        "d140",
        "\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"
    ],
    [
        "d1a1",
        "\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"
    ],
    [
        "d240",
        "\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"
    ],
    [
        "d2a1",
        "\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"
    ],
    [
        "d340",
        "\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"
    ],
    [
        "d3a1",
        "\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"
    ],
    [
        "d440",
        "\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"
    ],
    [
        "d4a1",
        "\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"
    ],
    [
        "d540",
        "\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"
    ],
    [
        "d5a1",
        "\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"
    ],
    [
        "d640",
        "\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"
    ],
    [
        "d6a1",
        "\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"
    ],
    [
        "d740",
        "\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"
    ],
    [
        "d7a1",
        "\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"
    ],
    [
        "d840",
        "\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"
    ],
    [
        "d8a1",
        "\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"
    ],
    [
        "d940",
        "\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"
    ],
    [
        "d9a1",
        "\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"
    ],
    [
        "da40",
        "\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"
    ],
    [
        "daa1",
        "\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"
    ],
    [
        "db40",
        "\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"
    ],
    [
        "dba1",
        "\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"
    ],
    [
        "dc40",
        "\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"
    ],
    [
        "dca1",
        "\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"
    ],
    [
        "dd40",
        "\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"
    ],
    [
        "dda1",
        "\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"
    ],
    [
        "de40",
        "\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"
    ],
    [
        "dea1",
        "\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"
    ],
    [
        "df40",
        "\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"
    ],
    [
        "dfa1",
        "\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"
    ],
    [
        "e040",
        "\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"
    ],
    [
        "e0a1",
        "\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"
    ],
    [
        "e140",
        "\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"
    ],
    [
        "e1a1",
        "\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"
    ],
    [
        "e240",
        "\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"
    ],
    [
        "e2a1",
        "\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"
    ],
    [
        "e340",
        "\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"
    ],
    [
        "e3a1",
        "\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"
    ],
    [
        "e440",
        "\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"
    ],
    [
        "e4a1",
        "\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"
    ],
    [
        "e540",
        "\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"
    ],
    [
        "e5a1",
        "\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"
    ],
    [
        "e640",
        "\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"
    ],
    [
        "e6a1",
        "\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"
    ],
    [
        "e740",
        "\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"
    ],
    [
        "e7a1",
        "\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"
    ],
    [
        "e840",
        "\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"
    ],
    [
        "e8a1",
        "\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"
    ],
    [
        "e940",
        "\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"
    ],
    [
        "e9a1",
        "\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"
    ],
    [
        "ea40",
        "\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"
    ],
    [
        "eaa1",
        "\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"
    ],
    [
        "eb40",
        "\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"
    ],
    [
        "eba1",
        "\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"
    ],
    [
        "ec40",
        "\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"
    ],
    [
        "eca1",
        "\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"
    ],
    [
        "ed40",
        "\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"
    ],
    [
        "eda1",
        "\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"
    ],
    [
        "ee40",
        "\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"
    ],
    [
        "eea1",
        "\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"
    ],
    [
        "ef40",
        "\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"
    ],
    [
        "efa1",
        "\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"
    ],
    [
        "f040",
        "\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"
    ],
    [
        "f0a1",
        "\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"
    ],
    [
        "f140",
        "\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"
    ],
    [
        "f1a1",
        "\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"
    ],
    [
        "f240",
        "\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"
    ],
    [
        "f2a1",
        "\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"
    ],
    [
        "f340",
        "\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"
    ],
    [
        "f3a1",
        "\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"
    ],
    [
        "f440",
        "\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"
    ],
    [
        "f4a1",
        "\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"
    ],
    [
        "f540",
        "\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"
    ],
    [
        "f5a1",
        "\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"
    ],
    [
        "f640",
        "\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"
    ],
    [
        "f6a1",
        "\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"
    ],
    [
        "f740",
        "\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"
    ],
    [
        "f7a1",
        "\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"
    ],
    [
        "f840",
        "\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"
    ],
    [
        "f8a1",
        "\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"
    ],
    [
        "f940",
        "\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"
    ],
    [
        "f9a1",
        "\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"
    ]
];
var $3939d1de148b5202$var$cp950$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $3939d1de148b5202$var$cp950
});
var $3939d1de148b5202$var$big5Added = [
    [
        "8740",
        "\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"
    ],
    [
        "8767",
        "\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"
    ],
    [
        "87a1",
        "\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"
    ],
    [
        "8840",
        "\u31C0",
        4,
        "\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"
    ],
    [
        "88a1",
        "\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"
    ],
    [
        "8940",
        "\uD868\uDFA9\uD844\uDD45"
    ],
    [
        "8943",
        "\u650A"
    ],
    [
        "8946",
        "\u4E3D\u6EDD\u9D4E\u91DF"
    ],
    [
        "894c",
        "\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"
    ],
    [
        "89a1",
        "\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"
    ],
    [
        "89ab",
        "\u918C\u78B8\u915E\u80BC"
    ],
    [
        "89b0",
        "\u8D0B\u80F6\uD842\uDDE7"
    ],
    [
        "89b5",
        "\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"
    ],
    [
        "89c1",
        "\u6E9A\u823E\u7519"
    ],
    [
        "89c5",
        "\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"
    ],
    [
        "8a40",
        "\uD85F\uDD84\u5525"
    ],
    [
        "8a43",
        "\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"
    ],
    [
        "8a64",
        "\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"
    ],
    [
        "8a76",
        "\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"
    ],
    [
        "8aa1",
        "\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"
    ],
    [
        "8aac",
        "\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"
    ],
    [
        "8ab2",
        "\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"
    ],
    [
        "8abb",
        "\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"
    ],
    [
        "8ac9",
        "\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"
    ],
    [
        "8ace",
        "\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"
    ],
    [
        "8adf",
        "\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"
    ],
    [
        "8af6",
        "\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"
    ],
    [
        "8b40",
        "\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"
    ],
    [
        "8b55",
        "\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"
    ],
    [
        "8ba1",
        "\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"
    ],
    [
        "8bde",
        "\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"
    ],
    [
        "8c40",
        "\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"
    ],
    [
        "8ca1",
        "\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"
    ],
    [
        "8ca7",
        "\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"
    ],
    [
        "8cc9",
        "\u9868\u676B\u4276\u573D"
    ],
    [
        "8cce",
        "\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"
    ],
    [
        "8ce6",
        "\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"
    ],
    [
        "8d40",
        "\uD842\uDF9F"
    ],
    [
        "8d42",
        "\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"
    ],
    [
        "8da1",
        "\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"
    ],
    [
        "8e40",
        "\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"
    ],
    [
        "8ea1",
        "\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"
    ],
    [
        "8f40",
        "\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"
    ],
    [
        "8fa1",
        "\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"
    ],
    [
        "9040",
        "\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"
    ],
    [
        "90a1",
        "\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"
    ],
    [
        "9140",
        "\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"
    ],
    [
        "91a1",
        "\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"
    ],
    [
        "9240",
        "\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"
    ],
    [
        "92a1",
        "\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"
    ],
    [
        "9340",
        "\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"
    ],
    [
        "93a1",
        "\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"
    ],
    [
        "9440",
        "\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"
    ],
    [
        "94a1",
        "\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"
    ],
    [
        "9540",
        "\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"
    ],
    [
        "95a1",
        "\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"
    ],
    [
        "9640",
        "\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"
    ],
    [
        "96a1",
        "\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"
    ],
    [
        "9740",
        "\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"
    ],
    [
        "97a1",
        "\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"
    ],
    [
        "9840",
        "\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"
    ],
    [
        "98a1",
        "\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"
    ],
    [
        "9940",
        "\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"
    ],
    [
        "99a1",
        "\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"
    ],
    [
        "9a40",
        "\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"
    ],
    [
        "9aa1",
        "\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"
    ],
    [
        "9b40",
        "\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"
    ],
    [
        "9b62",
        "\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"
    ],
    [
        "9ba1",
        "\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"
    ],
    [
        "9c40",
        "\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"
    ],
    [
        "9ca1",
        "\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"
    ],
    [
        "9d40",
        "\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"
    ],
    [
        "9da1",
        "\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"
    ],
    [
        "9e40",
        "\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"
    ],
    [
        "9ea1",
        "\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"
    ],
    [
        "9ead",
        "\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"
    ],
    [
        "9ec5",
        "\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"
    ],
    [
        "9ef5",
        "\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"
    ],
    [
        "9f40",
        "\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"
    ],
    [
        "9f4f",
        "\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"
    ],
    [
        "9fa1",
        "\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"
    ],
    [
        "9fae",
        "\u9159\u9681\u915C"
    ],
    [
        "9fb2",
        "\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"
    ],
    [
        "9fc1",
        "\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"
    ],
    [
        "9fc9",
        "\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"
    ],
    [
        "9fdb",
        "\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"
    ],
    [
        "9fe7",
        "\u6BFA\u8818\u7F78"
    ],
    [
        "9feb",
        "\u5620\uD869\uDE4A\u8E77\u9F53"
    ],
    [
        "9ff0",
        "\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"
    ],
    [
        "a040",
        "\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"
    ],
    [
        "a055",
        "\uD846\uDC3B\uD85B\uDE05"
    ],
    [
        "a058",
        "\u8A7E\uD849\uDD1B"
    ],
    [
        "a05b",
        "\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"
    ],
    [
        "a063",
        "\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"
    ],
    [
        "a073",
        "\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"
    ],
    [
        "a0a1",
        "\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"
    ],
    [
        "a0a6",
        "\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"
    ],
    [
        "a0ae",
        "\u77FE"
    ],
    [
        "a0b0",
        "\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"
    ],
    [
        "a0d4",
        "\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"
    ],
    [
        "a0e2",
        "\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"
    ],
    [
        "a3c0",
        "\u2400",
        31,
        "\u2421"
    ],
    [
        "c6a1",
        "\u2460",
        9,
        "\u2474",
        9,
        "\u2170",
        9,
        "\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",
        23
    ],
    [
        "c740",
        "\u3059",
        58,
        "\u30A1\u30A2\u30A3\u30A4"
    ],
    [
        "c7a1",
        "\u30A5",
        81,
        "\u0410",
        5,
        "\u0401\u0416",
        4
    ],
    [
        "c840",
        "\u041B",
        26,
        "\u0451\u0436",
        25,
        "\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"
    ],
    [
        "c8a1",
        "\u9FB0\u5188\u9FB1\uD85D\uDE07"
    ],
    [
        "c8cd",
        "\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"
    ],
    [
        "c8f5",
        "\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"
    ],
    [
        "f9fe",
        "\uFFED"
    ],
    [
        "fa40",
        "\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"
    ],
    [
        "faa1",
        "\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"
    ],
    [
        "fb40",
        "\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"
    ],
    [
        "fba1",
        "\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"
    ],
    [
        "fc40",
        "\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"
    ],
    [
        "fca1",
        "\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"
    ],
    [
        "fd40",
        "\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"
    ],
    [
        "fda1",
        "\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"
    ],
    [
        "fe40",
        "\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"
    ],
    [
        "fea1",
        "\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"
    ]
];
var $3939d1de148b5202$var$big5Added$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $3939d1de148b5202$var$big5Added
});
var $3939d1de148b5202$var$require$$0 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$shiftjis$1);
var $3939d1de148b5202$var$require$$1 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$eucjp$1);
var $3939d1de148b5202$var$require$$2 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$cp936$1);
var $3939d1de148b5202$var$require$$3$1 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$gbkAdded$1);
var $3939d1de148b5202$var$require$$4 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$gb18030Ranges$1);
var $3939d1de148b5202$var$require$$5 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$cp949$1);
var $3939d1de148b5202$var$require$$6 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$cp950$1);
var $3939d1de148b5202$var$require$$7 = $3939d1de148b5202$var$getCjsExportFromNamespace($3939d1de148b5202$var$big5Added$1);
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.
var $3939d1de148b5202$var$dbcsData = {
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
    'shiftjis': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$0;
        },
        encodeAdd: {
            "\xA5": 0x5C,
            "\u203E": 0x7E
        },
        encodeSkipVals: [
            {
                from: 0xED40,
                to: 0xF940
            }
        ]
    },
    'csshiftjis': 'shiftjis',
    'mskanji': 'shiftjis',
    'sjis': 'shiftjis',
    'windows31j': 'shiftjis',
    'ms31j': 'shiftjis',
    'xsjis': 'shiftjis',
    'windows932': 'shiftjis',
    'ms932': 'shiftjis',
    '932': 'shiftjis',
    'cp932': 'shiftjis',
    'eucjp': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$1;
        },
        encodeAdd: {
            "\xA5": 0x5C,
            "\u203E": 0x7E
        }
    },
    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    'gb2312': 'cp936',
    'gb231280': 'cp936',
    'gb23121980': 'cp936',
    'csgb2312': 'cp936',
    'csiso58gb231280': 'cp936',
    'euccn': 'cp936',
    // Microsoft's CP936 is a subset and approximation of GBK.
    'windows936': 'cp936',
    'ms936': 'cp936',
    '936': 'cp936',
    'cp936': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$2;
        }
    },
    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    'gbk': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$2.concat($3939d1de148b5202$var$require$$3$1);
        }
    },
    'xgbk': 'gbk',
    'isoir58': 'gbk',
    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    'gb18030': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$2.concat($3939d1de148b5202$var$require$$3$1);
        },
        gb18030: function gb18030() {
            return $3939d1de148b5202$var$require$$4;
        },
        encodeSkipVals: [
            0x80
        ],
        encodeAdd: {
            "\u20AC": 0xA2E3
        }
    },
    'chinese': 'gb18030',
    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    'windows949': 'cp949',
    'ms949': 'cp949',
    '949': 'cp949',
    'cp949': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$5;
        }
    },
    'cseuckr': 'cp949',
    'csksc56011987': 'cp949',
    'euckr': 'cp949',
    'isoir149': 'cp949',
    'korean': 'cp949',
    'ksc56011987': 'cp949',
    'ksc56011989': 'cp949',
    'ksc5601': 'cp949',
    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
    'windows950': 'cp950',
    'ms950': 'cp950',
    '950': 'cp950',
    'cp950': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$6;
        }
    },
    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    'big5': 'big5hkscs',
    'big5hkscs': {
        type: '_dbcs',
        table: function table() {
            return $3939d1de148b5202$var$require$$6.concat($3939d1de148b5202$var$require$$7);
        },
        encodeSkipVals: [
            0xa2cc
        ]
    },
    'cnbig5': 'big5hkscs',
    'csbig5': 'big5hkscs',
    'xxbig5': 'big5hkscs'
};
var $3939d1de148b5202$var$encodings = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    // We support Browserify by skipping automatic module discovery and requiring modules directly.
    var modules = [
        $3939d1de148b5202$var$internal,
        $3939d1de148b5202$var$utf16,
        $3939d1de148b5202$var$utf7,
        $3939d1de148b5202$var$sbcsCodec,
        $3939d1de148b5202$var$sbcsData,
        $3939d1de148b5202$var$sbcsDataGenerated,
        $3939d1de148b5202$var$dbcsCodec,
        $3939d1de148b5202$var$dbcsData
    ]; // Put all encoding/alias/codec definitions to single object and export it. 
    for(var i = 0; i < modules.length; i++){
        var module = modules[i];
        for(var enc in module)if (Object.prototype.hasOwnProperty.call(module, enc)) exports[enc] = module[enc];
    }
});
var $3939d1de148b5202$var$Buffer$6 = $3939d1de148b5202$var$buffer.Buffer, $3939d1de148b5202$var$Transform$1 = $3939d1de148b5202$var$Stream.Transform; // == Exports ==================================================================
var $3939d1de148b5202$var$streams = function streams(iconv) {
    // Additional Public API.
    iconv.encodeStream = function encodeStream(encoding, options) {
        return new $3939d1de148b5202$var$IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
    };
    iconv.decodeStream = function decodeStream(encoding, options) {
        return new $3939d1de148b5202$var$IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
    };
    iconv.supportsStreams = true; // Not published yet.
    iconv.IconvLiteEncoderStream = $3939d1de148b5202$var$IconvLiteEncoderStream;
    iconv.IconvLiteDecoderStream = $3939d1de148b5202$var$IconvLiteDecoderStream;
    iconv._collect = $3939d1de148b5202$var$IconvLiteDecoderStream.prototype.collect;
}; // == Encoder stream =======================================================
function $3939d1de148b5202$var$IconvLiteEncoderStream(conv, options) {
    this.conv = conv;
    options = options || {};
    options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
    $3939d1de148b5202$var$Transform$1.call(this, options);
}
$3939d1de148b5202$var$IconvLiteEncoderStream.prototype = Object.create($3939d1de148b5202$var$Transform$1.prototype, {
    constructor: {
        value: $3939d1de148b5202$var$IconvLiteEncoderStream
    }
});
$3939d1de148b5202$var$IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
    if (typeof chunk != 'string') return done(new Error("Iconv encoding stream needs strings as its input."));
    try {
        var res = this.conv.write(chunk);
        if (res && res.length) this.push(res);
        done();
    } catch (e) {
        done(e);
    }
};
$3939d1de148b5202$var$IconvLiteEncoderStream.prototype._flush = function(done) {
    try {
        var res = this.conv.end();
        if (res && res.length) this.push(res);
        done();
    } catch (e) {
        done(e);
    }
};
$3939d1de148b5202$var$IconvLiteEncoderStream.prototype.collect = function(cb) {
    var chunks = [];
    this.on('error', cb);
    this.on('data', function(chunk) {
        chunks.push(chunk);
    });
    this.on('end', function() {
        cb(null, $3939d1de148b5202$var$Buffer$6.concat(chunks));
    });
    return this;
}; // == Decoder stream =======================================================
function $3939d1de148b5202$var$IconvLiteDecoderStream(conv, options) {
    this.conv = conv;
    options = options || {};
    options.encoding = this.encoding = 'utf8'; // We output strings.
    $3939d1de148b5202$var$Transform$1.call(this, options);
}
$3939d1de148b5202$var$IconvLiteDecoderStream.prototype = Object.create($3939d1de148b5202$var$Transform$1.prototype, {
    constructor: {
        value: $3939d1de148b5202$var$IconvLiteDecoderStream
    }
});
$3939d1de148b5202$var$IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
    if (!$3939d1de148b5202$var$Buffer$6.isBuffer(chunk)) return done(new Error("Iconv decoding stream needs buffers as its input."));
    try {
        var res = this.conv.write(chunk);
        if (res && res.length) this.push(res, this.encoding);
        done();
    } catch (e) {
        done(e);
    }
};
$3939d1de148b5202$var$IconvLiteDecoderStream.prototype._flush = function(done) {
    try {
        var res = this.conv.end();
        if (res && res.length) this.push(res, this.encoding);
        done();
    } catch (e) {
        done(e);
    }
};
$3939d1de148b5202$var$IconvLiteDecoderStream.prototype.collect = function(cb) {
    var res = '';
    this.on('error', cb);
    this.on('data', function(chunk) {
        res += chunk;
    });
    this.on('end', function() {
        cb(null, res);
    });
    return this;
};
var $3939d1de148b5202$var$Buffer$7 = $3939d1de148b5202$var$buffer.Buffer; // Note: not polyfilled with safer-buffer on a purpose, as overrides Buffer
// == Extend Node primitives to use iconv-lite =================================
var $3939d1de148b5202$var$extendNode = function extendNode(iconv) {
    var original = undefined; // Place to keep original methods.
    // Node authors rewrote Buffer internals to make it compatible with
    // Uint8Array and we cannot patch key functions since then.
    // Note: this does use older Buffer API on a purpose
    iconv.supportsNodeEncodingsExtension = !($3939d1de148b5202$var$Buffer$7.from || new $3939d1de148b5202$var$Buffer$7(0) instanceof Uint8Array);
    iconv.extendNodeEncodings = function extendNodeEncodings() {
        if (original) return;
        original = {};
        if (!iconv.supportsNodeEncodingsExtension) {
            console.error("ACTION NEEDED: require('iconv-lite').extendNodeEncodings() is not supported in your version of Node");
            console.error("See more info at https://github.com/ashtuchkin/iconv-lite/wiki/Node-v4-compatibility");
            return;
        }
        var nodeNativeEncodings = {
            'hex': true,
            'utf8': true,
            'utf-8': true,
            'ascii': true,
            'binary': true,
            'base64': true,
            'ucs2': true,
            'ucs-2': true,
            'utf16le': true,
            'utf-16le': true
        };
        $3939d1de148b5202$var$Buffer$7.isNativeEncoding = function(enc) {
            return enc && nodeNativeEncodings[enc.toLowerCase()];
        }; // -- SlowBuffer -----------------------------------------------------------
        var SlowBuffer = $3939d1de148b5202$var$buffer.SlowBuffer;
        original.SlowBufferToString = SlowBuffer.prototype.toString;
        SlowBuffer.prototype.toString = function(encoding, start, end) {
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($3939d1de148b5202$var$Buffer$7.isNativeEncoding(encoding)) return original.SlowBufferToString.call(this, encoding, start, end); // Otherwise, use our decoding method.
            if (typeof start == 'undefined') start = 0;
            if (typeof end == 'undefined') end = this.length;
            return iconv.decode(this.slice(start, end), encoding);
        };
        original.SlowBufferWrite = SlowBuffer.prototype.write;
        SlowBuffer.prototype.write = function(string, offset, length, encoding) {
            // Support both (string, offset, length, encoding)
            // and the legacy (string, encoding, offset, length)
            if (isFinite(offset)) {
                if (!isFinite(length)) {
                    encoding = length;
                    length = undefined;
                }
            } else {
                // legacy
                var swap = encoding;
                encoding = offset;
                offset = length;
                length = swap;
            }
            offset = +offset || 0;
            var remaining = this.length - offset;
            if (!length) length = remaining;
            else {
                length = +length;
                if (length > remaining) length = remaining;
            }
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($3939d1de148b5202$var$Buffer$7.isNativeEncoding(encoding)) return original.SlowBufferWrite.call(this, string, offset, length, encoding);
            if (string.length > 0 && (length < 0 || offset < 0)) throw new RangeError('attempt to write beyond buffer bounds'); // Otherwise, use our encoding method.
            var buf = iconv.encode(string, encoding);
            if (buf.length < length) length = buf.length;
            buf.copy(this, offset, 0, length);
            return length;
        }; // -- Buffer ---------------------------------------------------------------
        original.BufferIsEncoding = $3939d1de148b5202$var$Buffer$7.isEncoding;
        $3939d1de148b5202$var$Buffer$7.isEncoding = function(encoding) {
            return $3939d1de148b5202$var$Buffer$7.isNativeEncoding(encoding) || iconv.encodingExists(encoding);
        };
        original.BufferByteLength = $3939d1de148b5202$var$Buffer$7.byteLength;
        $3939d1de148b5202$var$Buffer$7.byteLength = SlowBuffer.byteLength = function(str, encoding) {
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($3939d1de148b5202$var$Buffer$7.isNativeEncoding(encoding)) return original.BufferByteLength.call(this, str, encoding); // Slow, I know, but we don't have a better way yet.
            return iconv.encode(str, encoding).length;
        };
        original.BufferToString = $3939d1de148b5202$var$Buffer$7.prototype.toString;
        $3939d1de148b5202$var$Buffer$7.prototype.toString = function(encoding, start, end) {
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($3939d1de148b5202$var$Buffer$7.isNativeEncoding(encoding)) return original.BufferToString.call(this, encoding, start, end); // Otherwise, use our decoding method.
            if (typeof start == 'undefined') start = 0;
            if (typeof end == 'undefined') end = this.length;
            return iconv.decode(this.slice(start, end), encoding);
        };
        original.BufferWrite = $3939d1de148b5202$var$Buffer$7.prototype.write;
        $3939d1de148b5202$var$Buffer$7.prototype.write = function(string, offset, length, encoding) {
            var _offset = offset, _length = length, _encoding = encoding; // Support both (string, offset, length, encoding)
            // and the legacy (string, encoding, offset, length)
            if (isFinite(offset)) {
                if (!isFinite(length)) {
                    encoding = length;
                    length = undefined;
                }
            } else {
                // legacy
                var swap = encoding;
                encoding = offset;
                offset = length;
                length = swap;
            }
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($3939d1de148b5202$var$Buffer$7.isNativeEncoding(encoding)) return original.BufferWrite.call(this, string, _offset, _length, _encoding);
            offset = +offset || 0;
            var remaining = this.length - offset;
            if (!length) length = remaining;
            else {
                length = +length;
                if (length > remaining) length = remaining;
            }
            if (string.length > 0 && (length < 0 || offset < 0)) throw new RangeError('attempt to write beyond buffer bounds'); // Otherwise, use our encoding method.
            var buf = iconv.encode(string, encoding);
            if (buf.length < length) length = buf.length;
            buf.copy(this, offset, 0, length);
            return length; // TODO: Set _charsWritten.
        }; // -- Readable -------------------------------------------------------------
        if (iconv.supportsStreams) {
            var Readable = $3939d1de148b5202$var$Stream.Readable;
            original.ReadableSetEncoding = Readable.prototype.setEncoding;
            Readable.prototype.setEncoding = function setEncoding(enc, options) {
                // Use our own decoder, it has the same interface.
                // We cannot use original function as it doesn't handle BOM-s.
                this._readableState.decoder = iconv.getDecoder(enc, options);
                this._readableState.encoding = enc;
            };
            Readable.prototype.collect = iconv._collect;
        }
    }; // Remove iconv-lite Node primitive extensions.
    iconv.undoExtendNodeEncodings = function undoExtendNodeEncodings() {
        if (!iconv.supportsNodeEncodingsExtension) return;
        if (!original) throw new Error("require('iconv-lite').undoExtendNodeEncodings(): Nothing to undo; extendNodeEncodings() is not called.");
        delete $3939d1de148b5202$var$Buffer$7.isNativeEncoding;
        var SlowBuffer = $3939d1de148b5202$var$buffer.SlowBuffer;
        SlowBuffer.prototype.toString = original.SlowBufferToString;
        SlowBuffer.prototype.write = original.SlowBufferWrite;
        $3939d1de148b5202$var$Buffer$7.isEncoding = original.BufferIsEncoding;
        $3939d1de148b5202$var$Buffer$7.byteLength = original.BufferByteLength;
        $3939d1de148b5202$var$Buffer$7.prototype.toString = original.BufferToString;
        $3939d1de148b5202$var$Buffer$7.prototype.write = original.BufferWrite;
        if (iconv.supportsStreams) {
            var Readable = $3939d1de148b5202$var$Stream.Readable;
            Readable.prototype.setEncoding = original.ReadableSetEncoding;
            delete Readable.prototype.collect;
        }
        original = undefined;
    };
};
var $3939d1de148b5202$var$lib = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Solution would be installing npm modules "buffer" and "stream" explicitly.
    var Buffer = $3939d1de148b5202$var$safer_1.Buffer;
    var iconv = module.exports; // All codecs and aliases are kept here, keyed by encoding name/alias.
    // They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
    iconv.encodings = null; // Characters emitted in case of error.
    iconv.defaultCharUnicode = "\uFFFD";
    iconv.defaultCharSingleByte = '?'; // Public API.
    iconv.encode = function encode(str, encoding, options) {
        str = "" + (str || ""); // Ensure string.
        var encoder = iconv.getEncoder(encoding, options);
        var res = encoder.write(str);
        var trail = encoder.end();
        return trail && trail.length > 0 ? Buffer.concat([
            res,
            trail
        ]) : res;
    };
    iconv.decode = function decode(buf, encoding, options) {
        if (typeof buf === 'string') {
            if (!iconv.skipDecodeWarning) {
                console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
                iconv.skipDecodeWarning = true;
            }
            buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
        }
        var decoder = iconv.getDecoder(encoding, options);
        var res = decoder.write(buf);
        var trail = decoder.end();
        return trail ? res + trail : res;
    };
    iconv.encodingExists = function encodingExists(enc) {
        try {
            iconv.getCodec(enc);
            return true;
        } catch (e) {
            return false;
        }
    }; // Legacy aliases to convert functions
    iconv.toEncoding = iconv.encode;
    iconv.fromEncoding = iconv.decode; // Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
    iconv._codecDataCache = {};
    iconv.getCodec = function getCodec(encoding) {
        if (!iconv.encodings) iconv.encodings = $3939d1de148b5202$var$encodings; // Lazy load all encoding definitions.
        // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
        var enc = iconv._canonicalizeEncoding(encoding); // Traverse iconv.encodings to find actual codec.
        var codecOptions = {};
        while(true){
            var codec = iconv._codecDataCache[enc];
            if (codec) return codec;
            var codecDef = iconv.encodings[enc];
            switch(typeof codecDef){
                case "string":
                    // Direct alias to other encoding.
                    enc = codecDef;
                    break;
                case "object":
                    // Alias with options. Can be layered.
                    for(var key in codecDef)codecOptions[key] = codecDef[key];
                    if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                    enc = codecDef.type;
                    break;
                case "function":
                    // Codec itself.
                    if (!codecOptions.encodingName) codecOptions.encodingName = enc; // The codec function must load all tables and return object with .encoder and .decoder methods.
                    // It'll be called only once (for each different options object).
                    codec = new codecDef(codecOptions, iconv);
                    iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                    return codec;
                default:
                    throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
            }
        }
    };
    iconv._canonicalizeEncoding = function(encoding) {
        // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
        return ('' + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
    };
    iconv.getEncoder = function getEncoder(encoding, options) {
        var codec = iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
        if (codec.bomAware && options && options.addBOM) encoder = new $3939d1de148b5202$var$bomHandling.PrependBOM(encoder, options);
        return encoder;
    };
    iconv.getDecoder = function getDecoder(encoding, options) {
        var codec = iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
        if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new $3939d1de148b5202$var$bomHandling.StripBOM(decoder, options);
        return decoder;
    }; // Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
    var nodeVer = typeof $3939d1de148b5202$var$process !== 'undefined' && $3939d1de148b5202$var$process.versions && $3939d1de148b5202$var$process.versions.node;
    if (nodeVer) {
        // Load streaming support in Node v0.10+
        var nodeVerArr = nodeVer.split(".").map(Number);
        if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) $3939d1de148b5202$var$streams(iconv);
         // Load Node primitive extensions.
        $3939d1de148b5202$var$extendNode(iconv);
    }
});
var $3939d1de148b5202$var$DecodeStream = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var DecodeStream, iconv;
        try {
            iconv = $3939d1de148b5202$var$lib;
        } catch (_error) {}
        DecodeStream = function() {
            var key;
            function DecodeStream(buffer) {
                this.buffer = buffer;
                this.pos = 0;
                this.length = this.buffer.length;
            }
            DecodeStream.TYPES = {
                UInt8: 1,
                UInt16: 2,
                UInt24: 3,
                UInt32: 4,
                Int8: 1,
                Int16: 2,
                Int24: 3,
                Int32: 4,
                Float: 4,
                Double: 8
            };
            for(key in $3939d1de148b5202$var$buffer_1.prototype)if (key.slice(0, 4) === 'read') (function(key) {
                var bytes;
                bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
                return DecodeStream.prototype[key] = function() {
                    var ret;
                    ret = this.buffer[key](this.pos);
                    this.pos += bytes;
                    return ret;
                };
            })(key);
            DecodeStream.prototype.readString = function(length, encoding) {
                var buf, _byte, i, _i, _ref;
                if (encoding == null) encoding = 'ascii';
                switch(encoding){
                    case 'utf16le':
                    case 'ucs2':
                    case 'utf8':
                    case 'ascii':
                        return this.buffer.toString(encoding, this.pos, this.pos += length);
                    case 'utf16be':
                        buf = new $3939d1de148b5202$var$buffer_1(this.readBuffer(length));
                        for(i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2){
                            _byte = buf[i];
                            buf[i] = buf[i + 1];
                            buf[i + 1] = _byte;
                        }
                        return buf.toString('utf16le');
                    default:
                        buf = this.readBuffer(length);
                        if (iconv) try {
                            return iconv.decode(buf, encoding);
                        } catch (_error) {}
                        return buf;
                }
            };
            DecodeStream.prototype.readBuffer = function(length) {
                return this.buffer.slice(this.pos, this.pos += length);
            };
            DecodeStream.prototype.readUInt24BE = function() {
                return (this.readUInt16BE() << 8) + this.readUInt8();
            };
            DecodeStream.prototype.readUInt24LE = function() {
                return this.readUInt16LE() + (this.readUInt8() << 16);
            };
            DecodeStream.prototype.readInt24BE = function() {
                return (this.readInt16BE() << 8) + this.readUInt8();
            };
            DecodeStream.prototype.readInt24LE = function() {
                return this.readUInt16LE() + (this.readInt8() << 16);
            };
            return DecodeStream;
        }();
        module.exports = DecodeStream;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$EncodeStream = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var DecodeStream$1, EncodeStream, iconv, stream, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        stream = $3939d1de148b5202$var$Stream;
        DecodeStream$1 = $3939d1de148b5202$var$DecodeStream;
        try {
            iconv = $3939d1de148b5202$var$lib;
        } catch (_error) {}
        EncodeStream = function(_super) {
            var key;
            __extends(EncodeStream, _super);
            function EncodeStream(bufferSize) {
                if (bufferSize == null) bufferSize = 65536;
                EncodeStream.__super__.constructor.apply(this, arguments);
                this.buffer = new $3939d1de148b5202$var$buffer_1(bufferSize);
                this.bufferOffset = 0;
                this.pos = 0;
            }
            for(key in $3939d1de148b5202$var$buffer_1.prototype)if (key.slice(0, 5) === 'write') (function(key) {
                var bytes;
                bytes = +DecodeStream$1.TYPES[key.replace(/write|[BL]E/g, '')];
                return EncodeStream.prototype[key] = function(value) {
                    this.ensure(bytes);
                    this.buffer[key](value, this.bufferOffset);
                    this.bufferOffset += bytes;
                    return this.pos += bytes;
                };
            })(key);
            EncodeStream.prototype._read = function() {};
            EncodeStream.prototype.ensure = function(bytes) {
                if (this.bufferOffset + bytes > this.buffer.length) return this.flush();
            };
            EncodeStream.prototype.flush = function() {
                if (this.bufferOffset > 0) {
                    this.push(new $3939d1de148b5202$var$buffer_1(this.buffer.slice(0, this.bufferOffset)));
                    return this.bufferOffset = 0;
                }
            };
            EncodeStream.prototype.writeBuffer = function(buffer) {
                this.flush();
                this.push(buffer);
                return this.pos += buffer.length;
            };
            EncodeStream.prototype.writeString = function(string, encoding) {
                var buf, _byte, i, _i, _ref;
                if (encoding == null) encoding = 'ascii';
                switch(encoding){
                    case 'utf16le':
                    case 'ucs2':
                    case 'utf8':
                    case 'ascii':
                        return this.writeBuffer(new $3939d1de148b5202$var$buffer_1(string, encoding));
                    case 'utf16be':
                        buf = new $3939d1de148b5202$var$buffer_1(string, 'utf16le');
                        for(i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2){
                            _byte = buf[i];
                            buf[i] = buf[i + 1];
                            buf[i + 1] = _byte;
                        }
                        return this.writeBuffer(buf);
                    default:
                        if (iconv) return this.writeBuffer(iconv.encode(string, encoding));
                        else throw new Error('Install iconv-lite to enable additional string encodings.');
                }
            };
            EncodeStream.prototype.writeUInt24BE = function(val) {
                this.ensure(3);
                this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                this.buffer[this.bufferOffset++] = val & 0xff;
                return this.pos += 3;
            };
            EncodeStream.prototype.writeUInt24LE = function(val) {
                this.ensure(3);
                this.buffer[this.bufferOffset++] = val & 0xff;
                this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                return this.pos += 3;
            };
            EncodeStream.prototype.writeInt24BE = function(val) {
                if (val >= 0) return this.writeUInt24BE(val);
                else return this.writeUInt24BE(val + 0xffffff + 1);
            };
            EncodeStream.prototype.writeInt24LE = function(val) {
                if (val >= 0) return this.writeUInt24LE(val);
                else return this.writeUInt24LE(val + 0xffffff + 1);
            };
            EncodeStream.prototype.fill = function(val, length) {
                var buf;
                if (length < this.buffer.length) {
                    this.ensure(length);
                    this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
                    this.bufferOffset += length;
                    return this.pos += length;
                } else {
                    buf = new $3939d1de148b5202$var$buffer_1(length);
                    buf.fill(val);
                    return this.writeBuffer(buf);
                }
            };
            EncodeStream.prototype.end = function() {
                this.flush();
                return this.push(null);
            };
            return EncodeStream;
        }(stream.Readable);
        module.exports = EncodeStream;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$_Number = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var DecodeStream$1, Fixed, NumberT, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        DecodeStream$1 = $3939d1de148b5202$var$DecodeStream;
        NumberT = function() {
            function NumberT(type, endian) {
                this.type = type;
                this.endian = endian != null ? endian : 'BE';
                this.fn = this.type;
                if (this.type[this.type.length - 1] !== '8') this.fn += this.endian;
            }
            NumberT.prototype.size = function() {
                return DecodeStream$1.TYPES[this.type];
            };
            NumberT.prototype.decode = function(stream) {
                return stream['read' + this.fn]();
            };
            NumberT.prototype.encode = function(stream, val) {
                return stream['write' + this.fn](val);
            };
            return NumberT;
        }();
        exports.Number = NumberT;
        exports.uint8 = new NumberT('UInt8');
        exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');
        exports.uint16le = new NumberT('UInt16', 'LE');
        exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');
        exports.uint24le = new NumberT('UInt24', 'LE');
        exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');
        exports.uint32le = new NumberT('UInt32', 'LE');
        exports.int8 = new NumberT('Int8');
        exports.int16be = exports.int16 = new NumberT('Int16', 'BE');
        exports.int16le = new NumberT('Int16', 'LE');
        exports.int24be = exports.int24 = new NumberT('Int24', 'BE');
        exports.int24le = new NumberT('Int24', 'LE');
        exports.int32be = exports.int32 = new NumberT('Int32', 'BE');
        exports.int32le = new NumberT('Int32', 'LE');
        exports.floatbe = exports["float"] = new NumberT('Float', 'BE');
        exports.floatle = new NumberT('Float', 'LE');
        exports.doublebe = exports["double"] = new NumberT('Double', 'BE');
        exports.doublele = new NumberT('Double', 'LE');
        Fixed = function(_super) {
            __extends(Fixed, _super);
            function Fixed(size, endian, fracBits) {
                if (fracBits == null) fracBits = size >> 1;
                Fixed.__super__.constructor.call(this, "Int" + size, endian);
                this._point = 1 << fracBits;
            }
            Fixed.prototype.decode = function(stream) {
                return Fixed.__super__.decode.call(this, stream) / this._point;
            };
            Fixed.prototype.encode = function(stream, val) {
                return Fixed.__super__.encode.call(this, stream, val * this._point | 0);
            };
            return Fixed;
        }(NumberT);
        exports.Fixed = Fixed;
        exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');
        exports.fixed16le = new Fixed(16, 'LE');
        exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');
        exports.fixed32le = new Fixed(32, 'LE');
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$_Number_1 = $3939d1de148b5202$var$_Number.Number;
var $3939d1de148b5202$var$_Number_2 = $3939d1de148b5202$var$_Number.uint8;
var $3939d1de148b5202$var$_Number_3 = $3939d1de148b5202$var$_Number.uint16be;
var $3939d1de148b5202$var$_Number_4 = $3939d1de148b5202$var$_Number.uint16;
var $3939d1de148b5202$var$_Number_5 = $3939d1de148b5202$var$_Number.uint16le;
var $3939d1de148b5202$var$_Number_6 = $3939d1de148b5202$var$_Number.uint24be;
var $3939d1de148b5202$var$_Number_7 = $3939d1de148b5202$var$_Number.uint24;
var $3939d1de148b5202$var$_Number_8 = $3939d1de148b5202$var$_Number.uint24le;
var $3939d1de148b5202$var$_Number_9 = $3939d1de148b5202$var$_Number.uint32be;
var $3939d1de148b5202$var$_Number_10 = $3939d1de148b5202$var$_Number.uint32;
var $3939d1de148b5202$var$_Number_11 = $3939d1de148b5202$var$_Number.uint32le;
var $3939d1de148b5202$var$_Number_12 = $3939d1de148b5202$var$_Number.int8;
var $3939d1de148b5202$var$_Number_13 = $3939d1de148b5202$var$_Number.int16be;
var $3939d1de148b5202$var$_Number_14 = $3939d1de148b5202$var$_Number.int16;
var $3939d1de148b5202$var$_Number_15 = $3939d1de148b5202$var$_Number.int16le;
var $3939d1de148b5202$var$_Number_16 = $3939d1de148b5202$var$_Number.int24be;
var $3939d1de148b5202$var$_Number_17 = $3939d1de148b5202$var$_Number.int24;
var $3939d1de148b5202$var$_Number_18 = $3939d1de148b5202$var$_Number.int24le;
var $3939d1de148b5202$var$_Number_19 = $3939d1de148b5202$var$_Number.int32be;
var $3939d1de148b5202$var$_Number_20 = $3939d1de148b5202$var$_Number.int32;
var $3939d1de148b5202$var$_Number_21 = $3939d1de148b5202$var$_Number.int32le;
var $3939d1de148b5202$var$_Number_22 = $3939d1de148b5202$var$_Number.floatbe;
var $3939d1de148b5202$var$_Number_23 = $3939d1de148b5202$var$_Number.floatle;
var $3939d1de148b5202$var$_Number_24 = $3939d1de148b5202$var$_Number.doublebe;
var $3939d1de148b5202$var$_Number_25 = $3939d1de148b5202$var$_Number.doublele;
var $3939d1de148b5202$var$_Number_26 = $3939d1de148b5202$var$_Number.Fixed;
var $3939d1de148b5202$var$_Number_27 = $3939d1de148b5202$var$_Number.fixed16be;
var $3939d1de148b5202$var$_Number_28 = $3939d1de148b5202$var$_Number.fixed16;
var $3939d1de148b5202$var$_Number_29 = $3939d1de148b5202$var$_Number.fixed16le;
var $3939d1de148b5202$var$_Number_30 = $3939d1de148b5202$var$_Number.fixed32be;
var $3939d1de148b5202$var$_Number_31 = $3939d1de148b5202$var$_Number.fixed32;
var $3939d1de148b5202$var$_Number_32 = $3939d1de148b5202$var$_Number.fixed32le;
var $3939d1de148b5202$var$utils = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var NumberT, PropertyDescriptor;
        NumberT = $3939d1de148b5202$var$_Number.Number;
        exports.resolveLength = function(length, stream, parent) {
            var res;
            if (typeof length === 'number') res = length;
            else if (typeof length === 'function') res = length.call(parent, parent);
            else if (parent && typeof length === 'string') res = parent[length];
            else if (stream && length instanceof NumberT) res = length.decode(stream);
            if (isNaN(res)) throw new Error('Not a fixed size');
            return res;
        };
        PropertyDescriptor = function() {
            function PropertyDescriptor(opts) {
                var key, val;
                if (opts == null) opts = {};
                this.enumerable = true;
                this.configurable = true;
                for(key in opts){
                    val = opts[key];
                    this[key] = val;
                }
            }
            return PropertyDescriptor;
        }();
        exports.PropertyDescriptor = PropertyDescriptor;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$utils_1 = $3939d1de148b5202$var$utils.resolveLength;
var $3939d1de148b5202$var$utils_2 = $3939d1de148b5202$var$utils.PropertyDescriptor;
var $3939d1de148b5202$var$_Array = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var ArrayT, NumberT, utils$1;
        NumberT = $3939d1de148b5202$var$_Number.Number;
        utils$1 = $3939d1de148b5202$var$utils;
        ArrayT = function() {
            function ArrayT(type, length, lengthType) {
                this.type = type;
                this.length = length;
                this.lengthType = lengthType != null ? lengthType : 'count';
            }
            ArrayT.prototype.decode = function(stream, parent) {
                var ctx, i, length, pos, res, target, _i;
                pos = stream.pos;
                res = [];
                ctx = parent;
                if (this.length != null) length = utils$1.resolveLength(this.length, stream, parent);
                if (this.length instanceof NumberT) {
                    Object.defineProperties(res, {
                        parent: {
                            value: parent
                        },
                        _startOffset: {
                            value: pos
                        },
                        _currentOffset: {
                            value: 0,
                            writable: true
                        },
                        _length: {
                            value: length
                        }
                    });
                    ctx = res;
                }
                if (length == null || this.lengthType === 'bytes') {
                    target = length != null ? stream.pos + length : (parent != null ? parent._length : void 0) ? parent._startOffset + parent._length : stream.length;
                    while(stream.pos < target)res.push(this.type.decode(stream, ctx));
                } else for(i = _i = 0; _i < length; i = _i += 1)res.push(this.type.decode(stream, ctx));
                return res;
            };
            ArrayT.prototype.size = function(array, ctx) {
                var item, size, _i, _len;
                if (!array) return this.type.size(null, ctx) * utils$1.resolveLength(this.length, null, ctx);
                size = 0;
                if (this.length instanceof NumberT) {
                    size += this.length.size();
                    ctx = {
                        parent: ctx
                    };
                }
                for(_i = 0, _len = array.length; _i < _len; _i++){
                    item = array[_i];
                    size += this.type.size(item, ctx);
                }
                return size;
            };
            ArrayT.prototype.encode = function(stream, array, parent) {
                var ctx, i, item, ptr, _i, _len;
                ctx = parent;
                if (this.length instanceof NumberT) {
                    ctx = {
                        pointers: [],
                        startOffset: stream.pos,
                        parent: parent
                    };
                    ctx.pointerOffset = stream.pos + this.size(array, ctx);
                    this.length.encode(stream, array.length);
                }
                for(_i = 0, _len = array.length; _i < _len; _i++){
                    item = array[_i];
                    this.type.encode(stream, item, ctx);
                }
                if (this.length instanceof NumberT) {
                    i = 0;
                    while(i < ctx.pointers.length){
                        ptr = ctx.pointers[i++];
                        ptr.type.encode(stream, ptr.val);
                    }
                }
            };
            return ArrayT;
        }();
        module.exports = ArrayT;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$LazyArray = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var ArrayT, LazyArray, LazyArrayT, NumberT, inspect, utils$1, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        ArrayT = $3939d1de148b5202$var$_Array;
        NumberT = $3939d1de148b5202$var$_Number.Number;
        utils$1 = $3939d1de148b5202$var$utils;
        inspect = $3939d1de148b5202$var$require$$3.inspect;
        LazyArrayT = function(_super) {
            __extends(LazyArrayT, _super);
            function LazyArrayT() {
                return LazyArrayT.__super__.constructor.apply(this, arguments);
            }
            LazyArrayT.prototype.decode = function(stream, parent) {
                var length, pos, res;
                pos = stream.pos;
                length = utils$1.resolveLength(this.length, stream, parent);
                if (this.length instanceof NumberT) parent = {
                    parent: parent,
                    _startOffset: pos,
                    _currentOffset: 0,
                    _length: length
                };
                res = new LazyArray(this.type, length, stream, parent);
                stream.pos += length * this.type.size(null, parent);
                return res;
            };
            LazyArrayT.prototype.size = function(val, ctx) {
                if (val instanceof LazyArray) val = val.toArray();
                return LazyArrayT.__super__.size.call(this, val, ctx);
            };
            LazyArrayT.prototype.encode = function(stream, val, ctx) {
                if (val instanceof LazyArray) val = val.toArray();
                return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
            };
            return LazyArrayT;
        }(ArrayT);
        LazyArray = function() {
            function LazyArray(type, length, stream, ctx) {
                this.type = type;
                this.length = length;
                this.stream = stream;
                this.ctx = ctx;
                this.base = this.stream.pos;
                this.items = [];
            }
            LazyArray.prototype.get = function(index) {
                var pos;
                if (index < 0 || index >= this.length) return void 0;
                if (this.items[index] == null) {
                    pos = this.stream.pos;
                    this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
                    this.items[index] = this.type.decode(this.stream, this.ctx);
                    this.stream.pos = pos;
                }
                return this.items[index];
            };
            LazyArray.prototype.toArray = function() {
                var i, _i, _ref, _results;
                _results = [];
                for(i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1)_results.push(this.get(i));
                return _results;
            };
            LazyArray.prototype.inspect = function() {
                return inspect(this.toArray());
            };
            return LazyArray;
        }();
        module.exports = LazyArrayT;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Bitfield = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Bitfield;
        Bitfield = function() {
            function Bitfield(type, flags) {
                this.type = type;
                this.flags = flags != null ? flags : [];
            }
            Bitfield.prototype.decode = function(stream) {
                var flag, i, res, val, _i, _len, _ref;
                val = this.type.decode(stream);
                res = {};
                _ref = this.flags;
                for(i = _i = 0, _len = _ref.length; _i < _len; i = ++_i){
                    flag = _ref[i];
                    if (flag != null) res[flag] = !!(val & 1 << i);
                }
                return res;
            };
            Bitfield.prototype.size = function() {
                return this.type.size();
            };
            Bitfield.prototype.encode = function(stream, keys) {
                var flag, i, val, _i, _len, _ref;
                val = 0;
                _ref = this.flags;
                for(i = _i = 0, _len = _ref.length; _i < _len; i = ++_i){
                    flag = _ref[i];
                    if (flag != null) {
                        if (keys[flag]) val |= 1 << i;
                    }
                }
                return this.type.encode(stream, val);
            };
            return Bitfield;
        }();
        module.exports = Bitfield;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$_Boolean = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var BooleanT;
        BooleanT = function() {
            function BooleanT(type) {
                this.type = type;
            }
            BooleanT.prototype.decode = function(stream, parent) {
                return !!this.type.decode(stream, parent);
            };
            BooleanT.prototype.size = function(val, parent) {
                return this.type.size(val, parent);
            };
            BooleanT.prototype.encode = function(stream, val, parent) {
                return this.type.encode(stream, +val, parent);
            };
            return BooleanT;
        }();
        module.exports = BooleanT;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Buffer$8 = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var BufferT, NumberT, utils$1;
        utils$1 = $3939d1de148b5202$var$utils;
        NumberT = $3939d1de148b5202$var$_Number.Number;
        BufferT = function() {
            function BufferT(length) {
                this.length = length;
            }
            BufferT.prototype.decode = function(stream, parent) {
                var length;
                length = utils$1.resolveLength(this.length, stream, parent);
                return stream.readBuffer(length);
            };
            BufferT.prototype.size = function(val, parent) {
                if (!val) return utils$1.resolveLength(this.length, null, parent);
                return val.length;
            };
            BufferT.prototype.encode = function(stream, buf, parent) {
                if (this.length instanceof NumberT) this.length.encode(stream, buf.length);
                return stream.writeBuffer(buf);
            };
            return BufferT;
        }();
        module.exports = BufferT;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Enum = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Enum;
        Enum = function() {
            function Enum(type, options) {
                this.type = type;
                this.options = options != null ? options : [];
            }
            Enum.prototype.decode = function(stream) {
                var index;
                index = this.type.decode(stream);
                return this.options[index] || index;
            };
            Enum.prototype.size = function() {
                return this.type.size();
            };
            Enum.prototype.encode = function(stream, val) {
                var index;
                index = this.options.indexOf(val);
                if (index === -1) throw new Error("Unknown option in enum: " + val);
                return this.type.encode(stream, index);
            };
            return Enum;
        }();
        module.exports = Enum;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Optional = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Optional;
        Optional = function() {
            function Optional(type, condition) {
                this.type = type;
                this.condition = condition != null ? condition : true;
            }
            Optional.prototype.decode = function(stream, parent) {
                var condition;
                condition = this.condition;
                if (typeof condition === 'function') condition = condition.call(parent, parent);
                if (condition) return this.type.decode(stream, parent);
            };
            Optional.prototype.size = function(val, parent) {
                var condition;
                condition = this.condition;
                if (typeof condition === 'function') condition = condition.call(parent, parent);
                if (condition) return this.type.size(val, parent);
                else return 0;
            };
            Optional.prototype.encode = function(stream, val, parent) {
                var condition;
                condition = this.condition;
                if (typeof condition === 'function') condition = condition.call(parent, parent);
                if (condition) return this.type.encode(stream, val, parent);
            };
            return Optional;
        }();
        module.exports = Optional;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Reserved = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Reserved, utils$1;
        utils$1 = $3939d1de148b5202$var$utils;
        Reserved = function() {
            function Reserved(type, count) {
                this.type = type;
                this.count = count != null ? count : 1;
            }
            Reserved.prototype.decode = function(stream, parent) {
                stream.pos += this.size(null, parent);
                return void 0;
            };
            Reserved.prototype.size = function(data, parent) {
                var count;
                count = utils$1.resolveLength(this.count, null, parent);
                return this.type.size() * count;
            };
            Reserved.prototype.encode = function(stream, val, parent) {
                return stream.fill(0, this.size(val, parent));
            };
            return Reserved;
        }();
        module.exports = Reserved;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$_String = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var NumberT, StringT, utils$1;
        NumberT = $3939d1de148b5202$var$_Number.Number;
        utils$1 = $3939d1de148b5202$var$utils;
        StringT = function() {
            function StringT(length, encoding) {
                this.length = length;
                this.encoding = encoding != null ? encoding : 'ascii';
            }
            StringT.prototype.decode = function(stream, parent) {
                var buffer, encoding, length, pos, string;
                length = (function() {
                    if (this.length != null) return utils$1.resolveLength(this.length, stream, parent);
                    else {
                        buffer = stream.buffer, length = stream.length, pos = stream.pos;
                        while(pos < length && buffer[pos] !== 0x00)++pos;
                        return pos - stream.pos;
                    }
                }).call(this);
                encoding = this.encoding;
                if (typeof encoding === 'function') encoding = encoding.call(parent, parent) || 'ascii';
                string = stream.readString(length, encoding);
                if (this.length == null && stream.pos < stream.length) stream.pos++;
                return string;
            };
            StringT.prototype.size = function(val, parent) {
                var encoding, size;
                if (!val) return utils$1.resolveLength(this.length, null, parent);
                encoding = this.encoding;
                if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
                if (encoding === 'utf16be') encoding = 'utf16le';
                size = $3939d1de148b5202$var$buffer_1.byteLength(val, encoding);
                if (this.length instanceof NumberT) size += this.length.size();
                if (this.length == null) size++;
                return size;
            };
            StringT.prototype.encode = function(stream, val, parent) {
                var encoding;
                encoding = this.encoding;
                if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
                if (this.length instanceof NumberT) this.length.encode(stream, $3939d1de148b5202$var$buffer_1.byteLength(val, encoding));
                stream.writeString(val, encoding);
                if (this.length == null) return stream.writeUInt8(0x00);
            };
            return StringT;
        }();
        module.exports = StringT;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Struct = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Struct, utils$1;
        utils$1 = $3939d1de148b5202$var$utils;
        Struct = function() {
            function Struct(fields) {
                this.fields = fields != null ? fields : {};
            }
            Struct.prototype.decode = function(stream, parent, length) {
                var res, _ref;
                if (length == null) length = 0;
                res = this._setup(stream, parent, length);
                this._parseFields(stream, res, this.fields);
                if ((_ref = this.process) != null) _ref.call(res, stream);
                return res;
            };
            Struct.prototype._setup = function(stream, parent, length) {
                var res;
                res = {};
                Object.defineProperties(res, {
                    parent: {
                        value: parent
                    },
                    _startOffset: {
                        value: stream.pos
                    },
                    _currentOffset: {
                        value: 0,
                        writable: true
                    },
                    _length: {
                        value: length
                    }
                });
                return res;
            };
            Struct.prototype._parseFields = function(stream, res, fields) {
                var key, type, val;
                for(key in fields){
                    type = fields[key];
                    if (typeof type === 'function') val = type.call(res, res);
                    else val = type.decode(stream, res);
                    if (val !== void 0) {
                        if (val instanceof utils$1.PropertyDescriptor) Object.defineProperty(res, key, val);
                        else res[key] = val;
                    }
                    res._currentOffset = stream.pos - res._startOffset;
                }
            };
            Struct.prototype.size = function(val, parent, includePointers) {
                var ctx, key, size, type, _ref;
                if (val == null) val = {};
                if (includePointers == null) includePointers = true;
                ctx = {
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                size = 0;
                _ref = this.fields;
                for(key in _ref){
                    type = _ref[key];
                    if (type.size != null) size += type.size(val[key], ctx);
                }
                if (includePointers) size += ctx.pointerSize;
                return size;
            };
            Struct.prototype.encode = function(stream, val, parent) {
                var ctx, i, key, ptr, type, _ref, _ref1;
                if ((_ref = this.preEncode) != null) _ref.call(val, stream);
                ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                _ref1 = this.fields;
                for(key in _ref1){
                    type = _ref1[key];
                    if (type.encode != null) type.encode(stream, val[key], ctx);
                }
                i = 0;
                while(i < ctx.pointers.length){
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val, ptr.parent);
                }
            };
            return Struct;
        }();
        module.exports = Struct;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$VersionedStruct = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Struct$1, VersionedStruct, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        Struct$1 = $3939d1de148b5202$var$Struct;
        VersionedStruct = function(_super) {
            __extends(VersionedStruct, _super);
            function VersionedStruct(type, versions) {
                this.type = type;
                this.versions = versions != null ? versions : {};
            }
            VersionedStruct.prototype.versionGetter = function(parent) {
                if (typeof this.type === 'string') return this.type.split('.').reduce(function(obj, prop) {
                    if (typeof obj !== 'undefined') return obj[prop];
                    else return void 0;
                }, parent);
            };
            VersionedStruct.prototype.versionSetter = function(parent, version) {
                if (typeof this.type === 'string') return this.type.split('.').reduce(function(obj, prop) {
                    return obj[prop] = version;
                }, parent);
            };
            VersionedStruct.prototype.decode = function(stream, parent, length) {
                var fields, res, _ref;
                if (length == null) length = 0;
                res = this._setup(stream, parent, length);
                if (typeof this.type === 'string') res.version = this.versionGetter(parent);
                else res.version = this.type.decode(stream);
                if (this.versions.header) this._parseFields(stream, res, this.versions.header);
                fields = this.versions[res.version];
                if (fields == null) throw new Error("Unknown version " + res.version);
                if (fields instanceof VersionedStruct) return fields.decode(stream, parent);
                this._parseFields(stream, res, fields);
                if ((_ref = this.process) != null) _ref.call(res, stream);
                return res;
            };
            VersionedStruct.prototype.size = function(val, parent, includePointers) {
                var ctx, fields, key, size, type, _ref;
                if (includePointers == null) includePointers = true;
                if (!val) throw new Error('Not a fixed size');
                ctx = {
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                size = 0;
                if (typeof this.type !== 'string') size += this.type.size(val.version, ctx);
                if (this.versions.header) {
                    _ref = this.versions.header;
                    for(key in _ref){
                        type = _ref[key];
                        if (type.size != null) size += type.size(val[key], ctx);
                    }
                }
                fields = this.versions[val.version];
                if (fields == null) throw new Error("Unknown version " + val.version);
                for(key in fields){
                    type = fields[key];
                    if (type.size != null) size += type.size(val[key], ctx);
                }
                if (includePointers) size += ctx.pointerSize;
                return size;
            };
            VersionedStruct.prototype.encode = function(stream, val, parent) {
                var ctx, fields, i, key, ptr, type, _ref, _ref1;
                if ((_ref = this.preEncode) != null) _ref.call(val, stream);
                ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                if (typeof this.type !== 'string') this.type.encode(stream, val.version);
                if (this.versions.header) {
                    _ref1 = this.versions.header;
                    for(key in _ref1){
                        type = _ref1[key];
                        if (type.encode != null) type.encode(stream, val[key], ctx);
                    }
                }
                fields = this.versions[val.version];
                for(key in fields){
                    type = fields[key];
                    if (type.encode != null) type.encode(stream, val[key], ctx);
                }
                i = 0;
                while(i < ctx.pointers.length){
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val, ptr.parent);
                }
            };
            return VersionedStruct;
        }(Struct$1);
        module.exports = VersionedStruct;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Pointer = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Pointer, VoidPointer, utils$1;
        utils$1 = $3939d1de148b5202$var$utils;
        Pointer = function() {
            function Pointer(offsetType, type, options) {
                var _base, _base1, _base2, _base3;
                this.offsetType = offsetType;
                this.type = type;
                this.options = options != null ? options : {};
                if (this.type === 'void') this.type = null;
                if ((_base = this.options).type == null) _base.type = 'local';
                if ((_base1 = this.options).allowNull == null) _base1.allowNull = true;
                if ((_base2 = this.options).nullValue == null) _base2.nullValue = 0;
                if ((_base3 = this.options).lazy == null) _base3.lazy = false;
            }
            Pointer.prototype.relativeToGetter = function(ctx) {
                return this.options.relativeTo.split('.').reduce(function(obj, prop) {
                    return obj[prop];
                }, ctx);
            };
            Pointer.prototype.decode = function(stream, ctx) {
                var c, decodeValue, offset, ptr, relative, val;
                offset = this.offsetType.decode(stream, ctx);
                if (offset === this.options.nullValue && this.options.allowNull) return null;
                relative = (function() {
                    switch(this.options.type){
                        case 'local':
                            return ctx._startOffset;
                        case 'immediate':
                            return stream.pos - this.offsetType.size();
                        case 'parent':
                            return ctx.parent._startOffset;
                        default:
                            c = ctx;
                            while(c.parent)c = c.parent;
                            return c._startOffset || 0;
                    }
                }).call(this);
                if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
                ptr = offset + relative;
                if (this.type != null) {
                    val = null;
                    decodeValue = function(_this) {
                        return function() {
                            var pos;
                            if (val != null) return val;
                            pos = stream.pos;
                            stream.pos = ptr;
                            val = _this.type.decode(stream, ctx);
                            stream.pos = pos;
                            return val;
                        };
                    }(this);
                    if (this.options.lazy) return new utils$1.PropertyDescriptor({
                        get: decodeValue
                    });
                    return decodeValue();
                } else return ptr;
            };
            Pointer.prototype.size = function(val, ctx) {
                var parent, type;
                parent = ctx;
                switch(this.options.type){
                    case 'local':
                    case 'immediate':
                        break;
                    case 'parent':
                        ctx = ctx.parent;
                        break;
                    default:
                        while(ctx.parent)ctx = ctx.parent;
                }
                type = this.type;
                if (type == null) {
                    if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                    type = val.type;
                    val = val.value;
                }
                if (val && ctx) ctx.pointerSize += type.size(val, parent);
                return this.offsetType.size();
            };
            Pointer.prototype.encode = function(stream, val, ctx) {
                var parent, relative, type;
                parent = ctx;
                if (val == null) {
                    this.offsetType.encode(stream, this.options.nullValue);
                    return;
                }
                switch(this.options.type){
                    case 'local':
                        relative = ctx.startOffset;
                        break;
                    case 'immediate':
                        relative = stream.pos + this.offsetType.size(val, parent);
                        break;
                    case 'parent':
                        ctx = ctx.parent;
                        relative = ctx.startOffset;
                        break;
                    default:
                        relative = 0;
                        while(ctx.parent)ctx = ctx.parent;
                }
                if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
                this.offsetType.encode(stream, ctx.pointerOffset - relative);
                type = this.type;
                if (type == null) {
                    if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                    type = val.type;
                    val = val.value;
                }
                ctx.pointers.push({
                    type: type,
                    val: val,
                    parent: parent
                });
                return ctx.pointerOffset += type.size(val, parent);
            };
            return Pointer;
        }();
        VoidPointer = function() {
            function VoidPointer(type, value) {
                this.type = type;
                this.value = value;
            }
            return VoidPointer;
        }();
        exports.Pointer = Pointer;
        exports.VoidPointer = VoidPointer;
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$Pointer_1 = $3939d1de148b5202$var$Pointer.Pointer;
var $3939d1de148b5202$var$Pointer_2 = $3939d1de148b5202$var$Pointer.VoidPointer;
var $3939d1de148b5202$var$restructure = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var key, val, _ref, _ref1;
        exports.EncodeStream = $3939d1de148b5202$var$EncodeStream;
        exports.DecodeStream = $3939d1de148b5202$var$DecodeStream;
        exports.Array = $3939d1de148b5202$var$_Array;
        exports.LazyArray = $3939d1de148b5202$var$LazyArray;
        exports.Bitfield = $3939d1de148b5202$var$Bitfield;
        exports.Boolean = $3939d1de148b5202$var$_Boolean;
        exports.Buffer = $3939d1de148b5202$var$Buffer$8;
        exports.Enum = $3939d1de148b5202$var$Enum;
        exports.Optional = $3939d1de148b5202$var$Optional;
        exports.Reserved = $3939d1de148b5202$var$Reserved;
        exports.String = $3939d1de148b5202$var$_String;
        exports.Struct = $3939d1de148b5202$var$Struct;
        exports.VersionedStruct = $3939d1de148b5202$var$VersionedStruct;
        _ref = $3939d1de148b5202$var$_Number;
        for(key in _ref){
            val = _ref[key];
            exports[key] = val;
        }
        _ref1 = $3939d1de148b5202$var$Pointer;
        for(key in _ref1){
            val = _ref1[key];
            exports[key] = val;
        }
    }).call($3939d1de148b5202$var$commonjsGlobal);
});
var $3939d1de148b5202$var$restructure_1 = $3939d1de148b5202$var$restructure.EncodeStream;
var $3939d1de148b5202$var$restructure_2 = $3939d1de148b5202$var$restructure.DecodeStream;
var $3939d1de148b5202$var$restructure_3 = $3939d1de148b5202$var$restructure.Array;
var $3939d1de148b5202$var$restructure_4 = $3939d1de148b5202$var$restructure.LazyArray;
var $3939d1de148b5202$var$restructure_5 = $3939d1de148b5202$var$restructure.Bitfield;
var $3939d1de148b5202$var$restructure_6 = $3939d1de148b5202$var$restructure.Boolean;
var $3939d1de148b5202$var$restructure_7 = $3939d1de148b5202$var$restructure.Buffer;
var $3939d1de148b5202$var$restructure_8 = $3939d1de148b5202$var$restructure.Enum;
var $3939d1de148b5202$var$restructure_9 = $3939d1de148b5202$var$restructure.Optional;
var $3939d1de148b5202$var$restructure_10 = $3939d1de148b5202$var$restructure.Reserved;
var $3939d1de148b5202$var$restructure_11 = $3939d1de148b5202$var$restructure.String;
var $3939d1de148b5202$var$restructure_12 = $3939d1de148b5202$var$restructure.Struct;
var $3939d1de148b5202$var$restructure_13 = $3939d1de148b5202$var$restructure.VersionedStruct;
var $3939d1de148b5202$var$formats = [];
var $3939d1de148b5202$var$fontkit = {
    logErrors: false,
    registerFormat: function registerFormat(format) {
        $3939d1de148b5202$var$formats.push(format);
    },
    create: function create(uint8ArrayFontData, postscriptName) {
        var buffer = new $3939d1de148b5202$var$buffer_1.from(uint8ArrayFontData);
        for(var i = 0; i < $3939d1de148b5202$var$formats.length; i++){
            var format = $3939d1de148b5202$var$formats[i];
            if (format.probe(buffer)) {
                var font = new format(new $3939d1de148b5202$var$restructure.DecodeStream(buffer));
                if (postscriptName) return font.getFont(postscriptName);
                return font;
            }
        }
        throw new Error('Unknown font format');
    }
};
/**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */ function $3939d1de148b5202$var$cache(target, key, descriptor) {
    if (descriptor.get) {
        var get = descriptor.get;
        descriptor.get = function() {
            var value = get.call(this);
            Object.defineProperty(this, key, {
                value: value
            });
            return value;
        };
    } else if (typeof descriptor.value === 'function') {
        var fn = descriptor.value;
        return {
            get: function get() {
                var cache = new Map();
                function memoized() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var key = args.length > 0 ? args[0] : 'value';
                    if (cache.has(key)) return cache.get(key);
                    var result = fn.apply(this, args);
                    cache.set(key, result);
                    return result;
                }
                Object.defineProperty(this, key, {
                    value: memoized
                });
                return memoized;
            }
        };
    }
}
var $3939d1de148b5202$var$SubHeader = new $3939d1de148b5202$var$restructure.Struct({
    firstCode: $3939d1de148b5202$var$restructure.uint16,
    entryCount: $3939d1de148b5202$var$restructure.uint16,
    idDelta: $3939d1de148b5202$var$restructure.int16,
    idRangeOffset: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$CmapGroup = new $3939d1de148b5202$var$restructure.Struct({
    startCharCode: $3939d1de148b5202$var$restructure.uint32,
    endCharCode: $3939d1de148b5202$var$restructure.uint32,
    glyphID: $3939d1de148b5202$var$restructure.uint32
});
var $3939d1de148b5202$var$UnicodeValueRange = new $3939d1de148b5202$var$restructure.Struct({
    startUnicodeValue: $3939d1de148b5202$var$restructure.uint24,
    additionalCount: $3939d1de148b5202$var$restructure.uint8
});
var $3939d1de148b5202$var$UVSMapping = new $3939d1de148b5202$var$restructure.Struct({
    unicodeValue: $3939d1de148b5202$var$restructure.uint24,
    glyphID: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$DefaultUVS = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$UnicodeValueRange, $3939d1de148b5202$var$restructure.uint32);
var $3939d1de148b5202$var$NonDefaultUVS = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$UVSMapping, $3939d1de148b5202$var$restructure.uint32);
var $3939d1de148b5202$var$VarSelectorRecord = new $3939d1de148b5202$var$restructure.Struct({
    varSelector: $3939d1de148b5202$var$restructure.uint24,
    defaultUVS: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$DefaultUVS, {
        type: 'parent'
    }),
    nonDefaultUVS: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$NonDefaultUVS, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$CmapSubtable = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    0: {
        // Byte encoding
        length: $3939d1de148b5202$var$restructure.uint16,
        // Total table length in bytes (set to 262 for format 0)
        language: $3939d1de148b5202$var$restructure.uint16,
        // Language code for this encoding subtable, or zero if language-independent
        codeMap: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint8, 256)
    },
    2: {
        // High-byte mapping (CJK)
        length: $3939d1de148b5202$var$restructure.uint16,
        language: $3939d1de148b5202$var$restructure.uint16,
        subHeaderKeys: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 256),
        subHeaderCount: function subHeaderCount(t) {
            return Math.max.apply(Math, t.subHeaderKeys);
        },
        subHeaders: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$SubHeader, 'subHeaderCount'),
        glyphIndexArray: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, 'subHeaderCount')
    },
    4: {
        // Segment mapping to delta values
        length: $3939d1de148b5202$var$restructure.uint16,
        // Total table length in bytes
        language: $3939d1de148b5202$var$restructure.uint16,
        // Language code
        segCountX2: $3939d1de148b5202$var$restructure.uint16,
        segCount: function segCount(t) {
            return t.segCountX2 >> 1;
        },
        searchRange: $3939d1de148b5202$var$restructure.uint16,
        entrySelector: $3939d1de148b5202$var$restructure.uint16,
        rangeShift: $3939d1de148b5202$var$restructure.uint16,
        endCode: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, 'segCount'),
        reservedPad: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
        // This value should be zero
        startCode: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, 'segCount'),
        idDelta: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.int16, 'segCount'),
        idRangeOffset: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, 'segCount'),
        glyphIndexArray: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, function(t) {
            return (t.length - t._currentOffset) / 2;
        })
    },
    6: {
        // Trimmed table
        length: $3939d1de148b5202$var$restructure.uint16,
        language: $3939d1de148b5202$var$restructure.uint16,
        firstCode: $3939d1de148b5202$var$restructure.uint16,
        entryCount: $3939d1de148b5202$var$restructure.uint16,
        glyphIndices: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, 'entryCount')
    },
    8: {
        // mixed 16-bit and 32-bit coverage
        reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
        length: $3939d1de148b5202$var$restructure.uint32,
        language: $3939d1de148b5202$var$restructure.uint16,
        is32: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint8, 8192),
        nGroups: $3939d1de148b5202$var$restructure.uint32,
        groups: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$CmapGroup, 'nGroups')
    },
    10: {
        // Trimmed Array
        reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
        length: $3939d1de148b5202$var$restructure.uint32,
        language: $3939d1de148b5202$var$restructure.uint32,
        firstCode: $3939d1de148b5202$var$restructure.uint32,
        entryCount: $3939d1de148b5202$var$restructure.uint32,
        glyphIndices: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, 'numChars')
    },
    12: {
        // Segmented coverage
        reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
        length: $3939d1de148b5202$var$restructure.uint32,
        language: $3939d1de148b5202$var$restructure.uint32,
        nGroups: $3939d1de148b5202$var$restructure.uint32,
        groups: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$CmapGroup, 'nGroups')
    },
    13: {
        // Many-to-one range mappings (same as 12 except for group.startGlyphID)
        reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
        length: $3939d1de148b5202$var$restructure.uint32,
        language: $3939d1de148b5202$var$restructure.uint32,
        nGroups: $3939d1de148b5202$var$restructure.uint32,
        groups: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$CmapGroup, 'nGroups')
    },
    14: {
        // Unicode Variation Sequences
        length: $3939d1de148b5202$var$restructure.uint32,
        numRecords: $3939d1de148b5202$var$restructure.uint32,
        varSelectors: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$VarSelectorRecord, 'numRecords')
    }
});
var $3939d1de148b5202$var$CmapEntry = new $3939d1de148b5202$var$restructure.Struct({
    platformID: $3939d1de148b5202$var$restructure.uint16,
    // Platform identifier
    encodingID: $3939d1de148b5202$var$restructure.uint16,
    // Platform-specific encoding identifier
    table: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$CmapSubtable, {
        type: 'parent',
        lazy: true
    })
}); // character to glyph mapping
var $3939d1de148b5202$var$cmap = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    numSubtables: $3939d1de148b5202$var$restructure.uint16,
    tables: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$CmapEntry, 'numSubtables')
});
var $3939d1de148b5202$var$head = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.int32,
    // 0x00010000 (version 1.0)
    revision: $3939d1de148b5202$var$restructure.int32,
    // set by font manufacturer
    checkSumAdjustment: $3939d1de148b5202$var$restructure.uint32,
    magicNumber: $3939d1de148b5202$var$restructure.uint32,
    // set to 0x5F0F3CF5
    flags: $3939d1de148b5202$var$restructure.uint16,
    unitsPerEm: $3939d1de148b5202$var$restructure.uint16,
    // range from 64 to 16384
    created: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int32, 2),
    modified: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int32, 2),
    xMin: $3939d1de148b5202$var$restructure.int16,
    // for all glyph bounding boxes
    yMin: $3939d1de148b5202$var$restructure.int16,
    // for all glyph bounding boxes
    xMax: $3939d1de148b5202$var$restructure.int16,
    // for all glyph bounding boxes
    yMax: $3939d1de148b5202$var$restructure.int16,
    // for all glyph bounding boxes
    macStyle: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint16, [
        'bold',
        'italic',
        'underline',
        'outline',
        'shadow',
        'condensed',
        'extended'
    ]),
    lowestRecPPEM: $3939d1de148b5202$var$restructure.uint16,
    // smallest readable size in pixels
    fontDirectionHint: $3939d1de148b5202$var$restructure.int16,
    indexToLocFormat: $3939d1de148b5202$var$restructure.int16,
    // 0 for short offsets, 1 for long
    glyphDataFormat: $3939d1de148b5202$var$restructure.int16 // 0 for current format
});
var $3939d1de148b5202$var$hhea = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.int32,
    ascent: $3939d1de148b5202$var$restructure.int16,
    // Distance from baseline of highest ascender
    descent: $3939d1de148b5202$var$restructure.int16,
    // Distance from baseline of lowest descender
    lineGap: $3939d1de148b5202$var$restructure.int16,
    // Typographic line gap
    advanceWidthMax: $3939d1de148b5202$var$restructure.uint16,
    // Maximum advance width value in 'hmtx' table
    minLeftSideBearing: $3939d1de148b5202$var$restructure.int16,
    // Maximum advance width value in 'hmtx' table
    minRightSideBearing: $3939d1de148b5202$var$restructure.int16,
    // Minimum right sidebearing value
    xMaxExtent: $3939d1de148b5202$var$restructure.int16,
    caretSlopeRise: $3939d1de148b5202$var$restructure.int16,
    // Used to calculate the slope of the cursor (rise/run); 1 for vertical
    caretSlopeRun: $3939d1de148b5202$var$restructure.int16,
    // 0 for vertical
    caretOffset: $3939d1de148b5202$var$restructure.int16,
    // Set to 0 for non-slanted fonts
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.int16, 4),
    metricDataFormat: $3939d1de148b5202$var$restructure.int16,
    // 0 for current format
    numberOfMetrics: $3939d1de148b5202$var$restructure.uint16 // Number of advance widths in 'hmtx' table
});
var $3939d1de148b5202$var$HmtxEntry = new $3939d1de148b5202$var$restructure.Struct({
    advance: $3939d1de148b5202$var$restructure.uint16,
    bearing: $3939d1de148b5202$var$restructure.int16
});
var $3939d1de148b5202$var$hmtx = new $3939d1de148b5202$var$restructure.Struct({
    metrics: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$HmtxEntry, function(t) {
        return t.parent.hhea.numberOfMetrics;
    }),
    bearings: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.int16, function(t) {
        return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
    })
});
var $3939d1de148b5202$var$maxp = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.int32,
    numGlyphs: $3939d1de148b5202$var$restructure.uint16,
    // The number of glyphs in the font
    maxPoints: $3939d1de148b5202$var$restructure.uint16,
    // Maximum points in a non-composite glyph
    maxContours: $3939d1de148b5202$var$restructure.uint16,
    // Maximum contours in a non-composite glyph
    maxComponentPoints: $3939d1de148b5202$var$restructure.uint16,
    // Maximum points in a composite glyph
    maxComponentContours: $3939d1de148b5202$var$restructure.uint16,
    // Maximum contours in a composite glyph
    maxZones: $3939d1de148b5202$var$restructure.uint16,
    // 1 if instructions do not use the twilight zone, 2 otherwise
    maxTwilightPoints: $3939d1de148b5202$var$restructure.uint16,
    // Maximum points used in Z0
    maxStorage: $3939d1de148b5202$var$restructure.uint16,
    // Number of Storage Area locations
    maxFunctionDefs: $3939d1de148b5202$var$restructure.uint16,
    // Number of FDEFs
    maxInstructionDefs: $3939d1de148b5202$var$restructure.uint16,
    // Number of IDEFs
    maxStackElements: $3939d1de148b5202$var$restructure.uint16,
    // Maximum stack depth
    maxSizeOfInstructions: $3939d1de148b5202$var$restructure.uint16,
    // Maximum byte count for glyph instructions
    maxComponentElements: $3939d1de148b5202$var$restructure.uint16,
    // Maximum number of components referenced at “top level” for any composite glyph
    maxComponentDepth: $3939d1de148b5202$var$restructure.uint16 // Maximum levels of recursion; 1 for simple components
});
/**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */ function $3939d1de148b5202$var$getEncoding(platformID, encodingID, languageID) {
    if (languageID === void 0) languageID = 0;
    if (platformID === 1 && $3939d1de148b5202$var$MAC_LANGUAGE_ENCODINGS[languageID]) return $3939d1de148b5202$var$MAC_LANGUAGE_ENCODINGS[languageID];
    return $3939d1de148b5202$var$ENCODINGS[platformID][encodingID];
} // Map of platform ids to encoding ids.
var $3939d1de148b5202$var$ENCODINGS = [
    [
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be'
    ],
    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
    // 0	Roman                 17	Malayalam
    // 1	Japanese	            18	Sinhalese
    // 2	Traditional Chinese	  19	Burmese
    // 3	Korean	              20	Khmer
    // 4	Arabic	              21	Thai
    // 5	Hebrew	              22	Laotian
    // 6	Greek	                23	Georgian
    // 7	Russian	              24	Armenian
    // 8	RSymbol	              25	Simplified Chinese
    // 9	Devanagari	          26	Tibetan
    // 10	Gurmukhi	            27	Mongolian
    // 11	Gujarati	            28	Geez
    // 12	Oriya	                29	Slavic
    // 13	Bengali	              30	Vietnamese
    // 14	Tamil	                31	Sindhi
    // 15	Telugu	              32	(Uninterpreted)
    // 16	Kannada
    [
        'macroman',
        'shift-jis',
        'big5',
        'euc-kr',
        'iso-8859-6',
        'iso-8859-8',
        'macgreek',
        'maccyrillic',
        'symbol',
        'Devanagari',
        'Gurmukhi',
        'Gujarati',
        'Oriya',
        'Bengali',
        'Tamil',
        'Telugu',
        'Kannada',
        'Malayalam',
        'Sinhalese',
        'Burmese',
        'Khmer',
        'macthai',
        'Laotian',
        'Georgian',
        'Armenian',
        'gb-2312-80',
        'Tibetan',
        'Mongolian',
        'Geez',
        'maccenteuro',
        'Vietnamese',
        'Sindhi'
    ],
    [
        'ascii'
    ],
    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
    [
        'symbol',
        'utf16be',
        'shift-jis',
        'gb18030',
        'big5',
        'wansung',
        'johab',
        null,
        null,
        null,
        'utf16be'
    ]
]; // Overrides for Mac scripts by language id.
// See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var $3939d1de148b5202$var$MAC_LANGUAGE_ENCODINGS = {
    15: 'maciceland',
    17: 'macturkish',
    18: 'maccroatian',
    24: 'maccenteuro',
    25: 'maccenteuro',
    26: 'maccenteuro',
    27: 'maccenteuro',
    28: 'maccenteuro',
    30: 'maciceland',
    37: 'macromania',
    38: 'maccenteuro',
    39: 'maccenteuro',
    40: 'maccenteuro',
    143: 'macinuit',
    // Unsupported by iconv-lite
    146: 'macgaelic' // Unsupported by iconv-lite
}; // Map of platform ids to BCP-47 language codes.
var $3939d1de148b5202$var$LANGUAGES = [
    [],
    {
        // macintosh
        0: 'en',
        30: 'fo',
        60: 'ks',
        90: 'rw',
        1: 'fr',
        31: 'fa',
        61: 'ku',
        91: 'rn',
        2: 'de',
        32: 'ru',
        62: 'sd',
        92: 'ny',
        3: 'it',
        33: 'zh',
        63: 'bo',
        93: 'mg',
        4: 'nl',
        34: 'nl-BE',
        64: 'ne',
        94: 'eo',
        5: 'sv',
        35: 'ga',
        65: 'sa',
        128: 'cy',
        6: 'es',
        36: 'sq',
        66: 'mr',
        129: 'eu',
        7: 'da',
        37: 'ro',
        67: 'bn',
        130: 'ca',
        8: 'pt',
        38: 'cz',
        68: 'as',
        131: 'la',
        9: 'no',
        39: 'sk',
        69: 'gu',
        132: 'qu',
        10: 'he',
        40: 'si',
        70: 'pa',
        133: 'gn',
        11: 'ja',
        41: 'yi',
        71: 'or',
        134: 'ay',
        12: 'ar',
        42: 'sr',
        72: 'ml',
        135: 'tt',
        13: 'fi',
        43: 'mk',
        73: 'kn',
        136: 'ug',
        14: 'el',
        44: 'bg',
        74: 'ta',
        137: 'dz',
        15: 'is',
        45: 'uk',
        75: 'te',
        138: 'jv',
        16: 'mt',
        46: 'be',
        76: 'si',
        139: 'su',
        17: 'tr',
        47: 'uz',
        77: 'my',
        140: 'gl',
        18: 'hr',
        48: 'kk',
        78: 'km',
        141: 'af',
        19: 'zh-Hant',
        49: 'az-Cyrl',
        79: 'lo',
        142: 'br',
        20: 'ur',
        50: 'az-Arab',
        80: 'vi',
        143: 'iu',
        21: 'hi',
        51: 'hy',
        81: 'id',
        144: 'gd',
        22: 'th',
        52: 'ka',
        82: 'tl',
        145: 'gv',
        23: 'ko',
        53: 'mo',
        83: 'ms',
        146: 'ga',
        24: 'lt',
        54: 'ky',
        84: 'ms-Arab',
        147: 'to',
        25: 'pl',
        55: 'tg',
        85: 'am',
        148: 'el-polyton',
        26: 'hu',
        56: 'tk',
        86: 'ti',
        149: 'kl',
        27: 'es',
        57: 'mn-CN',
        87: 'om',
        150: 'az',
        28: 'lv',
        58: 'mn',
        88: 'so',
        151: 'nn',
        29: 'se',
        59: 'ps',
        89: 'sw'
    },
    [],
    {
        // windows                                        
        0x0436: 'af',
        0x4009: 'en-IN',
        0x0487: 'rw',
        0x0432: 'tn',
        0x041C: 'sq',
        0x1809: 'en-IE',
        0x0441: 'sw',
        0x045B: 'si',
        0x0484: 'gsw',
        0x2009: 'en-JM',
        0x0457: 'kok',
        0x041B: 'sk',
        0x045E: 'am',
        0x4409: 'en-MY',
        0x0412: 'ko',
        0x0424: 'sl',
        0x1401: 'ar-DZ',
        0x1409: 'en-NZ',
        0x0440: 'ky',
        0x2C0A: 'es-AR',
        0x3C01: 'ar-BH',
        0x3409: 'en-PH',
        0x0454: 'lo',
        0x400A: 'es-BO',
        0x0C01: 'ar',
        0x4809: 'en-SG',
        0x0426: 'lv',
        0x340A: 'es-CL',
        0x0801: 'ar-IQ',
        0x1C09: 'en-ZA',
        0x0427: 'lt',
        0x240A: 'es-CO',
        0x2C01: 'ar-JO',
        0x2C09: 'en-TT',
        0x082E: 'dsb',
        0x140A: 'es-CR',
        0x3401: 'ar-KW',
        0x0809: 'en-GB',
        0x046E: 'lb',
        0x1C0A: 'es-DO',
        0x3001: 'ar-LB',
        0x0409: 'en',
        0x042F: 'mk',
        0x300A: 'es-EC',
        0x1001: 'ar-LY',
        0x3009: 'en-ZW',
        0x083E: 'ms-BN',
        0x440A: 'es-SV',
        0x1801: 'ary',
        0x0425: 'et',
        0x043E: 'ms',
        0x100A: 'es-GT',
        0x2001: 'ar-OM',
        0x0438: 'fo',
        0x044C: 'ml',
        0x480A: 'es-HN',
        0x4001: 'ar-QA',
        0x0464: 'fil',
        0x043A: 'mt',
        0x080A: 'es-MX',
        0x0401: 'ar-SA',
        0x040B: 'fi',
        0x0481: 'mi',
        0x4C0A: 'es-NI',
        0x2801: 'ar-SY',
        0x080C: 'fr-BE',
        0x047A: 'arn',
        0x180A: 'es-PA',
        0x1C01: 'aeb',
        0x0C0C: 'fr-CA',
        0x044E: 'mr',
        0x3C0A: 'es-PY',
        0x3801: 'ar-AE',
        0x040C: 'fr',
        0x047C: 'moh',
        0x280A: 'es-PE',
        0x2401: 'ar-YE',
        0x140C: 'fr-LU',
        0x0450: 'mn',
        0x500A: 'es-PR',
        0x042B: 'hy',
        0x180C: 'fr-MC',
        0x0850: 'mn-CN',
        0x0C0A: 'es',
        0x044D: 'as',
        0x100C: 'fr-CH',
        0x0461: 'ne',
        0x040A: 'es',
        0x082C: 'az-Cyrl',
        0x0462: 'fy',
        0x0414: 'nb',
        0x540A: 'es-US',
        0x042C: 'az',
        0x0456: 'gl',
        0x0814: 'nn',
        0x380A: 'es-UY',
        0x046D: 'ba',
        0x0437: 'ka',
        0x0482: 'oc',
        0x200A: 'es-VE',
        0x042D: 'eu',
        0x0C07: 'de-AT',
        0x0448: 'or',
        0x081D: 'sv-FI',
        0x0423: 'be',
        0x0407: 'de',
        0x0463: 'ps',
        0x041D: 'sv',
        0x0845: 'bn',
        0x1407: 'de-LI',
        0x0415: 'pl',
        0x045A: 'syr',
        0x0445: 'bn-IN',
        0x1007: 'de-LU',
        0x0416: 'pt',
        0x0428: 'tg',
        0x201A: 'bs-Cyrl',
        0x0807: 'de-CH',
        0x0816: 'pt-PT',
        0x085F: 'tzm',
        0x141A: 'bs',
        0x0408: 'el',
        0x0446: 'pa',
        0x0449: 'ta',
        0x047E: 'br',
        0x046F: 'kl',
        0x046B: 'qu-BO',
        0x0444: 'tt',
        0x0402: 'bg',
        0x0447: 'gu',
        0x086B: 'qu-EC',
        0x044A: 'te',
        0x0403: 'ca',
        0x0468: 'ha',
        0x0C6B: 'qu',
        0x041E: 'th',
        0x0C04: 'zh-HK',
        0x040D: 'he',
        0x0418: 'ro',
        0x0451: 'bo',
        0x1404: 'zh-MO',
        0x0439: 'hi',
        0x0417: 'rm',
        0x041F: 'tr',
        0x0804: 'zh',
        0x040E: 'hu',
        0x0419: 'ru',
        0x0442: 'tk',
        0x1004: 'zh-SG',
        0x040F: 'is',
        0x243B: 'smn',
        0x0480: 'ug',
        0x0404: 'zh-TW',
        0x0470: 'ig',
        0x103B: 'smj-NO',
        0x0422: 'uk',
        0x0483: 'co',
        0x0421: 'id',
        0x143B: 'smj',
        0x042E: 'hsb',
        0x041A: 'hr',
        0x045D: 'iu',
        0x0C3B: 'se-FI',
        0x0420: 'ur',
        0x101A: 'hr-BA',
        0x085D: 'iu-Latn',
        0x043B: 'se',
        0x0843: 'uz-Cyrl',
        0x0405: 'cs',
        0x083C: 'ga',
        0x083B: 'se-SE',
        0x0443: 'uz',
        0x0406: 'da',
        0x0434: 'xh',
        0x203B: 'sms',
        0x042A: 'vi',
        0x048C: 'prs',
        0x0435: 'zu',
        0x183B: 'sma-NO',
        0x0452: 'cy',
        0x0465: 'dv',
        0x0410: 'it',
        0x1C3B: 'sms',
        0x0488: 'wo',
        0x0813: 'nl-BE',
        0x0810: 'it-CH',
        0x044F: 'sa',
        0x0485: 'sah',
        0x0413: 'nl',
        0x0411: 'ja',
        0x1C1A: 'sr-Cyrl-BA',
        0x0478: 'ii',
        0x0C09: 'en-AU',
        0x044B: 'kn',
        0x0C1A: 'sr',
        0x046A: 'yo',
        0x2809: 'en-BZ',
        0x043F: 'kk',
        0x181A: 'sr-Latn-BA',
        0x1009: 'en-CA',
        0x0453: 'km',
        0x081A: 'sr-Latn',
        0x2409: 'en-029',
        0x0486: 'quc',
        0x046C: 'nso'
    }
];
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$NameRecord = new $3939d1de148b5202$var$restructure.Struct({
    platformID: $3939d1de148b5202$var$restructure.uint16,
    encodingID: $3939d1de148b5202$var$restructure.uint16,
    languageID: $3939d1de148b5202$var$restructure.uint16,
    nameID: $3939d1de148b5202$var$restructure.uint16,
    length: $3939d1de148b5202$var$restructure.uint16,
    string: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$restructure.String('length', function(t) {
        return $3939d1de148b5202$var$getEncoding(t.platformID, t.encodingID, t.languageID);
    }), {
        type: 'parent',
        relativeTo: 'parent.stringOffset',
        allowNull: false
    })
});
var $3939d1de148b5202$var$LangTagRecord = new $3939d1de148b5202$var$restructure.Struct({
    length: $3939d1de148b5202$var$restructure.uint16,
    tag: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$restructure.String('length', 'utf16be'), {
        type: 'parent',
        relativeTo: 'stringOffset'
    })
});
var $3939d1de148b5202$var$NameTable = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    0: {
        count: $3939d1de148b5202$var$restructure.uint16,
        stringOffset: $3939d1de148b5202$var$restructure.uint16,
        records: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$NameRecord, 'count')
    },
    1: {
        count: $3939d1de148b5202$var$restructure.uint16,
        stringOffset: $3939d1de148b5202$var$restructure.uint16,
        records: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$NameRecord, 'count'),
        langTagCount: $3939d1de148b5202$var$restructure.uint16,
        langTags: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LangTagRecord, 'langTagCount')
    }
});
var $3939d1de148b5202$var$NAMES = [
    'copyright',
    'fontFamily',
    'fontSubfamily',
    'uniqueSubfamily',
    'fullName',
    'version',
    'postscriptName',
    'trademark',
    'manufacturer',
    'designer',
    'description',
    'vendorURL',
    'designerURL',
    'license',
    'licenseURL',
    null,
    'preferredFamily',
    'preferredSubfamily',
    'compatibleFull',
    'sampleText',
    'postscriptCIDFontName',
    'wwsFamilyName',
    'wwsSubfamilyName'
];
$3939d1de148b5202$var$NameTable.process = function(stream) {
    var records = {};
    for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose(this.records), _step; !(_step = _iterator()).done;){
        var record = _step.value;
        // find out what language this is for
        var language = $3939d1de148b5202$var$LANGUAGES[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
        if (language == null) language = record.platformID + '-' + record.languageID;
         // if the nameID is >= 256, it is a font feature record (AAT)
        var key = record.nameID >= 256 ? 'fontFeatures' : $3939d1de148b5202$var$NAMES[record.nameID] || record.nameID;
        if (records[key] == null) records[key] = {};
        var obj = records[key];
        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
        if (typeof record.string === 'string' || typeof obj[language] !== 'string') obj[language] = record.string;
    }
    this.records = records;
};
$3939d1de148b5202$var$NameTable.preEncode = function() {
    if (Array.isArray(this.records)) return;
    this.version = 0;
    var records = [];
    for(var key in this.records){
        var val = this.records[key];
        if (key === 'fontFeatures') continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 0x409,
            nameID: $3939d1de148b5202$var$NAMES.indexOf(key),
            length: $3939d1de148b5202$var$buffer_1.byteLength(val.en, 'utf16le'),
            string: val.en
        });
        if (key === 'postscriptName') records.push({
            platformID: 1,
            encodingID: 0,
            languageID: 0,
            nameID: $3939d1de148b5202$var$NAMES.indexOf(key),
            length: val.en.length,
            string: val.en
        });
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = $3939d1de148b5202$var$NameTable.size(this, null, false);
};
var $3939d1de148b5202$var$OS2 = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    header: {
        xAvgCharWidth: $3939d1de148b5202$var$restructure.int16,
        // average weighted advance width of lower case letters and space
        usWeightClass: $3939d1de148b5202$var$restructure.uint16,
        // visual weight of stroke in glyphs
        usWidthClass: $3939d1de148b5202$var$restructure.uint16,
        // relative change from the normal aspect ratio (width to height ratio)
        fsType: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint16, [
            null,
            'noEmbedding',
            'viewOnly',
            'editable',
            null,
            null,
            null,
            null,
            'noSubsetting',
            'bitmapOnly'
        ]),
        ySubscriptXSize: $3939d1de148b5202$var$restructure.int16,
        // recommended horizontal size in pixels for subscripts
        ySubscriptYSize: $3939d1de148b5202$var$restructure.int16,
        // recommended vertical size in pixels for subscripts
        ySubscriptXOffset: $3939d1de148b5202$var$restructure.int16,
        // recommended horizontal offset for subscripts
        ySubscriptYOffset: $3939d1de148b5202$var$restructure.int16,
        // recommended vertical offset form the baseline for subscripts
        ySuperscriptXSize: $3939d1de148b5202$var$restructure.int16,
        // recommended horizontal size in pixels for superscripts
        ySuperscriptYSize: $3939d1de148b5202$var$restructure.int16,
        // recommended vertical size in pixels for superscripts
        ySuperscriptXOffset: $3939d1de148b5202$var$restructure.int16,
        // recommended horizontal offset for superscripts
        ySuperscriptYOffset: $3939d1de148b5202$var$restructure.int16,
        // recommended vertical offset from the baseline for superscripts
        yStrikeoutSize: $3939d1de148b5202$var$restructure.int16,
        // width of the strikeout stroke
        yStrikeoutPosition: $3939d1de148b5202$var$restructure.int16,
        // position of the strikeout stroke relative to the baseline
        sFamilyClass: $3939d1de148b5202$var$restructure.int16,
        // classification of font-family design
        panose: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, 10),
        // describe the visual characteristics of a given typeface
        ulCharRange: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, 4),
        vendorID: new $3939d1de148b5202$var$restructure.String(4),
        // four character identifier for the font vendor
        fsSelection: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint16, [
            'italic',
            'underscore',
            'negative',
            'outlined',
            'strikeout',
            'bold',
            'regular',
            'useTypoMetrics',
            'wws',
            'oblique'
        ]),
        usFirstCharIndex: $3939d1de148b5202$var$restructure.uint16,
        // The minimum Unicode index in this font
        usLastCharIndex: $3939d1de148b5202$var$restructure.uint16 // The maximum Unicode index in this font
    },
    // The Apple version of this table ends here, but the Microsoft one continues on...
    0: {},
    1: {
        typoAscender: $3939d1de148b5202$var$restructure.int16,
        typoDescender: $3939d1de148b5202$var$restructure.int16,
        typoLineGap: $3939d1de148b5202$var$restructure.int16,
        winAscent: $3939d1de148b5202$var$restructure.uint16,
        winDescent: $3939d1de148b5202$var$restructure.uint16,
        codePageRange: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, 2)
    },
    2: {
        // these should be common with version 1 somehow
        typoAscender: $3939d1de148b5202$var$restructure.int16,
        typoDescender: $3939d1de148b5202$var$restructure.int16,
        typoLineGap: $3939d1de148b5202$var$restructure.int16,
        winAscent: $3939d1de148b5202$var$restructure.uint16,
        winDescent: $3939d1de148b5202$var$restructure.uint16,
        codePageRange: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, 2),
        xHeight: $3939d1de148b5202$var$restructure.int16,
        capHeight: $3939d1de148b5202$var$restructure.int16,
        defaultChar: $3939d1de148b5202$var$restructure.uint16,
        breakChar: $3939d1de148b5202$var$restructure.uint16,
        maxContent: $3939d1de148b5202$var$restructure.uint16
    },
    5: {
        typoAscender: $3939d1de148b5202$var$restructure.int16,
        typoDescender: $3939d1de148b5202$var$restructure.int16,
        typoLineGap: $3939d1de148b5202$var$restructure.int16,
        winAscent: $3939d1de148b5202$var$restructure.uint16,
        winDescent: $3939d1de148b5202$var$restructure.uint16,
        codePageRange: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, 2),
        xHeight: $3939d1de148b5202$var$restructure.int16,
        capHeight: $3939d1de148b5202$var$restructure.int16,
        defaultChar: $3939d1de148b5202$var$restructure.uint16,
        breakChar: $3939d1de148b5202$var$restructure.uint16,
        maxContent: $3939d1de148b5202$var$restructure.uint16,
        usLowerOpticalPointSize: $3939d1de148b5202$var$restructure.uint16,
        usUpperOpticalPointSize: $3939d1de148b5202$var$restructure.uint16
    }
});
var $3939d1de148b5202$var$versions$1 = $3939d1de148b5202$var$OS2.versions;
$3939d1de148b5202$var$versions$1[3] = $3939d1de148b5202$var$versions$1[4] = $3939d1de148b5202$var$versions$1[2];
var $3939d1de148b5202$var$post = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.fixed32, {
    header: {
        // these fields exist at the top of all versions
        italicAngle: $3939d1de148b5202$var$restructure.fixed32,
        // Italic angle in counter-clockwise degrees from the vertical.
        underlinePosition: $3939d1de148b5202$var$restructure.int16,
        // Suggested distance of the top of the underline from the baseline
        underlineThickness: $3939d1de148b5202$var$restructure.int16,
        // Suggested values for the underline thickness
        isFixedPitch: $3939d1de148b5202$var$restructure.uint32,
        // Whether the font is monospaced
        minMemType42: $3939d1de148b5202$var$restructure.uint32,
        // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
        maxMemType42: $3939d1de148b5202$var$restructure.uint32,
        // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
        minMemType1: $3939d1de148b5202$var$restructure.uint32,
        // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
        maxMemType1: $3939d1de148b5202$var$restructure.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
    },
    1: {},
    // version 1 has no additional fields
    2: {
        numberOfGlyphs: $3939d1de148b5202$var$restructure.uint16,
        glyphNameIndex: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'numberOfGlyphs'),
        names: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.String($3939d1de148b5202$var$restructure.uint8))
    },
    2.5: {
        numberOfGlyphs: $3939d1de148b5202$var$restructure.uint16,
        offsets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, 'numberOfGlyphs')
    },
    3: {},
    // version 3 has no additional fields
    4: {
        map: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, function(t) {
            return t.parent.maxp.numGlyphs;
        })
    }
});
var $3939d1de148b5202$var$cvt = new $3939d1de148b5202$var$restructure.Struct({
    controlValues: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int16)
});
// These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
var $3939d1de148b5202$var$fpgm = new $3939d1de148b5202$var$restructure.Struct({
    instructions: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8)
});
var $3939d1de148b5202$var$loca = new $3939d1de148b5202$var$restructure.VersionedStruct('head.indexToLocFormat', {
    0: {
        offsets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16)
    },
    1: {
        offsets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32)
    }
});
$3939d1de148b5202$var$loca.process = function() {
    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
};
$3939d1de148b5202$var$loca.preEncode = function() {
    if (this.version != null) return; // assume this.offsets is a sorted array
    this.version = this.offsets[this.offsets.length - 1] > 0xffff ? 1 : 0;
    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
};
var $3939d1de148b5202$var$prep = new $3939d1de148b5202$var$restructure.Struct({
    controlValueProgram: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8)
});
var $3939d1de148b5202$var$glyf = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Buffer());
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$1(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$1(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$1(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$CFFIndex = /*#__PURE__*/ function() {
    function CFFIndex(type) {
        this.type = type;
    }
    var _proto = CFFIndex.prototype;
    _proto.getCFFVersion = function getCFFVersion(ctx) {
        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
        return ctx ? ctx.version : -1;
    };
    _proto.decode = function decode(stream, parent) {
        var version = this.getCFFVersion(parent);
        var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
        if (count === 0) return [];
        var offSize = stream.readUInt8();
        var offsetType;
        if (offSize === 1) offsetType = $3939d1de148b5202$var$restructure.uint8;
        else if (offSize === 2) offsetType = $3939d1de148b5202$var$restructure.uint16;
        else if (offSize === 3) offsetType = $3939d1de148b5202$var$restructure.uint24;
        else if (offSize === 4) offsetType = $3939d1de148b5202$var$restructure.uint32;
        else throw new Error("Bad offset size in CFFIndex: " + offSize + " " + stream.pos);
        var ret = [];
        var startPos = stream.pos + (count + 1) * offSize - 1;
        var start = offsetType.decode(stream);
        for(var i = 0; i < count; i++){
            var end = offsetType.decode(stream);
            if (this.type != null) {
                var pos = stream.pos;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
            } else ret.push({
                offset: startPos + start,
                length: end - start
            });
            start = end;
        }
        stream.pos = startPos + start;
        return ret;
    };
    _proto.size = function size(arr, parent) {
        var size = 2;
        if (arr.length === 0) return size;
        var type = this.type || new $3939d1de148b5202$var$restructure.Buffer(); // find maximum offset to detminine offset type
        var offset = 1;
        for(var i = 0; i < arr.length; i++){
            var item = arr[i];
            offset += type.size(item, parent);
        }
        var offsetType;
        if (offset <= 0xff) offsetType = $3939d1de148b5202$var$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $3939d1de148b5202$var$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $3939d1de148b5202$var$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $3939d1de148b5202$var$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
        size += 1 + offsetType.size() * (arr.length + 1);
        size += offset - 1;
        return size;
    };
    _proto.encode = function encode(stream, arr, parent) {
        stream.writeUInt16BE(arr.length);
        if (arr.length === 0) return;
        var type = this.type || new $3939d1de148b5202$var$restructure.Buffer(); // find maximum offset to detminine offset type
        var sizes = [];
        var offset = 1;
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$1(arr), _step; !(_step = _iterator()).done;){
            var item = _step.value;
            var s = type.size(item, parent);
            sizes.push(s);
            offset += s;
        }
        var offsetType;
        if (offset <= 0xff) offsetType = $3939d1de148b5202$var$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $3939d1de148b5202$var$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $3939d1de148b5202$var$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $3939d1de148b5202$var$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
         // write offset size
        stream.writeUInt8(offsetType.size()); // write elements
        offset = 1;
        offsetType.encode(stream, offset);
        for(var _i = 0, _sizes = sizes; _i < _sizes.length; _i++){
            var size = _sizes[_i];
            offset += size;
            offsetType.encode(stream, offset);
        }
        for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$1(arr), _step2; !(_step2 = _iterator2()).done;){
            var _item = _step2.value;
            type.encode(stream, _item, parent);
        }
        return;
    };
    return CFFIndex;
}();
var $3939d1de148b5202$var$toStr = Object.prototype.toString;
var $3939d1de148b5202$var$isArguments = function isArguments(value) {
    var str = $3939d1de148b5202$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $3939d1de148b5202$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};
var $3939d1de148b5202$var$keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $3939d1de148b5202$var$has = Object.prototype.hasOwnProperty;
    var $3939d1de148b5202$var$toStr$1 = Object.prototype.toString;
    var $3939d1de148b5202$var$isArgs = $3939d1de148b5202$var$isArguments; // eslint-disable-line global-require
    var $3939d1de148b5202$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $3939d1de148b5202$var$hasDontEnumBug = !$3939d1de148b5202$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $3939d1de148b5202$var$hasProtoEnumBug = $3939d1de148b5202$var$isEnumerable.call(function() {}, 'prototype');
    var $3939d1de148b5202$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $3939d1de148b5202$var$equalsConstructorPrototype = function equalsConstructorPrototype(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $3939d1de148b5202$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $3939d1de148b5202$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$3939d1de148b5202$var$excludedKeys['$' + k] && $3939d1de148b5202$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $3939d1de148b5202$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $3939d1de148b5202$var$equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
        /* global window */ if (typeof window === 'undefined' || !$3939d1de148b5202$var$hasAutomationEqualityBug) return $3939d1de148b5202$var$equalsConstructorPrototype(o);
        try {
            return $3939d1de148b5202$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $3939d1de148b5202$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $3939d1de148b5202$var$toStr$1.call(object) === '[object Function]';
        var isArguments = $3939d1de148b5202$var$isArgs(object);
        var isString = isObject && $3939d1de148b5202$var$toStr$1.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $3939d1de148b5202$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$3939d1de148b5202$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $3939d1de148b5202$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($3939d1de148b5202$var$hasDontEnumBug) {
            var skipConstructor = $3939d1de148b5202$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $3939d1de148b5202$var$dontEnums.length; ++k)if (!(skipConstructor && $3939d1de148b5202$var$dontEnums[k] === 'constructor') && $3939d1de148b5202$var$has.call(object, $3939d1de148b5202$var$dontEnums[k])) theKeys.push($3939d1de148b5202$var$dontEnums[k]);
        }
        return theKeys;
    };
}
var $3939d1de148b5202$var$implementation = $3939d1de148b5202$var$keysShim;
var $3939d1de148b5202$var$slice = Array.prototype.slice;
var $3939d1de148b5202$var$origKeys = Object.keys;
var $3939d1de148b5202$var$keysShim$1 = $3939d1de148b5202$var$origKeys ? function keys(o) {
    return $3939d1de148b5202$var$origKeys(o);
} : $3939d1de148b5202$var$implementation;
var $3939d1de148b5202$var$originalKeys = Object.keys;
$3939d1de148b5202$var$keysShim$1.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            // eslint-disable-line func-name-matching
            if ($3939d1de148b5202$var$isArguments(object)) return $3939d1de148b5202$var$originalKeys($3939d1de148b5202$var$slice.call(object));
            return $3939d1de148b5202$var$originalKeys(object);
        };
    } else Object.keys = $3939d1de148b5202$var$keysShim$1;
    return Object.keys || $3939d1de148b5202$var$keysShim$1;
};
var $3939d1de148b5202$var$objectKeys = $3939d1de148b5202$var$keysShim$1;
var $3939d1de148b5202$var$hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $3939d1de148b5202$var$toStr$2 = Object.prototype.toString;
var $3939d1de148b5202$var$isStandardArguments = function isArguments(value) {
    if ($3939d1de148b5202$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $3939d1de148b5202$var$toStr$2.call(value) === '[object Arguments]';
};
var $3939d1de148b5202$var$isLegacyArguments = function isArguments(value) {
    if ($3939d1de148b5202$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $3939d1de148b5202$var$toStr$2.call(value) !== '[object Array]' && $3939d1de148b5202$var$toStr$2.call(value.callee) === '[object Function]';
};
var $3939d1de148b5202$var$supportsStandardArguments = function() {
    return $3939d1de148b5202$var$isStandardArguments(arguments);
}();
$3939d1de148b5202$var$isStandardArguments.isLegacyArguments = $3939d1de148b5202$var$isLegacyArguments; // for tests
var $3939d1de148b5202$var$isArguments$1 = $3939d1de148b5202$var$supportsStandardArguments ? $3939d1de148b5202$var$isStandardArguments : $3939d1de148b5202$var$isLegacyArguments;
var $3939d1de148b5202$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $3939d1de148b5202$var$toStr$3 = Object.prototype.toString;
var $3939d1de148b5202$var$concat = Array.prototype.concat;
var $3939d1de148b5202$var$origDefineProperty = Object.defineProperty;
var $3939d1de148b5202$var$isFunction$1 = function isFunction(fn) {
    return typeof fn === 'function' && $3939d1de148b5202$var$toStr$3.call(fn) === '[object Function]';
};
var $3939d1de148b5202$var$arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
    var obj = {};
    try {
        $3939d1de148b5202$var$origDefineProperty(obj, 'x', {
            enumerable: false,
            value: obj
        }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)// jscs:ignore disallowUnusedVariables
        return false;
        return obj.x === obj;
    } catch (e) {
        /* this is IE 8. */ return false;
    }
};
var $3939d1de148b5202$var$supportsDescriptors = $3939d1de148b5202$var$origDefineProperty && $3939d1de148b5202$var$arePropertyDescriptorsSupported();
var $3939d1de148b5202$var$defineProperty = function defineProperty(object, name, value, predicate) {
    if (name in object && (!$3939d1de148b5202$var$isFunction$1(predicate) || !predicate())) return;
    if ($3939d1de148b5202$var$supportsDescriptors) $3939d1de148b5202$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var $3939d1de148b5202$var$defineProperties = function defineProperties(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $3939d1de148b5202$var$objectKeys(map);
    if ($3939d1de148b5202$var$hasSymbols) props = $3939d1de148b5202$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$3939d1de148b5202$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$3939d1de148b5202$var$defineProperties.supportsDescriptors = !!$3939d1de148b5202$var$supportsDescriptors;
var $3939d1de148b5202$var$defineProperties_1 = $3939d1de148b5202$var$defineProperties;
/* eslint no-invalid-this: 1 */ var $3939d1de148b5202$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $3939d1de148b5202$var$slice$1 = Array.prototype.slice;
var $3939d1de148b5202$var$toStr$4 = Object.prototype.toString;
var $3939d1de148b5202$var$funcType = '[object Function]';
var $3939d1de148b5202$var$implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $3939d1de148b5202$var$toStr$4.call(target) !== $3939d1de148b5202$var$funcType) throw new TypeError($3939d1de148b5202$var$ERROR_MESSAGE + target);
    var args = $3939d1de148b5202$var$slice$1.call(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($3939d1de148b5202$var$slice$1.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($3939d1de148b5202$var$slice$1.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push('$' + i);
    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};
var $3939d1de148b5202$var$functionBind = Function.prototype.bind || $3939d1de148b5202$var$implementation$1;
/* eslint complexity: [2, 18], max-statements: [2, 33] */ var $3939d1de148b5202$var$shams = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
     // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};
var $3939d1de148b5202$var$origSymbol = $3939d1de148b5202$var$commonjsGlobal.Symbol;
var $3939d1de148b5202$var$hasSymbols$1 = function hasNativeSymbols() {
    if (typeof $3939d1de148b5202$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $3939d1de148b5202$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $3939d1de148b5202$var$shams();
};
/* globals
	Atomics,
	SharedArrayBuffer,
*/ var $3939d1de148b5202$var$undefined$1;
var $3939d1de148b5202$var$$TypeError = TypeError;
var $3939d1de148b5202$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($3939d1de148b5202$var$$gOPD) try {
    $3939d1de148b5202$var$$gOPD({}, '');
} catch (e) {
    $3939d1de148b5202$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $3939d1de148b5202$var$throwTypeError = function throwTypeError() {
    throw new $3939d1de148b5202$var$$TypeError();
};
var $3939d1de148b5202$var$ThrowTypeError = $3939d1de148b5202$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $3939d1de148b5202$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $3939d1de148b5202$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $3939d1de148b5202$var$throwTypeError;
        }
    }
}() : $3939d1de148b5202$var$throwTypeError;
var $3939d1de148b5202$var$hasSymbols$2 = $3939d1de148b5202$var$hasSymbols$1();
var $3939d1de148b5202$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $3939d1de148b5202$var$generatorFunction = $3939d1de148b5202$var$undefined$1;
var $3939d1de148b5202$var$asyncFunction = $3939d1de148b5202$var$undefined$1;
var $3939d1de148b5202$var$asyncGenFunction = $3939d1de148b5202$var$undefined$1;
var $3939d1de148b5202$var$TypedArray = typeof Uint8Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : $3939d1de148b5202$var$getProto(Uint8Array);
var $3939d1de148b5202$var$INTRINSICS = {
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? $3939d1de148b5202$var$undefined$1 : ArrayBuffer,
    '%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? $3939d1de148b5202$var$undefined$1 : ArrayBuffer.prototype,
    '%ArrayIteratorPrototype%': $3939d1de148b5202$var$hasSymbols$2 ? $3939d1de148b5202$var$getProto([][Symbol.iterator]()) : $3939d1de148b5202$var$undefined$1,
    '%ArrayPrototype%': Array.prototype,
    '%ArrayProto_entries%': Array.prototype.entries,
    '%ArrayProto_forEach%': Array.prototype.forEach,
    '%ArrayProto_keys%': Array.prototype.keys,
    '%ArrayProto_values%': Array.prototype.values,
    '%AsyncFromSyncIteratorPrototype%': $3939d1de148b5202$var$undefined$1,
    '%AsyncFunction%': $3939d1de148b5202$var$asyncFunction,
    '%AsyncFunctionPrototype%': $3939d1de148b5202$var$undefined$1,
    '%AsyncGenerator%': $3939d1de148b5202$var$undefined$1,
    '%AsyncGeneratorFunction%': $3939d1de148b5202$var$asyncGenFunction,
    '%AsyncGeneratorPrototype%': $3939d1de148b5202$var$undefined$1,
    '%AsyncIteratorPrototype%': $3939d1de148b5202$var$undefined$1,
    '%Atomics%': typeof Atomics === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Atomics,
    '%Boolean%': Boolean,
    '%BooleanPrototype%': Boolean.prototype,
    '%DataView%': typeof DataView === 'undefined' ? $3939d1de148b5202$var$undefined$1 : DataView,
    '%DataViewPrototype%': typeof DataView === 'undefined' ? $3939d1de148b5202$var$undefined$1 : DataView.prototype,
    '%Date%': Date,
    '%DatePrototype%': Date.prototype,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%ErrorPrototype%': Error.prototype,
    '%eval%': eval,
    // eslint-disable-line no-eval
    '%EvalError%': EvalError,
    '%EvalErrorPrototype%': EvalError.prototype,
    '%Float32Array%': typeof Float32Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Float32Array,
    '%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Float32Array.prototype,
    '%Float64Array%': typeof Float64Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Float64Array,
    '%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Float64Array.prototype,
    '%Function%': Function,
    '%FunctionPrototype%': Function.prototype,
    '%Generator%': $3939d1de148b5202$var$undefined$1,
    '%GeneratorFunction%': $3939d1de148b5202$var$generatorFunction,
    '%GeneratorPrototype%': $3939d1de148b5202$var$undefined$1,
    '%Int8Array%': typeof Int8Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Int8Array,
    '%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Int8Array.prototype,
    '%Int16Array%': typeof Int16Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Int16Array,
    '%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Int8Array.prototype,
    '%Int32Array%': typeof Int32Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Int32Array,
    '%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Int32Array.prototype,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $3939d1de148b5202$var$hasSymbols$2 ? $3939d1de148b5202$var$getProto($3939d1de148b5202$var$getProto([][Symbol.iterator]())) : $3939d1de148b5202$var$undefined$1,
    '%JSON%': typeof JSON === 'object' ? JSON : $3939d1de148b5202$var$undefined$1,
    '%JSONParse%': typeof JSON === 'object' ? JSON.parse : $3939d1de148b5202$var$undefined$1,
    '%Map%': typeof Map === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$3939d1de148b5202$var$hasSymbols$2 ? $3939d1de148b5202$var$undefined$1 : $3939d1de148b5202$var$getProto(new Map()[Symbol.iterator]()),
    '%MapPrototype%': typeof Map === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Map.prototype,
    '%Math%': Math,
    '%Number%': Number,
    '%NumberPrototype%': Number.prototype,
    '%Object%': Object,
    '%ObjectPrototype%': Object.prototype,
    '%ObjProto_toString%': Object.prototype.toString,
    '%ObjProto_valueOf%': Object.prototype.valueOf,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Promise,
    '%PromisePrototype%': typeof Promise === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Promise.prototype,
    '%PromiseProto_then%': typeof Promise === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Promise.prototype.then,
    '%Promise_all%': typeof Promise === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Promise.all,
    '%Promise_reject%': typeof Promise === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Promise.reject,
    '%Promise_resolve%': typeof Promise === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Promise.resolve,
    '%Proxy%': typeof Proxy === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Proxy,
    '%RangeError%': RangeError,
    '%RangeErrorPrototype%': RangeError.prototype,
    '%ReferenceError%': ReferenceError,
    '%ReferenceErrorPrototype%': ReferenceError.prototype,
    '%Reflect%': typeof Reflect === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Reflect,
    '%RegExp%': RegExp,
    '%RegExpPrototype%': RegExp.prototype,
    '%Set%': typeof Set === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$3939d1de148b5202$var$hasSymbols$2 ? $3939d1de148b5202$var$undefined$1 : $3939d1de148b5202$var$getProto(new Set()[Symbol.iterator]()),
    '%SetPrototype%': typeof Set === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Set.prototype,
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? $3939d1de148b5202$var$undefined$1 : SharedArrayBuffer,
    '%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? $3939d1de148b5202$var$undefined$1 : SharedArrayBuffer.prototype,
    '%String%': String,
    '%StringIteratorPrototype%': $3939d1de148b5202$var$hasSymbols$2 ? $3939d1de148b5202$var$getProto(''[Symbol.iterator]()) : $3939d1de148b5202$var$undefined$1,
    '%StringPrototype%': String.prototype,
    '%Symbol%': $3939d1de148b5202$var$hasSymbols$2 ? Symbol : $3939d1de148b5202$var$undefined$1,
    '%SymbolPrototype%': $3939d1de148b5202$var$hasSymbols$2 ? Symbol.prototype : $3939d1de148b5202$var$undefined$1,
    '%SyntaxError%': SyntaxError,
    '%SyntaxErrorPrototype%': SyntaxError.prototype,
    '%ThrowTypeError%': $3939d1de148b5202$var$ThrowTypeError,
    '%TypedArray%': $3939d1de148b5202$var$TypedArray,
    '%TypedArrayPrototype%': $3939d1de148b5202$var$TypedArray ? $3939d1de148b5202$var$TypedArray.prototype : $3939d1de148b5202$var$undefined$1,
    '%TypeError%': $3939d1de148b5202$var$$TypeError,
    '%TypeErrorPrototype%': $3939d1de148b5202$var$$TypeError.prototype,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint8Array,
    '%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint8Array.prototype,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint8ClampedArray,
    '%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint8ClampedArray.prototype,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint16Array,
    '%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint16Array.prototype,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint32Array,
    '%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? $3939d1de148b5202$var$undefined$1 : Uint32Array.prototype,
    '%URIError%': URIError,
    '%URIErrorPrototype%': URIError.prototype,
    '%WeakMap%': typeof WeakMap === 'undefined' ? $3939d1de148b5202$var$undefined$1 : WeakMap,
    '%WeakMapPrototype%': typeof WeakMap === 'undefined' ? $3939d1de148b5202$var$undefined$1 : WeakMap.prototype,
    '%WeakSet%': typeof WeakSet === 'undefined' ? $3939d1de148b5202$var$undefined$1 : WeakSet,
    '%WeakSetPrototype%': typeof WeakSet === 'undefined' ? $3939d1de148b5202$var$undefined$1 : WeakSet.prototype
};
var $3939d1de148b5202$var$$replace = $3939d1de148b5202$var$functionBind.call(Function.call, String.prototype.replace);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $3939d1de148b5202$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $3939d1de148b5202$var$reEscapeChar = /\\(\\)?/g;
/** Used to match backslashes in property paths. */ var $3939d1de148b5202$var$stringToPath = function stringToPath(string) {
    var result = [];
    $3939d1de148b5202$var$$replace(string, $3939d1de148b5202$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $3939d1de148b5202$var$$replace(subString, $3939d1de148b5202$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $3939d1de148b5202$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    if (!(name in $3939d1de148b5202$var$INTRINSICS)) throw new SyntaxError('intrinsic ' + name + ' does not exist!');
     // istanbul ignore if // hopefully this is impossible to test :-)
    if (typeof $3939d1de148b5202$var$INTRINSICS[name] === 'undefined' && !allowMissing) throw new $3939d1de148b5202$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    return $3939d1de148b5202$var$INTRINSICS[name];
};
var $3939d1de148b5202$var$GetIntrinsic = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new TypeError('"allowMissing" argument must be a boolean');
    var parts = $3939d1de148b5202$var$stringToPath(name);
    var value = $3939d1de148b5202$var$getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
    for(var i = 1; i < parts.length; i += 1)if (value != null) {
        if ($3939d1de148b5202$var$$gOPD && i + 1 >= parts.length) {
            var desc = $3939d1de148b5202$var$$gOPD(value, parts[i]);
            if (!allowMissing && !(parts[i] in value)) throw new $3939d1de148b5202$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
            value = desc ? desc.get || desc.value : value[parts[i]];
        } else value = value[parts[i]];
    }
    return value;
};
var $3939d1de148b5202$var$$Function = $3939d1de148b5202$var$GetIntrinsic('%Function%');
var $3939d1de148b5202$var$$apply = $3939d1de148b5202$var$$Function.apply;
var $3939d1de148b5202$var$$call = $3939d1de148b5202$var$$Function.call;
var $3939d1de148b5202$var$callBind = function callBind() {
    return $3939d1de148b5202$var$functionBind.apply($3939d1de148b5202$var$$call, arguments);
};
var $3939d1de148b5202$var$apply = function applyBind() {
    return $3939d1de148b5202$var$functionBind.apply($3939d1de148b5202$var$$apply, arguments);
};
$3939d1de148b5202$var$callBind.apply = $3939d1de148b5202$var$apply;
var $3939d1de148b5202$var$numberIsNaN = function numberIsNaN(value) {
    return value !== value;
};
var $3939d1de148b5202$var$implementation$2 = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($3939d1de148b5202$var$numberIsNaN(a) && $3939d1de148b5202$var$numberIsNaN(b)) return true;
    return false;
};
var $3939d1de148b5202$var$polyfill = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $3939d1de148b5202$var$implementation$2;
};
var $3939d1de148b5202$var$shim = function shimObjectIs() {
    var polyfill$1 = $3939d1de148b5202$var$polyfill();
    $3939d1de148b5202$var$defineProperties_1(Object, {
        is: polyfill$1
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill$1;
        }
    });
    return polyfill$1;
};
var $3939d1de148b5202$var$polyfill$1 = $3939d1de148b5202$var$callBind($3939d1de148b5202$var$polyfill(), Object);
$3939d1de148b5202$var$defineProperties_1($3939d1de148b5202$var$polyfill$1, {
    getPolyfill: $3939d1de148b5202$var$polyfill,
    implementation: $3939d1de148b5202$var$implementation$2,
    shim: $3939d1de148b5202$var$shim
});
var $3939d1de148b5202$var$objectIs = $3939d1de148b5202$var$polyfill$1;
var $3939d1de148b5202$var$src = $3939d1de148b5202$var$functionBind.call(Function.call, Object.prototype.hasOwnProperty);
var $3939d1de148b5202$var$regexExec = RegExp.prototype.exec;
var $3939d1de148b5202$var$gOPD = Object.getOwnPropertyDescriptor;
var $3939d1de148b5202$var$tryRegexExecCall = function tryRegexExec(value) {
    try {
        var lastIndex = value.lastIndex;
        value.lastIndex = 0; // eslint-disable-line no-param-reassign
        $3939d1de148b5202$var$regexExec.call(value);
        return true;
    } catch (e) {
        return false;
    } finally{
        value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
    }
};
var $3939d1de148b5202$var$toStr$5 = Object.prototype.toString;
var $3939d1de148b5202$var$regexClass = '[object RegExp]';
var $3939d1de148b5202$var$hasToStringTag$1 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $3939d1de148b5202$var$isRegex = function isRegex(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$3939d1de148b5202$var$hasToStringTag$1) return $3939d1de148b5202$var$toStr$5.call(value) === $3939d1de148b5202$var$regexClass;
    var descriptor = $3939d1de148b5202$var$gOPD(value, 'lastIndex');
    var hasLastIndexDataProperty = descriptor && $3939d1de148b5202$var$src(descriptor, 'value');
    if (!hasLastIndexDataProperty) return false;
    return $3939d1de148b5202$var$tryRegexExecCall(value);
};
var $3939d1de148b5202$var$$Object = Object;
var $3939d1de148b5202$var$$TypeError$1 = TypeError;
var $3939d1de148b5202$var$implementation$3 = function flags() {
    if (this != null && this !== $3939d1de148b5202$var$$Object(this)) throw new $3939d1de148b5202$var$$TypeError$1('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.sticky) result += 'y';
    return result;
};
var $3939d1de148b5202$var$supportsDescriptors$1 = $3939d1de148b5202$var$defineProperties_1.supportsDescriptors;
var $3939d1de148b5202$var$$gOPD$1 = Object.getOwnPropertyDescriptor;
var $3939d1de148b5202$var$$TypeError$2 = TypeError;
var $3939d1de148b5202$var$polyfill$2 = function getPolyfill() {
    if (!$3939d1de148b5202$var$supportsDescriptors$1) throw new $3939d1de148b5202$var$$TypeError$2('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    if (/a/mig.flags === 'gim') {
        var descriptor = $3939d1de148b5202$var$$gOPD$1(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') return descriptor.get;
    }
    return $3939d1de148b5202$var$implementation$3;
};
var $3939d1de148b5202$var$supportsDescriptors$2 = $3939d1de148b5202$var$defineProperties_1.supportsDescriptors;
var $3939d1de148b5202$var$gOPD$1 = Object.getOwnPropertyDescriptor;
var $3939d1de148b5202$var$defineProperty$1 = Object.defineProperty;
var $3939d1de148b5202$var$TypeErr = TypeError;
var $3939d1de148b5202$var$getProto$1 = Object.getPrototypeOf;
var $3939d1de148b5202$var$regex = /a/;
var $3939d1de148b5202$var$shim$1 = function shimFlags() {
    if (!$3939d1de148b5202$var$supportsDescriptors$2 || !$3939d1de148b5202$var$getProto$1) throw new $3939d1de148b5202$var$TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = $3939d1de148b5202$var$polyfill$2();
    var proto = $3939d1de148b5202$var$getProto$1($3939d1de148b5202$var$regex);
    var descriptor = $3939d1de148b5202$var$gOPD$1(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) $3939d1de148b5202$var$defineProperty$1(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};
var $3939d1de148b5202$var$flagsBound = $3939d1de148b5202$var$callBind($3939d1de148b5202$var$implementation$3);
$3939d1de148b5202$var$defineProperties_1($3939d1de148b5202$var$flagsBound, {
    getPolyfill: $3939d1de148b5202$var$polyfill$2,
    implementation: $3939d1de148b5202$var$implementation$3,
    shim: $3939d1de148b5202$var$shim$1
});
var $3939d1de148b5202$var$regexp_prototype_flags = $3939d1de148b5202$var$flagsBound;
var $3939d1de148b5202$var$getDay = Date.prototype.getDay;
var $3939d1de148b5202$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $3939d1de148b5202$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $3939d1de148b5202$var$toStr$6 = Object.prototype.toString;
var $3939d1de148b5202$var$dateClass = '[object Date]';
var $3939d1de148b5202$var$hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $3939d1de148b5202$var$isDateObject = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return $3939d1de148b5202$var$hasToStringTag$2 ? $3939d1de148b5202$var$tryDateObject(value) : $3939d1de148b5202$var$toStr$6.call(value) === $3939d1de148b5202$var$dateClass;
};
var $3939d1de148b5202$var$getTime = Date.prototype.getTime;
function $3939d1de148b5202$var$deepEqual(actual, expected, options) {
    var opts = options || {}; // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $3939d1de148b5202$var$objectIs(actual, expected) : actual === expected) return true;
     // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $3939d1de148b5202$var$objectIs(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $3939d1de148b5202$var$objEquiv(actual, expected, opts);
}
function $3939d1de148b5202$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $3939d1de148b5202$var$isBuffer$1(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $3939d1de148b5202$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($3939d1de148b5202$var$isUndefinedOrNull(a) || $3939d1de148b5202$var$isUndefinedOrNull(b)) return false;
     // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($3939d1de148b5202$var$isArguments$1(a) !== $3939d1de148b5202$var$isArguments$1(b)) return false;
    var aIsRegex = $3939d1de148b5202$var$isRegex(a);
    var bIsRegex = $3939d1de148b5202$var$isRegex(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $3939d1de148b5202$var$regexp_prototype_flags(a) === $3939d1de148b5202$var$regexp_prototype_flags(b);
    if ($3939d1de148b5202$var$isDateObject(a) && $3939d1de148b5202$var$isDateObject(b)) return $3939d1de148b5202$var$getTime.call(a) === $3939d1de148b5202$var$getTime.call(b);
    var aIsBuffer = $3939d1de148b5202$var$isBuffer$1(a);
    var bIsBuffer = $3939d1de148b5202$var$isBuffer$1(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        // && would work too, because both are true or both false here
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $3939d1de148b5202$var$objectKeys(a);
        var kb = $3939d1de148b5202$var$objectKeys(b);
    } catch (e) {
        // happens when one is a string literal and the other isn't
        return false;
    } // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
     // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort(); // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    } // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$3939d1de148b5202$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
var $3939d1de148b5202$var$deepEqual_1 = $3939d1de148b5202$var$deepEqual;
var $3939d1de148b5202$var$FLOAT_EOF = 0xf;
var $3939d1de148b5202$var$FLOAT_LOOKUP = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    'E',
    'E-',
    null,
    '-'
];
var $3939d1de148b5202$var$FLOAT_ENCODE_LOOKUP = {
    '.': 10,
    'E': 11,
    'E-': 12,
    '-': 14
};
var $3939d1de148b5202$var$CFFOperand = /*#__PURE__*/ function() {
    function CFFOperand() {}
    CFFOperand.decode = function decode(stream, value) {
        if (32 <= value && value <= 246) return value - 139;
        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
        if (value === 28) return stream.readInt16BE();
        if (value === 29) return stream.readInt32BE();
        if (value === 30) {
            var str = '';
            while(true){
                var b = stream.readUInt8();
                var n1 = b >> 4;
                if (n1 === $3939d1de148b5202$var$FLOAT_EOF) break;
                str += $3939d1de148b5202$var$FLOAT_LOOKUP[n1];
                var n2 = b & 15;
                if (n2 === $3939d1de148b5202$var$FLOAT_EOF) break;
                str += $3939d1de148b5202$var$FLOAT_LOOKUP[n2];
            }
            return parseFloat(str);
        }
        return null;
    };
    CFFOperand.size = function size(value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, set to 32768
        if (value.forceLarge) value = 32768;
        if ((value | 0) !== value) {
            // floating point
            var str = '' + value;
            return 1 + Math.ceil((str.length + 1) / 2);
        } else if (-107 <= value && value <= 107) return 1;
        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
        else if (-32768 <= value && value <= 32767) return 3;
        else return 5;
    };
    CFFOperand.encode = function encode(stream, value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, save the old value and set to 32768
        var val = Number(value);
        if (value.forceLarge) {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        } else if ((val | 0) !== val) {
            // floating point
            stream.writeUInt8(30);
            var str = '' + val;
            for(var i = 0; i < str.length; i += 2){
                var c1 = str[i];
                var n1 = $3939d1de148b5202$var$FLOAT_ENCODE_LOOKUP[c1] || +c1;
                if (i === str.length - 1) var n2 = $3939d1de148b5202$var$FLOAT_EOF;
                else {
                    var c2 = str[i + 1];
                    var n2 = $3939d1de148b5202$var$FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }
                stream.writeUInt8(n1 << 4 | n2 & 15);
            }
            if (n2 !== $3939d1de148b5202$var$FLOAT_EOF) return stream.writeUInt8($3939d1de148b5202$var$FLOAT_EOF << 4);
        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
        else if (108 <= val && val <= 1131) {
            val -= 108;
            stream.writeUInt8((val >> 8) + 247);
            return stream.writeUInt8(val & 0xff);
        } else if (-1131 <= val && val <= -108) {
            val = -val - 108;
            stream.writeUInt8((val >> 8) + 251);
            return stream.writeUInt8(val & 0xff);
        } else if (-32768 <= val && val <= 32767) {
            stream.writeUInt8(28);
            return stream.writeInt16BE(val);
        } else {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        }
    };
    return CFFOperand;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$2(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$2(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$2(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$CFFDict = /*#__PURE__*/ function() {
    function CFFDict(ops) {
        if (ops === void 0) ops = [];
        this.ops = ops;
        this.fields = {};
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$2(ops), _step; !(_step = _iterator()).done;){
            var field = _step.value;
            var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
            this.fields[key] = field;
        }
    }
    var _proto = CFFDict.prototype;
    _proto.decodeOperands = function decodeOperands(type, stream, ret, operands) {
        var _this = this;
        if (Array.isArray(type)) return operands.map(function(op, i) {
            return _this.decodeOperands(type[i], stream, ret, [
                op
            ]);
        });
        else if (type.decode != null) return type.decode(stream, ret, operands);
        else switch(type){
            case 'number':
            case 'offset':
            case 'sid':
                return operands[0];
            case 'boolean':
                return !!operands[0];
            default:
                return operands;
        }
    };
    _proto.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
        var _this2 = this;
        if (Array.isArray(type)) return operands.map(function(op, i) {
            return _this2.encodeOperands(type[i], stream, ctx, op)[0];
        });
        else if (type.encode != null) return type.encode(stream, operands, ctx);
        else if (typeof operands === 'number') return [
            operands
        ];
        else if (typeof operands === 'boolean') return [
            +operands
        ];
        else if (Array.isArray(operands)) return operands;
        else return [
            operands
        ];
    };
    _proto.decode = function decode(stream, parent) {
        var end = stream.pos + parent.length;
        var ret = {};
        var operands = []; // define hidden properties
        Object.defineProperties(ret, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            }
        }); // fill in defaults
        for(var key in this.fields){
            var field = this.fields[key];
            ret[field[1]] = field[3];
        }
        while(stream.pos < end){
            var b = stream.readUInt8();
            if (b < 28) {
                if (b === 12) b = b << 8 | stream.readUInt8();
                var _field = this.fields[b];
                if (!_field) throw new Error("Unknown operator " + b);
                var val = this.decodeOperands(_field[2], stream, ret, operands);
                if (val != null) {
                    if (val instanceof $3939d1de148b5202$var$utils_2) Object.defineProperty(ret, _field[1], val);
                    else ret[_field[1]] = val;
                }
                operands = [];
            } else operands.push($3939d1de148b5202$var$CFFOperand.decode(stream, b));
        }
        return ret;
    };
    _proto.size = function size(dict, parent, includePointers) {
        if (includePointers === void 0) includePointers = true;
        var ctx = {
            parent: parent,
            val: dict,
            pointerSize: 0,
            startOffset: parent.startOffset || 0
        };
        var len = 0;
        for(var k in this.fields){
            var field = this.fields[k];
            var val = dict[field[1]];
            if (val == null || $3939d1de148b5202$var$deepEqual_1(val, field[3])) continue;
            var operands = this.encodeOperands(field[2], null, ctx, val);
            for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$2(operands), _step2; !(_step2 = _iterator2()).done;){
                var op = _step2.value;
                len += $3939d1de148b5202$var$CFFOperand.size(op);
            }
            var key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            len += key.length;
        }
        if (includePointers) len += ctx.pointerSize;
        return len;
    };
    _proto.encode = function encode(stream, dict, parent) {
        var ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: dict,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
        for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$2(this.ops), _step3; !(_step3 = _iterator3()).done;){
            var field = _step3.value;
            var val = dict[field[1]];
            if (val == null || $3939d1de148b5202$var$deepEqual_1(val, field[3])) continue;
            var operands = this.encodeOperands(field[2], stream, ctx, val);
            for(var _iterator4 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$2(operands), _step4; !(_step4 = _iterator4()).done;){
                var op = _step4.value;
                $3939d1de148b5202$var$CFFOperand.encode(stream, op);
            }
            var key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            for(var _iterator5 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$2(key), _step5; !(_step5 = _iterator5()).done;){
                var _op = _step5.value;
                stream.writeUInt8(_op);
            }
        }
        var i = 0;
        while(i < ctx.pointers.length){
            var ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
        return;
    };
    return CFFDict;
}();
function $3939d1de148b5202$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$CFFPointer = /*#__PURE__*/ function(_r$Pointer) {
    $3939d1de148b5202$var$_inheritsLoose(CFFPointer, _r$Pointer);
    function CFFPointer(type, options) {
        if (options === void 0) options = {};
        if (options.type == null) options.type = 'global';
        return _r$Pointer.call(this, null, type, options) || this;
    }
    var _proto = CFFPointer.prototype;
    _proto.decode = function decode(stream, parent, operands) {
        this.offsetType = {
            decode: function decode() {
                return operands[0];
            }
        };
        return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
    };
    _proto.encode = function encode(stream, value, ctx) {
        if (!stream) {
            // compute the size (so ctx.pointerSize is correct)
            this.offsetType = {
                size: function size() {
                    return 0;
                }
            };
            this.size(value, ctx);
            return [
                new $3939d1de148b5202$var$Ptr(0)
            ];
        }
        var ptr = null;
        this.offsetType = {
            encode: function encode(stream, val) {
                return ptr = val;
            }
        };
        _r$Pointer.prototype.encode.call(this, stream, value, ctx);
        return [
            new $3939d1de148b5202$var$Ptr(ptr)
        ];
    };
    return CFFPointer;
}($3939d1de148b5202$var$restructure.Pointer);
var $3939d1de148b5202$var$Ptr = /*#__PURE__*/ function() {
    function Ptr(val) {
        this.val = val;
        this.forceLarge = true;
    }
    var _proto2 = Ptr.prototype;
    _proto2.valueOf = function valueOf() {
        return this.val;
    };
    return Ptr;
}();
var $3939d1de148b5202$var$CFFBlendOp = /*#__PURE__*/ function() {
    function CFFBlendOp() {}
    CFFBlendOp.decode = function decode(stream, parent, operands) {
        var numBlends = operands.pop(); // TODO: actually blend. For now just consume the deltas
        // since we don't use any of the values anyway.
        while(operands.length > numBlends)operands.pop();
    };
    return CFFBlendOp;
}();
var $3939d1de148b5202$var$CFFPrivateDict = new $3939d1de148b5202$var$CFFDict([
    [
        6,
        'BlueValues',
        'delta',
        null
    ],
    [
        7,
        'OtherBlues',
        'delta',
        null
    ],
    [
        8,
        'FamilyBlues',
        'delta',
        null
    ],
    [
        9,
        'FamilyOtherBlues',
        'delta',
        null
    ],
    [
        [
            12,
            9
        ],
        'BlueScale',
        'number',
        0.039625
    ],
    [
        [
            12,
            10
        ],
        'BlueShift',
        'number',
        7
    ],
    [
        [
            12,
            11
        ],
        'BlueFuzz',
        'number',
        1
    ],
    [
        10,
        'StdHW',
        'number',
        null
    ],
    [
        11,
        'StdVW',
        'number',
        null
    ],
    [
        [
            12,
            12
        ],
        'StemSnapH',
        'delta',
        null
    ],
    [
        [
            12,
            13
        ],
        'StemSnapV',
        'delta',
        null
    ],
    [
        [
            12,
            14
        ],
        'ForceBold',
        'boolean',
        false
    ],
    [
        [
            12,
            17
        ],
        'LanguageGroup',
        'number',
        0
    ],
    [
        [
            12,
            18
        ],
        'ExpansionFactor',
        'number',
        0.06
    ],
    [
        [
            12,
            19
        ],
        'initialRandomSeed',
        'number',
        0
    ],
    [
        20,
        'defaultWidthX',
        'number',
        0
    ],
    [
        21,
        'nominalWidthX',
        'number',
        0
    ],
    [
        22,
        'vsindex',
        'number',
        0
    ],
    [
        23,
        'blend',
        $3939d1de148b5202$var$CFFBlendOp,
        null
    ],
    [
        19,
        'Subrs',
        new $3939d1de148b5202$var$CFFPointer(new $3939d1de148b5202$var$CFFIndex(), {
            type: 'local'
        }),
        null
    ]
]);
// Automatically generated from Appendix A of the CFF specification; do
// not edit. Length should be 391.
var $3939d1de148b5202$var$standardStrings = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall",
    "001.000",
    "001.001",
    "001.002",
    "001.003",
    "Black",
    "Bold",
    "Book",
    "Light",
    "Medium",
    "Regular",
    "Roman",
    "Semibold"
];
var $3939d1de148b5202$var$StandardEncoding = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    '',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    '',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    '',
    'questiondown',
    '',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    '',
    'ring',
    'cedilla',
    '',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'AE',
    '',
    'ordfeminine',
    '',
    '',
    '',
    '',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    '',
    '',
    '',
    '',
    '',
    'ae',
    '',
    '',
    '',
    'dotlessi',
    '',
    '',
    'lslash',
    'oslash',
    'oe',
    'germandbls'
];
var $3939d1de148b5202$var$ExpertEncoding = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    '',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    '',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    '',
    '',
    'isuperior',
    '',
    '',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    '',
    '',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    '',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    '',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    '',
    '',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    '',
    'Dotaccentsmall',
    '',
    '',
    'Macronsmall',
    '',
    '',
    'figuredash',
    'hypheninferior',
    '',
    '',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    '',
    '',
    '',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    '',
    '',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
var $3939d1de148b5202$var$ISOAdobeCharset = [
    '.notdef',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    'questiondown',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    'AE',
    'ordfeminine',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    'ae',
    'dotlessi',
    'lslash',
    'oslash',
    'oe',
    'germandbls',
    'onesuperior',
    'logicalnot',
    'mu',
    'trademark',
    'Eth',
    'onehalf',
    'plusminus',
    'Thorn',
    'onequarter',
    'divide',
    'brokenbar',
    'degree',
    'thorn',
    'threequarters',
    'twosuperior',
    'registered',
    'minus',
    'eth',
    'multiply',
    'threesuperior',
    'copyright',
    'Aacute',
    'Acircumflex',
    'Adieresis',
    'Agrave',
    'Aring',
    'Atilde',
    'Ccedilla',
    'Eacute',
    'Ecircumflex',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Ntilde',
    'Oacute',
    'Ocircumflex',
    'Odieresis',
    'Ograve',
    'Otilde',
    'Scaron',
    'Uacute',
    'Ucircumflex',
    'Udieresis',
    'Ugrave',
    'Yacute',
    'Ydieresis',
    'Zcaron',
    'aacute',
    'acircumflex',
    'adieresis',
    'agrave',
    'aring',
    'atilde',
    'ccedilla',
    'eacute',
    'ecircumflex',
    'edieresis',
    'egrave',
    'iacute',
    'icircumflex',
    'idieresis',
    'igrave',
    'ntilde',
    'oacute',
    'ocircumflex',
    'odieresis',
    'ograve',
    'otilde',
    'scaron',
    'uacute',
    'ucircumflex',
    'udieresis',
    'ugrave',
    'yacute',
    'ydieresis',
    'zcaron'
];
var $3939d1de148b5202$var$ExpertCharset = [
    '.notdef',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    'Dotaccentsmall',
    'Macronsmall',
    'figuredash',
    'hypheninferior',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
var $3939d1de148b5202$var$ExpertSubsetCharset = [
    '.notdef',
    'space',
    'dollaroldstyle',
    'dollarsuperior',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'hyphensuperior',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'centoldstyle',
    'figuredash',
    'hypheninferior',
    'onequarter',
    'onehalf',
    'threequarters',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior'
];
// Scripts and Languages #
//########################
var $3939d1de148b5202$var$LangSysTable = new $3939d1de148b5202$var$restructure.Struct({
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
    reqFeatureIndex: $3939d1de148b5202$var$restructure.uint16,
    featureCount: $3939d1de148b5202$var$restructure.uint16,
    featureIndexes: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'featureCount')
});
var $3939d1de148b5202$var$LangSysRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    langSys: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$LangSysTable, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$Script = new $3939d1de148b5202$var$restructure.Struct({
    defaultLangSys: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$LangSysTable),
    count: $3939d1de148b5202$var$restructure.uint16,
    langSysRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LangSysRecord, 'count')
});
var $3939d1de148b5202$var$ScriptRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    script: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Script, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$ScriptList = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$ScriptRecord, $3939d1de148b5202$var$restructure.uint16); //#######################
// Features and Lookups #
//#######################
var $3939d1de148b5202$var$Feature = new $3939d1de148b5202$var$restructure.Struct({
    featureParams: $3939d1de148b5202$var$restructure.uint16,
    // pointer
    lookupCount: $3939d1de148b5202$var$restructure.uint16,
    lookupListIndexes: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'lookupCount')
});
var $3939d1de148b5202$var$FeatureRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    feature: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Feature, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$FeatureList = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FeatureRecord, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$LookupFlags = new $3939d1de148b5202$var$restructure.Struct({
    markAttachmentType: $3939d1de148b5202$var$restructure.uint8,
    flags: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint8, [
        'rightToLeft',
        'ignoreBaseGlyphs',
        'ignoreLigatures',
        'ignoreMarks',
        'useMarkFilteringSet'
    ])
});
function $3939d1de148b5202$var$LookupList(SubTable) {
    var Lookup = new $3939d1de148b5202$var$restructure.Struct({
        lookupType: $3939d1de148b5202$var$restructure.uint16,
        flags: $3939d1de148b5202$var$LookupFlags,
        subTableCount: $3939d1de148b5202$var$restructure.uint16,
        subTables: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, SubTable), 'subTableCount'),
        markFilteringSet: new $3939d1de148b5202$var$restructure.Optional($3939d1de148b5202$var$restructure.uint16, function(t) {
            return t.flags.flags.useMarkFilteringSet;
        })
    });
    return new $3939d1de148b5202$var$restructure.LazyArray(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, Lookup), $3939d1de148b5202$var$restructure.uint16);
} //#################
// Coverage Table #
//#################
var $3939d1de148b5202$var$RangeRecord = new $3939d1de148b5202$var$restructure.Struct({
    start: $3939d1de148b5202$var$restructure.uint16,
    end: $3939d1de148b5202$var$restructure.uint16,
    startCoverageIndex: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$Coverage = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: {
        glyphCount: $3939d1de148b5202$var$restructure.uint16,
        glyphs: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'glyphCount')
    },
    2: {
        rangeCount: $3939d1de148b5202$var$restructure.uint16,
        rangeRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$RangeRecord, 'rangeCount')
    }
}); //#########################
// Class Definition Table #
//#########################
var $3939d1de148b5202$var$ClassRangeRecord = new $3939d1de148b5202$var$restructure.Struct({
    start: $3939d1de148b5202$var$restructure.uint16,
    end: $3939d1de148b5202$var$restructure.uint16,
    "class": $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$ClassDef = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: {
        // Class array
        startGlyph: $3939d1de148b5202$var$restructure.uint16,
        glyphCount: $3939d1de148b5202$var$restructure.uint16,
        classValueArray: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'glyphCount')
    },
    2: {
        // Class ranges
        classRangeCount: $3939d1de148b5202$var$restructure.uint16,
        classRangeRecord: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$ClassRangeRecord, 'classRangeCount')
    }
}); //###############
// Device Table #
//###############
var $3939d1de148b5202$var$Device = new $3939d1de148b5202$var$restructure.Struct({
    a: $3939d1de148b5202$var$restructure.uint16,
    // startSize for hinting Device, outerIndex for VariationIndex
    b: $3939d1de148b5202$var$restructure.uint16,
    // endSize for Device, innerIndex for VariationIndex
    deltaFormat: $3939d1de148b5202$var$restructure.uint16
}); //#############################################
// Contextual Substitution/Positioning Tables #
//#############################################
var $3939d1de148b5202$var$LookupRecord = new $3939d1de148b5202$var$restructure.Struct({
    sequenceIndex: $3939d1de148b5202$var$restructure.uint16,
    lookupListIndex: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$Rule = new $3939d1de148b5202$var$restructure.Struct({
    glyphCount: $3939d1de148b5202$var$restructure.uint16,
    lookupCount: $3939d1de148b5202$var$restructure.uint16,
    input: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, function(t) {
        return t.glyphCount - 1;
    }),
    lookupRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LookupRecord, 'lookupCount')
});
var $3939d1de148b5202$var$RuleSet = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Rule), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$ClassRule = new $3939d1de148b5202$var$restructure.Struct({
    glyphCount: $3939d1de148b5202$var$restructure.uint16,
    lookupCount: $3939d1de148b5202$var$restructure.uint16,
    classes: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, function(t) {
        return t.glyphCount - 1;
    }),
    lookupRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LookupRecord, 'lookupCount')
});
var $3939d1de148b5202$var$ClassSet = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassRule), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$Context = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: {
        // Simple context
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        ruleSetCount: $3939d1de148b5202$var$restructure.uint16,
        ruleSets: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$RuleSet), 'ruleSetCount')
    },
    2: {
        // Class-based context
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        classDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef),
        classSetCnt: $3939d1de148b5202$var$restructure.uint16,
        classSet: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassSet), 'classSetCnt')
    },
    3: {
        glyphCount: $3939d1de148b5202$var$restructure.uint16,
        lookupCount: $3939d1de148b5202$var$restructure.uint16,
        coverages: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage), 'glyphCount'),
        lookupRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LookupRecord, 'lookupCount')
    }
}); //######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################
var $3939d1de148b5202$var$ChainRule = new $3939d1de148b5202$var$restructure.Struct({
    backtrackGlyphCount: $3939d1de148b5202$var$restructure.uint16,
    backtrack: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'backtrackGlyphCount'),
    inputGlyphCount: $3939d1de148b5202$var$restructure.uint16,
    input: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, function(t) {
        return t.inputGlyphCount - 1;
    }),
    lookaheadGlyphCount: $3939d1de148b5202$var$restructure.uint16,
    lookahead: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'lookaheadGlyphCount'),
    lookupCount: $3939d1de148b5202$var$restructure.uint16,
    lookupRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LookupRecord, 'lookupCount')
});
var $3939d1de148b5202$var$ChainRuleSet = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ChainRule), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$ChainingContext = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: {
        // Simple context glyph substitution
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        chainCount: $3939d1de148b5202$var$restructure.uint16,
        chainRuleSets: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ChainRuleSet), 'chainCount')
    },
    2: {
        // Class-based chaining context
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        backtrackClassDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef),
        inputClassDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef),
        lookaheadClassDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef),
        chainCount: $3939d1de148b5202$var$restructure.uint16,
        chainClassSet: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ChainRuleSet), 'chainCount')
    },
    3: {
        // Coverage-based chaining context
        backtrackGlyphCount: $3939d1de148b5202$var$restructure.uint16,
        backtrackCoverage: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage), 'backtrackGlyphCount'),
        inputGlyphCount: $3939d1de148b5202$var$restructure.uint16,
        inputCoverage: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage), 'inputGlyphCount'),
        lookaheadGlyphCount: $3939d1de148b5202$var$restructure.uint16,
        lookaheadCoverage: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage), 'lookaheadGlyphCount'),
        lookupCount: $3939d1de148b5202$var$restructure.uint16,
        lookupRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LookupRecord, 'lookupCount')
    }
});
var $3939d1de148b5202$var$_;
/*******************
 * Variation Store *
 *******************/ var $3939d1de148b5202$var$F2DOT14 = new $3939d1de148b5202$var$restructure.Fixed(16, 'BE', 14);
var $3939d1de148b5202$var$RegionAxisCoordinates = new $3939d1de148b5202$var$restructure.Struct({
    startCoord: $3939d1de148b5202$var$F2DOT14,
    peakCoord: $3939d1de148b5202$var$F2DOT14,
    endCoord: $3939d1de148b5202$var$F2DOT14
});
var $3939d1de148b5202$var$VariationRegionList = new $3939d1de148b5202$var$restructure.Struct({
    axisCount: $3939d1de148b5202$var$restructure.uint16,
    regionCount: $3939d1de148b5202$var$restructure.uint16,
    variationRegions: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$RegionAxisCoordinates, 'axisCount'), 'regionCount')
});
var $3939d1de148b5202$var$DeltaSet = new $3939d1de148b5202$var$restructure.Struct({
    shortDeltas: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int16, function(t) {
        return t.parent.shortDeltaCount;
    }),
    regionDeltas: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int8, function(t) {
        return t.parent.regionIndexCount - t.parent.shortDeltaCount;
    }),
    deltas: function deltas(t) {
        return t.shortDeltas.concat(t.regionDeltas);
    }
});
var $3939d1de148b5202$var$ItemVariationData = new $3939d1de148b5202$var$restructure.Struct({
    itemCount: $3939d1de148b5202$var$restructure.uint16,
    shortDeltaCount: $3939d1de148b5202$var$restructure.uint16,
    regionIndexCount: $3939d1de148b5202$var$restructure.uint16,
    regionIndexes: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'regionIndexCount'),
    deltaSets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$DeltaSet, 'itemCount')
});
var $3939d1de148b5202$var$ItemVariationStore = new $3939d1de148b5202$var$restructure.Struct({
    format: $3939d1de148b5202$var$restructure.uint16,
    variationRegionList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$VariationRegionList),
    variationDataCount: $3939d1de148b5202$var$restructure.uint16,
    itemVariationData: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$ItemVariationData), 'variationDataCount')
});
/**********************
 * Feature Variations *
 **********************/ var $3939d1de148b5202$var$ConditionTable = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: ($3939d1de148b5202$var$_ = {
        axisIndex: $3939d1de148b5202$var$restructure.uint16
    }, $3939d1de148b5202$var$_["axisIndex"] = $3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$_.filterRangeMinValue = $3939d1de148b5202$var$F2DOT14, $3939d1de148b5202$var$_.filterRangeMaxValue = $3939d1de148b5202$var$F2DOT14, $3939d1de148b5202$var$_)
});
var $3939d1de148b5202$var$ConditionSet = new $3939d1de148b5202$var$restructure.Struct({
    conditionCount: $3939d1de148b5202$var$restructure.uint16,
    conditionTable: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$ConditionTable), 'conditionCount')
});
var $3939d1de148b5202$var$FeatureTableSubstitutionRecord = new $3939d1de148b5202$var$restructure.Struct({
    featureIndex: $3939d1de148b5202$var$restructure.uint16,
    alternateFeatureTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$Feature, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$FeatureTableSubstitution = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.fixed32,
    substitutionCount: $3939d1de148b5202$var$restructure.uint16,
    substitutions: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FeatureTableSubstitutionRecord, 'substitutionCount')
});
var $3939d1de148b5202$var$FeatureVariationRecord = new $3939d1de148b5202$var$restructure.Struct({
    conditionSet: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$ConditionSet, {
        type: 'parent'
    }),
    featureTableSubstitution: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$FeatureTableSubstitution, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$FeatureVariations = new $3939d1de148b5202$var$restructure.Struct({
    majorVersion: $3939d1de148b5202$var$restructure.uint16,
    minorVersion: $3939d1de148b5202$var$restructure.uint16,
    featureVariationRecordCount: $3939d1de148b5202$var$restructure.uint32,
    featureVariationRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FeatureVariationRecord, 'featureVariationRecordCount')
});
function $3939d1de148b5202$var$_inheritsLoose$1(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
// otherwise delegates to the provided type.
var $3939d1de148b5202$var$PredefinedOp = /*#__PURE__*/ function() {
    function PredefinedOp(predefinedOps, type) {
        this.predefinedOps = predefinedOps;
        this.type = type;
    }
    var _proto = PredefinedOp.prototype;
    _proto.decode = function decode(stream, parent, operands) {
        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
        return this.type.decode(stream, parent, operands);
    };
    _proto.size = function size(value, ctx) {
        return this.type.size(value, ctx);
    };
    _proto.encode = function encode(stream, value, ctx) {
        var index = this.predefinedOps.indexOf(value);
        if (index !== -1) return index;
        return this.type.encode(stream, value, ctx);
    };
    return PredefinedOp;
}();
var $3939d1de148b5202$var$CFFEncodingVersion = /*#__PURE__*/ function(_r$Number) {
    $3939d1de148b5202$var$_inheritsLoose$1(CFFEncodingVersion, _r$Number);
    function CFFEncodingVersion() {
        return _r$Number.call(this, 'UInt8') || this;
    }
    var _proto2 = CFFEncodingVersion.prototype;
    _proto2.decode = function decode(stream) {
        return $3939d1de148b5202$var$restructure.uint8.decode(stream) & 0x7f;
    };
    return CFFEncodingVersion;
}($3939d1de148b5202$var$restructure.Number);
var $3939d1de148b5202$var$Range1 = new $3939d1de148b5202$var$restructure.Struct({
    first: $3939d1de148b5202$var$restructure.uint16,
    nLeft: $3939d1de148b5202$var$restructure.uint8
});
var $3939d1de148b5202$var$Range2 = new $3939d1de148b5202$var$restructure.Struct({
    first: $3939d1de148b5202$var$restructure.uint16,
    nLeft: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$CFFCustomEncoding = new $3939d1de148b5202$var$restructure.VersionedStruct(new $3939d1de148b5202$var$CFFEncodingVersion(), {
    0: {
        nCodes: $3939d1de148b5202$var$restructure.uint8,
        codes: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, 'nCodes')
    },
    1: {
        nRanges: $3939d1de148b5202$var$restructure.uint8,
        ranges: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Range1, 'nRanges')
    } // TODO: supplement?
});
var $3939d1de148b5202$var$CFFEncoding = new $3939d1de148b5202$var$PredefinedOp([
    $3939d1de148b5202$var$StandardEncoding,
    $3939d1de148b5202$var$ExpertEncoding
], new $3939d1de148b5202$var$CFFPointer($3939d1de148b5202$var$CFFCustomEncoding, {
    lazy: true
})); // Decodes an array of ranges until the total
// length is equal to the provided length.
var $3939d1de148b5202$var$RangeArray = /*#__PURE__*/ function(_r$Array) {
    $3939d1de148b5202$var$_inheritsLoose$1(RangeArray, _r$Array);
    function RangeArray() {
        return _r$Array.apply(this, arguments) || this;
    }
    var _proto3 = RangeArray.prototype;
    _proto3.decode = function decode(stream, parent) {
        var length = $3939d1de148b5202$var$utils_1(this.length, stream, parent);
        var count = 0;
        var res = [];
        while(count < length){
            var range = this.type.decode(stream, parent);
            range.offset = count;
            count += range.nLeft + 1;
            res.push(range);
        }
        return res;
    };
    return RangeArray;
}($3939d1de148b5202$var$restructure.Array);
var $3939d1de148b5202$var$CFFCustomCharset = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint8, {
    0: {
        glyphs: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    },
    1: {
        ranges: new $3939d1de148b5202$var$RangeArray($3939d1de148b5202$var$Range1, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    },
    2: {
        ranges: new $3939d1de148b5202$var$RangeArray($3939d1de148b5202$var$Range2, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    }
});
var $3939d1de148b5202$var$CFFCharset = new $3939d1de148b5202$var$PredefinedOp([
    $3939d1de148b5202$var$ISOAdobeCharset,
    $3939d1de148b5202$var$ExpertCharset,
    $3939d1de148b5202$var$ExpertSubsetCharset
], new $3939d1de148b5202$var$CFFPointer($3939d1de148b5202$var$CFFCustomCharset, {
    lazy: true
}));
var $3939d1de148b5202$var$FDRange3 = new $3939d1de148b5202$var$restructure.Struct({
    first: $3939d1de148b5202$var$restructure.uint16,
    fd: $3939d1de148b5202$var$restructure.uint8
});
var $3939d1de148b5202$var$FDRange4 = new $3939d1de148b5202$var$restructure.Struct({
    first: $3939d1de148b5202$var$restructure.uint32,
    fd: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$FDSelect = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint8, {
    0: {
        fds: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, function(t) {
            return t.parent.CharStrings.length;
        })
    },
    3: {
        nRanges: $3939d1de148b5202$var$restructure.uint16,
        ranges: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FDRange3, 'nRanges'),
        sentinel: $3939d1de148b5202$var$restructure.uint16
    },
    4: {
        nRanges: $3939d1de148b5202$var$restructure.uint32,
        ranges: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FDRange4, 'nRanges'),
        sentinel: $3939d1de148b5202$var$restructure.uint32
    }
});
var $3939d1de148b5202$var$ptr = new $3939d1de148b5202$var$CFFPointer($3939d1de148b5202$var$CFFPrivateDict);
var $3939d1de148b5202$var$CFFPrivateOp = /*#__PURE__*/ function() {
    function CFFPrivateOp() {}
    var _proto4 = CFFPrivateOp.prototype;
    _proto4.decode = function decode(stream, parent, operands) {
        parent.length = operands[0];
        return $3939d1de148b5202$var$ptr.decode(stream, parent, [
            operands[1]
        ]);
    };
    _proto4.size = function size(dict, ctx) {
        return [
            $3939d1de148b5202$var$CFFPrivateDict.size(dict, ctx, false),
            $3939d1de148b5202$var$ptr.size(dict, ctx)[0]
        ];
    };
    _proto4.encode = function encode(stream, dict, ctx) {
        return [
            $3939d1de148b5202$var$CFFPrivateDict.size(dict, ctx, false),
            $3939d1de148b5202$var$ptr.encode(stream, dict, ctx)[0]
        ];
    };
    return CFFPrivateOp;
}();
var $3939d1de148b5202$var$FontDict = new $3939d1de148b5202$var$CFFDict([
    [
        18,
        'Private',
        new $3939d1de148b5202$var$CFFPrivateOp(),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
var $3939d1de148b5202$var$CFFTopDict = new $3939d1de148b5202$var$CFFDict([
    [
        [
            12,
            30
        ],
        'ROS',
        [
            'sid',
            'sid',
            'number'
        ],
        null
    ],
    [
        0,
        'version',
        'sid',
        null
    ],
    [
        1,
        'Notice',
        'sid',
        null
    ],
    [
        [
            12,
            0
        ],
        'Copyright',
        'sid',
        null
    ],
    [
        2,
        'FullName',
        'sid',
        null
    ],
    [
        3,
        'FamilyName',
        'sid',
        null
    ],
    [
        4,
        'Weight',
        'sid',
        null
    ],
    [
        [
            12,
            1
        ],
        'isFixedPitch',
        'boolean',
        false
    ],
    [
        [
            12,
            2
        ],
        'ItalicAngle',
        'number',
        0
    ],
    [
        [
            12,
            3
        ],
        'UnderlinePosition',
        'number',
        -100
    ],
    [
        [
            12,
            4
        ],
        'UnderlineThickness',
        'number',
        50
    ],
    [
        [
            12,
            5
        ],
        'PaintType',
        'number',
        0
    ],
    [
        [
            12,
            6
        ],
        'CharstringType',
        'number',
        2
    ],
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        13,
        'UniqueID',
        'number',
        null
    ],
    [
        5,
        'FontBBox',
        'array',
        [
            0,
            0,
            0,
            0
        ]
    ],
    [
        [
            12,
            8
        ],
        'StrokeWidth',
        'number',
        0
    ],
    [
        14,
        'XUID',
        'array',
        null
    ],
    [
        15,
        'charset',
        $3939d1de148b5202$var$CFFCharset,
        $3939d1de148b5202$var$ISOAdobeCharset
    ],
    [
        16,
        'Encoding',
        $3939d1de148b5202$var$CFFEncoding,
        $3939d1de148b5202$var$StandardEncoding
    ],
    [
        17,
        'CharStrings',
        new $3939d1de148b5202$var$CFFPointer(new $3939d1de148b5202$var$CFFIndex()),
        null
    ],
    [
        18,
        'Private',
        new $3939d1de148b5202$var$CFFPrivateOp(),
        null
    ],
    [
        [
            12,
            20
        ],
        'SyntheticBase',
        'number',
        null
    ],
    [
        [
            12,
            21
        ],
        'PostScript',
        'sid',
        null
    ],
    [
        [
            12,
            22
        ],
        'BaseFontName',
        'sid',
        null
    ],
    [
        [
            12,
            23
        ],
        'BaseFontBlend',
        'delta',
        null
    ],
    [
        [
            12,
            31
        ],
        'CIDFontVersion',
        'number',
        0
    ],
    [
        [
            12,
            32
        ],
        'CIDFontRevision',
        'number',
        0
    ],
    [
        [
            12,
            33
        ],
        'CIDFontType',
        'number',
        0
    ],
    [
        [
            12,
            34
        ],
        'CIDCount',
        'number',
        8720
    ],
    [
        [
            12,
            35
        ],
        'UIDBase',
        'number',
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $3939d1de148b5202$var$CFFPointer($3939d1de148b5202$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $3939d1de148b5202$var$CFFPointer(new $3939d1de148b5202$var$CFFIndex($3939d1de148b5202$var$FontDict)),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
var $3939d1de148b5202$var$VariationStore = new $3939d1de148b5202$var$restructure.Struct({
    length: $3939d1de148b5202$var$restructure.uint16,
    itemVariationStore: $3939d1de148b5202$var$ItemVariationStore
});
var $3939d1de148b5202$var$CFF2TopDict = new $3939d1de148b5202$var$CFFDict([
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        17,
        'CharStrings',
        new $3939d1de148b5202$var$CFFPointer(new $3939d1de148b5202$var$CFFIndex()),
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $3939d1de148b5202$var$CFFPointer($3939d1de148b5202$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $3939d1de148b5202$var$CFFPointer(new $3939d1de148b5202$var$CFFIndex($3939d1de148b5202$var$FontDict)),
        null
    ],
    [
        24,
        'vstore',
        new $3939d1de148b5202$var$CFFPointer($3939d1de148b5202$var$VariationStore),
        null
    ],
    [
        25,
        'maxstack',
        'number',
        193
    ]
]);
var $3939d1de148b5202$var$CFFTop = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.fixed16, {
    1: {
        hdrSize: $3939d1de148b5202$var$restructure.uint8,
        offSize: $3939d1de148b5202$var$restructure.uint8,
        nameIndex: new $3939d1de148b5202$var$CFFIndex(new $3939d1de148b5202$var$restructure.String('length')),
        topDictIndex: new $3939d1de148b5202$var$CFFIndex($3939d1de148b5202$var$CFFTopDict),
        stringIndex: new $3939d1de148b5202$var$CFFIndex(new $3939d1de148b5202$var$restructure.String('length')),
        globalSubrIndex: new $3939d1de148b5202$var$CFFIndex()
    },
    2: {
        hdrSize: $3939d1de148b5202$var$restructure.uint8,
        length: $3939d1de148b5202$var$restructure.uint16,
        topDict: $3939d1de148b5202$var$CFF2TopDict,
        globalSubrIndex: new $3939d1de148b5202$var$CFFIndex()
    }
});
function $3939d1de148b5202$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $3939d1de148b5202$var$CFFFont = /*#__PURE__*/ function() {
    function CFFFont(stream) {
        this.stream = stream;
        this.decode();
    }
    CFFFont.decode = function decode(stream) {
        return new CFFFont(stream);
    };
    var _proto = CFFFont.prototype;
    _proto.decode = function decode() {
        var start = this.stream.pos;
        var top = $3939d1de148b5202$var$CFFTop.decode(this.stream);
        for(var key in top){
            var val = top[key];
            this[key] = val;
        }
        if (this.version < 2) {
            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
            this.topDict = this.topDictIndex[0];
        }
        this.isCIDFont = this.topDict.ROS != null;
        return this;
    };
    _proto.string = function string(sid) {
        if (this.version >= 2) return null;
        if (sid < $3939d1de148b5202$var$standardStrings.length) return $3939d1de148b5202$var$standardStrings[sid];
        return this.stringIndex[sid - $3939d1de148b5202$var$standardStrings.length];
    };
    _proto.getCharString = function getCharString(glyph) {
        this.stream.pos = this.topDict.CharStrings[glyph].offset;
        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
    };
    _proto.getGlyphName = function getGlyphName(gid) {
        // CFF2 glyph names are in the post table.
        if (this.version >= 2) return null;
         // CID-keyed fonts don't have glyph names
        if (this.isCIDFont) return null;
        var charset = this.topDict.charset;
        if (Array.isArray(charset)) return charset[gid];
        if (gid === 0) return '.notdef';
        gid -= 1;
        switch(charset.version){
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for(var i = 0; i < charset.ranges.length; i++){
                    var range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                }
                break;
        }
        return null;
    };
    _proto.fdForGlyph = function fdForGlyph(gid) {
        if (!this.topDict.FDSelect) return null;
        switch(this.topDict.FDSelect.version){
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                var ranges = this.topDict.FDSelect.ranges;
                var low = 0;
                var high = ranges.length - 1;
                while(low <= high){
                    var mid = low + high >> 1;
                    if (gid < ranges[mid].first) high = mid - 1;
                    else if (mid < high && gid > ranges[mid + 1].first) low = mid + 1;
                    else return ranges[mid].fd;
                }
            default:
                throw new Error("Unknown FDSelect version: " + this.topDict.FDSelect.version);
        }
    };
    _proto.privateDictForGlyph = function privateDictForGlyph(gid) {
        if (this.topDict.FDSelect) {
            var fd = this.fdForGlyph(gid);
            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
            return null;
        }
        if (this.version < 2) return this.topDict.Private;
        return this.topDict.FDArray[0].Private;
    };
    $3939d1de148b5202$var$_createClass(CFFFont, [
        {
            key: "postscriptName",
            get: function get() {
                if (this.version < 2) return this.nameIndex[0];
                return null;
            }
        },
        {
            key: "fullName",
            get: function get() {
                return this.string(this.topDict.FullName);
            }
        },
        {
            key: "familyName",
            get: function get() {
                return this.string(this.topDict.FamilyName);
            }
        }
    ]);
    return CFFFont;
}();
var $3939d1de148b5202$var$VerticalOrigin = new $3939d1de148b5202$var$restructure.Struct({
    glyphIndex: $3939d1de148b5202$var$restructure.uint16,
    vertOriginY: $3939d1de148b5202$var$restructure.int16
});
var $3939d1de148b5202$var$VORG = new $3939d1de148b5202$var$restructure.Struct({
    majorVersion: $3939d1de148b5202$var$restructure.uint16,
    minorVersion: $3939d1de148b5202$var$restructure.uint16,
    defaultVertOriginY: $3939d1de148b5202$var$restructure.int16,
    numVertOriginYMetrics: $3939d1de148b5202$var$restructure.uint16,
    metrics: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$VerticalOrigin, 'numVertOriginYMetrics')
});
var $3939d1de148b5202$var$BigMetrics = new $3939d1de148b5202$var$restructure.Struct({
    height: $3939d1de148b5202$var$restructure.uint8,
    width: $3939d1de148b5202$var$restructure.uint8,
    horiBearingX: $3939d1de148b5202$var$restructure.int8,
    horiBearingY: $3939d1de148b5202$var$restructure.int8,
    horiAdvance: $3939d1de148b5202$var$restructure.uint8,
    vertBearingX: $3939d1de148b5202$var$restructure.int8,
    vertBearingY: $3939d1de148b5202$var$restructure.int8,
    vertAdvance: $3939d1de148b5202$var$restructure.uint8
});
var $3939d1de148b5202$var$SmallMetrics = new $3939d1de148b5202$var$restructure.Struct({
    height: $3939d1de148b5202$var$restructure.uint8,
    width: $3939d1de148b5202$var$restructure.uint8,
    bearingX: $3939d1de148b5202$var$restructure.int8,
    bearingY: $3939d1de148b5202$var$restructure.int8,
    advance: $3939d1de148b5202$var$restructure.uint8
});
var $3939d1de148b5202$var$EBDTComponent = new $3939d1de148b5202$var$restructure.Struct({
    glyph: $3939d1de148b5202$var$restructure.uint16,
    xOffset: $3939d1de148b5202$var$restructure.int8,
    yOffset: $3939d1de148b5202$var$restructure.int8
});
var $3939d1de148b5202$var$ByteAligned = function ByteAligned() {};
var $3939d1de148b5202$var$BitAligned = function BitAligned() {};
var $3939d1de148b5202$var$glyph = new $3939d1de148b5202$var$restructure.VersionedStruct('version', {
    1: {
        metrics: $3939d1de148b5202$var$SmallMetrics,
        data: $3939d1de148b5202$var$ByteAligned
    },
    2: {
        metrics: $3939d1de148b5202$var$SmallMetrics,
        data: $3939d1de148b5202$var$BitAligned
    },
    // format 3 is deprecated
    // format 4 is not supported by Microsoft
    5: {
        data: $3939d1de148b5202$var$BitAligned
    },
    6: {
        metrics: $3939d1de148b5202$var$BigMetrics,
        data: $3939d1de148b5202$var$ByteAligned
    },
    7: {
        metrics: $3939d1de148b5202$var$BigMetrics,
        data: $3939d1de148b5202$var$BitAligned
    },
    8: {
        metrics: $3939d1de148b5202$var$SmallMetrics,
        pad: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8),
        numComponents: $3939d1de148b5202$var$restructure.uint16,
        components: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$EBDTComponent, 'numComponents')
    },
    9: {
        metrics: $3939d1de148b5202$var$BigMetrics,
        pad: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8),
        numComponents: $3939d1de148b5202$var$restructure.uint16,
        components: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$EBDTComponent, 'numComponents')
    },
    17: {
        metrics: $3939d1de148b5202$var$SmallMetrics,
        dataLen: $3939d1de148b5202$var$restructure.uint32,
        data: new $3939d1de148b5202$var$restructure.Buffer('dataLen')
    },
    18: {
        metrics: $3939d1de148b5202$var$BigMetrics,
        dataLen: $3939d1de148b5202$var$restructure.uint32,
        data: new $3939d1de148b5202$var$restructure.Buffer('dataLen')
    },
    19: {
        dataLen: $3939d1de148b5202$var$restructure.uint32,
        data: new $3939d1de148b5202$var$restructure.Buffer('dataLen')
    }
});
var $3939d1de148b5202$var$SBitLineMetrics = new $3939d1de148b5202$var$restructure.Struct({
    ascender: $3939d1de148b5202$var$restructure.int8,
    descender: $3939d1de148b5202$var$restructure.int8,
    widthMax: $3939d1de148b5202$var$restructure.uint8,
    caretSlopeNumerator: $3939d1de148b5202$var$restructure.int8,
    caretSlopeDenominator: $3939d1de148b5202$var$restructure.int8,
    caretOffset: $3939d1de148b5202$var$restructure.int8,
    minOriginSB: $3939d1de148b5202$var$restructure.int8,
    minAdvanceSB: $3939d1de148b5202$var$restructure.int8,
    maxBeforeBL: $3939d1de148b5202$var$restructure.int8,
    minAfterBL: $3939d1de148b5202$var$restructure.int8,
    pad: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.int8, 2)
});
var $3939d1de148b5202$var$CodeOffsetPair = new $3939d1de148b5202$var$restructure.Struct({
    glyphCode: $3939d1de148b5202$var$restructure.uint16,
    offset: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$IndexSubtable = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    header: {
        imageFormat: $3939d1de148b5202$var$restructure.uint16,
        imageDataOffset: $3939d1de148b5202$var$restructure.uint32
    },
    1: {
        offsetArray: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, function(t) {
            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
        })
    },
    2: {
        imageSize: $3939d1de148b5202$var$restructure.uint32,
        bigMetrics: $3939d1de148b5202$var$BigMetrics
    },
    3: {
        offsetArray: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, function(t) {
            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
        })
    },
    4: {
        numGlyphs: $3939d1de148b5202$var$restructure.uint32,
        glyphArray: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$CodeOffsetPair, function(t) {
            return t.numGlyphs + 1;
        })
    },
    5: {
        imageSize: $3939d1de148b5202$var$restructure.uint32,
        bigMetrics: $3939d1de148b5202$var$BigMetrics,
        numGlyphs: $3939d1de148b5202$var$restructure.uint32,
        glyphCodeArray: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'numGlyphs')
    }
});
var $3939d1de148b5202$var$IndexSubtableArray = new $3939d1de148b5202$var$restructure.Struct({
    firstGlyphIndex: $3939d1de148b5202$var$restructure.uint16,
    lastGlyphIndex: $3939d1de148b5202$var$restructure.uint16,
    subtable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$IndexSubtable)
});
var $3939d1de148b5202$var$BitmapSizeTable = new $3939d1de148b5202$var$restructure.Struct({
    indexSubTableArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$IndexSubtableArray, 1), {
        type: 'parent'
    }),
    indexTablesSize: $3939d1de148b5202$var$restructure.uint32,
    numberOfIndexSubTables: $3939d1de148b5202$var$restructure.uint32,
    colorRef: $3939d1de148b5202$var$restructure.uint32,
    hori: $3939d1de148b5202$var$SBitLineMetrics,
    vert: $3939d1de148b5202$var$SBitLineMetrics,
    startGlyphIndex: $3939d1de148b5202$var$restructure.uint16,
    endGlyphIndex: $3939d1de148b5202$var$restructure.uint16,
    ppemX: $3939d1de148b5202$var$restructure.uint8,
    ppemY: $3939d1de148b5202$var$restructure.uint8,
    bitDepth: $3939d1de148b5202$var$restructure.uint8,
    flags: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint8, [
        'horizontal',
        'vertical'
    ])
});
var $3939d1de148b5202$var$EBLC = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint32,
    // 0x00020000
    numSizes: $3939d1de148b5202$var$restructure.uint32,
    sizes: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$BitmapSizeTable, 'numSizes')
});
var $3939d1de148b5202$var$ImageTable = new $3939d1de148b5202$var$restructure.Struct({
    ppem: $3939d1de148b5202$var$restructure.uint16,
    resolution: $3939d1de148b5202$var$restructure.uint16,
    imageOffsets: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, 'void'), function(t) {
        return t.parent.parent.maxp.numGlyphs + 1;
    })
}); // This is the Apple sbix table, used by the "Apple Color Emoji" font.
// It includes several image tables with images for each bitmap glyph
// of several different sizes.
var $3939d1de148b5202$var$sbix = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    flags: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint16, [
        'renderOutlines'
    ]),
    numImgTables: $3939d1de148b5202$var$restructure.uint32,
    imageTables: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$ImageTable), 'numImgTables')
});
var $3939d1de148b5202$var$LayerRecord = new $3939d1de148b5202$var$restructure.Struct({
    gid: $3939d1de148b5202$var$restructure.uint16,
    // Glyph ID of layer glyph (must be in z-order from bottom to top).
    paletteIndex: $3939d1de148b5202$var$restructure.uint16 // Index value to use in the appropriate palette. This value must
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.
var $3939d1de148b5202$var$BaseGlyphRecord = new $3939d1de148b5202$var$restructure.Struct({
    gid: $3939d1de148b5202$var$restructure.uint16,
    // Glyph ID of reference glyph. This glyph is for reference only
    // and is not rendered for color.
    firstLayerIndex: $3939d1de148b5202$var$restructure.uint16,
    // Index (from beginning of the Layer Records) to the layer record.
    // There will be numLayers consecutive entries for this base glyph.
    numLayers: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$COLR = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    numBaseGlyphRecords: $3939d1de148b5202$var$restructure.uint16,
    baseGlyphRecord: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$BaseGlyphRecord, 'numBaseGlyphRecords')),
    layerRecords: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$LayerRecord, 'numLayerRecords'), {
        lazy: true
    }),
    numLayerRecords: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$ColorRecord = new $3939d1de148b5202$var$restructure.Struct({
    blue: $3939d1de148b5202$var$restructure.uint8,
    green: $3939d1de148b5202$var$restructure.uint8,
    red: $3939d1de148b5202$var$restructure.uint8,
    alpha: $3939d1de148b5202$var$restructure.uint8
});
var $3939d1de148b5202$var$CPAL = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    header: {
        numPaletteEntries: $3939d1de148b5202$var$restructure.uint16,
        numPalettes: $3939d1de148b5202$var$restructure.uint16,
        numColorRecords: $3939d1de148b5202$var$restructure.uint16,
        colorRecords: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$ColorRecord, 'numColorRecords')),
        colorRecordIndices: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'numPalettes')
    },
    0: {},
    1: {
        offsetPaletteTypeArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, 'numPalettes')),
        offsetPaletteLabelArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'numPalettes')),
        offsetPaletteEntryLabelArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'numPaletteEntries'))
    }
});
var $3939d1de148b5202$var$BaseCoord = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: {
        // Design units only
        coordinate: $3939d1de148b5202$var$restructure.int16 // X or Y value, in design units
    },
    2: {
        // Design units plus contour point
        coordinate: $3939d1de148b5202$var$restructure.int16,
        // X or Y value, in design units
        referenceGlyph: $3939d1de148b5202$var$restructure.uint16,
        // GlyphID of control glyph
        baseCoordPoint: $3939d1de148b5202$var$restructure.uint16 // Index of contour point on the referenceGlyph
    },
    3: {
        // Design units plus Device table
        coordinate: $3939d1de148b5202$var$restructure.int16,
        // X or Y value, in design units
        deviceTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device) // Device table for X or Y value
    }
});
var $3939d1de148b5202$var$BaseValues = new $3939d1de148b5202$var$restructure.Struct({
    defaultIndex: $3939d1de148b5202$var$restructure.uint16,
    // Index of default baseline for this script-same index in the BaseTagList
    baseCoordCount: $3939d1de148b5202$var$restructure.uint16,
    baseCoords: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseCoord), 'baseCoordCount')
});
var $3939d1de148b5202$var$FeatMinMaxRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    // 4-byte feature identification tag-must match FeatureTag in FeatureList
    minCoord: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseCoord, {
        type: 'parent'
    }),
    // May be NULL
    maxCoord: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseCoord, {
        type: 'parent'
    }) // May be NULL
});
var $3939d1de148b5202$var$MinMax = new $3939d1de148b5202$var$restructure.Struct({
    minCoord: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseCoord),
    // May be NULL
    maxCoord: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseCoord),
    // May be NULL
    featMinMaxCount: $3939d1de148b5202$var$restructure.uint16,
    // May be 0
    featMinMaxRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
});
var $3939d1de148b5202$var$BaseLangSysRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    // 4-byte language system identification tag
    minMax: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$MinMax, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$BaseScript = new $3939d1de148b5202$var$restructure.Struct({
    baseValues: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseValues),
    // May be NULL
    defaultMinMax: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$MinMax),
    // May be NULL
    baseLangSysCount: $3939d1de148b5202$var$restructure.uint16,
    // May be 0
    baseLangSysRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
});
var $3939d1de148b5202$var$BaseScriptRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    // 4-byte script identification tag
    script: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseScript, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$BaseScriptList = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$BaseScriptRecord, $3939d1de148b5202$var$restructure.uint16); // Array of 4-byte baseline identification tags-must be in alphabetical order
var $3939d1de148b5202$var$BaseTagList = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.String(4), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$Axis = new $3939d1de148b5202$var$restructure.Struct({
    baseTagList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseTagList),
    // May be NULL
    baseScriptList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseScriptList)
});
var $3939d1de148b5202$var$BASE = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint32, {
    header: {
        horizAxis: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Axis),
        // May be NULL
        vertAxis: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Axis) // May be NULL
    },
    0x00010000: {},
    0x00010001: {
        itemVariationStore: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$ItemVariationStore)
    }
});
var $3939d1de148b5202$var$AttachPoint = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$AttachList = new $3939d1de148b5202$var$restructure.Struct({
    coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
    glyphCount: $3939d1de148b5202$var$restructure.uint16,
    attachPoints: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$AttachPoint), 'glyphCount')
});
var $3939d1de148b5202$var$CaretValue = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: {
        // Design units only
        coordinate: $3939d1de148b5202$var$restructure.int16
    },
    2: {
        // Contour point
        caretValuePoint: $3939d1de148b5202$var$restructure.uint16
    },
    3: {
        // Design units plus Device table
        coordinate: $3939d1de148b5202$var$restructure.int16,
        deviceTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device)
    }
});
var $3939d1de148b5202$var$LigGlyph = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$CaretValue), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$LigCaretList = new $3939d1de148b5202$var$restructure.Struct({
    coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
    ligGlyphCount: $3939d1de148b5202$var$restructure.uint16,
    ligGlyphs: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$LigGlyph), 'ligGlyphCount')
});
var $3939d1de148b5202$var$MarkGlyphSetsDef = new $3939d1de148b5202$var$restructure.Struct({
    markSetTableFormat: $3939d1de148b5202$var$restructure.uint16,
    markSetCount: $3939d1de148b5202$var$restructure.uint16,
    coverage: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$Coverage), 'markSetCount')
});
var $3939d1de148b5202$var$GDEF = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint32, {
    header: {
        glyphClassDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef),
        attachList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$AttachList),
        ligCaretList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$LigCaretList),
        markAttachClassDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef)
    },
    0x00010000: {},
    0x00010002: {
        markGlyphSetsDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$MarkGlyphSetsDef)
    },
    0x00010003: {
        markGlyphSetsDef: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$MarkGlyphSetsDef),
        itemVariationStore: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$ItemVariationStore)
    }
});
var $3939d1de148b5202$var$ValueFormat = new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint16, [
    'xPlacement',
    'yPlacement',
    'xAdvance',
    'yAdvance',
    'xPlaDevice',
    'yPlaDevice',
    'xAdvDevice',
    'yAdvDevice'
]);
var $3939d1de148b5202$var$types = {
    xPlacement: $3939d1de148b5202$var$restructure.int16,
    yPlacement: $3939d1de148b5202$var$restructure.int16,
    xAdvance: $3939d1de148b5202$var$restructure.int16,
    yAdvance: $3939d1de148b5202$var$restructure.int16,
    xPlaDevice: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    yPlaDevice: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    xAdvDevice: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    yAdvDevice: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    })
};
var $3939d1de148b5202$var$ValueRecord = /*#__PURE__*/ function() {
    function ValueRecord(key) {
        if (key === void 0) key = 'valueFormat';
        this.key = key;
    }
    var _proto = ValueRecord.prototype;
    _proto.buildStruct = function buildStruct(parent) {
        var struct = parent;
        while(!struct[this.key] && struct.parent)struct = struct.parent;
        if (!struct[this.key]) return;
        var fields = {};
        fields.rel = function() {
            return struct._startOffset;
        };
        var format = struct[this.key];
        for(var key in format)if (format[key]) fields[key] = $3939d1de148b5202$var$types[key];
        return new $3939d1de148b5202$var$restructure.Struct(fields);
    };
    _proto.size = function size(val, ctx) {
        return this.buildStruct(ctx).size(val, ctx);
    };
    _proto.decode = function decode(stream, parent) {
        var res = this.buildStruct(parent).decode(stream, parent);
        delete res.rel;
        return res;
    };
    return ValueRecord;
}();
var $3939d1de148b5202$var$PairValueRecord = new $3939d1de148b5202$var$restructure.Struct({
    secondGlyph: $3939d1de148b5202$var$restructure.uint16,
    value1: new $3939d1de148b5202$var$ValueRecord('valueFormat1'),
    value2: new $3939d1de148b5202$var$ValueRecord('valueFormat2')
});
var $3939d1de148b5202$var$PairSet = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$PairValueRecord, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$Class2Record = new $3939d1de148b5202$var$restructure.Struct({
    value1: new $3939d1de148b5202$var$ValueRecord('valueFormat1'),
    value2: new $3939d1de148b5202$var$ValueRecord('valueFormat2')
});
var $3939d1de148b5202$var$Anchor = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    1: {
        // Design units only
        xCoordinate: $3939d1de148b5202$var$restructure.int16,
        yCoordinate: $3939d1de148b5202$var$restructure.int16
    },
    2: {
        // Design units plus contour point
        xCoordinate: $3939d1de148b5202$var$restructure.int16,
        yCoordinate: $3939d1de148b5202$var$restructure.int16,
        anchorPoint: $3939d1de148b5202$var$restructure.uint16
    },
    3: {
        // Design units plus Device tables
        xCoordinate: $3939d1de148b5202$var$restructure.int16,
        yCoordinate: $3939d1de148b5202$var$restructure.int16,
        xDeviceTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device),
        yDeviceTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Device)
    }
});
var $3939d1de148b5202$var$EntryExitRecord = new $3939d1de148b5202$var$restructure.Struct({
    entryAnchor: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Anchor, {
        type: 'parent'
    }),
    exitAnchor: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Anchor, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$MarkRecord = new $3939d1de148b5202$var$restructure.Struct({
    "class": $3939d1de148b5202$var$restructure.uint16,
    markAnchor: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Anchor, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$MarkArray = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$MarkRecord, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$BaseRecord = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Anchor), function(t) {
    return t.parent.classCount;
});
var $3939d1de148b5202$var$BaseArray = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$BaseRecord, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$ComponentRecord = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Anchor), function(t) {
    return t.parent.parent.classCount;
});
var $3939d1de148b5202$var$LigatureAttach = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$ComponentRecord, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$LigatureArray = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$LigatureAttach), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$GPOSLookup = new $3939d1de148b5202$var$restructure.VersionedStruct('lookupType', {
    1: new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
        // Single Adjustment
        1: {
            // Single positioning value
            coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
            valueFormat: $3939d1de148b5202$var$ValueFormat,
            value: new $3939d1de148b5202$var$ValueRecord()
        },
        2: {
            coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
            valueFormat: $3939d1de148b5202$var$ValueFormat,
            valueCount: $3939d1de148b5202$var$restructure.uint16,
            values: new $3939d1de148b5202$var$restructure.LazyArray(new $3939d1de148b5202$var$ValueRecord(), 'valueCount')
        }
    }),
    2: new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
        // Pair Adjustment Positioning
        1: {
            // Adjustments for glyph pairs
            coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
            valueFormat1: $3939d1de148b5202$var$ValueFormat,
            valueFormat2: $3939d1de148b5202$var$ValueFormat,
            pairSetCount: $3939d1de148b5202$var$restructure.uint16,
            pairSets: new $3939d1de148b5202$var$restructure.LazyArray(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$PairSet), 'pairSetCount')
        },
        2: {
            // Class pair adjustment
            coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
            valueFormat1: $3939d1de148b5202$var$ValueFormat,
            valueFormat2: $3939d1de148b5202$var$ValueFormat,
            classDef1: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef),
            classDef2: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassDef),
            class1Count: $3939d1de148b5202$var$restructure.uint16,
            class2Count: $3939d1de148b5202$var$restructure.uint16,
            classRecords: new $3939d1de148b5202$var$restructure.LazyArray(new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$Class2Record, 'class2Count'), 'class1Count')
        }
    }),
    3: {
        // Cursive Attachment Positioning
        format: $3939d1de148b5202$var$restructure.uint16,
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        entryExitCount: $3939d1de148b5202$var$restructure.uint16,
        entryExitRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$EntryExitRecord, 'entryExitCount')
    },
    4: {
        // MarkToBase Attachment Positioning
        format: $3939d1de148b5202$var$restructure.uint16,
        markCoverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        baseCoverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        classCount: $3939d1de148b5202$var$restructure.uint16,
        markArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$MarkArray),
        baseArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseArray)
    },
    5: {
        // MarkToLigature Attachment Positioning
        format: $3939d1de148b5202$var$restructure.uint16,
        markCoverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        ligatureCoverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        classCount: $3939d1de148b5202$var$restructure.uint16,
        markArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$MarkArray),
        ligatureArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$LigatureArray)
    },
    6: {
        // MarkToMark Attachment Positioning
        format: $3939d1de148b5202$var$restructure.uint16,
        mark1Coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        mark2Coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        classCount: $3939d1de148b5202$var$restructure.uint16,
        mark1Array: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$MarkArray),
        mark2Array: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$BaseArray)
    },
    7: $3939d1de148b5202$var$Context,
    // Contextual positioning
    8: $3939d1de148b5202$var$ChainingContext,
    // Chaining contextual positioning
    9: {
        // Extension Positioning
        posFormat: $3939d1de148b5202$var$restructure.uint16,
        lookupType: $3939d1de148b5202$var$restructure.uint16,
        // cannot also be 9
        extension: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$GPOSLookup)
    }
}); // Fix circular reference
$3939d1de148b5202$var$GPOSLookup.versions[9].extension.type = $3939d1de148b5202$var$GPOSLookup;
var $3939d1de148b5202$var$GPOS = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint32, {
    header: {
        scriptList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ScriptList),
        featureList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$FeatureList),
        lookupList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$LookupList($3939d1de148b5202$var$GPOSLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$FeatureVariations)
    }
}); // export GPOSLookup for JSTF table
var $3939d1de148b5202$var$Sequence = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$AlternateSet = $3939d1de148b5202$var$Sequence;
var $3939d1de148b5202$var$Ligature = new $3939d1de148b5202$var$restructure.Struct({
    glyph: $3939d1de148b5202$var$restructure.uint16,
    compCount: $3939d1de148b5202$var$restructure.uint16,
    components: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, function(t) {
        return t.compCount - 1;
    })
});
var $3939d1de148b5202$var$LigatureSet = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Ligature), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$GSUBLookup = new $3939d1de148b5202$var$restructure.VersionedStruct('lookupType', {
    1: new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
        // Single Substitution
        1: {
            coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
            deltaGlyphID: $3939d1de148b5202$var$restructure.int16
        },
        2: {
            coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
            glyphCount: $3939d1de148b5202$var$restructure.uint16,
            substitute: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.uint16, 'glyphCount')
        }
    }),
    2: {
        // Multiple Substitution
        substFormat: $3939d1de148b5202$var$restructure.uint16,
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        count: $3939d1de148b5202$var$restructure.uint16,
        sequences: new $3939d1de148b5202$var$restructure.LazyArray(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Sequence), 'count')
    },
    3: {
        // Alternate Substitution
        substFormat: $3939d1de148b5202$var$restructure.uint16,
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        count: $3939d1de148b5202$var$restructure.uint16,
        alternateSet: new $3939d1de148b5202$var$restructure.LazyArray(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$AlternateSet), 'count')
    },
    4: {
        // Ligature Substitution
        substFormat: $3939d1de148b5202$var$restructure.uint16,
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        count: $3939d1de148b5202$var$restructure.uint16,
        ligatureSets: new $3939d1de148b5202$var$restructure.LazyArray(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$LigatureSet), 'count')
    },
    5: $3939d1de148b5202$var$Context,
    // Contextual Substitution
    6: $3939d1de148b5202$var$ChainingContext,
    // Chaining Contextual Substitution
    7: {
        // Extension Substitution
        substFormat: $3939d1de148b5202$var$restructure.uint16,
        lookupType: $3939d1de148b5202$var$restructure.uint16,
        // cannot also be 7
        extension: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$GSUBLookup)
    },
    8: {
        // Reverse Chaining Contextual Single Substitution
        substFormat: $3939d1de148b5202$var$restructure.uint16,
        coverage: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage),
        backtrackCoverage: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage), 'backtrackGlyphCount'),
        lookaheadGlyphCount: $3939d1de148b5202$var$restructure.uint16,
        lookaheadCoverage: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Coverage), 'lookaheadGlyphCount'),
        glyphCount: $3939d1de148b5202$var$restructure.uint16,
        substitutes: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'glyphCount')
    }
}); // Fix circular reference
$3939d1de148b5202$var$GSUBLookup.versions[7].extension.type = $3939d1de148b5202$var$GSUBLookup;
var $3939d1de148b5202$var$GSUB = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint32, {
    header: {
        scriptList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ScriptList),
        featureList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$FeatureList),
        lookupList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$LookupList($3939d1de148b5202$var$GSUBLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$FeatureVariations)
    }
});
var $3939d1de148b5202$var$JstfGSUBModList = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$JstfPriority = new $3939d1de148b5202$var$restructure.Struct({
    shrinkageEnableGSUB: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    shrinkageDisableGSUB: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    shrinkageEnableGPOS: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    shrinkageDisableGPOS: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    shrinkageJstfMax: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$LookupList($3939d1de148b5202$var$GPOSLookup)),
    extensionEnableGSUB: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    extensionDisableGSUB: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    extensionEnableGPOS: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    extensionDisableGPOS: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfGSUBModList),
    extensionJstfMax: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$LookupList($3939d1de148b5202$var$GPOSLookup))
});
var $3939d1de148b5202$var$JstfLangSys = new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfPriority), $3939d1de148b5202$var$restructure.uint16);
var $3939d1de148b5202$var$JstfLangSysRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    jstfLangSys: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfLangSys)
});
var $3939d1de148b5202$var$JstfScript = new $3939d1de148b5202$var$restructure.Struct({
    extenderGlyphs: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$restructure.uint16)),
    // array of glyphs to extend line length
    defaultLangSys: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfLangSys),
    langSysCount: $3939d1de148b5202$var$restructure.uint16,
    langSysRecords: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$JstfLangSysRecord, 'langSysCount')
});
var $3939d1de148b5202$var$JstfScriptRecord = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    script: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JstfScript, {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$JSTF = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint32,
    // should be 0x00010000
    scriptCount: $3939d1de148b5202$var$restructure.uint16,
    scriptList: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$JstfScriptRecord, 'scriptCount')
});
var $3939d1de148b5202$var$VariableSizeNumber = /*#__PURE__*/ function() {
    function VariableSizeNumber(size) {
        this._size = size;
    }
    var _proto = VariableSizeNumber.prototype;
    _proto.decode = function decode(stream, parent) {
        switch(this.size(0, parent)){
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
        }
    };
    _proto.size = function size(val, parent) {
        return $3939d1de148b5202$var$utils_1(this._size, null, parent);
    };
    return VariableSizeNumber;
}();
var $3939d1de148b5202$var$MapDataEntry = new $3939d1de148b5202$var$restructure.Struct({
    entry: new $3939d1de148b5202$var$VariableSizeNumber(function(t) {
        return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
    }),
    outerIndex: function outerIndex(t) {
        return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
    },
    innerIndex: function innerIndex(t) {
        return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
    }
});
var $3939d1de148b5202$var$DeltaSetIndexMap = new $3939d1de148b5202$var$restructure.Struct({
    entryFormat: $3939d1de148b5202$var$restructure.uint16,
    mapCount: $3939d1de148b5202$var$restructure.uint16,
    mapData: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$MapDataEntry, 'mapCount')
});
var $3939d1de148b5202$var$HVAR = new $3939d1de148b5202$var$restructure.Struct({
    majorVersion: $3939d1de148b5202$var$restructure.uint16,
    minorVersion: $3939d1de148b5202$var$restructure.uint16,
    itemVariationStore: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$ItemVariationStore),
    advanceWidthMapping: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$DeltaSetIndexMap),
    LSBMapping: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$DeltaSetIndexMap),
    RSBMapping: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$DeltaSetIndexMap)
});
var $3939d1de148b5202$var$Signature = new $3939d1de148b5202$var$restructure.Struct({
    format: $3939d1de148b5202$var$restructure.uint32,
    length: $3939d1de148b5202$var$restructure.uint32,
    offset: $3939d1de148b5202$var$restructure.uint32
});
var $3939d1de148b5202$var$SignatureBlock = new $3939d1de148b5202$var$restructure.Struct({
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16, 2),
    cbSignature: $3939d1de148b5202$var$restructure.uint32,
    // Length (in bytes) of the PKCS#7 packet in pbSignature
    signature: new $3939d1de148b5202$var$restructure.Buffer('cbSignature')
});
var $3939d1de148b5202$var$DSIG = new $3939d1de148b5202$var$restructure.Struct({
    ulVersion: $3939d1de148b5202$var$restructure.uint32,
    // Version number of the DSIG table (0x00000001)
    usNumSigs: $3939d1de148b5202$var$restructure.uint16,
    // Number of signatures in the table
    usFlag: $3939d1de148b5202$var$restructure.uint16,
    // Permission flags
    signatures: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Signature, 'usNumSigs'),
    signatureBlocks: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$SignatureBlock, 'usNumSigs')
});
var $3939d1de148b5202$var$GaspRange = new $3939d1de148b5202$var$restructure.Struct({
    rangeMaxPPEM: $3939d1de148b5202$var$restructure.uint16,
    // Upper limit of range, in ppem
    rangeGaspBehavior: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint16, [
        'grayscale',
        'gridfit',
        'symmetricSmoothing',
        'symmetricGridfit' // only in version 1, for ClearType
    ])
});
var $3939d1de148b5202$var$gasp = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    // set to 0
    numRanges: $3939d1de148b5202$var$restructure.uint16,
    gaspRanges: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$GaspRange, 'numRanges') // Sorted by ppem
});
var $3939d1de148b5202$var$DeviceRecord = new $3939d1de148b5202$var$restructure.Struct({
    pixelSize: $3939d1de148b5202$var$restructure.uint8,
    maximumWidth: $3939d1de148b5202$var$restructure.uint8,
    widths: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, function(t) {
        return t.parent.parent.maxp.numGlyphs;
    })
}); // The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
var $3939d1de148b5202$var$hdmx = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    numRecords: $3939d1de148b5202$var$restructure.int16,
    sizeDeviceRecord: $3939d1de148b5202$var$restructure.int32,
    records: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$DeviceRecord, 'numRecords')
});
var $3939d1de148b5202$var$KernPair = new $3939d1de148b5202$var$restructure.Struct({
    left: $3939d1de148b5202$var$restructure.uint16,
    right: $3939d1de148b5202$var$restructure.uint16,
    value: $3939d1de148b5202$var$restructure.int16
});
var $3939d1de148b5202$var$ClassTable = new $3939d1de148b5202$var$restructure.Struct({
    firstGlyph: $3939d1de148b5202$var$restructure.uint16,
    nGlyphs: $3939d1de148b5202$var$restructure.uint16,
    offsets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'nGlyphs'),
    max: function max(t) {
        return t.offsets.length && Math.max.apply(Math, t.offsets);
    }
});
var $3939d1de148b5202$var$Kern2Array = new $3939d1de148b5202$var$restructure.Struct({
    off: function off(t) {
        return t._startOffset - t.parent.parent._startOffset;
    },
    len: function len(t) {
        return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
    },
    values: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.int16, 'len')
});
var $3939d1de148b5202$var$KernSubtable = new $3939d1de148b5202$var$restructure.VersionedStruct('format', {
    0: {
        nPairs: $3939d1de148b5202$var$restructure.uint16,
        searchRange: $3939d1de148b5202$var$restructure.uint16,
        entrySelector: $3939d1de148b5202$var$restructure.uint16,
        rangeShift: $3939d1de148b5202$var$restructure.uint16,
        pairs: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$KernPair, 'nPairs')
    },
    2: {
        rowWidth: $3939d1de148b5202$var$restructure.uint16,
        leftTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassTable, {
            type: 'parent'
        }),
        rightTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassTable, {
            type: 'parent'
        }),
        array: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$Kern2Array, {
            type: 'parent'
        })
    },
    3: {
        glyphCount: $3939d1de148b5202$var$restructure.uint16,
        kernValueCount: $3939d1de148b5202$var$restructure.uint8,
        leftClassCount: $3939d1de148b5202$var$restructure.uint8,
        rightClassCount: $3939d1de148b5202$var$restructure.uint8,
        flags: $3939d1de148b5202$var$restructure.uint8,
        kernValue: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int16, 'kernValueCount'),
        leftClass: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, 'glyphCount'),
        rightClass: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, 'glyphCount'),
        kernIndex: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, function(t) {
            return t.leftClassCount * t.rightClassCount;
        })
    }
});
var $3939d1de148b5202$var$KernTable = new $3939d1de148b5202$var$restructure.VersionedStruct('version', {
    0: {
        // Microsoft uses this format
        subVersion: $3939d1de148b5202$var$restructure.uint16,
        // Microsoft has an extra sub-table version number
        length: $3939d1de148b5202$var$restructure.uint16,
        // Length of the subtable, in bytes
        format: $3939d1de148b5202$var$restructure.uint8,
        // Format of subtable
        coverage: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint8, [
            'horizontal',
            'minimum',
            'crossStream',
            'override' // If set to 1 the value in this table replaces the accumulated value
        ]),
        subtable: $3939d1de148b5202$var$KernSubtable,
        padding: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8, function(t) {
            return t.length - t._currentOffset;
        })
    },
    1: {
        // Apple uses this format
        length: $3939d1de148b5202$var$restructure.uint32,
        coverage: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint8, [
            null,
            null,
            null,
            null,
            null,
            'variation',
            'crossStream',
            'vertical' // Set if table has vertical kerning values
        ]),
        format: $3939d1de148b5202$var$restructure.uint8,
        tupleIndex: $3939d1de148b5202$var$restructure.uint16,
        subtable: $3939d1de148b5202$var$KernSubtable,
        padding: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8, function(t) {
            return t.length - t._currentOffset;
        })
    }
});
var $3939d1de148b5202$var$kern = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
    0: {
        // Microsoft Version
        nTables: $3939d1de148b5202$var$restructure.uint16,
        tables: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$KernTable, 'nTables')
    },
    1: {
        // Apple Version
        reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
        // the other half of the version number
        nTables: $3939d1de148b5202$var$restructure.uint32,
        tables: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$KernTable, 'nTables')
    }
});
// Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
var $3939d1de148b5202$var$LTSH = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    numGlyphs: $3939d1de148b5202$var$restructure.uint16,
    yPels: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, 'numGlyphs')
});
// NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
var $3939d1de148b5202$var$PCLT = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    fontNumber: $3939d1de148b5202$var$restructure.uint32,
    pitch: $3939d1de148b5202$var$restructure.uint16,
    xHeight: $3939d1de148b5202$var$restructure.uint16,
    style: $3939d1de148b5202$var$restructure.uint16,
    typeFamily: $3939d1de148b5202$var$restructure.uint16,
    capHeight: $3939d1de148b5202$var$restructure.uint16,
    symbolSet: $3939d1de148b5202$var$restructure.uint16,
    typeface: new $3939d1de148b5202$var$restructure.String(16),
    characterComplement: new $3939d1de148b5202$var$restructure.String(8),
    fileName: new $3939d1de148b5202$var$restructure.String(6),
    strokeWeight: new $3939d1de148b5202$var$restructure.String(1),
    widthType: new $3939d1de148b5202$var$restructure.String(1),
    serifStyle: $3939d1de148b5202$var$restructure.uint8,
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8)
});
// sizes. This is needed in order to match font metrics on Windows.
var $3939d1de148b5202$var$Ratio = new $3939d1de148b5202$var$restructure.Struct({
    bCharSet: $3939d1de148b5202$var$restructure.uint8,
    // Character set
    xRatio: $3939d1de148b5202$var$restructure.uint8,
    // Value to use for x-Ratio
    yStartRatio: $3939d1de148b5202$var$restructure.uint8,
    // Starting y-Ratio value
    yEndRatio: $3939d1de148b5202$var$restructure.uint8 // Ending y-Ratio value
});
var $3939d1de148b5202$var$vTable = new $3939d1de148b5202$var$restructure.Struct({
    yPelHeight: $3939d1de148b5202$var$restructure.uint16,
    // yPelHeight to which values apply
    yMax: $3939d1de148b5202$var$restructure.int16,
    // Maximum value (in pels) for this yPelHeight
    yMin: $3939d1de148b5202$var$restructure.int16 // Minimum value (in pels) for this yPelHeight
});
var $3939d1de148b5202$var$VdmxGroup = new $3939d1de148b5202$var$restructure.Struct({
    recs: $3939d1de148b5202$var$restructure.uint16,
    // Number of height records in this group
    startsz: $3939d1de148b5202$var$restructure.uint8,
    // Starting yPelHeight
    endsz: $3939d1de148b5202$var$restructure.uint8,
    // Ending yPelHeight
    entries: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$vTable, 'recs') // The VDMX records
});
var $3939d1de148b5202$var$VDMX = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    // Version number (0 or 1)
    numRecs: $3939d1de148b5202$var$restructure.uint16,
    // Number of VDMX groups present
    numRatios: $3939d1de148b5202$var$restructure.uint16,
    // Number of aspect ratio groupings
    ratioRanges: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Ratio, 'numRatios'),
    // Ratio ranges
    offsets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'numRatios'),
    // Offset to the VDMX group for this ratio range
    groups: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$VdmxGroup, 'numRecs') // The actual VDMX groupings
});
var $3939d1de148b5202$var$vhea = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    // Version number of the Vertical Header Table
    ascent: $3939d1de148b5202$var$restructure.int16,
    // The vertical typographic ascender for this font
    descent: $3939d1de148b5202$var$restructure.int16,
    // The vertical typographic descender for this font
    lineGap: $3939d1de148b5202$var$restructure.int16,
    // The vertical typographic line gap for this font
    advanceHeightMax: $3939d1de148b5202$var$restructure.int16,
    // The maximum advance height measurement found in the font
    minTopSideBearing: $3939d1de148b5202$var$restructure.int16,
    // The minimum top side bearing measurement found in the font
    minBottomSideBearing: $3939d1de148b5202$var$restructure.int16,
    // The minimum bottom side bearing measurement found in the font
    yMaxExtent: $3939d1de148b5202$var$restructure.int16,
    caretSlopeRise: $3939d1de148b5202$var$restructure.int16,
    // Caret slope (rise/run)
    caretSlopeRun: $3939d1de148b5202$var$restructure.int16,
    caretOffset: $3939d1de148b5202$var$restructure.int16,
    // Set value equal to 0 for nonslanted fonts
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.int16, 4),
    metricDataFormat: $3939d1de148b5202$var$restructure.int16,
    // Set to 0
    numberOfMetrics: $3939d1de148b5202$var$restructure.uint16 // Number of advance heights in the Vertical Metrics table
});
var $3939d1de148b5202$var$VmtxEntry = new $3939d1de148b5202$var$restructure.Struct({
    advance: $3939d1de148b5202$var$restructure.uint16,
    // The advance height of the glyph
    bearing: $3939d1de148b5202$var$restructure.int16 // The top sidebearing of the glyph
}); // Vertical Metrics Table
var $3939d1de148b5202$var$vmtx = new $3939d1de148b5202$var$restructure.Struct({
    metrics: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$VmtxEntry, function(t) {
        return t.parent.vhea.numberOfMetrics;
    }),
    bearings: new $3939d1de148b5202$var$restructure.LazyArray($3939d1de148b5202$var$restructure.int16, function(t) {
        return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
    })
});
var $3939d1de148b5202$var$shortFrac = new $3939d1de148b5202$var$restructure.Fixed(16, 'BE', 14);
var $3939d1de148b5202$var$Correspondence = new $3939d1de148b5202$var$restructure.Struct({
    fromCoord: $3939d1de148b5202$var$shortFrac,
    toCoord: $3939d1de148b5202$var$shortFrac
});
var $3939d1de148b5202$var$Segment = new $3939d1de148b5202$var$restructure.Struct({
    pairCount: $3939d1de148b5202$var$restructure.uint16,
    correspondence: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Correspondence, 'pairCount')
});
var $3939d1de148b5202$var$avar = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.fixed32,
    axisCount: $3939d1de148b5202$var$restructure.uint32,
    segment: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Segment, 'axisCount')
});
function $3939d1de148b5202$var$_inheritsLoose$2(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$UnboundedArrayAccessor = /*#__PURE__*/ function() {
    function UnboundedArrayAccessor(type, stream, parent) {
        this.type = type;
        this.stream = stream;
        this.parent = parent;
        this.base = this.stream.pos;
        this._items = [];
    }
    var _proto = UnboundedArrayAccessor.prototype;
    _proto.getItem = function getItem(index) {
        if (this._items[index] == null) {
            var pos = this.stream.pos;
            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
            this._items[index] = this.type.decode(this.stream, this.parent);
            this.stream.pos = pos;
        }
        return this._items[index];
    };
    _proto.inspect = function inspect() {
        return "[UnboundedArray " + this.type.constructor.name + "]";
    };
    return UnboundedArrayAccessor;
}();
var $3939d1de148b5202$var$UnboundedArray = /*#__PURE__*/ function(_r$Array) {
    $3939d1de148b5202$var$_inheritsLoose$2(UnboundedArray, _r$Array);
    function UnboundedArray(type) {
        return _r$Array.call(this, type, 0) || this;
    }
    var _proto2 = UnboundedArray.prototype;
    _proto2.decode = function decode(stream, parent) {
        return new $3939d1de148b5202$var$UnboundedArrayAccessor(this.type, stream, parent);
    };
    return UnboundedArray;
}($3939d1de148b5202$var$restructure.Array);
var $3939d1de148b5202$var$LookupTable = function LookupTable(ValueType) {
    if (ValueType === void 0) ValueType = $3939d1de148b5202$var$restructure.uint16;
    // Helper class that makes internal structures invisible to pointers
    var Shadow = /*#__PURE__*/ function() {
        function Shadow(type) {
            this.type = type;
        }
        var _proto3 = Shadow.prototype;
        _proto3.decode = function decode(stream, ctx) {
            ctx = ctx.parent.parent;
            return this.type.decode(stream, ctx);
        };
        _proto3.size = function size(val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.size(val, ctx);
        };
        _proto3.encode = function encode(stream, val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.encode(stream, val, ctx);
        };
        return Shadow;
    }();
    ValueType = new Shadow(ValueType);
    var BinarySearchHeader = new $3939d1de148b5202$var$restructure.Struct({
        unitSize: $3939d1de148b5202$var$restructure.uint16,
        nUnits: $3939d1de148b5202$var$restructure.uint16,
        searchRange: $3939d1de148b5202$var$restructure.uint16,
        entrySelector: $3939d1de148b5202$var$restructure.uint16,
        rangeShift: $3939d1de148b5202$var$restructure.uint16
    });
    var LookupSegmentSingle = new $3939d1de148b5202$var$restructure.Struct({
        lastGlyph: $3939d1de148b5202$var$restructure.uint16,
        firstGlyph: $3939d1de148b5202$var$restructure.uint16,
        value: ValueType
    });
    var LookupSegmentArray = new $3939d1de148b5202$var$restructure.Struct({
        lastGlyph: $3939d1de148b5202$var$restructure.uint16,
        firstGlyph: $3939d1de148b5202$var$restructure.uint16,
        values: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$restructure.Array(ValueType, function(t) {
            return t.lastGlyph - t.firstGlyph + 1;
        }), {
            type: 'parent'
        })
    });
    var LookupSingle = new $3939d1de148b5202$var$restructure.Struct({
        glyph: $3939d1de148b5202$var$restructure.uint16,
        value: ValueType
    });
    return new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint16, {
        0: {
            values: new $3939d1de148b5202$var$UnboundedArray(ValueType) // length == number of glyphs maybe?
        },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $3939d1de148b5202$var$restructure.Array(LookupSegmentSingle, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $3939d1de148b5202$var$restructure.Array(LookupSegmentArray, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $3939d1de148b5202$var$restructure.Array(LookupSingle, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        8: {
            firstGlyph: $3939d1de148b5202$var$restructure.uint16,
            count: $3939d1de148b5202$var$restructure.uint16,
            values: new $3939d1de148b5202$var$restructure.Array(ValueType, 'count')
        }
    });
};
function $3939d1de148b5202$var$StateTable(entryData, lookupType) {
    if (entryData === void 0) entryData = {};
    if (lookupType === void 0) lookupType = $3939d1de148b5202$var$restructure.uint16;
    var entry = Object.assign({
        newState: $3939d1de148b5202$var$restructure.uint16,
        flags: $3939d1de148b5202$var$restructure.uint16
    }, entryData);
    var Entry = new $3939d1de148b5202$var$restructure.Struct(entry);
    var StateArray = new $3939d1de148b5202$var$UnboundedArray(new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, function(t) {
        return t.nClasses;
    }));
    var StateHeader = new $3939d1de148b5202$var$restructure.Struct({
        nClasses: $3939d1de148b5202$var$restructure.uint32,
        classTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$LookupTable(lookupType)),
        stateArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, StateArray),
        entryTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$UnboundedArray(Entry))
    });
    return StateHeader;
} // This is the old version of the StateTable structure
function $3939d1de148b5202$var$StateTable1(entryData, lookupType) {
    if (entryData === void 0) entryData = {};
    if (lookupType === void 0) lookupType = $3939d1de148b5202$var$restructure.uint16;
    var ClassLookupTable = new $3939d1de148b5202$var$restructure.Struct({
        version: function version() {
            return 8;
        },
        // simulate LookupTable
        firstGlyph: $3939d1de148b5202$var$restructure.uint16,
        values: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, $3939d1de148b5202$var$restructure.uint16)
    });
    var entry = Object.assign({
        newStateOffset: $3939d1de148b5202$var$restructure.uint16,
        // convert offset to stateArray index
        newState: function newState(t) {
            return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
        },
        flags: $3939d1de148b5202$var$restructure.uint16
    }, entryData);
    var Entry = new $3939d1de148b5202$var$restructure.Struct(entry);
    var StateArray = new $3939d1de148b5202$var$UnboundedArray(new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, function(t) {
        return t.nClasses;
    }));
    var StateHeader1 = new $3939d1de148b5202$var$restructure.Struct({
        nClasses: $3939d1de148b5202$var$restructure.uint16,
        classTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, ClassLookupTable),
        stateArray: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, StateArray),
        entryTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$UnboundedArray(Entry))
    });
    return StateHeader1;
}
var $3939d1de148b5202$var$BslnSubtable = new $3939d1de148b5202$var$restructure.VersionedStruct('format', {
    0: {
        // Distance-based, no mapping
        deltas: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int16, 32)
    },
    1: {
        // Distance-based, with mapping
        deltas: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.int16, 32),
        mappingData: new $3939d1de148b5202$var$LookupTable($3939d1de148b5202$var$restructure.uint16)
    },
    2: {
        // Control point-based, no mapping
        standardGlyph: $3939d1de148b5202$var$restructure.uint16,
        controlPoints: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 32)
    },
    3: {
        // Control point-based, with mapping
        standardGlyph: $3939d1de148b5202$var$restructure.uint16,
        controlPoints: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 32),
        mappingData: new $3939d1de148b5202$var$LookupTable($3939d1de148b5202$var$restructure.uint16)
    }
});
var $3939d1de148b5202$var$bsln = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.fixed32,
    format: $3939d1de148b5202$var$restructure.uint16,
    defaultBaseline: $3939d1de148b5202$var$restructure.uint16,
    subtable: $3939d1de148b5202$var$BslnSubtable
});
var $3939d1de148b5202$var$Setting = new $3939d1de148b5202$var$restructure.Struct({
    setting: $3939d1de148b5202$var$restructure.uint16,
    nameIndex: $3939d1de148b5202$var$restructure.int16,
    name: function name(t) {
        return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
    }
});
var $3939d1de148b5202$var$FeatureName = new $3939d1de148b5202$var$restructure.Struct({
    feature: $3939d1de148b5202$var$restructure.uint16,
    nSettings: $3939d1de148b5202$var$restructure.uint16,
    settingTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Setting, 'nSettings'), {
        type: 'parent'
    }),
    featureFlags: new $3939d1de148b5202$var$restructure.Bitfield($3939d1de148b5202$var$restructure.uint8, [
        null,
        null,
        null,
        null,
        null,
        null,
        'hasDefault',
        'exclusive'
    ]),
    defaultSetting: $3939d1de148b5202$var$restructure.uint8,
    nameIndex: $3939d1de148b5202$var$restructure.int16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameIndex];
    }
});
var $3939d1de148b5202$var$feat = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.fixed32,
    featureNameCount: $3939d1de148b5202$var$restructure.uint16,
    reserved1: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
    reserved2: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint32),
    featureNames: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FeatureName, 'featureNameCount')
});
var $3939d1de148b5202$var$Axis$1 = new $3939d1de148b5202$var$restructure.Struct({
    axisTag: new $3939d1de148b5202$var$restructure.String(4),
    minValue: $3939d1de148b5202$var$restructure.fixed32,
    defaultValue: $3939d1de148b5202$var$restructure.fixed32,
    maxValue: $3939d1de148b5202$var$restructure.fixed32,
    flags: $3939d1de148b5202$var$restructure.uint16,
    nameID: $3939d1de148b5202$var$restructure.uint16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameID];
    }
});
var $3939d1de148b5202$var$Instance = new $3939d1de148b5202$var$restructure.Struct({
    nameID: $3939d1de148b5202$var$restructure.uint16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameID];
    },
    flags: $3939d1de148b5202$var$restructure.uint16,
    coord: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.fixed32, function(t) {
        return t.parent.axisCount;
    }),
    postscriptNameID: new $3939d1de148b5202$var$restructure.Optional($3939d1de148b5202$var$restructure.uint16, function(t) {
        return t.parent.instanceSize - t._currentOffset > 0;
    })
});
var $3939d1de148b5202$var$fvar = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.fixed32,
    offsetToData: $3939d1de148b5202$var$restructure.uint16,
    countSizePairs: $3939d1de148b5202$var$restructure.uint16,
    axisCount: $3939d1de148b5202$var$restructure.uint16,
    axisSize: $3939d1de148b5202$var$restructure.uint16,
    instanceCount: $3939d1de148b5202$var$restructure.uint16,
    instanceSize: $3939d1de148b5202$var$restructure.uint16,
    axis: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Axis$1, 'axisCount'),
    instance: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Instance, 'instanceCount')
});
var $3939d1de148b5202$var$shortFrac$1 = new $3939d1de148b5202$var$restructure.Fixed(16, 'BE', 14);
var $3939d1de148b5202$var$Offset = /*#__PURE__*/ function() {
    function Offset() {}
    Offset.decode = function decode(stream, parent) {
        // In short format, offsets are multiplied by 2.
        // This doesn't seem to be documented by Apple, but it
        // is implemented this way in Freetype.
        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
    };
    return Offset;
}();
var $3939d1de148b5202$var$gvar = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
    axisCount: $3939d1de148b5202$var$restructure.uint16,
    globalCoordCount: $3939d1de148b5202$var$restructure.uint16,
    globalCoords: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$shortFrac$1, 'axisCount'), 'globalCoordCount')),
    glyphCount: $3939d1de148b5202$var$restructure.uint16,
    flags: $3939d1de148b5202$var$restructure.uint16,
    offsetToData: $3939d1de148b5202$var$restructure.uint32,
    offsets: new $3939d1de148b5202$var$restructure.Array(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$Offset, 'void', {
        relativeTo: 'offsetToData',
        allowNull: false
    }), function(t) {
        return t.glyphCount + 1;
    })
});
var $3939d1de148b5202$var$ClassTable$1 = new $3939d1de148b5202$var$restructure.Struct({
    length: $3939d1de148b5202$var$restructure.uint16,
    coverage: $3939d1de148b5202$var$restructure.uint16,
    subFeatureFlags: $3939d1de148b5202$var$restructure.uint32,
    stateTable: new $3939d1de148b5202$var$StateTable1()
});
var $3939d1de148b5202$var$WidthDeltaRecord = new $3939d1de148b5202$var$restructure.Struct({
    justClass: $3939d1de148b5202$var$restructure.uint32,
    beforeGrowLimit: $3939d1de148b5202$var$restructure.fixed32,
    beforeShrinkLimit: $3939d1de148b5202$var$restructure.fixed32,
    afterGrowLimit: $3939d1de148b5202$var$restructure.fixed32,
    afterShrinkLimit: $3939d1de148b5202$var$restructure.fixed32,
    growFlags: $3939d1de148b5202$var$restructure.uint16,
    shrinkFlags: $3939d1de148b5202$var$restructure.uint16
});
var $3939d1de148b5202$var$WidthDeltaCluster = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$WidthDeltaRecord, $3939d1de148b5202$var$restructure.uint32);
var $3939d1de148b5202$var$ActionData = new $3939d1de148b5202$var$restructure.VersionedStruct('actionType', {
    0: {
        // Decomposition action
        lowerLimit: $3939d1de148b5202$var$restructure.fixed32,
        upperLimit: $3939d1de148b5202$var$restructure.fixed32,
        order: $3939d1de148b5202$var$restructure.uint16,
        glyphs: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$restructure.uint16)
    },
    1: {
        // Unconditional add glyph action
        addGlyph: $3939d1de148b5202$var$restructure.uint16
    },
    2: {
        // Conditional add glyph action
        substThreshold: $3939d1de148b5202$var$restructure.fixed32,
        addGlyph: $3939d1de148b5202$var$restructure.uint16,
        substGlyph: $3939d1de148b5202$var$restructure.uint16
    },
    3: {},
    // Stretch glyph action (no data, not supported by CoreText)
    4: {
        // Ductile glyph action (not supported by CoreText)
        variationAxis: $3939d1de148b5202$var$restructure.uint32,
        minimumLimit: $3939d1de148b5202$var$restructure.fixed32,
        noStretchValue: $3939d1de148b5202$var$restructure.fixed32,
        maximumLimit: $3939d1de148b5202$var$restructure.fixed32
    },
    5: {
        // Repeated add glyph action
        flags: $3939d1de148b5202$var$restructure.uint16,
        glyph: $3939d1de148b5202$var$restructure.uint16
    }
});
var $3939d1de148b5202$var$Action = new $3939d1de148b5202$var$restructure.Struct({
    actionClass: $3939d1de148b5202$var$restructure.uint16,
    actionType: $3939d1de148b5202$var$restructure.uint16,
    actionLength: $3939d1de148b5202$var$restructure.uint32,
    actionData: $3939d1de148b5202$var$ActionData,
    padding: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8, function(t) {
        return t.actionLength - t._currentOffset;
    })
});
var $3939d1de148b5202$var$PostcompensationAction = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Action, $3939d1de148b5202$var$restructure.uint32);
var $3939d1de148b5202$var$PostCompensationTable = new $3939d1de148b5202$var$restructure.Struct({
    lookupTable: new $3939d1de148b5202$var$LookupTable(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$PostcompensationAction))
});
var $3939d1de148b5202$var$JustificationTable = new $3939d1de148b5202$var$restructure.Struct({
    classTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$ClassTable$1, {
        type: 'parent'
    }),
    wdcOffset: $3939d1de148b5202$var$restructure.uint16,
    postCompensationTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$PostCompensationTable, {
        type: 'parent'
    }),
    widthDeltaClusters: new $3939d1de148b5202$var$LookupTable(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$WidthDeltaCluster, {
        type: 'parent',
        relativeTo: 'wdcOffset'
    }))
});
var $3939d1de148b5202$var$just = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint32,
    format: $3939d1de148b5202$var$restructure.uint16,
    horizontal: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JustificationTable),
    vertical: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$JustificationTable)
});
var $3939d1de148b5202$var$LigatureData = {
    action: $3939d1de148b5202$var$restructure.uint16
};
var $3939d1de148b5202$var$ContextualData = {
    markIndex: $3939d1de148b5202$var$restructure.uint16,
    currentIndex: $3939d1de148b5202$var$restructure.uint16
};
var $3939d1de148b5202$var$InsertionData = {
    currentInsertIndex: $3939d1de148b5202$var$restructure.uint16,
    markedInsertIndex: $3939d1de148b5202$var$restructure.uint16
};
var $3939d1de148b5202$var$SubstitutionTable = new $3939d1de148b5202$var$restructure.Struct({
    items: new $3939d1de148b5202$var$UnboundedArray(new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$LookupTable()))
});
var $3939d1de148b5202$var$SubtableData = new $3939d1de148b5202$var$restructure.VersionedStruct('type', {
    0: {
        // Indic Rearrangement Subtable
        stateTable: new $3939d1de148b5202$var$StateTable()
    },
    1: {
        // Contextual Glyph Substitution Subtable
        stateTable: new $3939d1de148b5202$var$StateTable($3939d1de148b5202$var$ContextualData),
        substitutionTable: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$SubstitutionTable)
    },
    2: {
        // Ligature subtable
        stateTable: new $3939d1de148b5202$var$StateTable($3939d1de148b5202$var$LigatureData),
        ligatureActions: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$UnboundedArray($3939d1de148b5202$var$restructure.uint32)),
        components: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$UnboundedArray($3939d1de148b5202$var$restructure.uint16)),
        ligatureList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$UnboundedArray($3939d1de148b5202$var$restructure.uint16))
    },
    4: {
        // Non-contextual Glyph Substitution Subtable
        lookupTable: new $3939d1de148b5202$var$LookupTable()
    },
    5: {
        // Glyph Insertion Subtable
        stateTable: new $3939d1de148b5202$var$StateTable($3939d1de148b5202$var$InsertionData),
        insertionActions: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, new $3939d1de148b5202$var$UnboundedArray($3939d1de148b5202$var$restructure.uint16))
    }
});
var $3939d1de148b5202$var$Subtable = new $3939d1de148b5202$var$restructure.Struct({
    length: $3939d1de148b5202$var$restructure.uint32,
    coverage: $3939d1de148b5202$var$restructure.uint24,
    type: $3939d1de148b5202$var$restructure.uint8,
    subFeatureFlags: $3939d1de148b5202$var$restructure.uint32,
    table: $3939d1de148b5202$var$SubtableData,
    padding: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8, function(t) {
        return t.length - t._currentOffset;
    })
});
var $3939d1de148b5202$var$FeatureEntry = new $3939d1de148b5202$var$restructure.Struct({
    featureType: $3939d1de148b5202$var$restructure.uint16,
    featureSetting: $3939d1de148b5202$var$restructure.uint16,
    enableFlags: $3939d1de148b5202$var$restructure.uint32,
    disableFlags: $3939d1de148b5202$var$restructure.uint32
});
var $3939d1de148b5202$var$MorxChain = new $3939d1de148b5202$var$restructure.Struct({
    defaultFlags: $3939d1de148b5202$var$restructure.uint32,
    chainLength: $3939d1de148b5202$var$restructure.uint32,
    nFeatureEntries: $3939d1de148b5202$var$restructure.uint32,
    nSubtables: $3939d1de148b5202$var$restructure.uint32,
    features: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$FeatureEntry, 'nFeatureEntries'),
    subtables: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Subtable, 'nSubtables')
});
var $3939d1de148b5202$var$morx = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint16,
    unused: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
    nChains: $3939d1de148b5202$var$restructure.uint32,
    chains: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$MorxChain, 'nChains')
});
var $3939d1de148b5202$var$OpticalBounds = new $3939d1de148b5202$var$restructure.Struct({
    left: $3939d1de148b5202$var$restructure.int16,
    top: $3939d1de148b5202$var$restructure.int16,
    right: $3939d1de148b5202$var$restructure.int16,
    bottom: $3939d1de148b5202$var$restructure.int16
});
var $3939d1de148b5202$var$opbd = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.fixed32,
    format: $3939d1de148b5202$var$restructure.uint16,
    lookupTable: new $3939d1de148b5202$var$LookupTable($3939d1de148b5202$var$OpticalBounds)
});
var $3939d1de148b5202$var$tables = {};
$3939d1de148b5202$var$tables.cmap = $3939d1de148b5202$var$cmap;
$3939d1de148b5202$var$tables.head = $3939d1de148b5202$var$head;
$3939d1de148b5202$var$tables.hhea = $3939d1de148b5202$var$hhea;
$3939d1de148b5202$var$tables.hmtx = $3939d1de148b5202$var$hmtx;
$3939d1de148b5202$var$tables.maxp = $3939d1de148b5202$var$maxp;
$3939d1de148b5202$var$tables.name = $3939d1de148b5202$var$NameTable;
$3939d1de148b5202$var$tables['OS/2'] = $3939d1de148b5202$var$OS2;
$3939d1de148b5202$var$tables.post = $3939d1de148b5202$var$post; // TrueType Outlines
$3939d1de148b5202$var$tables.fpgm = $3939d1de148b5202$var$fpgm;
$3939d1de148b5202$var$tables.loca = $3939d1de148b5202$var$loca;
$3939d1de148b5202$var$tables.prep = $3939d1de148b5202$var$prep;
$3939d1de148b5202$var$tables['cvt '] = $3939d1de148b5202$var$cvt;
$3939d1de148b5202$var$tables.glyf = $3939d1de148b5202$var$glyf; // PostScript Outlines
$3939d1de148b5202$var$tables['CFF '] = $3939d1de148b5202$var$CFFFont;
$3939d1de148b5202$var$tables['CFF2'] = $3939d1de148b5202$var$CFFFont;
$3939d1de148b5202$var$tables.VORG = $3939d1de148b5202$var$VORG; // Bitmap Glyphs
$3939d1de148b5202$var$tables.EBLC = $3939d1de148b5202$var$EBLC;
$3939d1de148b5202$var$tables.CBLC = $3939d1de148b5202$var$tables.EBLC;
$3939d1de148b5202$var$tables.sbix = $3939d1de148b5202$var$sbix;
$3939d1de148b5202$var$tables.COLR = $3939d1de148b5202$var$COLR;
$3939d1de148b5202$var$tables.CPAL = $3939d1de148b5202$var$CPAL; // Advanced OpenType Tables
$3939d1de148b5202$var$tables.BASE = $3939d1de148b5202$var$BASE;
$3939d1de148b5202$var$tables.GDEF = $3939d1de148b5202$var$GDEF;
$3939d1de148b5202$var$tables.GPOS = $3939d1de148b5202$var$GPOS;
$3939d1de148b5202$var$tables.GSUB = $3939d1de148b5202$var$GSUB;
$3939d1de148b5202$var$tables.JSTF = $3939d1de148b5202$var$JSTF; // OpenType variations tables
$3939d1de148b5202$var$tables.HVAR = $3939d1de148b5202$var$HVAR; // Other OpenType Tables
$3939d1de148b5202$var$tables.DSIG = $3939d1de148b5202$var$DSIG;
$3939d1de148b5202$var$tables.gasp = $3939d1de148b5202$var$gasp;
$3939d1de148b5202$var$tables.hdmx = $3939d1de148b5202$var$hdmx;
$3939d1de148b5202$var$tables.kern = $3939d1de148b5202$var$kern;
$3939d1de148b5202$var$tables.LTSH = $3939d1de148b5202$var$LTSH;
$3939d1de148b5202$var$tables.PCLT = $3939d1de148b5202$var$PCLT;
$3939d1de148b5202$var$tables.VDMX = $3939d1de148b5202$var$VDMX;
$3939d1de148b5202$var$tables.vhea = $3939d1de148b5202$var$vhea;
$3939d1de148b5202$var$tables.vmtx = $3939d1de148b5202$var$vmtx; // Apple Advanced Typography Tables
$3939d1de148b5202$var$tables.avar = $3939d1de148b5202$var$avar;
$3939d1de148b5202$var$tables.bsln = $3939d1de148b5202$var$bsln;
$3939d1de148b5202$var$tables.feat = $3939d1de148b5202$var$feat;
$3939d1de148b5202$var$tables.fvar = $3939d1de148b5202$var$fvar;
$3939d1de148b5202$var$tables.gvar = $3939d1de148b5202$var$gvar;
$3939d1de148b5202$var$tables.just = $3939d1de148b5202$var$just;
$3939d1de148b5202$var$tables.morx = $3939d1de148b5202$var$morx;
$3939d1de148b5202$var$tables.opbd = $3939d1de148b5202$var$opbd;
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$3(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$3(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$3(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$TableEntry = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    checkSum: $3939d1de148b5202$var$restructure.uint32,
    offset: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, 'void', {
        type: 'global'
    }),
    length: $3939d1de148b5202$var$restructure.uint32
});
var $3939d1de148b5202$var$Directory = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    numTables: $3939d1de148b5202$var$restructure.uint16,
    searchRange: $3939d1de148b5202$var$restructure.uint16,
    entrySelector: $3939d1de148b5202$var$restructure.uint16,
    rangeShift: $3939d1de148b5202$var$restructure.uint16,
    tables: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$TableEntry, 'numTables')
});
$3939d1de148b5202$var$Directory.process = function() {
    var tables = {};
    for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$3(this.tables), _step; !(_step = _iterator()).done;){
        var table = _step.value;
        tables[table.tag] = table;
    }
    this.tables = tables;
};
$3939d1de148b5202$var$Directory.preEncode = function(stream) {
    var tables$1 = [];
    for(var tag in this.tables){
        var table = this.tables[tag];
        if (table) tables$1.push({
            tag: tag,
            checkSum: 0,
            offset: new $3939d1de148b5202$var$restructure.VoidPointer($3939d1de148b5202$var$tables[tag], table),
            length: $3939d1de148b5202$var$tables[tag].size(table)
        });
    }
    this.tag = 'true';
    this.numTables = tables$1.length;
    this.tables = tables$1;
    var maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
    var maxPowerOf2 = Math.pow(2, maxExponentFor2);
    this.searchRange = maxPowerOf2 * 16;
    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
function $3939d1de148b5202$var$binarySearch(arr, cmp) {
    var min = 0;
    var max = arr.length - 1;
    while(min <= max){
        var mid = min + max >> 1;
        var res = cmp(arr[mid]);
        if (res < 0) max = mid - 1;
        else if (res > 0) min = mid + 1;
        else return mid;
    }
    return -1;
}
function $3939d1de148b5202$var$range(index, end) {
    var range = [];
    while(index < end)range.push(index++);
    return range;
}
var $3939d1de148b5202$var$_class;
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$4(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$4(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$4(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
var $3939d1de148b5202$var$CmapProcessor = ($3939d1de148b5202$var$_class = /*#__PURE__*/ function() {
    function CmapProcessor(cmapTable) {
        // Attempt to find a Unicode cmap first
        this.encoding = null;
        this.cmap = this.findSubtable(cmapTable, [
            [
                3,
                10
            ],
            [
                0,
                6
            ],
            [
                0,
                4
            ],
            [
                3,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                2
            ],
            [
                0,
                1
            ],
            [
                0,
                0
            ]
        ]); // If not unicode cmap was found, and iconv-lite is installed,
        // take the first table with a supported encoding.
        if (!this.cmap && $3939d1de148b5202$var$lib) for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$4(cmapTable.tables), _step; !(_step = _iterator()).done;){
            var cmap = _step.value;
            var encoding = $3939d1de148b5202$var$getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
            if ($3939d1de148b5202$var$lib.encodingExists(encoding)) {
                this.cmap = cmap.table;
                this.encoding = encoding;
            }
        }
        if (!this.cmap) throw new Error("Could not find a supported cmap table");
        this.uvs = this.findSubtable(cmapTable, [
            [
                0,
                5
            ]
        ]);
        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
    }
    var _proto = CmapProcessor.prototype;
    _proto.findSubtable = function findSubtable(cmapTable, pairs) {
        for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$4(pairs), _step2; !(_step2 = _iterator2()).done;){
            var _step2$value = _step2.value, platformID = _step2$value[0], encodingID = _step2$value[1];
            for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$4(cmapTable.tables), _step3; !(_step3 = _iterator3()).done;){
                var cmap = _step3.value;
                if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
            }
        }
        return null;
    };
    _proto.lookup = function lookup(codepoint, variationSelector) {
        // If there is no Unicode cmap in this font, we need to re-encode
        // the codepoint in the encoding that the cmap supports.
        if (this.encoding) {
            var buf = $3939d1de148b5202$var$lib.encode(String.fromCodePoint(codepoint), this.encoding);
            codepoint = 0;
            for(var i = 0; i < buf.length; i++)codepoint = codepoint << 8 | buf[i];
             // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
        } else if (variationSelector) {
            var gid = this.getVariationSelector(codepoint, variationSelector);
            if (gid) return gid;
        }
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4:
                var min = 0;
                var max = cmap.segCount - 1;
                while(min <= max){
                    var mid = min + max >> 1;
                    if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                    else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                    else {
                        var rangeOffset = cmap.idRangeOffset.get(mid);
                        var _gid = void 0;
                        if (rangeOffset === 0) _gid = codepoint + cmap.idDelta.get(mid);
                        else {
                            var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                            _gid = cmap.glyphIndexArray.get(index) || 0;
                            if (_gid !== 0) _gid += cmap.idDelta.get(mid);
                        }
                        return _gid & 0xffff;
                    }
                }
                return 0;
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13:
                var _min = 0;
                var _max = cmap.nGroups - 1;
                while(_min <= _max){
                    var _mid = _min + _max >> 1;
                    var group = cmap.groups.get(_mid);
                    if (codepoint < group.startCharCode) _max = _mid - 1;
                    else if (codepoint > group.endCharCode) _min = _mid + 1;
                    else {
                        if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                        else return group.glyphID;
                    }
                }
                return 0;
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error("Unknown cmap format " + cmap.version);
        }
    };
    _proto.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
        if (!this.uvs) return 0;
        var selectors = this.uvs.varSelectors.toArray();
        var i = $3939d1de148b5202$var$binarySearch(selectors, function(x) {
            return variationSelector - x.varSelector;
        });
        var sel = selectors[i];
        if (i !== -1 && sel.defaultUVS) i = $3939d1de148b5202$var$binarySearch(sel.defaultUVS, function(x) {
            return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0;
        });
        if (i !== -1 && sel.nonDefaultUVS) {
            i = $3939d1de148b5202$var$binarySearch(sel.nonDefaultUVS, function(x) {
                return codepoint - x.unicodeValue;
            });
            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
        }
        return 0;
    };
    _proto.getCharacterSet = function getCharacterSet() {
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return $3939d1de148b5202$var$range(0, cmap.codeMap.length);
            case 4:
                var res = [];
                var endCodes = cmap.endCode.toArray();
                for(var i = 0; i < endCodes.length; i++){
                    var tail = endCodes[i] + 1;
                    var start = cmap.startCode.get(i);
                    res.push.apply(res, $3939d1de148b5202$var$range(start, tail));
                }
                return res;
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return $3939d1de148b5202$var$range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13:
                var _res = [];
                for(var _iterator4 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$4(cmap.groups.toArray()), _step4; !(_step4 = _iterator4()).done;){
                    var group = _step4.value;
                    _res.push.apply(_res, $3939d1de148b5202$var$range(group.startCharCode, group.endCharCode + 1));
                }
                return _res;
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error("Unknown cmap format " + cmap.version);
        }
    };
    _proto.codePointsForGlyph = function codePointsForGlyph(gid) {
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                var res = [];
                for(var i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                return res;
            case 4:
                var _res2 = [];
                for(var _i = 0; _i < cmap.segCount; _i++){
                    var end = cmap.endCode.get(_i);
                    var start = cmap.startCode.get(_i);
                    var rangeOffset = cmap.idRangeOffset.get(_i);
                    var delta = cmap.idDelta.get(_i);
                    for(var c = start; c <= end; c++){
                        var g = 0;
                        if (rangeOffset === 0) g = c + delta;
                        else {
                            var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i);
                            g = cmap.glyphIndexArray.get(index) || 0;
                            if (g !== 0) g += delta;
                        }
                        if (g === gid) _res2.push(c);
                    }
                }
                return _res2;
            case 12:
                var _res3 = [];
                for(var _iterator5 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$4(cmap.groups.toArray()), _step5; !(_step5 = _iterator5()).done;){
                    var group = _step5.value;
                    if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) _res3.push(group.startCharCode + (gid - group.glyphID));
                }
                return _res3;
            case 13:
                var _res4 = [];
                for(var _iterator6 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$4(cmap.groups.toArray()), _step6; !(_step6 = _iterator6()).done;){
                    var _group = _step6.value;
                    if (gid === _group.glyphID) _res4.push.apply(_res4, $3939d1de148b5202$var$range(_group.startCharCode, _group.endCharCode + 1));
                }
                return _res4;
            default:
                throw new Error("Unknown cmap format " + cmap.version);
        }
    };
    return CmapProcessor;
}(), $3939d1de148b5202$var$_applyDecoratedDescriptor($3939d1de148b5202$var$_class.prototype, "getCharacterSet", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class.prototype, "getCharacterSet"), $3939d1de148b5202$var$_class.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor($3939d1de148b5202$var$_class.prototype, "codePointsForGlyph", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class.prototype, "codePointsForGlyph"), $3939d1de148b5202$var$_class.prototype), $3939d1de148b5202$var$_class);
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$5(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$5(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$5(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$KernProcessor = /*#__PURE__*/ function() {
    function KernProcessor(font) {
        this.kern = font.kern;
    }
    var _proto = KernProcessor.prototype;
    _proto.process = function process(glyphs, positions) {
        for(var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
            var left = glyphs[glyphIndex].id;
            var right = glyphs[glyphIndex + 1].id;
            positions[glyphIndex].xAdvance += this.getKerning(left, right);
        }
    };
    _proto.getKerning = function getKerning(left, right) {
        var res = 0;
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$5(this.kern.tables), _step; !(_step = _iterator()).done;){
            var table = _step.value;
            if (table.coverage.crossStream) continue;
            switch(table.version){
                case 0:
                    if (!table.coverage.horizontal) continue;
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) continue;
                    break;
                default:
                    throw new Error("Unsupported kerning table version " + table.version);
            }
            var val = 0;
            var s = table.subtable;
            switch(table.format){
                case 0:
                    var pairIdx = $3939d1de148b5202$var$binarySearch(s.pairs, function(pair) {
                        return left - pair.left || right - pair.right;
                    });
                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                    break;
                case 2:
                    var leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    else leftOffset = s.array.off;
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    var index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error("Unsupported kerning sub-table format " + table.format);
            } // Microsoft supports the override flag, which resets the result
            // Otherwise, the sum of the results from all subtables is returned
            if (table.coverage.override) res = val;
            else res += val;
        }
        return res;
    };
    return KernProcessor;
}();
var $3939d1de148b5202$var$TINF_OK = 0;
var $3939d1de148b5202$var$TINF_DATA_ERROR = -3;
function $3939d1de148b5202$var$Tree() {
    this.table = new Uint16Array(16);
    /* table of code length counts */ this.trans = new Uint16Array(288);
/* code -> symbol translation table */ }
function $3939d1de148b5202$var$Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new $3939d1de148b5202$var$Tree();
    /* dynamic length/symbol tree */ this.dtree = new $3939d1de148b5202$var$Tree();
/* dynamic distance tree */ }
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var $3939d1de148b5202$var$sltree = new $3939d1de148b5202$var$Tree();
var $3939d1de148b5202$var$sdtree = new $3939d1de148b5202$var$Tree();
/* extra bits and base tables for length codes */ var $3939d1de148b5202$var$length_bits = new Uint8Array(30);
var $3939d1de148b5202$var$length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var $3939d1de148b5202$var$dist_bits = new Uint8Array(30);
var $3939d1de148b5202$var$dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var $3939d1de148b5202$var$clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var $3939d1de148b5202$var$code_tree = new $3939d1de148b5202$var$Tree();
var $3939d1de148b5202$var$lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function $3939d1de148b5202$var$tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function $3939d1de148b5202$var$tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var $3939d1de148b5202$var$offs = new Uint16Array(16);
function $3939d1de148b5202$var$tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        $3939d1de148b5202$var$offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[$3939d1de148b5202$var$offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function $3939d1de148b5202$var$tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function $3939d1de148b5202$var$tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function $3939d1de148b5202$var$tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function $3939d1de148b5202$var$tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = $3939d1de148b5202$var$tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = $3939d1de148b5202$var$tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = $3939d1de148b5202$var$tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)$3939d1de148b5202$var$lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = $3939d1de148b5202$var$tinf_read_bits(d, 3, 0);
        $3939d1de148b5202$var$lengths[$3939d1de148b5202$var$clcidx[i]] = clen;
    }
    /* build code length tree */ $3939d1de148b5202$var$tinf_build_tree($3939d1de148b5202$var$code_tree, $3939d1de148b5202$var$lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = $3939d1de148b5202$var$tinf_decode_symbol(d, $3939d1de148b5202$var$code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = $3939d1de148b5202$var$lengths[num - 1];
                for(length = $3939d1de148b5202$var$tinf_read_bits(d, 2, 3); length; --length)$3939d1de148b5202$var$lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = $3939d1de148b5202$var$tinf_read_bits(d, 3, 3); length; --length)$3939d1de148b5202$var$lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = $3939d1de148b5202$var$tinf_read_bits(d, 7, 11); length; --length)$3939d1de148b5202$var$lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ $3939d1de148b5202$var$lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ $3939d1de148b5202$var$tinf_build_tree(lt, $3939d1de148b5202$var$lengths, 0, hlit);
    $3939d1de148b5202$var$tinf_build_tree(dt, $3939d1de148b5202$var$lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function $3939d1de148b5202$var$tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = $3939d1de148b5202$var$tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return $3939d1de148b5202$var$TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = $3939d1de148b5202$var$tinf_read_bits(d, $3939d1de148b5202$var$length_bits[sym], $3939d1de148b5202$var$length_base[sym]);
            dist = $3939d1de148b5202$var$tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - $3939d1de148b5202$var$tinf_read_bits(d, $3939d1de148b5202$var$dist_bits[dist], $3939d1de148b5202$var$dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function $3939d1de148b5202$var$tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return $3939d1de148b5202$var$TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return $3939d1de148b5202$var$TINF_OK;
}
/* inflate stream from source to dest */ function $3939d1de148b5202$var$tinf_uncompress(source, dest) {
    var d = new $3939d1de148b5202$var$Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = $3939d1de148b5202$var$tinf_getbit(d);
        /* read block type (2 bits) */ btype = $3939d1de148b5202$var$tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = $3939d1de148b5202$var$tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = $3939d1de148b5202$var$tinf_inflate_block_data(d, $3939d1de148b5202$var$sltree, $3939d1de148b5202$var$sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ $3939d1de148b5202$var$tinf_decode_trees(d, d.ltree, d.dtree);
                res = $3939d1de148b5202$var$tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = $3939d1de148b5202$var$TINF_DATA_ERROR;
        }
        if (res !== $3939d1de148b5202$var$TINF_OK) throw new Error('Data error');
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ $3939d1de148b5202$var$tinf_build_fixed_trees($3939d1de148b5202$var$sltree, $3939d1de148b5202$var$sdtree);
/* build extra bits and base tables */ $3939d1de148b5202$var$tinf_build_bits_base($3939d1de148b5202$var$length_bits, $3939d1de148b5202$var$length_base, 4, 3);
$3939d1de148b5202$var$tinf_build_bits_base($3939d1de148b5202$var$dist_bits, $3939d1de148b5202$var$dist_base, 2, 1);
/* fix a special case */ $3939d1de148b5202$var$length_bits[28] = 0;
$3939d1de148b5202$var$length_base[28] = 258;
var $3939d1de148b5202$var$tinyInflate = $3939d1de148b5202$var$tinf_uncompress;
var $3939d1de148b5202$var$UnicodeTrie, $3939d1de148b5202$var$inflate;
$3939d1de148b5202$var$inflate = $3939d1de148b5202$var$tinyInflate;
$3939d1de148b5202$var$UnicodeTrie = function() {
    var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;
    SHIFT_1 = 11;
    SHIFT_2 = 5;
    SHIFT_1_2 = SHIFT_1 - SHIFT_2;
    OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
    INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
    INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
    INDEX_SHIFT = 2;
    DATA_BLOCK_LENGTH = 1 << SHIFT_2;
    DATA_MASK = DATA_BLOCK_LENGTH - 1;
    LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
    LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
    INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
    UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
    UTF8_2B_INDEX_2_LENGTH = 32;
    INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
    DATA_GRANULARITY = 1 << INDEX_SHIFT;
    function UnicodeTrie(data) {
        var isBuffer, uncompressedLength, view;
        isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
        if (isBuffer || data instanceof Uint8Array) {
            if (isBuffer) {
                this.highStart = data.readUInt32BE(0);
                this.errorValue = data.readUInt32BE(4);
                uncompressedLength = data.readUInt32BE(8);
                data = data.slice(12);
            } else {
                view = new DataView(data.buffer);
                this.highStart = view.getUint32(0);
                this.errorValue = view.getUint32(4);
                uncompressedLength = view.getUint32(8);
                data = data.subarray(12);
            }
            data = $3939d1de148b5202$var$inflate(data, new Uint8Array(uncompressedLength));
            data = $3939d1de148b5202$var$inflate(data, new Uint8Array(uncompressedLength));
            this.data = new Uint32Array(data.buffer);
        } else this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
    }
    UnicodeTrie.prototype.get = function(codePoint) {
        var index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
            index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
            index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - DATA_GRANULARITY];
    };
    return UnicodeTrie;
}();
var $3939d1de148b5202$var$unicodeTrie = $3939d1de148b5202$var$UnicodeTrie;
var $3939d1de148b5202$var$base64Arraybuffer = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    /*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */ (function() {
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"; // Use a lookup table to find the index.
        var lookup = new Uint8Array(256);
        for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
        exports.encode = function(arraybuffer) {
            var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
            for(i = 0; i < len; i += 3){
                base64 += chars[bytes[i] >> 2];
                base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                base64 += chars[bytes[i + 2] & 63];
            }
            if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
            else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
            return base64;
        };
        exports.decode = function(base64) {
            var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
            if (base64[base64.length - 1] === "=") {
                bufferLength--;
                if (base64[base64.length - 2] === "=") bufferLength--;
            }
            var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
            for(i = 0; i < len; i += 4){
                encoded1 = lookup[base64.charCodeAt(i)];
                encoded2 = lookup[base64.charCodeAt(i + 1)];
                encoded3 = lookup[base64.charCodeAt(i + 2)];
                encoded4 = lookup[base64.charCodeAt(i + 3)];
                bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
            }
            return arraybuffer;
        };
    })();
});
var $3939d1de148b5202$var$base64Arraybuffer_1 = $3939d1de148b5202$var$base64Arraybuffer.encode;
var $3939d1de148b5202$var$base64Arraybuffer_2 = $3939d1de148b5202$var$base64Arraybuffer.decode;
var $3939d1de148b5202$var$base64DeflatedData = "eJxtVtty4zYM/Rc/70Ni97LbN1tJ49SXeGI3O93OjgayGBERRXoo0h5Np/9eAKTcpNOHECAFAgfAAZ2/JkcIqnEeVT/55c9JcZx8mnzradk5Wva83clW8bZjraZly8s68lnLZ2y3Nrzla2tedkhL8crGsmVtHXhhLxvLCzvd8N0t3/0my4mvccjCTb5/mhxdV6FF2xQG+j6h3LpQPivna+UVA5lX7qxGWT5joznOQhl34dMQ4KhVXX78fD0e7Z7OyhsYSHt0Acp9rPqjxxPb3rlYGXW1zNsxrBz/61eirNUrb4qiuL3J8jbLaZazLH/I8scsf8ry5yw/Z/klyWn2N83+ptnfNPubZn/T7G+W7WfZfjbaZ//T7H+a/c+yn1n2Mxv9MK5tbAOQfEEPHaQPn7PhlzHBmzGzmzGFaw4j2Nsx2u0I71ZwfezVtba5mlmswEL54vBIrMjYGVtqAFEmtS3x2XWdY6qtISDLhTu5zr0yIx+tVh6DMOjBK9UK504BmZDF4NEYUee+UxaBby9V5ZVwykMlH/dkB6wcNBAsLlErk0PlIedyawO2BrG+U2cyauiLpGYbMKw9RN/FVif1DTxhZT56HNjhATrkyTgoE5uY8rdQg3gmwtIfT9QerSY1QUFJmYEcsFIZxgCWQHEQmp0mZwS2iez9Pmh0p5Q71cW1istfENyaLLkfHhu0wLZPjZaQz9HKhQOlZFyT3EXrOO4iaqzTtwrshXGtdKc4/MbZxpkUf41dFcUMqctcPnUpZROl/ZFiql5li0OKu6Cy5dN9pNpmfQEBWqHJ6ag54JMpC42tFNsD9ZOtHgxw9NTmA75STo1O0HklYjepkSt2l9Q/pJ7YM9IXKe4CuihVH4wLWG6hkZ7uNDR9uQNhQPTQ6+CTrwF0uWaTZ/UGwtvf4DwiL1JenOILKub4RqmgsNzAILy00RiBYBX4csHqcEwVLIhNojyZunwMkEj74Kifx3y6U76Tze9MvfD+vE937wiHl8B7Defsr+/ACgPvTQV9DhaP0Ash6MyOPRRUcxmbk0fHfh67E00XmHLOL4WE3IHpBq+stBkqKq/KHKQiWameo0nLea2HOikbYiODLpdIWmOGk+7fHxeRspDHYqXBOyq5TBInuHcx6FKG9VqirfMfzmg6keiSoMzPqk/T8mjTM4KOOE8dpUv4vx+0oYIx+B5MUP7dCUc7RN9e672Mthm7RYTUHQo1MAHeO0+/Oo7qlp41DW2XhlwDUQZTc3ya/JV2b0LsTTQhfVzpWMOFxlXeM7BBZuCAXkd5s/dY14lnGydGB2iFtHPt+PQr+bZNWaC8PjuIpNpyCUz6IlqFr86z3X0zUPZEgY/9mFsIMtX/7ZOX54B+vOnRBi2uNVx0uaSXmRPdoDxUd/Fk3CC12WNjvzJR03dla1WusIU2Ir/vCi7yX4DQiCMzeOYR/f06+f73P0+ms+k=";
var $3939d1de148b5202$var$base64DeflatedTrie = "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";
// we may be running in a browser so we make an Uint8Array
var $3939d1de148b5202$var$data = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedData))));
var $3939d1de148b5202$var$trieData = (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedTrie));
var $3939d1de148b5202$var$trie = new $3939d1de148b5202$var$unicodeTrie($3939d1de148b5202$var$trieData);
var $3939d1de148b5202$var$log2 = Math.log2 || function(n) {
    return Math.log(n) / Math.LN2;
};
var $3939d1de148b5202$var$bits = function bits(n) {
    return $3939d1de148b5202$var$log2(n) + 1 | 0;
}; // compute the number of bits stored for each field
var $3939d1de148b5202$var$CATEGORY_BITS = $3939d1de148b5202$var$bits($3939d1de148b5202$var$data.categories.length - 1);
var $3939d1de148b5202$var$COMBINING_BITS = $3939d1de148b5202$var$bits($3939d1de148b5202$var$data.combiningClasses.length - 1);
var $3939d1de148b5202$var$SCRIPT_BITS = $3939d1de148b5202$var$bits($3939d1de148b5202$var$data.scripts.length - 1);
var $3939d1de148b5202$var$EAW_BITS = $3939d1de148b5202$var$bits($3939d1de148b5202$var$data.eaw.length - 1);
var $3939d1de148b5202$var$NUMBER_BITS = 10; // compute shift and mask values for each field
var $3939d1de148b5202$var$CATEGORY_SHIFT = $3939d1de148b5202$var$COMBINING_BITS + $3939d1de148b5202$var$SCRIPT_BITS + $3939d1de148b5202$var$EAW_BITS + $3939d1de148b5202$var$NUMBER_BITS;
var $3939d1de148b5202$var$COMBINING_SHIFT = $3939d1de148b5202$var$SCRIPT_BITS + $3939d1de148b5202$var$EAW_BITS + $3939d1de148b5202$var$NUMBER_BITS;
var $3939d1de148b5202$var$SCRIPT_SHIFT = $3939d1de148b5202$var$EAW_BITS + $3939d1de148b5202$var$NUMBER_BITS;
var $3939d1de148b5202$var$EAW_SHIFT = $3939d1de148b5202$var$NUMBER_BITS;
var $3939d1de148b5202$var$CATEGORY_MASK = (1 << $3939d1de148b5202$var$CATEGORY_BITS) - 1;
var $3939d1de148b5202$var$COMBINING_MASK = (1 << $3939d1de148b5202$var$COMBINING_BITS) - 1;
var $3939d1de148b5202$var$SCRIPT_MASK = (1 << $3939d1de148b5202$var$SCRIPT_BITS) - 1;
var $3939d1de148b5202$var$EAW_MASK = (1 << $3939d1de148b5202$var$EAW_BITS) - 1;
var $3939d1de148b5202$var$NUMBER_MASK = (1 << $3939d1de148b5202$var$NUMBER_BITS) - 1;
var $3939d1de148b5202$var$getCategory = function getCategory(codePoint) {
    var val = $3939d1de148b5202$var$trie.get(codePoint);
    return $3939d1de148b5202$var$data.categories[val >> $3939d1de148b5202$var$CATEGORY_SHIFT & $3939d1de148b5202$var$CATEGORY_MASK];
};
var $3939d1de148b5202$var$getCombiningClass = function getCombiningClass(codePoint) {
    var val = $3939d1de148b5202$var$trie.get(codePoint);
    return $3939d1de148b5202$var$data.combiningClasses[val >> $3939d1de148b5202$var$COMBINING_SHIFT & $3939d1de148b5202$var$COMBINING_MASK];
};
var $3939d1de148b5202$var$getScript = function getScript(codePoint) {
    var val = $3939d1de148b5202$var$trie.get(codePoint);
    return $3939d1de148b5202$var$data.scripts[val >> $3939d1de148b5202$var$SCRIPT_SHIFT & $3939d1de148b5202$var$SCRIPT_MASK];
};
var $3939d1de148b5202$var$getEastAsianWidth = function getEastAsianWidth(codePoint) {
    var val = $3939d1de148b5202$var$trie.get(codePoint);
    return $3939d1de148b5202$var$data.eaw[val >> $3939d1de148b5202$var$EAW_SHIFT & $3939d1de148b5202$var$EAW_MASK];
};
var $3939d1de148b5202$var$getNumericValue = function getNumericValue(codePoint) {
    var val = $3939d1de148b5202$var$trie.get(codePoint);
    var num = val & $3939d1de148b5202$var$NUMBER_MASK;
    if (num === 0) return null;
    else if (num <= 50) return num - 1;
    else if (num < 0x1e0) {
        var numerator = (num >> 4) - 12;
        var denominator = (num & 0xf) + 1;
        return numerator / denominator;
    } else if (num < 0x300) {
        val = (num >> 5) - 14;
        var exp = (num & 0x1f) + 2;
        while(exp > 0){
            val *= 10;
            exp--;
        }
        return val;
    } else {
        val = (num >> 2) - 0xbf;
        var _exp = (num & 3) + 1;
        while(_exp > 0){
            val *= 60;
            _exp--;
        }
        return val;
    }
};
var $3939d1de148b5202$var$isAlphabetic = function isAlphabetic(codePoint) {
    var category = $3939d1de148b5202$var$getCategory(codePoint);
    return category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Nl';
};
var $3939d1de148b5202$var$isDigit = function isDigit(codePoint) {
    return $3939d1de148b5202$var$getCategory(codePoint) === 'Nd';
};
var $3939d1de148b5202$var$isPunctuation = function isPunctuation(codePoint) {
    var category = $3939d1de148b5202$var$getCategory(codePoint);
    return category === 'Pc' || category === 'Pd' || category === 'Pe' || category === 'Pf' || category === 'Pi' || category === 'Po' || category === 'Ps';
};
var $3939d1de148b5202$var$isLowerCase = function isLowerCase(codePoint) {
    return $3939d1de148b5202$var$getCategory(codePoint) === 'Ll';
};
var $3939d1de148b5202$var$isUpperCase = function isUpperCase(codePoint) {
    return $3939d1de148b5202$var$getCategory(codePoint) === 'Lu';
};
var $3939d1de148b5202$var$isTitleCase = function isTitleCase(codePoint) {
    return $3939d1de148b5202$var$getCategory(codePoint) === 'Lt';
};
var $3939d1de148b5202$var$isWhiteSpace = function isWhiteSpace(codePoint) {
    var category = $3939d1de148b5202$var$getCategory(codePoint);
    return category === 'Zs' || category === 'Zl' || category === 'Zp';
};
var $3939d1de148b5202$var$isBaseForm = function isBaseForm(codePoint) {
    var category = $3939d1de148b5202$var$getCategory(codePoint);
    return category === 'Nd' || category === 'No' || category === 'Nl' || category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Me' || category === 'Mc';
};
var $3939d1de148b5202$var$isMark = function isMark(codePoint) {
    var category = $3939d1de148b5202$var$getCategory(codePoint);
    return category === 'Mn' || category === 'Me' || category === 'Mc';
};
var $3939d1de148b5202$var$unicode = {
    getCategory: $3939d1de148b5202$var$getCategory,
    getCombiningClass: $3939d1de148b5202$var$getCombiningClass,
    getScript: $3939d1de148b5202$var$getScript,
    getEastAsianWidth: $3939d1de148b5202$var$getEastAsianWidth,
    getNumericValue: $3939d1de148b5202$var$getNumericValue,
    isAlphabetic: $3939d1de148b5202$var$isAlphabetic,
    isDigit: $3939d1de148b5202$var$isDigit,
    isPunctuation: $3939d1de148b5202$var$isPunctuation,
    isLowerCase: $3939d1de148b5202$var$isLowerCase,
    isUpperCase: $3939d1de148b5202$var$isUpperCase,
    isTitleCase: $3939d1de148b5202$var$isTitleCase,
    isWhiteSpace: $3939d1de148b5202$var$isWhiteSpace,
    isBaseForm: $3939d1de148b5202$var$isBaseForm,
    isMark: $3939d1de148b5202$var$isMark
};
/**
 * This class is used when GPOS does not define 'mark' or 'mkmk' features
 * for positioning marks relative to base glyphs. It uses the unicode
 * combining class property to position marks.
 *
 * Based on code from Harfbuzz, thanks!
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
 */ var $3939d1de148b5202$var$UnicodeLayoutEngine = /*#__PURE__*/ function() {
    function UnicodeLayoutEngine(font) {
        this.font = font;
    }
    var _proto = UnicodeLayoutEngine.prototype;
    _proto.positionGlyphs = function positionGlyphs(glyphs, positions) {
        // find each base + mark cluster, and position the marks relative to the base
        var clusterStart = 0;
        var clusterEnd = 0;
        for(var index = 0; index < glyphs.length; index++){
            var glyph = glyphs[index];
            if (glyph.isMark) // TODO: handle ligatures
            clusterEnd = index;
            else {
                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                clusterStart = clusterEnd = index;
            }
        }
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        return positions;
    };
    _proto.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
        var base = glyphs[clusterStart];
        var baseBox = base.cbox.copy(); // adjust bounding box for ligature glyphs
        if (base.codePoints.length > 1) // LTR. TODO: RTL support.
        baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
        var xOffset = -positions[clusterStart].xAdvance;
        var yOffset = 0;
        var yGap = this.font.unitsPerEm / 16; // position each of the mark glyphs relative to the base glyph
        for(var index = clusterStart + 1; index <= clusterEnd; index++){
            var mark = glyphs[index];
            var markBox = mark.cbox;
            var position = positions[index];
            var combiningClass = this.getCombiningClass(mark.codePoints[0]);
            if (combiningClass !== 'Not_Reordered') {
                position.xOffset = position.yOffset = 0; // x positioning
                switch(combiningClass){
                    case 'Double_Above':
                    case 'Double_Below':
                        // LTR. TODO: RTL support.
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case 'Attached_Below_Left':
                    case 'Below_Left':
                    case 'Above_Left':
                        // left align
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case 'Attached_Above_Right':
                    case 'Below_Right':
                    case 'Above_Right':
                        // right align
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        // Attached_Below, Attached_Above, Below, Above, other
                        // center align
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                } // y positioning
                switch(combiningClass){
                    case 'Double_Below':
                    case 'Below_Left':
                    case 'Below':
                    case 'Below_Right':
                    case 'Attached_Below_Left':
                    case 'Attached_Below':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') baseBox.minY += yGap;
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case 'Double_Above':
                    case 'Above_Left':
                    case 'Above':
                    case 'Above_Right':
                    case 'Attached_Above':
                    case 'Attached_Above_Right':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') baseBox.maxY += yGap;
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                }
                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
            } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
            }
        }
        return;
    };
    _proto.getCombiningClass = function getCombiningClass(codePoint) {
        var combiningClass = $3939d1de148b5202$var$unicode.getCombiningClass(codePoint); // Thai / Lao need some per-character work
        if ((codePoint & -256) === 0x0e00) {
            if (combiningClass === 'Not_Reordered') switch(codePoint){
                case 0x0e31:
                case 0x0e34:
                case 0x0e35:
                case 0x0e36:
                case 0x0e37:
                case 0x0e47:
                case 0x0e4c:
                case 0x0e3d:
                case 0x0e4e:
                    return 'Above_Right';
                case 0x0eb1:
                case 0x0eb4:
                case 0x0eb5:
                case 0x0eb6:
                case 0x0eb7:
                case 0x0ebb:
                case 0x0ecc:
                case 0x0ecd:
                    return 'Above';
                case 0x0ebc:
                    return 'Below';
            }
            else if (codePoint === 0x0e3a) // virama
            return 'Below_Right';
        }
        switch(combiningClass){
            // Hebrew
            case 'CCC10':
            case 'CCC11':
            case 'CCC12':
            case 'CCC13':
            case 'CCC14':
            case 'CCC15':
            case 'CCC16':
            case 'CCC17':
            case 'CCC18':
            case 'CCC20':
            case 'CCC22':
                // meteg
                return 'Below';
            case 'CCC23':
                // rafe
                return 'Attached_Above';
            case 'CCC24':
                // shin dot
                return 'Above_Right';
            case 'CCC25':
            case 'CCC19':
                // holam
                return 'Above_Left';
            case 'CCC26':
                // point varika
                return 'Above';
            case 'CCC21':
                break;
            // Arabic and Syriac
            case 'CCC27':
            case 'CCC28':
            case 'CCC30':
            case 'CCC31':
            case 'CCC33':
            case 'CCC34':
            case 'CCC35':
            case 'CCC36':
                // superscript alaph
                return 'Above';
            case 'CCC29':
            case 'CCC32':
                // kasra
                return 'Below';
            // Thai
            case 'CCC103':
                // sara u / sara uu
                return 'Below_Right';
            case 'CCC107':
                // mai
                return 'Above_Right';
            // Lao
            case 'CCC118':
                // sign u / sign uu
                return 'Below';
            case 'CCC122':
                // mai
                return 'Above';
            // Tibetan
            case 'CCC129':
            case 'CCC132':
                // sign u
                return 'Below';
            case 'CCC130':
                // sign i
                return 'Above';
        }
        return combiningClass;
    };
    return UnicodeLayoutEngine;
}();
function $3939d1de148b5202$var$_defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$1(Constructor, staticProps);
    return Constructor;
}
/**
 * Represents a glyph bounding box
 */ var $3939d1de148b5202$var$BBox = /*#__PURE__*/ function() {
    function BBox(minX, minY, maxX, maxY) {
        if (minX === void 0) minX = Infinity;
        if (minY === void 0) minY = Infinity;
        if (maxX === void 0) maxX = -Infinity;
        if (maxY === void 0) maxY = -Infinity;
        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * The width of the bounding box
   * @type {number}
   */ var _proto = BBox.prototype;
    _proto.addPoint = function addPoint(x, y) {
        if (Math.abs(x) !== Infinity) {
            if (x < this.minX) this.minX = x;
            if (x > this.maxX) this.maxX = x;
        }
        if (Math.abs(y) !== Infinity) {
            if (y < this.minY) this.minY = y;
            if (y > this.maxY) this.maxY = y;
        }
    };
    _proto.copy = function copy() {
        return new BBox(this.minX, this.minY, this.maxX, this.maxY);
    };
    $3939d1de148b5202$var$_createClass$1(BBox, [
        {
            key: "width",
            get: function get() {
                return this.maxX - this.minX;
            }
        },
        {
            key: "height",
            get: function get() {
                return this.maxY - this.minY;
            }
        }
    ]);
    return BBox;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$6(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$6(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$6(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
var $3939d1de148b5202$var$UNICODE_SCRIPTS = {
    Caucasian_Albanian: 'aghb',
    Arabic: 'arab',
    Imperial_Aramaic: 'armi',
    Armenian: 'armn',
    Avestan: 'avst',
    Balinese: 'bali',
    Bamum: 'bamu',
    Bassa_Vah: 'bass',
    Batak: 'batk',
    Bengali: [
        'bng2',
        'beng'
    ],
    Bopomofo: 'bopo',
    Brahmi: 'brah',
    Braille: 'brai',
    Buginese: 'bugi',
    Buhid: 'buhd',
    Chakma: 'cakm',
    Canadian_Aboriginal: 'cans',
    Carian: 'cari',
    Cham: 'cham',
    Cherokee: 'cher',
    Coptic: 'copt',
    Cypriot: 'cprt',
    Cyrillic: 'cyrl',
    Devanagari: [
        'dev2',
        'deva'
    ],
    Deseret: 'dsrt',
    Duployan: 'dupl',
    Egyptian_Hieroglyphs: 'egyp',
    Elbasan: 'elba',
    Ethiopic: 'ethi',
    Georgian: 'geor',
    Glagolitic: 'glag',
    Gothic: 'goth',
    Grantha: 'gran',
    Greek: 'grek',
    Gujarati: [
        'gjr2',
        'gujr'
    ],
    Gurmukhi: [
        'gur2',
        'guru'
    ],
    Hangul: 'hang',
    Han: 'hani',
    Hanunoo: 'hano',
    Hebrew: 'hebr',
    Hiragana: 'hira',
    Pahawh_Hmong: 'hmng',
    Katakana_Or_Hiragana: 'hrkt',
    Old_Italic: 'ital',
    Javanese: 'java',
    Kayah_Li: 'kali',
    Katakana: 'kana',
    Kharoshthi: 'khar',
    Khmer: 'khmr',
    Khojki: 'khoj',
    Kannada: [
        'knd2',
        'knda'
    ],
    Kaithi: 'kthi',
    Tai_Tham: 'lana',
    Lao: 'lao ',
    Latin: 'latn',
    Lepcha: 'lepc',
    Limbu: 'limb',
    Linear_A: 'lina',
    Linear_B: 'linb',
    Lisu: 'lisu',
    Lycian: 'lyci',
    Lydian: 'lydi',
    Mahajani: 'mahj',
    Mandaic: 'mand',
    Manichaean: 'mani',
    Mende_Kikakui: 'mend',
    Meroitic_Cursive: 'merc',
    Meroitic_Hieroglyphs: 'mero',
    Malayalam: [
        'mlm2',
        'mlym'
    ],
    Modi: 'modi',
    Mongolian: 'mong',
    Mro: 'mroo',
    Meetei_Mayek: 'mtei',
    Myanmar: [
        'mym2',
        'mymr'
    ],
    Old_North_Arabian: 'narb',
    Nabataean: 'nbat',
    Nko: 'nko ',
    Ogham: 'ogam',
    Ol_Chiki: 'olck',
    Old_Turkic: 'orkh',
    Oriya: [
        'ory2',
        'orya'
    ],
    Osmanya: 'osma',
    Palmyrene: 'palm',
    Pau_Cin_Hau: 'pauc',
    Old_Permic: 'perm',
    Phags_Pa: 'phag',
    Inscriptional_Pahlavi: 'phli',
    Psalter_Pahlavi: 'phlp',
    Phoenician: 'phnx',
    Miao: 'plrd',
    Inscriptional_Parthian: 'prti',
    Rejang: 'rjng',
    Runic: 'runr',
    Samaritan: 'samr',
    Old_South_Arabian: 'sarb',
    Saurashtra: 'saur',
    Shavian: 'shaw',
    Sharada: 'shrd',
    Siddham: 'sidd',
    Khudawadi: 'sind',
    Sinhala: 'sinh',
    Sora_Sompeng: 'sora',
    Sundanese: 'sund',
    Syloti_Nagri: 'sylo',
    Syriac: 'syrc',
    Tagbanwa: 'tagb',
    Takri: 'takr',
    Tai_Le: 'tale',
    New_Tai_Lue: 'talu',
    Tamil: [
        'tml2',
        'taml'
    ],
    Tai_Viet: 'tavt',
    Telugu: [
        'tel2',
        'telu'
    ],
    Tifinagh: 'tfng',
    Tagalog: 'tglg',
    Thaana: 'thaa',
    Thai: 'thai',
    Tibetan: 'tibt',
    Tirhuta: 'tirh',
    Ugaritic: 'ugar',
    Vai: 'vai ',
    Warang_Citi: 'wara',
    Old_Persian: 'xpeo',
    Cuneiform: 'xsux',
    Yi: 'yi  ',
    Inherited: 'zinh',
    Common: 'zyyy',
    Unknown: 'zzzz'
};
var $3939d1de148b5202$var$OPENTYPE_SCRIPTS = {};
for(var $3939d1de148b5202$var$script in $3939d1de148b5202$var$UNICODE_SCRIPTS){
    var $3939d1de148b5202$var$tag = $3939d1de148b5202$var$UNICODE_SCRIPTS[$3939d1de148b5202$var$script];
    if (Array.isArray($3939d1de148b5202$var$tag)) for(var $3939d1de148b5202$var$_iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$6($3939d1de148b5202$var$tag), $3939d1de148b5202$var$_step; !($3939d1de148b5202$var$_step = $3939d1de148b5202$var$_iterator()).done;){
        var $3939d1de148b5202$var$t = $3939d1de148b5202$var$_step.value;
        $3939d1de148b5202$var$OPENTYPE_SCRIPTS[$3939d1de148b5202$var$t] = $3939d1de148b5202$var$script;
    }
    else $3939d1de148b5202$var$OPENTYPE_SCRIPTS[$3939d1de148b5202$var$tag] = $3939d1de148b5202$var$script;
}
function $3939d1de148b5202$var$fromOpenType(tag) {
    return $3939d1de148b5202$var$OPENTYPE_SCRIPTS[tag];
}
function $3939d1de148b5202$var$forString(string) {
    var len = string.length;
    var idx = 0;
    while(idx < len){
        var code = string.charCodeAt(idx++); // Check if this is a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
            var next = string.charCodeAt(idx); // Check if this is a low surrogate
            if (0xdc00 <= next && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
            }
        }
        var _script = $3939d1de148b5202$var$unicode.getScript(code);
        if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') return $3939d1de148b5202$var$UNICODE_SCRIPTS[_script];
    }
    return $3939d1de148b5202$var$UNICODE_SCRIPTS.Unknown;
}
function $3939d1de148b5202$var$forCodePoints(codePoints) {
    for(var i = 0; i < codePoints.length; i++){
        var codePoint = codePoints[i];
        var _script2 = $3939d1de148b5202$var$unicode.getScript(codePoint);
        if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') return $3939d1de148b5202$var$UNICODE_SCRIPTS[_script2];
    }
    return $3939d1de148b5202$var$UNICODE_SCRIPTS.Unknown;
} // The scripts in this map are written from right to left
var $3939d1de148b5202$var$RTL = {
    arab: true,
    // Arabic
    hebr: true,
    // Hebrew
    syrc: true,
    // Syriac
    thaa: true,
    // Thaana
    cprt: true,
    // Cypriot Syllabary
    khar: true,
    // Kharosthi
    phnx: true,
    // Phoenician
    'nko ': true,
    // N'Ko
    lydi: true,
    // Lydian
    avst: true,
    // Avestan
    armi: true,
    // Imperial Aramaic
    phli: true,
    // Inscriptional Pahlavi
    prti: true,
    // Inscriptional Parthian
    sarb: true,
    // Old South Arabian
    orkh: true,
    // Old Turkic, Orkhon Runic
    samr: true,
    // Samaritan
    mand: true,
    // Mandaic, Mandaean
    merc: true,
    // Meroitic Cursive
    mero: true,
    // Meroitic Hieroglyphs
    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
    mani: true,
    // Manichaean
    mend: true,
    // Mende Kikakui
    nbat: true,
    // Nabataean
    narb: true,
    // Old North Arabian
    palm: true,
    // Palmyrene
    phlp: true // Psalter Pahlavi
};
function $3939d1de148b5202$var$direction(script) {
    if ($3939d1de148b5202$var$RTL[script]) return 'rtl';
    return 'ltr';
}
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$7(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$7(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$7(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$7(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$7(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$2(Constructor, staticProps);
    return Constructor;
}
/**
 * Represents a run of Glyph and GlyphPosition objects.
 * Returned by the font layout method.
 */ var $3939d1de148b5202$var$GlyphRun = /*#__PURE__*/ function() {
    function GlyphRun(glyphs, features, script, language, direction$1) {
        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction$1 || $3939d1de148b5202$var$direction(script);
        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {}; // Convert features to an object
        if (Array.isArray(features)) for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$7(features), _step; !(_step = _iterator()).done;){
            var tag = _step.value;
            this.features[tag] = true;
        }
        else if (typeof features === 'object') this.features = features;
    }
    /**
   * The total advance width of the run.
   * @type {number}
   */ $3939d1de148b5202$var$_createClass$2(GlyphRun, [
        {
            key: "advanceWidth",
            get: function get() {
                var width = 0;
                for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$7(this.positions), _step2; !(_step2 = _iterator2()).done;){
                    var position = _step2.value;
                    width += position.xAdvance;
                }
                return width;
            }
        },
        {
            key: "advanceHeight",
            get: function get() {
                var height = 0;
                for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$7(this.positions), _step3; !(_step3 = _iterator3()).done;){
                    var position = _step3.value;
                    height += position.yAdvance;
                }
                return height;
            }
        },
        {
            key: "bbox",
            get: function get() {
                var bbox = new $3939d1de148b5202$var$BBox();
                var x = 0;
                var y = 0;
                for(var index = 0; index < this.glyphs.length; index++){
                    var glyph = this.glyphs[index];
                    var p = this.positions[index];
                    var b = glyph.bbox;
                    bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
                    bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
                    x += p.xAdvance;
                    y += p.yAdvance;
                }
                return bbox;
            }
        }
    ]);
    return GlyphRun;
}();
/**
 * Represents positioning information for a glyph in a GlyphRun.
 */ var $3939d1de148b5202$var$GlyphPosition = function GlyphPosition(xAdvance, yAdvance, xOffset, yOffset) {
    if (xAdvance === void 0) xAdvance = 0;
    if (yAdvance === void 0) yAdvance = 0;
    if (xOffset === void 0) xOffset = 0;
    if (yOffset === void 0) yOffset = 0;
    /**
   * The amount to move the virtual pen in the X direction after rendering this glyph.
   * @type {number}
   */ this.xAdvance = xAdvance;
    /**
   * The amount to move the virtual pen in the Y direction after rendering this glyph.
   * @type {number}
   */ this.yAdvance = yAdvance;
    /**
   * The offset from the pen position in the X direction at which to render this glyph.
   * @type {number}
   */ this.xOffset = xOffset;
    /**
   * The offset from the pen position in the Y direction at which to render this glyph.
   * @type {number}
   */ this.yOffset = yOffset;
};
// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
var $3939d1de148b5202$var$features = {
    allTypographicFeatures: {
        code: 0,
        exclusive: false,
        allTypeFeatures: 0
    },
    ligatures: {
        code: 1,
        exclusive: false,
        requiredLigatures: 0,
        commonLigatures: 2,
        rareLigatures: 4,
        // logos: 6
        rebusPictures: 8,
        diphthongLigatures: 10,
        squaredLigatures: 12,
        abbrevSquaredLigatures: 14,
        symbolLigatures: 16,
        contextualLigatures: 18,
        historicalLigatures: 20
    },
    cursiveConnection: {
        code: 2,
        exclusive: true,
        unconnected: 0,
        partiallyConnected: 1,
        cursive: 2
    },
    letterCase: {
        code: 3,
        exclusive: true
    },
    // upperAndLowerCase: 0          # deprecated
    // allCaps: 1                    # deprecated
    // allLowerCase: 2               # deprecated
    // smallCaps: 3                  # deprecated
    // initialCaps: 4                # deprecated
    // initialCapsAndSmallCaps: 5    # deprecated
    verticalSubstitution: {
        code: 4,
        exclusive: false,
        substituteVerticalForms: 0
    },
    linguisticRearrangement: {
        code: 5,
        exclusive: false,
        linguisticRearrangement: 0
    },
    numberSpacing: {
        code: 6,
        exclusive: true,
        monospacedNumbers: 0,
        proportionalNumbers: 1,
        thirdWidthNumbers: 2,
        quarterWidthNumbers: 3
    },
    smartSwash: {
        code: 8,
        exclusive: false,
        wordInitialSwashes: 0,
        wordFinalSwashes: 2,
        // lineInitialSwashes: 4
        // lineFinalSwashes: 6
        nonFinalSwashes: 8
    },
    diacritics: {
        code: 9,
        exclusive: true,
        showDiacritics: 0,
        hideDiacritics: 1,
        decomposeDiacritics: 2
    },
    verticalPosition: {
        code: 10,
        exclusive: true,
        normalPosition: 0,
        superiors: 1,
        inferiors: 2,
        ordinals: 3,
        scientificInferiors: 4
    },
    fractions: {
        code: 11,
        exclusive: true,
        noFractions: 0,
        verticalFractions: 1,
        diagonalFractions: 2
    },
    overlappingCharacters: {
        code: 13,
        exclusive: false,
        preventOverlap: 0
    },
    typographicExtras: {
        code: 14,
        exclusive: false,
        // hyphensToEmDash: 0
        // hyphenToEnDash: 2
        slashedZero: 4
    },
    // formInterrobang: 6
    // smartQuotes: 8
    // periodsToEllipsis: 10
    mathematicalExtras: {
        code: 15,
        exclusive: false,
        // hyphenToMinus: 0
        // asteristoMultiply: 2
        // slashToDivide: 4
        // inequalityLigatures: 6
        // exponents: 8
        mathematicalGreek: 10
    },
    ornamentSets: {
        code: 16,
        exclusive: true,
        noOrnaments: 0,
        dingbats: 1,
        piCharacters: 2,
        fleurons: 3,
        decorativeBorders: 4,
        internationalSymbols: 5,
        mathSymbols: 6
    },
    characterAlternatives: {
        code: 17,
        exclusive: true,
        noAlternates: 0
    },
    // user defined options
    designComplexity: {
        code: 18,
        exclusive: true,
        designLevel1: 0,
        designLevel2: 1,
        designLevel3: 2,
        designLevel4: 3,
        designLevel5: 4
    },
    styleOptions: {
        code: 19,
        exclusive: true,
        noStyleOptions: 0,
        displayText: 1,
        engravedText: 2,
        illuminatedCaps: 3,
        titlingCaps: 4,
        tallCaps: 5
    },
    characterShape: {
        code: 20,
        exclusive: true,
        traditionalCharacters: 0,
        simplifiedCharacters: 1,
        JIS1978Characters: 2,
        JIS1983Characters: 3,
        JIS1990Characters: 4,
        traditionalAltOne: 5,
        traditionalAltTwo: 6,
        traditionalAltThree: 7,
        traditionalAltFour: 8,
        traditionalAltFive: 9,
        expertCharacters: 10,
        JIS2004Characters: 11,
        hojoCharacters: 12,
        NLCCharacters: 13,
        traditionalNamesCharacters: 14
    },
    numberCase: {
        code: 21,
        exclusive: true,
        lowerCaseNumbers: 0,
        upperCaseNumbers: 1
    },
    textSpacing: {
        code: 22,
        exclusive: true,
        proportionalText: 0,
        monospacedText: 1,
        halfWidthText: 2,
        thirdWidthText: 3,
        quarterWidthText: 4,
        altProportionalText: 5,
        altHalfWidthText: 6
    },
    transliteration: {
        code: 23,
        exclusive: true,
        noTransliteration: 0
    },
    // hanjaToHangul: 1
    // hiraganaToKatakana: 2
    // katakanaToHiragana: 3
    // kanaToRomanization: 4
    // romanizationToHiragana: 5
    // romanizationToKatakana: 6
    // hanjaToHangulAltOne: 7
    // hanjaToHangulAltTwo: 8
    // hanjaToHangulAltThree: 9
    annotation: {
        code: 24,
        exclusive: true,
        noAnnotation: 0,
        boxAnnotation: 1,
        roundedBoxAnnotation: 2,
        circleAnnotation: 3,
        invertedCircleAnnotation: 4,
        parenthesisAnnotation: 5,
        periodAnnotation: 6,
        romanNumeralAnnotation: 7,
        diamondAnnotation: 8,
        invertedBoxAnnotation: 9,
        invertedRoundedBoxAnnotation: 10
    },
    kanaSpacing: {
        code: 25,
        exclusive: true,
        fullWidthKana: 0,
        proportionalKana: 1
    },
    ideographicSpacing: {
        code: 26,
        exclusive: true,
        fullWidthIdeographs: 0,
        proportionalIdeographs: 1,
        halfWidthIdeographs: 2
    },
    unicodeDecomposition: {
        code: 27,
        exclusive: false,
        canonicalComposition: 0,
        compatibilityComposition: 2,
        transcodingComposition: 4
    },
    rubyKana: {
        code: 28,
        exclusive: false,
        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
        // rubyKana: 1     # deprecated - use rubyKanaOn instead
        rubyKana: 2
    },
    CJKSymbolAlternatives: {
        code: 29,
        exclusive: true,
        noCJKSymbolAlternatives: 0,
        CJKSymbolAltOne: 1,
        CJKSymbolAltTwo: 2,
        CJKSymbolAltThree: 3,
        CJKSymbolAltFour: 4,
        CJKSymbolAltFive: 5
    },
    ideographicAlternatives: {
        code: 30,
        exclusive: true,
        noIdeographicAlternatives: 0,
        ideographicAltOne: 1,
        ideographicAltTwo: 2,
        ideographicAltThree: 3,
        ideographicAltFour: 4,
        ideographicAltFive: 5
    },
    CJKVerticalRomanPlacement: {
        code: 31,
        exclusive: true,
        CJKVerticalRomanCentered: 0,
        CJKVerticalRomanHBaseline: 1
    },
    italicCJKRoman: {
        code: 32,
        exclusive: false,
        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
        CJKItalicRoman: 2
    },
    caseSensitiveLayout: {
        code: 33,
        exclusive: false,
        caseSensitiveLayout: 0,
        caseSensitiveSpacing: 2
    },
    alternateKana: {
        code: 34,
        exclusive: false,
        alternateHorizKana: 0,
        alternateVertKana: 2
    },
    stylisticAlternatives: {
        code: 35,
        exclusive: false,
        noStylisticAlternates: 0,
        stylisticAltOne: 2,
        stylisticAltTwo: 4,
        stylisticAltThree: 6,
        stylisticAltFour: 8,
        stylisticAltFive: 10,
        stylisticAltSix: 12,
        stylisticAltSeven: 14,
        stylisticAltEight: 16,
        stylisticAltNine: 18,
        stylisticAltTen: 20,
        stylisticAltEleven: 22,
        stylisticAltTwelve: 24,
        stylisticAltThirteen: 26,
        stylisticAltFourteen: 28,
        stylisticAltFifteen: 30,
        stylisticAltSixteen: 32,
        stylisticAltSeventeen: 34,
        stylisticAltEighteen: 36,
        stylisticAltNineteen: 38,
        stylisticAltTwenty: 40
    },
    contextualAlternates: {
        code: 36,
        exclusive: false,
        contextualAlternates: 0,
        swashAlternates: 2,
        contextualSwashAlternates: 4
    },
    lowerCase: {
        code: 37,
        exclusive: true,
        defaultLowerCase: 0,
        lowerCaseSmallCaps: 1,
        lowerCasePetiteCaps: 2
    },
    upperCase: {
        code: 38,
        exclusive: true,
        defaultUpperCase: 0,
        upperCaseSmallCaps: 1,
        upperCasePetiteCaps: 2
    },
    languageTag: {
        // indices into ltag table
        code: 39,
        exclusive: true
    },
    CJKRomanSpacing: {
        code: 103,
        exclusive: true,
        halfWidthCJKRoman: 0,
        proportionalCJKRoman: 1,
        defaultCJKRoman: 2,
        fullWidthCJKRoman: 3
    }
};
var $3939d1de148b5202$var$feature = function feature(name, selector) {
    return [
        $3939d1de148b5202$var$features[name].code,
        $3939d1de148b5202$var$features[name][selector]
    ];
};
var $3939d1de148b5202$var$OTMapping = {
    rlig: $3939d1de148b5202$var$feature('ligatures', 'requiredLigatures'),
    clig: $3939d1de148b5202$var$feature('ligatures', 'contextualLigatures'),
    dlig: $3939d1de148b5202$var$feature('ligatures', 'rareLigatures'),
    hlig: $3939d1de148b5202$var$feature('ligatures', 'historicalLigatures'),
    liga: $3939d1de148b5202$var$feature('ligatures', 'commonLigatures'),
    hist: $3939d1de148b5202$var$feature('ligatures', 'historicalLigatures'),
    // ??
    smcp: $3939d1de148b5202$var$feature('lowerCase', 'lowerCaseSmallCaps'),
    pcap: $3939d1de148b5202$var$feature('lowerCase', 'lowerCasePetiteCaps'),
    frac: $3939d1de148b5202$var$feature('fractions', 'diagonalFractions'),
    dnom: $3939d1de148b5202$var$feature('fractions', 'diagonalFractions'),
    // ??
    numr: $3939d1de148b5202$var$feature('fractions', 'diagonalFractions'),
    // ??
    afrc: $3939d1de148b5202$var$feature('fractions', 'verticalFractions'),
    // aalt
    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
    // unic, vatu, vhal, vjmo, vpal, vrt2
    // dist -> trak table?
    // kern, vkrn -> kern table
    // lfbd + opbd + rtbd -> opbd table?
    // mark, mkmk -> acnt table?
    // locl -> languageTag + ltag table
    "case": $3939d1de148b5202$var$feature('caseSensitiveLayout', 'caseSensitiveLayout'),
    // also caseSensitiveSpacing
    ccmp: $3939d1de148b5202$var$feature('unicodeDecomposition', 'canonicalComposition'),
    // compatibilityComposition?
    cpct: $3939d1de148b5202$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    // guess..., probably not given below
    valt: $3939d1de148b5202$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    swsh: $3939d1de148b5202$var$feature('contextualAlternates', 'swashAlternates'),
    cswh: $3939d1de148b5202$var$feature('contextualAlternates', 'contextualSwashAlternates'),
    curs: $3939d1de148b5202$var$feature('cursiveConnection', 'cursive'),
    // ??
    c2pc: $3939d1de148b5202$var$feature('upperCase', 'upperCasePetiteCaps'),
    c2sc: $3939d1de148b5202$var$feature('upperCase', 'upperCaseSmallCaps'),
    init: $3939d1de148b5202$var$feature('smartSwash', 'wordInitialSwashes'),
    // ??
    fin2: $3939d1de148b5202$var$feature('smartSwash', 'wordFinalSwashes'),
    // ??
    medi: $3939d1de148b5202$var$feature('smartSwash', 'nonFinalSwashes'),
    // ??
    med2: $3939d1de148b5202$var$feature('smartSwash', 'nonFinalSwashes'),
    // ??
    fin3: $3939d1de148b5202$var$feature('smartSwash', 'wordFinalSwashes'),
    // ??
    fina: $3939d1de148b5202$var$feature('smartSwash', 'wordFinalSwashes'),
    // ??
    pkna: $3939d1de148b5202$var$feature('kanaSpacing', 'proportionalKana'),
    half: $3939d1de148b5202$var$feature('textSpacing', 'halfWidthText'),
    // also HalfWidthCJKRoman, HalfWidthIdeographs?
    halt: $3939d1de148b5202$var$feature('textSpacing', 'altHalfWidthText'),
    hkna: $3939d1de148b5202$var$feature('alternateKana', 'alternateHorizKana'),
    vkna: $3939d1de148b5202$var$feature('alternateKana', 'alternateVertKana'),
    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
    ital: $3939d1de148b5202$var$feature('italicCJKRoman', 'CJKItalicRoman'),
    lnum: $3939d1de148b5202$var$feature('numberCase', 'upperCaseNumbers'),
    onum: $3939d1de148b5202$var$feature('numberCase', 'lowerCaseNumbers'),
    mgrk: $3939d1de148b5202$var$feature('mathematicalExtras', 'mathematicalGreek'),
    // nalt: not enough info. what type of annotation?
    // ornm: ditto, which ornament style?
    calt: $3939d1de148b5202$var$feature('contextualAlternates', 'contextualAlternates'),
    // or more?
    vrt2: $3939d1de148b5202$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    // oh... below?
    vert: $3939d1de148b5202$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    tnum: $3939d1de148b5202$var$feature('numberSpacing', 'monospacedNumbers'),
    pnum: $3939d1de148b5202$var$feature('numberSpacing', 'proportionalNumbers'),
    sups: $3939d1de148b5202$var$feature('verticalPosition', 'superiors'),
    subs: $3939d1de148b5202$var$feature('verticalPosition', 'inferiors'),
    ordn: $3939d1de148b5202$var$feature('verticalPosition', 'ordinals'),
    pwid: $3939d1de148b5202$var$feature('textSpacing', 'proportionalText'),
    hwid: $3939d1de148b5202$var$feature('textSpacing', 'halfWidthText'),
    qwid: $3939d1de148b5202$var$feature('textSpacing', 'quarterWidthText'),
    // also QuarterWidthNumbers?
    twid: $3939d1de148b5202$var$feature('textSpacing', 'thirdWidthText'),
    // also ThirdWidthNumbers?
    fwid: $3939d1de148b5202$var$feature('textSpacing', 'proportionalText'),
    //??
    palt: $3939d1de148b5202$var$feature('textSpacing', 'altProportionalText'),
    trad: $3939d1de148b5202$var$feature('characterShape', 'traditionalCharacters'),
    smpl: $3939d1de148b5202$var$feature('characterShape', 'simplifiedCharacters'),
    jp78: $3939d1de148b5202$var$feature('characterShape', 'JIS1978Characters'),
    jp83: $3939d1de148b5202$var$feature('characterShape', 'JIS1983Characters'),
    jp90: $3939d1de148b5202$var$feature('characterShape', 'JIS1990Characters'),
    jp04: $3939d1de148b5202$var$feature('characterShape', 'JIS2004Characters'),
    expt: $3939d1de148b5202$var$feature('characterShape', 'expertCharacters'),
    hojo: $3939d1de148b5202$var$feature('characterShape', 'hojoCharacters'),
    nlck: $3939d1de148b5202$var$feature('characterShape', 'NLCCharacters'),
    tnam: $3939d1de148b5202$var$feature('characterShape', 'traditionalNamesCharacters'),
    ruby: $3939d1de148b5202$var$feature('rubyKana', 'rubyKana'),
    titl: $3939d1de148b5202$var$feature('styleOptions', 'titlingCaps'),
    zero: $3939d1de148b5202$var$feature('typographicExtras', 'slashedZero'),
    ss01: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltOne'),
    ss02: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltTwo'),
    ss03: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltThree'),
    ss04: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltFour'),
    ss05: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltFive'),
    ss06: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltSix'),
    ss07: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltSeven'),
    ss08: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltEight'),
    ss09: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltNine'),
    ss10: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltTen'),
    ss11: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltEleven'),
    ss12: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltTwelve'),
    ss13: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltThirteen'),
    ss14: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltFourteen'),
    ss15: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltFifteen'),
    ss16: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltSixteen'),
    ss17: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltSeventeen'),
    ss18: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltEighteen'),
    ss19: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltNineteen'),
    ss20: $3939d1de148b5202$var$feature('stylisticAlternatives', 'stylisticAltTwenty')
}; // salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
// Add cv01-cv99 features
for(var $3939d1de148b5202$var$i$3 = 1; $3939d1de148b5202$var$i$3 <= 99; $3939d1de148b5202$var$i$3++)$3939d1de148b5202$var$OTMapping["cv" + ("00" + $3939d1de148b5202$var$i$3).slice(-2)] = [
    $3939d1de148b5202$var$features.characterAlternatives.code,
    $3939d1de148b5202$var$i$3
];
 // create inverse mapping
var $3939d1de148b5202$var$AATMapping = {};
for(var $3939d1de148b5202$var$ot in $3939d1de148b5202$var$OTMapping){
    var $3939d1de148b5202$var$aat = $3939d1de148b5202$var$OTMapping[$3939d1de148b5202$var$ot];
    if ($3939d1de148b5202$var$AATMapping[$3939d1de148b5202$var$aat[0]] == null) $3939d1de148b5202$var$AATMapping[$3939d1de148b5202$var$aat[0]] = {};
    $3939d1de148b5202$var$AATMapping[$3939d1de148b5202$var$aat[0]][$3939d1de148b5202$var$aat[1]] = $3939d1de148b5202$var$ot;
} // Maps an array of OpenType features to AAT features
// in the form of {featureType:{featureSetting:true}}
function $3939d1de148b5202$var$mapOTToAAT(features) {
    var res = {};
    for(var k in features){
        var r = void 0;
        if (r = $3939d1de148b5202$var$OTMapping[k]) {
            if (res[r[0]] == null) res[r[0]] = {};
            res[r[0]][r[1]] = features[k];
        }
    }
    return res;
} // Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function $3939d1de148b5202$var$mapFeatureStrings(f) {
    var type = f[0], setting = f[1];
    if (isNaN(type)) var typeCode = $3939d1de148b5202$var$features[type] && $3939d1de148b5202$var$features[type].code;
    else var typeCode = type;
    if (isNaN(setting)) var settingCode = $3939d1de148b5202$var$features[type] && $3939d1de148b5202$var$features[type][setting];
    else var settingCode = setting;
    return [
        typeCode,
        settingCode
    ];
} // Maps AAT features to an array of OpenType features
// Supports both arrays in the form of [[featureType, featureSetting]]
// and objects in the form of {featureType:{featureSetting:true}}
// featureTypes and featureSettings can be either strings or number codes
function $3939d1de148b5202$var$mapAATToOT(features) {
    var res = {};
    if (Array.isArray(features)) for(var k = 0; k < features.length; k++){
        var r = void 0;
        var f = $3939d1de148b5202$var$mapFeatureStrings(features[k]);
        if (r = $3939d1de148b5202$var$AATMapping[f[0]] && $3939d1de148b5202$var$AATMapping[f[0]][f[1]]) res[r] = true;
    }
    else if (typeof features === 'object') for(var type in features){
        var _feature = features[type];
        for(var setting in _feature){
            var _r = void 0;
            var _f = $3939d1de148b5202$var$mapFeatureStrings([
                type,
                setting
            ]);
            if (_feature[setting] && (_r = $3939d1de148b5202$var$AATMapping[_f[0]] && $3939d1de148b5202$var$AATMapping[_f[0]][_f[1]])) res[_r] = true;
        }
    }
    return Object.keys(res);
}
var $3939d1de148b5202$var$_class$1;
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$8(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$8(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$8(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$8(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$8(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$8(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
var $3939d1de148b5202$var$AATLookupTable = ($3939d1de148b5202$var$_class$1 = /*#__PURE__*/ function() {
    function AATLookupTable(table) {
        this.table = table;
    }
    var _proto = AATLookupTable.prototype;
    _proto.lookup = function lookup(glyph) {
        switch(this.table.version){
            case 0:
                // simple array format
                return this.table.values.getItem(glyph);
            case 2:
            case 4:
                var min = 0;
                var max = this.table.binarySearchHeader.nUnits - 1;
                while(min <= max){
                    var mid = min + max >> 1;
                    var seg = this.table.segments[mid]; // special end of search value
                    if (seg.firstGlyph === 0xffff) return null;
                    if (glyph < seg.firstGlyph) max = mid - 1;
                    else if (glyph > seg.lastGlyph) min = mid + 1;
                    else {
                        if (this.table.version === 2) return seg.value;
                        else return seg.values[glyph - seg.firstGlyph];
                    }
                }
                return null;
            case 6:
                // lookup single
                var _min = 0;
                var _max = this.table.binarySearchHeader.nUnits - 1;
                while(_min <= _max){
                    var mid = _min + _max >> 1;
                    var seg = this.table.segments[mid]; // special end of search value
                    if (seg.glyph === 0xffff) return null;
                    if (glyph < seg.glyph) _max = mid - 1;
                    else if (glyph > seg.glyph) _min = mid + 1;
                    else return seg.value;
                }
                return null;
            case 8:
                // lookup trimmed
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error("Unknown lookup table format: " + this.table.version);
        }
    };
    _proto.glyphsForValue = function glyphsForValue(classValue) {
        var res = [];
        switch(this.table.version){
            case 2:
            case 4:
                for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$8(this.table.segments), _step; !(_step = _iterator()).done;){
                    var segment = _step.value;
                    if (this.table.version === 2 && segment.value === classValue) res.push.apply(res, $3939d1de148b5202$var$range(segment.firstGlyph, segment.lastGlyph + 1));
                    else {
                        for(var index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                    }
                }
                break;
            case 6:
                // lookup single
                for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$8(this.table.segments), _step2; !(_step2 = _iterator2()).done;){
                    var _segment = _step2.value;
                    if (_segment.value === classValue) res.push(_segment.glyph);
                }
                break;
            case 8:
                // lookup trimmed
                for(var i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                break;
            default:
                throw new Error("Unknown lookup table format: " + this.table.version);
        }
        return res;
    };
    return AATLookupTable;
}(), $3939d1de148b5202$var$_applyDecoratedDescriptor$1($3939d1de148b5202$var$_class$1.prototype, "glyphsForValue", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$1.prototype, "glyphsForValue"), $3939d1de148b5202$var$_class$1.prototype), $3939d1de148b5202$var$_class$1);
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$9(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$9(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$9(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$9(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$9(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$9(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$START_OF_TEXT_STATE = 0;
var $3939d1de148b5202$var$END_OF_TEXT_CLASS = 0;
var $3939d1de148b5202$var$OUT_OF_BOUNDS_CLASS = 1;
var $3939d1de148b5202$var$DELETED_GLYPH_CLASS = 2;
var $3939d1de148b5202$var$DONT_ADVANCE = 0x4000;
var $3939d1de148b5202$var$AATStateMachine = /*#__PURE__*/ function() {
    function AATStateMachine(stateTable) {
        this.stateTable = stateTable;
        this.lookupTable = new $3939d1de148b5202$var$AATLookupTable(stateTable.classTable);
    }
    var _proto = AATStateMachine.prototype;
    _proto.process = function process(glyphs, reverse, processEntry) {
        var currentState = $3939d1de148b5202$var$START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
        var index = reverse ? glyphs.length - 1 : 0;
        var dir = reverse ? -1 : 1;
        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
            var glyph = null;
            var classCode = $3939d1de148b5202$var$OUT_OF_BOUNDS_CLASS;
            var shouldAdvance = true;
            if (index === glyphs.length || index === -1) classCode = $3939d1de148b5202$var$END_OF_TEXT_CLASS;
            else {
                glyph = glyphs[index];
                if (glyph.id === 0xffff) // deleted glyph
                classCode = $3939d1de148b5202$var$DELETED_GLYPH_CLASS;
                else {
                    classCode = this.lookupTable.lookup(glyph.id);
                    if (classCode == null) classCode = $3939d1de148b5202$var$OUT_OF_BOUNDS_CLASS;
                }
            }
            var row = this.stateTable.stateArray.getItem(currentState);
            var entryIndex = row[classCode];
            var entry = this.stateTable.entryTable.getItem(entryIndex);
            if (classCode !== $3939d1de148b5202$var$END_OF_TEXT_CLASS && classCode !== $3939d1de148b5202$var$DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & $3939d1de148b5202$var$DONT_ADVANCE);
            }
            currentState = entry.newState;
            if (shouldAdvance) index += dir;
        }
        return glyphs;
    };
    _proto.traverse = function traverse(opts, state, visited) {
        if (state === void 0) state = 0;
        if (visited === void 0) visited = new Set();
        if (visited.has(state)) return;
        visited.add(state);
        var _this$stateTable = this.stateTable, nClasses = _this$stateTable.nClasses, stateArray = _this$stateTable.stateArray, entryTable = _this$stateTable.entryTable;
        var row = stateArray.getItem(state); // Skip predefined classes
        for(var classCode = 4; classCode < nClasses; classCode++){
            var entryIndex = row[classCode];
            var entry = entryTable.getItem(entryIndex); // Try all glyphs in the class
            for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$9(this.lookupTable.glyphsForValue(classCode)), _step; !(_step = _iterator()).done;){
                var glyph = _step.value;
                if (opts.enter) opts.enter(glyph, entry);
                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                if (opts.exit) opts.exit(glyph, entry);
            }
        }
    };
    return AATStateMachine;
}();
var $3939d1de148b5202$var$_class$2;
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$a(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$a(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$a(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$a(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$a(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
var $3939d1de148b5202$var$MARK_FIRST = 0x8000;
var $3939d1de148b5202$var$MARK_LAST = 0x2000;
var $3939d1de148b5202$var$VERB = 0x000F; // contextual substitution and glyph insertion flag
var $3939d1de148b5202$var$SET_MARK = 0x8000; // ligature entry flags
var $3939d1de148b5202$var$SET_COMPONENT = 0x8000;
var $3939d1de148b5202$var$PERFORM_ACTION = 0x2000; // ligature action masks
var $3939d1de148b5202$var$LAST_MASK = 0x80000000;
var $3939d1de148b5202$var$STORE_MASK = 0x40000000;
var $3939d1de148b5202$var$OFFSET_MASK = 0x3FFFFFFF;
var $3939d1de148b5202$var$REVERSE_DIRECTION = 0x400000;
var $3939d1de148b5202$var$CURRENT_INSERT_BEFORE = 0x0800;
var $3939d1de148b5202$var$MARKED_INSERT_BEFORE = 0x0400;
var $3939d1de148b5202$var$CURRENT_INSERT_COUNT = 0x03E0;
var $3939d1de148b5202$var$MARKED_INSERT_COUNT = 0x001F;
var $3939d1de148b5202$var$AATMorxProcessor = ($3939d1de148b5202$var$_class$2 = /*#__PURE__*/ function() {
    function AATMorxProcessor(font) {
        this.processIndicRearragement = this.processIndicRearragement.bind(this);
        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
        this.processLigature = this.processLigature.bind(this);
        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
        this.font = font;
        this.morx = font.morx;
        this.inputCache = null;
    } // Processes an array of glyphs and applies the specified features
    // Features should be in the form of {featureType:{featureSetting:true}}
    var _proto = AATMorxProcessor.prototype;
    _proto.process = function process(glyphs, features) {
        if (features === void 0) features = {};
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(this.morx.chains), _step; !(_step = _iterator()).done;){
            var chain = _step.value;
            var flags = chain.defaultFlags; // enable/disable the requested features
            for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(chain.features), _step2; !(_step2 = _iterator2()).done;){
                var feature = _step2.value;
                var f = void 0;
                if ((f = features[feature.featureType]) && f[feature.featureSetting]) {
                    flags &= feature.disableFlags;
                    flags |= feature.enableFlags;
                }
            }
            for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(chain.subtables), _step3; !(_step3 = _iterator3()).done;){
                var subtable = _step3.value;
                if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
            }
        } // remove deleted glyphs
        var index = glyphs.length - 1;
        while(index >= 0){
            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
            index--;
        }
        return glyphs;
    };
    _proto.processSubtable = function processSubtable(subtable, glyphs) {
        this.subtable = subtable;
        this.glyphs = glyphs;
        if (this.subtable.type === 4) {
            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
            return;
        }
        this.ligatureStack = [];
        this.markedGlyph = null;
        this.firstGlyph = null;
        this.lastGlyph = null;
        this.markedIndex = null;
        var stateMachine = this.getStateMachine(subtable);
        var process = this.getProcessor();
        var reverse = !!(this.subtable.coverage & $3939d1de148b5202$var$REVERSE_DIRECTION);
        return stateMachine.process(this.glyphs, reverse, process);
    };
    _proto.getStateMachine = function getStateMachine(subtable) {
        return new $3939d1de148b5202$var$AATStateMachine(subtable.table.stateTable);
    };
    _proto.getProcessor = function getProcessor() {
        switch(this.subtable.type){
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error("Invalid morx subtable type: " + this.subtable.type);
        }
    };
    _proto.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
        if (entry.flags & $3939d1de148b5202$var$MARK_FIRST) this.firstGlyph = index;
        if (entry.flags & $3939d1de148b5202$var$MARK_LAST) this.lastGlyph = index;
        $3939d1de148b5202$var$reorderGlyphs(this.glyphs, entry.flags & $3939d1de148b5202$var$VERB, this.firstGlyph, this.lastGlyph);
    };
    _proto.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
        var subsitutions = this.subtable.table.substitutionTable.items;
        if (entry.markIndex !== 0xffff) {
            var lookup = subsitutions.getItem(entry.markIndex);
            var lookupTable = new $3939d1de148b5202$var$AATLookupTable(lookup);
            glyph = this.glyphs[this.markedGlyph];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.currentIndex !== 0xffff) {
            var _lookup = subsitutions.getItem(entry.currentIndex);
            var _lookupTable = new $3939d1de148b5202$var$AATLookupTable(_lookup);
            glyph = this.glyphs[index];
            var gid = _lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.flags & $3939d1de148b5202$var$SET_MARK) this.markedGlyph = index;
    };
    _proto.processLigature = function processLigature(glyph, entry, index) {
        if (entry.flags & $3939d1de148b5202$var$SET_COMPONENT) this.ligatureStack.push(index);
        if (entry.flags & $3939d1de148b5202$var$PERFORM_ACTION) {
            var _this$ligatureStack;
            var actions = this.subtable.table.ligatureActions;
            var components = this.subtable.table.components;
            var ligatureList = this.subtable.table.ligatureList;
            var actionIndex = entry.action;
            var last = false;
            var ligatureIndex = 0;
            var codePoints = [];
            var ligatureGlyphs = [];
            while(!last){
                var _codePoints;
                var componentGlyph = this.ligatureStack.pop();
                (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);
                var action = actions.getItem(actionIndex++);
                last = !!(action & $3939d1de148b5202$var$LAST_MASK);
                var store = !!(action & $3939d1de148b5202$var$STORE_MASK);
                var offset = (action & $3939d1de148b5202$var$OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                offset += this.glyphs[componentGlyph].id;
                var component = components.getItem(offset);
                ligatureIndex += component;
                if (last || store) {
                    var ligatureEntry = ligatureList.getItem(ligatureIndex);
                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                    ligatureGlyphs.push(componentGlyph);
                    ligatureIndex = 0;
                    codePoints = [];
                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
            } // Put ligature glyph indexes back on the stack
            (_this$ligatureStack = this.ligatureStack).push.apply(_this$ligatureStack, ligatureGlyphs);
        }
    };
    _proto.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
        var lookupTable = new $3939d1de148b5202$var$AATLookupTable(subtable.table.lookupTable);
        for(index = 0; index < glyphs.length; index++){
            var glyph = glyphs[index];
            if (glyph.id !== 0xffff) {
                var gid = lookupTable.lookup(glyph.id);
                if (gid) // 0 means do nothing
                glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
            }
        }
    };
    _proto._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
        var _this$glyphs;
        var insertions = [];
        while(count--){
            var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
            insertions.push(this.font.getGlyph(gid));
        }
        if (!isBefore) glyphIndex++;
        (_this$glyphs = this.glyphs).splice.apply(_this$glyphs, [
            glyphIndex,
            0
        ].concat(insertions));
    };
    _proto.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
        if (entry.flags & $3939d1de148b5202$var$SET_MARK) this.markedIndex = index;
        if (entry.markedInsertIndex !== 0xffff) {
            var count = (entry.flags & $3939d1de148b5202$var$MARKED_INSERT_COUNT) >>> 5;
            var isBefore = !!(entry.flags & $3939d1de148b5202$var$MARKED_INSERT_BEFORE);
            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
        }
        if (entry.currentInsertIndex !== 0xffff) {
            var _count = (entry.flags & $3939d1de148b5202$var$CURRENT_INSERT_COUNT) >>> 5;
            var _isBefore = !!(entry.flags & $3939d1de148b5202$var$CURRENT_INSERT_BEFORE);
            this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
        }
    };
    _proto.getSupportedFeatures = function getSupportedFeatures() {
        var features = [];
        for(var _iterator4 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(this.morx.chains), _step4; !(_step4 = _iterator4()).done;){
            var chain = _step4.value;
            for(var _iterator5 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(chain.features), _step5; !(_step5 = _iterator5()).done;){
                var feature = _step5.value;
                features.push([
                    feature.featureType,
                    feature.featureSetting
                ]);
            }
        }
        return features;
    };
    _proto.generateInputs = function generateInputs(gid) {
        if (!this.inputCache) this.generateInputCache();
        return this.inputCache[gid] || [];
    };
    _proto.generateInputCache = function generateInputCache() {
        this.inputCache = {};
        for(var _iterator6 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(this.morx.chains), _step6; !(_step6 = _iterator6()).done;){
            var chain = _step6.value;
            var flags = chain.defaultFlags;
            for(var _iterator7 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$a(chain.subtables), _step7; !(_step7 = _iterator7()).done;){
                var subtable = _step7.value;
                if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
            }
        }
    };
    _proto.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
        var _this = this;
        // Currently, only supporting ligature subtables.
        if (subtable.type !== 2) return;
        var reverse = !!(subtable.coverage & $3939d1de148b5202$var$REVERSE_DIRECTION);
        if (reverse) throw new Error('Reverse subtable, not supported.');
        this.subtable = subtable;
        this.ligatureStack = [];
        var stateMachine = this.getStateMachine(subtable);
        var process = this.getProcessor();
        var input = [];
        var stack = [];
        this.glyphs = [];
        stateMachine.traverse({
            enter: function enter(glyph, entry) {
                var glyphs = _this.glyphs;
                stack.push({
                    glyphs: glyphs.slice(),
                    ligatureStack: _this.ligatureStack.slice()
                }); // Add glyph to input and glyphs to process.
                var g = _this.font.getGlyph(glyph);
                input.push(g);
                glyphs.push(input[input.length - 1]); // Process ligature substitution
                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1); // Add input to result if only one matching (non-deleted) glyph remains.
                var count = 0;
                var found = 0;
                for(var i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                }
                if (count === 1) {
                    var result = input.map(function(g) {
                        return g.id;
                    });
                    var _cache = _this.inputCache[found];
                    if (_cache) _cache.push(result);
                    else _this.inputCache[found] = [
                        result
                    ];
                }
            },
            exit: function exit() {
                var _stack$pop = stack.pop();
                _this.glyphs = _stack$pop.glyphs;
                _this.ligatureStack = _stack$pop.ligatureStack;
                input.pop();
            }
        });
    };
    return AATMorxProcessor;
}(), $3939d1de148b5202$var$_applyDecoratedDescriptor$2($3939d1de148b5202$var$_class$2.prototype, "getStateMachine", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$2.prototype, "getStateMachine"), $3939d1de148b5202$var$_class$2.prototype), $3939d1de148b5202$var$_class$2);
// reverse the glyphs inside those ranges if specified
// ranges are in [offset, length] format
function $3939d1de148b5202$var$swap(glyphs, rangeA, rangeB, reverseA, reverseB) {
    if (reverseA === void 0) reverseA = false;
    if (reverseB === void 0) reverseB = false;
    var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) end.reverse();
    var start = glyphs.splice.apply(glyphs, [
        rangeA[0],
        rangeA[1]
    ].concat(end));
    if (reverseA) start.reverse();
    glyphs.splice.apply(glyphs, [
        rangeB[0] - (rangeA[1] - 1),
        0
    ].concat(start));
    return glyphs;
}
function $3939d1de148b5202$var$reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    switch(verb){
        case 0:
            // no change
            return glyphs;
        case 1:
            // Ax => xA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                0
            ]);
        case 2:
            // xD => Dx
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                1
            ]);
        case 3:
            // AxD => DxA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                1
            ]);
        case 4:
            // ABx => xAB
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ]);
        case 5:
            // ABx => xBA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ], true, false);
        case 6:
            // xCD => CDx
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ]);
        case 7:
            // xCD => DCx
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ], false, true);
        case 8:
            // AxCD => CDxA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ]);
        case 9:
            // AxCD => DCxA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ], false, true);
        case 10:
            // ABxD => DxAB
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ]);
        case 11:
            // ABxD => DxBA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ], true, false);
        case 12:
            // ABxCD => CDxAB
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ]);
        case 13:
            // ABxCD => CDxBA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, false);
        case 14:
            // ABxCD => DCxAB
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], false, true);
        case 15:
            // ABxCD => DCxBA
            return $3939d1de148b5202$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, true);
        default:
            throw new Error("Unknown verb: " + verb);
    }
}
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$b(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$b(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$b(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$b(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$b(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$b(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$AATLayoutEngine = /*#__PURE__*/ function() {
    function AATLayoutEngine(font) {
        this.font = font;
        this.morxProcessor = new $3939d1de148b5202$var$AATMorxProcessor(font);
        this.fallbackPosition = false;
    }
    var _proto = AATLayoutEngine.prototype;
    _proto.substitute = function substitute(glyphRun) {
        // AAT expects the glyphs to be in visual order prior to morx processing,
        // so reverse the glyphs if the script is right-to-left.
        if (glyphRun.direction === 'rtl') glyphRun.glyphs.reverse();
        this.morxProcessor.process(glyphRun.glyphs, $3939d1de148b5202$var$mapOTToAAT(glyphRun.features));
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        return $3939d1de148b5202$var$mapAATToOT(this.morxProcessor.getSupportedFeatures());
    };
    _proto.stringsForGlyph = function stringsForGlyph(gid) {
        var glyphStrings = this.morxProcessor.generateInputs(gid);
        var result = new Set();
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$b(glyphStrings), _step; !(_step = _iterator()).done;){
            var glyphs = _step.value;
            this._addStrings(glyphs, 0, result, '');
        }
        return result;
    };
    _proto._addStrings = function _addStrings(glyphs, index, strings, string) {
        var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
        for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$b(codePoints), _step2; !(_step2 = _iterator2()).done;){
            var codePoint = _step2.value;
            var s = string + String.fromCodePoint(codePoint);
            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
            else strings.add(s);
        }
    };
    return AATLayoutEngine;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$c(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$c(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$c(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$c(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$c(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * ShapingPlans are used by the OpenType shapers to store which
 * features should by applied, and in what order to apply them.
 * The features are applied in groups called stages. A feature
 * can be applied globally to all glyphs, or locally to only
 * specific glyphs.
 *
 * @private
 */ var $3939d1de148b5202$var$ShapingPlan = /*#__PURE__*/ function() {
    function ShapingPlan(font, script, direction) {
        this.font = font;
        this.script = script;
        this.direction = direction;
        this.stages = [];
        this.globalFeatures = {};
        this.allFeatures = {};
    }
    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ var _proto = ShapingPlan.prototype;
    _proto._addFeatures = function _addFeatures(features, global1) {
        var stageIndex = this.stages.length - 1;
        var stage = this.stages[stageIndex];
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$c(features), _step; !(_step = _iterator()).done;){
            var feature = _step.value;
            if (this.allFeatures[feature] == null) {
                stage.push(feature);
                this.allFeatures[feature] = stageIndex;
                if (global1) this.globalFeatures[feature] = true;
            }
        }
    };
    _proto.add = function add(arg, global1) {
        if (global1 === void 0) global1 = true;
        if (this.stages.length === 0) this.stages.push([]);
        if (typeof arg === 'string') arg = [
            arg
        ];
        if (Array.isArray(arg)) this._addFeatures(arg, global1);
        else if (typeof arg === 'object') {
            this._addFeatures(arg.global || [], true);
            this._addFeatures(arg.local || [], false);
        } else throw new Error("Unsupported argument to ShapingPlan#add");
    };
    _proto.addStage = function addStage(arg, global1) {
        if (typeof arg === 'function') this.stages.push(arg, []);
        else {
            this.stages.push([]);
            this.add(arg, global1);
        }
    };
    _proto.setFeatureOverrides = function setFeatureOverrides(features) {
        if (Array.isArray(features)) this.add(features);
        else if (typeof features === 'object') for(var tag in features){
            if (features[tag]) this.add(tag);
            else if (this.allFeatures[tag] != null) {
                var stage = this.stages[this.allFeatures[tag]];
                stage.splice(stage.indexOf(tag), 1);
                delete this.allFeatures[tag];
                delete this.globalFeatures[tag];
            }
        }
    };
    _proto.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
        for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$c(glyphs), _step2; !(_step2 = _iterator2()).done;){
            var glyph = _step2.value;
            for(var feature in this.globalFeatures)glyph.features[feature] = true;
        }
    };
    _proto.process = function process(processor, glyphs, positions) {
        for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$c(this.stages), _step3; !(_step3 = _iterator3()).done;){
            var stage = _step3.value;
            if (typeof stage === 'function') {
                if (!positions) stage(this.font, glyphs, this);
            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
        }
    };
    return ShapingPlan;
}();
function $3939d1de148b5202$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3939d1de148b5202$var$VARIATION_FEATURES = [
    'rvrn'
];
var $3939d1de148b5202$var$COMMON_FEATURES = [
    'ccmp',
    'locl',
    'rlig',
    'mark',
    'mkmk'
];
var $3939d1de148b5202$var$FRACTIONAL_FEATURES = [
    'frac',
    'numr',
    'dnom'
];
var $3939d1de148b5202$var$HORIZONTAL_FEATURES = [
    'calt',
    'clig',
    'liga',
    'rclt',
    'curs',
    'kern'
];
var $3939d1de148b5202$var$DIRECTIONAL_FEATURES = {
    ltr: [
        'ltra',
        'ltrm'
    ],
    rtl: [
        'rtla',
        'rtlm'
    ]
};
var $3939d1de148b5202$var$DefaultShaper = /*#__PURE__*/ function() {
    function DefaultShaper() {}
    DefaultShaper.plan = function plan(_plan, glyphs, features) {
        // Plan the features we want to apply
        this.planPreprocessing(_plan);
        this.planFeatures(_plan);
        this.planPostprocessing(_plan, features); // Assign the global features to all the glyphs
        _plan.assignGlobalFeatures(glyphs); // Assign local features to glyphs
        this.assignFeatures(_plan, glyphs);
    };
    DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
        plan.add({
            global: [].concat($3939d1de148b5202$var$VARIATION_FEATURES, $3939d1de148b5202$var$DIRECTIONAL_FEATURES[plan.direction]),
            local: $3939d1de148b5202$var$FRACTIONAL_FEATURES
        });
    };
    DefaultShaper.planFeatures = function planFeatures(plan) {};
    DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
        plan.add([].concat($3939d1de148b5202$var$COMMON_FEATURES, $3939d1de148b5202$var$HORIZONTAL_FEATURES));
        plan.setFeatureOverrides(userFeatures);
    };
    DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        // Enable contextual fractions
        for(var i = 0; i < glyphs.length; i++){
            var glyph = glyphs[i];
            if (glyph.codePoints[0] === 0x2044) {
                // fraction slash
                var start = i;
                var end = i + 1; // Apply numerator
                while(start > 0 && $3939d1de148b5202$var$unicode.isDigit(glyphs[start - 1].codePoints[0])){
                    glyphs[start - 1].features.numr = true;
                    glyphs[start - 1].features.frac = true;
                    start--;
                } // Apply denominator
                while(end < glyphs.length && $3939d1de148b5202$var$unicode.isDigit(glyphs[end].codePoints[0])){
                    glyphs[end].features.dnom = true;
                    glyphs[end].features.frac = true;
                    end++;
                } // Apply fraction slash
                glyph.features.frac = true;
                i = end - 1;
            }
        }
    };
    return DefaultShaper;
}();
$3939d1de148b5202$var$_defineProperty($3939d1de148b5202$var$DefaultShaper, "zeroMarkWidths", 'AFTER_GPOS');
var $3939d1de148b5202$var$base64DeflatedTrie$1 = "eJwBDgLx/QAB8AAAAAAAAAA4AAH9AQL+7ZotTMQwFMe77b44QIHA4JBIBAJ5lxASDAmGhHMoBIqgUOBQJAhOIpFIDIogSUgIEolEEgzJ/S/Xkpem3XXXboPbe8kv7a3r63vt69u6XDcWYhvsgn3Qlb//S3kMTsEZuACXoA9uwC24A/fgATyRfs/gTf4e8g4+ZP1Tll+knZlOfsC1pJ4IMQ8WkvLtKool+Los/V2pkN8MwzAMwzAMwzAMw1SP4fefVf7+wTAMwzAMwzC5cjUzYjEnXsFcW4gOOAeP4Ls9alufFWJTCNFrCdFvjepF8NLKbz7XcIbZMJxjOri2leF8s4N79zzPQz30P7DoOMT1o4qct9T/C06m1N9OHP3CwlJliSzQdlM9lNSk3kSjZih1TH2yQvv9JaE2UR/1uXLxLwSTzG0RJFrdxQ9TXKl2QUqbhNgHdDwXoT7Taz7SBHWD/oYkbf1dYyIhOvV+DU/7lWSNz1BxPW5uTO3jxnWVsvedb+zZ+o/L9Vlij95rerbZ7IoMelTe1XNFaJkkhqltphjT9ZrmT5ey34zVGijRbQxlX9n7xPTu1ZQUuY9993Oaf3nqDqnLNUf4SKg1iye005ZLIq1U9UiO5fJOGKfoN42nxnK1NUTOpfbYfNFzqZ5Tfe2wzWOIuLOtQdEov4qWtLhzJes6hI5RXwmZv0zPCps0A45rkwGaMQXv";
function $3939d1de148b5202$var$_inheritsLoose$3(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$trieData$1 = (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedTrie$1));
var $3939d1de148b5202$var$trie$1 = new $3939d1de148b5202$var$unicodeTrie($3939d1de148b5202$var$trieData$1);
var $3939d1de148b5202$var$FEATURES = [
    'isol',
    'fina',
    'fin2',
    'fin3',
    'medi',
    'med2',
    'init'
];
var $3939d1de148b5202$var$ShapingClasses = {
    Non_Joining: 0,
    Left_Joining: 1,
    Right_Joining: 2,
    Dual_Joining: 3,
    Join_Causing: 3,
    ALAPH: 4,
    'DALATH RISH': 5,
    Transparent: 6
};
var $3939d1de148b5202$var$ISOL = 'isol';
var $3939d1de148b5202$var$FINA = 'fina';
var $3939d1de148b5202$var$FIN2 = 'fin2';
var $3939d1de148b5202$var$FIN3 = 'fin3';
var $3939d1de148b5202$var$MEDI = 'medi';
var $3939d1de148b5202$var$MED2 = 'med2';
var $3939d1de148b5202$var$INIT = 'init';
var $3939d1de148b5202$var$NONE = null; // Each entry is [prevAction, curAction, nextState]
var $3939d1de148b5202$var$STATE_TABLE = [
    // State 0: prev was U,  not willing to join.
    [
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$NONE,
            0
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            1
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            1
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            6
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$NONE,
            0
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            1
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$FIN2,
            5
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            6
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$NONE,
            0
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$INIT,
            $3939d1de148b5202$var$FINA,
            1
        ],
        [
            $3939d1de148b5202$var$INIT,
            $3939d1de148b5202$var$FINA,
            3
        ],
        [
            $3939d1de148b5202$var$INIT,
            $3939d1de148b5202$var$FINA,
            4
        ],
        [
            $3939d1de148b5202$var$INIT,
            $3939d1de148b5202$var$FINA,
            6
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$NONE,
            0
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$MEDI,
            $3939d1de148b5202$var$FINA,
            1
        ],
        [
            $3939d1de148b5202$var$MEDI,
            $3939d1de148b5202$var$FINA,
            3
        ],
        [
            $3939d1de148b5202$var$MEDI,
            $3939d1de148b5202$var$FINA,
            4
        ],
        [
            $3939d1de148b5202$var$MEDI,
            $3939d1de148b5202$var$FINA,
            6
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$NONE,
            0
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$MED2,
            $3939d1de148b5202$var$ISOL,
            1
        ],
        [
            $3939d1de148b5202$var$MED2,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$MED2,
            $3939d1de148b5202$var$FIN2,
            5
        ],
        [
            $3939d1de148b5202$var$MED2,
            $3939d1de148b5202$var$ISOL,
            6
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$NONE,
            0
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$ISOL,
            $3939d1de148b5202$var$ISOL,
            1
        ],
        [
            $3939d1de148b5202$var$ISOL,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$ISOL,
            $3939d1de148b5202$var$FIN2,
            5
        ],
        [
            $3939d1de148b5202$var$ISOL,
            $3939d1de148b5202$var$ISOL,
            6
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$NONE,
            0
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            1
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            2
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$FIN3,
            5
        ],
        [
            $3939d1de148b5202$var$NONE,
            $3939d1de148b5202$var$ISOL,
            6
        ]
    ]
];
/**
 * This is a shaper for Arabic, and other cursive scripts.
 * It uses data from ArabicShaping.txt in the Unicode database,
 * compiled to a UnicodeTrie by generate-data.coffee.
 *
 * The shaping state machine was ported from Harfbuzz.
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
 */ var $3939d1de148b5202$var$ArabicShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $3939d1de148b5202$var$_inheritsLoose$3(ArabicShaper, _DefaultShaper);
    function ArabicShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    ArabicShaper.planFeatures = function planFeatures(plan) {
        plan.add([
            'ccmp',
            'locl'
        ]);
        for(var i = 0; i < $3939d1de148b5202$var$FEATURES.length; i++){
            var feature = $3939d1de148b5202$var$FEATURES[i];
            plan.addStage(feature, false);
        }
        plan.addStage('mset');
    };
    ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        _DefaultShaper.assignFeatures.call(this, plan, glyphs);
        var prev = -1;
        var state = 0;
        var actions = []; // Apply the state machine to map glyphs to features
        for(var i = 0; i < glyphs.length; i++){
            var curAction = void 0, prevAction = void 0;
            var glyph = glyphs[i];
            var type = $3939d1de148b5202$var$getShapingClass(glyph.codePoints[0]);
            if (type === $3939d1de148b5202$var$ShapingClasses.Transparent) {
                actions[i] = $3939d1de148b5202$var$NONE;
                continue;
            }
            var _STATE_TABLE$state$ty = $3939d1de148b5202$var$STATE_TABLE[state][type];
            prevAction = _STATE_TABLE$state$ty[0];
            curAction = _STATE_TABLE$state$ty[1];
            state = _STATE_TABLE$state$ty[2];
            if (prevAction !== $3939d1de148b5202$var$NONE && prev !== -1) actions[prev] = prevAction;
            actions[i] = curAction;
            prev = i;
        } // Apply the chosen features to their respective glyphs
        for(var index = 0; index < glyphs.length; index++){
            var feature = void 0;
            var glyph = glyphs[index];
            if (feature = actions[index]) glyph.features[feature] = true;
        }
    };
    return ArabicShaper;
}($3939d1de148b5202$var$DefaultShaper);
function $3939d1de148b5202$var$getShapingClass(codePoint) {
    var res = $3939d1de148b5202$var$trie$1.get(codePoint);
    if (res) return res - 1;
    var category = $3939d1de148b5202$var$unicode.getCategory(codePoint);
    if (category === 'Mn' || category === 'Me' || category === 'Cf') return $3939d1de148b5202$var$ShapingClasses.Transparent;
    return $3939d1de148b5202$var$ShapingClasses.Non_Joining;
}
function $3939d1de148b5202$var$_defineProperties$3(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$3(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$3(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$3(Constructor, staticProps);
    return Constructor;
}
var $3939d1de148b5202$var$GlyphIterator = /*#__PURE__*/ function() {
    function GlyphIterator(glyphs, options) {
        this.glyphs = glyphs;
        this.reset(options);
    }
    var _proto = GlyphIterator.prototype;
    _proto.reset = function reset(options, index) {
        if (options === void 0) options = {};
        if (index === void 0) index = 0;
        this.options = options;
        this.flags = options.flags || {};
        this.markAttachmentType = options.markAttachmentType || 0;
        this.index = index;
    };
    _proto.shouldIgnore = function shouldIgnore(glyph) {
        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
    };
    _proto.move = function move(dir) {
        this.index += dir;
        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
        if (0 > this.index || this.index >= this.glyphs.length) return null;
        return this.glyphs[this.index];
    };
    _proto.next = function next() {
        return this.move(1);
    };
    _proto.prev = function prev() {
        return this.move(-1);
    };
    _proto.peek = function peek(count) {
        if (count === void 0) count = 1;
        var idx = this.index;
        var res = this.increment(count);
        this.index = idx;
        return res;
    };
    _proto.peekIndex = function peekIndex(count) {
        if (count === void 0) count = 1;
        var idx = this.index;
        this.increment(count);
        var res = this.index;
        this.index = idx;
        return res;
    };
    _proto.increment = function increment(count) {
        if (count === void 0) count = 1;
        var dir = count < 0 ? -1 : 1;
        count = Math.abs(count);
        while(count--)this.move(dir);
        return this.glyphs[this.index];
    };
    $3939d1de148b5202$var$_createClass$3(GlyphIterator, [
        {
            key: "cur",
            get: function get() {
                return this.glyphs[this.index] || null;
            }
        }
    ]);
    return GlyphIterator;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$d(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$d(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$d(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$d(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$d(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$DEFAULT_SCRIPTS = [
    'DFLT',
    'dflt',
    'latn'
];
var $3939d1de148b5202$var$OTProcessor = /*#__PURE__*/ function() {
    function OTProcessor(font, table) {
        this.font = font;
        this.table = table;
        this.script = null;
        this.scriptTag = null;
        this.language = null;
        this.languageTag = null;
        this.features = {};
        this.lookups = {}; // Setup variation substitutions
        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1; // initialize to default script + language
        this.selectScript(); // current context (set by applyFeatures)
        this.glyphs = [];
        this.positions = []; // only used by GPOS
        this.ligatureID = 1;
        this.currentFeature = null;
    }
    var _proto = OTProcessor.prototype;
    _proto.findScript = function findScript(script) {
        if (this.table.scriptList == null) return null;
        if (!Array.isArray(script)) script = [
            script
        ];
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(script), _step; !(_step = _iterator()).done;){
            var s = _step.value;
            for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(this.table.scriptList), _step2; !(_step2 = _iterator2()).done;){
                var entry = _step2.value;
                if (entry.tag === s) return entry;
            }
        }
        return null;
    };
    _proto.selectScript = function selectScript(script, language, direction$1) {
        var changed = false;
        var entry;
        if (!this.script || script !== this.scriptTag) {
            entry = this.findScript(script);
            if (!entry) entry = this.findScript($3939d1de148b5202$var$DEFAULT_SCRIPTS);
            if (!entry) return this.scriptTag;
            this.scriptTag = entry.tag;
            this.script = entry.script;
            this.language = null;
            this.languageTag = null;
            changed = true;
        }
        if (!direction$1 || direction$1 !== this.direction) this.direction = direction$1 || $3939d1de148b5202$var$direction(script);
        if (language && language.length < 4) language += ' '.repeat(4 - language.length);
        if (!language || language !== this.languageTag) {
            this.language = null;
            for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(this.script.langSysRecords), _step3; !(_step3 = _iterator3()).done;){
                var lang = _step3.value;
                if (lang.tag === language) {
                    this.language = lang.langSys;
                    this.languageTag = lang.tag;
                    break;
                }
            }
            if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
            }
            changed = true;
        } // Build a feature lookup table
        if (changed) {
            this.features = {};
            if (this.language) for(var _iterator4 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(this.language.featureIndexes), _step4; !(_step4 = _iterator4()).done;){
                var featureIndex = _step4.value;
                var record = this.table.featureList[featureIndex];
                var substituteFeature = this.substituteFeatureForVariations(featureIndex);
                this.features[record.tag] = substituteFeature || record.feature;
            }
        }
        return this.scriptTag;
    };
    _proto.lookupsForFeatures = function lookupsForFeatures(userFeatures, exclude) {
        if (userFeatures === void 0) userFeatures = [];
        var lookups = [];
        for(var _iterator5 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(userFeatures), _step5; !(_step5 = _iterator5()).done;){
            var tag = _step5.value;
            var feature = this.features[tag];
            if (!feature) continue;
            for(var _iterator6 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(feature.lookupListIndexes), _step6; !(_step6 = _iterator6()).done;){
                var lookupIndex = _step6.value;
                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                lookups.push({
                    feature: tag,
                    index: lookupIndex,
                    lookup: this.table.lookupList.get(lookupIndex)
                });
            }
        }
        lookups.sort(function(a, b) {
            return a.index - b.index;
        });
        return lookups;
    };
    _proto.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
        if (this.variationsIndex === -1) return null;
        var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
        var substitutions = record.featureTableSubstitution.substitutions;
        for(var _iterator7 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(substitutions), _step7; !(_step7 = _iterator7()).done;){
            var substitution = _step7.value;
            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
        }
        return null;
    };
    _proto.findVariationsIndex = function findVariationsIndex(coords) {
        var variations = this.table.featureVariations;
        if (!variations) return -1;
        var records = variations.featureVariationRecords;
        for(var i = 0; i < records.length; i++){
            var conditions = records[i].conditionSet.conditionTable;
            if (this.variationConditionsMatch(conditions, coords)) return i;
        }
        return -1;
    };
    _proto.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
        return conditions.every(function(condition) {
            var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
        });
    };
    _proto.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
        var lookups = this.lookupsForFeatures(userFeatures);
        this.applyLookups(lookups, glyphs, advances);
    };
    _proto.applyLookups = function applyLookups(lookups, glyphs, positions) {
        this.glyphs = glyphs;
        this.positions = positions;
        this.glyphIterator = new $3939d1de148b5202$var$GlyphIterator(glyphs);
        for(var _iterator8 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(lookups), _step8; !(_step8 = _iterator8()).done;){
            var _step8$value = _step8.value, feature = _step8$value.feature, lookup = _step8$value.lookup;
            this.currentFeature = feature;
            this.glyphIterator.reset(lookup.flags);
            while(this.glyphIterator.index < glyphs.length){
                if (!(feature in this.glyphIterator.cur.features)) {
                    this.glyphIterator.next();
                    continue;
                }
                for(var _iterator9 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(lookup.subTables), _step9; !(_step9 = _iterator9()).done;){
                    var table = _step9.value;
                    var res = this.applyLookup(lookup.lookupType, table);
                    if (res) break;
                }
                this.glyphIterator.next();
            }
        }
    };
    _proto.applyLookup = function applyLookup(lookup, table) {
        throw new Error("applyLookup must be implemented by subclasses");
    };
    _proto.applyLookupList = function applyLookupList(lookupRecords) {
        var options = this.glyphIterator.options;
        var glyphIndex = this.glyphIterator.index;
        for(var _iterator10 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(lookupRecords), _step10; !(_step10 = _iterator10()).done;){
            var lookupRecord = _step10.value;
            // Reset flags and find glyph index for this lookup record
            this.glyphIterator.reset(options, glyphIndex);
            this.glyphIterator.increment(lookupRecord.sequenceIndex); // Get the lookup and setup flags for subtables
            var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index); // Apply lookup subtables until one matches
            for(var _iterator11 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(lookup.subTables), _step11; !(_step11 = _iterator11()).done;){
                var table = _step11.value;
                if (this.applyLookup(lookup.lookupType, table)) break;
            }
        }
        this.glyphIterator.reset(options, glyphIndex);
        return true;
    };
    _proto.coverageIndex = function coverageIndex(coverage, glyph) {
        if (glyph == null) glyph = this.glyphIterator.cur.id;
        switch(coverage.version){
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for(var _iterator12 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(coverage.rangeRecords), _step12; !(_step12 = _iterator12()).done;){
                    var range = _step12.value;
                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                }
                break;
        }
        return -1;
    };
    _proto.match = function match(sequenceIndex, sequence, fn, matched) {
        var pos = this.glyphIterator.index;
        var glyph = this.glyphIterator.increment(sequenceIndex);
        var idx = 0;
        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
            if (matched) matched.push(this.glyphIterator.index);
            idx++;
            glyph = this.glyphIterator.next();
        }
        this.glyphIterator.index = pos;
        if (idx < sequence.length) return false;
        return matched || true;
    };
    _proto.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, function(component, glyph) {
            return component === glyph.id;
        });
    };
    _proto.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
        var _this = this;
        return this.match(sequenceIndex, sequence, function(component, glyph) {
            // If the current feature doesn't apply to this glyph,
            if (!(_this.currentFeature in glyph.features)) return false;
            return component === glyph.id;
        }, []);
    };
    _proto.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
        var _this2 = this;
        return this.match(sequenceIndex, sequence, function(coverage, glyph) {
            return _this2.coverageIndex(coverage, glyph.id) >= 0;
        });
    };
    _proto.getClassID = function getClassID(glyph, classDef) {
        switch(classDef.version){
            case 1:
                // Class array
                var i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                break;
            case 2:
                for(var _iterator13 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(classDef.classRangeRecord), _step13; !(_step13 = _iterator13()).done;){
                    var range = _step13.value;
                    if (range.start <= glyph && glyph <= range.end) return range["class"];
                }
                break;
        }
        return 0;
    };
    _proto.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
        var _this3 = this;
        return this.match(sequenceIndex, sequence, function(classID, glyph) {
            return classID === _this3.getClassID(glyph.id, classDef);
        });
    };
    _proto.applyContext = function applyContext(table) {
        switch(table.version){
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var set = table.ruleSets[index];
                for(var _iterator14 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(set), _step14; !(_step14 = _iterator14()).done;){
                    var rule = _step14.value;
                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) return false;
                set = table.classSet[index];
                for(var _iterator15 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(set), _step15; !(_step15 = _iterator15()).done;){
                    var _rule = _step15.value;
                    if (this.classSequenceMatches(1, _rule.classes, table.classDef)) return this.applyLookupList(_rule.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    };
    _proto.applyChainingContext = function applyChainingContext(table) {
        switch(table.version){
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var set = table.chainRuleSets[index];
                for(var _iterator16 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(set), _step16; !(_step16 = _iterator16()).done;){
                    var rule = _step16.value;
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                var rules = table.chainClassSet[index];
                if (!rules) return false;
                for(var _iterator17 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$d(rules), _step17; !(_step17 = _iterator17()).done;){
                    var _rule2 = _step17.value;
                    if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) return this.applyLookupList(_rule2.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    };
    return OTProcessor;
}();
function $3939d1de148b5202$var$_defineProperties$4(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$4(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$4(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$4(Constructor, staticProps);
    return Constructor;
}
var $3939d1de148b5202$var$GlyphInfo = /*#__PURE__*/ function() {
    function GlyphInfo(font, id, codePoints, features) {
        if (codePoints === void 0) codePoints = [];
        this._font = font;
        this.codePoints = codePoints;
        this.id = id;
        this.features = {};
        if (Array.isArray(features)) for(var i = 0; i < features.length; i++){
            var feature = features[i];
            this.features[feature] = true;
        }
        else if (typeof features === 'object') Object.assign(this.features, features);
        this.ligatureID = null;
        this.ligatureComponent = null;
        this.isLigated = false;
        this.cursiveAttachment = null;
        this.markAttachment = null;
        this.shaperInfo = null;
        this.substituted = false;
        this.isMultiplied = false;
    }
    var _proto = GlyphInfo.prototype;
    _proto.copy = function copy() {
        return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
    };
    $3939d1de148b5202$var$_createClass$4(GlyphInfo, [
        {
            key: "id",
            get: function get() {
                return this._id;
            },
            set: function set(id) {
                this._id = id;
                this.substituted = true;
                var GDEF = this._font.GDEF;
                if (GDEF && GDEF.glyphClassDef) {
                    // TODO: clean this up
                    var classID = $3939d1de148b5202$var$OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
                    this.isBase = classID === 1;
                    this.isLigature = classID === 2;
                    this.isMark = classID === 3;
                    this.markAttachmentType = GDEF.markAttachClassDef ? $3939d1de148b5202$var$OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
                } else {
                    this.isMark = this.codePoints.length > 0 && this.codePoints.every($3939d1de148b5202$var$unicode.isMark);
                    this.isBase = !this.isMark;
                    this.isLigature = this.codePoints.length > 1;
                    this.markAttachmentType = 0;
                }
            }
        }
    ]);
    return GlyphInfo;
}();
function $3939d1de148b5202$var$_inheritsLoose$4(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $3939d1de148b5202$var$_defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * This is a shaper for the Hangul script, used by the Korean language.
 * It does the following:
 *   - decompose if unsupported by the font:
 *     <LV>   -> <L,V>
 *     <LVT>  -> <L,V,T>
 *     <LV,T> -> <L,V,T>
 *
 *   - compose if supported by the font:
 *     <L,V>   -> <LV>
 *     <L,V,T> -> <LVT>
 *     <LV,T>  -> <LVT>
 *
 *   - reorder tone marks (S is any valid syllable):
 *     <S, M> -> <M, S>
 *
 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
 *
 * This logic is based on the following documents:
 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
 */ var $3939d1de148b5202$var$HangulShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $3939d1de148b5202$var$_inheritsLoose$4(HangulShaper, _DefaultShaper);
    function HangulShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    HangulShaper.planFeatures = function planFeatures(plan) {
        plan.add([
            'ljmo',
            'vjmo',
            'tjmo'
        ], false);
    };
    HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var state = 0;
        var i = 0;
        while(i < glyphs.length){
            var action = void 0;
            var glyph = glyphs[i];
            var code = glyph.codePoints[0];
            var type = $3939d1de148b5202$var$getType(code);
            var _STATE_TABLE$state$ty = $3939d1de148b5202$var$STATE_TABLE$1[state][type];
            action = _STATE_TABLE$state$ty[0];
            state = _STATE_TABLE$state$ty[1];
            switch(action){
                case $3939d1de148b5202$var$DECOMPOSE:
                    // Decompose the composed syllable if it is not supported by the font.
                    if (!plan.font.hasGlyphForCodePoint(code)) i = $3939d1de148b5202$var$decompose(glyphs, i, plan.font);
                    break;
                case $3939d1de148b5202$var$COMPOSE:
                    // Found a decomposed syllable. Try to compose if supported by the font.
                    i = $3939d1de148b5202$var$compose(glyphs, i, plan.font);
                    break;
                case $3939d1de148b5202$var$TONE_MARK:
                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                    $3939d1de148b5202$var$reorderToneMark(glyphs, i, plan.font);
                    break;
                case $3939d1de148b5202$var$INVALID:
                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                    i = $3939d1de148b5202$var$insertDottedCircle(glyphs, i, plan.font);
                    break;
            }
            i++;
        }
    };
    return HangulShaper;
}($3939d1de148b5202$var$DefaultShaper);
$3939d1de148b5202$var$_defineProperty$1($3939d1de148b5202$var$HangulShaper, "zeroMarkWidths", 'NONE');
var $3939d1de148b5202$var$HANGUL_BASE = 0xac00;
var $3939d1de148b5202$var$HANGUL_END = 0xd7a4;
var $3939d1de148b5202$var$HANGUL_COUNT = $3939d1de148b5202$var$HANGUL_END - $3939d1de148b5202$var$HANGUL_BASE + 1;
var $3939d1de148b5202$var$L_BASE = 0x1100; // lead
var $3939d1de148b5202$var$V_BASE = 0x1161; // vowel
var $3939d1de148b5202$var$T_BASE = 0x11a7; // trail
var $3939d1de148b5202$var$L_COUNT = 19;
var $3939d1de148b5202$var$V_COUNT = 21;
var $3939d1de148b5202$var$T_COUNT = 28;
var $3939d1de148b5202$var$L_END = $3939d1de148b5202$var$L_BASE + $3939d1de148b5202$var$L_COUNT - 1;
var $3939d1de148b5202$var$V_END = $3939d1de148b5202$var$V_BASE + $3939d1de148b5202$var$V_COUNT - 1;
var $3939d1de148b5202$var$T_END = $3939d1de148b5202$var$T_BASE + $3939d1de148b5202$var$T_COUNT - 1;
var $3939d1de148b5202$var$DOTTED_CIRCLE = 0x25cc;
var $3939d1de148b5202$var$isL = function isL(code) {
    return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
};
var $3939d1de148b5202$var$isV = function isV(code) {
    return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
};
var $3939d1de148b5202$var$isT = function isT(code) {
    return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
};
var $3939d1de148b5202$var$isTone = function isTone(code) {
    return 0x302e <= code && code <= 0x302f;
};
var $3939d1de148b5202$var$isLVT = function isLVT(code) {
    return $3939d1de148b5202$var$HANGUL_BASE <= code && code <= $3939d1de148b5202$var$HANGUL_END;
};
var $3939d1de148b5202$var$isLV = function isLV(code) {
    return code - $3939d1de148b5202$var$HANGUL_BASE < $3939d1de148b5202$var$HANGUL_COUNT && (code - $3939d1de148b5202$var$HANGUL_BASE) % $3939d1de148b5202$var$T_COUNT === 0;
};
var $3939d1de148b5202$var$isCombiningL = function isCombiningL(code) {
    return $3939d1de148b5202$var$L_BASE <= code && code <= $3939d1de148b5202$var$L_END;
};
var $3939d1de148b5202$var$isCombiningV = function isCombiningV(code) {
    return $3939d1de148b5202$var$V_BASE <= code && code <= $3939d1de148b5202$var$V_END;
};
var $3939d1de148b5202$var$isCombiningT = function isCombiningT(code) {
    return 1 <= code && code <= $3939d1de148b5202$var$T_END;
}; // Character categories
var $3939d1de148b5202$var$X = 0; // Other character
var $3939d1de148b5202$var$L = 1; // Leading consonant
var $3939d1de148b5202$var$V = 2; // Medial vowel
var $3939d1de148b5202$var$T = 3; // Trailing consonant
var $3939d1de148b5202$var$LV = 4; // Composed <LV> syllable
var $3939d1de148b5202$var$LVT = 5; // Composed <LVT> syllable
var $3939d1de148b5202$var$M = 6; // Tone mark
// This function classifies a character using the above categories.
function $3939d1de148b5202$var$getType(code) {
    if ($3939d1de148b5202$var$isL(code)) return $3939d1de148b5202$var$L;
    if ($3939d1de148b5202$var$isV(code)) return $3939d1de148b5202$var$V;
    if ($3939d1de148b5202$var$isT(code)) return $3939d1de148b5202$var$T;
    if ($3939d1de148b5202$var$isLV(code)) return $3939d1de148b5202$var$LV;
    if ($3939d1de148b5202$var$isLVT(code)) return $3939d1de148b5202$var$LVT;
    if ($3939d1de148b5202$var$isTone(code)) return $3939d1de148b5202$var$M;
    return $3939d1de148b5202$var$X;
} // State machine actions
var $3939d1de148b5202$var$NO_ACTION = 0;
var $3939d1de148b5202$var$DECOMPOSE = 1;
var $3939d1de148b5202$var$COMPOSE = 2;
var $3939d1de148b5202$var$TONE_MARK = 4;
var $3939d1de148b5202$var$INVALID = 5; // Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
var $3939d1de148b5202$var$STATE_TABLE$1 = [
    // State 0: start state
    [
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            1
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            2
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            3
        ],
        [
            $3939d1de148b5202$var$INVALID,
            0
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            1
        ],
        [
            $3939d1de148b5202$var$COMPOSE,
            2
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            2
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            3
        ],
        [
            $3939d1de148b5202$var$INVALID,
            0
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            1
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$COMPOSE,
            3
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            2
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            3
        ],
        [
            $3939d1de148b5202$var$TONE_MARK,
            0
        ]
    ],
    [
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            1
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$NO_ACTION,
            0
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            2
        ],
        [
            $3939d1de148b5202$var$DECOMPOSE,
            3
        ],
        [
            $3939d1de148b5202$var$TONE_MARK,
            0
        ]
    ]
];
function $3939d1de148b5202$var$getGlyph(font, code, features) {
    return new $3939d1de148b5202$var$GlyphInfo(font, font.glyphForCodePoint(code).id, [
        code
    ], features);
}
function $3939d1de148b5202$var$decompose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyph.codePoints[0];
    var s = code - $3939d1de148b5202$var$HANGUL_BASE;
    var t = $3939d1de148b5202$var$T_BASE + s % $3939d1de148b5202$var$T_COUNT;
    s = s / $3939d1de148b5202$var$T_COUNT | 0;
    var l = $3939d1de148b5202$var$L_BASE + s / $3939d1de148b5202$var$V_COUNT | 0;
    var v = $3939d1de148b5202$var$V_BASE + s % $3939d1de148b5202$var$V_COUNT; // Don't decompose if all of the components are not available
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== $3939d1de148b5202$var$T_BASE && !font.hasGlyphForCodePoint(t)) return i;
     // Replace the current glyph with decomposed L, V, and T glyphs,
    // and apply the proper OpenType features to each component.
    var ljmo = $3939d1de148b5202$var$getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    var vjmo = $3939d1de148b5202$var$getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    var insert = [
        ljmo,
        vjmo
    ];
    if (t > $3939d1de148b5202$var$T_BASE) {
        var tjmo = $3939d1de148b5202$var$getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice.apply(glyphs, [
        i,
        1
    ].concat(insert));
    return i + insert.length - 1;
}
function $3939d1de148b5202$var$compose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    var type = $3939d1de148b5202$var$getType(code);
    var prev = glyphs[i - 1].codePoints[0];
    var prevType = $3939d1de148b5202$var$getType(prev); // Figure out what type of syllable we're dealing with
    var lv, ljmo, vjmo, tjmo;
    if (prevType === $3939d1de148b5202$var$LV && type === $3939d1de148b5202$var$T) {
        // <LV,T>
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === $3939d1de148b5202$var$V) {
            // <L,V>
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            // <L,V,T>
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        var l = ljmo.codePoints[0];
        var v = vjmo.codePoints[0]; // Make sure L and V are combining characters
        if ($3939d1de148b5202$var$isCombiningL(l) && $3939d1de148b5202$var$isCombiningV(v)) lv = $3939d1de148b5202$var$HANGUL_BASE + ((l - $3939d1de148b5202$var$L_BASE) * $3939d1de148b5202$var$V_COUNT + (v - $3939d1de148b5202$var$V_BASE)) * $3939d1de148b5202$var$T_COUNT;
    }
    var t = tjmo && tjmo.codePoints[0] || $3939d1de148b5202$var$T_BASE;
    if (lv != null && (t === $3939d1de148b5202$var$T_BASE || $3939d1de148b5202$var$isCombiningT(t))) {
        var s = lv + (t - $3939d1de148b5202$var$T_BASE); // Replace with a composed glyph if supported by the font,
        // otherwise apply the proper OpenType features to each component.
        if (font.hasGlyphForCodePoint(s)) {
            var del = prevType === $3939d1de148b5202$var$V ? 3 : 2;
            glyphs.splice(i - del + 1, del, $3939d1de148b5202$var$getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    } // Didn't compose (either a non-combining component or unsupported by font).
    if (ljmo) ljmo.features.ljmo = true;
    if (vjmo) vjmo.features.vjmo = true;
    if (tjmo) tjmo.features.tjmo = true;
    if (prevType === $3939d1de148b5202$var$LV) {
        // Sequence was originally <L,V>, which got combined earlier.
        // Either the T was non-combining, or the LVT glyph wasn't supported.
        // Decompose the glyph again and apply OT features.
        $3939d1de148b5202$var$decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function $3939d1de148b5202$var$getLength(code) {
    switch($3939d1de148b5202$var$getType(code)){
        case $3939d1de148b5202$var$LV:
        case $3939d1de148b5202$var$LVT:
            return 1;
        case $3939d1de148b5202$var$V:
            return 2;
        case $3939d1de148b5202$var$T:
            return 3;
    }
}
function $3939d1de148b5202$var$reorderToneMark(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0]; // Move tone mark to the beginning of the previous syllable, unless it is zero width
    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
    var prev = glyphs[i - 1].codePoints[0];
    var len = $3939d1de148b5202$var$getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function $3939d1de148b5202$var$insertDottedCircle(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint($3939d1de148b5202$var$DOTTED_CIRCLE)) {
        var dottedCircle = $3939d1de148b5202$var$getGlyph(font, $3939d1de148b5202$var$DOTTED_CIRCLE, glyph.features); // If the tone mark is zero width, insert the dotted circle before, otherwise after
        var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$e(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$e(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$e(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$e(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$e(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$e(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$INITIAL_STATE = 1;
var $3939d1de148b5202$var$FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ var $3939d1de148b5202$var$StateMachine = /*#__PURE__*/ function() {
    function StateMachine(dfa) {
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
    }
    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ var _proto = StateMachine.prototype;
    _proto.match = function match(str) {
        var _ref;
        var self1 = this;
        return _ref = {}, _ref[Symbol.iterator] = /*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
            var state, startRun, lastAccepting, lastState, p, c;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        state = $3939d1de148b5202$var$INITIAL_STATE;
                        startRun = null;
                        lastAccepting = null;
                        lastState = null;
                        p = 0;
                    case 5:
                        if (!(p < str.length)) {
                            _context.next = 21;
                            break;
                        }
                        c = str[p];
                        lastState = state;
                        state = self1.stateTable[state][c];
                        if (!(state === $3939d1de148b5202$var$FAIL_STATE)) {
                            _context.next = 15;
                            break;
                        }
                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                            _context.next = 13;
                            break;
                        }
                        _context.next = 13;
                        return [
                            startRun,
                            lastAccepting,
                            self1.tags[lastState]
                        ];
                    case 13:
                        // reset the state as if we started over from the initial state
                        state = self1.stateTable[$3939d1de148b5202$var$INITIAL_STATE][c];
                        startRun = null;
                    case 15:
                        // start a run if not in the failure state
                        if (state !== $3939d1de148b5202$var$FAIL_STATE && startRun == null) startRun = p;
                         // if accepting, mark the potential match end
                        if (self1.accepting[state]) lastAccepting = p;
                         // reset the state to the initial state if we get into the failure state
                        if (state === $3939d1de148b5202$var$FAIL_STATE) state = $3939d1de148b5202$var$INITIAL_STATE;
                    case 18:
                        p++;
                        _context.next = 5;
                        break;
                    case 21:
                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                            _context.next = 24;
                            break;
                        }
                        _context.next = 24;
                        return [
                            startRun,
                            lastAccepting,
                            self1.tags[state]
                        ];
                    case 24:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }), _ref;
    };
    _proto.apply = function apply(str, actions) {
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$e(this.match(str)), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
            for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$e(tags), _step2; !(_step2 = _iterator2()).done;){
                var tag = _step2.value;
                if (typeof actions[tag] === 'function') actions[tag](start, end, str.slice(start, end + 1));
            }
        }
    };
    return StateMachine;
}();
var $3939d1de148b5202$var$dfa = $3939d1de148b5202$var$StateMachine;
// Cateories used in the OpenType spec:
// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
var $3939d1de148b5202$var$CATEGORIES = {
    X: 1,
    C: 2,
    V: 4,
    N: 8,
    H: 16,
    ZWNJ: 32,
    ZWJ: 64,
    M: 128,
    SM: 256,
    VD: 512,
    A: 1024,
    Placeholder: 2048,
    Dotted_Circle: 4096,
    RS: 8192,
    // Register Shifter, used in Khmer OT spec.
    Coeng: 16384,
    // Khmer-style Virama.
    Repha: 32768,
    // Atomically-encoded logical or visual repha.
    Ra: 65536,
    CM: 131072,
    // Consonant-Medial.
    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
}; // Visual positions in a syllable from left to right.
var $3939d1de148b5202$var$POSITIONS = {
    Start: 1,
    Ra_To_Become_Reph: 2,
    Pre_M: 4,
    Pre_C: 8,
    Base_C: 16,
    After_Main: 32,
    Above_C: 64,
    Before_Sub: 128,
    Below_C: 256,
    After_Sub: 512,
    Before_Post: 1024,
    Post_C: 2048,
    After_Post: 4096,
    Final_C: 8192,
    SMVD: 16384,
    End: 32768
};
var $3939d1de148b5202$var$CONSONANT_FLAGS = $3939d1de148b5202$var$CATEGORIES.C | $3939d1de148b5202$var$CATEGORIES.Ra | $3939d1de148b5202$var$CATEGORIES.CM | $3939d1de148b5202$var$CATEGORIES.V | $3939d1de148b5202$var$CATEGORIES.Placeholder | $3939d1de148b5202$var$CATEGORIES.Dotted_Circle;
var $3939d1de148b5202$var$JOINER_FLAGS = $3939d1de148b5202$var$CATEGORIES.ZWJ | $3939d1de148b5202$var$CATEGORIES.ZWNJ;
var $3939d1de148b5202$var$HALANT_OR_COENG_FLAGS = $3939d1de148b5202$var$CATEGORIES.H | $3939d1de148b5202$var$CATEGORIES.Coeng;
var $3939d1de148b5202$var$INDIC_CONFIGS = {
    Default: {
        hasOldSpec: false,
        virama: 0,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Devanagari: {
        hasOldSpec: true,
        virama: 0x094D,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Bengali: {
        hasOldSpec: true,
        virama: 0x09CD,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.After_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gurmukhi: {
        hasOldSpec: true,
        virama: 0x0A4D,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.Before_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gujarati: {
        hasOldSpec: true,
        virama: 0x0ACD,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Oriya: {
        hasOldSpec: true,
        virama: 0x0B4D,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.After_Main,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Tamil: {
        hasOldSpec: true,
        virama: 0x0BCD,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Telugu: {
        hasOldSpec: true,
        virama: 0x0C4D,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.After_Post,
        rephMode: 'Explicit',
        blwfMode: 'Post_Only'
    },
    Kannada: {
        hasOldSpec: true,
        virama: 0x0CCD,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Post_Only'
    },
    Malayalam: {
        hasOldSpec: true,
        virama: 0x0D4D,
        basePos: 'Last',
        rephPos: $3939d1de148b5202$var$POSITIONS.After_Main,
        rephMode: 'Log_Repha',
        blwfMode: 'Pre_And_Post'
    },
    // Handled by UniversalShaper
    // Sinhala: {
    //   hasOldSpec: false,
    //   virama: 0x0DCA,
    //   basePos: 'Last_Sinhala',
    //   rephPos: POSITIONS.After_Main,
    //   rephMode: 'Explicit',
    //   blwfMode: 'Pre_And_Post'
    // },
    Khmer: {
        hasOldSpec: false,
        virama: 0x17D2,
        basePos: 'First',
        rephPos: $3939d1de148b5202$var$POSITIONS.Ra_To_Become_Reph,
        rephMode: 'Vis_Repha',
        blwfMode: 'Pre_And_Post'
    }
}; // Additional decompositions that aren't in Unicode
var $3939d1de148b5202$var$INDIC_DECOMPOSITIONS = {
    // Khmer
    0x17BE: [
        0x17C1,
        0x17BE
    ],
    0x17BF: [
        0x17C1,
        0x17BF
    ],
    0x17C0: [
        0x17C1,
        0x17C0
    ],
    0x17C4: [
        0x17C1,
        0x17C4
    ],
    0x17C5: [
        0x17C1,
        0x17C5
    ]
};
var $3939d1de148b5202$var$base64DeflatedIndicMachine = "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";
var $3939d1de148b5202$var$base64DeflatedUseData = "eJzNmVtv2zYUx7+LnvnA+6Vva4a0K5BsWLcWmBEEsqMG3mw5kJUOQ9HvvsOLLUp2owsVwGBCmj8d/nl0DkkzyLdsldfF465aF/vszSL7NUPZL7c/Q/0Rft+9hcr+Xt9AdfXuA9Sfbn5afnXtb/vatqHre1c3bzf/um5V2Mb33jt7//kqjD907Ty/2/n+tBMF0Rs//NqbXnt47UeUz5uNtQ86Hw8zhjF/fb794Bpbu8r6/slOc2tdsZUbeoeyh2K12z7t9ut6vSvh/b9lVGAFcYCGIcoNByP4rI9IEGOR1g5prRA1mDpkyBFppT2ikRUDxDCxA6HhiGEsPTIeiQZR3FgxYhHh3CLCKWJEWHlGpUNUMsSoFg4p4pDCEaIRkh7xBsmARIyOozl2o5nRCCrsEfPIRIgfrThxAwWXFgkObyUY9khHKFiZGDWmAjdcuABI5jyUkiD4bBPDlHSeKA2eKGmzwIxwVkZATIzgHqkISY+sJxySAUhqj0yDnGngEntuIkQa1DI1zUQOSePyAQ1G0kjhEfOIRkh6xCOkPBIRMh7pBhnGHTNMATRUBSoC1UeqMHcpti1BULt42Z6Mqfa2mjNHNbdUcxoojyk7UNmytZ4pgo0NsW0lgtrrQs8EqgL9jrJ9DUfQH/lyU8CzBUazlTu0oAj2C+JQBBBwBWlkEMGIEEQoIgzBHoOdRyQ8JgpB+u0TgyhGlCBKgxZlvvE1txW85yzOUnn0dqKAPXHa/VNBaqBi8APbB0ICSxTOFthdsNUVYnbRI+4tIY3wAM4ZDoGDyImgwOVRjBlP1EwhaPLV9A75ii0I7756O0v9irijeBLLsYKHJeXcowN8DCup/7XN4NceKHlm5WO/8HHfuo+mFi+EwEvPHoN0TaK7D8eX3rWUvjp7zqdXTRPAMTEdeKTO4zLXLXHbHSzOzciAkMM5NygiZ3T7yoRDq1eS/PjhNLmRqza2SNz904twFXnxlE5I9Vxupqp1v+/TvZtZru9lo7tIbMS6XnQuIANETzS7ZbxkfGdyE8gBrkZ3pd4AsGadzSd79o6HR1zxAlB9AfH6rxKRdF3+8mIYVAYsshkW7lw386S0MTEyvmekBW05D93hzgs2xXs+yv1z4n1lyjnUq9n9kkzXG7/eYqO5z56kLP34G7xzFZz1D5iUa+ZZ8bRycpNJEuP9Kevs3fm/LlIOh7MzJMTjGOE7lOWrVfFUr8vH7M3iS77ZF6iunidX6QqXVkGI6vzR/oNgAeHPltXun6K8X22e93VRZRaty4fiqYCqrFt8/992udu0UZ2XD3n10IJnJC8BXYof01H5vC2qfNNnNiZ/A1N6gfDrusq3+T10t+syr4tL8u014PQlAmxZVPd/79YlNMkBO5ni7vv/LbyJLg==";
var $3939d1de148b5202$var$base64DeflatedTrie$2 = "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";
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$f(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$f(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$f(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$f(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$f(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$f(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_inheritsLoose$5(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $3939d1de148b5202$var$_defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// we may be running in a browser so we make an Uint8Array
var $3939d1de148b5202$var$indicMachine = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedIndicMachine))));
var $3939d1de148b5202$var$useData = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedUseData))));
var $3939d1de148b5202$var$trieData$2 = (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedTrie$2));
var $3939d1de148b5202$var$decompositions = $3939d1de148b5202$var$useData.decompositions;
var $3939d1de148b5202$var$trie$2 = new $3939d1de148b5202$var$unicodeTrie($3939d1de148b5202$var$trieData$2);
var $3939d1de148b5202$var$stateMachine = new $3939d1de148b5202$var$dfa($3939d1de148b5202$var$indicMachine);
/**
 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
 */ var $3939d1de148b5202$var$IndicShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $3939d1de148b5202$var$_inheritsLoose$5(IndicShaper, _DefaultShaper);
    function IndicShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    IndicShaper.planFeatures = function planFeatures(plan) {
        plan.addStage($3939d1de148b5202$var$setupSyllables);
        plan.addStage([
            'locl',
            'ccmp'
        ]);
        plan.addStage($3939d1de148b5202$var$initialReordering);
        plan.addStage('nukt');
        plan.addStage('akhn');
        plan.addStage('rphf', false);
        plan.addStage('rkrf');
        plan.addStage('pref', false);
        plan.addStage('blwf', false);
        plan.addStage('abvf', false);
        plan.addStage('half', false);
        plan.addStage('pstf', false);
        plan.addStage('vatu');
        plan.addStage('cjct');
        plan.addStage('cfar', false);
        plan.addStage($3939d1de148b5202$var$finalReordering);
        plan.addStage({
            local: [
                'init'
            ],
            global: [
                'pres',
                'abvs',
                'blws',
                'psts',
                'haln',
                'dist',
                'abvm',
                'blwm',
                'calt',
                'clig'
            ]
        }); // Setup the indic config for the selected script
        plan.unicodeScript = $3939d1de148b5202$var$fromOpenType(plan.script);
        plan.indicConfig = $3939d1de148b5202$var$INDIC_CONFIGS[plan.unicodeScript] || $3939d1de148b5202$var$INDIC_CONFIGS.Default;
        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2'; // TODO: turn off kern (Khmer) and liga features.
    };
    IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var _loop = function _loop(i) {
            var codepoint = glyphs[i].codePoints[0];
            var d = $3939d1de148b5202$var$INDIC_DECOMPOSITIONS[codepoint] || $3939d1de148b5202$var$decompositions[codepoint];
            if (d) {
                var decomposed = d.map(function(c) {
                    var g = plan.font.glyphForCodePoint(c);
                    return new $3939d1de148b5202$var$GlyphInfo(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [
                    i,
                    1
                ].concat(decomposed));
            }
        };
        // Decompose split matras
        // TODO: do this in a more general unicode normalizer
        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
    };
    return IndicShaper;
}($3939d1de148b5202$var$DefaultShaper);
$3939d1de148b5202$var$_defineProperty$2($3939d1de148b5202$var$IndicShaper, "zeroMarkWidths", 'NONE');
function $3939d1de148b5202$var$indicCategory(glyph) {
    return $3939d1de148b5202$var$trie$2.get(glyph.codePoints[0]) >> 8;
}
function $3939d1de148b5202$var$indicPosition(glyph) {
    return 1 << ($3939d1de148b5202$var$trie$2.get(glyph.codePoints[0]) & 0xff);
}
var $3939d1de148b5202$var$IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
    this.category = category;
    this.position = position;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function $3939d1de148b5202$var$setupSyllables(font, glyphs) {
    var syllable = 0;
    var last = 0;
    for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$f($3939d1de148b5202$var$stateMachine.match(glyphs.map($3939d1de148b5202$var$indicCategory))), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
        if (start > last) {
            ++syllable;
            for(var _i = last; _i < start; _i++)glyphs[_i].shaperInfo = new $3939d1de148b5202$var$IndicInfo($3939d1de148b5202$var$CATEGORIES.X, $3939d1de148b5202$var$POSITIONS.End, 'non_indic_cluster', syllable);
        }
        ++syllable; // Create shaper info
        for(var _i2 = start; _i2 <= end; _i2++)glyphs[_i2].shaperInfo = new $3939d1de148b5202$var$IndicInfo(1 << $3939d1de148b5202$var$indicCategory(glyphs[_i2]), $3939d1de148b5202$var$indicPosition(glyphs[_i2]), tags[0], syllable);
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for(var i = last; i < glyphs.length; i++)glyphs[i].shaperInfo = new $3939d1de148b5202$var$IndicInfo($3939d1de148b5202$var$CATEGORIES.X, $3939d1de148b5202$var$POSITIONS.End, 'non_indic_cluster', syllable);
    }
}
function $3939d1de148b5202$var$isConsonant(glyph) {
    return glyph.shaperInfo.category & $3939d1de148b5202$var$CONSONANT_FLAGS;
}
function $3939d1de148b5202$var$isJoiner(glyph) {
    return glyph.shaperInfo.category & $3939d1de148b5202$var$JOINER_FLAGS;
}
function $3939d1de148b5202$var$isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & $3939d1de148b5202$var$HALANT_OR_COENG_FLAGS;
}
function $3939d1de148b5202$var$wouldSubstitute(glyphs, feature) {
    for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$f(glyphs), _step2; !(_step2 = _iterator2()).done;){
        var _glyph$features;
        var glyph = _step2.value;
        glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
    }
    var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([
        feature
    ], glyphs);
    return glyphs.length === 1;
}
function $3939d1de148b5202$var$consonantPosition(font, consonant, virama) {
    var glyphs = [
        virama,
        consonant,
        virama
    ];
    if ($3939d1de148b5202$var$wouldSubstitute(glyphs.slice(0, 2), 'blwf') || $3939d1de148b5202$var$wouldSubstitute(glyphs.slice(1, 3), 'blwf')) return $3939d1de148b5202$var$POSITIONS.Below_C;
    else if ($3939d1de148b5202$var$wouldSubstitute(glyphs.slice(0, 2), 'pstf') || $3939d1de148b5202$var$wouldSubstitute(glyphs.slice(1, 3), 'pstf')) return $3939d1de148b5202$var$POSITIONS.Post_C;
    else if ($3939d1de148b5202$var$wouldSubstitute(glyphs.slice(0, 2), 'pref') || $3939d1de148b5202$var$wouldSubstitute(glyphs.slice(1, 3), 'pref')) return $3939d1de148b5202$var$POSITIONS.Post_C;
    return $3939d1de148b5202$var$POSITIONS.Base_C;
}
function $3939d1de148b5202$var$initialReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
    var virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        var info = new $3939d1de148b5202$var$GlyphInfo(font, virama, [
            indicConfig.virama
        ]);
        for(var i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.Base_C) glyphs[i].shaperInfo.position = $3939d1de148b5202$var$consonantPosition(font, glyphs[i].copy(), info);
    }
    for(var start = 0, end = $3939d1de148b5202$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $3939d1de148b5202$var$nextSyllable(glyphs, start)){
        var _glyphs$start$shaperI = glyphs[start].shaperInfo, category = _glyphs$start$shaperI.category, syllableType = _glyphs$start$shaperI.syllableType;
        if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') continue;
        if (syllableType === 'broken_cluster' && dottedCircle) {
            var g = new $3939d1de148b5202$var$GlyphInfo(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = new $3939d1de148b5202$var$IndicInfo(1 << $3939d1de148b5202$var$indicCategory(g), $3939d1de148b5202$var$indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable); // Insert after possible Repha.
            var _i3 = start;
            while(_i3 < end && glyphs[_i3].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.Repha)_i3++;
            glyphs.splice(_i3++, 0, g);
            end++;
        } // 1. Find base consonant:
        //
        // The shaping engine finds the base consonant of the syllable, using the
        // following algorithm: starting from the end of the syllable, move backwards
        // until a consonant is found that does not have a below-base or post-base
        // form (post-base forms have to follow below-base forms), or that is not a
        // pre-base reordering Ra, or arrive at the first consonant. The consonant
        // stopped at will be the base.
        var base = end;
        var limit = start;
        var hasReph = false; // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        if (indicConfig.rephPos !== $3939d1de148b5202$var$POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !$3939d1de148b5202$var$isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.ZWJ)) {
            // See if it matches the 'rphf' feature.
            var _g = [
                glyphs[start].copy(),
                glyphs[start + 1].copy(),
                glyphs[start + 2].copy()
            ];
            if ($3939d1de148b5202$var$wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && $3939d1de148b5202$var$wouldSubstitute(_g, 'rphf')) {
                limit += 2;
                while(limit < end && $3939d1de148b5202$var$isJoiner(glyphs[limit]))limit++;
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.Repha) {
            limit++;
            while(limit < end && $3939d1de148b5202$var$isJoiner(glyphs[limit]))limit++;
            base = start;
            hasReph = true;
        }
        switch(indicConfig.basePos){
            case 'Last':
                // starting from the end of the syllable, move backwards
                var _i4 = end;
                var seenBelow = false;
                do {
                    var _info = glyphs[--_i4].shaperInfo; // until a consonant is found
                    if ($3939d1de148b5202$var$isConsonant(glyphs[_i4])) {
                        // that does not have a below-base or post-base form
                        // (post-base forms have to follow below-base forms),
                        if (_info.position !== $3939d1de148b5202$var$POSITIONS.Below_C && (_info.position !== $3939d1de148b5202$var$POSITIONS.Post_C || seenBelow)) {
                            base = _i4;
                            break;
                        } // or that is not a pre-base reordering Ra,
                        //
                        // IMPLEMENTATION NOTES:
                        //
                        // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                        // by the logic above already.
                        //
                        // or arrive at the first consonant. The consonant stopped at will
                        // be the base.
                        if (_info.position === $3939d1de148b5202$var$POSITIONS.Below_C) seenBelow = true;
                        base = _i4;
                    } else if (start < _i4 && _info.category === $3939d1de148b5202$var$CATEGORIES.ZWJ && glyphs[_i4 - 1].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.H) break;
                }while (_i4 > limit);
                break;
            case 'First':
                // The first consonant is always the base.
                base = start; // Mark all subsequent consonants as below.
                for(var _i5 = base + 1; _i5 < end; _i5++)if ($3939d1de148b5202$var$isConsonant(glyphs[_i5])) glyphs[_i5].shaperInfo.position = $3939d1de148b5202$var$POSITIONS.Below_C;
        } // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        //
        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
        if (hasReph && base === start && limit - base <= 2) hasReph = false;
         // 2. Decompose and reorder Matras:
        //
        // Each matra and any syllable modifier sign in the cluster are moved to the
        // appropriate position relative to the consonant(s) in the cluster. The
        // shaping engine decomposes two- or three-part matras into their constituent
        // parts before any repositioning. Matra characters are classified by which
        // consonant in a conjunct they have affinity for and are reordered to the
        // following positions:
        //
        //   o Before first half form in the syllable
        //   o After subjoined consonants
        //   o After post-form consonant
        //   o After main consonant (for above marks)
        //
        // IMPLEMENTATION NOTES:
        //
        // The normalize() routine has already decomposed matras for us, so we don't
        // need to worry about that.
        // 3.  Reorder marks to canonical order:
        //
        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
        // if necessary, so that the nukta is first.
        //
        // IMPLEMENTATION NOTES:
        //
        // We don't need to do this: the normalize() routine already did this for us.
        // Reorder characters
        for(var _i6 = start; _i6 < base; _i6++){
            var _info2 = glyphs[_i6].shaperInfo;
            _info2.position = Math.min($3939d1de148b5202$var$POSITIONS.Pre_C, _info2.position);
        }
        if (base < end) glyphs[base].shaperInfo.position = $3939d1de148b5202$var$POSITIONS.Base_C;
         // Mark final consonants.  A final consonant is one appearing after a matra,
        // like in Khmer.
        for(var _i7 = base + 1; _i7 < end; _i7++)if (glyphs[_i7].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.M) {
            for(var j = _i7 + 1; j < end; j++)if ($3939d1de148b5202$var$isConsonant(glyphs[j])) {
                glyphs[j].shaperInfo.position = $3939d1de148b5202$var$POSITIONS.Final_C;
                break;
            }
            break;
        }
         // Handle beginning Ra
        if (hasReph) glyphs[start].shaperInfo.position = $3939d1de148b5202$var$POSITIONS.Ra_To_Become_Reph;
         // For old-style Indic script tags, move the first post-base Halant after
        // last consonant.
        //
        // Reports suggest that in some scripts Uniscribe does this only if there
        // is *not* a Halant after last consonant already (eg. Kannada), while it
        // does it unconditionally in other scripts (eg. Malayalam).  We don't
        // currently know about other scripts, so we single out Malayalam for now.
        //
        // Kannada test case:
        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
        // With some versions of Lohit Kannada.
        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
        //
        // Malayalam test case:
        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
        if (plan.isOldSpec) {
            var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
            for(var _i8 = base + 1; _i8 < end; _i8++)if (glyphs[_i8].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.H) {
                var _j = void 0;
                for(_j = end - 1; _j > _i8; _j--){
                    if ($3939d1de148b5202$var$isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.H) break;
                }
                if (glyphs[_j].shaperInfo.category !== $3939d1de148b5202$var$CATEGORIES.H && _j > _i8) {
                    // Move Halant to after last consonant.
                    var t = glyphs[_i8];
                    glyphs.splice.apply(glyphs, [
                        _i8,
                        0
                    ].concat(glyphs.splice(_i8 + 1, _j - _i8)));
                    glyphs[_j] = t;
                }
                break;
            }
        } // Attach misc marks to previous char to move with them.
        var lastPos = $3939d1de148b5202$var$POSITIONS.Start;
        for(var _i9 = start; _i9 < end; _i9++){
            var _info3 = glyphs[_i9].shaperInfo;
            if (_info3.category & ($3939d1de148b5202$var$JOINER_FLAGS | $3939d1de148b5202$var$CATEGORIES.N | $3939d1de148b5202$var$CATEGORIES.RS | $3939d1de148b5202$var$CATEGORIES.CM | $3939d1de148b5202$var$HALANT_OR_COENG_FLAGS & _info3.category)) {
                _info3.position = lastPos;
                if (_info3.category === $3939d1de148b5202$var$CATEGORIES.H && _info3.position === $3939d1de148b5202$var$POSITIONS.Pre_M) {
                    // Uniscribe doesn't move the Halant with Left Matra.
                    // TEST: U+092B,U+093F,U+094DE
                    // We follow.  This is important for the Sinhala
                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                    // We don't want to move the virama with the left matra.
                    // TEST: U+0D9A,U+0DDA
                    for(var _j2 = _i9; _j2 > start; _j2--)if (glyphs[_j2 - 1].shaperInfo.position !== $3939d1de148b5202$var$POSITIONS.Pre_M) {
                        _info3.position = glyphs[_j2 - 1].shaperInfo.position;
                        break;
                    }
                }
            } else if (_info3.position !== $3939d1de148b5202$var$POSITIONS.SMVD) lastPos = _info3.position;
        } // For post-base consonants let them own anything before them
        // since the last consonant or matra.
        var last = base;
        for(var _i10 = base + 1; _i10 < end; _i10++){
            if ($3939d1de148b5202$var$isConsonant(glyphs[_i10])) {
                for(var _j3 = last + 1; _j3 < _i10; _j3++)if (glyphs[_j3].shaperInfo.position < $3939d1de148b5202$var$POSITIONS.SMVD) glyphs[_j3].shaperInfo.position = glyphs[_i10].shaperInfo.position;
                last = _i10;
            } else if (glyphs[_i10].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.M) last = _i10;
        }
        var arr = glyphs.slice(start, end);
        arr.sort(function(a, b) {
            return a.shaperInfo.position - b.shaperInfo.position;
        });
        glyphs.splice.apply(glyphs, [
            start,
            arr.length
        ].concat(arr)); // Find base again
        for(var _i11 = start; _i11 < end; _i11++)if (glyphs[_i11].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.Base_C) {
            base = _i11;
            break;
        }
         // Setup features now
        // Reph
        for(var _i12 = start; _i12 < end && glyphs[_i12].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.Ra_To_Become_Reph; _i12++)glyphs[_i12].features.rphf = true;
         // Pre-base
        var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
        for(var _i13 = start; _i13 < base; _i13++){
            glyphs[_i13].features.half = true;
            if (blwf) glyphs[_i13].features.blwf = true;
        } // Post-base
        for(var _i14 = base + 1; _i14 < end; _i14++){
            glyphs[_i14].features.abvf = true;
            glyphs[_i14].features.pstf = true;
            glyphs[_i14].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
            // Old-spec eye-lash Ra needs special handling.  From the
            // spec:
            //
            // "The feature 'below-base form' is applied to consonants
            // having below-base forms and following the base consonant.
            // The exception is vattu, which may appear below half forms
            // as well as below the base glyph. The feature 'below-base
            // form' will be applied to all such occurrences of Ra as well."
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
            // with Sanskrit 2003 font.
            //
            // However, note that Ra,Halant,ZWJ is the correct way to
            // request eyelash form of Ra, so we wouldbn't inhibit it
            // in that sequence.
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
            for(var _i15 = start; _i15 + 1 < base; _i15++)if (glyphs[_i15].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.Ra && glyphs[_i15 + 1].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.H && (_i15 + 1 === base || glyphs[_i15 + 2].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.ZWJ)) {
                glyphs[_i15].features.blwf = true;
                glyphs[_i15 + 1].features.blwf = true;
            }
        }
        var prefLen = 2;
        if (features.pref && base + prefLen < end) // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
        for(var _i16 = base + 1; _i16 + prefLen - 1 < end; _i16++){
            var _g2 = [
                glyphs[_i16].copy(),
                glyphs[_i16 + 1].copy()
            ];
            if ($3939d1de148b5202$var$wouldSubstitute(_g2, 'pref')) {
                for(var _j4 = 0; _j4 < prefLen; _j4++)glyphs[_i16++].features.pref = true;
                 // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                // Read the feature spec.
                // This allows distinguishing the following cases with MS Khmer fonts:
                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                if (features.cfar) for(; _i16 < end; _i16++)glyphs[_i16].features.cfar = true;
                break;
            }
        }
         // Apply ZWJ/ZWNJ effects
        for(var _i17 = start + 1; _i17 < end; _i17++)if ($3939d1de148b5202$var$isJoiner(glyphs[_i17])) {
            var nonJoiner = glyphs[_i17].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.ZWNJ;
            var _j5 = _i17;
            do {
                _j5--; // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                // being there, since we don't skip them for the CJCT
                // feature (ie. F_MANUAL_ZWJ)
                // A ZWNJ disables HALF.
                if (nonJoiner) delete glyphs[_j5].features.half;
            }while (_j5 > start && !$3939d1de148b5202$var$isConsonant(glyphs[_j5]));
        }
    }
}
function $3939d1de148b5202$var$finalReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    for(var start = 0, end = $3939d1de148b5202$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $3939d1de148b5202$var$nextSyllable(glyphs, start)){
        // 4. Final reordering:
        //
        // After the localized forms and basic shaping forms GSUB features have been
        // applied (see below), the shaping engine performs some final glyph
        // reordering before applying all the remaining font features to the entire
        // cluster.
        var tryPref = !!features.pref; // Find base again
        var base = start;
        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= $3939d1de148b5202$var$POSITIONS.Base_C) {
            if (tryPref && base + 1 < end) {
                for(var i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;
                        while(base < end && $3939d1de148b5202$var$isHalantOrCoeng(glyphs[base]))base++;
                        glyphs[base].shaperInfo.position = $3939d1de148b5202$var$POSITIONS.BASE_C;
                        tryPref = false;
                    }
                    break;
                }
            } // For Malayalam, skip over unformed below- (but NOT post-) forms.
            if (plan.unicodeScript === 'Malayalam') for(var _i18 = base + 1; _i18 < end; _i18++){
                while(_i18 < end && $3939d1de148b5202$var$isJoiner(glyphs[_i18]))_i18++;
                if (_i18 === end || !$3939d1de148b5202$var$isHalantOrCoeng(glyphs[_i18])) break;
                _i18++; // Skip halant.
                while(_i18 < end && $3939d1de148b5202$var$isJoiner(glyphs[_i18]))_i18++;
                if (_i18 < end && $3939d1de148b5202$var$isConsonant(glyphs[_i18]) && glyphs[_i18].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.Below_C) {
                    base = _i18;
                    glyphs[base].shaperInfo.position = $3939d1de148b5202$var$POSITIONS.Base_C;
                }
            }
            if (start < base && glyphs[base].shaperInfo.position > $3939d1de148b5202$var$POSITIONS.Base_C) base--;
            break;
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.ZWJ) base--;
        if (base < end) while(start < base && glyphs[base].shaperInfo.category & ($3939d1de148b5202$var$CATEGORIES.N | $3939d1de148b5202$var$HALANT_OR_COENG_FLAGS))base--;
         // o Reorder matras:
        //
        // If a pre-base matra character had been reordered before applying basic
        // features, the glyph can be moved closer to the main consonant based on
        // whether half-forms had been formed. Actual position for the matra is
        // defined as “after last standalone halant glyph, after initial matra
        // position and before the main consonant”. If ZWJ or ZWNJ follow this
        // halant, position is moved after it.
        //
        if (start + 1 < end && start < base) {
            // Otherwise there can't be any pre-base matra characters.
            // If we lost track of base, alas, position before last thingy.
            var newPos = base === end ? base - 2 : base - 1; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                while(newPos > start && !(glyphs[newPos].shaperInfo.category & ($3939d1de148b5202$var$CATEGORIES.M | $3939d1de148b5202$var$HALANT_OR_COENG_FLAGS)))newPos--;
                 // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!
                if ($3939d1de148b5202$var$isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== $3939d1de148b5202$var$POSITIONS.Pre_M) // If ZWJ or ZWNJ follow this halant, position is moved after it.
                {
                    if (newPos + 1 < end && $3939d1de148b5202$var$isJoiner(glyphs[newPos + 1])) newPos++;
                } else newPos = start; // No move.
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== $3939d1de148b5202$var$POSITIONS.Pre_M) {
                // Now go see if there's actually any matras...
                for(var _i19 = newPos; _i19 > start; _i19--)if (glyphs[_i19 - 1].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.Pre_M) {
                    var oldPos = _i19 - 1;
                    if (oldPos < base && base <= newPos) // Shouldn't actually happen.
                    base--;
                    var tmp = glyphs[oldPos];
                    glyphs.splice.apply(glyphs, [
                        oldPos,
                        0
                    ].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
                    glyphs[newPos] = tmp;
                    newPos--;
                }
            }
        } // o Reorder reph:
        //
        // Reph’s original position is always at the beginning of the syllable,
        // (i.e. it is not reordered at the character reordering stage). However,
        // it will be reordered according to the basic-forms shaping results.
        // Possible positions for reph, depending on the script, are; after main,
        // before post-base consonant forms, and after post-base consonant forms.
        // Two cases:
        //
        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
        //   we should only move it if the sequence ligated to the repha form.
        //
        // - If repha is encoded separately and in the logical position, we should only
        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
        //   to make it work without the reordering.
        if (start + 1 < end && glyphs[start].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            var newRephPos = void 0;
            var rephPos = indicConfig.rephPos;
            var found = false; // 1. If reph should be positioned after post-base consonant forms,
            //    proceed to step 5.
            if (rephPos !== $3939d1de148b5202$var$POSITIONS.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;
                while(newRephPos < base && !$3939d1de148b5202$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $3939d1de148b5202$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $3939d1de148b5202$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                } // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.
                if (!found && rephPos === $3939d1de148b5202$var$POSITIONS.After_Main) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= $3939d1de148b5202$var$POSITIONS.After_Main)newRephPos++;
                    found = newRephPos < end;
                } // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).
                if (!found && rephPos === $3939d1de148b5202$var$POSITIONS.After_Sub) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & ($3939d1de148b5202$var$POSITIONS.Post_C | $3939d1de148b5202$var$POSITIONS.After_Post | $3939d1de148b5202$var$POSITIONS.SMVD)))newRephPos++;
                    found = newRephPos < end;
                }
            } //  5. If no consonant is found in steps 3 or 4, move reph to a position
            //     immediately before the first post-base matra, syllable modifier
            //     sign or vedic sign that has a reordering class after the intended
            //     reph position. For example, if the reordering position for reph
            //     is post-main, it will skip above-base matras that also have a
            //     post-main position.
            if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;
                while(newRephPos < base && !$3939d1de148b5202$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $3939d1de148b5202$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $3939d1de148b5202$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
            } // 6. Otherwise, reorder reph to the end of the syllable.
            if (!found) {
                newRephPos = end - 1;
                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.SMVD)newRephPos--;
                 // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                if ($3939d1de148b5202$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    for(var _i20 = base + 1; _i20 < newRephPos; _i20++)if (glyphs[_i20].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.M) newRephPos--;
                }
            }
            var reph = glyphs[start];
            glyphs.splice.apply(glyphs, [
                start,
                0
            ].concat(glyphs.splice(start + 1, newRephPos - start)));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) base--;
        } // o Reorder pre-base reordering consonants:
        //
        // If a pre-base reordering consonant is found, reorder it according to
        // the following rules:
        if (tryPref && base + 1 < end) {
            for(var _i21 = base + 1; _i21 < end; _i21++)if (glyphs[_i21].features.pref) {
                // 1. Only reorder a glyph produced by substitution during application
                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                //    the feature generally but block it in certain contexts.)
                // Note: We just check that something got substituted.  We don't check that
                // the <pref> feature actually did it...
                //
                // Reorder pref only if it ligated.
                if (glyphs[_i21].isLigated && !glyphs[_i21].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    var _newPos = base; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.
                    if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                        while(_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & ($3939d1de148b5202$var$CATEGORIES.M | $3939d1de148b5202$var$HALANT_OR_COENG_FLAGS)))_newPos--;
                         // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                        // split matra, it should be reordered to *before* the left part of such matra.
                        if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.M) {
                            var _oldPos2 = _i21;
                            for(var j = base + 1; j < _oldPos2; j++)if (glyphs[j].shaperInfo.category === $3939d1de148b5202$var$CATEGORIES.M) {
                                _newPos--;
                                break;
                            }
                        }
                    }
                    if (_newPos > start && $3939d1de148b5202$var$isHalantOrCoeng(glyphs[_newPos - 1])) // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
                    {
                        if (_newPos < end && $3939d1de148b5202$var$isJoiner(glyphs[_newPos])) _newPos++;
                    }
                    var _oldPos = _i21;
                    var _tmp = glyphs[_oldPos];
                    glyphs.splice.apply(glyphs, [
                        _newPos + 1,
                        0
                    ].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
                    glyphs[_newPos] = _tmp;
                    if (_newPos <= base && base < _oldPos) base++;
                }
                break;
            }
        } // Apply 'init' to the Left Matra if it's a word start.
        if (glyphs[start].shaperInfo.position === $3939d1de148b5202$var$POSITIONS.Pre_M && (!start || !/Cf|Mn/.test($3939d1de148b5202$var$unicode.getCategory(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
    }
}
function $3939d1de148b5202$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
var $3939d1de148b5202$var$base64DeflatedTrie$3 = "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";
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$g(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$g(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$g(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$g(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$g(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$g(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_inheritsLoose$6(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $3939d1de148b5202$var$_defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// we may be running in a browser so we make an Uint8Array
var $3939d1de148b5202$var$useData$1 = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedUseData))));
var $3939d1de148b5202$var$trieData$3 = (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($3939d1de148b5202$var$base64Arraybuffer_2($3939d1de148b5202$var$base64DeflatedTrie$3));
var $3939d1de148b5202$var$categories = $3939d1de148b5202$var$useData$1.categories, $3939d1de148b5202$var$decompositions$1 = $3939d1de148b5202$var$useData$1.decompositions;
var $3939d1de148b5202$var$trie$3 = new $3939d1de148b5202$var$unicodeTrie($3939d1de148b5202$var$trieData$3);
var $3939d1de148b5202$var$stateMachine$1 = new $3939d1de148b5202$var$dfa($3939d1de148b5202$var$useData$1);
/**
 * This shaper is an implementation of the Universal Shaping Engine, which
 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
 */ var $3939d1de148b5202$var$UniversalShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $3939d1de148b5202$var$_inheritsLoose$6(UniversalShaper, _DefaultShaper);
    function UniversalShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    UniversalShaper.planFeatures = function planFeatures(plan) {
        plan.addStage($3939d1de148b5202$var$setupSyllables$1); // Default glyph pre-processing group
        plan.addStage([
            'locl',
            'ccmp',
            'nukt',
            'akhn'
        ]); // Reordering group
        plan.addStage($3939d1de148b5202$var$clearSubstitutionFlags);
        plan.addStage([
            'rphf'
        ], false);
        plan.addStage($3939d1de148b5202$var$recordRphf);
        plan.addStage($3939d1de148b5202$var$clearSubstitutionFlags);
        plan.addStage([
            'pref'
        ]);
        plan.addStage($3939d1de148b5202$var$recordPref); // Orthographic unit shaping group
        plan.addStage([
            'rkrf',
            'abvf',
            'blwf',
            'half',
            'pstf',
            'vatu',
            'cjct'
        ]);
        plan.addStage($3939d1de148b5202$var$reorder); // Topographical features
        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
        // Standard topographic presentation and positional feature application
        plan.addStage([
            'abvs',
            'blws',
            'pres',
            'psts',
            'dist',
            'abvm',
            'blwm'
        ]);
    };
    UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var _loop = function _loop(i) {
            var codepoint = glyphs[i].codePoints[0];
            if ($3939d1de148b5202$var$decompositions$1[codepoint]) {
                var decomposed = $3939d1de148b5202$var$decompositions$1[codepoint].map(function(c) {
                    var g = plan.font.glyphForCodePoint(c);
                    return new $3939d1de148b5202$var$GlyphInfo(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [
                    i,
                    1
                ].concat(decomposed));
            }
        };
        // Decompose split vowels
        // TODO: do this in a more general unicode normalizer
        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
    };
    return UniversalShaper;
}($3939d1de148b5202$var$DefaultShaper);
$3939d1de148b5202$var$_defineProperty$3($3939d1de148b5202$var$UniversalShaper, "zeroMarkWidths", 'BEFORE_GPOS');
function $3939d1de148b5202$var$useCategory(glyph) {
    return $3939d1de148b5202$var$trie$3.get(glyph.codePoints[0]);
}
var $3939d1de148b5202$var$USEInfo = function USEInfo(category, syllableType, syllable) {
    this.category = category;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function $3939d1de148b5202$var$setupSyllables$1(font, glyphs) {
    var syllable = 0;
    for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$g($3939d1de148b5202$var$stateMachine$1.match(glyphs.map($3939d1de148b5202$var$useCategory))), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
        ++syllable; // Create shaper info
        for(var i = start; i <= end; i++)glyphs[i].shaperInfo = new $3939d1de148b5202$var$USEInfo($3939d1de148b5202$var$categories[$3939d1de148b5202$var$useCategory(glyphs[i])], tags[0], syllable);
         // Assign rphf feature
        var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
        for(var _i = start; _i < start + limit; _i++)glyphs[_i].features.rphf = true;
    }
}
function $3939d1de148b5202$var$clearSubstitutionFlags(font, glyphs) {
    for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$g(glyphs), _step2; !(_step2 = _iterator2()).done;){
        var glyph = _step2.value;
        glyph.substituted = false;
    }
}
function $3939d1de148b5202$var$recordRphf(font, glyphs) {
    for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$g(glyphs), _step3; !(_step3 = _iterator3()).done;){
        var glyph = _step3.value;
        if (glyph.substituted && glyph.features.rphf) // Mark a substituted repha.
        glyph.shaperInfo.category = 'R';
    }
}
function $3939d1de148b5202$var$recordPref(font, glyphs) {
    for(var _iterator4 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$g(glyphs), _step4; !(_step4 = _iterator4()).done;){
        var glyph = _step4.value;
        if (glyph.substituted) // Mark a substituted pref as VPre, as they behave the same way.
        glyph.shaperInfo.category = 'VPre';
    }
}
function $3939d1de148b5202$var$reorder(font, glyphs) {
    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
    for(var start = 0, end = $3939d1de148b5202$var$nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = $3939d1de148b5202$var$nextSyllable$1(glyphs, start)){
        var i = void 0, j = void 0;
        var info = glyphs[start].shaperInfo;
        var type = info.syllableType; // Only a few syllable types need reordering.
        if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') continue;
         // Insert a dotted circle glyph in broken clusters.
        if (type === 'broken_cluster' && dottedCircle) {
            var g = new $3939d1de148b5202$var$GlyphInfo(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = info; // Insert after possible Repha.
            for(i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++);
            glyphs.splice(++i, 0, g);
            end++;
        } // Move things forward.
        if (info.category === 'R' && end - start > 1) // Got a repha. Reorder it to after first base, before first halant.
        for(i = start + 1; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($3939d1de148b5202$var$isBase(info) || $3939d1de148b5202$var$isHalant(glyphs[i])) {
                // If we hit a halant, move before it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                if ($3939d1de148b5202$var$isHalant(glyphs[i])) i--;
                glyphs.splice.apply(glyphs, [
                    start,
                    0
                ].concat(glyphs.splice(start + 1, i - start), [
                    glyphs[i]
                ]));
                break;
            }
        }
         // Move things back.
        for(i = start, j = end; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($3939d1de148b5202$var$isBase(info) || $3939d1de148b5202$var$isHalant(glyphs[i])) // If we hit a halant, move after it; otherwise it's a base: move to it's
            // place, and shift things in between backward.
            j = $3939d1de148b5202$var$isHalant(glyphs[i]) ? i + 1 : i;
            else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) glyphs.splice.apply(glyphs, [
                j,
                1,
                glyphs[i]
            ].concat(glyphs.splice(j, i - j)));
        }
    }
}
function $3939d1de148b5202$var$nextSyllable$1(glyphs, start) {
    if (start >= glyphs.length) return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
function $3939d1de148b5202$var$isHalant(glyph) {
    return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
}
function $3939d1de148b5202$var$isBase(info) {
    return info.category === 'B' || info.category === 'GB';
}
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$h(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$h(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$h(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$h(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$h(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$h(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$SHAPERS = {
    arab: $3939d1de148b5202$var$ArabicShaper,
    // Arabic
    mong: $3939d1de148b5202$var$ArabicShaper,
    // Mongolian
    syrc: $3939d1de148b5202$var$ArabicShaper,
    // Syriac
    'nko ': $3939d1de148b5202$var$ArabicShaper,
    // N'Ko
    phag: $3939d1de148b5202$var$ArabicShaper,
    // Phags Pa
    mand: $3939d1de148b5202$var$ArabicShaper,
    // Mandaic
    mani: $3939d1de148b5202$var$ArabicShaper,
    // Manichaean
    phlp: $3939d1de148b5202$var$ArabicShaper,
    // Psalter Pahlavi
    hang: $3939d1de148b5202$var$HangulShaper,
    // Hangul
    bng2: $3939d1de148b5202$var$IndicShaper,
    // Bengali
    beng: $3939d1de148b5202$var$IndicShaper,
    // Bengali
    dev2: $3939d1de148b5202$var$IndicShaper,
    // Devanagari
    deva: $3939d1de148b5202$var$IndicShaper,
    // Devanagari
    gjr2: $3939d1de148b5202$var$IndicShaper,
    // Gujarati
    gujr: $3939d1de148b5202$var$IndicShaper,
    // Gujarati
    guru: $3939d1de148b5202$var$IndicShaper,
    // Gurmukhi
    gur2: $3939d1de148b5202$var$IndicShaper,
    // Gurmukhi
    knda: $3939d1de148b5202$var$IndicShaper,
    // Kannada
    knd2: $3939d1de148b5202$var$IndicShaper,
    // Kannada
    mlm2: $3939d1de148b5202$var$IndicShaper,
    // Malayalam
    mlym: $3939d1de148b5202$var$IndicShaper,
    // Malayalam
    ory2: $3939d1de148b5202$var$IndicShaper,
    // Oriya
    orya: $3939d1de148b5202$var$IndicShaper,
    // Oriya
    taml: $3939d1de148b5202$var$IndicShaper,
    // Tamil
    tml2: $3939d1de148b5202$var$IndicShaper,
    // Tamil
    telu: $3939d1de148b5202$var$IndicShaper,
    // Telugu
    tel2: $3939d1de148b5202$var$IndicShaper,
    // Telugu
    khmr: $3939d1de148b5202$var$IndicShaper,
    // Khmer
    bali: $3939d1de148b5202$var$UniversalShaper,
    // Balinese
    batk: $3939d1de148b5202$var$UniversalShaper,
    // Batak
    brah: $3939d1de148b5202$var$UniversalShaper,
    // Brahmi
    bugi: $3939d1de148b5202$var$UniversalShaper,
    // Buginese
    buhd: $3939d1de148b5202$var$UniversalShaper,
    // Buhid
    cakm: $3939d1de148b5202$var$UniversalShaper,
    // Chakma
    cham: $3939d1de148b5202$var$UniversalShaper,
    // Cham
    dupl: $3939d1de148b5202$var$UniversalShaper,
    // Duployan
    egyp: $3939d1de148b5202$var$UniversalShaper,
    // Egyptian Hieroglyphs
    gran: $3939d1de148b5202$var$UniversalShaper,
    // Grantha
    hano: $3939d1de148b5202$var$UniversalShaper,
    // Hanunoo
    java: $3939d1de148b5202$var$UniversalShaper,
    // Javanese
    kthi: $3939d1de148b5202$var$UniversalShaper,
    // Kaithi
    kali: $3939d1de148b5202$var$UniversalShaper,
    // Kayah Li
    khar: $3939d1de148b5202$var$UniversalShaper,
    // Kharoshthi
    khoj: $3939d1de148b5202$var$UniversalShaper,
    // Khojki
    sind: $3939d1de148b5202$var$UniversalShaper,
    // Khudawadi
    lepc: $3939d1de148b5202$var$UniversalShaper,
    // Lepcha
    limb: $3939d1de148b5202$var$UniversalShaper,
    // Limbu
    mahj: $3939d1de148b5202$var$UniversalShaper,
    // Mahajani
    // mand: UniversalShaper, // Mandaic
    // mani: UniversalShaper, // Manichaean
    mtei: $3939d1de148b5202$var$UniversalShaper,
    // Meitei Mayek
    modi: $3939d1de148b5202$var$UniversalShaper,
    // Modi
    // mong: UniversalShaper, // Mongolian
    // 'nko ': UniversalShaper, // N’Ko
    hmng: $3939d1de148b5202$var$UniversalShaper,
    // Pahawh Hmong
    // phag: UniversalShaper, // Phags-pa
    // phlp: UniversalShaper, // Psalter Pahlavi
    rjng: $3939d1de148b5202$var$UniversalShaper,
    // Rejang
    saur: $3939d1de148b5202$var$UniversalShaper,
    // Saurashtra
    shrd: $3939d1de148b5202$var$UniversalShaper,
    // Sharada
    sidd: $3939d1de148b5202$var$UniversalShaper,
    // Siddham
    sinh: $3939d1de148b5202$var$UniversalShaper,
    // Sinhala
    sund: $3939d1de148b5202$var$UniversalShaper,
    // Sundanese
    sylo: $3939d1de148b5202$var$UniversalShaper,
    // Syloti Nagri
    tglg: $3939d1de148b5202$var$UniversalShaper,
    // Tagalog
    tagb: $3939d1de148b5202$var$UniversalShaper,
    // Tagbanwa
    tale: $3939d1de148b5202$var$UniversalShaper,
    // Tai Le
    lana: $3939d1de148b5202$var$UniversalShaper,
    // Tai Tham
    tavt: $3939d1de148b5202$var$UniversalShaper,
    // Tai Viet
    takr: $3939d1de148b5202$var$UniversalShaper,
    // Takri
    tibt: $3939d1de148b5202$var$UniversalShaper,
    // Tibetan
    tfng: $3939d1de148b5202$var$UniversalShaper,
    // Tifinagh
    tirh: $3939d1de148b5202$var$UniversalShaper,
    // Tirhuta
    latn: $3939d1de148b5202$var$DefaultShaper,
    // Latin
    DFLT: $3939d1de148b5202$var$DefaultShaper // Default
};
function $3939d1de148b5202$var$choose(script) {
    if (!Array.isArray(script)) script = [
        script
    ];
    for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$h(script), _step; !(_step = _iterator()).done;){
        var s = _step.value;
        var shaper = $3939d1de148b5202$var$SHAPERS[s];
        if (shaper) return shaper;
    }
    return $3939d1de148b5202$var$DefaultShaper;
}
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$i(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$i(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$i(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$i(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$i(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$i(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_inheritsLoose$7(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$GSUBProcessor = /*#__PURE__*/ function(_OTProcessor) {
    $3939d1de148b5202$var$_inheritsLoose$7(GSUBProcessor, _OTProcessor);
    function GSUBProcessor() {
        return _OTProcessor.apply(this, arguments) || this;
    }
    var _proto = GSUBProcessor.prototype;
    _proto.applyLookup = function applyLookup(lookupType, table) {
        var _this = this;
        switch(lookupType){
            case 1:
                // Single Substitution
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var glyph = this.glyphIterator.cur;
                switch(table.version){
                    case 1:
                        glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                        break;
                    case 2:
                        glyph.id = table.substitute.get(index);
                        break;
                }
                return true;
            case 2:
                // Multiple Substitution
                var _index = this.coverageIndex(table.coverage);
                if (_index !== -1) {
                    var _this$glyphs;
                    var sequence = table.sequences.get(_index);
                    this.glyphIterator.cur.id = sequence[0];
                    this.glyphIterator.cur.ligatureComponent = 0;
                    var features = this.glyphIterator.cur.features;
                    var curGlyph = this.glyphIterator.cur;
                    var replacement = sequence.slice(1).map(function(gid, i) {
                        var glyph = new $3939d1de148b5202$var$GlyphInfo(_this.font, gid, undefined, features);
                        glyph.shaperInfo = curGlyph.shaperInfo;
                        glyph.isLigated = curGlyph.isLigated;
                        glyph.ligatureComponent = i + 1;
                        glyph.substituted = true;
                        glyph.isMultiplied = true;
                        return glyph;
                    });
                    (_this$glyphs = this.glyphs).splice.apply(_this$glyphs, [
                        this.glyphIterator.index + 1,
                        0
                    ].concat(replacement));
                    return true;
                }
                return false;
            case 3:
                // Alternate Substitution
                var _index2 = this.coverageIndex(table.coverage);
                if (_index2 !== -1) {
                    var USER_INDEX = 0; // TODO
                    this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
                    return true;
                }
                return false;
            case 4:
                // Ligature Substitution
                var _index3 = this.coverageIndex(table.coverage);
                if (_index3 === -1) return false;
                for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$i(table.ligatureSets.get(_index3)), _step; !(_step = _iterator()).done;){
                    var ligature = _step.value;
                    var matched = this.sequenceMatchIndices(1, ligature.components);
                    if (!matched) continue;
                    var _curGlyph = this.glyphIterator.cur; // Concatenate all of the characters the new ligature will represent
                    var characters = _curGlyph.codePoints.slice();
                    for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$i(matched), _step2; !(_step2 = _iterator2()).done;){
                        var _index4 = _step2.value;
                        characters.push.apply(characters, this.glyphs[_index4].codePoints);
                    } // Create the replacement ligature glyph
                    var ligatureGlyph = new $3939d1de148b5202$var$GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
                    ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                    ligatureGlyph.isLigated = true;
                    ligatureGlyph.substituted = true; // From Harfbuzz:
                    // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                    //   the ligature to keep its old ligature id.  This will allow it to attach to
                    //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                    //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                    //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                    //   later, we don't want them to lose their ligature id/component, otherwise
                    //   GPOS will fail to correctly position the mark ligature on top of the
                    //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                    //
                    // - If a ligature is formed of components that some of which are also ligatures
                    //   themselves, and those ligature components had marks attached to *their*
                    //   components, we have to attach the marks to the new ligature component
                    //   positions!  Now *that*'s tricky!  And these marks may be following the
                    //   last component of the whole sequence, so we should loop forward looking
                    //   for them and update them.
                    //
                    //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                    //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                    //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                    //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                    //   the new ligature with a component value of 2.
                    //
                    //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                    var isMarkLigature = _curGlyph.isMark;
                    for(var i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                    ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                    var lastLigID = _curGlyph.ligatureID;
                    var lastNumComps = _curGlyph.codePoints.length;
                    var curComps = lastNumComps;
                    var idx = this.glyphIterator.index + 1; // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                    // This allows GPOS to attach marks to the correct ligature components.
                    for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$i(matched), _step3; !(_step3 = _iterator3()).done;){
                        var matchIndex = _step3.value;
                        // Don't assign new ligature components for mark ligatures (see above)
                        if (isMarkLigature) idx = matchIndex;
                        else while(idx < matchIndex){
                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                            this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                            this.glyphs[idx].ligatureComponent = ligatureComponent;
                            idx++;
                        }
                        lastLigID = this.glyphs[idx].ligatureID;
                        lastNumComps = this.glyphs[idx].codePoints.length;
                        curComps += lastNumComps;
                        idx++; // skip base glyph
                    } // Adjust ligature components for any marks following
                    if (lastLigID && !isMarkLigature) for(var _i = idx; _i < this.glyphs.length; _i++){
                        if (this.glyphs[_i].ligatureID === lastLigID) {
                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i].ligatureComponent || 1, lastNumComps);
                            this.glyphs[_i].ligatureComponent = ligatureComponent;
                        } else break;
                    }
                     // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                    for(var _i2 = matched.length - 1; _i2 >= 0; _i2--)this.glyphs.splice(matched[_i2], 1);
                    this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                    return true;
                }
                return false;
            case 5:
                // Contextual Substitution
                return this.applyContext(table);
            case 6:
                // Chaining Contextual Substitution
                return this.applyChainingContext(table);
            case 7:
                // Extension Substitution
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error("GSUB lookupType " + lookupType + " is not supported");
        }
    };
    return GSUBProcessor;
}($3939d1de148b5202$var$OTProcessor);
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$j(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$j(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$j(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$j(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$j(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$j(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_inheritsLoose$8(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$GPOSProcessor = /*#__PURE__*/ function(_OTProcessor) {
    $3939d1de148b5202$var$_inheritsLoose$8(GPOSProcessor, _OTProcessor);
    function GPOSProcessor() {
        return _OTProcessor.apply(this, arguments) || this;
    }
    var _proto = GPOSProcessor.prototype;
    _proto.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
        var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
        if (value.xPlacement != null) position.xOffset += value.xPlacement;
        if (value.yPlacement != null) position.yOffset += value.yPlacement;
         // Adjustments for font variations
        var variationProcessor = this.font._variationProcessor;
        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
        } // TODO: device tables
    };
    _proto.applyLookup = function applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                // Single positioning value
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                switch(table.version){
                    case 1:
                        this.applyPositionValue(0, table.value);
                        break;
                    case 2:
                        this.applyPositionValue(0, table.values.get(index));
                        break;
                }
                return true;
            case 2:
                // Pair Adjustment Positioning
                var nextGlyph = this.glyphIterator.peek();
                if (!nextGlyph) return false;
                var _index = this.coverageIndex(table.coverage);
                if (_index === -1) return false;
                switch(table.version){
                    case 1:
                        // Adjustments for glyph pairs
                        var set = table.pairSets.get(_index);
                        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$j(set), _step; !(_step = _iterator()).done;){
                            var _pair = _step.value;
                            if (_pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, _pair.value1);
                                this.applyPositionValue(1, _pair.value2);
                                return true;
                            }
                        }
                        return false;
                    case 2:
                        // Class pair adjustment
                        var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                        var class2 = this.getClassID(nextGlyph.id, table.classDef2);
                        if (class1 === -1 || class2 === -1) return false;
                        var pair = table.classRecords.get(class1).get(class2);
                        this.applyPositionValue(0, pair.value1);
                        this.applyPositionValue(1, pair.value2);
                        return true;
                }
            case 3:
                // Cursive Attachment Positioning
                var nextIndex = this.glyphIterator.peekIndex();
                var _nextGlyph = this.glyphs[nextIndex];
                if (!_nextGlyph) return false;
                var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                if (!curRecord || !curRecord.exitAnchor) return false;
                var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
                if (!nextRecord || !nextRecord.entryAnchor) return false;
                var entry = this.getAnchor(nextRecord.entryAnchor);
                var exit = this.getAnchor(curRecord.exitAnchor);
                var cur = this.positions[this.glyphIterator.index];
                var next = this.positions[nextIndex];
                switch(this.direction){
                    case 'ltr':
                        cur.xAdvance = exit.x + cur.xOffset;
                        var d = entry.x + next.xOffset;
                        next.xAdvance -= d;
                        next.xOffset -= d;
                        break;
                    case 'rtl':
                        d = exit.x + cur.xOffset;
                        cur.xAdvance -= d;
                        cur.xOffset -= d;
                        next.xAdvance = entry.x + next.xOffset;
                        break;
                }
                if (this.glyphIterator.flags.rightToLeft) {
                    this.glyphIterator.cur.cursiveAttachment = nextIndex;
                    cur.yOffset = entry.y - exit.y;
                } else {
                    _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                    cur.yOffset = exit.y - entry.y;
                }
                return true;
            case 4:
                // Mark to base positioning
                var markIndex = this.coverageIndex(table.markCoverage);
                if (markIndex === -1) return false;
                 // search backward for a base glyph
                var baseGlyphIndex = this.glyphIterator.index;
                while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                if (baseGlyphIndex < 0) return false;
                var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                if (baseIndex === -1) return false;
                var markRecord = table.markArray[markIndex];
                var baseAnchor = table.baseArray[baseIndex][markRecord["class"]];
                this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                return true;
            case 5:
                // Mark to ligature positioning
                var _markIndex = this.coverageIndex(table.markCoverage);
                if (_markIndex === -1) return false;
                 // search backward for a base glyph
                var _baseGlyphIndex = this.glyphIterator.index;
                while(--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark);
                if (_baseGlyphIndex < 0) return false;
                var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
                if (ligIndex === -1) return false;
                var ligAttach = table.ligatureArray[ligIndex];
                var markGlyph = this.glyphIterator.cur;
                var ligGlyph = this.glyphs[_baseGlyphIndex];
                var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                var _markRecord = table.markArray[_markIndex];
                var _baseAnchor = ligAttach[compIndex][_markRecord["class"]];
                this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
                return true;
            case 6:
                // Mark to mark positioning
                var mark1Index = this.coverageIndex(table.mark1Coverage);
                if (mark1Index === -1) return false;
                 // get the previous mark to attach to
                var prevIndex = this.glyphIterator.peekIndex(-1);
                var prev = this.glyphs[prevIndex];
                if (!prev || !prev.isMark) return false;
                var _cur = this.glyphIterator.cur; // The following logic was borrowed from Harfbuzz
                var good = false;
                if (_cur.ligatureID === prev.ligatureID) {
                    if (!_cur.ligatureID) // Marks belonging to the same base
                    good = true;
                    else if (_cur.ligatureComponent === prev.ligatureComponent) // Marks belonging to the same ligature component
                    good = true;
                } else // If ligature ids don't match, it may be the case that one of the marks
                // itself is a ligature, in which case match.
                if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                if (!good) return false;
                var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                if (mark2Index === -1) return false;
                var _markRecord2 = table.mark1Array[mark1Index];
                var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2["class"]];
                this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                return true;
            case 7:
                // Contextual positioning
                return this.applyContext(table);
            case 8:
                // Chaining contextual positioning
                return this.applyChainingContext(table);
            case 9:
                // Extension positioning
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error("Unsupported GPOS table: " + lookupType);
        }
    };
    _proto.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
        var baseCoords = this.getAnchor(baseAnchor);
        var markCoords = this.getAnchor(markRecord.markAnchor);
        var basePos = this.positions[baseGlyphIndex];
        var markPos = this.positions[this.glyphIterator.index];
        markPos.xOffset = baseCoords.x - markCoords.x;
        markPos.yOffset = baseCoords.y - markCoords.y;
        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
    };
    _proto.getAnchor = function getAnchor(anchor) {
        // TODO: contour point, device tables
        var x = anchor.xCoordinate;
        var y = anchor.yCoordinate; // Adjustments for font variations
        var variationProcessor = this.font._variationProcessor;
        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
        }
        return {
            x: x,
            y: y
        };
    };
    _proto.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
        _OTProcessor.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);
        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
        this.fixMarkAttachment();
    };
    _proto.fixCursiveAttachment = function fixCursiveAttachment(i) {
        var glyph = this.glyphs[i];
        if (glyph.cursiveAttachment != null) {
            var j = glyph.cursiveAttachment;
            glyph.cursiveAttachment = null;
            this.fixCursiveAttachment(j);
            this.positions[i].yOffset += this.positions[j].yOffset;
        }
    };
    _proto.fixMarkAttachment = function fixMarkAttachment() {
        for(var i = 0; i < this.glyphs.length; i++){
            var glyph = this.glyphs[i];
            if (glyph.markAttachment != null) {
                var j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;
                if (this.direction === 'ltr') for(var k = j; k < i; k++){
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                }
                else for(var _k = j + 1; _k < i + 1; _k++){
                    this.positions[i].xOffset += this.positions[_k].xAdvance;
                    this.positions[i].yOffset += this.positions[_k].yAdvance;
                }
            }
        }
    };
    return GPOSProcessor;
}($3939d1de148b5202$var$OTProcessor);
var $3939d1de148b5202$var$OTLayoutEngine = /*#__PURE__*/ function() {
    function OTLayoutEngine(font) {
        this.font = font;
        this.glyphInfos = null;
        this.plan = null;
        this.GSUBProcessor = null;
        this.GPOSProcessor = null;
        this.fallbackPosition = true;
        if (font.GSUB) this.GSUBProcessor = new $3939d1de148b5202$var$GSUBProcessor(font, font.GSUB);
        if (font.GPOS) this.GPOSProcessor = new $3939d1de148b5202$var$GPOSProcessor(font, font.GPOS);
    }
    var _proto = OTLayoutEngine.prototype;
    _proto.setup = function setup(glyphRun) {
        var _this = this;
        // Map glyphs to GlyphInfo objects so data can be passed between
        // GSUB and GPOS without mutating the real (shared) Glyph objects.
        this.glyphInfos = glyphRun.glyphs.map(function(glyph) {
            return new $3939d1de148b5202$var$GlyphInfo(_this.font, glyph.id, [].concat(glyph.codePoints));
        }); // Select a script based on what is available in GSUB/GPOS.
        var script = null;
        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
         // Choose a shaper based on the script, and setup a shaping plan.
        // This determines which features to apply to which glyphs.
        this.shaper = $3939d1de148b5202$var$choose(script);
        this.plan = new $3939d1de148b5202$var$ShapingPlan(this.font, script, glyphRun.direction);
        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features); // Assign chosen features to output glyph run
        for(var key in this.plan.allFeatures)glyphRun.features[key] = true;
    };
    _proto.substitute = function substitute(glyphRun) {
        var _this2 = this;
        if (this.GSUBProcessor) {
            this.plan.process(this.GSUBProcessor, this.glyphInfos); // Map glyph infos back to normal Glyph objects
            glyphRun.glyphs = this.glyphInfos.map(function(glyphInfo) {
                return _this2.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
            });
        }
    };
    _proto.position = function position(glyphRun) {
        if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') this.zeroMarkAdvances(glyphRun.positions);
        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
        if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') this.zeroMarkAdvances(glyphRun.positions);
         // Reverse the glyphs and positions if the script is right-to-left
        if (glyphRun.direction === 'rtl') {
            glyphRun.glyphs.reverse();
            glyphRun.positions.reverse();
        }
        return this.GPOSProcessor && this.GPOSProcessor.features;
    };
    _proto.zeroMarkAdvances = function zeroMarkAdvances(positions) {
        for(var i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    };
    _proto.cleanup = function cleanup() {
        this.glyphInfos = null;
        this.plan = null;
        this.shaper = null;
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        var features = [];
        if (this.GSUBProcessor) {
            this.GSUBProcessor.selectScript(script, language);
            features.push.apply(features, Object.keys(this.GSUBProcessor.features));
        }
        if (this.GPOSProcessor) {
            this.GPOSProcessor.selectScript(script, language);
            features.push.apply(features, Object.keys(this.GPOSProcessor.features));
        }
        return features;
    };
    return OTLayoutEngine;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$k(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$k(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$k(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$k(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$k(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$k(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$LayoutEngine = /*#__PURE__*/ function() {
    function LayoutEngine(font) {
        this.font = font;
        this.unicodeLayoutEngine = null;
        this.kernProcessor = null; // Choose an advanced layout engine. We try the AAT morx table first since more
        // scripts are currently supported because the shaping logic is built into the font.
        if (this.font.morx) this.engine = new $3939d1de148b5202$var$AATLayoutEngine(this.font);
        else if (this.font.GSUB || this.font.GPOS) this.engine = new $3939d1de148b5202$var$OTLayoutEngine(this.font);
    }
    var _proto = LayoutEngine.prototype;
    _proto.layout = function layout(string, features, script, language, direction) {
        // Make the features parameter optional
        if (typeof features === 'string') {
            direction = language;
            language = script;
            script = features;
            features = [];
        } // Map string to glyphs if needed
        if (typeof string === 'string') {
            // Attempt to detect the script from the string if not provided.
            if (script == null) script = $3939d1de148b5202$var$forString(string);
            var glyphs = this.font.glyphsForString(string);
        } else {
            // Attempt to detect the script from the glyph code points if not provided.
            if (script == null) {
                var codePoints = [];
                for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$k(string), _step; !(_step = _iterator()).done;){
                    var glyph = _step.value;
                    codePoints.push.apply(codePoints, glyph.codePoints);
                }
                script = $3939d1de148b5202$var$forCodePoints(codePoints);
            }
            var glyphs = string;
        }
        var glyphRun = new $3939d1de148b5202$var$GlyphRun(glyphs, features, script, language, direction); // Return early if there are no glyphs
        if (glyphs.length === 0) {
            glyphRun.positions = [];
            return glyphRun;
        } // Setup the advanced layout engine
        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
         // Substitute and position the glyphs
        this.substitute(glyphRun);
        this.position(glyphRun);
        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions); // Let the layout engine clean up any state it might have
        if (this.engine && this.engine.cleanup) this.engine.cleanup();
        return glyphRun;
    };
    _proto.substitute = function substitute(glyphRun) {
        // Call the advanced layout engine to make substitutions
        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
    };
    _proto.position = function position(glyphRun) {
        // Get initial glyph positions
        glyphRun.positions = glyphRun.glyphs.map(function(glyph) {
            return new $3939d1de148b5202$var$GlyphPosition(glyph.advanceWidth);
        });
        var positioned = null; // Call the advanced layout engine. Returns the features applied.
        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
         // if there is no GPOS table, use unicode properties to position marks.
        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new $3939d1de148b5202$var$UnicodeLayoutEngine(this.font);
            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
        } // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
            if (!this.kernProcessor) this.kernProcessor = new $3939d1de148b5202$var$KernProcessor(this.font);
            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
            glyphRun.features.kern = true;
        }
    };
    _proto.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
        var space = this.font.glyphForCodePoint(0x20);
        for(var i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
            glyphs[i] = space;
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    };
    _proto.isDefaultIgnorable = function isDefaultIgnorable(ch) {
        // From DerivedCoreProperties.txt in the Unicode database,
        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
        // Harfbuzz and Uniscribe do.
        var plane = ch >> 16;
        if (plane === 0) // BMP
        switch(ch >> 8){
            case 0x00:
                return ch === 0x00AD;
            case 0x03:
                return ch === 0x034F;
            case 0x06:
                return ch === 0x061C;
            case 0x17:
                return 0x17B4 <= ch && ch <= 0x17B5;
            case 0x18:
                return 0x180B <= ch && ch <= 0x180E;
            case 0x20:
                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
            case 0xFE:
                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
            case 0xFF:
                return 0xFFF0 <= ch && ch <= 0xFFF8;
            default:
                return false;
        }
        else // Other planes
        switch(plane){
            case 0x01:
                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
            case 0x0E:
                return 0xE0000 <= ch && ch <= 0xE0FFF;
            default:
                return false;
        }
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        var features = [];
        if (this.engine) features.push.apply(features, this.engine.getAvailableFeatures(script, language));
        if (this.font.kern && features.indexOf('kern') === -1) features.push('kern');
        return features;
    };
    _proto.stringsForGlyph = function stringsForGlyph(gid) {
        var result = new Set();
        var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
        for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$k(codePoints), _step2; !(_step2 = _iterator2()).done;){
            var codePoint = _step2.value;
            result.add(String.fromCodePoint(codePoint));
        }
        if (this.engine && this.engine.stringsForGlyph) for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$k(this.engine.stringsForGlyph(gid)), _step3; !(_step3 = _iterator3()).done;){
            var string = _step3.value;
            result.add(string);
        }
        return Array.from(result);
    };
    return LayoutEngine;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$l(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$l(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$l(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$l(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$l(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$l(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_defineProperties$5(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$5(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$5(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$5(Constructor, staticProps);
    return Constructor;
}
var $3939d1de148b5202$var$SVG_COMMANDS = {
    moveTo: 'M',
    lineTo: 'L',
    quadraticCurveTo: 'Q',
    bezierCurveTo: 'C',
    closePath: 'Z'
};
/**
 * Path objects are returned by glyphs and represent the actual
 * vector outlines for each glyph in the font. Paths can be converted
 * to SVG path data strings, or to functions that can be applied to
 * render the path to a graphics context.
 */ var $3939d1de148b5202$var$Path = /*#__PURE__*/ function() {
    function Path() {
        this.commands = [];
        this._bbox = null;
        this._cbox = null;
    }
    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ var _proto = Path.prototype;
    _proto.toFunction = function toFunction() {
        var _this = this;
        return function(ctx) {
            return _this.commands.forEach(function(c) {
                return ctx[c.command].apply(ctx, c.args);
            });
        };
    };
    _proto.toSVG = function toSVG() {
        var cmds = this.commands.map(function(c) {
            var args = c.args.map(function(arg) {
                return Math.round(arg * 100) / 100;
            });
            return "" + $3939d1de148b5202$var$SVG_COMMANDS[c.command] + args.join(' ');
        });
        return cmds.join('');
    };
    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ _proto.mapPoints = function mapPoints(fn) {
        var path = new Path();
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$l(this.commands), _step; !(_step = _iterator()).done;){
            var c = _step.value;
            var args = [];
            for(var i = 0; i < c.args.length; i += 2){
                var _fn = fn(c.args[i], c.args[i + 1]), x = _fn[0], y = _fn[1];
                args.push(x, y);
            }
            path[c.command].apply(path, args);
        }
        return path;
    };
    _proto.transform = function transform(m0, m1, m2, m3, m4, m5) {
        return this.mapPoints(function(x, y) {
            x = m0 * x + m2 * y + m4;
            y = m1 * x + m3 * y + m5;
            return [
                x,
                y
            ];
        });
    };
    _proto.translate = function translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    };
    _proto.rotate = function rotate(angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        return this.transform(cos, sin, -sin, cos, 0, 0);
    };
    _proto.scale = function scale(scaleX, scaleY) {
        if (scaleY === void 0) scaleY = scaleX;
        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
    };
    $3939d1de148b5202$var$_createClass$5(Path, [
        {
            key: "cbox",
            get: function get() {
                if (!this._cbox) {
                    var cbox = new $3939d1de148b5202$var$BBox();
                    for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$l(this.commands), _step2; !(_step2 = _iterator2()).done;){
                        var command = _step2.value;
                        for(var i = 0; i < command.args.length; i += 2)cbox.addPoint(command.args[i], command.args[i + 1]);
                    }
                    this._cbox = Object.freeze(cbox);
                }
                return this._cbox;
            }
        },
        {
            key: "bbox",
            get: function get() {
                if (this._bbox) return this._bbox;
                var bbox = new $3939d1de148b5202$var$BBox();
                var cx = 0, cy = 0;
                var f = function f(t) {
                    return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
                };
                for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$l(this.commands), _step3; !(_step3 = _iterator3()).done;){
                    var c = _step3.value;
                    switch(c.command){
                        case 'moveTo':
                        case 'lineTo':
                            var _c$args = c.args, x = _c$args[0], y = _c$args[1];
                            bbox.addPoint(x, y);
                            cx = x;
                            cy = y;
                            break;
                        case 'quadraticCurveTo':
                        case 'bezierCurveTo':
                            if (c.command === 'quadraticCurveTo') {
                                // http://fontforge.org/bezier.html
                                var _c$args2 = c.args, qp1x = _c$args2[0], qp1y = _c$args2[1], p3x = _c$args2[2], p3y = _c$args2[3];
                                var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                                var cp1y = cy + 2 / 3 * (qp1y - cy);
                                var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                                var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                            } else var _c$args3 = c.args, cp1x = _c$args3[0], cp1y = _c$args3[1], cp2x = _c$args3[2], cp2y = _c$args3[3], p3x = _c$args3[4], p3y = _c$args3[5];
                             // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                            bbox.addPoint(p3x, p3y);
                            var p0 = [
                                cx,
                                cy
                            ];
                            var p1 = [
                                cp1x,
                                cp1y
                            ];
                            var p2 = [
                                cp2x,
                                cp2y
                            ];
                            var p3 = [
                                p3x,
                                p3y
                            ];
                            for(var i = 0; i <= 1; i++){
                                var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                                var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                                c = 3 * p1[i] - 3 * p0[i];
                                if (a === 0) {
                                    if (b === 0) continue;
                                    var t = -c / b;
                                    if (0 < t && t < 1) {
                                        if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                                    }
                                    continue;
                                }
                                var b2ac = Math.pow(b, 2) - 4 * c * a;
                                if (b2ac < 0) continue;
                                var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t1 && t1 < 1) {
                                    if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                                }
                                var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t2 && t2 < 1) {
                                    if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                                }
                            }
                            cx = p3x;
                            cy = p3y;
                            break;
                    }
                }
                return this._bbox = Object.freeze(bbox);
            }
        }
    ]);
    return Path;
}();
var $3939d1de148b5202$var$_loop = function _loop() {
    var command = $3939d1de148b5202$var$_arr[$3939d1de148b5202$var$_i];
    $3939d1de148b5202$var$Path.prototype[command] = function() {
        this._bbox = this._cbox = null;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        this.commands.push({
            command: command,
            args: args
        });
        return this;
    };
};
for(var $3939d1de148b5202$var$_i = 0, $3939d1de148b5202$var$_arr = [
    'moveTo',
    'lineTo',
    'quadraticCurveTo',
    'bezierCurveTo',
    'closePath'
]; $3939d1de148b5202$var$_i < $3939d1de148b5202$var$_arr.length; $3939d1de148b5202$var$_i++)$3939d1de148b5202$var$_loop();
var $3939d1de148b5202$var$StandardNames = [
    '.notdef',
    '.null',
    'nonmarkingreturn',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quotesingle',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'grave',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'Adieresis',
    'Aring',
    'Ccedilla',
    'Eacute',
    'Ntilde',
    'Odieresis',
    'Udieresis',
    'aacute',
    'agrave',
    'acircumflex',
    'adieresis',
    'atilde',
    'aring',
    'ccedilla',
    'eacute',
    'egrave',
    'ecircumflex',
    'edieresis',
    'iacute',
    'igrave',
    'icircumflex',
    'idieresis',
    'ntilde',
    'oacute',
    'ograve',
    'ocircumflex',
    'odieresis',
    'otilde',
    'uacute',
    'ugrave',
    'ucircumflex',
    'udieresis',
    'dagger',
    'degree',
    'cent',
    'sterling',
    'section',
    'bullet',
    'paragraph',
    'germandbls',
    'registered',
    'copyright',
    'trademark',
    'acute',
    'dieresis',
    'notequal',
    'AE',
    'Oslash',
    'infinity',
    'plusminus',
    'lessequal',
    'greaterequal',
    'yen',
    'mu',
    'partialdiff',
    'summation',
    'product',
    'pi',
    'integral',
    'ordfeminine',
    'ordmasculine',
    'Omega',
    'ae',
    'oslash',
    'questiondown',
    'exclamdown',
    'logicalnot',
    'radical',
    'florin',
    'approxequal',
    'Delta',
    'guillemotleft',
    'guillemotright',
    'ellipsis',
    'nonbreakingspace',
    'Agrave',
    'Atilde',
    'Otilde',
    'OE',
    'oe',
    'endash',
    'emdash',
    'quotedblleft',
    'quotedblright',
    'quoteleft',
    'quoteright',
    'divide',
    'lozenge',
    'ydieresis',
    'Ydieresis',
    'fraction',
    'currency',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'daggerdbl',
    'periodcentered',
    'quotesinglbase',
    'quotedblbase',
    'perthousand',
    'Acircumflex',
    'Ecircumflex',
    'Aacute',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Oacute',
    'Ocircumflex',
    'apple',
    'Ograve',
    'Uacute',
    'Ucircumflex',
    'Ugrave',
    'dotlessi',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'Lslash',
    'lslash',
    'Scaron',
    'scaron',
    'Zcaron',
    'zcaron',
    'brokenbar',
    'Eth',
    'eth',
    'Yacute',
    'yacute',
    'Thorn',
    'thorn',
    'minus',
    'multiply',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'onehalf',
    'onequarter',
    'threequarters',
    'franc',
    'Gbreve',
    'gbreve',
    'Idotaccent',
    'Scedilla',
    'scedilla',
    'Cacute',
    'cacute',
    'Ccaron',
    'ccaron',
    'dcroat'
];
var $3939d1de148b5202$var$_class$3;
function $3939d1de148b5202$var$_defineProperties$6(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$6(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$6(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$6(Constructor, staticProps);
    return Constructor;
}
function $3939d1de148b5202$var$_applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
 *
 * You do not create glyph objects directly. They are created by various methods on the font object.
 * There are several subclasses of the base Glyph class internally that may be returned depending
 * on the font format, but they all inherit from this class.
 */ var $3939d1de148b5202$var$Glyph = ($3939d1de148b5202$var$_class$3 = /*#__PURE__*/ function() {
    function Glyph(id, codePoints, font) {
        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
        this._font = font; // TODO: get this info from GDEF if available
        this.isMark = this.codePoints.length > 0 && this.codePoints.every($3939d1de148b5202$var$unicode.isMark);
        this.isLigature = this.codePoints.length > 1;
    }
    var _proto = Glyph.prototype;
    _proto._getPath = function _getPath() {
        return new $3939d1de148b5202$var$Path();
    };
    _proto._getCBox = function _getCBox() {
        return this.path.cbox;
    };
    _proto._getBBox = function _getBBox() {
        return this.path.bbox;
    };
    _proto._getTableMetrics = function _getTableMetrics(table) {
        if (this.id < table.metrics.length) return table.metrics.get(this.id);
        var metric = table.metrics.get(table.metrics.length - 1);
        var res = {
            advance: metric ? metric.advance : 0,
            bearing: table.bearings.get(this.id - table.metrics.length) || 0
        };
        return res;
    };
    _proto._getMetrics = function _getMetrics(cbox) {
        if (this._metrics) return this._metrics;
        var _this$_getTableMetric = this._getTableMetrics(this._font.hmtx), advanceWidth = _this$_getTableMetric.advance, leftBearing = _this$_getTableMetric.bearing; // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
        if (this._font.vmtx) var _this$_getTableMetric2 = this._getTableMetrics(this._font.vmtx), advanceHeight = _this$_getTableMetric2.advance, topBearing = _this$_getTableMetric2.bearing;
        else {
            var os2;
            if (typeof cbox === 'undefined' || cbox === null) cbox = this.cbox;
            if ((os2 = this._font['OS/2']) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
            } else {
                var hhea = this._font.hhea;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
            }
        }
        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
        return this._metrics = {
            advanceWidth: advanceWidth,
            advanceHeight: advanceHeight,
            leftBearing: leftBearing,
            topBearing: topBearing
        };
    };
    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ _proto.getScaledPath = function getScaledPath(size) {
        var scale = 1 / this._font.unitsPerEm * size;
        return this.path.scale(scale);
    };
    _proto._getName = function _getName() {
        var post = this._font.post;
        if (!post) return null;
        switch(post.version){
            case 1:
                return $3939d1de148b5202$var$StandardNames[this.id];
            case 2:
                var id = post.glyphNameIndex[this.id];
                if (id < $3939d1de148b5202$var$StandardNames.length) return $3939d1de148b5202$var$StandardNames[id];
                return post.names[id - $3939d1de148b5202$var$StandardNames.length];
            case 2.5:
                return $3939d1de148b5202$var$StandardNames[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
        }
    };
    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ _proto.render = function render(ctx, size) {
        ctx.save();
        var scale = 1 / this._font.head.unitsPerEm * size;
        ctx.scale(scale, scale);
        var fn = this.path.toFunction();
        fn(ctx);
        ctx.fill();
        ctx.restore();
    };
    $3939d1de148b5202$var$_createClass$6(Glyph, [
        {
            key: "cbox",
            get: function get() {
                return this._getCBox();
            }
        },
        {
            key: "bbox",
            get: function get() {
                return this._getBBox();
            }
        },
        {
            key: "path",
            get: function get() {
                // Cache the path so we only decode it once
                // Decoding is actually performed by subclasses
                return this._getPath();
            }
        },
        {
            key: "advanceWidth",
            get: function get() {
                return this._getMetrics().advanceWidth;
            }
        },
        {
            key: "advanceHeight",
            get: function get() {
                return this._getMetrics().advanceHeight;
            }
        },
        {
            key: "ligatureCaretPositions",
            get: function get() {}
        },
        {
            key: "name",
            get: function get() {
                return this._getName();
            }
        }
    ]);
    return Glyph;
}(), $3939d1de148b5202$var$_applyDecoratedDescriptor$3($3939d1de148b5202$var$_class$3.prototype, "cbox", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$3.prototype, "cbox"), $3939d1de148b5202$var$_class$3.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$3($3939d1de148b5202$var$_class$3.prototype, "bbox", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$3.prototype, "bbox"), $3939d1de148b5202$var$_class$3.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$3($3939d1de148b5202$var$_class$3.prototype, "path", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$3.prototype, "path"), $3939d1de148b5202$var$_class$3.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$3($3939d1de148b5202$var$_class$3.prototype, "advanceWidth", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$3.prototype, "advanceWidth"), $3939d1de148b5202$var$_class$3.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$3($3939d1de148b5202$var$_class$3.prototype, "advanceHeight", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$3.prototype, "advanceHeight"), $3939d1de148b5202$var$_class$3.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$3($3939d1de148b5202$var$_class$3.prototype, "name", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$3.prototype, "name"), $3939d1de148b5202$var$_class$3.prototype), $3939d1de148b5202$var$_class$3);
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$m(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$m(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$m(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$m(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$m(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$m(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_inheritsLoose$9(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$GlyfHeader = new $3939d1de148b5202$var$restructure.Struct({
    numberOfContours: $3939d1de148b5202$var$restructure.int16,
    // if negative, this is a composite glyph
    xMin: $3939d1de148b5202$var$restructure.int16,
    yMin: $3939d1de148b5202$var$restructure.int16,
    xMax: $3939d1de148b5202$var$restructure.int16,
    yMax: $3939d1de148b5202$var$restructure.int16
}); // Flags for simple glyphs
var $3939d1de148b5202$var$ON_CURVE = 1;
var $3939d1de148b5202$var$X_SHORT_VECTOR = 2;
var $3939d1de148b5202$var$Y_SHORT_VECTOR = 4;
var $3939d1de148b5202$var$REPEAT = 8;
var $3939d1de148b5202$var$SAME_X = 16;
var $3939d1de148b5202$var$SAME_Y = 32; // Flags for composite glyphs
var $3939d1de148b5202$var$ARG_1_AND_2_ARE_WORDS = 1;
var $3939d1de148b5202$var$WE_HAVE_A_SCALE = 8;
var $3939d1de148b5202$var$MORE_COMPONENTS = 32;
var $3939d1de148b5202$var$WE_HAVE_AN_X_AND_Y_SCALE = 64;
var $3939d1de148b5202$var$WE_HAVE_A_TWO_BY_TWO = 128;
var $3939d1de148b5202$var$WE_HAVE_INSTRUCTIONS = 256;
var $3939d1de148b5202$var$Point = /*#__PURE__*/ function() {
    function Point(onCurve, endContour, x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        this.onCurve = onCurve;
        this.endContour = endContour;
        this.x = x;
        this.y = y;
    }
    var _proto = Point.prototype;
    _proto.copy = function copy() {
        return new Point(this.onCurve, this.endContour, this.x, this.y);
    };
    return Point;
}(); // Represents a component in a composite glyph
var $3939d1de148b5202$var$Component = function Component(glyphID, dx, dy) {
    this.glyphID = glyphID;
    this.dx = dx;
    this.dy = dy;
    this.pos = 0;
    this.scaleX = this.scaleY = 1;
    this.scale01 = this.scale10 = 0;
};
/**
 * Represents a TrueType glyph.
 */ var $3939d1de148b5202$var$TTFGlyph = /*#__PURE__*/ function(_Glyph) {
    $3939d1de148b5202$var$_inheritsLoose$9(TTFGlyph, _Glyph);
    function TTFGlyph() {
        return _Glyph.apply(this, arguments) || this;
    }
    var _proto2 = TTFGlyph.prototype;
    // Parses just the glyph header and returns the bounding box
    _proto2._getCBox = function _getCBox(internal) {
        // We need to decode the glyph if variation processing is requested,
        // so it's easier just to recompute the path's cbox after decoding.
        if (this._font._variationProcessor && !internal) return this.path.cbox;
        var stream = this._font._getTableStream('glyf');
        stream.pos += this._font.loca.offsets[this.id];
        var glyph = $3939d1de148b5202$var$GlyfHeader.decode(stream);
        var cbox = new $3939d1de148b5202$var$BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
        return Object.freeze(cbox);
    } // Parses a single glyph coordinate
    ;
    _proto2._parseGlyphCoord = function _parseGlyphCoord(stream, prev, _short, same) {
        if (_short) {
            var val = stream.readUInt8();
            if (!same) val = -val;
            val += prev;
        } else if (same) var val = prev;
        else var val = prev + stream.readInt16BE();
        return val;
    } // Decodes the glyph data into points for simple glyphs,
    ;
    _proto2._decode = function _decode() {
        var glyfPos = this._font.loca.offsets[this.id];
        var nextPos = this._font.loca.offsets[this.id + 1]; // Nothing to do if there is no data for this glyph
        if (glyfPos === nextPos) return null;
        var stream = this._font._getTableStream('glyf');
        stream.pos += glyfPos;
        var startPos = stream.pos;
        var glyph = $3939d1de148b5202$var$GlyfHeader.decode(stream);
        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
        return glyph;
    };
    _proto2._decodeSimple = function _decodeSimple(glyph, stream) {
        // this is a simple glyph
        glyph.points = [];
        var endPtsOfContours = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, glyph.numberOfContours).decode(stream);
        glyph.instructions = new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, $3939d1de148b5202$var$restructure.uint16).decode(stream);
        var flags = [];
        var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
        while(flags.length < numCoords){
            var flag = stream.readUInt8();
            flags.push(flag); // check for repeat flag
            if (flag & $3939d1de148b5202$var$REPEAT) {
                var count = stream.readUInt8();
                for(var j = 0; j < count; j++)flags.push(flag);
            }
        }
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            var point = new $3939d1de148b5202$var$Point(!!(flag & $3939d1de148b5202$var$ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
            glyph.points.push(point);
        }
        var px = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & $3939d1de148b5202$var$X_SHORT_VECTOR, flag & $3939d1de148b5202$var$SAME_X);
        }
        var py = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & $3939d1de148b5202$var$Y_SHORT_VECTOR, flag & $3939d1de148b5202$var$SAME_Y);
        }
        if (this._font._variationProcessor) {
            var points = glyph.points.slice();
            points.push.apply(points, this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.slice(-4);
        }
        return;
    };
    _proto2._decodeComposite = function _decodeComposite(glyph, stream, offset) {
        if (offset === void 0) offset = 0;
        // this is a composite glyph
        glyph.components = [];
        var haveInstructions = false;
        var flags = $3939d1de148b5202$var$MORE_COMPONENTS;
        while(flags & $3939d1de148b5202$var$MORE_COMPONENTS){
            flags = stream.readUInt16BE();
            var gPos = stream.pos - offset;
            var glyphID = stream.readUInt16BE();
            if (!haveInstructions) haveInstructions = (flags & $3939d1de148b5202$var$WE_HAVE_INSTRUCTIONS) !== 0;
            if (flags & $3939d1de148b5202$var$ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
            } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
            }
            var component = new $3939d1de148b5202$var$Component(glyphID, dx, dy);
            component.pos = gPos;
            if (flags & $3939d1de148b5202$var$WE_HAVE_A_SCALE) // fixed number with 14 bits of fraction
            component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            else if (flags & $3939d1de148b5202$var$WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            } else if (flags & $3939d1de148b5202$var$WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            }
            glyph.components.push(component);
        }
        if (this._font._variationProcessor) {
            var points = [];
            for(var j = 0; j < glyph.components.length; j++){
                var component = glyph.components[j];
                points.push(new $3939d1de148b5202$var$Point(true, true, component.dx, component.dy));
            }
            points.push.apply(points, this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.splice(-4, 4);
            for(var i = 0; i < points.length; i++){
                var point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
            }
        }
        return haveInstructions;
    };
    _proto2._getPhantomPoints = function _getPhantomPoints(glyph) {
        var cbox = this._getCBox(true);
        if (this._metrics == null) this._metrics = $3939d1de148b5202$var$Glyph.prototype._getMetrics.call(this, cbox);
        var _this$_metrics = this._metrics, advanceWidth = _this$_metrics.advanceWidth, advanceHeight = _this$_metrics.advanceHeight, leftBearing = _this$_metrics.leftBearing, topBearing = _this$_metrics.topBearing;
        return [
            new $3939d1de148b5202$var$Point(false, true, glyph.xMin - leftBearing, 0),
            new $3939d1de148b5202$var$Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
            new $3939d1de148b5202$var$Point(false, true, 0, glyph.yMax + topBearing),
            new $3939d1de148b5202$var$Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)
        ];
    } // Decodes font data, resolves composite glyphs, and returns an array of contours
    ;
    _proto2._getContours = function _getContours() {
        var glyph = this._decode();
        if (!glyph) return [];
        var points = [];
        if (glyph.numberOfContours < 0) // resolve composite glyphs
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$m(glyph.components), _step; !(_step = _iterator()).done;){
            var component = _step.value;
            var _contours = this._font.getGlyph(component.glyphID)._getContours();
            for(var i = 0; i < _contours.length; i++){
                var contour = _contours[i];
                for(var j = 0; j < contour.length; j++){
                    var _point = contour[j];
                    var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
                    var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
                    points.push(new $3939d1de148b5202$var$Point(_point.onCurve, _point.endContour, x, y));
                }
            }
        }
        else points = glyph.points || [];
         // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
        }
        var contours = [];
        var cur = [];
        for(var k = 0; k < points.length; k++){
            var point = points[k];
            cur.push(point);
            if (point.endContour) {
                contours.push(cur);
                cur = [];
            }
        }
        return contours;
    };
    _proto2._getMetrics = function _getMetrics() {
        if (this._metrics) return this._metrics;
        var cbox = this._getCBox(true);
        _Glyph.prototype._getMetrics.call(this, cbox);
        if (this._font._variationProcessor && !this._font.HVAR) // No HVAR table, decode the glyph. This triggers recomputation of metrics.
        this.path;
        return this._metrics;
    } // Converts contours to a Path object that can be rendered
    ;
    _proto2._getPath = function _getPath() {
        var contours = this._getContours();
        var path = new $3939d1de148b5202$var$Path();
        for(var i = 0; i < contours.length; i++){
            var contour = contours[i];
            var firstPt = contour[0];
            var lastPt = contour[contour.length - 1];
            var start = 0;
            if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
            } else {
                if (lastPt.onCurve) // Start at the last point if the first point is off curve and the last point is on curve
                firstPt = lastPt;
                else // Start at the middle if both the first and last points are off curve
                firstPt = new $3939d1de148b5202$var$Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                var curvePt = firstPt;
            }
            path.moveTo(firstPt.x, firstPt.y);
            for(var j = start; j < contour.length; j++){
                var pt = contour[j];
                var prevPt = j === 0 ? firstPt : contour[j - 1];
                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                else if (!prevPt.onCurve && !pt.onCurve) {
                    var midX = (prevPt.x + pt.x) / 2;
                    var midY = (prevPt.y + pt.y) / 2;
                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                    var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                    var curvePt = null;
                } else throw new Error("Unknown TTF path state");
            } // Connect the first and last points
            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            path.closePath();
        }
        return path;
    };
    return TTFGlyph;
}($3939d1de148b5202$var$Glyph);
function $3939d1de148b5202$var$_inheritsLoose$a(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * Represents an OpenType PostScript glyph, in the Compact Font Format.
 */ var $3939d1de148b5202$var$CFFGlyph = /*#__PURE__*/ function(_Glyph) {
    $3939d1de148b5202$var$_inheritsLoose$a(CFFGlyph, _Glyph);
    function CFFGlyph() {
        return _Glyph.apply(this, arguments) || this;
    }
    var _proto = CFFGlyph.prototype;
    _proto._getName = function _getName() {
        if (this._font.CFF2) return _Glyph.prototype._getName.call(this);
        return this._font['CFF '].getGlyphName(this.id);
    };
    _proto.bias = function bias(s) {
        if (s.length < 1240) return 107;
        else if (s.length < 33900) return 1131;
        else return 32768;
    };
    _proto._getPath = function _getPath() {
        var stream = this._font.stream;
        var pos = stream.pos;
        var cff = this._font.CFF2 || this._font['CFF '];
        var str = cff.topDict.CharStrings[this.id];
        var end = str.offset + str.length;
        stream.pos = str.offset;
        var path = new $3939d1de148b5202$var$Path();
        var stack = [];
        var trans = [];
        var width = null;
        var nStems = 0;
        var x = 0, y = 0;
        var usedGsubrs;
        var usedSubrs;
        var open = false;
        this._usedGsubrs = usedGsubrs = {};
        this._usedSubrs = usedSubrs = {};
        var gsubrs = cff.globalSubrIndex || [];
        var gsubrsBias = this.bias(gsubrs);
        var privateDict = cff.privateDictForGlyph(this.id);
        var subrs = privateDict.Subrs || [];
        var subrsBias = this.bias(subrs);
        var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
        var vsindex = privateDict.vsindex;
        var variationProcessor = this._font._variationProcessor;
        function checkWidth() {
            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
        }
        function parseStems() {
            if (stack.length % 2 !== 0) checkWidth();
            nStems += stack.length >> 1;
            return stack.length = 0;
        }
        function moveTo(x, y) {
            if (open) path.closePath();
            path.moveTo(x, y);
            open = true;
        }
        var parse = function parse() {
            while(stream.pos < end){
                var op = stream.readUInt8();
                if (op < 32) switch(op){
                    case 1:
                    case 3:
                    case 18:
                    case 23:
                        // vstemhm
                        parseStems();
                        break;
                    case 4:
                        // vmoveto
                        if (stack.length > 1) checkWidth();
                        y += stack.shift();
                        moveTo(x, y);
                        break;
                    case 5:
                        // rlineto
                        while(stack.length >= 2){
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                        }
                        break;
                    case 6:
                    case 7:
                        // vlineto
                        var phase = op === 6;
                        while(stack.length >= 1){
                            if (phase) x += stack.shift();
                            else y += stack.shift();
                            path.lineTo(x, y);
                            phase = !phase;
                        }
                        break;
                    case 8:
                        // rrcurveto
                        while(stack.length > 0){
                            var c1x = x + stack.shift();
                            var c1y = y + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 10:
                        // callsubr
                        var index = stack.pop() + subrsBias;
                        var subr = subrs[index];
                        if (subr) {
                            usedSubrs[index] = true;
                            var p = stream.pos;
                            var e = end;
                            stream.pos = subr.offset;
                            end = subr.offset + subr.length;
                            parse();
                            stream.pos = p;
                            end = e;
                        }
                        break;
                    case 11:
                        // return
                        if (cff.version >= 2) break;
                        return;
                    case 14:
                        // endchar
                        if (cff.version >= 2) break;
                        if (stack.length > 0) checkWidth();
                        if (open) {
                            path.closePath();
                            open = false;
                        }
                        break;
                    case 15:
                        // vsindex
                        if (cff.version < 2) throw new Error('vsindex operator not supported in CFF v1');
                        vsindex = stack.pop();
                        break;
                    case 16:
                        // blend
                        if (cff.version < 2) throw new Error('blend operator not supported in CFF v1');
                        if (!variationProcessor) throw new Error('blend operator in non-variation font');
                        var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                        var numBlends = stack.pop();
                        var numOperands = numBlends * blendVector.length;
                        var delta = stack.length - numOperands;
                        var base = delta - numBlends;
                        for(var i = 0; i < numBlends; i++){
                            var sum = stack[base + i];
                            for(var j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                            stack[base + i] = sum;
                        }
                        while(numOperands--)stack.pop();
                        break;
                    case 19:
                    case 20:
                        // cntrmask
                        parseStems();
                        stream.pos += nStems + 7 >> 3;
                        break;
                    case 21:
                        // rmoveto
                        if (stack.length > 2) checkWidth();
                        x += stack.shift();
                        y += stack.shift();
                        moveTo(x, y);
                        break;
                    case 22:
                        // hmoveto
                        if (stack.length > 1) checkWidth();
                        x += stack.shift();
                        moveTo(x, y);
                        break;
                    case 24:
                        // rcurveline
                        while(stack.length >= 8){
                            var c1x = x + stack.shift();
                            var c1y = y + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        x += stack.shift();
                        y += stack.shift();
                        path.lineTo(x, y);
                        break;
                    case 25:
                        // rlinecurve
                        while(stack.length >= 8){
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                        }
                        var c1x = x + stack.shift();
                        var c1y = y + stack.shift();
                        var c2x = c1x + stack.shift();
                        var c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        break;
                    case 26:
                        // vvcurveto
                        if (stack.length % 2) x += stack.shift();
                        while(stack.length >= 4){
                            c1x = x;
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x;
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 27:
                        // hhcurveto
                        if (stack.length % 2) y += stack.shift();
                        while(stack.length >= 4){
                            c1x = x + stack.shift();
                            c1y = y;
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y;
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 28:
                        // shortint
                        stack.push(stream.readInt16BE());
                        break;
                    case 29:
                        // callgsubr
                        index = stack.pop() + gsubrsBias;
                        subr = gsubrs[index];
                        if (subr) {
                            usedGsubrs[index] = true;
                            var p = stream.pos;
                            var e = end;
                            stream.pos = subr.offset;
                            end = subr.offset + subr.length;
                            parse();
                            stream.pos = p;
                            end = e;
                        }
                        break;
                    case 30:
                    case 31:
                        // hvcurveto
                        phase = op === 31;
                        while(stack.length >= 4){
                            if (phase) {
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                y = c2y + stack.shift();
                                x = c2x + (stack.length === 1 ? stack.shift() : 0);
                            } else {
                                c1x = x;
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + (stack.length === 1 ? stack.shift() : 0);
                            }
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            phase = !phase;
                        }
                        break;
                    case 12:
                        op = stream.readUInt8();
                        switch(op){
                            case 3:
                                // and
                                var a = stack.pop();
                                var b = stack.pop();
                                stack.push(a && b ? 1 : 0);
                                break;
                            case 4:
                                // or
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a || b ? 1 : 0);
                                break;
                            case 5:
                                // not
                                a = stack.pop();
                                stack.push(a ? 0 : 1);
                                break;
                            case 9:
                                // abs
                                a = stack.pop();
                                stack.push(Math.abs(a));
                                break;
                            case 10:
                                // add
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a + b);
                                break;
                            case 11:
                                // sub
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a - b);
                                break;
                            case 12:
                                // div
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a / b);
                                break;
                            case 14:
                                // neg
                                a = stack.pop();
                                stack.push(-a);
                                break;
                            case 15:
                                // eq
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a === b ? 1 : 0);
                                break;
                            case 18:
                                // drop
                                stack.pop();
                                break;
                            case 20:
                                // put
                                var val = stack.pop();
                                var idx = stack.pop();
                                trans[idx] = val;
                                break;
                            case 21:
                                // get
                                idx = stack.pop();
                                stack.push(trans[idx] || 0);
                                break;
                            case 22:
                                // ifelse
                                var s1 = stack.pop();
                                var s2 = stack.pop();
                                var v1 = stack.pop();
                                var v2 = stack.pop();
                                stack.push(v1 <= v2 ? s1 : s2);
                                break;
                            case 23:
                                // random
                                stack.push(Math.random());
                                break;
                            case 24:
                                // mul
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a * b);
                                break;
                            case 26:
                                // sqrt
                                a = stack.pop();
                                stack.push(Math.sqrt(a));
                                break;
                            case 27:
                                // dup
                                a = stack.pop();
                                stack.push(a, a);
                                break;
                            case 28:
                                // exch
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(b, a);
                                break;
                            case 29:
                                // index
                                idx = stack.pop();
                                if (idx < 0) idx = 0;
                                else if (idx > stack.length - 1) idx = stack.length - 1;
                                stack.push(stack[idx]);
                                break;
                            case 30:
                                // roll
                                var n = stack.pop();
                                var _j = stack.pop();
                                if (_j >= 0) while(_j > 0){
                                    var t = stack[n - 1];
                                    for(var _i = n - 2; _i >= 0; _i--)stack[_i + 1] = stack[_i];
                                    stack[0] = t;
                                    _j--;
                                }
                                else while(_j < 0){
                                    var t = stack[0];
                                    for(var _i2 = 0; _i2 <= n; _i2++)stack[_i2] = stack[_i2 + 1];
                                    stack[n - 1] = t;
                                    _j++;
                                }
                                break;
                            case 34:
                                // hflex
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                var c3x = c2x + stack.shift();
                                var c3y = c2y;
                                var c4x = c3x + stack.shift();
                                var c4y = c3y;
                                var c5x = c4x + stack.shift();
                                var c5y = c4y;
                                var c6x = c5x + stack.shift();
                                var c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 35:
                                // flex
                                var pts = [];
                                for(var _i3 = 0; _i3 <= 5; _i3++){
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                stack.shift(); // fd
                                break;
                            case 36:
                                // hflex1
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                c3x = c2x + stack.shift();
                                c3y = c2y;
                                c4x = c3x + stack.shift();
                                c4y = c3y;
                                c5x = c4x + stack.shift();
                                c5y = c4y + stack.shift();
                                c6x = c5x + stack.shift();
                                c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 37:
                                // flex1
                                var startx = x;
                                var starty = y;
                                pts = [];
                                for(var _i4 = 0; _i4 <= 4; _i4++){
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                    // horizontal
                                    x += stack.shift();
                                    y = starty;
                                } else {
                                    x = startx;
                                    y += stack.shift();
                                }
                                pts.push(x, y);
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                break;
                            default:
                                throw new Error("Unknown op: 12 " + op);
                        }
                        break;
                    default:
                        throw new Error("Unknown op: " + op);
                }
                else if (op < 247) stack.push(op - 139);
                else if (op < 251) {
                    var b1 = stream.readUInt8();
                    stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                    var b1 = stream.readUInt8();
                    stack.push(-(op - 251) * 256 - b1 - 108);
                } else stack.push(stream.readInt32BE() / 65536);
            }
        };
        parse();
        if (open) path.closePath();
        return path;
    };
    return CFFGlyph;
}($3939d1de148b5202$var$Glyph);
function $3939d1de148b5202$var$_inheritsLoose$b(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$SBIXImage = new $3939d1de148b5202$var$restructure.Struct({
    originX: $3939d1de148b5202$var$restructure.uint16,
    originY: $3939d1de148b5202$var$restructure.uint16,
    type: new $3939d1de148b5202$var$restructure.String(4),
    data: new $3939d1de148b5202$var$restructure.Buffer(function(t) {
        return t.parent.buflen - t._currentOffset;
    })
});
/**
 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
 */ var $3939d1de148b5202$var$SBIXGlyph = /*#__PURE__*/ function(_TTFGlyph) {
    $3939d1de148b5202$var$_inheritsLoose$b(SBIXGlyph, _TTFGlyph);
    function SBIXGlyph() {
        return _TTFGlyph.apply(this, arguments) || this;
    }
    var _proto = SBIXGlyph.prototype;
    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ _proto.getImageForSize = function getImageForSize(size) {
        for(var i = 0; i < this._font.sbix.imageTables.length; i++){
            var table = this._font.sbix.imageTables[i];
            if (table.ppem >= size) break;
        }
        var offsets = table.imageOffsets;
        var start = offsets[this.id];
        var end = offsets[this.id + 1];
        if (start === end) return null;
        this._font.stream.pos = start;
        return $3939d1de148b5202$var$SBIXImage.decode(this._font.stream, {
            buflen: end - start
        });
    };
    _proto.render = function render(ctx, size) {
        var img = this.getImageForSize(size);
        if (img != null) {
            var scale = size / this._font.unitsPerEm;
            ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale
            });
        }
        if (this._font.sbix.flags.renderOutlines) _TTFGlyph.prototype.render.call(this, ctx, size);
    };
    return SBIXGlyph;
}($3939d1de148b5202$var$TTFGlyph);
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$n(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$n(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$n(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$n(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$n(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$n(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_defineProperties$7(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$7(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$7(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$7(Constructor, staticProps);
    return Constructor;
}
function $3939d1de148b5202$var$_inheritsLoose$c(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$COLRLayer = function COLRLayer(glyph, color) {
    this.glyph = glyph;
    this.color = color;
};
/**
 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
 * Each glyph in this format contain a list of colored layers, each
 * of which  is another vector glyph.
 */ var $3939d1de148b5202$var$COLRGlyph = /*#__PURE__*/ function(_Glyph) {
    $3939d1de148b5202$var$_inheritsLoose$c(COLRGlyph, _Glyph);
    function COLRGlyph() {
        return _Glyph.apply(this, arguments) || this;
    }
    var _proto = COLRGlyph.prototype;
    _proto._getBBox = function _getBBox() {
        var bbox = new $3939d1de148b5202$var$BBox();
        for(var i = 0; i < this.layers.length; i++){
            var layer = this.layers[i];
            var b = layer.glyph.bbox;
            bbox.addPoint(b.minX, b.minY);
            bbox.addPoint(b.maxX, b.maxY);
        }
        return bbox;
    };
    _proto.render = function render(ctx, size) {
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$n(this.layers), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, glyph = _step$value.glyph, color = _step$value.color;
            ctx.fillColor([
                color.red,
                color.green,
                color.blue
            ], color.alpha / 255 * 100);
            glyph.render(ctx, size);
        }
        return;
    };
    $3939d1de148b5202$var$_createClass$7(COLRGlyph, [
        {
            key: "layers",
            get: function get() {
                var cpal = this._font.CPAL;
                var colr = this._font.COLR;
                var low = 0;
                var high = colr.baseGlyphRecord.length - 1;
                while(low <= high){
                    var mid = low + high >> 1;
                    var rec = colr.baseGlyphRecord[mid];
                    if (this.id < rec.gid) high = mid - 1;
                    else if (this.id > rec.gid) low = mid + 1;
                    else {
                        var baseLayer = rec;
                        break;
                    }
                } // if base glyph not found in COLR table,
                // default to normal glyph from glyf or CFF
                if (baseLayer == null) {
                    var g = this._font._getBaseGlyph(this.id);
                    var color = {
                        red: 0,
                        green: 0,
                        blue: 0,
                        alpha: 255
                    };
                    return [
                        new $3939d1de148b5202$var$COLRLayer(g, color)
                    ];
                } // otherwise, return an array of all the layers
                var layers = [];
                for(var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
                    var rec = colr.layerRecords[i];
                    var color = cpal.colorRecords[rec.paletteIndex];
                    var g = this._font._getBaseGlyph(rec.gid);
                    layers.push(new $3939d1de148b5202$var$COLRLayer(g, color));
                }
                return layers;
            }
        }
    ]);
    return COLRGlyph;
}($3939d1de148b5202$var$Glyph);
var $3939d1de148b5202$var$TUPLES_SHARE_POINT_NUMBERS = 0x8000;
var $3939d1de148b5202$var$TUPLE_COUNT_MASK = 0x0fff;
var $3939d1de148b5202$var$EMBEDDED_TUPLE_COORD = 0x8000;
var $3939d1de148b5202$var$INTERMEDIATE_TUPLE = 0x4000;
var $3939d1de148b5202$var$PRIVATE_POINT_NUMBERS = 0x2000;
var $3939d1de148b5202$var$TUPLE_INDEX_MASK = 0x0fff;
var $3939d1de148b5202$var$POINTS_ARE_WORDS = 0x80;
var $3939d1de148b5202$var$POINT_RUN_COUNT_MASK = 0x7f;
var $3939d1de148b5202$var$DELTAS_ARE_ZERO = 0x80;
var $3939d1de148b5202$var$DELTAS_ARE_WORDS = 0x40;
var $3939d1de148b5202$var$DELTA_RUN_COUNT_MASK = 0x3f;
/**
 * This class is transforms TrueType glyphs according to the data from
 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
 * These tables allow infinite adjustments to glyph weight, width, slant,
 * and optical size without the designer needing to specify every exact style.
 *
 * Apple's documentation for these tables is not great, so thanks to the
 * Freetype project for figuring much of this out.
 *
 * @private
 */ var $3939d1de148b5202$var$GlyphVariationProcessor = /*#__PURE__*/ function() {
    function GlyphVariationProcessor(font, coords) {
        this.font = font;
        this.normalizedCoords = this.normalizeCoords(coords);
        this.blendVectors = new Map();
    }
    var _proto = GlyphVariationProcessor.prototype;
    _proto.normalizeCoords = function normalizeCoords(coords) {
        // the default mapping is linear along each axis, in two segments:
        // from the minValue to defaultValue, and from defaultValue to maxValue.
        var normalized = [];
        for(var i = 0; i < this.font.fvar.axis.length; i++){
            var axis = this.font.fvar.axis[i];
            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
        } // if there is an avar table, the normalized value is calculated
        // by interpolating between the two nearest mapped values.
        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
            var segment = this.font.avar.segment[i];
            for(var j = 0; j < segment.correspondence.length; j++){
                var pair = segment.correspondence[j];
                if (j >= 1 && normalized[i] < pair.fromCoord) {
                    var prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                }
            }
        }
        return normalized;
    };
    _proto.transformPoints = function transformPoints(gid, glyphPoints) {
        if (!this.font.fvar || !this.font.gvar) return;
        var gvar = this.font.gvar;
        if (gid >= gvar.glyphCount) return;
        var offset = gvar.offsets[gid];
        if (offset === gvar.offsets[gid + 1]) return;
         // Read the gvar data for this glyph
        var stream = this.font.stream;
        stream.pos = offset;
        if (stream.pos >= stream.length) return;
        var tupleCount = stream.readUInt16BE();
        var offsetToData = offset + stream.readUInt16BE();
        if (tupleCount & $3939d1de148b5202$var$TUPLES_SHARE_POINT_NUMBERS) {
            var here = stream.pos;
            stream.pos = offsetToData;
            var sharedPoints = this.decodePoints();
            offsetToData = stream.pos;
            stream.pos = here;
        }
        var origPoints = glyphPoints.map(function(pt) {
            return pt.copy();
        });
        tupleCount &= $3939d1de148b5202$var$TUPLE_COUNT_MASK;
        for(var i = 0; i < tupleCount; i++){
            var tupleDataSize = stream.readUInt16BE();
            var tupleIndex = stream.readUInt16BE();
            if (tupleIndex & $3939d1de148b5202$var$EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];
                for(var a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
            } else {
                if ((tupleIndex & $3939d1de148b5202$var$TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error('Invalid gvar table');
                var tupleCoords = gvar.globalCoords[tupleIndex & $3939d1de148b5202$var$TUPLE_INDEX_MASK];
            }
            if (tupleIndex & $3939d1de148b5202$var$INTERMEDIATE_TUPLE) {
                var startCoords = [];
                for(var _a = 0; _a < gvar.axisCount; _a++)startCoords.push(stream.readInt16BE() / 16384);
                var endCoords = [];
                for(var _a2 = 0; _a2 < gvar.axisCount; _a2++)endCoords.push(stream.readInt16BE() / 16384);
            } // Get the factor at which to apply this tuple
            var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
            if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
            }
            var here = stream.pos;
            stream.pos = offsetToData;
            if (tupleIndex & $3939d1de148b5202$var$PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
            else var points = sharedPoints;
             // points.length = 0 means there are deltas for all points
            var nPoints = points.length === 0 ? glyphPoints.length : points.length;
            var xDeltas = this.decodeDeltas(nPoints);
            var yDeltas = this.decodeDeltas(nPoints);
            if (points.length === 0) // all points
            for(var _i = 0; _i < glyphPoints.length; _i++){
                var point = glyphPoints[_i];
                point.x += Math.round(xDeltas[_i] * factor);
                point.y += Math.round(yDeltas[_i] * factor);
            }
            else {
                var outPoints = origPoints.map(function(pt) {
                    return pt.copy();
                });
                var hasDelta = glyphPoints.map(function() {
                    return false;
                });
                for(var _i2 = 0; _i2 < points.length; _i2++){
                    var idx = points[_i2];
                    if (idx < glyphPoints.length) {
                        var _point = outPoints[idx];
                        hasDelta[idx] = true;
                        _point.x += Math.round(xDeltas[_i2] * factor);
                        _point.y += Math.round(yDeltas[_i2] * factor);
                    }
                }
                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                for(var _i3 = 0; _i3 < glyphPoints.length; _i3++){
                    var deltaX = outPoints[_i3].x - origPoints[_i3].x;
                    var deltaY = outPoints[_i3].y - origPoints[_i3].y;
                    glyphPoints[_i3].x += deltaX;
                    glyphPoints[_i3].y += deltaY;
                }
            }
            offsetToData += tupleDataSize;
            stream.pos = here;
        }
    };
    _proto.decodePoints = function decodePoints() {
        var stream = this.font.stream;
        var count = stream.readUInt8();
        if (count & $3939d1de148b5202$var$POINTS_ARE_WORDS) count = (count & $3939d1de148b5202$var$POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
        var points = new Uint16Array(count);
        var i = 0;
        var point = 0;
        while(i < count){
            var run = stream.readUInt8();
            var runCount = (run & $3939d1de148b5202$var$POINT_RUN_COUNT_MASK) + 1;
            var fn = run & $3939d1de148b5202$var$POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
            for(var j = 0; j < runCount && i < count; j++){
                point += fn.call(stream);
                points[i++] = point;
            }
        }
        return points;
    };
    _proto.decodeDeltas = function decodeDeltas(count) {
        var stream = this.font.stream;
        var i = 0;
        var deltas = new Int16Array(count);
        while(i < count){
            var run = stream.readUInt8();
            var runCount = (run & $3939d1de148b5202$var$DELTA_RUN_COUNT_MASK) + 1;
            if (run & $3939d1de148b5202$var$DELTAS_ARE_ZERO) i += runCount;
            else {
                var fn = run & $3939d1de148b5202$var$DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                for(var j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
            }
        }
        return deltas;
    };
    _proto.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
        var normalized = this.normalizedCoords;
        var gvar = this.font.gvar;
        var factor = 1;
        for(var i = 0; i < gvar.axisCount; i++){
            if (tupleCoords[i] === 0) continue;
            if (normalized[i] === 0) return 0;
            if ((tupleIndex & $3939d1de148b5202$var$INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
            } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
            }
        }
        return factor;
    } // Interpolates points without delta values.
    ;
    _proto.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
        if (points.length === 0) return;
        var point = 0;
        while(point < points.length){
            var firstPoint = point; // find the end point of the contour
            var endPoint = point;
            var pt = points[endPoint];
            while(!pt.endContour)pt = points[++endPoint];
             // find the first point that has a delta
            while(point <= endPoint && !hasDelta[point])point++;
            if (point > endPoint) continue;
            var firstDelta = point;
            var curDelta = point;
            point++;
            while(point <= endPoint){
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                    curDelta = point;
                }
                point++;
            } // shift contour if we only have a single delta
            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
            else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
            }
            point = endPoint + 1;
        }
    };
    _proto.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
        if (p1 > p2) return;
        var iterable = [
            'x',
            'y'
        ];
        for(var i = 0; i < iterable.length; i++){
            var k = iterable[i];
            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                var p = ref1;
                ref1 = ref2;
                ref2 = p;
            }
            var in1 = inPoints[ref1][k];
            var in2 = inPoints[ref2][k];
            var out1 = outPoints[ref1][k];
            var out2 = outPoints[ref2][k]; // If the reference points have the same coordinate but different
            // delta, inferred delta is zero.  Otherwise interpolate.
            if (in1 !== in2 || out1 === out2) {
                var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                for(var _p = p1; _p <= p2; _p++){
                    var out = inPoints[_p][k];
                    if (out <= in1) out += out1 - in1;
                    else if (out >= in2) out += out2 - in2;
                    else out = out1 + (out - in1) * scale;
                    outPoints[_p][k] = out;
                }
            }
        }
    };
    _proto.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
        var deltaX = outPoints[ref].x - inPoints[ref].x;
        var deltaY = outPoints[ref].y - inPoints[ref].y;
        if (deltaX === 0 && deltaY === 0) return;
        for(var p = p1; p <= p2; p++)if (p !== ref) {
            outPoints[p].x += deltaX;
            outPoints[p].y += deltaY;
        }
    };
    _proto.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
        var outerIndex, innerIndex;
        if (table.advanceWidthMapping) {
            var idx = gid;
            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
            var entryFormat = table.advanceWidthMapping.entryFormat;
            var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
            outerIndex = _table$advanceWidthMa.outerIndex;
            innerIndex = _table$advanceWidthMa.innerIndex;
        } else {
            outerIndex = 0;
            innerIndex = gid;
        }
        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
    } // See pseudo code from `Font Variations Overview'
    ;
    _proto.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
        if (outerIndex >= itemStore.itemVariationData.length) return 0;
        var varData = itemStore.itemVariationData[outerIndex];
        if (innerIndex >= varData.deltaSets.length) return 0;
        var deltaSet = varData.deltaSets[innerIndex];
        var blendVector = this.getBlendVector(itemStore, outerIndex);
        var netAdjustment = 0;
        for(var master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
        return netAdjustment;
    };
    _proto.getBlendVector = function getBlendVector(itemStore, outerIndex) {
        var varData = itemStore.itemVariationData[outerIndex];
        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
        var normalizedCoords = this.normalizedCoords;
        var blendVector = []; // outer loop steps through master designs to be blended
        for(var master = 0; master < varData.regionIndexCount; master++){
            var scalar = 1;
            var regionIndex = varData.regionIndexes[master];
            var axes = itemStore.variationRegionList.variationRegions[regionIndex]; // inner loop steps through axes in this region
            for(var j = 0; j < axes.length; j++){
                var axis = axes[j];
                var axisScalar = void 0; // compute the scalar contribution of this axis
                // ignore invalid ranges
                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1; // peak of 0 means ignore this axis
                else if (axis.peakCoord === 0) axisScalar = 1; // ignore this region if coords are out of range
                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0; // calculate a proportional factor
                else {
                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                } // take product of all the axis scalars
                scalar *= axisScalar;
            }
            blendVector[master] = scalar;
        }
        this.blendVectors.set(varData, blendVector);
        return blendVector;
    };
    return GlyphVariationProcessor;
}();
var $3939d1de148b5202$var$clone_1 = $3939d1de148b5202$var$createCommonjsModule(function(module) {
    var clone = function() {
        /**
     * Clones (copies) an Object using deep copying.
     *
     * This function supports circular references by default, but if you are certain
     * there are no circular references in your object, you can save some CPU time
     * by calling clone(obj, false).
     *
     * Caution: if `circular` is false and `parent` contains circular references,
     * your program may enter an infinite loop and crash.
     *
     * @param `parent` - the object to be cloned
     * @param `circular` - set to true if the object to be cloned may contain
     *    circular references. (optional - true by default)
     * @param `depth` - set to a number if the object is only to be cloned to
     *    a particular depth. (optional - defaults to Infinity)
     * @param `prototype` - sets the prototype to be used when cloning an object.
     *    (optional - defaults to parent prototype).
    */ function clone(parent, circular, depth, prototype) {
            var filter;
            if (typeof circular === 'object') {
                depth = circular.depth;
                prototype = circular.prototype;
                filter = circular.filter;
                circular = circular.circular;
            } // maintain two arrays for circular references, where corresponding parents
            // and children have the same index
            var allParents = [];
            var allChildren = [];
            var useBuffer = typeof $3939d1de148b5202$var$buffer_1 != 'undefined';
            if (typeof circular == 'undefined') circular = true;
            if (typeof depth == 'undefined') depth = Infinity; // recurse this function so we don't reset allParents and allChildren
            function _clone(parent, depth) {
                // cloning null always returns null
                if (parent === null) return null;
                if (depth == 0) return parent;
                var child;
                var proto;
                if (typeof parent != 'object') return parent;
                if (clone.__isArray(parent)) child = [];
                else if (clone.__isRegExp(parent)) {
                    child = new RegExp(parent.source, __getRegExpFlags(parent));
                    if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                else if (useBuffer && $3939d1de148b5202$var$buffer_1.isBuffer(parent)) {
                    if ($3939d1de148b5202$var$buffer_1.allocUnsafe) // Node.js >= 4.5.0
                    child = $3939d1de148b5202$var$buffer_1.allocUnsafe(parent.length);
                    else // Older Node.js versions
                    child = new $3939d1de148b5202$var$buffer_1(parent.length);
                    parent.copy(child);
                    return child;
                } else if (typeof prototype == 'undefined') {
                    proto = Object.getPrototypeOf(parent);
                    child = Object.create(proto);
                } else {
                    child = Object.create(prototype);
                    proto = prototype;
                }
                if (circular) {
                    var index = allParents.indexOf(parent);
                    if (index != -1) return allChildren[index];
                    allParents.push(parent);
                    allChildren.push(child);
                }
                for(var i in parent){
                    var attrs;
                    if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                    if (attrs && attrs.set == null) continue;
                    child[i] = _clone(parent[i], depth - 1);
                }
                return child;
            }
            return _clone(parent, depth);
        }
        /**
     * Simple flat clone using prototype, accepts only objects, usefull for property
     * override on FLAT configuration object (no nested props).
     *
     * USE WITH CAUTION! This may not behave as you wish if you do not know how this
     * works.
     */ clone.clonePrototype = function clonePrototype(parent) {
            if (parent === null) return null;
            var c = function c() {};
            c.prototype = parent;
            return new c();
        }; // private utility functions
        function __objToStr(o) {
            return Object.prototype.toString.call(o);
        }
        clone.__objToStr = __objToStr;
        function __isDate(o) {
            return typeof o === 'object' && __objToStr(o) === '[object Date]';
        }
        clone.__isDate = __isDate;
        function __isArray(o) {
            return typeof o === 'object' && __objToStr(o) === '[object Array]';
        }
        clone.__isArray = __isArray;
        function __isRegExp(o) {
            return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
        }
        clone.__isRegExp = __isRegExp;
        function __getRegExpFlags(re) {
            var flags = '';
            if (re.global) flags += 'g';
            if (re.ignoreCase) flags += 'i';
            if (re.multiline) flags += 'm';
            return flags;
        }
        clone.__getRegExpFlags = __getRegExpFlags;
        return clone;
    }();
    if (module.exports) module.exports = clone;
});
var $3939d1de148b5202$var$Subset = /*#__PURE__*/ function() {
    function Subset(font) {
        this.font = font;
        this.glyphs = [];
        this.mapping = {}; // always include the missing glyph
        this.includeGlyph(0);
    }
    var _proto = Subset.prototype;
    _proto.includeGlyph = function includeGlyph(glyph) {
        if (typeof glyph === 'object') glyph = glyph.id;
        if (this.mapping[glyph] == null) {
            this.glyphs.push(glyph);
            this.mapping[glyph] = this.glyphs.length - 1;
        }
        return this.mapping[glyph];
    };
    _proto.encodeStream = function encodeStream() {
        var _this = this;
        var s = new $3939d1de148b5202$var$restructure.EncodeStream();
        $3939d1de148b5202$var$nextTick(function() {
            _this.encode(s);
            return s.end();
        });
        return s;
    };
    return Subset;
}();
var $3939d1de148b5202$var$ON_CURVE$1 = 1;
var $3939d1de148b5202$var$X_SHORT_VECTOR$1 = 2;
var $3939d1de148b5202$var$Y_SHORT_VECTOR$1 = 4;
var $3939d1de148b5202$var$REPEAT$1 = 8;
var $3939d1de148b5202$var$SAME_X$1 = 16;
var $3939d1de148b5202$var$SAME_Y$1 = 32;
var $3939d1de148b5202$var$Point$1 = /*#__PURE__*/ function() {
    function Point() {}
    Point.size = function size(val) {
        return val >= 0 && val <= 255 ? 1 : 2;
    };
    Point.encode = function encode(stream, value) {
        if (value >= 0 && value <= 255) stream.writeUInt8(value);
        else stream.writeInt16BE(value);
    };
    return Point;
}();
var $3939d1de148b5202$var$Glyf = new $3939d1de148b5202$var$restructure.Struct({
    numberOfContours: $3939d1de148b5202$var$restructure.int16,
    // if negative, this is a composite glyph
    xMin: $3939d1de148b5202$var$restructure.int16,
    yMin: $3939d1de148b5202$var$restructure.int16,
    xMax: $3939d1de148b5202$var$restructure.int16,
    yMax: $3939d1de148b5202$var$restructure.int16,
    endPtsOfContours: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint16, 'numberOfContours'),
    instructions: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, $3939d1de148b5202$var$restructure.uint16),
    flags: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint8, 0),
    xPoints: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Point$1, 0),
    yPoints: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Point$1, 0)
});
/**
 * Encodes TrueType glyph outlines
 */ var $3939d1de148b5202$var$TTFGlyphEncoder = /*#__PURE__*/ function() {
    function TTFGlyphEncoder() {}
    var _proto = TTFGlyphEncoder.prototype;
    _proto.encodeSimple = function encodeSimple(path, instructions) {
        if (instructions === void 0) instructions = [];
        var endPtsOfContours = [];
        var xPoints = [];
        var yPoints = [];
        var flags = [];
        var same = 0;
        var lastX = 0, lastY = 0, lastFlag = 0;
        var pointCount = 0;
        for(var i = 0; i < path.commands.length; i++){
            var c = path.commands[i];
            for(var j = 0; j < c.args.length; j += 2){
                var x = c.args[j];
                var y = c.args[j + 1];
                var flag = 0; // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.
                if (c.command === 'quadraticCurveTo' && j === 2) {
                    var next = path.commands[i + 1];
                    if (next && next.command === 'quadraticCurveTo') {
                        var midX = (lastX + next.args[0]) / 2;
                        var midY = (lastY + next.args[1]) / 2;
                        if (x === midX && y === midY) continue;
                    }
                } // All points except control points are on curve.
                if (!(c.command === 'quadraticCurveTo' && j === 0)) flag |= $3939d1de148b5202$var$ON_CURVE$1;
                flag = this._encodePoint(x, lastX, xPoints, flag, $3939d1de148b5202$var$X_SHORT_VECTOR$1, $3939d1de148b5202$var$SAME_X$1);
                flag = this._encodePoint(y, lastY, yPoints, flag, $3939d1de148b5202$var$Y_SHORT_VECTOR$1, $3939d1de148b5202$var$SAME_Y$1);
                if (flag === lastFlag && same < 255) {
                    flags[flags.length - 1] |= $3939d1de148b5202$var$REPEAT$1;
                    same++;
                } else {
                    if (same > 0) {
                        flags.push(same);
                        same = 0;
                    }
                    flags.push(flag);
                    lastFlag = flag;
                }
                lastX = x;
                lastY = y;
                pointCount++;
            }
            if (c.command === 'closePath') endPtsOfContours.push(pointCount - 1);
        } // Close the path if the last command didn't already
        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') endPtsOfContours.push(pointCount - 1);
        var bbox = path.bbox;
        var glyf = {
            numberOfContours: endPtsOfContours.length,
            xMin: bbox.minX,
            yMin: bbox.minY,
            xMax: bbox.maxX,
            yMax: bbox.maxY,
            endPtsOfContours: endPtsOfContours,
            instructions: instructions,
            flags: flags,
            xPoints: xPoints,
            yPoints: yPoints
        };
        var size = $3939d1de148b5202$var$Glyf.size(glyf);
        var tail = 4 - size % 4;
        var stream = new $3939d1de148b5202$var$restructure.EncodeStream(size + tail);
        $3939d1de148b5202$var$Glyf.encode(stream, glyf); // Align to 4-byte length
        if (tail !== 0) stream.fill(0, tail);
        return stream.buffer;
    };
    _proto._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
        var diff = value - last;
        if (value === last) flag |= sameFlag;
        else {
            if (-255 <= diff && diff <= 255) {
                flag |= shortFlag;
                if (diff < 0) diff = -diff;
                else flag |= sameFlag;
            }
            points.push(diff);
        }
        return flag;
    };
    return TTFGlyphEncoder;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$o(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$o(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$o(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$o(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$o(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$o(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_inheritsLoose$d(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$TTFSubset = /*#__PURE__*/ function(_Subset) {
    $3939d1de148b5202$var$_inheritsLoose$d(TTFSubset, _Subset);
    function TTFSubset(font) {
        var _this;
        _this = _Subset.call(this, font) || this;
        _this.glyphEncoder = new $3939d1de148b5202$var$TTFGlyphEncoder();
        return _this;
    }
    var _proto = TTFSubset.prototype;
    _proto._addGlyph = function _addGlyph(gid) {
        var glyph = this.font.getGlyph(gid);
        var glyf = glyph._decode(); // get the offset to the glyph from the loca table
        var curOffset = this.font.loca.offsets[gid];
        var nextOffset = this.font.loca.offsets[gid + 1];
        var stream = this.font._getTableStream('glyf');
        stream.pos += curOffset;
        var buffer = stream.readBuffer(nextOffset - curOffset); // if it is a compound glyph, include its components
        if (glyf && glyf.numberOfContours < 0) {
            buffer = new $3939d1de148b5202$var$buffer_1(buffer);
            for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$o(glyf.components), _step; !(_step = _iterator()).done;){
                var component = _step.value;
                gid = this.includeGlyph(component.glyphID);
                buffer.writeUInt16BE(gid, component.pos);
            }
        } else if (glyf && this.font._variationProcessor) // If this is a TrueType variation glyph, re-encode the path
        buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
        this.glyf.push(buffer);
        this.loca.offsets.push(this.offset);
        this.hmtx.metrics.push({
            advance: glyph.advanceWidth,
            bearing: glyph._getMetrics().leftBearing
        });
        this.offset += buffer.length;
        return this.glyf.length - 1;
    };
    _proto.encode = function encode(stream) {
        // tables required by PDF spec:
        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
        //
        // additional tables required for standalone fonts:
        //   name, cmap, OS/2, post
        this.glyf = [];
        this.offset = 0;
        this.loca = {
            offsets: []
        };
        this.hmtx = {
            metrics: [],
            bearings: []
        }; // include all the glyphs
        // not using a for loop because we need to support adding more
        // glyphs to the array as we go, and CoffeeScript caches the length.
        var i = 0;
        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
        var maxp = $3939d1de148b5202$var$clone_1(this.font.maxp);
        maxp.numGlyphs = this.glyf.length;
        this.loca.offsets.push(this.offset);
        $3939d1de148b5202$var$tables.loca.preEncode.call(this.loca);
        var head = $3939d1de148b5202$var$clone_1(this.font.head);
        head.indexToLocFormat = this.loca.version;
        var hhea = $3939d1de148b5202$var$clone_1(this.font.hhea);
        hhea.numberOfMetrics = this.hmtx.metrics.length; // map = []
        // for index in [0...256]
        //     if index < @numGlyphs
        //         map[index] = index
        //     else
        //         map[index] = 0
        //
        // cmapTable =
        //     version: 0
        //     length: 262
        //     language: 0
        //     codeMap: map
        //
        // cmap =
        //     version: 0
        //     numSubtables: 1
        //     tables: [
        //         platformID: 1
        //         encodingID: 0
        //         table: cmapTable
        //     ]
        // TODO: subset prep, cvt, fpgm?
        $3939d1de148b5202$var$Directory.encode(stream, {
            tables: {
                head: head,
                hhea: hhea,
                loca: this.loca,
                maxp: maxp,
                'cvt ': this.font['cvt '],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm // name: clone @font.name
            }
        });
    };
    return TTFSubset;
}($3939d1de148b5202$var$Subset);
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$p(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$p(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$p(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$p(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$p(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$p(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_inheritsLoose$e(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$CFFSubset = /*#__PURE__*/ function(_Subset) {
    $3939d1de148b5202$var$_inheritsLoose$e(CFFSubset, _Subset);
    function CFFSubset(font) {
        var _this;
        _this = _Subset.call(this, font) || this;
        _this.cff = _this.font['CFF '];
        if (!_this.cff) throw new Error('Not a CFF Font');
        return _this;
    }
    var _proto = CFFSubset.prototype;
    _proto.subsetCharstrings = function subsetCharstrings() {
        this.charstrings = [];
        var gsubrs = {};
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$p(this.glyphs), _step; !(_step = _iterator()).done;){
            var gid = _step.value;
            this.charstrings.push(this.cff.getCharString(gid));
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedGsubrs)gsubrs[subr] = true;
        }
        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
    };
    _proto.subsetSubrs = function subsetSubrs(subrs, used) {
        var res = [];
        for(var i = 0; i < subrs.length; i++){
            var subr = subrs[i];
            if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
            } else res.push(new $3939d1de148b5202$var$buffer_1([
                11
            ])); // return
        }
        return res;
    };
    _proto.subsetFontdict = function subsetFontdict(topDict) {
        topDict.FDArray = [];
        topDict.FDSelect = {
            version: 0,
            fds: []
        };
        var used_fds = {};
        var used_subrs = [];
        for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$p(this.glyphs), _step2; !(_step2 = _iterator2()).done;){
            var gid = _step2.value;
            var fd = this.cff.fdForGlyph(gid);
            if (fd == null) continue;
            if (!used_fds[fd]) {
                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                used_subrs.push({});
            }
            used_fds[fd] = true;
            topDict.FDSelect.fds.push(topDict.FDArray.length - 1);
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedSubrs)used_subrs[used_subrs.length - 1][subr] = true;
        }
        for(var i = 0; i < topDict.FDArray.length; i++){
            var dict = topDict.FDArray[i];
            delete dict.FontName;
            if (dict.Private && dict.Private.Subrs) {
                dict.Private = Object.assign({}, dict.Private);
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
            }
        }
        return;
    };
    _proto.createCIDFontdict = function createCIDFontdict(topDict) {
        var used_subrs = {};
        for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$p(this.glyphs), _step3; !(_step3 = _iterator3()).done;){
            var gid = _step3.value;
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedSubrs)used_subrs[subr] = true;
        }
        var privateDict = Object.assign({}, this.cff.topDict.Private);
        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
        topDict.FDArray = [
            {
                Private: privateDict
            }
        ];
        return topDict.FDSelect = {
            version: 3,
            nRanges: 1,
            ranges: [
                {
                    first: 0,
                    fd: 0
                }
            ],
            sentinel: this.charstrings.length
        };
    };
    _proto.addString = function addString(string) {
        if (!string) return null;
        if (!this.strings) this.strings = [];
        this.strings.push(string);
        return $3939d1de148b5202$var$standardStrings.length + this.strings.length - 1;
    };
    _proto.encode = function encode(stream) {
        this.subsetCharstrings();
        var charset = {
            version: this.charstrings.length > 255 ? 2 : 1,
            ranges: [
                {
                    first: 1,
                    nLeft: this.charstrings.length - 2
                }
            ]
        };
        var topDict = Object.assign({}, this.cff.topDict);
        topDict.Private = null;
        topDict.charset = charset;
        topDict.Encoding = null;
        topDict.CharStrings = this.charstrings;
        for(var _i = 0, _arr = [
            'version',
            'Notice',
            'Copyright',
            'FullName',
            'FamilyName',
            'Weight',
            'PostScript',
            'BaseFontName',
            'FontName'
        ]; _i < _arr.length; _i++){
            var key = _arr[_i];
            topDict[key] = this.addString(this.cff.string(topDict[key]));
        }
        topDict.ROS = [
            this.addString('Adobe'),
            this.addString('Identity'),
            0
        ];
        topDict.CIDCount = this.charstrings.length;
        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
        else this.createCIDFontdict(topDict);
        var top = {
            version: 1,
            hdrSize: this.cff.hdrSize,
            offSize: this.cff.length,
            header: this.cff.header,
            nameIndex: [
                this.cff.postscriptName
            ],
            topDictIndex: [
                topDict
            ],
            stringIndex: this.strings,
            globalSubrIndex: this.gsubrs
        };
        $3939d1de148b5202$var$CFFTop.encode(stream, top);
    };
    return CFFSubset;
}($3939d1de148b5202$var$Subset);
var $3939d1de148b5202$var$_class$4;
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$q(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$q(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$q(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$q(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$q(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$q(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_defineProperties$8(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$8(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$8(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$8(Constructor, staticProps);
    return Constructor;
}
function $3939d1de148b5202$var$_applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * This is the base class for all SFNT-based font formats in fontkit.
 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
 */ var $3939d1de148b5202$var$TTFFont = ($3939d1de148b5202$var$_class$4 = /*#__PURE__*/ function() {
    TTFFont.probe = function probe(buffer) {
        var format = buffer.toString('ascii', 0, 4);
        return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
    };
    function TTFFont(stream, variationCoords) {
        if (variationCoords === void 0) variationCoords = null;
        this.stream = stream;
        this.variationCoords = variationCoords;
        this._directoryPos = this.stream.pos;
        this._tables = {};
        this._glyphs = {};
        this._decodeDirectory(); // define properties for each table to lazily parse
        for(var tag in this.directory.tables){
            var table = this.directory.tables[tag];
            if ($3939d1de148b5202$var$tables[tag] && table.length > 0) Object.defineProperty(this, tag, {
                get: this._getTable.bind(this, table)
            });
        }
    }
    var _proto = TTFFont.prototype;
    _proto._getTable = function _getTable(table) {
        if (!(table.tag in this._tables)) try {
            this._tables[table.tag] = this._decodeTable(table);
        } catch (e) {
            if ($3939d1de148b5202$var$fontkit.logErrors) {
                console.error("Error decoding table " + table.tag);
                console.error(e.stack);
            }
        }
        return this._tables[table.tag];
    };
    _proto._getTableStream = function _getTableStream(tag) {
        var table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            return this.stream;
        }
        return null;
    };
    _proto._decodeDirectory = function _decodeDirectory() {
        return this.directory = $3939d1de148b5202$var$Directory.decode(this.stream, {
            _startOffset: 0
        });
    };
    _proto._decodeTable = function _decodeTable(table) {
        var pos = this.stream.pos;
        var stream = this._getTableStream(table.tag);
        var result = $3939d1de148b5202$var$tables[table.tag].decode(stream, this, table.length);
        this.stream.pos = pos;
        return result;
    };
    /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ _proto.getName = function getName(key, lang) {
        if (lang === void 0) lang = 'en';
        var record = this.name.records[key];
        if (record) return record[lang];
        return null;
    };
    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ _proto.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
        return !!this._cmapProcessor.lookup(codePoint);
    };
    _proto.glyphForCodePoint = function glyphForCodePoint(codePoint) {
        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
            codePoint
        ]);
    };
    _proto.glyphsForString = function glyphsForString(string) {
        var glyphs = [];
        var len = string.length;
        var idx = 0;
        var last = -1;
        var state = -1;
        while(idx <= len){
            var code = 0;
            var nextState = 0;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    var next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                } // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) // Variation selector following normal codepoint.
            glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                last,
                code
            ]));
            else if (state === 0 && nextState === 0) // Normal codepoint following normal codepoint.
            glyphs.push(this.glyphForCodePoint(last));
            last = code;
            state = nextState;
        }
        return glyphs;
    };
    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ _proto.layout = function layout(string, userFeatures, script, language, direction) {
        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
    };
    _proto.stringsForGlyph = function stringsForGlyph(gid) {
        return this._layoutEngine.stringsForGlyph(gid);
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        return this._layoutEngine.getAvailableFeatures(script, language);
    };
    _proto._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
        if (characters === void 0) characters = [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf) this._glyphs[glyph] = new $3939d1de148b5202$var$TTFGlyph(glyph, characters, this);
            else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) this._glyphs[glyph] = new $3939d1de148b5202$var$CFFGlyph(glyph, characters, this);
        }
        return this._glyphs[glyph] || null;
    };
    _proto.getGlyph = function getGlyph(glyph, characters) {
        if (characters === void 0) characters = [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.sbix) this._glyphs[glyph] = new $3939d1de148b5202$var$SBIXGlyph(glyph, characters, this);
            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new $3939d1de148b5202$var$COLRGlyph(glyph, characters, this);
            else this._getBaseGlyph(glyph, characters);
        }
        return this._glyphs[glyph] || null;
    };
    _proto.createSubset = function createSubset() {
        if (this.directory.tables['CFF ']) return new $3939d1de148b5202$var$CFFSubset(this);
        return new $3939d1de148b5202$var$TTFSubset(this);
    };
    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ _proto.getVariation = function getVariation(settings) {
        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
        if (typeof settings === 'string') settings = this.namedVariations[settings];
        if (typeof settings !== 'object') throw new Error('Variation settings must be either a variation name or settings object.');
         // normalize the coordinates
        var coords = this.fvar.axis.map(function(axis, i) {
            var axisTag = axis.axisTag.trim();
            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
            else return axis.defaultValue;
        });
        var stream = new $3939d1de148b5202$var$restructure.DecodeStream(this.stream.buffer);
        stream.pos = this._directoryPos;
        var font = new TTFFont(stream, coords);
        font._tables = this._tables;
        return font;
    };
    // Standardized format plugin API
    _proto.getFont = function getFont(name) {
        return this.getVariation(name);
    };
    $3939d1de148b5202$var$_createClass$8(TTFFont, [
        {
            key: "postscriptName",
            get: function get() {
                var name = this.name.records.postscriptName;
                if (name) {
                    var lang = Object.keys(name)[0];
                    return name[lang];
                }
                return null;
            }
        },
        {
            key: "fullName",
            get: function get() {
                return this.getName('fullName');
            }
        },
        {
            key: "familyName",
            get: function get() {
                return this.getName('fontFamily');
            }
        },
        {
            key: "subfamilyName",
            get: function get() {
                return this.getName('fontSubfamily');
            }
        },
        {
            key: "copyright",
            get: function get() {
                return this.getName('copyright');
            }
        },
        {
            key: "version",
            get: function get() {
                return this.getName('version');
            }
        },
        {
            key: "ascent",
            get: function get() {
                return this.hhea.ascent;
            }
        },
        {
            key: "descent",
            get: function get() {
                return this.hhea.descent;
            }
        },
        {
            key: "lineGap",
            get: function get() {
                return this.hhea.lineGap;
            }
        },
        {
            key: "underlinePosition",
            get: function get() {
                return this.post.underlinePosition;
            }
        },
        {
            key: "underlineThickness",
            get: function get() {
                return this.post.underlineThickness;
            }
        },
        {
            key: "italicAngle",
            get: function get() {
                return this.post.italicAngle;
            }
        },
        {
            key: "capHeight",
            get: function get() {
                var os2 = this['OS/2'];
                return os2 ? os2.capHeight : this.ascent;
            }
        },
        {
            key: "xHeight",
            get: function get() {
                var os2 = this['OS/2'];
                return os2 ? os2.xHeight : 0;
            }
        },
        {
            key: "numGlyphs",
            get: function get() {
                return this.maxp.numGlyphs;
            }
        },
        {
            key: "unitsPerEm",
            get: function get() {
                return this.head.unitsPerEm;
            }
        },
        {
            key: "bbox",
            get: function get() {
                return Object.freeze(new $3939d1de148b5202$var$BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
            }
        },
        {
            key: "_cmapProcessor",
            get: function get() {
                return new $3939d1de148b5202$var$CmapProcessor(this.cmap);
            }
        },
        {
            key: "characterSet",
            get: function get() {
                return this._cmapProcessor.getCharacterSet();
            }
        },
        {
            key: "_layoutEngine",
            get: function get() {
                return new $3939d1de148b5202$var$LayoutEngine(this);
            }
        },
        {
            key: "availableFeatures",
            get: function get() {
                return this._layoutEngine.getAvailableFeatures();
            }
        },
        {
            key: "variationAxes",
            get: function get() {
                var res = {};
                if (!this.fvar) return res;
                for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$q(this.fvar.axis), _step; !(_step = _iterator()).done;){
                    var axis = _step.value;
                    res[axis.axisTag.trim()] = {
                        name: axis.name.en,
                        min: axis.minValue,
                        "default": axis.defaultValue,
                        max: axis.maxValue
                    };
                }
                return res;
            }
        },
        {
            key: "namedVariations",
            get: function get() {
                var res = {};
                if (!this.fvar) return res;
                for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$q(this.fvar.instance), _step2; !(_step2 = _iterator2()).done;){
                    var instance = _step2.value;
                    var settings = {};
                    for(var i = 0; i < this.fvar.axis.length; i++){
                        var axis = this.fvar.axis[i];
                        settings[axis.axisTag.trim()] = instance.coord[i];
                    }
                    res[instance.name.en] = settings;
                }
                return res;
            }
        },
        {
            key: "_variationProcessor",
            get: function get() {
                if (!this.fvar) return null;
                var variationCoords = this.variationCoords; // Ignore if no variation coords and not CFF2
                if (!variationCoords && !this.CFF2) return null;
                if (!variationCoords) variationCoords = this.fvar.axis.map(function(axis) {
                    return axis.defaultValue;
                });
                return new $3939d1de148b5202$var$GlyphVariationProcessor(this, variationCoords);
            }
        }
    ]);
    return TTFFont;
}(), $3939d1de148b5202$var$_applyDecoratedDescriptor$4($3939d1de148b5202$var$_class$4.prototype, "bbox", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$4.prototype, "bbox"), $3939d1de148b5202$var$_class$4.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$4($3939d1de148b5202$var$_class$4.prototype, "_cmapProcessor", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$4.prototype, "_cmapProcessor"), $3939d1de148b5202$var$_class$4.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$4($3939d1de148b5202$var$_class$4.prototype, "characterSet", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$4.prototype, "characterSet"), $3939d1de148b5202$var$_class$4.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$4($3939d1de148b5202$var$_class$4.prototype, "_layoutEngine", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$4.prototype, "_layoutEngine"), $3939d1de148b5202$var$_class$4.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$4($3939d1de148b5202$var$_class$4.prototype, "variationAxes", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$4.prototype, "variationAxes"), $3939d1de148b5202$var$_class$4.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$4($3939d1de148b5202$var$_class$4.prototype, "namedVariations", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$4.prototype, "namedVariations"), $3939d1de148b5202$var$_class$4.prototype), $3939d1de148b5202$var$_applyDecoratedDescriptor$4($3939d1de148b5202$var$_class$4.prototype, "_variationProcessor", [
    $3939d1de148b5202$var$cache
], Object.getOwnPropertyDescriptor($3939d1de148b5202$var$_class$4.prototype, "_variationProcessor"), $3939d1de148b5202$var$_class$4.prototype), $3939d1de148b5202$var$_class$4);
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$r(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$r(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$r(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$r(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$r(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$r(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3939d1de148b5202$var$WOFFDirectoryEntry = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    offset: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, 'void', {
        type: 'global'
    }),
    compLength: $3939d1de148b5202$var$restructure.uint32,
    length: $3939d1de148b5202$var$restructure.uint32,
    origChecksum: $3939d1de148b5202$var$restructure.uint32
});
var $3939d1de148b5202$var$WOFFDirectory = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    // should be 'wOFF'
    flavor: $3939d1de148b5202$var$restructure.uint32,
    length: $3939d1de148b5202$var$restructure.uint32,
    numTables: $3939d1de148b5202$var$restructure.uint16,
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
    totalSfntSize: $3939d1de148b5202$var$restructure.uint32,
    majorVersion: $3939d1de148b5202$var$restructure.uint16,
    minorVersion: $3939d1de148b5202$var$restructure.uint16,
    metaOffset: $3939d1de148b5202$var$restructure.uint32,
    metaLength: $3939d1de148b5202$var$restructure.uint32,
    metaOrigLength: $3939d1de148b5202$var$restructure.uint32,
    privOffset: $3939d1de148b5202$var$restructure.uint32,
    privLength: $3939d1de148b5202$var$restructure.uint32,
    tables: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$WOFFDirectoryEntry, 'numTables')
});
$3939d1de148b5202$var$WOFFDirectory.process = function() {
    var tables = {};
    for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$r(this.tables), _step; !(_step = _iterator()).done;){
        var table = _step.value;
        tables[table.tag] = table;
    }
    this.tables = tables;
};
var $3939d1de148b5202$var$TINF_OK$1 = 0;
var $3939d1de148b5202$var$TINF_DATA_ERROR$1 = -3;
function $3939d1de148b5202$var$Tree$1() {
    this.table = new Uint16Array(16);
    /* table of code length counts */ this.trans = new Uint16Array(288);
/* code -> symbol translation table */ }
function $3939d1de148b5202$var$Data$1(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new $3939d1de148b5202$var$Tree$1();
    /* dynamic length/symbol tree */ this.dtree = new $3939d1de148b5202$var$Tree$1();
/* dynamic distance tree */ }
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var $3939d1de148b5202$var$sltree$1 = new $3939d1de148b5202$var$Tree$1();
var $3939d1de148b5202$var$sdtree$1 = new $3939d1de148b5202$var$Tree$1();
/* extra bits and base tables for length codes */ var $3939d1de148b5202$var$length_bits$1 = new Uint8Array(30);
var $3939d1de148b5202$var$length_base$1 = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var $3939d1de148b5202$var$dist_bits$1 = new Uint8Array(30);
var $3939d1de148b5202$var$dist_base$1 = new Uint16Array(30);
/* special ordering of code length codes */ var $3939d1de148b5202$var$clcidx$1 = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var $3939d1de148b5202$var$code_tree$1 = new $3939d1de148b5202$var$Tree$1();
var $3939d1de148b5202$var$lengths$1 = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function $3939d1de148b5202$var$tinf_build_bits_base$1(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function $3939d1de148b5202$var$tinf_build_fixed_trees$1(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var $3939d1de148b5202$var$offs$1 = new Uint16Array(16);
function $3939d1de148b5202$var$tinf_build_tree$1(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        $3939d1de148b5202$var$offs$1[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[$3939d1de148b5202$var$offs$1[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function $3939d1de148b5202$var$tinf_getbit$1(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function $3939d1de148b5202$var$tinf_read_bits$1(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function $3939d1de148b5202$var$tinf_decode_symbol$1(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function $3939d1de148b5202$var$tinf_decode_trees$1(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = $3939d1de148b5202$var$tinf_read_bits$1(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = $3939d1de148b5202$var$tinf_read_bits$1(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = $3939d1de148b5202$var$tinf_read_bits$1(d, 4, 4);
    for(i = 0; i < 19; ++i)$3939d1de148b5202$var$lengths$1[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = $3939d1de148b5202$var$tinf_read_bits$1(d, 3, 0);
        $3939d1de148b5202$var$lengths$1[$3939d1de148b5202$var$clcidx$1[i]] = clen;
    }
    /* build code length tree */ $3939d1de148b5202$var$tinf_build_tree$1($3939d1de148b5202$var$code_tree$1, $3939d1de148b5202$var$lengths$1, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = $3939d1de148b5202$var$tinf_decode_symbol$1(d, $3939d1de148b5202$var$code_tree$1);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = $3939d1de148b5202$var$lengths$1[num - 1];
                for(length = $3939d1de148b5202$var$tinf_read_bits$1(d, 2, 3); length; --length)$3939d1de148b5202$var$lengths$1[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = $3939d1de148b5202$var$tinf_read_bits$1(d, 3, 3); length; --length)$3939d1de148b5202$var$lengths$1[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = $3939d1de148b5202$var$tinf_read_bits$1(d, 7, 11); length; --length)$3939d1de148b5202$var$lengths$1[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ $3939d1de148b5202$var$lengths$1[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ $3939d1de148b5202$var$tinf_build_tree$1(lt, $3939d1de148b5202$var$lengths$1, 0, hlit);
    $3939d1de148b5202$var$tinf_build_tree$1(dt, $3939d1de148b5202$var$lengths$1, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function $3939d1de148b5202$var$tinf_inflate_block_data$1(d, lt, dt) {
    while(true){
        var sym = $3939d1de148b5202$var$tinf_decode_symbol$1(d, lt);
        /* check for end of block */ if (sym === 256) return $3939d1de148b5202$var$TINF_OK$1;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = $3939d1de148b5202$var$tinf_read_bits$1(d, $3939d1de148b5202$var$length_bits$1[sym], $3939d1de148b5202$var$length_base$1[sym]);
            dist = $3939d1de148b5202$var$tinf_decode_symbol$1(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - $3939d1de148b5202$var$tinf_read_bits$1(d, $3939d1de148b5202$var$dist_bits$1[dist], $3939d1de148b5202$var$dist_base$1[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function $3939d1de148b5202$var$tinf_inflate_uncompressed_block$1(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return $3939d1de148b5202$var$TINF_DATA_ERROR$1;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return $3939d1de148b5202$var$TINF_OK$1;
}
/* inflate stream from source to dest */ function $3939d1de148b5202$var$tinf_uncompress$1(source, dest) {
    var d = new $3939d1de148b5202$var$Data$1(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = $3939d1de148b5202$var$tinf_getbit$1(d);
        /* read block type (2 bits) */ btype = $3939d1de148b5202$var$tinf_read_bits$1(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = $3939d1de148b5202$var$tinf_inflate_uncompressed_block$1(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = $3939d1de148b5202$var$tinf_inflate_block_data$1(d, $3939d1de148b5202$var$sltree$1, $3939d1de148b5202$var$sdtree$1);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ $3939d1de148b5202$var$tinf_decode_trees$1(d, d.ltree, d.dtree);
                res = $3939d1de148b5202$var$tinf_inflate_block_data$1(d, d.ltree, d.dtree);
                break;
            default:
                res = $3939d1de148b5202$var$TINF_DATA_ERROR$1;
        }
        if (res !== $3939d1de148b5202$var$TINF_OK$1) throw new Error('Data error');
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ $3939d1de148b5202$var$tinf_build_fixed_trees$1($3939d1de148b5202$var$sltree$1, $3939d1de148b5202$var$sdtree$1);
/* build extra bits and base tables */ $3939d1de148b5202$var$tinf_build_bits_base$1($3939d1de148b5202$var$length_bits$1, $3939d1de148b5202$var$length_base$1, 4, 3);
$3939d1de148b5202$var$tinf_build_bits_base$1($3939d1de148b5202$var$dist_bits$1, $3939d1de148b5202$var$dist_base$1, 2, 1);
/* fix a special case */ $3939d1de148b5202$var$length_bits$1[28] = 0;
$3939d1de148b5202$var$length_base$1[28] = 258;
var $3939d1de148b5202$var$tinyInflate$1 = $3939d1de148b5202$var$tinf_uncompress$1;
function $3939d1de148b5202$var$_inheritsLoose$f(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3939d1de148b5202$var$WOFFFont = /*#__PURE__*/ function(_TTFFont) {
    $3939d1de148b5202$var$_inheritsLoose$f(WOFFFont, _TTFFont);
    function WOFFFont() {
        return _TTFFont.apply(this, arguments) || this;
    }
    WOFFFont.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'wOFF';
    };
    var _proto = WOFFFont.prototype;
    _proto._decodeDirectory = function _decodeDirectory() {
        this.directory = $3939d1de148b5202$var$WOFFDirectory.decode(this.stream, {
            _startOffset: 0
        });
    };
    _proto._getTableStream = function _getTableStream(tag) {
        var table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header
                var outBuffer = new $3939d1de148b5202$var$buffer_1(table.length);
                var buf = $3939d1de148b5202$var$tinyInflate$1(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new $3939d1de148b5202$var$restructure.DecodeStream(buf);
            } else return this.stream;
        }
        return null;
    };
    return WOFFFont;
}($3939d1de148b5202$var$TTFFont);
function $3939d1de148b5202$var$BrotliInput(buffer) {
    this.buffer = buffer;
    this.pos = 0;
}
$3939d1de148b5202$var$BrotliInput.prototype.read = function(buf, i, count) {
    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
    this.pos += count;
    return count;
};
var $3939d1de148b5202$var$BrotliInput_1 = $3939d1de148b5202$var$BrotliInput;
function $3939d1de148b5202$var$BrotliOutput(buf) {
    this.buffer = buf;
    this.pos = 0;
}
$3939d1de148b5202$var$BrotliOutput.prototype.write = function(buf, count) {
    if (this.pos + count > this.buffer.length) throw new Error('Output buffer is not large enough');
    this.buffer.set(buf.subarray(0, count), this.pos);
    this.pos += count;
    return count;
};
var $3939d1de148b5202$var$BrotliOutput_1 = $3939d1de148b5202$var$BrotliOutput;
var $3939d1de148b5202$var$streams$1 = {
    BrotliInput: $3939d1de148b5202$var$BrotliInput_1,
    BrotliOutput: $3939d1de148b5202$var$BrotliOutput_1
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var $3939d1de148b5202$var$BROTLI_READ_SIZE = 4096;
var $3939d1de148b5202$var$BROTLI_IBUF_SIZE = 2 * $3939d1de148b5202$var$BROTLI_READ_SIZE + 32;
var $3939d1de148b5202$var$BROTLI_IBUF_MASK = 2 * $3939d1de148b5202$var$BROTLI_READ_SIZE - 1;
var $3939d1de148b5202$var$kBitMask = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
]);
/* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function $3939d1de148b5202$var$BrotliBitReader(input) {
    this.buf_ = new Uint8Array($3939d1de148b5202$var$BROTLI_IBUF_SIZE);
    this.input_ = input;
    /* input callback */ this.reset();
}
$3939d1de148b5202$var$BrotliBitReader.READ_SIZE = $3939d1de148b5202$var$BROTLI_READ_SIZE;
$3939d1de148b5202$var$BrotliBitReader.IBUF_MASK = $3939d1de148b5202$var$BROTLI_IBUF_MASK;
$3939d1de148b5202$var$BrotliBitReader.prototype.reset = function() {
    this.buf_ptr_ = 0;
    /* next input will write here */ this.val_ = 0;
    /* pre-fetched bits */ this.pos_ = 0;
    /* byte position in stream */ this.bit_pos_ = 0;
    /* current bit-reading position in val_ */ this.bit_end_pos_ = 0;
    /* bit-reading end position from LSB of val_ */ this.eos_ = 0;
    /* input stream is finished */ this.readMoreInput();
    for(var i = 0; i < 4; i++){
        this.val_ |= this.buf_[this.pos_] << 8 * i;
        ++this.pos_;
    }
    return this.bit_end_pos_ > 0;
};
/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ $3939d1de148b5202$var$BrotliBitReader.prototype.readMoreInput = function() {
    if (this.bit_end_pos_ > 256) return;
    else if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_) throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
    } else {
        var dst = this.buf_ptr_;
        var bytes_read = this.input_.read(this.buf_, dst, $3939d1de148b5202$var$BROTLI_READ_SIZE);
        if (bytes_read < 0) throw new Error('Unexpected end of input');
        if (bytes_read < $3939d1de148b5202$var$BROTLI_READ_SIZE) {
            this.eos_ = 1;
            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
        }
        if (dst === 0) {
            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[($3939d1de148b5202$var$BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
            this.buf_ptr_ = $3939d1de148b5202$var$BROTLI_READ_SIZE;
        } else this.buf_ptr_ = 0;
        this.bit_end_pos_ += bytes_read << 3;
    }
};
/* Guarantees that there are at least 24 bits in the buffer. */ $3939d1de148b5202$var$BrotliBitReader.prototype.fillBitWindow = function() {
    while(this.bit_pos_ >= 8){
        this.val_ >>>= 8;
        this.val_ |= this.buf_[this.pos_ & $3939d1de148b5202$var$BROTLI_IBUF_MASK] << 24;
        ++this.pos_;
        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
    }
};
/* Reads the specified number of bits from Read Buffer. */ $3939d1de148b5202$var$BrotliBitReader.prototype.readBits = function(n_bits) {
    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
    var val = this.val_ >>> this.bit_pos_ & $3939d1de148b5202$var$kBitMask[n_bits];
    this.bit_pos_ += n_bits;
    return val;
};
var $3939d1de148b5202$var$bit_reader = $3939d1de148b5202$var$BrotliBitReader;
var $3939d1de148b5202$var$byteLength_1$1 = $3939d1de148b5202$var$byteLength$1;
var $3939d1de148b5202$var$toByteArray_1$1 = $3939d1de148b5202$var$toByteArray$1;
var $3939d1de148b5202$var$fromByteArray_1$1 = $3939d1de148b5202$var$fromByteArray$1;
var $3939d1de148b5202$var$lookup$1 = [];
var $3939d1de148b5202$var$revLookup$1 = [];
var $3939d1de148b5202$var$Arr$1 = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3939d1de148b5202$var$code$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3939d1de148b5202$var$i$4 = 0, $3939d1de148b5202$var$len$1 = $3939d1de148b5202$var$code$1.length; $3939d1de148b5202$var$i$4 < $3939d1de148b5202$var$len$1; ++$3939d1de148b5202$var$i$4){
    $3939d1de148b5202$var$lookup$1[$3939d1de148b5202$var$i$4] = $3939d1de148b5202$var$code$1[$3939d1de148b5202$var$i$4];
    $3939d1de148b5202$var$revLookup$1[$3939d1de148b5202$var$code$1.charCodeAt($3939d1de148b5202$var$i$4)] = $3939d1de148b5202$var$i$4;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3939d1de148b5202$var$revLookup$1['-'.charCodeAt(0)] = 62;
$3939d1de148b5202$var$revLookup$1['_'.charCodeAt(0)] = 63;
function $3939d1de148b5202$var$getLens$1(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
     // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
} // base64 is 4/3 + up to two characters of the original data
function $3939d1de148b5202$var$byteLength$1(b64) {
    var lens = $3939d1de148b5202$var$getLens$1(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3939d1de148b5202$var$_byteLength$1(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3939d1de148b5202$var$toByteArray$1(b64) {
    var tmp;
    var lens = $3939d1de148b5202$var$getLens$1(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3939d1de148b5202$var$Arr$1($3939d1de148b5202$var$_byteLength$1(b64, validLen, placeHoldersLen));
    var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    for(var i = 0; i < len; i += 4){
        tmp = $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i)] << 18 | $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i + 1)] << 12 | $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i + 2)] << 6 | $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i)] << 2 | $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i)] << 10 | $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i + 1)] << 4 | $3939d1de148b5202$var$revLookup$1[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3939d1de148b5202$var$tripletToBase64$1(num) {
    return $3939d1de148b5202$var$lookup$1[num >> 18 & 0x3F] + $3939d1de148b5202$var$lookup$1[num >> 12 & 0x3F] + $3939d1de148b5202$var$lookup$1[num >> 6 & 0x3F] + $3939d1de148b5202$var$lookup$1[num & 0x3F];
}
function $3939d1de148b5202$var$encodeChunk$1(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3939d1de148b5202$var$tripletToBase64$1(tmp));
    }
    return output.join('');
}
function $3939d1de148b5202$var$fromByteArray$1(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3939d1de148b5202$var$encodeChunk$1(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
     // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3939d1de148b5202$var$lookup$1[tmp >> 2] + $3939d1de148b5202$var$lookup$1[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3939d1de148b5202$var$lookup$1[tmp >> 10] + $3939d1de148b5202$var$lookup$1[tmp >> 4 & 0x3F] + $3939d1de148b5202$var$lookup$1[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $3939d1de148b5202$var$base64Js$1 = {
    byteLength: $3939d1de148b5202$var$byteLength_1$1,
    toByteArray: $3939d1de148b5202$var$toByteArray_1$1,
    fromByteArray: $3939d1de148b5202$var$fromByteArray_1$1
};
var $3939d1de148b5202$var$dictionary_bin = "W5/fcQLn5gKf2XUbAiQ1XULX+TZz6ADToDsgqk6qVfeC0e4m6OO2wcQ1J76ZBVRV1fRkEsdu//62zQsFEZWSTCnMhcsQKlS2qOhuVYYMGCkV0fXWEoMFbESXrKEZ9wdUEsyw9g4bJlEt1Y6oVMxMRTEVbCIwZzJzboK5j8m4YH02qgXYhv1V+PM435sLVxyHJihaJREEhZGqL03txGFQLm76caGO/ovxKvzCby/3vMTtX/459f0igi7WutnKiMQ6wODSoRh/8Lx1V3Q99MvKtwB6bHdERYRY0hStJoMjNeTsNX7bn+Y7e4EQ3bf8xBc7L0BsyfFPK43dGSXpL6clYC/I328h54/VYrQ5i0648FgbGtl837svJ35L3Mot/+nPlNpWgKx1gGXQYqX6n+bbZ7wuyCHKcUok12Xjqub7NXZGzqBx0SD+uziNf87t7ve42jxSKQoW3nyxVrWIGlFShhCKxjpZZ5MeGna0+lBkk+kaN8F9qFBAFgEogyMBdcX/T1W/WnMOi/7ycWUQloEBKGeC48MkiwqJkJO+12eQiOFHMmck6q/IjWW3RZlany23TBm+cNr/84/oi5GGmGBZWrZ6j+zykVozz5fT/QH/Da6WTbZYYPynVNO7kxzuNN2kxKKWche5WveitPKAecB8YcAHz/+zXLjcLzkdDSktNIDwZE9J9X+tto43oJy65wApM3mDzYtCwX9lM+N5VR3kXYo0Z3t0TtXfgBFg7gU8oN0Dgl7fZlUbhNll+0uuohRVKjrEd8egrSndy5/Tgd2gqjA4CAVuC7ESUmL3DZoGnfhQV8uwnpi8EGvAVVsowNRxPudck7+oqAUDkwZopWqFnW1riss0t1z6iCISVKreYGNvQcXv+1L9+jbP8cd/dPUiqBso2q+7ZyFBvENCkkVr44iyPbtOoOoCecWsiuqMSML5lv+vN5MzUr+Dnh73G7Q1YnRYJVYXHRJaNAOByiaK6CusgFdBPE40r0rvqXV7tksKO2DrHYXBTv8P5ysqxEx8VDXUDDqkPH6NNOV/a2WH8zlkXRELSa8P+heNyJBBP7PgsG1EtWtNef6/i+lcayzQwQCsduidpbKfhWUDgAEmyhGu/zVTacI6RS0zTABrOYueemnVa19u9fT23N/Ta6RvTpof5DWygqreCqrDAgM4LID1+1T/taU6yTFVLqXOv+/MuQOFnaF8vLMKD7tKWDoBdALgxF33zQccCcdHx8fKIVdW69O7qHtXpeGr9jbbpFA+qRMWr5hp0s67FPc7HAiLV0g0/peZlW7hJPYEhZyhpSwahnf93/tZgfqZWXFdmdXBzqxGHLrQKxoAY6fRoBhgCRPmmGueYZ5JexTVDKUIXzkG/fqp/0U3hAgQdJ9zumutK6nqWbaqvm1pgu03IYR+G+8s0jDBBz8cApZFSBeuWasyqo2OMDKAZCozS+GWSvL/HsE9rHxooe17U3s/lTE+VZAk4j3dp6uIGaC0JMiqR5CUsabPyM0dOYDR7Ea7ip4USZlya38YfPtvrX/tBlhHilj55nZ1nfN24AOAi9BVtz/Mbn8AEDJCqJgsVUa6nQnSxv2Fs7l/NlCzpfYEjmPrNyib/+t0ei2eEMjvNhLkHCZlci4WhBe7ePZTmzYqlY9+1pxtS4GB+5lM1BHT9tS270EWUDYFq1I0yY/fNiAk4bk9yBgmef/f2k6AlYQZHsNFnW8wBQxCd68iWv7/35bXfz3JZmfGligWAKRjIs3IpzxQ27vAglHSiOzCYzJ9L9A1CdiyFvyR66ucA4jKifu5ehwER26yV7HjKqn5Mfozo7Coxxt8LWWPT47BeMxX8p0Pjb7hZn+6bw7z3Lw+7653j5sI8CLu5kThpMlj1m4c2ch3jGcP1FsT13vuK3qjecKTZk2kHcOZY40UX+qdaxstZqsqQqgXz+QGF99ZJLqr3VYu4aecl1Ab5GmqS8k/GV5b95zxQ5d4EfXUJ6kTS/CXF/aiqKDOT1T7Jz5z0PwDUcwr9clLN1OJGCiKfqvah+h3XzrBOiLOW8wvn8gW6qE8vPxi+Efv+UH55T7PQFVMh6cZ1pZQlzJpKZ7P7uWvwPGJ6DTlR6wbyj3Iv2HyefnRo/dv7dNx+qaa0N38iBsR++Uil7Wd4afwDNsrzDAK4fXZwvEY/jdKuIKXlfrQd2C39dW7ntnRbIp9OtGy9pPBn/V2ASoi/2UJZfS+xuGLH8bnLuPlzdTNS6zdyk8Dt/h6sfOW5myxh1f+zf3zZ3MX/mO9cQPp5pOx967ZA6/pqHvclNfnUFF+rq+Vd7alKr6KWPcIDhpn6v2K6NlUu6LrKo8b/pYpU/Gazfvtwhn7tEOUuXht5rUJdSf6sLjYf0VTYDgwJ81yaqKTUYej/tbHckSRb/HZicwGJqh1mAHB/IuNs9dc9yuvF3D5Xocm3elWFdq5oEy70dYFit79yaLiNjPj5UUcVmZUVhQEhW5V2Z6Cm4HVH/R8qlamRYwBileuh07CbEce3TXa2JmXWBf+ozt319psboobeZhVnwhMZzOeQJzhpTDbP71Tv8HuZxxUI/+ma3XW6DFDDs4+qmpERwHGBd2edxwUKlODRdUWZ/g0GOezrbzOZauFMai4QU6GVHV6aPNBiBndHSsV4IzpvUiiYyg6OyyrL4Dj5q/Lw3N5kAwftEVl9rNd7Jk5PDij2hTH6wIXnsyXkKePxbmHYgC8A6an5Fob/KH5GtC0l4eFso+VpxedtJHdHpNm+Bvy4C79yVOkrZsLrQ3OHCeB0Ra+kBIRldUGlDCEmq2RwXnfyh6Dz+alk6eftI2n6sastRrGwbwszBeDRS/Fa/KwRJkCzTsLr/JCs5hOPE/MPLYdZ1F1fv7D+VmysX6NpOC8aU9F4Qs6HvDyUy9PvFGDKZ/P5101TYHFl8pjj6wm/qyS75etZhhfg0UEL4OYmHk6m6dO192AzoIyPSV9QedDA4Ml23rRbqxMPMxf7FJnDc5FTElVS/PyqgePzmwVZ26NWhRDQ+oaT7ly7ell4s3DypS1s0g+tOr7XHrrkZj9+x/mJBttrLx98lFIaRZzHz4aC7r52/JQ4VjHahY2/YVXZn/QC2ztQb/sY3uRlyc5vQS8nLPGT/n27495i8HPA152z7Fh5aFpyn1GPJKHuPL8Iw94DuW3KjkURAWZXn4EQy89xiKEHN1mk/tkM4gYDBxwNoYvRfE6LFqsxWJtPrDGbsnLMap3Ka3MUoytW0cvieozOmdERmhcqzG+3HmZv2yZeiIeQTKGdRT4HHNxekm1tY+/n06rGmFleqLscSERzctTKM6G9P0Pc1RmVvrascIxaO1CQCiYPE15bD7c3xSeW7gXxYjgxcrUlcbIvO0r+Yplhx0kTt3qafDOmFyMjgGxXu73rddMHpV1wMubyAGcf/v5dLr5P72Ta9lBF+fzMJrMycwv+9vnU3ANIl1cH9tfW7af8u0/HG0vV47jNFXzFTtaha1xvze/s8KMtCYucXc1nzfd/MQydUXn/b72RBt5wO/3jRcMH9BdhC/yctKBIveRYPrNpDWqBsO8VMmP+WvRaOcA4zRMR1PvSoO92rS7pYEv+fZfEfTMzEdM+6X5tLlyxExhqLRkms5EuLovLfx66de5fL2/yX02H52FPVwahrPqmN/E0oVXnsCKhbi/yRxX83nRbUKWhzYceXOntfuXn51NszJ6MO73pQf5Pl4in3ec4JU8hF7ppV34+mm9r1LY0ee/i1O1wpd8+zfLztE0cqBxggiBi5Bu95v9l3r9r/U5hweLn+TbfxowrWDqdJauKd8+q/dH8sbPkc9ttuyO94f7/XK/nHX46MPFLEb5qQlNPvhJ50/59t9ft3LXu7uVaWaO2bDrDCnRSzZyWvFKxO1+vT8MwwunR3bX0CkfPjqb4K9O19tn5X50PvmYpEwHtiW9WtzuV/s76B1zvLLNkViNd8ySxIl/3orfqP90TyTGaf7/rx8jQzeHJXdmh/N6YDvbvmTBwCdxfEQ1NcL6wNMdSIXNq7b1EUzRy1/Axsyk5p22GMG1b+GxFgbHErZh92wuvco0AuOLXct9hvw2nw/LqIcDRRmJmmZzcgUa7JpM/WV/S9IUfbF56TL2orzqwebdRD8nIYNJ41D/hz37Fo11p2Y21wzPcn713qVGhqtevStYfGH4n69OEJtPvbbLYWvscDqc3Hgnu166+tAyLnxrX0Y5zoYjV++1sI7t5kMr02KT/+uwtkc+rZLOf/qn/s3nYCf13Dg8/sB2diJgjGqjQ+TLhxbzyue2Ob7X6/9lUwW7a+lbznHzOYy8LKW1C/uRPbQY3KW/0gO9LXunHLvPL97afba9bFtc9hmz7GAttjVYlCvQAiOwAk/gC5+hkLEs6tr3AZKxLJtOEwk2dLxTYWsIB/j/ToWtIWzo906FrSG8iaqqqqqqiIiIiAgzMzMzNz+AyK+01/zi8n8S+Y1MjoRaQ80WU/G8MBlO+53VPXANrWm4wzGUVZUjjBJZVdhpcfkjsmcWaO+UEldXi1e+zq+HOsCpknYshuh8pOLISJun7TN0EIGW2xTnlOImeecnoGW4raxe2G1T3HEvfYUYMhG+gAFOAwh5nK8mZhwJMmN7r224QVsNFvZ87Z0qatvknklyPDK3Hy45PgVKXji52Wen4d4PlFVVYGnNap+fSpFbK90rYnhUc6n91Q3AY9E0tJOFrcfZtm/491XbcG/jsViUPPX76qmeuiz+qY1Hk7/1VPM405zWVuoheLUimpWYdVzCmUdKHebMdzgrYrb8mL2eeLSnRWHdonfZa8RsOU9F37w+591l5FLYHiOqWeHtE/lWrBHcRKp3uhtr8yXm8LU/5ms+NM6ZKsqu90cFZ4o58+k4rdrtB97NADFbwmEG7lXqvirhOTOqU14xuUF2myIjURcPHrPOQ4lmM3PeMg7bUuk0nnZi67bXsU6H8lhqIo8TaOrEafCO1ARK9PjC0QOoq2BxmMdgYB9G/lIb9++fqNJ2s7BHGFyBNmZAR8J3KCo012ikaSP8BCrf6VI0X5xdnbhHIO+B5rbOyB54zXkzfObyJ4ecwxfqBJMLFc7m59rNcw7hoHnFZ0b00zee+gTqvjm61Pb4xn0kcDX4jvHM0rBXZypG3DCKnD/Waa/ZtHmtFPgO5eETx+k7RrVg3aSwm2YoNXnCs3XPQDhNn+Fia6IlOOuIG6VJH7TP6ava26ehKHQa2T4N0tcZ9dPCGo3ZdnNltsHQbeYt5vPnJezV/cAeNypdml1vCHI8M81nSRP5Qi2+mI8v/sxiZru9187nRtp3f/42NemcONa+4eVC3PCZzc88aZh851CqSsshe70uPxeN/dmYwlwb3trwMrN1Gq8jbnApcVDx/yDPeYs5/7r62tsQ6lLg+DiFXTEhzR9dHqv0iT4tgj825W+H3XiRUNUZT2kR9Ri0+lp+UM3iQtS8uOE23Ly4KYtvqH13jghUntJRAewuzNLDXp8RxdcaA3cMY6TO2IeSFRXezeWIjCqyhsUdMYuCgYTZSKpBype1zRfq8FshvfBPc6BAQWl7/QxIDp3VGo1J3vn42OEs3qznws+YLRXbymyB19a9XBx6n/owcyxlEYyFWCi+kG9F+EyD/4yn80+agaZ9P7ay2Dny99aK2o91FkfEOY8hBwyfi5uwx2y5SaHmG+oq/zl1FX/8irOf8Y3vAcX/6uLP6A6nvMO24edSGPjQc827Rw2atX+z2bKq0CmW9mOtYnr5/AfDa1ZfPaXnKtlWborup7QYx+Or2uWb+N3N//2+yDcXMqIJdf55xl7/vsj4WoPPlxLxtVrkJ4w/tTe3mLdATOOYwxcq52w5Wxz5MbPdVs5O8/lhfE7dPj0bIiPQ3QV0iqm4m3YX8hRfc6jQ3fWepevMqUDJd86Z4vwM40CWHnn+WphsGHfieF02D3tmZvpWD+kBpNCFcLnZhcmmrhpGzzbdA+sQ1ar18OJD87IOKOFoRNznaHPNHUfUNhvY1iU+uhvEvpKHaUn3qK3exVVyX4joipp3um7FmYJWmA+WbIDshRpbVRx5/nqstCgy87FGbfVB8yDGCqS+2qCsnRwnSAN6zgzxfdB2nBT/vZ4/6uxb6oH8b4VBRxiIB93wLa47hG3w2SL/2Z27yOXJFwZpSJaBYyvajA7vRRYNKqljXKpt/CFD/tSMr18DKKbwB0xggBePatl1nki0yvqW5zchlyZmJ0OTxJ3D+fsYJs/mxYN5+Le5oagtcl+YsVvy8kSjI2YGvGjvmpkRS9W2dtXqWnVuxUhURm1lKtou/hdEq19VBp9OjGvHEQSmrpuf2R24mXGheil8KeiANY8fW1VERUfBImb64j12caBZmRViZHbeVMjCrPDg9A90IXrtnsYCuZtRQ0PyrKDjBNOsPfKsg1pA02gHlVr0OXiFhtp6nJqXVzcbfM0KnzC3ggOENPE9VBdmHKN6LYaijb4wXxJn5A0FSDF5j+h1ooZx885Jt3ZKzO5n7Z5WfNEOtyyPqQEnn7WLv5Fis3PdgMshjF1FRydbNyeBbyKI1oN1TRVrVK7kgsb/zjX4NDPIRMctVeaxVB38Vh1x5KbeJbU138AM5KzmZu3uny0ErygxiJF7GVXUrPzFxrlx1uFdAaZFDN9cvIb74qD9tzBMo7L7WIEYK+sla1DVMHpF0F7b3+Y6S+zjvLeDMCpapmJo1weBWuxKF3rOocih1gun4BoJh1kWnV/Jmiq6uOhK3VfKxEHEkafjLgK3oujaPzY6SXg8phhL4TNR1xvJd1Wa0aYFfPUMLrNBDCh4AuGRTbtKMc6Z1Udj8evY/ZpCuMAUefdo69DZUngoqE1P9A3PJfOf7WixCEj+Y6t7fYeHbbxUAoFV3M89cCKfma3fc1+jKRe7MFWEbQqEfyzO2x/wrO2VYH7iYdQ9BkPyI8/3kXBpLaCpU7eC0Yv/am/tEDu7HZpqg0EvHo0nf/R/gRzUWy33/HXMJQeu1GylKmOkXzlCfGFruAcPPhaGqZOtu19zsJ1SO2Jz4Ztth5cBX6mRQwWmDwryG9FUMlZzNckMdK+IoMJv1rOWnBamS2w2KHiaPMPLC15hCZm4KTpoZyj4E2TqC/P6r7/EhnDMhKicZZ1ZwxuC7DPzDGs53q8gXaI9kFTK+2LTq7bhwsTbrMV8Rsfua5lMS0FwbTitUVnVa1yTb5IX51mmYnUcP9wPr8Ji1tiYJeJV9GZTrQhF7vvdU2OTU42ogJ9FDwhmycI2LIg++03C6scYhUyUuMV5tkw6kGUoL+mjNC38+wMdWNljn6tGPpRES7veqrSn5TRuv+dh6JVL/iDHU1db4c9WK3++OrH3PqziF916UMUKn8G67nN60GfWiHrXYhUG3yVWmyYak59NHj8t1smG4UDiWz2rPHNrKnN4Zo1LBbr2/eF9YZ0n0blx2nG4X+EKFxvS3W28JESD+FWk61VCD3z/URGHiJl++7TdBwkCj6tGOH3qDb0QqcOF9Kzpj0HUb/KyFW3Yhj2VMKJqGZleFBH7vqvf7WqLC3XMuHV8q8a4sTFuxUtkD/6JIBvKaVjv96ndgruKZ1k/BHzqf2K9fLk7HGXANyLDd1vxkK/i055pnzl+zw6zLnwXlVYVtfmacJgEpRP1hbGgrYPVN6v2lG+idQNGmwcKXu/8xEj/P6qe/sB2WmwNp6pp8jaISMkwdleFXYK55NHWLTTbutSUqjBfDGWo/Yg918qQ+8BRZSAHZbfuNZz2O0sov1Ue4CWlVg3rFhM3Kljj9ksGd/NUhk4nH+a5UN2+1i8+NM3vRNp7uQ6sqexSCukEVlVZriHNqFi5rLm9TMWa4qm3idJqppQACol2l4VSuvWLfta4JcXy3bROPNbXOgdOhG47LC0CwW/dMlSx4Jf17aEU3yA1x9p+Yc0jupXgcMuYNku64iYOkGToVDuJvlbEKlJqsmiHbvNrIVZEH+yFdF8DbleZ6iNiWwMqvtMp/mSpwx5KxRrT9p3MAPTHGtMbfvdFhyj9vhaKcn3At8Lc16Ai+vBcSp1ztXi7rCJZx/ql7TXcclq6Q76UeKWDy9boS0WHIjUuWhPG8LBmW5y2rhuTpM5vsLt+HOLh1Yf0DqXa9tsfC+kaKt2htA0ai/L2i7RKoNjEwztkmRU0GfgW1TxUvPFhg0V7DdfWJk5gfrccpYv+MA9M0dkGTLECeYwUixRzjRFdmjG7zdZIl3XKB9YliNKI31lfa7i2JG5C8Ss+rHe0D7Z696/V3DEAOWHnQ9yNahMUl5kENWS6pHKKp2D1BaSrrHdE1w2qNxIztpXgUIrF0bm15YML4b6V1k+GpNysTahKMVrrS85lTVo9OGJ96I47eAy5rYWpRf/mIzeoYU1DKaQCTUVwrhHeyNoDqHel+lLxr9WKzhSYw7vrR6+V5q0pfi2k3L1zqkubY6rrd9ZLvSuWNf0uqnkY+FpTvFzSW9Fp0b9l8JA7THV9eCi/PY/SCZIUYx3BU2alj7Cm3VV6eYpios4b6WuNOJdYXUK3zTqj5CVG2FqYM4Z7CuIU0qO05XR0d71FHM0YhZmJmTRfLlXEumN82BGtzdX0S19t1e+bUieK8zRmqpa4Qc5TSjifmaQsY2ETLjhI36gMR1+7qpjdXXHiceUekfBaucHShAOiFXmv3sNmGQyU5iVgnoocuonQXEPTFwslHtS8R+A47StI9wj0iSrtbi5rMysczFiImsQ+bdFClnFjjpXXwMy6O7qfjOr8Fb0a7ODItisjnn3EQO16+ypd1cwyaAW5Yzxz5QknfMO7643fXW/I9y3U2xH27Oapqr56Z/tEzglj6IbT6HEHjopiXqeRbe5mQQvxtcbDOVverN0ZgMdzqRYRjaXtMRd56Q4cZSmdPvZJdSrhJ1D9zNXPqAEqPIavPdfubt5oke2kmv0dztIszSv2VYuoyf1UuopbsYb+uX9h6WpwjpgtZ6fNNawNJ4q8O3CFoSbioAaOSZMx2GYaPYB+rEb6qjQiNRFQ76TvwNFVKD+BhH9VhcKGsXzmMI7BptU/CNWolM7YzROvpFAntsiWJp6eR2d3GarcYShVYSUqhmYOWj5E96NK2WvmYNTeY7Zs4RUEdv9h9QT4EseKt6LzLrqEOs3hxAY1MaNWpSa6zZx8F3YOVeCYMS88W+CYHDuWe4yoc6YK+djDuEOrBR5lvh0r+Q9uM88lrjx9x9AtgpQVNE8r+3O6Gvw59D+kBF/UMXyhliYUtPjmvXGY6Dk3x+kEOW+GtdMVC4EZTqoS/jmR0P0LS75DOc/w2vnri97M4SdbZ8qeU7gg8DVbERkU5geaMQO3mYrSYyAngeUQqrN0C0/vsFmcgWNXNeidsTAj7/4MncJR0caaBUpbLK1yBCBNRjEv6KvuVSdpPnEMJdsRRtqJ+U8tN1gXA4ePHc6ZT0eviI73UOJF0fEZ8YaneAQqQdGphNvwM4nIqPnXxV0xA0fnCT+oAhJuyw/q8jO0y8CjSteZExwBpIN6SvNp6A5G/abi6egeND/1GTguhuNjaUbbnSbGd4L8937Ezm34Eyi6n1maeOBxh3PI0jzJDf5mh/BsLD7F2GOKvlA/5gtvxI3/eV4sLfKW5Wy+oio+es/u6T8UU+nsofy57Icb/JlZHPFtCgd/x+bwt3ZT+xXTtTtTrGAb4QehC6X9G+8YT+ozcLxDsdCjsuOqwPFnrdLYaFc92Ui0m4fr39lYmlCaqTit7G6O/3kWDkgtXjNH4BiEm/+jegQnihOtfffn33WxsFjhfMd48HT+f6o6X65j7XR8WLSHMFkxbvOYsrRsF1bowDuSQ18Mkxk4qz2zoGPL5fu9h2Hqmt1asl3Q3Yu3szOc+spiCmX4AETBM3pLoTYSp3sVxahyhL8eC4mPN9k2x3o0xkiixIzM3CZFzf5oR4mecQ5+ax2wCah3/crmnHoqR0+KMaOPxRif1oEFRFOO/kTPPmtww+NfMXxEK6gn6iU32U6fFruIz8Q4WgljtnaCVTBgWx7diUdshC9ZEa5yKpRBBeW12r/iNc/+EgNqmhswNB8SBoihHXeDF7rrWDLcmt3V8GYYN7pXRy4DZjj4DJuUBL5iC3DQAaoo4vkftqVTYRGLS3mHZ7gdmdTTqbgNN/PTdTCOTgXolc88MhXAEUMdX0iy1JMuk5wLsgeu0QUYlz2S4skTWwJz6pOm/8ihrmgGfFgri+ZWUK2gAPHgbWa8jaocdSuM4FJYoKicYX/ZSENkg9Q1ZzJfwScfVnR2DegOGwCvmogaWJCLQepv9WNlU6QgsmOwICquU28Mlk3d9W5E81lU/5Ez0LcX6lwKMWDNluNKfBDUy/phJgBcMnfkh9iRxrdOzgs08JdPB85Lwo+GUSb4t3nC+0byqMZtO2fQJ4U2zGIr49t/28qmmGv2RanDD7a3FEcdtutkW8twwwlUSpb8QalodddbBfNHKDQ828BdE7OBgFdiKYohLawFYqpybQoxATZrheLhdI7+0Zlu9Q1myRcd15r9UIm8K2LGJxqTegntqNVMKnf1a8zQiyUR1rxoqjiFxeHxqFcYUTHfDu7rhbWng6qOxOsI+5A1p9mRyEPdVkTlE24vY54W7bWc6jMgZvNXdfC9/9q7408KDsbdL7Utz7QFSDetz2picArzrdpL8OaCHC9V26RroemtDZ5yNM/KGkWMyTmfnInEvwtSD23UcFcjhaE3VKzkoaEMKGBft4XbIO6forTY1lmGQwVmKicBCiArDzE+1oIxE08fWeviIOD5TznqH+OoHadvoOP20drMPe5Irg3XBQziW2XDuHYzjqQQ4wySssjXUs5H+t3FWYMHppUnBHMx/nYIT5d7OmjDbgD9F6na3m4l7KdkeSO3kTEPXafiWinogag7b52taiZhL1TSvBFmEZafFq2H8khQaZXuitCewT5FBgVtPK0j4xUHPfUz3Q28eac1Z139DAP23dgki94EC8vbDPTQC97HPPSWjUNG5tWKMsaxAEMKC0665Xvo1Ntd07wCLNf8Q56mrEPVpCxlIMVlQlWRxM3oAfpgIc+8KC3rEXUog5g06vt7zgXY8grH7hhwVSaeuvC06YYRAwpbyk/Unzj9hLEZNs2oxPQB9yc+GnL6zTgq7rI++KDJwX2SP8Sd6YzTuw5lV/kU6eQxRD12omfQAW6caTR4LikYkBB1CMOrvgRr/VY75+NSB40Cni6bADAtaK+vyxVWpf9NeKJxN2KYQ8Q2xPB3K1s7fuhvWbr2XpgW044VD6DRs0qXoqKf1NFsaGvKJc47leUV3pppP/5VTKFhaGuol4Esfjf5zyCyUHmHthChcYh4hYLQF+AFWsuq4t0wJyWgdwQVOZiV0efRHPoK5+E1vjz9wTJmVkITC9oEstAsyZSgE/dbicwKr89YUxKZI+owD205Tm5lnnmDRuP/JnzxX3gMtlrcX0UesZdxyQqYQuEW4R51vmQ5xOZteUd8SJruMlTUzhtVw/Nq7eUBcqN2/HVotgfngif60yKEtoUx3WYOZlVJuJOh8u59fzSDPFYtQgqDUAGyGhQOAvKroXMcOYY0qjnStJR/G3aP+Jt1sLVlGV8POwr/6OGsqetnyF3TmTqZjENfnXh51oxe9qVUw2M78EzAJ+IM8lZ1MBPQ9ZWSVc4J3mWSrLKrMHReA5qdGoz0ODRsaA+vwxXA2cAM4qlfzBJA6581m4hzxItQw5dxrrBL3Y6kCbUcFxo1S8jyV44q//+7ASNNudZ6xeaNOSIUffqMn4A9lIjFctYn2gpEPAb3f7p3iIBN8H14FUGQ9ct2hPsL+cEsTgUrR47uJVN4n4wt/wgfwwHuOnLd4yobkofy8JvxSQTA7rMpDIc608SlZFJfZYcmbT0tAHpPE8MrtQ42siTUNWxqvWZOmvu9f0JPoQmg+6l7sZWwyfi6PXkxJnwBraUG0MYG4zYHQz3igy/XsFkx5tNQxw43qvI9dU3f0DdhOUlHKjmi1VAr2Kiy0HZwD8VeEbhh0OiDdMYspolQsYdSwjCcjeowIXNZVUPmL2wwIkYhmXKhGozdCJ4lRKbsf4NBh/XnQoS92NJEWOVOFs2YhN8c5QZFeK0pRdAG40hqvLbmoSA8xQmzOOEc7wLcme9JOsjPCEgpCwUs9E2DohMHRhUeyGIN6TFvrbny8nDuilsDpzrH5mS76APoIEJmItS67sQJ+nfwddzmjPxcBEBBCw0kWDwd0EZCkNeOD7NNQhtBm7KHL9mRxj6U1yWU2puzlIDtpYxdH4ZPeXBJkTGAJfUr/oTCz/iypY6uXaR2V1doPxJYlrw2ghH0D5gbrhFcIxzYwi4a/4hqVdf2DdxBp6vGYDjavxMAAoy+1+3aiO6S3W/QAKNVXagDtvsNtx7Ks+HKgo6U21B+QSZgIogV5Bt+BnXisdVfy9VyXV+2P5fMuvdpAjM1o/K9Z+XnE4EOCrue+kcdYHqAQ0/Y/OmNlQ6OI33jH/uD1RalPaHpJAm2av0/xtpqdXVKNDrc9F2izo23Wu7firgbURFDNX9eGGeYBhiypyXZft2j3hTvzE6PMWKsod//rEILDkzBXfi7xh0eFkfb3/1zzPK/PI5Nk3FbZyTl4mq5BfBoVoqiPHO4Q4QKZAlrQ3MdNfi3oxIjvsM3kAFv3fdufurqYR3PSwX/mpGy/GFI/B2MNPiNdOppWVbs/gjF3YH+QA9jMhlAbhvasAHstB0IJew09iAkmXHl1/TEj+jvHOpOGrPRQXbPADM+Ig2/OEcUcpgPTItMtW4DdqgfYVI/+4hAFWYjUGpOP/UwNuB7+BbKOcALbjobdgzeBQfjgNSp2GOpxzGLj70Vvq5cw2AoYENwKLUtJUX8sGRox4dVa/TN4xKwaKcl9XawQR/uNus700Hf17pyNnezrUgaY9e4MADhEDBpsJT6y1gDJs1q6wlwGhuUzGR7C8kgpjPyHWwsvrf3yn1zJEIRa5eSxoLAZOCR9xbuztxFRJW9ZmMYfCFJ0evm9F2fVnuje92Rc4Pl6A8bluN8MZyyJGZ0+sNSb//DvAFxC2BqlEsFwccWeAl6CyBcQV1bx4mQMBP1Jxqk1EUADNLeieS2dUFbQ/c/kvwItbZ7tx0st16viqd53WsRmPTKv2AD8CUnhtPWg5aUegNpsYgasaw2+EVooeNKmrW3MFtj76bYHJm5K9gpAXZXsE5U8DM8XmVOSJ1F1WnLy6nQup+jx52bAb+rCq6y9WXl2B2oZDhfDkW7H3oYfT/4xx5VncBuxMXP2lNfhUVQjSSzSRbuZFE4vFawlzveXxaYKVs8LpvAb8IRYF3ZHiRnm0ADeNPWocwxSzNseG7NrSEVZoHdKWqaGEBz1N8Pt7kFbqh3LYmAbm9i1IChIpLpM5AS6mr6OAPHMwwznVy61YpBYX8xZDN/a+lt7n+x5j4bNOVteZ8lj3hpAHSx1VR8vZHec4AHO9XFCdjZ9eRkSV65ljMmZVzaej2qFn/qt1lvWzNZEfHxK3qOJrHL6crr0CRzMox5f2e8ALBB4UGFZKA3tN6F6IXd32GTJXGQ7DTi9j/dNcLF9jCbDcWGKxoKTYblIwbLDReL00LRcDPMcQuXLMh5YzgtfjkFK1DP1iDzzYYVZz5M/kWYRlRpig1htVRjVCknm+h1M5LiEDXOyHREhvzCGpFZjHS0RsK27o2avgdilrJkalWqPW3D9gmwV37HKmfM3F8YZj2ar+vHFvf3B8CRoH4kDHIK9mrAg+owiEwNjjd9V+FsQKYR8czJrUkf7Qoi2YaW6EVDZp5zYlqiYtuXOTHk4fAcZ7qBbdLDiJq0WNV1l2+Hntk1mMWvxrYmc8kIx8G3rW36J6Ra4lLrTOCgiOihmow+YnzUT19jbV2B3RWqSHyxkhmgsBqMYWvOcUom1jDQ436+fcbu3xf2bbeqU/ca+C4DOKE+e3qvmeMqW3AxejfzBRFVcwVYPq4L0APSWWoJu+5UYX4qg5U6YTioqQGPG9XrnuZ/BkxuYpe6Li87+18EskyQW/uA+uk2rpHpr6hut2TlVbKgWkFpx+AZffweiw2+VittkEyf/ifinS/0ItRL2Jq3tQOcxPaWO2xrG68GdFoUpZgFXaP2wYVtRc6xYCfI1CaBqyWpg4bx8OHBQwsV4XWMibZZ0LYjWEy2IxQ1mZrf1/UNbYCJplWu3nZ4WpodIGVA05d+RWSS+ET9tH3RfGGmNI1cIY7evZZq7o+a0bjjygpmR3mVfalkT/SZGT27Q8QGalwGlDOS9VHCyFAIL0a1Q7JiW3saz9gqY8lqKynFrPCzxkU4SIfLc9VfCI5edgRhDXs0edO992nhTKHriREP1NJC6SROMgQ0xO5kNNZOhMOIT99AUElbxqeZF8A3xrfDJsWtDnUenAHdYWSwAbYjFqQZ+D5gi3hNK8CSxU9i6f6ClL9IGlj1OPMQAsr84YG6ijsJpCaGWj75c3yOZKBB9mNpQNPUKkK0D6wgLH8MGoyRxTX6Y05Q4AnYNXMZwXM4eij/9WpsM/9CoRnFQXGR6MEaY+FXvXEO3RO0JaStk6OXuHVATHJE+1W+TU3bSZ2ksMtqjO0zfSJCdBv7y2d8DMx6TfVme3q0ZpTKMMu4YL/t7ciTNtdDkwPogh3Cnjx7qk08SHwf+dksZ7M2vCOlfsF0hQ6J4ehPCaHTNrM/zBSOqD83dBEBCW/F/LEmeh0nOHd7oVl3/Qo/9GUDkkbj7yz+9cvvu+dDAtx8NzCDTP4iKdZvk9MWiizvtILLepysflSvTLFBZ37RLwiriqyRxYv/zrgFd/9XVHh/OmzBvDX4mitMR/lUavs2Vx6cR94lzAkplm3IRNy4TFfu47tuYs9EQPIPVta4P64tV+sZ7n3ued3cgEx2YK+QL5+xms6osk8qQbTyuKVGdaX9FQqk6qfDnT5ykxk0VK7KZ62b6DNDUfQlqGHxSMKv1P0XN5BqMeKG1P4Wp5QfZDUCEldppoX0U6ss2jIko2XpURKCIhfaOqLPfShdtS37ZrT+jFRSH2xYVV1rmT/MBtRQhxiO4MQ3iAGlaZi+9PWBEIXOVnu9jN1f921lWLZky9bqbM3J2MAAI9jmuAx3gyoEUa6P2ivs0EeNv/OR+AX6q5SW6l5HaoFuS6jr6yg9limu+P0KYKzfMXWcQSfTXzpOzKEKpwI3YGXZpSSy2LTlMgfmFA3CF6R5c9xWEtRuCg2ZPUQ2Nb6dRFTNd4TfGHrnEWSKHPuRyiJSDAZ+KX0VxmSHjGPbQTLVpqixia2uyhQ394gBMt7C3ZAmxn/DJS+l1fBsAo2Eir/C0jG9csd4+/tp12pPc/BVJGaK9mfvr7M/CeztrmCO5qY06Edi4xAGtiEhnWAbzLy2VEyazE1J5nPmgU4RpW4Sa0TnOT6w5lgt3/tMpROigHHmexBGAMY0mdcDbDxWIz41NgdD6oxgHsJRgr5RnT6wZAkTOcStU4NMOQNemSO7gxGahdEsC+NRVGxMUhQmmM0llWRbbmFGHzEqLM4Iw0H7577Kyo+Zf+2cUFIOw93gEY171vQaM0HLwpjpdRR6Jz7V0ckE7XzYJ0TmY9znLdzkva0vNrAGGT5SUZ5uaHDkcGvI0ySpwkasEgZPMseYcu85w8HPdSNi+4T6A83iAwDbxgeFcB1ZM2iGXzFcEOUlYVrEckaOyodfvaYSQ7GuB4ISE0nYJc15X/1ciDTPbPCgYJK55VkEor4LvzL9S2WDy4xj+6FOqVyTAC2ZNowheeeSI5hA/02l8UYkv4nk9iaVn+kCVEUstgk5Hyq+gJm6R9vG3rhuM904he/hFmNQaUIATB1y3vw+OmxP4X5Yi6A5I5jJufHCjF9+AGNwnEllZjUco6XhsO5T5+R3yxz5yLVOnAn0zuS+6zdj0nTJbEZCbXJdtpfYZfCeCOqJHoE2vPPFS6eRLjIJlG69X93nfR0mxSFXzp1Zc0lt/VafDaImhUMtbnqWVb9M4nGNQLN68BHP7AR8Il9dkcxzmBv8PCZlw9guY0lurbBsmNYlwJZsA/B15/HfkbjbwPddaVecls/elmDHNW2r4crAx43feNkfRwsaNq/yyJ0d/p5hZ6AZajz7DBfUok0ZU62gCzz7x8eVfJTKA8IWn45vINLSM1q+HF9CV9qF3zP6Ml21kPPL3CXzkuYUlnSqT+Ij4tI/od5KwIs+tDajDs64owN7tOAd6eucGz+KfO26iNcBFpbWA5732bBNWO4kHNpr9D955L61bvHCF/mwSrz6eQaDjfDEANqGMkFc+NGxpKZzCD2sj/JrHd+zlPQ8Iz7Q+2JVIiVCuCKoK/hlAEHzvk/Piq3mRL1rT/fEh9hoT5GJmeYswg1otiKydizJ/fS2SeKHVu6Z3JEHjiW8NaTQgP5xdBli8nC57XiN9hrquBu99hn9zqwo92+PM2JXtpeVZS0PdqR5mDyDreMMtEws+CpwaRyyzoYtfcvt9PJIW0fJVNNi/FFyRsea7peLvJrL+5b4GOXJ8tAr+ATk9f8KmiIsRhqRy0vFzwRV3Z5dZ3QqIU8JQ/uQpkJbjMUMFj2F9sCFeaBjI4+fL/oN3+LQgjI4zuAfQ+3IPIPFQBccf0clJpsfpnBxD84atwtupkGqKvrH7cGNl/QcWcSi6wcVDML6ljOgYbo+2BOAWNNjlUBPiyitUAwbnhFvLbnqw42kR3Yp2kv2dMeDdcGOX5kT4S6M44KHEB/SpCfl7xgsUvs+JNY9G3O2X/6FEt9FyAn57lrbiu+tl83sCymSvq9eZbe9mchL7MTf/Ta78e80zSf0hYY5eUU7+ff14jv7Xy8qjzfzzzvaJnrIdvFb5BLWKcWGy5/w7+vV2cvIfwHqdTB+RuJK5oj9mbt0Hy94AmjMjjwYNZlNS6uiyxNnwNyt3gdreLb64p/3+08nXkb92LTkkRgFOwk1oGEVllcOj5lv1hfAZywDows0944U8vUFw+A/nuVq/UCygsrmWIBnHyU01d0XJPwriEOvx/ISK6Pk4y2w0gmojZs7lU8TtakBAdne4v/aNxmMpK4VcGMp7si0yqsiolXRuOi1Z1P7SqD3Zmp0CWcyK4Ubmp2SXiXuI5nGLCieFHKHNRIlcY3Pys2dwMTYCaqlyWSITwr2oGXvyU3h1Pf8eQ3w1bnD7ilocVjYDkcXR3Oo1BXgMLTUjNw2xMVwjtp99NhSVc5aIWrDQT5DHPKtCtheBP4zHcw4dz2eRdTMamhlHhtfgqJJHI7NGDUw1XL8vsSeSHyKqDtqoAmrQqsYwvwi7HW3ojWyhIa5oz5xJTaq14NAzFLjVLR12rRNUQ6xohDnrWFb5bG9yf8aCD8d5phoackcNJp+Dw3Due3RM+5Rid7EuIgsnwgpX0rUWh/nqPtByMhMZZ69NpgvRTKZ62ViZ+Q7Dp5r4K0d7EfJuiy06KuIYauRh5Ecrhdt2QpTS1k1AscEHvapNbU3HL1F2TFyR33Wxb5MvH5iZsrn3SDcsxlnnshO8PLwmdGN+paWnQuORtZGX37uhFT64SeuPsx8UOokY6ON85WdQ1dki5zErsJGazcBOddWJEKqNPiJpsMD1GrVLrVY+AOdPWQneTyyP1hRX/lMM4ZogGGOhYuAdr7F/DOiAoc++cn5vlf0zkMUJ40Z1rlgv9BelPqVOpxKeOpzKdF8maK+1Vv23MO9k/8+qpLoxrIGH2EDQlnGmH8CD31G8QqlyQIcpmR5bwmSVw9/Ns6IHgulCRehvZ/+VrM60Cu/r3AontFfrljew74skYe2uyn7JKQtFQBQRJ9ryGic/zQOsbS4scUBctA8cPToQ3x6ZBQu6DPu5m1bnCtP8TllLYA0UTQNVqza5nfew3Mopy1GPUwG5jsl0OVXniPmAcmLqO5HG8Hv3nSLecE9oOjPDXcsTxoCBxYyzBdj4wmnyEV4kvFDunipS8SSkvdaMnTBN9brHUR8xdmmEAp/Pdqk9uextp1t+JrtXwpN/MG2w/qhRMpSNxQ1uhg/kKO30eQ/FyHUDkWHT8V6gGRU4DhDMxZu7xXij9Ui6jlpWmQCqJg3FkOTq3WKneCRYZxBXMNAVLQgHXSCGSqNdjebY94oyIpVjMYehAiFx/tqzBXFHZaL5PeeD74rW5OysFoUXY8sebUZleFTUa/+zBKVTFDopTReXNuZq47QjkWnxjirCommO4L/GrFtVV21EpMyw8wyThL5Y59d88xtlx1g1ttSICDwnof6lt/6zliPzgVUL8jWBjC0o2D6Kg+jNuThkAlaDJsq/AG2aKA//A76avw2KNqtv223P+Wq3StRDDNKFFgtsFukYt1GFDWooFVXitaNhb3RCyJi4cMeNjROiPEDb4k+G3+hD8tsg+5hhmSc/8t2JTSwYoCzAI75doq8QTHe+E/Tw0RQSUDlU+6uBeNN3h6jJGX/mH8oj0i3caCNsjvTnoh73BtyZpsflHLq6AfwJNCDX4S98h4+pCOhGKDhV3rtkKHMa3EG4J9y8zFWI4UsfNzC/Rl5midNn7gwoN9j23HGCQQ+OAZpTTPMdiVow740gIyuEtd0qVxMyNXhHcnuXRKdw5wDUSL358ktjMXmAkvIB73BLa1vfF9BAUZInPYJiwxqFWQQBVk7gQH4ojfUQ/KEjn+A/WR6EEe4CtbpoLe1mzHkajgTIoE0SLDHVauKhrq12zrAXBGbPPWKCt4DGedq3JyGRbmPFW32bE7T20+73BatV/qQhhBWfWBFHfhYWXjALts38FemnoT+9bn1jDBMcUMmYgSc0e7GQjv2MUBwLU8ionCpgV+Qrhg7iUIfUY6JFxR0Y+ZTCPM+rVuq0GNLyJXX6nrUTt8HzFBRY1E/FIm2EeVA9NcXrj7S6YYIChVQCWr/m2fYUjC4j0XLkzZ8GCSLfmkW3PB/xq+nlXsKVBOj7vTvqKCOMq7Ztqr3cQ+N8gBnPaAps+oGwWOkbuxnRYj/x/WjiDclVrs22xMK4qArE1Ztk1456kiJriw6abkNeRHogaPRBgbgF9Z8i/tbzWELN4CvbqtrqV9TtGSnmPS2F9kqOIBaazHYaJ9bi3AoDBvlZasMluxt0BDXfhp02Jn411aVt6S4TUB8ZgFDkI6TP6gwPY85w+oUQSsjIeXVminrwIdK2ZAawb8Se6XOJbOaliQxHSrnAeONDLuCnFejIbp4YDtBcQCwMsYiRZfHefuEJqJcwKTTJ8sx5hjHmJI1sPFHOr6W9AhZ2NAod38mnLQk1gOz2LCAohoQbgMbUK9RMEA3LkiF7Sr9tLZp6lkciIGhE2V546w3Mam53VtVkGbB9w0Yk2XiRnCmbpxmHr2k4eSC0RuNbjNsUfDIfc8DZvRvgUDe1IlKdZTzcT4ZGEb53dp8VtsoZlyXzLHOdAbsp1LPTVaHvLA0GYDFMbAW/WUBfUAdHwqLFAV+3uHvYWrCfhUOR2i89qvCBoOb48usAGdcF2M4aKn79k/43WzBZ+xR1L0uZfia70XP9soQReeuhZiUnXFDG1T8/OXNmssTSnYO+3kVLAgeiY719uDwL9FQycgLPessNihMZbAKG7qwPZyG11G1+ZA3jAX2yddpYfmaKBlmfcK/V0mwIRUDC0nJSOPUl2KB8h13F4dlVZiRhdGY5farwN+f9hEb1cRi41ZcGDn6Xe9MMSTOY81ULJyXIHSWFIQHstVYLiJEiUjktlHiGjntN5/btB8Fu+vp28zl2fZXN+dJDyN6EXhS+0yzqpl/LSJNEUVxmu7BsNdjAY0jVsAhkNuuY0E1G48ej25mSt+00yPbQ4SRCVkIwb6ISvYtmJRPz9Zt5dk76blf+lJwAPH5KDF+vHAmACLoCdG2Adii6dOHnNJnTmZtoOGO8Q1jy1veMw6gbLFToQmfJa7nT7Al89mRbRkZZQxJTKgK5Kc9INzmTJFp0tpAPzNmyL/F08bX3nhCumM/cR/2RPn9emZ3VljokttZD1zVWXlUIqEU7SLk5I0lFRU0AcENXBYazNaVzsVHA/sD3o9hm42wbHIRb/BBQTKzAi8s3+bMtpOOZgLdQzCYPfX3UUxKd1WYVkGH7lh/RBBgMZZwXzU9+GYxdBqlGs0LP+DZ5g2BWNh6FAcR944B+K/JTWI3t9YyVyRhlP4CCoUk/mmF7+r2pilVBjxXBHFaBfBtr9hbVn2zDuI0kEOG3kBx8CGdPOjX1ph1POOZJUO1JEGG0jzUy2tK4X0CgVNYhmkqqQysRNtKuPdCJqK3WW57kaV17vXgiyPrl4KEEWgiGF1euI4QkSFHFf0TDroQiLNKJiLbdhH0YBhriRNCHPxSqJmNNoketaioohqMglh6wLtEGWSM1EZbQg72h0UJAIPVFCAJOThpQGGdKfFovcwEeiBuZHN2Ob4uVM7+gwZLz1D9E7ta4RmMZ24OBBAg7Eh6dLXGofZ4U2TFOCQMKjwhVckjrydRS+YaqCw1kYt6UexuzbNEDyYLTZnrY1PzsHZJT4U+awO2xlqTSYu6n/U29O2wPXgGOEKDMSq+zTUtyc8+6iLp0ivav4FKx+xxVy4FxhIF/pucVDqpsVe2jFOfdZhTzLz2QjtzvsTCvDPU7bzDH2eXVKUV9TZ+qFtaSSxnYgYdXKwVreIgvWhT9eGDB2OvnWyPLfIIIfNnfIxU8nW7MbcH05nhlsYtaW9EZRsxWcKdEqInq1DiZPKCz7iGmAU9/ccnnQud2pNgIGFYOTAWjhIrd63aPDgfj8/sdlD4l+UTlcxTI9jbaMqqN0gQxSHs60IAcW3cH4p3V1aSciTKB29L1tz2eUQhRiTgTvmqc+sGtBNh4ky0mQJGsdycBREP+fAaSs1EREDVo5gvgi5+aCN7NECw30owbCc1mSpjiahyNVwJd1jiGgzSwfTpzf2c5XJvG/g1n0fH88KHNnf+u7ZiRMlXueSIsloJBUtW9ezvsx9grfsX/FNxnbxU1Lvg0hLxixypHKGFAaPu0xCD8oDTeFSyfRT6s8109GMUZL8m2xXp8X2dpPCWWdX84iga4BrTlOfqox4shqEgh/Ht4qRst52cA1xOIUuOxgfUivp6v5f8IVyaryEdpVk72ERAwdT4aoY1usBgmP+0m06Q216H/nubtNYxHaOIYjcach3A8Ez/zc0KcShhel0HCYjFsA0FjYqyJ5ZUH1aZw3+zWC0hLpM6GDfcAdn9fq2orPmZbW6XXrf+Krc9RtvII5jeD3dFoT1KwZJwxfUMvc5KLfn8rROW23Jw89sJ2a5dpB3qWDUBWF2iX8OCuKprHosJ2mflBR+Wqs86VvgI/XMnsqb97+VlKdPVysczPj8Jhzf+WCvGBHijAqYlavbF60soMWlHbvKT+ScvhprgeTln51xX0sF+Eadc/l2s2a5BgkVbHYyz0E85p0LstqH+gEGiR84nBRRFIn8hLSZrGwqjZ3E29cuGi+5Z5bp7EM8MWFa9ssS/vy4VrDfECSv7DSU84DaP0sXI3Ap4lWznQ65nQoTKRWU30gd7Nn8ZowUvGIx4aqyXGwmA/PB4qN8msJUODezUHEl0VP9uo+cZ8vPFodSIB4C7lQYjEFj8yu49C2KIV3qxMFYTevG8KqAr0TPlkbzHHnTpDpvpzziAiNFh8xiT7C/TiyH0EguUw4vxAgpnE27WIypV+uFN2zW7xniF/n75trs9IJ5amB1zXXZ1LFkJ6GbS/dFokzl4cc2mamVwhL4XU0Av5gDWAl+aEWhAP7t2VIwU+EpvfOPDcLASX7H7lZpXA2XQfbSlD4qU18NffNPoAKMNSccBfO9YVVgmlW4RydBqfHAV7+hrZ84WJGho6bNT0YMhxxLdOx/dwGj0oyak9aAkNJ8lRJzUuA8sR+fPyiyTgUHio5+Pp+YaKlHrhR41jY5NESPS3x+zTMe0S2HnLOKCOQPpdxKyviBvdHrCDRqO+l96HhhNBLXWv4yEMuEUYo8kXnYJM8oIgVM4XJ+xXOev4YbWeqsvgq0lmw4/PiYr9sYLt+W5EAuYSFnJEan8CwJwbtASBfLBBpJZiRPor/aCJBZsM+MhvS7ZepyHvU8m5WSmaZnxuLts8ojl6KkS8oSAHkq5GWlCB/NgJ5W3rO2Cj1MK7ahxsCrbTT3a0V/QQH+sErxV4XUWDHx0kkFy25bPmBMBQ6BU3HoHhhYcJB9JhP6NXUWKxnE0raXHB6U9KHpWdQCQI72qevp5fMzcm+AvC85rsynVQhruDA9fp9COe7N56cg1UKGSas89vrN+WlGLYTwi5W+0xYdKEGtGCeNJwXKDU0XqU5uQYnWsMwTENLGtbQMvoGjIFIEMzCRal4rnBAg7D/CSn8MsCvS+FDJJAzoiioJEhZJgAp9n2+1Yznr7H+6eT4YkJ9Mpj60ImcW4i4iHDLn9RydB8dx3QYm3rsX6n4VRrZDsYK6DCGwkwd5n3/INFEpk16fYpP6JtMQpqEMzcOfQGAHXBTEGzuLJ03GYQL9bmV2/7ExDlRf+Uvf1sM2frRtCWmal12pMgtonvSCtR4n1CLUZRdTHDHP1Otwqd+rcdlavnKjUB/OYXQHUJzpNyFoKpQK+2OgrEKpGyIgIBgn2y9QHnTJihZOpEvOKIoHAMGAXHmj21Lym39Mbiow4IF+77xNuewziNVBxr6KD5e+9HzZSBIlUa/AmsDFJFXeyrQakR3FwowTGcADJHcEfhGkXYNGSYo4dh4bxwLM+28xjiqkdn0/3R4UEkvcBrBfn/SzBc1XhKM2VPlJgKSorjDac96V2UnQYXl1/yZPT4DVelgO+soMjexXwYO58VLl5xInQUZI8jc3H2CPnCNb9X05nOxIy4MlecasTqGK6s2az4RjpF2cQP2G28R+7wDPsZDZC/kWtjdoHC7SpdPmqQrUAhMwKVuxCmYTiD9q/O7GHtZvPSN0CAUQN/rymXZNniYLlJDE70bsk6Xxsh4kDOdxe7A2wo7P9F5YvqqRDI6brf79yPCSp4I0jVoO4YnLYtX5nzspR5WB4AKOYtR1ujXbOQpPyYDvfRE3FN5zw0i7reehdi7yV0YDRKRllGCGRk5Yz+Uv1fYl2ZwrnGsqsjgAVo0xEUba8ohjaNMJNwTwZA/wBDWFSCpg1eUH8MYL2zdioxRTqgGQrDZxQyNzyBJPXZF0+oxITJAbj7oNC5JwgDMUJaM5GqlGCWc//KCIrI+aclEe4IA0uzv7cuj6GCdaJONpi13O544vbtIHBF+A+JeDFUQNy61Gki3rtyQ4aUywn6ru314/dkGiP8Iwjo0J/2Txs49ZkwEl4mx+iYUUO55I6pJzU4P+7RRs+DXZkyKUYZqVWrPF4I94m4Wx1tXeE74o9GuX977yvJ/jkdak8+AmoHVjI15V+WwBdARFV2IPirJgVMdsg1Pez2VNHqa7EHWdTkl3XTcyjG9BiueWFvQfXI8aWSkuuRmqi/HUuzqyvLJfNfs0txMqldYYflWB1BS31WkuPJGGwXUCpjiQSktkuBMWwHjSkQxeehqw1Kgz0Trzm7QbtgxiEPDVmWCNCAeCfROTphd1ZNOhzLy6XfJyG6Xgd5MCAZw4xie0Sj5AnY1/akDgNS9YFl3Y06vd6FAsg2gVQJtzG7LVq1OH2frbXNHWH/NY89NNZ4QUSJqL2yEcGADbT38X0bGdukqYlSoliKOcsSTuqhcaemUeYLLoI8+MZor2RxXTRThF1LrHfqf/5LcLAjdl4EERgUysYS2geE+yFdasU91UgUDsc2cSQ1ZoT9+uLOwdgAmifwQqF028INc2IQEDfTmUw3eZxvz7Ud1z3xc1PQfeCvfKsB9jOhRj7rFyb9XcDWLcYj0bByosychMezMLVkFiYcdBBQtvI6K0KRuOZQH2kBsYHJaXTkup8F0eIhO1/GcIwWKpr2mouB7g5TUDJNvORXPXa/mU8bh27TAZYBe2sKx4NSv5OjnHIWD2RuysCzBlUfeNXhDd2jxnHoUlheJ3jBApzURy0fwm2FwwsSU0caQGl0Kv8hopRQE211NnvtLRsmCNrhhpEDoNiZEzD2QdJWKbRRWnaFedXHAELSN0t0bfsCsMf0ktfBoXBoNA+nZN9+pSlmuzspFevmsqqcMllzzvkyXrzoA+Ryo1ePXpdGOoJvhyru+EBRsmOp7MXZ0vNUMUqHLUoKglg1p73sWeZmPc+KAw0pE2zIsFFE5H4192KwDvDxdxEYoDBDNZjbg2bmADTeUKK57IPD4fTYF4c6EnXx/teYMORBDtIhPJneiZny7Nv/zG+YmekIKCoxr6kauE2bZtBLufetNG0BtBY7f+/ImUypMBvdWu/Q7vTMRzw5aQGZWuc1V0HEsItFYMIBnoKGZ0xcarba/TYZq50kCaflFysYjA4EDKHqGdpYWdKYmm+a7TADmW35yfnOYpZYrkpVEtiqF0EujI00aeplNs2k+qyFZNeE3CDPL9P6b4PQ/kataHkVpLSEVGK7EX6rAa7IVNrvZtFvOA6okKvBgMtFDAGZOx88MeBcJ8AR3AgUUeIznAN6tjCUipGDZONm1FjWJp4A3QIzSaIOmZ7DvF/ysYYbM/fFDOV0jntAjRdapxJxL0eThpEhKOjCDDq2ks+3GrwxqIFKLe1WdOzII8XIOPGnwy6LKXVfpSDOTEfaRsGujhpS4hBIsMOqHbl16PJxc4EkaVu9wpEYlF/84NSv5Zum4drMfp9yXbzzAOJqqS4YkI4cBrFrC7bMPiCfgI3nNZAqkk3QOZqR+yyqx+nDQKBBBZ7QKrfGMCL+XpqFaBJU0wpkBdAhbR4hJsmT5aynlvkouoxm/NjD5oe6BzVIO9uktM+/5dEC5P7vZvarmuO/lKXz4sBabVPIATuKTrwbJP8XUkdM6uEctHKXICUJGjaZIWRbZp8czquQYfY6ynBUCfIU+gG6wqSIBmYIm9pZpXdaL121V7q0VjDjmQnXvMe7ysoEZnZL15B0SpxS1jjd83uNIOKZwu5MPzg2NhOx3xMOPYwEn2CUzbSrwAs5OAtrz3GAaUkJOU74XwjaYUmGJdZBS1NJVkGYrToINLKDjxcuIlyfVsKQSG/G4DyiO2SlQvJ0d0Ot1uOG5IFSAkq+PRVMgVMDvOIJMdqjeCFKUGRWBW9wigYvcbU7CQL/7meF2KZAaWl+4y9uhowAX7elogAvItAAxo2+SFxGRsHGEW9BnhlTuWigYxRcnVUBRQHV41LV+Fr5CJYV7sHfeywswx4XMtUx6EkBhR+q8AXXUA8uPJ73Pb49i9KG9fOljvXeyFj9ixgbo6CcbAJ7WHWqKHy/h+YjBwp6VcN7M89FGzQ04qbrQtgrOFybg3gQRTYG5xn73ArkfQWjCJROwy3J38Dx/D7jOa6BBNsitEw1wGq780EEioOeD+ZGp2J66ADiVGMayiHYucMk8nTK2zzT9CnEraAk95kQjy4k0GRElLL5YAKLQErJ5rp1eay9O4Fb6yJGm9U4FaMwPGxtKD6odIIHKoWnhKo1U8KIpFC+MVn59ZXmc7ZTBZfsg6FQ8W10YfTr4u0nYrpHZbZ1jXiLmooF0cOm0+mPnJBXQtepc7n0BqOipNCqI6yyloTeRShNKH04FIo0gcMk0H/xThyN4pPAWjDDkEp3lNNPRNVfpMI44CWRlRgViP64eK0JSRp0WUvCWYumlW/c58Vcz/yMwVcW5oYb9+26TEhwvbxiNg48hl1VI1UXTU//Eta+BMKnGUivctfL5wINDD0giQL1ipt6U7C9cd4+lgqY2lMUZ02Uv6Prs+ZEZer7ZfWBXVghlfOOrClwsoOFKzWEfz6RZu1eCs+K8fLvkts5+BX0gyrFYve0C3qHrn5U/Oh6D/CihmWIrY7HUZRhJaxde+tldu6adYJ+LeXupQw0XExC36RETdNFxcq9glMu4cNQSX9cqR/GQYp+IxUkIcNGWVU7ZtGa6P3XAyodRt0XeS3Tp01AnCh0ZbUh4VrSZeV9RWfSoWyxnY3hzcZ30G/InDq4wxRrEejreBxnhIQbkxenxkaxl+k7eLUQkUR6vKJ2iDFNGX3WmVA1yaOH+mvhBd+sE6vacQzFobwY5BqEAFmejwW5ne7HtVNolOUgJc8CsUxmc/LBi8N5mu9VsIA5HyErnS6zeCz7VLI9+n/hbT6hTokMXTVyXJRKSG2hd2labXTbtmK4fNH3IZBPreSA4FMeVouVN3zG5x9CiGpLw/3pceo4qGqp+rVp+z+7yQ98oEf+nyH4F3+J9IheDBa94Wi63zJbLBCIZm7P0asHGpIJt3PzE3m0S4YIWyXBCVXGikj8MudDPB/6Nm2v4IxJ5gU0ii0guy5SUHqGUYzTP0jIJU5E82RHUXtX4lDdrihBLdP1YaG1AGUC12rQKuIaGvCpMjZC9bWSCYnjDlvpWbkdXMTNeBHLKiuoozMGIvkczmP0aRJSJ8PYnLCVNhKHXBNckH79e8Z8Kc2wUej4sQZoH8qDRGkg86maW/ZQWGNnLcXmq3FlXM6ssR/3P6E/bHMvm6HLrv1yRixit25JsH3/IOr2UV4BWJhxXW5BJ6Xdr07n9kF3ZNAk6/Xpc5MSFmYJ2R7bdL8Kk7q1OU9Elg/tCxJ8giT27wSTySF0GOxg4PbYJdi/Nyia9Nn89CGDulfJemm1aiEr/eleGSN+5MRrVJ4K6lgyTTIW3i9cQ0dAi6FHt0YMbH3wDSAtGLSAccezzxHitt1QdhW36CQgPcA8vIIBh3/JNjf/Obmc2yzpk8edSlS4lVdwgW5vzbYEyFoF4GCBBby1keVNueHAH+evi+H7oOVfS3XuPQSNTXOONAbzJeSb5stwdQHl1ZjrGoE49I8+A9j3t+ahhQj74FCSWpZrj7wRSFJJnnwi1T9HL5qrCFW/JZq6P62XkMWTb+u4lGpKfmmwiJWx178GOG7KbrZGqyWwmuyKWPkNswkZ1q8uptUlviIi+AXh2bOOTOLsrtNkfqbQJeh24reebkINLkjut5r4d9GR/r8CBa9SU0UQhsnZp5cP+RqWCixRm7i4YRFbtZ4EAkhtNa6jHb6gPYQv7MKqkPLRmX3dFsK8XsRLVZ6IEVrCbmNDc8o5mqsogjAQfoC9Bc7R6gfw03m+lQpv6kTfhxscDIX6s0w+fBxtkhjXAXr10UouWCx3C/p/FYwJRS/AXRKkjOb5CLmK4XRe0+xeDDwVkJPZau52bzLEDHCqV0f44pPgKOkYKgTZJ33fmk3Tu8SdxJ02SHM8Fem5SMsWqRyi2F1ynfRJszcFKykdWlNqgDA/L9lKYBmc7Zu/q9ii1FPF47VJkqhirUob53zoiJtVVRVwMR34gV9iqcBaHbRu9kkvqk3yMpfRFG49pKKjIiq7h/VpRwPGTHoY4cg05X5028iHsLvUW/uz+kjPyIEhhcKUwCkJAwbR9pIEGOn8z6svAO8i89sJ3dL5qDWFYbS+HGPRMxYwJItFQN86YESeJQhn2urGiLRffQeLptDl8dAgb+Tp47UQPxWOw17OeChLN1WnzlkPL1T5O+O3Menpn4C3IY5LEepHpnPeZHbvuWfeVtPlkH4LZjPbBrkJT3NoRJzBt86CO0Xq59oQ+8dsm0ymRcmQyn8w71mhmcuEI5byuF+C88VPYly2sEzjlzAQ3vdn/1+Hzguw6qFNNbqenhZGbdiG6RwZaTG7jTA2X9RdXjDN9yj1uQpyO4Lx8KRAcZcbZMafp4wPOd5MdXoFY52V1A8M9hi3sso93+uprE0qYNMjkE22CvK4HuUxqN7oIz5pWuETq1lQAjqlSlqdD2Rnr/ggp/TVkQYjn9lMfYelk2sH5HPdopYo7MHwlV1or9Bxf+QCyLzm92vzG2wjiIjC/ZHEJzeroJl6bdFPTpZho5MV2U86fLQqxNlGIMqCGy+9WYhJ8ob1r0+Whxde9L2PdysETv97O+xVw+VNN1TZSQN5I6l9m5Ip6pLIqLm4a1B1ffH6gHyqT9p82NOjntRWGIofO3bJz5GhkvSWbsXueTAMaJDou99kGLqDlhwBZNEQ4mKPuDvVwSK4WmLluHyhA97pZiVe8g+JxmnJF8IkV/tCs4Jq/HgOoAEGR9tCDsDbDmi3OviUQpG5D8XmKcSAUaFLRXb2lmJTNYdhtYyfjBYZQmN5qT5CNuaD3BVnlkCk7bsMW3AtXkNMMTuW4HjUERSJnVQ0vsBGa1wo3Qh7115XGeTF3NTz8w0440AgU7c3bSXO/KMINaIWXd0oLpoq/0/QJxCQSJ9XnYy1W7TYLBJpHsVWD1ahsA7FjNvRd6mxCiHsm8g6Z0pnzqIpF1dHUtP2ITU5Z1hZHbu+L3BEEStBbL9XYvGfEakv1bmf+bOZGnoiuHEdlBnaChxYKNzB23b8sw8YyT7Ajxfk49eJIAvdbVkdFCe2J0gMefhQ0bIZxhx3fzMIysQNiN8PgOUKxOMur10LduigREDRMZyP4oGWrP1GFY4t6groASsZ421os48wAdnrbovNhLt7ScNULkwZ5AIZJTrbaKYTLjA1oJ3sIuN/aYocm/9uoQHEIlacF1s/TM1fLcPTL38O9fOsjMEIwoPKfvt7opuI9G2Hf/PR4aCLDQ7wNmIdEuXJ/QNL72k5q4NejAldPfe3UVVqzkys8YZ/jYOGOp6c+YzRCrCuq0M11y7TiN6qk7YXRMn/gukxrEimbMQjr3jwRM6dKVZ4RUfWQr8noPXLJq6yh5R3EH1IVOHESst/LItbG2D2vRsZRkAObzvQAAD3mb3/G4NzopI0FAiHfbpq0X72adg6SRj+8OHMShtFxxLZlf/nLgRLbClwl5WmaYSs+yEjkq48tY7Z2bE0N91mJwt+ua0NlRJIDh0HikF4UvSVorFj2YVu9YeS5tfvlVjPSoNu/Zu6dEUfBOT555hahBdN3Sa5Xuj2Rvau1lQNIaC944y0RWj9UiNDskAK1WoL+EfXcC6IbBXFRyVfX/WKXxPAwUyIAGW8ggZ08hcijKTt1YKnUO6QPvcrmDVAb0FCLIXn5id4fD/Jx4tw/gbXs7WF9b2RgXtPhLBG9vF5FEkdHAKrQHZAJC/HWvk7nvzzDzIXZlfFTJoC3JpGgLPBY7SQTjGlUvG577yNutZ1hTfs9/1nkSXK9zzKLRZ3VODeKUovJe0WCq1zVMYxCJMenmNzPIU2S8TA4E7wWmbNkxq9rI2dd6v0VpcAPVMxnDsvWTWFayyqvKZO7Z08a62i/oH2/jxf8rpmfO64in3FLiL1GX8IGtVE9M23yGsIqJbxDTy+LtaMWDaPqkymb5VrQdzOvqldeU0SUi6IirG8UZ3jcpRbwHa1C0Dww9G/SFX3gPvTJQE+kyz+g1BeMILKKO+olcHzctOWgzxYHnOD7dpCRtuZEXACjgqesZMasoPgnuDC4nUviAAxDc5pngjoAITIkvhKwg5d608pdrZcA+qn5TMT6Uo/QzBaOxBCLTJX3Mgk85rMfsnWx86oLxf7p2PX5ONqieTa/qM3tPw4ZXvlAp83NSD8F7+ZgctK1TpoYwtiU2h02HCGioH5tkVCqNVTMH5p00sRy2JU1qyDBP2CII/Dg4WDsIl+zgeX7589srx6YORRQMBfKbodbB743Tl4WLKOEnwWUVBsm94SOlCracU72MSyj068wdpYjyz1FwC2bjQnxnB6Mp/pZ+yyZXtguEaYB+kqhjQ6UUmwSFazOb+rhYjLaoiM+aN9/8KKn0zaCTFpN9eKwWy7/u4EHzO46TdFSNjMfn2iPSJwDPCFHc0I1+vjdAZw5ZjqR/uzi9Zn20oAa5JnLEk/EA3VRWE7J/XrupfFJPtCUuqHPpnlL7ISJtRpSVcB8qsZCm2QEkWoROtCKKxUh3yEcMbWYJwk6DlEBG0bZP6eg06FL3v6RPb7odGuwm7FN8fG4woqtB8e7M5klPpo97GoObNwt+ludTAmxyC5hmcFx+dIvEZKI6igFKHqLH01iY1o7903VzG9QGetyVx5RNmBYUU+zIuSva/yIcECUi4pRmE3VkF2avqulQEUY4yZ/wmNboBzPmAPey3+dSYtBZUjeWWT0pPwCz4Vozxp9xeClIU60qvEFMQCaPvPaA70WlOP9f/ey39macvpGCVa+zfa8gO44wbxpJUlC8GN/pRMTQtzY8Z8/hiNrU+Zq64ZfFGIkdj7m7abcK1EBtws1X4J/hnqvasPvvDSDYWN+QcQVGMqXalkDtTad5rYY0TIR1Eqox3czwPMjKPvF5sFv17Thujr1IZ1Ytl4VX1J0vjXKmLY4lmXipRAro0qVGEcXxEVMMEl54jQMd4J7RjgomU0j1ptjyxY+cLiSyXPfiEcIS2lWDK3ISAy6UZ3Hb5vnPncA94411jcy75ay6B6DSTzK6UTCZR9uDANtPBrvIDgjsfarMiwoax2OlLxaSoYn4iRgkpEGqEkwox5tyI8aKkLlfZ12lO11TxsqRMY89j5JaO55XfPJPDL1LGSnC88Re9Ai+Nu5bZjtwRrvFITUFHPR4ZmxGslQMecgbZO7nHk32qHxYkdvWpup07ojcMCaVrpFAyFZJJbNvBpZfdf39Hdo2kPtT7v0/f8R/B5Nz4f1t9/3zNM/7n6SUHfcWk5dfQFJvcJMgPolGCpOFb/WC0FGWU2asuQyT+rm88ZKZ78Cei/CAh939CH0JYbpZIPtxc2ufXqjS3pHH9lnWK4iJ7OjR/EESpCo2R3MYKyE7rHfhTvWho4cL1QdN4jFTyR6syMwFm124TVDDRXMNveI1Dp/ntwdz8k8kxw7iFSx6+Yx6O+1LzMVrN0BBzziZi9kneZSzgollBnVwBh6oSOPHXrglrOj+QmR/AESrhDpKrWT+8/AiMDxS/5wwRNuGQPLlJ9ovomhJWn8sMLVItQ8N/7IXvtD8kdOoHaw+vBSbFImQsv/OCAIui99E+YSIOMlMvBXkAt+NAZK8wB9Jf8CPtB+TOUOR+z71d/AFXpPBT6+A5FLjxMjLIEoJzrQfquvxEIi+WoUzGR1IzQFNvbYOnxb2PyQ0kGdyXKzW2axQL8lNAXPk6NEjqrRD1oZtKLlFoofrXw0dCNWASHzy+7PSzOUJ3XtaPZsxLDjr+o41fKuKWNmjiZtfkOzItvlV2MDGSheGF0ma04qE3TUEfqJMrXFm7DpK+27DSvCUVf7rbNoljPhha5W7KBqVq0ShUSTbRmuqPtQreVWH4JET5yMhuqMoSd4r/N8sDmeQiQQvi1tcZv7Moc7dT5X5AtCD6kNEGZOzVcNYlpX4AbTsLgSYYliiPyVoniuYYySxsBy5cgb3pD+EK0Gpb0wJg031dPgaL8JZt6sIvzNPEHfVPOjXmaXj4bd4voXzpZ5GApMhILgMbCEWZ2zwgdeQgjNHLbPIt+KqxRwWPLTN6HwZ0Ouijj4UF+Sg0Au8XuIKW0WxlexdrFrDcZJ8Shauat3X0XmHygqgL1nAu2hrJFb4wZXkcS+i36KMyU1yFvYv23bQUJi/3yQpqr/naUOoiEWOxckyq/gq43dFou1DVDaYMZK9tho7+IXXokBCs5GRfOcBK7g3A+jXQ39K4YA8PBRW4m5+yR0ZAxWJncjRVbITvIAPHYRt1EJ3YLiUbqIvoKHtzHKtUy1ddRUQ0AUO41vonZDUOW+mrszw+SW/6Q/IUgNpcXFjkM7F4CSSQ2ExZg85otsMs7kqsQD4OxYeBNDcSpifjMoLb7GEbGWTwasVObmB/bfPcUlq0wYhXCYEDWRW02TP5bBrYsKTGWjnWDDJ1F7zWai0zW/2XsCuvBQjPFcTYaQX3tSXRSm8hsAoDdjArK/OFp6vcWYOE7lizP0Yc+8p16i7/NiXIiiQTp7c7Xus925VEtlKAjUdFhyaiLT7VxDagprMFwix4wZ05u0qj7cDWFd0W9OYHIu3JbJKMXRJ1aYNovugg+QqRN7fNHSi26VSgBpn+JfMuPo3aeqPWik/wI5Rz3BWarPQX4i5+dM0npwVOsX+KsOhC7vDg+OJsz4Q5zlnIeflUWL6QYMbf9WDfLmosLF4Qev3mJiOuHjoor/dMeBpA9iKDkMjYBNbRo414HCxjsHrB4EXNbHzNMDHCLuNBG6Sf+J4MZ/ElVsDSLxjIiGsTPhw8BPjxbfQtskj+dyNMKOOcUYIRBEIqbazz3lmjlRQhplxq673VklMMY6597vu+d89ec/zq7Mi4gQvh87ehYbpOuZEXj5g/Q7S7BFDAAB9DzG35SC853xtWVcnZQoH54jeOqYLR9NDuwxsVthTV7V99n/B7HSbAytbEyVTz/5NhJ8gGIjG0E5j3griULUd5Rg7tQR+90hJgNQKQH2btbSfPcaTOfIexc1db1BxUOhM1vWCpLaYuKr3FdNTt/T3PWCpEUWDKEtzYrjpzlL/wri3MITKsFvtF8QVV/NhVo97aKIBgdliNc10dWdXVDpVtsNn+2UIolrgqdWA4EY8so0YvB4a+aLzMXiMAuOHQrXY0tr+CL10JbvZzgjJJuB1cRkdT7DUqTvnswVUp5kkUSFVtIIFYK05+tQxT6992HHNWVhWxUsD1PkceIrlXuUVRogwmfdhyrf6zzaL8+c0L7GXMZOteAhAVQVwdJh+7nrX7x4LaIIfz2F2v7Dg/uDfz2Fa+4gFm2zHAor8UqimJG3VTJtZEoFXhnDYXvxMJFc6ku2bhbCxzij2z5UNuK0jmp1mnvkVNUfR+SEmj1Lr94Lym75PO7Fs0MIr3GdsWXRXSfgLTVY0FLqba97u1In8NAcY7IC6TjWLigwKEIm43NxTdaVTv9mcKkzuzBkKd8x/xt1p/9BbP7Wyb4bpo1K1gnOpbLvKz58pWl3B55RJ/Z5mRDLPtNQg14jdOEs9+h/V5UVpwrAI8kGbX8KPVPDIMfIqKDjJD9UyDOPhjZ3vFAyecwyq4akUE9mDOtJEK1hpDyi6Ae87sWAClXGTiwPwN7PXWwjxaR79ArHRIPeYKTunVW24sPr/3HPz2IwH8oKH4OlWEmt4BLM6W5g4kMcYbLwj2usodD1088stZA7VOsUSpEVl4w7NMb1EUHMRxAxLF0CIV+0L3iZb+ekB1vSDSFjAZ3hfLJf7gFaXrOKn+mhR+rWw/eTXIcAgl4HvFuBg1LOmOAwJH3eoVEjjwheKA4icbrQCmvAtpQ0mXG0agYp5mj4Rb6mdQ+RV4QBPbxMqh9C7o8nP0Wko2ocnCHeRGhN1XVyT2b9ACsL+6ylUy+yC3QEnaKRIJK91YtaoSrcWZMMwxuM0E9J68Z+YyjA0g8p1PfHAAIROy6Sa04VXOuT6A351FOWhKfTGsFJ3RTJGWYPoLk5FVK4OaYR9hkJvezwF9vQN1126r6isMGXWTqFW+3HL3I/jurlIdDWIVvYY+s6yq7lrFSPAGRdnU7PVwY/SvWbZGpXzy3BQ2LmAJlrONUsZs4oGkly0V267xbD5KMY8woNNsmWG1VVgLCra8aQBBcI4DP2BlNwxhiCtHlaz6OWFoCW0vMR3ErrG7JyMjTSCnvRcsEHgmPnwA6iNpJ2DrFb4gLlhKJyZGaWkA97H6FFdwEcLT6DRQQL++fOkVC4cYGW1TG/3iK5dShRSuiBulmihqgjR45Vi03o2RbQbP3sxt90VxQ6vzdlGfkXmmKmjOi080JSHkLntjvsBJnv7gKscOaTOkEaRQqAnCA4HWtB4XnMtOhpRmH2FH8tTXrIjAGNWEmudQLCkcVlGTQ965Kh0H6ixXbgImQP6b42B49sO5C8pc7iRlgyvSYvcnH9FgQ3azLbQG2cUW96SDojTQStxkOJyOuDGTHAnnWkz29aEwN9FT8EJ4yhXOg+jLTrCPKeEoJ9a7lDXOjEr8AgX4BmnMQ668oW0zYPyQiVMPxKRHtpfnEEyaKhdzNVThlxxDQNdrHeZiUFb6NoY2KwvSb7BnRcpJy+/g/zAYx3fYSN5QEaVD2Y1VsNWxB0BSO12MRsRY8JLfAezRMz5lURuLUnG1ToKk6Q30FughqWN6gBNcFxP/nY/iv+iaUQOa+2Nuym46wtI/DvSfzSp1jEi4SdYBE7YhTiVV5cX9gwboVDMVgZp5YBQlHOQvaDNfcCoCJuYhf5kz5kwiIKPjzgpcRJHPbOhJajeoeRL53cuMahhV8Z7IRr6M4hW0JzT7mzaMUzQpm866zwM7Cs07fJYXuWvjAMkbe5O6V4bu71sOG6JQ4oL8zIeXHheFVavzxmlIyBkgc9IZlEDplMPr8xlcyss4pVUdwK1e7CK2kTsSdq7g5SHRAl3pYUB9Ko4fsh4qleOyJv1z3KFSTSvwEcRO/Ew8ozEDYZSqpfoVW9uhJfYrNAXR0Z3VmeoAD+rVWtwP/13sE/3ICX3HhDG3CMc476dEEC0K3umSAD4j+ZQLVdFOsWL2C1TH5+4KiSWH+lMibo+B55hR3Gq40G1n25sGcN0mEcoU2wN9FCVyQLBhYOu9aHVLWjEKx2JIUZi5ySoHUAI9b8hGzaLMxCZDMLhv8MkcpTqEwz9KFDpCpqQhVmsGQN8m24wyB82FAKNmjgfKRsXRmsSESovAwXjBIoMKSG51p6Um8b3i7GISs7kjTq/PZoioCfJzfKdJTN0Q45kQEQuh9H88M3yEs3DbtRTKALraM0YC8laiMiOOe6ADmTcCiREeAWZelBaEXRaSuj2lx0xHaRYqF65O0Lo5OCFU18A8cMDE4MLYm9w2QSr9NgQAIcRxZsNpA7UJR0e71JL+VU+ISWFk5I97lra8uGg7GlQYhGd4Gc6rxsLFRiIeGO4abP4S4ekQ1fiqDCy87GZHd52fn5aaDGuvOmIofrzpVwMvtbreZ/855OaXTRcNiNE0wzGZSxbjg26v8ko8L537v/XCCWP2MFaArJpvnkep0pA+O86MWjRAZPQRfznZiSIaTppy6m3p6HrNSsY7fDtz7Cl4V/DJAjQDoyiL2uwf1UHVd2AIrzBUSlJaTj4k6NL97a/GqhWKU9RUmjnYKpm2r+JYUcrkCuZKvcYvrg8pDoUKQywY9GDWg03DUFSirlUXBS5SWn/KAntnf0IdHGL/7mwXqDG+LZYjbEdQmqUqq4y54TNmWUP7IgcAw5816YBzwiNIJiE9M4lPCzeI/FGBeYy3p6IAmH4AjXXmvQ4Iy0Y82NTobcAggT2Cdqz6Mx4TdGoq9fn2etrWKUNFyatAHydQTVUQ2S5OWVUlugcNvoUrlA8cJJz9MqOa/W3iVno4zDHfE7zhoY5f5lRTVZDhrQbR8LS4eRLz8iPMyBL6o4PiLlp89FjdokQLaSBmKHUwWp0na5fE3v9zny2YcDXG/jfI9sctulHRbdkI5a4GOPJx4oAJQzVZ/yYAado8KNZUdEFs9ZPiBsausotXMNebEgr0dyopuqfScFJ3ODNPHgclACPdccwv0YJGQdsN2lhoV4HVGBxcEUeUX/alr4nqpcc1CCR3vR7g40zteQg/JvWmFlUE4mAiTpHlYGrB7w+U2KdSwQz2QJKBe/5eiixWipmfP15AFWrK8Sh1GBBYLgzki1wTMhGQmagXqJ2+FuqJ8f0XzXCVJFHQdMAw8xco11HhM347alrAu+wmX3pDFABOvkC+WPX0Uhg1Z5MVHKNROxaR84YV3s12UcM+70cJ460SzEaKLyh472vOMD3XnaK7zxZcXlWqenEvcjmgGNR2OKbI1s8U+iwiW+HotHalp3e1MGDy6BMVIvajnAzkFHbeVsgjmJUkrP9OAwnEHYXVBqYx3q7LvXjoVR0mY8h+ZaOnh053pdsGkmbqhyryN01eVHySr+CkDYkSMeZ1xjPNVM+gVLTDKu2VGsMUJqWO4TwPDP0VOg2/8ITbAUaMGb4LjL7L+Pi11lEVMXTYIlAZ/QHmTENjyx3kDkBdfcvvQt6tKk6jYFM4EG5UXDTaF5+1ZjRz6W7MdJPC+wTkbDUim4p5QQH3b9kGk2Bkilyeur8Bc20wm5uJSBO95GfYDI1EZipoRaH7uVveneqz43tlTZGRQ4a7CNmMHgXyOQQOL6WQkgMUTQDT8vh21aSdz7ERiZT1jK9F+v6wgFvuEmGngSvIUR2CJkc5tx1QygfZnAruONobB1idCLB1FCfO7N1ZdRocT8/Wye+EnDiO9pzqIpnLDl4bkaRKW+ekBVwHn46Shw1X0tclt/0ROijuUB4kIInrVJU4buWf4YITJtjOJ6iKdr1u+flgQeFH70GxKjhdgt/MrwfB4K/sXczQ+9zYcrD4dhY6qZhZ010rrxggWA8JaZyg2pYij8ieYEg1aZJkZK9O1Re7sB0iouf60rK0Gd+AYlp7soqCBCDGwfKeUQhCBn0E0o0GS6PdmjLi0TtCYZeqazqwN+yNINIA8Lk3iPDnWUiIPLGNcHmZDxfeK0iAdxm/T7LnN+gemRL61hHIc0NCAZaiYJR+OHnLWSe8sLrK905B5eEJHNlWq4RmEXIaFTmo49f8w61+NwfEUyuJAwVqZCLFcyHBKAcIVj3sNzfEOXzVKIndxHw+AR93owhbCxUZf6Gs8cz6/1VdrFEPrv330+9s6BtMVPJ3zl/Uf9rUi0Z/opexfdL3ykF76e999GPfVv8fJv/Y/+/5hEMon1tqNFyVRevV9y9/uIvsG3dbB8GRRrgaEXfhx+2xeOFt+cEn3RZanNxdEe2+B6MHpNbrRE53PlDifPvFcp4kO78ILR0T4xyW/WGPyBsqGdoA7zJJCu1TKbGfhnqgnRbxbB2B3UZoeQ2bz2sTVnUwokTcTU21RxN1PYPS3Sar7T0eRIsyCNowr9amwoMU/od9s2APtiKNL6ENOlyKADstAEWKA+sdKDhrJ6BOhRJmZ+QJbAaZ3/5Fq0/lumCgEzGEbu3yi0Y4I4EgVAjqxh4HbuQn0GrRhOWyAfsglQJAVL1y/6yezS2k8RE2MstJLh92NOB3GCYgFXznF4d25qiP4ZCyI4RYGesut6FXK6GwPpKK8WHEkhYui0AyEmr5Ml3uBFtPFdnioI8RiCooa7Z1G1WuyIi3nSNglutc+xY8BkeW3JJXPK6jd2VIMpaSxpVtFq+R+ySK9J6WG5Qvt+C+QH1hyYUOVK7857nFmyDBYgZ/o+AnibzNVqyYCJQvyDXDTK+iXdkA71bY7TL3bvuLxLBQ8kbTvTEY9aqkQ3+MiLWbEgjLzOH+lXgco1ERgzd80rDCymlpaRQbOYnKG/ODoFl46lzT0cjM5FYVvv0qLUbD5lyJtMUaC1pFlTkNONx6lliaX9o0i/1vws5bNKn5OuENQEKmLlcP4o2ZmJjD4zzd3Fk32uQ4uRWkPSUqb4LBe3EXHdORNB2BWsws5daRnMfNVX7isPSb1hMQdAJi1/qmDMfRUlCU74pmnzjbXfL8PVG8NsW6IQM2Ne23iCPIpryJjYbVnm5hCvKpMa7HLViNiNc+xTfDIaKm3jctViD8A1M9YPJNk003VVr4Zo2MuGW8vil8SLaGpPXqG7I4DLdtl8a4Rbx1Lt4w5Huqaa1XzZBtj208EJVGcmKYEuaeN27zT9EE6a09JerXdEbpaNgNqYJdhP1NdqiPKsbDRUi86XvvNC7rME5mrSQtrzAZVndtSjCMqd8BmaeGR4l4YFULGRBeXIV9Y4yxLFdyoUNpiy2IhePSWzBofYPP0eIa2q5JP4j9G8at/AqoSsLAUuRXtvgsqX/zYwsE+of6oSDbUOo4RMJw+DOUTJq+hnqwKim9Yy/napyZNTc2rCq6V9jHtJbxGPDwlzWj/Sk3zF/BHOlT/fSjSq7FqlPI1q6J+ru8Aku008SFINXZfOfnZNOvGPMtEmn2gLPt+H4QLA+/SYe4j398auzhKIp2Pok3mPC5q1IN1HgR+mnEfc4NeeHYwd2/kpszR3cBn7ni9NbIqhtSWFW8xbUJuUPVOeeXu3j0IGZmFNiwaNZ6rH4/zQ2ODz6tFxRLsUYZu1bfd1uIvfQDt4YD/efKYv8VF8bHGDgK22w2Wqwpi43vNCOXFJZCGMqWiPbL8mil6tsmOTXAWCyMCw73e2rADZj2IK6rqksM3EXF2cbLb4vjB14wa/yXK5vwU+05MzERJ5nXsXsW21o7M+gO0js2OyKciP5uF2iXyb2DiptwQeHeqygkrNsqVCSlldxBMpwHi1vfc8RKpP/4L3Lmpq6DZcvhDDfxTCE3splacTcOtXdK2g303dIWBVe2wD/Gvja1cClFQ67gw0t1ZUttsUgQ1Veky8oOpS6ksYEc4bqseCbZy766SvL3FodmnahlWJRgVCNjPxhL/fk2wyvlKhITH/VQCipOI0dNcRa5B1M5HmOBjTLeZQJy237e2mobwmDyJNHePhdDmiknvLKaDbShL+Is1XTCJuLQd2wmdJL7+mKvs294whXQD+vtd88KKk0DXP8B1Xu9J+xo69VOuFgexgTrcvI6SyltuLix9OPuE6/iRJYoBMEXxU4shQMf4Fjqwf1PtnJ/wWSZd29rhZjRmTGgiGTAUQqRz+nCdjeMfYhsBD5Lv60KILWEvNEHfmsDs2L0A252351eUoYxAysVaCJVLdH9QFWAmqJDCODUcdoo12+gd6bW2boY0pBVHWL6LQDK5bYWh1V8vFvi0cRpfwv7cJiMX3AZNJuTddHehTIdU0YQ/sQ1dLoF2xQPcCuHKiuCWOY30DHe1OwcClLAhqAKyqlnIbH/8u9ScJpcS4kgp6HKDUdiOgRaRGSiUCRBjzI5gSksMZKqy7Sd51aeg0tgJ+x0TH9YH2Mgsap9N7ENZdEB0bey2DMTrBA1hn56SErNHf3tKtqyL9b6yXEP97/rc+jgD2N1LNUH6RM9AzP3kSipr06RkKOolR7HO768jjWiH1X92jA7dkg7gcNcjqsZCgfqWw0tPXdLg20cF6vnQypg7gLtkazrHAodyYfENPQZsdfnjMZiNu4nJO97D1/sQE+3vNFzrSDOKw+keLECYf7RJwVHeP/j79833oZ0egonYB2FlFE5qj02B/LVOMJQlsB8uNg3Leg4qtZwntsOSNidR0abbZmAK4sCzvt8Yiuz2yrNCJoH5O8XvX/vLeR/BBYTWj0sOPYM/jyxRd5+/JziKAABaPcw/34UA3aj/gLZxZgRCWN6m4m3demanNgsx0P237/Q+Ew5VYnJPkyCY0cIVHoFn2Ay/e7U4P19APbPFXEHX94N6KhEMPG7iwB3+I+O1jd5n6VSgHegxgaSawO6iQCYFgDsPSMsNOcUj4q3sF6KzGaH/0u5PQoAj/8zq6Uc9MoNrGqhYeb2jQo0WlGlXjxtanZLS24/OIN5Gx/2g684BPDQpwlqnkFcxpmP/osnOXrFuu4PqifouQH0eF5qCkvITQbJw/Zvy5mAHWC9oU+cTiYhJmSfKsCyt1cGVxisKu+NymEQIAyaCgud/V09qT3nk/9s/SWsYtha7yNpzBIMM40rCSGaJ9u6lEkl00vXBiEt7p9P5IBCiavynEOv7FgLqPdeqxRiCwuFVMolSIUBcoyfUC2e2FJSAUgYdVGFf0b0Kn2EZlK97yyxrT2MVgvtRikfdaAW8RwEEfN+B7/eK8bBdp7URpbqn1xcrC6d2UjdsKbzCjBFqkKkoZt7Mrhg6YagE7spkqj0jOrWM+UGQ0MUlG2evP1uE1p2xSv4dMK0dna6ENcNUF+xkaJ7B764NdxLCpuvhblltVRAf7vK5qPttJ/9RYFUUSGcLdibnz6mf7WkPO3MkUUhR2mAOuGv8IWw5XG1ZvoVMnjSAZe6T7WYA99GENxoHkMiKxHlCuK5Gd0INrISImHQrQmv6F4mqU/TTQ8nHMDzCRivKySQ8dqkpQgnUMnwIkaAuc6/FGq1hw3b2Sba398BhUwUZSAIO8XZvnuLdY2n6hOXws+gq9BHUKcKFA6kz6FDnpxLPICa3qGhnc97bo1FT/XJk48LrkHJ2CAtBv0RtN97N21plfpXHvZ8gMJb7Zc4cfI6MbPwsW7AilCSXMFIEUEmir8XLEklA0ztYbGpTTGqttp5hpFTTIqUyaAIqvMT9A/x+Ji5ejA4Bhxb/cl1pUdOD6epd3yilIdO6j297xInoiBPuEDW2/UfslDyhGkQs7Wy253bVnlT+SWg89zYIK/9KXFl5fe+jow2rd5FXv8zDPrmfMXiUPt9QBO/iK4QGbX5j/7Rx1c1vzsY8ONbP3lVIaPrhL4+1QrECTN3nyKavGG0gBBtHvTKhGoBHgMXHStFowN+HKrPriYu+OZ05Frn8okQrPaaxoKP1ULCS/cmKFN3gcH7HQlVjraCeQmtjg1pSQxeuqXiSKgLpxc/1OiZsU4+n4lz4hpahGyWBURLi4642n1gn9qz9bIsaCeEPJ0uJmenMWp2tJmIwLQ6VSgDYErOeBCfSj9P4G/vI7oIF+l/n5fp956QgxGvur77ynawAu3G9MdFbJbu49NZnWnnFcQHjxRuhUYvg1U/e84N4JTecciDAKb/KYIFXzloyuE1eYXf54MmhjTq7B/yBToDzzpx3tJCTo3HCmVPYfmtBRe3mPYEE/6RlTIxbf4fSOcaKFGk4gbaUWe44hVk9SZzhW80yfW5QWBHxmtUzvMhfVQli4gZTktIOZd9mjJ5hsbmzttaHQB29Am3dZkmx3g/qvYocyhZ2PXAWsNQiIaf+Q8W/MWPIK7/TjvCx5q2XRp4lVWydMc2wIQkhadDB0xsnw/kSEyGjLKjI4coVIwtubTF3E7MJ6LS6UOsJKj82XVAVPJJcepfewbzE91ivXZvOvYfsmMevwtPpfMzGmC7WJlyW2j0jh7AF1JLmwEJSKYwIvu6DHc3YnyLH9ZdIBnQ+nOVDRiP+REpqv++typYHIvoJyICGA40d8bR7HR2k7do6UQTHF4oriYeIQbxKe4Th6+/l1BjUtS9hqORh3MbgvYrStXTfSwaBOmAVQZzpYNqsAmQyjY56MUqty3c/xH6GuhNvNaG9vGbG6cPtBM8UA3e8r51D0AR9kozKuGGSMgLz3nAHxDNnc7GTwpLj7/6HeWp1iksDeTjwCLpxejuMtpMnGJgsiku1sOACwQ9ukzESiDRN77YNESxR5LphOlcASXA5uIts1LnBIcn1J7BLWs49DMALSnuz95gdOrTZr0u1SeYHinno/pE58xYoXbVO/S+FEMMs5qyWkMnp8Q3ClyTlZP52Y9nq7b8fITPuVXUk9ohG5EFHw4gAEcjFxfKb3xuAsEjx2z1wxNbSZMcgS9GKyW3R6KwJONgtA64LTyxWm8Bvudp0M1FdJPEGopM4Fvg7G/hsptkhCfHFegv4ENwxPeXmYhxwZy7js+BeM27t9ODBMynVCLJ7RWcBMteZJtvjOYHb5lOnCLYWNEMKC59BA7covu1cANa2PXL05iGdufOzkgFqqHBOrgQVUmLEc+Mkz4Rq8O6WkNr7atNkH4M8d+SD1t/tSzt3oFql+neVs+AwEI5JaBJaxARtY2Z4mKoUqxds4UpZ0sv3zIbNoo0J4fihldQTX3XNcuNcZmcrB5LTWMdzeRuAtBk3cZHYQF6gTi3PNuDJ0nmR+4LPLoHvxQIxRgJ9iNNXqf2SYJhcvCtJiVWo85TsyFOuq7EyBPJrAdhEgE0cTq16FQXhYPJFqSfiVn0IQnPOy0LbU4BeG94QjdYNB0CiQ3QaxQqD2ebSMiNjaVaw8WaM4Z5WnzcVDsr4eGweSLa2DE3BWViaxhZFIcSTjgxNCAfelg+hznVOYoe5VqTYs1g7WtfTm3e4/WduC6p+qqAM8H4ZyrJCGpewThTDPe6H7CzX/zQ8Tm+r65HeZn+MsmxUciEWPlAVaK/VBaQBWfoG/aRL/jSZIQfep/89GjasWmbaWzeEZ2R1FOjvyJT37O9B8046SRSKVEnXWlBqbkb5XCS3qFeuE9xb9+frEknxWB5h1D/hruz2iVDEAS7+qkEz5Ot5agHJc7WCdY94Ws61sURcX5nG8UELGBAHZ3i+3VulAyT0nKNNz4K2LBHBWJcTBX1wzf+//u/j/9+//v87+9/l9Lbh/L/uyNYiTsWV2LwsjaA6MxTuzFMqmxW8Jw/+IppdX8t/Clgi1rI1SN0UC/r6tX/4lUc2VV1OQReSeCsjUpKZchw4XUcjHfw6ryCV3R8s6VXm67vp4n+lcPV9gJwmbKQEsmrJi9c2vkwrm8HFbVYNTaRGq8D91t9n5+U+aD/hNtN3HjC/nC/vUoGFSCkXP+NlRcmLUqLbiUBl4LYf1U/CCvwtd3ryCH8gUmGITAxiH1O5rnGTz7y1LuFjmnFGQ1UWuM7HwfXtWl2fPFKklYwNUpF2IL/TmaRETjQiM5SJacI+3Gv5MBU8lP5Io6gWkawpyzNEVGqOdx4YlO1dCvjbWFZWbCmeiFKPSlMKtKcMFLs/KQxtgAHi7NZNCQ32bBAW2mbHflVZ8wXKi1JKVHkW20bnYnl3dKWJeWJOiX3oKPBD6Zbi0ZvSIuWktUHB8qDR8DMMh1ZfkBL9FS9x5r0hBGLJ8pUCJv3NYH+Ae8p40mZWd5m5fhobFjQeQvqTT4VKWIYfRL0tfaXKiVl75hHReuTJEcqVlug+eOIIc4bdIydtn2K0iNZPsYWQvQio2qbO3OqAlPHDDOB7DfjGEfVF51FqqNacd6QmgFKJpMfLp5DHTv4wXlONKVXF9zTJpDV4m1sYZqJPhotcsliZM8yksKkCkzpiXt+EcRQvSQqmBS9WdWkxMTJXPSw94jqI3varCjQxTazjlMH8jTS8ilaW8014/vwA/LNa+YiFoyyx3s/KswP3O8QW1jtq45yTM/DX9a8M4voTVaO2ebvw1EooDw/yg6Y1faY+WwrdVs5Yt0hQ5EwRfYXSFxray1YvSM+kYmlpLG2/9mm1MfmbKHXr44Ih8nVKb1M537ZANUkCtdsPZ80JVKVKabVHCadaLXg+IV8i5GSwpZti0h6diTaKs9sdpUKEpd7jDUpYmHtiX33SKiO3tuydkaxA7pEc9XIQEOfWJlszj5YpL5bKeQyT7aZSBOamvSHl8xsWvgo26IP/bqk+0EJUz+gkkcvlUlyPp2kdKFtt7y5aCdks9ZJJcFp5ZWeaWKgtnXMN3ORwGLBE0PtkEIek5FY2aVssUZHtsWIvnljMVJtuVIjpZup/5VL1yPOHWWHkOMc6YySWMckczD5jUj2mlLVquFaMU8leGVaqeXis+aRRL8zm4WuBk6cyWfGMxgtr8useQEx7k/PvRoZyd9nde1GUCV84gMX8Ogu/BWezYPSR27llzQnA97oo0pYyxobYUJfsj+ysTm9zJ+S4pk0TGo9VTG0KjqYhTmALfoDZVKla2b5yhv241PxFaLJs3i05K0AAIdcGxCJZmT3ZdT7CliR7q+kur7WdQjygYtOWRL9B8E4s4LI8KpAj7bE0dg7DLOaX+MGeAi0hMMSSWZEz+RudXbZCsGYS0QqiXjH9XQbd8sCB+nIVTq7/T/FDS+zWY9q7Z2fdq1tdLb6v3hKKVDAw5gjj6o9r1wHFROdHc18MJp4SJ2Ucvu+iQ9EgkekW8VCM+psM6y+/2SBy8tNN4a3L1MzP+OLsyvESo5gS7IQOnIqMmviJBVc6zbVG1n8eXiA3j46kmvvtJlewwNDrxk4SbJOtP/TV/lIVK9ueShNbbMHfwnLTLLhbZuO79ec5XvfgRwLFK+w1r5ZWW15rVFZrE+wKqNRv5KqsLNfpGgnoUU6Y71NxEmN7MyqwqAQqoIULOw/LbuUB2+uE75gJt+kq1qY4LoxV+qR/zalupea3D5+WMeaRIn0sAI6DDWDh158fqUb4YhAxhREbUN0qyyJYkBU4V2KARXDT65gW3gRsiv7xSPYEKLwzgriWcWgPr0sbZnv7m1XHNFW6xPdGNZUdxFiUYlmXNjDVWuu7LCkX/nVkrXaJhiYktBISC2xgBXQnNEP+cptWl1eG62a7CPXrnrkTQ5BQASbEqUZWMDiZUisKyHDeLFOaJILUo5f6iDt4ZO8MlqaKLto0AmTHVVbkGuyPa1R/ywZsWRoRDoRdNMMHwYTsklMVnlAd2S0282bgMI8fiJpDh69OSL6K3qbo20KfpNMurnYGQSr/stFqZ7hYsxKlLnKAKhsmB8AIpEQ4bd/NrTLTXefsE6ChRmKWjXKVgpGoPs8GAicgKVw4K0qgDgy1A6hFq1WRat3fHF+FkU+b6H4NWpOU3KXTxrIb2qSHAb+qhm8hiSROi/9ofapjxhyKxxntPpge6KL5Z4+WBMYkAcE6+0Hd3Yh2zBsK2MV3iW0Y6cvOCroXlRb2MMJtdWx+3dkFzGh2Pe3DZ9QpSqpaR/rE1ImOrHqYYyccpiLC22amJIjRWVAherTfpQLmo6/K2pna85GrDuQPlH1Tsar8isAJbXLafSwOof4gg9RkAGm/oYpBQQiPUoyDk2BCQ1k+KILq48ErFo4WSRhHLq/y7mgw3+L85PpP6xWr6cgp9sOjYjKagOrxF148uhuaWtjet953fh1IQiEzgC+d2IgBCcUZqgTAICm2bR8oCjDLBsmg+ThyhfD+zBalsKBY1Ce54Y/t9cwfbLu9SFwEgphfopNA3yNxgyDafUM3mYTovZNgPGdd4ZFFOj1vtfFW3u7N+iHEN1HkeesDMXKPyoCDCGVMo4GCCD6PBhQ3dRZIHy0Y/3MaE5zU9mTCrwwnZojtE+qNpMSkJSpmGe0EzLyFelMJqhfFQ7a50uXxZ8pCc2wxtAKWgHoeamR2O7R+bq7IbPYItO0esdRgoTaY38hZLJ5y02oIVwoPokGIzxAMDuanQ1vn2WDQ00Rh6o5QOaCRu99fwDbQcN0XAuqkFpxT/cfz3slGRVokrNU0iqiMAJFEbKScZdmSkTUznC0U+MfwFOGdLgsewRyPKwBZYSmy6U325iUhBQNxbAC3FLKDV9VSOuQpOOukJ/GAmu/tyEbX9DgEp6dv1zoU0IqzpG6gssSjIYRVPGgU1QAQYRgIT8gEV0EXr1sqeh2I6rXjtmoCYyEDCe/PkFEi/Q48FuT29p557iN+LCwk5CK/CZ2WdAdfQZh2Z9QGrzPLSNRj5igUWzl9Vi0rCqH8G1Kp4QMLkuwMCAypdviDXyOIk0AHTM8HBYKh3b0/F+DxoNj4ZdoZfCpQVdnZarqoMaHWnMLNVcyevytGsrXQEoIbubqWYNo7NRHzdc0zvT21fWVirj7g36iy6pxogfvgHp1xH1Turbz8QyyHnXeBJicpYUctbzApwzZ1HT+FPEXMAgUZetgeGMwt4G+DHiDT2Lu+PT21fjJCAfV16a/Wu1PqOkUHSTKYhWW6PhhHUlNtWzFnA7MbY+r64vkwdpfNB2JfWgWXAvkzd42K4lN9x7Wrg4kIKgXCb4mcW595MCPJ/cTfPAMQMFWwnqwde4w8HZYJFpQwcSMhjVz4B8p6ncSCN1X4klxoIH4BN2J6taBMj6lHkAOs8JJAmXq5xsQtrPIPIIp/HG6i21xMGcFgqDXSRF0xQg14d2uy6HgKE13LSvQe52oShF5Jx1R6avyL4thhXQZHfC94oZzuPUBKFYf1VvDaxIrtV6dNGSx7DO0i1p6CzBkuAmEqyWceQY7F9+U0ObYDzoa1iKao/cOD/v6Q9gHrrr1uCeOk8fST9MG23Ul0KmM3r+Wn6Hi6WAcL7gEeaykicvgjzkjSwFsAXIR81Zx4QJ6oosVyJkCcT+4xAldCcihqvTf94HHUPXYp3REIaR4dhpQF6+FK1H0i9i7Pvh8owu3lO4PT1iuqu+DkL2Bj9+kdfGAg2TXw03iNHyobxofLE2ibjsYDPgeEQlRMR7afXbSGQcnPjI2D+sdtmuQ771dbASUsDndU7t58jrrNGRzISvwioAlHs5FA+cBE5Ccznkd8NMV6BR6ksnKLPZnMUawRDU1MZ/ib3xCdkTblHKu4blNiylH5n213yM0zubEie0o4JhzcfAy3H5qh2l17uLooBNLaO+gzonTH2uF8PQu9EyH+pjGsACTMy4cHzsPdymUSXYJOMP3yTkXqvO/lpvt0cX5ekDEu9PUfBeZODkFuAjXCaGdi6ew4qxJ8PmFfwmPpkgQjQlWqomFY6UkjmcnAtJG75EVR+NpzGpP1Ef5qUUbfowrC3zcSLX3BxgWEgEx/v9cP8H8u1Mvt9/rMDYf6sjwU1xSOPBgzFEeJLMRVFtKo5QHsUYT8ZRLCah27599EuqoC9PYjYO6aoAMHB8X1OHwEAYouHfHB3nyb2B+SnZxM/vw/bCtORjLMSy5aZoEpvgdGvlJfNPFUu/p7Z4VVK1hiI0/UTuB3ZPq4ohEbm7Mntgc1evEtknaosgZSwnDC2BdMmibpeg48X8Ixl+/8+xXdbshQXUPPvx8jT3fkELivHSmqbhblfNFShWAyQnJ3WBU6SMYSIpTDmHjdLVAdlADdz9gCplZw6mTiHqDwIsxbm9ErGusiVpg2w8Q3khKV/R9Oj8PFeF43hmW/nSd99nZzhyjCX3QOZkkB6BsH4H866WGyv9E0hVAzPYah2tkRfQZMmP2rinfOeQalge0ovhduBjJs9a1GBwReerceify49ctOh5/65ATYuMsAkVltmvTLBk4oHpdl6i+p8DoNj4Fb2vhdFYer2JSEilEwPd5n5zNoGBXEjreg/wh2NFnNRaIUHSOXa4eJRwygZoX6vnWnqVdCRT1ARxeFrNBJ+tsdooMwqnYhE7zIxnD8pZH+P0Nu1wWxCPTADfNWmqx626IBJJq6NeapcGeOmbtXvl0TeWG0Y7OGGV4+EHTtNBIT5Wd0Bujl7inXgZgfXTM5efD3qDTJ54O9v3Bkv+tdIRlq1kXcVD0BEMirmFxglNPt5pedb1AnxuCYMChUykwsTIWqT23XDpvTiKEru1cTcEMeniB+HQDehxPXNmkotFdwUPnilB/u4Nx5Xc6l8J9jH1EgKZUUt8t8cyoZleDBEt8oibDmJRAoMKJ5Oe9CSWS5ZMEJvacsGVdXDWjp/Ype5x0p9PXB2PAwt2LRD3d+ftNgpuyvxlP8pB84oB1i73vAVpwyrmXW72hfW6Dzn9Jkj4++0VQ4d0KSx1AsDA4OtXXDo63/w+GD+zC7w5SJaxsmnlYRQ4dgdjA7tTl2KNLnpJ+mvkoDxtt1a4oPaX3EVqj96o9sRKBQqU7ZOiupeAIyLMD+Y3YwHx30XWHB5CQiw7q3mj1EDlP2eBsZbz79ayUMbyHQ7s8gu4Lgip1LiGJj7NQj905/+rgUYKAA5qdrlHKIknWmqfuR+PB8RdBkDg/NgnlT89G72h2NvySnj7UyBwD+mi/IWs1xWbxuVwUIVXun5cMqBtFbrccI+DILjsVQg6eeq0itiRfedn89CvyFtpkxaauEvSANuZmB1p8FGPbU94J9medwsZ9HkUYjmI7OH5HuxendLbxTaYrPuIfE2ffXFKhoNBUp33HsFAXmCV/Vxpq5AYgFoRr5Ay93ZLRlgaIPjhZjXZZChT+aE5iWAXMX0oSFQEtwjiuhQQItTQX5IYrKfKB+queTNplR1Hoflo5/I6aPPmACwQCE2jTOYo5Dz1cs7Sod0KTG/3kEDGk3kUaUCON19xSJCab3kNpWZhSWkO8l+SpW70Wn3g0ciOIJO5JXma6dbos6jyisuxXwUUhj2+1uGhcvuliKtWwsUTw4gi1c/diEEpZHoKoxTBeMDmhPhKTx7TXWRakV8imJR355DcIHkR9IREHxohP4TbyR5LtFU24umRPRmEYHbpe1LghyxPx7YgUHjNbbQFRQhh4KeU1EabXx8FS3JAxp2rwRDoeWkJgWRUSKw6gGP5U2PuO9V4ZuiKXGGzFQuRuf+tkSSsbBtRJKhCi3ENuLlXhPbjTKD4djXVnfXFds6Zb+1XiUrRfyayGxJq1+SYBEfbKlgjiSmk0orgTqzSS+DZ5rTqsJbttiNtp+KMqGE2AHGFw6jQqM5vD6vMptmXV9OAjq49Uf/Lx9Opam+Hn5O9p8qoBBAQixzQZ4eNVkO9sPzJAMyR1y4/RCQQ1s0pV5KAU5sKLw3tkcFbI/JqrjCsK4Mw+W8aod4lioYuawUiCyVWBE/qPaFi5bnkgpfu/ae47174rI1fqQoTbW0HrU6FAejq7ByM0V4zkZTg02/YJK2N7hUQRCeZ4BIgSEqgD8XsjzG6LIsSbuHoIdz/LhFzbNn1clci1NHWJ0/6/O8HJMdIpEZbqi1RrrFfoo/rI/7ufm2MPG5lUI0IYJ4MAiHRTSOFJ2oTverFHYXThkYFIoyFx6rMYFgaOKM4xNWdlOnIcKb/suptptgTOTdVIf4YgdaAjJnIAm4qNNHNQqqAzvi53GkyRCEoseUBrHohZsjUbkR8gfKtc/+Oa72lwxJ8Mq6HDfDATbfbJhzeIuFQJSiw1uZprHlzUf90WgqG76zO0eCB1WdPv1IT6sNxxh91GEL2YpgC97ikFHyoaH92ndwduqZ6IYjkg20DX33MWdoZk7QkcKUCgisIYslOaaLyvIIqRKWQj16jE1DlQWJJaPopWTJjXfixEjRJJo8g4++wuQjbq+WVYjsqCuNIQW3YjnxKe2M5ZKEqq+cX7ZVgnkbsU3RWIyXA1rxv4kGersYJjD//auldXGmcEbcfTeF16Y1708FB1HIfmWv6dSFi6oD4E+RIjCsEZ+kY7dKnwReJJw3xCjKvi3kGN42rvyhUlIz0Bp+fNSV5xwFiuBzG296e5s/oHoFtUyUplmPulIPl+e1CQIQVtjlzLzzzbV+D/OVQtYzo5ixtMi5BmHuG4N/uKfJk5UIREp7+12oZlKtPBomXSzAY0KgtbPzzZoHQxujnREUgBU+O/jKKhgxVhRPtbqyHiUaRwRpHv7pgRPyUrnE7fYkVblGmfTY28tFCvlILC04Tz3ivkNWVazA+OsYrxvRM/hiNn8Fc4bQBeUZABGx5S/xFf9Lbbmk298X7iFg2yeimvsQqqJ+hYbt6uq+Zf9jC+Jcwiccd61NKQtFvGWrgJiHB5lwi6fR8KzYS7EaEHf/ka9EC7H8D+WEa3TEACHBkNSj/cXxFeq4RllC+fUFm2xtstYLL2nos1DfzsC9vqDDdRVcPA3Ho95aEQHvExVThXPqym65llkKlfRXbPTRiDepdylHjmV9YTWAEjlD9DdQnCem7Aj/ml58On366392214B5zrmQz/9ySG2mFqEwjq5sFl5tYJPw5hNz8lyZPUTsr5E0F2C9VMPnZckWP7+mbwp/BiN7f4kf7vtGnZF2JGvjK/sDX1RtcFY5oPQnE4lIAYV49U3C9SP0LCY/9i/WIFK9ORjzM9kG/KGrAuwFmgdEpdLaiqQNpCTGZVuAO65afkY1h33hrqyLjZy92JK3/twdj9pafFcwfXONmPQWldPlMe7jlP24Js0v9m8bIJ9TgS2IuRvE9ZVRaCwSJYOtAfL5H/YS4FfzKWKbek+GFulheyKtDNlBtrdmr+KU+ibHTdalzFUmMfxw3f36x+3cQbJLItSilW9cuvZEMjKw987jykZRlsH/UI+HlKfo2tLwemBEeBFtmxF2xmItA/dAIfQ+rXnm88dqvXa+GapOYVt/2waFimXFx3TC2MUiOi5/Ml+3rj/YU6Ihx2hXgiDXFsUeQkRAD6wF3SCPi2flk7XwKAA4zboqynuELD312EJ88lmDEVOMa1W/K/a8tGylZRMrMoILyoMQzzbDJHNZrhH77L9qSC42HVmKiZ5S0016UTp83gOhCwz9XItK9fgXfK3F5d7nZCBUekoLxrutQaPHa16Rjsa0gTrzyjqTnmcIcrxg6X6dkKiucudc0DD5W4pJPf0vuDW8r5/uw24YfMuxFRpD2ovT2mFX79xH6Jf+MVdv2TYqR6/955QgVPe3JCD/WjAYcLA9tpXgFiEjge2J5ljeI/iUzg91KQuHkII4mmHZxC3XQORLAC6G7uFn5LOmlnXkjFdoO976moNTxElS8HdxWoPAkjjocDR136m2l+f5t6xaaNgdodOvTu0rievnhNAB79WNrVs6EsPgkgfahF9gSFzzAd+rJSraw5Mllit7vUP5YxA843lUpu6/5jAR0RvH4rRXkSg3nE+O5GFyfe+L0s5r3k05FyghSFnKo4TTgs07qj4nTLqOYj6qaW9knJTDkF5OFMYbmCP+8H16Ty482OjvERV6OFyw043L9w3hoJi408sR+SGo1WviXUu8d7qS+ehKjpKwxeCthsm2LBFSFeetx0x4AaKPxtp3CxdWqCsLrB1s/j5TAhc1jNZsXWl6tjo/WDoewxzg8T8NnhZ1niUwL/nhfygLanCnRwaFGDyLw+sfZhyZ1UtYTp8TYB6dE7R3VsKKH95CUxJ8u8N+9u2/9HUNKHW3x3w5GQrfOPafk2w5qZq8MaHT0ebeY3wIsp3rN9lrpIsW9c1ws3VNV+JwNz0Lo9+V7zZr6GD56We6gWVIvtmam5GPPkVAbr74r6SwhuL+TRXtW/0pgyX16VNl4/EAD50TnUPuwrW6OcUO2VlWXS0inq872kk7GUlW6o/ozFKq+Sip6LcTtSDfDrPTcCHhx75H8BeRon+KG2wRwzfDgWhALmiWOMO6h3pm1UCZEPEjScyk7tdLx6WrdA2N1QTPENvNnhCQjW6kl057/qv7IwRryHrZBCwVSbLLnFRiHdTwk8mlYixFt1slEcPD7FVht13HyqVeyD55HOXrh2ElAxJyinGeoFzwKA91zfrdLvDxJSjzmImfvTisreI25EDcVfGsmxLVbfU8PGe/7NmWWKjXcdTJ11jAlVIY/Bv/mcxg/Q10vCHwKG1GW/XbJq5nxDhyLqiorn7Wd7VEVL8UgVzpHMjQ+Z8DUgSukiVwWAKkeTlVVeZ7t1DGnCgJVIdBPZAEK5f8CDyDNo7tK4/5DBjdD5MPV86TaEhGsLVFPQSI68KlBYy84FievdU9gWh6XZrugvtCZmi9vfd6db6V7FmoEcRHnG36VZH8N4aZaldq9zZawt1uBFgxYYx+Gs/qW1jwANeFy+LCoymyM6zgG7j8bGzUyLhvrbJkTYAEdICEb4kMKusKT9V3eIwMLsjdUdgijMc+7iKrr+TxrVWG0U+W95SGrxnxGrE4eaJFfgvAjUM4SAy8UaRwE9j6ZQH5qYAWGtXByvDiLSDfOD0yFA3UCMKSyQ30fyy1mIRg4ZcgZHLNHWl+c9SeijOvbOJxoQy7lTN2r3Y8p6ovxvUY74aOYbuVezryqXA6U+fcp6wSV9X5/OZKP18tB56Ua0gMyxJI7XyNT7IrqN8GsB9rL/kP5KMrjXxgqKLDa+V5OCH6a5hmOWemMUsea9vQl9t5Oce76PrTyTv50ExOqngE3PHPfSL//AItPdB7kGnyTRhVUUFNdJJ2z7RtktZwgmQzhBG/G7QsjZmJfCE7k75EmdIKH7xlnmDrNM/XbTT6FzldcH/rcRGxlPrv4qDScqE7JSmQABJWqRT/TUcJSwoQM+1jvDigvrjjH8oeK2in1S+/yO1j8xAws/T5u0VnIvAPqaE1atNuN0cuRliLcH2j0nTL4JpcR7w9Qya0JoaHgsOiALLCCzRkl1UUESz+ze/gIXHGtDwgYrK6pCFKJ1webSDog4zTlPkgXZqxlQDiYMjhDpwTtBW2WxthWbov9dt2X9XFLFmcF+eEc1UaQ74gqZiZsdj63pH1qcv3Vy8JYciogIVKsJ8Yy3J9w/GhjWVSQAmrS0BPOWK+RKV+0lWqXgYMnIFwpcZVD7zPSp547i9HlflB8gVnSTGmmq1ClO081OW/UH11pEQMfkEdDFzjLC1Cdo/BdL3s7cXb8J++Hzz1rhOUVZFIPehRiZ8VYu6+7Er7j5PSZu9g/GBdmNzJmyCD9wiswj9BZw+T3iBrg81re36ihMLjoVLoWc+62a1U/7qVX5CpvTVF7rocSAKwv4cBVqZm7lLDS/qoXs4fMs/VQi6BtVbNA3uSzKpQfjH1o3x4LrvkOn40zhm6hjduDglzJUwA0POabgdXIndp9fzhOo23Pe+Rk9GSLX0d71Poqry8NQDTzNlsa+JTNG9+UrEf+ngxCjGEsDCc0bz+udVRyHQI1jmEO3S+IOQycEq7XwB6z3wfMfa73m8PVRp+iOgtZfeSBl01xn03vMaQJkyj7vnhGCklsCWVRUl4y+5oNUzQ63B2dbjDF3vikd/3RUMifPYnX5Glfuk2FsV/7RqjI9yKTbE8wJY+74p7qXO8+dIYgjtLD/N8TJtRh04N9tXJA4H59IkMmLElgvr0Q5OCeVfdAt+5hkh4pQgfRMHpL74XatLQpPiOyHRs/OdmHtBf8nOZcxVKzdGclIN16lE7kJ+pVMjspOI+5+TqLRO6m0ZpNXJoZRv9MPDRcAfJUtNZHyig/s2wwReakFgPPJwCQmu1I30/tcBbji+Na53i1W1N+BqoY7Zxo+U/M9XyJ4Ok2SSkBtoOrwuhAY3a03Eu6l8wFdIG1cN+e8hopTkiKF093KuH/BcB39rMiGDLn6XVhGKEaaT/vqb/lufuAdpGExevF1+J9itkFhCfymWr9vGb3BTK4j598zRH7+e+MU9maruZqb0pkGxRDRE1CD4Z8LV4vhgPidk5w2Bq816g3nHw1//j3JStz7NR9HIWELO8TMn3QrP/zZp//+Dv9p429/ogv+GATR+n/UdF+ns9xNkXZQJXY4t9jMkJNUFygAtzndXwjss+yWH9HAnLQQfhAskdZS2l01HLWv7L7us5uTH409pqitvfSOQg/c+Zt7k879P3K9+WV68n7+3cZfuRd/dDPP/03rn+d+/nBvWfgDlt8+LzjqJ/vx3CnNOwiXhho778C96iD+1TBvRZYeP+EH81LE0vVwOOrmCLB3iKzI1x+vJEsrPH4uF0UB4TJ4X3uDfOCo3PYpYe0MF4bouh0DQ/l43fxUF7Y+dpWuvTSffB0yO2UQUETI/LwCZE3BvnevJ7c9zUlY3H58xzke6DNFDQG8n0WtDN4LAYN4nogKav1ezOfK/z+t6tsCTp+dhx4ymjWuCJk1dEUifDP+HyS4iP/Vg9B2jTo9L4NbiBuDS4nuuHW6H+JDQn2JtqRKGkEQPEYE7uzazXIkcxIAqUq1esasZBETlEZY7y7Jo+RoV/IsjY9eIMkUvr42Hc0xqtsavZvhz1OLwSxMOTuqzlhb0WbdOwBH9EYiyBjatz40bUxTHbiWxqJ0uma19qhPruvcWJlbiSSH48OLDDpaHPszvyct41ZfTu10+vjox6kOqK6v0K/gEPphEvMl/vwSv+A4Hhm36JSP9IXTyCZDm4kKsqD5ay8b1Sad/vaiyO5N/sDfEV6Z4q95E+yfjxpqBoBETW2C7xl4pIO2bDODDFurUPwE7EWC2Uplq+AHmBHvir2PSgkR12/Ry65O0aZtQPeXi9mTlF/Wj5GQ+vFkYyhXsLTjrBSP9hwk4GPqDP5rBn5/l8b0mLRAvRSzXHc293bs3s8EsdE3m2exxidWVB4joHR+S+dz5/W+v00K3TqN14CDBth8eWcsTbiwXPsygHdGid0PEdy6HHm2v/IUuV5RVapYmzGsX90mpnIdNGcOOq64Dbc5GUbYpD9M7S+6cLY//QmjxFLP5cuTFRm3vA5rkFZroFnO3bjHF35uU3s8mvL7Tp9nyTc4mymTJ5sLIp7umSnGkO23faehtz3mmTS7fbVx5rP7x3HXIjRNeq/A3xCs9JNB08c9S9BF2O3bOur0ItslFxXgRPdaapBIi4dRpKGxVz7ir69t/bc9qTxjvtOyGOfiLGDhR4fYywHv1WdOplxIV87TpLBy3Wc0QP0P9s4G7FBNOdITS/tep3o3h1TEa5XDDii7fWtqRzUEReP2fbxz7bHWWJdbIOxOUJZtItNZpTFRfj6vm9sYjRxQVO+WTdiOhdPeTJ+8YirPvoeL88l5iLYOHd3b/Imkq+1ZN1El3UikhftuteEYxf1Wujof8Pr4ICTu5ezZyZ4tHQMxlzUHLYO2VMOoNMGL/20S5i2o2obfk+8qqdR7xzbRDbgU0lnuIgz4LelQ5XS7xbLuSQtNS95v3ZUOdaUx/Qd8qxCt6xf2E62yb/HukLO6RyorV8KgYl5YNc75y+KvefrxY+lc/64y9kvWP0a0bDz/rojq+RWjO06WeruWqNFU7r3HPIcLWRql8ICZsz2Ls/qOm/CLn6++X+Qf7mGspYCrZod/lpl6Rw4xN/yuq8gqV4B6aHk1hVE1SfILxWu5gvXqbfARYQpspcxKp1F/c8XOPzkZvmoSw+vEqBLdrq1fr3wAPv5NnM9i8F+jdAuxkP5Z71c6uhK3enlnGymr7UsWZKC12qgUiG8XXGQ9mxnqz4GSIlybF9eXmbqj2sHX+a1jf0gRoONHRdRSrIq03Ty89eQ1GbV/Bk+du4+V15zls+vvERvZ4E7ZbnxWTVjDjb4o/k8jlw44pTIrUGxxuJvBeO+heuhOjpFsO6lVJ/aXnJDa/bM0Ql1cLbXE/Pbv3EZ3vj3iVrB5irjupZTzlnv677NrI9UNYNqbPgp/HZXS+lJmk87wec+7YOxTDo2aw2l3NfDr34VNlvqWJBknuK7oSlZ6/T10zuOoPZOeoIk81N+sL843WJ2Q4Z0fZ3scsqC/JV2fuhWi1jGURSKZV637lf53Xnnx16/vKEXY89aVJ0fv91jGdfG+G4+sniwHes4hS+udOr4RfhFhG/F5gUG35QaU+McuLmclb5ZWmR+sG5V6nf+PxYzlrnFGxpZaK8eqqVo0NfmAWoGfXDiT/FnUbWvzGDOTr8aktOZWg4BYvz5YH12ZbfCcGtNk+dDAZNGWvHov+PIOnY9Prjg8h/wLRrT69suaMVZ5bNuK00lSVpnqSX1NON/81FoP92rYndionwgOiA8WMf4vc8l15KqEEG4yAm2+WAN5Brfu1sq9suWYqgoajgOYt/JCk1gC8wPkK+XKCtRX6TAtgvrnuBgNRmn6I8lVDipOVB9kX6Oxkp4ZKyd1M6Gj8/v2U7k+YQBL95Kb9PQENucJb0JlW3b5tObN7m/Z1j1ev388d7o15zgXsI9CikAGAViR6lkJv7nb4Ak40M2G8TJ447kN+pvfHiOFjSUSP6PM+QfbAywKJCBaxSVxpizHseZUyUBhq59vFwrkyGoRiHbo0apweEZeSLuNiQ+HAekOnarFg00dZNXaPeoHPTRR0FmEyqYExOVaaaO8c0uFUh7U4e/UxdBmthlBDgg257Q33j1hA7HTxSeTTSuVnPZbgW1nodwmG16aKBDKxEetv7D9OjO0JhrbJTnoe+kcGoDJazFSO8/fUN9Jy/g4XK5PUkw2dgPDGpJqBfhe7GA+cjzfE/EGsMM+FV9nj9IAhrSfT/J3QE5TEIYyk5UjsI6ZZcCPr6A8FZUF4g9nnpVmjX90MLSQysIPD0nFzqwCcSJmIb5mYv2Cmk+C1MDFkZQyCBq4c/Yai9LJ6xYkGS/x2s5/frIW2vmG2Wrv0APpCdgCA9snFvfpe8uc0OwdRs4G9973PGEBnQB5qKrCQ6m6X/H7NInZ7y/1674/ZXOVp7OeuCRk8JFS516VHrnH1HkIUIlTIljjHaQtEtkJtosYul77cVwjk3gW1Ajaa6zWeyHGLlpk3VHE2VFzT2yI/EvlGUSz2H9zYE1s4nsKMtMqNyKNtL/59CpFJki5Fou6VXGm8vWATEPwrUVOLvoA8jLuwOzVBCgHB2Cr5V6OwEWtJEKokJkfc87h+sNHTvMb0KVTp5284QTPupoWvQVUwUeogZR3kBMESYo0mfukewRVPKh5+rzLQb7HKjFFIgWhj1w3yN/qCNoPI8XFiUgBNT1hCHBsAz8L7Oyt8wQWUFj92ONn/APyJFg8hzueqoJdNj57ROrFbffuS/XxrSXLTRgj5uxZjpgQYceeMc2wJrahReSKpm3QjHfqExTLAB2ipVumE8pqcZv8LYXQiPHHsgb5BMW8zM5pvQit+mQx8XGaVDcfVbLyMTlY8xcfmm/RSAT/H09UQol5gIz7rESDmnrQ4bURIB4iRXMDQwxgex1GgtDxKp2HayIkR+E/aDmCttNm2C6lytWdfOVzD6X2SpDWjQDlMRvAp1symWv4my1bPCD+E1EmGnMGWhNwmycJnDV2WrQNxO45ukEb08AAffizYKVULp15I4vbNK5DzWwCSUADfmKhfGSUqii1L2UsE8rB7mLuHuUJZOx4+WiizHBJ/hwboaBzhpNOVvgFTf5cJsHef7L1HCI9dOUUbb+YxUJWn6dYOLz+THi91kzY5dtO5c+grX7v0jEbsuoOGnoIreDIg/sFMyG+TyCLIcAWd1IZ1UNFxE8Uie13ucm40U2fcxC0u3WLvLOxwu+F7MWUsHsdtFQZ7W+nlfCASiAKyh8rnP3EyDByvtJb6Kax6/HkLzT9SyEyTMVM1zPtM0MJY14DmsWh4MgD15Ea9Hd00AdkTZ0EiG5NAGuIBzQJJ0JR0na+OB7lQA6UKxMfihIQ7GCCnVz694QvykWXTxpS2soDu+smru1UdIxSvAszBFD1c8c6ZOobA8bJiJIvuycgIXBQIXWwhyTgZDQxJTRXgEwRNAawGSXO0a1DKjdihLVNp/taE/xYhsgwe+VpKEEB4LlraQyE84gEihxCnbfoyOuJIEXy2FIYw+JjRusybKlU2g/vhTSGTydvCvXhYBdtAXtS2v7LkHtmXh/8fly1do8FI/D0f8UbzVb5h+KRhMGSAmR2mhi0YG/uj7wgxcfzCrMvdjitUIpXDX8ae2JcF/36qUWIMwN6JsjaRGNj+jEteGDcFyTUb8X/NHSucKMJp7pduxtD6KuxVlyxxwaeiC1FbGBESO84lbyrAugYxdl+2N8/6AgWpo/IeoAOcsG35IA/b3AuSyoa55L7llBLlaWlEWvuCFd8f8NfcTUgzJv6CbB+6ohWwodlk9nGWFpBAOaz5uEW5xBvmjnHFeDsb0mXwayj3mdYq5gxxNf3H3/tnCgHwjSrpSgVxLmiTtuszdRUFIsn6LiMPjL808vL1uQhDbM7aA43mISXReqjSskynIRcHCJ9qeFopJfx9tqyUoGbSwJex/0aDE3plBPGtNBYgWbdLom3+Q/bjdizR2/AS/c/dH/d3G7pyl1qDXgtOFtEqidwLqxPYtrNEveasWq3vPUUtqTeu8gpov4bdOQRI2kneFvRNMrShyVeEupK1PoLDPMSfWMIJcs267mGB8X9CehQCF0gIyhpP10mbyM7lwW1e6TGvHBV1sg/UyTghHPGRqMyaebC6pbB1WKNCQtlai1GGvmq9zUKaUzLaXsXEBYtHxmFbEZ2kJhR164LhWW2Tlp1dhsGE7ZgIWRBOx3Zcu2DxgH+G83WTPceKG0TgQKKiiNNOlWgvqNEbnrk6fVD+AqRam2OguZb0YWSTX88N+i/ELSxbaUUpPx4vJUzYg/WonSeA8xUK6u7DPHgpqWpEe6D4cXg5uK9FIYVba47V/nb+wyOtk+zG8RrS4EA0ouwa04iByRLSvoJA2FzaobbZtXnq8GdbfqEp5I2dpfpj59TCVif6+E75p665faiX8gS213RqBxTZqfHP46nF6NSenOneuT+vgbLUbdTH2/t0REFXZJOEB6DHvx6N6g9956CYrY/AYcm9gELJXYkrSi+0F0geKDZgOCIYkLU/+GOW5aGj8mvLFgtFH5+XC8hvAE3CvHRfl4ofM/Qwk4x2A+R+nyc9gNu/9Tem7XW4XRnyRymf52z09cTOdr+PG6+P/Vb4QiXlwauc5WB1z3o+IJjlbxI8MyWtSzT+k4sKVbhF3xa+vDts3NxXa87iiu+xRH9cAprnOL2h6vV54iQRXuOAj1s8nLFK8gZ70ThIQcWdF19/2xaJmT0efrkNDkWbpAQPdo92Z8+Hn/aLjbOzB9AI/k12fPs9HhUNDJ1u6ax2VxD3R6PywN7BrLJ26z6s3QoMp76qzzwetrDABKSGkfW5PwS1GvYNUbK6uRqxfyVGNyFB0E+OugMM8kKwmJmupuRWO8XkXXXQECyRVw9UyIrtCtcc4oNqXqr7AURBmKn6Khz3eBN96LwIJrAGP9mr/59uTOSx631suyT+QujDd4beUFpZ0kJEEnjlP+X/Kr2kCKhnENTg4BsMTOmMqlj2WMFLRUlVG0fzdCBgUta9odrJfpVdFomTi6ak0tFjXTcdqqvWBAzjY6hVrH9sbt3Z9gn+AVDpTcQImefbB4edirjzrsNievve4ZT4EUZWV3TxEsIW+9MT/RJoKfZZYSRGfC1CwPG/9rdMOM8qR/LUYvw5f/emUSoD7YSFuOoqchdUg2UePd1eCtFSKgxLSZ764oy4lvRCIH6bowPxZWwxNFctksLeil47pfevcBipkkBIc4ngZG+kxGZ71a72KQ7VaZ6MZOZkQJZXM6kb/Ac0/XkJx8dvyfJcWbI3zONEaEPIW8GbkYjsZcwy+eMoKrYjDmvEEixHzkCSCRPRzhOfJZuLdcbx19EL23MA8rnjTZZ787FGMnkqnpuzB5/90w1gtUSRaWcb0eta8198VEeZMUSfIhyuc4/nywFQ9uqn7jdqXh+5wwv+RK9XouNPbYdoEelNGo34KyySwigsrfCe0v/PlWPvQvQg8R0KgHO18mTVThhQrlbEQ0Kp/JxPdjHyR7E1QPw/ut0r+HDDG7BwZFm9IqEUZRpv2WpzlMkOemeLcAt5CsrzskLGaVOAxyySzZV/D2EY7ydNZMf8e8VhHcKGHAWNszf1EOq8fNstijMY4JXyATwTdncFFqcNDfDo+mWFvxJJpc4sEZtjXyBdoFcxbUmniCoKq5jydUHNjYJxMqN1KzYV62MugcELVhS3Bnd+TLLOh7dws/zSXWzxEb4Nj4aFun5x4kDWLK5TUF/yCXB/cZYvI9kPgVsG2jShtXkxfgT+xzjJofXqPEnIXIQ1lnIdmVzBOM90EXvJUW6a0nZ/7XjJGl8ToO3H/fdxnxmTNKBZxnkpXLVgLXCZywGT3YyS75w/PAH5I/jMuRspej8xZObU9kREbRA+kqjmKRFaKGWAmFQspC+QLbKPf0RaK3OXvBSWqo46p70ws/eZpu6jCtZUgQy6r4tHMPUdAgWGGUYNbuv/1a6K+MVFsd3T183+T8capSo6m0+Sh57fEeG/95dykGJBQMj09DSW2bY0mUonDy9a8trLnnL5B5LW3Nl8rJZNysO8Zb+80zXxqUGFpud3Qzwb7bf+8mq6x0TAnJU9pDQR9YQmZhlna2xuxJt0aCO/f1SU8gblOrbIyMsxTlVUW69VJPzYU2HlRXcqE2lLLxnObZuz2tT9CivfTAUYfmzJlt/lOPgsR6VN64/xQd4Jlk/RV7UKVv2Gx/AWsmTAuCWKhdwC+4HmKEKYZh2Xis4KsUR1BeObs1c13wqFRnocdmuheaTV30gvVXZcouzHKK5zwrN52jXJEuX6dGx3BCpV/++4f3hyaW/cQJLFKqasjsMuO3B3WlMq2gyYfdK1e7L2pO/tRye2mwzwZPfdUMrl5wdLqdd2Kv/wVtnpyWYhd49L6rsOV+8HXPrWH2Kup89l2tz6bf80iYSd+V4LROSOHeamvexR524q4r43rTmtFzQvArpvWfLYFZrbFspBsXNUqqenjxNNsFXatZvlIhk7teUPfK+YL32F8McTnjv0BZNppb+vshoCrtLXjIWq3EJXpVXIlG6ZNL0dh6qEm2WMwDjD3LfOfkGh1/czYc/0qhiD2ozNnH4882MVVt3JbVFkbwowNCO3KL5IoYW5wlVeGCViOuv1svZx7FbzxKzA4zGqBlRRaRWCobXaVq4yYCWbZf8eiJwt3OY+MFiSJengcFP2t0JMfzOiJ7cECvpx7neg1Rc5x+7myPJOXt2FohVRyXtD+/rDoTOyGYInJelZMjolecVHUhUNqvdZWg2J2t0jPmiLFeRD/8fOT4o+NGILb+TufCo9ceBBm3JLVn+MO2675n7qiEX/6W+188cYg3Zn5NSTjgOKfWFSAANa6raCxSoVU851oJLY11WIoYK0du0ec5E4tCnAPoKh71riTsjVIp3gKvBbEYQiNYrmH22oLQWA2AdwMnID6PX9b58dR2QKo4qag1D1Z+L/FwEKTR7osOZPWECPJIHQqPUsM5i/CH5YupVPfFA5pHUBcsesh8eO5YhyWnaVRPZn/BmdXVumZWPxMP5e28zm2uqHgFoT9CymHYNNrzrrjlXZM06HnzDxYNlI5b/QosxLmmrqDFqmogQdqk0WLkUceoAvQxHgkIyvWU69BPFr24VB6+lx75Rna6dGtrmOxDnvBojvi1/4dHjVeg8owofPe1cOnxU1ioh016s/Vudv9mhV9f35At+Sh28h1bpp8xhr09+vf47Elx3Ms6hyp6QvB3t0vnLbOhwo660cp7K0vvepabK7YJfxEWWfrC2YzJfYOjygPwfwd/1amTqa0hZ5ueebhWYVMubRTwIjj+0Oq0ohU3zfRfuL8gt59XsHdwKtxTQQ4Y2qz6gisxnm2UdlmpEkgOsZz7iEk6QOt8BuPwr+NR01LTqXmJo1C76o1N274twJvl+I069TiLpenK/miRxhyY8jvYV6W1WuSwhH9q7kuwnJMtm7IWcqs7HsnyHSqWXLSpYtZGaR1V3t0gauninFPZGtWskF65rtti48UV9uV9KM8kfDYs0pgB00S+TlzTXV6P8mxq15b9En8sz3jWSszcifZa/NuufPNnNTb031pptt0+sRSH/7UG8pzbsgtt3OG3ut7B9JzDMt2mTZuyRNIV8D54TuTrpNcHtgmMlYJeiY9XS83NYJicjRjtJSf9BZLsQv629QdDsKQhTK5CnXhpk7vMNkHzPhm0ExW/VCGApHfPyBagtZQTQmPHx7g5IXXsrQDPzIVhv2LB6Ih138iSDww1JNHrDvzUxvp73MsQBVhW8EbrReaVUcLB1R3PUXyaYG4HpJUcLVxMgDxcPkVRQpL7VTAGabDzbKcvg12t5P8TSGQkrj/gOrpnbiDHwluA73xbXts/L7u468cRWSWRtgTwlQnA47EKg0OiZDgFxAKQQUcsbGomITgeXUAAyKe03eA7Mp4gnyKQmm0LXJtEk6ddksMJCuxDmmHzmVhO+XaN2A54MIh3niw5CF7PwiXFZrnA8wOdeHLvvhdoqIDG9PDI7UnWWHq526T8y6ixJPhkuVKZnoUruOpUgOOp3iIKBjk+yi1vHo5cItHXb1PIKzGaZlRS0g5d3MV2pD8FQdGYLZ73aae/eEIUePMc4NFz8pIUfLCrrF4jVWH5gQneN3S8vANBmUXrEcKGn6hIUN95y1vpsvLwbGpzV9L0ZKTan6TDXM05236uLJcIEMKVAxKNT0K8WljuwNny3BNQRfzovA85beI9zr1AGNYnYCVkR1aGngWURUrgqR+gRrQhxW81l3CHevjvGEPzPMTxdsIfB9dfGRbZU0cg/1mcubtECX4tvaedmNAvTxCJtc2QaoUalGfENCGK7IS/O8CRpdOVca8EWCRwv2sSWE8CJPW5PCugjCXPd3h6U60cPD+bdhtXZuYB6stcoveE7Sm5MM2yvfUHXFSW7KzLmi7/EeEWL0wqcOH9MOSKjhCHHmw+JGLcYE/7SBZQCRggox0ZZTAxrlzNNXYXL5fNIjkdT4YMqVUz6p8YDt049v4OXGdg3qTrtLBUXOZf7ahPlZAY/O+7Sp0bvGSHdyQ8B1LOsplqMb9Se8VAE7gIdSZvxbRSrfl+Lk5Qaqi5QJceqjitdErcHXg/3MryljPSIAMaaloFm1cVwBJ8DNmkDqoGROSHFetrgjQ5CahuKkdH5pRPigMrgTtlFI8ufJPJSUlGgTjbBSvpRc0zypiUn6U5KZqcRoyrtzhmJ7/caeZkmVRwJQeLOG8LY6vP5ChpKhc8Js0El+n6FXqbx9ItdtLtYP92kKfaTLtCi8StLZdENJa9Ex1nOoz1kQ7qxoiZFKRyLf4O4CHRT0T/0W9F8epNKVoeyxUXhy3sQMMsJjQJEyMOjmOhMFgOmmlscV4eFi1CldU92yjwleirEKPW3bPAuEhRZV7JsKV3Lr5cETAiFuX5Nw5UlF7d2HZ96Bh0sgFIL5KGaKSoVYVlvdKpZJVP5+NZ7xDEkQhmDgsDKciazJCXJ6ZN2B3FY2f6VZyGl/t4aunGIAk/BHaS+i+SpdRfnB/OktOvyjinWNfM9Ksr6WwtCa1hCmeRI6icpFM4o8quCLsikU0tMoZI/9EqXRMpKGaWzofl4nQuVQm17d5fU5qXCQeCDqVaL9XJ9qJ08n3G3EFZS28SHEb3cdRBdtO0YcTzil3QknNKEe/smQ1fTb0XbpyNB5xAeuIlf+5KWlEY0DqJbsnzJlQxJPOVyHiKMx5Xu9FcEv1Fbg6Fhm4t+Jyy5JC1W3YO8dYLsO0PXPbxodBgttTbH3rt9Cp1lJIk2r3O1Zqu94eRbnIz2f50lWolYzuKsj4PMok4abHLO8NAC884hiXx5Fy5pWKO0bWL7uEGXaJCtznhP67SlQ4xjWIfgq6EpZ28QMtuZK7JC0RGbl9nA4XtFLug/NLMoH1pGt9IonAJqcEDLyH6TDROcbsmGPaGIxMo41IUAnQVPMPGByp4mOmh9ZQMkBAcksUK55LsZj7E5z5XuZoyWCKu6nHmDq22xI/9Z8YdxJy4kWpD16jLVrpwGLWfyOD0Wd+cBzFBxVaGv7S5k9qwh/5t/LQEXsRqI3Q9Rm3QIoaZW9GlsDaKOUyykyWuhNOprSEi0s1G4rgoiX1V743EELti+pJu5og6X0g6oTynUqlhH9k6ezyRi05NGZHz0nvp3HOJr7ebrAUFrDjbkFBObEvdQWkkUbL0pEvMU46X58vF9j9F3j6kpyetNUBItrEubW9ZvMPM4qNqLlsSBJqOH3XbNwv/cXDXNxN8iFLzUhteisYY+RlHYOuP29/Cb+L+xv+35Rv7xudnZ6ohK4cMPfCG8KI7dNmjNk/H4e84pOxn/sZHK9psfvj8ncA8qJz7O8xqbxESDivGJOZzF7o5PJLQ7g34qAWoyuA+x3btU98LT6ZyGyceIXjrqob2CAVql4VOTQPUQYvHV/g4zAuCZGvYQBtf0wmd5lilrvuEn1BXLny01B4h4SMDlYsnNpm9d7m9h578ufpef9Z4WplqWQvqo52fyUA7J24eZD5av6SyGIV9kpmHNqyvdfzcpEMw97BvknV2fq+MFHun9BT3Lsf8pbzvisWiIQvYkng+8Vxk1V+dli1u56kY50LRjaPdotvT5BwqtwyF+emo/z9J3yVUVGfKrxQtJMOAQWoQii/4dp9wgybSa5mkucmRLtEQZ/pz0tL/NVcgWAd95nEQ3Tg6tNbuyn3Iepz65L3huMUUBntllWuu4DbtOFSMSbpILV4fy6wlM0SOvi6CpLh81c1LreIvKd61uEWBcDw1lUBUW1I0Z+m/PaRlX+PQ/oxg0Ye6KUiIiTF4ADNk59Ydpt5/rkxmq9tV5Kcp/eQLUVVmBzQNVuytQCP6Ezd0G8eLxWyHpmZWJ3bAzkWTtg4lZlw42SQezEmiUPaJUuR/qklVA/87S4ArFCpALdY3QRdUw3G3XbWUp6aq9z0zUizcPa7351p9JXOZyfdZBFnqt90VzQndXB/mwf8LC9STj5kenVpNuqOQQP3mIRJj7eV21FxG8VAxKrEn3c+XfmZ800EPb9/5lIlijscUbB6da0RQaMook0zug1G0tKi/JBC4rw7/D3m4ARzAkzMcVrDcT2SyFtUdWAsFlsPDFqV3N+EjyXaoEePwroaZCiLqEzb8MW+PNE9TmTC01EzWli51PzZvUqkmyuROU+V6ik+Le/9qT6nwzUzf9tP68tYei0YaDGx6kAd7jn1cKqOCuYbiELH9zYqcc4MnRJjkeGiqaGwLImhyeKs+xKJMBlOJ05ow9gGCKZ1VpnMKoSCTbMS+X+23y042zOb5MtcY/6oBeAo1Vy89OTyhpavFP78jXCcFH0t7Gx24hMEOm2gsEfGabVpQgvFqbQKMsknFRRmuPHcZu0Su/WMFphZvB2r/EGbG72rpGGho3h+Msz0uGzJ7hNK2uqQiE1qmn0zgacKYYZBCqsxV+sjbpoVdSilW/b94n2xNb648VmNIoizqEWhBnsen+d0kbCPmRItfWqSBeOd9Wne3c6bcd6uvXOJ6WdiSsuXq0ndhqrQ4QoWUjCjYtZ0EAhnSOP1m44xkf0O7jXghrzSJWxP4a/t72jU29Vu2rvu4n7HfHkkmQOMGSS+NPeLGO5I73mC2B7+lMiBQQZRM9/9liLIfowupUFAbPBbR+lxDM6M8Ptgh1paJq5Rvs7yEuLQv/7d1oU2woFSb3FMPWQOKMuCuJ7pDDjpIclus5TeEoMBy2YdVB4fxmesaCeMNsEgTHKS5WDSGyNUOoEpcC2OFWtIRf0w27ck34/DjxRTVIcc9+kqZE6iMSiVDsiKdP/Xz5XfEhm/sBhO50p1rvJDlkyyxuJ9SPgs7YeUJBjXdeAkE+P9OQJm6SZnn1svcduI78dYmbkE2mtziPrcjVisXG78spLvbZaSFx/Rks9zP4LKn0Cdz/3JsetkT06A8f/yCgMO6Mb1Hme0JJ7b2wZz1qleqTuKBGokhPVUZ0dVu+tnQYNEY1fmkZSz6+EGZ5EzL7657mreZGR3jUfaEk458PDniBzsSmBKhDRzfXameryJv9/D5m6HIqZ0R+ouCE54Dzp4IJuuD1e4Dc5i+PpSORJfG23uVgqixAMDvchMR0nZdH5brclYwRoJRWv/rlxGRI5ffD5NPGmIDt7vDE1434pYdVZIFh89Bs94HGGJbTwrN8T6lh1HZFTOB4lWzWj6EVqxSMvC0/ljWBQ3F2kc/mO2b6tWonT2JEqEwFts8rz2h+oWNds9ceR2cb7zZvJTDppHaEhK5avWqsseWa2Dt5BBhabdWSktS80oMQrL4TvAM9b5HMmyDnO+OkkbMXfUJG7eXqTIG6lqSOEbqVR+qYdP7uWb57WEJqzyh411GAVsDinPs7KvUeXItlcMdOUWzXBH6zscymV1LLVCtc8IePojzXHF9m5b5zGwBRdzcyUJkiu938ApmAayRdJrX1PmVguWUvt2ThQ62czItTyWJMW2An/hdDfMK7SiFQlGIdAbltHz3ycoh7j9V7GxNWBpbtcSdqm4XxRwTawc3cbZ+xfSv9qQfEkDKfZTwCkqWGI/ur250ItXlMlh6vUNWEYIg9A3GzbgmbqvTN8js2YMo87CU5y6nZ4dbJLDQJj9fc7yM7tZzJDZFtqOcU8+mZjYlq4VmifI23iHb1ZoT9E+kT2dolnP1AfiOkt7PQCSykBiXy5mv637IegWSKj9IKrYZf4Lu9+I7ub+mkRdlvYzehh/jaJ9n7HUH5b2IbgeNdkY7wx1yVzxS7pbvky6+nmVUtRllEFfweUQ0/nG017WoUYSxs+j2B4FV/F62EtHlMWZXYrjGHpthnNb1x66LKZ0Qe92INWHdfR/vqp02wMS8r1G4dJqHok8KmQ7947G13a4YXbsGgHcBvRuVu1eAi4/A5+ZixmdSXM73LupB/LH7O9yxLTVXJTyBbI1S49TIROrfVCOb/czZ9pM4JsZx8kUz8dQGv7gUWKxXvTH7QM/3J2OuXXgciUhqY+cgtaOliQQVOYthBLV3xpESZT3rmfEYNZxmpBbb24CRao86prn+i9TNOh8VxRJGXJfXHATJHs1T5txgc/opYrY8XjlGQQbRcoxIBcnVsMjmU1ymmIUL4dviJXndMAJ0Yet+c7O52/p98ytlmAsGBaTAmMhimAnvp1TWNGM9BpuitGj+t810CU2UhorrjPKGtThVC8WaXw04WFnT5fTjqmPyrQ0tN3CkLsctVy2xr0ZWgiWVZ1OrlFjjxJYsOiZv2cAoOvE+7sY0I/TwWcZqMoyIKNOftwP7w++Rfg67ljfovKYa50if3fzE/8aPYVey/Nq35+nH2sLPh/fP5TsylSKGOZ4k69d2PnH43+kq++sRXHQqGArWdwhx+hpwQC6JgT2uxehYU4Zbw7oNb6/HLikPyJROGK2ouyr+vzseESp9G50T4AyFrSqOQ0rroCYP4sMDFBrHn342EyZTMlSyk47rHSq89Y9/nI3zG5lX16Z5lxphguLOcZUndL8wNcrkyjH82jqg8Bo8OYkynrxZvbFno5lUS3OPr8Ko3mX9NoRPdYOKKjD07bvgFgpZ/RF+YzkWvJ/Hs/tUbfeGzGWLxNAjfDzHHMVSDwB5SabQLsIZHiBp43FjGkaienYoDd18hu2BGwOK7U3o70K/WY/kuuKdmdrykIBUdG2mvE91L1JtTbh20mOLbk1vCAamu7utlXeGU2ooVikbU/actcgmsC1FKk2qmj3GWeIWbj4tGIxE7BLcBWUvvcnd/lYxsMV4F917fWeFB/XbINN3qGvIyTpCalz1lVewdIGqeAS/gB8Mi+sA+BqDiX3VGD2eUunTRbSY+AuDy4E3Qx3hAhwnSXX+B0zuj3eQ1miS8Vux2z/l6/BkWtjKGU72aJkOCWhGcSf3+kFkkB15vGOsQrSdFr6qTj0gBYiOlnBO41170gOWHSUoBVRU2JjwppYdhIFDfu7tIRHccSNM5KZOFDPz0TGMAjzzEpeLwTWp+kn201kU6NjbiMQJx83+LX1e1tZ10kuChJZ/XBUQ1dwaBHjTDJDqOympEk8X2M3VtVw21JksChA8w1tTefO3RJ1FMbqZ01bHHkudDB/OhLfe7P5GOHaI28ZXKTMuqo0hLWQ4HabBsGG7NbP1RiXtETz074er6w/OerJWEqjmkq2y51q1BVI+JUudnVa3ogBpzdhFE7fC7kybrAt2Z6RqDjATAUEYeYK45WMupBKQRtQlU+uNsjnzj6ZmGrezA+ASrWxQ6LMkHRXqXwNq7ftv28dUx/ZSJciDXP2SWJsWaN0FjPX9Yko6LobZ7aYW/IdUktI9apTLyHS8DyWPyuoZyxN1TK/vtfxk3HwWh6JczZC8Ftn0bIJay2g+n5wd7lm9rEsKO+svqVmi+c1j88hSCxbzrg4+HEP0Nt1/B6YW1XVm09T1CpAKjc9n18hjqsaFGdfyva1ZG0Xu3ip6N6JGpyTSqY5h4BOlpLPaOnyw45PdXTN+DtAKg7DLrLFTnWusoSBHk3s0d7YouJHq85/R09Tfc37ENXZF48eAYLnq9GLioNcwDZrC6FW6godB8JnqYUPvn0pWLfQz0lM0Yy8Mybgn84Ds3Q9bDP10bLyOV+qzxa4Rd9Dhu7cju8mMaONXK3UqmBQ9qIg7etIwEqM/kECk/Dzja4Bs1xR+Q/tCbc8IKrSGsTdJJ0vge7IG20W687uVmK6icWQ6cD3lwFzgNMGtFvO5qyJeKflGLAAcQZOrkxVwy3cWvqlGpvjmf9Qe6Ap20MPbV92DPV0OhFM4kz8Yr0ffC2zLWSQ1kqY6QdQrttR3kh1YLtQd1kCEv5hVoPIRWl5ERcUTttBIrWp6Xs5Ehh5OUUwI5aEBvuiDmUoENmnVw1FohCrbRp1A1E+XSlWVOTi7ADW+5Ohb9z1vK4qx5R5lPdGCPBJZ00mC+Ssp8VUbgpGAvXWMuWQQRbCqI6Rr2jtxZxtfP7W/8onz+yz0Gs76LaT5HX9ecyiZCB/ZR/gFtMxPsDwohoeCRtiuLxE1GM1vUEUgBv86+eehL58/P56QFGQ/MqOe/vC76L63jzmeax4exd/OKTUvkXg+fOJUHych9xt/9goJMrapSgvXrj8+8vk/N80f22Sewj6cyGqt1B6mztoeklVHHraouhvHJaG/OuBz6DHKMpFmQULU1bRWlyYE0RPXYYkUycIemN7TLtgNCJX6BqdyxDKkegO7nJK5xQ7OVYDZTMf9bVHidtk6DQX9Et+V9M7esgbsYBdEeUpsB0Xvw2kd9+rI7V+m47u+O/tq7mw7262HU1WlS9uFzsV6JxIHNmUCy0QS9e077JGRFbG65z3/dOKB/Zk+yDdKpUmdXjn/aS3N5nv4fK7bMHHmPlHd4E2+iTbV5rpzScRnxk6KARuDTJ8Q1LpK2mP8gj1EbuJ9RIyY+EWK4hCiIDBAS1Tm2IEXAFfgKPgdL9O6mAa06wjCcUAL6EsxPQWO9VNegBPm/0GgkZbDxCynxujX/92vmGcjZRMAY45puak2sFLCLSwXpEsyy5fnF0jGJBhm+fNSHKKUUfy+276A7/feLOFxxUuHRNJI2Osenxyvf8DAGObT60pfTTlhEg9u/KKkhJqm5U1/+BEcSkpFDA5XeCqxwXmPac1jcuZ3JWQ+p0NdWzb/5v1ZvF8GtMTFFEdQjpLO0bwPb0BHNWnip3liDXI2fXf05jjvfJ0NpjLCUgfTh9CMFYVFKEd4Z/OG/2C+N435mnK+9t1gvCiVcaaH7rK4+PjCvpVNiz+t2QyqH1O8x3JKZVl6Q+Lp/XK8wMjVMslOq9FdSw5FtUs/CptXH9PW+wbWHgrV17R5jTVOtGtKFu3nb80T+E0tv9QkzW3J2dbaw/8ddAKZ0pxIaEqLjlPrji3VgJ3GvdFvlqD8075woxh4fVt0JZE0KVFsAvqhe0dqN9b35jtSpnYMXkU+vZq+IAHad3IHc2s/LYrnD1anfG46IFiMIr9oNbZDWvwthqYNqOigaKd/XlLU4XHfk/PXIjPsLy/9/kAtQ+/wKH+hI/IROWj5FPvTZAT9f7j4ZXQyG4M0TujMAFXYkKvEHv1xhySekgXGGqNxWeWKlf8dDAlLuB1cb/qOD+rk7cmwt+1yKpk9cudqBanTi6zTbXRtV8qylNtjyOVKy1HTz0GW9rjt6sSjAZcT5R+KdtyYb0zyqG9pSLuCw5WBwAn7fjBjKLLoxLXMI+52L9cLwIR2B6OllJZLHJ8vDxmWdtF+QJnmt1rsHPIWY20lftk8fYePkAIg6Hgn532QoIpegMxiWgAOfe5/U44APR8Ac0NeZrVh3gEhs12W+tVSiWiUQekf/YBECUy5fdYbA08dd7VzPAP9aiVcIB9k6tY7WdJ1wNV+bHeydNtmC6G5ICtFC1ZwmJU/j8hf0I8TRVKSiz5oYIa93EpUI78X8GYIAZabx47/n8LDAAJ0nNtP1rpROprqKMBRecShca6qXuTSI3jZBLOB3Vp381B5rCGhjSvh/NSVkYp2qIdP/Bg=";
/**
 * The normal dictionary-data.js is quite large, which makes it
 * unsuitable for browser usage. In order to make it smaller,
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses
 * it's own dictionary. 😜
 */ var $3939d1de148b5202$var$init = function init(BrotliDecompressBuffer) {
    var compressed = $3939d1de148b5202$var$base64Js$1.toByteArray($3939d1de148b5202$var$dictionary_bin);
    return BrotliDecompressBuffer(compressed);
};
var $3939d1de148b5202$var$dictionaryDataCompressed = {
    init: $3939d1de148b5202$var$init
};
var $3939d1de148b5202$var$dictionary = $3939d1de148b5202$var$createCommonjsModule(function(module, exports) {
    /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  
     Collection of static dictionary words.
  */ exports.init = function(BrotliDecompressBuffer) {
        exports.dictionary = $3939d1de148b5202$var$dictionaryDataCompressed.init(BrotliDecompressBuffer);
    };
    exports.offsetsByLength = new Uint32Array([
        0,
        0,
        0,
        0,
        0,
        4096,
        9216,
        21504,
        35840,
        44032,
        53248,
        63488,
        74752,
        87040,
        93696,
        100864,
        104704,
        106752,
        108928,
        113536,
        115968,
        118528,
        119872,
        121280,
        122016
    ]);
    exports.sizeBitsByLength = new Uint8Array([
        0,
        0,
        0,
        0,
        10,
        10,
        11,
        11,
        10,
        10,
        10,
        10,
        10,
        9,
        9,
        8,
        7,
        7,
        8,
        7,
        7,
        6,
        6,
        5,
        5
    ]);
    exports.minDictionaryWordLength = 4;
    exports.maxDictionaryWordLength = 24;
});
var $3939d1de148b5202$var$dictionary_1 = $3939d1de148b5202$var$dictionary.init;
var $3939d1de148b5202$var$dictionary_2 = $3939d1de148b5202$var$dictionary.dictionary;
var $3939d1de148b5202$var$dictionary_3 = $3939d1de148b5202$var$dictionary.offsetsByLength;
var $3939d1de148b5202$var$dictionary_4 = $3939d1de148b5202$var$dictionary.sizeBitsByLength;
var $3939d1de148b5202$var$dictionary_5 = $3939d1de148b5202$var$dictionary.minDictionaryWordLength;
var $3939d1de148b5202$var$dictionary_6 = $3939d1de148b5202$var$dictionary.maxDictionaryWordLength;
function $3939d1de148b5202$var$HuffmanCode(bits, value) {
    this.bits = bits;
    /* number of bits used for this symbol */ this.value = value;
/* symbol value or table offset */ }
var $3939d1de148b5202$var$HuffmanCode_1 = $3939d1de148b5202$var$HuffmanCode;
var $3939d1de148b5202$var$MAX_LENGTH = 15;
/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function $3939d1de148b5202$var$GetNextKey(key, len) {
    var step = 1 << len - 1;
    while(key & step)step >>= 1;
    return (key & step - 1) + step;
}
/* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function $3939d1de148b5202$var$ReplicateValue(table, i, step, end, code) {
    do {
        end -= step;
        table[i + end] = new $3939d1de148b5202$var$HuffmanCode(code.bits, code.value);
    }while (end > 0);
}
/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function $3939d1de148b5202$var$NextTableBitSize(count, len, root_bits) {
    var left = 1 << len - root_bits;
    while(len < $3939d1de148b5202$var$MAX_LENGTH){
        left -= count[len];
        if (left <= 0) break;
        ++len;
        left <<= 1;
    }
    return len - root_bits;
}
var $3939d1de148b5202$var$BrotliBuildHuffmanTable = function BrotliBuildHuffmanTable(root_table, table, root_bits, code_lengths, code_lengths_size) {
    var start_table = table;
    var code;
    /* current table entry */ var len;
    /* current code length */ var symbol;
    /* symbol index in original or sorted table */ var key;
    /* reversed prefix code */ var step;
    /* step size to replicate values in current table */ var low;
    /* low bits for current root entry */ var mask;
    /* mask for low bits */ var table_bits;
    /* key length of current table */ var table_size;
    /* size of current table */ var total_size;
    /* sum of root table size and 2nd level table sizes */ var sorted;
    /* symbols sorted by code length */ var count = new Int32Array($3939d1de148b5202$var$MAX_LENGTH + 1);
    /* number of codes of each length */ var offset = new Int32Array($3939d1de148b5202$var$MAX_LENGTH + 1);
    /* offsets in sorted table for each length */ sorted = new Int32Array(code_lengths_size);
    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
    for(len = 1; len < $3939d1de148b5202$var$MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
    table_bits = root_bits;
    table_size = 1 << table_bits;
    total_size = table_size;
    /* special case code with only one value */ if (offset[$3939d1de148b5202$var$MAX_LENGTH] === 1) {
        for(key = 0; key < total_size; ++key)root_table[table + key] = new $3939d1de148b5202$var$HuffmanCode(0, sorted[0] & 0xffff);
        return total_size;
    }
    /* fill in root table */ key = 0;
    symbol = 0;
    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        code = new $3939d1de148b5202$var$HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
        $3939d1de148b5202$var$ReplicateValue(root_table, table + key, step, table_size, code);
        key = $3939d1de148b5202$var$GetNextKey(key, len);
    }
    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
    low = -1;
    for(len = root_bits + 1, step = 2; len <= $3939d1de148b5202$var$MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        if ((key & mask) !== low) {
            table += table_size;
            table_bits = $3939d1de148b5202$var$NextTableBitSize(count, len, root_bits);
            table_size = 1 << table_bits;
            total_size += table_size;
            low = key & mask;
            root_table[start_table + low] = new $3939d1de148b5202$var$HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
        }
        code = new $3939d1de148b5202$var$HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
        $3939d1de148b5202$var$ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
        key = $3939d1de148b5202$var$GetNextKey(key, len);
    }
    return total_size;
};
var $3939d1de148b5202$var$huffman = {
    HuffmanCode: $3939d1de148b5202$var$HuffmanCode_1,
    BrotliBuildHuffmanTable: $3939d1de148b5202$var$BrotliBuildHuffmanTable
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ /* Common context lookup table for all context modes. */ var $3939d1de148b5202$var$lookup$2 = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */ 0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */ 2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */ 0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */ 0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
var $3939d1de148b5202$var$lookupOffsets = new Uint16Array([
    /* CONTEXT_LSB6 */ 1024,
    1536,
    /* CONTEXT_MSB6 */ 1280,
    1536,
    /* CONTEXT_UTF8 */ 0,
    256,
    /* CONTEXT_SIGNED */ 768,
    512
]);
var $3939d1de148b5202$var$context = {
    lookup: $3939d1de148b5202$var$lookup$2,
    lookupOffsets: $3939d1de148b5202$var$lookupOffsets
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ function $3939d1de148b5202$var$PrefixCodeRange(offset, nbits) {
    this.offset = offset;
    this.nbits = nbits;
}
var $3939d1de148b5202$var$kBlockLengthPrefixCode = [
    new $3939d1de148b5202$var$PrefixCodeRange(1, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(5, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(9, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(13, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(17, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(25, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(33, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(41, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(49, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(65, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(81, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(97, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(113, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(145, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(177, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(209, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(241, 6),
    new $3939d1de148b5202$var$PrefixCodeRange(305, 6),
    new $3939d1de148b5202$var$PrefixCodeRange(369, 7),
    new $3939d1de148b5202$var$PrefixCodeRange(497, 8),
    new $3939d1de148b5202$var$PrefixCodeRange(753, 9),
    new $3939d1de148b5202$var$PrefixCodeRange(1265, 10),
    new $3939d1de148b5202$var$PrefixCodeRange(2289, 11),
    new $3939d1de148b5202$var$PrefixCodeRange(4337, 12),
    new $3939d1de148b5202$var$PrefixCodeRange(8433, 13),
    new $3939d1de148b5202$var$PrefixCodeRange(16625, 24)
];
var $3939d1de148b5202$var$kInsertLengthPrefixCode = [
    new $3939d1de148b5202$var$PrefixCodeRange(0, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(1, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(2, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(3, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(4, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(5, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(6, 1),
    new $3939d1de148b5202$var$PrefixCodeRange(8, 1),
    new $3939d1de148b5202$var$PrefixCodeRange(10, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(14, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(18, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(26, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(34, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(50, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(66, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(98, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(130, 6),
    new $3939d1de148b5202$var$PrefixCodeRange(194, 7),
    new $3939d1de148b5202$var$PrefixCodeRange(322, 8),
    new $3939d1de148b5202$var$PrefixCodeRange(578, 9),
    new $3939d1de148b5202$var$PrefixCodeRange(1090, 10),
    new $3939d1de148b5202$var$PrefixCodeRange(2114, 12),
    new $3939d1de148b5202$var$PrefixCodeRange(6210, 14),
    new $3939d1de148b5202$var$PrefixCodeRange(22594, 24)
];
var $3939d1de148b5202$var$kCopyLengthPrefixCode = [
    new $3939d1de148b5202$var$PrefixCodeRange(2, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(3, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(4, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(5, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(6, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(7, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(8, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(9, 0),
    new $3939d1de148b5202$var$PrefixCodeRange(10, 1),
    new $3939d1de148b5202$var$PrefixCodeRange(12, 1),
    new $3939d1de148b5202$var$PrefixCodeRange(14, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(18, 2),
    new $3939d1de148b5202$var$PrefixCodeRange(22, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(30, 3),
    new $3939d1de148b5202$var$PrefixCodeRange(38, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(54, 4),
    new $3939d1de148b5202$var$PrefixCodeRange(70, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(102, 5),
    new $3939d1de148b5202$var$PrefixCodeRange(134, 6),
    new $3939d1de148b5202$var$PrefixCodeRange(198, 7),
    new $3939d1de148b5202$var$PrefixCodeRange(326, 8),
    new $3939d1de148b5202$var$PrefixCodeRange(582, 9),
    new $3939d1de148b5202$var$PrefixCodeRange(1094, 10),
    new $3939d1de148b5202$var$PrefixCodeRange(2118, 24)
];
var $3939d1de148b5202$var$kInsertRangeLut = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
];
var $3939d1de148b5202$var$kCopyRangeLut = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
];
var $3939d1de148b5202$var$prefix = {
    kBlockLengthPrefixCode: $3939d1de148b5202$var$kBlockLengthPrefixCode,
    kInsertLengthPrefixCode: $3939d1de148b5202$var$kInsertLengthPrefixCode,
    kCopyLengthPrefixCode: $3939d1de148b5202$var$kCopyLengthPrefixCode,
    kInsertRangeLut: $3939d1de148b5202$var$kInsertRangeLut,
    kCopyRangeLut: $3939d1de148b5202$var$kCopyRangeLut
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var $3939d1de148b5202$var$kIdentity = 0;
var $3939d1de148b5202$var$kOmitLast1 = 1;
var $3939d1de148b5202$var$kOmitLast2 = 2;
var $3939d1de148b5202$var$kOmitLast3 = 3;
var $3939d1de148b5202$var$kOmitLast4 = 4;
var $3939d1de148b5202$var$kOmitLast5 = 5;
var $3939d1de148b5202$var$kOmitLast6 = 6;
var $3939d1de148b5202$var$kOmitLast7 = 7;
var $3939d1de148b5202$var$kOmitLast8 = 8;
var $3939d1de148b5202$var$kOmitLast9 = 9;
var $3939d1de148b5202$var$kUppercaseFirst = 10;
var $3939d1de148b5202$var$kUppercaseAll = 11;
var $3939d1de148b5202$var$kOmitFirst1 = 12;
var $3939d1de148b5202$var$kOmitFirst2 = 13;
var $3939d1de148b5202$var$kOmitFirst3 = 14;
var $3939d1de148b5202$var$kOmitFirst4 = 15;
var $3939d1de148b5202$var$kOmitFirst5 = 16;
var $3939d1de148b5202$var$kOmitFirst6 = 17;
var $3939d1de148b5202$var$kOmitFirst7 = 18;
var $3939d1de148b5202$var$kOmitFirst9 = 20;
function $3939d1de148b5202$var$Transform$2(prefix, transform, suffix) {
    this.prefix = new Uint8Array(prefix.length);
    this.transform = transform;
    this.suffix = new Uint8Array(suffix.length);
    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
}
var $3939d1de148b5202$var$kTransforms = [
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst1, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " the "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, ""),
    new $3939d1de148b5202$var$Transform$2("s ", $3939d1de148b5202$var$kIdentity, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " of "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " and "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst2, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast1, ""),
    new $3939d1de148b5202$var$Transform$2(", ", $3939d1de148b5202$var$kIdentity, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, ", "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " in "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " to "),
    new $3939d1de148b5202$var$Transform$2("e ", $3939d1de148b5202$var$kIdentity, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "\""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "."),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "\">"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "\n"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast3, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "]"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " for "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst3, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast2, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " a "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " that "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, ". "),
    new $3939d1de148b5202$var$Transform$2(".", $3939d1de148b5202$var$kIdentity, ""),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, ", "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst4, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " with "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "'"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " from "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " by "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst5, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst6, ""),
    new $3939d1de148b5202$var$Transform$2(" the ", $3939d1de148b5202$var$kIdentity, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast4, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, ". The "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " on "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " as "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " is "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast7, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast1, "ing "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "\n\t"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, ":"),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, ". "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "ed "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst9, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitFirst7, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast6, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "("),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, ", "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast8, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " at "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "ly "),
    new $3939d1de148b5202$var$Transform$2(" the ", $3939d1de148b5202$var$kIdentity, " of "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast5, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kOmitLast9, ""),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, ", "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, "\""),
    new $3939d1de148b5202$var$Transform$2(".", $3939d1de148b5202$var$kIdentity, "("),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, "\">"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "=\""),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, "."),
    new $3939d1de148b5202$var$Transform$2(".com/", $3939d1de148b5202$var$kIdentity, ""),
    new $3939d1de148b5202$var$Transform$2(" the ", $3939d1de148b5202$var$kIdentity, " of the "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, "'"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, ". This "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, ","),
    new $3939d1de148b5202$var$Transform$2(".", $3939d1de148b5202$var$kIdentity, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, "("),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, "."),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, " not "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, "=\""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "er "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseAll, " "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "al "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseAll, ""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "='"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, "\""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, ". "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, "("),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "ful "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, ". "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "ive "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "less "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, "'"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "est "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, "."),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, "\">"),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, "='"),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, ","),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "ize "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, "."),
    new $3939d1de148b5202$var$Transform$2("\xc2\xa0", $3939d1de148b5202$var$kIdentity, ""),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kIdentity, ","),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, "=\""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, "=\""),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kIdentity, "ous "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, ", "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseFirst, "='"),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, ","),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseAll, "=\""),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseAll, ", "),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, ","),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, "("),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, ". "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseAll, "."),
    new $3939d1de148b5202$var$Transform$2("", $3939d1de148b5202$var$kUppercaseAll, "='"),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseAll, ". "),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, "=\""),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseAll, "='"),
    new $3939d1de148b5202$var$Transform$2(" ", $3939d1de148b5202$var$kUppercaseFirst, "='")
];
var $3939d1de148b5202$var$kTransforms_1 = $3939d1de148b5202$var$kTransforms;
var $3939d1de148b5202$var$kNumTransforms = $3939d1de148b5202$var$kTransforms.length;
function $3939d1de148b5202$var$ToUpperCase(p, i) {
    if (p[i] < 0xc0) {
        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
        return 1;
    }
    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
        p[i + 1] ^= 32;
        return 2;
    }
    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
    return 3;
}
var $3939d1de148b5202$var$transformDictionaryWord = function transformDictionaryWord(dst, idx, word, len, transform) {
    var prefix = $3939d1de148b5202$var$kTransforms[transform].prefix;
    var suffix = $3939d1de148b5202$var$kTransforms[transform].suffix;
    var t = $3939d1de148b5202$var$kTransforms[transform].transform;
    var skip = t < $3939d1de148b5202$var$kOmitFirst1 ? 0 : t - ($3939d1de148b5202$var$kOmitFirst1 - 1);
    var i = 0;
    var start_idx = idx;
    var uppercase;
    if (skip > len) skip = len;
    var prefix_pos = 0;
    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
    word += skip;
    len -= skip;
    if (t <= $3939d1de148b5202$var$kOmitLast9) len -= t;
    for(i = 0; i < len; i++)dst[idx++] = $3939d1de148b5202$var$dictionary.dictionary[word + i];
    uppercase = idx - len;
    if (t === $3939d1de148b5202$var$kUppercaseFirst) $3939d1de148b5202$var$ToUpperCase(dst, uppercase);
    else if (t === $3939d1de148b5202$var$kUppercaseAll) while(len > 0){
        var step = $3939d1de148b5202$var$ToUpperCase(dst, uppercase);
        uppercase += step;
        len -= step;
    }
    var suffix_pos = 0;
    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
    return idx - start_idx;
};
var $3939d1de148b5202$var$transform = {
    kTransforms: $3939d1de148b5202$var$kTransforms_1,
    kNumTransforms: $3939d1de148b5202$var$kNumTransforms,
    transformDictionaryWord: $3939d1de148b5202$var$transformDictionaryWord
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var $3939d1de148b5202$var$BrotliInput$1 = $3939d1de148b5202$var$streams$1.BrotliInput;
var $3939d1de148b5202$var$BrotliOutput$1 = $3939d1de148b5202$var$streams$1.BrotliOutput;
var $3939d1de148b5202$var$HuffmanCode$1 = $3939d1de148b5202$var$huffman.HuffmanCode;
var $3939d1de148b5202$var$BrotliBuildHuffmanTable$1 = $3939d1de148b5202$var$huffman.BrotliBuildHuffmanTable;
var $3939d1de148b5202$var$kDefaultCodeLength = 8;
var $3939d1de148b5202$var$kCodeLengthRepeatCode = 16;
var $3939d1de148b5202$var$kNumLiteralCodes = 256;
var $3939d1de148b5202$var$kNumInsertAndCopyCodes = 704;
var $3939d1de148b5202$var$kNumBlockLengthCodes = 26;
var $3939d1de148b5202$var$kLiteralContextBits = 6;
var $3939d1de148b5202$var$kDistanceContextBits = 2;
var $3939d1de148b5202$var$HUFFMAN_TABLE_BITS = 8;
var $3939d1de148b5202$var$HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE = 1080;
var $3939d1de148b5202$var$CODE_LENGTH_CODES = 18;
var $3939d1de148b5202$var$kCodeLengthCodeOrder = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
]);
var $3939d1de148b5202$var$NUM_DISTANCE_SHORT_CODES = 16;
var $3939d1de148b5202$var$kDistanceShortCodeIndexOffset = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
]);
var $3939d1de148b5202$var$kDistanceShortCodeValueOffset = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
]);
var $3939d1de148b5202$var$kMaxHuffmanTableSize = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
]);
function $3939d1de148b5202$var$DecodeWindowBits(br) {
    var n;
    if (br.readBits(1) === 0) return 16;
    n = br.readBits(3);
    if (n > 0) return 17 + n;
    n = br.readBits(3);
    if (n > 0) return 8 + n;
    return 17;
}
/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function $3939d1de148b5202$var$DecodeVarLenUint8(br) {
    if (br.readBits(1)) {
        var nbits = br.readBits(3);
        if (nbits === 0) return 1;
        else return br.readBits(nbits) + (1 << nbits);
    }
    return 0;
}
function $3939d1de148b5202$var$MetaBlockLength() {
    this.meta_block_length = 0;
    this.input_end = 0;
    this.is_uncompressed = 0;
    this.is_metadata = false;
}
function $3939d1de148b5202$var$DecodeMetaBlockLength(br) {
    var out = new $3939d1de148b5202$var$MetaBlockLength();
    var size_nibbles;
    var size_bytes;
    var i;
    out.input_end = br.readBits(1);
    if (out.input_end && br.readBits(1)) return out;
    size_nibbles = br.readBits(2) + 4;
    if (size_nibbles === 7) {
        out.is_metadata = true;
        if (br.readBits(1) !== 0) throw new Error('Invalid reserved bit');
        size_bytes = br.readBits(2);
        if (size_bytes === 0) return out;
        for(i = 0; i < size_bytes; i++){
            var next_byte = br.readBits(8);
            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error('Invalid size byte');
            out.meta_block_length |= next_byte << i * 8;
        }
    } else for(i = 0; i < size_nibbles; ++i){
        var next_nibble = br.readBits(4);
        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error('Invalid size nibble');
        out.meta_block_length |= next_nibble << i * 4;
    }
    ++out.meta_block_length;
    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
    return out;
}
/* Decodes the next Huffman code from bit-stream. */ function $3939d1de148b5202$var$ReadSymbol(table, index, br) {
    var nbits;
    br.fillBitWindow();
    index += br.val_ >>> br.bit_pos_ & $3939d1de148b5202$var$HUFFMAN_TABLE_MASK;
    nbits = table[index].bits - $3939d1de148b5202$var$HUFFMAN_TABLE_BITS;
    if (nbits > 0) {
        br.bit_pos_ += $3939d1de148b5202$var$HUFFMAN_TABLE_BITS;
        index += table[index].value;
        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
    }
    br.bit_pos_ += table[index].bits;
    return table[index].value;
}
function $3939d1de148b5202$var$ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
    var symbol = 0;
    var prev_code_len = $3939d1de148b5202$var$kDefaultCodeLength;
    var repeat = 0;
    var repeat_code_len = 0;
    var space = 32768;
    var table = [];
    for(var i = 0; i < 32; i++)table.push(new $3939d1de148b5202$var$HuffmanCode$1(0, 0));
    $3939d1de148b5202$var$BrotliBuildHuffmanTable$1(table, 0, 5, code_length_code_lengths, $3939d1de148b5202$var$CODE_LENGTH_CODES);
    while(symbol < num_symbols && space > 0){
        var p = 0;
        var code_len;
        br.readMoreInput();
        br.fillBitWindow();
        p += br.val_ >>> br.bit_pos_ & 31;
        br.bit_pos_ += table[p].bits;
        code_len = table[p].value & 0xff;
        if (code_len < $3939d1de148b5202$var$kCodeLengthRepeatCode) {
            repeat = 0;
            code_lengths[symbol++] = code_len;
            if (code_len !== 0) {
                prev_code_len = code_len;
                space -= 32768 >> code_len;
            }
        } else {
            var extra_bits = code_len - 14;
            var old_repeat;
            var repeat_delta;
            var new_len = 0;
            if (code_len === $3939d1de148b5202$var$kCodeLengthRepeatCode) new_len = prev_code_len;
            if (repeat_code_len !== new_len) {
                repeat = 0;
                repeat_code_len = new_len;
            }
            old_repeat = repeat;
            if (repeat > 0) {
                repeat -= 2;
                repeat <<= extra_bits;
            }
            repeat += br.readBits(extra_bits) + 3;
            repeat_delta = repeat - old_repeat;
            if (symbol + repeat_delta > num_symbols) throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
            symbol += repeat_delta;
            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
        }
    }
    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
}
function $3939d1de148b5202$var$ReadHuffmanCode(alphabet_size, tables, table, br) {
    var table_size = 0;
    var simple_code_or_skip;
    var code_lengths = new Uint8Array(alphabet_size);
    br.readMoreInput();
    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
    if (simple_code_or_skip === 1) {
        /* Read symbols, codes & code lengths directly. */ var i;
        var max_bits_counter = alphabet_size - 1;
        var max_bits = 0;
        var symbols = new Int32Array(4);
        var num_symbols = br.readBits(2) + 1;
        while(max_bits_counter){
            max_bits_counter >>= 1;
            ++max_bits;
        }
        for(i = 0; i < num_symbols; ++i){
            symbols[i] = br.readBits(max_bits) % alphabet_size;
            code_lengths[symbols[i]] = 2;
        }
        code_lengths[symbols[0]] = 1;
        switch(num_symbols){
            case 1:
                break;
            case 3:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error('[ReadHuffmanCode] invalid symbols');
                break;
            case 2:
                if (symbols[0] === symbols[1]) throw new Error('[ReadHuffmanCode] invalid symbols');
                code_lengths[symbols[1]] = 1;
                break;
            case 4:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error('[ReadHuffmanCode] invalid symbols');
                if (br.readBits(1)) {
                    code_lengths[symbols[2]] = 3;
                    code_lengths[symbols[3]] = 3;
                } else code_lengths[symbols[0]] = 2;
                break;
        }
    } else {
        /* Decode Huffman-coded code lengths. */ var i;
        var code_length_code_lengths = new Uint8Array($3939d1de148b5202$var$CODE_LENGTH_CODES);
        var space = 32;
        var num_codes = 0;
        /* Static Huffman code for the code length code lengths */ var huff = [
            new $3939d1de148b5202$var$HuffmanCode$1(2, 0),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 4),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 3),
            new $3939d1de148b5202$var$HuffmanCode$1(3, 2),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 0),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 4),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 3),
            new $3939d1de148b5202$var$HuffmanCode$1(4, 1),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 0),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 4),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 3),
            new $3939d1de148b5202$var$HuffmanCode$1(3, 2),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 0),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 4),
            new $3939d1de148b5202$var$HuffmanCode$1(2, 3),
            new $3939d1de148b5202$var$HuffmanCode$1(4, 5)
        ];
        for(i = simple_code_or_skip; i < $3939d1de148b5202$var$CODE_LENGTH_CODES && space > 0; ++i){
            var code_len_idx = $3939d1de148b5202$var$kCodeLengthCodeOrder[i];
            var p = 0;
            var v;
            br.fillBitWindow();
            p += br.val_ >>> br.bit_pos_ & 15;
            br.bit_pos_ += huff[p].bits;
            v = huff[p].value;
            code_length_code_lengths[code_len_idx] = v;
            if (v !== 0) {
                space -= 32 >> v;
                ++num_codes;
            }
        }
        if (!(num_codes === 1 || space === 0)) throw new Error('[ReadHuffmanCode] invalid num_codes or space');
        $3939d1de148b5202$var$ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
    }
    table_size = $3939d1de148b5202$var$BrotliBuildHuffmanTable$1(tables, table, $3939d1de148b5202$var$HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return table_size;
}
function $3939d1de148b5202$var$ReadBlockLength(table, index, br) {
    var code;
    var nbits;
    code = $3939d1de148b5202$var$ReadSymbol(table, index, br);
    nbits = $3939d1de148b5202$var$prefix.kBlockLengthPrefixCode[code].nbits;
    return $3939d1de148b5202$var$prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}
function $3939d1de148b5202$var$TranslateShortCodes(code, ringbuffer, index) {
    var val;
    if (code < $3939d1de148b5202$var$NUM_DISTANCE_SHORT_CODES) {
        index += $3939d1de148b5202$var$kDistanceShortCodeIndexOffset[code];
        index &= 3;
        val = ringbuffer[index] + $3939d1de148b5202$var$kDistanceShortCodeValueOffset[code];
    } else val = code - $3939d1de148b5202$var$NUM_DISTANCE_SHORT_CODES + 1;
    return val;
}
function $3939d1de148b5202$var$MoveToFront(v, index) {
    var value = v[index];
    var i = index;
    for(; i; --i)v[i] = v[i - 1];
    v[0] = value;
}
function $3939d1de148b5202$var$InverseMoveToFrontTransform(v, v_len) {
    var mtf = new Uint8Array(256);
    var i;
    for(i = 0; i < 256; ++i)mtf[i] = i;
    for(i = 0; i < v_len; ++i){
        var index = v[i];
        v[i] = mtf[index];
        if (index) $3939d1de148b5202$var$MoveToFront(mtf, index);
    }
}
/* Contains a collection of huffman trees with the same alphabet size. */ function $3939d1de148b5202$var$HuffmanTreeGroup(alphabet_size, num_htrees) {
    this.alphabet_size = alphabet_size;
    this.num_htrees = num_htrees;
    this.codes = new Array(num_htrees + num_htrees * $3939d1de148b5202$var$kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
    this.htrees = new Uint32Array(num_htrees);
}
$3939d1de148b5202$var$HuffmanTreeGroup.prototype.decode = function(br) {
    var i;
    var table_size;
    var next = 0;
    for(i = 0; i < this.num_htrees; ++i){
        this.htrees[i] = next;
        table_size = $3939d1de148b5202$var$ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
        next += table_size;
    }
};
function $3939d1de148b5202$var$DecodeContextMap(context_map_size, br) {
    var out = {
        num_htrees: null,
        context_map: null
    };
    var use_rle_for_zeros;
    var max_run_length_prefix = 0;
    var table;
    var i;
    br.readMoreInput();
    var num_htrees = out.num_htrees = $3939d1de148b5202$var$DecodeVarLenUint8(br) + 1;
    var context_map = out.context_map = new Uint8Array(context_map_size);
    if (num_htrees <= 1) return out;
    use_rle_for_zeros = br.readBits(1);
    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
    table = [];
    for(i = 0; i < $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new $3939d1de148b5202$var$HuffmanCode$1(0, 0);
    $3939d1de148b5202$var$ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
    for(i = 0; i < context_map_size;){
        var code;
        br.readMoreInput();
        code = $3939d1de148b5202$var$ReadSymbol(table, 0, br);
        if (code === 0) {
            context_map[i] = 0;
            ++i;
        } else if (code <= max_run_length_prefix) {
            var reps = 1 + (1 << code) + br.readBits(code);
            while(--reps){
                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                context_map[i] = 0;
                ++i;
            }
        } else {
            context_map[i] = code - max_run_length_prefix;
            ++i;
        }
    }
    if (br.readBits(1)) $3939d1de148b5202$var$InverseMoveToFrontTransform(context_map, context_map_size);
    return out;
}
function $3939d1de148b5202$var$DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
    var ringbuffer = tree_type * 2;
    var index = tree_type;
    var type_code = $3939d1de148b5202$var$ReadSymbol(trees, tree_type * $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE, br);
    var block_type;
    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
    else block_type = type_code - 2;
    if (block_type >= max_block_type) block_type -= max_block_type;
    block_types[tree_type] = block_type;
    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
    ++indexes[index];
}
function $3939d1de148b5202$var$CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
    var rb_size = ringbuffer_mask + 1;
    var rb_pos = pos & ringbuffer_mask;
    var br_pos = br.pos_ & $3939d1de148b5202$var$bit_reader.IBUF_MASK;
    var nbytes;
    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
        while(len-- > 0){
            br.readMoreInput();
            ringbuffer[rb_pos++] = br.readBits(8);
            if (rb_pos === rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos = 0;
            }
        }
        return;
    }
    if (br.bit_end_pos_ < 32) throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
        br.bit_pos_ += 8;
        ++rb_pos;
        --len;
    }
    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
    if (br_pos + nbytes > $3939d1de148b5202$var$bit_reader.IBUF_MASK) {
        var tail = $3939d1de148b5202$var$bit_reader.IBUF_MASK + 1 - br_pos;
        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
        nbytes -= tail;
        rb_pos += tail;
        len -= tail;
        br_pos = 0;
    }
    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    rb_pos += nbytes;
    len -= nbytes;
    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos -= rb_size;
        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
    }
    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
        nbytes = rb_size - rb_pos;
        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
        output.write(ringbuffer, rb_size);
        len -= nbytes;
        rb_pos = 0;
    }
    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
    /* Restore the state of the bit reader. */ br.reset();
}
/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function $3939d1de148b5202$var$JumpToByteBoundary(br) {
    var new_bit_pos = br.bit_pos_ + 7 & -8;
    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
    return pad_bits == 0;
}
function $3939d1de148b5202$var$BrotliDecompressedSize(buffer) {
    var input = new $3939d1de148b5202$var$BrotliInput$1(buffer);
    var br = new $3939d1de148b5202$var$bit_reader(input);
    $3939d1de148b5202$var$DecodeWindowBits(br);
    var out = $3939d1de148b5202$var$DecodeMetaBlockLength(br);
    return out.meta_block_length;
}
var $3939d1de148b5202$var$BrotliDecompressedSize_1 = $3939d1de148b5202$var$BrotliDecompressedSize;
function $3939d1de148b5202$var$BrotliDecompressBuffer(buffer, output_size) {
    var input = new $3939d1de148b5202$var$BrotliInput$1(buffer);
    if (output_size == null) output_size = $3939d1de148b5202$var$BrotliDecompressedSize(buffer);
    var output_buffer = new Uint8Array(output_size);
    var output = new $3939d1de148b5202$var$BrotliOutput$1(output_buffer);
    $3939d1de148b5202$var$BrotliDecompress(input, output);
    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
    return output.buffer;
}
var $3939d1de148b5202$var$BrotliDecompressBuffer_1 = $3939d1de148b5202$var$BrotliDecompressBuffer;
function $3939d1de148b5202$var$BrotliDecompress(input, output) {
    var i;
    var pos = 0;
    var input_end = 0;
    var window_bits = 0;
    var max_backward_distance;
    var max_distance = 0;
    var ringbuffer_size;
    var ringbuffer_mask;
    var ringbuffer;
    var ringbuffer_end;
    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
        16,
        15,
        11,
        4
    ];
    var dist_rb_idx = 0;
    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
    var prev_byte2 = 0;
    var hgroup = [
        new $3939d1de148b5202$var$HuffmanTreeGroup(0, 0),
        new $3939d1de148b5202$var$HuffmanTreeGroup(0, 0),
        new $3939d1de148b5202$var$HuffmanTreeGroup(0, 0)
    ];
    var block_type_trees;
    var block_len_trees;
    var br;
    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + $3939d1de148b5202$var$bit_reader.READ_SIZE;
    br = new $3939d1de148b5202$var$bit_reader(input);
    /* Decode window size. */ window_bits = $3939d1de148b5202$var$DecodeWindowBits(br);
    max_backward_distance = (1 << window_bits) - 16;
    ringbuffer_size = 1 << window_bits;
    ringbuffer_mask = ringbuffer_size - 1;
    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + $3939d1de148b5202$var$dictionary.maxDictionaryWordLength);
    ringbuffer_end = ringbuffer_size;
    block_type_trees = [];
    block_len_trees = [];
    for(var x = 0; x < 3 * $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE; x++){
        block_type_trees[x] = new $3939d1de148b5202$var$HuffmanCode$1(0, 0);
        block_len_trees[x] = new $3939d1de148b5202$var$HuffmanCode$1(0, 0);
    }
    while(!input_end){
        var meta_block_remaining_len = 0;
        var is_uncompressed;
        var block_length = [
            268435456,
            268435456,
            268435456
        ];
        var block_type = [
            0
        ];
        var num_block_types = [
            1,
            1,
            1
        ];
        var block_type_rb = [
            0,
            1,
            0,
            1,
            0,
            1
        ];
        var block_type_rb_index = [
            0
        ];
        var distance_postfix_bits;
        var num_direct_distance_codes;
        var distance_postfix_mask;
        var num_distance_codes;
        var context_map = null;
        var context_modes = null;
        var num_literal_htrees;
        var dist_context_map = null;
        var num_dist_htrees;
        var context_offset = 0;
        var context_map_slice = null;
        var literal_htree_index = 0;
        var dist_context_offset = 0;
        var dist_context_map_slice = null;
        var dist_htree_index = 0;
        var context_lookup_offset1 = 0;
        var context_lookup_offset2 = 0;
        var context_mode;
        var htree_command;
        for(i = 0; i < 3; ++i){
            hgroup[i].codes = null;
            hgroup[i].htrees = null;
        }
        br.readMoreInput();
        var _out = $3939d1de148b5202$var$DecodeMetaBlockLength(br);
        meta_block_remaining_len = _out.meta_block_length;
        if (pos + meta_block_remaining_len > output.buffer.length) {
            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
            tmp.set(output.buffer);
            output.buffer = tmp;
        }
        input_end = _out.input_end;
        is_uncompressed = _out.is_uncompressed;
        if (_out.is_metadata) {
            $3939d1de148b5202$var$JumpToByteBoundary(br);
            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                br.readMoreInput();
                /* Read one byte and ignore it. */ br.readBits(8);
            }
            continue;
        }
        if (meta_block_remaining_len === 0) continue;
        if (is_uncompressed) {
            br.bit_pos_ = br.bit_pos_ + 7 & -8;
            $3939d1de148b5202$var$CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
            pos += meta_block_remaining_len;
            continue;
        }
        for(i = 0; i < 3; ++i){
            num_block_types[i] = $3939d1de148b5202$var$DecodeVarLenUint8(br) + 1;
            if (num_block_types[i] >= 2) {
                $3939d1de148b5202$var$ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE, br);
                $3939d1de148b5202$var$ReadHuffmanCode($3939d1de148b5202$var$kNumBlockLengthCodes, block_len_trees, i * $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_length[i] = $3939d1de148b5202$var$ReadBlockLength(block_len_trees, i * $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_type_rb_index[i] = 1;
            }
        }
        br.readMoreInput();
        distance_postfix_bits = br.readBits(2);
        num_direct_distance_codes = $3939d1de148b5202$var$NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
        context_modes = new Uint8Array(num_block_types[0]);
        for(i = 0; i < num_block_types[0]; ++i){
            br.readMoreInput();
            context_modes[i] = br.readBits(2) << 1;
        }
        var _o1 = $3939d1de148b5202$var$DecodeContextMap(num_block_types[0] << $3939d1de148b5202$var$kLiteralContextBits, br);
        num_literal_htrees = _o1.num_htrees;
        context_map = _o1.context_map;
        var _o2 = $3939d1de148b5202$var$DecodeContextMap(num_block_types[2] << $3939d1de148b5202$var$kDistanceContextBits, br);
        num_dist_htrees = _o2.num_htrees;
        dist_context_map = _o2.context_map;
        hgroup[0] = new $3939d1de148b5202$var$HuffmanTreeGroup($3939d1de148b5202$var$kNumLiteralCodes, num_literal_htrees);
        hgroup[1] = new $3939d1de148b5202$var$HuffmanTreeGroup($3939d1de148b5202$var$kNumInsertAndCopyCodes, num_block_types[1]);
        hgroup[2] = new $3939d1de148b5202$var$HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
        context_map_slice = 0;
        dist_context_map_slice = 0;
        context_mode = context_modes[block_type[0]];
        context_lookup_offset1 = $3939d1de148b5202$var$context.lookupOffsets[context_mode];
        context_lookup_offset2 = $3939d1de148b5202$var$context.lookupOffsets[context_mode + 1];
        htree_command = hgroup[1].htrees[0];
        while(meta_block_remaining_len > 0){
            var cmd_code;
            var range_idx;
            var insert_code;
            var copy_code;
            var insert_length;
            var copy_length;
            var distance_code;
            var distance;
            var context$1;
            var j;
            var copy_dst;
            br.readMoreInput();
            if (block_length[1] === 0) {
                $3939d1de148b5202$var$DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                block_length[1] = $3939d1de148b5202$var$ReadBlockLength(block_len_trees, $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE, br);
                htree_command = hgroup[1].htrees[block_type[1]];
            }
            --block_length[1];
            cmd_code = $3939d1de148b5202$var$ReadSymbol(hgroup[1].codes, htree_command, br);
            range_idx = cmd_code >> 6;
            if (range_idx >= 2) {
                range_idx -= 2;
                distance_code = -1;
            } else distance_code = 0;
            insert_code = $3939d1de148b5202$var$prefix.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
            copy_code = $3939d1de148b5202$var$prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
            insert_length = $3939d1de148b5202$var$prefix.kInsertLengthPrefixCode[insert_code].offset + br.readBits($3939d1de148b5202$var$prefix.kInsertLengthPrefixCode[insert_code].nbits);
            copy_length = $3939d1de148b5202$var$prefix.kCopyLengthPrefixCode[copy_code].offset + br.readBits($3939d1de148b5202$var$prefix.kCopyLengthPrefixCode[copy_code].nbits);
            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
            for(j = 0; j < insert_length; ++j){
                br.readMoreInput();
                if (block_length[0] === 0) {
                    $3939d1de148b5202$var$DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[0] = $3939d1de148b5202$var$ReadBlockLength(block_len_trees, 0, br);
                    context_offset = block_type[0] << $3939d1de148b5202$var$kLiteralContextBits;
                    context_map_slice = context_offset;
                    context_mode = context_modes[block_type[0]];
                    context_lookup_offset1 = $3939d1de148b5202$var$context.lookupOffsets[context_mode];
                    context_lookup_offset2 = $3939d1de148b5202$var$context.lookupOffsets[context_mode + 1];
                }
                context$1 = $3939d1de148b5202$var$context.lookup[context_lookup_offset1 + prev_byte1] | $3939d1de148b5202$var$context.lookup[context_lookup_offset2 + prev_byte2];
                literal_htree_index = context_map[context_map_slice + context$1];
                --block_length[0];
                prev_byte2 = prev_byte1;
                prev_byte1 = $3939d1de148b5202$var$ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                ++pos;
            }
            meta_block_remaining_len -= insert_length;
            if (meta_block_remaining_len <= 0) break;
            if (distance_code < 0) {
                var context$1;
                br.readMoreInput();
                if (block_length[2] === 0) {
                    $3939d1de148b5202$var$DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[2] = $3939d1de148b5202$var$ReadBlockLength(block_len_trees, 2 * $3939d1de148b5202$var$HUFFMAN_MAX_TABLE_SIZE, br);
                    dist_context_offset = block_type[2] << $3939d1de148b5202$var$kDistanceContextBits;
                    dist_context_map_slice = dist_context_offset;
                }
                --block_length[2];
                context$1 = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                dist_htree_index = dist_context_map[dist_context_map_slice + context$1];
                distance_code = $3939d1de148b5202$var$ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                if (distance_code >= num_direct_distance_codes) {
                    var nbits;
                    var postfix;
                    var offset;
                    distance_code -= num_direct_distance_codes;
                    postfix = distance_code & distance_postfix_mask;
                    distance_code >>= distance_postfix_bits;
                    nbits = (distance_code >> 1) + 1;
                    offset = (2 + (distance_code & 1) << nbits) - 4;
                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                }
            }
            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = $3939d1de148b5202$var$TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
            if (distance < 0) throw new Error('[BrotliDecompress] invalid distance');
            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
            else max_distance = max_backward_distance;
            copy_dst = pos & ringbuffer_mask;
            if (distance > max_distance) {
                if (copy_length >= $3939d1de148b5202$var$dictionary.minDictionaryWordLength && copy_length <= $3939d1de148b5202$var$dictionary.maxDictionaryWordLength) {
                    var offset = $3939d1de148b5202$var$dictionary.offsetsByLength[copy_length];
                    var word_id = distance - max_distance - 1;
                    var shift = $3939d1de148b5202$var$dictionary.sizeBitsByLength[copy_length];
                    var mask = (1 << shift) - 1;
                    var word_idx = word_id & mask;
                    var transform_idx = word_id >> shift;
                    offset += word_idx * copy_length;
                    if (transform_idx < $3939d1de148b5202$var$transform.kNumTransforms) {
                        var len = $3939d1de148b5202$var$transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                        copy_dst += len;
                        pos += len;
                        meta_block_remaining_len -= len;
                        if (copy_dst >= ringbuffer_end) {
                            output.write(ringbuffer, ringbuffer_size);
                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                        }
                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            } else {
                if (distance_code > 0) {
                    dist_rb[dist_rb_idx & 3] = distance;
                    ++dist_rb_idx;
                }
                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                for(j = 0; j < copy_length; ++j){
                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                    ++pos;
                    --meta_block_remaining_len;
                }
            }
            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
        }
        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
    }
    output.write(ringbuffer, pos & ringbuffer_mask);
}
var $3939d1de148b5202$var$BrotliDecompress_1 = $3939d1de148b5202$var$BrotliDecompress;
$3939d1de148b5202$var$dictionary.init($3939d1de148b5202$var$BrotliDecompressBuffer);
var $3939d1de148b5202$var$decode = {
    BrotliDecompressedSize: $3939d1de148b5202$var$BrotliDecompressedSize_1,
    BrotliDecompressBuffer: $3939d1de148b5202$var$BrotliDecompressBuffer_1,
    BrotliDecompress: $3939d1de148b5202$var$BrotliDecompress_1
};
var $3939d1de148b5202$var$decompress = $3939d1de148b5202$var$decode.BrotliDecompressBuffer;
function $3939d1de148b5202$var$_inheritsLoose$g(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
 */ var $3939d1de148b5202$var$WOFF2Glyph = /*#__PURE__*/ function(_TTFGlyph) {
    $3939d1de148b5202$var$_inheritsLoose$g(WOFF2Glyph, _TTFGlyph);
    function WOFF2Glyph() {
        return _TTFGlyph.apply(this, arguments) || this;
    }
    var _proto = WOFF2Glyph.prototype;
    _proto._decode = function _decode() {
        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
        return this._font._transformedGlyphs[this.id];
    };
    _proto._getCBox = function _getCBox() {
        return this.path.bbox;
    };
    return WOFF2Glyph;
}($3939d1de148b5202$var$TTFGlyph);
var $3939d1de148b5202$var$Base128 = {
    decode: function decode(stream) {
        var result = 0;
        var iterable = [
            0,
            1,
            2,
            3,
            4
        ];
        for(var j = 0; j < iterable.length; j++){
            var code = stream.readUInt8(); // If any of the top seven bits are set then we're about to overflow.
            if (result & 0xe0000000) throw new Error('Overflow');
            result = result << 7 | code & 0x7f;
            if ((code & 0x80) === 0) return result;
        }
        throw new Error('Bad base 128 number');
    }
};
var $3939d1de148b5202$var$knownTags = [
    'cmap',
    'head',
    'hhea',
    'hmtx',
    'maxp',
    'name',
    'OS/2',
    'post',
    'cvt ',
    'fpgm',
    'glyf',
    'loca',
    'prep',
    'CFF ',
    'VORG',
    'EBDT',
    'EBLC',
    'gasp',
    'hdmx',
    'kern',
    'LTSH',
    'PCLT',
    'VDMX',
    'vhea',
    'vmtx',
    'BASE',
    'GDEF',
    'GPOS',
    'GSUB',
    'EBSC',
    'JSTF',
    'MATH',
    'CBDT',
    'CBLC',
    'COLR',
    'CPAL',
    'SVG ',
    'sbix',
    'acnt',
    'avar',
    'bdat',
    'bloc',
    'bsln',
    'cvar',
    'fdsc',
    'feat',
    'fmtx',
    'fvar',
    'gvar',
    'hsty',
    'just',
    'lcar',
    'mort',
    'morx',
    'opbd',
    'prop',
    'trak',
    'Zapf',
    'Silf',
    'Glat',
    'Gloc',
    'Feat',
    'Sill'
];
var $3939d1de148b5202$var$WOFF2DirectoryEntry = new $3939d1de148b5202$var$restructure.Struct({
    flags: $3939d1de148b5202$var$restructure.uint8,
    customTag: new $3939d1de148b5202$var$restructure.Optional(new $3939d1de148b5202$var$restructure.String(4), function(t) {
        return (t.flags & 0x3f) === 0x3f;
    }),
    tag: function tag(t) {
        return t.customTag || $3939d1de148b5202$var$knownTags[t.flags & 0x3f];
    },
    // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
    length: $3939d1de148b5202$var$Base128,
    transformVersion: function transformVersion(t) {
        return t.flags >>> 6 & 0x03;
    },
    transformed: function transformed(t) {
        return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
    },
    transformLength: new $3939d1de148b5202$var$restructure.Optional($3939d1de148b5202$var$Base128, function(t) {
        return t.transformed;
    })
});
var $3939d1de148b5202$var$WOFF2Directory = new $3939d1de148b5202$var$restructure.Struct({
    tag: new $3939d1de148b5202$var$restructure.String(4),
    // should be 'wOF2'
    flavor: $3939d1de148b5202$var$restructure.uint32,
    length: $3939d1de148b5202$var$restructure.uint32,
    numTables: $3939d1de148b5202$var$restructure.uint16,
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint16),
    totalSfntSize: $3939d1de148b5202$var$restructure.uint32,
    totalCompressedSize: $3939d1de148b5202$var$restructure.uint32,
    majorVersion: $3939d1de148b5202$var$restructure.uint16,
    minorVersion: $3939d1de148b5202$var$restructure.uint16,
    metaOffset: $3939d1de148b5202$var$restructure.uint32,
    metaLength: $3939d1de148b5202$var$restructure.uint32,
    metaOrigLength: $3939d1de148b5202$var$restructure.uint32,
    privOffset: $3939d1de148b5202$var$restructure.uint32,
    privLength: $3939d1de148b5202$var$restructure.uint32,
    tables: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$WOFF2DirectoryEntry, 'numTables')
});
$3939d1de148b5202$var$WOFF2Directory.process = function() {
    var tables = {};
    for(var i = 0; i < this.tables.length; i++){
        var table = this.tables[i];
        tables[table.tag] = table;
    }
    return this.tables = tables;
};
function $3939d1de148b5202$var$_inheritsLoose$h(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
 * See spec here: http://www.w3.org/TR/WOFF2/
 */ var $3939d1de148b5202$var$WOFF2Font = /*#__PURE__*/ function(_TTFFont) {
    $3939d1de148b5202$var$_inheritsLoose$h(WOFF2Font, _TTFFont);
    function WOFF2Font() {
        return _TTFFont.apply(this, arguments) || this;
    }
    WOFF2Font.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'wOF2';
    };
    var _proto = WOFF2Font.prototype;
    _proto._decodeDirectory = function _decodeDirectory() {
        this.directory = $3939d1de148b5202$var$WOFF2Directory.decode(this.stream);
        this._dataPos = this.stream.pos;
    };
    _proto._decompress = function _decompress() {
        // decompress data and setup table offsets if we haven't already
        if (!this._decompressed) {
            this.stream.pos = this._dataPos;
            var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
            var decompressedSize = 0;
            for(var tag in this.directory.tables){
                var entry = this.directory.tables[tag];
                entry.offset = decompressedSize;
                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
            }
            var decompressed = $3939d1de148b5202$var$decompress(buffer, decompressedSize);
            if (!decompressed) throw new Error('Error decoding compressed data in WOFF2');
            this.stream = new $3939d1de148b5202$var$restructure.DecodeStream(new $3939d1de148b5202$var$buffer_1(decompressed));
            this._decompressed = true;
        }
    };
    _proto._decodeTable = function _decodeTable(table) {
        this._decompress();
        return _TTFFont.prototype._decodeTable.call(this, table);
    } // Override this method to get a glyph and return our
    ;
    _proto._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
        if (characters === void 0) characters = [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                if (!this._transformedGlyphs) this._transformGlyfTable();
                return this._glyphs[glyph] = new $3939d1de148b5202$var$WOFF2Glyph(glyph, characters, this);
            } else return _TTFFont.prototype._getBaseGlyph.call(this, glyph, characters);
        }
    };
    _proto._transformGlyfTable = function _transformGlyfTable() {
        this._decompress();
        this.stream.pos = this.directory.tables.glyf.offset;
        var table = $3939d1de148b5202$var$GlyfTable.decode(this.stream);
        var glyphs = [];
        for(var index = 0; index < table.numGlyphs; index++){
            var glyph = {};
            var nContours = table.nContours.readInt16BE();
            glyph.numberOfContours = nContours;
            if (nContours > 0) {
                // simple glyph
                var nPoints = [];
                var totalPoints = 0;
                for(var i = 0; i < nContours; i++){
                    var _r = $3939d1de148b5202$var$read255UInt16(table.nPoints);
                    totalPoints += _r;
                    nPoints.push(totalPoints);
                }
                glyph.points = $3939d1de148b5202$var$decodeTriplet(table.flags, table.glyphs, totalPoints);
                for(var _i = 0; _i < nContours; _i++)glyph.points[nPoints[_i] - 1].endContour = true;
                var instructionSize = $3939d1de148b5202$var$read255UInt16(table.glyphs);
            } else if (nContours < 0) {
                // composite glyph
                var haveInstructions = $3939d1de148b5202$var$TTFGlyph.prototype._decodeComposite.call({
                    _font: this
                }, glyph, table.composites);
                if (haveInstructions) var instructionSize = $3939d1de148b5202$var$read255UInt16(table.glyphs);
            }
            glyphs.push(glyph);
        }
        this._transformedGlyphs = glyphs;
    };
    return WOFF2Font;
}($3939d1de148b5202$var$TTFFont); // Special class that accepts a length and returns a sub-stream for that data
var $3939d1de148b5202$var$Substream = /*#__PURE__*/ function() {
    function Substream(length) {
        this.length = length;
        this._buf = new $3939d1de148b5202$var$restructure.Buffer(length);
    }
    var _proto2 = Substream.prototype;
    _proto2.decode = function decode(stream, parent) {
        return new $3939d1de148b5202$var$restructure.DecodeStream(this._buf.decode(stream, parent));
    };
    return Substream;
}(); // This struct represents the entire glyf table
var $3939d1de148b5202$var$GlyfTable = new $3939d1de148b5202$var$restructure.Struct({
    version: $3939d1de148b5202$var$restructure.uint32,
    numGlyphs: $3939d1de148b5202$var$restructure.uint16,
    indexFormat: $3939d1de148b5202$var$restructure.uint16,
    nContourStreamSize: $3939d1de148b5202$var$restructure.uint32,
    nPointsStreamSize: $3939d1de148b5202$var$restructure.uint32,
    flagStreamSize: $3939d1de148b5202$var$restructure.uint32,
    glyphStreamSize: $3939d1de148b5202$var$restructure.uint32,
    compositeStreamSize: $3939d1de148b5202$var$restructure.uint32,
    bboxStreamSize: $3939d1de148b5202$var$restructure.uint32,
    instructionStreamSize: $3939d1de148b5202$var$restructure.uint32,
    nContours: new $3939d1de148b5202$var$Substream('nContourStreamSize'),
    nPoints: new $3939d1de148b5202$var$Substream('nPointsStreamSize'),
    flags: new $3939d1de148b5202$var$Substream('flagStreamSize'),
    glyphs: new $3939d1de148b5202$var$Substream('glyphStreamSize'),
    composites: new $3939d1de148b5202$var$Substream('compositeStreamSize'),
    bboxes: new $3939d1de148b5202$var$Substream('bboxStreamSize'),
    instructions: new $3939d1de148b5202$var$Substream('instructionStreamSize')
});
var $3939d1de148b5202$var$WORD_CODE = 253;
var $3939d1de148b5202$var$ONE_MORE_BYTE_CODE2 = 254;
var $3939d1de148b5202$var$ONE_MORE_BYTE_CODE1 = 255;
var $3939d1de148b5202$var$LOWEST_U_CODE = 253;
function $3939d1de148b5202$var$read255UInt16(stream) {
    var code = stream.readUInt8();
    if (code === $3939d1de148b5202$var$WORD_CODE) return stream.readUInt16BE();
    if (code === $3939d1de148b5202$var$ONE_MORE_BYTE_CODE1) return stream.readUInt8() + $3939d1de148b5202$var$LOWEST_U_CODE;
    if (code === $3939d1de148b5202$var$ONE_MORE_BYTE_CODE2) return stream.readUInt8() + $3939d1de148b5202$var$LOWEST_U_CODE * 2;
    return code;
}
function $3939d1de148b5202$var$withSign(flag, baseval) {
    return flag & 1 ? baseval : -baseval;
}
function $3939d1de148b5202$var$decodeTriplet(flags, glyphs, nPoints) {
    var y;
    var x = y = 0;
    var res = [];
    for(var i = 0; i < nPoints; i++){
        var dx = 0, dy = 0;
        var flag = flags.readUInt8();
        var onCurve = !(flag >> 7);
        flag &= 0x7f;
        if (flag < 10) {
            dx = 0;
            dy = $3939d1de148b5202$var$withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
        } else if (flag < 20) {
            dx = $3939d1de148b5202$var$withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
            dy = 0;
        } else if (flag < 84) {
            var b0 = flag - 20;
            var b1 = glyphs.readUInt8();
            dx = $3939d1de148b5202$var$withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
            dy = $3939d1de148b5202$var$withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
        } else if (flag < 120) {
            var b0 = flag - 84;
            dx = $3939d1de148b5202$var$withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
            dy = $3939d1de148b5202$var$withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
        } else if (flag < 124) {
            var b1 = glyphs.readUInt8();
            var b2 = glyphs.readUInt8();
            dx = $3939d1de148b5202$var$withSign(flag, (b1 << 4) + (b2 >> 4));
            dy = $3939d1de148b5202$var$withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
        } else {
            dx = $3939d1de148b5202$var$withSign(flag, glyphs.readUInt16BE());
            dy = $3939d1de148b5202$var$withSign(flag >> 1, glyphs.readUInt16BE());
        }
        x += dx;
        y += dy;
        res.push(new $3939d1de148b5202$var$Point(onCurve, false, x, y));
    }
    return res;
}
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$s(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$s(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$s(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$s(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$s(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$s(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_defineProperties$9(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$9(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$9(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$9(Constructor, staticProps);
    return Constructor;
}
var $3939d1de148b5202$var$TTCHeader = new $3939d1de148b5202$var$restructure.VersionedStruct($3939d1de148b5202$var$restructure.uint32, {
    0x00010000: {
        numFonts: $3939d1de148b5202$var$restructure.uint32,
        offsets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, 'numFonts')
    },
    0x00020000: {
        numFonts: $3939d1de148b5202$var$restructure.uint32,
        offsets: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$restructure.uint32, 'numFonts'),
        dsigTag: $3939d1de148b5202$var$restructure.uint32,
        dsigLength: $3939d1de148b5202$var$restructure.uint32,
        dsigOffset: $3939d1de148b5202$var$restructure.uint32
    }
});
var $3939d1de148b5202$var$TrueTypeCollection = /*#__PURE__*/ function() {
    TrueTypeCollection.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'ttcf';
    };
    function TrueTypeCollection(stream) {
        this.stream = stream;
        if (stream.readString(4) !== 'ttcf') throw new Error('Not a TrueType collection');
        this.header = $3939d1de148b5202$var$TTCHeader.decode(stream);
    }
    var _proto = TrueTypeCollection.prototype;
    _proto.getFont = function getFont(name) {
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$s(this.header.offsets), _step; !(_step = _iterator()).done;){
            var offset = _step.value;
            var stream = new $3939d1de148b5202$var$restructure.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            var font = new $3939d1de148b5202$var$TTFFont(stream);
            if (font.postscriptName === name) return font;
        }
        return null;
    };
    $3939d1de148b5202$var$_createClass$9(TrueTypeCollection, [
        {
            key: "fonts",
            get: function get() {
                var fonts = [];
                for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$s(this.header.offsets), _step2; !(_step2 = _iterator2()).done;){
                    var offset = _step2.value;
                    var stream = new $3939d1de148b5202$var$restructure.DecodeStream(this.stream.buffer);
                    stream.pos = offset;
                    fonts.push(new $3939d1de148b5202$var$TTFFont(stream));
                }
                return fonts;
            }
        }
    ]);
    return TrueTypeCollection;
}();
function $3939d1de148b5202$var$_createForOfIteratorHelperLoose$t(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $3939d1de148b5202$var$_unsupportedIterableToArray$t(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $3939d1de148b5202$var$_unsupportedIterableToArray$t(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3939d1de148b5202$var$_arrayLikeToArray$t(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3939d1de148b5202$var$_arrayLikeToArray$t(o, minLen);
}
function $3939d1de148b5202$var$_arrayLikeToArray$t(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3939d1de148b5202$var$_defineProperties$a(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3939d1de148b5202$var$_createClass$a(Constructor, protoProps, staticProps) {
    if (protoProps) $3939d1de148b5202$var$_defineProperties$a(Constructor.prototype, protoProps);
    if (staticProps) $3939d1de148b5202$var$_defineProperties$a(Constructor, staticProps);
    return Constructor;
}
var $3939d1de148b5202$var$DFontName = new $3939d1de148b5202$var$restructure.String($3939d1de148b5202$var$restructure.uint8);
var $3939d1de148b5202$var$DFontData = new $3939d1de148b5202$var$restructure.Struct({
    len: $3939d1de148b5202$var$restructure.uint32,
    buf: new $3939d1de148b5202$var$restructure.Buffer('len')
});
var $3939d1de148b5202$var$Ref = new $3939d1de148b5202$var$restructure.Struct({
    id: $3939d1de148b5202$var$restructure.uint16,
    nameOffset: $3939d1de148b5202$var$restructure.int16,
    attr: $3939d1de148b5202$var$restructure.uint8,
    dataOffset: $3939d1de148b5202$var$restructure.uint24,
    handle: $3939d1de148b5202$var$restructure.uint32
});
var $3939d1de148b5202$var$Type = new $3939d1de148b5202$var$restructure.Struct({
    name: new $3939d1de148b5202$var$restructure.String(4),
    maxTypeIndex: $3939d1de148b5202$var$restructure.uint16,
    refList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Ref, function(t) {
        return t.maxTypeIndex + 1;
    }), {
        type: 'parent'
    })
});
var $3939d1de148b5202$var$TypeList = new $3939d1de148b5202$var$restructure.Struct({
    length: $3939d1de148b5202$var$restructure.uint16,
    types: new $3939d1de148b5202$var$restructure.Array($3939d1de148b5202$var$Type, function(t) {
        return t.length + 1;
    })
});
var $3939d1de148b5202$var$DFontMap = new $3939d1de148b5202$var$restructure.Struct({
    reserved: new $3939d1de148b5202$var$restructure.Reserved($3939d1de148b5202$var$restructure.uint8, 24),
    typeList: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, $3939d1de148b5202$var$TypeList),
    nameListOffset: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint16, 'void')
});
var $3939d1de148b5202$var$DFontHeader = new $3939d1de148b5202$var$restructure.Struct({
    dataOffset: $3939d1de148b5202$var$restructure.uint32,
    map: new $3939d1de148b5202$var$restructure.Pointer($3939d1de148b5202$var$restructure.uint32, $3939d1de148b5202$var$DFontMap),
    dataLength: $3939d1de148b5202$var$restructure.uint32,
    mapLength: $3939d1de148b5202$var$restructure.uint32
});
var $3939d1de148b5202$var$DFont = /*#__PURE__*/ function() {
    DFont.probe = function probe(buffer) {
        var stream = new $3939d1de148b5202$var$restructure.DecodeStream(buffer);
        try {
            var header = $3939d1de148b5202$var$DFontHeader.decode(stream);
        } catch (e) {
            return false;
        }
        for(var _iterator = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$t(header.map.typeList.types), _step; !(_step = _iterator()).done;){
            var type = _step.value;
            if (type.name === 'sfnt') return true;
        }
        return false;
    };
    function DFont(stream) {
        this.stream = stream;
        this.header = $3939d1de148b5202$var$DFontHeader.decode(this.stream);
        for(var _iterator2 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$t(this.header.map.typeList.types), _step2; !(_step2 = _iterator2()).done;){
            var type = _step2.value;
            for(var _iterator3 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$t(type.refList), _step3; !(_step3 = _iterator3()).done;){
                var ref = _step3.value;
                if (ref.nameOffset >= 0) {
                    this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                    ref.name = $3939d1de148b5202$var$DFontName.decode(this.stream);
                } else ref.name = null;
            }
            if (type.name === 'sfnt') this.sfnt = type;
        }
    }
    var _proto = DFont.prototype;
    _proto.getFont = function getFont(name) {
        if (!this.sfnt) return null;
        for(var _iterator4 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$t(this.sfnt.refList), _step4; !(_step4 = _iterator4()).done;){
            var ref = _step4.value;
            var pos = this.header.dataOffset + ref.dataOffset + 4;
            var stream = new $3939d1de148b5202$var$restructure.DecodeStream(this.stream.buffer.slice(pos));
            var font = new $3939d1de148b5202$var$TTFFont(stream);
            if (font.postscriptName === name) return font;
        }
        return null;
    };
    $3939d1de148b5202$var$_createClass$a(DFont, [
        {
            key: "fonts",
            get: function get() {
                var fonts = [];
                for(var _iterator5 = $3939d1de148b5202$var$_createForOfIteratorHelperLoose$t(this.sfnt.refList), _step5; !(_step5 = _iterator5()).done;){
                    var ref = _step5.value;
                    var pos = this.header.dataOffset + ref.dataOffset + 4;
                    var stream = new $3939d1de148b5202$var$restructure.DecodeStream(this.stream.buffer.slice(pos));
                    fonts.push(new $3939d1de148b5202$var$TTFFont(stream));
                }
                return fonts;
            }
        }
    ]);
    return DFont;
}();
$3939d1de148b5202$var$fontkit.registerFormat($3939d1de148b5202$var$TTFFont);
$3939d1de148b5202$var$fontkit.registerFormat($3939d1de148b5202$var$WOFFFont);
$3939d1de148b5202$var$fontkit.registerFormat($3939d1de148b5202$var$WOFF2Font);
$3939d1de148b5202$var$fontkit.registerFormat($3939d1de148b5202$var$TrueTypeCollection);
$3939d1de148b5202$var$fontkit.registerFormat($3939d1de148b5202$var$DFont);
var $3939d1de148b5202$export$2e2bcd8739ae039 = $3939d1de148b5202$var$fontkit;

});

parcelRegister("4GpFN", function(module, exports) {

$parcel$export(module.exports, "getDate", () => $368effd1825dba32$export$aa350b96d91cd94);
$parcel$export(module.exports, "capitalizeEveryWord", () => $368effd1825dba32$export$1c25f59067672ebe);
$parcel$export(module.exports, "superscript", () => $368effd1825dba32$export$b4aab94a5fcfcead);
$parcel$export(module.exports, "fetchUint8Array", () => $368effd1825dba32$export$bc096d0ec7cfcc89);
$parcel$export(module.exports, "drawText", () => $368effd1825dba32$export$b11bd9a0808bdc9);
$parcel$export(module.exports, "drawRectangle", () => $368effd1825dba32$export$cac848e0621718d8);
$parcel$export(module.exports, "savePDF", () => $368effd1825dba32$export$12362df9a4433a0b);
parcelRequire("01v82");
var $8auL6 = parcelRequire("8auL6");
var $dPHSK = parcelRequire("dPHSK");
var $8dCYu = parcelRequire("8dCYu");
var $gidDr = parcelRequire("gidDr");
function $368effd1825dba32$export$aa350b96d91cd94() {
    const now = new Date();
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    return `${months[now.getMonth()]} ${now.getDate()}, ${now.getFullYear()}`;
}
function $368effd1825dba32$export$73f5c5f9b6ebb3d8(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $368effd1825dba32$export$1c25f59067672ebe(value) {
    return value.split(/\s+/).map((word)=>$368effd1825dba32$export$73f5c5f9b6ebb3d8(word)).join(' ');
}
function $368effd1825dba32$export$b4aab94a5fcfcead(value) {
    const glyphs = [
        "\u2070",
        "\xb9",
        "\xb2",
        "\xb3",
        "\u2074",
        "\u2075",
        "\u2076",
        "\u2077",
        "\u2078",
        "\u2079"
    ];
    return [
        ...value.toString()
    ].map((char)=>glyphs[parseInt(char)]).join('');
}
function $368effd1825dba32$export$41f28d0d76de7163(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = (event)=>resolve(reader.result);
        reader.onerror = (event)=>reject();
        reader.readAsArrayBuffer(blob);
    });
}
async function $368effd1825dba32$export$bc096d0ec7cfcc89(path) {
    return await fetch(path).then((res)=>res.arrayBuffer()).then((res)=>new Uint8Array(res));
}
function $368effd1825dba32$var$hexToRgb(value) {
    return (0, $gidDr.rgb)(((value & 0xff0000) >> 16) / 255, ((value & 0xff00) >> 8) / 255, (value & 0xff) / 255);
}
function $368effd1825dba32$var$alignToTranslate(align, width, height) {
    const offsets = {
        'left': {
            x: (x)=>x
        },
        'right': {
            x: (x)=>x - width
        },
        'top': {
            y: (y)=>y + height
        },
        'bottom': {
            y: (y)=>y
        }
    };
    return align.split(/\s+/).reduce((translate, token)=>({
            ...translate,
            ...offsets[token]
        }), {
        x: (x)=>x - width / 2,
        y: (y)=>y + height / 2
    });
}
function $368effd1825dba32$export$b11bd9a0808bdc9(options) {
    const { doc: doc, page: page, font: font, maxWidth: maxWidth, maxHeight: maxHeight, size: size, x: x, y: y, align: align, color: color, ...rest } = {
        text: '',
        maxWidth: 0,
        maxHeight: 0,
        size: 12,
        x: 0,
        y: 0,
        align: 'center',
        color: 0x0,
        ...options
    };
    const lineHeight = rest.lineHeight ?? font.heightAtSize(size);
    const maxLines = maxHeight > 0 ? Math.floor(maxHeight / lineHeight) : Infinity;
    const lines = (maxWidth > 0 ? rest.text.trim().split(/\n/).map((line)=>{
        const words = [];
        line.split(/\s+/).forEach((word)=>{
            const glyphs = [];
            let start = 0;
            let end = 0;
            while(end < word.length)if (font.widthOfTextAtSize(word.slice(start, ++end), size) > maxWidth) {
                glyphs.push(word.slice(start, end - 1));
                start = end - 1;
            }
            glyphs.push(word.slice(start, end));
            words.push(glyphs.join('\n'));
        });
        return words.join(' ').split(/\n/);
    }).flat().map((line)=>{
        const lines = [];
        let words = [];
        line.split(/\s+/).forEach((word)=>{
            words.push(word);
            if (font.widthOfTextAtSize(words.join(' '), size) > maxWidth) {
                const lastWord = words.pop();
                lines.push(words.join(' '));
                words = [
                    lastWord
                ];
            }
        });
        lines.push(words.join(' '));
        return lines;
    }).flat() : [
        rest.text
    ]).slice(0, maxLines);
    const text = lines.join('\n');
    const width = maxWidth > 0 ? maxWidth : font.widthOfTextAtSize(text, size);
    const height = lineHeight * lines.length;
    const offset = lineHeight * (lines.length - 1);
    const translate = $368effd1825dba32$var$alignToTranslate(align, width, height);
    const coordinates = {
        x: translate.x(x),
        y: page.getHeight() - translate.y(y) + offset
    };
    page.drawText(text, {
        font: font,
        size: size,
        lineHeight: lineHeight,
        x: coordinates.x,
        y: coordinates.y,
        color: $368effd1825dba32$var$hexToRgb(color),
        ...rest
    });
    if (rest.url) {
        const linkAnnot = doc.context.obj({
            Type: 'Annot',
            Subtype: 'Link',
            Rect: [
                coordinates.x,
                coordinates.y,
                coordinates.x + width,
                coordinates.y + height
            ],
            Border: [
                0,
                0,
                0
            ],
            C: [
                0,
                0,
                0
            ],
            A: {
                Type: 'Action',
                S: 'URI',
                URI: (0, $8dCYu.default).of(rest.url)
            }
        });
        const linkAnnotRef = doc.context.register(linkAnnot);
        const annots = page.node.lookup((0, $dPHSK.default).of('Annots'), (0, $8auL6.default));
        annots.push(linkAnnotRef);
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $368effd1825dba32$export$cac848e0621718d8(options) {
    const { page: page, x: x, y: y, width: width, height: height, color: color, opacity: opacity, ...rest } = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        color: 0x0,
        opacity: 1,
        ...options
    };
    page.drawRectangle({
        x: x,
        y: page.getHeight() - y - height,
        width: width,
        height: height,
        color: $368effd1825dba32$var$hexToRgb(color),
        opacity: opacity
    });
}
async function $368effd1825dba32$export$12362df9a4433a0b(name, doc) {
    const bytes = await doc.save();
    const anchor = document.createElement('a');
    anchor.href = URL.createObjectURL(new Blob([
        new Uint8Array(bytes)
    ], {
        type: 'application/pdf'
    }));
    anchor.download = `${name}.pdf`;
    anchor.click();
}

});

parcelRegister("lyNTZ", function(module, exports) {
module.exports = import.meta.resolve("kRw95");

});

parcelRegister("4frTP", function(module, exports) {
module.exports = import.meta.resolve("3rw6I");

});

parcelRegister("dL6bL", function(module, exports) {
module.exports = import.meta.resolve("fs8G6");

});

parcelRegister("d1QFr", function(module, exports) {
module.exports = import.meta.resolve("escz0");

});

parcelRegister("kYWTk", function(module, exports) {
module.exports = import.meta.resolve("cRwqt");

});

parcelRegister("05c6E", function(module, exports) {
module.exports = import.meta.resolve("4zb4U");

});

parcelRegister("5jVXc", function(module, exports) {
module.exports = import.meta.resolve("45HYY");

});



parcelRegister("ccMGy", function(module, exports) {

$parcel$export(module.exports, "render", () => $8e2c5ef187b007c3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $8e2c5ef187b007c3$var$_hoisted_1 = {
    class: "px-6 py-14 bg-[url(./images/circle-pattern-blue.svg)] bg-no-repeat sm:px-8 sm:py-28 lg:px-24",
    style: {
        "background-position": "center bottom 125px"
    }
};
const $8e2c5ef187b007c3$var$_hoisted_2 = {
    class: "max-w-6xl mx-auto"
};
const $8e2c5ef187b007c3$var$_hoisted_3 = {
    class: "mb-12 text-center"
};
const $8e2c5ef187b007c3$var$_hoisted_4 = {
    class: "my-6 sm:my-10"
};
const $8e2c5ef187b007c3$var$_hoisted_5 = {
    key: 0,
    class: "flex items-center justify-center"
};
const $8e2c5ef187b007c3$var$_hoisted_6 = {
    key: 1
};
const $8e2c5ef187b007c3$var$_hoisted_7 = {
    key: 2
};
const $8e2c5ef187b007c3$var$_hoisted_8 = {
    class: "flex justify-center"
};
const $8e2c5ef187b007c3$var$_hoisted_9 = [
    "src"
];
const $8e2c5ef187b007c3$var$_hoisted_10 = {
    class: "flex flex-col items-center lg:flex-row justify-center gap-8"
};
const $8e2c5ef187b007c3$var$_hoisted_11 = {
    class: "px-6 py-12 bg-grey-mercury text-black text-center sm:px-8 lg:px-24"
};
const $8e2c5ef187b007c3$var$_hoisted_12 = {
    class: "max-w-6xl mx-auto"
};
function $8e2c5ef187b007c3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", null, [
            (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_1, [
                (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_2, [
                    (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_3, [
                        _cache[3] || (_cache[3] = (0, $TusQn.createElementVNode)("h1", {
                            class: "mb-3 text-2xl leading-normal font-bold text-blue-primary sm:mb-5 sm:text-4xl"
                        }, " Thank you! Your report is ready for download: ", -1 /* HOISTED */ )),
                        (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_4, [
                            (0, $TusQn.createVNode)($setup["Button"], {
                                onClick: $setup.onClickDownload,
                                disabled: $setup.downloadDisabled,
                                class: "px-10 py-3 text-blue-primary bg-green-bitter-lemon hover:bg-green-rio whitespace-nowrap disabled:text-white disabled:bg-black/40 disabled:cursor-not-allowed"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        $setup.downloadDisabled && !$setup.downloadCompleted ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8e2c5ef187b007c3$var$_hoisted_5, _cache[0] || (_cache[0] = [
                                            (0, $TusQn.createElementVNode)("p", null, "Generating Your Custom Report", -1 /* HOISTED */ ),
                                            (0, $TusQn.createElementVNode)("svg", {
                                                class: "ml-3 -mr-1 size-5 animate-spin text-white",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24"
                                            }, [
                                                (0, $TusQn.createElementVNode)("circle", {
                                                    class: "opacity-25",
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "10",
                                                    stroke: "currentColor",
                                                    "stroke-width": "4"
                                                }),
                                                (0, $TusQn.createElementVNode)("path", {
                                                    class: "opacity-75",
                                                    fill: "currentColor",
                                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                })
                                            ], -1 /* HOISTED */ )
                                        ]))) : $setup.downloadCompleted ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8e2c5ef187b007c3$var$_hoisted_6, _cache[1] || (_cache[1] = [
                                            (0, $TusQn.createElementVNode)("p", null, "Thank you", -1 /* HOISTED */ )
                                        ]))) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8e2c5ef187b007c3$var$_hoisted_7, _cache[2] || (_cache[2] = [
                                            (0, $TusQn.createElementVNode)("p", null, "Download Now", -1 /* HOISTED */ )
                                        ])))
                                    ]),
                                _: 1 /* STABLE */ 
                            }, 8 /* PROPS */ , [
                                "disabled"
                            ])
                        ]),
                        _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("p", {
                            class: "max-w-5xl mx-auto mb-10 text-base text-black sm:text-xl"
                        }, " You'll also receive a copy of the report via email. ", -1 /* HOISTED */ )),
                        (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_8, [
                            (0, $TusQn.createElementVNode)("img", {
                                src: $setup.mockupUrl,
                                alt: "bioM\xe9rieux Population Health Data Mockup",
                                class: "w-sm"
                            }, null, 8 /* PROPS */ , $8e2c5ef187b007c3$var$_hoisted_9)
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_10, [
                        (0, $TusQn.createVNode)($setup["DownloadBlock"], {
                            eyebrow: "trends data",
                            heading: "Syndromic Trends",
                            paragraph: "View nationwide trends for various infectious pathogens related to syndromic diseases."
                        }, {
                            button: (0, $TusQn.withCtx)(()=>_cache[5] || (_cache[5] = [
                                    (0, $TusQn.createElementVNode)("a", {
                                        href: "https://syndromictrends.com/",
                                        target: "_blank"
                                    }, "visit syndromic trends", -1 /* HOISTED */ )
                                ])),
                            _: 1 /* STABLE */ 
                        }),
                        (0, $TusQn.createVNode)($setup["DownloadBlock"], {
                            eyebrow: "trends report",
                            heading: "Real data. Real trends.",
                            paragraph: "Access your free report today to track nationwide trends, and stay prepared for what's coming next."
                        }, {
                            button: (0, $TusQn.withCtx)(()=>_cache[6] || (_cache[6] = [
                                    (0, $TusQn.createElementVNode)("a", {
                                        href: "https://www.biomerieux.com/us/en/education/resource-hub/trends-reports.html",
                                        target: "_blank"
                                    }, "get my report", -1 /* HOISTED */ )
                                ])),
                            _: 1 /* STABLE */ 
                        })
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("div", $8e2c5ef187b007c3$var$_hoisted_12, [
                    _cache[8] || (_cache[8] = (0, $TusQn.createElementVNode)("p", {
                        class: "mb-10"
                    }, [
                        (0, $TusQn.createElementVNode)("strong", null, "Looking to take action?"),
                        (0, $TusQn.createTextVNode)(" Our product specialists are standing by to guide you to the right solution. ")
                    ], -1 /* HOISTED */ )),
                    (0, $TusQn.createVNode)($setup["Button"], {
                        class: "text-white bg-blue-primary hover:bg-blue-prussian-hover px-10"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>_cache[7] || (_cache[7] = [
                                (0, $TusQn.createElementVNode)("a", {
                                    href: "https://info.biomerieux.com/clin_us_2025_population-health-tool_talk-to-sales"
                                }, " Schedule a Free Consultation ", -1 /* HOISTED */ )
                            ])),
                        _: 1 /* STABLE */ ,
                        __: [
                            7
                        ]
                    })
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64 /* STABLE_FRAGMENT */ );
}

});

parcelRegister("fZ08O", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba2ca98a1fce1773$export$2e2bcd8739ae039);
let $ba2ca98a1fce1773$var$NOOP = ()=>{};
var $ba2ca98a1fce1773$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $73mM4 = parcelRequire("73mM4");
let $86bc214e0d51cefe$var$script;



let $86bc214e0d51cefe$var$initialize = ()=>{
    $86bc214e0d51cefe$var$script = (parcelRequire("f3c4t"));
    if ($86bc214e0d51cefe$var$script.__esModule) $86bc214e0d51cefe$var$script = $86bc214e0d51cefe$var$script.default;
    $86bc214e0d51cefe$var$script.render = (parcelRequire("cCAf4")).render;
    (parcelRequire("jWWsu")).default($86bc214e0d51cefe$var$script);
    $86bc214e0d51cefe$var$script.__scopeId = 'data-v-2dc7de';
    $86bc214e0d51cefe$var$script.__file = "index.vue";
};
$86bc214e0d51cefe$var$initialize();
var $86bc214e0d51cefe$export$2e2bcd8739ae039 = $86bc214e0d51cefe$var$script;


let $eae0f8b0376ac390$var$script;



let $eae0f8b0376ac390$var$initialize = ()=>{
    $eae0f8b0376ac390$var$script = (parcelRequire("hc7Da"));
    if ($eae0f8b0376ac390$var$script.__esModule) $eae0f8b0376ac390$var$script = $eae0f8b0376ac390$var$script.default;
    $eae0f8b0376ac390$var$script.render = (parcelRequire("4v856")).render;
    (parcelRequire("1hsKx")).default($eae0f8b0376ac390$var$script);
    $eae0f8b0376ac390$var$script.__scopeId = 'data-v-77b79b';
    $eae0f8b0376ac390$var$script.__file = "report.vue";
};
$eae0f8b0376ac390$var$initialize();
var $eae0f8b0376ac390$export$2e2bcd8739ae039 = $eae0f8b0376ac390$var$script;


let $7643bfa1677cea1c$var$script;



let $7643bfa1677cea1c$var$initialize = ()=>{
    $7643bfa1677cea1c$var$script = (parcelRequire("gmjQI"));
    if ($7643bfa1677cea1c$var$script.__esModule) $7643bfa1677cea1c$var$script = $7643bfa1677cea1c$var$script.default;
    $7643bfa1677cea1c$var$script.render = (parcelRequire("dW5xm")).render;
    (parcelRequire("6K7T2")).default($7643bfa1677cea1c$var$script);
    $7643bfa1677cea1c$var$script.__scopeId = 'data-v-9afbba';
    $7643bfa1677cea1c$var$script.__file = "entry.vue";
};
$7643bfa1677cea1c$var$initialize();
var $7643bfa1677cea1c$export$2e2bcd8739ae039 = $7643bfa1677cea1c$var$script;


let $51c5cd0194ba49b1$var$script;



let $51c5cd0194ba49b1$var$initialize = ()=>{
    $51c5cd0194ba49b1$var$script = (parcelRequire("grgHc"));
    if ($51c5cd0194ba49b1$var$script.__esModule) $51c5cd0194ba49b1$var$script = $51c5cd0194ba49b1$var$script.default;
    $51c5cd0194ba49b1$var$script.render = (parcelRequire("kB4kJ")).render;
    (parcelRequire("8etOz")).default($51c5cd0194ba49b1$var$script);
    $51c5cd0194ba49b1$var$script.__scopeId = 'data-v-847f7c';
    $51c5cd0194ba49b1$var$script.__file = "form.vue";
};
$51c5cd0194ba49b1$var$initialize();
var $51c5cd0194ba49b1$export$2e2bcd8739ae039 = $51c5cd0194ba49b1$var$script;


let $eb679a6bb0f160ff$var$script;



let $eb679a6bb0f160ff$var$initialize = ()=>{
    $eb679a6bb0f160ff$var$script = (parcelRequire("lfBBY"));
    if ($eb679a6bb0f160ff$var$script.__esModule) $eb679a6bb0f160ff$var$script = $eb679a6bb0f160ff$var$script.default;
    $eb679a6bb0f160ff$var$script.render = (parcelRequire("ccMGy")).render;
    (parcelRequire("fZ08O")).default($eb679a6bb0f160ff$var$script);
    $eb679a6bb0f160ff$var$script.__scopeId = 'data-v-69e02c';
    $eb679a6bb0f160ff$var$script.__file = "download.vue";
};
$eb679a6bb0f160ff$var$initialize();
var $eb679a6bb0f160ff$export$2e2bcd8739ae039 = $eb679a6bb0f160ff$var$script;


window.__VUE_OPTIONS_API__ = true;
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
function $35da740d59af89ba$var$removeQueryParams(to) {
    if (Object.keys(to.query).length) return {
        path: to.path,
        query: {},
        hash: to.hash
    };
}
const $35da740d59af89ba$var$routes = [
    {
        name: 'home',
        path: '/',
        redirect: ()=>({
                path: '/entry'
            })
    },
    {
        name: 'entry',
        path: '/entry',
        component: (0, $7643bfa1677cea1c$export$2e2bcd8739ae039),
        beforeEnter: [
            $35da740d59af89ba$var$removeQueryParams
        ]
    },
    {
        name: 'report',
        path: '/report',
        component: (0, $eae0f8b0376ac390$export$2e2bcd8739ae039)
    },
    {
        name: 'form',
        path: '/form',
        component: (0, $51c5cd0194ba49b1$export$2e2bcd8739ae039)
    },
    {
        name: 'download',
        path: '/download',
        component: (0, $eb679a6bb0f160ff$export$2e2bcd8739ae039)
    }
];
const $35da740d59af89ba$var$router = (0, $73mM4.createRouter)({
    history: (0, $73mM4.createWebHashHistory)(),
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        else return {
            left: 0,
            top: 0
        };
    },
    routes: $35da740d59af89ba$var$routes
});
$35da740d59af89ba$var$router.afterEach((to, from)=>{
    if (typeof Munchkin == 'object') Munchkin.munchkinFunction('visitWebPage', {
        'url': `/clin_us_2025_population-health-tool${window.location.search}#${to.fullPath}`
    });
});
$35da740d59af89ba$var$router.beforeEach((to)=>{
    if ((to.name === 'form' || to.name === 'download') && to.query['zip-code'].length !== 5) return {
        name: 'report',
        query: {
            'zip-code': to.query['zip-code']
        }
    };
});
const $35da740d59af89ba$var$app = (0, $eeJ70.createApp)((0, $86bc214e0d51cefe$export$2e2bcd8739ae039));
$35da740d59af89ba$var$app.use($35da740d59af89ba$var$router);
$35da740d59af89ba$var$app.mount('#app');


//# sourceMappingURL=clin_us_app_population-health-tool_index.16b57466.js.map
